var _objectSpread = require("/www/stadlzwei/html/pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _defineProperty = require("/www/stadlzwei/html/pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _get = require("/www/stadlzwei/html/pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/www/stadlzwei/html/pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/www/stadlzwei/html/pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _construct = require("/www/stadlzwei/html/pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/construct");

var _possibleConstructorReturn = require("/www/stadlzwei/html/pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _regeneratorRuntime = require("/www/stadlzwei/html/pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/www/stadlzwei/html/pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/www/stadlzwei/html/pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _toConsumableArray = require("/www/stadlzwei/html/pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _inherits = require("/www/stadlzwei/html/pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/www/stadlzwei/html/pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/www/stadlzwei/html/pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _createClass = require("/www/stadlzwei/html/pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/www/stadlzwei/html/pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

!function (t) {
  var e = t.de = t.de || {};
  e.dictionary = Object.assign(e.dictionary || {}, {
    "%0 of %1": "%0 von %1",
    Aquamarine: "Aquamarinblau",
    Black: "Schwarz",
    "Block quote": "Blockzitat",
    Blue: "Blau",
    Bold: "Fett",
    "Break text": "Bild teilt Text",
    "Bulleted List": "Aufzählungsliste",
    Cancel: "Abbrechen",
    "Cannot upload file:": "Datei kann nicht hochgeladen werden:",
    "Centered image": "Zentriertes Bild",
    "Change image text alternative": "Alternativtext ändern",
    "Choose heading": "Überschrift auswählen",
    Column: "Spalte",
    "Decrease indent": "Einzug verkleinern",
    "Delete column": "Spalte löschen",
    "Delete row": "Zeile löschen",
    "Dim grey": "Dunkelgrau",
    Downloadable: "Herunterladbar",
    "Dropdown toolbar": "Dropdown-Liste Werkzeugleiste",
    "Edit block": "Absatz bearbeiten",
    "Edit link": "Link bearbeiten",
    "Editor toolbar": "Editor Werkzeugleiste",
    "Enter image caption": "Bildunterschrift eingeben",
    "Full size image": "Bild in voller Größe",
    Green: "Grün",
    Grey: "Grau",
    "Header column": "Kopfspalte",
    "Header row": "Kopfzeile",
    Heading: "Überschrift",
    "Heading 1": "Überschrift 1",
    "Heading 2": "Überschrift 2",
    "Heading 3": "Überschrift 3",
    "Heading 4": "Überschrift 4",
    "Heading 5": "Überschrift 5",
    "Heading 6": "Überschrift 6",
    "Image toolbar": "Bild Werkzeugleiste",
    "image widget": "Bild-Steuerelement",
    "In line": "Text in Zeile",
    "Increase indent": "Einzug vergrößern",
    "Insert code block": "Code-Block einfügen",
    "Insert column left": "Spalte links einfügen",
    "Insert column right": "Spalte rechts einfügen",
    "Insert image": "Bild einfügen",
    "Insert media": "Medium einfügen",
    "Insert paragraph after block": "Absatz nach Block einfügen",
    "Insert paragraph before block": "Absatz vor Block einfügen",
    "Insert row above": "Zeile oben einfügen",
    "Insert row below": "Zeile unten einfügen",
    "Insert table": "Tabelle einfügen",
    Italic: "Kursiv",
    "Left aligned image": "Linksbündiges Bild",
    "Light blue": "Hellblau",
    "Light green": "Hellgrün",
    "Light grey": "Hellgrau",
    Link: "Link",
    "Link URL": "Link Adresse",
    "Media URL": "Medien-URL",
    "media widget": "Medien-Widget",
    "Merge cell down": "Zelle unten verbinden",
    "Merge cell left": "Zelle links verbinden",
    "Merge cell right": "Zelle rechts verbinden",
    "Merge cell up": "Zelle verbinden",
    "Merge cells": "Zellen verbinden",
    Next: "Nächste",
    "Numbered List": "Nummerierte Liste",
    "Open in a new tab": "In neuem Tab öffnen",
    "Open link in new tab": "Link im neuen Tab öffnen",
    Orange: "Orange",
    Paragraph: "Absatz",
    "Paste the media URL in the input.": "Medien-URL in das Eingabefeld einfügen.",
    "Plain text": "Nur Text",
    Previous: "vorherige",
    Purple: "Violett",
    Red: "Rot",
    Redo: "Wiederherstellen",
    "Rich Text Editor": "Rich Text Editor",
    "Rich Text Editor, %0": "Rich-Text-Editor, %0",
    "Right aligned image": "Rechtsbündiges Bild",
    Row: "Zeile",
    Save: "Speichern",
    "Select all": "Alles auswählen",
    "Select column": "Spalte auswählen",
    "Select row": "Zeile auswählen",
    "Show more items": "Mehr anzeigen",
    "Side image": "Seitenbild",
    "Split cell horizontally": "Zelle horizontal teilen",
    "Split cell vertically": "Zelle vertikal teilen",
    Subscript: "Tiefgestellt",
    Superscript: "Hochgestellt",
    "Table toolbar": "Tabelle Werkzeugleiste",
    "Text alternative": "Alternativtext",
    "The URL must not be empty.": "Die URL darf nicht leer sein.",
    "This link has no URL": "Dieser Link hat keine Adresse",
    "This media URL is not supported.": "Diese Medien-URL wird nicht unterstützt.",
    "Tip: Paste the URL into the content to embed faster.": "Tipp: Zum schnelleren Einbetten können Sie die Medien-URL in den Inhalt einfügen.",
    "Toggle caption off": "Tabellenüberschrift deaktivieren",
    "Toggle caption on": "Tabellenüberschrift aktivieren",
    Turquoise: "Türkis",
    Undo: "Rückgängig",
    Unlink: "Link entfernen",
    "Upload failed": "Hochladen fehlgeschlagen",
    "Upload in progress": "Upload läuft",
    White: "Weiß",
    "Widget toolbar": "Widget Werkzeugleiste",
    "Wrap text": "Text umfließt Bild",
    Yellow: "Gelb"
  }), e.getPluralForm = function (t) {
    return 1 != t;
  };
}(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})),
/*!
 * @license Copyright (c) 2003-2022, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.StadlEditor = e() : t.StadlEditor = e();
}(self, function () {
  return function () {
    var t = {
      7614: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck-content blockquote{overflow:hidden;padding-right:1.5em;padding-left:1.5em;margin-left:0;margin-right:0;font-style:italic;border-left:5px solid #ccc}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-block-quote/theme/blockquote.css"],
          names: [],
          mappings: "AAKA,uBAEC,eAAgB,CAGhB,mBAAoB,CACpB,kBAAmB,CAEnB,aAAc,CACd,cAAe,CACf,iBAAkB,CAClB,0BACD,CAEA,gCACC,aAAc,CACd,2BACD",
          sourcesContent: ['/**\n * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content blockquote {\n\t/* See #12 */\n\toverflow: hidden;\n\n\t/* https://github.com/ckeditor/ckeditor5-block-quote/issues/15 */\n\tpadding-right: 1.5em;\n\tpadding-left: 1.5em;\n\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tfont-style: italic;\n\tborder-left: solid 5px hsl(0, 0%, 80%);\n}\n\n.ck-content[dir="rtl"] blockquote {\n\tborder-left: 0;\n\tborder-right: solid 5px hsl(0, 0%, 80%);\n}\n'],
          sourceRoot: ""
        }]), e.Z = s;
      },
      6147: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, '.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position{display:inline;position:relative;pointer-events:none}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{position:absolute;width:0}.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__selection-handle,.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__type-around{display:none}:root{--ck-clipboard-drop-target-dot-width:12px;--ck-clipboard-drop-target-dot-height:8px;--ck-clipboard-drop-target-color:var(--ck-color-focus-border)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{bottom:calc(var(--ck-clipboard-drop-target-dot-height)*-0.5);top:calc(var(--ck-clipboard-drop-target-dot-height)*-0.5);border:1px solid var(--ck-clipboard-drop-target-color);background:var(--ck-clipboard-drop-target-color);margin-left:-1px}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span:after{content:"";width:0;height:0;display:block;position:absolute;left:50%;top:calc(var(--ck-clipboard-drop-target-dot-height)*-0.5);transform:translateX(-50%);border-left:calc(var(--ck-clipboard-drop-target-dot-width)*0.5) solid transparent;border-bottom:0 solid transparent;border-right:calc(var(--ck-clipboard-drop-target-dot-width)*0.5) solid transparent;border-top:calc(var(--ck-clipboard-drop-target-dot-height)) solid var(--ck-clipboard-drop-target-color)}.ck.ck-editor__editable .ck-widget.ck-clipboard-drop-target-range{outline:var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color)!important}.ck.ck-editor__editable .ck-widget:-webkit-drag{zoom:.6;outline:none!important}', "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-clipboard/theme/clipboard.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-clipboard/clipboard.css"],
          names: [],
          mappings: "AASC,8DACC,cAAe,CACf,iBAAkB,CAClB,mBAMD,CAJC,mEACC,iBAAkB,CAClB,OACD,CAWA,qJACC,YACD,CCzBF,MACC,yCAA0C,CAC1C,yCAA0C,CAC1C,6DACD,CAOE,mEACC,4DAA8D,CAC9D,yDAA2D,CAC3D,sDAAuD,CACvD,gDAAiD,CACjD,gBAkBD,CAfC,yEACC,UAAW,CACX,OAAQ,CACR,QAAS,CAET,aAAc,CACd,iBAAkB,CAClB,QAAS,CACT,yDAA2D,CAE3D,0BAA2B,CAG3B,iFAAmB,CAAnB,iCAAmB,CAAnB,kFAAmB,CAAnB,uGACD,CA2DF,kEACC,gGACD,CAKA,gDACC,OAAS,CACT,sBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t/*\n\t * Vertical drop target (in text).\n\t */\n\t& .ck.ck-clipboard-drop-target-position {\n\t\tdisplay: inline;\n\t\tposition: relative;\n\t\tpointer-events: none;\n\n\t\t& span {\n\t\t\tposition: absolute;\n\t\t\twidth: 0;\n\t\t}\n\t}\n\n\t/*\n\t * Styles of the widget being dragged (its preview).\n\t */\n\t& .ck-widget:-webkit-drag {\n\t\t& > .ck-widget__selection-handle {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t& > .ck-widget__type-around {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-clipboard-drop-target-dot-width: 12px;\n\t--ck-clipboard-drop-target-dot-height: 8px;\n\t--ck-clipboard-drop-target-color: var(--ck-color-focus-border)\n}\n\n.ck.ck-editor__editable {\n\t/*\n\t * Vertical drop target (in text).\n\t */\n\t& .ck.ck-clipboard-drop-target-position {\n\t\t& span {\n\t\t\tbottom: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\t\t\ttop: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\t\t\tborder: 1px solid var(--ck-clipboard-drop-target-color);\n\t\t\tbackground: var(--ck-clipboard-drop-target-color);\n\t\t\tmargin-left: -1px;\n\n\t\t\t/* The triangle above the marker */\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 50%;\n\t\t\t\ttop: calc(var(--ck-clipboard-drop-target-dot-height) * -.5);\n\n\t\t\t\ttransform: translateX(-50%);\n\t\t\t\tborder-color: var(--ck-clipboard-drop-target-color) transparent transparent transparent;\n\t\t\t\tborder-width: calc(var(--ck-clipboard-drop-target-dot-height)) calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0 calc(.5 * var(--ck-clipboard-drop-target-dot-width));\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t// Horizontal drop target (between blocks).\n\t& .ck.ck-clipboard-drop-target-position {\n\t\tdisplay: block;\n\t\tposition: relative;\n\t\twidth: 100%;\n\t\theight: 0;\n\t\tmargin: 0;\n\t\ttext-align: initial;\n\n\t\t& .ck-clipboard-drop-target__line {\n\t\t\tposition: absolute;\n\t\t\twidth: 100%;\n\t\t\theight: 0;\n\t\t\tborder: 1px solid var(--ck-clipboard-drop-target-color);\n\t\t\tmargin-top: -1px;\n\n\t\t\t&::before {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: calc(-1 * var(--ck-clipboard-drop-target-dot-size));\n\t\t\t\ttop: 0;\n\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t\tborder-color: transparent transparent transparent var(--ck-clipboard-drop-target-color);\n\t\t\t\tborder-width: var(--ck-clipboard-drop-target-dot-size) 0 var(--ck-clipboard-drop-target-dot-size) calc(2 * var(--ck-clipboard-drop-target-dot-size));\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tright: calc(-1 * var(--ck-clipboard-drop-target-dot-size));\n\t\t\t\ttop: 0;\n\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t\tborder-color: transparent var(--ck-clipboard-drop-target-color) transparent transparent;\n\t\t\t\tborder-width: var(--ck-clipboard-drop-target-dot-size) calc(2 * var(--ck-clipboard-drop-target-dot-size)) var(--ck-clipboard-drop-target-dot-size) 0;\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\t\t}\n\t}\n\t*/\n\n\t/*\n\t * Styles of the widget that it a drop target.\n\t */\n\t& .ck-widget.ck-clipboard-drop-target-range {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color) !important;\n\t}\n\n\t/*\n\t * Styles of the widget being dragged (its preview).\n\t */\n\t& .ck-widget:-webkit-drag {\n\t\tzoom: 0.6;\n\t\toutline: none !important;\n\t}\n}\n'],
          sourceRoot: ""
        }]), e.Z = s;
      },
      3807: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck-content pre{padding:1em;color:#353535;background:hsla(0,0%,78%,.3);border:1px solid #c4c4c4;border-radius:2px;text-align:left;direction:ltr;tab-size:4;white-space:pre-wrap;font-style:normal;min-width:200px}.ck-content pre code{background:unset;padding:0;border-radius:0}.ck.ck-editor__editable pre{position:relative}.ck.ck-editor__editable pre[data-language]:after{content:attr(data-language);position:absolute}:root{--ck-color-code-block-label-background:#757575}.ck.ck-editor__editable pre[data-language]:after{top:-1px;right:10px;background:var(--ck-color-code-block-label-background);font-size:10px;font-family:var(--ck-font-face);line-height:16px;padding:var(--ck-spacing-tiny) var(--ck-spacing-medium);color:#fff;white-space:nowrap}.ck.ck-code-block-dropdown .ck-dropdown__panel{max-height:250px;overflow-y:auto;overflow-x:hidden}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-code-block/theme/codeblock.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-code-block/codeblock.css"],
          names: [],
          mappings: "AAKA,gBACC,WAAY,CACZ,aAAwB,CACxB,4BAAiC,CACjC,wBAAiC,CACjC,iBAAkB,CAGlB,eAAgB,CAChB,aAAc,CAEd,UAAW,CACX,oBAAqB,CAGrB,iBAAkB,CAGlB,eAOD,CALC,qBACC,gBAAiB,CACjB,SAAU,CACV,eACD,CAGD,4BACC,iBAMD,CAJC,iDACC,2BAA4B,CAC5B,iBACD,CCjCD,MACC,8CACD,CAEA,iDACC,QAAS,CACT,UAAW,CACX,sDAAuD,CAEvD,cAAe,CACf,+BAAgC,CAChC,gBAAiB,CACjB,uDAAwD,CACxD,UAAuB,CACvB,kBACD,CAEA,+CAEC,gBAAiB,CACjB,eAAgB,CAChB,iBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content pre {\n\tpadding: 1em;\n\tcolor: hsl(0, 0%, 20.8%);\n\tbackground: hsla(0, 0%, 78%, 0.3);\n\tborder: 1px solid hsl(0, 0%, 77%);\n\tborder-radius: 2px;\n\n\t/* Code block are language direction–agnostic. */\n\ttext-align: left;\n\tdirection: ltr;\n\n\ttab-size: 4;\n\twhite-space: pre-wrap;\n\n\t/* Don't inherit the style, e.g. when in a block quote. */\n\tfont-style: normal;\n\n\t/* Don't let the code be squashed e.g. when in a table cell. */\n\tmin-width: 200px;\n\n\t& code {\n\t\tbackground: unset;\n\t\tpadding: 0;\n\t\tborder-radius: 0;\n\t}\n}\n\n.ck.ck-editor__editable pre {\n\tposition: relative;\n\n\t&[data-language]::after {\n\t\tcontent: attr(data-language);\n\t\tposition: absolute;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-code-block-label-background: hsl(0, 0%, 46%);\n}\n\n.ck.ck-editor__editable pre[data-language]::after {\n\ttop: -1px;\n\tright: 10px;\n\tbackground: var(--ck-color-code-block-label-background);\n\n\tfont-size: 10px;\n\tfont-family: var(--ck-font-face);\n\tline-height: 16px;\n\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-medium);\n\tcolor: hsl(0, 0%, 100%);\n\twhite-space: nowrap;\n}\n\n.ck.ck-code-block-dropdown .ck-dropdown__panel {\n\t/* There could be dozens of languages available. Use scroll to prevent a 10e6px dropdown. */\n\tmax-height: 250px;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      2869: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-modal)}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-bottom-width:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar{border-bottom-width:1px;border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-editor-classic/theme/classiceditor.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-editor-classic/classiceditor.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAKA,cAIC,iBAMD,CAJC,2DAEC,yBACD,CCLC,gDCED,eDKC,CAPA,uICMA,qCAAsC,CDJpC,2BAA4B,CAC5B,4BAIF,CAPA,gDAMC,qBACD,CAEA,iFACC,uBAAwB,CCR1B,eDaC,CANA,yMCHA,qCAAsC,CDOpC,eAEF,CAKF,yCAEC,0CAA2C,CCpB3C,eD8BD,CAZA,yHCdE,qCAAsC,CDmBtC,wBAAyB,CACzB,yBAMF,CAHC,0DACC,wCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor {\n\t/* All the elements within `.ck-editor` are positioned relatively to it.\n\t If any element needs to be positioned with respect to the <body>, etc.,\n\t it must land outside of the `.ck-editor` in DOM. */\n\tposition: relative;\n\n\t& .ck-editor__top .ck-sticky-panel .ck-toolbar {\n\t\t/* https://github.com/ckeditor/ckeditor5-editor-classic/issues/62 */\n\t\tz-index: var(--ck-z-modal);\n\t}\n}\n", '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_rounded.css";\n\n.ck.ck-editor__top {\n\t& .ck-sticky-panel {\n\t\t& .ck-toolbar {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\n\t\t\tborder-bottom-width: 0;\n\t\t}\n\n\t\t& .ck-sticky-panel__content_sticky .ck-toolbar {\n\t\t\tborder-bottom-width: 1px;\n\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Note: Use ck-editor__main to make sure these styles don\'t apply to other editor types */\n.ck.ck-editor__main > .ck-editor__editable {\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/113 */\n\tbackground: var(--ck-color-base-background);\n\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&:not(.ck-focused) {\n\t\tborder-color: var(--ck-color-base-border);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      1314: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-placeholder,.ck .ck-placeholder{position:relative}.ck.ck-placeholder:before,.ck .ck-placeholder:before{position:absolute;left:0;right:0;content:attr(data-placeholder);pointer-events:none}.ck.ck-read-only .ck-placeholder:before{display:none}.ck.ck-placeholder:before,.ck .ck-placeholder:before{cursor:text;color:var(--ck-color-engine-placeholder-text)}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-engine/theme/placeholder.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-engine/placeholder.css"],
          names: [],
          mappings: "AAMA,uCAEC,iBAWD,CATC,qDACC,iBAAkB,CAClB,MAAO,CACP,OAAQ,CACR,8BAA+B,CAG/B,mBACD,CAKA,wCACC,YACD,CClBA,qDACC,WAAY,CACZ,6CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder,\n.ck .ck-placeholder {\n\tposition: relative;\n\n\t&::before {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tcontent: attr(data-placeholder);\n\n\t\t/* See ckeditor/ckeditor5#469. */\n\t\tpointer-events: none;\n\t}\n}\n\n/* See ckeditor/ckeditor5#1987. */\n.ck.ck-read-only .ck-placeholder {\n\t&::before {\n\t\tdisplay: none;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder, .ck .ck-placeholder {\n\t&::before {\n\t\tcursor: text;\n\t\tcolor: var(--ck-color-engine-placeholder-text);\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      9525: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-editor__editable span[data-ck-unsafe-element]{display:none}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-engine/theme/renderer.css"],
          names: [],
          mappings: "AAMA,qDACC,YACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Elements marked by the Renderer as hidden should be invisible in the editor. */\n.ck.ck-editor__editable span[data-ck-unsafe-element] {\n\tdisplay: none;\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      2233: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-heading/theme/heading.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-heading/heading.css"],
          names: [],
          mappings: "AAKA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,+BACC,eACD,CCZC,2EACC,SACD,CAEA,uEACC,cACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-heading_heading1 {\n\tfont-size: 20px;\n}\n\n.ck.ck-heading_heading2 {\n\tfont-size: 17px;\n}\n\n.ck.ck-heading_heading3 {\n\tfont-size: 14px;\n}\n\n.ck[class*="ck-heading_heading"] {\n\tfont-weight: bold;\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Resize dropdown's button label. */\n.ck.ck-dropdown.ck-heading-dropdown {\n\t& .ck-dropdown__button .ck-button__label {\n\t\twidth: 8em;\n\t}\n\n\t& .ck-dropdown__panel .ck-list__item {\n\t\tmin-width: 18em;\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      6359: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck-content .image{display:table;clear:both;text-align:center;margin:.9em auto;min-width:50px}.ck-content .image img{display:block;margin:0 auto;max-width:100%;min-width:100%}.ck-content .image-inline{display:inline-flex;max-width:100%;align-items:flex-start}.ck-content .image-inline picture{display:flex}.ck-content .image-inline img,.ck-content .image-inline picture{flex-grow:1;flex-shrink:1;max-width:100%}.ck.ck-editor__editable .image>figcaption.ck-placeholder:before{padding-left:inherit;padding-right:inherit;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ck.ck-editor__editable .image-inline.ck-widget_selected,.ck.ck-editor__editable .image.ck-widget_selected{z-index:1}.ck.ck-editor__editable .image-inline.ck-widget_selected ::selection{display:none}.ck.ck-editor__editable td .image-inline img,.ck.ck-editor__editable th .image-inline img{max-width:none}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-image/theme/image.css"],
          names: [],
          mappings: "AAMC,mBACC,aAAc,CACd,UAAW,CACX,iBAAkB,CAKlB,gBAAkB,CAGlB,cAeD,CAbC,uBAEC,aAAc,CAGd,aAAc,CAGd,cAAe,CAGf,cACD,CAGD,0BAMC,mBAAoB,CAGpB,cAAe,CAGf,sBAiBD,CAdC,kCACC,YACD,CAGA,gEAGC,WAAY,CACZ,aAAc,CAGd,cACD,CAUD,gEACC,oBAAqB,CACrB,qBAAsB,CAMtB,kBAAmB,CACnB,eAAgB,CAChB,sBACD,CAWA,2GACC,SAUD,CAHC,qEACC,YACD,CAOA,0FACC,cACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content {\n\t& .image {\n\t\tdisplay: table;\n\t\tclear: both;\n\t\ttext-align: center;\n\n\t\t/* Make sure there is some space between the content and the image. Center image by default. */\n\t\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\t \tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\t\tmargin: 0.9em auto;\n\n\t\t/* Make sure the caption will be displayed properly (See: https://github.com/ckeditor/ckeditor5/issues/1870). */\n\t\tmin-width: 50px;\n\n\t\t& img {\n\t\t\t/* Prevent unnecessary margins caused by line-height (see #44). */\n\t\t\tdisplay: block;\n\n\t\t\t/* Center the image if its width is smaller than the content\'s width. */\n\t\t\tmargin: 0 auto;\n\n\t\t\t/* Make sure the image never exceeds the size of the parent container (ckeditor/ckeditor5-ui#67). */\n\t\t\tmax-width: 100%;\n\n\t\t\t/* Make sure the image is never smaller than the parent container (See: https://github.com/ckeditor/ckeditor5/issues/9300). */\n\t\t\tmin-width: 100%\n\t\t}\n\t}\n\n\t& .image-inline {\n\t\t/*\n\t\t * Normally, the .image-inline would have "display: inline-block" and "img { width: 100% }" (to follow the wrapper while resizing).\n\t\t * Unfortunately, together with "srcset", it gets automatically stretched up to the width of the editing root.\n\t\t * This strange behavior does not happen with inline-flex.\n\t\t */\n\t\tdisplay: inline-flex;\n\n\t\t/* While being resized, don\'t allow the image to exceed the width of the editing root. */\n\t\tmax-width: 100%;\n\n\t\t/* This is required by Safari to resize images in a sensible way. Without this, the browser breaks the ratio. */\n\t\talign-items: flex-start;\n\n\t\t/* When the picture is present it must act as a flex container to let the img resize properly */\n\t\t& picture {\n\t\t\tdisplay: flex;\n\t\t}\n\n\t\t/* When the picture is present, it must act like a resizable img. */\n\t\t& picture,\n\t\t& img {\n\t\t\t/* This is necessary for the img to span the entire .image-inline wrapper and to resize properly. */\n\t\t\tflex-grow: 1;\n\t\t\tflex-shrink: 1;\n\n\t\t\t/* Prevents overflowing the editing root boundaries when an inline image is very wide. */\n\t\t\tmax-width: 100%;\n\t\t}\n\t}\n}\n\n.ck.ck-editor__editable {\n\t/*\n\t * Inhertit the content styles padding of the <figcaption> in case the integration overrides `text-align: center`\n\t * of `.image` (e.g. to the left/right). This ensures the placeholder stays at the padding just like the native\n\t * caret does, and not at the edge of <figcaption>.\n\t */\n\t& .image > figcaption.ck-placeholder::before {\n\t\tpadding-left: inherit;\n\t\tpadding-right: inherit;\n\n\t\t/*\n\t\t * Make sure the image caption placeholder doesn\'t overflow the placeholder area.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9162.\n\t\t */\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\n\n\t/*\n\t * Make sure the selected inline image always stays on top of its siblings.\n\t * See https://github.com/ckeditor/ckeditor5/issues/9108.\n\t */\n\t& .image.ck-widget_selected {\n\t\tz-index: 1;\n\t}\n\n\t& .image-inline.ck-widget_selected {\n\t\tz-index: 1;\n\n\t\t/*\n\t\t * Make sure the native browser selection style is not displayed.\n\t\t * Inline image widgets have their own styles for the selected state and\n\t\t * leaving this up to the browser is asking for a visual collision.\n\t\t */\n\t\t& ::selection {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t/* The inline image nested in the table should have its original size if not resized.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9117. */\n\t& td,\n\t& th {\n\t\t& .image-inline img {\n\t\t\tmax-width: none;\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]), e.Z = s;
      },
      7347: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-color-image-caption-background:#f7f7f7;--ck-color-image-caption-text:#333;--ck-color-image-caption-highligted-background:#fd0}.ck-content .image>figcaption{display:table-caption;caption-side:bottom;word-break:break-word;color:var(--ck-color-image-caption-text);background-color:var(--ck-color-image-caption-background);padding:.6em;font-size:.75em;outline-offset:-1px}.ck.ck-editor__editable .image>figcaption.image__caption_highlighted{animation:ck-image-caption-highlight .6s ease-out}@keyframes ck-image-caption-highlight{0%{background-color:var(--ck-color-image-caption-highligted-background)}to{background-color:var(--ck-color-image-caption-background)}}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-image/theme/imagecaption.css"],
          names: [],
          mappings: "AAKA,MACC,2CAAoD,CACpD,kCAA8C,CAC9C,mDACD,CAGA,8BACC,qBAAsB,CACtB,mBAAoB,CACpB,qBAAsB,CACtB,wCAAyC,CACzC,yDAA0D,CAC1D,YAAa,CACb,eAAgB,CAChB,mBACD,CAGA,qEACC,iDACD,CAEA,sCACC,GACC,oEACD,CAEA,GACC,yDACD,CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-image-caption-background: hsl(0, 0%, 97%);\n\t--ck-color-image-caption-text: hsl(0, 0%, 20%);\n\t--ck-color-image-caption-highligted-background: hsl(52deg 100% 50%);\n}\n\n/* Content styles */\n.ck-content .image > figcaption {\n\tdisplay: table-caption;\n\tcaption-side: bottom;\n\tword-break: break-word;\n\tcolor: var(--ck-color-image-caption-text);\n\tbackground-color: var(--ck-color-image-caption-background);\n\tpadding: .6em;\n\tfont-size: .75em;\n\toutline-offset: -1px;\n}\n\n/* Editing styles */\n.ck.ck-editor__editable .image > figcaption.image__caption_highlighted {\n\tanimation: ck-image-caption-highlight .6s ease-out;\n}\n\n@keyframes ck-image-caption-highlight {\n\t0% {\n\t\tbackground-color: var(--ck-color-image-caption-highligted-background);\n\t}\n\n\t100% {\n\t\tbackground-color: var(--ck-color-image-caption-background);\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      1443: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-image-style-spacing:1.5em;--ck-inline-image-style-spacing:calc(var(--ck-image-style-spacing)/2)}.ck-content .image-style-block-align-left,.ck-content .image-style-block-align-right{max-width:calc(100% - var(--ck-image-style-spacing))}.ck-content .image-style-align-left,.ck-content .image-style-align-right{clear:none}.ck-content .image-style-side{float:right;margin-left:var(--ck-image-style-spacing);max-width:50%}.ck-content .image-style-align-left{float:left;margin-right:var(--ck-image-style-spacing)}.ck-content .image-style-align-center{margin-left:auto;margin-right:auto}.ck-content .image-style-align-right{float:right;margin-left:var(--ck-image-style-spacing)}.ck-content .image-style-block-align-right{margin-right:0;margin-left:auto}.ck-content .image-style-block-align-left{margin-left:0;margin-right:auto}.ck-content p+.image-style-align-left,.ck-content p+.image-style-align-right,.ck-content p+.image-style-side{margin-top:0}.ck-content .image-inline.image-style-align-left,.ck-content .image-inline.image-style-align-right{margin-top:var(--ck-inline-image-style-spacing);margin-bottom:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-left{margin-right:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-right{margin-left:var(--ck-inline-image-style-spacing)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-background)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after{display:none}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-hover-background)}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-image/theme/imagestyle.css"],
          names: [],
          mappings: "AAKA,MACC,8BAA+B,CAC/B,qEACD,CAMC,qFAEC,oDACD,CAIA,yEAEC,UACD,CAEA,8BACC,WAAY,CACZ,yCAA0C,CAC1C,aACD,CAEA,oCACC,UAAW,CACX,0CACD,CAEA,sCACC,gBAAiB,CACjB,iBACD,CAEA,qCACC,WAAY,CACZ,yCACD,CAEA,2CACC,cAAe,CACf,gBACD,CAEA,0CACC,aAAc,CACd,iBACD,CAGA,6GAGC,YACD,CAGC,mGAEC,+CAAgD,CAChD,kDACD,CAEA,iDACC,iDACD,CAEA,kDACC,gDACD,CAUC,0lBAGC,qDAKD,CAHC,8nBACC,YACD,CAKD,oVAGC,2DACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-image-style-spacing: 1.5em;\n\t--ck-inline-image-style-spacing: calc(var(--ck-image-style-spacing) / 2);\n}\n\n.ck-content {\n\t/* Provides a minimal side margin for the left and right aligned images, so that the user has a visual feedback\n\tconfirming successful application of the style if image width exceeds the editor's size.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9342 */\n\t& .image-style-block-align-left,\n\t& .image-style-block-align-right {\n\t\tmax-width: calc(100% - var(--ck-image-style-spacing));\n\t}\n\n\t/* Allows displaying multiple floating images in the same line.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9183#issuecomment-804988132 */\n\t& .image-style-align-left,\n\t& .image-style-align-right {\n\t\tclear: none;\n\t}\n\n\t& .image-style-side {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t\tmax-width: 50%;\n\t}\n\n\t& .image-style-align-left {\n\t\tfloat: left;\n\t\tmargin-right: var(--ck-image-style-spacing);\n\t}\n\n\t& .image-style-align-center {\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t}\n\n\t& .image-style-align-right {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t}\n\n\t& .image-style-block-align-right {\n\t\tmargin-right: 0;\n\t\tmargin-left: auto;\n\t}\n\n\t& .image-style-block-align-left {\n\t\tmargin-left: 0;\n\t\tmargin-right: auto;\n\t}\n\n\t/* Simulates margin collapsing with the preceding paragraph, which does not work for the floating elements. */\n\t& p + .image-style-align-left,\n\t& p + .image-style-align-right,\n\t& p + .image-style-side {\n\t\tmargin-top: 0;\n\t}\n\n\t& .image-inline {\n\t\t&.image-style-align-left,\n\t\t&.image-style-align-right {\n\t\t\tmargin-top: var(--ck-inline-image-style-spacing);\n\t\t\tmargin-bottom: var(--ck-inline-image-style-spacing);\n\t\t}\n\n\t\t&.image-style-align-left {\n\t\t\tmargin-right: var(--ck-inline-image-style-spacing);\n\t\t}\n\n\t\t&.image-style-align-right {\n\t\t\tmargin-left: var(--ck-inline-image-style-spacing);\n\t\t}\n\t}\n}\n\n.ck.ck-splitbutton {\n\t/* The button should display as a regular drop-down if the action button\n\tis forced to fire the same action as the arrow button. */\n\t&.ck-splitbutton_flatten {\n\t\t&:hover,\n\t\t&.ck-splitbutton_open {\n\t\t\t& > .ck-splitbutton__action:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled):not(:hover) {\n\t\t\t\tbackground-color: var(--ck-color-button-on-background);\n\n\t\t\t\t&::after {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.ck-splitbutton_open:hover {\n\t\t\t& > .ck-splitbutton__action:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled):not(:hover) {\n\t\t\t\tbackground-color: var(--ck-color-button-on-hover-background);\n\t\t\t}\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      5333: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, '.ck-image-upload-complete-icon{display:block;position:absolute;top:min(var(--ck-spacing-medium),6%);right:min(var(--ck-spacing-medium),6%);border-radius:50%;z-index:1}.ck-image-upload-complete-icon:after{content:"";position:absolute}:root{--ck-color-image-upload-icon:#fff;--ck-color-image-upload-icon-background:#008a00;--ck-image-upload-icon-size:20;--ck-image-upload-icon-width:2px;--ck-image-upload-icon-is-visible:clamp(0px,100% - 50px,1px)}.ck-image-upload-complete-icon{opacity:0;background:var(--ck-color-image-upload-icon-background);animation-name:ck-upload-complete-icon-show,ck-upload-complete-icon-hide;animation-fill-mode:forwards,forwards;animation-duration:.5s,.5s;font-size:calc(1px*var(--ck-image-upload-icon-size));animation-delay:0ms,3s;overflow:hidden;width:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size));height:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size))}.ck-image-upload-complete-icon:after{left:25%;top:50%;opacity:0;height:0;width:0;transform:scaleX(-1) rotate(135deg);transform-origin:left top;border-top:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);border-right:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);animation-name:ck-upload-complete-icon-check;animation-duration:.5s;animation-delay:.5s;animation-fill-mode:forwards;box-sizing:border-box}@keyframes ck-upload-complete-icon-show{0%{opacity:0}to{opacity:1}}@keyframes ck-upload-complete-icon-hide{0%{opacity:1}to{opacity:0}}@keyframes ck-upload-complete-icon-check{0%{opacity:1;width:0;height:0}33%{width:.3em;height:0}to{opacity:1;width:.3em;height:.45em}}', "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-image/theme/imageuploadicon.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadicon.css"],
          names: [],
          mappings: "AAKA,+BACC,aAAc,CACd,iBAAkB,CAMlB,oCAAsC,CACtC,sCAAwC,CACxC,iBAAkB,CAClB,SAMD,CAJC,qCACC,UAAW,CACX,iBACD,CChBD,MACC,iCAA8C,CAC9C,+CAA4D,CAG5D,8BAA+B,CAC/B,gCAAiC,CACjC,4DACD,CAEA,+BACC,SAAU,CACV,uDAAwD,CACxD,wEAA0E,CAC1E,qCAAuC,CACvC,0BAAgC,CAGhC,oDAAuD,CAGvD,sBAA4B,CAM5B,eAAgB,CAChB,mFAAsF,CACtF,oFAyBD,CAtBC,qCAEC,QAAS,CAET,OAAQ,CACR,SAAU,CACV,QAAS,CACT,OAAQ,CAER,mCAAoC,CACpC,yBAA0B,CAC1B,oFAAqF,CACrF,sFAAuF,CAEvF,4CAA6C,CAC7C,sBAAyB,CACzB,mBAAsB,CACtB,4BAA6B,CAG7B,qBACD,CAGD,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,yCACC,GACC,SAAU,CACV,OAAQ,CACR,QACD,CACA,IACC,UAAY,CACZ,QACD,CACA,GACC,SAAU,CACV,UAAY,CACZ,YACD,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-image-upload-complete-icon {\n\tdisplay: block;\n\tposition: absolute;\n\n\t/*\n\t * Smaller images should have the icon closer to the border.\n\t * Match the icon position with the linked image indicator brought by the link image feature.\n\t */\n\ttop: min(var(--ck-spacing-medium), 6%);\n\tright: min(var(--ck-spacing-medium), 6%);\n\tborder-radius: 50%;\n\tz-index: 1;\n\n\t&::after {\n\t\tcontent: "";\n\t\tposition: absolute;\n\t}\n}\n', '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-image-upload-icon: hsl(0, 0%, 100%);\n\t--ck-color-image-upload-icon-background: hsl(120, 100%, 27%);\n\n\t/* Match the icon size with the linked image indicator brought by the link image feature. */\n\t--ck-image-upload-icon-size: 20;\n\t--ck-image-upload-icon-width: 2px;\n\t--ck-image-upload-icon-is-visible: clamp(0px, 100% - 50px, 1px);\n}\n\n.ck-image-upload-complete-icon {\n\topacity: 0;\n\tbackground: var(--ck-color-image-upload-icon-background);\n\tanimation-name: ck-upload-complete-icon-show, ck-upload-complete-icon-hide;\n\tanimation-fill-mode: forwards, forwards;\n\tanimation-duration: 500ms, 500ms;\n\n\t/* To make animation scalable. */\n\tfont-size: calc(1px * var(--ck-image-upload-icon-size));\n\n\t/* Hide completed upload icon after 3 seconds. */\n\tanimation-delay: 0ms, 3000ms;\n\n\t/*\n\t * Use CSS math to simulate container queries.\n\t * https://css-tricks.com/the-raven-technique-one-step-closer-to-container-queries/#what-about-showing-and-hiding-things\n\t */\n\toverflow: hidden;\n\twidth: calc(var(--ck-image-upload-icon-is-visible) * var(--ck-image-upload-icon-size));\n\theight: calc(var(--ck-image-upload-icon-is-visible) * var(--ck-image-upload-icon-size));\n\n\t/* This is check icon element made from border-width mixed with animations. */\n\t&::after {\n\t\t/* Because of border transformation we need to "hard code" left position. */\n\t\tleft: 25%;\n\n\t\ttop: 50%;\n\t\topacity: 0;\n\t\theight: 0;\n\t\twidth: 0;\n\n\t\ttransform: scaleX(-1) rotate(135deg);\n\t\ttransform-origin: left top;\n\t\tborder-top: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\t\tborder-right: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\n\t\tanimation-name: ck-upload-complete-icon-check;\n\t\tanimation-duration: 500ms;\n\t\tanimation-delay: 500ms;\n\t\tanimation-fill-mode: forwards;\n\n\t\t/* #1095. While reset is not providing proper box-sizing for pseudoelements, we need to handle it. */\n\t\tbox-sizing: border-box;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-show {\n\tfrom {\n\t\topacity: 0;\n\t}\n\n\tto {\n\t\topacity: 1;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-hide {\n\tfrom {\n\t\topacity: 1;\n\t}\n\n\tto {\n\t\topacity: 0;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-check {\n\t0% {\n\t\topacity: 1;\n\t\twidth: 0;\n\t\theight: 0;\n\t}\n\t33% {\n\t\twidth: 0.3em;\n\t\theight: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t\twidth: 0.3em;\n\t\theight: 0.45em;\n\t}\n}\n'],
          sourceRoot: ""
        }]), e.Z = s;
      },
      5074: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, '.ck .ck-upload-placeholder-loader{position:absolute;display:flex;align-items:center;justify-content:center;top:0;left:0}.ck .ck-upload-placeholder-loader:before{content:"";position:relative}:root{--ck-color-upload-placeholder-loader:#b3b3b3;--ck-upload-placeholder-loader-size:32px;--ck-upload-placeholder-image-aspect-ratio:2.8}.ck .ck-image-upload-placeholder{width:100%;margin:0}.ck .ck-image-upload-placeholder.image-inline{width:calc(var(--ck-upload-placeholder-loader-size)*2*var(--ck-upload-placeholder-image-aspect-ratio))}.ck .ck-image-upload-placeholder img{aspect-ratio:var(--ck-upload-placeholder-image-aspect-ratio)}.ck .ck-upload-placeholder-loader{width:100%;height:100%}.ck .ck-upload-placeholder-loader:before{width:var(--ck-upload-placeholder-loader-size);height:var(--ck-upload-placeholder-loader-size);border-radius:50%;border-top:3px solid var(--ck-color-upload-placeholder-loader);border-right:2px solid transparent;animation:ck-upload-placeholder-loader 1s linear infinite}@keyframes ck-upload-placeholder-loader{to{transform:rotate(1turn)}}', "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-image/theme/imageuploadloader.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadloader.css"],
          names: [],
          mappings: "AAKA,kCACC,iBAAkB,CAClB,YAAa,CACb,kBAAmB,CACnB,sBAAuB,CACvB,KAAM,CACN,MAMD,CAJC,yCACC,UAAW,CACX,iBACD,CCXD,MACC,4CAAqD,CACrD,wCAAyC,CACzC,8CACD,CAEA,iCAEC,UAAW,CACX,QAeD,CAbC,8CACC,sGACD,CAEA,qCAOC,4DACD,CAGD,kCACC,UAAW,CACX,WAUD,CARC,yCACC,8CAA+C,CAC/C,+CAAgD,CAChD,iBAAkB,CAClB,8DAA+D,CAC/D,kCAAmC,CACnC,yDACD,CAGD,wCACC,GACC,uBACD,CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-upload-placeholder-loader {\n\tposition: absolute;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttop: 0;\n\tleft: 0;\n\n\t&::before {\n\t\tcontent: '';\n\t\tposition: relative;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-upload-placeholder-loader: hsl(0, 0%, 70%);\n\t--ck-upload-placeholder-loader-size: 32px;\n\t--ck-upload-placeholder-image-aspect-ratio: 2.8;\n}\n\n.ck .ck-image-upload-placeholder {\n\t/* We need to control the full width of the SVG gray background. */\n\twidth: 100%;\n\tmargin: 0;\n\n\t&.image-inline {\n\t\twidth: calc( 2 * var(--ck-upload-placeholder-loader-size) * var(--ck-upload-placeholder-image-aspect-ratio) );\n\t}\n\n\t& img {\n\t\t/*\n\t\t * This is an arbitrary aspect for a 1x1 px GIF to display to the user. Not too tall, not too short.\n\t\t * There's nothing special about this number except that it should make the image placeholder look like\n\t\t * a real image during this short period after the upload started and before the image was read from the\n\t\t * file system (and a rich preview was loaded).\n\t\t */\n\t\taspect-ratio: var(--ck-upload-placeholder-image-aspect-ratio);\n\t}\n}\n\n.ck .ck-upload-placeholder-loader {\n\twidth: 100%;\n\theight: 100%;\n\n\t&::before {\n\t\twidth: var(--ck-upload-placeholder-loader-size);\n\t\theight: var(--ck-upload-placeholder-loader-size);\n\t\tborder-radius: 50%;\n\t\tborder-top: 3px solid var(--ck-color-upload-placeholder-loader);\n\t\tborder-right: 2px solid transparent;\n\t\tanimation: ck-upload-placeholder-loader 1s linear infinite;\n\t}\n}\n\n@keyframes ck-upload-placeholder-loader {\n\tto {\n\t\ttransform: rotate( 360deg );\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      4636: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-editor__editable .image,.ck.ck-editor__editable .image-inline{position:relative}.ck.ck-editor__editable .image-inline .ck-progress-bar,.ck.ck-editor__editable .image .ck-progress-bar{position:absolute;top:0;left:0}.ck.ck-editor__editable .image-inline.ck-appear,.ck.ck-editor__editable .image.ck-appear{animation:fadeIn .7s}.ck.ck-editor__editable .image-inline .ck-progress-bar,.ck.ck-editor__editable .image .ck-progress-bar{height:2px;width:0;background:var(--ck-color-upload-bar-background);transition:width .1s}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-image/theme/imageuploadprogress.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadprogress.css"],
          names: [],
          mappings: "AAMC,qEAEC,iBACD,CAGA,uGAEC,iBAAkB,CAClB,KAAM,CACN,MACD,CCRC,yFACC,oBACD,CAID,uGAEC,UAAW,CACX,OAAQ,CACR,gDAAiD,CACjD,oBACD,CAGD,kBACC,GAAO,SAAY,CACnB,GAAO,SAAY,CACpB",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t& .image,\n\t& .image-inline {\n\t\tposition: relative;\n\t}\n\n\t/* Upload progress bar. */\n\t& .image .ck-progress-bar,\n\t& .image-inline .ck-progress-bar {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t& .image,\n\t& .image-inline {\n\t\t/* Showing animation. */\n\t\t&.ck-appear {\n\t\t\tanimation: fadeIn 700ms;\n\t\t}\n\t}\n\n\t/* Upload progress bar. */\n\t& .image .ck-progress-bar,\n\t& .image-inline .ck-progress-bar {\n\t\theight: 2px;\n\t\twidth: 0;\n\t\tbackground: var(--ck-color-upload-bar-background);\n\t\ttransition: width 100ms;\n\t}\n}\n\n@keyframes fadeIn {\n\tfrom { opacity: 0; }\n\tto   { opacity: 1; }\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      6003: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-text-alternative-form{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-text-alternative-form .ck-labeled-field-view{display:inline-block}.ck.ck-text-alternative-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-text-alternative-form{flex-wrap:wrap}.ck.ck-text-alternative-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-text-alternative-form .ck-button{flex-basis:50%}}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-image/theme/textalternativeform.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css"],
          names: [],
          mappings: "AAOA,6BACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,oDACC,oBACD,CAEA,uCACC,YACD,CCZA,oCDCD,6BAcE,cAUF,CARE,oDACC,eACD,CAEA,wCACC,cACD,CCrBD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-text-alternative-form {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      9352: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}.ck .ck-link_selected span.image-inline{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background)}.ck .ck-fake-link-selection{background:var(--ck-color-link-fake-selection)}.ck .ck-fake-link-selection_collapsed{height:100%;border-right:1px solid var(--ck-color-base-text);margin-right:-1px;outline:1px solid hsla(0,0%,100%,.5)}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/link.css"],
          names: [],
          mappings: "AAMA,sBACC,mDAMD,CAHC,wCACC,yFACD,CAOD,4BACC,8CACD,CAGA,sCACC,WAAY,CACZ,gDAAiD,CACjD,iBAAkB,CAClB,oCACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Class added to span element surrounding currently selected link. */\n.ck .ck-link_selected {\n\tbackground: var(--ck-color-link-selected-background);\n\n\t/* Give linked inline images some outline to let the user know they are also part of the link. */\n\t& span.image-inline {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background);\n\t}\n}\n\n/*\n * Classes used by the "fake visual selection" displayed in the content when an input\n * in the link UI has focus (the browser does not render the native selection in this state).\n */\n.ck .ck-fake-link-selection {\n\tbackground: var(--ck-color-link-fake-selection);\n}\n\n/* A collapsed fake visual selection. */\n.ck .ck-fake-link-selection_collapsed {\n\theight: 100%;\n\tborder-right: 1px solid var(--ck-color-base-text);\n\tmargin-right: -1px;\n\toutline: solid 1px hsla(0, 0%, 100%, .5);\n}\n'],
          sourceRoot: ""
        }]), e.Z = s;
      },
      6022: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{padding:0 var(--ck-spacing-medium);color:var(--ck-color-link-default);text-overflow:ellipsis;cursor:pointer;max-width:var(--ck-input-width);min-width:3em;text-align:center}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}[dir=ltr] .ck.ck-link-actions .ck-button:not(:first-child),[dir=rtl] .ck.ck-link-actions .ck-button:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{min-width:0;max-width:100%}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview),[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-link/theme/linkactions.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkactions.css"],
          names: [],
          mappings: "AAOA,oBACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,8CACC,oBAKD,CAHC,gEACC,eACD,CCXD,oCDCD,oBAcE,cAUF,CARE,8CACC,eACD,CAEA,8DACC,cACD,CCrBD,CCKA,wDACC,cAAe,CACf,eAmCD,CAjCC,0EACC,kCAAmC,CACnC,kCAAmC,CACnC,sBAAuB,CACvB,cAAe,CAIf,+BAAgC,CAChC,aAAc,CACd,iBAKD,CAHC,gFACC,yBACD,CAGD,mPAIC,eACD,CAEA,+DACC,eACD,CAGC,gFACC,yBACD,CAWD,qHACC,sCACD,CDvDD,oCC2DC,wDACC,8DAMD,CAJC,0EACC,WAAY,CACZ,cACD,CAGD,gJAME,aAEF,CD1ED",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-link-actions__preview {\n\t\tdisplay: inline-block;\n\n\t\t& .ck-button__label {\n\t\t\toverflow: hidden;\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-link-actions__preview {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\t& .ck-button.ck-link-actions__preview {\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\n\t\t& .ck-button__label {\n\t\t\tpadding: 0 var(--ck-spacing-medium);\n\t\t\tcolor: var(--ck-color-link-default);\n\t\t\ttext-overflow: ellipsis;\n\t\t\tcursor: pointer;\n\n\t\t\t/* Match the box model of the link editor form\'s input so the balloon\n\t\t\tdoes not change width when moving between actions and the form. */\n\t\t\tmax-width: var(--ck-input-width);\n\t\t\tmin-width: 3em;\n\t\t\ttext-align: center;\n\n\t\t\t&:hover {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\n\t\t&,\n\t\t&:hover,\n\t\t&:focus,\n\t\t&:active {\n\t\t\tbackground: none;\n\t\t}\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&:focus {\n\t\t\t& .ck-button__label {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-button:not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-button:not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\t& .ck-button.ck-link-actions__preview {\n\t\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-standard) 0;\n\n\t\t\t& .ck-button__label {\n\t\t\t\tmin-width: 0;\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]), e.Z = s;
      },
      3953: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-link-form{display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form_layout-vertical .ck-button.ck-button-cancel,.ck.ck-link-form_layout-vertical .ck-button.ck-button-save{margin-top:var(--ck-spacing-medium)}.ck.ck-link-form_layout-vertical{padding:0;min-width:var(--ck-input-width)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical .ck-button{padding:var(--ck-spacing-standard);margin:0;border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border);width:50%}[dir=ltr] .ck.ck-link-form_layout-vertical .ck-button,[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin:var(--ck-spacing-standard) var(--ck-spacing-large)}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{border:0;padding:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-link/theme/linkform.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkform.css"],
          names: [],
          mappings: "AAOA,iBACC,YAiBD,CAfC,2BACC,YACD,CCNA,oCDCD,iBAQE,cAUF,CARE,wCACC,eACD,CAEA,4BACC,cACD,CCfD,CDuBD,iCACC,aAYD,CALE,wHAEC,mCACD,CE/BF,iCACC,SAAU,CACV,+BA8CD,CA5CC,wDACC,8EAMD,CAJC,uEACC,WAAY,CACZ,UACD,CAGD,4CACC,kCAAmC,CACnC,QAAS,CACT,eAAgB,CAChB,QAAS,CACT,gDAAiD,CACjD,SAaD,CAnBA,4GAaE,aAMF,CAJE,mEACC,kDACD,CAKF,6CACC,yDAWD,CATC,wEACC,QAAS,CACT,SAAU,CACV,UAKD,CAHC,8EACC,eACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-form {\n\tdisplay: flex;\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tdisplay: block;\n\n\t/*\n\t * Whether the form is in the responsive mode or not, if there are decorator buttons\n\t * keep the top margin of action buttons medium.\n\t */\n\t& .ck-button {\n\t\t&.ck-button-save,\n\t\t&.ck-button-cancel {\n\t\t\tmargin-top: var(--ck-spacing-medium);\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tpadding: 0;\n\tmin-width: var(--ck-input-width);\n\n\t& .ck-labeled-field-view {\n\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small);\n\n\t\t& .ck-input-text {\n\t\t\tmin-width: 0;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t& .ck-button {\n\t\tpadding: var(--ck-spacing-standard);\n\t\tmargin: 0;\n\t\tborder-radius: 0;\n\t\tborder: 0;\n\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\twidth: 50%;\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-left: 0;\n\n\t\t\t&:last-of-type {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Using additional `.ck` class for stronger CSS specificity than `.ck.ck-link-form > :not(:first-child)`. */\n\t& .ck.ck-list {\n\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-large);\n\n\t\t& .ck-button.ck-switchbutton {\n\t\t\tborder: 0;\n\t\t\tpadding: 0;\n\t\t\twidth: 100%;\n\n\t\t\t&:hover {\n\t\t\t\tbackground: none;\n\t\t\t}\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]), e.Z = s;
      },
      8030: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck-content .media{clear:both;margin:.9em 0;display:block;min-width:15em}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaembed.css"],
          names: [],
          mappings: "AAKA,mBAGC,UAAW,CAKX,aAAe,CAIf,aAAc,CAId,cACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .media {\n\t/* Don\'t allow floated content overlap the media.\n\thttps://github.com/ckeditor/ckeditor5-media-embed/issues/53 */\n\tclear: both;\n\n\t/* Make sure there is some space between the content and the media. */\n\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\tmargin: 0.9em 0;\n\n\t/* Make sure media is not overriden with Bootstrap default `flex` value.\n\tSee: https://github.com/ckeditor/ckeditor5/issues/1373. */\n\tdisplay: block;\n\n\t/* Give the media some minimal width in the content to prevent them\n\tfrom being "squashed" in tight spaces, e.g. in table cells (#44) */\n\tmin-width: 15em;\n}\n'],
          sourceRoot: ""
        }]), e.Z = s;
      },
      6385: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, '.ck-media__wrapper .ck-media__placeholder{display:flex;flex-direction:column;align-items:center}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:block}@media (hover:none){.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:none}}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url{max-width:100%;position:relative}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url:hover .ck-tooltip{visibility:visible;opacity:1}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{overflow:hidden;display:block}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck-media__placeholder__icon *{display:none}.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper>:not(.ck-media__placeholder),.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder{pointer-events:none}:root{--ck-media-embed-placeholder-icon-size:3em;--ck-color-media-embed-placeholder-url-text:#757575;--ck-color-media-embed-placeholder-url-text-hover:var(--ck-color-base-text)}.ck-media__wrapper{margin:0 auto}.ck-media__wrapper .ck-media__placeholder{padding:calc(var(--ck-spacing-standard)*3);background:var(--ck-color-base-foreground)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon{min-width:var(--ck-media-embed-placeholder-icon-size);height:var(--ck-media-embed-placeholder-icon-size);margin-bottom:var(--ck-spacing-large);background-position:50%;background-size:cover}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon .ck-icon{width:100%;height:100%}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text{color:var(--ck-color-media-embed-placeholder-url-text);white-space:nowrap;text-align:center;font-style:italic;text-overflow:ellipsis}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:var(--ck-color-media-embed-placeholder-url-text-hover);cursor:pointer;text-decoration:underline}.ck-media__wrapper[data-oembed-url*="open.spotify.com"]{max-width:300px;max-height:380px}.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder{background:#4268b3}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik05NjcuNDg0IDBINTYuNTE3QzI1LjMwNCAwIDAgMjUuMzA0IDAgNTYuNTE3djkxMC45NjZDMCA5OTguNjk0IDI1LjI5NyAxMDI0IDU2LjUyMiAxMDI0SDU0N1Y2MjhINDE0VjQ3M2gxMzNWMzU5LjAyOWMwLTEzMi4yNjIgODAuNzczLTIwNC4yODIgMTk4Ljc1Ni0yMDQuMjgyIDU2LjUxMyAwIDEwNS4wODYgNC4yMDggMTE5LjI0NCA2LjA4OVYyOTlsLTgxLjYxNi4wMzdjLTYzLjk5MyAwLTc2LjM4NCAzMC40OTItNzYuMzg0IDc1LjIzNlY0NzNoMTUzLjQ4N2wtMTkuOTg2IDE1NUg3MDd2Mzk2aDI2MC40ODRjMzEuMjEzIDAgNTYuNTE2LTI1LjMwMyA1Ni41MTYtNTYuNTE2VjU2LjUxNUMxMDI0IDI1LjMwMyA5OTguNjk3IDAgOTY3LjQ4NCAwIiBmaWxsPSIjRkZGRkZFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#cdf}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder{background:linear-gradient(-135deg,#1400c7,#b800b1,#f50000)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#ffe0fe}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder{background:linear-gradient(90deg,#71c6f4,#0d70a5)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIj48cGF0aCBkPSJNNDAwIDIwMGMwIDExMC41LTg5LjUgMjAwLTIwMCAyMDBTMCAzMTAuNSAwIDIwMCA4OS41IDAgMjAwIDBzMjAwIDg5LjUgMjAwIDIwMHpNMTYzLjQgMzA1LjVjODguNyAwIDEzNy4yLTczLjUgMTM3LjItMTM3LjIgMC0yLjEgMC00LjItLjEtNi4yIDkuNC02LjggMTcuNi0xNS4zIDI0LjEtMjUtOC42IDMuOC0xNy45IDYuNC0yNy43IDcuNiAxMC02IDE3LjYtMTUuNCAyMS4yLTI2LjctOS4zIDUuNS0xOS42IDkuNS0zMC42IDExLjctOC44LTkuNC0yMS4zLTE1LjItMzUuMi0xNS4yLTI2LjYgMC00OC4yIDIxLjYtNDguMiA0OC4yIDAgMy44LjQgNy41IDEuMyAxMS00MC4xLTItNzUuNi0yMS4yLTk5LjQtNTAuNC00LjEgNy4xLTYuNSAxNS40LTYuNSAyNC4yIDAgMTYuNyA4LjUgMzEuNSAyMS41IDQwLjEtNy45LS4yLTE1LjMtMi40LTIxLjgtNnYuNmMwIDIzLjQgMTYuNiA0Mi44IDM4LjcgNDcuMy00IDEuMS04LjMgMS43LTEyLjcgMS43LTMuMSAwLTYuMS0uMy05LjEtLjkgNi4xIDE5LjIgMjMuOSAzMy4xIDQ1IDMzLjUtMTYuNSAxMi45LTM3LjMgMjAuNi01OS45IDIwLjYtMy45IDAtNy43LS4yLTExLjUtLjcgMjEuMSAxMy44IDQ2LjUgMjEuOCA3My43IDIxLjgiIGZpbGw9IiNmZmYiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text{color:#b8e6ff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}', "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaembedediting.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-media-embed/mediaembedediting.css"],
          names: [],
          mappings: "AAQC,0CACC,YAAa,CACb,qBAAsB,CACtB,kBAmBD,CCpBA,kFACC,aAqBD,CAHC,oBAnBD,kFAoBE,YAEF,CADC,CDlBA,sEAIC,cAAe,CAEf,iBAUD,CCoBD,wFACC,kBAAmB,CACnB,SACD,CD3BE,wGACC,eAAgB,CAChB,aACD,CAWD,6kBACC,YACD,CAYF,2LACC,mBACD,CElDA,MACC,0CAA2C,CAE3C,mDAA4D,CAC5D,2EACD,CAEA,mBACC,aA+FD,CA7FC,0CACC,0CAA+C,CAC/C,0CA4BD,CA1BC,uEACC,qDAAsD,CACtD,kDAAmD,CACnD,qCAAsC,CACtC,uBAA2B,CAC3B,qBAMD,CAJC,gFACC,UAAW,CACX,WACD,CAGD,4EACC,sDAAuD,CACvD,kBAAmB,CACnB,iBAAkB,CAClB,iBAAkB,CAClB,sBAOD,CALC,kFACC,4DAA6D,CAC7D,cAAe,CACf,yBACD,CAIF,wDACC,eAAgB,CAChB,gBACD,CAEA,4UAIC,gvGACD,CAEA,2EACC,kBAaD,CAXC,wGACC,orBACD,CAEA,6GACC,UAKD,CAHC,mHACC,UACD,CAIF,4EACC,2DAcD,CAZC,yGACC,4jHACD,CAGA,8GACC,aAKD,CAHC,oHACC,UACD,CAIF,6EAEC,iDAaD,CAXC,0GACC,48BACD,CAEA,+GACC,aAKD,CAHC,qHACC,UACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css";\n\n.ck-media__wrapper {\n\t& .ck-media__placeholder {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\n\t\t& .ck-media__placeholder__url {\n\t\t\t@mixin ck-tooltip_enabled;\n\n\t\t\t/* Otherwise the URL will overflow when the content is very narrow. */\n\t\t\tmax-width: 100%;\n\n\t\t\tposition: relative;\n\n\t\t\t&:hover {\n\t\t\t\t@mixin ck-tooltip_visible;\n\t\t\t}\n\n\t\t\t& .ck-media__placeholder__url__text {\n\t\t\t\toverflow: hidden;\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="twitter.com"],\n\t&[data-oembed-url*="google.com/maps"],\n\t&[data-oembed-url*="goo.gl/maps"],\n\t&[data-oembed-url*="maps.google.com"],\n\t&[data-oembed-url*="maps.app.goo.gl"],\n\t&[data-oembed-url*="facebook.com"],\n\t&[data-oembed-url*="instagram.com"] {\n\t\t& .ck-media__placeholder__icon * {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/* Disable all mouse interaction as long as the editor is not read–only.\n   https://github.com/ckeditor/ckeditor5-media-embed/issues/58 */\n.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper > *:not(.ck-media__placeholder) {\n\tpointer-events: none;\n}\n\n/* Disable all mouse interaction when the widget is not selected (e.g. to avoid opening links by accident).\n   https://github.com/ckeditor/ckeditor5-media-embed/issues/18 */\n.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder {\n\tpointer-events: none;\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Enables the tooltip, which is the tooltip is in DOM but\n * not yet displayed.\n */\n@define-mixin ck-tooltip_enabled {\n\t& .ck-tooltip {\n\t\tdisplay: block;\n\n\t\t/*\n\t\t * Don't display tooltips in devices which don't support :hover.\n\t\t * In fact, it's all about iOS, which forces user to click UI elements twice to execute\n\t\t * the primary action, when tooltips are enabled.\n\t\t *\n\t\t * Q: OK, but why not the following query?\n\t\t *\n\t\t *   @media (hover) {\n\t\t *       display: block;\n\t\t *   }\n\t\t *\n\t\t * A: Because FF does not support it and it would completely disable tooltips\n\t\t * in that browser.\n\t\t *\n\t\t * More in https://github.com/ckeditor/ckeditor5/issues/920.\n\t\t */\n\t\t@media (hover:none) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/**\n * Disables the tooltip making it disappear from DOM.\n */\n@define-mixin ck-tooltip_disabled {\n\t& .ck-tooltip {\n\t\tdisplay: none;\n\t}\n}\n\n/**\n * Shows the tooltip, which is already in DOM.\n * Requires `ck-tooltip_enabled` first.\n */\n@define-mixin ck-tooltip_visible {\n\t& .ck-tooltip {\n\t\tvisibility: visible;\n\t\topacity: 1;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-media-embed-placeholder-icon-size: 3em;\n\n\t--ck-color-media-embed-placeholder-url-text: hsl(0, 0%, 46%);\n\t--ck-color-media-embed-placeholder-url-text-hover: var(--ck-color-base-text);\n}\n\n.ck-media__wrapper {\n\tmargin: 0 auto;\n\n\t& .ck-media__placeholder {\n\t\tpadding: calc( 3 * var(--ck-spacing-standard) );\n\t\tbackground: var(--ck-color-base-foreground);\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tmin-width: var(--ck-media-embed-placeholder-icon-size);\n\t\t\theight: var(--ck-media-embed-placeholder-icon-size);\n\t\t\tmargin-bottom: var(--ck-spacing-large);\n\t\t\tbackground-position: center;\n\t\t\tbackground-size: cover;\n\n\t\t\t& .ck-icon {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t}\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: var(--ck-color-media-embed-placeholder-url-text);\n\t\t\twhite-space: nowrap;\n\t\t\ttext-align: center;\n\t\t\tfont-style: italic;\n\t\t\ttext-overflow: ellipsis;\n\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--ck-color-media-embed-placeholder-url-text-hover);\n\t\t\t\tcursor: pointer;\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="open.spotify.com"] {\n\t\tmax-width: 300px;\n\t\tmax-height: 380px;\n\t}\n\n\t&[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon {\n\t\tbackground-image: url(data:image/svg+xml;base64,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);\n\t}\n\n\t&[data-oembed-url*="facebook.com"] .ck-media__placeholder {\n\t\tbackground: hsl(220, 46%, 48%);\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIxMDI0cHgiIGhlaWdodD0iMTAyNHB4IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPiAgICAgICAgPHRpdGxlPkZpbGwgMTwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgaWQ9ImZMb2dvX1doaXRlIiBmaWxsPSIjRkZGRkZFIj4gICAgICAgICAgICA8cGF0aCBkPSJNOTY3LjQ4NCwwIEw1Ni41MTcsMCBDMjUuMzA0LDAgMCwyNS4zMDQgMCw1Ni41MTcgTDAsOTY3LjQ4MyBDMCw5OTguNjk0IDI1LjI5NywxMDI0IDU2LjUyMiwxMDI0IEw1NDcsMTAyNCBMNTQ3LDYyOCBMNDE0LDYyOCBMNDE0LDQ3MyBMNTQ3LDQ3MyBMNTQ3LDM1OS4wMjkgQzU0NywyMjYuNzY3IDYyNy43NzMsMTU0Ljc0NyA3NDUuNzU2LDE1NC43NDcgQzgwMi4yNjksMTU0Ljc0NyA4NTAuODQyLDE1OC45NTUgODY1LDE2MC44MzYgTDg2NSwyOTkgTDc4My4zODQsMjk5LjAzNyBDNzE5LjM5MSwyOTkuMDM3IDcwNywzMjkuNTI5IDcwNywzNzQuMjczIEw3MDcsNDczIEw4NjAuNDg3LDQ3MyBMODQwLjUwMSw2MjggTDcwNyw2MjggTDcwNywxMDI0IEw5NjcuNDg0LDEwMjQgQzk5OC42OTcsMTAyNCAxMDI0LDk5OC42OTcgMTAyNCw5NjcuNDg0IEwxMDI0LDU2LjUxNSBDMTAyNCwyNS4zMDMgOTk4LjY5NywwIDk2Ny40ODQsMCIgaWQ9IkZpbGwtMSI+PC9wYXRoPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+);\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(220, 100%, 90%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="instagram.com"] .ck-media__placeholder {\n\t\tbackground: linear-gradient(-135deg,hsl(246, 100%, 39%),hsl(302, 100%, 36%),hsl(0, 100%, 48%));\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,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);\n\t\t}\n\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(302, 100%, 94%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder {\n\t\t/* Use gradient to contrast with focused widget (ckeditor/ckeditor5-media-embed#22). */\n\t\tbackground: linear-gradient( to right, hsl(201, 85%, 70%), hsl(201, 85%, 35%) );\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IldoaXRlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQwMCA0MDAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQwMCA0MDA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPi5zdDB7ZmlsbDojRkZGRkZGO308L3N0eWxlPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00MDAsMjAwYzAsMTEwLjUtODkuNSwyMDAtMjAwLDIwMFMwLDMxMC41LDAsMjAwUzg5LjUsMCwyMDAsMFM0MDAsODkuNSw0MDAsMjAweiBNMTYzLjQsMzA1LjVjODguNywwLDEzNy4yLTczLjUsMTM3LjItMTM3LjJjMC0yLjEsMC00LjItMC4xLTYuMmM5LjQtNi44LDE3LjYtMTUuMywyNC4xLTI1Yy04LjYsMy44LTE3LjksNi40LTI3LjcsNy42YzEwLTYsMTcuNi0xNS40LDIxLjItMjYuN2MtOS4zLDUuNS0xOS42LDkuNS0zMC42LDExLjdjLTguOC05LjQtMjEuMy0xNS4yLTM1LjItMTUuMmMtMjYuNiwwLTQ4LjIsMjEuNi00OC4yLDQ4LjJjMCwzLjgsMC40LDcuNSwxLjMsMTFjLTQwLjEtMi03NS42LTIxLjItOTkuNC01MC40Yy00LjEsNy4xLTYuNSwxNS40LTYuNSwyNC4yYzAsMTYuNyw4LjUsMzEuNSwyMS41LDQwLjFjLTcuOS0wLjItMTUuMy0yLjQtMjEuOC02YzAsMC4yLDAsMC40LDAsMC42YzAsMjMuNCwxNi42LDQyLjgsMzguNyw0Ny4zYy00LDEuMS04LjMsMS43LTEyLjcsMS43Yy0zLjEsMC02LjEtMC4zLTkuMS0wLjljNi4xLDE5LjIsMjMuOSwzMy4xLDQ1LDMzLjVjLTE2LjUsMTIuOS0zNy4zLDIwLjYtNTkuOSwyMC42Yy0zLjksMC03LjctMC4yLTExLjUtMC43QzExMC44LDI5Ny41LDEzNi4yLDMwNS41LDE2My40LDMwNS41Ii8+PC9zdmc+);\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(201, 100%, 86%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]), e.Z = s;
      },
      1523: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-media-form{display:flex;align-items:flex-start;flex-direction:row;flex-wrap:nowrap}.ck.ck-media-form .ck-labeled-field-view{display:inline-block}.ck.ck-media-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-media-form{flex-wrap:wrap}.ck.ck-media-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-media-form .ck-button{flex-basis:50%}}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaform.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css"],
          names: [],
          mappings: "AAOA,kBACC,YAAa,CACb,sBAAuB,CACvB,kBAAmB,CACnB,gBAqBD,CAnBC,yCACC,oBACD,CAEA,4BACC,YACD,CCbA,oCDCD,kBAeE,cAUF,CARE,yCACC,eACD,CAEA,6BACC,cACD,CCtBD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-media-form {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      3010: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-color-mention-background:rgba(153,0,48,0.1);--ck-color-mention-text:#990030}.ck-content .mention{background:var(--ck-color-mention-background);color:var(--ck-color-mention-text)}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-mention/mention.css"],
          names: [],
          mappings: "AAKA,MACC,gDAAwD,CACxD,+BACD,CAEA,qBACC,6CAA8C,CAC9C,kCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-mention-background: hsla(341, 100%, 30%, 0.1);\n\t--ck-color-mention-text: hsl(341, 100%, 30%);\n}\n\n.ck-content .mention {\n\tbackground: var(--ck-color-mention-background);\n\tcolor: var(--ck-color-mention-text);\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      6614: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-mention-list-max-height:300px}.ck.ck-mentions{max-height:var(--ck-mention-list-max-height);overflow-y:auto;overflow-x:hidden;overscroll-behavior:contain}.ck.ck-mentions>.ck-list__item{overflow:hidden;flex-shrink:0}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-mention/theme/mentionui.css"],
          names: [],
          mappings: "AAKA,MACC,kCACD,CAEA,gBACC,4CAA6C,CAE7C,eAAgB,CAIhB,iBAAkB,CAElB,2BAQD,CAJC,+BACC,eAAgB,CAChB,aACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-mention-list-max-height: 300px;\n}\n\n.ck.ck-mentions {\n\tmax-height: var(--ck-mention-list-max-height);\n\n\toverflow-y: auto;\n\n\t/* Prevent unnecessary horizontal scrollbar in Safari\n\thttps://github.com/ckeditor/ckeditor5-mention/issues/41 */\n\toverflow-x: hidden;\n\n\toverscroll-behavior: contain;\n\n\t/* Prevent unnecessary vertical scrollbar in Safari\n\thttps://github.com/ckeditor/ckeditor5-mention/issues/41 */\n\t& > .ck-list__item {\n\t\toverflow: hidden;\n\t\tflex-shrink: 0;\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      2798: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck .ck-insert-table-dropdown__grid{display:flex;flex-direction:row;flex-wrap:wrap}:root{--ck-insert-table-dropdown-padding:10px;--ck-insert-table-dropdown-box-height:11px;--ck-insert-table-dropdown-box-width:12px;--ck-insert-table-dropdown-box-margin:1px}.ck .ck-insert-table-dropdown__grid{width:calc(var(--ck-insert-table-dropdown-box-width)*10 + var(--ck-insert-table-dropdown-box-margin)*20 + var(--ck-insert-table-dropdown-padding)*2);padding:var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0}.ck .ck-insert-table-dropdown__label{text-align:center}.ck .ck-insert-table-dropdown-grid-box{width:var(--ck-insert-table-dropdown-box-width);height:var(--ck-insert-table-dropdown-box-height);margin:var(--ck-insert-table-dropdown-box-margin);border:1px solid var(--ck-color-base-border);border-radius:1px}.ck .ck-insert-table-dropdown-grid-box.ck-on{border-color:var(--ck-color-focus-border);background:var(--ck-color-focus-outer-shadow)}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-table/theme/inserttable.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/inserttable.css"],
          names: [],
          mappings: "AAKA,oCACC,YAAa,CACb,kBAAmB,CACnB,cACD,CCJA,MACC,uCAAwC,CACxC,0CAA2C,CAC3C,yCAA0C,CAC1C,yCACD,CAEA,oCAEC,oJAA2J,CAC3J,yFACD,CAEA,qCACC,iBACD,CAEA,uCACC,+CAAgD,CAChD,iDAAkD,CAClD,iDAAkD,CAClD,4CAA6C,CAC7C,iBAMD,CAJC,6CACC,yCAA0C,CAC1C,6CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-insert-table-dropdown__grid {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: wrap;\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-insert-table-dropdown-padding: 10px;\n\t--ck-insert-table-dropdown-box-height: 11px;\n\t--ck-insert-table-dropdown-box-width: 12px;\n\t--ck-insert-table-dropdown-box-margin: 1px;\n}\n\n.ck .ck-insert-table-dropdown__grid {\n\t/* The width of a container should match 10 items in a row so there will be a 10x10 grid. */\n\twidth: calc(var(--ck-insert-table-dropdown-box-width) * 10 + var(--ck-insert-table-dropdown-box-margin) * 20 + var(--ck-insert-table-dropdown-padding) * 2);\n\tpadding: var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0;\n}\n\n.ck .ck-insert-table-dropdown__label {\n\ttext-align: center;\n}\n\n.ck .ck-insert-table-dropdown-grid-box {\n\twidth: var(--ck-insert-table-dropdown-box-width);\n\theight: var(--ck-insert-table-dropdown-box-height);\n\tmargin: var(--ck-insert-table-dropdown-box-margin);\n\tborder: 1px solid var(--ck-color-base-border);\n\tborder-radius: 1px;\n\n\t&.ck-on {\n\t\tborder-color: var(--ck-color-focus-border);\n\t\tbackground: var(--ck-color-focus-outer-shadow);\n\t}\n}\n\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      9311: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck-content .table{margin:.9em auto;display:table}.ck-content .table table{border-collapse:collapse;border-spacing:0;width:100%;height:100%;border:1px double #b3b3b3}.ck-content .table table td,.ck-content .table table th{min-width:2em;padding:.4em;border:1px solid #bfbfbf}.ck-content .table table th{font-weight:700;background:hsla(0,0%,0%,5%)}.ck-content[dir=rtl] .table th{text-align:right}.ck-content[dir=ltr] .table th{text-align:left}.ck-editor__editable .ck-table-bogus-paragraph{display:inline-block;width:100%}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-table/theme/table.css"],
          names: [],
          mappings: "AAKA,mBAIC,gBAAkB,CAClB,aAgCD,CA9BC,yBAEC,wBAAyB,CACzB,gBAAiB,CAIjB,UAAW,CACX,WAAY,CAIZ,yBAiBD,CAfC,wDAEC,aAAc,CACd,YAAa,CAKb,wBACD,CAEA,4BACC,eAAiB,CACjB,2BACD,CAMF,+BACC,gBACD,CAEA,+BACC,eACD,CAEA,+CAKC,oBAAqB,CAMrB,UACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .table {\n\t/* Give the table widget some air and center it horizontally */\n\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\tmargin: 0.9em auto;\n\tdisplay: table;\n\n\t& table {\n\t\t/* The table cells should have slight borders */\n\t\tborder-collapse: collapse;\n\t\tborder-spacing: 0;\n\n\t\t/* Table width and height are set on the parent <figure>. Make sure the table inside stretches\n\t\tto the full dimensions of the container (https://github.com/ckeditor/ckeditor5/issues/6186). */\n\t\twidth: 100%;\n\t\theight: 100%;\n\n\t\t/* The outer border of the table should be slightly darker than the inner lines.\n\t\tAlso see https://github.com/ckeditor/ckeditor5-table/issues/50. */\n\t\tborder: 1px double hsl(0, 0%, 70%);\n\n\t\t& td,\n\t\t& th {\n\t\t\tmin-width: 2em;\n\t\t\tpadding: .4em;\n\n\t\t\t/* The border is inherited from .ck-editor__nested-editable styles, so theoretically it\'s not necessary here.\n\t\t\tHowever, the border is a content style, so it should use .ck-content (so it works outside the editor).\n\t\t\tHence, the duplication. See https://github.com/ckeditor/ckeditor5/issues/6314 */\n\t\t\tborder: 1px solid hsl(0, 0%, 75%);\n\t\t}\n\n\t\t& th {\n\t\t\tfont-weight: bold;\n\t\t\tbackground: hsla(0, 0%, 0%, 5%);\n\t\t}\n\t}\n}\n\n/* Text alignment of the table header should match the editor settings and override the native browser styling,\nwhen content is available outside the ediitor. See https://github.com/ckeditor/ckeditor5/issues/6638 */\n.ck-content[dir="rtl"] .table th {\n\ttext-align: right;\n}\n\n.ck-content[dir="ltr"] .table th {\n\ttext-align: left;\n}\n\n.ck-editor__editable .ck-table-bogus-paragraph {\n\t/*\n\t * Use display:inline-block to force Chrome/Safari to limit text mutations to this element.\n\t * See https://github.com/ckeditor/ckeditor5/issues/6062.\n\t */\n\tdisplay: inline-block;\n\n\t/*\n\t * Inline HTML elements nested in the span should always be dimensioned in relation to the whole cell width.\n\t * See https://github.com/ckeditor/ckeditor5/issues/9117.\n\t */\n\twidth: 100%;\n}\n'],
          sourceRoot: ""
        }]), e.Z = s;
      },
      2511: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-color-table-focused-cell-background:rgba(158,207,250,0.3)}.ck-widget.table td.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table td.ck-editor__nested-editable:focus,.ck-widget.table th.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table th.ck-editor__nested-editable:focus{background:var(--ck-color-table-focused-cell-background);border-style:none;outline:1px solid var(--ck-color-focus-border);outline-offset:-1px}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableediting.css"],
          names: [],
          mappings: "AAKA,MACC,8DACD,CAKE,8QAGC,wDAAyD,CAKzD,iBAAkB,CAClB,8CAA+C,CAC/C,mBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-table-focused-cell-background: hsla(208, 90%, 80%, .3);\n}\n\n.ck-widget.table {\n\t& td,\n\t& th {\n\t\t&.ck-editor__nested-editable.ck-editor__nested-editable_focused,\n\t\t&.ck-editor__nested-editable:focus {\n\t\t\t/* A very slight background to highlight the focused cell */\n\t\t\tbackground: var(--ck-color-table-focused-cell-background);\n\n\t\t\t/* Fixes the problem where surrounding cells cover the focused cell's border.\n\t\t\tIt does not fix the problem in all places but the UX is improved.\n\t\t\tSee https://github.com/ckeditor/ckeditor5-table/issues/29. */\n\t\t\tborder-style: none;\n\t\t\toutline: 1px solid var(--ck-color-focus-border);\n\t\t\toutline-offset: -1px; /* progressive enhancement - no IE support */\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      2382: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ':root{--ck-table-selected-cell-background:rgba(158,207,250,0.3)}.ck.ck-editor__editable .table table td.ck-editor__editable_selected,.ck.ck-editor__editable .table table th.ck-editor__editable_selected{position:relative;caret-color:transparent;outline:unset;box-shadow:unset}.ck.ck-editor__editable .table table td.ck-editor__editable_selected:after,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:after{content:"";pointer-events:none;background-color:var(--ck-table-selected-cell-background);position:absolute;top:0;left:0;right:0;bottom:0}.ck.ck-editor__editable .table table td.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table td.ck-editor__editable_selected:focus,.ck.ck-editor__editable .table table th.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:focus{background-color:transparent}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget{outline:unset}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget>.ck-widget__selection-handle,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget>.ck-widget__selection-handle{display:none}', "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableselection.css"],
          names: [],
          mappings: "AAKA,MACC,yDACD,CAGC,0IAEC,iBAAkB,CAClB,uBAAwB,CACxB,aAAc,CACd,gBA8BD,CA3BC,sJACC,UAAW,CACX,mBAAoB,CACpB,yDAA0D,CAC1D,iBAAkB,CAClB,KAAM,CACN,MAAO,CACP,OAAQ,CACR,QACD,CAEA,wTAEC,4BACD,CAMA,gKACC,aAKD,CAHC,0NACC,YACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-table-selected-cell-background: hsla(208, 90%, 80%, .3);\n}\n\n.ck.ck-editor__editable .table table {\n\t& td.ck-editor__editable_selected,\n\t& th.ck-editor__editable_selected {\n\t\tposition: relative;\n\t\tcaret-color: transparent;\n\t\toutline: unset;\n\t\tbox-shadow: unset;\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/6446 */\n\t\t&:after {\n\t\t\tcontent: '';\n\t\t\tpointer-events: none;\n\t\t\tbackground-color: var(--ck-table-selected-cell-background);\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t}\n\n\t\t& ::selection,\n\t\t&:focus {\n\t\t\tbackground-color: transparent;\n\t\t}\n\n\t\t/*\n\t\t * To reduce the amount of noise, all widgets in the table selection have no outline and no selection handle.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9491.\n\t\t */\n\t\t& .ck-widget {\n\t\t\toutline: unset;\n\n\t\t\t& > .ck-widget__selection-handle {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      2518: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-button,a.ck.ck-button{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:block}@media (hover:none){.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:none}}.ck.ck-button,a.ck.ck-button{position:relative;display:inline-flex;align-items:center;justify-content:left}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{display:none}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button:hover .ck-tooltip,a.ck.ck-button:hover .ck-tooltip{visibility:visible;opacity:1}.ck.ck-button:focus:not(:hover) .ck-tooltip,a.ck.ck-button:focus:not(:hover) .ck-tooltip{display:none}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-default-active-shadow)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{white-space:nowrap;cursor:default;vertical-align:middle;padding:var(--ck-spacing-tiny);text-align:center;min-width:var(--ck-ui-component-min-height);min-height:var(--ck-ui-component-min-height);line-height:1;font-size:inherit;border:1px solid transparent;transition:box-shadow .2s ease-in-out,border .2s ease-in-out;-webkit-appearance:none}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{font-size:inherit;font-weight:inherit;color:inherit;cursor:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{color:inherit}[dir=ltr] .ck.ck-button .ck-button__keystroke,[dir=ltr] a.ck.ck-button .ck-button__keystroke{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-button .ck-button__keystroke,[dir=rtl] a.ck.ck-button .ck-button__keystroke{margin-right:var(--ck-spacing-large)}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{font-weight:700;opacity:.7}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__icon{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__keystroke,a.ck.ck-button.ck-disabled .ck-button__keystroke{opacity:.3}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(var(--ck-spacing-small)*-1);margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-right:calc(var(--ck-spacing-small)*-1);margin-left:var(--ck-spacing-small)}.ck.ck-button.ck-button_with-keystroke .ck-button__label,a.ck.ck-button.ck-button_with-keystroke .ck-button__label{flex-grow:1}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-on-active-shadow)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-action-active-shadow)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/button/button.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/button.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/mixins/_button.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css"],
          names: [],
          mappings: "AAQA,6BCCC,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBD6BD,CE/BC,qDACC,aAqBD,CAHC,oBAnBD,qDAoBE,YAEF,CADC,CFvBF,6BAKC,iBAAkB,CAClB,mBAAoB,CACpB,kBAAmB,CACnB,oBAyBD,CAvBC,iEACC,YACD,CAGC,yGACC,oBACD,CAID,iFACC,sBACD,CEkBA,iEACC,kBAAmB,CACnB,SACD,CAbA,yFACC,YACD,CC7BD,6BCAC,oDD0ID,CCvIE,6EACC,0DACD,CAEA,+EACC,2DAA4C,CAC5C,uEACD,CAID,qDACC,6DACD,CDhBD,6BEDC,eF2ID,CA1IA,wIEGE,qCFuIF,CA1IA,6BAKC,kBAAmB,CACnB,cAAe,CACf,qBAAsB,CACtB,8BAA+B,CAC/B,iBAAkB,CAGlB,2CAA4C,CAC5C,4CAA6C,CAI7C,aAAc,CAGd,iBAAkB,CAGlB,4BAA6B,CAG7B,4DAA8D,CAG9D,uBA6GD,CA3GC,oFGjCA,YAAa,CACb,2BAA2B,CCF3B,2CJsCA,CAIC,kJAEC,aACD,CAGD,iEAEC,iBAAkB,CAClB,mBAAoB,CACpB,aAAc,CACd,cAAe,CAIf,qBASD,CAlBA,qFAYE,eAMF,CAlBA,qFAgBE,gBAEF,CAEA,yEACC,aAYD,CAbA,6FAIE,mCASF,CAbA,6FAQE,oCAKF,CAbA,yEAWC,eAAiB,CACjB,UACD,CAIC,oIIrFD,oDJyFC,CAEA,uFK3FD,kCL6FC,CAGA,yFKhGD,kCLkGC,CAEA,iGACC,UACD,CAGD,qEACC,yDAcD,CAXC,2HAEE,4CAA+C,CAC/C,oCAOF,CAVA,2HAOE,6CAAgD,CAChD,mCAEF,CAKA,mHACC,WACD,CAID,yCC/HA,+CDiIA,CC9HC,yFACC,qDACD,CAEA,2FACC,sDAA4C,CAC5C,kEACD,CAID,iEACC,wDACD,CDmHA,2DACC,iCACD,CAEA,+DACC,mCACD,CAID,2CC7IC,mDDkJD,CC/IE,2FACC,yDACD,CAEA,6FACC,0DAA4C,CAC5C,sEACD,CAID,mEACC,4DACD,CD6HD,2CAIC,wCACD,CAEA,uCAEC,eACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n@import "../tooltip/mixins/_tooltip.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-unselectable;\n\t@mixin ck-tooltip_enabled;\n\n\tposition: relative;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: left;\n\n\t& .ck-button__label {\n\t\tdisplay: none;\n\t}\n\n\t&.ck-button_with-text {\n\t\t& .ck-button__label {\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n\n\t/* Center the icon horizontally in a button without text. */\n\t&:not(.ck-button_with-text)  {\n\t\tjustify-content: center;\n\t}\n\n\t&:hover {\n\t\t@mixin ck-tooltip_visible;\n\t}\n\n\t/* Get rid of the native focus outline around the tooltip when focused (but not :hover). */\n\t&:focus:not(:hover) {\n\t\t@mixin ck-tooltip_disabled;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Enables the tooltip, which is the tooltip is in DOM but\n * not yet displayed.\n */\n@define-mixin ck-tooltip_enabled {\n\t& .ck-tooltip {\n\t\tdisplay: block;\n\n\t\t/*\n\t\t * Don't display tooltips in devices which don't support :hover.\n\t\t * In fact, it's all about iOS, which forces user to click UI elements twice to execute\n\t\t * the primary action, when tooltips are enabled.\n\t\t *\n\t\t * Q: OK, but why not the following query?\n\t\t *\n\t\t *   @media (hover) {\n\t\t *       display: block;\n\t\t *   }\n\t\t *\n\t\t * A: Because FF does not support it and it would completely disable tooltips\n\t\t * in that browser.\n\t\t *\n\t\t * More in https://github.com/ckeditor/ckeditor5/issues/920.\n\t\t */\n\t\t@media (hover:none) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/**\n * Disables the tooltip making it disappear from DOM.\n */\n@define-mixin ck-tooltip_disabled {\n\t& .ck-tooltip {\n\t\tdisplay: none;\n\t}\n}\n\n/**\n * Shows the tooltip, which is already in DOM.\n * Requires `ck-tooltip_enabled` first.\n */\n@define-mixin ck-tooltip_visible {\n\t& .ck-tooltip {\n\t\tvisibility: visible;\n\t\topacity: 1;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../mixins/_button.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-button-colors --ck-color-button-default;\n\t@mixin ck-rounded-corners;\n\n\twhite-space: nowrap;\n\tcursor: default;\n\tvertical-align: middle;\n\tpadding: var(--ck-spacing-tiny);\n\ttext-align: center;\n\n\t/* A very important piece of styling. Go to variable declaration to learn more. */\n\tmin-width: var(--ck-ui-component-min-height);\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Normalize the height of the line. Removing this will break consistent height\n\tamong text and text-less buttons (with icons). */\n\tline-height: 1;\n\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t/* Avoid flickering when the foucs border shows up. */\n\tborder: 1px solid transparent;\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .2s ease-in-out, border .2s ease-in-out;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/189 */\n\t-webkit-appearance: none;\n\n\t&:active,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t/* Allow icon coloring using the text "color" property. */\n\t& .ck-button__icon {\n\t\t& use,\n\t\t& use * {\n\t\t\tcolor: inherit;\n\t\t}\n\t}\n\n\t& .ck-button__label {\n\t\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\t\tfont-size: inherit;\n\t\tfont-weight: inherit;\n\t\tcolor: inherit;\n\t\tcursor: inherit;\n\n\t\t/* Must be consistent with .ck-icon\'s vertical align. Otherwise, buttons with and\n\t\twithout labels (but with icons) have different sizes in Chrome */\n\t\tvertical-align: middle;\n\n\t\t@mixin ck-dir ltr {\n\t\t\ttext-align: left;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttext-align: right;\n\t\t}\n\t}\n\n\t& .ck-button__keystroke {\n\t\tcolor: inherit;\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: var(--ck-spacing-large);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-right: var(--ck-spacing-large);\n\t\t}\n\n\t\tfont-weight: bold;\n\t\topacity: .7;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t&.ck-disabled {\n\t\t&:active,\n\t\t&:focus {\n\t\t\t/* The disabled button should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t\t& .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t& .ck-button__keystroke {\n\t\t\topacity: .3;\n\t\t}\n\t}\n\n\t&.ck-button_with-text {\n\t\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-standard);\n\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-button_with-keystroke {\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__label {\n\t\t\tflex-grow: 1;\n\t\t}\n\t}\n\n\t/* A style of the button which is currently on, e.g. its feature is active. */\n\t&.ck-on {\n\t\t@mixin ck-button-colors --ck-color-button-on;\n\t}\n\n\t&.ck-button-save {\n\t\tcolor: var(--ck-color-button-save);\n\t}\n\n\t&.ck-button-cancel {\n\t\tcolor: var(--ck-color-button-cancel);\n\t}\n}\n\n/* A style of the button which handles the primary action. */\n.ck.ck-button-action,\na.ck.ck-button-action {\n\t@mixin ck-button-colors --ck-color-button-action;\n\n\tcolor: var(--ck-color-button-action-text);\n}\n\n.ck.ck-button-bold,\na.ck.ck-button-bold {\n\tfont-weight: bold;\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements a button of given background color.\n *\n * @param {String} $background - Background color of the button.\n * @param {String} $border - Border color of the button.\n */\n@define-mixin ck-button-colors $prefix {\n\tbackground: var($(prefix)-background);\n\n\t&:not(.ck-disabled) {\n\t\t&:hover {\n\t\t\tbackground: var($(prefix)-hover-background);\n\t\t}\n\n\t\t&:active {\n\t\t\tbackground: var($(prefix)-active-background);\n\t\t\tbox-shadow: inset 0 2px 2px var($(prefix)-active-shadow);\n\t\t}\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t&.ck-disabled {\n\t\tbackground: var($(prefix)-disabled-background);\n\t}\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      9483: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:1.0769230769em;--ck-switch-button-toggle-spacing:1px;--ck-switch-button-translation:calc(var(--ck-switch-button-toggle-width) - var(--ck-switch-button-toggle-inner-size) - var(--ck-switch-button-toggle-spacing)*2)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(var(--ck-spacing-large)*2)}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(var(--ck-spacing-large)*2)}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{transition:background .4s ease;width:var(--ck-switch-button-toggle-width);background:var(--ck-color-switch-button-off-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(var(--ck-border-radius)*0.5)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{margin:var(--ck-switch-button-toggle-spacing);width:var(--ck-switch-button-toggle-inner-size);height:var(--ck-switch-button-toggle-inner-size);background:var(--ck-color-switch-button-inner-background);transition:all .3s ease}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var(--ck-switch-button-translation))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(var(--ck-switch-button-translation)*-1))}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/button/switchbutton.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/switchbutton.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css"],
          names: [],
          mappings: "AASE,4HACC,aACD,CCCF,MAEC,8CAA+C,CAE/C,mDAAoD,CACpD,qCAAsC,CACtC,gKAKD,CAGC,0DAGE,4CAOF,CAVA,0DAQE,2CAEF,CAEA,iDC3BA,eDoEA,CAzCA,yICvBC,qCDgED,CAzCA,2DAKE,gBAoCF,CAzCA,2DAUE,iBA+BF,CAzCA,iDAcC,8BAAiC,CAEjC,0CAA2C,CAC3C,uDAwBD,CAtBC,2EC9CD,eD2DC,CAbA,6LC1CA,qCAAsC,CD4CpC,+CAWF,CAbA,2EAMC,6CAA8C,CAC9C,+CAAgD,CAChD,gDAAiD,CACjD,yDAA0D,CAG1D,uBACD,CAEA,uDACC,6DAKD,CAHC,iFACC,+DACD,CAIF,6DExEA,kCF0EA,CAEA,uDACC,sDAkBD,CAhBC,6DACC,4DACD,CAEA,2FAKE,yDAMF,CAXA,2FASE,kEAEF",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-button.ck-switchbutton {\n\t& .ck-button__toggle {\n\t\tdisplay: block;\n\n\t\t& .ck-button__toggle__inner {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/* Note: To avoid rendering issues (aliasing) but to preserve the responsive nature\nof the component, floating–point numbers have been used which, for the default font size\n(see: --ck-font-size-base), will generate simple integers. */\n:root {\n\t/* 34px at 13px font-size */\n\t--ck-switch-button-toggle-width: 2.6153846154em;\n\t/* 14px at 13px font-size */\n\t--ck-switch-button-toggle-inner-size: 1.0769230769em;\n\t--ck-switch-button-toggle-spacing: 1px;\n\t--ck-switch-button-translation: calc(\n\t\tvar(--ck-switch-button-toggle-width) -\n\t\tvar(--ck-switch-button-toggle-inner-size) -\n\t\t2 * var(--ck-switch-button-toggle-spacing)\n\t);\n}\n\n.ck.ck-button.ck-switchbutton {\n\t& .ck-button__label {\n\t\t@mixin ck-dir ltr {\n\t\t\t/* Separate the label from the switch */\n\t\t\tmargin-right: calc(2 * var(--ck-spacing-large));\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t/* Separate the label from the switch */\n\t\t\tmargin-left: calc(2 * var(--ck-spacing-large));\n\t\t}\n\t}\n\n\t& .ck-button__toggle {\n\t\t@mixin ck-rounded-corners;\n\n\t\t@mixin ck-dir ltr {\n\t\t\t/* Make sure the toggle is always to the right as far as possible. */\n\t\t\tmargin-left: auto;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t/* Make sure the toggle is always to the left as far as possible. */\n\t\t\tmargin-right: auto;\n\t\t}\n\n\t\t/* Gently animate the background color of the toggle switch */\n\t\ttransition: background 400ms ease;\n\n\t\twidth: var(--ck-switch-button-toggle-width);\n\t\tbackground: var(--ck-color-switch-button-off-background);\n\n\t\t& .ck-button__toggle__inner {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-radius: calc(.5 * var(--ck-border-radius));\n\t\t\t}\n\n\t\t\t/* Leave some tiny bit of space around the inner part of the switch */\n\t\t\tmargin: var(--ck-switch-button-toggle-spacing);\n\t\t\twidth: var(--ck-switch-button-toggle-inner-size);\n\t\t\theight: var(--ck-switch-button-toggle-inner-size);\n\t\t\tbackground: var(--ck-color-switch-button-inner-background);\n\n\t\t\t/* Gently animate the inner part of the toggle switch */\n\t\t\ttransition: all 300ms ease;\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground: var(--ck-color-switch-button-off-hover-background);\n\n\t\t\t& .ck-button__toggle__inner {\n\t\t\t\tbox-shadow: 0 0 0 5px var(--ck-color-switch-button-inner-shadow);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-button__toggle {\n\t\t@mixin ck-disabled;\n\t}\n\n\t&.ck-on .ck-button__toggle {\n\t\tbackground: var(--ck-color-switch-button-on-background);\n\n\t\t&:hover {\n\t\t\tbackground: var(--ck-color-switch-button-on-hover-background);\n\t\t}\n\n\t\t& .ck-button__toggle__inner {\n\t\t\t/*\n\t\t\t * Move the toggle switch to the right. It will be animated.\n\t\t\t */\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\ttransform: translateX( var( --ck-switch-button-translation ) );\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\ttransform: translateX( calc( -1 * var( --ck-switch-button-translation ) ) );\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      3362: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-color-grid{display:grid}:root{--ck-color-grid-tile-size:24px;--ck-color-color-grid-check-icon:#000}.ck.ck-color-grid{grid-gap:5px;padding:8px}.ck.ck-color-grid__tile{width:var(--ck-color-grid-tile-size);height:var(--ck-color-grid-tile-size);min-width:var(--ck-color-grid-tile-size);min-height:var(--ck-color-grid-tile-size);padding:0;transition:box-shadow .2s ease;border:0}.ck.ck-color-grid__tile.ck-disabled{cursor:unset;transition:unset}.ck.ck-color-grid__tile.ck-color-table__color-tile_bordered{box-shadow:0 0 0 1px var(--ck-color-base-border)}.ck.ck-color-grid__tile .ck.ck-icon{display:none;color:var(--ck-color-color-grid-check-icon)}.ck.ck-color-grid__tile.ck-on{box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-base-text)}.ck.ck-color-grid__tile.ck-on .ck.ck-icon{display:block}.ck.ck-color-grid__tile.ck-on,.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){border:0}.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-focus-border)}.ck.ck-color-grid__label{padding:0 var(--ck-spacing-standard)}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/colorgrid/colorgrid.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/colorgrid/colorgrid.css"],
          names: [],
          mappings: "AAKA,kBACC,YACD,CCAA,MACC,8BAA+B,CAK/B,qCACD,CAEA,kBACC,YAAa,CACb,WACD,CAEA,wBACC,oCAAqC,CACrC,qCAAsC,CACtC,wCAAyC,CACzC,yCAA0C,CAC1C,SAAU,CACV,8BAA+B,CAC/B,QAmCD,CAjCC,oCACC,YAAa,CACb,gBACD,CAEA,4DACC,gDACD,CAEA,oCACC,YAAa,CACb,2CACD,CAEA,8BACC,8FAKD,CAHC,0CACC,aACD,CAGD,8HAIC,QACD,CAEA,gGAEC,iGACD,CAGD,yBACC,oCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-color-grid {\n\tdisplay: grid;\n}\n", '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-color-grid-tile-size: 24px;\n\n\t/* Not using global colors here because these may change but some colors in a pallette\n\t * require special treatment. For instance, this ensures no matter what the UI text color is,\n\t * the check icon will look good on the black color tile. */\n\t--ck-color-color-grid-check-icon: hsl(0, 0%, 0%);\n}\n\n.ck.ck-color-grid {\n\tgrid-gap: 5px;\n\tpadding: 8px;\n}\n\n.ck.ck-color-grid__tile {\n\twidth: var(--ck-color-grid-tile-size);\n\theight: var(--ck-color-grid-tile-size);\n\tmin-width: var(--ck-color-grid-tile-size);\n\tmin-height: var(--ck-color-grid-tile-size);\n\tpadding: 0;\n\ttransition: .2s ease box-shadow;\n\tborder: 0;\n\n\t&.ck-disabled {\n\t\tcursor: unset;\n\t\ttransition: unset;\n\t}\n\n\t&.ck-color-table__color-tile_bordered {\n\t\tbox-shadow: 0 0 0 1px var(--ck-color-base-border);\n\t}\n\n\t& .ck.ck-icon {\n\t\tdisplay: none;\n\t\tcolor: var(--ck-color-color-grid-check-icon);\n\t}\n\n\t&.ck-on {\n\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-base-text);\n\n\t\t& .ck.ck-icon {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t&.ck-on,\n\t&:focus:not( .ck-disabled ),\n\t&:hover:not( .ck-disabled ) {\n\t\t/* Disable the default .ck-button\'s border ring. */\n\t\tborder: 0;\n\t}\n\n\t&:focus:not( .ck-disabled ),\n\t&:hover:not( .ck-disabled ) {\n\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-focus-border);\n\t}\n}\n\n.ck.ck-color-grid__label {\n\tpadding: 0 var(--ck-spacing-standard);\n}\n'],
          sourceRoot: ""
        }]), e.Z = s;
      },
      4130: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-dropdown-max-width:75vw}.ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on .ck-tooltip{display:none}.ck.ck-dropdown .ck-dropdown__panel{-webkit-backface-visibility:hidden;display:none;z-index:var(--ck-z-modal);max-width:var(--ck-dropdown-max-width);position:absolute}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{top:100%;bottom:auto}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s{left:50%;transform:translateX(-50%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw{left:75%;transform:translateX(-75%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme{left:25%;transform:translateX(-25%)}.ck.ck-toolbar .ck-dropdown__panel{z-index:calc(var(--ck-z-modal) + 1)}:root{--ck-dropdown-arrow-size:calc(var(--ck-icon-size)*0.5)}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{width:7em;overflow:hidden;text-overflow:ellipsis}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-dropdown__button_label-width_auto .ck-button__label{width:auto}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active{box-shadow:none}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active:focus,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active:focus{box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-dropdown__panel{border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dropdown__panel{box-shadow:var(--ck-drop-shadow),0 0;background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;min-width:100%}.ck.ck-dropdown__panel.ck-dropdown__panel_se{border-top-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_sw{border-top-right-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_ne{border-bottom-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_nw{border-bottom-right-radius:0}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/dropdown.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/dropdown.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAOA,MACC,4BACD,CAEA,gBACC,oBAAqB,CACrB,iBAqFD,CAnFC,oCACC,mBAAoB,CACpB,2BACD,CAGA,+CACC,UAOD,CCUA,iEACC,YACD,CDVA,oCAGC,kCAAmC,CAEnC,YAAa,CACb,yBAA0B,CAC1B,sCAAuC,CAEvC,iBAyDD,CAvDC,+DACC,oBACD,CAEA,mSAKC,WACD,CAEA,mSASC,QAAS,CACT,WACD,CAEA,oHAEC,MACD,CAEA,oHAEC,OACD,CAEA,kHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAQF,mCACC,mCACD,CEhGA,MACC,sDACD,CAEA,gBAEC,iBA2ED,CAzEC,oCACC,mCACD,CAGC,8CACC,gCAAiC,CAGjC,sCACD,CAIA,8CACC,+BAAgC,CAGhC,oCACD,CAGD,gDC/BA,kCDiCA,CAIE,mFAEC,oCACD,CAIA,mFAEC,qCACD,CAID,iEACC,SAAU,CACV,eAAgB,CAChB,sBACD,CAGA,6EC1DD,kCD4DC,CAGA,qDACC,2BAA4B,CAC5B,4BACD,CAEA,sGACC,UACD,CAGA,yHAEC,eAKD,CAHC,qIE7EF,2CF+EE,CAKH,uBGlFC,eH8GD,CA5BA,qFG9EE,qCH0GF,CA5BA,uBEpFC,oCAA8B,CFwF9B,oDAAqD,CACrD,sDAAuD,CACvD,QAAS,CAGT,cAmBD,CAfC,6CACC,wBACD,CAEA,6CACC,yBACD,CAEA,6CACC,2BACD,CAEA,6CACC,4BACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import \"../tooltip/mixins/_tooltip.css\";\n\n:root {\n\t--ck-dropdown-max-width: 75vw;\n}\n\n.ck.ck-dropdown {\n\tdisplay: inline-block;\n\tposition: relative;\n\n\t& .ck-dropdown__arrow {\n\t\tpointer-events: none;\n\t\tz-index: var(--ck-z-default);\n\t}\n\n\t/* Dropdown button should span horizontally, e.g. in vertical toolbars */\n\t& .ck-button.ck-dropdown__button {\n\t\twidth: 100%;\n\n\t\t/* Disable main button's tooltip when the dropdown is open. Otherwise the panel may\n\t\tpartially cover the tooltip */\n\t\t&.ck-on {\n\t\t\t@mixin ck-tooltip_disabled;\n\t\t}\n\t}\n\n\t& .ck-dropdown__panel {\n\t\t/* This is to get rid of flickering when the tooltip is shown under the panel,\n\t\twhich looks like the panel moves vertically a pixel down and up. */\n\t\t-webkit-backface-visibility: hidden;\n\n\t\tdisplay: none;\n\t\tz-index: var(--ck-z-modal);\n\t\tmax-width: var(--ck-dropdown-max-width);\n\n\t\tposition: absolute;\n\n\t\t&.ck-dropdown__panel-visible {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_n,\n\t\t&.ck-dropdown__panel_nmw,\n\t\t&.ck-dropdown__panel_nme {\n\t\t\tbottom: 100%;\n\t\t}\n\n\t\t&.ck-dropdown__panel_se,\n\t\t&.ck-dropdown__panel_sw,\n\t\t&.ck-dropdown__panel_smw,\n\t\t&.ck-dropdown__panel_sme,\n\t\t&.ck-dropdown__panel_s {\n\t\t\t/*\n\t\t\t * Using transform: translate3d( 0, 100%, 0 ) causes blurry dropdown on Chrome 67-78+ on non-retina displays.\n\t\t\t * See https://github.com/ckeditor/ckeditor5/issues/1053.\n\t\t\t */\n\t\t\ttop: 100%;\n\t\t\tbottom: auto;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_se {\n\t\t\tleft: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_sw {\n\t\t\tright: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_s,\n\t\t&.ck-dropdown__panel_n {\n\t\t\t/* Positioning panels relative to the center of the button */\n\t\t\tleft: 50%;\n\t\t\ttransform: translateX(-50%);\n\t\t}\n\n\t\t&.ck-dropdown__panel_nmw,\n\t\t&.ck-dropdown__panel_smw {\n\t\t\t/* Positioning panels relative to the middle-west of the button */\n\t\t\tleft: 75%;\n\t\t\ttransform: translateX(-75%);\n\t\t}\n\n\t\t&.ck-dropdown__panel_nme,\n\t\t&.ck-dropdown__panel_sme {\n\t\t\t/* Positioning panels relative to the middle-east of the button */\n\t\t\tleft: 25%;\n\t\t\ttransform: translateX(-25%);\n\t\t}\n\t}\n}\n\n/*\n * Toolbar dropdown panels should be always above the UI (eg. other dropdown panels) from the editor's content.\n * See https://github.com/ckeditor/ckeditor5/issues/7874\n */\n.ck.ck-toolbar .ck-dropdown__panel {\n\tz-index: calc( var(--ck-z-modal) + 1 );\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Enables the tooltip, which is the tooltip is in DOM but\n * not yet displayed.\n */\n@define-mixin ck-tooltip_enabled {\n\t& .ck-tooltip {\n\t\tdisplay: block;\n\n\t\t/*\n\t\t * Don't display tooltips in devices which don't support :hover.\n\t\t * In fact, it's all about iOS, which forces user to click UI elements twice to execute\n\t\t * the primary action, when tooltips are enabled.\n\t\t *\n\t\t * Q: OK, but why not the following query?\n\t\t *\n\t\t *   @media (hover) {\n\t\t *       display: block;\n\t\t *   }\n\t\t *\n\t\t * A: Because FF does not support it and it would completely disable tooltips\n\t\t * in that browser.\n\t\t *\n\t\t * More in https://github.com/ckeditor/ckeditor5/issues/920.\n\t\t */\n\t\t@media (hover:none) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/**\n * Disables the tooltip making it disappear from DOM.\n */\n@define-mixin ck-tooltip_disabled {\n\t& .ck-tooltip {\n\t\tdisplay: none;\n\t}\n}\n\n/**\n * Shows the tooltip, which is already in DOM.\n * Requires `ck-tooltip_enabled` first.\n */\n@define-mixin ck-tooltip_visible {\n\t& .ck-tooltip {\n\t\tvisibility: visible;\n\t\topacity: 1;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-dropdown-arrow-size: calc(0.5 * var(--ck-icon-size));\n}\n\n.ck.ck-dropdown {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-dropdown__arrow {\n\t\twidth: var(--ck-dropdown-arrow-size);\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-dropdown__arrow {\n\t\t\tright: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-dropdown__arrow {\n\t\t\tleft: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-dropdown__arrow {\n\t\t@mixin ck-disabled;\n\t}\n\n\t& .ck-button.ck-dropdown__button {\n\t\t@mixin ck-dir ltr {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-right: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t/* #23 */\n\t\t& .ck-button__label {\n\t\t\twidth: 7em;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t\t&.ck-disabled .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/816 */\n\t\t&.ck-on {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t&.ck-dropdown__button_label-width_auto .ck-button__label {\n\t\t\twidth: auto;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/8699 */\n\t\t&.ck-off:active,\n\t\t&.ck-on:active {\n\t\t\tbox-shadow: none;\n\t\t\t\n\t\t\t&:focus {\n\t\t\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-dropdown__panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tbackground: var(--ck-color-dropdown-panel-background);\n\tborder: 1px solid var(--ck-color-dropdown-panel-border);\n\tbottom: 0;\n\n\t/* Make sure the panel is at least as wide as the drop-down\'s button. */\n\tmin-width: 100%;\n\n\t/* Disabled corner border radius to be consistent with the .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-dropdown__panel_se {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_sw {\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_ne {\n\t\tborder-bottom-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_nw {\n\t\tborder-bottom-right-radius: 0;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      7995: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-dropdown .ck-dropdown__panel .ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list,.ck.ck-dropdown .ck-dropdown__panel .ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/listdropdown.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAOA,6CCIC,eDqBD,CAzBA,iICQE,qCAAsC,CDJtC,wBAqBF,CAfE,mFCND,eDYC,CANA,6MCFA,qCAAsC,CDIpC,wBAAyB,CACzB,2BAA4B,CAC5B,4BAEF,CAEA,kFCdD,eDmBC,CALA,2MCVA,qCAAsC,CDYpC,wBAAyB,CACzB,yBAEF",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n.ck.ck-dropdown .ck-dropdown__panel .ck-list {\n\t/* Disabled radius of top-left border to be consistent with .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t/* Make sure the button belonging to the first/last child of the list goes well with the\n\tborder radius of the entire panel. */\n\t& .ck-list__item {\n\t\t&:first-child .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\n\t\t&:last-child .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-top-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      9199: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, '.ck.ck-splitbutton{font-size:inherit}.ck.ck-splitbutton .ck-splitbutton__action:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button .ck-tooltip{display:none}:root{--ck-color-split-button-hover-background:#ebebeb;--ck-color-split-button-hover-border:#b3b3b3}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-top-right-radius:unset;border-bottom-right-radius:unset}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-top-left-radius:unset;border-bottom-left-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow{min-width:unset}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-top-left-radius:unset;border-bottom-left-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-top-right-radius:unset;border-bottom-right-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow svg{width:var(--ck-dropdown-arrow-size)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover),.ck.ck-splitbutton:hover>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover){background:var(--ck-color-split-button-hover-background)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{content:"";position:absolute;width:1px;height:100%;background-color:var(--ck-color-split-button-hover-border)}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{left:-1px}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{right:-1px}.ck.ck-splitbutton.ck-splitbutton_open{border-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__action{border-bottom-left-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__arrow{border-bottom-right-radius:0}', "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/splitbutton.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/splitbutton.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAOA,mBAEC,iBAUD,CARC,iDACC,qCACD,CC0BA,8DACC,YACD,CClCD,MACC,gDAAyD,CACzD,4CACD,CAMC,oIAIE,6BAA8B,CAC9B,gCAQF,CAbA,oIAUE,4BAA6B,CAC7B,+BAEF,CAEA,0CAGC,eAiBD,CApBA,oDAOE,4BAA6B,CAC7B,+BAYF,CApBA,oDAaE,6BAA8B,CAC9B,gCAMF,CAHC,8CACC,mCACD,CASA,0KACC,wDACD,CAIA,8JACC,UAAW,CACX,iBAAkB,CAClB,SAAU,CACV,WAAY,CACZ,0DACD,CAGC,kLACC,SACD,CAIA,kLACC,UACD,CAMF,uCC7EA,eDuFA,CAVA,qHCzEC,qCDmFD,CARE,qKACC,2BACD,CAEA,mKACC,4BACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../tooltip/mixins/_tooltip.css";\n\n.ck.ck-splitbutton {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-splitbutton__action:focus {\n\t\tz-index: calc(var(--ck-z-default) + 1);\n\t}\n\n\t/* Disable tooltips for the buttons when the button is "open" */\n\t&.ck-splitbutton_open > .ck-button {\n\t\t@mixin ck-tooltip_disabled;\n\t}\n}\n\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Enables the tooltip, which is the tooltip is in DOM but\n * not yet displayed.\n */\n@define-mixin ck-tooltip_enabled {\n\t& .ck-tooltip {\n\t\tdisplay: block;\n\n\t\t/*\n\t\t * Don't display tooltips in devices which don't support :hover.\n\t\t * In fact, it's all about iOS, which forces user to click UI elements twice to execute\n\t\t * the primary action, when tooltips are enabled.\n\t\t *\n\t\t * Q: OK, but why not the following query?\n\t\t *\n\t\t *   @media (hover) {\n\t\t *       display: block;\n\t\t *   }\n\t\t *\n\t\t * A: Because FF does not support it and it would completely disable tooltips\n\t\t * in that browser.\n\t\t *\n\t\t * More in https://github.com/ckeditor/ckeditor5/issues/920.\n\t\t */\n\t\t@media (hover:none) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/**\n * Disables the tooltip making it disappear from DOM.\n */\n@define-mixin ck-tooltip_disabled {\n\t& .ck-tooltip {\n\t\tdisplay: none;\n\t}\n}\n\n/**\n * Shows the tooltip, which is already in DOM.\n * Requires `ck-tooltip_enabled` first.\n */\n@define-mixin ck-tooltip_visible {\n\t& .ck-tooltip {\n\t\tvisibility: visible;\n\t\topacity: 1;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-color-split-button-hover-background: hsl(0, 0%, 92%);\n\t--ck-color-split-button-hover-border: hsl(0, 0%, 70%);\n}\n\n.ck.ck-splitbutton {\n\t/*\n\t * Note: ck-rounded and ck-dir mixins don\'t go together (because they both use @nest).\n\t */\n\t&:hover > .ck-splitbutton__action,\n\t&.ck-splitbutton_open > .ck-splitbutton__action {\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the action button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the action button on the left side */\n\t\t\tborder-top-left-radius: unset;\n\t\t\tborder-bottom-left-radius: unset;\n\t\t}\n\t}\n\n\t& > .ck-splitbutton__arrow {\n\t\t/* It\'s a text-less button and since the icon is positioned absolutely in such situation,\n\t\tit must get some arbitrary min-width. */\n\t\tmin-width: unset;\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the arrow button on the left side */\n\t\t\tborder-top-left-radius: unset;\n\t\t\tborder-bottom-left-radius: unset;\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the arrow button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t& svg {\n\t\t\twidth: var(--ck-dropdown-arrow-size);\n\t\t}\n\t}\n\n\t/* When the split button is "open" (the arrow is on) or being hovered, it should get some styling\n\tas a whole. The background of both buttons should stand out and there should be a visual\n\tseparation between both buttons. */\n\t&.ck-splitbutton_open,\n\t&:hover {\n\t\t/* When the split button hovered as a whole, not as individual buttons. */\n\t\t& > .ck-button:not(.ck-on):not(.ck-disabled):not(:hover) {\n\t\t\tbackground: var(--ck-color-split-button-hover-background);\n\t\t}\n\n\t\t/* Splitbutton separator needs to be set with the ::after pseudoselector\n\t\tto display properly the borders on focus */\n\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\tcontent: \'\';\n\t\t\tposition: absolute;\n\t\t\twidth: 1px;\n\t\t\theight: 100%;\n\t\t\tbackground-color: var(--ck-color-split-button-hover-border);\n\t\t}\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\t\tleft: -1px;\n\t\t\t}\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\t\tright: -1px;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Don\'t round the bottom left and right corners of the buttons when "open"\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-splitbutton_open {\n\t\t@mixin ck-rounded-corners {\n\t\t\t& > .ck-splitbutton__action {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t}\n\n\t\t\t& > .ck-splitbutton__arrow {\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      2951: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-toolbar-dropdown-max-width:60vw}.ck.ck-toolbar-dropdown>.ck-dropdown__panel{width:max-content;max-width:var(--ck-toolbar-dropdown-max-width)}.ck.ck-toolbar-dropdown>.ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/toolbardropdown.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/toolbardropdown.css"],
          names: [],
          mappings: "AAKA,MACC,oCACD,CAEA,4CAEC,iBAAkB,CAClB,8CAOD,CAJE,6DACC,qCACD,CCZF,oCACC,QACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-toolbar-dropdown-max-width: 60vw;\n}\n\n.ck.ck-toolbar-dropdown > .ck-dropdown__panel {\n\t/* https://github.com/ckeditor/ckeditor5/issues/5586 */\n\twidth: max-content;\n\tmax-width: var(--ck-toolbar-dropdown-max-width);\n\n\t& .ck-button {\n\t\t&:focus {\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-toolbar-dropdown .ck-toolbar {\n\tborder: 0;\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      4606: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-color-editable-blur-selection:#d9d9d9}.ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0}.ck.ck-editor__editable_inline{overflow:auto;padding:0 var(--ck-spacing-standard);border:1px solid transparent}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-editor__editable_inline.ck-blurred ::selection{background:var(--ck-color-editable-blur-selection)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-base-foreground)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-base-foreground)}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/editorui/editorui.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAWA,MACC,0CACD,CAEA,yDCJC,eDWD,CAPA,yJCAE,qCDOF,CAJC,oEERA,YAAa,CACb,2BAA2B,CCF3B,qCHYA,CAGD,+BACC,aAAc,CACd,oCAAqC,CACrC,4BA4BD,CA1BC,wCACC,eACD,CAEA,wCACC,gBACD,CAGA,4CACC,kCACD,CAGA,2CAKC,qCACD,CAGA,sDACC,kDACD,CAKA,gEACC,mDACD,CAIA,gEACC,gDACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_focus.css";\n@import "../../mixins/_button.css";\n\n:root {\n\t--ck-color-editable-blur-selection: hsl(0, 0%, 85%);\n}\n\n.ck.ck-editor__editable:not(.ck-editor__nested-editable) {\n\t@mixin ck-rounded-corners;\n\n\t&.ck-focused {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\t}\n}\n\n.ck.ck-editor__editable_inline {\n\toverflow: auto;\n\tpadding: 0 var(--ck-spacing-standard);\n\tborder: 1px solid transparent;\n\n\t&[dir="ltr"] {\n\t\ttext-align: left;\n\t}\n\n\t&[dir="rtl"] {\n\t\ttext-align: right;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/116 */\n\t& > *:first-child {\n\t\tmargin-top: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/847 */\n\t& > *:last-child {\n\t\t/*\n\t\t * This value should match with the default margins of the block elements (like .media or .image)\n\t\t * to avoid a content jumping when the fake selection container shows up (See https://github.com/ckeditor/ckeditor5/issues/9825).\n\t\t */\n\t\tmargin-bottom: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/6517 */\n\t&.ck-blurred ::selection {\n\t\tbackground: var(--ck-color-editable-blur-selection);\n\t}\n}\n\n/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/111 */\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_n"] {\n\t&::after {\n\t\tborder-bottom-color: var(--ck-color-base-foreground);\n\t}\n}\n\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_s"] {\n\t&::after {\n\t\tborder-top-color: var(--ck-color-base-foreground);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      9458: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-form__header{display:flex;flex-direction:row;flex-wrap:nowrap;align-items:center;justify-content:space-between}:root{--ck-form-header-height:38px}.ck.ck-form__header{padding:var(--ck-spacing-small) var(--ck-spacing-large);height:var(--ck-form-header-height);line-height:var(--ck-form-header-height);border-bottom:1px solid var(--ck-color-base-border)}.ck.ck-form__header .ck-form__header__label{font-weight:700}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/formheader/formheader.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/formheader/formheader.css"],
          names: [],
          mappings: "AAKA,oBACC,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CACjB,kBAAmB,CACnB,6BACD,CCNA,MACC,4BACD,CAEA,oBACC,uDAAwD,CACxD,mCAAoC,CACpC,wCAAyC,CACzC,mDAKD,CAHC,4CACC,eACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form__header {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-form-header-height: 38px;\n}\n\n.ck.ck-form__header {\n\tpadding: var(--ck-spacing-small) var(--ck-spacing-large);\n\theight: var(--ck-form-header-height);\n\tline-height: var(--ck-form-header-height);\n\tborder-bottom: 1px solid var(--ck-color-base-border);\n\n\t& .ck-form__header__label {\n\t\tfont-weight: bold;\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      9474: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{width:var(--ck-icon-size);height:var(--ck-icon-size);font-size:.8333350694em;will-change:transform}.ck.ck-icon,.ck.ck-icon *{color:inherit;cursor:inherit}.ck.ck-icon :not([fill]){fill:currentColor}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/icon/icon.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/icon/icon.css"],
          names: [],
          mappings: "AAKA,YACC,qBACD,CCFA,MACC,0EACD,CAEA,YACC,yBAA0B,CAC1B,0BAA2B,CAG3B,uBAAwB,CAQxB,qBAcD,CAZC,0BARA,aAAc,CAGd,cAgBA,CAJC,yBAEC,iBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-icon {\n\tvertical-align: middle;\n}\n", '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-icon-size: calc(var(--ck-line-height-base) * var(--ck-font-size-normal));\n}\n\n.ck.ck-icon {\n\twidth: var(--ck-icon-size);\n\theight: var(--ck-icon-size);\n\n\t/* Multiplied by the height of the line in "px" should give SVG "viewport" dimensions */\n\tfont-size: .8333350694em;\n\n\tcolor: inherit;\n\n\t/* Inherit cursor style (#5). */\n\tcursor: inherit;\n\n\t/* This will prevent blurry icons on Firefox. See #340. */\n\twill-change: transform;\n\n\t& * {\n\t\t/* Inherit cursor style (#5). */\n\t\tcursor: inherit;\n\n\t\t/* Allows dynamic coloring of the icons. */\n\t\tcolor: inherit;\n\n\t\t&:not([fill]) {\n\t\t\t/* Needed by FF. */\n\t\t\tfill: currentColor;\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]), e.Z = s;
      },
      5735: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-input-width:18em;--ck-input-text-width:var(--ck-input-width)}.ck.ck-input{border-radius:0}.ck-rounded-corners .ck.ck-input,.ck.ck-input.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input{background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);min-width:var(--ck-input-width);min-height:var(--ck-ui-component-min-height);transition:box-shadow .1s ease-in-out,border .1s ease-in-out}.ck.ck-input:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-input[readonly]{border:1px solid var(--ck-color-input-disabled-border);background:var(--ck-color-input-disabled-background);color:var(--ck-color-input-disabled-text)}.ck.ck-input[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-input.ck-error{border-color:var(--ck-color-input-error-border);animation:ck-input-shake .3s ease both}.ck.ck-input.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),0 0}@keyframes ck-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/input/input.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AASA,MACC,qBAAsB,CAGtB,2CACD,CAEA,aCLC,eD2CD,CAtCA,iECDE,qCDuCF,CAtCA,aAGC,2CAA4C,CAC5C,6CAA8C,CAC9C,6DAA8D,CAC9D,+BAAgC,CAGhC,4CAA6C,CAG7C,4DA0BD,CAxBC,mBEpBA,YAAa,CACb,2BAA2B,CCF3B,2CHwBA,CAEA,uBACC,sDAAuD,CACvD,oDAAqD,CACrD,yCAMD,CAJC,6BG/BD,oDHkCC,CAGD,sBACC,+CAAgD,CAChD,sCAKD,CAHC,4BGzCD,iDH2CC,CAIF,0BACC,IACC,0BACD,CAEA,IACC,yBACD,CAEA,IACC,0BACD,CAEA,IACC,yBACD,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-input-width: 18em;\n\n\t/* Backward compatibility. */\n\t--ck-input-text-width: var(--ck-input-width);\n}\n\n.ck.ck-input {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-input-background);\n\tborder: 1px solid var(--ck-color-input-border);\n\tpadding: var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);\n\tmin-width: var(--ck-input-width);\n\n\t/* This is important to stay of the same height as surrounding buttons */\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .1s ease-in-out, border .1s ease-in-out;\n\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t&[readonly] {\n\t\tborder: 1px solid var(--ck-color-input-disabled-border);\n\t\tbackground: var(--ck-color-input-disabled-background);\n\t\tcolor: var(--ck-color-input-disabled-text);\n\n\t\t&:focus {\n\t\t\t/* The read-only input should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\tborder-color: var(--ck-color-input-error-border);\n\t\tanimation: ck-input-shake .3s ease both;\n\n\t\t&:focus {\n\t\t\t@mixin ck-box-shadow var(--ck-focus-error-outer-shadow);\n\t\t}\n\t}\n}\n\n@keyframes ck-input-shake {\n\t20% {\n\t\ttransform: translateX(-2px);\n\t}\n\n\t40% {\n\t\ttransform: translateX(2px);\n\t}\n\n\t60% {\n\t\ttransform: translateX(-1px);\n\t}\n\n\t80% {\n\t\ttransform: translateX(1px);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      6526: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/label/label.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/label/label.css"],
          names: [],
          mappings: "AAKA,aACC,aACD,CAEA,mBACC,YACD,CCNA,aACC,eACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tdisplay: block;\n}\n\n.ck.ck-voice-label {\n\tdisplay: none;\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tfont-weight: bold;\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      6518: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{display:flex;position:relative}.ck.ck-labeled-field-view .ck.ck-label{display:block;position:absolute}:root{--ck-labeled-field-view-transition:.1s cubic-bezier(0,0,0.24,0.95);--ck-labeled-field-empty-unfocused-max-width:100% - 2 * var(--ck-spacing-medium);--ck-color-labeled-field-label-background:var(--ck-color-base-background)}.ck.ck-labeled-field-view{border-radius:0}.ck-rounded-corners .ck.ck-labeled-field-view,.ck.ck-labeled-field-view.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{width:100%}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{top:0}[dir=ltr] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{left:0}[dir=rtl] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{right:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{pointer-events:none;transform-origin:0 0;transform:translate(var(--ck-spacing-medium),-6px) scale(.75);background:var(--ck-color-labeled-field-label-background);padding:0 calc(var(--ck-font-size-tiny)*0.5);line-height:normal;font-weight:400;text-overflow:ellipsis;overflow:hidden;max-width:100%;transition:transform var(--ck-labeled-field-view-transition),padding var(--ck-labeled-field-view-transition),background var(--ck-labeled-field-view-transition)}.ck.ck-labeled-field-view.ck-error .ck-input:not([readonly])+.ck.ck-label,.ck.ck-labeled-field-view.ck-error>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view .ck-labeled-field-view__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-field-view .ck-labeled-field-view__status.ck-labeled-field-view__status_error{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-input-disabled-text)}[dir=ltr] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=ltr] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(var(--ck-spacing-medium),calc(var(--ck-font-size-base)*0.6)) scale(1)}[dir=rtl] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=rtl] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(calc(var(--ck-spacing-medium)*-1),calc(var(--ck-font-size-base)*0.6)) scale(1)}.ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width));background:transparent;padding:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck.ck-button{background:transparent}.ck.ck-labeled-field-view.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck-button>.ck-button__label{opacity:0}.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown+.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard))}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/labeledfield/labeledfieldview.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/labeledfield/labeledfieldview.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAMC,mEACC,YAAa,CACb,iBACD,CAEA,uCACC,aAAc,CACd,iBACD,CCND,MACC,kEAAsE,CACtE,gFAAiF,CACjF,yEACD,CAEA,0BCHC,eD4GD,CAzGA,2FCCE,qCDwGF,CAtGC,mEACC,UAmCD,CAjCC,gFACC,KA+BD,CAhCA,0FAIE,MA4BF,CAhCA,0FAQE,OAwBF,CAhCA,gFAWC,mBAAoB,CACpB,oBAAqB,CAGrB,6DAA+D,CAE/D,yDAA0D,CAC1D,4CAA8C,CAC9C,kBAAoB,CACpB,eAAmB,CAGnB,sBAAuB,CACvB,eAAgB,CAEhB,cAAe,CAEf,+JAID,CAQA,mKACC,gCACD,CAGD,yDACC,mCAAoC,CACpC,kCAAmC,CAInC,kBAKD,CAHC,6FACC,gCACD,CAID,4OAEC,yCACD,CAIA,oUAGE,yFAYF,CAfA,oUAOE,kGAQF,CAfA,gTAWC,iEAAkE,CAElE,sBAAuB,CACvB,SACD,CAKA,8FACC,sBACD,CAGA,yIACC,SACD,CAGA,kMACC,8HACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-labeled-field-view {\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t}\n\n\t& .ck.ck-label {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-labeled-field-view-transition: .1s cubic-bezier(0, 0, 0.24, 0.95);\n\t--ck-labeled-field-empty-unfocused-max-width: 100% - 2 * var(--ck-spacing-medium);\n\t--ck-color-labeled-field-label-background: var(--ck-color-base-background);\n}\n\n.ck.ck-labeled-field-view {\n\t@mixin ck-rounded-corners;\n\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\twidth: 100%;\n\n\t\t& > .ck.ck-label {\n\t\t\ttop: 0px;\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tleft: 0px;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tright: 0px;\n\t\t\t}\n\n\t\t\tpointer-events: none;\n\t\t\ttransform-origin: 0 0;\n\n\t\t\t/* By default, display the label scaled down above the field. */\n\t\t\ttransform: translate(var(--ck-spacing-medium), -6px) scale(.75);\n\n\t\t\tbackground: var(--ck-color-labeled-field-label-background);\n\t\t\tpadding: 0 calc(.5 * var(--ck-font-size-tiny));\n\t\t\tline-height: initial;\n\t\t\tfont-weight: normal;\n\n\t\t\t/* Prevent overflow when the label is longer than the input */\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\n\t\t\tmax-width: 100%;\n\n\t\t\ttransition:\n\t\t\t\ttransform var(--ck-labeled-field-view-transition),\n\t\t\t\tpadding var(--ck-labeled-field-view-transition),\n\t\t\t\tbackground var(--ck-labeled-field-view-transition);\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\t& > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\n\t\t& .ck-input:not([readonly]) + .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t& .ck-labeled-field-view__status {\n\t\tfont-size: var(--ck-font-size-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\n\t\t/* Let the info wrap to the next line to avoid stretching the layout horizontally.\n\t\tThe status could be very long. */\n\t\twhite-space: normal;\n\n\t\t&.ck-labeled-field-view__status_error {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t/* Disabled fields and fields that have no focus should fade out. */\n\t&.ck-disabled > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\tcolor: var(--ck-color-input-disabled-text);\n\t}\n\n\t/* Fields that are disabled or not focused and without a placeholder should have full-sized labels. */\n\t/* stylelint-disable-next-line no-descending-specificity */\n\t&.ck-disabled.ck-labeled-field-view_empty > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t@mixin ck-dir ltr {\n\t\t\ttransform: translate(var(--ck-spacing-medium), calc(0.6 * var(--ck-font-size-base))) scale(1);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttransform: translate(calc(-1 * var(--ck-spacing-medium)), calc(0.6 * var(--ck-font-size-base))) scale(1);\n\t\t}\n\n\t\t/* Compensate for the default translate position. */\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width));\n\n\t\tbackground: transparent;\n\t\tpadding: 0;\n\t}\n\n\t/*------ DropdownView integration ----------------------------------------------------------------------------------- */\n\n\t/* Make sure dropdown\' background color in any of dropdown\'s state does not collide with labeled field. */\n\t& > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck.ck-button {\n\t\tbackground: transparent;\n\t}\n\n\t/* When the dropdown is "empty", the labeled field label replaces its label. */\n\t&.ck-labeled-field-view_empty > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck-button > .ck-button__label {\n\t\topacity: 0;\n\t}\n\n\t/* Make sure the label of the empty, unfocused input does not cover the dropdown arrow. */\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown + .ck-label {\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard));\n\t}\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      5319: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-list{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-direction:column}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{list-style-type:none;background:var(--ck-color-list-background)}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item .ck-button{min-height:unset;width:100%;text-align:left;border-radius:0;padding:calc(var(--ck-line-height-base)*0.2*var(--ck-font-size-base)) calc(var(--ck-line-height-base)*0.4*var(--ck-font-size-base))}.ck.ck-list__item .ck-button .ck-button__label{line-height:calc(var(--ck-line-height-base)*1.2*var(--ck-font-size-base))}.ck.ck-list__item .ck-button:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item .ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item .ck-button.ck-on:focus:not(.ck-disabled){border-color:var(--ck-color-base-background)}.ck.ck-list__item .ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item .ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item .ck-switchbutton.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck.ck-list__separator{height:1px;width:100%;background:var(--ck-color-base-border)}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/list/list.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/list/list.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAOA,YCEC,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBAAgB,CDFhB,YAAa,CACb,qBAcD,CAZC,2DAEC,aACD,CAKA,kCACC,iBAAkB,CAClB,2BACD,CEfD,YCEC,eDGD,CALA,+DCME,qCDDF,CALA,YAGC,oBAAqB,CACrB,0CACD,CAEA,kBACC,cAAe,CACf,cA2DD,CAzDC,6BACC,gBAAiB,CACjB,UAAW,CACX,eAAgB,CAChB,eAAgB,CAKhB,mIAiCD,CA7BC,+CAEC,yEACD,CAEA,oCACC,eACD,CAEA,mCACC,oDAAqD,CACrD,yCAaD,CAXC,0CACC,eACD,CAEA,2DACC,0DACD,CAEA,2DACC,4CACD,CAGD,qDACC,uDACD,CAMA,yCACC,0CAA2C,CAC3C,aAMD,CAJC,iEACC,uDAAwD,CACxD,aACD,CAKH,uBACC,UAAW,CACX,UAAW,CACX,sCACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-list {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t& .ck-list__item,\n\t& .ck-list__separator {\n\t\tdisplay: block;\n\t}\n\n\t/* Make sure that whatever child of the list item gets focus, it remains on the\n\ttop. Thanks to that, styles like box-shadow, outline, etc. are not masked by\n\tadjacent list items. */\n\t& .ck-list__item > *:focus {\n\t\tposition: relative;\n\t\tz-index: var(--ck-z-default);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n.ck.ck-list {\n\t@mixin ck-rounded-corners;\n\n\tlist-style-type: none;\n\tbackground: var(--ck-color-list-background);\n}\n\n.ck.ck-list__item {\n\tcursor: default;\n\tmin-width: 12em;\n\n\t& .ck-button {\n\t\tmin-height: unset;\n\t\twidth: 100%;\n\t\ttext-align: left;\n\t\tborder-radius: 0;\n\n\t\t/* List items should have the same height. Use absolute units to make sure it is so\n\t\t   because e.g. different heading styles may have different height\n\t\t   https://github.com/ckeditor/ckeditor5-heading/issues/63 */\n\t\tpadding:\n\t\t\tcalc(.2 * var(--ck-line-height-base) * var(--ck-font-size-base))\n\t\t\tcalc(.4 * var(--ck-line-height-base) * var(--ck-font-size-base));\n\n\t\t& .ck-button__label {\n\t\t\t/* https://github.com/ckeditor/ckeditor5-heading/issues/63 */\n\t\t\tline-height: calc(1.2 * var(--ck-line-height-base) * var(--ck-font-size-base));\n\t\t}\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-button-on-background);\n\t\t\tcolor: var(--ck-color-list-button-on-text);\n\n\t\t\t&:active {\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-on-background-focus);\n\t\t\t}\n\n\t\t\t&:focus:not(.ck-disabled) {\n\t\t\t\tborder-color: var(--ck-color-base-background);\n\t\t\t}\n\t\t}\n\n\t\t&:hover:not(.ck-disabled) {\n\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t}\n\t}\n\n\t/* It\'s unnecessary to change the background/text of a switch toggle; it has different ways\n\tof conveying its state (like the switcher) */\n\t& .ck-switchbutton {\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-background);\n\t\t\tcolor: inherit;\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t\t\tcolor: inherit;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-list__separator {\n\theight: 1px;\n\twidth: 100%;\n\tbackground: var(--ck-color-base-border);\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      4451: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-modal)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px;--ck-balloon-arrow-drop-shadow:0 2px 2px var(--ck-color-shadow-drop)}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{width:0;height:0;border-style:solid}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:var(--ck-balloon-arrow-height);border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:0}.ck.ck-balloon-panel[class*=arrow_n]:before{border-bottom-color:var(--ck-color-panel-border)}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-color:transparent;border-right-color:transparent;border-top-color:transparent}.ck.ck-balloon-panel[class*=arrow_n]:after{border-bottom-color:var(--ck-color-panel-background);margin-top:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:0;border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-top-color:var(--ck-color-panel-border);filter:drop-shadow(var(--ck-balloon-arrow-drop-shadow))}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent}.ck.ck-balloon-panel[class*=arrow_s]:after{border-top-color:var(--ck-color-panel-background);margin-bottom:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{right:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:before{right:25%;margin-right:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:before{right:25%;margin-right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}', "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/balloonpanel.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonpanel.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAKA,MAEC,8DACD,CAEA,qBACC,YAAa,CACb,iBAAkB,CAElB,yBAyCD,CAtCE,+GAEC,UAAW,CACX,iBACD,CAEA,wDACC,6CACD,CAEA,uDACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAGD,8CACC,aACD,CC9CD,MACC,6BAA8B,CAC9B,8BAA+B,CAC/B,iCAAkC,CAClC,oEACD,CAEA,qBCJC,eD4ID,CAxIA,iFCAE,qCDwIF,CAxIA,qBENC,oCAA8B,CFU9B,eAAgB,CAEhB,2CAA4C,CAC5C,6CAiID,CA9HE,+GAEC,OAAQ,CACR,QAAS,CACT,kBACD,CAIA,uFAEC,oDAAoH,CAApH,kDAAoH,CAApH,qDAAoH,CAApH,kBACD,CAEA,4CACC,gDACD,CAEA,uFAHC,6BAA8E,CAA9E,8BAA8E,CAA9E,4BAMD,CAHA,2CACC,oDAAkF,CAClF,yCACD,CAIA,uFAEC,oDAAoH,CAApH,qBAAoH,CAApH,qDAAoH,CAApH,+CACD,CAEA,4CACC,6CAAkE,CAClE,uDACD,CAEA,uFAJC,6BAAkE,CAAlE,+BAAkE,CAAlE,8BAOD,CAHA,2CACC,iDAAkF,CAClF,4CACD,CAIA,yGAEC,QAAS,CACT,uDAA0D,CAC1D,2CACD,CAIA,2GAEC,+CAAkD,CAClD,2CACD,CAIA,2GAEC,gDAAmD,CACnD,2CACD,CAIA,yGAEC,QAAS,CACT,uDAA0D,CAC1D,8CACD,CAIA,2GAEC,+CAAkD,CAClD,8CACD,CAIA,2GAEC,gDAAmD,CACnD,8CACD,CAIA,6GAEC,SAAU,CACV,uDAA0D,CAC1D,8CACD,CAIA,6GAEC,QAAS,CACT,sDAAyD,CACzD,8CACD,CAIA,6GAEC,SAAU,CACV,uDAA0D,CAC1D,2CACD,CAIA,6GAEC,QAAS,CACT,sDAAyD,CACzD,2CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* Make sure the balloon arrow does not float over its children. */\n\t--ck-balloon-panel-arrow-z-index: calc(var(--ck-z-default) - 3);\n}\n\n.ck.ck-balloon-panel {\n\tdisplay: none;\n\tposition: absolute;\n\n\tz-index: var(--ck-z-modal);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tposition: absolute;\n\t\t}\n\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_visible {\n\t\tdisplay: block;\n\t}\n}\n', '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-arrow-offset: 2px;\n\t--ck-balloon-arrow-height: 10px;\n\t--ck-balloon-arrow-half-width: 8px;\n\t--ck-balloon-arrow-drop-shadow: 0 2px 2px var(--ck-color-shadow-drop);\n}\n\n.ck.ck-balloon-panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: 1px solid var(--ck-color-panel-border);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t\tborder-style: solid;\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-border) transparent;\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-background) transparent;\n\t\t\tmargin-top: var(--ck-balloon-arrow-offset);\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: var(--ck-color-panel-border) transparent transparent;\n\t\t\tfilter: drop-shadow(var(--ck-balloon-arrow-drop-shadow));\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: var(--ck-color-panel-background) transparent transparent transparent;\n\t\t\tmargin-bottom: var(--ck-balloon-arrow-offset);\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_n {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_ne {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_s {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_se {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_smw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nmw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      9167: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck .ck-balloon-rotator__navigation{display:flex;align-items:center;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-small)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/balloonrotator.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonrotator.css"],
          names: [],
          mappings: "AAKA,oCACC,YAAa,CACb,kBAAmB,CACnB,sBACD,CAKA,6CACC,sBACD,CCXA,oCACC,6CAA8C,CAC9C,sDAAuD,CACvD,iCAgBD,CAbC,sCACC,oCAAqC,CACrC,kCAAmC,CACnC,qCACD,CAGA,iEACC,uCAAwC,CAGxC,mCACD,CAMA,2DACC,eACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n/* Buttons inside a toolbar should be centered when rotator bar is wider.\n * See: https://github.com/ckeditor/ckeditor5-ui/issues/495\n */\n.ck .ck-balloon-rotator__content .ck-toolbar {\n\tjustify-content: center;\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tbackground: var(--ck-color-toolbar-background);\n\tborder-bottom: 1px solid var(--ck-color-toolbar-border);\n\tpadding: 0 var(--ck-spacing-small);\n\n\t/* Let's keep similar appearance to `ck-toolbar`. */\n\t& > * {\n\t\tmargin-right: var(--ck-spacing-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t/* Gives counter more breath than buttons. */\n\t& .ck-balloon-rotator__counter {\n\t\tmargin-right: var(--ck-spacing-standard);\n\n\t\t/* We need to use smaller margin because of previous button's right margin. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n.ck .ck-balloon-rotator__content {\n\n\t/* Disable default annotation shadow inside rotator with fake panels. */\n\t& .ck.ck-annotation-wrapper {\n\t\tbox-shadow: none;\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      9135: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-modal) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);width:100%;height:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/fakepanel.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/fakepanel.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAKA,mBACC,iBAAkB,CAGlB,mCACD,CAEA,uBACC,iBACD,CAEA,mCACC,SACD,CAEA,oCACC,SACD,CCfA,MACC,6CAA8C,CAC9C,2CACD,CAGA,uBCJC,oCAA8B,CDO9B,eAAgB,CAEhB,2CAA4C,CAC5C,6CAA8C,CAC9C,qCAAsC,CAEtC,UAAW,CACX,WACD,CAEA,mCACC,0DAA2D,CAC3D,uDACD,CAEA,oCACC,kEAAqE,CACrE,+DACD,CACA,oCACC,kEAAqE,CACrE,+DACD,CAGA,yIAGC,4CACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-fake-panel {\n\tposition: absolute;\n\n\t/* Fake panels should be placed under main balloon content. */\n\tz-index: calc(var(--ck-z-modal) - 1);\n}\n\n.ck .ck-fake-panel div {\n\tposition: absolute;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tz-index: 2;\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tz-index: 1;\n}\n", '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-fake-panel-offset-horizontal: 6px;\n\t--ck-balloon-fake-panel-offset-vertical: 6px;\n}\n\n/* Let\'s use `.ck-balloon-panel` appearance. See: balloonpanel.css. */\n.ck .ck-fake-panel div {\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: 1px solid var(--ck-color-panel-border);\n\tborder-radius: var(--ck-border-radius);\n\n\twidth: 100%;\n\theight: 100%;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tmargin-left: var(--ck-balloon-fake-panel-offset-horizontal);\n\tmargin-top: var(--ck-balloon-fake-panel-offset-vertical);\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 2);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 2);\n}\n.ck .ck-fake-panel div:nth-child( 3 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 3);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 3);\n}\n\n/* If balloon is positioned above element, we need to move fake panel to the top. */\n.ck .ck-balloon-panel_arrow_s + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_se + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_sw + .ck-fake-panel {\n\t--ck-balloon-fake-panel-offset-vertical: -6px;\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      4285: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-sticky-panel .ck-sticky-panel__content_sticky{z-index:var(--ck-z-modal);position:fixed;top:0}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{top:auto;position:absolute}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{box-shadow:var(--ck-drop-shadow),0 0;border-width:0 1px 1px;border-top-left-radius:0;border-top-right-radius:0}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/stickypanel.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/stickypanel.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAMC,qDACC,yBAA0B,CAC1B,cAAe,CACf,KACD,CAEA,kEACC,QAAS,CACT,iBACD,CCPA,qDCCA,oCAA8B,CDE7B,sBAAuB,CACvB,wBAAyB,CACzB,yBACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\tz-index: var(--ck-z-modal); /* #315 */\n\t\tposition: fixed;\n\t\ttop: 0;\n\t}\n\n\t& .ck-sticky-panel__content_sticky_bottom-limit {\n\t\ttop: auto;\n\t\tposition: absolute;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\t@mixin ck-drop-shadow;\n\n\t\tborder-width: 0 1px 1px;\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      8312: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, '.ck-vertical-form .ck-button:after{content:"";width:0;position:absolute;right:-1px;top:var(--ck-spacing-small);bottom:var(--ck-spacing-small);z-index:1}@media screen and (max-width:600px){.ck.ck-responsive-form .ck-button:after{content:"";width:0;position:absolute;right:-1px;top:var(--ck-spacing-small);bottom:var(--ck-spacing-small);z-index:1}}.ck-vertical-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form{padding:var(--ck-spacing-large)}.ck.ck-responsive-form:focus{outline:none}[dir=ltr] .ck.ck-responsive-form>:not(:first-child),[dir=rtl] .ck.ck-responsive-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-responsive-form{padding:0;width:calc(var(--ck-input-width)*0.8)}.ck.ck-responsive-form .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) 0}.ck.ck-responsive-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-responsive-form .ck-labeled-field-view .ck-labeled-field-view__error{white-space:normal}.ck.ck-responsive-form>.ck-button:last-child,.ck.ck-responsive-form>.ck-button:nth-last-child(2){padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-large);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-responsive-form>.ck-button:last-child,[dir=ltr] .ck.ck-responsive-form>.ck-button:nth-last-child(2),[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2){margin-left:0}.ck.ck-responsive-form>.ck-button:nth-last-child(2):after,[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child:last-of-type,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2):last-of-type{border-right:1px solid var(--ck-color-base-border)}}', "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/responsive-form/responsiveform.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/responsive-form/responsiveform.css"],
          names: [],
          mappings: "AAOA,mCACC,UAAW,CACX,OAAQ,CACR,iBAAkB,CAClB,UAAW,CACX,2BAA4B,CAC5B,8BAA+B,CAC/B,SACD,CCTC,oCDaC,wCACC,UAAW,CACX,OAAQ,CACR,iBAAkB,CAClB,UAAW,CACX,2BAA4B,CAC5B,8BAA+B,CAC/B,SACD,CCnBD,CCAD,qDACC,kDACD,CAEA,uBACC,+BAkED,CAhEC,6BAEC,YACD,CASC,uGACC,sCACD,CDvBD,oCCMD,uBAqBE,SAAU,CACV,qCA6CF,CA3CE,8CACC,wDAWD,CATC,6DACC,WAAY,CACZ,UACD,CAGA,4EACC,kBACD,CAID,iGAEC,kCAAmC,CACnC,kCAAmC,CAEnC,eAAgB,CAChB,QAAS,CACT,gDAaD,CApBA,0OAcE,aAMF,CAGC,yMACC,kDACD,CDpEF",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck-vertical-form .ck-button::after {\n\tcontent: "";\n\twidth: 0;\n\tposition: absolute;\n\tright: -1px;\n\ttop: var(--ck-spacing-small);\n\tbottom: var(--ck-spacing-small);\n\tz-index: 1;\n}\n\n.ck.ck-responsive-form {\n\t@mixin ck-media-phone {\n\t\t& .ck-button::after {\n\t\t\tcontent: "";\n\t\t\twidth: 0;\n\t\t\tposition: absolute;\n\t\t\tright: -1px;\n\t\t\ttop: var(--ck-spacing-small);\n\t\t\tbottom: var(--ck-spacing-small);\n\t\t\tz-index: 1;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck-vertical-form > .ck-button:nth-last-child(2)::after {\n\tborder-right: 1px solid var(--ck-color-base-border);\n}\n\n.ck.ck-responsive-form {\n\tpadding: var(--ck-spacing-large);\n\n\t&:focus {\n\t\t/* See: https://github.com/ckeditor/ckeditor5/issues/4773 */\n\t\toutline: none;\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& > :not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& > :not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tpadding: 0;\n\t\twidth: calc(.8 * var(--ck-input-width));\n\n\t\t& .ck-labeled-field-view {\n\t\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) 0;\n\n\t\t\t& .ck-input-text {\n\t\t\t\tmin-width: 0;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\n\t\t\t/* Let the long error messages wrap in the narrow form. */\n\t\t\t& .ck-labeled-field-view__error {\n\t\t\t\twhite-space: normal;\n\t\t\t}\n\t\t}\n\n\t\t/* Styles for two last buttons in the form (save&cancel, edit&unlink, etc.). */\n\t\t& > .ck-button:nth-last-child(1),\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\tpadding: var(--ck-spacing-standard);\n\t\t\tmargin-top: var(--ck-spacing-large);\n\n\t\t\tborder-radius: 0;\n\t\t\tborder: 0;\n\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\n\t\t\t\t&:last-of-type {\n\t\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\t&::after {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\t}\n}\n'],
          sourceRoot: ""
        }]), e.Z = s;
      },
      2503: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-block-toolbar-button{position:absolute;z-index:var(--ck-z-default)}:root{--ck-color-block-toolbar-button:var(--ck-color-text);--ck-block-toolbar-button-size:var(--ck-font-size-normal)}.ck.ck-block-toolbar-button{color:var(--ck-color-block-toolbar-button);font-size:var(--ck-block-toolbar-size)}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/toolbar/blocktoolbar.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/blocktoolbar.css"],
          names: [],
          mappings: "AAKA,4BACC,iBAAkB,CAClB,2BACD,CCHA,MACC,oDAAqD,CACrD,yDACD,CAEA,4BACC,0CAA2C,CAC3C,sCACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-block-toolbar-button {\n\tposition: absolute;\n\tz-index: var(--ck-z-default);\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-block-toolbar-button: var(--ck-color-text);\n\t--ck-block-toolbar-button-size: var(--ck-font-size-normal);\n}\n\n.ck.ck-block-toolbar-button {\n\tcolor: var(--ck-color-block-toolbar-button);\n\tfont-size: var(--ck-block-toolbar-size);\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      1329: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck.ck-toolbar{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-flow:row nowrap;align-items:center}.ck.ck-toolbar>.ck-toolbar__items{display:flex;flex-flow:row wrap;align-items:center;flex-grow:1}.ck.ck-toolbar .ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar .ck.ck-toolbar__separator:first-child,.ck.ck-toolbar .ck.ck-toolbar__separator:last-child{display:none}.ck.ck-toolbar .ck-toolbar__line-break{flex-basis:100%}.ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck-dropdown__button .ck-dropdown__arrow{display:none}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);padding:0 var(--ck-spacing-small);border:1px solid var(--ck-color-toolbar-border)}.ck.ck-toolbar .ck.ck-toolbar__separator{align-self:stretch;width:1px;min-width:1px;background:var(--ck-color-toolbar-border);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck.ck-toolbar .ck-toolbar__line-break{height:0}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break){margin-right:var(--ck-spacing-small)}.ck.ck-toolbar>.ck-toolbar__items:empty+.ck.ck-toolbar__separator{display:none}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break),.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items>.ck{width:100%;margin:0;border-radius:0;border:0}.ck.ck-toolbar.ck-toolbar_compact{padding:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>*{margin:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>:not(:first-child):not(:last-child){border-radius:0}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck.ck-button.ck-dropdown__button{padding-left:var(--ck-spacing-tiny)}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck{margin-right:0}.ck.ck-toolbar[dir=rtl]:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-left:0}.ck.ck-toolbar[dir=rtl].ck-toolbar_compact>.ck-toolbar__items>.ck:first-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.ck.ck-toolbar[dir=rtl].ck-toolbar_compact>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-top-right-radius:0;border-bottom-right-radius:0}.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__separator,[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl].ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=rtl] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child){margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-right:0}.ck.ck-toolbar[dir=ltr].ck-toolbar_compact>.ck-toolbar__items>.ck:first-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.ck.ck-toolbar[dir=ltr].ck-toolbar_compact>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.ck.ck-toolbar[dir=ltr]>.ck.ck-toolbar__separator,[dir=ltr] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-right:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr].ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=ltr] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child){margin-right:var(--ck-spacing-small)}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/toolbar/toolbar.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/toolbar.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAOA,eCEC,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBAAgB,CDFhB,YAAa,CACb,oBAAqB,CACrB,kBA6CD,CA3CC,kCACC,YAAa,CACb,kBAAmB,CACnB,kBAAmB,CACnB,WAED,CAEA,yCACC,oBAWD,CAJC,yGAEC,YACD,CAGD,uCACC,eACD,CAEA,sDACC,gBACD,CAEA,sDACC,qBACD,CAEA,sDACC,gBACD,CAGC,yFACC,YACD,CE/CF,eCGC,eD0FD,CA7FA,qECOE,qCDsFF,CA7FA,eAGC,6CAA8C,CAC9C,iCAAkC,CAClC,+CAwFD,CAtFC,yCACC,kBAAmB,CACnB,SAAU,CACV,aAAc,CACd,yCAA0C,CAM1C,kCAAmC,CACnC,qCACD,CAEA,uCACC,QACD,CAGC,gEAEC,oCACD,CAIA,kEACC,YACD,CAGD,gHAGC,kCAAmC,CACnC,qCACD,CAEA,mCAEC,SAgBD,CAbC,0DAEC,UAAW,CAGX,QAAS,CAGT,eAAgB,CAGhB,QACD,CAGD,kCAEC,SAWD,CATC,uDAEC,QAMD,CAHC,yFACC,eACD,CASD,kFACC,mCACD,CAvFF,qCA2FE,QAEF,CAYC,+FACC,cACD,CAEA,iJAEC,mCACD,CAEA,qHACC,aACD,CAIC,6JACC,wBAAyB,CACzB,2BACD,CAGA,2JACC,yBAA0B,CAC1B,4BACD,CAID,qGACC,mCACD,CAGA,yLACC,mCACD,CAWA,qHACC,cACD,CAIC,6JACC,yBAA0B,CAC1B,4BACD,CAGA,2JACC,wBAAyB,CACzB,2BACD,CAID,qGACC,oCACD,CAGA,yLACC,oCACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\talign-items: center;\n\n\t& > .ck-toolbar__items {\n\t\tdisplay: flex;\n\t\tflex-flow: row wrap;\n\t\talign-items: center;\n\t\tflex-grow: 1;\n\n\t}\n\n\t& .ck.ck-toolbar__separator {\n\t\tdisplay: inline-block;\n\n\t\t/*\n\t\t * A leading or trailing separator makes no sense (separates from nothing on one side).\n\t\t * For instance, it can happen when toolbar items (also separators) are getting grouped one by one and\n\t\t * moved to another toolbar in the dropdown.\n\t\t */\n\t\t&:first-child,\n\t\t&:last-child {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\tflex-basis: 100%;\n\t}\n\n\t&.ck-toolbar_grouping > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t&.ck-toolbar_vertical > .ck-toolbar__items {\n\t\tflex-direction: column;\n\t}\n\n\t&.ck-toolbar_floating > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t& > .ck-dropdown__button .ck-dropdown__arrow {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-toolbar-background);\n\tpadding: 0 var(--ck-spacing-small);\n\tborder: 1px solid var(--ck-color-toolbar-border);\n\n\t& .ck.ck-toolbar__separator {\n\t\talign-self: stretch;\n\t\twidth: 1px;\n\t\tmin-width: 1px;\n\t\tbackground: var(--ck-color-toolbar-border);\n\n\t\t/*\n\t\t * These margins make the separators look better in balloon toolbars (when aligned with the "tip").\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/7493.\n\t\t */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\theight: 0;\n\t}\n\n\t& > .ck-toolbar__items {\n\t\t& > *:not(.ck-toolbar__line-break) {\n\t\t\t/* (#11) Separate toolbar items. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\n\t\t/* Don\'t display a separator after an empty items container, for instance,\n\t\twhen all items were grouped */\n\t\t&:empty + .ck.ck-toolbar__separator {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& > .ck-toolbar__items > *:not(.ck-toolbar__line-break),\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/* Make sure items wrapped to the next line have v-spacing */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t&.ck-toolbar_vertical {\n\t\t/* Items in a vertical toolbar span the entire width. */\n\t\tpadding: 0;\n\n\t\t/* Specificity matters here. See https://github.com/ckeditor/ckeditor5-theme-lark/issues/168. */\n\t\t& > .ck-toolbar__items > .ck {\n\t\t\t/* Items in a vertical toolbar should span the horizontal space. */\n\t\t\twidth: 100%;\n\n\t\t\t/* Items in a vertical toolbar should have no margin. */\n\t\t\tmargin: 0;\n\n\t\t\t/* Items in a vertical toolbar span the entire width so rounded corners are pointless. */\n\t\t\tborder-radius: 0;\n\n\t\t\t/* Items in a vertical toolbar span the entire width so any border is pointless. */\n\t\t\tborder: 0;\n\t\t}\n\t}\n\n\t&.ck-toolbar_compact {\n\t\t/* No spacing around items. */\n\t\tpadding: 0;\n\n\t\t& > .ck-toolbar__items > * {\n\t\t\t/* Compact toolbar items have no spacing between them. */\n\t\t\tmargin: 0;\n\n\t\t\t/* "Middle" children should have no rounded corners. */\n\t\t\t&:not(:first-child):not(:last-child) {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/*\n\t\t * Dropdown button has asymmetric padding to fit the arrow.\n\t\t * This button has no arrow so let\'s revert that padding back to normal.\n\t\t */\n\t\t& > .ck.ck-button.ck-dropdown__button {\n\t\t\tpadding-left: var(--ck-spacing-tiny);\n\t\t}\n\t}\n\n\t@nest .ck-toolbar-container & {\n\t\tborder: 0;\n\t}\n}\n\n/* stylelint-disable */\n\n/*\n * Styles for RTL toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="rtl"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="rtl"] {\n\t& > .ck-toolbar__items > .ck {\n\t\tmargin-right: 0;\n\t}\n\n\t&:not(.ck-toolbar_compact) > .ck-toolbar__items > .ck {\n\t\t/* (#11) Separate toolbar items. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-left: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n/*\n * Styles for LTR toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="ltr"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="ltr"] {\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-right: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n}\n\n/* stylelint-enable */\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      8552: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, '.ck.ck-tooltip,.ck.ck-tooltip .ck-tooltip__text:after{position:absolute;pointer-events:none;-webkit-backface-visibility:hidden}.ck.ck-tooltip{visibility:hidden;opacity:0;display:none;z-index:var(--ck-z-modal)}.ck.ck-tooltip .ck-tooltip__text{display:inline-block}.ck.ck-tooltip .ck-tooltip__text:after{content:"";width:0;height:0}:root{--ck-tooltip-arrow-size:5px}.ck.ck-tooltip{left:50%;top:0;transition:opacity .2s ease-in-out .2s}.ck.ck-tooltip .ck-tooltip__text{border-radius:0}.ck-rounded-corners .ck.ck-tooltip .ck-tooltip__text,.ck.ck-tooltip .ck-tooltip__text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-tooltip .ck-tooltip__text{font-size:.9em;line-height:1.5;color:var(--ck-color-tooltip-text);padding:var(--ck-spacing-small) var(--ck-spacing-medium);background:var(--ck-color-tooltip-background);position:relative;left:-50%}.ck.ck-tooltip .ck-tooltip__text:after{transition:opacity .2s ease-in-out .2s;border-style:solid;left:50%}.ck.ck-tooltip.ck-tooltip_s,.ck.ck-tooltip.ck-tooltip_se,.ck.ck-tooltip.ck-tooltip_sw{bottom:calc(var(--ck-tooltip-arrow-size)*-1);transform:translateY(100%)}.ck.ck-tooltip.ck-tooltip_s .ck-tooltip__text:after,.ck.ck-tooltip.ck-tooltip_se .ck-tooltip__text:after,.ck.ck-tooltip.ck-tooltip_sw .ck-tooltip__text:after{top:calc(var(--ck-tooltip-arrow-size)*-1 + 1px);transform:translateX(-50%);border-left-color:transparent;border-bottom-color:var(--ck-color-tooltip-background);border-right-color:transparent;border-top-color:transparent;border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:var(--ck-tooltip-arrow-size);border-top-width:0}.ck.ck-tooltip.ck-tooltip_sw{right:50%;left:auto}.ck.ck-tooltip.ck-tooltip_sw .ck-tooltip__text{left:auto;right:calc(var(--ck-tooltip-arrow-size)*-2)}.ck.ck-tooltip.ck-tooltip_sw .ck-tooltip__text:after{left:auto;right:0}.ck.ck-tooltip.ck-tooltip_se{left:50%;right:auto}.ck.ck-tooltip.ck-tooltip_se .ck-tooltip__text{right:auto;left:calc(var(--ck-tooltip-arrow-size)*-2)}.ck.ck-tooltip.ck-tooltip_se .ck-tooltip__text:after{right:auto;left:0;transform:translateX(50%)}.ck.ck-tooltip.ck-tooltip_n{top:calc(var(--ck-tooltip-arrow-size)*-1);transform:translateY(-100%)}.ck.ck-tooltip.ck-tooltip_n .ck-tooltip__text:after{bottom:calc(var(--ck-tooltip-arrow-size)*-1);transform:translateX(-50%);border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;border-top-color:var(--ck-color-tooltip-background);border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:0;border-right-width:var(--ck-tooltip-arrow-size);border-top-width:var(--ck-tooltip-arrow-size)}.ck.ck-tooltip.ck-tooltip_e{left:calc(100% + var(--ck-tooltip-arrow-size));top:50%}.ck.ck-tooltip.ck-tooltip_e .ck-tooltip__text{left:0;transform:translateY(-50%)}.ck.ck-tooltip.ck-tooltip_e .ck-tooltip__text:after{left:calc(var(--ck-tooltip-arrow-size)*-1);top:calc(50% - var(--ck-tooltip-arrow-size)*1);border-left-color:transparent;border-bottom-color:transparent;border-right-color:var(--ck-color-tooltip-background);border-top-color:transparent;border-left-width:0;border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:var(--ck-tooltip-arrow-size);border-top-width:var(--ck-tooltip-arrow-size)}.ck.ck-tooltip.ck-tooltip_w{right:calc(100% + var(--ck-tooltip-arrow-size));left:auto;top:50%}.ck.ck-tooltip.ck-tooltip_w .ck-tooltip__text{left:0;transform:translateY(-50%)}.ck.ck-tooltip.ck-tooltip_w .ck-tooltip__text:after{left:100%;top:calc(50% - var(--ck-tooltip-arrow-size)*1);border-left-color:var(--ck-color-tooltip-background);border-bottom-color:transparent;border-right-color:transparent;border-top-color:transparent;border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:0;border-top-width:var(--ck-tooltip-arrow-size)}', "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/tooltip.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/tooltip/tooltip.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
          names: [],
          mappings: "AAKA,sDAEC,iBAAkB,CAGlB,mBAAoB,CAIpB,kCACD,CAEA,eAEC,iBAAkB,CAClB,SAAU,CACV,YAAa,CACb,yBAWD,CATC,iCACC,oBAOD,CALC,uCACC,UAAW,CACX,OAAQ,CACR,QACD,CCxBF,MACC,2BACD,CAEA,eACC,QAAS,CAMT,KAAM,CAON,sCAwKD,CAtKC,iCChBA,eDqCA,CArBA,yGCZC,qCDiCD,CArBA,iCAGC,cAAe,CACf,eAAgB,CAChB,kCAAmC,CACnC,wDAAyD,CACzD,6CAA8C,CAC9C,iBAAkB,CAClB,SAYD,CAVC,uCAMC,sCAAuC,CACvC,kBAAmB,CACnB,QACD,CAYD,sFAGC,4CAA+C,CAC/C,0BASD,CAPC,8JAEC,+CAAkD,CAClD,0BAA6B,CAC7B,6BAAoF,CAApF,sDAAoF,CAApF,8BAAoF,CAApF,4BAAoF,CACpF,8CAAsG,CAAtG,gDAAsG,CAAtG,+CAAsG,CAAtG,kBACD,CAaD,6BACC,SAAU,CACV,SAWD,CATC,+CACC,SAAU,CACV,2CACD,CAEA,qDACC,SAAU,CACV,OACD,CAYD,6BACC,QAAS,CACT,UAYD,CAVC,+CACC,UAAW,CACX,0CACD,CAEA,qDACC,UAAW,CACX,MAAO,CACP,yBACD,CAYD,4BACC,yCAA4C,CAC5C,2BAQD,CANC,oDACC,4CAA+C,CAC/C,0BAA6B,CAC7B,6BAAoF,CAApF,+BAAoF,CAApF,8BAAoF,CAApF,mDAAoF,CACpF,8CAAsG,CAAtG,qBAAsG,CAAtG,+CAAsG,CAAtG,6CACD,CAUD,4BACC,8CAA+C,CAC/C,OAaD,CAXC,8CACC,MAAO,CACP,0BAQD,CANC,oDACC,0CAA6C,CAC7C,8CAAiD,CACjD,6BAAoF,CAApF,+BAAoF,CAApF,qDAAoF,CAApF,4BAAoF,CACpF,mBAAsG,CAAtG,gDAAsG,CAAtG,+CAAsG,CAAtG,6CACD,CAWF,4BACC,+CAAgD,CAChD,SAAU,CACV,OAaD,CAXC,8CACC,MAAO,CACP,0BAQD,CANC,oDACC,SAAU,CACV,8CAAiD,CACjD,oDAAoF,CAApF,+BAAoF,CAApF,8BAAoF,CAApF,4BAAoF,CACpF,8CAAsG,CAAtG,gDAAsG,CAAtG,oBAAsG,CAAtG,6CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-tooltip,\n.ck.ck-tooltip .ck-tooltip__text::after {\n\tposition: absolute;\n\n\t/* Without this, hovering the tooltip could keep it visible. */\n\tpointer-events: none;\n\n\t/* This is to get rid of flickering when transitioning opacity in Chrome.\n\tIt\'s weird but it works. */\n\t-webkit-backface-visibility: hidden;\n}\n\n.ck.ck-tooltip {\n\t/* Tooltip is hidden by default. */\n\tvisibility: hidden;\n\topacity: 0;\n\tdisplay: none;\n\tz-index: var(--ck-z-modal);\n\n\t& .ck-tooltip__text {\n\t\tdisplay: inline-block;\n\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t}\n\t}\n}\n', '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-tooltip-arrow-size: 5px;\n}\n\n.ck.ck-tooltip {\n\tleft: 50%;\n\n\t/*\n\t * Prevent blurry tooltips in LoDPI environments.\n\t * See https://github.com/ckeditor/ckeditor5/issues/1802.\n\t */\n\ttop: 0;\n\n\t/*\n\t * For the transition to work, the tooltip must be controlled\n\t * using visibility+opacity. A delay prevents a "tooltip avalanche"\n\t * i.e. when scanning the toolbar with mouse cursor.\n\t */\n\ttransition: opacity .2s ease-in-out .2s;\n\n\t& .ck-tooltip__text {\n\t\t@mixin ck-rounded-corners;\n\n\t\tfont-size: .9em;\n\t\tline-height: 1.5;\n\t\tcolor: var(--ck-color-tooltip-text);\n\t\tpadding: var(--ck-spacing-small) var(--ck-spacing-medium);\n\t\tbackground: var(--ck-color-tooltip-background);\n\t\tposition: relative;\n\t\tleft: -50%;\n\n\t\t&::after {\n\t\t\t/*\n\t\t\t * For the transition to work, the tooltip must be controlled\n\t\t\t * using visibility+opacity. A delay prevents a "tooltip avalanche"\n\t\t\t * i.e. when scanning the toolbar with mouse cursor.\n\t\t\t */\n\t\t\ttransition: opacity .2s ease-in-out .2s;\n\t\t\tborder-style: solid;\n\t\t\tleft: 50%;\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip south of the element.\n\t *\n\t *       [element]\n\t *           ^\n\t *     +-----------+\n\t *     |  Tooltip  |\n\t *     +-----------+\n\t */\n\t&.ck-tooltip_s,\n\t&.ck-tooltip_sw,\n\t&.ck-tooltip_se {\n\t\tbottom: calc(-1 * var(--ck-tooltip-arrow-size));\n\t\ttransform: translateY( 100% );\n\n\t\t& .ck-tooltip__text::after {\n\t\t\t/* 1px addresses gliches in rendering causing gap between the triangle and the text */\n\t\t\ttop: calc(-1 * var(--ck-tooltip-arrow-size) + 1px);\n\t\t\ttransform: translateX( -50% );\n\t\t\tborder-color: transparent transparent var(--ck-color-tooltip-background) transparent;\n\t\t\tborder-width: 0 var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size);\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip south-west of the element.\n\t *\n\t *        [element]\n\t *            ^\n\t *  +-----------+\n\t *  |  Tooltip  |\n\t *  +-----------+\n\t */\n\n\t&.ck-tooltip_sw {\n\t\tright: 50%;\n\t\tleft: auto;\n\n\t\t& .ck-tooltip__text {\n\t\t\tleft: auto;\n\t\t\tright: calc( -2 * var(--ck-tooltip-arrow-size));\n\t\t}\n\n\t\t& .ck-tooltip__text::after {\n\t\t\tleft: auto;\n\t\t\tright: 0;\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip south-east of the element.\n\t *\n\t *  [element]\n\t *      ^\n\t *    +-----------+\n\t *    |  Tooltip  |\n\t *    +-----------+\n\t */\n\t&.ck-tooltip_se {\n\t\tleft: 50%;\n\t\tright: auto;\n\n\t\t& .ck-tooltip__text {\n\t\t\tright: auto;\n\t\t\tleft: calc( -2 * var(--ck-tooltip-arrow-size));\n\t\t}\n\n\t\t& .ck-tooltip__text::after {\n\t\t\tright: auto;\n\t\t\tleft: 0;\n\t\t\ttransform: translateX( 50% );\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip north of the element.\n\t *\n\t *     +-----------+\n\t *     |  Tooltip  |\n\t *     +-----------+\n\t *           V\n\t *       [element]\n\t */\n\t&.ck-tooltip_n {\n\t\ttop: calc(-1 * var(--ck-tooltip-arrow-size));\n\t\ttransform: translateY( -100% );\n\n\t\t& .ck-tooltip__text::after {\n\t\t\tbottom: calc(-1 * var(--ck-tooltip-arrow-size));\n\t\t\ttransform: translateX( -50% );\n\t\t\tborder-color: var(--ck-color-tooltip-background) transparent transparent transparent;\n\t\t\tborder-width: var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size) 0 var(--ck-tooltip-arrow-size);\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip east of the element.\n\t *\n\t *                +----------+\n\t *    [element] < |   east   |\n\t *                +----------+\n\t */\n\t&.ck-tooltip_e {\n\t\tleft: calc(100% + var(--ck-tooltip-arrow-size));\n\t\ttop: 50%;\n\n\t\t& .ck-tooltip__text {\n\t\t\tleft: 0;\n\t\t\ttransform: translateY( -50% );\n\n\t\t\t&::after {\n\t\t\t\tleft: calc(-1 * var(--ck-tooltip-arrow-size));\n\t\t\t\ttop: calc(50% - 1 * var(--ck-tooltip-arrow-size));\n\t\t\t\tborder-color: transparent var(--ck-color-tooltip-background) transparent transparent;\n\t\t\t\tborder-width: var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size) 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip west of the element.\n\t *\n\t *    +----------+\n\t *    |   west   | > [element]\n\t *    +----------+\n\t */\n\t&.ck-tooltip_w {\n\t\tright: calc(100% + var(--ck-tooltip-arrow-size));\n\t\tleft: auto;\n\t\ttop: 50%;\n\n\t\t& .ck-tooltip__text {\n\t\t\tleft: 0;\n\t\t\ttransform: translateY( -50% );\n\n\t\t\t&::after {\n\t\t\t\tleft: 100%;\n\t\t\t\ttop: calc(50% - 1 * var(--ck-tooltip-arrow-size));\n\t\t\t\tborder-color: transparent transparent transparent var(--ck-color-tooltip-background);\n\t\t\t\tborder-width: var(--ck-tooltip-arrow-size) 0 var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size);\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      4258: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck-hidden{display:none!important}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{box-sizing:border-box;width:auto;height:auto;position:static}:root{--ck-z-default:1;--ck-z-modal:calc(var(--ck-z-default) + 999)}.ck-transitions-disabled,.ck-transitions-disabled *{transition:none!important}:root{--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#c4c4c4;--ck-color-base-action:#61b045;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#198cf0;--ck-color-base-active-focus:#0e7fe1;--ck-color-base-error:#db3700;--ck-color-focus-border-coordinates:208,79%,51%;--ck-color-focus-border:hsl(var(--ck-color-focus-border-coordinates));--ck-color-focus-outer-shadow:#bcdefb;--ck-color-focus-disabled-shadow:rgba(119,186,248,0.3);--ck-color-focus-error-shadow:rgba(255,64,31,0.3);--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:rgba(0,0,0,0.15);--ck-color-shadow-drop-active:rgba(0,0,0,0.2);--ck-color-shadow-inner:rgba(0,0,0,0.1);--ck-color-button-default-background:transparent;--ck-color-button-default-hover-background:#e6e6e6;--ck-color-button-default-active-background:#d9d9d9;--ck-color-button-default-active-shadow:#bfbfbf;--ck-color-button-default-disabled-background:transparent;--ck-color-button-on-background:#dedede;--ck-color-button-on-hover-background:#c4c4c4;--ck-color-button-on-active-background:#bababa;--ck-color-button-on-active-shadow:#a1a1a1;--ck-color-button-on-disabled-background:#dedede;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#579e3d;--ck-color-button-action-active-background:#53973b;--ck-color-button-action-active-shadow:#498433;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#b0b0b0;--ck-color-switch-button-off-hover-background:#a3a3a3;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#579e3d;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:rgba(0,0,0,0.1);--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:#c7c7c7;--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:#c7c7c7;--ck-color-input-disabled-text:#757575;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-base-active);--ck-color-list-button-on-background-focus:var(--ck-color-base-active-focus);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-foreground);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:rgba(31,177,255,0.1);--ck-color-link-fake-selection:rgba(31,177,255,0.3);--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{margin:0;padding:0;border:0;background:transparent;text-decoration:none;vertical-align:middle;transition:none;word-wrap:break-word}.ck.ck-reset_all,.ck.ck-reset_all *{border-collapse:collapse;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);color:var(--ck-color-text);text-align:left;white-space:nowrap;cursor:auto;float:none}.ck.ck-reset_all .ck-rtl *{text-align:right}.ck.ck-reset_all iframe{vertical-align:inherit}.ck.ck-reset_all textarea{white-space:pre-wrap}.ck.ck-reset_all input[type=password],.ck.ck-reset_all input[type=text],.ck.ck-reset_all textarea{cursor:text}.ck.ck-reset_all input[type=password][disabled],.ck.ck-reset_all input[type=text][disabled],.ck.ck-reset_all textarea[disabled]{cursor:default}.ck.ck-reset_all fieldset{padding:10px;border:2px groove #dfdee3}.ck.ck-reset_all button::-moz-focus-inner{padding:0;border:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/globals/_hidden.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/globals/_reset.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/globals/_zindex.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-ui/theme/globals/_transition.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_colors.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_disabled.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_focus.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_fonts.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_reset.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_rounded.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_shadow.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_spacing.css"],
          names: [],
          mappings: "AAQA,WAGC,sBACD,CCPA,iDAGC,qBAAsB,CACtB,UAAW,CACX,WAAY,CACZ,eACD,CCPA,MACC,gBAAiB,CACjB,4CACD,CCAA,oDAEC,yBACD,CCNA,MACC,kCAAmD,CACnD,+BAAoD,CACpD,8BAAgD,CAChD,8BAAmD,CACnD,6BAAmD,CACnD,yBAA+C,CAC/C,8BAAmD,CACnD,oCAAuD,CACvD,6BAAkD,CAIlD,+CAAwD,CACxD,qEAA+E,CAC/E,qCAAwD,CACxD,sDAA8D,CAC9D,iDAAyD,CACzD,yCAAqD,CACrD,uCAAsD,CACtD,6CAA0D,CAC1D,uCAAsD,CAItD,gDAAuD,CACvD,kDAA+D,CAC/D,mDAAgE,CAChE,+CAA6D,CAC7D,yDAA8D,CAE9D,uCAAuD,CACvD,6CAA4D,CAC5D,8CAA4D,CAC5D,0CAAyD,CACzD,gDAA8D,CAE9D,+DAAsE,CACtE,iDAAkE,CAClE,kDAAkE,CAClE,8CAA+D,CAC/D,oDAAoE,CACpE,6DAAsE,CAEtE,8BAAoD,CACpD,gCAAqD,CAErD,+CAA4D,CAC5D,qDAAiE,CACjE,+EAAqF,CACrF,oDAAmE,CACnE,yEAA8E,CAC9E,qDAAgE,CAIhE,oEAA2E,CAC3E,4DAAoE,CAIpE,2DAAoE,CACpE,+BAAiD,CACjD,wDAAgE,CAChE,+CAA0D,CAC1D,4CAA2D,CAC3D,wCAAwD,CACxD,sCAAsD,CAItD,0DAAmE,CACnE,uFAA6F,CAC7F,gEAAuE,CACvE,4EAAiF,CACjF,8DAAsE,CAItE,2DAAoE,CACpE,mDAA6D,CAI7D,6DAAsE,CACtE,qDAA+D,CAI/D,uDAAgE,CAChE,uDAAiE,CAIjE,0CAAyD,CAIzD,wCAA2D,CAI3D,+BAAoD,CACpD,wDAAmE,CACnE,mDAAgE,CCpGhE,wBAAyB,CCAzB,0CAA2C,CAK3C,gGAAiG,CAKjG,4GAA6G,CAK7G,sGAAuG,CAKvG,sDAAuD,CCvBvD,wBAAyB,CACzB,6BAA8B,CAC9B,wDAA6D,CAE7D,yBAA0B,CAC1B,2BAA4B,CAC5B,yBAA0B,CAC1B,wBAAyB,CACzB,0BAA2B,CCJ3B,kCJoGD,CI9FA,iDAIC,QAAS,CACT,SAAU,CACV,QAAS,CACT,sBAAuB,CACvB,oBAAqB,CACrB,qBAAsB,CACtB,eAAgB,CAGhB,oBACD,CAKA,oCAGC,wBAAyB,CACzB,iGAAkG,CAClG,0BAA2B,CAC3B,eAAgB,CAChB,kBAAmB,CACnB,WAAY,CACZ,UACD,CAGC,2BACC,gBACD,CAEA,wBAEC,sBACD,CAEA,0BACC,oBACD,CAEA,kGAGC,WACD,CAEA,gIAGC,cACD,CAEA,0BACC,YAAa,CACb,yBACD,CAEA,0CAEC,SAAU,CACV,QACD,CAMD,8BAEC,gBACD,CCnFA,MACC,sBAAuB,CCAvB,gEAAiE,CAKjE,0DAA2D,CAK3D,wEAAyE,CCbzE,uBAA8B,CAC9B,mDAA2D,CAC3D,4CAAkD,CAClD,oDAA4D,CAC5D,mDAA2D,CAC3D,kDAA2D,CAC3D,yDFFD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which hides an element in DOM.\n */\n.ck-hidden {\n\t/* Override selector specificity. Otherwise, all elements with some display\n\tstyle defined will override this one, which is not a desired result. */\n\tdisplay: none !important;\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck.ck-reset_all * {\n\tbox-sizing: border-box;\n\twidth: auto;\n\theight: auto;\n\tposition: static;\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-z-default: 1;\n\t--ck-z-modal: calc( var(--ck-z-default) + 999 );\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class that disables all transitions of the element and its children.\n */\n.ck-transitions-disabled,\n.ck-transitions-disabled * {\n\ttransition: none !important;\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-base-foreground: \t\t\t\t\t\t\t\thsl(0, 0%, 98%);\n\t--ck-color-base-background: \t\t\t\t\t\t\t\thsl(0, 0%, 100%);\n\t--ck-color-base-border: \t\t\t\t\t\t\t\t\thsl(0, 0%, 77%);\n\t--ck-color-base-action: \t\t\t\t\t\t\t\t\thsl(104, 44%, 48%);\n\t--ck-color-base-focus: \t\t\t\t\t\t\t\t\t\thsl(209, 92%, 70%);\n\t--ck-color-base-text: \t\t\t\t\t\t\t\t\t\thsl(0, 0%, 20%);\n\t--ck-color-base-active: \t\t\t\t\t\t\t\t\thsl(208, 88%, 52%);\n\t--ck-color-base-active-focus:\t\t\t\t\t\t\t\thsl(208, 88%, 47%);\n\t--ck-color-base-error:\t\t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t/* -- Generic colors ------------------------------------------------------------------------ */\n\n\t--ck-color-focus-border-coordinates: \t\t\t\t\t\t208, 79%, 51%;\n\t--ck-color-focus-border: \t\t\t\t\t\t\t\t\thsl(var(--ck-color-focus-border-coordinates));\n\t--ck-color-focus-outer-shadow:\t\t\t\t\t\t\t\thsl(207, 89%, 86%);\n\t--ck-color-focus-disabled-shadow:\t\t\t\t\t\t\thsla(209, 90%, 72%,.3);\n\t--ck-color-focus-error-shadow:\t\t\t\t\t\t\t\thsla(9,100%,56%,.3);\n\t--ck-color-text: \t\t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-shadow-drop: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.15);\n\t--ck-color-shadow-drop-active:\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.2);\n\t--ck-color-shadow-inner: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Buttons ------------------------------------------------------------------------------- */\n\n\t--ck-color-button-default-background: \t\t\t\t\t\ttransparent;\n\t--ck-color-button-default-hover-background: \t\t\t\thsl(0, 0%, 90%);\n\t--ck-color-button-default-active-background: \t\t\t\thsl(0, 0%, 85%);\n\t--ck-color-button-default-active-shadow: \t\t\t\t\thsl(0, 0%, 75%);\n\t--ck-color-button-default-disabled-background: \t\t\t\ttransparent;\n\n\t--ck-color-button-on-background: \t\t\t\t\t\t\thsl(0, 0%, 87%);\n\t--ck-color-button-on-hover-background: \t\t\t\t\t\thsl(0, 0%, 77%);\n\t--ck-color-button-on-active-background: \t\t\t\t\thsl(0, 0%, 73%);\n\t--ck-color-button-on-active-shadow: \t\t\t\t\t\thsl(0, 0%, 63%);\n\t--ck-color-button-on-disabled-background: \t\t\t\t\thsl(0, 0%, 87%);\n\n\t--ck-color-button-action-background: \t\t\t\t\t\tvar(--ck-color-base-action);\n\t--ck-color-button-action-hover-background: \t\t\t\t\thsl(104, 44%, 43%);\n\t--ck-color-button-action-active-background: \t\t\t\thsl(104, 44%, 41%);\n\t--ck-color-button-action-active-shadow: \t\t\t\t\thsl(104, 44%, 36%);\n\t--ck-color-button-action-disabled-background: \t\t\t\thsl(104, 44%, 58%);\n\t--ck-color-button-action-text: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t--ck-color-button-save: \t\t\t\t\t\t\t\t\thsl(120, 100%, 27%);\n\t--ck-color-button-cancel: \t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t--ck-color-switch-button-off-background:\t\t\t\t\thsl(0, 0%, 69%);\n\t--ck-color-switch-button-off-hover-background:\t\t\t\thsl(0, 0%, 64%);\n\t--ck-color-switch-button-on-background:\t\t\t\t\t\tvar(--ck-color-button-action-background);\n\t--ck-color-switch-button-on-hover-background:\t\t\t\thsl(104, 44%, 43%);\n\t--ck-color-switch-button-inner-background:\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-switch-button-inner-shadow:\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Dropdown ------------------------------------------------------------------------------ */\n\n\t--ck-color-dropdown-panel-background: \t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-dropdown-panel-border: \t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Input --------------------------------------------------------------------------------- */\n\n\t--ck-color-input-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-input-border: \t\t\t\t\t\t\t\t\thsl(0, 0%, 78%);\n\t--ck-color-input-error-border:\t\t\t\t\t\t\t\tvar(--ck-color-base-error);\n\t--ck-color-input-text: \t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-input-disabled-background: \t\t\t\t\t\thsl(0, 0%, 95%);\n\t--ck-color-input-disabled-border: \t\t\t\t\t\t\thsl(0, 0%, 78%);\n\t--ck-color-input-disabled-text: \t\t\t\t\t\t\thsl(0, 0%, 46%);\n\n\t/* -- List ---------------------------------------------------------------------------------- */\n\n\t--ck-color-list-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-list-button-hover-background: \t\t\t\t\tvar(--ck-color-button-default-hover-background);\n\t--ck-color-list-button-on-background: \t\t\t\t\t\tvar(--ck-color-base-active);\n\t--ck-color-list-button-on-background-focus: \t\t\t\tvar(--ck-color-base-active-focus);\n\t--ck-color-list-button-on-text:\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Panel --------------------------------------------------------------------------------- */\n\n\t--ck-color-panel-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-panel-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Toolbar ------------------------------------------------------------------------------- */\n\n\t--ck-color-toolbar-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-foreground);\n\t--ck-color-toolbar-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Tooltip ------------------------------------------------------------------------------- */\n\n\t--ck-color-tooltip-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-tooltip-text: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Engine -------------------------------------------------------------------------------- */\n\n\t--ck-color-engine-placeholder-text: \t\t\t\t\t\thsl(0, 0%, 44%);\n\n\t/* -- Upload -------------------------------------------------------------------------------- */\n\n\t--ck-color-upload-bar-background:\t\t \t\t\t\t\thsl(209, 92%, 70%);\n\n\t/* -- Link -------------------------------------------------------------------------------- */\n\n\t--ck-color-link-default:\t\t\t\t\t\t\t\t\thsl(240, 100%, 47%);\n\t--ck-color-link-selected-background:\t\t\t\t\t\thsla(201, 100%, 56%, 0.1);\n\t--ck-color-link-fake-selection:\t\t\t\t\t\t\t\thsla(201, 100%, 56%, 0.3);\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * An opacity value of disabled UI item.\n\t */\n\t--ck-disabled-opacity: .5;\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * The geometry of the of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow-geometry: 0 0 0 3px;\n\n\t/**\n\t * A visual style of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when disabled).\n\t */\n\t--ck-focus-disabled-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when has errors).\n\t */\n\t--ck-focus-error-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);\n\n\t/**\n\t * A visual style of focused element's border or outline.\n\t */\n\t--ck-focus-ring: 1px solid var(--ck-color-focus-border);\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-font-size-base: 13px;\n\t--ck-line-height-base: 1.84615;\n\t--ck-font-face: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;\n\n\t--ck-font-size-tiny: 0.7em;\n\t--ck-font-size-small: 0.75em;\n\t--ck-font-size-normal: 1em;\n\t--ck-font-size-big: 1.4em;\n\t--ck-font-size-large: 1.8em;\n}\n", '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* This is super-important. This is **manually** adjusted so a button without an icon\n\tis never smaller than a button with icon, additionally making sure that text-less buttons\n\tare perfect squares. The value is also shared by other components which should stay "in-line"\n\twith buttons. */\n\t--ck-ui-component-min-height: 2.3em;\n}\n\n/**\n * Resets an element, ignoring its children.\n */\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck.ck-reset_all * {\n\t/* Do not include inheritable rules here. */\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\tbackground: transparent;\n\ttext-decoration: none;\n\tvertical-align: middle;\n\ttransition: none;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/105 */\n\tword-wrap: break-word;\n}\n\n/**\n * Resets an element AND its children.\n */\n.ck.ck-reset_all,\n.ck.ck-reset_all * {\n\t/* These are rule inherited by all children elements. */\n\tborder-collapse: collapse;\n\tfont: normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);\n\tcolor: var(--ck-color-text);\n\ttext-align: left;\n\twhite-space: nowrap;\n\tcursor: auto;\n\tfloat: none;\n}\n\n.ck.ck-reset_all {\n\t& .ck-rtl * {\n\t\ttext-align: right;\n\t}\n\n\t& iframe {\n\t\t/* For IE */\n\t\tvertical-align: inherit;\n\t}\n\n\t& textarea {\n\t\twhite-space: pre-wrap;\n\t}\n\n\t& textarea,\n\t& input[type="text"],\n\t& input[type="password"] {\n\t\tcursor: text;\n\t}\n\n\t& textarea[disabled],\n\t& input[type="text"][disabled],\n\t& input[type="password"][disabled] {\n\t\tcursor: default;\n\t}\n\n\t& fieldset {\n\t\tpadding: 10px;\n\t\tborder: 2px groove hsl(255, 7%, 88%);\n\t}\n\n\t& button::-moz-focus-inner {\n\t\t/* See http://stackoverflow.com/questions/5517744/remove-extra-button-spacing-padding-in-firefox */\n\t\tpadding: 0;\n\t\tborder: 0\n\t}\n}\n\n/**\n * Default UI rules for RTL languages.\n */\n.ck[dir="rtl"],\n.ck[dir="rtl"] .ck {\n\ttext-align: right;\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Default border-radius value.\n */\n:root{\n\t--ck-border-radius: 2px;\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * A visual style of element's inner shadow (i.e. input).\n\t */\n\t--ck-inner-shadow: 2px 2px 3px var(--ck-color-shadow-inner) inset;\n\n\t/**\n\t * A visual style of element's drop shadow (i.e. panel).\n\t */\n\t--ck-drop-shadow: 0 1px 2px 1px var(--ck-color-shadow-drop);\n\n\t/**\n\t * A visual style of element's active shadow (i.e. comment or suggestion).\n\t */\n\t--ck-drop-shadow-active: 0 3px 6px 1px var(--ck-color-shadow-drop-active);\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-spacing-unit: \t\t\t\t\t\t0.6em;\n\t--ck-spacing-large: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 1.5);\n\t--ck-spacing-standard: \t\t\t\t\tvar(--ck-spacing-unit);\n\t--ck-spacing-medium: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.8);\n\t--ck-spacing-small: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.5);\n\t--ck-spacing-tiny: \t\t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.3);\n\t--ck-spacing-extra-tiny: \t\t\t\tcalc(var(--ck-spacing-unit) * 0.16);\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      7482: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ":root{--ck-color-resizer:var(--ck-color-focus-border);--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2;--ck-resizer-border-radius:var(--ck-border-radius);--ck-resizer-tooltip-offset:10px;--ck-resizer-tooltip-height:calc(var(--ck-spacing-small)*2 + 10px)}.ck .ck-widget,.ck .ck-widget.ck-widget_with-selection-handle{position:relative}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{position:absolute}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);color:var(--ck-color-resizer-tooltip-text);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);font-size:var(--ck-font-size-tiny);display:block;padding:0 var(--ck-spacing-small);height:var(--ck-resizer-tooltip-height);line-height:var(--ck-resizer-tooltip-height)}.ck .ck-size-view.ck-orientation-above-center,.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{top:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{top:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-above-center{top:calc(var(--ck-resizer-tooltip-height)*-1);left:50%;transform:translate(-50%)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-width:var(--ck-widget-outline-thickness);outline-style:solid;outline-color:transparent;transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid transparent}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;background-color:var(--ck-color-widget-editable-focus-background)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{padding:4px;box-sizing:border-box;background-color:transparent;opacity:0;transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;transform:translateY(-100%);left:calc(0px - var(--ck-widget-outline-thickness));top:0}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{width:var(--ck-widget-handler-icon-size);height:var(--ck-widget-handler-icon-size);color:var(--ck-color-widget-drag-handler-icon-color)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{opacity:1;background-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:1;background-color:var(--ck-color-focus-border)}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:1}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck.ck-editor__editable.ck-read-only .ck-widget{transition:none}.ck.ck-editor__editable.ck-read-only .ck-widget:not(.ck-widget_selected){--ck-widget-outline-thickness:0px}.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle:hover,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover.ck-widget_with-selection-handle>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover.ck-widget_with-selection-handle>.ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable>.ck-widget.ck-widget_with-selection-handle:first-child,.ck.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handle:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-widget/theme/widget.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widget.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
          names: [],
          mappings: "AAKA,MACC,+CAAgD,CAChD,6CAAsD,CACtD,uCAAgD,CAEhD,kDAAmD,CACnD,gCAAiC,CACjC,kEACD,CAOA,8DAEC,iBAqBD,CAnBC,4EACC,iBAOD,CALC,qFAGC,aACD,CASD,iLACC,kBACD,CAGD,kBACC,qDAAsD,CACtD,0CAA2C,CAC3C,qDAAsD,CACtD,6CAA8C,CAC9C,kCAAmC,CACnC,aAAc,CACd,iCAAkC,CAClC,uCAAwC,CACxC,4CAoCD,CAlCC,8NAKC,iBACD,CAEA,0CACC,oCAAqC,CACrC,qCACD,CAEA,2CACC,oCAAqC,CACrC,sCACD,CAEA,8CACC,uCAAwC,CACxC,sCACD,CAEA,6CACC,uCAAwC,CACxC,qCACD,CAGA,8CACC,6CAAgD,CAChD,QAAS,CACT,yBACD,CCjFD,MACC,iCAAkC,CAClC,kCAAmC,CACnC,4CAA6C,CAC7C,wCAAyC,CAEzC,wCAAiD,CACjD,sCAAkD,CAClD,2EAA4E,CAC5E,yEACD,CAEA,eACC,gDAAiD,CACjD,mBAAoB,CACpB,yBAA0B,CAC1B,6GAUD,CARC,0EAEC,6EACD,CAEA,qBACC,iDACD,CAGD,gCACC,4BAWD,CAPC,yGC/BA,YAAa,CACb,2BAA2B,CCF3B,qCAA8B,CFqC7B,iEACD,CAIA,4EACC,WAAY,CACZ,qBAAsB,CAGtB,4BAA6B,CAC7B,SAAU,CAMV,6SAG6F,CAG7F,iEAAkE,CAGlE,2BAA4B,CAC5B,mDAAoD,CACpD,KAqBD,CAnBC,qFAEC,wCAAyC,CACzC,yCAA0C,CAC1C,oDASD,CANC,kHACC,SAAU,CAGV,+DACD,CAID,wHACC,SACD,CAID,kFACC,SAAU,CACV,oDACD,CAKC,oMACC,SAAU,CACV,6CAMD,CAHC,gRACC,SACD,CAOH,qFACC,SAAU,CACV,oDACD,CAGA,gDAEC,eAkBD,CAhBC,yEAOC,iCACD,CAGC,gOAEC,gDACD,CAOD,wIAEC,mDAQD,CALE,ghBAEC,gDACD,CAKH,yKAOC,yDACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-resizer: var(--ck-color-focus-border);\n\t--ck-color-resizer-tooltip-background: hsl(0, 0%, 15%);\n\t--ck-color-resizer-tooltip-text: hsl(0, 0%, 95%);\n\n\t--ck-resizer-border-radius: var(--ck-border-radius);\n\t--ck-resizer-tooltip-offset: 10px;\n\t--ck-resizer-tooltip-height: calc(var(--ck-spacing-small) * 2 + 10px);\n}\n\n.ck .ck-widget {\n\t/* This is neccessary for type around UI to be positioned properly. */\n\tposition: relative;\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n\n\t& .ck-widget__selection-handle {\n\t\tposition: absolute;\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the icon in not a subject to font-size or line-height to avoid\n\t\t\tunnecessary spacing around it. */\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t/* Show the selection handle on mouse hover over the widget, but not for nested widgets. */\n\t&:hover > .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n\n\t/* Show the selection handle when the widget is selected, but not for nested widgets. */\n\t&.ck-widget_selected > .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n}\n\n.ck .ck-size-view {\n\tbackground: var(--ck-color-resizer-tooltip-background);\n\tcolor: var(--ck-color-resizer-tooltip-text);\n\tborder: 1px solid var(--ck-color-resizer-tooltip-text);\n\tborder-radius: var(--ck-resizer-border-radius);\n\tfont-size: var(--ck-font-size-tiny);\n\tdisplay: block;\n\tpadding: 0 var(--ck-spacing-small);\n\theight: var(--ck-resizer-tooltip-height);\n\tline-height: var(--ck-resizer-tooltip-height);\n\n\t&.ck-orientation-top-left,\n\t&.ck-orientation-top-right,\n\t&.ck-orientation-bottom-right,\n\t&.ck-orientation-bottom-left,\n\t&.ck-orientation-above-center {\n\t\tposition: absolute;\n\t}\n\n\t&.ck-orientation-top-left {\n\t\ttop: var(--ck-resizer-tooltip-offset);\n\t\tleft: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-top-right {\n\t\ttop: var(--ck-resizer-tooltip-offset);\n\t\tright: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-bottom-right {\n\t\tbottom: var(--ck-resizer-tooltip-offset);\n\t\tright: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-bottom-left {\n\t\tbottom: var(--ck-resizer-tooltip-offset);\n\t\tleft: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t/* Class applied if the widget is too small to contain the size label */\n\t&.ck-orientation-above-center {\n\t\ttop: calc(var(--ck-resizer-tooltip-height) * -1);\n\t\tleft: 50%;\n\t\ttransform: translate(-50%);\n\t}\n}\n", '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n\n:root {\n\t--ck-widget-outline-thickness: 3px;\n\t--ck-widget-handler-icon-size: 16px;\n\t--ck-widget-handler-animation-duration: 200ms;\n\t--ck-widget-handler-animation-curve: ease;\n\n\t--ck-color-widget-blurred-border: hsl(0, 0%, 87%);\n\t--ck-color-widget-hover-border: hsl(43, 100%, 62%);\n\t--ck-color-widget-editable-focus-background: var(--ck-color-base-background);\n\t--ck-color-widget-drag-handler-icon-color: var(--ck-color-base-background);\n}\n\n.ck .ck-widget {\n\toutline-width: var(--ck-widget-outline-thickness);\n\toutline-style: solid;\n\toutline-color: transparent;\n\ttransition: outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border);\n\t}\n\n\t&:hover {\n\t\toutline-color: var(--ck-color-widget-hover-border);\n\t}\n}\n\n.ck .ck-editor__nested-editable {\n\tborder: 1px solid transparent;\n\n\t/* The :focus style is applied before .ck-editor__nested-editable_focused class is rendered in the view.\n\tThese styles show a different border for a blink of an eye, so `:focus` need to have same styles applied. */\n\t&.ck-editor__nested-editable_focused,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\n\t\tbackground-color: var(--ck-color-widget-editable-focus-background);\n\t}\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t& .ck-widget__selection-handle {\n\t\tpadding: 4px;\n\t\tbox-sizing: border-box;\n\n\t\t/* Background and opacity will be animated as the handler shows up or the widget gets selected. */\n\t\tbackground-color: transparent;\n\t\topacity: 0;\n\n\t\t/* Transition:\n\t\t   * background-color for the .ck-widget_selected state change,\n\t\t   * visibility for hiding the handler,\n\t\t   * opacity for the proper look of the icon when the handler disappears. */\n\t\ttransition:\n\t\t\tbackground-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\tvisibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\topacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t/* Make only top corners round. */\n\t\tborder-radius: var(--ck-border-radius) var(--ck-border-radius) 0 0;\n\n\t\t/* Place the drag handler outside the widget wrapper. */\n\t\ttransform: translateY(-100%);\n\t\tleft: calc(0px - var(--ck-widget-outline-thickness));\n\t\ttop: 0;\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the dimensions of the icon are independent of the fon-size of the content. */\n\t\t\twidth: var(--ck-widget-handler-icon-size);\n\t\t\theight: var(--ck-widget-handler-icon-size);\n\t\t\tcolor: var(--ck-color-widget-drag-handler-icon-color);\n\n\t\t\t/* The "selected" part of the icon is invisible by default */\n\t\t\t& .ck-icon__selected-indicator {\n\t\t\t\topacity: 0;\n\n\t\t\t\t/* Note: The animation is longer on purpose. Simply feels better. */\n\t\t\t\ttransition: opacity 300ms var(--ck-widget-handler-animation-curve);\n\t\t\t}\n\t\t}\n\n\t\t/* Advertise using the look of the icon that once clicked the handler, the widget will be selected. */\n\t\t&:hover .ck-icon .ck-icon__selected-indicator {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t/* Show the selection handler on mouse hover over the widget, but not for nested widgets. */\n\t&:hover > .ck-widget__selection-handle {\n\t\topacity: 1;\n\t\tbackground-color: var(--ck-color-widget-hover-border);\n\t}\n\n\t/* Show the selection handler when the widget is selected, but not for nested widgets. */\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\t& > .ck-widget__selection-handle {\n\t\t\topacity: 1;\n\t\t\tbackground-color: var(--ck-color-focus-border);\n\n\t\t\t/* When the widget is selected, notify the user using the proper look of the icon. */\n\t\t\t& .ck-icon .ck-icon__selected-indicator {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* In a RTL environment, align the selection handler to the right side of the widget */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle {\n\tleft: auto;\n\tright: calc(0px - var(--ck-widget-outline-thickness));\n}\n\n/* https://github.com/ckeditor/ckeditor5/issues/6415 */\n.ck.ck-editor__editable.ck-read-only .ck-widget {\n\t/* Prevent the :hover outline from showing up because of the used outline-color transition. */\n\ttransition: none;\n\n\t&:not(.ck-widget_selected) {\n\t\t/* Disable visual effects of hover/active widget when CKEditor is in readOnly mode.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/1261\n\t\t *\n\t\t * Leave the unit because this custom property is used in calc() by other features.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/6775\n\t\t */\n\t\t--ck-widget-outline-thickness: 0px;\n\t}\n\n\t&.ck-widget_with-selection-handle {\n\t\t& .ck-widget__selection-handle,\n\t\t& .ck-widget__selection-handle:hover {\n\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t}\n\t}\n}\n\n/* Style the widget when it\'s selected but the editable it belongs to lost focus. */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck.ck-editor__editable.ck-blurred .ck-widget {\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline-color: var(--ck-color-widget-blurred-border);\n\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t& > .ck-widget__selection-handle,\n\t\t\t& > .ck-widget__selection-handle:hover {\n\t\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-editor__editable > .ck-widget.ck-widget_with-selection-handle:first-child,\n.ck.ck-editor__editable blockquote > .ck-widget.ck-widget_with-selection-handle:first-child {\n\t/* Do not crop selection handler if a widget is a first-child in the blockquote or in the root editable.\n\tIn fact, anything with overflow: hidden.\n\thttps://github.com/ckeditor/ckeditor5-block-quote/issues/28\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/44\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/66 */\n\tmargin-top: calc(1em + var(--ck-widget-handler-icon-size));\n}\n', "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      2497: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, ".ck .ck-widget_with-resizer{position:relative}.ck .ck-widget__resizer{display:none;position:absolute;pointer-events:none;left:0;top:0}.ck-focused .ck-widget_with-resizer.ck-widget_selected>.ck-widget__resizer{display:block}.ck .ck-widget__resizer__handle{position:absolute;pointer-events:all}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{cursor:nesw-resize}:root{--ck-resizer-size:10px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-border-width:1px}.ck .ck-widget__resizer{outline:1px solid var(--ck-color-resizer)}.ck .ck-widget__resizer__handle{width:var(--ck-resizer-size);height:var(--ck-resizer-size);background:var(--ck-color-focus-border);border:var(--ck-resizer-border-width) solid #fff;border-radius:var(--ck-resizer-border-radius)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{top:var(--ck-resizer-offset);left:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{top:var(--ck-resizer-offset);right:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right{bottom:var(--ck-resizer-offset);right:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left{bottom:var(--ck-resizer-offset);left:var(--ck-resizer-offset)}", "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-widget/theme/widgetresize.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widgetresize.css"],
          names: [],
          mappings: "AAKA,4BAEC,iBACD,CAEA,wBACC,YAAa,CACb,iBAAkB,CAGlB,mBAAoB,CAEpB,MAAO,CACP,KACD,CAGC,2EACC,aACD,CAGD,gCACC,iBAAkB,CAGlB,kBAWD,CATC,4IAEC,kBACD,CAEA,4IAEC,kBACD,CCpCD,MACC,sBAAuB,CAGvB,yDAAiE,CACjE,6BACD,CAEA,wBACC,yCACD,CAEA,gCACC,4BAA6B,CAC7B,6BAA8B,CAC9B,uCAAwC,CACxC,gDAA6D,CAC7D,6CAqBD,CAnBC,oEACC,4BAA6B,CAC7B,6BACD,CAEA,qEACC,4BAA6B,CAC7B,8BACD,CAEA,wEACC,+BAAgC,CAChC,8BACD,CAEA,uEACC,+BAAgC,CAChC,6BACD",
          sourcesContent: ["/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget_with-resizer {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n}\n\n.ck .ck-widget__resizer {\n\tdisplay: none;\n\tposition: absolute;\n\n\t/* The wrapper itself should not interfere with the pointer device, only the handles should. */\n\tpointer-events: none;\n\n\tleft: 0;\n\ttop: 0;\n}\n\n.ck-focused .ck-widget_with-resizer.ck-widget_selected {\n\t& > .ck-widget__resizer {\n\t\tdisplay: block;\n\t}\n}\n\n.ck .ck-widget__resizer__handle {\n\tposition: absolute;\n\n\t/* Resizers are the only UI elements that should interfere with a pointer device. */\n\tpointer-events: all;\n\n\t&.ck-widget__resizer__handle-top-left,\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tcursor: nwse-resize;\n\t}\n\n\t&.ck-widget__resizer__handle-top-right,\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tcursor: nesw-resize;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-resizer-size: 10px;\n\n\t/* Set the resizer with a 50% offset. */\n\t--ck-resizer-offset: calc( ( var(--ck-resizer-size) / -2 ) - 2px);\n\t--ck-resizer-border-width: 1px;\n}\n\n.ck .ck-widget__resizer {\n\toutline: 1px solid var(--ck-color-resizer);\n}\n\n.ck .ck-widget__resizer__handle {\n\twidth: var(--ck-resizer-size);\n\theight: var(--ck-resizer-size);\n\tbackground: var(--ck-color-focus-border);\n\tborder: var(--ck-resizer-border-width) solid hsl(0, 0%, 100%);\n\tborder-radius: var(--ck-resizer-border-radius);\n\n\t&.ck-widget__resizer__handle-top-left {\n\t\ttop: var(--ck-resizer-offset);\n\t\tleft: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-top-right {\n\t\ttop: var(--ck-resizer-offset);\n\t\tright: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tbottom: var(--ck-resizer-offset);\n\t\tright: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tbottom: var(--ck-resizer-offset);\n\t\tleft: var(--ck-resizer-offset);\n\t}\n}\n"],
          sourceRoot: ""
        }]), e.Z = s;
      },
      178: function _(t, e, n) {
        "use strict";

        var i = n(4015),
            o = n.n(i),
            r = n(3645),
            s = n.n(r)()(o());
        s.push([t.id, '.ck .ck-widget .ck-widget__type-around__button{display:block;position:absolute;overflow:hidden;z-index:var(--ck-z-default)}.ck .ck-widget .ck-widget__type-around__button svg{position:absolute;top:50%;left:50%;z-index:calc(var(--ck-z-default) + 2)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_before{top:calc(var(--ck-widget-outline-thickness)*-0.5);left:min(10%,30px);transform:translateY(-50%)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_after{bottom:calc(var(--ck-widget-outline-thickness)*-0.5);right:min(10%,30px);transform:translateY(50%)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{content:"";display:block;position:absolute;top:1px;left:1px;z-index:calc(var(--ck-z-default) + 1)}.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:none;position:absolute;left:0;right:0}.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__fake-caret{left:calc(var(--ck-widget-outline-thickness)*-1);right:calc(var(--ck-widget-outline-thickness)*-1)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__fake-caret{top:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__fake-caret{bottom:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck.ck-editor__editable.ck-read-only .ck-widget__type-around,.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around,.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around{display:none}:root{--ck-widget-type-around-button-size:20px;--ck-color-widget-type-around-button-active:var(--ck-color-focus-border);--ck-color-widget-type-around-button-hover:var(--ck-color-widget-hover-border);--ck-color-widget-type-around-button-blurred-editable:var(--ck-color-widget-blurred-border);--ck-color-widget-type-around-button-radar-start-alpha:0;--ck-color-widget-type-around-button-radar-end-alpha:.3;--ck-color-widget-type-around-button-icon:var(--ck-color-base-background)}.ck .ck-widget .ck-widget__type-around__button{width:var(--ck-widget-type-around-button-size);height:var(--ck-widget-type-around-button-size);background:var(--ck-color-widget-type-around-button);border-radius:100px;transition:opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);opacity:0;pointer-events:none}.ck .ck-widget .ck-widget__type-around__button svg{width:10px;height:8px;transform:translate(-50%,-50%);transition:transform .5s ease;margin-top:1px}.ck .ck-widget .ck-widget__type-around__button svg *{stroke-dasharray:10;stroke-dashoffset:0;fill:none;stroke:var(--ck-color-widget-type-around-button-icon);stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round}.ck .ck-widget .ck-widget__type-around__button svg line{stroke-dasharray:7}.ck .ck-widget .ck-widget__type-around__button:hover{animation:ck-widget-type-around-button-sonar 1s ease infinite}.ck .ck-widget .ck-widget__type-around__button:hover svg polyline{animation:ck-widget-type-around-arrow-dash 2s linear}.ck .ck-widget .ck-widget__type-around__button:hover svg line{animation:ck-widget-type-around-arrow-tip-dash 2s linear}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:1;pointer-events:auto}.ck .ck-widget:not(.ck-widget_selected)>.ck-widget__type-around>.ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button-hover)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover{background:var(--ck-color-widget-type-around-button-active)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{width:calc(var(--ck-widget-type-around-button-size) - 2px);height:calc(var(--ck-widget-type-around-button-size) - 2px);border-radius:100px;background:linear-gradient(135deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.3))}.ck .ck-widget.ck-widget_with-selection-handle>.ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:20px}.ck .ck-widget .ck-widget__type-around__fake-caret{pointer-events:none;height:1px;animation:ck-widget-type-around-fake-caret-pulse 1s linear infinite normal forwards;outline:1px solid hsla(0,0%,100%,.5);background:var(--ck-color-base-text)}.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_after,.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_before{outline-color:transparent}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected:hover,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:0}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer{opacity:0}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:0;margin-right:20px}.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover){background:var(--ck-color-widget-type-around-button-blurred-editable)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover) svg *{stroke:#999}@keyframes ck-widget-type-around-arrow-dash{0%{stroke-dashoffset:10}20%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-arrow-tip-dash{0%,20%{stroke-dashoffset:7}40%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-button-sonar{0%{box-shadow:0 0 0 0 hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}50%{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-end-alpha))}to{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}}@keyframes ck-widget-type-around-fake-caret-pulse{0%{opacity:1}49%{opacity:1}50%{opacity:0}99%{opacity:0}to{opacity:1}}', "", {
          version: 3,
          sources: ["webpack://./../../node_modules/@ckeditor/ckeditor5-widget/theme/widgettypearound.css", "webpack://./../../node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widgettypearound.css"],
          names: [],
          mappings: "AASC,+CACC,aAAc,CACd,iBAAkB,CAClB,eAAgB,CAChB,2BAwBD,CAtBC,mDACC,iBAAkB,CAClB,OAAQ,CACR,QAAS,CACT,qCACD,CAEA,qFAEC,iDAAoD,CACpD,kBAAoB,CAEpB,0BACD,CAEA,oFAEC,oDAAuD,CACvD,mBAAqB,CAErB,yBACD,CAUA,mLACC,UAAW,CACX,aAAc,CACd,iBAAkB,CAClB,OAAQ,CACR,QAAS,CACT,qCACD,CAMD,2EACC,YAAa,CACb,iBAAkB,CAClB,MAAO,CACP,OACD,CAOA,iFACC,gDAAqD,CACrD,iDACD,CAKA,wHACC,qDAA0D,CAC1D,aACD,CAKA,uHACC,wDAA6D,CAC7D,aACD,CAoBD,mOACC,YACD,CC3GA,MACC,wCAAyC,CACzC,wEAAyE,CACzE,8EAA+E,CAC/E,2FAA4F,CAC5F,wDAAyD,CACzD,uDAAwD,CACxD,yEACD,CAgBC,+CACC,8CAA+C,CAC/C,+CAAgD,CAChD,oDAAqD,CACrD,mBAAoB,CACpB,uMAAyM,CAb1M,SAAU,CACV,mBA0DA,CA1CC,mDACC,UAAW,CACX,UAAW,CACX,8BAA+B,CAC/B,6BAA8B,CAC9B,cAgBD,CAdC,qDACC,mBAAoB,CACpB,mBAAoB,CAEpB,SAAU,CACV,qDAAsD,CACtD,kBAAmB,CACnB,oBAAqB,CACrB,qBACD,CAEA,wDACC,kBACD,CAGD,qDAIC,6DAcD,CARE,kEACC,oDACD,CAEA,8DACC,wDACD,CAUF,uKAvED,SAAU,CACV,mBAwEC,CAOD,gGACC,0DACD,CAOA,uKAEC,2DAQD,CANC,mLACC,0DAA2D,CAC3D,2DAA4D,CAC5D,mBAAoB,CACpB,uEACD,CAOD,8GACC,gBACD,CAKA,mDACC,mBAAoB,CACpB,UAAW,CACX,mFAAoF,CAMpF,oCAAwC,CACxC,oCACD,CAOC,6JAEC,yBACD,CAUA,yKACC,iDACD,CAMA,uOAlJD,SAAU,CACV,mBAmJC,CASE,0jBACC,SACD,CASF,mPACC,SACD,CASF,uHACC,aAAc,CACd,iBACD,CAYG,iRAlMF,SAAU,CACV,mBAmME,CAQH,kIACC,qEAKD,CAHC,wIACC,WACD,CAGD,4CACC,GACC,oBACD,CACA,OACC,mBACD,CACD,CAEA,gDACC,OACC,mBACD,CACA,OACC,mBACD,CACD,CAEA,8CACC,GACC,6HACD,CACA,IACC,6HACD,CACA,GACC,+HACD,CACD,CAEA,kDACC,GACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,GACC,SACD,CACD",
          sourcesContent: ['/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\toverflow: hidden;\n\t\tz-index: var(--ck-z-default);\n\n\t\t& svg {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\tz-index: calc(var(--ck-z-default) + 2);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_before {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\ttop: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tleft: min(10%, 30px);\n\n\t\t\ttransform: translateY(-50%);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_after {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\tbottom: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tright: min(10%, 30px);\n\n\t\t\ttransform: translateY(50%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\ttop: 1px;\n\t\t\tleft: 1px;\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tdisplay: none;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t}\n\n\t/*\n\t * When the widget is hovered the "fake caret" would normally be narrower than the\n\t * extra outline displayed around the widget. Let\'s extend the "fake caret" to match\n\t * the full width of the widget.\n\t */\n\t&:hover > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tleft: calc( -1 * var(--ck-widget-outline-thickness) );\n\t\tright: calc( -1 * var(--ck-widget-outline-thickness) );\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed before the widget (backward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_before > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\ttop: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed after the widget (forward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_after > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tbottom: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n}\n\n/*\n * Integration with the read-only mode of the editor.\n */\n.ck.ck-editor__editable.ck-read-only .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the restricted editing mode (feature) of the editor.\n */\n.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the #isEnabled property of the WidgetTypeAround plugin.\n */\n.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around {\n\tdisplay: none;\n}\n', '/*\n * Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-widget-type-around-button-size: 20px;\n\t--ck-color-widget-type-around-button-active: var(--ck-color-focus-border);\n\t--ck-color-widget-type-around-button-hover: var(--ck-color-widget-hover-border);\n\t--ck-color-widget-type-around-button-blurred-editable: var(--ck-color-widget-blurred-border);\n\t--ck-color-widget-type-around-button-radar-start-alpha: 0;\n\t--ck-color-widget-type-around-button-radar-end-alpha: .3;\n\t--ck-color-widget-type-around-button-icon: var(--ck-color-base-background);\n}\n\n@define-mixin ck-widget-type-around-button-visible {\n\topacity: 1;\n\tpointer-events: auto;\n}\n\n@define-mixin ck-widget-type-around-button-hidden {\n\topacity: 0;\n\tpointer-events: none;\n}\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\twidth: var(--ck-widget-type-around-button-size);\n\t\theight: var(--ck-widget-type-around-button-size);\n\t\tbackground: var(--ck-color-widget-type-around-button);\n\t\tborder-radius: 100px;\n\t\ttransition: opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve), background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t@mixin ck-widget-type-around-button-hidden;\n\n\t\t& svg {\n\t\t\twidth: 10px;\n\t\t\theight: 8px;\n\t\t\ttransform: translate(-50%,-50%);\n\t\t\ttransition: transform .5s ease;\n\t\t\tmargin-top: 1px;\n\n\t\t\t& * {\n\t\t\t\tstroke-dasharray: 10;\n\t\t\t\tstroke-dashoffset: 0;\n\n\t\t\t\tfill: none;\n\t\t\t\tstroke: var(--ck-color-widget-type-around-button-icon);\n\t\t\t\tstroke-width: 1.5px;\n\t\t\t\tstroke-linecap: round;\n\t\t\t\tstroke-linejoin: round;\n\t\t\t}\n\n\t\t\t& line {\n\t\t\t\tstroke-dasharray: 7;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\t/*\n\t\t\t * Display the "sonar" around the button when hovered.\n\t\t\t */\n\t\t\tanimation: ck-widget-type-around-button-sonar 1s ease infinite;\n\n\t\t\t/*\n\t\t\t * Animate active button\'s icon.\n\t\t\t */\n\t\t\t& svg {\n\t\t\t\t& polyline {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-dash 2s linear;\n\t\t\t\t}\n\n\t\t\t\t& line {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-tip-dash 2s linear;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * Show type around buttons when the widget gets selected or being hovered.\n\t */\n\t&.ck-widget_selected,\n\t&:hover {\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-visible;\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when the widget is NOT selected (but the buttons are visible\n\t * and still can be hovered).\n\t */\n\t&:not(.ck-widget_selected) > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\tbackground: var(--ck-color-widget-type-around-button-hover);\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\tbackground: var(--ck-color-widget-type-around-button-active);\n\n\t\t&::after {\n\t\t\twidth: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\theight: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\tborder-radius: 100px;\n\t\t\tbackground: linear-gradient(135deg, hsla(0,0%,100%,0) 0%, hsla(0,0%,100%,.3) 100%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the "before" button when the widget has a selection handle. Because some space\n\t * is consumed by the handle, the button must be moved slightly to the right to let it breathe.\n\t */\n\t&.ck-widget_with-selection-handle > .ck-widget__type-around > .ck-widget__type-around__button_before {\n\t\tmargin-left: 20px;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& .ck-widget__type-around__fake-caret {\n\t\tpointer-events: none;\n\t\theight: 1px;\n\t\tanimation: ck-widget-type-around-fake-caret-pulse linear 1s infinite normal forwards;\n\n\t\t/*\n\t\t * The semi-transparent-outline+background combo improves the contrast\n\t\t * when the background underneath the fake caret is dark.\n\t\t */\n\t\toutline: solid 1px hsla(0, 0%, 100%, .5);\n\t\tbackground: var(--ck-color-base-text);\n\t}\n\n\t/*\n\t * Styles of the widget when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t * Despite the widget being physically selected in the model, its outline should disappear.\n\t */\n\t&.ck-widget_selected {\n\t\t&.ck-widget_type-around_show-fake-caret_before,\n\t\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t\toutline-color: transparent;\n\t\t}\n\t}\n\n\t&.ck-widget_type-around_show-fake-caret_before,\n\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t/*\n\t\t * When the "fake caret" is visible we simulate that the widget is not selected\n\t\t * (despite being physically selected), so the outline color should be for the\n\t\t * unselected widget.\n\t\t */\n\t\t&.ck-widget_selected:hover {\n\t\t\toutline-color: var(--ck-color-widget-hover-border);\n\t\t}\n\n\t\t/*\n\t\t * Styles of the type around buttons when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t\t * In this state, the type around buttons would collide with the fake carets so they should disappear.\n\t\t */\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the selection handle. When the caret is visible, simply\n\t\t * hide the handle because it intersects with the caret (and does not make much sense anyway).\n\t\t */\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t&.ck-widget_selected,\n\t\t\t&.ck-widget_selected:hover {\n\t\t\t\t& > .ck-widget__selection-handle {\n\t\t\t\t\topacity: 0\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the resize UI. When the caret is visible, simply\n\t\t * hide the resize UI because it creates too much noise. It can be visible when the user\n\t\t * hovers the widget, though.\n\t\t */\n\t\t&.ck-widget_selected.ck-widget_with-resizer > .ck-widget__resizer {\n\t\t\topacity: 0\n\t\t}\n\t}\n}\n\n/*\n * Styles for the "before" button when the widget has a selection handle in an RTL environment.\n * The selection handler is aligned to the right side of the widget so there is no need to create\n * additional space for it next to the "before" button.\n */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around > .ck-widget__type-around__button_before {\n\tmargin-left: 0;\n\tmargin-right: 20px;\n}\n\n/*\n * Hide type around buttons when the widget is selected as a child of a selected\n * nested editable (e.g. mulit-cell table selection).\n *\n * See https://github.com/ckeditor/ckeditor5/issues/7263.\n */\n.ck-editor__nested-editable.ck-editor__editable_selected {\n\t& .ck-widget {\n\t\t&.ck-widget_selected,\n\t\t&:hover {\n\t\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*\n * Styles for the buttons when the widget is selected but the user clicked outside of the editor (blurred the editor).\n */\n.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button:not(:hover) {\n\tbackground: var(--ck-color-widget-type-around-button-blurred-editable);\n\n\t& svg * {\n\t\tstroke: hsl(0,0%,60%);\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-dash {\n\t0% {\n\t\tstroke-dashoffset: 10;\n\t}\n\t20%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-tip-dash {\n\t0%, 20% {\n\t\tstroke-dashoffset: 7;\n\t}\n\t40%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-button-sonar {\n\t0% {\n\t\tbox-shadow: 0 0 0 0 hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n\t50% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-end-alpha));\n\t}\n\t100% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n}\n\n@keyframes ck-widget-type-around-fake-caret-pulse {\n\t0% {\n\t\topacity: 1;\n\t}\n\t49% {\n\t\topacity: 1;\n\t}\n\t50% {\n\t\topacity: 0;\n\t}\n\t99% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n}\n'],
          sourceRoot: ""
        }]), e.Z = s;
      },
      3645: function _(t) {
        "use strict";

        t.exports = function (t) {
          var e = [];
          return e.toString = function () {
            return this.map(function (e) {
              var n = t(e);
              return e[2] ? "@media ".concat(e[2], " {").concat(n, "}") : n;
            }).join("");
          }, e.i = function (t, n, i) {
            "string" == typeof t && (t = [[null, t, ""]]);
            var o = {};
            if (i) for (var r = 0; r < this.length; r++) {
              var s = this[r][0];
              null != s && (o[s] = !0);
            }

            for (var a = 0; a < t.length; a++) {
              var c = [].concat(t[a]);
              i && o[c[0]] || (n && (c[2] ? c[2] = "".concat(n, " and ").concat(c[2]) : c[2] = n), e.push(c));
            }
          }, e;
        };
      },
      4015: function _(t) {
        "use strict";

        function e(t, e) {
          return function (t) {
            if (Array.isArray(t)) return t;
          }(t) || function (t, e) {
            var n = t && ("undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"]);
            if (null == n) return;
            var i,
                o,
                r = [],
                s = !0,
                a = !1;

            try {
              for (n = n.call(t); !(s = (i = n.next()).done) && (r.push(i.value), !e || r.length !== e); s = !0) {
                ;
              }
            } catch (t) {
              a = !0, o = t;
            } finally {
              try {
                s || null == n.return || n.return();
              } finally {
                if (a) throw o;
              }
            }

            return r;
          }(t, e) || function (t, e) {
            if (!t) return;
            if ("string" == typeof t) return n(t, e);
            var i = Object.prototype.toString.call(t).slice(8, -1);
            "Object" === i && t.constructor && (i = t.constructor.name);
            if ("Map" === i || "Set" === i) return Array.from(t);
            if ("Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return n(t, e);
          }(t, e) || function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }();
        }

        function n(t, e) {
          (null == e || e > t.length) && (e = t.length);

          for (var n = 0, i = new Array(e); n < e; n++) {
            i[n] = t[n];
          }

          return i;
        }

        t.exports = function (t) {
          var n = e(t, 4),
              i = n[1],
              o = n[3];
          if (!o) return i;

          if ("function" == typeof btoa) {
            var r = btoa(unescape(encodeURIComponent(JSON.stringify(o)))),
                s = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(r),
                a = "/*# ".concat(s, " */"),
                c = o.sources.map(function (t) {
              return "/*# sourceURL=".concat(o.sourceRoot || "").concat(t, " */");
            });
            return [i].concat(c).concat([a]).join("\n");
          }

          return [i].join("\n");
        };
      },
      3379: function _(t, e, n) {
        "use strict";

        var i,
            o = function o() {
          return void 0 === i && (i = Boolean(window && document && document.all && !window.atob)), i;
        },
            r = function () {
          var t = {};
          return function (e) {
            if (void 0 === t[e]) {
              var n = document.querySelector(e);
              if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
                n = n.contentDocument.head;
              } catch (t) {
                n = null;
              }
              t[e] = n;
            }

            return t[e];
          };
        }(),
            s = [];

        function a(t) {
          for (var e = -1, n = 0; n < s.length; n++) {
            if (s[n].identifier === t) {
              e = n;
              break;
            }
          }

          return e;
        }

        function c(t, e) {
          for (var n = {}, i = [], o = 0; o < t.length; o++) {
            var r = t[o],
                c = e.base ? r[0] + e.base : r[0],
                l = n[c] || 0,
                d = "".concat(c, " ").concat(l);
            n[c] = l + 1;
            var h = a(d),
                u = {
              css: r[1],
              media: r[2],
              sourceMap: r[3]
            };
            -1 !== h ? (s[h].references++, s[h].updater(u)) : s.push({
              identifier: d,
              updater: f(u, e),
              references: 1
            }), i.push(d);
          }

          return i;
        }

        function l(t) {
          var e = document.createElement("style"),
              i = t.attributes || {};

          if (void 0 === i.nonce) {
            var o = n.nc;
            o && (i.nonce = o);
          }

          if (Object.keys(i).forEach(function (t) {
            e.setAttribute(t, i[t]);
          }), "function" == typeof t.insert) t.insert(e);else {
            var s = r(t.insert || "head");
            if (!s) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
            s.appendChild(e);
          }
          return e;
        }

        var d,
            h = (d = [], function (t, e) {
          return d[t] = e, d.filter(Boolean).join("\n");
        });

        function u(t, e, n, i) {
          var o = n ? "" : i.media ? "@media ".concat(i.media, " {").concat(i.css, "}") : i.css;
          if (t.styleSheet) t.styleSheet.cssText = h(e, o);else {
            var r = document.createTextNode(o),
                s = t.childNodes;
            s[e] && t.removeChild(s[e]), s.length ? t.insertBefore(r, s[e]) : t.appendChild(r);
          }
        }

        function g(t, e, n) {
          var i = n.css,
              o = n.media,
              r = n.sourceMap;
          if (o ? t.setAttribute("media", o) : t.removeAttribute("media"), r && "undefined" != typeof btoa && (i += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */")), t.styleSheet) t.styleSheet.cssText = i;else {
            for (; t.firstChild;) {
              t.removeChild(t.firstChild);
            }

            t.appendChild(document.createTextNode(i));
          }
        }

        var m = null,
            p = 0;

        function f(t, e) {
          var n, i, o;

          if (e.singleton) {
            var r = p++;
            n = m || (m = l(e)), i = u.bind(null, n, r, !1), o = u.bind(null, n, r, !0);
          } else n = l(e), i = g.bind(null, n, e), o = function o() {
            !function (t) {
              if (null === t.parentNode) return !1;
              t.parentNode.removeChild(t);
            }(n);
          };

          return i(t), function (e) {
            if (e) {
              if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
              i(t = e);
            } else o();
          };
        }

        t.exports = function (t, e) {
          (e = e || {}).singleton || "boolean" == typeof e.singleton || (e.singleton = o());
          var n = c(t = t || [], e);
          return function (t) {
            if (t = t || [], "[object Array]" === Object.prototype.toString.call(t)) {
              for (var i = 0; i < n.length; i++) {
                var o = a(n[i]);
                s[o].references--;
              }

              for (var r = c(t, e), l = 0; l < n.length; l++) {
                var d = a(n[l]);
                0 === s[d].references && (s[d].updater(), s.splice(d, 1));
              }

              n = r;
            }
          };
        };
      },
      3917: function _(t) {
        t.exports = function () {
          "use strict";

          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
            }
          }

          function e(e, n, i) {
            return n && t(e.prototype, n), i && t(e, i), e;
          }

          function n(t, e) {
            if (t) {
              if ("string" == typeof t) return i(t, e);
              var n = Object.prototype.toString.call(t).slice(8, -1);
              return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? i(t, e) : void 0;
            }
          }

          function i(t, e) {
            (null == e || e > t.length) && (e = t.length);

            for (var n = 0, i = new Array(e); n < e; n++) {
              i[n] = t[n];
            }

            return i;
          }

          function o(t, e) {
            var i;

            if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
              if (Array.isArray(t) || (i = n(t)) || e && t && "number" == typeof t.length) {
                i && (t = i);
                var o = 0;
                return function () {
                  return o >= t.length ? {
                    done: !0
                  } : {
                    done: !1,
                    value: t[o++]
                  };
                };
              }

              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }

            return (i = t[Symbol.iterator]()).next.bind(i);
          }

          function r(t, e) {
            return t(e = {
              exports: {}
            }, e.exports), e.exports;
          }

          var s = r(function (t) {
            function e() {
              return {
                baseUrl: null,
                breaks: !1,
                gfm: !0,
                headerIds: !0,
                headerPrefix: "",
                highlight: null,
                langPrefix: "language-",
                mangle: !0,
                pedantic: !1,
                renderer: null,
                sanitize: !1,
                sanitizer: null,
                silent: !1,
                smartLists: !1,
                smartypants: !1,
                tokenizer: null,
                walkTokens: null,
                xhtml: !1
              };
            }

            function n(e) {
              t.exports.defaults = e;
            }

            t.exports = {
              defaults: e(),
              getDefaults: e,
              changeDefaults: n
            };
          }),
              a = (s.defaults, s.getDefaults, s.changeDefaults, /[&<>"']/),
              c = /[&<>"']/g,
              l = /[<>"']|&(?!#?\w+;)/,
              d = /[<>"']|&(?!#?\w+;)/g,
              h = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
          },
              u = function u(t) {
            return h[t];
          };

          function g(t, e) {
            if (e) {
              if (a.test(t)) return t.replace(c, u);
            } else if (l.test(t)) return t.replace(d, u);

            return t;
          }

          var m = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/gi;

          function p(t) {
            return t.replace(m, function (t, e) {
              return "colon" === (e = e.toLowerCase()) ? ":" : "#" === e.charAt(0) ? "x" === e.charAt(1) ? String.fromCharCode(parseInt(e.substring(2), 16)) : String.fromCharCode(+e.substring(1)) : "";
            });
          }

          var f = /(^|[^\[])\^/g;

          function k(t, e) {
            t = t.source || t, e = e || "";
            var n = {
              replace: function replace(e, i) {
                return i = (i = i.source || i).replace(f, "$1"), t = t.replace(e, i), n;
              },
              getRegex: function getRegex() {
                return new RegExp(t, e);
              }
            };
            return n;
          }

          var b = /[^\w:]/g,
              w = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;

          function A(t, e, n) {
            if (t) {
              var i;

              try {
                i = decodeURIComponent(p(n)).replace(b, "").toLowerCase();
              } catch (t) {
                return null;
              }

              if (0 === i.indexOf("javascript:") || 0 === i.indexOf("vbscript:") || 0 === i.indexOf("data:")) return null;
            }

            e && !w.test(n) && (n = x(e, n));

            try {
              n = encodeURI(n).replace(/%25/g, "%");
            } catch (t) {
              return null;
            }

            return n;
          }

          var C = {},
              _ = /^[^:]+:\/*[^/]*$/,
              v = /^([^:]+:)[\s\S]*$/,
              y = /^([^:]+:\/*[^/]*)[\s\S]*$/;

          function x(t, e) {
            C[" " + t] || (_.test(t) ? C[" " + t] = t + "/" : C[" " + t] = S(t, "/", !0));
            var n = -1 === (t = C[" " + t]).indexOf(":");
            return "//" === e.substring(0, 2) ? n ? e : t.replace(v, "$1") + e : "/" === e.charAt(0) ? n ? e : t.replace(y, "$1") + e : t + e;
          }

          function E(t) {
            for (var e, n, i = 1; i < arguments.length; i++) {
              for (n in e = arguments[i]) {
                Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
              }
            }

            return t;
          }

          function D(t, e) {
            var n = t.replace(/\|/g, function (t, e, n) {
              for (var i = !1, o = e; --o >= 0 && "\\" === n[o];) {
                i = !i;
              }

              return i ? "|" : " |";
            }).split(/ \|/),
                i = 0;
            if (n.length > e) n.splice(e);else for (; n.length < e;) {
              n.push("");
            }

            for (; i < n.length; i++) {
              n[i] = n[i].trim().replace(/\\\|/g, "|");
            }

            return n;
          }

          function S(t, e, n) {
            var i = t.length;
            if (0 === i) return "";

            for (var o = 0; o < i;) {
              var r = t.charAt(i - o - 1);

              if (r !== e || n) {
                if (r === e || !n) break;
                o++;
              } else o++;
            }

            return t.substr(0, i - o);
          }

          function I(t, e) {
            if (-1 === t.indexOf(e[1])) return -1;

            for (var n = t.length, i = 0, o = 0; o < n; o++) {
              if ("\\" === t[o]) o++;else if (t[o] === e[0]) i++;else if (t[o] === e[1] && --i < 0) return o;
            }

            return -1;
          }

          function M(t) {
            t && t.sanitize && !t.silent && console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
          }

          var T = {
            escape: g,
            unescape: p,
            edit: k,
            cleanUrl: A,
            resolveUrl: x,
            noopTest: {
              exec: function exec() {}
            },
            merge: E,
            splitCells: D,
            rtrim: S,
            findClosingBracket: I,
            checkSanitizeDeprecation: M
          },
              N = s.defaults,
              B = T.rtrim,
              z = T.splitCells,
              P = T.escape,
              L = T.findClosingBracket;

          function R(t, e, n) {
            var i = e.href,
                o = e.title ? P(e.title) : null,
                r = t[1].replace(/\\([\[\]])/g, "$1");
            return "!" !== t[0].charAt(0) ? {
              type: "link",
              raw: n,
              href: i,
              title: o,
              text: r
            } : {
              type: "image",
              raw: n,
              href: i,
              title: o,
              text: P(r)
            };
          }

          function O(t, e) {
            var n = t.match(/^(\s+)(?:```)/);
            if (null === n) return e;
            var i = n[1];
            return e.split("\n").map(function (t) {
              var e = t.match(/^\s+/);
              return null === e ? t : e[0].length >= i.length ? t.slice(i.length) : t;
            }).join("\n");
          }

          var j = function () {
            function t(t) {
              this.options = t || N;
            }

            var e = t.prototype;
            return e.space = function (t) {
              var e = this.rules.block.newline.exec(t);
              if (e) return e[0].length > 1 ? {
                type: "space",
                raw: e[0]
              } : {
                raw: "\n"
              };
            }, e.code = function (t, e) {
              var n = this.rules.block.code.exec(t);

              if (n) {
                var i = e[e.length - 1];
                if (i && "paragraph" === i.type) return {
                  raw: n[0],
                  text: n[0].trimRight()
                };
                var o = n[0].replace(/^ {4}/gm, "");
                return {
                  type: "code",
                  raw: n[0],
                  codeBlockStyle: "indented",
                  text: this.options.pedantic ? o : B(o, "\n")
                };
              }
            }, e.fences = function (t) {
              var e = this.rules.block.fences.exec(t);

              if (e) {
                var n = e[0],
                    i = O(n, e[3] || "");
                return {
                  type: "code",
                  raw: n,
                  lang: e[2] ? e[2].trim() : e[2],
                  text: i
                };
              }
            }, e.heading = function (t) {
              var e = this.rules.block.heading.exec(t);
              if (e) return {
                type: "heading",
                raw: e[0],
                depth: e[1].length,
                text: e[2]
              };
            }, e.nptable = function (t) {
              var e = this.rules.block.nptable.exec(t);

              if (e) {
                var n = {
                  type: "table",
                  header: z(e[1].replace(/^ *| *\| *$/g, "")),
                  align: e[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                  cells: e[3] ? e[3].replace(/\n$/, "").split("\n") : [],
                  raw: e[0]
                };

                if (n.header.length === n.align.length) {
                  var i,
                      o = n.align.length;

                  for (i = 0; i < o; i++) {
                    /^ *-+: *$/.test(n.align[i]) ? n.align[i] = "right" : /^ *:-+: *$/.test(n.align[i]) ? n.align[i] = "center" : /^ *:-+ *$/.test(n.align[i]) ? n.align[i] = "left" : n.align[i] = null;
                  }

                  for (o = n.cells.length, i = 0; i < o; i++) {
                    n.cells[i] = z(n.cells[i], n.header.length);
                  }

                  return n;
                }
              }
            }, e.hr = function (t) {
              var e = this.rules.block.hr.exec(t);
              if (e) return {
                type: "hr",
                raw: e[0]
              };
            }, e.blockquote = function (t) {
              var e = this.rules.block.blockquote.exec(t);

              if (e) {
                var n = e[0].replace(/^ *> ?/gm, "");
                return {
                  type: "blockquote",
                  raw: e[0],
                  text: n
                };
              }
            }, e.list = function (t) {
              var e = this.rules.block.list.exec(t);

              if (e) {
                for (var n, i, o, r, s, a, c, l = e[0], d = e[2], h = d.length > 1, u = ")" === d[d.length - 1], g = {
                  type: "list",
                  raw: l,
                  ordered: h,
                  start: h ? +d.slice(0, -1) : "",
                  loose: !1,
                  items: []
                }, m = e[0].match(this.rules.block.item), p = !1, f = m.length, k = 0; k < f; k++) {
                  l = n = m[k], i = n.length, ~(n = n.replace(/^ *([*+-]|\d+[.)]) */, "")).indexOf("\n ") && (i -= n.length, n = this.options.pedantic ? n.replace(/^ {1,4}/gm, "") : n.replace(new RegExp("^ {1," + i + "}", "gm"), "")), k !== f - 1 && (o = this.rules.block.bullet.exec(m[k + 1])[0], (h ? 1 === o.length || !u && ")" === o[o.length - 1] : o.length > 1 || this.options.smartLists && o !== d) && (r = m.slice(k + 1).join("\n"), g.raw = g.raw.substring(0, g.raw.length - r.length), k = f - 1)), s = p || /\n\n(?!\s*$)/.test(n), k !== f - 1 && (p = "\n" === n.charAt(n.length - 1), s || (s = p)), s && (g.loose = !0), c = void 0, (a = /^\[[ xX]\] /.test(n)) && (c = " " !== n[1], n = n.replace(/^\[[ xX]\] +/, "")), g.items.push({
                    type: "list_item",
                    raw: l,
                    task: a,
                    checked: c,
                    loose: s,
                    text: n
                  });
                }

                return g;
              }
            }, e.html = function (t) {
              var e = this.rules.block.html.exec(t);
              if (e) return {
                type: this.options.sanitize ? "paragraph" : "html",
                raw: e[0],
                pre: !this.options.sanitizer && ("pre" === e[1] || "script" === e[1] || "style" === e[1]),
                text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(e[0]) : P(e[0]) : e[0]
              };
            }, e.def = function (t) {
              var e = this.rules.block.def.exec(t);
              if (e) return e[3] && (e[3] = e[3].substring(1, e[3].length - 1)), {
                tag: e[1].toLowerCase().replace(/\s+/g, " "),
                raw: e[0],
                href: e[2],
                title: e[3]
              };
            }, e.table = function (t) {
              var e = this.rules.block.table.exec(t);

              if (e) {
                var n = {
                  type: "table",
                  header: z(e[1].replace(/^ *| *\| *$/g, "")),
                  align: e[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                  cells: e[3] ? e[3].replace(/\n$/, "").split("\n") : []
                };

                if (n.header.length === n.align.length) {
                  n.raw = e[0];
                  var i,
                      o = n.align.length;

                  for (i = 0; i < o; i++) {
                    /^ *-+: *$/.test(n.align[i]) ? n.align[i] = "right" : /^ *:-+: *$/.test(n.align[i]) ? n.align[i] = "center" : /^ *:-+ *$/.test(n.align[i]) ? n.align[i] = "left" : n.align[i] = null;
                  }

                  for (o = n.cells.length, i = 0; i < o; i++) {
                    n.cells[i] = z(n.cells[i].replace(/^ *\| *| *\| *$/g, ""), n.header.length);
                  }

                  return n;
                }
              }
            }, e.lheading = function (t) {
              var e = this.rules.block.lheading.exec(t);
              if (e) return {
                type: "heading",
                raw: e[0],
                depth: "=" === e[2].charAt(0) ? 1 : 2,
                text: e[1]
              };
            }, e.paragraph = function (t) {
              var e = this.rules.block.paragraph.exec(t);
              if (e) return {
                type: "paragraph",
                raw: e[0],
                text: "\n" === e[1].charAt(e[1].length - 1) ? e[1].slice(0, -1) : e[1]
              };
            }, e.text = function (t, e) {
              var n = this.rules.block.text.exec(t);

              if (n) {
                var i = e[e.length - 1];
                return i && "text" === i.type ? {
                  raw: n[0],
                  text: n[0]
                } : {
                  type: "text",
                  raw: n[0],
                  text: n[0]
                };
              }
            }, e.escape = function (t) {
              var e = this.rules.inline.escape.exec(t);
              if (e) return {
                type: "escape",
                raw: e[0],
                text: P(e[1])
              };
            }, e.tag = function (t, e, n) {
              var i = this.rules.inline.tag.exec(t);
              if (i) return !e && /^<a /i.test(i[0]) ? e = !0 : e && /^<\/a>/i.test(i[0]) && (e = !1), !n && /^<(pre|code|kbd|script)(\s|>)/i.test(i[0]) ? n = !0 : n && /^<\/(pre|code|kbd|script)(\s|>)/i.test(i[0]) && (n = !1), {
                type: this.options.sanitize ? "text" : "html",
                raw: i[0],
                inLink: e,
                inRawBlock: n,
                text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(i[0]) : P(i[0]) : i[0]
              };
            }, e.link = function (t) {
              var e = this.rules.inline.link.exec(t);

              if (e) {
                var n = L(e[2], "()");

                if (n > -1) {
                  var i = (0 === e[0].indexOf("!") ? 5 : 4) + e[1].length + n;
                  e[2] = e[2].substring(0, n), e[0] = e[0].substring(0, i).trim(), e[3] = "";
                }

                var o = e[2],
                    r = "";

                if (this.options.pedantic) {
                  var s = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(o);
                  s ? (o = s[1], r = s[3]) : r = "";
                } else r = e[3] ? e[3].slice(1, -1) : "";

                return R(e, {
                  href: (o = o.trim().replace(/^<([\s\S]*)>$/, "$1")) ? o.replace(this.rules.inline._escapes, "$1") : o,
                  title: r ? r.replace(this.rules.inline._escapes, "$1") : r
                }, e[0]);
              }
            }, e.reflink = function (t, e) {
              var n;

              if ((n = this.rules.inline.reflink.exec(t)) || (n = this.rules.inline.nolink.exec(t))) {
                var i = (n[2] || n[1]).replace(/\s+/g, " ");

                if (!(i = e[i.toLowerCase()]) || !i.href) {
                  var o = n[0].charAt(0);
                  return {
                    type: "text",
                    raw: o,
                    text: o
                  };
                }

                return R(n, i, n[0]);
              }
            }, e.strong = function (t, e, n) {
              void 0 === n && (n = "");
              var i = this.rules.inline.strong.start.exec(t);

              if (i && (!i[1] || i[1] && ("" === n || this.rules.inline.punctuation.exec(n)))) {
                e = e.slice(-1 * t.length);
                var o,
                    r = "**" === i[0] ? this.rules.inline.strong.endAst : this.rules.inline.strong.endUnd;

                for (r.lastIndex = 0; null != (i = r.exec(e));) {
                  if (o = this.rules.inline.strong.middle.exec(e.slice(0, i.index + 3))) return {
                    type: "strong",
                    raw: t.slice(0, o[0].length),
                    text: t.slice(2, o[0].length - 2)
                  };
                }
              }
            }, e.em = function (t, e, n) {
              void 0 === n && (n = "");
              var i = this.rules.inline.em.start.exec(t);

              if (i && (!i[1] || i[1] && ("" === n || this.rules.inline.punctuation.exec(n)))) {
                e = e.slice(-1 * t.length);
                var o,
                    r = "*" === i[0] ? this.rules.inline.em.endAst : this.rules.inline.em.endUnd;

                for (r.lastIndex = 0; null != (i = r.exec(e));) {
                  if (o = this.rules.inline.em.middle.exec(e.slice(0, i.index + 2))) return {
                    type: "em",
                    raw: t.slice(0, o[0].length),
                    text: t.slice(1, o[0].length - 1)
                  };
                }
              }
            }, e.codespan = function (t) {
              var e = this.rules.inline.code.exec(t);

              if (e) {
                var n = e[2].replace(/\n/g, " "),
                    i = /[^ ]/.test(n),
                    o = n.startsWith(" ") && n.endsWith(" ");
                return i && o && (n = n.substring(1, n.length - 1)), n = P(n, !0), {
                  type: "codespan",
                  raw: e[0],
                  text: n
                };
              }
            }, e.br = function (t) {
              var e = this.rules.inline.br.exec(t);
              if (e) return {
                type: "br",
                raw: e[0]
              };
            }, e.del = function (t) {
              var e = this.rules.inline.del.exec(t);
              if (e) return {
                type: "del",
                raw: e[0],
                text: e[1]
              };
            }, e.autolink = function (t, e) {
              var n,
                  i,
                  o = this.rules.inline.autolink.exec(t);
              if (o) return i = "@" === o[2] ? "mailto:" + (n = P(this.options.mangle ? e(o[1]) : o[1])) : n = P(o[1]), {
                type: "link",
                raw: o[0],
                text: n,
                href: i,
                tokens: [{
                  type: "text",
                  raw: n,
                  text: n
                }]
              };
            }, e.url = function (t, e) {
              var n;

              if (n = this.rules.inline.url.exec(t)) {
                var i, o;
                if ("@" === n[2]) o = "mailto:" + (i = P(this.options.mangle ? e(n[0]) : n[0]));else {
                  var r;

                  do {
                    r = n[0], n[0] = this.rules.inline._backpedal.exec(n[0])[0];
                  } while (r !== n[0]);

                  i = P(n[0]), o = "www." === n[1] ? "http://" + i : i;
                }
                return {
                  type: "link",
                  raw: n[0],
                  text: i,
                  href: o,
                  tokens: [{
                    type: "text",
                    raw: i,
                    text: i
                  }]
                };
              }
            }, e.inlineText = function (t, e, n) {
              var i,
                  o = this.rules.inline.text.exec(t);
              if (o) return i = e ? this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(o[0]) : P(o[0]) : o[0] : P(this.options.smartypants ? n(o[0]) : o[0]), {
                type: "text",
                raw: o[0],
                text: i
              };
            }, t;
          }(),
              F = T.noopTest,
              V = T.edit,
              U = T.merge,
              H = {
            newline: /^\n+/,
            code: /^( {4}[^\n]+\n*)+/,
            fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?:\n+|$)|$)/,
            hr: /^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,
            heading: /^ {0,3}(#{1,6}) +([^\n]*?)(?: +#+)? *(?:\n+|$)/,
            blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
            list: /^( {0,3})(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
            html: "^ {0,3}(?:<(script|pre|style)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?\\?>\\n*|<![A-Z][\\s\\S]*?>\\n*|<!\\[CDATA\\[[\\s\\S]*?\\]\\]>\\n*|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:\\n{2,}|$)|<(?!script|pre|style)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:\\n{2,}|$)|</(?!script|pre|style)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:\\n{2,}|$))",
            def: /^ {0,3}\[(label)\]: *\n? *<?([^\s>]+)>?(?:(?: +\n? *| *\n *)(title))? *(?:\n+|$)/,
            nptable: F,
            table: F,
            lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
            _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html)[^\n]+)*)/,
            text: /^[^\n]+/,
            _label: /(?!\s*\])(?:\\[\[\]]|[^\[\]])+/,
            _title: /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/
          };

          H.def = V(H.def).replace("label", H._label).replace("title", H._title).getRegex(), H.bullet = /(?:[*+-]|\d{1,9}[.)])/, H.item = /^( *)(bull) ?[^\n]*(?:\n(?!\1bull ?)[^\n]*)*/, H.item = V(H.item, "gm").replace(/bull/g, H.bullet).getRegex(), H.list = V(H.list).replace(/bull/g, H.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + H.def.source + ")").getRegex(), H._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", H._comment = /<!--(?!-?>)[\s\S]*?-->/, H.html = V(H.html, "i").replace("comment", H._comment).replace("tag", H._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), H.paragraph = V(H._paragraph).replace("hr", H.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|!--)").replace("tag", H._tag).getRegex(), H.blockquote = V(H.blockquote).replace("paragraph", H.paragraph).getRegex(), H.normal = U({}, H), H.gfm = U({}, H.normal, {
            nptable: "^ *([^|\\n ].*\\|.*)\\n *([-:]+ *\\|[-| :]*)(?:\\n((?:(?!\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)",
            table: "^ *\\|(.+)\\n *\\|?( *[-:]+[-| :]*)(?:\\n *((?:(?!\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
          }), H.gfm.nptable = V(H.gfm.nptable).replace("hr", H.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|!--)").replace("tag", H._tag).getRegex(), H.gfm.table = V(H.gfm.table).replace("hr", H.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|!--)").replace("tag", H._tag).getRegex(), H.pedantic = U({}, H.normal, {
            html: V("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", H._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
            def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
            heading: /^ *(#{1,6}) *([^\n]+?) *(?:#+ *)?(?:\n+|$)/,
            fences: F,
            paragraph: V(H.normal._paragraph).replace("hr", H.hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", H.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
          });
          var q = {
            escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
            autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
            url: F,
            tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
            link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
            reflink: /^!?\[(label)\]\[(?!\s*\])((?:\\[\[\]]?|[^\[\]\\])+)\]/,
            nolink: /^!?\[(?!\s*\])((?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]])*)\](?:\[\])?/,
            reflinkSearch: "reflink|nolink(?!\\()",
            strong: {
              start: /^(?:(\*\*(?=[*punctuation]))|\*\*)(?![\s])|__/,
              middle: /^\*\*(?:(?:(?!overlapSkip)(?:[^*]|\\\*)|overlapSkip)|\*(?:(?!overlapSkip)(?:[^*]|\\\*)|overlapSkip)*?\*)+?\*\*$|^__(?![\s])((?:(?:(?!overlapSkip)(?:[^_]|\\_)|overlapSkip)|_(?:(?!overlapSkip)(?:[^_]|\\_)|overlapSkip)*?_)+?)__$/,
              endAst: /[^punctuation\s]\*\*(?!\*)|[punctuation]\*\*(?!\*)(?:(?=[punctuation\s]|$))/,
              endUnd: /[^\s]__(?!_)(?:(?=[punctuation\s])|$)/
            },
            em: {
              start: /^(?:(\*(?=[punctuation]))|\*)(?![*\s])|_/,
              middle: /^\*(?:(?:(?!overlapSkip)(?:[^*]|\\\*)|overlapSkip)|\*(?:(?!overlapSkip)(?:[^*]|\\\*)|overlapSkip)*?\*)+?\*$|^_(?![_\s])(?:(?:(?!overlapSkip)(?:[^_]|\\_)|overlapSkip)|_(?:(?!overlapSkip)(?:[^_]|\\_)|overlapSkip)*?_)+?_$/,
              endAst: /[^punctuation\s]\*(?!\*)|[punctuation]\*(?!\*)(?:(?=[punctuation\s]|$))/,
              endUnd: /[^\s]_(?!_)(?:(?=[punctuation\s])|$)/
            },
            code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
            br: /^( {2,}|\\)\n(?!\s*$)/,
            del: F,
            text: /^(`+|[^`])(?:[\s\S]*?(?:(?=[\\<!\[`*]|\b_|$)|[^ ](?= {2,}\n))|(?= {2,}\n))/,
            punctuation: /^([\s*punctuation])/,
            _punctuation: "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~"
          };
          q.punctuation = V(q.punctuation).replace(/punctuation/g, q._punctuation).getRegex(), q._blockSkip = "\\[[^\\]]*?\\]\\([^\\)]*?\\)|`[^`]*?`|<[^>]*?>", q._overlapSkip = "__[^_]*?__|\\*\\*\\[^\\*\\]*?\\*\\*", q.em.start = V(q.em.start).replace(/punctuation/g, q._punctuation).getRegex(), q.em.middle = V(q.em.middle).replace(/punctuation/g, q._punctuation).replace(/overlapSkip/g, q._overlapSkip).getRegex(), q.em.endAst = V(q.em.endAst, "g").replace(/punctuation/g, q._punctuation).getRegex(), q.em.endUnd = V(q.em.endUnd, "g").replace(/punctuation/g, q._punctuation).getRegex(), q.strong.start = V(q.strong.start).replace(/punctuation/g, q._punctuation).getRegex(), q.strong.middle = V(q.strong.middle).replace(/punctuation/g, q._punctuation).replace(/blockSkip/g, q._blockSkip).getRegex(), q.strong.endAst = V(q.strong.endAst, "g").replace(/punctuation/g, q._punctuation).getRegex(), q.strong.endUnd = V(q.strong.endUnd, "g").replace(/punctuation/g, q._punctuation).getRegex(), q.blockSkip = V(q._blockSkip, "g").getRegex(), q.overlapSkip = V(q._overlapSkip, "g").getRegex(), q._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g, q._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/, q._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/, q.autolink = V(q.autolink).replace("scheme", q._scheme).replace("email", q._email).getRegex(), q._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/, q.tag = V(q.tag).replace("comment", H._comment).replace("attribute", q._attribute).getRegex(), q._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, q._href = /<(?:\\[<>]?|[^\s<>\\])*>|[^\s\x00-\x1f]*/, q._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/, q.link = V(q.link).replace("label", q._label).replace("href", q._href).replace("title", q._title).getRegex(), q.reflink = V(q.reflink).replace("label", q._label).getRegex(), q.reflinkSearch = V(q.reflinkSearch, "g").replace("reflink", q.reflink).replace("nolink", q.nolink).getRegex(), q.normal = U({}, q), q.pedantic = U({}, q.normal, {
            strong: {
              start: /^__|\*\*/,
              middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
              endAst: /\*\*(?!\*)/g,
              endUnd: /__(?!_)/g
            },
            em: {
              start: /^_|\*/,
              middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
              endAst: /\*(?!\*)/g,
              endUnd: /_(?!_)/g
            },
            link: V(/^!?\[(label)\]\((.*?)\)/).replace("label", q._label).getRegex(),
            reflink: V(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", q._label).getRegex()
          }), q.gfm = U({}, q.normal, {
            escape: V(q.escape).replace("])", "~|])").getRegex(),
            _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
            url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
            _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
            del: /^~+(?=\S)([\s\S]*?\S)~+/,
            text: /^(`+|[^`])(?:[\s\S]*?(?:(?=[\\<!\[`*~]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@))|(?= {2,}\n|[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@))/
          }), q.gfm.url = V(q.gfm.url, "i").replace("email", q.gfm._extended_email).getRegex(), q.breaks = U({}, q.gfm, {
            br: V(q.br).replace("{2,}", "*").getRegex(),
            text: V(q.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
          });
          var W = {
            block: H,
            inline: q
          },
              G = s.defaults,
              $ = W.block,
              Y = W.inline;

          function K(t) {
            return t.replace(/---/g, "—").replace(/--/g, "–").replace(/(^|[-\u2014/(\[{"\s])'/g, "$1‘").replace(/'/g, "’").replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1“").replace(/"/g, "”").replace(/\.{3}/g, "…");
          }

          function Q(t) {
            var e,
                n,
                i = "",
                o = t.length;

            for (e = 0; e < o; e++) {
              n = t.charCodeAt(e), Math.random() > .5 && (n = "x" + n.toString(16)), i += "&#" + n + ";";
            }

            return i;
          }

          var Z = function () {
            function t(t) {
              this.tokens = [], this.tokens.links = Object.create(null), this.options = t || G, this.options.tokenizer = this.options.tokenizer || new j(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options;
              var e = {
                block: $.normal,
                inline: Y.normal
              };
              this.options.pedantic ? (e.block = $.pedantic, e.inline = Y.pedantic) : this.options.gfm && (e.block = $.gfm, this.options.breaks ? e.inline = Y.breaks : e.inline = Y.gfm), this.tokenizer.rules = e;
            }

            t.lex = function (e, n) {
              return new t(n).lex(e);
            };

            var n = t.prototype;
            return n.lex = function (t) {
              return t = t.replace(/\r\n|\r/g, "\n").replace(/\t/g, "    "), this.blockTokens(t, this.tokens, !0), this.inline(this.tokens), this.tokens;
            }, n.blockTokens = function (t, e, n) {
              var i, o, r, s;

              for (void 0 === e && (e = []), void 0 === n && (n = !0), t = t.replace(/^ +$/gm, ""); t;) {
                if (i = this.tokenizer.space(t)) t = t.substring(i.raw.length), i.type && e.push(i);else if (i = this.tokenizer.code(t, e)) t = t.substring(i.raw.length), i.type ? e.push(i) : ((s = e[e.length - 1]).raw += "\n" + i.raw, s.text += "\n" + i.text);else if (i = this.tokenizer.fences(t)) t = t.substring(i.raw.length), e.push(i);else if (i = this.tokenizer.heading(t)) t = t.substring(i.raw.length), e.push(i);else if (i = this.tokenizer.nptable(t)) t = t.substring(i.raw.length), e.push(i);else if (i = this.tokenizer.hr(t)) t = t.substring(i.raw.length), e.push(i);else if (i = this.tokenizer.blockquote(t)) t = t.substring(i.raw.length), i.tokens = this.blockTokens(i.text, [], n), e.push(i);else if (i = this.tokenizer.list(t)) {
                  for (t = t.substring(i.raw.length), r = i.items.length, o = 0; o < r; o++) {
                    i.items[o].tokens = this.blockTokens(i.items[o].text, [], !1);
                  }

                  e.push(i);
                } else if (i = this.tokenizer.html(t)) t = t.substring(i.raw.length), e.push(i);else if (n && (i = this.tokenizer.def(t))) t = t.substring(i.raw.length), this.tokens.links[i.tag] || (this.tokens.links[i.tag] = {
                  href: i.href,
                  title: i.title
                });else if (i = this.tokenizer.table(t)) t = t.substring(i.raw.length), e.push(i);else if (i = this.tokenizer.lheading(t)) t = t.substring(i.raw.length), e.push(i);else if (n && (i = this.tokenizer.paragraph(t))) t = t.substring(i.raw.length), e.push(i);else if (i = this.tokenizer.text(t, e)) t = t.substring(i.raw.length), i.type ? e.push(i) : ((s = e[e.length - 1]).raw += "\n" + i.raw, s.text += "\n" + i.text);else if (t) {
                  var a = "Infinite loop on byte: " + t.charCodeAt(0);

                  if (this.options.silent) {
                    console.error(a);
                    break;
                  }

                  throw new Error(a);
                }
              }

              return e;
            }, n.inline = function (t) {
              var e,
                  n,
                  i,
                  o,
                  r,
                  s,
                  a = t.length;

              for (e = 0; e < a; e++) {
                switch ((s = t[e]).type) {
                  case "paragraph":
                  case "text":
                  case "heading":
                    s.tokens = [], this.inlineTokens(s.text, s.tokens);
                    break;

                  case "table":
                    for (s.tokens = {
                      header: [],
                      cells: []
                    }, o = s.header.length, n = 0; n < o; n++) {
                      s.tokens.header[n] = [], this.inlineTokens(s.header[n], s.tokens.header[n]);
                    }

                    for (o = s.cells.length, n = 0; n < o; n++) {
                      for (r = s.cells[n], s.tokens.cells[n] = [], i = 0; i < r.length; i++) {
                        s.tokens.cells[n][i] = [], this.inlineTokens(r[i], s.tokens.cells[n][i]);
                      }
                    }

                    break;

                  case "blockquote":
                    this.inline(s.tokens);
                    break;

                  case "list":
                    for (o = s.items.length, n = 0; n < o; n++) {
                      this.inline(s.items[n].tokens);
                    }

                }
              }

              return t;
            }, n.inlineTokens = function (t, e, n, i, o) {
              var r;
              void 0 === e && (e = []), void 0 === n && (n = !1), void 0 === i && (i = !1), void 0 === o && (o = "");
              var s,
                  a = t;

              if (this.tokens.links) {
                var c = Object.keys(this.tokens.links);
                if (c.length > 0) for (; null != (s = this.tokenizer.rules.inline.reflinkSearch.exec(a));) {
                  c.includes(s[0].slice(s[0].lastIndexOf("[") + 1, -1)) && (a = a.slice(0, s.index) + "[" + "a".repeat(s[0].length - 2) + "]" + a.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
                }
              }

              for (; null != (s = this.tokenizer.rules.inline.blockSkip.exec(a));) {
                a = a.slice(0, s.index) + "[" + "a".repeat(s[0].length - 2) + "]" + a.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
              }

              for (; t;) {
                if (r = this.tokenizer.escape(t)) t = t.substring(r.raw.length), e.push(r);else if (r = this.tokenizer.tag(t, n, i)) t = t.substring(r.raw.length), n = r.inLink, i = r.inRawBlock, e.push(r);else if (r = this.tokenizer.link(t)) t = t.substring(r.raw.length), "link" === r.type && (r.tokens = this.inlineTokens(r.text, [], !0, i)), e.push(r);else if (r = this.tokenizer.reflink(t, this.tokens.links)) t = t.substring(r.raw.length), "link" === r.type && (r.tokens = this.inlineTokens(r.text, [], !0, i)), e.push(r);else if (r = this.tokenizer.strong(t, a, o)) t = t.substring(r.raw.length), r.tokens = this.inlineTokens(r.text, [], n, i), e.push(r);else if (r = this.tokenizer.em(t, a, o)) t = t.substring(r.raw.length), r.tokens = this.inlineTokens(r.text, [], n, i), e.push(r);else if (r = this.tokenizer.codespan(t)) t = t.substring(r.raw.length), e.push(r);else if (r = this.tokenizer.br(t)) t = t.substring(r.raw.length), e.push(r);else if (r = this.tokenizer.del(t)) t = t.substring(r.raw.length), r.tokens = this.inlineTokens(r.text, [], n, i), e.push(r);else if (r = this.tokenizer.autolink(t, Q)) t = t.substring(r.raw.length), e.push(r);else if (n || !(r = this.tokenizer.url(t, Q))) {
                  if (r = this.tokenizer.inlineText(t, i, K)) t = t.substring(r.raw.length), o = r.raw.slice(-1), e.push(r);else if (t) {
                    var l = "Infinite loop on byte: " + t.charCodeAt(0);

                    if (this.options.silent) {
                      console.error(l);
                      break;
                    }

                    throw new Error(l);
                  }
                } else t = t.substring(r.raw.length), e.push(r);
              }

              return e;
            }, e(t, null, [{
              key: "rules",
              get: function get() {
                return {
                  block: $,
                  inline: Y
                };
              }
            }]), t;
          }(),
              J = s.defaults,
              X = T.cleanUrl,
              tt = T.escape,
              et = function () {
            function t(t) {
              this.options = t || J;
            }

            var e = t.prototype;
            return e.code = function (t, e, n) {
              var i = (e || "").match(/\S*/)[0];

              if (this.options.highlight) {
                var o = this.options.highlight(t, i);
                null != o && o !== t && (n = !0, t = o);
              }

              return i ? '<pre><code class="' + this.options.langPrefix + tt(i, !0) + '">' + (n ? t : tt(t, !0)) + "</code></pre>\n" : "<pre><code>" + (n ? t : tt(t, !0)) + "</code></pre>\n";
            }, e.blockquote = function (t) {
              return "<blockquote>\n" + t + "</blockquote>\n";
            }, e.html = function (t) {
              return t;
            }, e.heading = function (t, e, n, i) {
              return this.options.headerIds ? "<h" + e + ' id="' + this.options.headerPrefix + i.slug(n) + '">' + t + "</h" + e + ">\n" : "<h" + e + ">" + t + "</h" + e + ">\n";
            }, e.hr = function () {
              return this.options.xhtml ? "<hr/>\n" : "<hr>\n";
            }, e.list = function (t, e, n) {
              var i = e ? "ol" : "ul";
              return "<" + i + (e && 1 !== n ? ' start="' + n + '"' : "") + ">\n" + t + "</" + i + ">\n";
            }, e.listitem = function (t) {
              return "<li>" + t + "</li>\n";
            }, e.checkbox = function (t) {
              return "<input " + (t ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
            }, e.paragraph = function (t) {
              return "<p>" + t + "</p>\n";
            }, e.table = function (t, e) {
              return e && (e = "<tbody>" + e + "</tbody>"), "<table>\n<thead>\n" + t + "</thead>\n" + e + "</table>\n";
            }, e.tablerow = function (t) {
              return "<tr>\n" + t + "</tr>\n";
            }, e.tablecell = function (t, e) {
              var n = e.header ? "th" : "td";
              return (e.align ? "<" + n + ' align="' + e.align + '">' : "<" + n + ">") + t + "</" + n + ">\n";
            }, e.strong = function (t) {
              return "<strong>" + t + "</strong>";
            }, e.em = function (t) {
              return "<em>" + t + "</em>";
            }, e.codespan = function (t) {
              return "<code>" + t + "</code>";
            }, e.br = function () {
              return this.options.xhtml ? "<br/>" : "<br>";
            }, e.del = function (t) {
              return "<del>" + t + "</del>";
            }, e.link = function (t, e, n) {
              if (null === (t = X(this.options.sanitize, this.options.baseUrl, t))) return n;
              var i = '<a href="' + tt(t) + '"';
              return e && (i += ' title="' + e + '"'), i += ">" + n + "</a>";
            }, e.image = function (t, e, n) {
              if (null === (t = X(this.options.sanitize, this.options.baseUrl, t))) return n;
              var i = '<img src="' + t + '" alt="' + n + '"';
              return e && (i += ' title="' + e + '"'), i += this.options.xhtml ? "/>" : ">";
            }, e.text = function (t) {
              return t;
            }, t;
          }(),
              nt = function () {
            function t() {}

            var e = t.prototype;
            return e.strong = function (t) {
              return t;
            }, e.em = function (t) {
              return t;
            }, e.codespan = function (t) {
              return t;
            }, e.del = function (t) {
              return t;
            }, e.html = function (t) {
              return t;
            }, e.text = function (t) {
              return t;
            }, e.link = function (t, e, n) {
              return "" + n;
            }, e.image = function (t, e, n) {
              return "" + n;
            }, e.br = function () {
              return "";
            }, t;
          }(),
              it = function () {
            function t() {
              this.seen = {};
            }

            return t.prototype.slug = function (t) {
              var e = t.toLowerCase().trim().replace(/<[!\/a-z].*?>/gi, "").replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");

              if (this.seen.hasOwnProperty(e)) {
                var n = e;

                do {
                  this.seen[n]++, e = n + "-" + this.seen[n];
                } while (this.seen.hasOwnProperty(e));
              }

              return this.seen[e] = 0, e;
            }, t;
          }(),
              ot = s.defaults,
              rt = T.unescape,
              st = function () {
            function t(t) {
              this.options = t || ot, this.options.renderer = this.options.renderer || new et(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.textRenderer = new nt(), this.slugger = new it();
            }

            t.parse = function (e, n) {
              return new t(n).parse(e);
            };

            var e = t.prototype;
            return e.parse = function (t, e) {
              void 0 === e && (e = !0);
              var n,
                  i,
                  o,
                  r,
                  s,
                  a,
                  c,
                  l,
                  d,
                  h,
                  u,
                  g,
                  m,
                  p,
                  f,
                  k,
                  b,
                  w,
                  A = "",
                  C = t.length;

              for (n = 0; n < C; n++) {
                switch ((h = t[n]).type) {
                  case "space":
                    continue;

                  case "hr":
                    A += this.renderer.hr();
                    continue;

                  case "heading":
                    A += this.renderer.heading(this.parseInline(h.tokens), h.depth, rt(this.parseInline(h.tokens, this.textRenderer)), this.slugger);
                    continue;

                  case "code":
                    A += this.renderer.code(h.text, h.lang, h.escaped);
                    continue;

                  case "table":
                    for (l = "", c = "", r = h.header.length, i = 0; i < r; i++) {
                      c += this.renderer.tablecell(this.parseInline(h.tokens.header[i]), {
                        header: !0,
                        align: h.align[i]
                      });
                    }

                    for (l += this.renderer.tablerow(c), d = "", r = h.cells.length, i = 0; i < r; i++) {
                      for (c = "", s = (a = h.tokens.cells[i]).length, o = 0; o < s; o++) {
                        c += this.renderer.tablecell(this.parseInline(a[o]), {
                          header: !1,
                          align: h.align[o]
                        });
                      }

                      d += this.renderer.tablerow(c);
                    }

                    A += this.renderer.table(l, d);
                    continue;

                  case "blockquote":
                    d = this.parse(h.tokens), A += this.renderer.blockquote(d);
                    continue;

                  case "list":
                    for (u = h.ordered, g = h.start, m = h.loose, r = h.items.length, d = "", i = 0; i < r; i++) {
                      k = (f = h.items[i]).checked, b = f.task, p = "", f.task && (w = this.renderer.checkbox(k), m ? f.tokens.length > 0 && "text" === f.tokens[0].type ? (f.tokens[0].text = w + " " + f.tokens[0].text, f.tokens[0].tokens && f.tokens[0].tokens.length > 0 && "text" === f.tokens[0].tokens[0].type && (f.tokens[0].tokens[0].text = w + " " + f.tokens[0].tokens[0].text)) : f.tokens.unshift({
                        type: "text",
                        text: w
                      }) : p += w), p += this.parse(f.tokens, m), d += this.renderer.listitem(p, b, k);
                    }

                    A += this.renderer.list(d, u, g);
                    continue;

                  case "html":
                    A += this.renderer.html(h.text);
                    continue;

                  case "paragraph":
                    A += this.renderer.paragraph(this.parseInline(h.tokens));
                    continue;

                  case "text":
                    for (d = h.tokens ? this.parseInline(h.tokens) : h.text; n + 1 < C && "text" === t[n + 1].type;) {
                      d += "\n" + ((h = t[++n]).tokens ? this.parseInline(h.tokens) : h.text);
                    }

                    A += e ? this.renderer.paragraph(d) : d;
                    continue;

                  default:
                    var _ = 'Token with "' + h.type + '" type was not found.';

                    if (this.options.silent) return void console.error(_);
                    throw new Error(_);
                }
              }

              return A;
            }, e.parseInline = function (t, e) {
              e = e || this.renderer;
              var n,
                  i,
                  o = "",
                  r = t.length;

              for (n = 0; n < r; n++) {
                switch ((i = t[n]).type) {
                  case "escape":
                  case "text":
                    o += e.text(i.text);
                    break;

                  case "html":
                    o += e.html(i.text);
                    break;

                  case "link":
                    o += e.link(i.href, i.title, this.parseInline(i.tokens, e));
                    break;

                  case "image":
                    o += e.image(i.href, i.title, i.text);
                    break;

                  case "strong":
                    o += e.strong(this.parseInline(i.tokens, e));
                    break;

                  case "em":
                    o += e.em(this.parseInline(i.tokens, e));
                    break;

                  case "codespan":
                    o += e.codespan(i.text);
                    break;

                  case "br":
                    o += e.br();
                    break;

                  case "del":
                    o += e.del(this.parseInline(i.tokens, e));
                    break;

                  default:
                    var s = 'Token with "' + i.type + '" type was not found.';
                    if (this.options.silent) return void console.error(s);
                    throw new Error(s);
                }
              }

              return o;
            }, t;
          }(),
              at = T.merge,
              ct = T.checkSanitizeDeprecation,
              lt = T.escape,
              dt = s.getDefaults,
              ht = s.changeDefaults,
              ut = s.defaults;

          function gt(t, e, n) {
            if (null == t) throw new Error("marked(): input parameter is undefined or null");
            if ("string" != typeof t) throw new Error("marked(): input parameter is of type " + Object.prototype.toString.call(t) + ", string expected");

            if ("function" == typeof e && (n = e, e = null), e = at({}, gt.defaults, e || {}), ct(e), n) {
              var i,
                  o = e.highlight;

              try {
                i = Z.lex(t, e);
              } catch (t) {
                return n(t);
              }

              var r = function r(t) {
                var r;
                if (!t) try {
                  r = st.parse(i, e);
                } catch (e) {
                  t = e;
                }
                return e.highlight = o, t ? n(t) : n(null, r);
              };

              if (!o || o.length < 3) return r();
              if (delete e.highlight, !i.length) return r();
              var s = 0;
              return gt.walkTokens(i, function (t) {
                "code" === t.type && (s++, setTimeout(function () {
                  o(t.text, t.lang, function (e, n) {
                    if (e) return r(e);
                    null != n && n !== t.text && (t.text = n, t.escaped = !0), 0 == --s && r();
                  });
                }, 0));
              }), void (0 === s && r());
            }

            try {
              var a = Z.lex(t, e);
              return e.walkTokens && gt.walkTokens(a, e.walkTokens), st.parse(a, e);
            } catch (t) {
              if (t.message += "\nPlease report this to https://github.com/markedjs/marked.", e.silent) return "<p>An error occurred:</p><pre>" + lt(t.message + "", !0) + "</pre>";
              throw t;
            }
          }

          return gt.options = gt.setOptions = function (t) {
            return at(gt.defaults, t), ht(gt.defaults), gt;
          }, gt.getDefaults = dt, gt.defaults = ut, gt.use = function (t) {
            var e = at({}, t);

            if (t.renderer && function () {
              var n = gt.defaults.renderer || new et(),
                  i = function i(e) {
                var i = n[e];

                n[e] = function () {
                  for (var o = arguments.length, r = new Array(o), s = 0; s < o; s++) {
                    r[s] = arguments[s];
                  }

                  var a = t.renderer[e].apply(n, r);
                  return !1 === a && (a = i.apply(n, r)), a;
                };
              };

              for (var o in t.renderer) {
                i(o);
              }

              e.renderer = n;
            }(), t.tokenizer && function () {
              var n = gt.defaults.tokenizer || new j(),
                  i = function i(e) {
                var i = n[e];

                n[e] = function () {
                  for (var o = arguments.length, r = new Array(o), s = 0; s < o; s++) {
                    r[s] = arguments[s];
                  }

                  var a = t.tokenizer[e].apply(n, r);
                  return !1 === a && (a = i.apply(n, r)), a;
                };
              };

              for (var o in t.tokenizer) {
                i(o);
              }

              e.tokenizer = n;
            }(), t.walkTokens) {
              var n = gt.defaults.walkTokens;

              e.walkTokens = function (e) {
                t.walkTokens(e), n && n(e);
              };
            }

            gt.setOptions(e);
          }, gt.walkTokens = function (t, e) {
            for (var n, i = o(t); !(n = i()).done;) {
              var r = n.value;

              switch (e(r), r.type) {
                case "table":
                  for (var s, a = o(r.tokens.header); !(s = a()).done;) {
                    var c = s.value;
                    gt.walkTokens(c, e);
                  }

                  for (var l, d = o(r.tokens.cells); !(l = d()).done;) {
                    for (var h, u = o(l.value); !(h = u()).done;) {
                      var g = h.value;
                      gt.walkTokens(g, e);
                    }
                  }

                  break;

                case "list":
                  gt.walkTokens(r.items, e);
                  break;

                default:
                  r.tokens && gt.walkTokens(r.tokens, e);
              }
            }
          }, gt.Parser = st, gt.parser = st.parse, gt.Renderer = et, gt.TextRenderer = nt, gt.Lexer = Z, gt.lexer = Z.lex, gt.Tokenizer = j, gt.Slugger = it, gt.parse = gt, gt;
        }();
      },
      5915: function _() {}
    },
        e = {};

    function n(i) {
      var o = e[i];
      if (void 0 !== o) return o.exports;
      var r = e[i] = {
        id: i,
        exports: {}
      };
      return t[i].call(r.exports, r, r.exports, n), r.exports;
    }

    n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, {
        a: e
      }), e;
    }, n.d = function (t, e) {
      for (var i in e) {
        n.o(e, i) && !n.o(t, i) && Object.defineProperty(t, i, {
          enumerable: !0,
          get: e[i]
        });
      }
    }, n.g = function () {
      if ("object" == typeof globalThis) return globalThis;

      try {
        return this || new Function("return this")();
      } catch (t) {
        if ("object" == typeof window) return window;
      }
    }(), n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    };
    var i = {};
    return function () {
      "use strict";

      var _marked = /*#__PURE__*/_regeneratorRuntime.mark(tl),
          _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(el),
          _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(ym);

      n.d(i, {
        default: function _default() {
          return Uv;
        }
      });

      var t = function t() {
        return function t() {
          t.called = !0;
        };
      };

      var e = /*#__PURE__*/_createClass(function e(_e2, n) {
        _classCallCheck(this, e);

        this.source = _e2, this.name = n, this.path = [], this.stop = t(), this.off = t();
      });

      var o = new Array(256).fill().map(function (t, e) {
        return ("0" + e.toString(16)).slice(-2);
      });

      function r() {
        var t = 4294967296 * Math.random() >>> 0,
            e = 4294967296 * Math.random() >>> 0,
            n = 4294967296 * Math.random() >>> 0,
            i = 4294967296 * Math.random() >>> 0;
        return "e" + o[t >> 0 & 255] + o[t >> 8 & 255] + o[t >> 16 & 255] + o[t >> 24 & 255] + o[e >> 0 & 255] + o[e >> 8 & 255] + o[e >> 16 & 255] + o[e >> 24 & 255] + o[n >> 0 & 255] + o[n >> 8 & 255] + o[n >> 16 & 255] + o[n >> 24 & 255] + o[i >> 0 & 255] + o[i >> 8 & 255] + o[i >> 16 & 255] + o[i >> 24 & 255];
      }

      var s = {
        get: function get(t) {
          return "number" != typeof t ? this[t] || this.normal : t;
        },
        highest: 1e5,
        high: 1e3,
        normal: 0,
        low: -1e3,
        lowest: -1e5
      };

      var a = /*#__PURE__*/function (_Error) {
        _inherits(a, _Error);

        var _super = _createSuper(a);

        function a(t, e, n) {
          var _this;

          _classCallCheck(this, a);

          _this = _super.call(this, function (t, e) {
            var n = new WeakSet(),
                i = function i(t, e) {
              if ("object" == typeof e && null !== e) {
                if (n.has(e)) return "[object ".concat(e.constructor.name, "]");
                n.add(e);
              }

              return e;
            },
                o = e ? " ".concat(JSON.stringify(e, i)) : "",
                r = l(t);

            return t + o + r;
          }(t, n)), _this.name = "CKEditorError", _this.context = e, _this.data = n;
          return _this;
        }

        _createClass(a, [{
          key: "is",
          value: function is(t) {
            return "CKEditorError" === t;
          }
        }], [{
          key: "rethrowUnexpectedError",
          value: function rethrowUnexpectedError(t, e) {
            if (t.is && t.is("CKEditorError")) throw t;
            var n = new a(t.message, e);
            throw n.stack = t.stack, n;
          }
        }]);

        return a;
      }( /*#__PURE__*/_wrapNativeSuper(Error));

      function c(t, e) {
        var _console;

        (_console = console).warn.apply(_console, _toConsumableArray(d(t, e)));
      }

      function l(t) {
        return "\nRead more: https://ckeditor.com/docs/ckeditor5/latest/framework/guides/support/error-codes.html#error-".concat(t);
      }

      function d(t, e) {
        var n = l(t);
        return e ? [t, e, n] : [t, n];
      }

      var h = "32.0.0";
      var u = "object" == typeof window ? window : n.g;
      if (u.CKEDITOR_VERSION) throw new a("ckeditor-duplicated-modules", null);
      u.CKEDITOR_VERSION = h;
      var g = Symbol("listeningTo"),
          m = Symbol("emitterId"),
          p = {
        on: function on(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          this.listenTo(this, t, e, n);
        },
        once: function once(t, e, n) {
          var i = !1;
          this.listenTo(this, t, function (t) {
            for (var _len = arguments.length, n = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              n[_key - 1] = arguments[_key];
            }

            i || (i = !0, t.off(), e.call.apply(e, [this, t].concat(n)));
          }, n);
        },
        off: function off(t, e) {
          this.stopListening(this, t, e);
        },
        listenTo: function listenTo(t, e, n) {
          var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
          var o, r;
          this[g] || (this[g] = {});
          var s = this[g];
          b(t) || k(t);
          var a = b(t);
          (o = s[a]) || (o = s[a] = {
            emitter: t,
            callbacks: {}
          }), (r = o.callbacks[e]) || (r = o.callbacks[e] = []), r.push(n), function (t, e, n, i, o) {
            e._addEventListener ? e._addEventListener(n, i, o) : t._addEventListener.call(e, n, i, o);
          }(this, t, e, n, i);
        },
        stopListening: function stopListening(t, e, n) {
          var i = this[g];
          var o = t && b(t);
          var r = i && o && i[o],
              s = r && e && r.callbacks[e];
          if (!(!i || t && !r || e && !s)) if (n) {
            v(this, t, e, n);
            -1 !== s.indexOf(n) && (1 === s.length ? delete r.callbacks[e] : v(this, t, e, n));
          } else if (s) {
            for (; n = s.pop();) {
              v(this, t, e, n);
            }

            delete r.callbacks[e];
          } else if (r) {
            for (e in r.callbacks) {
              this.stopListening(t, e);
            }

            delete i[o];
          } else {
            for (o in i) {
              this.stopListening(i[o].emitter);
            }

            delete this[g];
          }
        },
        fire: function fire(t) {
          try {
            var _i2 = t instanceof e ? t : new e(this, t),
                _o2 = _i2.name;

            var _r2 = C(this, _o2);

            for (var _len2 = arguments.length, n = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              n[_key2 - 1] = arguments[_key2];
            }

            if (_i2.path.push(this), _r2) {
              var _t2 = [_i2].concat(n);

              _r2 = Array.from(_r2);

              for (var _e3 = 0; _e3 < _r2.length && (_r2[_e3].callback.apply(this, _t2), _i2.off.called && (delete _i2.off.called, this._removeEventListener(_o2, _r2[_e3].callback)), !_i2.stop.called); _e3++) {
                ;
              }
            }

            if (this._delegations) {
              var _t3 = this._delegations.get(_o2),
                  _e4 = this._delegations.get("*");

              _t3 && _(_t3, _i2, n), _e4 && _(_e4, _i2, n);
            }

            return _i2.return;
          } catch (t) {
            a.rethrowUnexpectedError(t, this);
          }
        },
        delegate: function delegate() {
          var _this2 = this;

          for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            t[_key3] = arguments[_key3];
          }

          return {
            to: function to(e, n) {
              _this2._delegations || (_this2._delegations = new Map()), t.forEach(function (t) {
                var i = _this2._delegations.get(t);

                i ? i.set(e, n) : _this2._delegations.set(t, new Map([[e, n]]));
              });
            }
          };
        },
        stopDelegating: function stopDelegating(t, e) {
          if (this._delegations) if (t) {
            if (e) {
              var _n2 = this._delegations.get(t);

              _n2 && _n2.delete(e);
            } else this._delegations.delete(t);
          } else this._delegations.clear();
        },
        _addEventListener: function _addEventListener(t, e, n) {
          !function (t, e) {
            var n = w(t);
            if (n[e]) return;
            var i = e,
                o = null;
            var r = [];

            for (; "" !== i && !n[i];) {
              n[i] = {
                callbacks: [],
                childEvents: []
              }, r.push(n[i]), o && n[i].childEvents.push(o), o = i, i = i.substr(0, i.lastIndexOf(":"));
            }

            if ("" !== i) {
              var _iterator = _createForOfIteratorHelper(r),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var _t4 = _step.value;
                  _t4.callbacks = n[i].callbacks.slice();
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              n[i].childEvents.push(o);
            }
          }(this, t);
          var i = A(this, t),
              o = s.get(n.priority),
              r = {
            callback: e,
            priority: o
          };

          var _iterator2 = _createForOfIteratorHelper(i),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _t5 = _step2.value;

              var _e5 = !1;

              for (var _n3 = 0; _n3 < _t5.length; _n3++) {
                if (_t5[_n3].priority < o) {
                  _t5.splice(_n3, 0, r), _e5 = !0;
                  break;
                }
              }

              _e5 || _t5.push(r);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        },
        _removeEventListener: function _removeEventListener(t, e) {
          var n = A(this, t);

          var _iterator3 = _createForOfIteratorHelper(n),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _t6 = _step3.value;

              for (var _n4 = 0; _n4 < _t6.length; _n4++) {
                _t6[_n4].callback == e && (_t6.splice(_n4, 1), _n4--);
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      };
      var f = p;

      function k(t, e) {
        t[m] || (t[m] = e || r());
      }

      function b(t) {
        return t[m];
      }

      function w(t) {
        return t._events || Object.defineProperty(t, "_events", {
          value: {}
        }), t._events;
      }

      function A(t, e) {
        var n = w(t)[e];
        if (!n) return [];
        var i = [n.callbacks];

        for (var _e6 = 0; _e6 < n.childEvents.length; _e6++) {
          var _o3 = A(t, n.childEvents[_e6]);

          i = i.concat(_o3);
        }

        return i;
      }

      function C(t, e) {
        var n;
        return t._events && (n = t._events[e]) && n.callbacks.length ? n.callbacks : e.indexOf(":") > -1 ? C(t, e.substr(0, e.lastIndexOf(":"))) : null;
      }

      function _(t, n, i) {
        var _iterator4 = _createForOfIteratorHelper(t),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _step4$value = _slicedToArray(_step4.value, 2),
                _o4 = _step4$value[0],
                _r3 = _step4$value[1];

            _r3 ? "function" == typeof _r3 && (_r3 = _r3(n.name)) : _r3 = n.name;

            var _t7 = new e(n.source, _r3);

            _t7.path = _toConsumableArray(n.path), _o4.fire.apply(_o4, [_t7].concat(_toConsumableArray(i)));
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }

      function v(t, e, n, i) {
        e._removeEventListener ? e._removeEventListener(n, i) : t._removeEventListener.call(e, n, i);
      }

      var y = function y(t) {
        var e = typeof t;
        return null != t && ("object" == e || "function" == e);
      },
          x = "object" == typeof global && global && global.Object === Object && global,
          E = "object" == typeof self && self && self.Object === Object && self,
          D = x || E || Function("return this")(),
          S = D.Symbol,
          I = Object.prototype,
          M = I.hasOwnProperty,
          T = I.toString,
          N = S ? S.toStringTag : void 0;

      var B = function B(t) {
        var e = M.call(t, N),
            n = t[N];

        try {
          t[N] = void 0;
          var i = !0;
        } catch (t) {}

        var o = T.call(t);
        return i && (e ? t[N] = n : delete t[N]), o;
      },
          z = Object.prototype.toString;

      var P = function P(t) {
        return z.call(t);
      },
          L = S ? S.toStringTag : void 0;

      var R = function R(t) {
        return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : L && L in Object(t) ? B(t) : P(t);
      };

      var O = function O(t) {
        if (!y(t)) return !1;
        var e = R(t);
        return "[object Function]" == e || "[object GeneratorFunction]" == e || "[object AsyncFunction]" == e || "[object Proxy]" == e;
      },
          j = D["__core-js_shared__"],
          F = function () {
        var t = /[^.]+$/.exec(j && j.keys && j.keys.IE_PROTO || "");
        return t ? "Symbol(src)_1." + t : "";
      }();

      var V = function V(t) {
        return !!F && F in t;
      },
          U = Function.prototype.toString;

      var H = function H(t) {
        if (null != t) {
          try {
            return U.call(t);
          } catch (t) {}

          try {
            return t + "";
          } catch (t) {}
        }

        return "";
      },
          q = /^\[object .+?Constructor\]$/,
          W = Function.prototype,
          G = Object.prototype,
          $ = W.toString,
          Y = G.hasOwnProperty,
          K = RegExp("^" + $.call(Y).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

      var Q = function Q(t) {
        return !(!y(t) || V(t)) && (O(t) ? K : q).test(H(t));
      };

      var Z = function Z(t, e) {
        return null == t ? void 0 : t[e];
      };

      var J = function J(t, e) {
        var n = Z(t, e);
        return Q(n) ? n : void 0;
      },
          X = function () {
        try {
          var t = J(Object, "defineProperty");
          return t({}, "", {}), t;
        } catch (t) {}
      }();

      var tt = function tt(t, e, n) {
        "__proto__" == e && X ? X(t, e, {
          configurable: !0,
          enumerable: !0,
          value: n,
          writable: !0
        }) : t[e] = n;
      };

      var et = function et(t, e) {
        return t === e || t != t && e != e;
      },
          nt = Object.prototype.hasOwnProperty;

      var it = function it(t, e, n) {
        var i = t[e];
        nt.call(t, e) && et(i, n) && (void 0 !== n || e in t) || tt(t, e, n);
      };

      var ot = function ot(t, e, n, i) {
        var o = !n;
        n || (n = {});

        for (var r = -1, s = e.length; ++r < s;) {
          var a = e[r],
              c = i ? i(n[a], t[a], a, n, t) : void 0;
          void 0 === c && (c = t[a]), o ? tt(n, a, c) : it(n, a, c);
        }

        return n;
      };

      var rt = function rt(t) {
        return t;
      };

      var st = function st(t, e, n) {
        switch (n.length) {
          case 0:
            return t.call(e);

          case 1:
            return t.call(e, n[0]);

          case 2:
            return t.call(e, n[0], n[1]);

          case 3:
            return t.call(e, n[0], n[1], n[2]);
        }

        return t.apply(e, n);
      },
          at = Math.max;

      var ct = function ct(t, e, n) {
        return e = at(void 0 === e ? t.length - 1 : e, 0), function () {
          for (var i = arguments, o = -1, r = at(i.length - e, 0), s = Array(r); ++o < r;) {
            s[o] = i[e + o];
          }

          o = -1;

          for (var a = Array(e + 1); ++o < e;) {
            a[o] = i[o];
          }

          return a[e] = n(s), st(t, this, a);
        };
      };

      var lt = function lt(t) {
        return function () {
          return t;
        };
      },
          dt = X ? function (t, e) {
        return X(t, "toString", {
          configurable: !0,
          enumerable: !1,
          value: lt(e),
          writable: !0
        });
      } : rt,
          ht = Date.now;

      var ut = function ut(t) {
        var e = 0,
            n = 0;
        return function () {
          var i = ht(),
              o = 16 - (i - n);

          if (n = i, o > 0) {
            if (++e >= 800) return arguments[0];
          } else e = 0;

          return t.apply(void 0, arguments);
        };
      },
          gt = ut(dt);

      var mt = function mt(t, e) {
        return gt(ct(t, e, rt), t + "");
      };

      var pt = function pt(t) {
        return "number" == typeof t && t > -1 && t % 1 == 0 && t <= 9007199254740991;
      };

      var ft = function ft(t) {
        return null != t && pt(t.length) && !O(t);
      },
          kt = /^(?:0|[1-9]\d*)$/;

      var bt = function bt(t, e) {
        var n = typeof t;
        return !!(e = null == e ? 9007199254740991 : e) && ("number" == n || "symbol" != n && kt.test(t)) && t > -1 && t % 1 == 0 && t < e;
      };

      var wt = function wt(t, e, n) {
        if (!y(n)) return !1;
        var i = typeof e;
        return !!("number" == i ? ft(n) && bt(e, n.length) : "string" == i && e in n) && et(n[e], t);
      };

      var At = function At(t) {
        return mt(function (e, n) {
          var i = -1,
              o = n.length,
              r = o > 1 ? n[o - 1] : void 0,
              s = o > 2 ? n[2] : void 0;

          for (r = t.length > 3 && "function" == typeof r ? (o--, r) : void 0, s && wt(n[0], n[1], s) && (r = o < 3 ? void 0 : r, o = 1), e = Object(e); ++i < o;) {
            var a = n[i];
            a && t(e, a, i, r);
          }

          return e;
        });
      };

      var Ct = function Ct(t, e) {
        for (var n = -1, i = Array(t); ++n < t;) {
          i[n] = e(n);
        }

        return i;
      };

      var _t = function _t(t) {
        return null != t && "object" == typeof t;
      };

      var vt = function vt(t) {
        return _t(t) && "[object Arguments]" == R(t);
      },
          yt = Object.prototype,
          xt = yt.hasOwnProperty,
          Et = yt.propertyIsEnumerable,
          Dt = vt(function () {
        return arguments;
      }()) ? vt : function (t) {
        return _t(t) && xt.call(t, "callee") && !Et.call(t, "callee");
      },
          St = Dt,
          It = Array.isArray;

      var Mt = function Mt() {
        return !1;
      },
          Tt = "object" == typeof exports && exports && !exports.nodeType && exports,
          Nt = Tt && "object" == typeof module && module && !module.nodeType && module,
          Bt = Nt && Nt.exports === Tt ? D.Buffer : void 0,
          zt = (Bt ? Bt.isBuffer : void 0) || Mt,
          Pt = {};

      Pt["[object Float32Array]"] = Pt["[object Float64Array]"] = Pt["[object Int8Array]"] = Pt["[object Int16Array]"] = Pt["[object Int32Array]"] = Pt["[object Uint8Array]"] = Pt["[object Uint8ClampedArray]"] = Pt["[object Uint16Array]"] = Pt["[object Uint32Array]"] = !0, Pt["[object Arguments]"] = Pt["[object Array]"] = Pt["[object ArrayBuffer]"] = Pt["[object Boolean]"] = Pt["[object DataView]"] = Pt["[object Date]"] = Pt["[object Error]"] = Pt["[object Function]"] = Pt["[object Map]"] = Pt["[object Number]"] = Pt["[object Object]"] = Pt["[object RegExp]"] = Pt["[object Set]"] = Pt["[object String]"] = Pt["[object WeakMap]"] = !1;

      var Lt = function Lt(t) {
        return _t(t) && pt(t.length) && !!Pt[R(t)];
      };

      var Rt = function Rt(t) {
        return function (e) {
          return t(e);
        };
      },
          Ot = "object" == typeof exports && exports && !exports.nodeType && exports,
          jt = Ot && "object" == typeof module && module && !module.nodeType && module,
          Ft = jt && jt.exports === Ot && x.process,
          Vt = function () {
        try {
          var t = jt && jt.require && jt.require("util").types;

          return t || Ft && Ft.binding && Ft.binding("util");
        } catch (t) {}
      }(),
          Ut = Vt && Vt.isTypedArray,
          Ht = Ut ? Rt(Ut) : Lt,
          qt = Object.prototype.hasOwnProperty;

      var Wt = function Wt(t, e) {
        var n = It(t),
            i = !n && St(t),
            o = !n && !i && zt(t),
            r = !n && !i && !o && Ht(t),
            s = n || i || o || r,
            a = s ? Ct(t.length, String) : [],
            c = a.length;

        for (var l in t) {
          !e && !qt.call(t, l) || s && ("length" == l || o && ("offset" == l || "parent" == l) || r && ("buffer" == l || "byteLength" == l || "byteOffset" == l) || bt(l, c)) || a.push(l);
        }

        return a;
      },
          Gt = Object.prototype;

      var $t = function $t(t) {
        var e = t && t.constructor;
        return t === ("function" == typeof e && e.prototype || Gt);
      };

      var Yt = function Yt(t) {
        var e = [];
        if (null != t) for (var n in Object(t)) {
          e.push(n);
        }
        return e;
      },
          Kt = Object.prototype.hasOwnProperty;

      var Qt = function Qt(t) {
        if (!y(t)) return Yt(t);
        var e = $t(t),
            n = [];

        for (var i in t) {
          ("constructor" != i || !e && Kt.call(t, i)) && n.push(i);
        }

        return n;
      };

      var Zt = function Zt(t) {
        return ft(t) ? Wt(t, !0) : Qt(t);
      },
          Jt = At(function (t, e) {
        ot(e, Zt(e), t);
      });

      var Xt = Symbol("observableProperties"),
          te = Symbol("boundObservables"),
          ee = Symbol("boundProperties"),
          ne = Symbol("decoratedMethods"),
          ie = Symbol("decoratedOriginal"),
          oe = {
        set: function set(t, e) {
          var _this3 = this;

          if (y(t)) return void Object.keys(t).forEach(function (e) {
            _this3.set(e, t[e]);
          }, this);
          se(this);
          var n = this[Xt];
          if (t in this && !n.has(t)) throw new a("observable-set-cannot-override", this);
          Object.defineProperty(this, t, {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return n.get(t);
            },
            set: function set(e) {
              var i = n.get(t);
              var o = this.fire("set:" + t, t, e, i);
              void 0 === o && (o = e), i === o && n.has(t) || (n.set(t, o), this.fire("change:" + t, t, o, i));
            }
          }), this[t] = e;
        },
        bind: function bind() {
          var _this4 = this;

          for (var _len4 = arguments.length, t = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            t[_key4] = arguments[_key4];
          }

          if (!t.length || !le(t)) throw new a("observable-bind-wrong-properties", this);
          if (new Set(t).size !== t.length) throw new a("observable-bind-duplicate-properties", this);
          se(this);
          var e = this[ee];
          t.forEach(function (t) {
            if (e.has(t)) throw new a("observable-bind-rebind", _this4);
          });
          var n = new Map();
          return t.forEach(function (t) {
            var i = {
              property: t,
              to: []
            };
            e.set(t, i), n.set(t, i);
          }), {
            to: ae,
            toMany: ce,
            _observable: this,
            _bindProperties: t,
            _to: [],
            _bindings: n
          };
        },
        unbind: function unbind() {
          var _this5 = this;

          if (!this[Xt]) return;
          var e = this[ee],
              n = this[te];

          for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            t[_key5] = arguments[_key5];
          }

          if (t.length) {
            if (!le(t)) throw new a("observable-unbind-wrong-properties", this);
            t.forEach(function (t) {
              var i = e.get(t);
              if (!i) return;
              var o, r, s, a;
              i.to.forEach(function (t) {
                o = t[0], r = t[1], s = n.get(o), a = s[r], a.delete(i), a.size || delete s[r], Object.keys(s).length || (n.delete(o), _this5.stopListening(o, "change"));
              }), e.delete(t);
            });
          } else n.forEach(function (t, e) {
            _this5.stopListening(e, "change");
          }), n.clear(), e.clear();
        },
        decorate: function decorate(t) {
          var _this6 = this;

          var e = this[t];
          if (!e) throw new a("observablemixin-cannot-decorate-undefined", this, {
            object: this,
            methodName: t
          });
          this.on(t, function (t, n) {
            t.return = e.apply(_this6, n);
          }), this[t] = function () {
            for (var _len6 = arguments.length, e = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
              e[_key6] = arguments[_key6];
            }

            return this.fire(t, e);
          }, this[t][ie] = e, this[ne] || (this[ne] = []), this[ne].push(t);
        }
      };
      Jt(oe, f), oe.stopListening = function (t, e, n) {
        if (!t && this[ne]) {
          var _iterator5 = _createForOfIteratorHelper(this[ne]),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _t8 = _step5.value;
              this[_t8] = this[_t8][ie];
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }

          delete this[ne];
        }

        f.stopListening.call(this, t, e, n);
      };
      var re = oe;

      function se(t) {
        t[Xt] || (Object.defineProperty(t, Xt, {
          value: new Map()
        }), Object.defineProperty(t, te, {
          value: new Map()
        }), Object.defineProperty(t, ee, {
          value: new Map()
        }));
      }

      function ae() {
        var _this7 = this;

        var e = function () {
          for (var _len7 = arguments.length, t = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            t[_key7] = arguments[_key7];
          }

          if (!t.length) throw new a("observable-bind-to-parse-error", null);
          var e = {
            to: []
          };
          var n;
          "function" == typeof t[t.length - 1] && (e.callback = t.pop());
          return t.forEach(function (t) {
            if ("string" == typeof t) n.properties.push(t);else {
              if ("object" != typeof t) throw new a("observable-bind-to-parse-error", null);
              n = {
                observable: t,
                properties: []
              }, e.to.push(n);
            }
          }), e;
        }.apply(void 0, arguments),
            n = Array.from(this._bindings.keys()),
            i = n.length;

        if (!e.callback && e.to.length > 1) throw new a("observable-bind-to-no-callback", this);
        if (i > 1 && e.callback) throw new a("observable-bind-to-extra-callback", this);
        var o;
        e.to.forEach(function (t) {
          if (t.properties.length && t.properties.length !== i) throw new a("observable-bind-to-properties-length", _this7);
          t.properties.length || (t.properties = _this7._bindProperties);
        }), this._to = e.to, e.callback && (this._bindings.get(n[0]).callback = e.callback), o = this._observable, this._to.forEach(function (t) {
          var e = o[te];
          var n;
          e.get(t.observable) || o.listenTo(t.observable, "change", function (i, r) {
            n = e.get(t.observable)[r], n && n.forEach(function (t) {
              de(o, t.property);
            });
          });
        }), function (t) {
          var e;

          t._bindings.forEach(function (n, i) {
            t._to.forEach(function (o) {
              e = o.properties[n.callback ? 0 : t._bindProperties.indexOf(i)], n.to.push([o.observable, e]), function (t, e, n, i) {
                var o = t[te],
                    r = o.get(n),
                    s = r || {};
                s[i] || (s[i] = new Set());
                s[i].add(e), r || o.set(n, s);
              }(t._observable, n, o.observable, e);
            });
          });
        }(this), this._bindProperties.forEach(function (t) {
          de(_this7._observable, t);
        });
      }

      function ce(t, e, n) {
        if (this._bindings.size > 1) throw new a("observable-bind-to-many-not-one-binding", this);
        this.to.apply(this, _toConsumableArray(function (t, e) {
          var n = t.map(function (t) {
            return [t, e];
          });
          return Array.prototype.concat.apply([], n);
        }(t, e)).concat([n]));
      }

      function le(t) {
        return t.every(function (t) {
          return "string" == typeof t;
        });
      }

      function de(t, e) {
        var n = t[ee].get(e);
        var i;
        n.callback ? i = n.callback.apply(t, n.to.map(function (t) {
          return t[0][t[1]];
        })) : (i = n.to[0], i = i[0][i[1]]), Object.prototype.hasOwnProperty.call(t, e) ? t[e] = i : t.set(e, i);
      }

      function he(t) {
        for (var _len8 = arguments.length, e = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
          e[_key8 - 1] = arguments[_key8];
        }

        e.forEach(function (e) {
          Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e)).forEach(function (n) {
            if (n in t.prototype) return;
            var i = Object.getOwnPropertyDescriptor(e, n);
            i.enumerable = !1, Object.defineProperty(t.prototype, n, i);
          });
        });
      }

      var ue = /*#__PURE__*/function () {
        function ue(t) {
          _classCallCheck(this, ue);

          this.editor = t, this.set("isEnabled", !0), this._disableStack = new Set();
        }

        _createClass(ue, [{
          key: "forceDisabled",
          value: function forceDisabled(t) {
            this._disableStack.add(t), 1 == this._disableStack.size && (this.on("set:isEnabled", ge, {
              priority: "highest"
            }), this.isEnabled = !1);
          }
        }, {
          key: "clearForceDisabled",
          value: function clearForceDisabled(t) {
            this._disableStack.delete(t), 0 == this._disableStack.size && (this.off("set:isEnabled", ge), this.isEnabled = !0);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.stopListening();
          }
        }], [{
          key: "isContextPlugin",
          get: function get() {
            return !1;
          }
        }]);

        return ue;
      }();

      function ge(t) {
        t.return = !1, t.stop();
      }

      he(ue, re);

      var me = /*#__PURE__*/function () {
        function me(t) {
          var _this8 = this;

          _classCallCheck(this, me);

          this.editor = t, this.set("value", void 0), this.set("isEnabled", !1), this.affectsData = !0, this._disableStack = new Set(), this.decorate("execute"), this.listenTo(this.editor.model.document, "change", function () {
            _this8.refresh();
          }), this.on("execute", function (t) {
            _this8.isEnabled || t.stop();
          }, {
            priority: "high"
          }), this.listenTo(t, "change:isReadOnly", function (t, e, n) {
            n && _this8.affectsData ? _this8.forceDisabled("readOnlyMode") : _this8.clearForceDisabled("readOnlyMode");
          });
        }

        _createClass(me, [{
          key: "refresh",
          value: function refresh() {
            this.isEnabled = !0;
          }
        }, {
          key: "forceDisabled",
          value: function forceDisabled(t) {
            this._disableStack.add(t), 1 == this._disableStack.size && (this.on("set:isEnabled", pe, {
              priority: "highest"
            }), this.isEnabled = !1);
          }
        }, {
          key: "clearForceDisabled",
          value: function clearForceDisabled(t) {
            this._disableStack.delete(t), 0 == this._disableStack.size && (this.off("set:isEnabled", pe), this.refresh());
          }
        }, {
          key: "execute",
          value: function execute() {}
        }, {
          key: "destroy",
          value: function destroy() {
            this.stopListening();
          }
        }]);

        return me;
      }();

      function pe(t) {
        t.return = !1, t.stop();
      }

      he(me, re);

      var fe = /*#__PURE__*/function (_me) {
        _inherits(fe, _me);

        var _super2 = _createSuper(fe);

        function fe(t) {
          var _this9;

          _classCallCheck(this, fe);

          _this9 = _super2.call(this, t), _this9._childCommands = [];
          return _this9;
        }

        _createClass(fe, [{
          key: "refresh",
          value: function refresh() {}
        }, {
          key: "execute",
          value: function execute() {
            var e = this._getFirstEnabledCommand();

            for (var _len9 = arguments.length, t = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
              t[_key9] = arguments[_key9];
            }

            return null != e && e.execute(t);
          }
        }, {
          key: "registerChildCommand",
          value: function registerChildCommand(t) {
            var _this10 = this;

            this._childCommands.push(t), t.on("change:isEnabled", function () {
              return _this10._checkEnabled();
            }), this._checkEnabled();
          }
        }, {
          key: "_checkEnabled",
          value: function _checkEnabled() {
            this.isEnabled = !!this._getFirstEnabledCommand();
          }
        }, {
          key: "_getFirstEnabledCommand",
          value: function _getFirstEnabledCommand() {
            return this._childCommands.find(function (t) {
              return t.isEnabled;
            });
          }
        }]);

        return fe;
      }(me);

      var ke = function ke(t, e) {
        return function (n) {
          return t(e(n));
        };
      },
          be = ke(Object.getPrototypeOf, Object),
          we = Function.prototype,
          Ae = Object.prototype,
          Ce = we.toString,
          _e = Ae.hasOwnProperty,
          ve = Ce.call(Object);

      var ye = function ye(t) {
        if (!_t(t) || "[object Object]" != R(t)) return !1;
        var e = be(t);
        if (null === e) return !0;
        var n = _e.call(e, "constructor") && e.constructor;
        return "function" == typeof n && n instanceof n && Ce.call(n) == ve;
      };

      var xe = function xe() {
        this.__data__ = [], this.size = 0;
      };

      var Ee = function Ee(t, e) {
        for (var n = t.length; n--;) {
          if (et(t[n][0], e)) return n;
        }

        return -1;
      },
          De = Array.prototype.splice;

      var Se = function Se(t) {
        var e = this.__data__,
            n = Ee(e, t);
        return !(n < 0) && (n == e.length - 1 ? e.pop() : De.call(e, n, 1), --this.size, !0);
      };

      var Ie = function Ie(t) {
        var e = this.__data__,
            n = Ee(e, t);
        return n < 0 ? void 0 : e[n][1];
      };

      var Me = function Me(t) {
        return Ee(this.__data__, t) > -1;
      };

      var Te = function Te(t, e) {
        var n = this.__data__,
            i = Ee(n, t);
        return i < 0 ? (++this.size, n.push([t, e])) : n[i][1] = e, this;
      };

      function Ne(t) {
        var e = -1,
            n = null == t ? 0 : t.length;

        for (this.clear(); ++e < n;) {
          var i = t[e];
          this.set(i[0], i[1]);
        }
      }

      Ne.prototype.clear = xe, Ne.prototype.delete = Se, Ne.prototype.get = Ie, Ne.prototype.has = Me, Ne.prototype.set = Te;
      var Be = Ne;

      var ze = function ze() {
        this.__data__ = new Be(), this.size = 0;
      };

      var Pe = function Pe(t) {
        var e = this.__data__,
            n = e.delete(t);
        return this.size = e.size, n;
      };

      var Le = function Le(t) {
        return this.__data__.get(t);
      };

      var Re = function Re(t) {
        return this.__data__.has(t);
      },
          Oe = J(D, "Map"),
          je = J(Object, "create");

      var Fe = function Fe() {
        this.__data__ = je ? je(null) : {}, this.size = 0;
      };

      var Ve = function Ve(t) {
        var e = this.has(t) && delete this.__data__[t];
        return this.size -= e ? 1 : 0, e;
      },
          Ue = Object.prototype.hasOwnProperty;

      var He = function He(t) {
        var e = this.__data__;

        if (je) {
          var n = e[t];
          return "__lodash_hash_undefined__" === n ? void 0 : n;
        }

        return Ue.call(e, t) ? e[t] : void 0;
      },
          qe = Object.prototype.hasOwnProperty;

      var We = function We(t) {
        var e = this.__data__;
        return je ? void 0 !== e[t] : qe.call(e, t);
      };

      var Ge = function Ge(t, e) {
        var n = this.__data__;
        return this.size += this.has(t) ? 0 : 1, n[t] = je && void 0 === e ? "__lodash_hash_undefined__" : e, this;
      };

      function $e(t) {
        var e = -1,
            n = null == t ? 0 : t.length;

        for (this.clear(); ++e < n;) {
          var i = t[e];
          this.set(i[0], i[1]);
        }
      }

      $e.prototype.clear = Fe, $e.prototype.delete = Ve, $e.prototype.get = He, $e.prototype.has = We, $e.prototype.set = Ge;
      var Ye = $e;

      var Ke = function Ke() {
        this.size = 0, this.__data__ = {
          hash: new Ye(),
          map: new (Oe || Be)(),
          string: new Ye()
        };
      };

      var Qe = function Qe(t) {
        var e = typeof t;
        return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
      };

      var Ze = function Ze(t, e) {
        var n = t.__data__;
        return Qe(e) ? n["string" == typeof e ? "string" : "hash"] : n.map;
      };

      var Je = function Je(t) {
        var e = Ze(this, t).delete(t);
        return this.size -= e ? 1 : 0, e;
      };

      var Xe = function Xe(t) {
        return Ze(this, t).get(t);
      };

      var tn = function tn(t) {
        return Ze(this, t).has(t);
      };

      var en = function en(t, e) {
        var n = Ze(this, t),
            i = n.size;
        return n.set(t, e), this.size += n.size == i ? 0 : 1, this;
      };

      function nn(t) {
        var e = -1,
            n = null == t ? 0 : t.length;

        for (this.clear(); ++e < n;) {
          var i = t[e];
          this.set(i[0], i[1]);
        }
      }

      nn.prototype.clear = Ke, nn.prototype.delete = Je, nn.prototype.get = Xe, nn.prototype.has = tn, nn.prototype.set = en;
      var on = nn;

      var rn = function rn(t, e) {
        var n = this.__data__;

        if (n instanceof Be) {
          var i = n.__data__;
          if (!Oe || i.length < 199) return i.push([t, e]), this.size = ++n.size, this;
          n = this.__data__ = new on(i);
        }

        return n.set(t, e), this.size = n.size, this;
      };

      function sn(t) {
        var e = this.__data__ = new Be(t);
        this.size = e.size;
      }

      sn.prototype.clear = ze, sn.prototype.delete = Pe, sn.prototype.get = Le, sn.prototype.has = Re, sn.prototype.set = rn;
      var an = sn;

      var cn = function cn(t, e) {
        for (var n = -1, i = null == t ? 0 : t.length; ++n < i && !1 !== e(t[n], n, t);) {
          ;
        }

        return t;
      },
          ln = ke(Object.keys, Object),
          dn = Object.prototype.hasOwnProperty;

      var hn = function hn(t) {
        if (!$t(t)) return ln(t);
        var e = [];

        for (var n in Object(t)) {
          dn.call(t, n) && "constructor" != n && e.push(n);
        }

        return e;
      };

      var un = function un(t) {
        return ft(t) ? Wt(t) : hn(t);
      };

      var gn = function gn(t, e) {
        return t && ot(e, un(e), t);
      };

      var mn = function mn(t, e) {
        return t && ot(e, Zt(e), t);
      },
          pn = "object" == typeof exports && exports && !exports.nodeType && exports,
          fn = pn && "object" == typeof module && module && !module.nodeType && module,
          kn = fn && fn.exports === pn ? D.Buffer : void 0,
          bn = kn ? kn.allocUnsafe : void 0;

      var wn = function wn(t, e) {
        if (e) return t.slice();
        var n = t.length,
            i = bn ? bn(n) : new t.constructor(n);
        return t.copy(i), i;
      };

      var An = function An(t, e) {
        var n = -1,
            i = t.length;

        for (e || (e = Array(i)); ++n < i;) {
          e[n] = t[n];
        }

        return e;
      };

      var Cn = function Cn(t, e) {
        for (var n = -1, i = null == t ? 0 : t.length, o = 0, r = []; ++n < i;) {
          var s = t[n];
          e(s, n, t) && (r[o++] = s);
        }

        return r;
      };

      var _n = function _n() {
        return [];
      },
          vn = Object.prototype.propertyIsEnumerable,
          yn = Object.getOwnPropertySymbols,
          xn = yn ? function (t) {
        return null == t ? [] : (t = Object(t), Cn(yn(t), function (e) {
          return vn.call(t, e);
        }));
      } : _n;

      var En = function En(t, e) {
        return ot(t, xn(t), e);
      };

      var Dn = function Dn(t, e) {
        for (var n = -1, i = e.length, o = t.length; ++n < i;) {
          t[o + n] = e[n];
        }

        return t;
      },
          Sn = Object.getOwnPropertySymbols ? function (t) {
        for (var e = []; t;) {
          Dn(e, xn(t)), t = be(t);
        }

        return e;
      } : _n;

      var In = function In(t, e) {
        return ot(t, Sn(t), e);
      };

      var Mn = function Mn(t, e, n) {
        var i = e(t);
        return It(t) ? i : Dn(i, n(t));
      };

      var Tn = function Tn(t) {
        return Mn(t, un, xn);
      };

      var Nn = function Nn(t) {
        return Mn(t, Zt, Sn);
      },
          Bn = J(D, "DataView"),
          zn = J(D, "Promise"),
          Pn = J(D, "Set"),
          Ln = J(D, "WeakMap"),
          Rn = "[object Map]",
          On = "[object Promise]",
          jn = "[object Set]",
          Fn = "[object WeakMap]",
          Vn = "[object DataView]",
          Un = H(Bn),
          Hn = H(Oe),
          qn = H(zn),
          Wn = H(Pn),
          Gn = H(Ln),
          $n = R;

      (Bn && $n(new Bn(new ArrayBuffer(1))) != Vn || Oe && $n(new Oe()) != Rn || zn && $n(zn.resolve()) != On || Pn && $n(new Pn()) != jn || Ln && $n(new Ln()) != Fn) && ($n = function $n(t) {
        var e = R(t),
            n = "[object Object]" == e ? t.constructor : void 0,
            i = n ? H(n) : "";
        if (i) switch (i) {
          case Un:
            return Vn;

          case Hn:
            return Rn;

          case qn:
            return On;

          case Wn:
            return jn;

          case Gn:
            return Fn;
        }
        return e;
      });
      var Yn = $n,
          Kn = Object.prototype.hasOwnProperty;

      var Qn = function Qn(t) {
        var e = t.length,
            n = new t.constructor(e);
        return e && "string" == typeof t[0] && Kn.call(t, "index") && (n.index = t.index, n.input = t.input), n;
      },
          Zn = D.Uint8Array;

      var Jn = function Jn(t) {
        var e = new t.constructor(t.byteLength);
        return new Zn(e).set(new Zn(t)), e;
      };

      var Xn = function Xn(t, e) {
        var n = e ? Jn(t.buffer) : t.buffer;
        return new t.constructor(n, t.byteOffset, t.byteLength);
      },
          ti = /\w*$/;

      var ei = function ei(t) {
        var e = new t.constructor(t.source, ti.exec(t));
        return e.lastIndex = t.lastIndex, e;
      },
          ni = S ? S.prototype : void 0,
          ii = ni ? ni.valueOf : void 0;

      var oi = function oi(t) {
        return ii ? Object(ii.call(t)) : {};
      };

      var ri = function ri(t, e) {
        var n = e ? Jn(t.buffer) : t.buffer;
        return new t.constructor(n, t.byteOffset, t.length);
      };

      var si = function si(t, e, n) {
        var i = t.constructor;

        switch (e) {
          case "[object ArrayBuffer]":
            return Jn(t);

          case "[object Boolean]":
          case "[object Date]":
            return new i(+t);

          case "[object DataView]":
            return Xn(t, n);

          case "[object Float32Array]":
          case "[object Float64Array]":
          case "[object Int8Array]":
          case "[object Int16Array]":
          case "[object Int32Array]":
          case "[object Uint8Array]":
          case "[object Uint8ClampedArray]":
          case "[object Uint16Array]":
          case "[object Uint32Array]":
            return ri(t, n);

          case "[object Map]":
          case "[object Set]":
            return new i();

          case "[object Number]":
          case "[object String]":
            return new i(t);

          case "[object RegExp]":
            return ei(t);

          case "[object Symbol]":
            return oi(t);
        }
      },
          ai = Object.create,
          ci = function () {
        function t() {}

        return function (e) {
          if (!y(e)) return {};
          if (ai) return ai(e);
          t.prototype = e;
          var n = new t();
          return t.prototype = void 0, n;
        };
      }();

      var li = function li(t) {
        return "function" != typeof t.constructor || $t(t) ? {} : ci(be(t));
      };

      var di = function di(t) {
        return _t(t) && "[object Map]" == Yn(t);
      },
          hi = Vt && Vt.isMap,
          ui = hi ? Rt(hi) : di;

      var gi = function gi(t) {
        return _t(t) && "[object Set]" == Yn(t);
      },
          mi = Vt && Vt.isSet,
          pi = mi ? Rt(mi) : gi,
          fi = "[object Arguments]",
          ki = "[object Function]",
          bi = "[object Object]",
          wi = {};

      wi[fi] = wi["[object Array]"] = wi["[object ArrayBuffer]"] = wi["[object DataView]"] = wi["[object Boolean]"] = wi["[object Date]"] = wi["[object Float32Array]"] = wi["[object Float64Array]"] = wi["[object Int8Array]"] = wi["[object Int16Array]"] = wi["[object Int32Array]"] = wi["[object Map]"] = wi["[object Number]"] = wi["[object Object]"] = wi["[object RegExp]"] = wi["[object Set]"] = wi["[object String]"] = wi["[object Symbol]"] = wi["[object Uint8Array]"] = wi["[object Uint8ClampedArray]"] = wi["[object Uint16Array]"] = wi["[object Uint32Array]"] = !0, wi["[object Error]"] = wi[ki] = wi["[object WeakMap]"] = !1;

      var Ai = function t(e, n, i, o, r, s) {
        var a,
            c = 1 & n,
            l = 2 & n,
            d = 4 & n;
        if (i && (a = r ? i(e, o, r, s) : i(e)), void 0 !== a) return a;
        if (!y(e)) return e;
        var h = It(e);

        if (h) {
          if (a = Qn(e), !c) return An(e, a);
        } else {
          var u = Yn(e),
              g = u == ki || "[object GeneratorFunction]" == u;
          if (zt(e)) return wn(e, c);

          if (u == bi || u == fi || g && !r) {
            if (a = l || g ? {} : li(e), !c) return l ? In(e, mn(a, e)) : En(e, gn(a, e));
          } else {
            if (!wi[u]) return r ? e : {};
            a = si(e, u, c);
          }
        }

        s || (s = new an());
        var m = s.get(e);
        if (m) return m;
        s.set(e, a), pi(e) ? e.forEach(function (o) {
          a.add(t(o, n, i, o, e, s));
        }) : ui(e) && e.forEach(function (o, r) {
          a.set(r, t(o, n, i, r, e, s));
        });
        var p = h ? void 0 : (d ? l ? Nn : Tn : l ? Zt : un)(e);
        return cn(p || e, function (o, r) {
          p && (o = e[r = o]), it(a, r, t(o, n, i, r, e, s));
        }), a;
      };

      var Ci = function Ci(t, e) {
        return Ai(t, 5, e = "function" == typeof e ? e : void 0);
      };

      var _i = function _i(t) {
        return _t(t) && 1 === t.nodeType && !ye(t);
      };

      var vi = /*#__PURE__*/function () {
        function vi(t, e) {
          _classCallCheck(this, vi);

          this._config = {}, e && this.define(yi(e)), t && this._setObjectToTarget(this._config, t);
        }

        _createClass(vi, [{
          key: "set",
          value: function set(t, e) {
            this._setToTarget(this._config, t, e);
          }
        }, {
          key: "define",
          value: function define(t, e) {
            this._setToTarget(this._config, t, e, !0);
          }
        }, {
          key: "get",
          value: function get(t) {
            return this._getFromSource(this._config, t);
          }
        }, {
          key: "names",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function names() {
            var _i3, _Object$keys, _t9;

            return _regeneratorRuntime.wrap(function names$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _i3 = 0, _Object$keys = Object.keys(this._config);

                  case 1:
                    if (!(_i3 < _Object$keys.length)) {
                      _context.next = 8;
                      break;
                    }

                    _t9 = _Object$keys[_i3];
                    _context.next = 5;
                    return _t9;

                  case 5:
                    _i3++;
                    _context.next = 1;
                    break;

                  case 8:
                  case "end":
                    return _context.stop();
                }
              }
            }, names, this);
          })
        }, {
          key: "_setToTarget",
          value: function _setToTarget(t, e, n) {
            var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
            if (ye(e)) return void this._setObjectToTarget(t, e, i);
            var o = e.split(".");
            e = o.pop();

            var _iterator6 = _createForOfIteratorHelper(o),
                _step6;

            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var _e7 = _step6.value;
                ye(t[_e7]) || (t[_e7] = {}), t = t[_e7];
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }

            if (ye(n)) return ye(t[e]) || (t[e] = {}), t = t[e], void this._setObjectToTarget(t, n, i);
            i && void 0 !== t[e] || (t[e] = n);
          }
        }, {
          key: "_getFromSource",
          value: function _getFromSource(t, e) {
            var n = e.split(".");
            e = n.pop();

            var _iterator7 = _createForOfIteratorHelper(n),
                _step7;

            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var _e8 = _step7.value;

                if (!ye(t[_e8])) {
                  t = null;
                  break;
                }

                t = t[_e8];
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }

            return t ? yi(t[e]) : void 0;
          }
        }, {
          key: "_setObjectToTarget",
          value: function _setObjectToTarget(t, e, n) {
            var _this11 = this;

            Object.keys(e).forEach(function (i) {
              _this11._setToTarget(t, i, e[i], n);
            });
          }
        }]);

        return vi;
      }();

      function yi(t) {
        return Ci(t, xi);
      }

      function xi(t) {
        return _i(t) ? t : void 0;
      }

      function Ei(t) {
        return !(!t || !t[Symbol.iterator]);
      }

      var Di = /*#__PURE__*/function (_Symbol$iterator) {
        function Di() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          _classCallCheck(this, Di);

          var n = Ei(t);

          if (n || (e = t), this._items = [], this._itemMap = new Map(), this._idProperty = e.idProperty || "id", this._bindToExternalToInternalMap = new WeakMap(), this._bindToInternalToExternalMap = new WeakMap(), this._skippedIndexesFromExternal = [], n) {
            var _iterator8 = _createForOfIteratorHelper(t),
                _step8;

            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var _e9 = _step8.value;
                this._items.push(_e9), this._itemMap.set(this._getItemIdBeforeAdding(_e9), _e9);
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
          }
        }

        _createClass(Di, [{
          key: "length",
          get: function get() {
            return this._items.length;
          }
        }, {
          key: "first",
          get: function get() {
            return this._items[0] || null;
          }
        }, {
          key: "last",
          get: function get() {
            return this._items[this.length - 1] || null;
          }
        }, {
          key: "add",
          value: function add(t, e) {
            return this.addMany([t], e);
          }
        }, {
          key: "addMany",
          value: function addMany(t, e) {
            if (void 0 === e) e = this._items.length;else if (e > this._items.length || e < 0) throw new a("collection-add-item-invalid-index", this);

            for (var _n5 = 0; _n5 < t.length; _n5++) {
              var _i4 = t[_n5],
                  _o5 = this._getItemIdBeforeAdding(_i4),
                  _r4 = e + _n5;

              this._items.splice(_r4, 0, _i4), this._itemMap.set(_o5, _i4), this.fire("add", _i4, _r4);
            }

            return this.fire("change", {
              added: t,
              removed: [],
              index: e
            }), this;
          }
        }, {
          key: "get",
          value: function get(t) {
            var e;
            if ("string" == typeof t) e = this._itemMap.get(t);else {
              if ("number" != typeof t) throw new a("collection-get-invalid-arg", this);
              e = this._items[t];
            }
            return e || null;
          }
        }, {
          key: "has",
          value: function has(t) {
            if ("string" == typeof t) return this._itemMap.has(t);
            {
              var _e10 = t[this._idProperty];
              return this._itemMap.has(_e10);
            }
          }
        }, {
          key: "getIndex",
          value: function getIndex(t) {
            var e;
            return e = "string" == typeof t ? this._itemMap.get(t) : t, this._items.indexOf(e);
          }
        }, {
          key: "remove",
          value: function remove(t) {
            var _this$_remove = this._remove(t),
                _this$_remove2 = _slicedToArray(_this$_remove, 2),
                e = _this$_remove2[0],
                n = _this$_remove2[1];

            return this.fire("change", {
              added: [],
              removed: [e],
              index: n
            }), e;
          }
        }, {
          key: "map",
          value: function map(t, e) {
            return this._items.map(t, e);
          }
        }, {
          key: "find",
          value: function find(t, e) {
            return this._items.find(t, e);
          }
        }, {
          key: "filter",
          value: function filter(t, e) {
            return this._items.filter(t, e);
          }
        }, {
          key: "clear",
          value: function clear() {
            this._bindToCollection && (this.stopListening(this._bindToCollection), this._bindToCollection = null);
            var t = Array.from(this._items);

            for (; this.length;) {
              this._remove(0);
            }

            this.fire("change", {
              added: [],
              removed: t,
              index: 0
            });
          }
        }, {
          key: "bindTo",
          value: function bindTo(t) {
            var _this12 = this;

            if (this._bindToCollection) throw new a("collection-bind-to-rebind", this);
            return this._bindToCollection = t, {
              as: function as(t) {
                _this12._setUpBindToBinding(function (e) {
                  return new t(e);
                });
              },
              using: function using(t) {
                "function" == typeof t ? _this12._setUpBindToBinding(function (e) {
                  return t(e);
                }) : _this12._setUpBindToBinding(function (e) {
                  return e[t];
                });
              }
            };
          }
        }, {
          key: "_setUpBindToBinding",
          value: function _setUpBindToBinding(t) {
            var _this13 = this;

            var e = this._bindToCollection,
                n = function n(_n7, i, o) {
              var r = e._bindToCollection == _this13,
                  s = e._bindToInternalToExternalMap.get(i);

              if (r && s) _this13._bindToExternalToInternalMap.set(i, s), _this13._bindToInternalToExternalMap.set(s, i);else {
                var _n6 = t(i);

                if (!_n6) return void _this13._skippedIndexesFromExternal.push(o);
                var _r5 = o;

                var _iterator9 = _createForOfIteratorHelper(_this13._skippedIndexesFromExternal),
                    _step9;

                try {
                  for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                    var _t11 = _step9.value;
                    o > _t11 && _r5--;
                  }
                } catch (err) {
                  _iterator9.e(err);
                } finally {
                  _iterator9.f();
                }

                var _iterator10 = _createForOfIteratorHelper(e._skippedIndexesFromExternal),
                    _step10;

                try {
                  for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                    var _t12 = _step10.value;
                    _r5 >= _t12 && _r5++;
                  }
                } catch (err) {
                  _iterator10.e(err);
                } finally {
                  _iterator10.f();
                }

                _this13._bindToExternalToInternalMap.set(i, _n6), _this13._bindToInternalToExternalMap.set(_n6, i), _this13.add(_n6, _r5);

                for (var _t10 = 0; _t10 < e._skippedIndexesFromExternal.length; _t10++) {
                  _r5 <= e._skippedIndexesFromExternal[_t10] && e._skippedIndexesFromExternal[_t10]++;
                }
              }
            };

            var _iterator11 = _createForOfIteratorHelper(e),
                _step11;

            try {
              for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                var _t13 = _step11.value;
                n(0, _t13, e.getIndex(_t13));
              }
            } catch (err) {
              _iterator11.e(err);
            } finally {
              _iterator11.f();
            }

            this.listenTo(e, "add", n), this.listenTo(e, "remove", function (t, e, n) {
              var i = _this13._bindToExternalToInternalMap.get(e);

              i && _this13.remove(i), _this13._skippedIndexesFromExternal = _this13._skippedIndexesFromExternal.reduce(function (t, e) {
                return n < e && t.push(e - 1), n > e && t.push(e), t;
              }, []);
            });
          }
        }, {
          key: "_getItemIdBeforeAdding",
          value: function _getItemIdBeforeAdding(t) {
            var e = this._idProperty;
            var n;

            if (e in t) {
              if (n = t[e], "string" != typeof n) throw new a("collection-add-invalid-id", this);
              if (this.get(n)) throw new a("collection-add-item-already-exists", this);
            } else t[e] = n = r();

            return n;
          }
        }, {
          key: "_remove",
          value: function _remove(t) {
            var e,
                n,
                i,
                o = !1;
            var r = this._idProperty;
            if ("string" == typeof t ? (n = t, i = this._itemMap.get(n), o = !i, i && (e = this._items.indexOf(i))) : "number" == typeof t ? (e = t, i = this._items[e], o = !i, i && (n = i[r])) : (i = t, n = i[r], e = this._items.indexOf(i), o = -1 == e || !this._itemMap.get(n)), o) throw new a("collection-remove-404", this);
            this._items.splice(e, 1), this._itemMap.delete(n);

            var s = this._bindToInternalToExternalMap.get(i);

            return this._bindToInternalToExternalMap.delete(i), this._bindToExternalToInternalMap.delete(s), this.fire("remove", i, e), [i, e];
          }
        }, {
          key: _Symbol$iterator,
          value: function value() {
            return this._items[Symbol.iterator]();
          }
        }]);

        return Di;
      }(Symbol.iterator);

      he(Di, f);

      var Si = /*#__PURE__*/function (_Symbol$iterator2) {
        function Si(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

          _classCallCheck(this, Si);

          this._context = t, this._plugins = new Map(), this._availablePlugins = new Map();

          var _iterator12 = _createForOfIteratorHelper(e),
              _step12;

          try {
            for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
              var _t14 = _step12.value;
              _t14.pluginName && this._availablePlugins.set(_t14.pluginName, _t14);
            }
          } catch (err) {
            _iterator12.e(err);
          } finally {
            _iterator12.f();
          }

          this._contextPlugins = new Map();

          var _iterator13 = _createForOfIteratorHelper(n),
              _step13;

          try {
            for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
              var _step13$value = _slicedToArray(_step13.value, 2),
                  _t15 = _step13$value[0],
                  _e11 = _step13$value[1];

              this._contextPlugins.set(_t15, _e11), this._contextPlugins.set(_e11, _t15), _t15.pluginName && this._availablePlugins.set(_t15.pluginName, _t15);
            }
          } catch (err) {
            _iterator13.e(err);
          } finally {
            _iterator13.f();
          }
        }

        _createClass(Si, [{
          key: _Symbol$iterator2,
          value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
            var _iterator14, _step14, _t16;

            return _regeneratorRuntime.wrap(function value$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _iterator14 = _createForOfIteratorHelper(this._plugins);
                    _context2.prev = 1;

                    _iterator14.s();

                  case 3:
                    if ((_step14 = _iterator14.n()).done) {
                      _context2.next = 11;
                      break;
                    }

                    _t16 = _step14.value;
                    _context2.t0 = "function" == typeof _t16[0];

                    if (!_context2.t0) {
                      _context2.next = 9;
                      break;
                    }

                    _context2.next = 9;
                    return _t16;

                  case 9:
                    _context2.next = 3;
                    break;

                  case 11:
                    _context2.next = 16;
                    break;

                  case 13:
                    _context2.prev = 13;
                    _context2.t1 = _context2["catch"](1);

                    _iterator14.e(_context2.t1);

                  case 16:
                    _context2.prev = 16;

                    _iterator14.f();

                    return _context2.finish(16);

                  case 19:
                  case "end":
                    return _context2.stop();
                }
              }
            }, value, this, [[1, 13, 16, 19]]);
          })
        }, {
          key: "get",
          value: function get(t) {
            var e = this._plugins.get(t);

            if (!e) {
              var _e12 = t;
              throw "function" == typeof t && (_e12 = t.pluginName || t.name), new a("plugincollection-plugin-not-loaded", this._context, {
                plugin: _e12
              });
            }

            return e;
          }
        }, {
          key: "has",
          value: function has(t) {
            return this._plugins.has(t);
          }
        }, {
          key: "init",
          value: function init(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            var i = this,
                o = this._context;
            !function t(e) {
              var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
              e.forEach(function (e) {
                c(e) && (n.has(e) || (n.add(e), e.pluginName && !i._availablePlugins.has(e.pluginName) && i._availablePlugins.set(e.pluginName, e), e.requires && t(e.requires, n)));
              });
            }(t), u(t);

            var r = _toConsumableArray(function t(e) {
              var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
              return e.map(function (t) {
                return c(t) ? t : i._availablePlugins.get(t);
              }).reduce(function (e, i) {
                return n.has(i) ? e : (n.add(i), i.requires && (u(i.requires, i), t(i.requires, n).forEach(function (t) {
                  return e.add(t);
                })), e.add(i));
              }, new Set());
            }(t.filter(function (t) {
              return !d(t, e);
            })));

            !function (t, e) {
              var _iterator15 = _createForOfIteratorHelper(e),
                  _step15;

              try {
                for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                  var _n8 = _step15.value;
                  if ("function" != typeof _n8) throw new a("plugincollection-replace-plugin-invalid-type", null, {
                    pluginItem: _n8
                  });
                  var _e13 = _n8.pluginName;
                  if (!_e13) throw new a("plugincollection-replace-plugin-missing-name", null, {
                    pluginItem: _n8
                  });
                  if (_n8.requires && _n8.requires.length) throw new a("plugincollection-plugin-for-replacing-cannot-have-dependencies", null, {
                    pluginName: _e13
                  });

                  var _o6 = i._availablePlugins.get(_e13);

                  if (!_o6) throw new a("plugincollection-plugin-for-replacing-not-exist", null, {
                    pluginName: _e13
                  });

                  var _r6 = t.indexOf(_o6);

                  if (-1 === _r6) {
                    if (i._contextPlugins.has(_o6)) return;
                    throw new a("plugincollection-plugin-for-replacing-not-loaded", null, {
                      pluginName: _e13
                    });
                  }

                  if (_o6.requires && _o6.requires.length) throw new a("plugincollection-replaced-plugin-cannot-have-dependencies", null, {
                    pluginName: _e13
                  });
                  t.splice(_r6, 1, _n8), i._availablePlugins.set(_e13, _n8);
                }
              } catch (err) {
                _iterator15.e(err);
              } finally {
                _iterator15.f();
              }
            }(r, n);

            var s = function (t) {
              return t.map(function (t) {
                var e = i._contextPlugins.get(t) || new t(o);
                return i._add(t, e), e;
              });
            }(r);

            return g(s, "init").then(function () {
              return g(s, "afterInit");
            }).then(function () {
              return s;
            });

            function c(t) {
              return "function" == typeof t;
            }

            function l(t) {
              return c(t) && t.isContextPlugin;
            }

            function d(t, e) {
              return e.some(function (e) {
                return e === t || h(t) === e || h(e) === t;
              });
            }

            function h(t) {
              return c(t) ? t.pluginName || t.name : t;
            }

            function u(t) {
              var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              t.map(function (t) {
                return c(t) ? t : i._availablePlugins.get(t) || t;
              }).forEach(function (t) {
                !function (t, e) {
                  if (c(t)) return;
                  if (e) throw new a("plugincollection-soft-required", o, {
                    missingPlugin: t,
                    requiredBy: h(e)
                  });
                  throw new a("plugincollection-plugin-not-found", o, {
                    plugin: t
                  });
                }(t, n), function (t, e) {
                  if (!l(e)) return;
                  if (l(t)) return;
                  throw new a("plugincollection-context-required", o, {
                    plugin: h(t),
                    requiredBy: h(e)
                  });
                }(t, n), function (t, n) {
                  if (!n) return;
                  if (!d(t, e)) return;
                  throw new a("plugincollection-required", o, {
                    plugin: h(t),
                    requiredBy: h(n)
                  });
                }(t, n);
              });
            }

            function g(t, e) {
              return t.reduce(function (t, n) {
                return n[e] ? i._contextPlugins.has(n) ? t : t.then(n[e].bind(n)) : t;
              }, Promise.resolve());
            }
          }
        }, {
          key: "destroy",
          value: function destroy() {
            var t = [];

            var _iterator16 = _createForOfIteratorHelper(this),
                _step16;

            try {
              for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                var _step16$value = _slicedToArray(_step16.value, 2),
                    _e14 = _step16$value[1];

                "function" != typeof _e14.destroy || this._contextPlugins.has(_e14) || t.push(_e14.destroy());
              }
            } catch (err) {
              _iterator16.e(err);
            } finally {
              _iterator16.f();
            }

            return Promise.all(t);
          }
        }, {
          key: "_add",
          value: function _add(t, e) {
            this._plugins.set(t, e);

            var n = t.pluginName;

            if (n) {
              if (this._plugins.has(n)) throw new a("plugincollection-plugin-name-conflict", null, {
                pluginName: n,
                plugin1: this._plugins.get(n).constructor,
                plugin2: t
              });

              this._plugins.set(n, e);
            }
          }
        }]);

        return Si;
      }(Symbol.iterator);

      function Ii(t) {
        return Array.isArray(t) ? t : [t];
      }

      function Mi(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        if ("number" != typeof n) throw new a("translation-service-quantity-not-a-number", null, {
          quantity: n
        });
        var i = Object.keys(window.CKEDITOR_TRANSLATIONS).length;
        1 === i && (t = Object.keys(window.CKEDITOR_TRANSLATIONS)[0]);
        var o = e.id || e.string;
        if (0 === i || !function (t, e) {
          return !!window.CKEDITOR_TRANSLATIONS[t] && !!window.CKEDITOR_TRANSLATIONS[t].dictionary[e];
        }(t, o)) return 1 !== n ? e.plural : e.string;

        var r = window.CKEDITOR_TRANSLATIONS[t].dictionary,
            s = window.CKEDITOR_TRANSLATIONS[t].getPluralForm || function (t) {
          return 1 === t ? 0 : 1;
        };

        if ("string" == typeof r[o]) return r[o];
        var c = Number(s(n));
        return r[o][c];
      }

      he(Si, f), window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {});
      var Ti = ["ar", "ara", "fa", "per", "fas", "he", "heb", "ku", "kur", "ug", "uig"];

      function Ni(t) {
        return Ti.includes(t) ? "rtl" : "ltr";
      }

      var Bi = /*#__PURE__*/function () {
        function Bi() {
          var _this14 = this;

          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          _classCallCheck(this, Bi);

          this.uiLanguage = t.uiLanguage || "en", this.contentLanguage = t.contentLanguage || this.uiLanguage, this.uiLanguageDirection = Ni(this.uiLanguage), this.contentLanguageDirection = Ni(this.contentLanguage), this.t = function (t, e) {
            return _this14._t(t, e);
          };
        }

        _createClass(Bi, [{
          key: "language",
          get: function get() {
            return console.warn("locale-deprecated-language-property: The Locale#language property has been deprecated and will be removed in the near future. Please use #uiLanguage and #contentLanguage properties instead."), this.uiLanguage;
          }
        }, {
          key: "_t",
          value: function _t(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            e = Ii(e), "string" == typeof t && (t = {
              string: t
            });
            var n = !!t.plural ? e[0] : 1;
            return function (t, e) {
              return t.replace(/%(\d+)/g, function (t, n) {
                return n < e.length ? e[n] : t;
              });
            }(Mi(this.uiLanguage, t, n), e);
          }
        }]);

        return Bi;
      }();

      var zi = /*#__PURE__*/function () {
        function zi(t) {
          _classCallCheck(this, zi);

          this.config = new vi(t, this.constructor.defaultConfig);
          var e = this.constructor.builtinPlugins;
          this.config.define("plugins", e), this.plugins = new Si(this, e);
          var n = this.config.get("language") || {};
          this.locale = new Bi({
            uiLanguage: "string" == typeof n ? n : n.ui,
            contentLanguage: this.config.get("language.content")
          }), this.t = this.locale.t, this.editors = new Di(), this._contextOwner = null;
        }

        _createClass(zi, [{
          key: "initPlugins",
          value: function initPlugins() {
            var t = this.config.get("plugins") || [],
                e = this.config.get("substitutePlugins") || [];

            var _iterator17 = _createForOfIteratorHelper(t.concat(e)),
                _step17;

            try {
              for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                var _n9 = _step17.value;
                if ("function" != typeof _n9) throw new a("context-initplugins-constructor-only", null, {
                  Plugin: _n9
                });
                if (!0 !== _n9.isContextPlugin) throw new a("context-initplugins-invalid-plugin", null, {
                  Plugin: _n9
                });
              }
            } catch (err) {
              _iterator17.e(err);
            } finally {
              _iterator17.f();
            }

            return this.plugins.init(t, [], e);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            var _this15 = this;

            return Promise.all(Array.from(this.editors, function (t) {
              return t.destroy();
            })).then(function () {
              return _this15.plugins.destroy();
            });
          }
        }, {
          key: "_addEditor",
          value: function _addEditor(t, e) {
            if (this._contextOwner) throw new a("context-addeditor-private-context");
            this.editors.add(t), e && (this._contextOwner = t);
          }
        }, {
          key: "_removeEditor",
          value: function _removeEditor(t) {
            return this.editors.has(t) && this.editors.remove(t), this._contextOwner === t ? this.destroy() : Promise.resolve();
          }
        }, {
          key: "_getEditorConfig",
          value: function _getEditorConfig() {
            var t = {};

            var _iterator18 = _createForOfIteratorHelper(this.config.names()),
                _step18;

            try {
              for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                var _e15 = _step18.value;
                ["plugins", "removePlugins", "extraPlugins"].includes(_e15) || (t[_e15] = this.config.get(_e15));
              }
            } catch (err) {
              _iterator18.e(err);
            } finally {
              _iterator18.f();
            }

            return t;
          }
        }], [{
          key: "create",
          value: function create(t) {
            var _this16 = this;

            return new Promise(function (e) {
              var n = new _this16(t);
              e(n.initPlugins().then(function () {
                return n;
              }));
            });
          }
        }]);

        return zi;
      }();

      var Pi = /*#__PURE__*/function () {
        function Pi(t) {
          _classCallCheck(this, Pi);

          this.context = t;
        }

        _createClass(Pi, [{
          key: "destroy",
          value: function destroy() {
            this.stopListening();
          }
        }], [{
          key: "isContextPlugin",
          get: function get() {
            return !0;
          }
        }]);

        return Pi;
      }();

      function Li(t, e) {
        var n = Math.min(t.length, e.length);

        for (var _i5 = 0; _i5 < n; _i5++) {
          if (t[_i5] != e[_i5]) return _i5;
        }

        return t.length == e.length ? "same" : t.length < e.length ? "prefix" : "extension";
      }

      he(Pi, re);

      var Ri = function Ri(t) {
        return Ai(t, 4);
      };

      var Oi = /*#__PURE__*/function () {
        function Oi(t) {
          _classCallCheck(this, Oi);

          this.document = t, this.parent = null;
        }

        _createClass(Oi, [{
          key: "index",
          get: function get() {
            var t;
            if (!this.parent) return null;
            if (-1 == (t = this.parent.getChildIndex(this))) throw new a("view-node-not-found-in-parent", this);
            return t;
          }
        }, {
          key: "nextSibling",
          get: function get() {
            var t = this.index;
            return null !== t && this.parent.getChild(t + 1) || null;
          }
        }, {
          key: "previousSibling",
          get: function get() {
            var t = this.index;
            return null !== t && this.parent.getChild(t - 1) || null;
          }
        }, {
          key: "root",
          get: function get() {
            var t = this;

            for (; t.parent;) {
              t = t.parent;
            }

            return t;
          }
        }, {
          key: "isAttached",
          value: function isAttached() {
            return this.root.is("rootElement");
          }
        }, {
          key: "getPath",
          value: function getPath() {
            var t = [];
            var e = this;

            for (; e.parent;) {
              t.unshift(e.index), e = e.parent;
            }

            return t;
          }
        }, {
          key: "getAncestors",
          value: function getAncestors() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
              includeSelf: !1,
              parentFirst: !1
            };
            var e = [];
            var n = t.includeSelf ? this : this.parent;

            for (; n;) {
              e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
            }

            return e;
          }
        }, {
          key: "getCommonAncestor",
          value: function getCommonAncestor(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var n = this.getAncestors(e),
                i = t.getAncestors(e);
            var o = 0;

            for (; n[o] == i[o] && n[o];) {
              o++;
            }

            return 0 === o ? null : n[o - 1];
          }
        }, {
          key: "isBefore",
          value: function isBefore(t) {
            if (this == t) return !1;
            if (this.root !== t.root) return !1;
            var e = this.getPath(),
                n = t.getPath(),
                i = Li(e, n);

            switch (i) {
              case "prefix":
                return !0;

              case "extension":
                return !1;

              default:
                return e[i] < n[i];
            }
          }
        }, {
          key: "isAfter",
          value: function isAfter(t) {
            return this != t && this.root === t.root && !this.isBefore(t);
          }
        }, {
          key: "_remove",
          value: function _remove() {
            this.parent._removeChildren(this.index);
          }
        }, {
          key: "_fireChange",
          value: function _fireChange(t, e) {
            this.fire("change:" + t, e), this.parent && this.parent._fireChange(t, e);
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var t = Ri(this);
            return delete t.parent, t;
          }
        }, {
          key: "is",
          value: function is(t) {
            return "node" === t || "view:node" === t;
          }
        }]);

        return Oi;
      }();

      he(Oi, f);

      var ji = /*#__PURE__*/function (_Oi) {
        _inherits(ji, _Oi);

        var _super3 = _createSuper(ji);

        function ji(t, e) {
          var _this17;

          _classCallCheck(this, ji);

          _this17 = _super3.call(this, t), _this17._textData = e;
          return _this17;
        }

        _createClass(ji, [{
          key: "is",
          value: function is(t) {
            return "$text" === t || "view:$text" === t || "text" === t || "view:text" === t || "node" === t || "view:node" === t;
          }
        }, {
          key: "data",
          get: function get() {
            return this._textData;
          }
        }, {
          key: "_data",
          get: function get() {
            return this.data;
          },
          set: function set(t) {
            this._fireChange("text", this), this._textData = t;
          }
        }, {
          key: "isSimilar",
          value: function isSimilar(t) {
            return t instanceof ji && (this === t || this.data === t.data);
          }
        }, {
          key: "_clone",
          value: function _clone() {
            return new ji(this.document, this.data);
          }
        }]);

        return ji;
      }(Oi);

      var Fi = /*#__PURE__*/function () {
        function Fi(t, e, n) {
          _classCallCheck(this, Fi);

          if (this.textNode = t, e < 0 || e > t.data.length) throw new a("view-textproxy-wrong-offsetintext", this);
          if (n < 0 || e + n > t.data.length) throw new a("view-textproxy-wrong-length", this);
          this.data = t.data.substring(e, e + n), this.offsetInText = e;
        }

        _createClass(Fi, [{
          key: "offsetSize",
          get: function get() {
            return this.data.length;
          }
        }, {
          key: "isPartial",
          get: function get() {
            return this.data.length !== this.textNode.data.length;
          }
        }, {
          key: "parent",
          get: function get() {
            return this.textNode.parent;
          }
        }, {
          key: "root",
          get: function get() {
            return this.textNode.root;
          }
        }, {
          key: "document",
          get: function get() {
            return this.textNode.document;
          }
        }, {
          key: "is",
          value: function is(t) {
            return "$textProxy" === t || "view:$textProxy" === t || "textProxy" === t || "view:textProxy" === t;
          }
        }, {
          key: "getAncestors",
          value: function getAncestors() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
              includeSelf: !1,
              parentFirst: !1
            };
            var e = [];
            var n = t.includeSelf ? this.textNode : this.parent;

            for (; null !== n;) {
              e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
            }

            return e;
          }
        }]);

        return Fi;
      }();

      function Vi(t) {
        return Ei(t) ? new Map(t) : function (t) {
          var e = new Map();

          for (var _n10 in t) {
            e.set(_n10, t[_n10]);
          }

          return e;
        }(t);
      }

      var Ui = /*#__PURE__*/function () {
        function Ui() {
          _classCallCheck(this, Ui);

          this._patterns = [], this.add.apply(this, arguments);
        }

        _createClass(Ui, [{
          key: "add",
          value: function add() {
            for (var _len10 = arguments.length, t = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
              t[_key10] = arguments[_key10];
            }

            for (var _i6 = 0, _t17 = t; _i6 < _t17.length; _i6++) {
              var _e16 = _t17[_i6];
              ("string" == typeof _e16 || _e16 instanceof RegExp) && (_e16 = {
                name: _e16
              }), this._patterns.push(_e16);
            }
          }
        }, {
          key: "match",
          value: function match() {
            for (var _len11 = arguments.length, t = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
              t[_key11] = arguments[_key11];
            }

            for (var _i7 = 0, _t18 = t; _i7 < _t18.length; _i7++) {
              var _e17 = _t18[_i7];

              var _iterator19 = _createForOfIteratorHelper(this._patterns),
                  _step19;

              try {
                for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                  var _t19 = _step19.value;

                  var _n11 = Hi(_e17, _t19);

                  if (_n11) return {
                    element: _e17,
                    pattern: _t19,
                    match: _n11
                  };
                }
              } catch (err) {
                _iterator19.e(err);
              } finally {
                _iterator19.f();
              }
            }

            return null;
          }
        }, {
          key: "matchAll",
          value: function matchAll() {
            var e = [];

            for (var _len12 = arguments.length, t = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
              t[_key12] = arguments[_key12];
            }

            for (var _i8 = 0, _t20 = t; _i8 < _t20.length; _i8++) {
              var _n12 = _t20[_i8];

              var _iterator20 = _createForOfIteratorHelper(this._patterns),
                  _step20;

              try {
                for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
                  var _t21 = _step20.value;

                  var _i9 = Hi(_n12, _t21);

                  _i9 && e.push({
                    element: _n12,
                    pattern: _t21,
                    match: _i9
                  });
                }
              } catch (err) {
                _iterator20.e(err);
              } finally {
                _iterator20.f();
              }
            }

            return e.length > 0 ? e : null;
          }
        }, {
          key: "getElementName",
          value: function getElementName() {
            if (1 !== this._patterns.length) return null;
            var t = this._patterns[0],
                e = t.name;
            return "function" == typeof t || !e || e instanceof RegExp ? null : e;
          }
        }]);

        return Ui;
      }();

      function Hi(t, e) {
        if ("function" == typeof e) return e(t);
        var n = {};
        return e.name && (n.name = function (t, e) {
          if (t instanceof RegExp) return !!e.match(t);
          return t === e;
        }(e.name, t.name), !n.name) || e.attributes && (n.attributes = function (t, e) {
          var n = new Set(e.getAttributeKeys());
          ye(t) ? (void 0 !== t.style && c("matcher-pattern-deprecated-attributes-style-key", t), void 0 !== t.class && c("matcher-pattern-deprecated-attributes-class-key", t)) : (n.delete("style"), n.delete("class"));
          return qi(t, n, function (t) {
            return e.getAttribute(t);
          });
        }(e.attributes, t), !n.attributes) ? null : !(e.classes && (n.classes = function (t, e) {
          return qi(t, e.getClassNames());
        }(e.classes, t), !n.classes)) && !(e.styles && (n.styles = function (t, e) {
          return qi(t, e.getStyleNames(!0), function (t) {
            return e.getStyle(t);
          });
        }(e.styles, t), !n.styles)) && n;
      }

      function qi(t, e, n) {
        var i = function (t) {
          if (Array.isArray(t)) return t.map(function (t) {
            return ye(t) ? (void 0 !== t.key && void 0 !== t.value || c("matcher-pattern-missing-key-or-value", t), [t.key, t.value]) : [t, !0];
          });
          if (ye(t)) return Object.entries(t);
          return [[t, !0]];
        }(t),
            o = Array.from(e),
            r = [];

        return i.forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              t = _ref2[0],
              e = _ref2[1];

          o.forEach(function (i) {
            (function (t, e) {
              return !0 === t || t === e || t instanceof RegExp && e.match(t);
            })(t, i) && function (t, e, n) {
              if (!0 === t) return !0;
              var i = n(e);
              return t === i || t instanceof RegExp && !!String(i).match(t);
            }(e, i, n) && r.push(i);
          });
        }), !i.length || r.length < i.length ? null : r;
      }

      var Wi = function Wi(t) {
        return "symbol" == typeof t || _t(t) && "[object Symbol]" == R(t);
      },
          Gi = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
          $i = /^\w*$/;

      var Yi = function Yi(t, e) {
        if (It(t)) return !1;
        var n = typeof t;
        return !("number" != n && "symbol" != n && "boolean" != n && null != t && !Wi(t)) || $i.test(t) || !Gi.test(t) || null != e && t in Object(e);
      };

      function Ki(t, e) {
        if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError("Expected a function");

        var n = function n() {
          var i = arguments,
              o = e ? e.apply(this, i) : i[0],
              r = n.cache;
          if (r.has(o)) return r.get(o);
          var s = t.apply(this, i);
          return n.cache = r.set(o, s) || r, s;
        };

        return n.cache = new (Ki.Cache || on)(), n;
      }

      Ki.Cache = on;
      var Qi = Ki;

      var Zi = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
          Ji = /\\(\\)?/g,
          Xi = function (t) {
        var e = Qi(t, function (t) {
          return 500 === n.size && n.clear(), t;
        }),
            n = e.cache;
        return e;
      }(function (t) {
        var e = [];
        return 46 === t.charCodeAt(0) && e.push(""), t.replace(Zi, function (t, n, i, o) {
          e.push(i ? o.replace(Ji, "$1") : n || t);
        }), e;
      }),
          to = Xi;

      var eo = function eo(t, e) {
        for (var n = -1, i = null == t ? 0 : t.length, o = Array(i); ++n < i;) {
          o[n] = e(t[n], n, t);
        }

        return o;
      },
          no = S ? S.prototype : void 0,
          io = no ? no.toString : void 0;

      var oo = function t(e) {
        if ("string" == typeof e) return e;
        if (It(e)) return eo(e, t) + "";
        if (Wi(e)) return io ? io.call(e) : "";
        var n = e + "";
        return "0" == n && 1 / e == -Infinity ? "-0" : n;
      };

      var ro = function ro(t) {
        return null == t ? "" : oo(t);
      };

      var so = function so(t, e) {
        return It(t) ? t : Yi(t, e) ? [t] : to(ro(t));
      };

      var ao = function ao(t) {
        var e = null == t ? 0 : t.length;
        return e ? t[e - 1] : void 0;
      };

      var co = function co(t) {
        if ("string" == typeof t || Wi(t)) return t;
        var e = t + "";
        return "0" == e && 1 / t == -Infinity ? "-0" : e;
      };

      var lo = function lo(t, e) {
        for (var n = 0, i = (e = so(e, t)).length; null != t && n < i;) {
          t = t[co(e[n++])];
        }

        return n && n == i ? t : void 0;
      };

      var ho = function ho(t, e, n) {
        var i = -1,
            o = t.length;
        e < 0 && (e = -e > o ? 0 : o + e), (n = n > o ? o : n) < 0 && (n += o), o = e > n ? 0 : n - e >>> 0, e >>>= 0;

        for (var r = Array(o); ++i < o;) {
          r[i] = t[i + e];
        }

        return r;
      };

      var uo = function uo(t, e) {
        return e.length < 2 ? t : lo(t, ho(e, 0, -1));
      };

      var go = function go(t, e) {
        return e = so(e, t), null == (t = uo(t, e)) || delete t[co(ao(e))];
      };

      var mo = function mo(t, e) {
        return null == t || go(t, e);
      };

      var po = function po(t, e, n) {
        var i = null == t ? void 0 : lo(t, e);
        return void 0 === i ? n : i;
      };

      var fo = function fo(t, e, n) {
        (void 0 !== n && !et(t[e], n) || void 0 === n && !(e in t)) && tt(t, e, n);
      };

      var ko = function (t) {
        return function (e, n, i) {
          for (var o = -1, r = Object(e), s = i(e), a = s.length; a--;) {
            var c = s[t ? a : ++o];
            if (!1 === n(r[c], c, r)) break;
          }

          return e;
        };
      }();

      var bo = function bo(t) {
        return _t(t) && ft(t);
      };

      var wo = function wo(t, e) {
        if (("constructor" !== e || "function" != typeof t[e]) && "__proto__" != e) return t[e];
      };

      var Ao = function Ao(t) {
        return ot(t, Zt(t));
      };

      var Co = function Co(t, e, n, i, o, r, s) {
        var a = wo(t, n),
            c = wo(e, n),
            l = s.get(c);
        if (l) fo(t, n, l);else {
          var d = r ? r(a, c, n + "", t, e, s) : void 0,
              h = void 0 === d;

          if (h) {
            var u = It(c),
                g = !u && zt(c),
                m = !u && !g && Ht(c);
            d = c, u || g || m ? It(a) ? d = a : bo(a) ? d = An(a) : g ? (h = !1, d = wn(c, !0)) : m ? (h = !1, d = ri(c, !0)) : d = [] : ye(c) || St(c) ? (d = a, St(a) ? d = Ao(a) : y(a) && !O(a) || (d = li(c))) : h = !1;
          }

          h && (s.set(c, d), o(d, c, i, r, s), s.delete(c)), fo(t, n, d);
        }
      };

      var _o = function t(e, n, i, o, r) {
        e !== n && ko(n, function (s, a) {
          if (r || (r = new an()), y(s)) Co(e, n, a, i, t, o, r);else {
            var c = o ? o(wo(e, a), s, a + "", e, n, r) : void 0;
            void 0 === c && (c = s), fo(e, a, c);
          }
        }, Zt);
      },
          vo = At(function (t, e, n) {
        _o(t, e, n);
      });

      var yo = function yo(t, e, n, i) {
        if (!y(t)) return t;

        for (var o = -1, r = (e = so(e, t)).length, s = r - 1, a = t; null != a && ++o < r;) {
          var c = co(e[o]),
              l = n;
          if ("__proto__" === c || "constructor" === c || "prototype" === c) return t;

          if (o != s) {
            var d = a[c];
            void 0 === (l = i ? i(d, c, a) : void 0) && (l = y(d) ? d : bt(e[o + 1]) ? [] : {});
          }

          it(a, c, l), a = a[c];
        }

        return t;
      };

      var xo = function xo(t, e, n) {
        return null == t ? t : yo(t, e, n);
      };

      var Eo = /*#__PURE__*/function () {
        function Eo(t) {
          _classCallCheck(this, Eo);

          this._styles = {}, this._styleProcessor = t;
        }

        _createClass(Eo, [{
          key: "isEmpty",
          get: function get() {
            var t = Object.entries(this._styles);
            return !Array.from(t).length;
          }
        }, {
          key: "size",
          get: function get() {
            return this.isEmpty ? 0 : this.getStyleNames().length;
          }
        }, {
          key: "setTo",
          value: function setTo(t) {
            this.clear();
            var e = Array.from(function (t) {
              var e = null,
                  n = 0,
                  i = 0,
                  o = null;
              var r = new Map();
              if ("" === t) return r;
              ";" != t.charAt(t.length - 1) && (t += ";");

              for (var _s2 = 0; _s2 < t.length; _s2++) {
                var _a2 = t.charAt(_s2);

                if (null === e) switch (_a2) {
                  case ":":
                    o || (o = t.substr(n, _s2 - n), i = _s2 + 1);
                    break;

                  case '"':
                  case "'":
                    e = _a2;
                    break;

                  case ";":
                    {
                      var _e18 = t.substr(i, _s2 - i);

                      o && r.set(o.trim(), _e18.trim()), o = null, n = _s2 + 1;
                      break;
                    }
                } else _a2 === e && (e = null);
              }

              return r;
            }(t).entries());

            for (var _i10 = 0, _e19 = e; _i10 < _e19.length; _i10++) {
              var _e19$_i = _slicedToArray(_e19[_i10], 2),
                  _t22 = _e19$_i[0],
                  _n13 = _e19$_i[1];

              this._styleProcessor.toNormalizedForm(_t22, _n13, this._styles);
            }
          }
        }, {
          key: "has",
          value: function has(t) {
            if (this.isEmpty) return !1;

            var e = this._styleProcessor.getReducedForm(t, this._styles).find(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 1),
                  e = _ref4[0];

              return e === t;
            });

            return Array.isArray(e);
          }
        }, {
          key: "set",
          value: function set(t, e) {
            if (y(t)) for (var _i11 = 0, _Object$entries = Object.entries(t); _i11 < _Object$entries.length; _i11++) {
              var _Object$entries$_i = _slicedToArray(_Object$entries[_i11], 2),
                  _e20 = _Object$entries$_i[0],
                  _n14 = _Object$entries$_i[1];

              this._styleProcessor.toNormalizedForm(_e20, _n14, this._styles);
            } else this._styleProcessor.toNormalizedForm(t, e, this._styles);
          }
        }, {
          key: "remove",
          value: function remove(t) {
            var e = So(t);
            mo(this._styles, e), delete this._styles[t], this._cleanEmptyObjectsOnPath(e);
          }
        }, {
          key: "getNormalized",
          value: function getNormalized(t) {
            return this._styleProcessor.getNormalized(t, this._styles);
          }
        }, {
          key: "toString",
          value: function toString() {
            return this.isEmpty ? "" : this._getStylesEntries().map(function (t) {
              return t.join(":");
            }).sort().join(";") + ";";
          }
        }, {
          key: "getAsString",
          value: function getAsString(t) {
            if (this.isEmpty) return;
            if (this._styles[t] && !y(this._styles[t])) return this._styles[t];

            var e = this._styleProcessor.getReducedForm(t, this._styles).find(function (_ref5) {
              var _ref6 = _slicedToArray(_ref5, 1),
                  e = _ref6[0];

              return e === t;
            });

            return Array.isArray(e) ? e[1] : void 0;
          }
        }, {
          key: "getStyleNames",
          value: function getStyleNames() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
            if (this.isEmpty) return [];
            if (t) return this._styleProcessor.getStyleNames(this._styles);
            return this._getStylesEntries().map(function (_ref7) {
              var _ref8 = _slicedToArray(_ref7, 1),
                  t = _ref8[0];

              return t;
            });
          }
        }, {
          key: "clear",
          value: function clear() {
            this._styles = {};
          }
        }, {
          key: "_getStylesEntries",
          value: function _getStylesEntries() {
            var t = [],
                e = Object.keys(this._styles);

            for (var _i12 = 0, _e21 = e; _i12 < _e21.length; _i12++) {
              var _n15 = _e21[_i12];
              t.push.apply(t, _toConsumableArray(this._styleProcessor.getReducedForm(_n15, this._styles)));
            }

            return t;
          }
        }, {
          key: "_cleanEmptyObjectsOnPath",
          value: function _cleanEmptyObjectsOnPath(t) {
            var e = t.split(".");
            if (!(e.length > 1)) return;
            var n = e.splice(0, e.length - 1).join("."),
                i = po(this._styles, n);
            if (!i) return;
            !Array.from(Object.keys(i)).length && this.remove(n);
          }
        }]);

        return Eo;
      }();

      var Do = /*#__PURE__*/function () {
        function Do() {
          _classCallCheck(this, Do);

          this._normalizers = new Map(), this._extractors = new Map(), this._reducers = new Map(), this._consumables = new Map();
        }

        _createClass(Do, [{
          key: "toNormalizedForm",
          value: function toNormalizedForm(t, e, n) {
            if (y(e)) Io(n, So(t), e);else if (this._normalizers.has(t)) {
              var _i13 = this._normalizers.get(t),
                  _i14 = _i13(e),
                  _o7 = _i14.path,
                  _r7 = _i14.value;

              Io(n, _o7, _r7);
            } else Io(n, t, e);
          }
        }, {
          key: "getNormalized",
          value: function getNormalized(t, e) {
            if (!t) return vo({}, e);
            if (void 0 !== e[t]) return e[t];

            if (this._extractors.has(t)) {
              var _n16 = this._extractors.get(t);

              if ("string" == typeof _n16) return po(e, _n16);

              var _i15 = _n16(t, e);

              if (_i15) return _i15;
            }

            return po(e, So(t));
          }
        }, {
          key: "getReducedForm",
          value: function getReducedForm(t, e) {
            var n = this.getNormalized(t, e);
            if (void 0 === n) return [];

            if (this._reducers.has(t)) {
              return this._reducers.get(t)(n);
            }

            return [[t, n]];
          }
        }, {
          key: "getStyleNames",
          value: function getStyleNames(t) {
            var _this18 = this;

            var e = Array.from(this._consumables.keys()).filter(function (e) {
              var n = _this18.getNormalized(e, t);

              return n && "object" == typeof n ? Object.keys(n).length : n;
            }),
                n = new Set([].concat(_toConsumableArray(e), _toConsumableArray(Object.keys(t))));
            return Array.from(n.values());
          }
        }, {
          key: "getRelatedStyles",
          value: function getRelatedStyles(t) {
            return this._consumables.get(t) || [];
          }
        }, {
          key: "setNormalizer",
          value: function setNormalizer(t, e) {
            this._normalizers.set(t, e);
          }
        }, {
          key: "setExtractor",
          value: function setExtractor(t, e) {
            this._extractors.set(t, e);
          }
        }, {
          key: "setReducer",
          value: function setReducer(t, e) {
            this._reducers.set(t, e);
          }
        }, {
          key: "setStyleRelation",
          value: function setStyleRelation(t, e) {
            this._mapStyleNames(t, e);

            var _iterator21 = _createForOfIteratorHelper(e),
                _step21;

            try {
              for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
                var _n17 = _step21.value;

                this._mapStyleNames(_n17, [t]);
              }
            } catch (err) {
              _iterator21.e(err);
            } finally {
              _iterator21.f();
            }
          }
        }, {
          key: "_mapStyleNames",
          value: function _mapStyleNames(t, e) {
            var _this$_consumables$ge;

            this._consumables.has(t) || this._consumables.set(t, []), (_this$_consumables$ge = this._consumables.get(t)).push.apply(_this$_consumables$ge, _toConsumableArray(e));
          }
        }]);

        return Do;
      }();

      function So(t) {
        return t.replace("-", ".");
      }

      function Io(t, e, n) {
        var i = n;
        y(n) && (i = vo({}, po(t, e), n)), xo(t, e, i);
      }

      var Mo = /*#__PURE__*/function (_Oi2) {
        _inherits(Mo, _Oi2);

        var _super4 = _createSuper(Mo);

        function Mo(t, e, n, i) {
          var _this19;

          _classCallCheck(this, Mo);

          if (_this19 = _super4.call(this, t), _this19.name = e, _this19._attrs = function (t) {
            t = Vi(t);

            var _iterator22 = _createForOfIteratorHelper(t),
                _step22;

            try {
              for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
                var _step22$value = _slicedToArray(_step22.value, 2),
                    _e22 = _step22$value[0],
                    _n18 = _step22$value[1];

                null === _n18 ? t.delete(_e22) : "string" != typeof _n18 && t.set(_e22, String(_n18));
              }
            } catch (err) {
              _iterator22.e(err);
            } finally {
              _iterator22.f();
            }

            return t;
          }(n), _this19._children = [], i && _this19._insertChild(0, i), _this19._classes = new Set(), _this19._attrs.has("class")) {
            var _t23 = _this19._attrs.get("class");

            To(_this19._classes, _t23), _this19._attrs.delete("class");
          }

          _this19._styles = new Eo(_this19.document.stylesProcessor), _this19._attrs.has("style") && (_this19._styles.setTo(_this19._attrs.get("style")), _this19._attrs.delete("style")), _this19._customProperties = new Map(), _this19._isAllowedInsideAttributeElement = !1, _this19._unsafeAttributesToRender = [];
          return _possibleConstructorReturn(_this19);
        }

        _createClass(Mo, [{
          key: "childCount",
          get: function get() {
            return this._children.length;
          }
        }, {
          key: "isEmpty",
          get: function get() {
            return 0 === this._children.length;
          }
        }, {
          key: "isAllowedInsideAttributeElement",
          get: function get() {
            return this._isAllowedInsideAttributeElement;
          }
        }, {
          key: "is",
          value: function is(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            return e ? e === this.name && ("element" === t || "view:element" === t) : "element" === t || "view:element" === t || "node" === t || "view:node" === t;
          }
        }, {
          key: "getChild",
          value: function getChild(t) {
            return this._children[t];
          }
        }, {
          key: "getChildIndex",
          value: function getChildIndex(t) {
            return this._children.indexOf(t);
          }
        }, {
          key: "getChildren",
          value: function getChildren() {
            return this._children[Symbol.iterator]();
          }
        }, {
          key: "getAttributeKeys",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function getAttributeKeys() {
            return _regeneratorRuntime.wrap(function getAttributeKeys$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.t0 = this._classes.size > 0;

                    if (!_context3.t0) {
                      _context3.next = 4;
                      break;
                    }

                    _context3.next = 4;
                    return "class";

                  case 4:
                    _context3.t1 = this._styles.isEmpty;

                    if (_context3.t1) {
                      _context3.next = 8;
                      break;
                    }

                    _context3.next = 8;
                    return "style";

                  case 8:
                    return _context3.delegateYield(this._attrs.keys(), "t2", 9);

                  case 9:
                  case "end":
                    return _context3.stop();
                }
              }
            }, getAttributeKeys, this);
          })
        }, {
          key: "getAttributes",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function getAttributes() {
            return _regeneratorRuntime.wrap(function getAttributes$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    return _context4.delegateYield(this._attrs.entries(), "t0", 1);

                  case 1:
                    _context4.t1 = this._classes.size > 0;

                    if (!_context4.t1) {
                      _context4.next = 5;
                      break;
                    }

                    _context4.next = 5;
                    return ["class", this.getAttribute("class")];

                  case 5:
                    _context4.t2 = this._styles.isEmpty;

                    if (_context4.t2) {
                      _context4.next = 9;
                      break;
                    }

                    _context4.next = 9;
                    return ["style", this.getAttribute("style")];

                  case 9:
                  case "end":
                    return _context4.stop();
                }
              }
            }, getAttributes, this);
          })
        }, {
          key: "getAttribute",
          value: function getAttribute(t) {
            if ("class" == t) return this._classes.size > 0 ? _toConsumableArray(this._classes).join(" ") : void 0;

            if ("style" == t) {
              var _t24 = this._styles.toString();

              return "" == _t24 ? void 0 : _t24;
            }

            return this._attrs.get(t);
          }
        }, {
          key: "hasAttribute",
          value: function hasAttribute(t) {
            return "class" == t ? this._classes.size > 0 : "style" == t ? !this._styles.isEmpty : this._attrs.has(t);
          }
        }, {
          key: "isSimilar",
          value: function isSimilar(t) {
            if (!(t instanceof Mo)) return !1;
            if (this === t) return !0;
            if (this.name != t.name) return !1;
            if (this.isAllowedInsideAttributeElement != t.isAllowedInsideAttributeElement) return !1;
            if (this._attrs.size !== t._attrs.size || this._classes.size !== t._classes.size || this._styles.size !== t._styles.size) return !1;

            var _iterator23 = _createForOfIteratorHelper(this._attrs),
                _step23;

            try {
              for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
                var _step23$value = _slicedToArray(_step23.value, 2),
                    _e23 = _step23$value[0],
                    _n19 = _step23$value[1];

                if (!t._attrs.has(_e23) || t._attrs.get(_e23) !== _n19) return !1;
              }
            } catch (err) {
              _iterator23.e(err);
            } finally {
              _iterator23.f();
            }

            var _iterator24 = _createForOfIteratorHelper(this._classes),
                _step24;

            try {
              for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
                var _e24 = _step24.value;
                if (!t._classes.has(_e24)) return !1;
              }
            } catch (err) {
              _iterator24.e(err);
            } finally {
              _iterator24.f();
            }

            var _iterator25 = _createForOfIteratorHelper(this._styles.getStyleNames()),
                _step25;

            try {
              for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
                var _e25 = _step25.value;
                if (!t._styles.has(_e25) || t._styles.getAsString(_e25) !== this._styles.getAsString(_e25)) return !1;
              }
            } catch (err) {
              _iterator25.e(err);
            } finally {
              _iterator25.f();
            }

            return !0;
          }
        }, {
          key: "hasClass",
          value: function hasClass() {
            for (var _len13 = arguments.length, t = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
              t[_key13] = arguments[_key13];
            }

            for (var _i16 = 0, _t25 = t; _i16 < _t25.length; _i16++) {
              var _e26 = _t25[_i16];
              if (!this._classes.has(_e26)) return !1;
            }

            return !0;
          }
        }, {
          key: "getClassNames",
          value: function getClassNames() {
            return this._classes.keys();
          }
        }, {
          key: "getStyle",
          value: function getStyle(t) {
            return this._styles.getAsString(t);
          }
        }, {
          key: "getNormalizedStyle",
          value: function getNormalizedStyle(t) {
            return this._styles.getNormalized(t);
          }
        }, {
          key: "getStyleNames",
          value: function getStyleNames() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
            return this._styles.getStyleNames(t);
          }
        }, {
          key: "hasStyle",
          value: function hasStyle() {
            for (var _len14 = arguments.length, t = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
              t[_key14] = arguments[_key14];
            }

            for (var _i17 = 0, _t26 = t; _i17 < _t26.length; _i17++) {
              var _e27 = _t26[_i17];
              if (!this._styles.has(_e27)) return !1;
            }

            return !0;
          }
        }, {
          key: "findAncestor",
          value: function findAncestor() {
            for (var _len15 = arguments.length, t = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
              t[_key15] = arguments[_key15];
            }

            var e = _construct(Ui, t);

            var n = this.parent;

            for (; n;) {
              if (e.match(n)) return n;
              n = n.parent;
            }

            return null;
          }
        }, {
          key: "getCustomProperty",
          value: function getCustomProperty(t) {
            return this._customProperties.get(t);
          }
        }, {
          key: "getCustomProperties",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function getCustomProperties() {
            return _regeneratorRuntime.wrap(function getCustomProperties$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    return _context5.delegateYield(this._customProperties.entries(), "t0", 1);

                  case 1:
                  case "end":
                    return _context5.stop();
                }
              }
            }, getCustomProperties, this);
          })
        }, {
          key: "getIdentity",
          value: function getIdentity() {
            var t = Array.from(this._classes).sort().join(","),
                e = this._styles.toString(),
                n = Array.from(this._attrs).map(function (t) {
              return "".concat(t[0], "=\"").concat(t[1], "\"");
            }).sort().join(" ");

            return this.name + ("" == t ? "" : " class=\"".concat(t, "\"")) + (e ? " style=\"".concat(e, "\"") : "") + ("" == n ? "" : " ".concat(n));
          }
        }, {
          key: "shouldRenderUnsafeAttribute",
          value: function shouldRenderUnsafeAttribute(t) {
            return this._unsafeAttributesToRender.includes(t);
          }
        }, {
          key: "_clone",
          value: function _clone() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
            var e = [];

            if (t) {
              var _iterator26 = _createForOfIteratorHelper(this.getChildren()),
                  _step26;

              try {
                for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
                  var _n20 = _step26.value;
                  e.push(_n20._clone(t));
                }
              } catch (err) {
                _iterator26.e(err);
              } finally {
                _iterator26.f();
              }
            }

            var n = new this.constructor(this.document, this.name, this._attrs, e);
            return n._classes = new Set(this._classes), n._styles.set(this._styles.getNormalized()), n._customProperties = new Map(this._customProperties), n.getFillerOffset = this.getFillerOffset, n._isAllowedInsideAttributeElement = this.isAllowedInsideAttributeElement, n;
          }
        }, {
          key: "_appendChild",
          value: function _appendChild(t) {
            return this._insertChild(this.childCount, t);
          }
        }, {
          key: "_insertChild",
          value: function _insertChild(t, e) {
            this._fireChange("children", this);

            var n = 0;

            var i = function (t, e) {
              if ("string" == typeof e) return [new ji(t, e)];
              Ei(e) || (e = [e]);
              return Array.from(e).map(function (e) {
                return "string" == typeof e ? new ji(t, e) : e instanceof Fi ? new ji(t, e.data) : e;
              });
            }(this.document, e);

            var _iterator27 = _createForOfIteratorHelper(i),
                _step27;

            try {
              for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
                var _e28 = _step27.value;
                null !== _e28.parent && _e28._remove(), _e28.parent = this, _e28.document = this.document, this._children.splice(t, 0, _e28), t++, n++;
              }
            } catch (err) {
              _iterator27.e(err);
            } finally {
              _iterator27.f();
            }

            return n;
          }
        }, {
          key: "_removeChildren",
          value: function _removeChildren(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            this._fireChange("children", this);

            for (var _n21 = t; _n21 < t + e; _n21++) {
              this._children[_n21].parent = null;
            }

            return this._children.splice(t, e);
          }
        }, {
          key: "_setAttribute",
          value: function _setAttribute(t, e) {
            e = String(e), this._fireChange("attributes", this), "class" == t ? To(this._classes, e) : "style" == t ? this._styles.setTo(e) : this._attrs.set(t, e);
          }
        }, {
          key: "_removeAttribute",
          value: function _removeAttribute(t) {
            return this._fireChange("attributes", this), "class" == t ? this._classes.size > 0 && (this._classes.clear(), !0) : "style" == t ? !this._styles.isEmpty && (this._styles.clear(), !0) : this._attrs.delete(t);
          }
        }, {
          key: "_addClass",
          value: function _addClass(t) {
            this._fireChange("attributes", this);

            var _iterator28 = _createForOfIteratorHelper(Ii(t)),
                _step28;

            try {
              for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
                var _e29 = _step28.value;

                this._classes.add(_e29);
              }
            } catch (err) {
              _iterator28.e(err);
            } finally {
              _iterator28.f();
            }
          }
        }, {
          key: "_removeClass",
          value: function _removeClass(t) {
            this._fireChange("attributes", this);

            var _iterator29 = _createForOfIteratorHelper(Ii(t)),
                _step29;

            try {
              for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
                var _e30 = _step29.value;

                this._classes.delete(_e30);
              }
            } catch (err) {
              _iterator29.e(err);
            } finally {
              _iterator29.f();
            }
          }
        }, {
          key: "_setStyle",
          value: function _setStyle(t, e) {
            this._fireChange("attributes", this), this._styles.set(t, e);
          }
        }, {
          key: "_removeStyle",
          value: function _removeStyle(t) {
            this._fireChange("attributes", this);

            var _iterator30 = _createForOfIteratorHelper(Ii(t)),
                _step30;

            try {
              for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
                var _e31 = _step30.value;

                this._styles.remove(_e31);
              }
            } catch (err) {
              _iterator30.e(err);
            } finally {
              _iterator30.f();
            }
          }
        }, {
          key: "_setCustomProperty",
          value: function _setCustomProperty(t, e) {
            this._customProperties.set(t, e);
          }
        }, {
          key: "_removeCustomProperty",
          value: function _removeCustomProperty(t) {
            return this._customProperties.delete(t);
          }
        }]);

        return Mo;
      }(Oi);

      function To(t, e) {
        var n = e.split(/\s+/);
        t.clear(), n.forEach(function (e) {
          return t.add(e);
        });
      }

      var No = /*#__PURE__*/function (_Mo) {
        _inherits(No, _Mo);

        var _super5 = _createSuper(No);

        function No(t, e, n, i) {
          var _this20;

          _classCallCheck(this, No);

          _this20 = _super5.call(this, t, e, n, i), _this20.getFillerOffset = Bo;
          return _this20;
        }

        _createClass(No, [{
          key: "is",
          value: function is(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            return e ? e === this.name && ("containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t) : "containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
          }
        }]);

        return No;
      }(Mo);

      function Bo() {
        var t = _toConsumableArray(this.getChildren()),
            e = t[this.childCount - 1];

        if (e && e.is("element", "br")) return this.childCount;

        var _iterator31 = _createForOfIteratorHelper(t),
            _step31;

        try {
          for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
            var _e32 = _step31.value;
            if (!_e32.is("uiElement")) return null;
          }
        } catch (err) {
          _iterator31.e(err);
        } finally {
          _iterator31.f();
        }

        return this.childCount;
      }

      var zo = /*#__PURE__*/function (_No) {
        _inherits(zo, _No);

        var _super6 = _createSuper(zo);

        function zo(t, e, n, i) {
          var _this21;

          _classCallCheck(this, zo);

          _this21 = _super6.call(this, t, e, n, i), _this21.set("isReadOnly", !1), _this21.set("isFocused", !1), _this21.bind("isReadOnly").to(t), _this21.bind("isFocused").to(t, "isFocused", function (e) {
            return e && t.selection.editableElement == _assertThisInitialized(_this21);
          }), _this21.listenTo(t.selection, "change", function () {
            _this21.isFocused = t.isFocused && t.selection.editableElement == _assertThisInitialized(_this21);
          });
          return _this21;
        }

        _createClass(zo, [{
          key: "is",
          value: function is(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            return e ? e === this.name && ("editableElement" === t || "view:editableElement" === t || "containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t) : "editableElement" === t || "view:editableElement" === t || "containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.stopListening();
          }
        }]);

        return zo;
      }(No);

      he(zo, re);
      var Po = Symbol("rootName");

      var Lo = /*#__PURE__*/function (_zo) {
        _inherits(Lo, _zo);

        var _super7 = _createSuper(Lo);

        function Lo(t, e) {
          var _this22;

          _classCallCheck(this, Lo);

          _this22 = _super7.call(this, t, e), _this22.rootName = "main";
          return _this22;
        }

        _createClass(Lo, [{
          key: "is",
          value: function is(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            return e ? e === this.name && ("rootElement" === t || "view:rootElement" === t || "editableElement" === t || "view:editableElement" === t || "containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t) : "rootElement" === t || "view:rootElement" === t || "editableElement" === t || "view:editableElement" === t || "containerElement" === t || "view:containerElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
          }
        }, {
          key: "rootName",
          get: function get() {
            return this.getCustomProperty(Po);
          },
          set: function set(t) {
            this._setCustomProperty(Po, t);
          }
        }, {
          key: "_name",
          set: function set(t) {
            this.name = t;
          }
        }]);

        return Lo;
      }(zo);

      var Ro = /*#__PURE__*/function (_Symbol$iterator3) {
        function Ro() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          _classCallCheck(this, Ro);

          if (!t.boundaries && !t.startPosition) throw new a("view-tree-walker-no-start-position", null);
          if (t.direction && "forward" != t.direction && "backward" != t.direction) throw new a("view-tree-walker-unknown-direction", t.startPosition, {
            direction: t.direction
          });
          this.boundaries = t.boundaries || null, t.startPosition ? this.position = Oo._createAt(t.startPosition) : this.position = Oo._createAt(t.boundaries["backward" == t.direction ? "end" : "start"]), this.direction = t.direction || "forward", this.singleCharacters = !!t.singleCharacters, this.shallow = !!t.shallow, this.ignoreElementEnd = !!t.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
        }

        _createClass(Ro, [{
          key: _Symbol$iterator3,
          value: function value() {
            return this;
          }
        }, {
          key: "skip",
          value: function skip(t) {
            var e, n, i;

            do {
              var _this$next;

              i = this.position, (_this$next = this.next(), e = _this$next.done, n = _this$next.value, _this$next);
            } while (!e && t(n));

            e || (this.position = i);
          }
        }, {
          key: "next",
          value: function next() {
            return "forward" == this.direction ? this._next() : this._previous();
          }
        }, {
          key: "_next",
          value: function _next() {
            var t = this.position.clone();
            var e = this.position,
                n = t.parent;
            if (null === n.parent && t.offset === n.childCount) return {
              done: !0
            };
            if (n === this._boundaryEndParent && t.offset == this.boundaries.end.offset) return {
              done: !0
            };
            var i;

            if (n instanceof ji) {
              if (t.isAtEnd) return this.position = Oo._createAfter(n), this._next();
              i = n.data[t.offset];
            } else i = n.getChild(t.offset);

            if (i instanceof Mo) return this.shallow ? t.offset++ : t = new Oo(i, 0), this.position = t, this._formatReturnValue("elementStart", i, e, t, 1);

            if (i instanceof ji) {
              if (this.singleCharacters) return t = new Oo(i, 0), this.position = t, this._next();
              {
                var _n22,
                    _o8 = i.data.length;

                return i == this._boundaryEndParent ? (_o8 = this.boundaries.end.offset, _n22 = new Fi(i, 0, _o8), t = Oo._createAfter(_n22)) : (_n22 = new Fi(i, 0, i.data.length), t.offset++), this.position = t, this._formatReturnValue("text", _n22, e, t, _o8);
              }
            }

            if ("string" == typeof i) {
              var _i18;

              if (this.singleCharacters) _i18 = 1;else {
                _i18 = (n === this._boundaryEndParent ? this.boundaries.end.offset : n.data.length) - t.offset;
              }

              var _o9 = new Fi(n, t.offset, _i18);

              return t.offset += _i18, this.position = t, this._formatReturnValue("text", _o9, e, t, _i18);
            }

            return t = Oo._createAfter(n), this.position = t, this.ignoreElementEnd ? this._next() : this._formatReturnValue("elementEnd", n, e, t);
          }
        }, {
          key: "_previous",
          value: function _previous() {
            var t = this.position.clone();
            var e = this.position,
                n = t.parent;
            if (null === n.parent && 0 === t.offset) return {
              done: !0
            };
            if (n == this._boundaryStartParent && t.offset == this.boundaries.start.offset) return {
              done: !0
            };
            var i;

            if (n instanceof ji) {
              if (t.isAtStart) return this.position = Oo._createBefore(n), this._previous();
              i = n.data[t.offset - 1];
            } else i = n.getChild(t.offset - 1);

            if (i instanceof Mo) return this.shallow ? (t.offset--, this.position = t, this._formatReturnValue("elementStart", i, e, t, 1)) : (t = new Oo(i, i.childCount), this.position = t, this.ignoreElementEnd ? this._previous() : this._formatReturnValue("elementEnd", i, e, t));

            if (i instanceof ji) {
              if (this.singleCharacters) return t = new Oo(i, i.data.length), this.position = t, this._previous();
              {
                var _n23,
                    _o10 = i.data.length;

                if (i == this._boundaryStartParent) {
                  var _e33 = this.boundaries.start.offset;
                  _n23 = new Fi(i, _e33, i.data.length - _e33), _o10 = _n23.data.length, t = Oo._createBefore(_n23);
                } else _n23 = new Fi(i, 0, i.data.length), t.offset--;

                return this.position = t, this._formatReturnValue("text", _n23, e, t, _o10);
              }
            }

            if ("string" == typeof i) {
              var _i19;

              if (this.singleCharacters) _i19 = 1;else {
                var _e34 = n === this._boundaryStartParent ? this.boundaries.start.offset : 0;

                _i19 = t.offset - _e34;
              }
              t.offset -= _i19;

              var _o11 = new Fi(n, t.offset, _i19);

              return this.position = t, this._formatReturnValue("text", _o11, e, t, _i19);
            }

            return t = Oo._createBefore(n), this.position = t, this._formatReturnValue("elementStart", n, e, t, 1);
          }
        }, {
          key: "_formatReturnValue",
          value: function _formatReturnValue(t, e, n, i, o) {
            return e instanceof Fi && (e.offsetInText + e.data.length == e.textNode.data.length && ("forward" != this.direction || this.boundaries && this.boundaries.end.isEqual(this.position) ? n = Oo._createAfter(e.textNode) : (i = Oo._createAfter(e.textNode), this.position = i)), 0 === e.offsetInText && ("backward" != this.direction || this.boundaries && this.boundaries.start.isEqual(this.position) ? n = Oo._createBefore(e.textNode) : (i = Oo._createBefore(e.textNode), this.position = i))), {
              done: !1,
              value: {
                type: t,
                item: e,
                previousPosition: n,
                nextPosition: i,
                length: o
              }
            };
          }
        }]);

        return Ro;
      }(Symbol.iterator);

      var Oo = /*#__PURE__*/function () {
        function Oo(t, e) {
          _classCallCheck(this, Oo);

          this.parent = t, this.offset = e;
        }

        _createClass(Oo, [{
          key: "nodeAfter",
          get: function get() {
            return this.parent.is("$text") ? null : this.parent.getChild(this.offset) || null;
          }
        }, {
          key: "nodeBefore",
          get: function get() {
            return this.parent.is("$text") ? null : this.parent.getChild(this.offset - 1) || null;
          }
        }, {
          key: "isAtStart",
          get: function get() {
            return 0 === this.offset;
          }
        }, {
          key: "isAtEnd",
          get: function get() {
            var t = this.parent.is("$text") ? this.parent.data.length : this.parent.childCount;
            return this.offset === t;
          }
        }, {
          key: "root",
          get: function get() {
            return this.parent.root;
          }
        }, {
          key: "editableElement",
          get: function get() {
            var t = this.parent;

            for (; !(t instanceof zo);) {
              if (!t.parent) return null;
              t = t.parent;
            }

            return t;
          }
        }, {
          key: "getShiftedBy",
          value: function getShiftedBy(t) {
            var e = Oo._createAt(this),
                n = e.offset + t;

            return e.offset = n < 0 ? 0 : n, e;
          }
        }, {
          key: "getLastMatchingPosition",
          value: function getLastMatchingPosition(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            e.startPosition = this;
            var n = new Ro(e);
            return n.skip(t), n.position;
          }
        }, {
          key: "getAncestors",
          value: function getAncestors() {
            return this.parent.is("documentFragment") ? [this.parent] : this.parent.getAncestors({
              includeSelf: !0
            });
          }
        }, {
          key: "getCommonAncestor",
          value: function getCommonAncestor(t) {
            var e = this.getAncestors(),
                n = t.getAncestors();
            var i = 0;

            for (; e[i] == n[i] && e[i];) {
              i++;
            }

            return 0 === i ? null : e[i - 1];
          }
        }, {
          key: "is",
          value: function is(t) {
            return "position" === t || "view:position" === t;
          }
        }, {
          key: "isEqual",
          value: function isEqual(t) {
            return this.parent == t.parent && this.offset == t.offset;
          }
        }, {
          key: "isBefore",
          value: function isBefore(t) {
            return "before" == this.compareWith(t);
          }
        }, {
          key: "isAfter",
          value: function isAfter(t) {
            return "after" == this.compareWith(t);
          }
        }, {
          key: "compareWith",
          value: function compareWith(t) {
            if (this.root !== t.root) return "different";
            if (this.isEqual(t)) return "same";
            var e = this.parent.is("node") ? this.parent.getPath() : [],
                n = t.parent.is("node") ? t.parent.getPath() : [];
            e.push(this.offset), n.push(t.offset);
            var i = Li(e, n);

            switch (i) {
              case "prefix":
                return "before";

              case "extension":
                return "after";

              default:
                return e[i] < n[i] ? "before" : "after";
            }
          }
        }, {
          key: "getWalker",
          value: function getWalker() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return t.startPosition = this, new Ro(t);
          }
        }, {
          key: "clone",
          value: function clone() {
            return new Oo(this.parent, this.offset);
          }
        }], [{
          key: "_createAt",
          value: function _createAt(t, e) {
            if (t instanceof Oo) return new this(t.parent, t.offset);
            {
              var _n24 = t;
              if ("end" == e) e = _n24.is("$text") ? _n24.data.length : _n24.childCount;else {
                if ("before" == e) return this._createBefore(_n24);
                if ("after" == e) return this._createAfter(_n24);
                if (0 !== e && !e) throw new a("view-createpositionat-offset-required", _n24);
              }
              return new Oo(_n24, e);
            }
          }
        }, {
          key: "_createAfter",
          value: function _createAfter(t) {
            if (t.is("$textProxy")) return new Oo(t.textNode, t.offsetInText + t.data.length);
            if (!t.parent) throw new a("view-position-after-root", t, {
              root: t
            });
            return new Oo(t.parent, t.index + 1);
          }
        }, {
          key: "_createBefore",
          value: function _createBefore(t) {
            if (t.is("$textProxy")) return new Oo(t.textNode, t.offsetInText);
            if (!t.parent) throw new a("view-position-before-root", t, {
              root: t
            });
            return new Oo(t.parent, t.index);
          }
        }]);

        return Oo;
      }();

      var jo = /*#__PURE__*/function (_Symbol$iterator4) {
        function jo(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

          _classCallCheck(this, jo);

          this.start = t.clone(), this.end = e ? e.clone() : t.clone();
        }

        _createClass(jo, [{
          key: _Symbol$iterator4,
          value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
            return _regeneratorRuntime.wrap(function value$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    return _context6.delegateYield(new Ro({
                      boundaries: this,
                      ignoreElementEnd: !0
                    }), "t0", 1);

                  case 1:
                  case "end":
                    return _context6.stop();
                }
              }
            }, value, this);
          })
        }, {
          key: "isCollapsed",
          get: function get() {
            return this.start.isEqual(this.end);
          }
        }, {
          key: "isFlat",
          get: function get() {
            return this.start.parent === this.end.parent;
          }
        }, {
          key: "root",
          get: function get() {
            return this.start.root;
          }
        }, {
          key: "getEnlarged",
          value: function getEnlarged() {
            var t = this.start.getLastMatchingPosition(Fo, {
              direction: "backward"
            }),
                e = this.end.getLastMatchingPosition(Fo);
            return t.parent.is("$text") && t.isAtStart && (t = Oo._createBefore(t.parent)), e.parent.is("$text") && e.isAtEnd && (e = Oo._createAfter(e.parent)), new jo(t, e);
          }
        }, {
          key: "getTrimmed",
          value: function getTrimmed() {
            var t = this.start.getLastMatchingPosition(Fo);
            if (t.isAfter(this.end) || t.isEqual(this.end)) return new jo(t, t);
            var e = this.end.getLastMatchingPosition(Fo, {
              direction: "backward"
            });
            var n = t.nodeAfter,
                i = e.nodeBefore;
            return n && n.is("$text") && (t = new Oo(n, 0)), i && i.is("$text") && (e = new Oo(i, i.data.length)), new jo(t, e);
          }
        }, {
          key: "isEqual",
          value: function isEqual(t) {
            return this == t || this.start.isEqual(t.start) && this.end.isEqual(t.end);
          }
        }, {
          key: "containsPosition",
          value: function containsPosition(t) {
            return t.isAfter(this.start) && t.isBefore(this.end);
          }
        }, {
          key: "containsRange",
          value: function containsRange(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            t.isCollapsed && (e = !1);
            var n = this.containsPosition(t.start) || e && this.start.isEqual(t.start),
                i = this.containsPosition(t.end) || e && this.end.isEqual(t.end);
            return n && i;
          }
        }, {
          key: "getDifference",
          value: function getDifference(t) {
            var e = [];
            return this.isIntersecting(t) ? (this.containsPosition(t.start) && e.push(new jo(this.start, t.start)), this.containsPosition(t.end) && e.push(new jo(t.end, this.end))) : e.push(this.clone()), e;
          }
        }, {
          key: "getIntersection",
          value: function getIntersection(t) {
            if (this.isIntersecting(t)) {
              var _e35 = this.start,
                  _n25 = this.end;
              return this.containsPosition(t.start) && (_e35 = t.start), this.containsPosition(t.end) && (_n25 = t.end), new jo(_e35, _n25);
            }

            return null;
          }
        }, {
          key: "getWalker",
          value: function getWalker() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return t.boundaries = this, new Ro(t);
          }
        }, {
          key: "getCommonAncestor",
          value: function getCommonAncestor() {
            return this.start.getCommonAncestor(this.end);
          }
        }, {
          key: "getContainedElement",
          value: function getContainedElement() {
            if (this.isCollapsed) return null;
            var t = this.start.nodeAfter,
                e = this.end.nodeBefore;
            return this.start.parent.is("$text") && this.start.isAtEnd && this.start.parent.nextSibling && (t = this.start.parent.nextSibling), this.end.parent.is("$text") && this.end.isAtStart && this.end.parent.previousSibling && (e = this.end.parent.previousSibling), t && t.is("element") && t === e ? t : null;
          }
        }, {
          key: "clone",
          value: function clone() {
            return new jo(this.start, this.end);
          }
        }, {
          key: "getItems",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function getItems() {
            var t,
                e,
                _iterator32,
                _step32,
                _t27,
                _args7 = arguments;

            return _regeneratorRuntime.wrap(function getItems$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    t = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
                    t.boundaries = this, t.ignoreElementEnd = !0;
                    e = new Ro(t);
                    _iterator32 = _createForOfIteratorHelper(e);
                    _context7.prev = 4;

                    _iterator32.s();

                  case 6:
                    if ((_step32 = _iterator32.n()).done) {
                      _context7.next = 12;
                      break;
                    }

                    _t27 = _step32.value;
                    _context7.next = 10;
                    return _t27.item;

                  case 10:
                    _context7.next = 6;
                    break;

                  case 12:
                    _context7.next = 17;
                    break;

                  case 14:
                    _context7.prev = 14;
                    _context7.t0 = _context7["catch"](4);

                    _iterator32.e(_context7.t0);

                  case 17:
                    _context7.prev = 17;

                    _iterator32.f();

                    return _context7.finish(17);

                  case 20:
                  case "end":
                    return _context7.stop();
                }
              }
            }, getItems, this, [[4, 14, 17, 20]]);
          })
        }, {
          key: "getPositions",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function getPositions() {
            var t,
                e,
                _iterator33,
                _step33,
                _t28,
                _args8 = arguments;

            return _regeneratorRuntime.wrap(function getPositions$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    t = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
                    t.boundaries = this;
                    e = new Ro(t);
                    _context8.next = 5;
                    return e.position;

                  case 5:
                    _iterator33 = _createForOfIteratorHelper(e);
                    _context8.prev = 6;

                    _iterator33.s();

                  case 8:
                    if ((_step33 = _iterator33.n()).done) {
                      _context8.next = 14;
                      break;
                    }

                    _t28 = _step33.value;
                    _context8.next = 12;
                    return _t28.nextPosition;

                  case 12:
                    _context8.next = 8;
                    break;

                  case 14:
                    _context8.next = 19;
                    break;

                  case 16:
                    _context8.prev = 16;
                    _context8.t0 = _context8["catch"](6);

                    _iterator33.e(_context8.t0);

                  case 19:
                    _context8.prev = 19;

                    _iterator33.f();

                    return _context8.finish(19);

                  case 22:
                  case "end":
                    return _context8.stop();
                }
              }
            }, getPositions, this, [[6, 16, 19, 22]]);
          })
        }, {
          key: "is",
          value: function is(t) {
            return "range" === t || "view:range" === t;
          }
        }, {
          key: "isIntersecting",
          value: function isIntersecting(t) {
            return this.start.isBefore(t.end) && this.end.isAfter(t.start);
          }
        }], [{
          key: "_createFromParentsAndOffsets",
          value: function _createFromParentsAndOffsets(t, e, n, i) {
            return new this(new Oo(t, e), new Oo(n, i));
          }
        }, {
          key: "_createFromPositionAndShift",
          value: function _createFromPositionAndShift(t, e) {
            var n = t,
                i = t.getShiftedBy(e);
            return e > 0 ? new this(n, i) : new this(i, n);
          }
        }, {
          key: "_createIn",
          value: function _createIn(t) {
            return this._createFromParentsAndOffsets(t, 0, t, t.childCount);
          }
        }, {
          key: "_createOn",
          value: function _createOn(t) {
            var e = t.is("$textProxy") ? t.offsetSize : 1;
            return this._createFromPositionAndShift(Oo._createBefore(t), e);
          }
        }]);

        return jo;
      }(Symbol.iterator);

      function Fo(t) {
        return !(!t.item.is("attributeElement") && !t.item.is("uiElement"));
      }

      function Vo(t) {
        var e = 0;

        var _iterator34 = _createForOfIteratorHelper(t),
            _step34;

        try {
          for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
            var _n26 = _step34.value;
            e++;
          }
        } catch (err) {
          _iterator34.e(err);
        } finally {
          _iterator34.f();
        }

        return e;
      }

      var Uo = /*#__PURE__*/function () {
        function Uo() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          var e = arguments.length > 1 ? arguments[1] : undefined;
          var n = arguments.length > 2 ? arguments[2] : undefined;

          _classCallCheck(this, Uo);

          this._ranges = [], this._lastRangeBackward = !1, this._isFake = !1, this._fakeSelectionLabel = "", this.setTo(t, e, n);
        }

        _createClass(Uo, [{
          key: "isFake",
          get: function get() {
            return this._isFake;
          }
        }, {
          key: "fakeSelectionLabel",
          get: function get() {
            return this._fakeSelectionLabel;
          }
        }, {
          key: "anchor",
          get: function get() {
            if (!this._ranges.length) return null;
            var t = this._ranges[this._ranges.length - 1];
            return (this._lastRangeBackward ? t.end : t.start).clone();
          }
        }, {
          key: "focus",
          get: function get() {
            if (!this._ranges.length) return null;
            var t = this._ranges[this._ranges.length - 1];
            return (this._lastRangeBackward ? t.start : t.end).clone();
          }
        }, {
          key: "isCollapsed",
          get: function get() {
            return 1 === this.rangeCount && this._ranges[0].isCollapsed;
          }
        }, {
          key: "rangeCount",
          get: function get() {
            return this._ranges.length;
          }
        }, {
          key: "isBackward",
          get: function get() {
            return !this.isCollapsed && this._lastRangeBackward;
          }
        }, {
          key: "editableElement",
          get: function get() {
            return this.anchor ? this.anchor.editableElement : null;
          }
        }, {
          key: "getRanges",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function getRanges() {
            var _iterator35, _step35, _t29;

            return _regeneratorRuntime.wrap(function getRanges$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    _iterator35 = _createForOfIteratorHelper(this._ranges);
                    _context9.prev = 1;

                    _iterator35.s();

                  case 3:
                    if ((_step35 = _iterator35.n()).done) {
                      _context9.next = 9;
                      break;
                    }

                    _t29 = _step35.value;
                    _context9.next = 7;
                    return _t29.clone();

                  case 7:
                    _context9.next = 3;
                    break;

                  case 9:
                    _context9.next = 14;
                    break;

                  case 11:
                    _context9.prev = 11;
                    _context9.t0 = _context9["catch"](1);

                    _iterator35.e(_context9.t0);

                  case 14:
                    _context9.prev = 14;

                    _iterator35.f();

                    return _context9.finish(14);

                  case 17:
                  case "end":
                    return _context9.stop();
                }
              }
            }, getRanges, this, [[1, 11, 14, 17]]);
          })
        }, {
          key: "getFirstRange",
          value: function getFirstRange() {
            var t = null;

            var _iterator36 = _createForOfIteratorHelper(this._ranges),
                _step36;

            try {
              for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
                var _e36 = _step36.value;
                t && !_e36.start.isBefore(t.start) || (t = _e36);
              }
            } catch (err) {
              _iterator36.e(err);
            } finally {
              _iterator36.f();
            }

            return t ? t.clone() : null;
          }
        }, {
          key: "getLastRange",
          value: function getLastRange() {
            var t = null;

            var _iterator37 = _createForOfIteratorHelper(this._ranges),
                _step37;

            try {
              for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
                var _e37 = _step37.value;
                t && !_e37.end.isAfter(t.end) || (t = _e37);
              }
            } catch (err) {
              _iterator37.e(err);
            } finally {
              _iterator37.f();
            }

            return t ? t.clone() : null;
          }
        }, {
          key: "getFirstPosition",
          value: function getFirstPosition() {
            var t = this.getFirstRange();
            return t ? t.start.clone() : null;
          }
        }, {
          key: "getLastPosition",
          value: function getLastPosition() {
            var t = this.getLastRange();
            return t ? t.end.clone() : null;
          }
        }, {
          key: "isEqual",
          value: function isEqual(t) {
            if (this.isFake != t.isFake) return !1;
            if (this.isFake && this.fakeSelectionLabel != t.fakeSelectionLabel) return !1;
            if (this.rangeCount != t.rangeCount) return !1;
            if (0 === this.rangeCount) return !0;
            if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) return !1;

            var _iterator38 = _createForOfIteratorHelper(this._ranges),
                _step38;

            try {
              for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
                var _e38 = _step38.value;

                var _n27 = !1;

                var _iterator39 = _createForOfIteratorHelper(t._ranges),
                    _step39;

                try {
                  for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
                    var _i20 = _step39.value;

                    if (_e38.isEqual(_i20)) {
                      _n27 = !0;
                      break;
                    }
                  }
                } catch (err) {
                  _iterator39.e(err);
                } finally {
                  _iterator39.f();
                }

                if (!_n27) return !1;
              }
            } catch (err) {
              _iterator38.e(err);
            } finally {
              _iterator38.f();
            }

            return !0;
          }
        }, {
          key: "isSimilar",
          value: function isSimilar(t) {
            if (this.isBackward != t.isBackward) return !1;
            var e = Vo(this.getRanges());
            if (e != Vo(t.getRanges())) return !1;
            if (0 == e) return !0;

            var _iterator40 = _createForOfIteratorHelper(this.getRanges()),
                _step40;

            try {
              for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
                var _e39 = _step40.value;
                _e39 = _e39.getTrimmed();

                var _n28 = !1;

                var _iterator41 = _createForOfIteratorHelper(t.getRanges()),
                    _step41;

                try {
                  for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
                    var _i21 = _step41.value;

                    if (_i21 = _i21.getTrimmed(), _e39.start.isEqual(_i21.start) && _e39.end.isEqual(_i21.end)) {
                      _n28 = !0;
                      break;
                    }
                  }
                } catch (err) {
                  _iterator41.e(err);
                } finally {
                  _iterator41.f();
                }

                if (!_n28) return !1;
              }
            } catch (err) {
              _iterator40.e(err);
            } finally {
              _iterator40.f();
            }

            return !0;
          }
        }, {
          key: "getSelectedElement",
          value: function getSelectedElement() {
            return 1 !== this.rangeCount ? null : this.getFirstRange().getContainedElement();
          }
        }, {
          key: "setTo",
          value: function setTo(t, e, n) {
            if (null === t) this._setRanges([]), this._setFakeOptions(e);else if (t instanceof Uo || t instanceof Ho) this._setRanges(t.getRanges(), t.isBackward), this._setFakeOptions({
              fake: t.isFake,
              label: t.fakeSelectionLabel
            });else if (t instanceof jo) this._setRanges([t], e && e.backward), this._setFakeOptions(e);else if (t instanceof Oo) this._setRanges([new jo(t)]), this._setFakeOptions(e);else if (t instanceof Oi) {
              var _i22 = !!n && !!n.backward;

              var _o12;

              if (void 0 === e) throw new a("view-selection-setto-required-second-parameter", this);
              _o12 = "in" == e ? jo._createIn(t) : "on" == e ? jo._createOn(t) : new jo(Oo._createAt(t, e)), this._setRanges([_o12], _i22), this._setFakeOptions(n);
            } else {
              if (!Ei(t)) throw new a("view-selection-setto-not-selectable", this);
              this._setRanges(t, e && e.backward), this._setFakeOptions(e);
            }
            this.fire("change");
          }
        }, {
          key: "setFocus",
          value: function setFocus(t, e) {
            if (null === this.anchor) throw new a("view-selection-setfocus-no-ranges", this);

            var n = Oo._createAt(t, e);

            if ("same" == n.compareWith(this.focus)) return;
            var i = this.anchor;
            this._ranges.pop(), "before" == n.compareWith(i) ? this._addRange(new jo(n, i), !0) : this._addRange(new jo(i, n)), this.fire("change");
          }
        }, {
          key: "is",
          value: function is(t) {
            return "selection" === t || "view:selection" === t;
          }
        }, {
          key: "_setRanges",
          value: function _setRanges(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            t = Array.from(t), this._ranges = [];

            var _iterator42 = _createForOfIteratorHelper(t),
                _step42;

            try {
              for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
                var _e40 = _step42.value;

                this._addRange(_e40);
              }
            } catch (err) {
              _iterator42.e(err);
            } finally {
              _iterator42.f();
            }

            this._lastRangeBackward = !!e;
          }
        }, {
          key: "_setFakeOptions",
          value: function _setFakeOptions() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            this._isFake = !!t.fake, this._fakeSelectionLabel = t.fake && t.label || "";
          }
        }, {
          key: "_addRange",
          value: function _addRange(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            if (!(t instanceof jo)) throw new a("view-selection-add-range-not-range", this);
            this._pushRange(t), this._lastRangeBackward = !!e;
          }
        }, {
          key: "_pushRange",
          value: function _pushRange(t) {
            var _iterator43 = _createForOfIteratorHelper(this._ranges),
                _step43;

            try {
              for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
                var _e41 = _step43.value;
                if (t.isIntersecting(_e41)) throw new a("view-selection-range-intersects", this, {
                  addedRange: t,
                  intersectingRange: _e41
                });
              }
            } catch (err) {
              _iterator43.e(err);
            } finally {
              _iterator43.f();
            }

            this._ranges.push(new jo(t.start, t.end));
          }
        }]);

        return Uo;
      }();

      he(Uo, f);

      var Ho = /*#__PURE__*/function () {
        function Ho() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          var e = arguments.length > 1 ? arguments[1] : undefined;
          var n = arguments.length > 2 ? arguments[2] : undefined;

          _classCallCheck(this, Ho);

          this._selection = new Uo(), this._selection.delegate("change").to(this), this._selection.setTo(t, e, n);
        }

        _createClass(Ho, [{
          key: "isFake",
          get: function get() {
            return this._selection.isFake;
          }
        }, {
          key: "fakeSelectionLabel",
          get: function get() {
            return this._selection.fakeSelectionLabel;
          }
        }, {
          key: "anchor",
          get: function get() {
            return this._selection.anchor;
          }
        }, {
          key: "focus",
          get: function get() {
            return this._selection.focus;
          }
        }, {
          key: "isCollapsed",
          get: function get() {
            return this._selection.isCollapsed;
          }
        }, {
          key: "rangeCount",
          get: function get() {
            return this._selection.rangeCount;
          }
        }, {
          key: "isBackward",
          get: function get() {
            return this._selection.isBackward;
          }
        }, {
          key: "editableElement",
          get: function get() {
            return this._selection.editableElement;
          }
        }, {
          key: "_ranges",
          get: function get() {
            return this._selection._ranges;
          }
        }, {
          key: "getRanges",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function getRanges() {
            return _regeneratorRuntime.wrap(function getRanges$(_context10) {
              while (1) {
                switch (_context10.prev = _context10.next) {
                  case 0:
                    return _context10.delegateYield(this._selection.getRanges(), "t0", 1);

                  case 1:
                  case "end":
                    return _context10.stop();
                }
              }
            }, getRanges, this);
          })
        }, {
          key: "getFirstRange",
          value: function getFirstRange() {
            return this._selection.getFirstRange();
          }
        }, {
          key: "getLastRange",
          value: function getLastRange() {
            return this._selection.getLastRange();
          }
        }, {
          key: "getFirstPosition",
          value: function getFirstPosition() {
            return this._selection.getFirstPosition();
          }
        }, {
          key: "getLastPosition",
          value: function getLastPosition() {
            return this._selection.getLastPosition();
          }
        }, {
          key: "getSelectedElement",
          value: function getSelectedElement() {
            return this._selection.getSelectedElement();
          }
        }, {
          key: "isEqual",
          value: function isEqual(t) {
            return this._selection.isEqual(t);
          }
        }, {
          key: "isSimilar",
          value: function isSimilar(t) {
            return this._selection.isSimilar(t);
          }
        }, {
          key: "is",
          value: function is(t) {
            return "selection" === t || "documentSelection" == t || "view:selection" == t || "view:documentSelection" == t;
          }
        }, {
          key: "_setTo",
          value: function _setTo(t, e, n) {
            this._selection.setTo(t, e, n);
          }
        }, {
          key: "_setFocus",
          value: function _setFocus(t, e) {
            this._selection.setFocus(t, e);
          }
        }]);

        return Ho;
      }();

      he(Ho, f);

      var qo = /*#__PURE__*/function (_e42) {
        _inherits(qo, _e42);

        var _super8 = _createSuper(qo);

        function qo(t, e, n) {
          var _this23;

          _classCallCheck(this, qo);

          _this23 = _super8.call(this, t, e), _this23.startRange = n, _this23._eventPhase = "none", _this23._currentTarget = null;
          return _this23;
        }

        _createClass(qo, [{
          key: "eventPhase",
          get: function get() {
            return this._eventPhase;
          }
        }, {
          key: "currentTarget",
          get: function get() {
            return this._currentTarget;
          }
        }]);

        return qo;
      }(e);

      var Wo = Symbol("bubbling contexts"),
          Go = {
        fire: function fire(t) {
          try {
            var _i23 = t instanceof e ? t : new e(this, t),
                _o13 = Zo(this);

            if (!_o13.size) return;

            for (var _len16 = arguments.length, n = new Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
              n[_key16 - 1] = arguments[_key16];
            }

            if (Yo(_i23, "capturing", this), Ko.apply(void 0, [_o13, "$capture", _i23].concat(n))) return _i23.return;

            var _r8 = _i23.startRange || this.selection.getFirstRange(),
                _s3 = _r8 ? _r8.getContainedElement() : null,
                _a3 = !!_s3 && Boolean(Qo(_o13, _s3));

            var _c2 = _s3 || function (t) {
              if (!t) return null;
              var e = t.start.parent,
                  n = t.end.parent,
                  i = e.getPath(),
                  o = n.getPath();
              return i.length > o.length ? e : n;
            }(_r8);

            if (Yo(_i23, "atTarget", _c2), !_a3) {
              if (Ko.apply(void 0, [_o13, "$text", _i23].concat(n))) return _i23.return;
              Yo(_i23, "bubbling", _c2);
            }

            for (; _c2;) {
              if (_c2.is("rootElement")) {
                if (Ko.apply(void 0, [_o13, "$root", _i23].concat(n))) return _i23.return;
              } else if (_c2.is("element") && Ko.apply(void 0, [_o13, _c2.name, _i23].concat(n))) return _i23.return;

              if (Ko.apply(void 0, [_o13, _c2, _i23].concat(n))) return _i23.return;
              _c2 = _c2.parent, Yo(_i23, "bubbling", _c2);
            }

            return Yo(_i23, "bubbling", this), Ko.apply(void 0, [_o13, "$document", _i23].concat(n)), _i23.return;
          } catch (t) {
            a.rethrowUnexpectedError(t, this);
          }
        },
        _addEventListener: function _addEventListener(t, e, n) {
          var i = Ii(n.context || "$document"),
              o = Zo(this);

          var _iterator44 = _createForOfIteratorHelper(i),
              _step44;

          try {
            for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
              var _r9 = _step44.value;

              var _i24 = o.get(_r9);

              _i24 || (_i24 = Object.create(f), o.set(_r9, _i24)), this.listenTo(_i24, t, e, n);
            }
          } catch (err) {
            _iterator44.e(err);
          } finally {
            _iterator44.f();
          }
        },
        _removeEventListener: function _removeEventListener(t, e) {
          var n = Zo(this);

          var _iterator45 = _createForOfIteratorHelper(n.values()),
              _step45;

          try {
            for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
              var _i25 = _step45.value;
              this.stopListening(_i25, t, e);
            }
          } catch (err) {
            _iterator45.e(err);
          } finally {
            _iterator45.f();
          }
        }
      };
      var $o = Go;

      function Yo(t, e, n) {
        t instanceof qo && (t._eventPhase = e, t._currentTarget = n);
      }

      function Ko(t, e, n) {
        var o = "string" == typeof e ? t.get(e) : Qo(t, e);

        for (var _len17 = arguments.length, i = new Array(_len17 > 3 ? _len17 - 3 : 0), _key17 = 3; _key17 < _len17; _key17++) {
          i[_key17 - 3] = arguments[_key17];
        }

        return !!o && (o.fire.apply(o, [n].concat(i)), n.stop.called);
      }

      function Qo(t, e) {
        var _iterator46 = _createForOfIteratorHelper(t),
            _step46;

        try {
          for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
            var _step46$value = _slicedToArray(_step46.value, 2),
                _n29 = _step46$value[0],
                _i26 = _step46$value[1];

            if ("function" == typeof _n29 && _n29(e)) return _i26;
          }
        } catch (err) {
          _iterator46.e(err);
        } finally {
          _iterator46.f();
        }

        return null;
      }

      function Zo(t) {
        return t[Wo] || (t[Wo] = new Map()), t[Wo];
      }

      var Jo = /*#__PURE__*/function () {
        function Jo(t) {
          _classCallCheck(this, Jo);

          this.selection = new Ho(), this.roots = new Di({
            idProperty: "rootName"
          }), this.stylesProcessor = t, this.set("isReadOnly", !1), this.set("isFocused", !1), this.set("isSelecting", !1), this.set("isComposing", !1), this._postFixers = new Set();
        }

        _createClass(Jo, [{
          key: "getRoot",
          value: function getRoot() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
            return this.roots.get(t);
          }
        }, {
          key: "registerPostFixer",
          value: function registerPostFixer(t) {
            this._postFixers.add(t);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.roots.map(function (t) {
              return t.destroy();
            }), this.stopListening();
          }
        }, {
          key: "_callPostFixers",
          value: function _callPostFixers(t) {
            var e = !1;

            do {
              var _iterator47 = _createForOfIteratorHelper(this._postFixers),
                  _step47;

              try {
                for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
                  var _n30 = _step47.value;
                  if (e = _n30(t), e) break;
                }
              } catch (err) {
                _iterator47.e(err);
              } finally {
                _iterator47.f();
              }
            } while (e);
          }
        }]);

        return Jo;
      }();

      he(Jo, $o), he(Jo, re);

      var Xo = /*#__PURE__*/function (_Mo2) {
        _inherits(Xo, _Mo2);

        var _super9 = _createSuper(Xo);

        function Xo(t, e, n, i) {
          var _this24;

          _classCallCheck(this, Xo);

          _this24 = _super9.call(this, t, e, n, i), _this24.getFillerOffset = tr, _this24._priority = 10, _this24._id = null, _this24._clonesGroup = null;
          return _this24;
        }

        _createClass(Xo, [{
          key: "priority",
          get: function get() {
            return this._priority;
          }
        }, {
          key: "id",
          get: function get() {
            return this._id;
          }
        }, {
          key: "getElementsWithSameId",
          value: function getElementsWithSameId() {
            if (null === this.id) throw new a("attribute-element-get-elements-with-same-id-no-id", this);
            return new Set(this._clonesGroup);
          }
        }, {
          key: "is",
          value: function is(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            return e ? e === this.name && ("attributeElement" === t || "view:attributeElement" === t || "element" === t || "view:element" === t) : "attributeElement" === t || "view:attributeElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
          }
        }, {
          key: "isSimilar",
          value: function isSimilar(t) {
            return null !== this.id || null !== t.id ? this.id === t.id : _get(_getPrototypeOf(Xo.prototype), "isSimilar", this).call(this, t) && this.priority == t.priority;
          }
        }, {
          key: "_clone",
          value: function _clone(t) {
            var e = _get(_getPrototypeOf(Xo.prototype), "_clone", this).call(this, t);

            return e._priority = this._priority, e._id = this._id, e;
          }
        }]);

        return Xo;
      }(Mo);

      function tr() {
        if (er(this)) return null;
        var t = this.parent;

        for (; t && t.is("attributeElement");) {
          if (er(t) > 1) return null;
          t = t.parent;
        }

        return !t || er(t) > 1 ? null : this.childCount;
      }

      function er(t) {
        return Array.from(t.getChildren()).filter(function (t) {
          return !t.is("uiElement");
        }).length;
      }

      Xo.DEFAULT_PRIORITY = 10;

      var nr = /*#__PURE__*/function (_Mo3) {
        _inherits(nr, _Mo3);

        var _super10 = _createSuper(nr);

        function nr(t, e, n, i) {
          var _this25;

          _classCallCheck(this, nr);

          _this25 = _super10.call(this, t, e, n, i), _this25._isAllowedInsideAttributeElement = !0, _this25.getFillerOffset = ir;
          return _this25;
        }

        _createClass(nr, [{
          key: "is",
          value: function is(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            return e ? e === this.name && ("emptyElement" === t || "view:emptyElement" === t || "element" === t || "view:element" === t) : "emptyElement" === t || "view:emptyElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
          }
        }, {
          key: "_insertChild",
          value: function _insertChild(t, e) {
            if (e && (e instanceof Oi || Array.from(e).length > 0)) throw new a("view-emptyelement-cannot-add", [this, e]);
          }
        }]);

        return nr;
      }(Mo);

      function ir() {
        return null;
      }

      var or = navigator.userAgent.toLowerCase(),
          rr = {
        isMac: ar(or),
        isWindows: function (t) {
          return t.indexOf("windows") > -1;
        }(or),
        isGecko: function (t) {
          return !!t.match(/gecko\/\d+/);
        }(or),
        isSafari: function (t) {
          return t.indexOf(" applewebkit/") > -1 && -1 === t.indexOf("chrome");
        }(or),
        isiOS: function (t) {
          return !!t.match(/iphone|ipad/i) || ar(t) && navigator.maxTouchPoints > 0;
        }(or),
        isAndroid: function (t) {
          return t.indexOf("android") > -1;
        }(or),
        isBlink: function (t) {
          return t.indexOf("chrome/") > -1 && t.indexOf("edge/") < 0;
        }(or),
        features: {
          isRegExpUnicodePropertySupported: function () {
            var t = !1;

            try {
              t = 0 === "ć".search(new RegExp("[\\p{L}]", "u"));
            } catch (t) {}

            return t;
          }()
        }
      };
      var sr = rr;

      function ar(t) {
        return t.indexOf("macintosh") > -1;
      }

      var cr = {
        ctrl: "⌃",
        cmd: "⌘",
        alt: "⌥",
        shift: "⇧"
      },
          lr = {
        ctrl: "Ctrl+",
        alt: "Alt+",
        shift: "Shift+"
      },
          dr = function () {
        var t = {
          arrowleft: 37,
          arrowup: 38,
          arrowright: 39,
          arrowdown: 40,
          backspace: 8,
          delete: 46,
          enter: 13,
          space: 32,
          esc: 27,
          tab: 9,
          ctrl: 1114112,
          shift: 2228224,
          alt: 4456448,
          cmd: 8912896
        };

        for (var _e43 = 65; _e43 <= 90; _e43++) {
          var _n31 = String.fromCharCode(_e43);

          t[_n31.toLowerCase()] = _e43;
        }

        for (var _e44 = 48; _e44 <= 57; _e44++) {
          t[_e44 - 48] = _e44;
        }

        for (var _e45 = 112; _e45 <= 123; _e45++) {
          t["f" + (_e45 - 111)] = _e45;
        }

        var _iterator48 = _createForOfIteratorHelper("`-=[];',./\\"),
            _step48;

        try {
          for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
            var _e46 = _step48.value;
            t[_e46] = _e46.charCodeAt(0);
          }
        } catch (err) {
          _iterator48.e(err);
        } finally {
          _iterator48.f();
        }

        return t;
      }(),
          hr = Object.fromEntries(Object.entries(dr).map(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
            t = _ref10[0],
            e = _ref10[1];

        return [e, t.charAt(0).toUpperCase() + t.slice(1)];
      }));

      function ur(t) {
        var e;

        if ("string" == typeof t) {
          if (e = dr[t.toLowerCase()], !e) throw new a("keyboard-unknown-key", null, {
            key: t
          });
        } else e = t.keyCode + (t.altKey ? dr.alt : 0) + (t.ctrlKey ? dr.ctrl : 0) + (t.shiftKey ? dr.shift : 0) + (t.metaKey ? dr.cmd : 0);

        return e;
      }

      function gr(t) {
        return "string" == typeof t && (t = function (t) {
          return t.split("+").map(function (t) {
            return t.trim();
          });
        }(t)), t.map(function (t) {
          return "string" == typeof t ? function (t) {
            if (t.endsWith("!")) return ur(t.slice(0, -1));
            var e = ur(t);
            return sr.isMac && e == dr.ctrl ? dr.cmd : e;
          }(t) : t;
        }).reduce(function (t, e) {
          return e + t;
        }, 0);
      }

      function mr(t) {
        var e = gr(t);
        return Object.entries(sr.isMac ? cr : lr).reduce(function (t, _ref11) {
          var _ref12 = _slicedToArray(_ref11, 2),
              n = _ref12[0],
              i = _ref12[1];

          return 0 != (e & dr[n]) && (e &= ~dr[n], t += i), t;
        }, "") + (e ? hr[e] : "");
      }

      function pr(t, e) {
        var n = "ltr" === e;

        switch (t) {
          case dr.arrowleft:
            return n ? "left" : "right";

          case dr.arrowright:
            return n ? "right" : "left";

          case dr.arrowup:
            return "up";

          case dr.arrowdown:
            return "down";
        }
      }

      var fr = /*#__PURE__*/function (_Mo4) {
        _inherits(fr, _Mo4);

        var _super11 = _createSuper(fr);

        function fr(t, e, n, i) {
          var _this26;

          _classCallCheck(this, fr);

          _this26 = _super11.call(this, t, e, n, i), _this26._isAllowedInsideAttributeElement = !0, _this26.getFillerOffset = br;
          return _this26;
        }

        _createClass(fr, [{
          key: "is",
          value: function is(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            return e ? e === this.name && ("uiElement" === t || "view:uiElement" === t || "element" === t || "view:element" === t) : "uiElement" === t || "view:uiElement" === t || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
          }
        }, {
          key: "_insertChild",
          value: function _insertChild(t, e) {
            if (e && (e instanceof Oi || Array.from(e).length > 0)) throw new a("view-uielement-cannot-add", this);
          }
        }, {
          key: "render",
          value: function render(t) {
            return this.toDomElement(t);
          }
        }, {
          key: "toDomElement",
          value: function toDomElement(t) {
            var e = t.createElement(this.name);

            var _iterator49 = _createForOfIteratorHelper(this.getAttributeKeys()),
                _step49;

            try {
              for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
                var _t30 = _step49.value;
                e.setAttribute(_t30, this.getAttribute(_t30));
              }
            } catch (err) {
              _iterator49.e(err);
            } finally {
              _iterator49.f();
            }

            return e;
          }
        }]);

        return fr;
      }(Mo);

      function kr(t) {
        t.document.on("arrowKey", function (e, n) {
          return function (t, e, n) {
            if (e.keyCode == dr.arrowright) {
              var _t31 = e.domTarget.ownerDocument.defaultView.getSelection(),
                  _i27 = 1 == _t31.rangeCount && _t31.getRangeAt(0).collapsed;

              if (_i27 || e.shiftKey) {
                var _e47 = _t31.focusNode,
                    _o14 = _t31.focusOffset,
                    _r10 = n.domPositionToView(_e47, _o14);

                if (null === _r10) return;

                var _s4 = !1;

                var _a4 = _r10.getLastMatchingPosition(function (t) {
                  return t.item.is("uiElement") && (_s4 = !0), !(!t.item.is("uiElement") && !t.item.is("attributeElement"));
                });

                if (_s4) {
                  var _e48 = n.viewPositionToDom(_a4);

                  _i27 ? _t31.collapse(_e48.parent, _e48.offset) : _t31.extend(_e48.parent, _e48.offset);
                }
              }
            }
          }(0, n, t.domConverter);
        }, {
          priority: "low"
        });
      }

      function br() {
        return null;
      }

      var wr = /*#__PURE__*/function (_Mo5) {
        _inherits(wr, _Mo5);

        var _super12 = _createSuper(wr);

        function wr(t, e, n, i) {
          var _this27;

          _classCallCheck(this, wr);

          _this27 = _super12.call(this, t, e, n, i), _this27._isAllowedInsideAttributeElement = !0, _this27.getFillerOffset = Ar;
          return _this27;
        }

        _createClass(wr, [{
          key: "is",
          value: function is(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            return e ? e === this.name && ("rawElement" === t || "view:rawElement" === t || "element" === t || "view:element" === t) : "rawElement" === t || "view:rawElement" === t || t === this.name || t === "view:" + this.name || "element" === t || "view:element" === t || "node" === t || "view:node" === t;
          }
        }, {
          key: "_insertChild",
          value: function _insertChild(t, e) {
            if (e && (e instanceof Oi || Array.from(e).length > 0)) throw new a("view-rawelement-cannot-add", [this, e]);
          }
        }]);

        return wr;
      }(Mo);

      function Ar() {
        return null;
      }

      var Cr = /*#__PURE__*/function (_Symbol$iterator5) {
        function Cr(t, e) {
          _classCallCheck(this, Cr);

          this.document = t, this._children = [], e && this._insertChild(0, e);
        }

        _createClass(Cr, [{
          key: _Symbol$iterator5,
          value: function value() {
            return this._children[Symbol.iterator]();
          }
        }, {
          key: "childCount",
          get: function get() {
            return this._children.length;
          }
        }, {
          key: "isEmpty",
          get: function get() {
            return 0 === this.childCount;
          }
        }, {
          key: "root",
          get: function get() {
            return this;
          }
        }, {
          key: "parent",
          get: function get() {
            return null;
          }
        }, {
          key: "is",
          value: function is(t) {
            return "documentFragment" === t || "view:documentFragment" === t;
          }
        }, {
          key: "_appendChild",
          value: function _appendChild(t) {
            return this._insertChild(this.childCount, t);
          }
        }, {
          key: "getChild",
          value: function getChild(t) {
            return this._children[t];
          }
        }, {
          key: "getChildIndex",
          value: function getChildIndex(t) {
            return this._children.indexOf(t);
          }
        }, {
          key: "getChildren",
          value: function getChildren() {
            return this._children[Symbol.iterator]();
          }
        }, {
          key: "_insertChild",
          value: function _insertChild(t, e) {
            this._fireChange("children", this);

            var n = 0;

            var i = function (t, e) {
              if ("string" == typeof e) return [new ji(t, e)];
              Ei(e) || (e = [e]);
              return Array.from(e).map(function (e) {
                return "string" == typeof e ? new ji(t, e) : e instanceof Fi ? new ji(t, e.data) : e;
              });
            }(this.document, e);

            var _iterator50 = _createForOfIteratorHelper(i),
                _step50;

            try {
              for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
                var _e49 = _step50.value;
                null !== _e49.parent && _e49._remove(), _e49.parent = this, this._children.splice(t, 0, _e49), t++, n++;
              }
            } catch (err) {
              _iterator50.e(err);
            } finally {
              _iterator50.f();
            }

            return n;
          }
        }, {
          key: "_removeChildren",
          value: function _removeChildren(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            this._fireChange("children", this);

            for (var _n32 = t; _n32 < t + e; _n32++) {
              this._children[_n32].parent = null;
            }

            return this._children.splice(t, e);
          }
        }, {
          key: "_fireChange",
          value: function _fireChange(t, e) {
            this.fire("change:" + t, e);
          }
        }]);

        return Cr;
      }(Symbol.iterator);

      he(Cr, f);

      var _r = /*#__PURE__*/function () {
        function _r(t) {
          _classCallCheck(this, _r);

          this.document = t, this._cloneGroups = new Map();
        }

        _createClass(_r, [{
          key: "setSelection",
          value: function setSelection(t, e, n) {
            this.document.selection._setTo(t, e, n);
          }
        }, {
          key: "setSelectionFocus",
          value: function setSelectionFocus(t, e) {
            this.document.selection._setFocus(t, e);
          }
        }, {
          key: "createDocumentFragment",
          value: function createDocumentFragment(t) {
            return new Cr(this.document, t);
          }
        }, {
          key: "createText",
          value: function createText(t) {
            return new ji(this.document, t);
          }
        }, {
          key: "createAttributeElement",
          value: function createAttributeElement(t, e) {
            var _i$_unsafeAttributesT;

            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var i = new Xo(this.document, t, e);
            return "number" == typeof n.priority && (i._priority = n.priority), n.id && (i._id = n.id), n.renderUnsafeAttributes && (_i$_unsafeAttributesT = i._unsafeAttributesToRender).push.apply(_i$_unsafeAttributesT, _toConsumableArray(n.renderUnsafeAttributes)), i;
          }
        }, {
          key: "createContainerElement",
          value: function createContainerElement(t, e) {
            var _i$_unsafeAttributesT2;

            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var i = new No(this.document, t, e);
            return void 0 !== n.isAllowedInsideAttributeElement && (i._isAllowedInsideAttributeElement = n.isAllowedInsideAttributeElement), n.renderUnsafeAttributes && (_i$_unsafeAttributesT2 = i._unsafeAttributesToRender).push.apply(_i$_unsafeAttributesT2, _toConsumableArray(n.renderUnsafeAttributes)), i;
          }
        }, {
          key: "createEditableElement",
          value: function createEditableElement(t, e) {
            var _i$_unsafeAttributesT3;

            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var i = new zo(this.document, t, e);
            return i._document = this.document, n.renderUnsafeAttributes && (_i$_unsafeAttributesT3 = i._unsafeAttributesToRender).push.apply(_i$_unsafeAttributesT3, _toConsumableArray(n.renderUnsafeAttributes)), i;
          }
        }, {
          key: "createEmptyElement",
          value: function createEmptyElement(t, e) {
            var _i$_unsafeAttributesT4;

            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var i = new nr(this.document, t, e);
            return void 0 !== n.isAllowedInsideAttributeElement && (i._isAllowedInsideAttributeElement = n.isAllowedInsideAttributeElement), n.renderUnsafeAttributes && (_i$_unsafeAttributesT4 = i._unsafeAttributesToRender).push.apply(_i$_unsafeAttributesT4, _toConsumableArray(n.renderUnsafeAttributes)), i;
          }
        }, {
          key: "createUIElement",
          value: function createUIElement(t, e, n) {
            var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var o = new fr(this.document, t, e);
            return n && (o.render = n), void 0 !== i.isAllowedInsideAttributeElement && (o._isAllowedInsideAttributeElement = i.isAllowedInsideAttributeElement), o;
          }
        }, {
          key: "createRawElement",
          value: function createRawElement(t, e, n) {
            var _o$_unsafeAttributesT;

            var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var o = new wr(this.document, t, e);
            return o.render = n || function () {}, void 0 !== i.isAllowedInsideAttributeElement && (o._isAllowedInsideAttributeElement = i.isAllowedInsideAttributeElement), i.renderUnsafeAttributes && (_o$_unsafeAttributesT = o._unsafeAttributesToRender).push.apply(_o$_unsafeAttributesT, _toConsumableArray(i.renderUnsafeAttributes)), o;
          }
        }, {
          key: "setAttribute",
          value: function setAttribute(t, e, n) {
            n._setAttribute(t, e);
          }
        }, {
          key: "removeAttribute",
          value: function removeAttribute(t, e) {
            e._removeAttribute(t);
          }
        }, {
          key: "addClass",
          value: function addClass(t, e) {
            e._addClass(t);
          }
        }, {
          key: "removeClass",
          value: function removeClass(t, e) {
            e._removeClass(t);
          }
        }, {
          key: "setStyle",
          value: function setStyle(t, e, n) {
            ye(t) && void 0 === n && (n = e), n._setStyle(t, e);
          }
        }, {
          key: "removeStyle",
          value: function removeStyle(t, e) {
            e._removeStyle(t);
          }
        }, {
          key: "setCustomProperty",
          value: function setCustomProperty(t, e, n) {
            n._setCustomProperty(t, e);
          }
        }, {
          key: "removeCustomProperty",
          value: function removeCustomProperty(t, e) {
            return e._removeCustomProperty(t);
          }
        }, {
          key: "breakAttributes",
          value: function breakAttributes(t) {
            return t instanceof Oo ? this._breakAttributes(t) : this._breakAttributesRange(t);
          }
        }, {
          key: "breakContainer",
          value: function breakContainer(t) {
            var e = t.parent;
            if (!e.is("containerElement")) throw new a("view-writer-break-non-container-element", this.document);
            if (!e.parent) throw new a("view-writer-break-root", this.document);
            if (t.isAtStart) return Oo._createBefore(e);

            if (!t.isAtEnd) {
              var _n33 = e._clone(!1);

              this.insert(Oo._createAfter(e), _n33);

              var _i28 = new jo(t, Oo._createAt(e, "end")),
                  _o15 = new Oo(_n33, 0);

              this.move(_i28, _o15);
            }

            return Oo._createAfter(e);
          }
        }, {
          key: "mergeAttributes",
          value: function mergeAttributes(t) {
            var e = t.offset,
                n = t.parent;
            if (n.is("$text")) return t;

            if (n.is("attributeElement") && 0 === n.childCount) {
              var _t32 = n.parent,
                  _e50 = n.index;
              return n._remove(), this._removeFromClonedElementsGroup(n), this.mergeAttributes(new Oo(_t32, _e50));
            }

            var i = n.getChild(e - 1),
                o = n.getChild(e);
            if (!i || !o) return t;
            if (i.is("$text") && o.is("$text")) return Dr(i, o);

            if (i.is("attributeElement") && o.is("attributeElement") && i.isSimilar(o)) {
              var _t33 = i.childCount;
              return i._appendChild(o.getChildren()), o._remove(), this._removeFromClonedElementsGroup(o), this.mergeAttributes(new Oo(i, _t33));
            }

            return t;
          }
        }, {
          key: "mergeContainers",
          value: function mergeContainers(t) {
            var e = t.nodeBefore,
                n = t.nodeAfter;
            if (!(e && n && e.is("containerElement") && n.is("containerElement"))) throw new a("view-writer-merge-containers-invalid-position", this.document);
            var i = e.getChild(e.childCount - 1),
                o = i instanceof ji ? Oo._createAt(i, "end") : Oo._createAt(e, "end");
            return this.move(jo._createIn(n), Oo._createAt(e, "end")), this.remove(jo._createOn(n)), o;
          }
        }, {
          key: "insert",
          value: function insert(t, e) {
            Sr(e = Ei(e) ? _toConsumableArray(e) : [e], this.document);
            var n = e.reduce(function (t, e) {
              var n = t[t.length - 1],
                  i = !(e.is("uiElement") && e.isAllowedInsideAttributeElement);
              return n && n.breakAttributes == i ? n.nodes.push(e) : t.push({
                breakAttributes: i,
                nodes: [e]
              }), t;
            }, []);
            var i = null,
                o = t;

            var _iterator51 = _createForOfIteratorHelper(n),
                _step51;

            try {
              for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
                var _step51$value = _step51.value,
                    _t34 = _step51$value.nodes,
                    _e51 = _step51$value.breakAttributes;

                var _n34 = this._insertNodes(o, _t34, _e51);

                i || (i = _n34.start), o = _n34.end;
              }
            } catch (err) {
              _iterator51.e(err);
            } finally {
              _iterator51.f();
            }

            return i ? new jo(i, o) : new jo(t);
          }
        }, {
          key: "remove",
          value: function remove(t) {
            var e = t instanceof jo ? t : jo._createOn(t);
            if (Tr(e, this.document), e.isCollapsed) return new Cr(this.document);

            var _this$_breakAttribute = this._breakAttributesRange(e, !0),
                n = _this$_breakAttribute.start,
                i = _this$_breakAttribute.end,
                o = n.parent,
                r = i.offset - n.offset,
                s = o._removeChildren(n.offset, r);

            var _iterator52 = _createForOfIteratorHelper(s),
                _step52;

            try {
              for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
                var _t35 = _step52.value;

                this._removeFromClonedElementsGroup(_t35);
              }
            } catch (err) {
              _iterator52.e(err);
            } finally {
              _iterator52.f();
            }

            var a = this.mergeAttributes(n);
            return e.start = a, e.end = a.clone(), new Cr(this.document, s);
          }
        }, {
          key: "clear",
          value: function clear(t, e) {
            Tr(t, this.document);
            var n = t.getWalker({
              direction: "backward",
              ignoreElementEnd: !0
            });

            var _iterator53 = _createForOfIteratorHelper(n),
                _step53;

            try {
              for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
                var _i29 = _step53.value;
                var _n35 = _i29.item;

                var _o16 = void 0;

                if (_n35.is("element") && e.isSimilar(_n35)) _o16 = jo._createOn(_n35);else if (!_i29.nextPosition.isAfter(t.start) && _n35.is("$textProxy")) {
                  var _t36 = _n35.getAncestors().find(function (t) {
                    return t.is("element") && e.isSimilar(t);
                  });

                  _t36 && (_o16 = jo._createIn(_t36));
                }
                _o16 && (_o16.end.isAfter(t.end) && (_o16.end = t.end), _o16.start.isBefore(t.start) && (_o16.start = t.start), this.remove(_o16));
              }
            } catch (err) {
              _iterator53.e(err);
            } finally {
              _iterator53.f();
            }
          }
        }, {
          key: "move",
          value: function move(t, e) {
            var n;

            if (e.isAfter(t.end)) {
              var _i30 = (e = this._breakAttributes(e, !0)).parent,
                  _o17 = _i30.childCount;

              t = this._breakAttributesRange(t, !0), n = this.remove(t), e.offset += _i30.childCount - _o17;
            } else n = this.remove(t);

            return this.insert(e, n);
          }
        }, {
          key: "wrap",
          value: function wrap(t, e) {
            if (!(e instanceof Xo)) throw new a("view-writer-wrap-invalid-attribute", this.document);

            if (Tr(t, this.document), t.isCollapsed) {
              var _i31 = t.start;
              _i31.parent.is("element") && (n = _i31.parent, !Array.from(n.getChildren()).some(function (t) {
                return !t.is("uiElement");
              })) && (_i31 = _i31.getLastMatchingPosition(function (t) {
                return t.item.is("uiElement");
              })), _i31 = this._wrapPosition(_i31, e);
              var _o18 = this.document.selection;
              return _o18.isCollapsed && _o18.getFirstPosition().isEqual(t.start) && this.setSelection(_i31), new jo(_i31);
            }

            return this._wrapRange(t, e);
            var n;
          }
        }, {
          key: "unwrap",
          value: function unwrap(t, e) {
            if (!(e instanceof Xo)) throw new a("view-writer-unwrap-invalid-attribute", this.document);
            if (Tr(t, this.document), t.isCollapsed) return t;

            var _this$_breakAttribute2 = this._breakAttributesRange(t, !0),
                n = _this$_breakAttribute2.start,
                i = _this$_breakAttribute2.end,
                o = n.parent,
                r = this._unwrapChildren(o, n.offset, i.offset, e),
                s = this.mergeAttributes(r.start);

            s.isEqual(r.start) || r.end.offset--;
            var c = this.mergeAttributes(r.end);
            return new jo(s, c);
          }
        }, {
          key: "rename",
          value: function rename(t, e) {
            var n = new No(this.document, t, e.getAttributes());
            return this.insert(Oo._createAfter(e), n), this.move(jo._createIn(e), Oo._createAt(n, 0)), this.remove(jo._createOn(e)), n;
          }
        }, {
          key: "clearClonedElementsGroup",
          value: function clearClonedElementsGroup(t) {
            this._cloneGroups.delete(t);
          }
        }, {
          key: "createPositionAt",
          value: function createPositionAt(t, e) {
            return Oo._createAt(t, e);
          }
        }, {
          key: "createPositionAfter",
          value: function createPositionAfter(t) {
            return Oo._createAfter(t);
          }
        }, {
          key: "createPositionBefore",
          value: function createPositionBefore(t) {
            return Oo._createBefore(t);
          }
        }, {
          key: "createRange",
          value: function createRange(t, e) {
            return new jo(t, e);
          }
        }, {
          key: "createRangeOn",
          value: function createRangeOn(t) {
            return jo._createOn(t);
          }
        }, {
          key: "createRangeIn",
          value: function createRangeIn(t) {
            return jo._createIn(t);
          }
        }, {
          key: "createSelection",
          value: function createSelection(t, e, n) {
            return new Uo(t, e, n);
          }
        }, {
          key: "_insertNodes",
          value: function _insertNodes(t, e, n) {
            var i, o;
            if (i = n ? vr(t) : t.parent.is("$text") ? t.parent.parent : t.parent, !i) throw new a("view-writer-invalid-position-container", this.document);
            o = n ? this._breakAttributes(t, !0) : t.parent.is("$text") ? Er(t) : t;

            var r = i._insertChild(o.offset, e);

            var _iterator54 = _createForOfIteratorHelper(e),
                _step54;

            try {
              for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
                var _t37 = _step54.value;

                this._addToClonedElementsGroup(_t37);
              }
            } catch (err) {
              _iterator54.e(err);
            } finally {
              _iterator54.f();
            }

            var s = o.getShiftedBy(r),
                c = this.mergeAttributes(o);
            c.isEqual(o) || s.offset--;
            var l = this.mergeAttributes(s);
            return new jo(c, l);
          }
        }, {
          key: "_wrapChildren",
          value: function _wrapChildren(t, e, n, i) {
            var o = e;
            var r = [];

            for (; o < n;) {
              var _e52 = t.getChild(o),
                  _n36 = _e52.is("$text"),
                  _s5 = _e52.is("attributeElement"),
                  _a5 = _e52.isAllowedInsideAttributeElement;

              if (_s5 && this._wrapAttributeElement(i, _e52)) r.push(new Oo(t, o));else if (_n36 || _a5 || _s5 && yr(i, _e52)) {
                var _n37 = i._clone();

                _e52._remove(), _n37._appendChild(_e52), t._insertChild(o, _n37), this._addToClonedElementsGroup(_n37), r.push(new Oo(t, o));
              } else _s5 && this._wrapChildren(_e52, 0, _e52.childCount, i);
              o++;
            }

            var s = 0;

            for (var _i32 = 0, _r11 = r; _i32 < _r11.length; _i32++) {
              var _t38 = _r11[_i32];
              if (_t38.offset -= s, _t38.offset == e) continue;
              this.mergeAttributes(_t38).isEqual(_t38) || (s++, n--);
            }

            return jo._createFromParentsAndOffsets(t, e, t, n);
          }
        }, {
          key: "_unwrapChildren",
          value: function _unwrapChildren(t, e, n, i) {
            var o = e;
            var r = [];

            for (; o < n;) {
              var _e53 = t.getChild(o);

              if (_e53.is("attributeElement")) {
                if (_e53.isSimilar(i)) {
                  var _i33 = _e53.getChildren(),
                      _s6 = _e53.childCount;

                  _e53._remove(), t._insertChild(o, _i33), this._removeFromClonedElementsGroup(_e53), r.push(new Oo(t, o), new Oo(t, o + _s6)), o += _s6, n += _s6 - 1;
                } else this._unwrapAttributeElement(i, _e53) ? (r.push(new Oo(t, o), new Oo(t, o + 1)), o++) : (this._unwrapChildren(_e53, 0, _e53.childCount, i), o++);
              } else o++;
            }

            var s = 0;

            for (var _i34 = 0, _r12 = r; _i34 < _r12.length; _i34++) {
              var _t39 = _r12[_i34];
              if (_t39.offset -= s, _t39.offset == e || _t39.offset == n) continue;
              this.mergeAttributes(_t39).isEqual(_t39) || (s++, n--);
            }

            return jo._createFromParentsAndOffsets(t, e, t, n);
          }
        }, {
          key: "_wrapRange",
          value: function _wrapRange(t, e) {
            var _this$_breakAttribute3 = this._breakAttributesRange(t, !0),
                n = _this$_breakAttribute3.start,
                i = _this$_breakAttribute3.end,
                o = n.parent,
                r = this._wrapChildren(o, n.offset, i.offset, e),
                s = this.mergeAttributes(r.start);

            s.isEqual(r.start) || r.end.offset--;
            var a = this.mergeAttributes(r.end);
            return new jo(s, a);
          }
        }, {
          key: "_wrapPosition",
          value: function _wrapPosition(t, e) {
            if (e.isSimilar(t.parent)) return xr(t.clone());
            t.parent.is("$text") && (t = Er(t));
            var n = this.createAttributeElement();
            n._priority = Number.POSITIVE_INFINITY, n.isSimilar = function () {
              return !1;
            }, t.parent._insertChild(t.offset, n);
            var i = new jo(t, t.getShiftedBy(1));
            this.wrap(i, e);
            var o = new Oo(n.parent, n.index);

            n._remove();

            var r = o.nodeBefore,
                s = o.nodeAfter;
            return r instanceof ji && s instanceof ji ? Dr(r, s) : xr(o);
          }
        }, {
          key: "_wrapAttributeElement",
          value: function _wrapAttributeElement(t, e) {
            if (!Nr(t, e)) return !1;
            if (t.name !== e.name || t.priority !== e.priority) return !1;

            var _iterator55 = _createForOfIteratorHelper(t.getAttributeKeys()),
                _step55;

            try {
              for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
                var _n38 = _step55.value;
                if ("class" !== _n38 && "style" !== _n38 && e.hasAttribute(_n38) && e.getAttribute(_n38) !== t.getAttribute(_n38)) return !1;
              }
            } catch (err) {
              _iterator55.e(err);
            } finally {
              _iterator55.f();
            }

            var _iterator56 = _createForOfIteratorHelper(t.getStyleNames()),
                _step56;

            try {
              for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
                var _n39 = _step56.value;
                if (e.hasStyle(_n39) && e.getStyle(_n39) !== t.getStyle(_n39)) return !1;
              }
            } catch (err) {
              _iterator56.e(err);
            } finally {
              _iterator56.f();
            }

            var _iterator57 = _createForOfIteratorHelper(t.getAttributeKeys()),
                _step57;

            try {
              for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
                var _n40 = _step57.value;
                "class" !== _n40 && "style" !== _n40 && (e.hasAttribute(_n40) || this.setAttribute(_n40, t.getAttribute(_n40), e));
              }
            } catch (err) {
              _iterator57.e(err);
            } finally {
              _iterator57.f();
            }

            var _iterator58 = _createForOfIteratorHelper(t.getStyleNames()),
                _step58;

            try {
              for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
                var _n41 = _step58.value;
                e.hasStyle(_n41) || this.setStyle(_n41, t.getStyle(_n41), e);
              }
            } catch (err) {
              _iterator58.e(err);
            } finally {
              _iterator58.f();
            }

            var _iterator59 = _createForOfIteratorHelper(t.getClassNames()),
                _step59;

            try {
              for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
                var _n42 = _step59.value;
                e.hasClass(_n42) || this.addClass(_n42, e);
              }
            } catch (err) {
              _iterator59.e(err);
            } finally {
              _iterator59.f();
            }

            return !0;
          }
        }, {
          key: "_unwrapAttributeElement",
          value: function _unwrapAttributeElement(t, e) {
            if (!Nr(t, e)) return !1;
            if (t.name !== e.name || t.priority !== e.priority) return !1;

            var _iterator60 = _createForOfIteratorHelper(t.getAttributeKeys()),
                _step60;

            try {
              for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
                var _n43 = _step60.value;
                if ("class" !== _n43 && "style" !== _n43 && (!e.hasAttribute(_n43) || e.getAttribute(_n43) !== t.getAttribute(_n43))) return !1;
              }
            } catch (err) {
              _iterator60.e(err);
            } finally {
              _iterator60.f();
            }

            if (!e.hasClass.apply(e, _toConsumableArray(t.getClassNames()))) return !1;

            var _iterator61 = _createForOfIteratorHelper(t.getStyleNames()),
                _step61;

            try {
              for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
                var _n44 = _step61.value;
                if (!e.hasStyle(_n44) || e.getStyle(_n44) !== t.getStyle(_n44)) return !1;
              }
            } catch (err) {
              _iterator61.e(err);
            } finally {
              _iterator61.f();
            }

            var _iterator62 = _createForOfIteratorHelper(t.getAttributeKeys()),
                _step62;

            try {
              for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
                var _n45 = _step62.value;
                "class" !== _n45 && "style" !== _n45 && this.removeAttribute(_n45, e);
              }
            } catch (err) {
              _iterator62.e(err);
            } finally {
              _iterator62.f();
            }

            return this.removeClass(Array.from(t.getClassNames()), e), this.removeStyle(Array.from(t.getStyleNames()), e), !0;
          }
        }, {
          key: "_breakAttributesRange",
          value: function _breakAttributesRange(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            var n = t.start,
                i = t.end;

            if (Tr(t, this.document), t.isCollapsed) {
              var _n46 = this._breakAttributes(t.start, e);

              return new jo(_n46, _n46);
            }

            var o = this._breakAttributes(i, e),
                r = o.parent.childCount,
                s = this._breakAttributes(n, e);

            return o.offset += o.parent.childCount - r, new jo(s, o);
          }
        }, {
          key: "_breakAttributes",
          value: function _breakAttributes(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            var n = t.offset,
                i = t.parent;
            if (t.parent.is("emptyElement")) throw new a("view-writer-cannot-break-empty-element", this.document);
            if (t.parent.is("uiElement")) throw new a("view-writer-cannot-break-ui-element", this.document);
            if (t.parent.is("rawElement")) throw new a("view-writer-cannot-break-raw-element", this.document);
            if (!e && i.is("$text") && Mr(i.parent)) return t.clone();
            if (Mr(i)) return t.clone();
            if (i.is("$text")) return this._breakAttributes(Er(t), e);

            if (n == i.childCount) {
              var _t40 = new Oo(i.parent, i.index + 1);

              return this._breakAttributes(_t40, e);
            }

            if (0 === n) {
              var _t41 = new Oo(i.parent, i.index);

              return this._breakAttributes(_t41, e);
            }

            {
              var _t42 = i.index + 1,
                  _o19 = i._clone();

              i.parent._insertChild(_t42, _o19), this._addToClonedElementsGroup(_o19);

              var _r13 = i.childCount - n,
                  _s7 = i._removeChildren(n, _r13);

              _o19._appendChild(_s7);

              var _a6 = new Oo(i.parent, _t42);

              return this._breakAttributes(_a6, e);
            }
          }
        }, {
          key: "_addToClonedElementsGroup",
          value: function _addToClonedElementsGroup(t) {
            if (!t.root.is("rootElement")) return;

            if (t.is("element")) {
              var _iterator63 = _createForOfIteratorHelper(t.getChildren()),
                  _step63;

              try {
                for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
                  var _e54 = _step63.value;

                  this._addToClonedElementsGroup(_e54);
                }
              } catch (err) {
                _iterator63.e(err);
              } finally {
                _iterator63.f();
              }
            }

            var e = t.id;
            if (!e) return;

            var n = this._cloneGroups.get(e);

            n || (n = new Set(), this._cloneGroups.set(e, n)), n.add(t), t._clonesGroup = n;
          }
        }, {
          key: "_removeFromClonedElementsGroup",
          value: function _removeFromClonedElementsGroup(t) {
            if (t.is("element")) {
              var _iterator64 = _createForOfIteratorHelper(t.getChildren()),
                  _step64;

              try {
                for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
                  var _e55 = _step64.value;

                  this._removeFromClonedElementsGroup(_e55);
                }
              } catch (err) {
                _iterator64.e(err);
              } finally {
                _iterator64.f();
              }
            }

            var e = t.id;
            if (!e) return;

            var n = this._cloneGroups.get(e);

            n && n.delete(t);
          }
        }]);

        return _r;
      }();

      function vr(t) {
        var e = t.parent;

        for (; !Mr(e);) {
          if (!e) return;
          e = e.parent;
        }

        return e;
      }

      function yr(t, e) {
        return t.priority < e.priority || !(t.priority > e.priority) && t.getIdentity() < e.getIdentity();
      }

      function xr(t) {
        var e = t.nodeBefore;
        if (e && e.is("$text")) return new Oo(e, e.data.length);
        var n = t.nodeAfter;
        return n && n.is("$text") ? new Oo(n, 0) : t;
      }

      function Er(t) {
        if (t.offset == t.parent.data.length) return new Oo(t.parent.parent, t.parent.index + 1);
        if (0 === t.offset) return new Oo(t.parent.parent, t.parent.index);
        var e = t.parent.data.slice(t.offset);
        return t.parent._data = t.parent.data.slice(0, t.offset), t.parent.parent._insertChild(t.parent.index + 1, new ji(t.root.document, e)), new Oo(t.parent.parent, t.parent.index + 1);
      }

      function Dr(t, e) {
        var n = t.data.length;
        return t._data += e.data, e._remove(), new Oo(t, n);
      }

      function Sr(t, e) {
        var _iterator65 = _createForOfIteratorHelper(t),
            _step65;

        try {
          var _loop = function _loop() {
            var n = _step65.value;
            if (!Ir.some(function (t) {
              return n instanceof t;
            })) throw new a("view-writer-insert-invalid-node-type", e);
            n.is("$text") || Sr(n.getChildren(), e);
          };

          for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator65.e(err);
        } finally {
          _iterator65.f();
        }
      }

      var Ir = [ji, Xo, No, nr, wr, fr];

      function Mr(t) {
        return t && (t.is("containerElement") || t.is("documentFragment"));
      }

      function Tr(t, e) {
        var n = vr(t.start),
            i = vr(t.end);
        if (!n || !i || n !== i) throw new a("view-writer-invalid-range-container", e);
      }

      function Nr(t, e) {
        return null === t.id && null === e.id;
      }

      function Br(t) {
        return "[object Text]" == Object.prototype.toString.call(t);
      }

      var zr = function zr(t) {
        return t.createTextNode(" ");
      },
          Pr = function Pr(t) {
        var e = t.createElement("span");
        return e.dataset.ckeFiller = !0, e.innerHTML = " ", e;
      },
          Lr = function Lr(t) {
        var e = t.createElement("br");
        return e.dataset.ckeFiller = !0, e;
      },
          Rr = "⁠".repeat(7);

      function Or(t) {
        return Br(t) && t.data.substr(0, 7) === Rr;
      }

      function jr(t) {
        return 7 == t.data.length && Or(t);
      }

      function Fr(t) {
        return Or(t) ? t.data.slice(7) : t.data;
      }

      function Vr(t, e) {
        if (e.keyCode == dr.arrowleft) {
          var _t43 = e.domTarget.ownerDocument.defaultView.getSelection();

          if (1 == _t43.rangeCount && _t43.getRangeAt(0).collapsed) {
            var _e56 = _t43.getRangeAt(0).startContainer,
                _n47 = _t43.getRangeAt(0).startOffset;

            Or(_e56) && _n47 <= 7 && _t43.collapse(_e56, 0);
          }
        }
      }

      function Ur(t, e, n) {
        var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
        n = n || function (t, e) {
          return t === e;
        }, Array.isArray(t) || (t = Array.prototype.slice.call(t)), Array.isArray(e) || (e = Array.prototype.slice.call(e));

        var o = function (t, e, n) {
          var i = Hr(t, e, n);
          if (-1 === i) return {
            firstIndex: -1,
            lastIndexOld: -1,
            lastIndexNew: -1
          };
          var o = qr(t, i),
              r = qr(e, i),
              s = Hr(o, r, n),
              a = t.length - s,
              c = e.length - s;
          return {
            firstIndex: i,
            lastIndexOld: a,
            lastIndexNew: c
          };
        }(t, e, n);

        return i ? function (t, e) {
          var n = t.firstIndex,
              i = t.lastIndexOld,
              o = t.lastIndexNew;
          if (-1 === n) return Array(e).fill("equal");
          var r = [];
          n > 0 && (r = r.concat(Array(n).fill("equal")));
          o - n > 0 && (r = r.concat(Array(o - n).fill("insert")));
          i - n > 0 && (r = r.concat(Array(i - n).fill("delete")));
          o < e && (r = r.concat(Array(e - o).fill("equal")));
          return r;
        }(o, e.length) : function (t, e) {
          var n = [],
              i = e.firstIndex,
              o = e.lastIndexOld,
              r = e.lastIndexNew;
          r - i > 0 && n.push({
            index: i,
            type: "insert",
            values: t.slice(i, r)
          });
          o - i > 0 && n.push({
            index: i + (r - i),
            type: "delete",
            howMany: o - i
          });
          return n;
        }(e, o);
      }

      function Hr(t, e, n) {
        for (var _i35 = 0; _i35 < Math.max(t.length, e.length); _i35++) {
          if (void 0 === t[_i35] || void 0 === e[_i35] || !n(t[_i35], e[_i35])) return _i35;
        }

        return -1;
      }

      function qr(t, e) {
        return t.slice(e).reverse();
      }

      function Wr(t, e, n) {
        n = n || function (t, e) {
          return t === e;
        };

        var i = t.length,
            o = e.length;
        if (i > 200 || o > 200 || i + o > 300) return Wr.fastDiff(t, e, n, !0);
        var r, s;

        if (o < i) {
          var _n48 = t;
          t = e, e = _n48, r = "delete", s = "insert";
        } else r = "insert", s = "delete";

        var a = t.length,
            c = e.length,
            l = c - a,
            d = {},
            h = {};

        function u(i) {
          var o = (void 0 !== h[i - 1] ? h[i - 1] : -1) + 1,
              l = void 0 !== h[i + 1] ? h[i + 1] : -1,
              u = o > l ? -1 : 1;
          d[i + u] && (d[i] = d[i + u].slice(0)), d[i] || (d[i] = []), d[i].push(o > l ? r : s);
          var g = Math.max(o, l),
              m = g - i;

          for (; m < a && g < c && n(t[m], e[g]);) {
            m++, g++, d[i].push("equal");
          }

          return g;
        }

        var g,
            m = 0;

        do {
          for (g = -m; g < l; g++) {
            h[g] = u(g);
          }

          for (g = l + m; g > l; g--) {
            h[g] = u(g);
          }

          h[l] = u(l), m++;
        } while (h[l] !== c);

        return d[l].slice(1);
      }

      function Gr(t, e, n) {
        t.insertBefore(n, t.childNodes[e] || null);
      }

      function $r(t) {
        var e = t.parentNode;
        e && e.removeChild(t);
      }

      function Yr(t) {
        return t && t.nodeType === Node.COMMENT_NODE;
      }

      function Kr(t) {
        if (t) {
          if (t.defaultView) return t instanceof t.defaultView.Document;
          if (t.ownerDocument && t.ownerDocument.defaultView) return t instanceof t.ownerDocument.defaultView.Node;
        }

        return !1;
      }

      Wr.fastDiff = Ur;
      var Qr = n(3379),
          Zr = n.n(Qr),
          Jr = n(9525),
          Xr = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Jr.Z, Xr), Jr.Z.locals;

      var ts = /*#__PURE__*/function () {
        function ts(t, e) {
          var _this28 = this;

          _classCallCheck(this, ts);

          this.domDocuments = new Set(), this.domConverter = t, this.markedAttributes = new Set(), this.markedChildren = new Set(), this.markedTexts = new Set(), this.selection = e, this.set("isFocused", !1), this.set("isSelecting", !1), sr.isBlink && !sr.isAndroid && this.on("change:isSelecting", function () {
            _this28.isSelecting || _this28.render();
          }), this._inlineFiller = null, this._fakeSelectionContainer = null;
        }

        _createClass(ts, [{
          key: "markToSync",
          value: function markToSync(t, e) {
            if ("text" === t) this.domConverter.mapViewToDom(e.parent) && this.markedTexts.add(e);else {
              if (!this.domConverter.mapViewToDom(e)) return;
              if ("attributes" === t) this.markedAttributes.add(e);else {
                if ("children" !== t) throw new a("view-renderer-unknown-type", this);
                this.markedChildren.add(e);
              }
            }
          }
        }, {
          key: "render",
          value: function render() {
            var t;
            var e = !(sr.isBlink && !sr.isAndroid) || !this.isSelecting;

            var _iterator66 = _createForOfIteratorHelper(this.markedChildren),
                _step66;

            try {
              for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
                var _t44 = _step66.value;

                this._updateChildrenMappings(_t44);
              }
            } catch (err) {
              _iterator66.e(err);
            } finally {
              _iterator66.f();
            }

            e ? (this._inlineFiller && !this._isSelectionInInlineFiller() && this._removeInlineFiller(), this._inlineFiller ? t = this._getInlineFillerPosition() : this._needsInlineFillerAtSelection() && (t = this.selection.getFirstPosition(), this.markedChildren.add(t.parent))) : this._inlineFiller && this._inlineFiller.parentNode && (t = this.domConverter.domPositionToView(this._inlineFiller));

            var _iterator67 = _createForOfIteratorHelper(this.markedAttributes),
                _step67;

            try {
              for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
                var _t45 = _step67.value;

                this._updateAttrs(_t45);
              }
            } catch (err) {
              _iterator67.e(err);
            } finally {
              _iterator67.f();
            }

            var _iterator68 = _createForOfIteratorHelper(this.markedChildren),
                _step68;

            try {
              for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
                var _e58 = _step68.value;

                this._updateChildren(_e58, {
                  inlineFillerPosition: t
                });
              }
            } catch (err) {
              _iterator68.e(err);
            } finally {
              _iterator68.f();
            }

            var _iterator69 = _createForOfIteratorHelper(this.markedTexts),
                _step69;

            try {
              for (_iterator69.s(); !(_step69 = _iterator69.n()).done;) {
                var _e59 = _step69.value;
                !this.markedChildren.has(_e59.parent) && this.domConverter.mapViewToDom(_e59.parent) && this._updateText(_e59, {
                  inlineFillerPosition: t
                });
              }
            } catch (err) {
              _iterator69.e(err);
            } finally {
              _iterator69.f();
            }

            if (e) if (t) {
              var _e57 = this.domConverter.viewPositionToDom(t),
                  _n49 = _e57.parent.ownerDocument;

              Or(_e57.parent) ? this._inlineFiller = _e57.parent : this._inlineFiller = es(_n49, _e57.parent, _e57.offset);
            } else this._inlineFiller = null;
            this._updateFocus(), this._updateSelection(), this.markedTexts.clear(), this.markedAttributes.clear(), this.markedChildren.clear();
          }
        }, {
          key: "_updateChildrenMappings",
          value: function _updateChildrenMappings(t) {
            var e = this.domConverter.mapViewToDom(t);
            if (!e) return;

            var n = Array.from(this.domConverter.mapViewToDom(t).childNodes),
                i = Array.from(this.domConverter.viewChildrenToDom(t, e.ownerDocument, {
              withChildren: !1
            })),
                o = this._diffNodeLists(n, i),
                r = this._findReplaceActions(o, n, i);

            if (-1 !== r.indexOf("replace")) {
              var _e60 = {
                equal: 0,
                insert: 0,
                delete: 0
              };

              var _iterator70 = _createForOfIteratorHelper(r),
                  _step70;

              try {
                for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
                  var _o20 = _step70.value;

                  if ("replace" === _o20) {
                    var _o21 = _e60.equal + _e60.insert,
                        _r14 = _e60.equal + _e60.delete,
                        _s8 = t.getChild(_o21);

                    !_s8 || _s8.is("uiElement") || _s8.is("rawElement") || this._updateElementMappings(_s8, n[_r14]), $r(i[_o21]), _e60.equal++;
                  } else _e60[_o20]++;
                }
              } catch (err) {
                _iterator70.e(err);
              } finally {
                _iterator70.f();
              }
            }
          }
        }, {
          key: "_updateElementMappings",
          value: function _updateElementMappings(t, e) {
            this.domConverter.unbindDomElement(e), this.domConverter.bindElements(e, t), this.markedChildren.add(t), this.markedAttributes.add(t);
          }
        }, {
          key: "_getInlineFillerPosition",
          value: function _getInlineFillerPosition() {
            var t = this.selection.getFirstPosition();
            return t.parent.is("$text") ? Oo._createBefore(this.selection.getFirstPosition().parent) : t;
          }
        }, {
          key: "_isSelectionInInlineFiller",
          value: function _isSelectionInInlineFiller() {
            if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
            var t = this.selection.getFirstPosition(),
                e = this.domConverter.viewPositionToDom(t);
            return !!(e && Br(e.parent) && Or(e.parent));
          }
        }, {
          key: "_removeInlineFiller",
          value: function _removeInlineFiller() {
            var t = this._inlineFiller;
            if (!Or(t)) throw new a("view-renderer-filler-was-lost", this);
            jr(t) ? t.remove() : t.data = t.data.substr(7), this._inlineFiller = null;
          }
        }, {
          key: "_needsInlineFillerAtSelection",
          value: function _needsInlineFillerAtSelection() {
            if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
            var t = this.selection.getFirstPosition(),
                e = t.parent,
                n = t.offset;
            if (!this.domConverter.mapViewToDom(e.root)) return !1;
            if (!e.is("element")) return !1;
            if (!function (t) {
              if ("false" == t.getAttribute("contenteditable")) return !1;
              var e = t.findAncestor(function (t) {
                return t.hasAttribute("contenteditable");
              });
              return !e || "true" == e.getAttribute("contenteditable");
            }(e)) return !1;
            if (n === e.getFillerOffset()) return !1;
            var i = t.nodeBefore,
                o = t.nodeAfter;
            return !(i instanceof ji || o instanceof ji);
          }
        }, {
          key: "_updateText",
          value: function _updateText(t, e) {
            var n = this.domConverter.findCorrespondingDomText(t),
                i = this.domConverter.viewToDom(t, n.ownerDocument),
                o = n.data;
            var r = i.data;
            var s = e.inlineFillerPosition;

            if (s && s.parent == t.parent && s.offset == t.index && (r = Rr + r), o != r) {
              var _t46 = Ur(o, r);

              var _iterator71 = _createForOfIteratorHelper(_t46),
                  _step71;

              try {
                for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
                  var _e61 = _step71.value;
                  "insert" === _e61.type ? n.insertData(_e61.index, _e61.values.join("")) : n.deleteData(_e61.index, _e61.howMany);
                }
              } catch (err) {
                _iterator71.e(err);
              } finally {
                _iterator71.f();
              }
            }
          }
        }, {
          key: "_updateAttrs",
          value: function _updateAttrs(t) {
            var e = this.domConverter.mapViewToDom(t);
            if (!e) return;
            var n = Array.from(e.attributes).map(function (t) {
              return t.name;
            }),
                i = t.getAttributeKeys();

            var _iterator72 = _createForOfIteratorHelper(i),
                _step72;

            try {
              for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
                var _n50 = _step72.value;
                this.domConverter.setDomElementAttribute(e, _n50, t.getAttribute(_n50), t);
              }
            } catch (err) {
              _iterator72.e(err);
            } finally {
              _iterator72.f();
            }

            var _iterator73 = _createForOfIteratorHelper(n),
                _step73;

            try {
              for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
                var _i36 = _step73.value;
                t.hasAttribute(_i36) || this.domConverter.removeDomElementAttribute(e, _i36);
              }
            } catch (err) {
              _iterator73.e(err);
            } finally {
              _iterator73.f();
            }
          }
        }, {
          key: "_updateChildren",
          value: function _updateChildren(t, e) {
            var n = this.domConverter.mapViewToDom(t);
            if (!n) return;
            var i = e.inlineFillerPosition,
                o = this.domConverter.mapViewToDom(t).childNodes,
                r = Array.from(this.domConverter.viewChildrenToDom(t, n.ownerDocument, {
              bind: !0
            }));
            i && i.parent === t && es(n.ownerDocument, r, i.offset);

            var s = this._diffNodeLists(o, r);

            var a = 0;
            var c = new Set();

            var _iterator74 = _createForOfIteratorHelper(s),
                _step74;

            try {
              for (_iterator74.s(); !(_step74 = _iterator74.n()).done;) {
                var _t47 = _step74.value;
                "delete" === _t47 ? (c.add(o[a]), $r(o[a])) : "equal" === _t47 && a++;
              }
            } catch (err) {
              _iterator74.e(err);
            } finally {
              _iterator74.f();
            }

            a = 0;

            var _iterator75 = _createForOfIteratorHelper(s),
                _step75;

            try {
              for (_iterator75.s(); !(_step75 = _iterator75.n()).done;) {
                var _t48 = _step75.value;
                "insert" === _t48 ? (Gr(n, a, r[a]), a++) : "equal" === _t48 && (this._markDescendantTextToSync(this.domConverter.domToView(r[a])), a++);
              }
            } catch (err) {
              _iterator75.e(err);
            } finally {
              _iterator75.f();
            }

            var _iterator76 = _createForOfIteratorHelper(c),
                _step76;

            try {
              for (_iterator76.s(); !(_step76 = _iterator76.n()).done;) {
                var _t49 = _step76.value;
                _t49.parentNode || this.domConverter.unbindDomElement(_t49);
              }
            } catch (err) {
              _iterator76.e(err);
            } finally {
              _iterator76.f();
            }
          }
        }, {
          key: "_diffNodeLists",
          value: function _diffNodeLists(t, e) {
            return Wr(t = function (t, e) {
              var n = Array.from(t);
              if (0 == n.length || !e) return n;
              n[n.length - 1] == e && n.pop();
              return n;
            }(t, this._fakeSelectionContainer), e, is.bind(null, this.domConverter));
          }
        }, {
          key: "_findReplaceActions",
          value: function _findReplaceActions(t, e, n) {
            if (-1 === t.indexOf("insert") || -1 === t.indexOf("delete")) return t;
            var i = [],
                o = [],
                r = [];
            var s = {
              equal: 0,
              insert: 0,
              delete: 0
            };

            var _iterator77 = _createForOfIteratorHelper(t),
                _step77;

            try {
              for (_iterator77.s(); !(_step77 = _iterator77.n()).done;) {
                var _a7 = _step77.value;
                "insert" === _a7 ? r.push(n[s.equal + s.insert]) : "delete" === _a7 ? o.push(e[s.equal + s.delete]) : (i = i.concat(Wr(o, r, ns).map(function (t) {
                  return "equal" === t ? "replace" : t;
                })), i.push("equal"), o = [], r = []), s[_a7]++;
              }
            } catch (err) {
              _iterator77.e(err);
            } finally {
              _iterator77.f();
            }

            return i.concat(Wr(o, r, ns).map(function (t) {
              return "equal" === t ? "replace" : t;
            }));
          }
        }, {
          key: "_markDescendantTextToSync",
          value: function _markDescendantTextToSync(t) {
            if (t) if (t.is("$text")) this.markedTexts.add(t);else if (t.is("element")) {
              var _iterator78 = _createForOfIteratorHelper(t.getChildren()),
                  _step78;

              try {
                for (_iterator78.s(); !(_step78 = _iterator78.n()).done;) {
                  var _e62 = _step78.value;

                  this._markDescendantTextToSync(_e62);
                }
              } catch (err) {
                _iterator78.e(err);
              } finally {
                _iterator78.f();
              }
            }
          }
        }, {
          key: "_updateSelection",
          value: function _updateSelection() {
            if (sr.isBlink && !sr.isAndroid && this.isSelecting && !this.markedChildren.size) return;
            if (0 === this.selection.rangeCount) return this._removeDomSelection(), void this._removeFakeSelection();
            var t = this.domConverter.mapViewToDom(this.selection.editableElement);
            this.isFocused && t && (this.selection.isFake ? this._updateFakeSelection(t) : (this._removeFakeSelection(), this._updateDomSelection(t)));
          }
        }, {
          key: "_updateFakeSelection",
          value: function _updateFakeSelection(t) {
            var e = t.ownerDocument;
            this._fakeSelectionContainer || (this._fakeSelectionContainer = function (t) {
              var e = t.createElement("div");
              return e.className = "ck-fake-selection-container", Object.assign(e.style, {
                position: "fixed",
                top: 0,
                left: "-9999px",
                width: "42px"
              }), e.textContent = " ", e;
            }(e));
            var n = this._fakeSelectionContainer;
            if (this.domConverter.bindFakeSelection(n, this.selection), !this._fakeSelectionNeedsUpdate(t)) return;
            n.parentElement && n.parentElement == t || t.appendChild(n), n.textContent = this.selection.fakeSelectionLabel || " ";
            var i = e.getSelection(),
                o = e.createRange();
            i.removeAllRanges(), o.selectNodeContents(n), i.addRange(o);
          }
        }, {
          key: "_updateDomSelection",
          value: function _updateDomSelection(t) {
            var e = t.ownerDocument.defaultView.getSelection();
            if (!this._domSelectionNeedsUpdate(e)) return;
            var n = this.domConverter.viewPositionToDom(this.selection.anchor),
                i = this.domConverter.viewPositionToDom(this.selection.focus);
            e.collapse(n.parent, n.offset), e.extend(i.parent, i.offset), sr.isGecko && function (t, e) {
              var n = t.parent;
              if (n.nodeType != Node.ELEMENT_NODE || t.offset != n.childNodes.length - 1) return;
              var i = n.childNodes[t.offset];
              i && "BR" == i.tagName && e.addRange(e.getRangeAt(0));
            }(i, e);
          }
        }, {
          key: "_domSelectionNeedsUpdate",
          value: function _domSelectionNeedsUpdate(t) {
            if (!this.domConverter.isDomSelectionCorrect(t)) return !0;
            var e = t && this.domConverter.domSelectionToView(t);
            return (!e || !this.selection.isEqual(e)) && !(!this.selection.isCollapsed && this.selection.isSimilar(e));
          }
        }, {
          key: "_fakeSelectionNeedsUpdate",
          value: function _fakeSelectionNeedsUpdate(t) {
            var e = this._fakeSelectionContainer,
                n = t.ownerDocument.getSelection();
            return !e || e.parentElement !== t || n.anchorNode !== e && !e.contains(n.anchorNode) || e.textContent !== this.selection.fakeSelectionLabel;
          }
        }, {
          key: "_removeDomSelection",
          value: function _removeDomSelection() {
            var _iterator79 = _createForOfIteratorHelper(this.domDocuments),
                _step79;

            try {
              for (_iterator79.s(); !(_step79 = _iterator79.n()).done;) {
                var _t50 = _step79.value;

                if (_t50.getSelection().rangeCount) {
                  var _e63 = _t50.activeElement,
                      _n51 = this.domConverter.mapDomToView(_e63);

                  _e63 && _n51 && _t50.getSelection().removeAllRanges();
                }
              }
            } catch (err) {
              _iterator79.e(err);
            } finally {
              _iterator79.f();
            }
          }
        }, {
          key: "_removeFakeSelection",
          value: function _removeFakeSelection() {
            var t = this._fakeSelectionContainer;
            t && t.remove();
          }
        }, {
          key: "_updateFocus",
          value: function _updateFocus() {
            if (this.isFocused) {
              var _t51 = this.selection.editableElement;
              _t51 && this.domConverter.focus(_t51);
            }
          }
        }]);

        return ts;
      }();

      function es(t, e, n) {
        var i = e instanceof Array ? e : e.childNodes,
            o = i[n];
        if (Br(o)) return o.data = Rr + o.data, o;
        {
          var _o22 = t.createTextNode(Rr);

          return Array.isArray(e) ? i.splice(n, 0, _o22) : Gr(e, n, _o22), _o22;
        }
      }

      function ns(t, e) {
        return Kr(t) && Kr(e) && !Br(t) && !Br(e) && !Yr(t) && !Yr(e) && t.tagName.toLowerCase() === e.tagName.toLowerCase();
      }

      function is(t, e, n) {
        return e === n || (Br(e) && Br(n) ? e.data === n.data : !(!t.isBlockFiller(e) || !t.isBlockFiller(n)));
      }

      he(ts, re);
      var os = {
        window: window,
        document: document
      };

      function rs(t) {
        var e = 0;

        for (; t.previousSibling;) {
          t = t.previousSibling, e++;
        }

        return e;
      }

      function ss(t) {
        var e = [];

        for (; t && t.nodeType != Node.DOCUMENT_NODE;) {
          e.unshift(t), t = t.parentNode;
        }

        return e;
      }

      var as = Lr(document),
          cs = zr(document),
          ls = Pr(document),
          ds = "data-ck-unsafe-attribute-",
          hs = "data-ck-unsafe-element";

      var us = /*#__PURE__*/function () {
        function us(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          _classCallCheck(this, us);

          this.document = t, this.renderingMode = e.renderingMode || "editing", this.blockFillerMode = e.blockFillerMode || ("editing" === this.renderingMode ? "br" : "nbsp"), this.preElements = ["pre"], this.blockElements = ["address", "article", "aside", "blockquote", "caption", "center", "dd", "details", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "legend", "li", "main", "menu", "nav", "ol", "p", "pre", "section", "summary", "table", "tbody", "td", "tfoot", "th", "thead", "tr", "ul"], this.inlineObjectElements = ["object", "iframe", "input", "button", "textarea", "select", "option", "video", "embed", "audio", "img", "canvas"], this._domToViewMapping = new WeakMap(), this._viewToDomMapping = new WeakMap(), this._fakeSelectionMapping = new WeakMap(), this._rawContentElementMatcher = new Ui(), this._encounteredRawContentDomNodes = new WeakSet();
        }

        _createClass(us, [{
          key: "bindFakeSelection",
          value: function bindFakeSelection(t, e) {
            this._fakeSelectionMapping.set(t, new Uo(e));
          }
        }, {
          key: "fakeSelectionToView",
          value: function fakeSelectionToView(t) {
            return this._fakeSelectionMapping.get(t);
          }
        }, {
          key: "bindElements",
          value: function bindElements(t, e) {
            this._domToViewMapping.set(t, e), this._viewToDomMapping.set(e, t);
          }
        }, {
          key: "unbindDomElement",
          value: function unbindDomElement(t) {
            var e = this._domToViewMapping.get(t);

            if (e) {
              this._domToViewMapping.delete(t), this._viewToDomMapping.delete(e);

              var _iterator80 = _createForOfIteratorHelper(t.childNodes),
                  _step80;

              try {
                for (_iterator80.s(); !(_step80 = _iterator80.n()).done;) {
                  var _e64 = _step80.value;
                  this.unbindDomElement(_e64);
                }
              } catch (err) {
                _iterator80.e(err);
              } finally {
                _iterator80.f();
              }
            }
          }
        }, {
          key: "bindDocumentFragments",
          value: function bindDocumentFragments(t, e) {
            this._domToViewMapping.set(t, e), this._viewToDomMapping.set(e, t);
          }
        }, {
          key: "shouldRenderAttribute",
          value: function shouldRenderAttribute(t, e, n) {
            return "data" === this.renderingMode || !(t = t.toLowerCase()).startsWith("on") && ("srcdoc" !== t || !e.match(/\bon\S+\s*=|javascript:|<\s*\/*script/i)) && ("img" === n && ("src" === t || "srcset" === t) || "source" === n && "srcset" === t || !e.match(/^\s*(javascript:|data:(image\/svg|text\/x?html))/i));
          }
        }, {
          key: "setContentOf",
          value: function setContentOf(t, e) {
            if ("data" === this.renderingMode) return void (t.innerHTML = e);
            var n = new DOMParser().parseFromString(e, "text/html"),
                i = n.createDocumentFragment(),
                o = n.body.childNodes;

            for (; o.length > 0;) {
              i.appendChild(o[0]);
            }

            var r = n.createTreeWalker(i, NodeFilter.SHOW_ELEMENT),
                s = [];
            var a;

            for (; a = r.nextNode();) {
              s.push(a);
            }

            for (var _i37 = 0, _s9 = s; _i37 < _s9.length; _i37++) {
              var _t52 = _s9[_i37];

              var _iterator81 = _createForOfIteratorHelper(_t52.getAttributeNames()),
                  _step81;

              try {
                for (_iterator81.s(); !(_step81 = _iterator81.n()).done;) {
                  var _e66 = _step81.value;
                  this.setDomElementAttribute(_t52, _e66, _t52.getAttribute(_e66));
                }
              } catch (err) {
                _iterator81.e(err);
              } finally {
                _iterator81.f();
              }

              var _e65 = _t52.tagName.toLowerCase();

              this._shouldRenameElement(_e65) && (c("domconverter-unsafe-element-detected", {
                unsafeElement: _t52
              }), _t52.replaceWith(this._createReplacementDomElement(_e65, _t52)));
            }

            for (; t.firstChild;) {
              t.firstChild.remove();
            }

            t.append(i);
          }
        }, {
          key: "viewToDom",
          value: function viewToDom(t, e) {
            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            if (t.is("$text")) {
              var _n52 = this._processDataFromViewText(t);

              return e.createTextNode(_n52);
            }

            {
              if (this.mapViewToDom(t)) return this.mapViewToDom(t);

              var _i38;

              if (t.is("documentFragment")) _i38 = e.createDocumentFragment(), n.bind && this.bindDocumentFragments(_i38, t);else {
                if (t.is("uiElement")) return _i38 = "$comment" === t.name ? e.createComment(t.getCustomProperty("$rawContent")) : t.render(e, this), n.bind && this.bindElements(_i38, t), _i38;
                this._shouldRenameElement(t.name) ? (c("domconverter-unsafe-element-detected", {
                  unsafeElement: t
                }), _i38 = this._createReplacementDomElement(t.name)) : _i38 = t.hasAttribute("xmlns") ? e.createElementNS(t.getAttribute("xmlns"), t.name) : e.createElement(t.name), t.is("rawElement") && t.render(_i38, this), n.bind && this.bindElements(_i38, t);

                var _iterator82 = _createForOfIteratorHelper(t.getAttributeKeys()),
                    _step82;

                try {
                  for (_iterator82.s(); !(_step82 = _iterator82.n()).done;) {
                    var _e67 = _step82.value;
                    this.setDomElementAttribute(_i38, _e67, t.getAttribute(_e67), t);
                  }
                } catch (err) {
                  _iterator82.e(err);
                } finally {
                  _iterator82.f();
                }
              }

              if (!1 !== n.withChildren) {
                var _iterator83 = _createForOfIteratorHelper(this.viewChildrenToDom(t, e, n)),
                    _step83;

                try {
                  for (_iterator83.s(); !(_step83 = _iterator83.n()).done;) {
                    var _o23 = _step83.value;

                    _i38.appendChild(_o23);
                  }
                } catch (err) {
                  _iterator83.e(err);
                } finally {
                  _iterator83.f();
                }
              }

              return _i38;
            }
          }
        }, {
          key: "setDomElementAttribute",
          value: function setDomElementAttribute(t, e, n) {
            var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            var o = this.shouldRenderAttribute(e, n, t.tagName.toLowerCase()) || i && i.shouldRenderUnsafeAttribute(e);
            o || c("domconverter-unsafe-attribute-detected", {
              domElement: t,
              key: e,
              value: n
            }), t.hasAttribute(e) && !o ? t.removeAttribute(e) : t.hasAttribute(ds + e) && o && t.removeAttribute(ds + e), t.setAttribute(o ? e : ds + e, n);
          }
        }, {
          key: "removeDomElementAttribute",
          value: function removeDomElementAttribute(t, e) {
            e != hs && (t.removeAttribute(e), t.removeAttribute(ds + e));
          }
        }, {
          key: "viewChildrenToDom",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function viewChildrenToDom(t, e) {
            var n,
                i,
                o,
                _iterator84,
                _step84,
                _r15,
                _args11 = arguments;

            return _regeneratorRuntime.wrap(function viewChildrenToDom$(_context11) {
              while (1) {
                switch (_context11.prev = _context11.next) {
                  case 0:
                    n = _args11.length > 2 && _args11[2] !== undefined ? _args11[2] : {};
                    i = t.getFillerOffset && t.getFillerOffset();
                    o = 0;
                    _iterator84 = _createForOfIteratorHelper(t.getChildren());
                    _context11.prev = 4;

                    _iterator84.s();

                  case 6:
                    if ((_step84 = _iterator84.n()).done) {
                      _context11.next = 17;
                      break;
                    }

                    _r15 = _step84.value;
                    _context11.t0 = i === o;

                    if (!_context11.t0) {
                      _context11.next = 12;
                      break;
                    }

                    _context11.next = 12;
                    return this._getBlockFiller(e);

                  case 12:
                    _context11.next = 14;
                    return this.viewToDom(_r15, e, n);

                  case 14:
                    o++;

                  case 15:
                    _context11.next = 6;
                    break;

                  case 17:
                    _context11.next = 22;
                    break;

                  case 19:
                    _context11.prev = 19;
                    _context11.t1 = _context11["catch"](4);

                    _iterator84.e(_context11.t1);

                  case 22:
                    _context11.prev = 22;

                    _iterator84.f();

                    return _context11.finish(22);

                  case 25:
                    _context11.t2 = i === o;

                    if (!_context11.t2) {
                      _context11.next = 29;
                      break;
                    }

                    _context11.next = 29;
                    return this._getBlockFiller(e);

                  case 29:
                  case "end":
                    return _context11.stop();
                }
              }
            }, viewChildrenToDom, this, [[4, 19, 22, 25]]);
          })
        }, {
          key: "viewRangeToDom",
          value: function viewRangeToDom(t) {
            var e = this.viewPositionToDom(t.start),
                n = this.viewPositionToDom(t.end),
                i = document.createRange();
            return i.setStart(e.parent, e.offset), i.setEnd(n.parent, n.offset), i;
          }
        }, {
          key: "viewPositionToDom",
          value: function viewPositionToDom(t) {
            var e = t.parent;

            if (e.is("$text")) {
              var _n53 = this.findCorrespondingDomText(e);

              if (!_n53) return null;
              var _i39 = t.offset;
              return Or(_n53) && (_i39 += 7), {
                parent: _n53,
                offset: _i39
              };
            }

            {
              var _n54, _i40, _o24;

              if (0 === t.offset) {
                if (_n54 = this.mapViewToDom(e), !_n54) return null;
                _o24 = _n54.childNodes[0];
              } else {
                var _e68 = t.nodeBefore;
                if (_i40 = _e68.is("$text") ? this.findCorrespondingDomText(_e68) : this.mapViewToDom(t.nodeBefore), !_i40) return null;
                _n54 = _i40.parentNode, _o24 = _i40.nextSibling;
              }

              if (Br(_o24) && Or(_o24)) return {
                parent: _o24,
                offset: 7
              };
              return {
                parent: _n54,
                offset: _i40 ? rs(_i40) + 1 : 0
              };
            }
          }
        }, {
          key: "domToView",
          value: function domToView(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            if (this.isBlockFiller(t)) return null;
            var n = this.getHostViewElement(t);
            if (n) return n;
            if (Yr(t) && e.skipComments) return null;

            if (Br(t)) {
              if (jr(t)) return null;
              {
                var _e69 = this._processDataFromDomText(t);

                return "" === _e69 ? null : new ji(this.document, _e69);
              }
            }

            {
              if (this.mapDomToView(t)) return this.mapDomToView(t);

              var _n55;

              if (this.isDocumentFragment(t)) _n55 = new Cr(this.document), e.bind && this.bindDocumentFragments(t, _n55);else {
                _n55 = this._createViewElement(t, e), e.bind && this.bindElements(t, _n55);
                var _i41 = t.attributes;
                if (_i41) for (var _t53 = _i41.length - 1; _t53 >= 0; _t53--) {
                  _n55._setAttribute(_i41[_t53].name, _i41[_t53].value);
                }

                if (this._isViewElementWithRawContent(_n55, e) || Yr(t)) {
                  var _e70 = Yr(t) ? t.data : t.innerHTML;

                  return _n55._setCustomProperty("$rawContent", _e70), this._encounteredRawContentDomNodes.add(t), _n55;
                }
              }

              if (!1 !== e.withChildren) {
                var _iterator85 = _createForOfIteratorHelper(this.domChildrenToView(t, e)),
                    _step85;

                try {
                  for (_iterator85.s(); !(_step85 = _iterator85.n()).done;) {
                    var _i42 = _step85.value;

                    _n55._appendChild(_i42);
                  }
                } catch (err) {
                  _iterator85.e(err);
                } finally {
                  _iterator85.f();
                }
              }

              return _n55;
            }
          }
        }, {
          key: "domChildrenToView",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function domChildrenToView(t) {
            var e,
                _n56,
                _i43,
                _o25,
                _args12 = arguments;

            return _regeneratorRuntime.wrap(function domChildrenToView$(_context12) {
              while (1) {
                switch (_context12.prev = _context12.next) {
                  case 0:
                    e = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : {};
                    _n56 = 0;

                  case 2:
                    if (!(_n56 < t.childNodes.length)) {
                      _context12.next = 11;
                      break;
                    }

                    _i43 = t.childNodes[_n56], _o25 = this.domToView(_i43, e);
                    _context12.t0 = null !== _o25;

                    if (!_context12.t0) {
                      _context12.next = 8;
                      break;
                    }

                    _context12.next = 8;
                    return _o25;

                  case 8:
                    _n56++;
                    _context12.next = 2;
                    break;

                  case 11:
                  case "end":
                    return _context12.stop();
                }
              }
            }, domChildrenToView, this);
          })
        }, {
          key: "domSelectionToView",
          value: function domSelectionToView(t) {
            if (1 === t.rangeCount) {
              var _e71 = t.getRangeAt(0).startContainer;
              Br(_e71) && (_e71 = _e71.parentNode);

              var _n57 = this.fakeSelectionToView(_e71);

              if (_n57) return _n57;
            }

            var e = this.isDomSelectionBackward(t),
                n = [];

            for (var _e72 = 0; _e72 < t.rangeCount; _e72++) {
              var _i44 = t.getRangeAt(_e72),
                  _o26 = this.domRangeToView(_i44);

              _o26 && n.push(_o26);
            }

            return new Uo(n, {
              backward: e
            });
          }
        }, {
          key: "domRangeToView",
          value: function domRangeToView(t) {
            var e = this.domPositionToView(t.startContainer, t.startOffset),
                n = this.domPositionToView(t.endContainer, t.endOffset);
            return e && n ? new jo(e, n) : null;
          }
        }, {
          key: "domPositionToView",
          value: function domPositionToView(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            if (this.isBlockFiller(t)) return this.domPositionToView(t.parentNode, rs(t));
            var n = this.mapDomToView(t);
            if (n && (n.is("uiElement") || n.is("rawElement"))) return Oo._createBefore(n);

            if (Br(t)) {
              if (jr(t)) return this.domPositionToView(t.parentNode, rs(t));

              var _n58 = this.findCorrespondingViewText(t);

              var _i45 = e;
              return _n58 ? (Or(t) && (_i45 -= 7, _i45 = _i45 < 0 ? 0 : _i45), new Oo(_n58, _i45)) : null;
            }

            if (0 === e) {
              var _e73 = this.mapDomToView(t);

              if (_e73) return new Oo(_e73, 0);
            } else {
              var _n59 = t.childNodes[e - 1],
                  _i46 = Br(_n59) ? this.findCorrespondingViewText(_n59) : this.mapDomToView(_n59);

              if (_i46 && _i46.parent) return new Oo(_i46.parent, _i46.index + 1);
            }

            return null;
          }
        }, {
          key: "mapDomToView",
          value: function mapDomToView(t) {
            return this.getHostViewElement(t) || this._domToViewMapping.get(t);
          }
        }, {
          key: "findCorrespondingViewText",
          value: function findCorrespondingViewText(t) {
            if (jr(t)) return null;
            var e = this.getHostViewElement(t);
            if (e) return e;
            var n = t.previousSibling;

            if (n) {
              if (!this.isElement(n)) return null;

              var _t54 = this.mapDomToView(n);

              if (_t54) {
                return _t54.nextSibling instanceof ji ? _t54.nextSibling : null;
              }
            } else {
              var _e74 = this.mapDomToView(t.parentNode);

              if (_e74) {
                var _t55 = _e74.getChild(0);

                return _t55 instanceof ji ? _t55 : null;
              }
            }

            return null;
          }
        }, {
          key: "mapViewToDom",
          value: function mapViewToDom(t) {
            return this._viewToDomMapping.get(t);
          }
        }, {
          key: "findCorrespondingDomText",
          value: function findCorrespondingDomText(t) {
            var e = t.previousSibling;
            return e && this.mapViewToDom(e) ? this.mapViewToDom(e).nextSibling : !e && t.parent && this.mapViewToDom(t.parent) ? this.mapViewToDom(t.parent).childNodes[0] : null;
          }
        }, {
          key: "focus",
          value: function focus(t) {
            var e = this.mapViewToDom(t);

            if (e && e.ownerDocument.activeElement !== e) {
              var _os$window = os.window,
                  _t56 = _os$window.scrollX,
                  _n60 = _os$window.scrollY,
                  _i47 = [];
              gs(e, function (t) {
                var e = t.scrollLeft,
                    n = t.scrollTop;

                _i47.push([e, n]);
              }), e.focus(), gs(e, function (t) {
                var _i47$shift = _i47.shift(),
                    _i47$shift2 = _slicedToArray(_i47$shift, 2),
                    e = _i47$shift2[0],
                    n = _i47$shift2[1];

                t.scrollLeft = e, t.scrollTop = n;
              }), os.window.scrollTo(_t56, _n60);
            }
          }
        }, {
          key: "isElement",
          value: function isElement(t) {
            return t && t.nodeType == Node.ELEMENT_NODE;
          }
        }, {
          key: "isDocumentFragment",
          value: function isDocumentFragment(t) {
            return t && t.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
          }
        }, {
          key: "isBlockFiller",
          value: function isBlockFiller(t) {
            return "br" == this.blockFillerMode ? t.isEqualNode(as) : !("BR" !== t.tagName || !ms(t, this.blockElements) || 1 !== t.parentNode.childNodes.length) || t.isEqualNode(ls) || function (t, e) {
              return t.isEqualNode(cs) && ms(t, e) && 1 === t.parentNode.childNodes.length;
            }(t, this.blockElements);
          }
        }, {
          key: "isDomSelectionBackward",
          value: function isDomSelectionBackward(t) {
            if (t.isCollapsed) return !1;
            var e = document.createRange();
            e.setStart(t.anchorNode, t.anchorOffset), e.setEnd(t.focusNode, t.focusOffset);
            var n = e.collapsed;
            return e.detach(), n;
          }
        }, {
          key: "getHostViewElement",
          value: function getHostViewElement(t) {
            var e = ss(t);

            for (e.pop(); e.length;) {
              var _t57 = e.pop(),
                  _n61 = this._domToViewMapping.get(_t57);

              if (_n61 && (_n61.is("uiElement") || _n61.is("rawElement"))) return _n61;
            }

            return null;
          }
        }, {
          key: "isDomSelectionCorrect",
          value: function isDomSelectionCorrect(t) {
            return this._isDomSelectionPositionCorrect(t.anchorNode, t.anchorOffset) && this._isDomSelectionPositionCorrect(t.focusNode, t.focusOffset);
          }
        }, {
          key: "registerRawContentMatcher",
          value: function registerRawContentMatcher(t) {
            this._rawContentElementMatcher.add(t);
          }
        }, {
          key: "_getBlockFiller",
          value: function _getBlockFiller(t) {
            switch (this.blockFillerMode) {
              case "nbsp":
                return zr(t);

              case "markedNbsp":
                return Pr(t);

              case "br":
                return Lr(t);
            }
          }
        }, {
          key: "_isDomSelectionPositionCorrect",
          value: function _isDomSelectionPositionCorrect(t, e) {
            if (Br(t) && Or(t) && e < 7) return !1;
            if (this.isElement(t) && Or(t.childNodes[e])) return !1;
            var n = this.mapDomToView(t);
            return !n || !n.is("uiElement") && !n.is("rawElement");
          }
        }, {
          key: "_processDataFromViewText",
          value: function _processDataFromViewText(t) {
            var _this29 = this;

            var e = t.data;
            if (t.getAncestors().some(function (t) {
              return _this29.preElements.includes(t.name);
            })) return e;

            if (" " == e.charAt(0)) {
              var _n62 = this._getTouchingInlineViewNode(t, !1);

              !(_n62 && _n62.is("$textProxy") && this._nodeEndsWithSpace(_n62)) && _n62 || (e = " " + e.substr(1));
            }

            if (" " == e.charAt(e.length - 1)) {
              var _n63 = this._getTouchingInlineViewNode(t, !0),
                  _i48 = _n63 && _n63.is("$textProxy") && " " == _n63.data.charAt(0);

              " " != e.charAt(e.length - 2) && _n63 && !_i48 || (e = e.substr(0, e.length - 1) + " ");
            }

            return e.replace(/ {2}/g, "  ");
          }
        }, {
          key: "_nodeEndsWithSpace",
          value: function _nodeEndsWithSpace(t) {
            var _this30 = this;

            if (t.getAncestors().some(function (t) {
              return _this30.preElements.includes(t.name);
            })) return !1;

            var e = this._processDataFromViewText(t);

            return " " == e.charAt(e.length - 1);
          }
        }, {
          key: "_processDataFromDomText",
          value: function _processDataFromDomText(t) {
            var e = t.data;
            if (function (t, e) {
              return ss(t).some(function (t) {
                return t.tagName && e.includes(t.tagName.toLowerCase());
              });
            }(t, this.preElements)) return Fr(t);
            e = e.replace(/[ \n\t\r]{1,}/g, " ");

            var n = this._getTouchingInlineDomNode(t, !1),
                i = this._getTouchingInlineDomNode(t, !0),
                o = this._checkShouldLeftTrimDomText(t, n),
                r = this._checkShouldRightTrimDomText(t, i);

            o && (e = e.replace(/^ /, "")), r && (e = e.replace(/ $/, "")), e = Fr(new Text(e)), e = e.replace(/ \u00A0/g, "  ");
            var s = i && this.isElement(i) && "BR" != i.tagName,
                a = i && Br(i) && " " == i.data.charAt(0);
            return (/( |\u00A0)\u00A0$/.test(e) || !i || s || a) && (e = e.replace(/\u00A0$/, " ")), (o || n && this.isElement(n) && "BR" != n.tagName) && (e = e.replace(/^\u00A0/, " ")), e;
          }
        }, {
          key: "_checkShouldLeftTrimDomText",
          value: function _checkShouldLeftTrimDomText(t, e) {
            return !e || (this.isElement(e) ? "BR" === e.tagName : !this._encounteredRawContentDomNodes.has(t.previousSibling) && /[^\S\u00A0]/.test(e.data.charAt(e.data.length - 1)));
          }
        }, {
          key: "_checkShouldRightTrimDomText",
          value: function _checkShouldRightTrimDomText(t, e) {
            return !e && !Or(t);
          }
        }, {
          key: "_getTouchingInlineViewNode",
          value: function _getTouchingInlineViewNode(t, e) {
            var n = new Ro({
              startPosition: e ? Oo._createAfter(t) : Oo._createBefore(t),
              direction: e ? "forward" : "backward"
            });

            var _iterator86 = _createForOfIteratorHelper(n),
                _step86;

            try {
              for (_iterator86.s(); !(_step86 = _iterator86.n()).done;) {
                var _t58 = _step86.value;
                if (_t58.item.is("element") && this.inlineObjectElements.includes(_t58.item.name)) return _t58.item;
                if (_t58.item.is("containerElement")) return null;
                if (_t58.item.is("element", "br")) return null;
                if (_t58.item.is("$textProxy")) return _t58.item;
              }
            } catch (err) {
              _iterator86.e(err);
            } finally {
              _iterator86.f();
            }

            return null;
          }
        }, {
          key: "_getTouchingInlineDomNode",
          value: function _getTouchingInlineDomNode(t, e) {
            if (!t.parentNode) return null;
            var n = e ? "firstChild" : "lastChild",
                i = e ? "nextSibling" : "previousSibling";
            var o = !0;

            do {
              if (!o && t[n] ? t = t[n] : t[i] ? (t = t[i], o = !1) : (t = t.parentNode, o = !0), !t || this._isBlockElement(t)) return null;
            } while (!Br(t) && "BR" != t.tagName && !this._isInlineObjectElement(t));

            return t;
          }
        }, {
          key: "_isBlockElement",
          value: function _isBlockElement(t) {
            return this.isElement(t) && this.blockElements.includes(t.tagName.toLowerCase());
          }
        }, {
          key: "_isInlineObjectElement",
          value: function _isInlineObjectElement(t) {
            return this.isElement(t) && this.inlineObjectElements.includes(t.tagName.toLowerCase());
          }
        }, {
          key: "_createViewElement",
          value: function _createViewElement(t, e) {
            if (Yr(t)) return new fr(this.document, "$comment");
            var n = e.keepOriginalCase ? t.tagName : t.tagName.toLowerCase();
            return new Mo(this.document, n);
          }
        }, {
          key: "_isViewElementWithRawContent",
          value: function _isViewElementWithRawContent(t, e) {
            return !1 !== e.withChildren && this._rawContentElementMatcher.match(t);
          }
        }, {
          key: "_shouldRenameElement",
          value: function _shouldRenameElement(t) {
            return "editing" == this.renderingMode && "script" == t.toLowerCase();
          }
        }, {
          key: "_createReplacementDomElement",
          value: function _createReplacementDomElement(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var n = document.createElement("span");

            if (n.setAttribute(hs, t), e) {
              for (; e.firstChild;) {
                n.appendChild(e.firstChild);
              }

              var _iterator87 = _createForOfIteratorHelper(e.getAttributeNames()),
                  _step87;

              try {
                for (_iterator87.s(); !(_step87 = _iterator87.n()).done;) {
                  var _t59 = _step87.value;
                  n.setAttribute(_t59, e.getAttribute(_t59));
                }
              } catch (err) {
                _iterator87.e(err);
              } finally {
                _iterator87.f();
              }
            }

            return n;
          }
        }]);

        return us;
      }();

      function gs(t, e) {
        for (; t && t != os.document;) {
          e(t), t = t.parentNode;
        }
      }

      function ms(t, e) {
        var n = t.parentNode;
        return n && n.tagName && e.includes(n.tagName.toLowerCase());
      }

      function ps(t) {
        var e = Object.prototype.toString.apply(t);
        return "[object Window]" == e || "[object global]" == e;
      }

      var fs = Jt({}, f, {
        listenTo: function listenTo(t, e, n) {
          var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

          if (Kr(t) || ps(t)) {
            var _o27 = {
              capture: !!i.useCapture,
              passive: !!i.usePassive
            },
                _r16 = this._getProxyEmitter(t, _o27) || new bs(t, _o27);

            this.listenTo(_r16, e, n, i);
          } else f.listenTo.call(this, t, e, n, i);
        },
        stopListening: function stopListening(t, e, n) {
          if (Kr(t) || ps(t)) {
            var _i49 = this._getAllProxyEmitters(t);

            var _iterator88 = _createForOfIteratorHelper(_i49),
                _step88;

            try {
              for (_iterator88.s(); !(_step88 = _iterator88.n()).done;) {
                var _t60 = _step88.value;
                this.stopListening(_t60, e, n);
              }
            } catch (err) {
              _iterator88.e(err);
            } finally {
              _iterator88.f();
            }
          } else f.stopListening.call(this, t, e, n);
        },
        _getProxyEmitter: function _getProxyEmitter(t, e) {
          return n = this, i = ws(t, e), n[g] && n[g][i] ? n[g][i].emitter : null;
          var n, i;
        },
        _getAllProxyEmitters: function _getAllProxyEmitters(t) {
          var _this31 = this;

          return [{
            capture: !1,
            passive: !1
          }, {
            capture: !1,
            passive: !0
          }, {
            capture: !0,
            passive: !1
          }, {
            capture: !0,
            passive: !0
          }].map(function (e) {
            return _this31._getProxyEmitter(t, e);
          }).filter(function (t) {
            return !!t;
          });
        }
      });
      var ks = fs;

      var bs = /*#__PURE__*/_createClass(function bs(t, e) {
        _classCallCheck(this, bs);

        k(this, ws(t, e)), this._domNode = t, this._options = e;
      });

      function ws(t, e) {
        var n = function (t) {
          return t["data-ck-expando"] || (t["data-ck-expando"] = r());
        }(t);

        var _iterator89 = _createForOfIteratorHelper(Object.keys(e).sort()),
            _step89;

        try {
          for (_iterator89.s(); !(_step89 = _iterator89.n()).done;) {
            var _t61 = _step89.value;
            e[_t61] && (n += "-" + _t61);
          }
        } catch (err) {
          _iterator89.e(err);
        } finally {
          _iterator89.f();
        }

        return n;
      }

      Jt(bs.prototype, f, {
        attach: function attach(t) {
          if (this._domListeners && this._domListeners[t]) return;

          var e = this._createDomListener(t);

          this._domNode.addEventListener(t, e, this._options), this._domListeners || (this._domListeners = {}), this._domListeners[t] = e;
        },
        detach: function detach(t) {
          var e;
          !this._domListeners[t] || (e = this._events[t]) && e.callbacks.length || this._domListeners[t].removeListener();
        },
        _addEventListener: function _addEventListener(t, e, n) {
          this.attach(t), f._addEventListener.call(this, t, e, n);
        },
        _removeEventListener: function _removeEventListener(t, e) {
          f._removeEventListener.call(this, t, e), this.detach(t);
        },
        _createDomListener: function _createDomListener(t) {
          var _this32 = this;

          var e = function e(_e75) {
            _this32.fire(t, _e75);
          };

          return e.removeListener = function () {
            _this32._domNode.removeEventListener(t, e, _this32._options), delete _this32._domListeners[t];
          }, e;
        }
      });

      var As = /*#__PURE__*/function () {
        function As(t) {
          _classCallCheck(this, As);

          this.view = t, this.document = t.document, this.isEnabled = !1;
        }

        _createClass(As, [{
          key: "enable",
          value: function enable() {
            this.isEnabled = !0;
          }
        }, {
          key: "disable",
          value: function disable() {
            this.isEnabled = !1;
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.disable(), this.stopListening();
          }
        }, {
          key: "checkShouldIgnoreEventFromTarget",
          value: function checkShouldIgnoreEventFromTarget(t) {
            return t && 3 === t.nodeType && (t = t.parentNode), !(!t || 1 !== t.nodeType) && t.matches("[data-cke-ignore-events], [data-cke-ignore-events] *");
          }
        }]);

        return As;
      }();

      he(As, ks);

      var Cs = function Cs(t) {
        return this.__data__.set(t, "__lodash_hash_undefined__"), this;
      };

      var _s = function _s(t) {
        return this.__data__.has(t);
      };

      function vs(t) {
        var e = -1,
            n = null == t ? 0 : t.length;

        for (this.__data__ = new on(); ++e < n;) {
          this.add(t[e]);
        }
      }

      vs.prototype.add = vs.prototype.push = Cs, vs.prototype.has = _s;
      var ys = vs;

      var xs = function xs(t, e) {
        for (var n = -1, i = null == t ? 0 : t.length; ++n < i;) {
          if (e(t[n], n, t)) return !0;
        }

        return !1;
      };

      var Es = function Es(t, e) {
        return t.has(e);
      };

      var Ds = function Ds(t, e, n, i, o, r) {
        var s = 1 & n,
            a = t.length,
            c = e.length;
        if (a != c && !(s && c > a)) return !1;
        var l = r.get(t),
            d = r.get(e);
        if (l && d) return l == e && d == t;
        var h = -1,
            u = !0,
            g = 2 & n ? new ys() : void 0;

        for (r.set(t, e), r.set(e, t); ++h < a;) {
          var m = t[h],
              p = e[h];
          if (i) var f = s ? i(p, m, h, e, t, r) : i(m, p, h, t, e, r);

          if (void 0 !== f) {
            if (f) continue;
            u = !1;
            break;
          }

          if (g) {
            if (!xs(e, function (t, e) {
              if (!Es(g, e) && (m === t || o(m, t, n, i, r))) return g.push(e);
            })) {
              u = !1;
              break;
            }
          } else if (m !== p && !o(m, p, n, i, r)) {
            u = !1;
            break;
          }
        }

        return r.delete(t), r.delete(e), u;
      };

      var Ss = function Ss(t) {
        var e = -1,
            n = Array(t.size);
        return t.forEach(function (t, i) {
          n[++e] = [i, t];
        }), n;
      };

      var Is = function Is(t) {
        var e = -1,
            n = Array(t.size);
        return t.forEach(function (t) {
          n[++e] = t;
        }), n;
      },
          Ms = S ? S.prototype : void 0,
          Ts = Ms ? Ms.valueOf : void 0;

      var Ns = function Ns(t, e, n, i, o, r, s) {
        switch (n) {
          case "[object DataView]":
            if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
            t = t.buffer, e = e.buffer;

          case "[object ArrayBuffer]":
            return !(t.byteLength != e.byteLength || !r(new Zn(t), new Zn(e)));

          case "[object Boolean]":
          case "[object Date]":
          case "[object Number]":
            return et(+t, +e);

          case "[object Error]":
            return t.name == e.name && t.message == e.message;

          case "[object RegExp]":
          case "[object String]":
            return t == e + "";

          case "[object Map]":
            var a = Ss;

          case "[object Set]":
            var c = 1 & i;
            if (a || (a = Is), t.size != e.size && !c) return !1;
            var l = s.get(t);
            if (l) return l == e;
            i |= 2, s.set(t, e);
            var d = Ds(a(t), a(e), i, o, r, s);
            return s.delete(t), d;

          case "[object Symbol]":
            if (Ts) return Ts.call(t) == Ts.call(e);
        }

        return !1;
      },
          Bs = Object.prototype.hasOwnProperty;

      var zs = function zs(t, e, n, i, o, r) {
        var s = 1 & n,
            a = Tn(t),
            c = a.length;
        if (c != Tn(e).length && !s) return !1;

        for (var l = c; l--;) {
          var d = a[l];
          if (!(s ? d in e : Bs.call(e, d))) return !1;
        }

        var h = r.get(t),
            u = r.get(e);
        if (h && u) return h == e && u == t;
        var g = !0;
        r.set(t, e), r.set(e, t);

        for (var m = s; ++l < c;) {
          var p = t[d = a[l]],
              f = e[d];
          if (i) var k = s ? i(f, p, d, e, t, r) : i(p, f, d, t, e, r);

          if (!(void 0 === k ? p === f || o(p, f, n, i, r) : k)) {
            g = !1;
            break;
          }

          m || (m = "constructor" == d);
        }

        if (g && !m) {
          var b = t.constructor,
              w = e.constructor;
          b == w || !("constructor" in t) || !("constructor" in e) || "function" == typeof b && b instanceof b && "function" == typeof w && w instanceof w || (g = !1);
        }

        return r.delete(t), r.delete(e), g;
      },
          Ps = "[object Arguments]",
          Ls = "[object Array]",
          Rs = "[object Object]",
          Os = Object.prototype.hasOwnProperty;

      var js = function js(t, e, n, i, o, r) {
        var s = It(t),
            a = It(e),
            c = s ? Ls : Yn(t),
            l = a ? Ls : Yn(e),
            d = (c = c == Ps ? Rs : c) == Rs,
            h = (l = l == Ps ? Rs : l) == Rs,
            u = c == l;

        if (u && zt(t)) {
          if (!zt(e)) return !1;
          s = !0, d = !1;
        }

        if (u && !d) return r || (r = new an()), s || Ht(t) ? Ds(t, e, n, i, o, r) : Ns(t, e, c, n, i, o, r);

        if (!(1 & n)) {
          var g = d && Os.call(t, "__wrapped__"),
              m = h && Os.call(e, "__wrapped__");

          if (g || m) {
            var p = g ? t.value() : t,
                f = m ? e.value() : e;
            return r || (r = new an()), o(p, f, n, i, r);
          }
        }

        return !!u && (r || (r = new an()), zs(t, e, n, i, o, r));
      };

      var Fs = function t(e, n, i, o, r) {
        return e === n || (null == e || null == n || !_t(e) && !_t(n) ? e != e && n != n : js(e, n, i, o, t, r));
      };

      var Vs = function Vs(t, e, n) {
        var i = (n = "function" == typeof n ? n : void 0) ? n(t, e) : void 0;
        return void 0 === i ? Fs(t, e, void 0, n) : !!i;
      };

      var Us = /*#__PURE__*/function (_As) {
        _inherits(Us, _As);

        var _super13 = _createSuper(Us);

        function Us(t) {
          var _this33;

          _classCallCheck(this, Us);

          _this33 = _super13.call(this, t), _this33._config = {
            childList: !0,
            characterData: !0,
            characterDataOldValue: !0,
            subtree: !0
          }, _this33.domConverter = t.domConverter, _this33.renderer = t._renderer, _this33._domElements = [], _this33._mutationObserver = new window.MutationObserver(_this33._onMutations.bind(_assertThisInitialized(_this33)));
          return _this33;
        }

        _createClass(Us, [{
          key: "flush",
          value: function flush() {
            this._onMutations(this._mutationObserver.takeRecords());
          }
        }, {
          key: "observe",
          value: function observe(t) {
            this._domElements.push(t), this.isEnabled && this._mutationObserver.observe(t, this._config);
          }
        }, {
          key: "enable",
          value: function enable() {
            _get(_getPrototypeOf(Us.prototype), "enable", this).call(this);

            var _iterator90 = _createForOfIteratorHelper(this._domElements),
                _step90;

            try {
              for (_iterator90.s(); !(_step90 = _iterator90.n()).done;) {
                var _t62 = _step90.value;

                this._mutationObserver.observe(_t62, this._config);
              }
            } catch (err) {
              _iterator90.e(err);
            } finally {
              _iterator90.f();
            }
          }
        }, {
          key: "disable",
          value: function disable() {
            _get(_getPrototypeOf(Us.prototype), "disable", this).call(this), this._mutationObserver.disconnect();
          }
        }, {
          key: "destroy",
          value: function destroy() {
            _get(_getPrototypeOf(Us.prototype), "destroy", this).call(this), this._mutationObserver.disconnect();
          }
        }, {
          key: "_onMutations",
          value: function _onMutations(t) {
            if (0 === t.length) return;
            var e = this.domConverter,
                n = new Map(),
                i = new Set();

            var _iterator91 = _createForOfIteratorHelper(t),
                _step91;

            try {
              for (_iterator91.s(); !(_step91 = _iterator91.n()).done;) {
                var _n65 = _step91.value;

                if ("childList" === _n65.type) {
                  var _t64 = e.mapDomToView(_n65.target);

                  if (_t64 && (_t64.is("uiElement") || _t64.is("rawElement"))) continue;
                  _t64 && !this._isBogusBrMutation(_n65) && i.add(_t64);
                }
              }
            } catch (err) {
              _iterator91.e(err);
            } finally {
              _iterator91.f();
            }

            var _iterator92 = _createForOfIteratorHelper(t),
                _step92;

            try {
              for (_iterator92.s(); !(_step92 = _iterator92.n()).done;) {
                var _o28 = _step92.value;

                var _t65 = e.mapDomToView(_o28.target);

                if ((!_t65 || !_t65.is("uiElement") && !_t65.is("rawElement")) && "characterData" === _o28.type) {
                  var _t66 = e.findCorrespondingViewText(_o28.target);

                  _t66 && !i.has(_t66.parent) ? n.set(_t66, {
                    type: "text",
                    oldText: _t66.data,
                    newText: Fr(_o28.target),
                    node: _t66
                  }) : !_t66 && Or(_o28.target) && i.add(e.mapDomToView(_o28.target.parentNode));
                }
              }
            } catch (err) {
              _iterator92.e(err);
            } finally {
              _iterator92.f();
            }

            var o = [];

            var _iterator93 = _createForOfIteratorHelper(n.values()),
                _step93;

            try {
              for (_iterator93.s(); !(_step93 = _iterator93.n()).done;) {
                var _t67 = _step93.value;
                this.renderer.markToSync("text", _t67.node), o.push(_t67);
              }
            } catch (err) {
              _iterator93.e(err);
            } finally {
              _iterator93.f();
            }

            var _iterator94 = _createForOfIteratorHelper(i),
                _step94;

            try {
              for (_iterator94.s(); !(_step94 = _iterator94.n()).done;) {
                var _t68 = _step94.value;

                var _n66 = e.mapViewToDom(_t68),
                    _i50 = Array.from(_t68.getChildren()),
                    _r17 = Array.from(e.domChildrenToView(_n66, {
                  withChildren: !1
                }));

                Vs(_i50, _r17, a) || (this.renderer.markToSync("children", _t68), o.push({
                  type: "children",
                  oldChildren: _i50,
                  newChildren: _r17,
                  node: _t68
                }));
              }
            } catch (err) {
              _iterator94.e(err);
            } finally {
              _iterator94.f();
            }

            var r = t[0].target.ownerDocument.getSelection();
            var s = null;

            if (r && r.anchorNode) {
              var _t63 = e.domPositionToView(r.anchorNode, r.anchorOffset),
                  _n64 = e.domPositionToView(r.focusNode, r.focusOffset);

              _t63 && _n64 && (s = new Uo(_t63), s.setFocus(_n64));
            }

            function a(t, e) {
              if (!Array.isArray(t)) return t === e || !(!t.is("$text") || !e.is("$text")) && t.data === e.data;
            }

            o.length && (this.document.fire("mutations", o, s), this.view.forceRender());
          }
        }, {
          key: "_isBogusBrMutation",
          value: function _isBogusBrMutation(t) {
            var e = null;
            return null === t.nextSibling && 0 === t.removedNodes.length && 1 == t.addedNodes.length && (e = this.domConverter.domToView(t.addedNodes[0], {
              withChildren: !1
            })), e && e.is("element", "br");
          }
        }]);

        return Us;
      }(As);

      var Hs = /*#__PURE__*/function () {
        function Hs(t, e, n) {
          _classCallCheck(this, Hs);

          this.view = t, this.document = t.document, this.domEvent = e, this.domTarget = e.target, Jt(this, n);
        }

        _createClass(Hs, [{
          key: "target",
          get: function get() {
            return this.view.domConverter.mapDomToView(this.domTarget);
          }
        }, {
          key: "preventDefault",
          value: function preventDefault() {
            this.domEvent.preventDefault();
          }
        }, {
          key: "stopPropagation",
          value: function stopPropagation() {
            this.domEvent.stopPropagation();
          }
        }]);

        return Hs;
      }();

      var qs = /*#__PURE__*/function (_As2) {
        _inherits(qs, _As2);

        var _super14 = _createSuper(qs);

        function qs(t) {
          var _this34;

          _classCallCheck(this, qs);

          _this34 = _super14.call(this, t), _this34.useCapture = !1;
          return _this34;
        }

        _createClass(qs, [{
          key: "observe",
          value: function observe(t) {
            var _this35 = this;

            ("string" == typeof this.domEventType ? [this.domEventType] : this.domEventType).forEach(function (e) {
              _this35.listenTo(t, e, function (t, e) {
                _this35.isEnabled && !_this35.checkShouldIgnoreEventFromTarget(e.target) && _this35.onDomEvent(e);
              }, {
                useCapture: _this35.useCapture
              });
            });
          }
        }, {
          key: "fire",
          value: function fire(t, e, n) {
            this.isEnabled && this.document.fire(t, new Hs(this.view, e, n));
          }
        }]);

        return qs;
      }(As);

      var Ws = /*#__PURE__*/function (_qs) {
        _inherits(Ws, _qs);

        var _super15 = _createSuper(Ws);

        function Ws(t) {
          var _this36;

          _classCallCheck(this, Ws);

          _this36 = _super15.call(this, t), _this36.domEventType = ["keydown", "keyup"];
          return _this36;
        }

        _createClass(Ws, [{
          key: "onDomEvent",
          value: function onDomEvent(t) {
            this.fire(t.type, t, {
              keyCode: t.keyCode,
              altKey: t.altKey,
              ctrlKey: t.ctrlKey,
              shiftKey: t.shiftKey,
              metaKey: t.metaKey,

              get keystroke() {
                return ur(this);
              }

            });
          }
        }]);

        return Ws;
      }(qs);

      var Gs = function Gs() {
        return D.Date.now();
      },
          $s = /\s/;

      var Ys = function Ys(t) {
        for (var e = t.length; e-- && $s.test(t.charAt(e));) {
          ;
        }

        return e;
      },
          Ks = /^\s+/;

      var Qs = function Qs(t) {
        return t ? t.slice(0, Ys(t) + 1).replace(Ks, "") : t;
      },
          Zs = /^[-+]0x[0-9a-f]+$/i,
          Js = /^0b[01]+$/i,
          Xs = /^0o[0-7]+$/i,
          ta = parseInt;

      var ea = function ea(t) {
        if ("number" == typeof t) return t;
        if (Wi(t)) return NaN;

        if (y(t)) {
          var e = "function" == typeof t.valueOf ? t.valueOf() : t;
          t = y(e) ? e + "" : e;
        }

        if ("string" != typeof t) return 0 === t ? t : +t;
        t = Qs(t);
        var n = Js.test(t);
        return n || Xs.test(t) ? ta(t.slice(2), n ? 2 : 8) : Zs.test(t) ? NaN : +t;
      },
          na = Math.max,
          ia = Math.min;

      var oa = function oa(t, e, n) {
        var i,
            o,
            r,
            s,
            a,
            c,
            l = 0,
            d = !1,
            h = !1,
            u = !0;
        if ("function" != typeof t) throw new TypeError("Expected a function");

        function g(e) {
          var n = i,
              r = o;
          return i = o = void 0, l = e, s = t.apply(r, n);
        }

        function m(t) {
          return l = t, a = setTimeout(f, e), d ? g(t) : s;
        }

        function p(t) {
          var n = t - c;
          return void 0 === c || n >= e || n < 0 || h && t - l >= r;
        }

        function f() {
          var t = Gs();
          if (p(t)) return k(t);
          a = setTimeout(f, function (t) {
            var n = e - (t - c);
            return h ? ia(n, r - (t - l)) : n;
          }(t));
        }

        function k(t) {
          return a = void 0, u && i ? g(t) : (i = o = void 0, s);
        }

        function b() {
          var t = Gs(),
              n = p(t);

          if (i = arguments, o = this, c = t, n) {
            if (void 0 === a) return m(c);
            if (h) return clearTimeout(a), a = setTimeout(f, e), g(c);
          }

          return void 0 === a && (a = setTimeout(f, e)), s;
        }

        return e = ea(e) || 0, y(n) && (d = !!n.leading, r = (h = "maxWait" in n) ? na(ea(n.maxWait) || 0, e) : r, u = "trailing" in n ? !!n.trailing : u), b.cancel = function () {
          void 0 !== a && clearTimeout(a), l = 0, i = c = o = a = void 0;
        }, b.flush = function () {
          return void 0 === a ? s : k(Gs());
        }, b;
      };

      var ra = /*#__PURE__*/function (_As3) {
        _inherits(ra, _As3);

        var _super16 = _createSuper(ra);

        function ra(t) {
          var _this37;

          _classCallCheck(this, ra);

          _this37 = _super16.call(this, t), _this37._fireSelectionChangeDoneDebounced = oa(function (t) {
            return _this37.document.fire("selectionChangeDone", t);
          }, 200);
          return _this37;
        }

        _createClass(ra, [{
          key: "observe",
          value: function observe() {
            var _this38 = this;

            var t = this.document;
            t.on("arrowKey", function (e, n) {
              t.selection.isFake && _this38.isEnabled && n.preventDefault();
            }, {
              context: "$capture"
            }), t.on("arrowKey", function (e, n) {
              t.selection.isFake && _this38.isEnabled && _this38._handleSelectionMove(n.keyCode);
            }, {
              priority: "lowest"
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            _get(_getPrototypeOf(ra.prototype), "destroy", this).call(this), this._fireSelectionChangeDoneDebounced.cancel();
          }
        }, {
          key: "_handleSelectionMove",
          value: function _handleSelectionMove(t) {
            var e = this.document.selection,
                n = new Uo(e.getRanges(), {
              backward: e.isBackward,
              fake: !1
            });
            t != dr.arrowleft && t != dr.arrowup || n.setTo(n.getFirstPosition()), t != dr.arrowright && t != dr.arrowdown || n.setTo(n.getLastPosition());
            var i = {
              oldSelection: e,
              newSelection: n,
              domSelection: null
            };
            this.document.fire("selectionChange", i), this._fireSelectionChangeDoneDebounced(i);
          }
        }]);

        return ra;
      }(As);

      var sa = /*#__PURE__*/function (_As4) {
        _inherits(sa, _As4);

        var _super17 = _createSuper(sa);

        function sa(t) {
          var _this39;

          _classCallCheck(this, sa);

          _this39 = _super17.call(this, t), _this39.mutationObserver = t.getObserver(Us), _this39.selection = _this39.document.selection, _this39.domConverter = t.domConverter, _this39._documents = new WeakSet(), _this39._fireSelectionChangeDoneDebounced = oa(function (t) {
            return _this39.document.fire("selectionChangeDone", t);
          }, 200), _this39._clearInfiniteLoopInterval = setInterval(function () {
            return _this39._clearInfiniteLoop();
          }, 1e3), _this39._documentIsSelectingInactivityTimeoutDebounced = oa(function () {
            return _this39.document.isSelecting = !1;
          }, 5e3), _this39._loopbackCounter = 0;
          return _this39;
        }

        _createClass(sa, [{
          key: "observe",
          value: function observe(t) {
            var _this40 = this;

            var e = t.ownerDocument,
                n = function n() {
              _this40.document.isSelecting = !1, _this40._documentIsSelectingInactivityTimeoutDebounced.cancel();
            };

            this.listenTo(t, "selectstart", function () {
              _this40.document.isSelecting = !0, _this40._documentIsSelectingInactivityTimeoutDebounced();
            }, {
              priority: "highest"
            }), this.listenTo(t, "keydown", n, {
              priority: "highest"
            }), this.listenTo(t, "keyup", n, {
              priority: "highest"
            }), this._documents.has(e) || (this.listenTo(e, "mouseup", n, {
              priority: "highest"
            }), this.listenTo(e, "selectionchange", function (t, n) {
              _this40._handleSelectionChange(n, e), _this40._documentIsSelectingInactivityTimeoutDebounced();
            }), this._documents.add(e));
          }
        }, {
          key: "destroy",
          value: function destroy() {
            _get(_getPrototypeOf(sa.prototype), "destroy", this).call(this), clearInterval(this._clearInfiniteLoopInterval), this._fireSelectionChangeDoneDebounced.cancel(), this._documentIsSelectingInactivityTimeoutDebounced.cancel();
          }
        }, {
          key: "_handleSelectionChange",
          value: function _handleSelectionChange(t, e) {
            if (!this.isEnabled) return;
            var n = e.defaultView.getSelection();
            if (this.checkShouldIgnoreEventFromTarget(n.anchorNode)) return;
            this.mutationObserver.flush();
            var i = this.domConverter.domSelectionToView(n);

            if (0 != i.rangeCount) {
              if (this.view.hasDomSelection = !0, !(this.selection.isEqual(i) && this.domConverter.isDomSelectionCorrect(n) || ++this._loopbackCounter > 60)) if (this.selection.isSimilar(i)) this.view.forceRender();else {
                var _t69 = {
                  oldSelection: this.selection,
                  newSelection: i,
                  domSelection: n
                };
                this.document.fire("selectionChange", _t69), this._fireSelectionChangeDoneDebounced(_t69);
              }
            } else this.view.hasDomSelection = !1;
          }
        }, {
          key: "_clearInfiniteLoop",
          value: function _clearInfiniteLoop() {
            this._loopbackCounter = 0;
          }
        }]);

        return sa;
      }(As);

      var aa = /*#__PURE__*/function (_qs2) {
        _inherits(aa, _qs2);

        var _super18 = _createSuper(aa);

        function aa(t) {
          var _this41;

          _classCallCheck(this, aa);

          _this41 = _super18.call(this, t), _this41.domEventType = ["focus", "blur"], _this41.useCapture = !0;
          var e = _this41.document;
          e.on("focus", function () {
            e.isFocused = !0, _this41._renderTimeoutId = setTimeout(function () {
              return t.change(function () {});
            }, 50);
          }), e.on("blur", function (n, i) {
            var o = e.selection.editableElement;
            null !== o && o !== i.target || (e.isFocused = !1, t.change(function () {}));
          });
          return _this41;
        }

        _createClass(aa, [{
          key: "onDomEvent",
          value: function onDomEvent(t) {
            this.fire(t.type, t);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this._renderTimeoutId && clearTimeout(this._renderTimeoutId), _get(_getPrototypeOf(aa.prototype), "destroy", this).call(this);
          }
        }]);

        return aa;
      }(qs);

      var ca = /*#__PURE__*/function (_qs3) {
        _inherits(ca, _qs3);

        var _super19 = _createSuper(ca);

        function ca(t) {
          var _this42;

          _classCallCheck(this, ca);

          _this42 = _super19.call(this, t), _this42.domEventType = ["compositionstart", "compositionupdate", "compositionend"];
          var e = _this42.document;
          e.on("compositionstart", function () {
            e.isComposing = !0;
          }), e.on("compositionend", function () {
            e.isComposing = !1;
          });
          return _this42;
        }

        _createClass(ca, [{
          key: "onDomEvent",
          value: function onDomEvent(t) {
            this.fire(t.type, t);
          }
        }]);

        return ca;
      }(qs);

      var la = /*#__PURE__*/function (_qs4) {
        _inherits(la, _qs4);

        var _super20 = _createSuper(la);

        function la(t) {
          var _this43;

          _classCallCheck(this, la);

          _this43 = _super20.call(this, t), _this43.domEventType = ["beforeinput"];
          return _this43;
        }

        _createClass(la, [{
          key: "onDomEvent",
          value: function onDomEvent(t) {
            this.fire(t.type, t);
          }
        }]);

        return la;
      }(qs);

      var da = /*#__PURE__*/function () {
        function da() {
          _classCallCheck(this, da);

          this._replacedElements = [];
        }

        _createClass(da, [{
          key: "replace",
          value: function replace(t, e) {
            this._replacedElements.push({
              element: t,
              newElement: e
            }), t.style.display = "none", e && t.parentNode.insertBefore(e, t.nextSibling);
          }
        }, {
          key: "restore",
          value: function restore() {
            this._replacedElements.forEach(function (_ref13) {
              var t = _ref13.element,
                  e = _ref13.newElement;
              t.style.display = "", e && e.remove();
            }), this._replacedElements = [];
          }
        }]);

        return da;
      }();

      function ha(t) {
        return "[object Range]" == Object.prototype.toString.apply(t);
      }

      function ua(t) {
        var e = t.ownerDocument.defaultView.getComputedStyle(t);
        return {
          top: parseInt(e.borderTopWidth, 10),
          right: parseInt(e.borderRightWidth, 10),
          bottom: parseInt(e.borderBottomWidth, 10),
          left: parseInt(e.borderLeftWidth, 10)
        };
      }

      var ga = ["top", "right", "bottom", "left", "width", "height"];

      var ma = /*#__PURE__*/function () {
        function ma(t) {
          _classCallCheck(this, ma);

          var e = ha(t);
          if (Object.defineProperty(this, "_source", {
            value: t._source || t,
            writable: !0,
            enumerable: !1
          }), _i(t) || e) {
            if (e) {
              var _e76 = ma.getDomRangeRects(t);

              pa(this, ma.getBoundingRect(_e76));
            } else pa(this, t.getBoundingClientRect());
          } else if (ps(t)) {
            var _e77 = t.innerWidth,
                _n67 = t.innerHeight;
            pa(this, {
              top: 0,
              right: _e77,
              bottom: _n67,
              left: 0,
              width: _e77,
              height: _n67
            });
          } else pa(this, t);
        }

        _createClass(ma, [{
          key: "clone",
          value: function clone() {
            return new ma(this);
          }
        }, {
          key: "moveTo",
          value: function moveTo(t, e) {
            return this.top = e, this.right = t + this.width, this.bottom = e + this.height, this.left = t, this;
          }
        }, {
          key: "moveBy",
          value: function moveBy(t, e) {
            return this.top += e, this.right += t, this.left += t, this.bottom += e, this;
          }
        }, {
          key: "getIntersection",
          value: function getIntersection(t) {
            var e = {
              top: Math.max(this.top, t.top),
              right: Math.min(this.right, t.right),
              bottom: Math.min(this.bottom, t.bottom),
              left: Math.max(this.left, t.left)
            };
            return e.width = e.right - e.left, e.height = e.bottom - e.top, e.width < 0 || e.height < 0 ? null : new ma(e);
          }
        }, {
          key: "getIntersectionArea",
          value: function getIntersectionArea(t) {
            var e = this.getIntersection(t);
            return e ? e.getArea() : 0;
          }
        }, {
          key: "getArea",
          value: function getArea() {
            return this.width * this.height;
          }
        }, {
          key: "getVisible",
          value: function getVisible() {
            var t = this._source;
            var e = this.clone();

            if (!fa(t)) {
              var _n68 = t.parentNode || t.commonAncestorContainer;

              for (; _n68 && !fa(_n68);) {
                var _t70 = new ma(_n68),
                    _i51 = e.getIntersection(_t70);

                if (!_i51) return null;
                _i51.getArea() < e.getArea() && (e = _i51), _n68 = _n68.parentNode;
              }
            }

            return e;
          }
        }, {
          key: "isEqual",
          value: function isEqual(t) {
            var _iterator95 = _createForOfIteratorHelper(ga),
                _step95;

            try {
              for (_iterator95.s(); !(_step95 = _iterator95.n()).done;) {
                var _e78 = _step95.value;
                if (this[_e78] !== t[_e78]) return !1;
              }
            } catch (err) {
              _iterator95.e(err);
            } finally {
              _iterator95.f();
            }

            return !0;
          }
        }, {
          key: "contains",
          value: function contains(t) {
            var e = this.getIntersection(t);
            return !(!e || !e.isEqual(t));
          }
        }, {
          key: "excludeScrollbarsAndBorders",
          value: function excludeScrollbarsAndBorders() {
            var t = this._source;
            var e, n, i;
            if (ps(t)) e = t.innerWidth - t.document.documentElement.clientWidth, n = t.innerHeight - t.document.documentElement.clientHeight, i = t.getComputedStyle(t.document.documentElement).direction;else {
              var _o29 = ua(this._source);

              e = t.offsetWidth - t.clientWidth - _o29.left - _o29.right, n = t.offsetHeight - t.clientHeight - _o29.top - _o29.bottom, i = t.ownerDocument.defaultView.getComputedStyle(t).direction, this.left += _o29.left, this.top += _o29.top, this.right -= _o29.right, this.bottom -= _o29.bottom, this.width = this.right - this.left, this.height = this.bottom - this.top;
            }
            return this.width -= e, "ltr" === i ? this.right -= e : this.left += e, this.height -= n, this.bottom -= n, this;
          }
        }], [{
          key: "getDomRangeRects",
          value: function getDomRangeRects(t) {
            var e = [],
                n = Array.from(t.getClientRects());

            if (n.length) {
              var _iterator96 = _createForOfIteratorHelper(n),
                  _step96;

              try {
                for (_iterator96.s(); !(_step96 = _iterator96.n()).done;) {
                  var _t71 = _step96.value;
                  e.push(new ma(_t71));
                }
              } catch (err) {
                _iterator96.e(err);
              } finally {
                _iterator96.f();
              }
            } else {
              var _n69 = t.startContainer;
              Br(_n69) && (_n69 = _n69.parentNode);

              var _i52 = new ma(_n69.getBoundingClientRect());

              _i52.right = _i52.left, _i52.width = 0, e.push(_i52);
            }

            return e;
          }
        }, {
          key: "getBoundingRect",
          value: function getBoundingRect(t) {
            var e = {
              left: Number.POSITIVE_INFINITY,
              top: Number.POSITIVE_INFINITY,
              right: Number.NEGATIVE_INFINITY,
              bottom: Number.NEGATIVE_INFINITY
            };
            var n = 0;

            var _iterator97 = _createForOfIteratorHelper(t),
                _step97;

            try {
              for (_iterator97.s(); !(_step97 = _iterator97.n()).done;) {
                var _i53 = _step97.value;
                n++, e.left = Math.min(e.left, _i53.left), e.top = Math.min(e.top, _i53.top), e.right = Math.max(e.right, _i53.right), e.bottom = Math.max(e.bottom, _i53.bottom);
              }
            } catch (err) {
              _iterator97.e(err);
            } finally {
              _iterator97.f();
            }

            return 0 == n ? null : (e.width = e.right - e.left, e.height = e.bottom - e.top, new ma(e));
          }
        }]);

        return ma;
      }();

      function pa(t, e) {
        var _iterator98 = _createForOfIteratorHelper(ga),
            _step98;

        try {
          for (_iterator98.s(); !(_step98 = _iterator98.n()).done;) {
            var _n70 = _step98.value;
            t[_n70] = e[_n70];
          }
        } catch (err) {
          _iterator98.e(err);
        } finally {
          _iterator98.f();
        }
      }

      function fa(t) {
        return !!_i(t) && t === t.ownerDocument.body;
      }

      var ka = /*#__PURE__*/function () {
        function ka(t, e) {
          _classCallCheck(this, ka);

          ka._observerInstance || ka._createObserver(), this._element = t, this._callback = e, ka._addElementCallback(t, e), ka._observerInstance.observe(t);
        }

        _createClass(ka, [{
          key: "destroy",
          value: function destroy() {
            ka._deleteElementCallback(this._element, this._callback);
          }
        }], [{
          key: "_addElementCallback",
          value: function _addElementCallback(t, e) {
            ka._elementCallbacks || (ka._elementCallbacks = new Map());

            var n = ka._elementCallbacks.get(t);

            n || (n = new Set(), ka._elementCallbacks.set(t, n)), n.add(e);
          }
        }, {
          key: "_deleteElementCallback",
          value: function _deleteElementCallback(t, e) {
            var n = ka._getElementCallbacks(t);

            n && (n.delete(e), n.size || (ka._elementCallbacks.delete(t), ka._observerInstance.unobserve(t))), ka._elementCallbacks && !ka._elementCallbacks.size && (ka._observerInstance = null, ka._elementCallbacks = null);
          }
        }, {
          key: "_getElementCallbacks",
          value: function _getElementCallbacks(t) {
            return ka._elementCallbacks ? ka._elementCallbacks.get(t) : null;
          }
        }, {
          key: "_createObserver",
          value: function _createObserver() {
            var t;
            t = "function" == typeof os.window.ResizeObserver ? os.window.ResizeObserver : ba, ka._observerInstance = new t(function (t) {
              var _iterator99 = _createForOfIteratorHelper(t),
                  _step99;

              try {
                for (_iterator99.s(); !(_step99 = _iterator99.n()).done;) {
                  var _e79 = _step99.value;

                  var _t72 = ka._getElementCallbacks(_e79.target);

                  if (_t72) {
                    var _iterator100 = _createForOfIteratorHelper(_t72),
                        _step100;

                    try {
                      for (_iterator100.s(); !(_step100 = _iterator100.n()).done;) {
                        var _n71 = _step100.value;

                        _n71(_e79);
                      }
                    } catch (err) {
                      _iterator100.e(err);
                    } finally {
                      _iterator100.f();
                    }
                  }
                }
              } catch (err) {
                _iterator99.e(err);
              } finally {
                _iterator99.f();
              }
            });
          }
        }]);

        return ka;
      }();

      ka._observerInstance = null, ka._elementCallbacks = null;

      var ba = /*#__PURE__*/function () {
        function ba(t) {
          _classCallCheck(this, ba);

          this._callback = t, this._elements = new Set(), this._previousRects = new Map(), this._periodicCheckTimeout = null;
        }

        _createClass(ba, [{
          key: "observe",
          value: function observe(t) {
            this._elements.add(t), this._checkElementRectsAndExecuteCallback(), 1 === this._elements.size && this._startPeriodicCheck();
          }
        }, {
          key: "unobserve",
          value: function unobserve(t) {
            this._elements.delete(t), this._previousRects.delete(t), this._elements.size || this._stopPeriodicCheck();
          }
        }, {
          key: "_startPeriodicCheck",
          value: function _startPeriodicCheck() {
            var _this44 = this;

            var t = function t() {
              _this44._checkElementRectsAndExecuteCallback(), _this44._periodicCheckTimeout = setTimeout(t, 100);
            };

            this.listenTo(os.window, "resize", function () {
              _this44._checkElementRectsAndExecuteCallback();
            }), this._periodicCheckTimeout = setTimeout(t, 100);
          }
        }, {
          key: "_stopPeriodicCheck",
          value: function _stopPeriodicCheck() {
            clearTimeout(this._periodicCheckTimeout), this.stopListening(), this._previousRects.clear();
          }
        }, {
          key: "_checkElementRectsAndExecuteCallback",
          value: function _checkElementRectsAndExecuteCallback() {
            var t = [];

            var _iterator101 = _createForOfIteratorHelper(this._elements),
                _step101;

            try {
              for (_iterator101.s(); !(_step101 = _iterator101.n()).done;) {
                var _e80 = _step101.value;
                this._hasRectChanged(_e80) && t.push({
                  target: _e80,
                  contentRect: this._previousRects.get(_e80)
                });
              }
            } catch (err) {
              _iterator101.e(err);
            } finally {
              _iterator101.f();
            }

            t.length && this._callback(t);
          }
        }, {
          key: "_hasRectChanged",
          value: function _hasRectChanged(t) {
            if (!t.ownerDocument.body.contains(t)) return !1;

            var e = new ma(t),
                n = this._previousRects.get(t),
                i = !n || !n.isEqual(e);

            return this._previousRects.set(t, e), i;
          }
        }]);

        return ba;
      }();

      function wa(t) {
        var e = t.next();
        return e.done ? null : e.value;
      }

      he(ba, ks);

      var Aa = /*#__PURE__*/function () {
        function Aa() {
          _classCallCheck(this, Aa);

          this.set("isFocused", !1), this.set("focusedElement", null), this._elements = new Set(), this._nextEventLoopTimeout = null;
        }

        _createClass(Aa, [{
          key: "add",
          value: function add(t) {
            var _this45 = this;

            if (this._elements.has(t)) throw new a("focustracker-add-element-already-exist", this);
            this.listenTo(t, "focus", function () {
              return _this45._focus(t);
            }, {
              useCapture: !0
            }), this.listenTo(t, "blur", function () {
              return _this45._blur();
            }, {
              useCapture: !0
            }), this._elements.add(t);
          }
        }, {
          key: "remove",
          value: function remove(t) {
            t === this.focusedElement && this._blur(t), this._elements.has(t) && (this.stopListening(t), this._elements.delete(t));
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.stopListening();
          }
        }, {
          key: "_focus",
          value: function _focus(t) {
            clearTimeout(this._nextEventLoopTimeout), this.focusedElement = t, this.isFocused = !0;
          }
        }, {
          key: "_blur",
          value: function _blur() {
            var _this46 = this;

            clearTimeout(this._nextEventLoopTimeout), this._nextEventLoopTimeout = setTimeout(function () {
              _this46.focusedElement = null, _this46.isFocused = !1;
            }, 0);
          }
        }]);

        return Aa;
      }();

      he(Aa, ks), he(Aa, re);

      var Ca = /*#__PURE__*/function () {
        function Ca() {
          _classCallCheck(this, Ca);

          this._listener = Object.create(ks);
        }

        _createClass(Ca, [{
          key: "listenTo",
          value: function listenTo(t) {
            var _this47 = this;

            this._listener.listenTo(t, "keydown", function (t, e) {
              _this47._listener.fire("_keydown:" + ur(e), e);
            });
          }
        }, {
          key: "set",
          value: function set(t, e) {
            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var i = gr(t),
                o = n.priority;

            this._listener.listenTo(this._listener, "_keydown:" + i, function (t, n) {
              e(n, function () {
                n.preventDefault(), n.stopPropagation(), t.stop();
              }), t.return = !0;
            }, {
              priority: o
            });
          }
        }, {
          key: "press",
          value: function press(t) {
            return !!this._listener.fire("_keydown:" + ur(t), t);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this._listener.stopListening();
          }
        }]);

        return Ca;
      }();

      var _a = /*#__PURE__*/function (_As5) {
        _inherits(_a, _As5);

        var _super21 = _createSuper(_a);

        function _a(t) {
          var _this48;

          _classCallCheck(this, _a);

          _this48 = _super21.call(this, t), _this48.document.on("keydown", function (t, e) {
            if (_this48.isEnabled && ((n = e.keyCode) == dr.arrowright || n == dr.arrowleft || n == dr.arrowup || n == dr.arrowdown)) {
              var _n72 = new qo(_this48.document, "arrowKey", _this48.document.selection.getFirstRange());

              _this48.document.fire(_n72, e), _n72.stop.called && t.stop();
            }

            var n;
          });
          return _this48;
        }

        _createClass(_a, [{
          key: "observe",
          value: function observe() {}
        }]);

        return _a;
      }(As);

      function va(_ref14) {
        var t = _ref14.target,
            _ref14$viewportOffset = _ref14.viewportOffset,
            e = _ref14$viewportOffset === void 0 ? 0 : _ref14$viewportOffset;
        var n = Ma(t);
        var i = n,
            o = null;

        for (; i;) {
          var _r18 = void 0;

          _r18 = Ta(i == n ? t : o), xa(_r18, function () {
            return Na(t, i);
          });

          var _s10 = Na(t, i);

          if (ya(i, _s10, e), i.parent != i) {
            if (o = i.frameElement, i = i.parent, !o) return;
          } else i = null;
        }
      }

      function ya(t, e, n) {
        var i = e.clone().moveBy(0, n),
            o = e.clone().moveBy(0, -n),
            r = new ma(t).excludeScrollbarsAndBorders();

        if (![o, i].every(function (t) {
          return r.contains(t);
        })) {
          var _s11 = t.scrollX,
              _a8 = t.scrollY;
          Da(o, r) ? _a8 -= r.top - e.top + n : Ea(i, r) && (_a8 += e.bottom - r.bottom + n), Sa(e, r) ? _s11 -= r.left - e.left + n : Ia(e, r) && (_s11 += e.right - r.right + n), t.scrollTo(_s11, _a8);
        }
      }

      function xa(t, e) {
        var n = Ma(t);
        var i, o;

        for (; t != n.document.body;) {
          o = e(), i = new ma(t).excludeScrollbarsAndBorders(), i.contains(o) || (Da(o, i) ? t.scrollTop -= i.top - o.top : Ea(o, i) && (t.scrollTop += o.bottom - i.bottom), Sa(o, i) ? t.scrollLeft -= i.left - o.left : Ia(o, i) && (t.scrollLeft += o.right - i.right)), t = t.parentNode;
        }
      }

      function Ea(t, e) {
        return t.bottom > e.bottom;
      }

      function Da(t, e) {
        return t.top < e.top;
      }

      function Sa(t, e) {
        return t.left < e.left;
      }

      function Ia(t, e) {
        return t.right > e.right;
      }

      function Ma(t) {
        return ha(t) ? t.startContainer.ownerDocument.defaultView : t.ownerDocument.defaultView;
      }

      function Ta(t) {
        if (ha(t)) {
          var _e81 = t.commonAncestorContainer;
          return Br(_e81) && (_e81 = _e81.parentNode), _e81;
        }

        return t.parentNode;
      }

      function Na(t, e) {
        var n = Ma(t),
            i = new ma(t);
        if (n === e) return i;
        {
          var _t73 = n;

          for (; _t73 != e;) {
            var _e82 = _t73.frameElement,
                _n73 = new ma(_e82).excludeScrollbarsAndBorders();

            i.moveBy(_n73.left, _n73.top), _t73 = _t73.parent;
          }
        }
        return i;
      }

      Object.assign({}, {
        scrollViewportToShowTarget: va,
        scrollAncestorsToShowTarget: function scrollAncestorsToShowTarget(t) {
          xa(Ta(t), function () {
            return new ma(t);
          });
        }
      });

      var Ba = /*#__PURE__*/function () {
        function Ba(t) {
          var _this49 = this;

          _classCallCheck(this, Ba);

          this.document = new Jo(t), this.domConverter = new us(this.document), this.domRoots = new Map(), this.set("isRenderingInProgress", !1), this.set("hasDomSelection", !1), this._renderer = new ts(this.domConverter, this.document.selection), this._renderer.bind("isFocused", "isSelecting").to(this.document), this._initialDomRootAttributes = new WeakMap(), this._observers = new Map(), this._ongoingChange = !1, this._postFixersInProgress = !1, this._renderingDisabled = !1, this._hasChangedSinceTheLastRendering = !1, this._writer = new _r(this.document), this.addObserver(Us), this.addObserver(sa), this.addObserver(aa), this.addObserver(Ws), this.addObserver(ra), this.addObserver(ca), this.addObserver(_a), sr.isAndroid && this.addObserver(la), this.document.on("arrowKey", Vr, {
            priority: "low"
          }), kr(this), this.on("render", function () {
            _this49._render(), _this49.document.fire("layoutChanged"), _this49._hasChangedSinceTheLastRendering = !1;
          }), this.listenTo(this.document.selection, "change", function () {
            _this49._hasChangedSinceTheLastRendering = !0;
          }), this.listenTo(this.document, "change:isFocused", function () {
            _this49._hasChangedSinceTheLastRendering = !0;
          });
        }

        _createClass(Ba, [{
          key: "attachDomRoot",
          value: function attachDomRoot(t) {
            var _this50 = this;

            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
            var n = this.document.getRoot(e);
            n._name = t.tagName.toLowerCase();
            var i = {};

            for (var _i54 = 0, _Array$from = Array.from(t.attributes); _i54 < _Array$from.length; _i54++) {
              var _Array$from$_i = _Array$from[_i54],
                  _e83 = _Array$from$_i.name,
                  _o30 = _Array$from$_i.value;
              i[_e83] = _o30, "class" === _e83 ? this._writer.addClass(_o30.split(" "), n) : this._writer.setAttribute(_e83, _o30, n);
            }

            this._initialDomRootAttributes.set(t, i);

            var o = function o() {
              _this50._writer.setAttribute("contenteditable", !n.isReadOnly, n), n.isReadOnly ? _this50._writer.addClass("ck-read-only", n) : _this50._writer.removeClass("ck-read-only", n);
            };

            o(), this.domRoots.set(e, t), this.domConverter.bindElements(t, n), this._renderer.markToSync("children", n), this._renderer.markToSync("attributes", n), this._renderer.domDocuments.add(t.ownerDocument), n.on("change:children", function (t, e) {
              return _this50._renderer.markToSync("children", e);
            }), n.on("change:attributes", function (t, e) {
              return _this50._renderer.markToSync("attributes", e);
            }), n.on("change:text", function (t, e) {
              return _this50._renderer.markToSync("text", e);
            }), n.on("change:isReadOnly", function () {
              return _this50.change(o);
            }), n.on("change", function () {
              _this50._hasChangedSinceTheLastRendering = !0;
            });

            var _iterator102 = _createForOfIteratorHelper(this._observers.values()),
                _step102;

            try {
              for (_iterator102.s(); !(_step102 = _iterator102.n()).done;) {
                var _n74 = _step102.value;

                _n74.observe(t, e);
              }
            } catch (err) {
              _iterator102.e(err);
            } finally {
              _iterator102.f();
            }
          }
        }, {
          key: "detachDomRoot",
          value: function detachDomRoot(t) {
            var e = this.domRoots.get(t);
            Array.from(e.attributes).forEach(function (_ref15) {
              var t = _ref15.name;
              return e.removeAttribute(t);
            });

            var n = this._initialDomRootAttributes.get(e);

            for (var _t74 in n) {
              e.setAttribute(_t74, n[_t74]);
            }

            this.domRoots.delete(t), this.domConverter.unbindDomElement(e);
          }
        }, {
          key: "getDomRoot",
          value: function getDomRoot() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
            return this.domRoots.get(t);
          }
        }, {
          key: "addObserver",
          value: function addObserver(t) {
            var e = this._observers.get(t);

            if (e) return e;
            e = new t(this), this._observers.set(t, e);

            var _iterator103 = _createForOfIteratorHelper(this.domRoots),
                _step103;

            try {
              for (_iterator103.s(); !(_step103 = _iterator103.n()).done;) {
                var _step103$value = _slicedToArray(_step103.value, 2),
                    _t75 = _step103$value[0],
                    _n75 = _step103$value[1];

                e.observe(_n75, _t75);
              }
            } catch (err) {
              _iterator103.e(err);
            } finally {
              _iterator103.f();
            }

            return e.enable(), e;
          }
        }, {
          key: "getObserver",
          value: function getObserver(t) {
            return this._observers.get(t);
          }
        }, {
          key: "disableObservers",
          value: function disableObservers() {
            var _iterator104 = _createForOfIteratorHelper(this._observers.values()),
                _step104;

            try {
              for (_iterator104.s(); !(_step104 = _iterator104.n()).done;) {
                var _t76 = _step104.value;

                _t76.disable();
              }
            } catch (err) {
              _iterator104.e(err);
            } finally {
              _iterator104.f();
            }
          }
        }, {
          key: "enableObservers",
          value: function enableObservers() {
            var _iterator105 = _createForOfIteratorHelper(this._observers.values()),
                _step105;

            try {
              for (_iterator105.s(); !(_step105 = _iterator105.n()).done;) {
                var _t77 = _step105.value;

                _t77.enable();
              }
            } catch (err) {
              _iterator105.e(err);
            } finally {
              _iterator105.f();
            }
          }
        }, {
          key: "scrollToTheSelection",
          value: function scrollToTheSelection() {
            var t = this.document.selection.getFirstRange();
            t && va({
              target: this.domConverter.viewRangeToDom(t),
              viewportOffset: 20
            });
          }
        }, {
          key: "focus",
          value: function focus() {
            if (!this.document.isFocused) {
              var _t78 = this.document.selection.editableElement;
              _t78 && (this.domConverter.focus(_t78), this.forceRender());
            }
          }
        }, {
          key: "change",
          value: function change(t) {
            if (this.isRenderingInProgress || this._postFixersInProgress) throw new a("cannot-change-view-tree", this);

            try {
              if (this._ongoingChange) return t(this._writer);
              this._ongoingChange = !0;

              var _e84 = t(this._writer);

              return this._ongoingChange = !1, !this._renderingDisabled && this._hasChangedSinceTheLastRendering && (this._postFixersInProgress = !0, this.document._callPostFixers(this._writer), this._postFixersInProgress = !1, this.fire("render")), _e84;
            } catch (t) {
              a.rethrowUnexpectedError(t, this);
            }
          }
        }, {
          key: "forceRender",
          value: function forceRender() {
            this._hasChangedSinceTheLastRendering = !0, this.change(function () {});
          }
        }, {
          key: "destroy",
          value: function destroy() {
            var _iterator106 = _createForOfIteratorHelper(this._observers.values()),
                _step106;

            try {
              for (_iterator106.s(); !(_step106 = _iterator106.n()).done;) {
                var _t79 = _step106.value;

                _t79.destroy();
              }
            } catch (err) {
              _iterator106.e(err);
            } finally {
              _iterator106.f();
            }

            this.document.destroy(), this.stopListening();
          }
        }, {
          key: "createPositionAt",
          value: function createPositionAt(t, e) {
            return Oo._createAt(t, e);
          }
        }, {
          key: "createPositionAfter",
          value: function createPositionAfter(t) {
            return Oo._createAfter(t);
          }
        }, {
          key: "createPositionBefore",
          value: function createPositionBefore(t) {
            return Oo._createBefore(t);
          }
        }, {
          key: "createRange",
          value: function createRange(t, e) {
            return new jo(t, e);
          }
        }, {
          key: "createRangeOn",
          value: function createRangeOn(t) {
            return jo._createOn(t);
          }
        }, {
          key: "createRangeIn",
          value: function createRangeIn(t) {
            return jo._createIn(t);
          }
        }, {
          key: "createSelection",
          value: function createSelection(t, e, n) {
            return new Uo(t, e, n);
          }
        }, {
          key: "_disableRendering",
          value: function _disableRendering(t) {
            this._renderingDisabled = t, 0 == t && this.change(function () {});
          }
        }, {
          key: "_render",
          value: function _render() {
            this.isRenderingInProgress = !0, this.disableObservers(), this._renderer.render(), this.enableObservers(), this.isRenderingInProgress = !1;
          }
        }]);

        return Ba;
      }();

      he(Ba, re);

      var za = /*#__PURE__*/function () {
        function za(t) {
          _classCallCheck(this, za);

          this.parent = null, this._attrs = Vi(t);
        }

        _createClass(za, [{
          key: "index",
          get: function get() {
            var t;
            if (!this.parent) return null;
            if (null === (t = this.parent.getChildIndex(this))) throw new a("model-node-not-found-in-parent", this);
            return t;
          }
        }, {
          key: "startOffset",
          get: function get() {
            var t;
            if (!this.parent) return null;
            if (null === (t = this.parent.getChildStartOffset(this))) throw new a("model-node-not-found-in-parent", this);
            return t;
          }
        }, {
          key: "offsetSize",
          get: function get() {
            return 1;
          }
        }, {
          key: "endOffset",
          get: function get() {
            return this.parent ? this.startOffset + this.offsetSize : null;
          }
        }, {
          key: "nextSibling",
          get: function get() {
            var t = this.index;
            return null !== t && this.parent.getChild(t + 1) || null;
          }
        }, {
          key: "previousSibling",
          get: function get() {
            var t = this.index;
            return null !== t && this.parent.getChild(t - 1) || null;
          }
        }, {
          key: "root",
          get: function get() {
            var t = this;

            for (; t.parent;) {
              t = t.parent;
            }

            return t;
          }
        }, {
          key: "isAttached",
          value: function isAttached() {
            return this.root.is("rootElement");
          }
        }, {
          key: "getPath",
          value: function getPath() {
            var t = [];
            var e = this;

            for (; e.parent;) {
              t.unshift(e.startOffset), e = e.parent;
            }

            return t;
          }
        }, {
          key: "getAncestors",
          value: function getAncestors() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
              includeSelf: !1,
              parentFirst: !1
            };
            var e = [];
            var n = t.includeSelf ? this : this.parent;

            for (; n;) {
              e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
            }

            return e;
          }
        }, {
          key: "getCommonAncestor",
          value: function getCommonAncestor(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var n = this.getAncestors(e),
                i = t.getAncestors(e);
            var o = 0;

            for (; n[o] == i[o] && n[o];) {
              o++;
            }

            return 0 === o ? null : n[o - 1];
          }
        }, {
          key: "isBefore",
          value: function isBefore(t) {
            if (this == t) return !1;
            if (this.root !== t.root) return !1;
            var e = this.getPath(),
                n = t.getPath(),
                i = Li(e, n);

            switch (i) {
              case "prefix":
                return !0;

              case "extension":
                return !1;

              default:
                return e[i] < n[i];
            }
          }
        }, {
          key: "isAfter",
          value: function isAfter(t) {
            return this != t && this.root === t.root && !this.isBefore(t);
          }
        }, {
          key: "hasAttribute",
          value: function hasAttribute(t) {
            return this._attrs.has(t);
          }
        }, {
          key: "getAttribute",
          value: function getAttribute(t) {
            return this._attrs.get(t);
          }
        }, {
          key: "getAttributes",
          value: function getAttributes() {
            return this._attrs.entries();
          }
        }, {
          key: "getAttributeKeys",
          value: function getAttributeKeys() {
            return this._attrs.keys();
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var t = {};
            return this._attrs.size && (t.attributes = Array.from(this._attrs).reduce(function (t, e) {
              return t[e[0]] = e[1], t;
            }, {})), t;
          }
        }, {
          key: "is",
          value: function is(t) {
            return "node" === t || "model:node" === t;
          }
        }, {
          key: "_clone",
          value: function _clone() {
            return new za(this._attrs);
          }
        }, {
          key: "_remove",
          value: function _remove() {
            this.parent._removeChildren(this.index);
          }
        }, {
          key: "_setAttribute",
          value: function _setAttribute(t, e) {
            this._attrs.set(t, e);
          }
        }, {
          key: "_setAttributesTo",
          value: function _setAttributesTo(t) {
            this._attrs = Vi(t);
          }
        }, {
          key: "_removeAttribute",
          value: function _removeAttribute(t) {
            return this._attrs.delete(t);
          }
        }, {
          key: "_clearAttributes",
          value: function _clearAttributes() {
            this._attrs.clear();
          }
        }]);

        return za;
      }();

      var Pa = /*#__PURE__*/function (_za) {
        _inherits(Pa, _za);

        var _super22 = _createSuper(Pa);

        function Pa(t, e) {
          var _this51;

          _classCallCheck(this, Pa);

          _this51 = _super22.call(this, e), _this51._data = t || "";
          return _this51;
        }

        _createClass(Pa, [{
          key: "offsetSize",
          get: function get() {
            return this.data.length;
          }
        }, {
          key: "data",
          get: function get() {
            return this._data;
          }
        }, {
          key: "is",
          value: function is(t) {
            return "$text" === t || "model:$text" === t || "text" === t || "model:text" === t || "node" === t || "model:node" === t;
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var t = _get(_getPrototypeOf(Pa.prototype), "toJSON", this).call(this);

            return t.data = this.data, t;
          }
        }, {
          key: "_clone",
          value: function _clone() {
            return new Pa(this.data, this.getAttributes());
          }
        }], [{
          key: "fromJSON",
          value: function fromJSON(t) {
            return new Pa(t.data, t.attributes);
          }
        }]);

        return Pa;
      }(za);

      var La = /*#__PURE__*/function () {
        function La(t, e, n) {
          _classCallCheck(this, La);

          if (this.textNode = t, e < 0 || e > t.offsetSize) throw new a("model-textproxy-wrong-offsetintext", this);
          if (n < 0 || e + n > t.offsetSize) throw new a("model-textproxy-wrong-length", this);
          this.data = t.data.substring(e, e + n), this.offsetInText = e;
        }

        _createClass(La, [{
          key: "startOffset",
          get: function get() {
            return null !== this.textNode.startOffset ? this.textNode.startOffset + this.offsetInText : null;
          }
        }, {
          key: "offsetSize",
          get: function get() {
            return this.data.length;
          }
        }, {
          key: "endOffset",
          get: function get() {
            return null !== this.startOffset ? this.startOffset + this.offsetSize : null;
          }
        }, {
          key: "isPartial",
          get: function get() {
            return this.offsetSize !== this.textNode.offsetSize;
          }
        }, {
          key: "parent",
          get: function get() {
            return this.textNode.parent;
          }
        }, {
          key: "root",
          get: function get() {
            return this.textNode.root;
          }
        }, {
          key: "is",
          value: function is(t) {
            return "$textProxy" === t || "model:$textProxy" === t || "textProxy" === t || "model:textProxy" === t;
          }
        }, {
          key: "getPath",
          value: function getPath() {
            var t = this.textNode.getPath();
            return t.length > 0 && (t[t.length - 1] += this.offsetInText), t;
          }
        }, {
          key: "getAncestors",
          value: function getAncestors() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
              includeSelf: !1,
              parentFirst: !1
            };
            var e = [];
            var n = t.includeSelf ? this : this.parent;

            for (; n;) {
              e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
            }

            return e;
          }
        }, {
          key: "hasAttribute",
          value: function hasAttribute(t) {
            return this.textNode.hasAttribute(t);
          }
        }, {
          key: "getAttribute",
          value: function getAttribute(t) {
            return this.textNode.getAttribute(t);
          }
        }, {
          key: "getAttributes",
          value: function getAttributes() {
            return this.textNode.getAttributes();
          }
        }, {
          key: "getAttributeKeys",
          value: function getAttributeKeys() {
            return this.textNode.getAttributeKeys();
          }
        }]);

        return La;
      }();

      var Ra = /*#__PURE__*/function (_Symbol$iterator6) {
        function Ra(t) {
          _classCallCheck(this, Ra);

          this._nodes = [], t && this._insertNodes(0, t);
        }

        _createClass(Ra, [{
          key: _Symbol$iterator6,
          value: function value() {
            return this._nodes[Symbol.iterator]();
          }
        }, {
          key: "length",
          get: function get() {
            return this._nodes.length;
          }
        }, {
          key: "maxOffset",
          get: function get() {
            return this._nodes.reduce(function (t, e) {
              return t + e.offsetSize;
            }, 0);
          }
        }, {
          key: "getNode",
          value: function getNode(t) {
            return this._nodes[t] || null;
          }
        }, {
          key: "getNodeIndex",
          value: function getNodeIndex(t) {
            var e = this._nodes.indexOf(t);

            return -1 == e ? null : e;
          }
        }, {
          key: "getNodeStartOffset",
          value: function getNodeStartOffset(t) {
            var e = this.getNodeIndex(t);
            return null === e ? null : this._nodes.slice(0, e).reduce(function (t, e) {
              return t + e.offsetSize;
            }, 0);
          }
        }, {
          key: "indexToOffset",
          value: function indexToOffset(t) {
            if (t == this._nodes.length) return this.maxOffset;
            var e = this._nodes[t];
            if (!e) throw new a("model-nodelist-index-out-of-bounds", this);
            return this.getNodeStartOffset(e);
          }
        }, {
          key: "offsetToIndex",
          value: function offsetToIndex(t) {
            var e = 0;

            var _iterator107 = _createForOfIteratorHelper(this._nodes),
                _step107;

            try {
              for (_iterator107.s(); !(_step107 = _iterator107.n()).done;) {
                var _n76 = _step107.value;
                if (t >= e && t < e + _n76.offsetSize) return this.getNodeIndex(_n76);
                e += _n76.offsetSize;
              }
            } catch (err) {
              _iterator107.e(err);
            } finally {
              _iterator107.f();
            }

            if (e != t) throw new a("model-nodelist-offset-out-of-bounds", this, {
              offset: t,
              nodeList: this
            });
            return this.length;
          }
        }, {
          key: "_insertNodes",
          value: function _insertNodes(t, e) {
            var _this$_nodes;

            var _iterator108 = _createForOfIteratorHelper(e),
                _step108;

            try {
              for (_iterator108.s(); !(_step108 = _iterator108.n()).done;) {
                var _t80 = _step108.value;
                if (!(_t80 instanceof za)) throw new a("model-nodelist-insertnodes-not-node", this);
              }
            } catch (err) {
              _iterator108.e(err);
            } finally {
              _iterator108.f();
            }

            (_this$_nodes = this._nodes).splice.apply(_this$_nodes, [t, 0].concat(_toConsumableArray(e)));
          }
        }, {
          key: "_removeNodes",
          value: function _removeNodes(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            return this._nodes.splice(t, e);
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            return this._nodes.map(function (t) {
              return t.toJSON();
            });
          }
        }]);

        return Ra;
      }(Symbol.iterator);

      var Oa = /*#__PURE__*/function (_za2) {
        _inherits(Oa, _za2);

        var _super23 = _createSuper(Oa);

        function Oa(t, e, n) {
          var _this52;

          _classCallCheck(this, Oa);

          _this52 = _super23.call(this, e), _this52.name = t, _this52._children = new Ra(), n && _this52._insertChild(0, n);
          return _this52;
        }

        _createClass(Oa, [{
          key: "childCount",
          get: function get() {
            return this._children.length;
          }
        }, {
          key: "maxOffset",
          get: function get() {
            return this._children.maxOffset;
          }
        }, {
          key: "isEmpty",
          get: function get() {
            return 0 === this.childCount;
          }
        }, {
          key: "is",
          value: function is(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            return e ? e === this.name && ("element" === t || "model:element" === t) : "element" === t || "model:element" === t || "node" === t || "model:node" === t;
          }
        }, {
          key: "getChild",
          value: function getChild(t) {
            return this._children.getNode(t);
          }
        }, {
          key: "getChildren",
          value: function getChildren() {
            return this._children[Symbol.iterator]();
          }
        }, {
          key: "getChildIndex",
          value: function getChildIndex(t) {
            return this._children.getNodeIndex(t);
          }
        }, {
          key: "getChildStartOffset",
          value: function getChildStartOffset(t) {
            return this._children.getNodeStartOffset(t);
          }
        }, {
          key: "offsetToIndex",
          value: function offsetToIndex(t) {
            return this._children.offsetToIndex(t);
          }
        }, {
          key: "getNodeByPath",
          value: function getNodeByPath(t) {
            var e = this;

            var _iterator109 = _createForOfIteratorHelper(t),
                _step109;

            try {
              for (_iterator109.s(); !(_step109 = _iterator109.n()).done;) {
                var _n77 = _step109.value;
                e = e.getChild(e.offsetToIndex(_n77));
              }
            } catch (err) {
              _iterator109.e(err);
            } finally {
              _iterator109.f();
            }

            return e;
          }
        }, {
          key: "findAncestor",
          value: function findAncestor(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
              includeSelf: !1
            };
            var n = e.includeSelf ? this : this.parent;

            for (; n;) {
              if (n.name === t) return n;
              n = n.parent;
            }

            return null;
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var t = _get(_getPrototypeOf(Oa.prototype), "toJSON", this).call(this);

            if (t.name = this.name, this._children.length > 0) {
              t.children = [];

              var _iterator110 = _createForOfIteratorHelper(this._children),
                  _step110;

              try {
                for (_iterator110.s(); !(_step110 = _iterator110.n()).done;) {
                  var _e85 = _step110.value;
                  t.children.push(_e85.toJSON());
                }
              } catch (err) {
                _iterator110.e(err);
              } finally {
                _iterator110.f();
              }
            }

            return t;
          }
        }, {
          key: "_clone",
          value: function _clone() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
            var e = t ? Array.from(this._children).map(function (t) {
              return t._clone(!0);
            }) : null;
            return new Oa(this.name, this.getAttributes(), e);
          }
        }, {
          key: "_appendChild",
          value: function _appendChild(t) {
            this._insertChild(this.childCount, t);
          }
        }, {
          key: "_insertChild",
          value: function _insertChild(t, e) {
            var n = function (t) {
              if ("string" == typeof t) return [new Pa(t)];
              Ei(t) || (t = [t]);
              return Array.from(t).map(function (t) {
                return "string" == typeof t ? new Pa(t) : t instanceof La ? new Pa(t.data, t.getAttributes()) : t;
              });
            }(e);

            var _iterator111 = _createForOfIteratorHelper(n),
                _step111;

            try {
              for (_iterator111.s(); !(_step111 = _iterator111.n()).done;) {
                var _t81 = _step111.value;
                null !== _t81.parent && _t81._remove(), _t81.parent = this;
              }
            } catch (err) {
              _iterator111.e(err);
            } finally {
              _iterator111.f();
            }

            this._children._insertNodes(t, n);
          }
        }, {
          key: "_removeChildren",
          value: function _removeChildren(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            var n = this._children._removeNodes(t, e);

            var _iterator112 = _createForOfIteratorHelper(n),
                _step112;

            try {
              for (_iterator112.s(); !(_step112 = _iterator112.n()).done;) {
                var _t82 = _step112.value;
                _t82.parent = null;
              }
            } catch (err) {
              _iterator112.e(err);
            } finally {
              _iterator112.f();
            }

            return n;
          }
        }], [{
          key: "fromJSON",
          value: function fromJSON(t) {
            var e = null;

            if (t.children) {
              e = [];

              var _iterator113 = _createForOfIteratorHelper(t.children),
                  _step113;

              try {
                for (_iterator113.s(); !(_step113 = _iterator113.n()).done;) {
                  var _n78 = _step113.value;
                  _n78.name ? e.push(Oa.fromJSON(_n78)) : e.push(Pa.fromJSON(_n78));
                }
              } catch (err) {
                _iterator113.e(err);
              } finally {
                _iterator113.f();
              }
            }

            return new Oa(t.name, t.attributes, e);
          }
        }]);

        return Oa;
      }(za);

      var ja = /*#__PURE__*/function (_Symbol$iterator7) {
        function ja() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          _classCallCheck(this, ja);

          if (!t.boundaries && !t.startPosition) throw new a("model-tree-walker-no-start-position", null);
          var e = t.direction || "forward";
          if ("forward" != e && "backward" != e) throw new a("model-tree-walker-unknown-direction", t, {
            direction: e
          });
          this.direction = e, this.boundaries = t.boundaries || null, t.startPosition ? this.position = t.startPosition.clone() : this.position = Va._createAt(this.boundaries["backward" == this.direction ? "end" : "start"]), this.position.stickiness = "toNone", this.singleCharacters = !!t.singleCharacters, this.shallow = !!t.shallow, this.ignoreElementEnd = !!t.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null, this._visitedParent = this.position.parent;
        }

        _createClass(ja, [{
          key: _Symbol$iterator7,
          value: function value() {
            return this;
          }
        }, {
          key: "skip",
          value: function skip(t) {
            var e, n, i, o;

            do {
              var _this$next2;

              i = this.position, o = this._visitedParent, (_this$next2 = this.next(), e = _this$next2.done, n = _this$next2.value, _this$next2);
            } while (!e && t(n));

            e || (this.position = i, this._visitedParent = o);
          }
        }, {
          key: "next",
          value: function next() {
            return "forward" == this.direction ? this._next() : this._previous();
          }
        }, {
          key: "_next",
          value: function _next() {
            var t = this.position,
                e = this.position.clone(),
                n = this._visitedParent;
            if (null === n.parent && e.offset === n.maxOffset) return {
              done: !0
            };
            if (n === this._boundaryEndParent && e.offset == this.boundaries.end.offset) return {
              done: !0
            };
            var i = e.parent,
                o = Ua(e, i),
                r = o || Ha(e, i, o);
            if (r instanceof Oa) return this.shallow ? e.offset++ : (e.path.push(0), this._visitedParent = r), this.position = e, Fa("elementStart", r, t, e, 1);

            if (r instanceof Pa) {
              var _i55;

              if (this.singleCharacters) _i55 = 1;else {
                var _t83 = r.endOffset;
                this._boundaryEndParent == n && this.boundaries.end.offset < _t83 && (_t83 = this.boundaries.end.offset), _i55 = _t83 - e.offset;
              }

              var _o31 = e.offset - r.startOffset,
                  _s12 = new La(r, _o31, _i55);

              return e.offset += _i55, this.position = e, Fa("text", _s12, t, e, _i55);
            }

            return e.path.pop(), e.offset++, this.position = e, this._visitedParent = n.parent, this.ignoreElementEnd ? this._next() : Fa("elementEnd", n, t, e);
          }
        }, {
          key: "_previous",
          value: function _previous() {
            var t = this.position,
                e = this.position.clone(),
                n = this._visitedParent;
            if (null === n.parent && 0 === e.offset) return {
              done: !0
            };
            if (n == this._boundaryStartParent && e.offset == this.boundaries.start.offset) return {
              done: !0
            };
            var i = e.parent,
                o = Ua(e, i),
                r = o || qa(e, i, o);
            if (r instanceof Oa) return e.offset--, this.shallow ? (this.position = e, Fa("elementStart", r, t, e, 1)) : (e.path.push(r.maxOffset), this.position = e, this._visitedParent = r, this.ignoreElementEnd ? this._previous() : Fa("elementEnd", r, t, e));

            if (r instanceof Pa) {
              var _i56;

              if (this.singleCharacters) _i56 = 1;else {
                var _t84 = r.startOffset;
                this._boundaryStartParent == n && this.boundaries.start.offset > _t84 && (_t84 = this.boundaries.start.offset), _i56 = e.offset - _t84;
              }

              var _o32 = e.offset - r.startOffset,
                  _s13 = new La(r, _o32 - _i56, _i56);

              return e.offset -= _i56, this.position = e, Fa("text", _s13, t, e, _i56);
            }

            return e.path.pop(), this.position = e, this._visitedParent = n.parent, Fa("elementStart", n, t, e, 1);
          }
        }]);

        return ja;
      }(Symbol.iterator);

      function Fa(t, e, n, i, o) {
        return {
          done: !1,
          value: {
            type: t,
            item: e,
            previousPosition: n,
            nextPosition: i,
            length: o
          }
        };
      }

      var Va = /*#__PURE__*/function () {
        function Va(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";

          _classCallCheck(this, Va);

          if (!t.is("element") && !t.is("documentFragment")) throw new a("model-position-root-invalid", t);
          if (!(e instanceof Array) || 0 === e.length) throw new a("model-position-path-incorrect-format", t, {
            path: e
          });
          t.is("rootElement") ? e = e.slice() : (e = [].concat(_toConsumableArray(t.getPath()), _toConsumableArray(e)), t = t.root), this.root = t, this.path = e, this.stickiness = n;
        }

        _createClass(Va, [{
          key: "offset",
          get: function get() {
            return this.path[this.path.length - 1];
          },
          set: function set(t) {
            this.path[this.path.length - 1] = t;
          }
        }, {
          key: "parent",
          get: function get() {
            var t = this.root;

            for (var _e86 = 0; _e86 < this.path.length - 1; _e86++) {
              if (t = t.getChild(t.offsetToIndex(this.path[_e86])), !t) throw new a("model-position-path-incorrect", this, {
                position: this
              });
            }

            if (t.is("$text")) throw new a("model-position-path-incorrect", this, {
              position: this
            });
            return t;
          }
        }, {
          key: "index",
          get: function get() {
            return this.parent.offsetToIndex(this.offset);
          }
        }, {
          key: "textNode",
          get: function get() {
            return Ua(this, this.parent);
          }
        }, {
          key: "nodeAfter",
          get: function get() {
            var t = this.parent;
            return Ha(this, t, Ua(this, t));
          }
        }, {
          key: "nodeBefore",
          get: function get() {
            var t = this.parent;
            return qa(this, t, Ua(this, t));
          }
        }, {
          key: "isAtStart",
          get: function get() {
            return 0 === this.offset;
          }
        }, {
          key: "isAtEnd",
          get: function get() {
            return this.offset == this.parent.maxOffset;
          }
        }, {
          key: "compareWith",
          value: function compareWith(t) {
            if (this.root != t.root) return "different";
            var e = Li(this.path, t.path);

            switch (e) {
              case "same":
                return "same";

              case "prefix":
                return "before";

              case "extension":
                return "after";

              default:
                return this.path[e] < t.path[e] ? "before" : "after";
            }
          }
        }, {
          key: "getLastMatchingPosition",
          value: function getLastMatchingPosition(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            e.startPosition = this;
            var n = new ja(e);
            return n.skip(t), n.position;
          }
        }, {
          key: "getParentPath",
          value: function getParentPath() {
            return this.path.slice(0, -1);
          }
        }, {
          key: "getAncestors",
          value: function getAncestors() {
            var t = this.parent;
            return t.is("documentFragment") ? [t] : t.getAncestors({
              includeSelf: !0
            });
          }
        }, {
          key: "findAncestor",
          value: function findAncestor(t) {
            var e = this.parent;
            return e.is("element") ? e.findAncestor(t, {
              includeSelf: !0
            }) : null;
          }
        }, {
          key: "getCommonPath",
          value: function getCommonPath(t) {
            if (this.root != t.root) return [];
            var e = Li(this.path, t.path),
                n = "string" == typeof e ? Math.min(this.path.length, t.path.length) : e;
            return this.path.slice(0, n);
          }
        }, {
          key: "getCommonAncestor",
          value: function getCommonAncestor(t) {
            var e = this.getAncestors(),
                n = t.getAncestors();
            var i = 0;

            for (; e[i] == n[i] && e[i];) {
              i++;
            }

            return 0 === i ? null : e[i - 1];
          }
        }, {
          key: "getShiftedBy",
          value: function getShiftedBy(t) {
            var e = this.clone(),
                n = e.offset + t;
            return e.offset = n < 0 ? 0 : n, e;
          }
        }, {
          key: "isAfter",
          value: function isAfter(t) {
            return "after" == this.compareWith(t);
          }
        }, {
          key: "isBefore",
          value: function isBefore(t) {
            return "before" == this.compareWith(t);
          }
        }, {
          key: "isEqual",
          value: function isEqual(t) {
            return "same" == this.compareWith(t);
          }
        }, {
          key: "isTouching",
          value: function isTouching(t) {
            var e = null,
                n = null;

            switch (this.compareWith(t)) {
              case "same":
                return !0;

              case "before":
                e = Va._createAt(this), n = Va._createAt(t);
                break;

              case "after":
                e = Va._createAt(t), n = Va._createAt(this);
                break;

              default:
                return !1;
            }

            var i = e.parent;

            for (; e.path.length + n.path.length;) {
              if (e.isEqual(n)) return !0;

              if (e.path.length > n.path.length) {
                if (e.offset !== i.maxOffset) return !1;
                e.path = e.path.slice(0, -1), i = i.parent, e.offset++;
              } else {
                if (0 !== n.offset) return !1;
                n.path = n.path.slice(0, -1);
              }
            }
          }
        }, {
          key: "is",
          value: function is(t) {
            return "position" === t || "model:position" === t;
          }
        }, {
          key: "hasSameParentAs",
          value: function hasSameParentAs(t) {
            if (this.root !== t.root) return !1;
            return "same" == Li(this.getParentPath(), t.getParentPath());
          }
        }, {
          key: "getTransformedByOperation",
          value: function getTransformedByOperation(t) {
            var e;

            switch (t.type) {
              case "insert":
                e = this._getTransformedByInsertOperation(t);
                break;

              case "move":
              case "remove":
              case "reinsert":
                e = this._getTransformedByMoveOperation(t);
                break;

              case "split":
                e = this._getTransformedBySplitOperation(t);
                break;

              case "merge":
                e = this._getTransformedByMergeOperation(t);
                break;

              default:
                e = Va._createAt(this);
            }

            return e;
          }
        }, {
          key: "_getTransformedByInsertOperation",
          value: function _getTransformedByInsertOperation(t) {
            return this._getTransformedByInsertion(t.position, t.howMany);
          }
        }, {
          key: "_getTransformedByMoveOperation",
          value: function _getTransformedByMoveOperation(t) {
            return this._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany);
          }
        }, {
          key: "_getTransformedBySplitOperation",
          value: function _getTransformedBySplitOperation(t) {
            var e = t.movedRange;
            return e.containsPosition(this) || e.start.isEqual(this) && "toNext" == this.stickiness ? this._getCombined(t.splitPosition, t.moveTargetPosition) : t.graveyardPosition ? this._getTransformedByMove(t.graveyardPosition, t.insertionPosition, 1) : this._getTransformedByInsertion(t.insertionPosition, 1);
          }
        }, {
          key: "_getTransformedByMergeOperation",
          value: function _getTransformedByMergeOperation(t) {
            var e = t.movedRange;
            var n;
            return e.containsPosition(this) || e.start.isEqual(this) ? (n = this._getCombined(t.sourcePosition, t.targetPosition), t.sourcePosition.isBefore(t.targetPosition) && (n = n._getTransformedByDeletion(t.deletionPosition, 1))) : n = this.isEqual(t.deletionPosition) ? Va._createAt(t.deletionPosition) : this._getTransformedByMove(t.deletionPosition, t.graveyardPosition, 1), n;
          }
        }, {
          key: "_getTransformedByDeletion",
          value: function _getTransformedByDeletion(t, e) {
            var n = Va._createAt(this);

            if (this.root != t.root) return n;

            if ("same" == Li(t.getParentPath(), this.getParentPath())) {
              if (t.offset < this.offset) {
                if (t.offset + e > this.offset) return null;
                n.offset -= e;
              }
            } else if ("prefix" == Li(t.getParentPath(), this.getParentPath())) {
              var _i57 = t.path.length - 1;

              if (t.offset <= this.path[_i57]) {
                if (t.offset + e > this.path[_i57]) return null;
                n.path[_i57] -= e;
              }
            }

            return n;
          }
        }, {
          key: "_getTransformedByInsertion",
          value: function _getTransformedByInsertion(t, e) {
            var n = Va._createAt(this);

            if (this.root != t.root) return n;
            if ("same" == Li(t.getParentPath(), this.getParentPath())) (t.offset < this.offset || t.offset == this.offset && "toPrevious" != this.stickiness) && (n.offset += e);else if ("prefix" == Li(t.getParentPath(), this.getParentPath())) {
              var _i58 = t.path.length - 1;

              t.offset <= this.path[_i58] && (n.path[_i58] += e);
            }
            return n;
          }
        }, {
          key: "_getTransformedByMove",
          value: function _getTransformedByMove(t, e, n) {
            if (e = e._getTransformedByDeletion(t, n), t.isEqual(e)) return Va._createAt(this);

            var i = this._getTransformedByDeletion(t, n);

            return null === i || t.isEqual(this) && "toNext" == this.stickiness || t.getShiftedBy(n).isEqual(this) && "toPrevious" == this.stickiness ? this._getCombined(t, e) : i._getTransformedByInsertion(e, n);
          }
        }, {
          key: "_getCombined",
          value: function _getCombined(t, e) {
            var n = t.path.length - 1,
                i = Va._createAt(e);

            return i.stickiness = this.stickiness, i.offset = i.offset + this.path[n] - t.offset, i.path = [].concat(_toConsumableArray(i.path), _toConsumableArray(this.path.slice(n + 1))), i;
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            return {
              root: this.root.toJSON(),
              path: Array.from(this.path),
              stickiness: this.stickiness
            };
          }
        }, {
          key: "clone",
          value: function clone() {
            return new this.constructor(this.root, this.path, this.stickiness);
          }
        }], [{
          key: "_createAt",
          value: function _createAt(t, e) {
            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
            if (t instanceof Va) return new Va(t.root, t.path, t.stickiness);
            {
              var _i59 = t;
              if ("end" == e) e = _i59.maxOffset;else {
                if ("before" == e) return this._createBefore(_i59, n);
                if ("after" == e) return this._createAfter(_i59, n);
                if (0 !== e && !e) throw new a("model-createpositionat-offset-required", [this, t]);
              }
              if (!_i59.is("element") && !_i59.is("documentFragment")) throw new a("model-position-parent-incorrect", [this, t]);

              var _o33 = _i59.getPath();

              return _o33.push(e), new this(_i59.root, _o33, n);
            }
          }
        }, {
          key: "_createAfter",
          value: function _createAfter(t, e) {
            if (!t.parent) throw new a("model-position-after-root", [this, t], {
              root: t
            });
            return this._createAt(t.parent, t.endOffset, e);
          }
        }, {
          key: "_createBefore",
          value: function _createBefore(t, e) {
            if (!t.parent) throw new a("model-position-before-root", t, {
              root: t
            });
            return this._createAt(t.parent, t.startOffset, e);
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(t, e) {
            if ("$graveyard" === t.root) {
              var _n79 = new Va(e.graveyard, t.path);

              return _n79.stickiness = t.stickiness, _n79;
            }

            if (!e.getRoot(t.root)) throw new a("model-position-fromjson-no-root", e, {
              rootName: t.root
            });
            return new Va(e.getRoot(t.root), t.path, t.stickiness);
          }
        }]);

        return Va;
      }();

      function Ua(t, e) {
        var n = e.getChild(e.offsetToIndex(t.offset));
        return n && n.is("$text") && n.startOffset < t.offset ? n : null;
      }

      function Ha(t, e, n) {
        return null !== n ? null : e.getChild(e.offsetToIndex(t.offset));
      }

      function qa(t, e, n) {
        return null !== n ? null : e.getChild(e.offsetToIndex(t.offset) - 1);
      }

      var Wa = /*#__PURE__*/function (_Symbol$iterator8) {
        function Wa(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

          _classCallCheck(this, Wa);

          this.start = Va._createAt(t), this.end = e ? Va._createAt(e) : Va._createAt(t), this.start.stickiness = this.isCollapsed ? "toNone" : "toNext", this.end.stickiness = this.isCollapsed ? "toNone" : "toPrevious";
        }

        _createClass(Wa, [{
          key: _Symbol$iterator8,
          value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
            return _regeneratorRuntime.wrap(function value$(_context13) {
              while (1) {
                switch (_context13.prev = _context13.next) {
                  case 0:
                    return _context13.delegateYield(new ja({
                      boundaries: this,
                      ignoreElementEnd: !0
                    }), "t0", 1);

                  case 1:
                  case "end":
                    return _context13.stop();
                }
              }
            }, value, this);
          })
        }, {
          key: "isCollapsed",
          get: function get() {
            return this.start.isEqual(this.end);
          }
        }, {
          key: "isFlat",
          get: function get() {
            return "same" == Li(this.start.getParentPath(), this.end.getParentPath());
          }
        }, {
          key: "root",
          get: function get() {
            return this.start.root;
          }
        }, {
          key: "containsPosition",
          value: function containsPosition(t) {
            return t.isAfter(this.start) && t.isBefore(this.end);
          }
        }, {
          key: "containsRange",
          value: function containsRange(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            t.isCollapsed && (e = !1);
            var n = this.containsPosition(t.start) || e && this.start.isEqual(t.start),
                i = this.containsPosition(t.end) || e && this.end.isEqual(t.end);
            return n && i;
          }
        }, {
          key: "containsItem",
          value: function containsItem(t) {
            var e = Va._createBefore(t);

            return this.containsPosition(e) || this.start.isEqual(e);
          }
        }, {
          key: "is",
          value: function is(t) {
            return "range" === t || "model:range" === t;
          }
        }, {
          key: "isEqual",
          value: function isEqual(t) {
            return this.start.isEqual(t.start) && this.end.isEqual(t.end);
          }
        }, {
          key: "isIntersecting",
          value: function isIntersecting(t) {
            return this.start.isBefore(t.end) && this.end.isAfter(t.start);
          }
        }, {
          key: "getDifference",
          value: function getDifference(t) {
            var e = [];
            return this.isIntersecting(t) ? (this.containsPosition(t.start) && e.push(new Wa(this.start, t.start)), this.containsPosition(t.end) && e.push(new Wa(t.end, this.end))) : e.push(new Wa(this.start, this.end)), e;
          }
        }, {
          key: "getIntersection",
          value: function getIntersection(t) {
            if (this.isIntersecting(t)) {
              var _e87 = this.start,
                  _n80 = this.end;
              return this.containsPosition(t.start) && (_e87 = t.start), this.containsPosition(t.end) && (_n80 = t.end), new Wa(_e87, _n80);
            }

            return null;
          }
        }, {
          key: "getJoined",
          value: function getJoined(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            var n = this.isIntersecting(t);
            if (n || (n = this.start.isBefore(t.start) ? e ? this.end.isTouching(t.start) : this.end.isEqual(t.start) : e ? t.end.isTouching(this.start) : t.end.isEqual(this.start)), !n) return null;
            var i = this.start,
                o = this.end;
            return t.start.isBefore(i) && (i = t.start), t.end.isAfter(o) && (o = t.end), new Wa(i, o);
          }
        }, {
          key: "getMinimalFlatRanges",
          value: function getMinimalFlatRanges() {
            var t = [],
                e = this.start.getCommonPath(this.end).length,
                n = Va._createAt(this.start);

            var i = n.parent;

            for (; n.path.length > e + 1;) {
              var _e88 = i.maxOffset - n.offset;

              0 !== _e88 && t.push(new Wa(n, n.getShiftedBy(_e88))), n.path = n.path.slice(0, -1), n.offset++, i = i.parent;
            }

            for (; n.path.length <= this.end.path.length;) {
              var _e89 = this.end.path[n.path.length - 1],
                  _i60 = _e89 - n.offset;

              0 !== _i60 && t.push(new Wa(n, n.getShiftedBy(_i60))), n.offset = _e89, n.path.push(0);
            }

            return t;
          }
        }, {
          key: "getWalker",
          value: function getWalker() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return t.boundaries = this, new ja(t);
          }
        }, {
          key: "getItems",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function getItems() {
            var t,
                e,
                _iterator114,
                _step114,
                _t85,
                _args14 = arguments;

            return _regeneratorRuntime.wrap(function getItems$(_context14) {
              while (1) {
                switch (_context14.prev = _context14.next) {
                  case 0:
                    t = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : {};
                    t.boundaries = this, t.ignoreElementEnd = !0;
                    e = new ja(t);
                    _iterator114 = _createForOfIteratorHelper(e);
                    _context14.prev = 4;

                    _iterator114.s();

                  case 6:
                    if ((_step114 = _iterator114.n()).done) {
                      _context14.next = 12;
                      break;
                    }

                    _t85 = _step114.value;
                    _context14.next = 10;
                    return _t85.item;

                  case 10:
                    _context14.next = 6;
                    break;

                  case 12:
                    _context14.next = 17;
                    break;

                  case 14:
                    _context14.prev = 14;
                    _context14.t0 = _context14["catch"](4);

                    _iterator114.e(_context14.t0);

                  case 17:
                    _context14.prev = 17;

                    _iterator114.f();

                    return _context14.finish(17);

                  case 20:
                  case "end":
                    return _context14.stop();
                }
              }
            }, getItems, this, [[4, 14, 17, 20]]);
          })
        }, {
          key: "getPositions",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function getPositions() {
            var t,
                e,
                _iterator115,
                _step115,
                _t86,
                _args15 = arguments;

            return _regeneratorRuntime.wrap(function getPositions$(_context15) {
              while (1) {
                switch (_context15.prev = _context15.next) {
                  case 0:
                    t = _args15.length > 0 && _args15[0] !== undefined ? _args15[0] : {};
                    t.boundaries = this;
                    e = new ja(t);
                    _context15.next = 5;
                    return e.position;

                  case 5:
                    _iterator115 = _createForOfIteratorHelper(e);
                    _context15.prev = 6;

                    _iterator115.s();

                  case 8:
                    if ((_step115 = _iterator115.n()).done) {
                      _context15.next = 14;
                      break;
                    }

                    _t86 = _step115.value;
                    _context15.next = 12;
                    return _t86.nextPosition;

                  case 12:
                    _context15.next = 8;
                    break;

                  case 14:
                    _context15.next = 19;
                    break;

                  case 16:
                    _context15.prev = 16;
                    _context15.t0 = _context15["catch"](6);

                    _iterator115.e(_context15.t0);

                  case 19:
                    _context15.prev = 19;

                    _iterator115.f();

                    return _context15.finish(19);

                  case 22:
                  case "end":
                    return _context15.stop();
                }
              }
            }, getPositions, this, [[6, 16, 19, 22]]);
          })
        }, {
          key: "getTransformedByOperation",
          value: function getTransformedByOperation(t) {
            switch (t.type) {
              case "insert":
                return this._getTransformedByInsertOperation(t);

              case "move":
              case "remove":
              case "reinsert":
                return this._getTransformedByMoveOperation(t);

              case "split":
                return [this._getTransformedBySplitOperation(t)];

              case "merge":
                return [this._getTransformedByMergeOperation(t)];
            }

            return [new Wa(this.start, this.end)];
          }
        }, {
          key: "getTransformedByOperations",
          value: function getTransformedByOperations(t) {
            var e = [new Wa(this.start, this.end)];

            var _iterator116 = _createForOfIteratorHelper(t),
                _step116;

            try {
              for (_iterator116.s(); !(_step116 = _iterator116.n()).done;) {
                var _n82 = _step116.value;

                for (var _t89 = 0; _t89 < e.length; _t89++) {
                  var _i62 = e[_t89].getTransformedByOperation(_n82);

                  e.splice.apply(e, [_t89, 1].concat(_toConsumableArray(_i62))), _t89 += _i62.length - 1;
                }
              }
            } catch (err) {
              _iterator116.e(err);
            } finally {
              _iterator116.f();
            }

            for (var _t87 = 0; _t87 < e.length; _t87++) {
              var _n81 = e[_t87];

              for (var _i61 = _t87 + 1; _i61 < e.length; _i61++) {
                var _t88 = e[_i61];
                (_n81.containsRange(_t88) || _t88.containsRange(_n81) || _n81.isEqual(_t88)) && e.splice(_i61, 1);
              }
            }

            return e;
          }
        }, {
          key: "getCommonAncestor",
          value: function getCommonAncestor() {
            return this.start.getCommonAncestor(this.end);
          }
        }, {
          key: "getContainedElement",
          value: function getContainedElement() {
            if (this.isCollapsed) return null;
            var t = this.start.nodeAfter,
                e = this.end.nodeBefore;
            return t && t.is("element") && t === e ? t : null;
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            return {
              start: this.start.toJSON(),
              end: this.end.toJSON()
            };
          }
        }, {
          key: "clone",
          value: function clone() {
            return new this.constructor(this.start, this.end);
          }
        }, {
          key: "_getTransformedByInsertOperation",
          value: function _getTransformedByInsertOperation(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            return this._getTransformedByInsertion(t.position, t.howMany, e);
          }
        }, {
          key: "_getTransformedByMoveOperation",
          value: function _getTransformedByMoveOperation(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            var n = t.sourcePosition,
                i = t.howMany,
                o = t.targetPosition;
            return this._getTransformedByMove(n, o, i, e);
          }
        }, {
          key: "_getTransformedBySplitOperation",
          value: function _getTransformedBySplitOperation(t) {
            var e = this.start._getTransformedBySplitOperation(t);

            var n = this.end._getTransformedBySplitOperation(t);

            return this.end.isEqual(t.insertionPosition) && (n = this.end.getShiftedBy(1)), e.root != n.root && (n = this.end.getShiftedBy(-1)), new Wa(e, n);
          }
        }, {
          key: "_getTransformedByMergeOperation",
          value: function _getTransformedByMergeOperation(t) {
            if (this.start.isEqual(t.targetPosition) && this.end.isEqual(t.deletionPosition)) return new Wa(this.start);

            var e = this.start._getTransformedByMergeOperation(t),
                n = this.end._getTransformedByMergeOperation(t);

            return e.root != n.root && (n = this.end.getShiftedBy(-1)), e.isAfter(n) ? (t.sourcePosition.isBefore(t.targetPosition) ? (e = Va._createAt(n), e.offset = 0) : (t.deletionPosition.isEqual(e) || (n = t.deletionPosition), e = t.targetPosition), new Wa(e, n)) : new Wa(e, n);
          }
        }, {
          key: "_getTransformedByInsertion",
          value: function _getTransformedByInsertion(t, e) {
            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
            if (n && this.containsPosition(t)) return [new Wa(this.start, t), new Wa(t.getShiftedBy(e), this.end._getTransformedByInsertion(t, e))];
            {
              var _n83 = new Wa(this.start, this.end);

              return _n83.start = _n83.start._getTransformedByInsertion(t, e), _n83.end = _n83.end._getTransformedByInsertion(t, e), [_n83];
            }
          }
        }, {
          key: "_getTransformedByMove",
          value: function _getTransformedByMove(t, e, n) {
            var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

            if (this.isCollapsed) {
              var _i63 = this.start._getTransformedByMove(t, e, n);

              return [new Wa(_i63)];
            }

            var o = Wa._createFromPositionAndShift(t, n),
                r = e._getTransformedByDeletion(t, n);

            if (this.containsPosition(e) && !i && (o.containsPosition(this.start) || o.containsPosition(this.end))) {
              var _i64 = this.start._getTransformedByMove(t, e, n),
                  _o34 = this.end._getTransformedByMove(t, e, n);

              return [new Wa(_i64, _o34)];
            }

            var s;
            var a = this.getDifference(o);
            var c = null;
            var l = this.getIntersection(o);

            if (1 == a.length ? c = new Wa(a[0].start._getTransformedByDeletion(t, n), a[0].end._getTransformedByDeletion(t, n)) : 2 == a.length && (c = new Wa(this.start, this.end._getTransformedByDeletion(t, n))), s = c ? c._getTransformedByInsertion(r, n, null !== l || i) : [], l) {
              var _t90 = new Wa(l.start._getCombined(o.start, r), l.end._getCombined(o.start, r));

              2 == s.length ? s.splice(1, 0, _t90) : s.push(_t90);
            }

            return s;
          }
        }, {
          key: "_getTransformedByDeletion",
          value: function _getTransformedByDeletion(t, e) {
            var n = this.start._getTransformedByDeletion(t, e),
                i = this.end._getTransformedByDeletion(t, e);

            return null == n && null == i ? null : (null == n && (n = t), null == i && (i = t), new Wa(n, i));
          }
        }], [{
          key: "_createFromPositionAndShift",
          value: function _createFromPositionAndShift(t, e) {
            var n = t,
                i = t.getShiftedBy(e);
            return e > 0 ? new this(n, i) : new this(i, n);
          }
        }, {
          key: "_createIn",
          value: function _createIn(t) {
            return new this(Va._createAt(t, 0), Va._createAt(t, t.maxOffset));
          }
        }, {
          key: "_createOn",
          value: function _createOn(t) {
            return this._createFromPositionAndShift(Va._createBefore(t), t.offsetSize);
          }
        }, {
          key: "_createFromRanges",
          value: function _createFromRanges(t) {
            if (0 === t.length) throw new a("range-create-from-ranges-empty-array", null);
            if (1 == t.length) return t[0].clone();
            var e = t[0];
            t.sort(function (t, e) {
              return t.start.isAfter(e.start) ? 1 : -1;
            });
            var n = t.indexOf(e),
                i = new this(e.start, e.end);
            if (n > 0) for (var _e90 = n - 1; t[_e90].end.isEqual(i.start); _e90++) {
              i.start = Va._createAt(t[_e90].start);
            }

            for (var _e91 = n + 1; _e91 < t.length && t[_e91].start.isEqual(i.end); _e91++) {
              i.end = Va._createAt(t[_e91].end);
            }

            return i;
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(t, e) {
            return new this(Va.fromJSON(t.start, e), Va.fromJSON(t.end, e));
          }
        }]);

        return Wa;
      }(Symbol.iterator);

      var Ga = /*#__PURE__*/function () {
        function Ga() {
          var _this53 = this;

          _classCallCheck(this, Ga);

          this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._viewToModelLengthCallbacks = new Map(), this._markerNameToElements = new Map(), this._elementToMarkerNames = new Map(), this._unboundMarkerNames = new Set(), this.on("modelToViewPosition", function (t, e) {
            if (e.viewPosition) return;

            var n = _this53._modelToViewMapping.get(e.modelPosition.parent);

            e.viewPosition = _this53.findPositionIn(n, e.modelPosition.offset);
          }, {
            priority: "low"
          }), this.on("viewToModelPosition", function (t, e) {
            if (e.modelPosition) return;

            var n = _this53.findMappedViewAncestor(e.viewPosition),
                i = _this53._viewToModelMapping.get(n),
                o = _this53._toModelOffset(e.viewPosition.parent, e.viewPosition.offset, n);

            e.modelPosition = Va._createAt(i, o);
          }, {
            priority: "low"
          });
        }

        _createClass(Ga, [{
          key: "bindElements",
          value: function bindElements(t, e) {
            this._modelToViewMapping.set(t, e), this._viewToModelMapping.set(e, t);
          }
        }, {
          key: "unbindViewElement",
          value: function unbindViewElement(t) {
            var e = this.toModelElement(t);

            if (this._viewToModelMapping.delete(t), this._elementToMarkerNames.has(t)) {
              var _iterator117 = _createForOfIteratorHelper(this._elementToMarkerNames.get(t)),
                  _step117;

              try {
                for (_iterator117.s(); !(_step117 = _iterator117.n()).done;) {
                  var _e92 = _step117.value;

                  this._unboundMarkerNames.add(_e92);
                }
              } catch (err) {
                _iterator117.e(err);
              } finally {
                _iterator117.f();
              }
            }

            this._modelToViewMapping.get(e) == t && this._modelToViewMapping.delete(e);
          }
        }, {
          key: "unbindModelElement",
          value: function unbindModelElement(t) {
            var e = this.toViewElement(t);
            this._modelToViewMapping.delete(t), this._viewToModelMapping.get(e) == t && this._viewToModelMapping.delete(e);
          }
        }, {
          key: "bindElementToMarker",
          value: function bindElementToMarker(t, e) {
            var n = this._markerNameToElements.get(e) || new Set();
            n.add(t);
            var i = this._elementToMarkerNames.get(t) || new Set();
            i.add(e), this._markerNameToElements.set(e, n), this._elementToMarkerNames.set(t, i);
          }
        }, {
          key: "unbindElementFromMarkerName",
          value: function unbindElementFromMarkerName(t, e) {
            var n = this._markerNameToElements.get(e);

            n && (n.delete(t), 0 == n.size && this._markerNameToElements.delete(e));

            var i = this._elementToMarkerNames.get(t);

            i && (i.delete(e), 0 == i.size && this._elementToMarkerNames.delete(t));
          }
        }, {
          key: "flushUnboundMarkerNames",
          value: function flushUnboundMarkerNames() {
            var t = Array.from(this._unboundMarkerNames);
            return this._unboundMarkerNames.clear(), t;
          }
        }, {
          key: "clearBindings",
          value: function clearBindings() {
            this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._markerNameToElements = new Map(), this._elementToMarkerNames = new Map(), this._unboundMarkerNames = new Set();
          }
        }, {
          key: "toModelElement",
          value: function toModelElement(t) {
            return this._viewToModelMapping.get(t);
          }
        }, {
          key: "toViewElement",
          value: function toViewElement(t) {
            return this._modelToViewMapping.get(t);
          }
        }, {
          key: "toModelRange",
          value: function toModelRange(t) {
            return new Wa(this.toModelPosition(t.start), this.toModelPosition(t.end));
          }
        }, {
          key: "toViewRange",
          value: function toViewRange(t) {
            return new jo(this.toViewPosition(t.start), this.toViewPosition(t.end));
          }
        }, {
          key: "toModelPosition",
          value: function toModelPosition(t) {
            var e = {
              viewPosition: t,
              mapper: this
            };
            return this.fire("viewToModelPosition", e), e.modelPosition;
          }
        }, {
          key: "toViewPosition",
          value: function toViewPosition(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
              isPhantom: !1
            };
            var n = {
              modelPosition: t,
              mapper: this,
              isPhantom: e.isPhantom
            };
            return this.fire("modelToViewPosition", n), n.viewPosition;
          }
        }, {
          key: "markerNameToElements",
          value: function markerNameToElements(t) {
            var e = this._markerNameToElements.get(t);

            if (!e) return null;
            var n = new Set();

            var _iterator118 = _createForOfIteratorHelper(e),
                _step118;

            try {
              for (_iterator118.s(); !(_step118 = _iterator118.n()).done;) {
                var _t91 = _step118.value;

                if (_t91.is("attributeElement")) {
                  var _iterator119 = _createForOfIteratorHelper(_t91.getElementsWithSameId()),
                      _step119;

                  try {
                    for (_iterator119.s(); !(_step119 = _iterator119.n()).done;) {
                      var _e93 = _step119.value;
                      n.add(_e93);
                    }
                  } catch (err) {
                    _iterator119.e(err);
                  } finally {
                    _iterator119.f();
                  }
                } else n.add(_t91);
              }
            } catch (err) {
              _iterator118.e(err);
            } finally {
              _iterator118.f();
            }

            return n;
          }
        }, {
          key: "registerViewToModelLength",
          value: function registerViewToModelLength(t, e) {
            this._viewToModelLengthCallbacks.set(t, e);
          }
        }, {
          key: "findMappedViewAncestor",
          value: function findMappedViewAncestor(t) {
            var e = t.parent;

            for (; !this._viewToModelMapping.has(e);) {
              e = e.parent;
            }

            return e;
          }
        }, {
          key: "_toModelOffset",
          value: function _toModelOffset(t, e, n) {
            if (n != t) {
              return this._toModelOffset(t.parent, t.index, n) + this._toModelOffset(t, e, t);
            }

            if (t.is("$text")) return e;
            var i = 0;

            for (var _n84 = 0; _n84 < e; _n84++) {
              i += this.getModelLength(t.getChild(_n84));
            }

            return i;
          }
        }, {
          key: "getModelLength",
          value: function getModelLength(t) {
            if (this._viewToModelLengthCallbacks.get(t.name)) {
              return this._viewToModelLengthCallbacks.get(t.name)(t);
            }

            if (this._viewToModelMapping.has(t)) return 1;
            if (t.is("$text")) return t.data.length;
            if (t.is("uiElement")) return 0;
            {
              var _e94 = 0;

              var _iterator120 = _createForOfIteratorHelper(t.getChildren()),
                  _step120;

              try {
                for (_iterator120.s(); !(_step120 = _iterator120.n()).done;) {
                  var _n85 = _step120.value;
                  _e94 += this.getModelLength(_n85);
                }
              } catch (err) {
                _iterator120.e(err);
              } finally {
                _iterator120.f();
              }

              return _e94;
            }
          }
        }, {
          key: "findPositionIn",
          value: function findPositionIn(t, e) {
            var n,
                i = 0,
                o = 0,
                r = 0;
            if (t.is("$text")) return new Oo(t, e);

            for (; o < e;) {
              n = t.getChild(r), i = this.getModelLength(n), o += i, r++;
            }

            return o == e ? this._moveViewPositionToTextNode(new Oo(t, r)) : this.findPositionIn(n, e - (o - i));
          }
        }, {
          key: "_moveViewPositionToTextNode",
          value: function _moveViewPositionToTextNode(t) {
            var e = t.nodeBefore,
                n = t.nodeAfter;
            return e instanceof ji ? new Oo(e, e.data.length) : n instanceof ji ? new Oo(n, 0) : t;
          }
        }]);

        return Ga;
      }();

      he(Ga, f);

      var $a = /*#__PURE__*/function () {
        function $a() {
          _classCallCheck(this, $a);

          this._consumable = new Map(), this._textProxyRegistry = new Map();
        }

        _createClass($a, [{
          key: "add",
          value: function add(t, e) {
            e = Ya(e), t instanceof La && (t = this._getSymbolForTextProxy(t)), this._consumable.has(t) || this._consumable.set(t, new Map()), this._consumable.get(t).set(e, !0);
          }
        }, {
          key: "consume",
          value: function consume(t, e) {
            return e = Ya(e), t instanceof La && (t = this._getSymbolForTextProxy(t)), !!this.test(t, e) && (this._consumable.get(t).set(e, !1), !0);
          }
        }, {
          key: "test",
          value: function test(t, e) {
            e = Ya(e), t instanceof La && (t = this._getSymbolForTextProxy(t));

            var n = this._consumable.get(t);

            if (void 0 === n) return null;
            var i = n.get(e);
            return void 0 === i ? null : i;
          }
        }, {
          key: "revert",
          value: function revert(t, e) {
            e = Ya(e), t instanceof La && (t = this._getSymbolForTextProxy(t));
            var n = this.test(t, e);
            return !1 === n ? (this._consumable.get(t).set(e, !0), !0) : !0 !== n && null;
          }
        }, {
          key: "_getSymbolForTextProxy",
          value: function _getSymbolForTextProxy(t) {
            var e = null;

            var n = this._textProxyRegistry.get(t.startOffset);

            if (n) {
              var _i65 = n.get(t.endOffset);

              _i65 && (e = _i65.get(t.parent));
            }

            return e || (e = this._addSymbolForTextProxy(t.startOffset, t.endOffset, t.parent)), e;
          }
        }, {
          key: "_addSymbolForTextProxy",
          value: function _addSymbolForTextProxy(t, e, n) {
            var i = Symbol("textProxySymbol");
            var o, r;
            return o = this._textProxyRegistry.get(t), o || (o = new Map(), this._textProxyRegistry.set(t, o)), r = o.get(e), r || (r = new Map(), o.set(e, r)), r.set(n, i), i;
          }
        }]);

        return $a;
      }();

      function Ya(t) {
        var e = t.split(":");
        return "addMarker" == e[0] || "removeMarker" == e[0] ? t : e.length > 1 ? e[0] + ":" + e[1] : e[0];
      }

      var Ka = /*#__PURE__*/function () {
        function Ka(t) {
          _classCallCheck(this, Ka);

          this.conversionApi = Object.assign({
            dispatcher: this
          }, t), this._reconversionEventsMapping = new Map();
        }

        _createClass(Ka, [{
          key: "convertChanges",
          value: function convertChanges(t, e, n) {
            var _iterator121 = _createForOfIteratorHelper(t.getMarkersToRemove()),
                _step121;

            try {
              for (_iterator121.s(); !(_step121 = _iterator121.n()).done;) {
                var _e95 = _step121.value;
                this.convertMarkerRemove(_e95.name, _e95.range, n);
              }
            } catch (err) {
              _iterator121.e(err);
            } finally {
              _iterator121.f();
            }

            var i = this._mapChangesWithAutomaticReconversion(t);

            var _iterator122 = _createForOfIteratorHelper(i),
                _step122;

            try {
              for (_iterator122.s(); !(_step122 = _iterator122.n()).done;) {
                var _t92 = _step122.value;
                "insert" === _t92.type ? this.convertInsert(Wa._createFromPositionAndShift(_t92.position, _t92.length), n) : "remove" === _t92.type ? this.convertRemove(_t92.position, _t92.length, _t92.name, n) : "reconvert" === _t92.type ? this.reconvertElement(_t92.element, n) : this.convertAttribute(_t92.range, _t92.attributeKey, _t92.attributeOldValue, _t92.attributeNewValue, n);
              }
            } catch (err) {
              _iterator122.e(err);
            } finally {
              _iterator122.f();
            }

            var _iterator123 = _createForOfIteratorHelper(this.conversionApi.mapper.flushUnboundMarkerNames()),
                _step123;

            try {
              for (_iterator123.s(); !(_step123 = _iterator123.n()).done;) {
                var _t93 = _step123.value;

                var _i66 = e.get(_t93).getRange();

                this.convertMarkerRemove(_t93, _i66, n), this.convertMarkerAdd(_t93, _i66, n);
              }
            } catch (err) {
              _iterator123.e(err);
            } finally {
              _iterator123.f();
            }

            var _iterator124 = _createForOfIteratorHelper(t.getMarkersToAdd()),
                _step124;

            try {
              for (_iterator124.s(); !(_step124 = _iterator124.n()).done;) {
                var _e96 = _step124.value;
                this.convertMarkerAdd(_e96.name, _e96.range, n);
              }
            } catch (err) {
              _iterator124.e(err);
            } finally {
              _iterator124.f();
            }
          }
        }, {
          key: "convertInsert",
          value: function convertInsert(t, e) {
            this.conversionApi.writer = e, this.conversionApi.consumable = this._createInsertConsumable(t);

            var _iterator125 = _createForOfIteratorHelper(Array.from(t).map(Za)),
                _step125;

            try {
              for (_iterator125.s(); !(_step125 = _iterator125.n()).done;) {
                var _e97 = _step125.value;

                this._convertInsertWithAttributes(_e97);
              }
            } catch (err) {
              _iterator125.e(err);
            } finally {
              _iterator125.f();
            }

            this._clearConversionApi();
          }
        }, {
          key: "convertRemove",
          value: function convertRemove(t, e, n, i) {
            this.conversionApi.writer = i, this.fire("remove:" + n, {
              position: t,
              length: e
            }, this.conversionApi), this._clearConversionApi();
          }
        }, {
          key: "convertAttribute",
          value: function convertAttribute(t, e, n, i, o) {
            this.conversionApi.writer = o, this.conversionApi.consumable = this._createConsumableForRange(t, "attribute:".concat(e));

            var _iterator126 = _createForOfIteratorHelper(t),
                _step126;

            try {
              for (_iterator126.s(); !(_step126 = _iterator126.n()).done;) {
                var _o35 = _step126.value;
                var _t94 = {
                  item: _o35.item,
                  range: Wa._createFromPositionAndShift(_o35.previousPosition, _o35.length),
                  attributeKey: e,
                  attributeOldValue: n,
                  attributeNewValue: i
                };

                this._testAndFire("attribute:".concat(e), _t94);
              }
            } catch (err) {
              _iterator126.e(err);
            } finally {
              _iterator126.f();
            }

            this._clearConversionApi();
          }
        }, {
          key: "reconvertElement",
          value: function reconvertElement(t, e) {
            var n = Wa._createOn(t);

            this.conversionApi.writer = e, this.conversionApi.consumable = this._createInsertConsumable(n);
            var i = this.conversionApi.mapper,
                o = i.toViewElement(t);
            e.remove(o), this._convertInsertWithAttributes({
              item: t,
              range: n
            });
            var r = i.toViewElement(t);

            var _iterator127 = _createForOfIteratorHelper(Wa._createIn(t)),
                _step127;

            try {
              for (_iterator127.s(); !(_step127 = _iterator127.n()).done;) {
                var _n86 = _step127.value;

                var _t95 = _n86.item,
                    _o36 = Ja(_t95, i);

                _o36 ? _o36.root !== r.root && e.move(e.createRangeOn(_o36), i.toViewPosition(Va._createBefore(_t95))) : this._convertInsertWithAttributes(Za(_n86));
              }
            } catch (err) {
              _iterator127.e(err);
            } finally {
              _iterator127.f();
            }

            i.unbindViewElement(o), this._clearConversionApi();
          }
        }, {
          key: "convertSelection",
          value: function convertSelection(t, e, n) {
            var i = Array.from(e.getMarkersAtPosition(t.getFirstPosition()));

            if (this.conversionApi.writer = n, this.conversionApi.consumable = this._createSelectionConsumable(t, i), this.fire("selection", {
              selection: t
            }, this.conversionApi), t.isCollapsed) {
              var _iterator128 = _createForOfIteratorHelper(i),
                  _step128;

              try {
                for (_iterator128.s(); !(_step128 = _iterator128.n()).done;) {
                  var _e98 = _step128.value;

                  var _n87 = _e98.getRange();

                  if (!Qa(t.getFirstPosition(), _e98, this.conversionApi.mapper)) continue;
                  var _i67 = {
                    item: t,
                    markerName: _e98.name,
                    markerRange: _n87
                  };
                  this.conversionApi.consumable.test(t, "addMarker:" + _e98.name) && this.fire("addMarker:" + _e98.name, _i67, this.conversionApi);
                }
              } catch (err) {
                _iterator128.e(err);
              } finally {
                _iterator128.f();
              }

              var _iterator129 = _createForOfIteratorHelper(t.getAttributeKeys()),
                  _step129;

              try {
                for (_iterator129.s(); !(_step129 = _iterator129.n()).done;) {
                  var _e99 = _step129.value;
                  var _n88 = {
                    item: t,
                    range: t.getFirstRange(),
                    attributeKey: _e99,
                    attributeOldValue: null,
                    attributeNewValue: t.getAttribute(_e99)
                  };
                  this.conversionApi.consumable.test(t, "attribute:" + _n88.attributeKey) && this.fire("attribute:" + _n88.attributeKey + ":$text", _n88, this.conversionApi);
                }
              } catch (err) {
                _iterator129.e(err);
              } finally {
                _iterator129.f();
              }

              this._clearConversionApi();
            } else this._clearConversionApi();
          }
        }, {
          key: "convertMarkerAdd",
          value: function convertMarkerAdd(t, e, n) {
            if ("$graveyard" == e.root.rootName) return;
            this.conversionApi.writer = n;
            var i = "addMarker:" + t,
                o = new $a();

            if (o.add(e, i), this.conversionApi.consumable = o, this.fire(i, {
              markerName: t,
              markerRange: e
            }, this.conversionApi), o.test(e, i)) {
              this.conversionApi.consumable = this._createConsumableForRange(e, i);

              var _iterator130 = _createForOfIteratorHelper(e.getItems()),
                  _step130;

              try {
                for (_iterator130.s(); !(_step130 = _iterator130.n()).done;) {
                  var _n89 = _step130.value;
                  if (!this.conversionApi.consumable.test(_n89, i)) continue;
                  var _o37 = {
                    item: _n89,
                    range: Wa._createOn(_n89),
                    markerName: t,
                    markerRange: e
                  };
                  this.fire(i, _o37, this.conversionApi);
                }
              } catch (err) {
                _iterator130.e(err);
              } finally {
                _iterator130.f();
              }

              this._clearConversionApi();
            } else this._clearConversionApi();
          }
        }, {
          key: "convertMarkerRemove",
          value: function convertMarkerRemove(t, e, n) {
            "$graveyard" != e.root.rootName && (this.conversionApi.writer = n, this.fire("removeMarker:" + t, {
              markerName: t,
              markerRange: e
            }, this.conversionApi), this._clearConversionApi());
          }
        }, {
          key: "_mapReconversionTriggerEvent",
          value: function _mapReconversionTriggerEvent(t, e) {
            this._reconversionEventsMapping.set(e, t);
          }
        }, {
          key: "_createInsertConsumable",
          value: function _createInsertConsumable(t) {
            var e = new $a();

            var _iterator131 = _createForOfIteratorHelper(t),
                _step131;

            try {
              for (_iterator131.s(); !(_step131 = _iterator131.n()).done;) {
                var _n90 = _step131.value;
                var _t96 = _n90.item;
                e.add(_t96, "insert");

                var _iterator132 = _createForOfIteratorHelper(_t96.getAttributeKeys()),
                    _step132;

                try {
                  for (_iterator132.s(); !(_step132 = _iterator132.n()).done;) {
                    var _n91 = _step132.value;
                    e.add(_t96, "attribute:" + _n91);
                  }
                } catch (err) {
                  _iterator132.e(err);
                } finally {
                  _iterator132.f();
                }
              }
            } catch (err) {
              _iterator131.e(err);
            } finally {
              _iterator131.f();
            }

            return e;
          }
        }, {
          key: "_createConsumableForRange",
          value: function _createConsumableForRange(t, e) {
            var n = new $a();

            var _iterator133 = _createForOfIteratorHelper(t.getItems()),
                _step133;

            try {
              for (_iterator133.s(); !(_step133 = _iterator133.n()).done;) {
                var _i68 = _step133.value;
                n.add(_i68, e);
              }
            } catch (err) {
              _iterator133.e(err);
            } finally {
              _iterator133.f();
            }

            return n;
          }
        }, {
          key: "_createSelectionConsumable",
          value: function _createSelectionConsumable(t, e) {
            var n = new $a();
            n.add(t, "selection");

            var _iterator134 = _createForOfIteratorHelper(e),
                _step134;

            try {
              for (_iterator134.s(); !(_step134 = _iterator134.n()).done;) {
                var _i69 = _step134.value;
                n.add(t, "addMarker:" + _i69.name);
              }
            } catch (err) {
              _iterator134.e(err);
            } finally {
              _iterator134.f();
            }

            var _iterator135 = _createForOfIteratorHelper(t.getAttributeKeys()),
                _step135;

            try {
              for (_iterator135.s(); !(_step135 = _iterator135.n()).done;) {
                var _e100 = _step135.value;
                n.add(t, "attribute:" + _e100);
              }
            } catch (err) {
              _iterator135.e(err);
            } finally {
              _iterator135.f();
            }

            return n;
          }
        }, {
          key: "_testAndFire",
          value: function _testAndFire(t, e) {
            this.conversionApi.consumable.test(e.item, t) && this.fire(function (t, e) {
              var n = e.item.name || "$text";
              return "".concat(t, ":").concat(n);
            }(t, e), e, this.conversionApi);
          }
        }, {
          key: "_clearConversionApi",
          value: function _clearConversionApi() {
            delete this.conversionApi.writer, delete this.conversionApi.consumable;
          }
        }, {
          key: "_convertInsertWithAttributes",
          value: function _convertInsertWithAttributes(t) {
            this._testAndFire("insert", t);

            var _iterator136 = _createForOfIteratorHelper(t.item.getAttributeKeys()),
                _step136;

            try {
              for (_iterator136.s(); !(_step136 = _iterator136.n()).done;) {
                var _e101 = _step136.value;
                t.attributeKey = _e101, t.attributeOldValue = null, t.attributeNewValue = t.item.getAttribute(_e101), this._testAndFire("attribute:".concat(_e101), t);
              }
            } catch (err) {
              _iterator136.e(err);
            } finally {
              _iterator136.f();
            }
          }
        }, {
          key: "_mapChangesWithAutomaticReconversion",
          value: function _mapChangesWithAutomaticReconversion(t) {
            var e = new Set(),
                n = [];

            var _iterator137 = _createForOfIteratorHelper(t.getChanges()),
                _step137;

            try {
              for (_iterator137.s(); !(_step137 = _iterator137.n()).done;) {
                var _i70 = _step137.value;

                var _t97 = _i70.position || _i70.range.start,
                    _o38 = _t97.parent;

                if (Ua(_t97, _o38)) {
                  n.push(_i70);
                  continue;
                }

                var _r19 = "attribute" === _i70.type ? Ha(_t97, _o38, null) : _o38;

                if (_r19.is("$text")) {
                  n.push(_i70);
                  continue;
                }

                var _s14 = void 0;

                if (_s14 = "attribute" === _i70.type ? "attribute:".concat(_i70.attributeKey, ":").concat(_r19.name) : "".concat(_i70.type, ":").concat(_i70.name), this._isReconvertTriggerEvent(_s14, _r19.name)) {
                  if (e.has(_r19)) continue;
                  e.add(_r19), n.push({
                    type: "reconvert",
                    element: _r19
                  });
                } else n.push(_i70);
              }
            } catch (err) {
              _iterator137.e(err);
            } finally {
              _iterator137.f();
            }

            return n;
          }
        }, {
          key: "_isReconvertTriggerEvent",
          value: function _isReconvertTriggerEvent(t, e) {
            return this._reconversionEventsMapping.get(t) === e;
          }
        }]);

        return Ka;
      }();

      function Qa(t, e, n) {
        var i = e.getRange(),
            o = Array.from(t.getAncestors());
        o.shift(), o.reverse();
        return !o.some(function (t) {
          if (i.containsItem(t)) {
            return !!n.toViewElement(t).getCustomProperty("addHighlight");
          }
        });
      }

      function Za(t) {
        return {
          item: t.item,
          range: Wa._createFromPositionAndShift(t.previousPosition, t.length)
        };
      }

      function Ja(t, e) {
        if (t.is("textProxy")) {
          var _n92 = e.toViewPosition(Va._createBefore(t)).parent;
          return _n92.is("$text") ? _n92 : null;
        }

        return e.toViewElement(t);
      }

      he(Ka, f);

      var Xa = /*#__PURE__*/function () {
        function Xa(t, e, n) {
          _classCallCheck(this, Xa);

          this._lastRangeBackward = !1, this._ranges = [], this._attrs = new Map(), t && this.setTo(t, e, n);
        }

        _createClass(Xa, [{
          key: "anchor",
          get: function get() {
            if (this._ranges.length > 0) {
              var _t98 = this._ranges[this._ranges.length - 1];
              return this._lastRangeBackward ? _t98.end : _t98.start;
            }

            return null;
          }
        }, {
          key: "focus",
          get: function get() {
            if (this._ranges.length > 0) {
              var _t99 = this._ranges[this._ranges.length - 1];
              return this._lastRangeBackward ? _t99.start : _t99.end;
            }

            return null;
          }
        }, {
          key: "isCollapsed",
          get: function get() {
            return 1 === this._ranges.length && this._ranges[0].isCollapsed;
          }
        }, {
          key: "rangeCount",
          get: function get() {
            return this._ranges.length;
          }
        }, {
          key: "isBackward",
          get: function get() {
            return !this.isCollapsed && this._lastRangeBackward;
          }
        }, {
          key: "isEqual",
          value: function isEqual(t) {
            if (this.rangeCount != t.rangeCount) return !1;
            if (0 === this.rangeCount) return !0;
            if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) return !1;

            var _iterator138 = _createForOfIteratorHelper(this._ranges),
                _step138;

            try {
              for (_iterator138.s(); !(_step138 = _iterator138.n()).done;) {
                var _e102 = _step138.value;

                var _n93 = !1;

                var _iterator139 = _createForOfIteratorHelper(t._ranges),
                    _step139;

                try {
                  for (_iterator139.s(); !(_step139 = _iterator139.n()).done;) {
                    var _i71 = _step139.value;

                    if (_e102.isEqual(_i71)) {
                      _n93 = !0;
                      break;
                    }
                  }
                } catch (err) {
                  _iterator139.e(err);
                } finally {
                  _iterator139.f();
                }

                if (!_n93) return !1;
              }
            } catch (err) {
              _iterator138.e(err);
            } finally {
              _iterator138.f();
            }

            return !0;
          }
        }, {
          key: "getRanges",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function getRanges() {
            var _iterator140, _step140, _t100;

            return _regeneratorRuntime.wrap(function getRanges$(_context16) {
              while (1) {
                switch (_context16.prev = _context16.next) {
                  case 0:
                    _iterator140 = _createForOfIteratorHelper(this._ranges);
                    _context16.prev = 1;

                    _iterator140.s();

                  case 3:
                    if ((_step140 = _iterator140.n()).done) {
                      _context16.next = 9;
                      break;
                    }

                    _t100 = _step140.value;
                    _context16.next = 7;
                    return new Wa(_t100.start, _t100.end);

                  case 7:
                    _context16.next = 3;
                    break;

                  case 9:
                    _context16.next = 14;
                    break;

                  case 11:
                    _context16.prev = 11;
                    _context16.t0 = _context16["catch"](1);

                    _iterator140.e(_context16.t0);

                  case 14:
                    _context16.prev = 14;

                    _iterator140.f();

                    return _context16.finish(14);

                  case 17:
                  case "end":
                    return _context16.stop();
                }
              }
            }, getRanges, this, [[1, 11, 14, 17]]);
          })
        }, {
          key: "getFirstRange",
          value: function getFirstRange() {
            var t = null;

            var _iterator141 = _createForOfIteratorHelper(this._ranges),
                _step141;

            try {
              for (_iterator141.s(); !(_step141 = _iterator141.n()).done;) {
                var _e103 = _step141.value;
                t && !_e103.start.isBefore(t.start) || (t = _e103);
              }
            } catch (err) {
              _iterator141.e(err);
            } finally {
              _iterator141.f();
            }

            return t ? new Wa(t.start, t.end) : null;
          }
        }, {
          key: "getLastRange",
          value: function getLastRange() {
            var t = null;

            var _iterator142 = _createForOfIteratorHelper(this._ranges),
                _step142;

            try {
              for (_iterator142.s(); !(_step142 = _iterator142.n()).done;) {
                var _e104 = _step142.value;
                t && !_e104.end.isAfter(t.end) || (t = _e104);
              }
            } catch (err) {
              _iterator142.e(err);
            } finally {
              _iterator142.f();
            }

            return t ? new Wa(t.start, t.end) : null;
          }
        }, {
          key: "getFirstPosition",
          value: function getFirstPosition() {
            var t = this.getFirstRange();
            return t ? t.start.clone() : null;
          }
        }, {
          key: "getLastPosition",
          value: function getLastPosition() {
            var t = this.getLastRange();
            return t ? t.end.clone() : null;
          }
        }, {
          key: "setTo",
          value: function setTo(t, e, n) {
            if (null === t) this._setRanges([]);else if (t instanceof Xa) this._setRanges(t.getRanges(), t.isBackward);else if (t && "function" == typeof t.getRanges) this._setRanges(t.getRanges(), t.isBackward);else if (t instanceof Wa) this._setRanges([t], !!e && !!e.backward);else if (t instanceof Va) this._setRanges([new Wa(t)]);else if (t instanceof za) {
              var _i72 = !!n && !!n.backward;

              var _o39;

              if ("in" == e) _o39 = Wa._createIn(t);else if ("on" == e) _o39 = Wa._createOn(t);else {
                if (void 0 === e) throw new a("model-selection-setto-required-second-parameter", [this, t]);
                _o39 = new Wa(Va._createAt(t, e));
              }

              this._setRanges([_o39], _i72);
            } else {
              if (!Ei(t)) throw new a("model-selection-setto-not-selectable", [this, t]);

              this._setRanges(t, e && !!e.backward);
            }
          }
        }, {
          key: "_setRanges",
          value: function _setRanges(t) {
            var _this54 = this;

            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            var n = (t = Array.from(t)).some(function (e) {
              if (!(e instanceof Wa)) throw new a("model-selection-set-ranges-not-range", [_this54, t]);
              return _this54._ranges.every(function (t) {
                return !t.isEqual(e);
              });
            });

            if (t.length !== this._ranges.length || n) {
              this._removeAllRanges();

              var _iterator143 = _createForOfIteratorHelper(t),
                  _step143;

              try {
                for (_iterator143.s(); !(_step143 = _iterator143.n()).done;) {
                  var _e105 = _step143.value;

                  this._pushRange(_e105);
                }
              } catch (err) {
                _iterator143.e(err);
              } finally {
                _iterator143.f();
              }

              this._lastRangeBackward = !!e, this.fire("change:range", {
                directChange: !0
              });
            }
          }
        }, {
          key: "setFocus",
          value: function setFocus(t, e) {
            if (null === this.anchor) throw new a("model-selection-setfocus-no-ranges", [this, t]);

            var n = Va._createAt(t, e);

            if ("same" == n.compareWith(this.focus)) return;
            var i = this.anchor;
            this._ranges.length && this._popRange(), "before" == n.compareWith(i) ? (this._pushRange(new Wa(n, i)), this._lastRangeBackward = !0) : (this._pushRange(new Wa(i, n)), this._lastRangeBackward = !1), this.fire("change:range", {
              directChange: !0
            });
          }
        }, {
          key: "getAttribute",
          value: function getAttribute(t) {
            return this._attrs.get(t);
          }
        }, {
          key: "getAttributes",
          value: function getAttributes() {
            return this._attrs.entries();
          }
        }, {
          key: "getAttributeKeys",
          value: function getAttributeKeys() {
            return this._attrs.keys();
          }
        }, {
          key: "hasAttribute",
          value: function hasAttribute(t) {
            return this._attrs.has(t);
          }
        }, {
          key: "removeAttribute",
          value: function removeAttribute(t) {
            this.hasAttribute(t) && (this._attrs.delete(t), this.fire("change:attribute", {
              attributeKeys: [t],
              directChange: !0
            }));
          }
        }, {
          key: "setAttribute",
          value: function setAttribute(t, e) {
            this.getAttribute(t) !== e && (this._attrs.set(t, e), this.fire("change:attribute", {
              attributeKeys: [t],
              directChange: !0
            }));
          }
        }, {
          key: "getSelectedElement",
          value: function getSelectedElement() {
            return 1 !== this.rangeCount ? null : this.getFirstRange().getContainedElement();
          }
        }, {
          key: "is",
          value: function is(t) {
            return "selection" === t || "model:selection" === t;
          }
        }, {
          key: "getSelectedBlocks",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function getSelectedBlocks() {
            var t, _iterator144, _step144, _e106, _n94, _iterator145, _step145, _n95, _i74, _i73;

            return _regeneratorRuntime.wrap(function getSelectedBlocks$(_context17) {
              while (1) {
                switch (_context17.prev = _context17.next) {
                  case 0:
                    t = new WeakSet();
                    _iterator144 = _createForOfIteratorHelper(this.getRanges());
                    _context17.prev = 2;

                    _iterator144.s();

                  case 4:
                    if ((_step144 = _iterator144.n()).done) {
                      _context17.next = 38;
                      break;
                    }

                    _e106 = _step144.value;
                    _n94 = nc(_e106.start, t);
                    _context17.t0 = _n94 && ic(_n94, _e106);

                    if (!_context17.t0) {
                      _context17.next = 11;
                      break;
                    }

                    _context17.next = 11;
                    return _n94;

                  case 11:
                    _iterator145 = _createForOfIteratorHelper(_e106.getWalker());
                    _context17.prev = 12;

                    _iterator145.s();

                  case 14:
                    if ((_step145 = _iterator145.n()).done) {
                      _context17.next = 23;
                      break;
                    }

                    _n95 = _step145.value;
                    _i74 = _n95.item;
                    _context17.t1 = "elementEnd" == _n95.type && ec(_i74, t, _e106);

                    if (!_context17.t1) {
                      _context17.next = 21;
                      break;
                    }

                    _context17.next = 21;
                    return _i74;

                  case 21:
                    _context17.next = 14;
                    break;

                  case 23:
                    _context17.next = 28;
                    break;

                  case 25:
                    _context17.prev = 25;
                    _context17.t2 = _context17["catch"](12);

                    _iterator145.e(_context17.t2);

                  case 28:
                    _context17.prev = 28;

                    _iterator145.f();

                    return _context17.finish(28);

                  case 31:
                    _i73 = nc(_e106.end, t);
                    _context17.t3 = _i73 && !_e106.end.isTouching(Va._createAt(_i73, 0)) && ic(_i73, _e106);

                    if (!_context17.t3) {
                      _context17.next = 36;
                      break;
                    }

                    _context17.next = 36;
                    return _i73;

                  case 36:
                    _context17.next = 4;
                    break;

                  case 38:
                    _context17.next = 43;
                    break;

                  case 40:
                    _context17.prev = 40;
                    _context17.t4 = _context17["catch"](2);

                    _iterator144.e(_context17.t4);

                  case 43:
                    _context17.prev = 43;

                    _iterator144.f();

                    return _context17.finish(43);

                  case 46:
                  case "end":
                    return _context17.stop();
                }
              }
            }, getSelectedBlocks, this, [[2, 40, 43, 46], [12, 25, 28, 31]]);
          })
        }, {
          key: "containsEntireContent",
          value: function containsEntireContent() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.anchor.root;

            var e = Va._createAt(t, 0),
                n = Va._createAt(t, "end");

            return e.isTouching(this.getFirstPosition()) && n.isTouching(this.getLastPosition());
          }
        }, {
          key: "_pushRange",
          value: function _pushRange(t) {
            this._checkRange(t), this._ranges.push(new Wa(t.start, t.end));
          }
        }, {
          key: "_checkRange",
          value: function _checkRange(t) {
            for (var _e107 = 0; _e107 < this._ranges.length; _e107++) {
              if (t.isIntersecting(this._ranges[_e107])) throw new a("model-selection-range-intersects", [this, t], {
                addedRange: t,
                intersectingRange: this._ranges[_e107]
              });
            }
          }
        }, {
          key: "_removeAllRanges",
          value: function _removeAllRanges() {
            for (; this._ranges.length > 0;) {
              this._popRange();
            }
          }
        }, {
          key: "_popRange",
          value: function _popRange() {
            this._ranges.pop();
          }
        }]);

        return Xa;
      }();

      function tc(t, e) {
        return !e.has(t) && (e.add(t), t.root.document.model.schema.isBlock(t) && t.parent);
      }

      function ec(t, e, n) {
        return tc(t, e) && ic(t, n);
      }

      function nc(t, e) {
        var n = t.parent.root.document.model.schema,
            i = t.parent.getAncestors({
          parentFirst: !0,
          includeSelf: !0
        });
        var o = !1;
        var r = i.find(function (t) {
          return !o && (o = n.isLimit(t), !o && tc(t, e));
        });
        return i.forEach(function (t) {
          return e.add(t);
        }), r;
      }

      function ic(t, e) {
        var n = function (t) {
          var e = t.root.document.model.schema;
          var n = t.parent;

          for (; n;) {
            if (e.isBlock(n)) return n;
            n = n.parent;
          }
        }(t);

        if (!n) return !0;
        return !e.containsRange(Wa._createOn(n), !0);
      }

      he(Xa, f);

      var oc = /*#__PURE__*/function (_Wa) {
        _inherits(oc, _Wa);

        var _super24 = _createSuper(oc);

        function oc(t, e) {
          var _this55;

          _classCallCheck(this, oc);

          _this55 = _super24.call(this, t, e), rc.call(_assertThisInitialized(_this55));
          return _this55;
        }

        _createClass(oc, [{
          key: "detach",
          value: function detach() {
            this.stopListening();
          }
        }, {
          key: "is",
          value: function is(t) {
            return "liveRange" === t || "model:liveRange" === t || "range" == t || "model:range" === t;
          }
        }, {
          key: "toRange",
          value: function toRange() {
            return new Wa(this.start, this.end);
          }
        }], [{
          key: "fromRange",
          value: function fromRange(t) {
            return new oc(t.start, t.end);
          }
        }]);

        return oc;
      }(Wa);

      function rc() {
        var _this56 = this;

        this.listenTo(this.root.document.model, "applyOperation", function (t, e) {
          var n = e[0];
          n.isDocumentOperation && sc.call(_this56, n);
        }, {
          priority: "low"
        });
      }

      function sc(t) {
        var e = this.getTransformedByOperation(t),
            n = Wa._createFromRanges(e),
            i = !n.isEqual(this),
            o = function (t, e) {
          switch (e.type) {
            case "insert":
              return t.containsPosition(e.position);

            case "move":
            case "remove":
            case "reinsert":
            case "merge":
              return t.containsPosition(e.sourcePosition) || t.start.isEqual(e.sourcePosition) || t.containsPosition(e.targetPosition);

            case "split":
              return t.containsPosition(e.splitPosition) || t.containsPosition(e.insertionPosition);
          }

          return !1;
        }(this, t);

        var r = null;

        if (i) {
          "$graveyard" == n.root.rootName && (r = "remove" == t.type ? t.sourcePosition : t.deletionPosition);

          var _e108 = this.toRange();

          this.start = n.start, this.end = n.end, this.fire("change:range", _e108, {
            deletionPosition: r
          });
        } else o && this.fire("change:content", this.toRange(), {
          deletionPosition: r
        });
      }

      he(oc, f);
      var ac = "selection:";

      var cc = /*#__PURE__*/function () {
        function cc(t) {
          _classCallCheck(this, cc);

          this._selection = new lc(t), this._selection.delegate("change:range").to(this), this._selection.delegate("change:attribute").to(this), this._selection.delegate("change:marker").to(this);
        }

        _createClass(cc, [{
          key: "isCollapsed",
          get: function get() {
            return this._selection.isCollapsed;
          }
        }, {
          key: "anchor",
          get: function get() {
            return this._selection.anchor;
          }
        }, {
          key: "focus",
          get: function get() {
            return this._selection.focus;
          }
        }, {
          key: "rangeCount",
          get: function get() {
            return this._selection.rangeCount;
          }
        }, {
          key: "hasOwnRange",
          get: function get() {
            return this._selection.hasOwnRange;
          }
        }, {
          key: "isBackward",
          get: function get() {
            return this._selection.isBackward;
          }
        }, {
          key: "isGravityOverridden",
          get: function get() {
            return this._selection.isGravityOverridden;
          }
        }, {
          key: "markers",
          get: function get() {
            return this._selection.markers;
          }
        }, {
          key: "_ranges",
          get: function get() {
            return this._selection._ranges;
          }
        }, {
          key: "getRanges",
          value: function getRanges() {
            return this._selection.getRanges();
          }
        }, {
          key: "getFirstPosition",
          value: function getFirstPosition() {
            return this._selection.getFirstPosition();
          }
        }, {
          key: "getLastPosition",
          value: function getLastPosition() {
            return this._selection.getLastPosition();
          }
        }, {
          key: "getFirstRange",
          value: function getFirstRange() {
            return this._selection.getFirstRange();
          }
        }, {
          key: "getLastRange",
          value: function getLastRange() {
            return this._selection.getLastRange();
          }
        }, {
          key: "getSelectedBlocks",
          value: function getSelectedBlocks() {
            return this._selection.getSelectedBlocks();
          }
        }, {
          key: "getSelectedElement",
          value: function getSelectedElement() {
            return this._selection.getSelectedElement();
          }
        }, {
          key: "containsEntireContent",
          value: function containsEntireContent(t) {
            return this._selection.containsEntireContent(t);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this._selection.destroy();
          }
        }, {
          key: "getAttributeKeys",
          value: function getAttributeKeys() {
            return this._selection.getAttributeKeys();
          }
        }, {
          key: "getAttributes",
          value: function getAttributes() {
            return this._selection.getAttributes();
          }
        }, {
          key: "getAttribute",
          value: function getAttribute(t) {
            return this._selection.getAttribute(t);
          }
        }, {
          key: "hasAttribute",
          value: function hasAttribute(t) {
            return this._selection.hasAttribute(t);
          }
        }, {
          key: "refresh",
          value: function refresh() {
            this._selection._updateMarkers(), this._selection._updateAttributes(!1);
          }
        }, {
          key: "observeMarkers",
          value: function observeMarkers(t) {
            this._selection.observeMarkers(t);
          }
        }, {
          key: "is",
          value: function is(t) {
            return "selection" === t || "model:selection" == t || "documentSelection" == t || "model:documentSelection" == t;
          }
        }, {
          key: "_setFocus",
          value: function _setFocus(t, e) {
            this._selection.setFocus(t, e);
          }
        }, {
          key: "_setTo",
          value: function _setTo(t, e, n) {
            this._selection.setTo(t, e, n);
          }
        }, {
          key: "_setAttribute",
          value: function _setAttribute(t, e) {
            this._selection.setAttribute(t, e);
          }
        }, {
          key: "_removeAttribute",
          value: function _removeAttribute(t) {
            this._selection.removeAttribute(t);
          }
        }, {
          key: "_getStoredAttributes",
          value: function _getStoredAttributes() {
            return this._selection._getStoredAttributes();
          }
        }, {
          key: "_overrideGravity",
          value: function _overrideGravity() {
            return this._selection.overrideGravity();
          }
        }, {
          key: "_restoreGravity",
          value: function _restoreGravity(t) {
            this._selection.restoreGravity(t);
          }
        }], [{
          key: "_getStoreAttributeKey",
          value: function _getStoreAttributeKey(t) {
            return ac + t;
          }
        }, {
          key: "_isStoreAttributeKey",
          value: function _isStoreAttributeKey(t) {
            return t.startsWith(ac);
          }
        }]);

        return cc;
      }();

      he(cc, f);

      var lc = /*#__PURE__*/function (_Xa) {
        _inherits(lc, _Xa);

        var _super25 = _createSuper(lc);

        function lc(t) {
          var _this57;

          _classCallCheck(this, lc);

          _this57 = _super25.call(this), _this57.markers = new Di({
            idProperty: "name"
          }), _this57._model = t.model, _this57._document = t, _this57._attributePriority = new Map(), _this57._selectionRestorePosition = null, _this57._hasChangedRange = !1, _this57._overriddenGravityRegister = new Set(), _this57._observedMarkers = new Set(), _this57.listenTo(_this57._model, "applyOperation", function (t, e) {
            var n = e[0];
            n.isDocumentOperation && "marker" != n.type && "rename" != n.type && "noop" != n.type && (0 == _this57._ranges.length && _this57._selectionRestorePosition && _this57._fixGraveyardSelection(_this57._selectionRestorePosition), _this57._selectionRestorePosition = null, _this57._hasChangedRange && (_this57._hasChangedRange = !1, _this57.fire("change:range", {
              directChange: !1
            })));
          }, {
            priority: "lowest"
          }), _this57.on("change:range", function () {
            var _iterator146 = _createForOfIteratorHelper(_this57.getRanges()),
                _step146;

            try {
              for (_iterator146.s(); !(_step146 = _iterator146.n()).done;) {
                var _t101 = _step146.value;
                if (!_this57._document._validateSelectionRange(_t101)) throw new a("document-selection-wrong-position", _assertThisInitialized(_this57), {
                  range: _t101
                });
              }
            } catch (err) {
              _iterator146.e(err);
            } finally {
              _iterator146.f();
            }
          }), _this57.listenTo(_this57._model.markers, "update", function (t, e, n, i) {
            _this57._updateMarker(e, i);
          }), _this57.listenTo(_this57._document, "change", function (t, e) {
            !function (t, e) {
              var n = t.document.differ;

              var _iterator147 = _createForOfIteratorHelper(n.getChanges()),
                  _step147;

              try {
                var _loop2 = function _loop2() {
                  var i = _step147.value;
                  if ("insert" != i.type) return "continue";
                  var n = i.position.parent;
                  i.length === n.maxOffset && t.enqueueChange(e, function (t) {
                    var e = Array.from(n.getAttributeKeys()).filter(function (t) {
                      return t.startsWith(ac);
                    });

                    var _iterator148 = _createForOfIteratorHelper(e),
                        _step148;

                    try {
                      for (_iterator148.s(); !(_step148 = _iterator148.n()).done;) {
                        var _i75 = _step148.value;
                        t.removeAttribute(_i75, n);
                      }
                    } catch (err) {
                      _iterator148.e(err);
                    } finally {
                      _iterator148.f();
                    }
                  });
                };

                for (_iterator147.s(); !(_step147 = _iterator147.n()).done;) {
                  var _ret = _loop2();

                  if (_ret === "continue") continue;
                }
              } catch (err) {
                _iterator147.e(err);
              } finally {
                _iterator147.f();
              }
            }(_this57._model, e);
          });
          return _this57;
        }

        _createClass(lc, [{
          key: "isCollapsed",
          get: function get() {
            return 0 === this._ranges.length ? this._document._getDefaultRange().isCollapsed : _get(_getPrototypeOf(lc.prototype), "isCollapsed", this);
          }
        }, {
          key: "anchor",
          get: function get() {
            return _get(_getPrototypeOf(lc.prototype), "anchor", this) || this._document._getDefaultRange().start;
          }
        }, {
          key: "focus",
          get: function get() {
            return _get(_getPrototypeOf(lc.prototype), "focus", this) || this._document._getDefaultRange().end;
          }
        }, {
          key: "rangeCount",
          get: function get() {
            return this._ranges.length ? this._ranges.length : 1;
          }
        }, {
          key: "hasOwnRange",
          get: function get() {
            return this._ranges.length > 0;
          }
        }, {
          key: "isGravityOverridden",
          get: function get() {
            return !!this._overriddenGravityRegister.size;
          }
        }, {
          key: "destroy",
          value: function destroy() {
            for (var _t102 = 0; _t102 < this._ranges.length; _t102++) {
              this._ranges[_t102].detach();
            }

            this.stopListening();
          }
        }, {
          key: "getRanges",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function getRanges() {
            return _regeneratorRuntime.wrap(function getRanges$(_context18) {
              while (1) {
                switch (_context18.prev = _context18.next) {
                  case 0:
                    if (!this._ranges.length) {
                      _context18.next = 4;
                      break;
                    }

                    return _context18.delegateYield(_get(_getPrototypeOf(lc.prototype), "getRanges", this).call(this), "t0", 2);

                  case 2:
                    _context18.next = 6;
                    break;

                  case 4:
                    _context18.next = 6;
                    return this._document._getDefaultRange();

                  case 6:
                  case "end":
                    return _context18.stop();
                }
              }
            }, getRanges, this);
          })
        }, {
          key: "getFirstRange",
          value: function getFirstRange() {
            return _get(_getPrototypeOf(lc.prototype), "getFirstRange", this).call(this) || this._document._getDefaultRange();
          }
        }, {
          key: "getLastRange",
          value: function getLastRange() {
            return _get(_getPrototypeOf(lc.prototype), "getLastRange", this).call(this) || this._document._getDefaultRange();
          }
        }, {
          key: "setTo",
          value: function setTo(t, e, n) {
            _get(_getPrototypeOf(lc.prototype), "setTo", this).call(this, t, e, n), this._updateAttributes(!0), this._updateMarkers();
          }
        }, {
          key: "setFocus",
          value: function setFocus(t, e) {
            _get(_getPrototypeOf(lc.prototype), "setFocus", this).call(this, t, e), this._updateAttributes(!0), this._updateMarkers();
          }
        }, {
          key: "setAttribute",
          value: function setAttribute(t, e) {
            if (this._setAttribute(t, e)) {
              var _e109 = [t];
              this.fire("change:attribute", {
                attributeKeys: _e109,
                directChange: !0
              });
            }
          }
        }, {
          key: "removeAttribute",
          value: function removeAttribute(t) {
            if (this._removeAttribute(t)) {
              var _e110 = [t];
              this.fire("change:attribute", {
                attributeKeys: _e110,
                directChange: !0
              });
            }
          }
        }, {
          key: "overrideGravity",
          value: function overrideGravity() {
            var t = r();
            return this._overriddenGravityRegister.add(t), 1 === this._overriddenGravityRegister.size && this._updateAttributes(!0), t;
          }
        }, {
          key: "restoreGravity",
          value: function restoreGravity(t) {
            if (!this._overriddenGravityRegister.has(t)) throw new a("document-selection-gravity-wrong-restore", this, {
              uid: t
            });
            this._overriddenGravityRegister.delete(t), this.isGravityOverridden || this._updateAttributes(!0);
          }
        }, {
          key: "observeMarkers",
          value: function observeMarkers(t) {
            this._observedMarkers.add(t), this._updateMarkers();
          }
        }, {
          key: "_popRange",
          value: function _popRange() {
            this._ranges.pop().detach();
          }
        }, {
          key: "_pushRange",
          value: function _pushRange(t) {
            var e = this._prepareRange(t);

            e && this._ranges.push(e);
          }
        }, {
          key: "_prepareRange",
          value: function _prepareRange(t) {
            var _this58 = this;

            if (this._checkRange(t), t.root == this._document.graveyard) return;
            var e = oc.fromRange(t);
            return e.on("change:range", function (t, n, i) {
              if (_this58._hasChangedRange = !0, e.root == _this58._document.graveyard) {
                _this58._selectionRestorePosition = i.deletionPosition;

                var _t103 = _this58._ranges.indexOf(e);

                _this58._ranges.splice(_t103, 1), e.detach();
              }
            }), e;
          }
        }, {
          key: "_updateMarkers",
          value: function _updateMarkers() {
            if (!this._observedMarkers.size) return;
            var t = [];
            var e = !1;

            var _iterator149 = _createForOfIteratorHelper(this._model.markers),
                _step149;

            try {
              for (_iterator149.s(); !(_step149 = _iterator149.n()).done;) {
                var _e111 = _step149.value;

                var _n98 = _e111.name.split(":", 1)[0];

                if (!this._observedMarkers.has(_n98)) continue;

                var _i78 = _e111.getRange();

                var _iterator150 = _createForOfIteratorHelper(this.getRanges()),
                    _step150;

                try {
                  for (_iterator150.s(); !(_step150 = _iterator150.n()).done;) {
                    var _n99 = _step150.value;
                    _i78.containsRange(_n99, !_n99.isCollapsed) && t.push(_e111);
                  }
                } catch (err) {
                  _iterator150.e(err);
                } finally {
                  _iterator150.f();
                }
              }
            } catch (err) {
              _iterator149.e(err);
            } finally {
              _iterator149.f();
            }

            var n = Array.from(this.markers);

            for (var _i76 = 0, _t104 = t; _i76 < _t104.length; _i76++) {
              var _n96 = _t104[_i76];
              this.markers.has(_n96) || (this.markers.add(_n96), e = !0);
            }

            for (var _i77 = 0, _Array$from2 = Array.from(this.markers); _i77 < _Array$from2.length; _i77++) {
              var _n97 = _Array$from2[_i77];
              t.includes(_n97) || (this.markers.remove(_n97), e = !0);
            }

            e && this.fire("change:marker", {
              oldMarkers: n,
              directChange: !1
            });
          }
        }, {
          key: "_updateMarker",
          value: function _updateMarker(t, e) {
            var n = t.name.split(":", 1)[0];
            if (!this._observedMarkers.has(n)) return;
            var i = !1;
            var o = Array.from(this.markers),
                r = this.markers.has(t);

            if (e) {
              var _n100 = !1;

              var _iterator151 = _createForOfIteratorHelper(this.getRanges()),
                  _step151;

              try {
                for (_iterator151.s(); !(_step151 = _iterator151.n()).done;) {
                  var _t105 = _step151.value;

                  if (e.containsRange(_t105, !_t105.isCollapsed)) {
                    _n100 = !0;
                    break;
                  }
                }
              } catch (err) {
                _iterator151.e(err);
              } finally {
                _iterator151.f();
              }

              _n100 && !r ? (this.markers.add(t), i = !0) : !_n100 && r && (this.markers.remove(t), i = !0);
            } else r && (this.markers.remove(t), i = !0);

            i && this.fire("change:marker", {
              oldMarkers: o,
              directChange: !1
            });
          }
        }, {
          key: "_updateAttributes",
          value: function _updateAttributes(t) {
            var e = Vi(this._getSurroundingAttributes()),
                n = Vi(this.getAttributes());
            if (t) this._attributePriority = new Map(), this._attrs = new Map();else {
              var _iterator152 = _createForOfIteratorHelper(this._attributePriority),
                  _step152;

              try {
                for (_iterator152.s(); !(_step152 = _iterator152.n()).done;) {
                  var _step152$value = _slicedToArray(_step152.value, 2),
                      _t106 = _step152$value[0],
                      _e112 = _step152$value[1];

                  "low" == _e112 && (this._attrs.delete(_t106), this._attributePriority.delete(_t106));
                }
              } catch (err) {
                _iterator152.e(err);
              } finally {
                _iterator152.f();
              }
            }

            this._setAttributesTo(e);

            var i = [];

            var _iterator153 = _createForOfIteratorHelper(this.getAttributes()),
                _step153;

            try {
              for (_iterator153.s(); !(_step153 = _iterator153.n()).done;) {
                var _step153$value = _slicedToArray(_step153.value, 2),
                    _t107 = _step153$value[0],
                    _e113 = _step153$value[1];

                n.has(_t107) && n.get(_t107) === _e113 || i.push(_t107);
              }
            } catch (err) {
              _iterator153.e(err);
            } finally {
              _iterator153.f();
            }

            var _iterator154 = _createForOfIteratorHelper(n),
                _step154;

            try {
              for (_iterator154.s(); !(_step154 = _iterator154.n()).done;) {
                var _step154$value = _slicedToArray(_step154.value, 1),
                    _t108 = _step154$value[0];

                this.hasAttribute(_t108) || i.push(_t108);
              }
            } catch (err) {
              _iterator154.e(err);
            } finally {
              _iterator154.f();
            }

            i.length > 0 && this.fire("change:attribute", {
              attributeKeys: i,
              directChange: !1
            });
          }
        }, {
          key: "_setAttribute",
          value: function _setAttribute(t, e) {
            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
            var i = n ? "normal" : "low";
            if ("low" == i && "normal" == this._attributePriority.get(t)) return !1;
            return _get(_getPrototypeOf(lc.prototype), "getAttribute", this).call(this, t) !== e && (this._attrs.set(t, e), this._attributePriority.set(t, i), !0);
          }
        }, {
          key: "_removeAttribute",
          value: function _removeAttribute(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
            var n = e ? "normal" : "low";
            return ("low" != n || "normal" != this._attributePriority.get(t)) && (this._attributePriority.set(t, n), !!_get(_getPrototypeOf(lc.prototype), "hasAttribute", this).call(this, t) && (this._attrs.delete(t), !0));
          }
        }, {
          key: "_setAttributesTo",
          value: function _setAttributesTo(t) {
            var e = new Set();

            var _iterator155 = _createForOfIteratorHelper(this.getAttributes()),
                _step155;

            try {
              for (_iterator155.s(); !(_step155 = _iterator155.n()).done;) {
                var _step155$value = _slicedToArray(_step155.value, 2),
                    _e114 = _step155$value[0],
                    _n101 = _step155$value[1];

                t.get(_e114) !== _n101 && this._removeAttribute(_e114, !1);
              }
            } catch (err) {
              _iterator155.e(err);
            } finally {
              _iterator155.f();
            }

            var _iterator156 = _createForOfIteratorHelper(t),
                _step156;

            try {
              for (_iterator156.s(); !(_step156 = _iterator156.n()).done;) {
                var _step156$value = _slicedToArray(_step156.value, 2),
                    _n102 = _step156$value[0],
                    _i79 = _step156$value[1];

                this._setAttribute(_n102, _i79, !1) && e.add(_n102);
              }
            } catch (err) {
              _iterator156.e(err);
            } finally {
              _iterator156.f();
            }

            return e;
          }
        }, {
          key: "_getStoredAttributes",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function _getStoredAttributes() {
            var t, _iterator157, _step157, _e115, _n103;

            return _regeneratorRuntime.wrap(function _getStoredAttributes$(_context19) {
              while (1) {
                switch (_context19.prev = _context19.next) {
                  case 0:
                    t = this.getFirstPosition().parent;

                    if (!(this.isCollapsed && t.isEmpty)) {
                      _context19.next = 21;
                      break;
                    }

                    _iterator157 = _createForOfIteratorHelper(t.getAttributeKeys());
                    _context19.prev = 3;

                    _iterator157.s();

                  case 5:
                    if ((_step157 = _iterator157.n()).done) {
                      _context19.next = 13;
                      break;
                    }

                    _e115 = _step157.value;

                    if (!_e115.startsWith(ac)) {
                      _context19.next = 11;
                      break;
                    }

                    _n103 = _e115.substr(ac.length);
                    _context19.next = 11;
                    return [_n103, t.getAttribute(_e115)];

                  case 11:
                    _context19.next = 5;
                    break;

                  case 13:
                    _context19.next = 18;
                    break;

                  case 15:
                    _context19.prev = 15;
                    _context19.t0 = _context19["catch"](3);

                    _iterator157.e(_context19.t0);

                  case 18:
                    _context19.prev = 18;

                    _iterator157.f();

                    return _context19.finish(18);

                  case 21:
                  case "end":
                    return _context19.stop();
                }
              }
            }, _getStoredAttributes, this, [[3, 15, 18, 21]]);
          })
        }, {
          key: "_getSurroundingAttributes",
          value: function _getSurroundingAttributes() {
            var t = this.getFirstPosition(),
                e = this._model.schema;
            var n = null;

            if (this.isCollapsed) {
              var _i80 = t.textNode ? t.textNode : t.nodeBefore,
                  _o40 = t.textNode ? t.textNode : t.nodeAfter;

              if (this.isGravityOverridden || (n = dc(_i80)), n || (n = dc(_o40)), !this.isGravityOverridden && !n) {
                var _t109 = _i80;

                for (; _t109 && !e.isInline(_t109) && !n;) {
                  _t109 = _t109.previousSibling, n = dc(_t109);
                }
              }

              if (!n) {
                var _t110 = _o40;

                for (; _t110 && !e.isInline(_t110) && !n;) {
                  _t110 = _t110.nextSibling, n = dc(_t110);
                }
              }

              n || (n = this._getStoredAttributes());
            } else {
              var _t111 = this.getFirstRange();

              var _iterator158 = _createForOfIteratorHelper(_t111),
                  _step158;

              try {
                for (_iterator158.s(); !(_step158 = _iterator158.n()).done;) {
                  var _i81 = _step158.value;
                  if (_i81.item.is("element") && e.isObject(_i81.item)) break;

                  if ("text" == _i81.type) {
                    n = _i81.item.getAttributes();
                    break;
                  }
                }
              } catch (err) {
                _iterator158.e(err);
              } finally {
                _iterator158.f();
              }
            }

            return n;
          }
        }, {
          key: "_fixGraveyardSelection",
          value: function _fixGraveyardSelection(t) {
            var e = this._model.schema.getNearestSelectionRange(t);

            e && this._pushRange(e);
          }
        }]);

        return lc;
      }(Xa);

      function dc(t) {
        return t instanceof La || t instanceof Pa ? t.getAttributes() : null;
      }

      var hc = /*#__PURE__*/function () {
        function hc(t) {
          _classCallCheck(this, hc);

          this._dispatchers = t;
        }

        _createClass(hc, [{
          key: "add",
          value: function add(t) {
            var _iterator159 = _createForOfIteratorHelper(this._dispatchers),
                _step159;

            try {
              for (_iterator159.s(); !(_step159 = _iterator159.n()).done;) {
                var _e116 = _step159.value;
                t(_e116);
              }
            } catch (err) {
              _iterator159.e(err);
            } finally {
              _iterator159.f();
            }

            return this;
          }
        }]);

        return hc;
      }();

      var uc = function uc(t) {
        return Ai(t, 5);
      };

      var gc = /*#__PURE__*/function (_hc) {
        _inherits(gc, _hc);

        var _super26 = _createSuper(gc);

        function gc() {
          _classCallCheck(this, gc);

          return _super26.apply(this, arguments);
        }

        _createClass(gc, [{
          key: "elementToElement",
          value: function elementToElement(t) {
            return this.add(function (t) {
              return (t = uc(t)).view = fc(t.view, "container"), function (e) {
                var n;

                if (e.on("insert:" + t.model, (n = t.view, function (t, e, i) {
                  var o = n(e.item, i);
                  if (!o) return;
                  if (!i.consumable.consume(e.item, "insert")) return;
                  var r = i.mapper.toViewPosition(e.range.start);
                  i.mapper.bindElements(e.item, o), i.writer.insert(r, o);
                }), {
                  priority: t.converterPriority || "normal"
                }), t.triggerBy) {
                  if (t.triggerBy.attributes) {
                    var _iterator160 = _createForOfIteratorHelper(t.triggerBy.attributes),
                        _step160;

                    try {
                      for (_iterator160.s(); !(_step160 = _iterator160.n()).done;) {
                        var _n104 = _step160.value;

                        e._mapReconversionTriggerEvent(t.model, "attribute:".concat(_n104, ":").concat(t.model));
                      }
                    } catch (err) {
                      _iterator160.e(err);
                    } finally {
                      _iterator160.f();
                    }
                  }

                  if (t.triggerBy.children) {
                    var _iterator161 = _createForOfIteratorHelper(t.triggerBy.children),
                        _step161;

                    try {
                      for (_iterator161.s(); !(_step161 = _iterator161.n()).done;) {
                        var _n105 = _step161.value;
                        e._mapReconversionTriggerEvent(t.model, "insert:".concat(_n105)), e._mapReconversionTriggerEvent(t.model, "remove:".concat(_n105));
                      }
                    } catch (err) {
                      _iterator161.e(err);
                    } finally {
                      _iterator161.f();
                    }
                  }
                }
              };
            }(t));
          }
        }, {
          key: "attributeToElement",
          value: function attributeToElement(t) {
            return this.add(function (t) {
              t = uc(t);
              var e = "attribute:" + (t.model.key ? t.model.key : t.model);
              t.model.name && (e += ":" + t.model.name);

              if (t.model.values) {
                var _iterator162 = _createForOfIteratorHelper(t.model.values),
                    _step162;

                try {
                  for (_iterator162.s(); !(_step162 = _iterator162.n()).done;) {
                    var _e117 = _step162.value;
                    t.view[_e117] = fc(t.view[_e117], "attribute");
                  }
                } catch (err) {
                  _iterator162.e(err);
                } finally {
                  _iterator162.f();
                }
              } else t.view = fc(t.view, "attribute");

              var n = kc(t);
              return function (i) {
                i.on(e, function (t) {
                  return function (e, n, i) {
                    var o = t(n.attributeOldValue, i),
                        r = t(n.attributeNewValue, i);
                    if (!o && !r) return;
                    if (!i.consumable.consume(n.item, e.name)) return;
                    var s = i.writer,
                        a = s.document.selection;
                    if (n.item instanceof Xa || n.item instanceof cc) s.wrap(a.getFirstRange(), r);else {
                      var _t112 = i.mapper.toViewRange(n.range);

                      null !== n.attributeOldValue && o && (_t112 = s.unwrap(_t112, o)), null !== n.attributeNewValue && r && s.wrap(_t112, r);
                    }
                  };
                }(n), {
                  priority: t.converterPriority || "normal"
                });
              };
            }(t));
          }
        }, {
          key: "attributeToAttribute",
          value: function attributeToAttribute(t) {
            return this.add(function (t) {
              t = uc(t);
              var e = "attribute:" + (t.model.key ? t.model.key : t.model);
              t.model.name && (e += ":" + t.model.name);

              if (t.model.values) {
                var _iterator163 = _createForOfIteratorHelper(t.model.values),
                    _step163;

                try {
                  for (_iterator163.s(); !(_step163 = _iterator163.n()).done;) {
                    var _e118 = _step163.value;
                    t.view[_e118] = bc(t.view[_e118]);
                  }
                } catch (err) {
                  _iterator163.e(err);
                } finally {
                  _iterator163.f();
                }
              } else t.view = bc(t.view);

              var n = kc(t);
              return function (i) {
                var o;
                i.on(e, (o = n, function (t, e, n) {
                  var i = o(e.attributeOldValue, n),
                      r = o(e.attributeNewValue, n);
                  if (!i && !r) return;
                  if (!n.consumable.consume(e.item, t.name)) return;
                  var s = n.mapper.toViewElement(e.item),
                      c = n.writer;
                  if (!s) throw new a("conversion-attribute-to-attribute-on-text", [e, n]);
                  if (null !== e.attributeOldValue && i) if ("class" == i.key) {
                    var _t113 = Ii(i.value);

                    var _iterator164 = _createForOfIteratorHelper(_t113),
                        _step164;

                    try {
                      for (_iterator164.s(); !(_step164 = _iterator164.n()).done;) {
                        var _e119 = _step164.value;
                        c.removeClass(_e119, s);
                      }
                    } catch (err) {
                      _iterator164.e(err);
                    } finally {
                      _iterator164.f();
                    }
                  } else if ("style" == i.key) {
                    var _t114 = Object.keys(i.value);

                    for (var _i82 = 0, _t115 = _t114; _i82 < _t115.length; _i82++) {
                      var _e120 = _t115[_i82];
                      c.removeStyle(_e120, s);
                    }
                  } else c.removeAttribute(i.key, s);
                  if (null !== e.attributeNewValue && r) if ("class" == r.key) {
                    var _t116 = Ii(r.value);

                    var _iterator165 = _createForOfIteratorHelper(_t116),
                        _step165;

                    try {
                      for (_iterator165.s(); !(_step165 = _iterator165.n()).done;) {
                        var _e121 = _step165.value;
                        c.addClass(_e121, s);
                      }
                    } catch (err) {
                      _iterator165.e(err);
                    } finally {
                      _iterator165.f();
                    }
                  } else if ("style" == r.key) {
                    var _t117 = Object.keys(r.value);

                    for (var _i83 = 0, _t118 = _t117; _i83 < _t118.length; _i83++) {
                      var _e122 = _t118[_i83];
                      c.setStyle(_e122, r.value[_e122], s);
                    }
                  } else c.setAttribute(r.key, r.value, s);
                }), {
                  priority: t.converterPriority || "normal"
                });
              };
            }(t));
          }
        }, {
          key: "markerToElement",
          value: function markerToElement(t) {
            return this.add(function (t) {
              return (t = uc(t)).view = fc(t.view, "ui"), function (e) {
                var n;
                e.on("addMarker:" + t.model, (n = t.view, function (t, e, i) {
                  e.isOpening = !0;
                  var o = n(e, i);
                  e.isOpening = !1;
                  var r = n(e, i);
                  if (!o || !r) return;
                  var s = e.markerRange;
                  if (s.isCollapsed && !i.consumable.consume(s, t.name)) return;

                  var _iterator166 = _createForOfIteratorHelper(s),
                      _step166;

                  try {
                    for (_iterator166.s(); !(_step166 = _iterator166.n()).done;) {
                      var _e123 = _step166.value;
                      if (!i.consumable.consume(_e123.item, t.name)) return;
                    }
                  } catch (err) {
                    _iterator166.e(err);
                  } finally {
                    _iterator166.f();
                  }

                  var a = i.mapper,
                      c = i.writer;
                  c.insert(a.toViewPosition(s.start), o), i.mapper.bindElementToMarker(o, e.markerName), s.isCollapsed || (c.insert(a.toViewPosition(s.end), r), i.mapper.bindElementToMarker(r, e.markerName)), t.stop();
                }), {
                  priority: t.converterPriority || "normal"
                }), e.on("removeMarker:" + t.model, (t.view, function (t, e, n) {
                  var i = n.mapper.markerNameToElements(e.markerName);

                  if (i) {
                    var _iterator167 = _createForOfIteratorHelper(i),
                        _step167;

                    try {
                      for (_iterator167.s(); !(_step167 = _iterator167.n()).done;) {
                        var _t119 = _step167.value;
                        n.mapper.unbindElementFromMarkerName(_t119, e.markerName), n.writer.clear(n.writer.createRangeOn(_t119), _t119);
                      }
                    } catch (err) {
                      _iterator167.e(err);
                    } finally {
                      _iterator167.f();
                    }

                    n.writer.clearClonedElementsGroup(e.markerName), t.stop();
                  }
                }), {
                  priority: t.converterPriority || "normal"
                });
              };
            }(t));
          }
        }, {
          key: "markerToHighlight",
          value: function markerToHighlight(t) {
            return this.add(function (t) {
              return function (e) {
                var n;
                e.on("addMarker:" + t.model, (n = t.view, function (t, e, i) {
                  if (!e.item) return;
                  if (!(e.item instanceof Xa || e.item instanceof cc || e.item.is("$textProxy"))) return;
                  var o = wc(n, e, i);
                  if (!o) return;
                  if (!i.consumable.consume(e.item, t.name)) return;
                  var r = i.writer,
                      s = mc(r, o),
                      a = r.document.selection;
                  if (e.item instanceof Xa || e.item instanceof cc) r.wrap(a.getFirstRange(), s, a);else {
                    var _t120 = i.mapper.toViewRange(e.range),
                        _n106 = r.wrap(_t120, s);

                    var _iterator168 = _createForOfIteratorHelper(_n106.getItems()),
                        _step168;

                    try {
                      for (_iterator168.s(); !(_step168 = _iterator168.n()).done;) {
                        var _t121 = _step168.value;

                        if (_t121.is("attributeElement") && _t121.isSimilar(s)) {
                          i.mapper.bindElementToMarker(_t121, e.markerName);
                          break;
                        }
                      }
                    } catch (err) {
                      _iterator168.e(err);
                    } finally {
                      _iterator168.f();
                    }
                  }
                }), {
                  priority: t.converterPriority || "normal"
                }), e.on("addMarker:" + t.model, function (t) {
                  return function (e, n, i) {
                    if (!n.item) return;
                    if (!(n.item instanceof Oa)) return;
                    var o = wc(t, n, i);
                    if (!o) return;
                    if (!i.consumable.test(n.item, e.name)) return;
                    var r = i.mapper.toViewElement(n.item);

                    if (r && r.getCustomProperty("addHighlight")) {
                      i.consumable.consume(n.item, e.name);

                      var _iterator169 = _createForOfIteratorHelper(Wa._createIn(n.item)),
                          _step169;

                      try {
                        for (_iterator169.s(); !(_step169 = _iterator169.n()).done;) {
                          var _t122 = _step169.value;
                          i.consumable.consume(_t122.item, e.name);
                        }
                      } catch (err) {
                        _iterator169.e(err);
                      } finally {
                        _iterator169.f();
                      }

                      r.getCustomProperty("addHighlight")(r, o, i.writer), i.mapper.bindElementToMarker(r, n.markerName);
                    }
                  };
                }(t.view), {
                  priority: t.converterPriority || "normal"
                }), e.on("removeMarker:" + t.model, function (t) {
                  return function (e, n, i) {
                    if (n.markerRange.isCollapsed) return;
                    var o = wc(t, n, i);
                    if (!o) return;
                    var r = mc(i.writer, o),
                        s = i.mapper.markerNameToElements(n.markerName);

                    if (s) {
                      var _iterator170 = _createForOfIteratorHelper(s),
                          _step170;

                      try {
                        for (_iterator170.s(); !(_step170 = _iterator170.n()).done;) {
                          var _t123 = _step170.value;
                          i.mapper.unbindElementFromMarkerName(_t123, n.markerName), _t123.is("attributeElement") ? i.writer.unwrap(i.writer.createRangeOn(_t123), r) : _t123.getCustomProperty("removeHighlight")(_t123, o.id, i.writer);
                        }
                      } catch (err) {
                        _iterator170.e(err);
                      } finally {
                        _iterator170.f();
                      }

                      i.writer.clearClonedElementsGroup(n.markerName), e.stop();
                    }
                  };
                }(t.view), {
                  priority: t.converterPriority || "normal"
                });
              };
            }(t));
          }
        }, {
          key: "markerToData",
          value: function markerToData(t) {
            return this.add(function (t) {
              var e = (t = uc(t)).model;
              t.view || (t.view = function (n) {
                return {
                  group: e,
                  name: n.substr(t.model.length + 1)
                };
              });
              return function (n) {
                var i;
                n.on("addMarker:" + e, (i = t.view, function (t, e, n) {
                  var o = i(e.markerName, n);
                  if (!o) return;
                  var r = e.markerRange;
                  n.consumable.consume(r, t.name) && (pc(r, !1, n, e, o), pc(r, !0, n, e, o), t.stop());
                }), {
                  priority: t.converterPriority || "normal"
                }), n.on("removeMarker:" + e, function (t) {
                  return function (e, n, i) {
                    var o = t(n.markerName, i);
                    if (!o) return;
                    var r = i.mapper.markerNameToElements(n.markerName);

                    if (r) {
                      var _iterator171 = _createForOfIteratorHelper(r),
                          _step171;

                      try {
                        for (_iterator171.s(); !(_step171 = _iterator171.n()).done;) {
                          var _t124 = _step171.value;
                          i.mapper.unbindElementFromMarkerName(_t124, n.markerName), _t124.is("containerElement") ? (s("data-".concat(o.group, "-start-before"), _t124), s("data-".concat(o.group, "-start-after"), _t124), s("data-".concat(o.group, "-end-before"), _t124), s("data-".concat(o.group, "-end-after"), _t124)) : i.writer.clear(i.writer.createRangeOn(_t124), _t124);
                        }
                      } catch (err) {
                        _iterator171.e(err);
                      } finally {
                        _iterator171.f();
                      }

                      i.writer.clearClonedElementsGroup(n.markerName), e.stop();
                    }

                    function s(t, e) {
                      if (e.hasAttribute(t)) {
                        var _n107 = new Set(e.getAttribute(t).split(","));

                        _n107.delete(o.name), 0 == _n107.size ? i.writer.removeAttribute(t, e) : i.writer.setAttribute(t, Array.from(_n107).join(","), e);
                      }
                    }
                  };
                }(t.view), {
                  priority: t.converterPriority || "normal"
                });
              };
            }(t));
          }
        }]);

        return gc;
      }(hc);

      function mc(t, e) {
        var n = t.createAttributeElement("span", e.attributes);
        return e.classes && n._addClass(e.classes), "number" == typeof e.priority && (n._priority = e.priority), n._id = e.id, n;
      }

      function pc(t, e, n, i, o) {
        var r = e ? t.start : t.end,
            s = r.nodeAfter && r.nodeAfter.is("element") ? r.nodeAfter : null,
            a = r.nodeBefore && r.nodeBefore.is("element") ? r.nodeBefore : null;

        if (s || a) {
          var _t125, _r20;

          e && s || !e && !a ? (_t125 = s, _r20 = !0) : (_t125 = a, _r20 = !1);

          var _c3 = n.mapper.toViewElement(_t125);

          if (_c3) return void function (t, e, n, i, o, r) {
            var s = "data-".concat(r.group, "-").concat(e ? "start" : "end", "-").concat(n ? "before" : "after"),
                a = t.hasAttribute(s) ? t.getAttribute(s).split(",") : [];
            a.unshift(r.name), i.writer.setAttribute(s, a.join(","), t), i.mapper.bindElementToMarker(t, o.markerName);
          }(_c3, e, _r20, n, i, o);
        }

        !function (t, e, n, i, o) {
          var r = "".concat(o.group, "-").concat(e ? "start" : "end"),
              s = o.name ? {
            name: o.name
          } : null,
              a = n.writer.createUIElement(r, s);
          n.writer.insert(t, a), n.mapper.bindElementToMarker(a, i.markerName);
        }(n.mapper.toViewPosition(r), e, n, i, o);
      }

      function fc(t, e) {
        return "function" == typeof t ? t : function (n, i) {
          return function (t, e, n) {
            "string" == typeof t && (t = {
              name: t
            });
            var i;
            var o = e.writer,
                r = Object.assign({}, t.attributes);
            if ("container" == n) i = o.createContainerElement(t.name, r);else if ("attribute" == n) {
              var _e124 = {
                priority: t.priority || Xo.DEFAULT_PRIORITY
              };
              i = o.createAttributeElement(t.name, r, _e124);
            } else i = o.createUIElement(t.name, r);

            if (t.styles) {
              var _e125 = Object.keys(t.styles);

              for (var _i84 = 0, _e126 = _e125; _i84 < _e126.length; _i84++) {
                var _n108 = _e126[_i84];
                o.setStyle(_n108, t.styles[_n108], i);
              }
            }

            if (t.classes) {
              var _e127 = t.classes;
              if ("string" == typeof _e127) o.addClass(_e127, i);else {
                var _iterator172 = _createForOfIteratorHelper(_e127),
                    _step172;

                try {
                  for (_iterator172.s(); !(_step172 = _iterator172.n()).done;) {
                    var _t126 = _step172.value;
                    o.addClass(_t126, i);
                  }
                } catch (err) {
                  _iterator172.e(err);
                } finally {
                  _iterator172.f();
                }
              }
            }

            return i;
          }(t, i, e);
        };
      }

      function kc(t) {
        return t.model.values ? function (e, n) {
          var i = t.view[e];
          return i ? i(e, n) : null;
        } : t.view;
      }

      function bc(t) {
        return "string" == typeof t ? function (e) {
          return {
            key: t,
            value: e
          };
        } : "object" == typeof t ? t.value ? function () {
          return t;
        } : function (e) {
          return {
            key: t.key,
            value: e
          };
        } : t;
      }

      function wc(t, e, n) {
        var i = "function" == typeof t ? t(e, n) : t;
        return i ? (i.priority || (i.priority = 10), i.id || (i.id = e.markerName), i) : null;
      }

      function Ac(t) {
        var _t$model = t.model,
            e = _t$model.schema,
            n = _t$model.document;

        var _iterator173 = _createForOfIteratorHelper(n.getRootNames()),
            _step173;

        try {
          for (_iterator173.s(); !(_step173 = _iterator173.n()).done;) {
            var _i85 = _step173.value;

            var _o41 = n.getRoot(_i85);

            if (_o41.isEmpty && !e.checkChild(_o41, "$text") && e.checkChild(_o41, "paragraph")) return t.insertElement("paragraph", _o41), !0;
          }
        } catch (err) {
          _iterator173.e(err);
        } finally {
          _iterator173.f();
        }

        return !1;
      }

      function Cc(t, e, n) {
        var i = n.createContext(t);
        return !!n.checkChild(i, "paragraph") && !!n.checkChild(i.push("paragraph"), e);
      }

      function _c(t, e) {
        var n = e.createElement("paragraph");
        return e.insert(n, t), e.createPositionAt(n, 0);
      }

      var vc = /*#__PURE__*/function (_hc2) {
        _inherits(vc, _hc2);

        var _super27 = _createSuper(vc);

        function vc() {
          _classCallCheck(this, vc);

          return _super27.apply(this, arguments);
        }

        _createClass(vc, [{
          key: "elementToElement",
          value: function elementToElement(t) {
            return this.add(yc(t));
          }
        }, {
          key: "elementToAttribute",
          value: function elementToAttribute(t) {
            return this.add(function (t) {
              Dc(t = uc(t));
              var e = Sc(t, !1),
                  n = xc(t.view),
                  i = n ? "element:" + n : "element";
              return function (n) {
                n.on(i, e, {
                  priority: t.converterPriority || "low"
                });
              };
            }(t));
          }
        }, {
          key: "attributeToAttribute",
          value: function attributeToAttribute(t) {
            return this.add(function (t) {
              t = uc(t);
              var e = null;
              ("string" == typeof t.view || t.view.key) && (e = function (t) {
                "string" == typeof t.view && (t.view = {
                  key: t.view
                });
                var e = t.view.key;
                var n;

                if ("class" == e || "style" == e) {
                  n = _defineProperty({}, "class" == e ? "classes" : "styles", t.view.value);
                } else {
                  n = {
                    attributes: _defineProperty({}, e, void 0 === t.view.value ? /[\s\S]*/ : t.view.value)
                  };
                }

                t.view.name && (n.name = t.view.name);
                return t.view = n, e;
              }(t));
              Dc(t, e);
              var n = Sc(t, !0);
              return function (e) {
                e.on("element", n, {
                  priority: t.converterPriority || "low"
                });
              };
            }(t));
          }
        }, {
          key: "elementToMarker",
          value: function elementToMarker(t) {
            return this.add(function (t) {
              return function (t) {
                var e = t.model;

                t.model = function (t, n) {
                  var i = "string" == typeof e ? e : e(t, n);
                  return n.writer.createElement("$marker", {
                    "data-name": i
                  });
                };
              }(t = uc(t)), yc(t);
            }(t));
          }
        }, {
          key: "dataToMarker",
          value: function dataToMarker(t) {
            return this.add(function (t) {
              (t = uc(t)).model || (t.model = function (e) {
                return e ? t.view + ":" + e : t.view;
              });
              var e = Ec(Ic(t, "start")),
                  n = Ec(Ic(t, "end"));
              return function (i) {
                i.on("element:" + t.view + "-start", e, {
                  priority: t.converterPriority || "normal"
                }), i.on("element:" + t.view + "-end", n, {
                  priority: t.converterPriority || "normal"
                });
                var o = s.get("low"),
                    r = s.get("highest"),
                    a = s.get(t.converterPriority) / r;
                i.on("element", function (t) {
                  return function (e, n, i) {
                    var o = "data-".concat(t.view);

                    function r(e, o) {
                      var _iterator174 = _createForOfIteratorHelper(o),
                          _step174;

                      try {
                        for (_iterator174.s(); !(_step174 = _iterator174.n()).done;) {
                          var _r21 = _step174.value;

                          var _o42 = t.model(_r21, i),
                              _s15 = i.writer.createElement("$marker", {
                            "data-name": _o42
                          });

                          i.writer.insert(_s15, e), n.modelCursor.isEqual(e) ? n.modelCursor = n.modelCursor.getShiftedBy(1) : n.modelCursor = n.modelCursor._getTransformedByInsertion(e, 1), n.modelRange = n.modelRange._getTransformedByInsertion(e, 1)[0];
                        }
                      } catch (err) {
                        _iterator174.e(err);
                      } finally {
                        _iterator174.f();
                      }
                    }

                    (i.consumable.test(n.viewItem, {
                      attributes: o + "-end-after"
                    }) || i.consumable.test(n.viewItem, {
                      attributes: o + "-start-after"
                    }) || i.consumable.test(n.viewItem, {
                      attributes: o + "-end-before"
                    }) || i.consumable.test(n.viewItem, {
                      attributes: o + "-start-before"
                    })) && (n.modelRange || Object.assign(n, i.convertChildren(n.viewItem, n.modelCursor)), i.consumable.consume(n.viewItem, {
                      attributes: o + "-end-after"
                    }) && r(n.modelRange.end, n.viewItem.getAttribute(o + "-end-after").split(",")), i.consumable.consume(n.viewItem, {
                      attributes: o + "-start-after"
                    }) && r(n.modelRange.end, n.viewItem.getAttribute(o + "-start-after").split(",")), i.consumable.consume(n.viewItem, {
                      attributes: o + "-end-before"
                    }) && r(n.modelRange.start, n.viewItem.getAttribute(o + "-end-before").split(",")), i.consumable.consume(n.viewItem, {
                      attributes: o + "-start-before"
                    }) && r(n.modelRange.start, n.viewItem.getAttribute(o + "-start-before").split(",")));
                  };
                }(t), {
                  priority: o + a
                });
              };
            }(t));
          }
        }]);

        return vc;
      }(hc);

      function yc(t) {
        var e = Ec(t = uc(t)),
            n = xc(t.view),
            i = n ? "element:" + n : "element";
        return function (n) {
          n.on(i, e, {
            priority: t.converterPriority || "normal"
          });
        };
      }

      function xc(t) {
        return "string" == typeof t ? t : "object" == typeof t && "string" == typeof t.name ? t.name : null;
      }

      function Ec(t) {
        var e = new Ui(t.view);
        return function (n, i, o) {
          var r = e.match(i.viewItem);
          if (!r) return;
          var s = r.match;
          if (s.name = !0, !o.consumable.test(i.viewItem, s)) return;

          var a = function (t, e, n) {
            return t instanceof Function ? t(e, n) : n.writer.createElement(t);
          }(t.model, i.viewItem, o);

          a && o.safeInsert(a, i.modelCursor) && (o.consumable.consume(i.viewItem, s), o.convertChildren(i.viewItem, a), o.updateConversionResult(a, i));
        };
      }

      function Dc(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var n = null === e || function (t) {
          return t.getAttribute(e);
        },
            i = "object" != typeof t.model ? t.model : t.model.key,
            o = "object" != typeof t.model || void 0 === t.model.value ? n : t.model.value;

        t.model = {
          key: i,
          value: o
        };
      }

      function Sc(t, e) {
        var n = new Ui(t.view);
        return function (i, o, r) {
          var s = n.match(o.viewItem);
          if (!s) return;
          if (!function (t, e) {
            var n = "function" == typeof t ? t(e) : t;
            if ("object" == typeof n && !xc(n)) return !1;
            return !n.classes && !n.attributes && !n.styles;
          }(t.view, o.viewItem) ? delete s.match.name : s.match.name = !0, !r.consumable.test(o.viewItem, s.match)) return;
          var a = t.model.key,
              c = "function" == typeof t.model.value ? t.model.value(o.viewItem, r) : t.model.value;
          if (null === c) return;
          o.modelRange || Object.assign(o, r.convertChildren(o.viewItem, o.modelCursor));

          var l = function (t, e, n, i) {
            var o = !1;

            for (var _i86 = 0, _Array$from3 = Array.from(t.getItems({
              shallow: n
            })); _i86 < _Array$from3.length; _i86++) {
              var _r22 = _Array$from3[_i86];
              i.schema.checkAttribute(_r22, e.key) && (o = !0, _r22.hasAttribute(e.key) || i.writer.setAttribute(e.key, e.value, _r22));
            }

            return o;
          }(o.modelRange, {
            key: a,
            value: c
          }, e, r);

          l && r.consumable.consume(o.viewItem, s.match);
        };
      }

      function Ic(t, e) {
        var n = {};
        return n.view = t.view + "-" + e, n.model = function (e, n) {
          var i = e.getAttribute("name"),
              o = t.model(i, n);
          return n.writer.createElement("$marker", {
            "data-name": o
          });
        }, n;
      }

      var Mc = /*#__PURE__*/function () {
        function Mc(t, e) {
          var _this59 = this;

          _classCallCheck(this, Mc);

          this.model = t, this.view = new Ba(e), this.mapper = new Ga(), this.downcastDispatcher = new Ka({
            mapper: this.mapper,
            schema: t.schema
          });
          var n = this.model.document,
              i = n.selection,
              o = this.model.markers;
          this.listenTo(this.model, "_beforeChanges", function () {
            _this59.view._disableRendering(!0);
          }, {
            priority: "highest"
          }), this.listenTo(this.model, "_afterChanges", function () {
            _this59.view._disableRendering(!1);
          }, {
            priority: "lowest"
          }), this.listenTo(n, "change", function () {
            _this59.view.change(function (t) {
              _this59.downcastDispatcher.convertChanges(n.differ, o, t), _this59.downcastDispatcher.convertSelection(i, o, t);
            });
          }, {
            priority: "low"
          }), this.listenTo(this.view.document, "selectionChange", function (t, e) {
            return function (n, i) {
              var o = i.newSelection,
                  r = [];

              var _iterator175 = _createForOfIteratorHelper(o.getRanges()),
                  _step175;

              try {
                for (_iterator175.s(); !(_step175 = _iterator175.n()).done;) {
                  var _t127 = _step175.value;
                  r.push(e.toModelRange(_t127));
                }
              } catch (err) {
                _iterator175.e(err);
              } finally {
                _iterator175.f();
              }

              var s = t.createSelection(r, {
                backward: o.isBackward
              });
              s.isEqual(t.document.selection) || t.change(function (t) {
                t.setSelection(s);
              });
            };
          }(this.model, this.mapper)), this.downcastDispatcher.on("insert:$text", function (t, e, n) {
            if (!n.consumable.consume(e.item, "insert")) return;
            var i = n.writer,
                o = n.mapper.toViewPosition(e.range.start),
                r = i.createText(e.item.data);
            i.insert(o, r);
          }, {
            priority: "lowest"
          }), this.downcastDispatcher.on("remove", function (t, e, n) {
            var i = n.mapper.toViewPosition(e.position),
                o = e.position.getShiftedBy(e.length),
                r = n.mapper.toViewPosition(o, {
              isPhantom: !0
            }),
                s = n.writer.createRange(i, r),
                a = n.writer.remove(s.getTrimmed());

            var _iterator176 = _createForOfIteratorHelper(n.writer.createRangeIn(a).getItems()),
                _step176;

            try {
              for (_iterator176.s(); !(_step176 = _iterator176.n()).done;) {
                var _t128 = _step176.value;
                n.mapper.unbindViewElement(_t128);
              }
            } catch (err) {
              _iterator176.e(err);
            } finally {
              _iterator176.f();
            }
          }, {
            priority: "low"
          }), this.downcastDispatcher.on("selection", function (t, e, n) {
            var i = n.writer,
                o = i.document.selection;

            var _iterator177 = _createForOfIteratorHelper(o.getRanges()),
                _step177;

            try {
              for (_iterator177.s(); !(_step177 = _iterator177.n()).done;) {
                var _t129 = _step177.value;
                _t129.isCollapsed && _t129.end.parent.isAttached() && n.writer.mergeAttributes(_t129.start);
              }
            } catch (err) {
              _iterator177.e(err);
            } finally {
              _iterator177.f();
            }

            i.setSelection(null);
          }, {
            priority: "high"
          }), this.downcastDispatcher.on("selection", function (t, e, n) {
            var i = e.selection;
            if (i.isCollapsed) return;
            if (!n.consumable.consume(i, "selection")) return;
            var o = [];

            var _iterator178 = _createForOfIteratorHelper(i.getRanges()),
                _step178;

            try {
              for (_iterator178.s(); !(_step178 = _iterator178.n()).done;) {
                var _t130 = _step178.value;

                var _e128 = n.mapper.toViewRange(_t130);

                o.push(_e128);
              }
            } catch (err) {
              _iterator178.e(err);
            } finally {
              _iterator178.f();
            }

            n.writer.setSelection(o, {
              backward: i.isBackward
            });
          }, {
            priority: "low"
          }), this.downcastDispatcher.on("selection", function (t, e, n) {
            var i = e.selection;
            if (!i.isCollapsed) return;
            if (!n.consumable.consume(i, "selection")) return;
            var o = n.writer,
                r = i.getFirstPosition(),
                s = n.mapper.toViewPosition(r),
                a = o.breakAttributes(s);
            o.setSelection(a);
          }, {
            priority: "low"
          }), this.view.document.roots.bindTo(this.model.document.roots).using(function (t) {
            if ("$graveyard" == t.rootName) return null;
            var e = new Lo(_this59.view.document, t.name);
            return e.rootName = t.rootName, _this59.mapper.bindElements(t, e), e;
          });
        }

        _createClass(Mc, [{
          key: "destroy",
          value: function destroy() {
            this.view.destroy(), this.stopListening();
          }
        }]);

        return Mc;
      }();

      he(Mc, re);

      var Tc = /*#__PURE__*/function (_Symbol$iterator9) {
        function Tc() {
          _classCallCheck(this, Tc);

          this._commands = new Map();
        }

        _createClass(Tc, [{
          key: "add",
          value: function add(t, e) {
            this._commands.set(t, e);
          }
        }, {
          key: "get",
          value: function get(t) {
            return this._commands.get(t);
          }
        }, {
          key: "execute",
          value: function execute(t) {
            var n = this.get(t);
            if (!n) throw new a("commandcollection-command-not-found", this, {
              commandName: t
            });

            for (var _len18 = arguments.length, e = new Array(_len18 > 1 ? _len18 - 1 : 0), _key18 = 1; _key18 < _len18; _key18++) {
              e[_key18 - 1] = arguments[_key18];
            }

            return n.execute.apply(n, e);
          }
        }, {
          key: "names",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function names() {
            return _regeneratorRuntime.wrap(function names$(_context20) {
              while (1) {
                switch (_context20.prev = _context20.next) {
                  case 0:
                    return _context20.delegateYield(this._commands.keys(), "t0", 1);

                  case 1:
                  case "end":
                    return _context20.stop();
                }
              }
            }, names, this);
          })
        }, {
          key: "commands",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function commands() {
            return _regeneratorRuntime.wrap(function commands$(_context21) {
              while (1) {
                switch (_context21.prev = _context21.next) {
                  case 0:
                    return _context21.delegateYield(this._commands.values(), "t0", 1);

                  case 1:
                  case "end":
                    return _context21.stop();
                }
              }
            }, commands, this);
          })
        }, {
          key: _Symbol$iterator9,
          value: function value() {
            return this._commands[Symbol.iterator]();
          }
        }, {
          key: "destroy",
          value: function destroy() {
            var _iterator179 = _createForOfIteratorHelper(this.commands()),
                _step179;

            try {
              for (_iterator179.s(); !(_step179 = _iterator179.n()).done;) {
                var _t131 = _step179.value;

                _t131.destroy();
              }
            } catch (err) {
              _iterator179.e(err);
            } finally {
              _iterator179.f();
            }
          }
        }]);

        return Tc;
      }(Symbol.iterator);

      var Nc = /*#__PURE__*/function () {
        function Nc() {
          _classCallCheck(this, Nc);

          this._consumables = new Map();
        }

        _createClass(Nc, [{
          key: "add",
          value: function add(t, e) {
            var n;
            t.is("$text") || t.is("documentFragment") ? this._consumables.set(t, !0) : (this._consumables.has(t) ? n = this._consumables.get(t) : (n = new Bc(t), this._consumables.set(t, n)), n.add(e));
          }
        }, {
          key: "test",
          value: function test(t, e) {
            var n = this._consumables.get(t);

            return void 0 === n ? null : t.is("$text") || t.is("documentFragment") ? n : n.test(e);
          }
        }, {
          key: "consume",
          value: function consume(t, e) {
            return !!this.test(t, e) && (t.is("$text") || t.is("documentFragment") ? this._consumables.set(t, !1) : this._consumables.get(t).consume(e), !0);
          }
        }, {
          key: "revert",
          value: function revert(t, e) {
            var n = this._consumables.get(t);

            void 0 !== n && (t.is("$text") || t.is("documentFragment") ? this._consumables.set(t, !0) : n.revert(e));
          }
        }], [{
          key: "consumablesFromElement",
          value: function consumablesFromElement(t) {
            var e = {
              element: t,
              name: !0,
              attributes: [],
              classes: [],
              styles: []
            },
                n = t.getAttributeKeys();

            var _iterator180 = _createForOfIteratorHelper(n),
                _step180;

            try {
              for (_iterator180.s(); !(_step180 = _iterator180.n()).done;) {
                var _t132 = _step180.value;
                "style" != _t132 && "class" != _t132 && e.attributes.push(_t132);
              }
            } catch (err) {
              _iterator180.e(err);
            } finally {
              _iterator180.f();
            }

            var i = t.getClassNames();

            var _iterator181 = _createForOfIteratorHelper(i),
                _step181;

            try {
              for (_iterator181.s(); !(_step181 = _iterator181.n()).done;) {
                var _t133 = _step181.value;
                e.classes.push(_t133);
              }
            } catch (err) {
              _iterator181.e(err);
            } finally {
              _iterator181.f();
            }

            var o = t.getStyleNames();

            var _iterator182 = _createForOfIteratorHelper(o),
                _step182;

            try {
              for (_iterator182.s(); !(_step182 = _iterator182.n()).done;) {
                var _t134 = _step182.value;
                e.styles.push(_t134);
              }
            } catch (err) {
              _iterator182.e(err);
            } finally {
              _iterator182.f();
            }

            return e;
          }
        }, {
          key: "createFrom",
          value: function createFrom(t, e) {
            if (e || (e = new Nc(t)), t.is("$text")) return e.add(t), e;
            t.is("element") && e.add(t, Nc.consumablesFromElement(t)), t.is("documentFragment") && e.add(t);

            var _iterator183 = _createForOfIteratorHelper(t.getChildren()),
                _step183;

            try {
              for (_iterator183.s(); !(_step183 = _iterator183.n()).done;) {
                var _n110 = _step183.value;
                e = Nc.createFrom(_n110, e);
              }
            } catch (err) {
              _iterator183.e(err);
            } finally {
              _iterator183.f();
            }

            return e;
          }
        }]);

        return Nc;
      }();

      var Bc = /*#__PURE__*/function () {
        function Bc(t) {
          _classCallCheck(this, Bc);

          this.element = t, this._canConsumeName = null, this._consumables = {
            attributes: new Map(),
            styles: new Map(),
            classes: new Map()
          };
        }

        _createClass(Bc, [{
          key: "add",
          value: function add(t) {
            t.name && (this._canConsumeName = !0);

            for (var _e129 in this._consumables) {
              _e129 in t && this._add(_e129, t[_e129]);
            }
          }
        }, {
          key: "test",
          value: function test(t) {
            if (t.name && !this._canConsumeName) return this._canConsumeName;

            for (var _e130 in this._consumables) {
              if (_e130 in t) {
                var _n111 = this._test(_e130, t[_e130]);

                if (!0 !== _n111) return _n111;
              }
            }

            return !0;
          }
        }, {
          key: "consume",
          value: function consume(t) {
            t.name && (this._canConsumeName = !1);

            for (var _e131 in this._consumables) {
              _e131 in t && this._consume(_e131, t[_e131]);
            }
          }
        }, {
          key: "revert",
          value: function revert(t) {
            t.name && (this._canConsumeName = !0);

            for (var _e132 in this._consumables) {
              _e132 in t && this._revert(_e132, t[_e132]);
            }
          }
        }, {
          key: "_add",
          value: function _add(t, e) {
            var n = It(e) ? e : [e],
                i = this._consumables[t];

            var _iterator184 = _createForOfIteratorHelper(n),
                _step184;

            try {
              for (_iterator184.s(); !(_step184 = _iterator184.n()).done;) {
                var _e133 = _step184.value;
                if ("attributes" === t && ("class" === _e133 || "style" === _e133)) throw new a("viewconsumable-invalid-attribute", this);

                if (i.set(_e133, !0), "styles" === t) {
                  var _iterator185 = _createForOfIteratorHelper(this.element.document.stylesProcessor.getRelatedStyles(_e133)),
                      _step185;

                  try {
                    for (_iterator185.s(); !(_step185 = _iterator185.n()).done;) {
                      var _t135 = _step185.value;
                      i.set(_t135, !0);
                    }
                  } catch (err) {
                    _iterator185.e(err);
                  } finally {
                    _iterator185.f();
                  }
                }
              }
            } catch (err) {
              _iterator184.e(err);
            } finally {
              _iterator184.f();
            }
          }
        }, {
          key: "_test",
          value: function _test(t, e) {
            var n = It(e) ? e : [e],
                i = this._consumables[t];

            var _iterator186 = _createForOfIteratorHelper(n),
                _step186;

            try {
              for (_iterator186.s(); !(_step186 = _iterator186.n()).done;) {
                var _e134 = _step186.value;

                if ("attributes" !== t || "class" !== _e134 && "style" !== _e134) {
                  var _t136 = i.get(_e134);

                  if (void 0 === _t136) return null;
                  if (!_t136) return !1;
                } else {
                  var _t137 = "class" == _e134 ? "classes" : "styles",
                      _n112 = this._test(_t137, _toConsumableArray(this._consumables[_t137].keys()));

                  if (!0 !== _n112) return _n112;
                }
              }
            } catch (err) {
              _iterator186.e(err);
            } finally {
              _iterator186.f();
            }

            return !0;
          }
        }, {
          key: "_consume",
          value: function _consume(t, e) {
            var n = It(e) ? e : [e],
                i = this._consumables[t];

            var _iterator187 = _createForOfIteratorHelper(n),
                _step187;

            try {
              for (_iterator187.s(); !(_step187 = _iterator187.n()).done;) {
                var _e135 = _step187.value;

                if ("attributes" !== t || "class" !== _e135 && "style" !== _e135) {
                  if (i.set(_e135, !1), "styles" == t) {
                    var _iterator188 = _createForOfIteratorHelper(this.element.document.stylesProcessor.getRelatedStyles(_e135)),
                        _step188;

                    try {
                      for (_iterator188.s(); !(_step188 = _iterator188.n()).done;) {
                        var _t138 = _step188.value;
                        i.set(_t138, !1);
                      }
                    } catch (err) {
                      _iterator188.e(err);
                    } finally {
                      _iterator188.f();
                    }
                  }
                } else {
                  var _t139 = "class" == _e135 ? "classes" : "styles";

                  this._consume(_t139, _toConsumableArray(this._consumables[_t139].keys()));
                }
              }
            } catch (err) {
              _iterator187.e(err);
            } finally {
              _iterator187.f();
            }
          }
        }, {
          key: "_revert",
          value: function _revert(t, e) {
            var n = It(e) ? e : [e],
                i = this._consumables[t];

            var _iterator189 = _createForOfIteratorHelper(n),
                _step189;

            try {
              for (_iterator189.s(); !(_step189 = _iterator189.n()).done;) {
                var _e136 = _step189.value;

                if ("attributes" !== t || "class" !== _e136 && "style" !== _e136) {
                  !1 === i.get(_e136) && i.set(_e136, !0);
                } else {
                  var _t140 = "class" == _e136 ? "classes" : "styles";

                  this._revert(_t140, _toConsumableArray(this._consumables[_t140].keys()));
                }
              }
            } catch (err) {
              _iterator189.e(err);
            } finally {
              _iterator189.f();
            }
          }
        }]);

        return Bc;
      }();

      var zc = /*#__PURE__*/function () {
        function zc() {
          var _this60 = this;

          _classCallCheck(this, zc);

          this._sourceDefinitions = {}, this._attributeProperties = {}, this.decorate("checkChild"), this.decorate("checkAttribute"), this.on("checkAttribute", function (t, e) {
            e[0] = new Pc(e[0]);
          }, {
            priority: "highest"
          }), this.on("checkChild", function (t, e) {
            e[0] = new Pc(e[0]), e[1] = _this60.getDefinition(e[1]);
          }, {
            priority: "highest"
          });
        }

        _createClass(zc, [{
          key: "register",
          value: function register(t, e) {
            if (this._sourceDefinitions[t]) throw new a("schema-cannot-register-item-twice", this, {
              itemName: t
            });
            this._sourceDefinitions[t] = [Object.assign({}, e)], this._clearCache();
          }
        }, {
          key: "extend",
          value: function extend(t, e) {
            if (!this._sourceDefinitions[t]) throw new a("schema-cannot-extend-missing-item", this, {
              itemName: t
            });
            this._sourceDefinitions[t].push(Object.assign({}, e)), this._clearCache();
          }
        }, {
          key: "getDefinitions",
          value: function getDefinitions() {
            return this._compiledDefinitions || this._compile(), this._compiledDefinitions;
          }
        }, {
          key: "getDefinition",
          value: function getDefinition(t) {
            var e;
            return e = "string" == typeof t ? t : t.is && (t.is("$text") || t.is("$textProxy")) ? "$text" : t.name, this.getDefinitions()[e];
          }
        }, {
          key: "isRegistered",
          value: function isRegistered(t) {
            return !!this.getDefinition(t);
          }
        }, {
          key: "isBlock",
          value: function isBlock(t) {
            var e = this.getDefinition(t);
            return !(!e || !e.isBlock);
          }
        }, {
          key: "isLimit",
          value: function isLimit(t) {
            var e = this.getDefinition(t);
            return !!e && !(!e.isLimit && !e.isObject);
          }
        }, {
          key: "isObject",
          value: function isObject(t) {
            var e = this.getDefinition(t);
            return !!e && !!(e.isObject || e.isLimit && e.isSelectable && e.isContent);
          }
        }, {
          key: "isInline",
          value: function isInline(t) {
            var e = this.getDefinition(t);
            return !(!e || !e.isInline);
          }
        }, {
          key: "isSelectable",
          value: function isSelectable(t) {
            var e = this.getDefinition(t);
            return !!e && !(!e.isSelectable && !e.isObject);
          }
        }, {
          key: "isContent",
          value: function isContent(t) {
            var e = this.getDefinition(t);
            return !!e && !(!e.isContent && !e.isObject);
          }
        }, {
          key: "checkChild",
          value: function checkChild(t, e) {
            return !!e && this._checkContextMatch(e, t);
          }
        }, {
          key: "checkAttribute",
          value: function checkAttribute(t, e) {
            var n = this.getDefinition(t.last);
            return !!n && n.allowAttributes.includes(e);
          }
        }, {
          key: "checkMerge",
          value: function checkMerge(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (t instanceof Va) {
              var _e137 = t.nodeBefore,
                  _n113 = t.nodeAfter;
              if (!(_e137 instanceof Oa)) throw new a("schema-check-merge-no-element-before", this);
              if (!(_n113 instanceof Oa)) throw new a("schema-check-merge-no-element-after", this);
              return this.checkMerge(_e137, _n113);
            }

            var _iterator190 = _createForOfIteratorHelper(e.getChildren()),
                _step190;

            try {
              for (_iterator190.s(); !(_step190 = _iterator190.n()).done;) {
                var _n114 = _step190.value;
                if (!this.checkChild(t, _n114)) return !1;
              }
            } catch (err) {
              _iterator190.e(err);
            } finally {
              _iterator190.f();
            }

            return !0;
          }
        }, {
          key: "addChildCheck",
          value: function addChildCheck(t) {
            this.on("checkChild", function (e, _ref16) {
              var _ref17 = _slicedToArray(_ref16, 2),
                  n = _ref17[0],
                  i = _ref17[1];

              if (!i) return;
              var o = t(n, i);
              "boolean" == typeof o && (e.stop(), e.return = o);
            }, {
              priority: "high"
            });
          }
        }, {
          key: "addAttributeCheck",
          value: function addAttributeCheck(t) {
            this.on("checkAttribute", function (e, _ref18) {
              var _ref19 = _slicedToArray(_ref18, 2),
                  n = _ref19[0],
                  i = _ref19[1];

              var o = t(n, i);
              "boolean" == typeof o && (e.stop(), e.return = o);
            }, {
              priority: "high"
            });
          }
        }, {
          key: "setAttributeProperties",
          value: function setAttributeProperties(t, e) {
            this._attributeProperties[t] = Object.assign(this.getAttributeProperties(t), e);
          }
        }, {
          key: "getAttributeProperties",
          value: function getAttributeProperties(t) {
            return this._attributeProperties[t] || {};
          }
        }, {
          key: "getLimitElement",
          value: function getLimitElement(t) {
            var e;
            if (t instanceof Va) e = t.parent;else {
              e = (t instanceof Wa ? [t] : Array.from(t.getRanges())).reduce(function (t, e) {
                var n = e.getCommonAncestor();
                return t ? t.getCommonAncestor(n, {
                  includeSelf: !0
                }) : n;
              }, null);
            }

            for (; !this.isLimit(e) && e.parent;) {
              e = e.parent;
            }

            return e;
          }
        }, {
          key: "checkAttributeInSelection",
          value: function checkAttributeInSelection(t, e) {
            if (t.isCollapsed) {
              var _n115 = [].concat(_toConsumableArray(t.getFirstPosition().getAncestors()), [new Pa("", t.getAttributes())]);

              return this.checkAttribute(_n115, e);
            }

            {
              var _n116 = t.getRanges();

              var _iterator191 = _createForOfIteratorHelper(_n116),
                  _step191;

              try {
                for (_iterator191.s(); !(_step191 = _iterator191.n()).done;) {
                  var _t141 = _step191.value;

                  var _iterator192 = _createForOfIteratorHelper(_t141),
                      _step192;

                  try {
                    for (_iterator192.s(); !(_step192 = _iterator192.n()).done;) {
                      var _n117 = _step192.value;
                      if (this.checkAttribute(_n117.item, e)) return !0;
                    }
                  } catch (err) {
                    _iterator192.e(err);
                  } finally {
                    _iterator192.f();
                  }
                }
              } catch (err) {
                _iterator191.e(err);
              } finally {
                _iterator191.f();
              }
            }
            return !1;
          }
        }, {
          key: "getValidRanges",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function getValidRanges(t, e) {
            var _iterator194, _step194, _n118;

            return _regeneratorRuntime.wrap(function getValidRanges$(_context23) {
              while (1) {
                switch (_context23.prev = _context23.next) {
                  case 0:
                    t = /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
                      var _iterator193, _step193, _e138;

                      return _regeneratorRuntime.wrap(function _callee$(_context22) {
                        while (1) {
                          switch (_context22.prev = _context22.next) {
                            case 0:
                              _iterator193 = _createForOfIteratorHelper(t);
                              _context22.prev = 1;

                              _iterator193.s();

                            case 3:
                              if ((_step193 = _iterator193.n()).done) {
                                _context22.next = 8;
                                break;
                              }

                              _e138 = _step193.value;
                              return _context22.delegateYield(_e138.getMinimalFlatRanges(), "t0", 6);

                            case 6:
                              _context22.next = 3;
                              break;

                            case 8:
                              _context22.next = 13;
                              break;

                            case 10:
                              _context22.prev = 10;
                              _context22.t1 = _context22["catch"](1);

                              _iterator193.e(_context22.t1);

                            case 13:
                              _context22.prev = 13;

                              _iterator193.f();

                              return _context22.finish(13);

                            case 16:
                            case "end":
                              return _context22.stop();
                          }
                        }
                      }, _callee, null, [[1, 10, 13, 16]]);
                    })(t);
                    _iterator194 = _createForOfIteratorHelper(t);
                    _context23.prev = 2;

                    _iterator194.s();

                  case 4:
                    if ((_step194 = _iterator194.n()).done) {
                      _context23.next = 9;
                      break;
                    }

                    _n118 = _step194.value;
                    return _context23.delegateYield(this._getValidRangesForRange(_n118, e), "t0", 7);

                  case 7:
                    _context23.next = 4;
                    break;

                  case 9:
                    _context23.next = 14;
                    break;

                  case 11:
                    _context23.prev = 11;
                    _context23.t1 = _context23["catch"](2);

                    _iterator194.e(_context23.t1);

                  case 14:
                    _context23.prev = 14;

                    _iterator194.f();

                    return _context23.finish(14);

                  case 17:
                  case "end":
                    return _context23.stop();
                }
              }
            }, getValidRanges, this, [[2, 11, 14, 17]]);
          })
        }, {
          key: "getNearestSelectionRange",
          value: function getNearestSelectionRange(t) {
            var _this61 = this;

            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "both";
            if (this.checkChild(t, "$text")) return new Wa(t);
            var n, i;
            var o = t.getAncestors().reverse().find(function (t) {
              return _this61.isLimit(t);
            }) || t.root;
            "both" != e && "backward" != e || (n = new ja({
              boundaries: Wa._createIn(o),
              startPosition: t,
              direction: "backward"
            })), "both" != e && "forward" != e || (i = new ja({
              boundaries: Wa._createIn(o),
              startPosition: t
            }));

            var _iterator195 = _createForOfIteratorHelper( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t, e) {
              var n, _e139, _t142;

              return _regeneratorRuntime.wrap(function _callee2$(_context24) {
                while (1) {
                  switch (_context24.prev = _context24.next) {
                    case 0:
                      n = !1;

                    case 1:
                      if (n) {
                        _context24.next = 18;
                        break;
                      }

                      if (!(n = !0, t)) {
                        _context24.next = 9;
                        break;
                      }

                      _e139 = t.next();
                      _context24.t0 = _e139.done;

                      if (_context24.t0) {
                        _context24.next = 9;
                        break;
                      }

                      n = !1;
                      _context24.next = 9;
                      return {
                        walker: t,
                        value: _e139.value
                      };

                    case 9:
                      if (!e) {
                        _context24.next = 16;
                        break;
                      }

                      _t142 = e.next();
                      _context24.t1 = _t142.done;

                      if (_context24.t1) {
                        _context24.next = 16;
                        break;
                      }

                      n = !1;
                      _context24.next = 16;
                      return {
                        walker: e,
                        value: _t142.value
                      };

                    case 16:
                      _context24.next = 1;
                      break;

                    case 18:
                    case "end":
                      return _context24.stop();
                  }
                }
              }, _callee2);
            })(n, i)),
                _step195;

            try {
              for (_iterator195.s(); !(_step195 = _iterator195.n()).done;) {
                var _t143 = _step195.value;

                var _e140 = _t143.walker == n ? "elementEnd" : "elementStart",
                    _i87 = _t143.value;

                if (_i87.type == _e140 && this.isObject(_i87.item)) return Wa._createOn(_i87.item);
                if (this.checkChild(_i87.nextPosition, "$text")) return new Wa(_i87.nextPosition);
              }
            } catch (err) {
              _iterator195.e(err);
            } finally {
              _iterator195.f();
            }

            return null;
          }
        }, {
          key: "findAllowedParent",
          value: function findAllowedParent(t, e) {
            var n = t.parent;

            for (; n;) {
              if (this.checkChild(n, e)) return n;
              if (this.isLimit(n)) return null;
              n = n.parent;
            }

            return null;
          }
        }, {
          key: "removeDisallowedAttributes",
          value: function removeDisallowedAttributes(t, e) {
            var _iterator196 = _createForOfIteratorHelper(t),
                _step196;

            try {
              for (_iterator196.s(); !(_step196 = _iterator196.n()).done;) {
                var _n119 = _step196.value;
                if (_n119.is("$text")) Yc(this, _n119, e);else {
                  var _t144 = Wa._createIn(_n119).getPositions();

                  var _iterator197 = _createForOfIteratorHelper(_t144),
                      _step197;

                  try {
                    for (_iterator197.s(); !(_step197 = _iterator197.n()).done;) {
                      var _n120 = _step197.value;
                      Yc(this, _n120.nodeBefore || _n120.parent, e);
                    }
                  } catch (err) {
                    _iterator197.e(err);
                  } finally {
                    _iterator197.f();
                  }
                }
              }
            } catch (err) {
              _iterator196.e(err);
            } finally {
              _iterator196.f();
            }
          }
        }, {
          key: "createContext",
          value: function createContext(t) {
            return new Pc(t);
          }
        }, {
          key: "_clearCache",
          value: function _clearCache() {
            this._compiledDefinitions = null;
          }
        }, {
          key: "_compile",
          value: function _compile() {
            var t = {},
                e = this._sourceDefinitions,
                n = Object.keys(e);

            for (var _i88 = 0, _n121 = n; _i88 < _n121.length; _i88++) {
              var _i89 = _n121[_i88];
              t[_i89] = Lc(e[_i89], _i89);
            }

            for (var _i90 = 0, _n122 = n; _i90 < _n122.length; _i90++) {
              var _e141 = _n122[_i90];
              Rc(t, _e141);
            }

            for (var _i91 = 0, _n123 = n; _i91 < _n123.length; _i91++) {
              var _e142 = _n123[_i91];
              Oc(t, _e142);
            }

            for (var _i92 = 0, _n124 = n; _i92 < _n124.length; _i92++) {
              var _e143 = _n124[_i92];
              jc(t, _e143);
            }

            for (var _i93 = 0, _n125 = n; _i93 < _n125.length; _i93++) {
              var _e144 = _n125[_i93];
              Fc(t, _e144), Vc(t, _e144);
            }

            for (var _i94 = 0, _n126 = n; _i94 < _n126.length; _i94++) {
              var _e145 = _n126[_i94];
              Uc(t, _e145), Hc(t, _e145), qc(t, _e145);
            }

            this._compiledDefinitions = t;
          }
        }, {
          key: "_checkContextMatch",
          value: function _checkContextMatch(t, e) {
            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.length - 1;
            var i = e.getItem(n);

            if (t.allowIn.includes(i.name)) {
              if (0 == n) return !0;
              {
                var _t145 = this.getDefinition(i);

                return this._checkContextMatch(_t145, e, n - 1);
              }
            }

            return !1;
          }
        }, {
          key: "_getValidRangesForRange",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function _getValidRangesForRange(t, e) {
            var n, i, _iterator198, _step198, _o43;

            return _regeneratorRuntime.wrap(function _getValidRangesForRange$(_context25) {
              while (1) {
                switch (_context25.prev = _context25.next) {
                  case 0:
                    n = t.start, i = t.start;
                    _iterator198 = _createForOfIteratorHelper(t.getItems({
                      shallow: !0
                    }));
                    _context25.prev = 2;

                    _iterator198.s();

                  case 4:
                    if ((_step198 = _iterator198.n()).done) {
                      _context25.next = 19;
                      break;
                    }

                    _o43 = _step198.value;
                    _context25.t0 = _o43.is("element");

                    if (!_context25.t0) {
                      _context25.next = 9;
                      break;
                    }

                    return _context25.delegateYield(this._getValidRangesForRange(Wa._createIn(_o43), e), "t1", 9);

                  case 9:
                    _context25.t2 = this.checkAttribute(_o43, e);

                    if (_context25.t2) {
                      _context25.next = 16;
                      break;
                    }

                    _context25.t3 = n.isEqual(i);

                    if (_context25.t3) {
                      _context25.next = 15;
                      break;
                    }

                    _context25.next = 15;
                    return new Wa(n, i);

                  case 15:
                    n = Va._createAfter(_o43);

                  case 16:
                    i = Va._createAfter(_o43);

                  case 17:
                    _context25.next = 4;
                    break;

                  case 19:
                    _context25.next = 24;
                    break;

                  case 21:
                    _context25.prev = 21;
                    _context25.t4 = _context25["catch"](2);

                    _iterator198.e(_context25.t4);

                  case 24:
                    _context25.prev = 24;

                    _iterator198.f();

                    return _context25.finish(24);

                  case 27:
                    _context25.t5 = n.isEqual(i);

                    if (_context25.t5) {
                      _context25.next = 31;
                      break;
                    }

                    _context25.next = 31;
                    return new Wa(n, i);

                  case 31:
                  case "end":
                    return _context25.stop();
                }
              }
            }, _getValidRangesForRange, this, [[2, 21, 24, 27]]);
          })
        }]);

        return zc;
      }();

      he(zc, re);

      var Pc = /*#__PURE__*/function (_Symbol$iterator10) {
        function Pc(t) {
          _classCallCheck(this, Pc);

          if (t instanceof Pc) return t;
          "string" == typeof t ? t = [t] : Array.isArray(t) || (t = t.getAncestors({
            includeSelf: !0
          })), this._items = t.map($c);
        }

        _createClass(Pc, [{
          key: "length",
          get: function get() {
            return this._items.length;
          }
        }, {
          key: "last",
          get: function get() {
            return this._items[this._items.length - 1];
          }
        }, {
          key: _Symbol$iterator10,
          value: function value() {
            return this._items[Symbol.iterator]();
          }
        }, {
          key: "push",
          value: function push(t) {
            var e = new Pc([t]);
            return e._items = [].concat(_toConsumableArray(this._items), _toConsumableArray(e._items)), e;
          }
        }, {
          key: "getItem",
          value: function getItem(t) {
            return this._items[t];
          }
        }, {
          key: "getNames",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function getNames() {
            return _regeneratorRuntime.wrap(function getNames$(_context26) {
              while (1) {
                switch (_context26.prev = _context26.next) {
                  case 0:
                    return _context26.delegateYield(this._items.map(function (t) {
                      return t.name;
                    }), "t0", 1);

                  case 1:
                  case "end":
                    return _context26.stop();
                }
              }
            }, getNames, this);
          })
        }, {
          key: "endsWith",
          value: function endsWith(t) {
            return Array.from(this.getNames()).join(" ").endsWith(t);
          }
        }, {
          key: "startsWith",
          value: function startsWith(t) {
            return Array.from(this.getNames()).join(" ").startsWith(t);
          }
        }]);

        return Pc;
      }(Symbol.iterator);

      function Lc(t, e) {
        var n = {
          name: e,
          allowIn: [],
          allowContentOf: [],
          allowWhere: [],
          allowAttributes: [],
          allowAttributesOf: [],
          allowChildren: [],
          inheritTypesFrom: []
        };
        return function (t, e) {
          var _iterator199 = _createForOfIteratorHelper(t),
              _step199;

          try {
            for (_iterator199.s(); !(_step199 = _iterator199.n()).done;) {
              var _n127 = _step199.value;

              var _t146 = Object.keys(_n127).filter(function (t) {
                return t.startsWith("is");
              });

              var _iterator200 = _createForOfIteratorHelper(_t146),
                  _step200;

              try {
                for (_iterator200.s(); !(_step200 = _iterator200.n()).done;) {
                  var _i95 = _step200.value;
                  e[_i95] = _n127[_i95];
                }
              } catch (err) {
                _iterator200.e(err);
              } finally {
                _iterator200.f();
              }
            }
          } catch (err) {
            _iterator199.e(err);
          } finally {
            _iterator199.f();
          }
        }(t, n), Wc(t, n, "allowIn"), Wc(t, n, "allowContentOf"), Wc(t, n, "allowWhere"), Wc(t, n, "allowAttributes"), Wc(t, n, "allowAttributesOf"), Wc(t, n, "allowChildren"), Wc(t, n, "inheritTypesFrom"), function (t, e) {
          var _iterator201 = _createForOfIteratorHelper(t),
              _step201;

          try {
            for (_iterator201.s(); !(_step201 = _iterator201.n()).done;) {
              var _n128 = _step201.value;
              var _t147 = _n128.inheritAllFrom;
              _t147 && (e.allowContentOf.push(_t147), e.allowWhere.push(_t147), e.allowAttributesOf.push(_t147), e.inheritTypesFrom.push(_t147));
            }
          } catch (err) {
            _iterator201.e(err);
          } finally {
            _iterator201.f();
          }
        }(t, n), n;
      }

      function Rc(t, e) {
        var n = t[e];

        var _iterator202 = _createForOfIteratorHelper(n.allowChildren),
            _step202;

        try {
          for (_iterator202.s(); !(_step202 = _iterator202.n()).done;) {
            var _i96 = _step202.value;
            var _n129 = t[_i96];
            _n129 && _n129.allowIn.push(e);
          }
        } catch (err) {
          _iterator202.e(err);
        } finally {
          _iterator202.f();
        }

        n.allowChildren.length = 0;
      }

      function Oc(t, e) {
        var _iterator203 = _createForOfIteratorHelper(t[e].allowContentOf),
            _step203;

        try {
          for (_iterator203.s(); !(_step203 = _iterator203.n()).done;) {
            var _n130 = _step203.value;

            if (t[_n130]) {
              Gc(t, _n130).forEach(function (t) {
                t.allowIn.push(e);
              });
            }
          }
        } catch (err) {
          _iterator203.e(err);
        } finally {
          _iterator203.f();
        }

        delete t[e].allowContentOf;
      }

      function jc(t, e) {
        var _iterator204 = _createForOfIteratorHelper(t[e].allowWhere),
            _step204;

        try {
          for (_iterator204.s(); !(_step204 = _iterator204.n()).done;) {
            var _n131 = _step204.value;
            var _i97 = t[_n131];

            if (_i97) {
              var _t$e$allowIn;

              var _n132 = _i97.allowIn;

              (_t$e$allowIn = t[e].allowIn).push.apply(_t$e$allowIn, _toConsumableArray(_n132));
            }
          }
        } catch (err) {
          _iterator204.e(err);
        } finally {
          _iterator204.f();
        }

        delete t[e].allowWhere;
      }

      function Fc(t, e) {
        var _iterator205 = _createForOfIteratorHelper(t[e].allowAttributesOf),
            _step205;

        try {
          for (_iterator205.s(); !(_step205 = _iterator205.n()).done;) {
            var _n133 = _step205.value;
            var _i98 = t[_n133];

            if (_i98) {
              var _t$e$allowAttributes;

              var _n134 = _i98.allowAttributes;

              (_t$e$allowAttributes = t[e].allowAttributes).push.apply(_t$e$allowAttributes, _toConsumableArray(_n134));
            }
          }
        } catch (err) {
          _iterator205.e(err);
        } finally {
          _iterator205.f();
        }

        delete t[e].allowAttributesOf;
      }

      function Vc(t, e) {
        var n = t[e];

        var _iterator206 = _createForOfIteratorHelper(n.inheritTypesFrom),
            _step206;

        try {
          for (_iterator206.s(); !(_step206 = _iterator206.n()).done;) {
            var _e146 = _step206.value;
            var _i99 = t[_e146];

            if (_i99) {
              var _t148 = Object.keys(_i99).filter(function (t) {
                return t.startsWith("is");
              });

              var _iterator207 = _createForOfIteratorHelper(_t148),
                  _step207;

              try {
                for (_iterator207.s(); !(_step207 = _iterator207.n()).done;) {
                  var _e147 = _step207.value;
                  _e147 in n || (n[_e147] = _i99[_e147]);
                }
              } catch (err) {
                _iterator207.e(err);
              } finally {
                _iterator207.f();
              }
            }
          }
        } catch (err) {
          _iterator206.e(err);
        } finally {
          _iterator206.f();
        }

        delete n.inheritTypesFrom;
      }

      function Uc(t, e) {
        var n = t[e],
            i = n.allowIn.filter(function (e) {
          return t[e];
        });
        n.allowIn = Array.from(new Set(i));
      }

      function Hc(t, e) {
        var n = t[e];

        var _iterator208 = _createForOfIteratorHelper(n.allowIn),
            _step208;

        try {
          for (_iterator208.s(); !(_step208 = _iterator208.n()).done;) {
            var _i100 = _step208.value;

            t[_i100].allowChildren.push(e);
          }
        } catch (err) {
          _iterator208.e(err);
        } finally {
          _iterator208.f();
        }
      }

      function qc(t, e) {
        var n = t[e];
        n.allowAttributes = Array.from(new Set(n.allowAttributes));
      }

      function Wc(t, e, n) {
        var _iterator209 = _createForOfIteratorHelper(t),
            _step209;

        try {
          for (_iterator209.s(); !(_step209 = _iterator209.n()).done;) {
            var _e$n;

            var _i101 = _step209.value;
            "string" == typeof _i101[n] ? e[n].push(_i101[n]) : Array.isArray(_i101[n]) && (_e$n = e[n]).push.apply(_e$n, _toConsumableArray(_i101[n]));
          }
        } catch (err) {
          _iterator209.e(err);
        } finally {
          _iterator209.f();
        }
      }

      function Gc(t, e) {
        var n = t[e];
        return (i = t, Object.keys(i).map(function (t) {
          return i[t];
        })).filter(function (t) {
          return t.allowIn.includes(n.name);
        });
        var i;
      }

      function $c(t) {
        return "string" == typeof t || t.is("documentFragment") ? {
          name: "string" == typeof t ? t : "$documentFragment",
          getAttributeKeys: /*#__PURE__*/_regeneratorRuntime.mark(function getAttributeKeys() {
            return _regeneratorRuntime.wrap(function getAttributeKeys$(_context27) {
              while (1) {
                switch (_context27.prev = _context27.next) {
                  case 0:
                  case "end":
                    return _context27.stop();
                }
              }
            }, getAttributeKeys);
          }),
          getAttribute: function getAttribute() {}
        } : {
          name: t.is("element") ? t.name : "$text",
          getAttributeKeys: /*#__PURE__*/_regeneratorRuntime.mark(function getAttributeKeys() {
            return _regeneratorRuntime.wrap(function getAttributeKeys$(_context28) {
              while (1) {
                switch (_context28.prev = _context28.next) {
                  case 0:
                    return _context28.delegateYield(t.getAttributeKeys(), "t0", 1);

                  case 1:
                  case "end":
                    return _context28.stop();
                }
              }
            }, getAttributeKeys);
          }),
          getAttribute: function getAttribute(e) {
            return t.getAttribute(e);
          }
        };
      }

      function Yc(t, e, n) {
        var _iterator210 = _createForOfIteratorHelper(e.getAttributeKeys()),
            _step210;

        try {
          for (_iterator210.s(); !(_step210 = _iterator210.n()).done;) {
            var _i102 = _step210.value;
            t.checkAttribute(e, _i102) || n.removeAttribute(_i102, e);
          }
        } catch (err) {
          _iterator210.e(err);
        } finally {
          _iterator210.f();
        }
      }

      var Kc = /*#__PURE__*/function () {
        function Kc() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          _classCallCheck(this, Kc);

          this._splitParts = new Map(), this._cursorParents = new Map(), this._modelCursor = null, this.conversionApi = Object.assign({}, t), this.conversionApi.convertItem = this._convertItem.bind(this), this.conversionApi.convertChildren = this._convertChildren.bind(this), this.conversionApi.safeInsert = this._safeInsert.bind(this), this.conversionApi.updateConversionResult = this._updateConversionResult.bind(this), this.conversionApi.splitToAllowedParent = this._splitToAllowedParent.bind(this), this.conversionApi.getSplitParts = this._getSplitParts.bind(this);
        }

        _createClass(Kc, [{
          key: "convert",
          value: function convert(t, e) {
            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ["$root"];
            this.fire("viewCleanup", t), this._modelCursor = function (t, e) {
              var n;

              var _iterator211 = _createForOfIteratorHelper(new Pc(t)),
                  _step211;

              try {
                for (_iterator211.s(); !(_step211 = _iterator211.n()).done;) {
                  var _i103 = _step211.value;
                  var _t149 = {};

                  var _iterator212 = _createForOfIteratorHelper(_i103.getAttributeKeys()),
                      _step212;

                  try {
                    for (_iterator212.s(); !(_step212 = _iterator212.n()).done;) {
                      var _e148 = _step212.value;
                      _t149[_e148] = _i103.getAttribute(_e148);
                    }
                  } catch (err) {
                    _iterator212.e(err);
                  } finally {
                    _iterator212.f();
                  }

                  var _o44 = e.createElement(_i103.name, _t149);

                  n && e.append(_o44, n), n = Va._createAt(_o44, 0);
                }
              } catch (err) {
                _iterator211.e(err);
              } finally {
                _iterator211.f();
              }

              return n;
            }(n, e), this.conversionApi.writer = e, this.conversionApi.consumable = Nc.createFrom(t), this.conversionApi.store = {};

            var _this$_convertItem = this._convertItem(t, this._modelCursor),
                i = _this$_convertItem.modelRange,
                o = e.createDocumentFragment();

            if (i) {
              this._removeEmptyElements();

              for (var _i104 = 0, _Array$from4 = Array.from(this._modelCursor.parent.getChildren()); _i104 < _Array$from4.length; _i104++) {
                var _t150 = _Array$from4[_i104];
                e.append(_t150, o);
              }

              o.markers = function (t, e) {
                var n = new Set(),
                    i = new Map(),
                    o = Wa._createIn(t).getItems();

                var _iterator213 = _createForOfIteratorHelper(o),
                    _step213;

                try {
                  for (_iterator213.s(); !(_step213 = _iterator213.n()).done;) {
                    var _t151 = _step213.value;
                    "$marker" == _t151.name && n.add(_t151);
                  }
                } catch (err) {
                  _iterator213.e(err);
                } finally {
                  _iterator213.f();
                }

                var _iterator214 = _createForOfIteratorHelper(n),
                    _step214;

                try {
                  for (_iterator214.s(); !(_step214 = _iterator214.n()).done;) {
                    var _t152 = _step214.value;

                    var _n135 = _t152.getAttribute("data-name"),
                        _o45 = e.createPositionBefore(_t152);

                    i.has(_n135) ? i.get(_n135).end = _o45.clone() : i.set(_n135, new Wa(_o45.clone())), e.remove(_t152);
                  }
                } catch (err) {
                  _iterator214.e(err);
                } finally {
                  _iterator214.f();
                }

                return i;
              }(o, e);
            }

            return this._modelCursor = null, this._splitParts.clear(), this._cursorParents.clear(), this.conversionApi.writer = null, this.conversionApi.store = null, o;
          }
        }, {
          key: "_convertItem",
          value: function _convertItem(t, e) {
            var n = Object.assign({
              viewItem: t,
              modelCursor: e,
              modelRange: null
            });
            if (t.is("element") ? this.fire("element:" + t.name, n, this.conversionApi) : t.is("$text") ? this.fire("text", n, this.conversionApi) : this.fire("documentFragment", n, this.conversionApi), n.modelRange && !(n.modelRange instanceof Wa)) throw new a("view-conversion-dispatcher-incorrect-result", this);
            return {
              modelRange: n.modelRange,
              modelCursor: n.modelCursor
            };
          }
        }, {
          key: "_convertChildren",
          value: function _convertChildren(t, e) {
            var n = e.is("position") ? e : Va._createAt(e, 0);
            var i = new Wa(n);

            for (var _i105 = 0, _Array$from5 = Array.from(t.getChildren()); _i105 < _Array$from5.length; _i105++) {
              var _e149 = _Array$from5[_i105];

              var _t153 = this._convertItem(_e149, n);

              _t153.modelRange instanceof Wa && (i.end = _t153.modelRange.end, n = _t153.modelCursor);
            }

            return {
              modelRange: i,
              modelCursor: n
            };
          }
        }, {
          key: "_safeInsert",
          value: function _safeInsert(t, e) {
            var n = this._splitToAllowedParent(t, e);

            return !!n && (this.conversionApi.writer.insert(t, n.position), !0);
          }
        }, {
          key: "_updateConversionResult",
          value: function _updateConversionResult(t, e) {
            var n = this._getSplitParts(t),
                i = this.conversionApi.writer;

            e.modelRange || (e.modelRange = i.createRange(i.createPositionBefore(t), i.createPositionAfter(n[n.length - 1])));

            var o = this._cursorParents.get(t);

            e.modelCursor = o ? i.createPositionAt(o, 0) : e.modelRange.end;
          }
        }, {
          key: "_splitToAllowedParent",
          value: function _splitToAllowedParent(t, e) {
            var _this$conversionApi = this.conversionApi,
                n = _this$conversionApi.schema,
                i = _this$conversionApi.writer;
            var o = n.findAllowedParent(e, t);

            if (o) {
              if (o === e.parent) return {
                position: e
              };
              this._modelCursor.parent.getAncestors().includes(o) && (o = null);
            }

            if (!o) return Cc(e, t, n) ? {
              position: _c(e, i)
            } : null;
            var r = this.conversionApi.writer.split(e, o),
                s = [];

            var _iterator215 = _createForOfIteratorHelper(r.range.getWalker()),
                _step215;

            try {
              for (_iterator215.s(); !(_step215 = _iterator215.n()).done;) {
                var _t154 = _step215.value;
                if ("elementEnd" == _t154.type) s.push(_t154.item);else {
                  var _e150 = s.pop(),
                      _n136 = _t154.item;

                  this._registerSplitPair(_e150, _n136);
                }
              }
            } catch (err) {
              _iterator215.e(err);
            } finally {
              _iterator215.f();
            }

            var a = r.range.end.parent;
            return this._cursorParents.set(t, a), {
              position: r.position,
              cursorParent: a
            };
          }
        }, {
          key: "_registerSplitPair",
          value: function _registerSplitPair(t, e) {
            this._splitParts.has(t) || this._splitParts.set(t, [t]);

            var n = this._splitParts.get(t);

            this._splitParts.set(e, n), n.push(e);
          }
        }, {
          key: "_getSplitParts",
          value: function _getSplitParts(t) {
            var e;
            return e = this._splitParts.has(t) ? this._splitParts.get(t) : [t], e;
          }
        }, {
          key: "_removeEmptyElements",
          value: function _removeEmptyElements() {
            var t = !1;

            var _iterator216 = _createForOfIteratorHelper(this._splitParts.keys()),
                _step216;

            try {
              for (_iterator216.s(); !(_step216 = _iterator216.n()).done;) {
                var _e151 = _step216.value;
                _e151.isEmpty && (this.conversionApi.writer.remove(_e151), this._splitParts.delete(_e151), t = !0);
              }
            } catch (err) {
              _iterator216.e(err);
            } finally {
              _iterator216.f();
            }

            t && this._removeEmptyElements();
          }
        }]);

        return Kc;
      }();

      he(Kc, f);

      var Qc = /*#__PURE__*/function () {
        function Qc() {
          _classCallCheck(this, Qc);
        }

        _createClass(Qc, [{
          key: "getHtml",
          value: function getHtml(t) {
            var e = document.implementation.createHTMLDocument("").createElement("div");
            return e.appendChild(t), e.innerHTML;
          }
        }]);

        return Qc;
      }();

      var Zc = /*#__PURE__*/function () {
        function Zc(t) {
          _classCallCheck(this, Zc);

          this.domParser = new DOMParser(), this.domConverter = new us(t, {
            renderingMode: "data"
          }), this.htmlWriter = new Qc();
        }

        _createClass(Zc, [{
          key: "toData",
          value: function toData(t) {
            var e = this.domConverter.viewToDom(t, document);
            return this.htmlWriter.getHtml(e);
          }
        }, {
          key: "toView",
          value: function toView(t) {
            var e = this._toDom(t);

            return this.domConverter.domToView(e);
          }
        }, {
          key: "registerRawContentMatcher",
          value: function registerRawContentMatcher(t) {
            this.domConverter.registerRawContentMatcher(t);
          }
        }, {
          key: "useFillerType",
          value: function useFillerType(t) {
            this.domConverter.blockFillerMode = "marked" == t ? "markedNbsp" : "nbsp";
          }
        }, {
          key: "_toDom",
          value: function _toDom(t) {
            t.match(/<(?:html|body|head|meta)(?:\s[^>]*)?>/i) || (t = "<body>".concat(t, "</body>"));
            var e = this.domParser.parseFromString(t, "text/html"),
                n = e.createDocumentFragment(),
                i = e.body.childNodes;

            for (; i.length > 0;) {
              n.appendChild(i[0]);
            }

            return n;
          }
        }]);

        return Zc;
      }();

      var Jc = /*#__PURE__*/function () {
        function Jc(t, e) {
          var _this62 = this;

          _classCallCheck(this, Jc);

          this.model = t, this.mapper = new Ga(), this.downcastDispatcher = new Ka({
            mapper: this.mapper,
            schema: t.schema
          }), this.downcastDispatcher.on("insert:$text", function (t, e, n) {
            if (!n.consumable.consume(e.item, "insert")) return;
            var i = n.writer,
                o = n.mapper.toViewPosition(e.range.start),
                r = i.createText(e.item.data);
            i.insert(o, r);
          }, {
            priority: "lowest"
          }), this.upcastDispatcher = new Kc({
            schema: t.schema
          }), this.viewDocument = new Jo(e), this.stylesProcessor = e, this.htmlProcessor = new Zc(this.viewDocument), this.processor = this.htmlProcessor, this._viewWriter = new _r(this.viewDocument), this.upcastDispatcher.on("text", function (t, e, _ref20) {
            var n = _ref20.schema,
                i = _ref20.consumable,
                o = _ref20.writer;
            var r = e.modelCursor;
            if (!i.test(e.viewItem)) return;

            if (!n.checkChild(r, "$text")) {
              if (!Cc(r, "$text", n)) return;
              r = _c(r, o);
            }

            i.consume(e.viewItem);
            var s = o.createText(e.viewItem.data);
            o.insert(s, r), e.modelRange = o.createRange(r, r.getShiftedBy(s.offsetSize)), e.modelCursor = e.modelRange.end;
          }, {
            priority: "lowest"
          }), this.upcastDispatcher.on("element", function (t, e, n) {
            if (!e.modelRange && n.consumable.consume(e.viewItem, {
              name: !0
            })) {
              var _n$convertChildren = n.convertChildren(e.viewItem, e.modelCursor),
                  _t155 = _n$convertChildren.modelRange,
                  _i106 = _n$convertChildren.modelCursor;

              e.modelRange = _t155, e.modelCursor = _i106;
            }
          }, {
            priority: "lowest"
          }), this.upcastDispatcher.on("documentFragment", function (t, e, n) {
            if (!e.modelRange && n.consumable.consume(e.viewItem, {
              name: !0
            })) {
              var _n$convertChildren2 = n.convertChildren(e.viewItem, e.modelCursor),
                  _t156 = _n$convertChildren2.modelRange,
                  _i107 = _n$convertChildren2.modelCursor;

              e.modelRange = _t156, e.modelCursor = _i107;
            }
          }, {
            priority: "lowest"
          }), this.decorate("init"), this.decorate("set"), this.decorate("get"), this.on("init", function () {
            _this62.fire("ready");
          }, {
            priority: "lowest"
          }), this.on("ready", function () {
            _this62.model.enqueueChange({
              isUndoable: !1
            }, Ac);
          }, {
            priority: "lowest"
          });
        }

        _createClass(Jc, [{
          key: "get",
          value: function get() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _t$rootName = t.rootName,
                e = _t$rootName === void 0 ? "main" : _t$rootName,
                _t$trim = t.trim,
                n = _t$trim === void 0 ? "empty" : _t$trim;
            if (!this._checkIfRootsExists([e])) throw new a("datacontroller-get-non-existent-root", this);
            var i = this.model.document.getRoot(e);
            return "empty" !== n || this.model.hasContent(i, {
              ignoreWhitespaces: !0
            }) ? this.stringify(i, t) : "";
          }
        }, {
          key: "stringify",
          value: function stringify(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var n = this.toView(t, e);
            return this.processor.toData(n);
          }
        }, {
          key: "toView",
          value: function toView(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var n = this.viewDocument,
                i = this._viewWriter;
            this.mapper.clearBindings();

            var o = Wa._createIn(t),
                r = new Cr(n);

            this.mapper.bindElements(t, r), this.downcastDispatcher.conversionApi.options = e, this.downcastDispatcher.convertInsert(o, i);
            var s = t.is("documentFragment") ? Array.from(t.markers) : function (t) {
              var e = [],
                  n = t.root.document;
              if (!n) return [];

              var i = Wa._createIn(t);

              var _iterator217 = _createForOfIteratorHelper(n.model.markers),
                  _step217;

              try {
                for (_iterator217.s(); !(_step217 = _iterator217.n()).done;) {
                  var _t157 = _step217.value;

                  var _n137 = _t157.getRange(),
                      _o46 = _n137.isCollapsed,
                      _r23 = _n137.start.isEqual(i.start) || _n137.end.isEqual(i.end);

                  if (_o46 && _r23) e.push([_t157.name, _n137]);else {
                    var _o47 = i.getIntersection(_n137);

                    _o47 && e.push([_t157.name, _o47]);
                  }
                }
              } catch (err) {
                _iterator217.e(err);
              } finally {
                _iterator217.f();
              }

              return e.sort(function (_ref21, _ref22) {
                var _ref23 = _slicedToArray(_ref21, 2),
                    t = _ref23[0],
                    e = _ref23[1];

                var _ref24 = _slicedToArray(_ref22, 2),
                    n = _ref24[0],
                    i = _ref24[1];

                if ("after" !== e.end.compareWith(i.start)) return 1;
                if ("before" !== e.start.compareWith(i.end)) return -1;

                switch (e.start.compareWith(i.start)) {
                  case "before":
                    return 1;

                  case "after":
                    return -1;

                  default:
                    switch (e.end.compareWith(i.end)) {
                      case "before":
                        return 1;

                      case "after":
                        return -1;

                      default:
                        return n.localeCompare(t);
                    }

                }
              });
            }(t);

            var _iterator218 = _createForOfIteratorHelper(s),
                _step218;

            try {
              for (_iterator218.s(); !(_step218 = _iterator218.n()).done;) {
                var _step218$value = _slicedToArray(_step218.value, 2),
                    _t158 = _step218$value[0],
                    _e152 = _step218$value[1];

                this.downcastDispatcher.convertMarkerAdd(_t158, _e152, i);
              }
            } catch (err) {
              _iterator218.e(err);
            } finally {
              _iterator218.f();
            }

            return delete this.downcastDispatcher.conversionApi.options, r;
          }
        }, {
          key: "init",
          value: function init(t) {
            var _this63 = this;

            if (this.model.document.version) throw new a("datacontroller-init-document-not-empty", this);
            var e = {};
            if ("string" == typeof t ? e.main = t : e = t, !this._checkIfRootsExists(Object.keys(e))) throw new a("datacontroller-init-non-existent-root", this);
            return this.model.enqueueChange({
              isUndoable: !1
            }, function (t) {
              for (var _i108 = 0, _Object$keys2 = Object.keys(e); _i108 < _Object$keys2.length; _i108++) {
                var _n138 = _Object$keys2[_i108];

                var _i109 = _this63.model.document.getRoot(_n138);

                t.insert(_this63.parse(e[_n138], _i109), _i109, 0);
              }
            }), Promise.resolve();
          }
        }, {
          key: "set",
          value: function set(t) {
            var _this64 = this;

            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var n = {};
            if ("string" == typeof t ? n.main = t : n = t, !this._checkIfRootsExists(Object.keys(n))) throw new a("datacontroller-set-non-existent-root", this);
            this.model.enqueueChange(e.batchType || {}, function (t) {
              t.setSelection(null), t.removeSelectionAttribute(_this64.model.document.selection.getAttributeKeys());

              for (var _i110 = 0, _Object$keys3 = Object.keys(n); _i110 < _Object$keys3.length; _i110++) {
                var _e153 = _Object$keys3[_i110];

                var _i111 = _this64.model.document.getRoot(_e153);

                t.remove(t.createRangeIn(_i111)), t.insert(_this64.parse(n[_e153], _i111), _i111, 0);
              }
            });
          }
        }, {
          key: "parse",
          value: function parse(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
            var n = this.processor.toView(t);
            return this.toModel(n, e);
          }
        }, {
          key: "toModel",
          value: function toModel(t) {
            var _this65 = this;

            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
            return this.model.change(function (n) {
              return _this65.upcastDispatcher.convert(t, n, e);
            });
          }
        }, {
          key: "addStyleProcessorRules",
          value: function addStyleProcessorRules(t) {
            t(this.stylesProcessor);
          }
        }, {
          key: "registerRawContentMatcher",
          value: function registerRawContentMatcher(t) {
            this.processor && this.processor !== this.htmlProcessor && this.processor.registerRawContentMatcher(t), this.htmlProcessor.registerRawContentMatcher(t);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.stopListening();
          }
        }, {
          key: "_checkIfRootsExists",
          value: function _checkIfRootsExists(t) {
            var _iterator219 = _createForOfIteratorHelper(t),
                _step219;

            try {
              for (_iterator219.s(); !(_step219 = _iterator219.n()).done;) {
                var _e154 = _step219.value;
                if (!this.model.document.getRootNames().includes(_e154)) return !1;
              }
            } catch (err) {
              _iterator219.e(err);
            } finally {
              _iterator219.f();
            }

            return !0;
          }
        }]);

        return Jc;
      }();

      he(Jc, re);

      var Xc = /*#__PURE__*/function () {
        function Xc(t, e) {
          _classCallCheck(this, Xc);

          this._helpers = new Map(), this._downcast = Ii(t), this._createConversionHelpers({
            name: "downcast",
            dispatchers: this._downcast,
            isDowncast: !0
          }), this._upcast = Ii(e), this._createConversionHelpers({
            name: "upcast",
            dispatchers: this._upcast,
            isDowncast: !1
          });
        }

        _createClass(Xc, [{
          key: "addAlias",
          value: function addAlias(t, e) {
            var n = this._downcast.includes(e);

            if (!this._upcast.includes(e) && !n) throw new a("conversion-add-alias-dispatcher-not-registered", this);

            this._createConversionHelpers({
              name: t,
              dispatchers: [e],
              isDowncast: n
            });
          }
        }, {
          key: "for",
          value: function _for(t) {
            if (!this._helpers.has(t)) throw new a("conversion-for-unknown-group", this);
            return this._helpers.get(t);
          }
        }, {
          key: "elementToElement",
          value: function elementToElement(t) {
            this.for("downcast").elementToElement(t);

            var _iterator220 = _createForOfIteratorHelper(tl(t)),
                _step220;

            try {
              for (_iterator220.s(); !(_step220 = _iterator220.n()).done;) {
                var _step220$value = _step220.value,
                    _e155 = _step220$value.model,
                    _n139 = _step220$value.view;
                this.for("upcast").elementToElement({
                  model: _e155,
                  view: _n139,
                  converterPriority: t.converterPriority
                });
              }
            } catch (err) {
              _iterator220.e(err);
            } finally {
              _iterator220.f();
            }
          }
        }, {
          key: "attributeToElement",
          value: function attributeToElement(t) {
            this.for("downcast").attributeToElement(t);

            var _iterator221 = _createForOfIteratorHelper(tl(t)),
                _step221;

            try {
              for (_iterator221.s(); !(_step221 = _iterator221.n()).done;) {
                var _step221$value = _step221.value,
                    _e156 = _step221$value.model,
                    _n140 = _step221$value.view;
                this.for("upcast").elementToAttribute({
                  view: _n140,
                  model: _e156,
                  converterPriority: t.converterPriority
                });
              }
            } catch (err) {
              _iterator221.e(err);
            } finally {
              _iterator221.f();
            }
          }
        }, {
          key: "attributeToAttribute",
          value: function attributeToAttribute(t) {
            this.for("downcast").attributeToAttribute(t);

            var _iterator222 = _createForOfIteratorHelper(tl(t)),
                _step222;

            try {
              for (_iterator222.s(); !(_step222 = _iterator222.n()).done;) {
                var _step222$value = _step222.value,
                    _e157 = _step222$value.model,
                    _n141 = _step222$value.view;
                this.for("upcast").attributeToAttribute({
                  view: _n141,
                  model: _e157
                });
              }
            } catch (err) {
              _iterator222.e(err);
            } finally {
              _iterator222.f();
            }
          }
        }, {
          key: "_createConversionHelpers",
          value: function _createConversionHelpers(_ref25) {
            var t = _ref25.name,
                e = _ref25.dispatchers,
                n = _ref25.isDowncast;
            if (this._helpers.has(t)) throw new a("conversion-group-exists", this);
            var i = n ? new gc(e) : new vc(e);

            this._helpers.set(t, i);
          }
        }]);

        return Xc;
      }();

      function tl(t) {
        var _iterator223, _step223, _e158, _n142, _i112, _o48;

        return _regeneratorRuntime.wrap(function tl$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                if (!t.model.values) {
                  _context29.next = 20;
                  break;
                }

                _iterator223 = _createForOfIteratorHelper(t.model.values);
                _context29.prev = 2;

                _iterator223.s();

              case 4:
                if ((_step223 = _iterator223.n()).done) {
                  _context29.next = 10;
                  break;
                }

                _e158 = _step223.value;
                _n142 = {
                  key: t.model.key,
                  value: _e158
                }, _i112 = t.view[_e158], _o48 = t.upcastAlso ? t.upcastAlso[_e158] : void 0;
                return _context29.delegateYield(el(_n142, _i112, _o48), "t0", 8);

              case 8:
                _context29.next = 4;
                break;

              case 10:
                _context29.next = 15;
                break;

              case 12:
                _context29.prev = 12;
                _context29.t1 = _context29["catch"](2);

                _iterator223.e(_context29.t1);

              case 15:
                _context29.prev = 15;

                _iterator223.f();

                return _context29.finish(15);

              case 18:
                _context29.next = 21;
                break;

              case 20:
                return _context29.delegateYield(el(t.model, t.view, t.upcastAlso), "t2", 21);

              case 21:
              case "end":
                return _context29.stop();
            }
          }
        }, _marked, null, [[2, 12, 15, 18]]);
      }

      function el(t, e, n) {
        var _iterator224, _step224, _e159;

        return _regeneratorRuntime.wrap(function el$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return {
                  model: t,
                  view: e
                };

              case 2:
                if (!n) {
                  _context30.next = 20;
                  break;
                }

                _iterator224 = _createForOfIteratorHelper(Ii(n));
                _context30.prev = 4;

                _iterator224.s();

              case 6:
                if ((_step224 = _iterator224.n()).done) {
                  _context30.next = 12;
                  break;
                }

                _e159 = _step224.value;
                _context30.next = 10;
                return {
                  model: t,
                  view: _e159
                };

              case 10:
                _context30.next = 6;
                break;

              case 12:
                _context30.next = 17;
                break;

              case 14:
                _context30.prev = 14;
                _context30.t0 = _context30["catch"](4);

                _iterator224.e(_context30.t0);

              case 17:
                _context30.prev = 17;

                _iterator224.f();

                return _context30.finish(17);

              case 20:
              case "end":
                return _context30.stop();
            }
          }
        }, _marked2, null, [[4, 14, 17, 20]]);
      }

      var nl = /*#__PURE__*/function () {
        function nl() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          _classCallCheck(this, nl);

          "string" == typeof t && (t = "transparent" === t ? {
            isUndoable: !1
          } : {}, c("batch-constructor-deprecated-string-type"));
          var _t159 = t,
              _t159$isUndoable = _t159.isUndoable,
              e = _t159$isUndoable === void 0 ? !0 : _t159$isUndoable,
              _t159$isLocal = _t159.isLocal,
              n = _t159$isLocal === void 0 ? !0 : _t159$isLocal,
              _t159$isUndo = _t159.isUndo,
              i = _t159$isUndo === void 0 ? !1 : _t159$isUndo,
              _t159$isTyping = _t159.isTyping,
              o = _t159$isTyping === void 0 ? !1 : _t159$isTyping;
          this.operations = [], this.isUndoable = e, this.isLocal = n, this.isUndo = i, this.isTyping = o;
        }

        _createClass(nl, [{
          key: "type",
          get: function get() {
            return c("batch-type-deprecated"), "default";
          }
        }, {
          key: "baseVersion",
          get: function get() {
            var _iterator225 = _createForOfIteratorHelper(this.operations),
                _step225;

            try {
              for (_iterator225.s(); !(_step225 = _iterator225.n()).done;) {
                var _t160 = _step225.value;
                if (null !== _t160.baseVersion) return _t160.baseVersion;
              }
            } catch (err) {
              _iterator225.e(err);
            } finally {
              _iterator225.f();
            }

            return null;
          }
        }, {
          key: "addOperation",
          value: function addOperation(t) {
            return t.batch = this, this.operations.push(t), t;
          }
        }]);

        return nl;
      }();

      var il = /*#__PURE__*/function () {
        function il(t) {
          _classCallCheck(this, il);

          this.baseVersion = t, this.isDocumentOperation = null !== this.baseVersion, this.batch = null;
        }

        _createClass(il, [{
          key: "_validate",
          value: function _validate() {}
        }, {
          key: "toJSON",
          value: function toJSON() {
            var t = Object.assign({}, this);
            return t.__className = this.constructor.className, delete t.batch, delete t.isDocumentOperation, t;
          }
        }], [{
          key: "className",
          get: function get() {
            return "Operation";
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(t) {
            return new this(t.baseVersion);
          }
        }]);

        return il;
      }();

      var ol = /*#__PURE__*/function (_Symbol$iterator11) {
        function ol(t) {
          _classCallCheck(this, ol);

          this.markers = new Map(), this._children = new Ra(), t && this._insertChild(0, t);
        }

        _createClass(ol, [{
          key: _Symbol$iterator11,
          value: function value() {
            return this.getChildren();
          }
        }, {
          key: "childCount",
          get: function get() {
            return this._children.length;
          }
        }, {
          key: "maxOffset",
          get: function get() {
            return this._children.maxOffset;
          }
        }, {
          key: "isEmpty",
          get: function get() {
            return 0 === this.childCount;
          }
        }, {
          key: "root",
          get: function get() {
            return this;
          }
        }, {
          key: "parent",
          get: function get() {
            return null;
          }
        }, {
          key: "is",
          value: function is(t) {
            return "documentFragment" === t || "model:documentFragment" === t;
          }
        }, {
          key: "getChild",
          value: function getChild(t) {
            return this._children.getNode(t);
          }
        }, {
          key: "getChildren",
          value: function getChildren() {
            return this._children[Symbol.iterator]();
          }
        }, {
          key: "getChildIndex",
          value: function getChildIndex(t) {
            return this._children.getNodeIndex(t);
          }
        }, {
          key: "getChildStartOffset",
          value: function getChildStartOffset(t) {
            return this._children.getNodeStartOffset(t);
          }
        }, {
          key: "getPath",
          value: function getPath() {
            return [];
          }
        }, {
          key: "getNodeByPath",
          value: function getNodeByPath(t) {
            var e = this;

            var _iterator226 = _createForOfIteratorHelper(t),
                _step226;

            try {
              for (_iterator226.s(); !(_step226 = _iterator226.n()).done;) {
                var _n143 = _step226.value;
                e = e.getChild(e.offsetToIndex(_n143));
              }
            } catch (err) {
              _iterator226.e(err);
            } finally {
              _iterator226.f();
            }

            return e;
          }
        }, {
          key: "offsetToIndex",
          value: function offsetToIndex(t) {
            return this._children.offsetToIndex(t);
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var t = [];

            var _iterator227 = _createForOfIteratorHelper(this._children),
                _step227;

            try {
              for (_iterator227.s(); !(_step227 = _iterator227.n()).done;) {
                var _e160 = _step227.value;
                t.push(_e160.toJSON());
              }
            } catch (err) {
              _iterator227.e(err);
            } finally {
              _iterator227.f();
            }

            return t;
          }
        }, {
          key: "_appendChild",
          value: function _appendChild(t) {
            this._insertChild(this.childCount, t);
          }
        }, {
          key: "_insertChild",
          value: function _insertChild(t, e) {
            var n = function (t) {
              if ("string" == typeof t) return [new Pa(t)];
              Ei(t) || (t = [t]);
              return Array.from(t).map(function (t) {
                return "string" == typeof t ? new Pa(t) : t instanceof La ? new Pa(t.data, t.getAttributes()) : t;
              });
            }(e);

            var _iterator228 = _createForOfIteratorHelper(n),
                _step228;

            try {
              for (_iterator228.s(); !(_step228 = _iterator228.n()).done;) {
                var _t161 = _step228.value;
                null !== _t161.parent && _t161._remove(), _t161.parent = this;
              }
            } catch (err) {
              _iterator228.e(err);
            } finally {
              _iterator228.f();
            }

            this._children._insertNodes(t, n);
          }
        }, {
          key: "_removeChildren",
          value: function _removeChildren(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            var n = this._children._removeNodes(t, e);

            var _iterator229 = _createForOfIteratorHelper(n),
                _step229;

            try {
              for (_iterator229.s(); !(_step229 = _iterator229.n()).done;) {
                var _t162 = _step229.value;
                _t162.parent = null;
              }
            } catch (err) {
              _iterator229.e(err);
            } finally {
              _iterator229.f();
            }

            return n;
          }
        }], [{
          key: "fromJSON",
          value: function fromJSON(t) {
            var e = [];

            var _iterator230 = _createForOfIteratorHelper(t),
                _step230;

            try {
              for (_iterator230.s(); !(_step230 = _iterator230.n()).done;) {
                var _n144 = _step230.value;
                _n144.name ? e.push(Oa.fromJSON(_n144)) : e.push(Pa.fromJSON(_n144));
              }
            } catch (err) {
              _iterator230.e(err);
            } finally {
              _iterator230.f();
            }

            return new ol(e);
          }
        }]);

        return ol;
      }(Symbol.iterator);

      function rl(t, e) {
        var n = (e = cl(e)).reduce(function (t, e) {
          return t + e.offsetSize;
        }, 0),
            i = t.parent;
        dl(t);
        var o = t.index;
        return i._insertChild(o, e), ll(i, o + e.length), ll(i, o), new Wa(t, t.getShiftedBy(n));
      }

      function sl(t) {
        if (!t.isFlat) throw new a("operation-utils-remove-range-not-flat", this);
        var e = t.start.parent;
        dl(t.start), dl(t.end);

        var n = e._removeChildren(t.start.index, t.end.index - t.start.index);

        return ll(e, t.start.index), n;
      }

      function al(t, e) {
        if (!t.isFlat) throw new a("operation-utils-move-range-not-flat", this);
        var n = sl(t);
        return rl(e = e._getTransformedByDeletion(t.start, t.end.offset - t.start.offset), n);
      }

      function cl(t) {
        var e = [];
        t instanceof Array || (t = [t]);

        for (var _n145 = 0; _n145 < t.length; _n145++) {
          if ("string" == typeof t[_n145]) e.push(new Pa(t[_n145]));else if (t[_n145] instanceof La) e.push(new Pa(t[_n145].data, t[_n145].getAttributes()));else if (t[_n145] instanceof ol || t[_n145] instanceof Ra) {
            var _iterator231 = _createForOfIteratorHelper(t[_n145]),
                _step231;

            try {
              for (_iterator231.s(); !(_step231 = _iterator231.n()).done;) {
                var _i113 = _step231.value;
                e.push(_i113);
              }
            } catch (err) {
              _iterator231.e(err);
            } finally {
              _iterator231.f();
            }
          } else t[_n145] instanceof za && e.push(t[_n145]);
        }

        for (var _t163 = 1; _t163 < e.length; _t163++) {
          var _n146 = e[_t163],
              _i114 = e[_t163 - 1];
          _n146 instanceof Pa && _i114 instanceof Pa && hl(_n146, _i114) && (e.splice(_t163 - 1, 2, new Pa(_i114.data + _n146.data, _i114.getAttributes())), _t163--);
        }

        return e;
      }

      function ll(t, e) {
        var n = t.getChild(e - 1),
            i = t.getChild(e);

        if (n && i && n.is("$text") && i.is("$text") && hl(n, i)) {
          var _o49 = new Pa(n.data + i.data, n.getAttributes());

          t._removeChildren(e - 1, 2), t._insertChild(e - 1, _o49);
        }
      }

      function dl(t) {
        var e = t.textNode,
            n = t.parent;

        if (e) {
          var _i115 = t.offset - e.startOffset,
              _o50 = e.index;

          n._removeChildren(_o50, 1);

          var _r24 = new Pa(e.data.substr(0, _i115), e.getAttributes()),
              _s16 = new Pa(e.data.substr(_i115), e.getAttributes());

          n._insertChild(_o50, [_r24, _s16]);
        }
      }

      function hl(t, e) {
        var n = t.getAttributes(),
            i = e.getAttributes();

        var _iterator232 = _createForOfIteratorHelper(n),
            _step232;

        try {
          for (_iterator232.s(); !(_step232 = _iterator232.n()).done;) {
            var _t164 = _step232.value;
            if (_t164[1] !== e.getAttribute(_t164[0])) return !1;
            i.next();
          }
        } catch (err) {
          _iterator232.e(err);
        } finally {
          _iterator232.f();
        }

        return i.next().done;
      }

      var ul = function ul(t, e) {
        return Fs(t, e);
      };

      var gl = /*#__PURE__*/function (_il) {
        _inherits(gl, _il);

        var _super28 = _createSuper(gl);

        function gl(t, e, n, i, o) {
          var _this66;

          _classCallCheck(this, gl);

          _this66 = _super28.call(this, o), _this66.range = t.clone(), _this66.key = e, _this66.oldValue = void 0 === n ? null : n, _this66.newValue = void 0 === i ? null : i;
          return _this66;
        }

        _createClass(gl, [{
          key: "type",
          get: function get() {
            return null === this.oldValue ? "addAttribute" : null === this.newValue ? "removeAttribute" : "changeAttribute";
          }
        }, {
          key: "clone",
          value: function clone() {
            return new gl(this.range, this.key, this.oldValue, this.newValue, this.baseVersion);
          }
        }, {
          key: "getReversed",
          value: function getReversed() {
            return new gl(this.range, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var t = _get(_getPrototypeOf(gl.prototype), "toJSON", this).call(this);

            return t.range = this.range.toJSON(), t;
          }
        }, {
          key: "_validate",
          value: function _validate() {
            if (!this.range.isFlat) throw new a("attribute-operation-range-not-flat", this);

            var _iterator233 = _createForOfIteratorHelper(this.range.getItems({
              shallow: !0
            })),
                _step233;

            try {
              for (_iterator233.s(); !(_step233 = _iterator233.n()).done;) {
                var _t165 = _step233.value;
                if (null !== this.oldValue && !ul(_t165.getAttribute(this.key), this.oldValue)) throw new a("attribute-operation-wrong-old-value", this, {
                  item: _t165,
                  key: this.key,
                  value: this.oldValue
                });
                if (null === this.oldValue && null !== this.newValue && _t165.hasAttribute(this.key)) throw new a("attribute-operation-attribute-exists", this, {
                  node: _t165,
                  key: this.key
                });
              }
            } catch (err) {
              _iterator233.e(err);
            } finally {
              _iterator233.f();
            }
          }
        }, {
          key: "_execute",
          value: function _execute() {
            ul(this.oldValue, this.newValue) || function (t, e, n) {
              dl(t.start), dl(t.end);

              var _iterator234 = _createForOfIteratorHelper(t.getItems({
                shallow: !0
              })),
                  _step234;

              try {
                for (_iterator234.s(); !(_step234 = _iterator234.n()).done;) {
                  var _i116 = _step234.value;

                  var _t166 = _i116.is("$textProxy") ? _i116.textNode : _i116;

                  null !== n ? _t166._setAttribute(e, n) : _t166._removeAttribute(e), ll(_t166.parent, _t166.index);
                }
              } catch (err) {
                _iterator234.e(err);
              } finally {
                _iterator234.f();
              }

              ll(t.end.parent, t.end.index);
            }(this.range, this.key, this.newValue);
          }
        }], [{
          key: "className",
          get: function get() {
            return "AttributeOperation";
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(t, e) {
            return new gl(Wa.fromJSON(t.range, e), t.key, t.oldValue, t.newValue, t.baseVersion);
          }
        }]);

        return gl;
      }(il);

      var ml = /*#__PURE__*/function (_il2) {
        _inherits(ml, _il2);

        var _super29 = _createSuper(ml);

        function ml(t, e) {
          var _this67;

          _classCallCheck(this, ml);

          _this67 = _super29.call(this, null), _this67.sourcePosition = t.clone(), _this67.howMany = e;
          return _this67;
        }

        _createClass(ml, [{
          key: "type",
          get: function get() {
            return "detach";
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var t = _get(_getPrototypeOf(ml.prototype), "toJSON", this).call(this);

            return t.sourcePosition = this.sourcePosition.toJSON(), t;
          }
        }, {
          key: "_validate",
          value: function _validate() {
            if (this.sourcePosition.root.document) throw new a("detach-operation-on-document-node", this);
          }
        }, {
          key: "_execute",
          value: function _execute() {
            sl(Wa._createFromPositionAndShift(this.sourcePosition, this.howMany));
          }
        }], [{
          key: "className",
          get: function get() {
            return "DetachOperation";
          }
        }]);

        return ml;
      }(il);

      var pl = /*#__PURE__*/function (_il3) {
        _inherits(pl, _il3);

        var _super30 = _createSuper(pl);

        function pl(t, e, n, i) {
          var _this68;

          _classCallCheck(this, pl);

          _this68 = _super30.call(this, i), _this68.sourcePosition = t.clone(), _this68.sourcePosition.stickiness = "toNext", _this68.howMany = e, _this68.targetPosition = n.clone(), _this68.targetPosition.stickiness = "toNone";
          return _this68;
        }

        _createClass(pl, [{
          key: "type",
          get: function get() {
            return "$graveyard" == this.targetPosition.root.rootName ? "remove" : "$graveyard" == this.sourcePosition.root.rootName ? "reinsert" : "move";
          }
        }, {
          key: "clone",
          value: function clone() {
            return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion);
          }
        }, {
          key: "getMovedRangeStart",
          value: function getMovedRangeStart() {
            return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany);
          }
        }, {
          key: "getReversed",
          value: function getReversed() {
            var t = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany);

            return new this.constructor(this.getMovedRangeStart(), this.howMany, t, this.baseVersion + 1);
          }
        }, {
          key: "_validate",
          value: function _validate() {
            var t = this.sourcePosition.parent,
                e = this.targetPosition.parent,
                n = this.sourcePosition.offset,
                i = this.targetPosition.offset;
            if (n + this.howMany > t.maxOffset) throw new a("move-operation-nodes-do-not-exist", this);
            if (t === e && n < i && i < n + this.howMany) throw new a("move-operation-range-into-itself", this);

            if (this.sourcePosition.root == this.targetPosition.root && "prefix" == Li(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath())) {
              var _t167 = this.sourcePosition.path.length - 1;

              if (this.targetPosition.path[_t167] >= n && this.targetPosition.path[_t167] < n + this.howMany) throw new a("move-operation-node-into-itself", this);
            }
          }
        }, {
          key: "_execute",
          value: function _execute() {
            al(Wa._createFromPositionAndShift(this.sourcePosition, this.howMany), this.targetPosition);
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var t = _get(_getPrototypeOf(pl.prototype), "toJSON", this).call(this);

            return t.sourcePosition = this.sourcePosition.toJSON(), t.targetPosition = this.targetPosition.toJSON(), t;
          }
        }], [{
          key: "className",
          get: function get() {
            return "MoveOperation";
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(t, e) {
            var n = Va.fromJSON(t.sourcePosition, e),
                i = Va.fromJSON(t.targetPosition, e);
            return new this(n, t.howMany, i, t.baseVersion);
          }
        }]);

        return pl;
      }(il);

      var fl = /*#__PURE__*/function (_il4) {
        _inherits(fl, _il4);

        var _super31 = _createSuper(fl);

        function fl(t, e, n) {
          var _this69;

          _classCallCheck(this, fl);

          _this69 = _super31.call(this, n), _this69.position = t.clone(), _this69.position.stickiness = "toNone", _this69.nodes = new Ra(cl(e)), _this69.shouldReceiveAttributes = !1;
          return _this69;
        }

        _createClass(fl, [{
          key: "type",
          get: function get() {
            return "insert";
          }
        }, {
          key: "howMany",
          get: function get() {
            return this.nodes.maxOffset;
          }
        }, {
          key: "clone",
          value: function clone() {
            var t = new Ra(_toConsumableArray(this.nodes).map(function (t) {
              return t._clone(!0);
            })),
                e = new fl(this.position, t, this.baseVersion);
            return e.shouldReceiveAttributes = this.shouldReceiveAttributes, e;
          }
        }, {
          key: "getReversed",
          value: function getReversed() {
            var t = this.position.root.document.graveyard,
                e = new Va(t, [0]);
            return new pl(this.position, this.nodes.maxOffset, e, this.baseVersion + 1);
          }
        }, {
          key: "_validate",
          value: function _validate() {
            var t = this.position.parent;
            if (!t || t.maxOffset < this.position.offset) throw new a("insert-operation-position-invalid", this);
          }
        }, {
          key: "_execute",
          value: function _execute() {
            var t = this.nodes;
            this.nodes = new Ra(_toConsumableArray(t).map(function (t) {
              return t._clone(!0);
            })), rl(this.position, t);
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var t = _get(_getPrototypeOf(fl.prototype), "toJSON", this).call(this);

            return t.position = this.position.toJSON(), t.nodes = this.nodes.toJSON(), t;
          }
        }], [{
          key: "className",
          get: function get() {
            return "InsertOperation";
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(t, e) {
            var n = [];

            var _iterator235 = _createForOfIteratorHelper(t.nodes),
                _step235;

            try {
              for (_iterator235.s(); !(_step235 = _iterator235.n()).done;) {
                var _e161 = _step235.value;
                _e161.name ? n.push(Oa.fromJSON(_e161)) : n.push(Pa.fromJSON(_e161));
              }
            } catch (err) {
              _iterator235.e(err);
            } finally {
              _iterator235.f();
            }

            var i = new fl(Va.fromJSON(t.position, e), n, t.baseVersion);
            return i.shouldReceiveAttributes = t.shouldReceiveAttributes, i;
          }
        }]);

        return fl;
      }(il);

      var kl = /*#__PURE__*/function (_il5) {
        _inherits(kl, _il5);

        var _super32 = _createSuper(kl);

        function kl(t, e, n, i, o, r) {
          var _this70;

          _classCallCheck(this, kl);

          _this70 = _super32.call(this, r), _this70.name = t, _this70.oldRange = e ? e.clone() : null, _this70.newRange = n ? n.clone() : null, _this70.affectsData = o, _this70._markers = i;
          return _this70;
        }

        _createClass(kl, [{
          key: "type",
          get: function get() {
            return "marker";
          }
        }, {
          key: "clone",
          value: function clone() {
            return new kl(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
          }
        }, {
          key: "getReversed",
          value: function getReversed() {
            return new kl(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
          }
        }, {
          key: "_execute",
          value: function _execute() {
            var t = this.newRange ? "_set" : "_remove";

            this._markers[t](this.name, this.newRange, !0, this.affectsData);
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var t = _get(_getPrototypeOf(kl.prototype), "toJSON", this).call(this);

            return this.oldRange && (t.oldRange = this.oldRange.toJSON()), this.newRange && (t.newRange = this.newRange.toJSON()), delete t._markers, t;
          }
        }], [{
          key: "className",
          get: function get() {
            return "MarkerOperation";
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(t, e) {
            return new kl(t.name, t.oldRange ? Wa.fromJSON(t.oldRange, e) : null, t.newRange ? Wa.fromJSON(t.newRange, e) : null, e.model.markers, t.affectsData, t.baseVersion);
          }
        }]);

        return kl;
      }(il);

      var bl = /*#__PURE__*/function (_il6) {
        _inherits(bl, _il6);

        var _super33 = _createSuper(bl);

        function bl(t, e, n, i) {
          var _this71;

          _classCallCheck(this, bl);

          _this71 = _super33.call(this, i), _this71.position = t, _this71.position.stickiness = "toNext", _this71.oldName = e, _this71.newName = n;
          return _this71;
        }

        _createClass(bl, [{
          key: "type",
          get: function get() {
            return "rename";
          }
        }, {
          key: "clone",
          value: function clone() {
            return new bl(this.position.clone(), this.oldName, this.newName, this.baseVersion);
          }
        }, {
          key: "getReversed",
          value: function getReversed() {
            return new bl(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1);
          }
        }, {
          key: "_validate",
          value: function _validate() {
            var t = this.position.nodeAfter;
            if (!(t instanceof Oa)) throw new a("rename-operation-wrong-position", this);
            if (t.name !== this.oldName) throw new a("rename-operation-wrong-name", this);
          }
        }, {
          key: "_execute",
          value: function _execute() {
            this.position.nodeAfter.name = this.newName;
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var t = _get(_getPrototypeOf(bl.prototype), "toJSON", this).call(this);

            return t.position = this.position.toJSON(), t;
          }
        }], [{
          key: "className",
          get: function get() {
            return "RenameOperation";
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(t, e) {
            return new bl(Va.fromJSON(t.position, e), t.oldName, t.newName, t.baseVersion);
          }
        }]);

        return bl;
      }(il);

      var wl = /*#__PURE__*/function (_il7) {
        _inherits(wl, _il7);

        var _super34 = _createSuper(wl);

        function wl(t, e, n, i, o) {
          var _this72;

          _classCallCheck(this, wl);

          _this72 = _super34.call(this, o), _this72.root = t, _this72.key = e, _this72.oldValue = n, _this72.newValue = i;
          return _this72;
        }

        _createClass(wl, [{
          key: "type",
          get: function get() {
            return null === this.oldValue ? "addRootAttribute" : null === this.newValue ? "removeRootAttribute" : "changeRootAttribute";
          }
        }, {
          key: "clone",
          value: function clone() {
            return new wl(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
          }
        }, {
          key: "getReversed",
          value: function getReversed() {
            return new wl(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
          }
        }, {
          key: "_validate",
          value: function _validate() {
            if (this.root != this.root.root || this.root.is("documentFragment")) throw new a("rootattribute-operation-not-a-root", this, {
              root: this.root,
              key: this.key
            });
            if (null !== this.oldValue && this.root.getAttribute(this.key) !== this.oldValue) throw new a("rootattribute-operation-wrong-old-value", this, {
              root: this.root,
              key: this.key
            });
            if (null === this.oldValue && null !== this.newValue && this.root.hasAttribute(this.key)) throw new a("rootattribute-operation-attribute-exists", this, {
              root: this.root,
              key: this.key
            });
          }
        }, {
          key: "_execute",
          value: function _execute() {
            null !== this.newValue ? this.root._setAttribute(this.key, this.newValue) : this.root._removeAttribute(this.key);
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var t = _get(_getPrototypeOf(wl.prototype), "toJSON", this).call(this);

            return t.root = this.root.toJSON(), t;
          }
        }], [{
          key: "className",
          get: function get() {
            return "RootAttributeOperation";
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(t, e) {
            if (!e.getRoot(t.root)) throw new a("rootattribute-operation-fromjson-no-root", this, {
              rootName: t.root
            });
            return new wl(e.getRoot(t.root), t.key, t.oldValue, t.newValue, t.baseVersion);
          }
        }]);

        return wl;
      }(il);

      var Al = /*#__PURE__*/function (_il8) {
        _inherits(Al, _il8);

        var _super35 = _createSuper(Al);

        function Al(t, e, n, i, o) {
          var _this73;

          _classCallCheck(this, Al);

          _this73 = _super35.call(this, o), _this73.sourcePosition = t.clone(), _this73.sourcePosition.stickiness = "toPrevious", _this73.howMany = e, _this73.targetPosition = n.clone(), _this73.targetPosition.stickiness = "toNext", _this73.graveyardPosition = i.clone();
          return _this73;
        }

        _createClass(Al, [{
          key: "type",
          get: function get() {
            return "merge";
          }
        }, {
          key: "deletionPosition",
          get: function get() {
            return new Va(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1));
          }
        }, {
          key: "movedRange",
          get: function get() {
            var t = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
            return new Wa(this.sourcePosition, t);
          }
        }, {
          key: "clone",
          value: function clone() {
            return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion);
          }
        }, {
          key: "getReversed",
          value: function getReversed() {
            var t = this.targetPosition._getTransformedByMergeOperation(this),
                e = this.sourcePosition.path.slice(0, -1),
                n = new Va(this.sourcePosition.root, e)._getTransformedByMergeOperation(this);

            return new Cl(t, this.howMany, n, this.graveyardPosition, this.baseVersion + 1);
          }
        }, {
          key: "_validate",
          value: function _validate() {
            var t = this.sourcePosition.parent,
                e = this.targetPosition.parent;
            if (!t.parent) throw new a("merge-operation-source-position-invalid", this);
            if (!e.parent) throw new a("merge-operation-target-position-invalid", this);
            if (this.howMany != t.maxOffset) throw new a("merge-operation-how-many-invalid", this);
          }
        }, {
          key: "_execute",
          value: function _execute() {
            var t = this.sourcePosition.parent;
            al(Wa._createIn(t), this.targetPosition), al(Wa._createOn(t), this.graveyardPosition);
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var t = _get(_getPrototypeOf(Al.prototype), "toJSON", this).call(this);

            return t.sourcePosition = t.sourcePosition.toJSON(), t.targetPosition = t.targetPosition.toJSON(), t.graveyardPosition = t.graveyardPosition.toJSON(), t;
          }
        }], [{
          key: "className",
          get: function get() {
            return "MergeOperation";
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(t, e) {
            var n = Va.fromJSON(t.sourcePosition, e),
                i = Va.fromJSON(t.targetPosition, e),
                o = Va.fromJSON(t.graveyardPosition, e);
            return new this(n, t.howMany, i, o, t.baseVersion);
          }
        }]);

        return Al;
      }(il);

      var Cl = /*#__PURE__*/function (_il9) {
        _inherits(Cl, _il9);

        var _super36 = _createSuper(Cl);

        function Cl(t, e, n, i, o) {
          var _this74;

          _classCallCheck(this, Cl);

          _this74 = _super36.call(this, o), _this74.splitPosition = t.clone(), _this74.splitPosition.stickiness = "toNext", _this74.howMany = e, _this74.insertionPosition = n, _this74.graveyardPosition = i ? i.clone() : null, _this74.graveyardPosition && (_this74.graveyardPosition.stickiness = "toNext");
          return _this74;
        }

        _createClass(Cl, [{
          key: "type",
          get: function get() {
            return "split";
          }
        }, {
          key: "moveTargetPosition",
          get: function get() {
            var t = this.insertionPosition.path.slice();
            return t.push(0), new Va(this.insertionPosition.root, t);
          }
        }, {
          key: "movedRange",
          get: function get() {
            var t = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
            return new Wa(this.splitPosition, t);
          }
        }, {
          key: "clone",
          value: function clone() {
            return new this.constructor(this.splitPosition, this.howMany, this.insertionPosition, this.graveyardPosition, this.baseVersion);
          }
        }, {
          key: "getReversed",
          value: function getReversed() {
            var t = this.splitPosition.root.document.graveyard,
                e = new Va(t, [0]);
            return new Al(this.moveTargetPosition, this.howMany, this.splitPosition, e, this.baseVersion + 1);
          }
        }, {
          key: "_validate",
          value: function _validate() {
            var t = this.splitPosition.parent,
                e = this.splitPosition.offset;
            if (!t || t.maxOffset < e) throw new a("split-operation-position-invalid", this);
            if (!t.parent) throw new a("split-operation-split-in-root", this);
            if (this.howMany != t.maxOffset - this.splitPosition.offset) throw new a("split-operation-how-many-invalid", this);
            if (this.graveyardPosition && !this.graveyardPosition.nodeAfter) throw new a("split-operation-graveyard-position-invalid", this);
          }
        }, {
          key: "_execute",
          value: function _execute() {
            var t = this.splitPosition.parent;
            if (this.graveyardPosition) al(Wa._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);else {
              var _e162 = t._clone();

              rl(this.insertionPosition, _e162);
            }
            al(new Wa(Va._createAt(t, this.splitPosition.offset), Va._createAt(t, t.maxOffset)), this.moveTargetPosition);
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var t = _get(_getPrototypeOf(Cl.prototype), "toJSON", this).call(this);

            return t.splitPosition = this.splitPosition.toJSON(), t.insertionPosition = this.insertionPosition.toJSON(), this.graveyardPosition && (t.graveyardPosition = this.graveyardPosition.toJSON()), t;
          }
        }], [{
          key: "className",
          get: function get() {
            return "SplitOperation";
          }
        }, {
          key: "getInsertionPosition",
          value: function getInsertionPosition(t) {
            var e = t.path.slice(0, -1);
            return e[e.length - 1]++, new Va(t.root, e, "toPrevious");
          }
        }, {
          key: "fromJSON",
          value: function fromJSON(t, e) {
            var n = Va.fromJSON(t.splitPosition, e),
                i = Va.fromJSON(t.insertionPosition, e),
                o = t.graveyardPosition ? Va.fromJSON(t.graveyardPosition, e) : null;
            return new this(n, t.howMany, i, o, t.baseVersion);
          }
        }]);

        return Cl;
      }(il);

      var _l = /*#__PURE__*/function (_Oa) {
        _inherits(_l, _Oa);

        var _super37 = _createSuper(_l);

        function _l(t, e) {
          var _this75;

          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "main";

          _classCallCheck(this, _l);

          _this75 = _super37.call(this, e), _this75._document = t, _this75.rootName = n;
          return _this75;
        }

        _createClass(_l, [{
          key: "document",
          get: function get() {
            return this._document;
          }
        }, {
          key: "is",
          value: function is(t, e) {
            return e ? e === this.name && ("rootElement" === t || "model:rootElement" === t || "element" === t || "model:element" === t) : "rootElement" === t || "model:rootElement" === t || "element" === t || "model:element" === t || "node" === t || "model:node" === t;
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            return this.rootName;
          }
        }]);

        return _l;
      }(Oa);

      var vl = /*#__PURE__*/function () {
        function vl(t, e) {
          _classCallCheck(this, vl);

          this.model = t, this.batch = e;
        }

        _createClass(vl, [{
          key: "createText",
          value: function createText(t, e) {
            return new Pa(t, e);
          }
        }, {
          key: "createElement",
          value: function createElement(t, e) {
            return new Oa(t, e);
          }
        }, {
          key: "createDocumentFragment",
          value: function createDocumentFragment() {
            return new ol();
          }
        }, {
          key: "cloneElement",
          value: function cloneElement(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
            return t._clone(e);
          }
        }, {
          key: "insert",
          value: function insert(t, e) {
            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            if (this._assertWriterUsedCorrectly(), t instanceof Pa && "" == t.data) return;

            var i = Va._createAt(e, n);

            if (t.parent) {
              if (Sl(t.root, i.root)) return void this.move(Wa._createOn(t), i);
              if (t.root.document) throw new a("model-writer-insert-forbidden-move", this);
              this.remove(t);
            }

            var o = i.root.document ? i.root.document.version : null,
                r = new fl(i, t, o);

            if (t instanceof Pa && (r.shouldReceiveAttributes = !0), this.batch.addOperation(r), this.model.applyOperation(r), t instanceof ol) {
              var _iterator236 = _createForOfIteratorHelper(t.markers),
                  _step236;

              try {
                for (_iterator236.s(); !(_step236 = _iterator236.n()).done;) {
                  var _step236$value = _slicedToArray(_step236.value, 2),
                      _e163 = _step236$value[0],
                      _n147 = _step236$value[1];

                  var _t168 = Va._createAt(_n147.root, 0),
                      _o51 = {
                    range: new Wa(_n147.start._getCombined(_t168, i), _n147.end._getCombined(_t168, i)),
                    usingOperation: !0,
                    affectsData: !0
                  };

                  this.model.markers.has(_e163) ? this.updateMarker(_e163, _o51) : this.addMarker(_e163, _o51);
                }
              } catch (err) {
                _iterator236.e(err);
              } finally {
                _iterator236.f();
              }
            }
          }
        }, {
          key: "insertText",
          value: function insertText(t, e, n, i) {
            e instanceof ol || e instanceof Oa || e instanceof Va ? this.insert(this.createText(t), e, n) : this.insert(this.createText(t, e), n, i);
          }
        }, {
          key: "insertElement",
          value: function insertElement(t, e, n, i) {
            e instanceof ol || e instanceof Oa || e instanceof Va ? this.insert(this.createElement(t), e, n) : this.insert(this.createElement(t, e), n, i);
          }
        }, {
          key: "append",
          value: function append(t, e) {
            this.insert(t, e, "end");
          }
        }, {
          key: "appendText",
          value: function appendText(t, e, n) {
            e instanceof ol || e instanceof Oa ? this.insert(this.createText(t), e, "end") : this.insert(this.createText(t, e), n, "end");
          }
        }, {
          key: "appendElement",
          value: function appendElement(t, e, n) {
            e instanceof ol || e instanceof Oa ? this.insert(this.createElement(t), e, "end") : this.insert(this.createElement(t, e), n, "end");
          }
        }, {
          key: "setAttribute",
          value: function setAttribute(t, e, n) {
            if (this._assertWriterUsedCorrectly(), n instanceof Wa) {
              var _i117 = n.getMinimalFlatRanges();

              var _iterator237 = _createForOfIteratorHelper(_i117),
                  _step237;

              try {
                for (_iterator237.s(); !(_step237 = _iterator237.n()).done;) {
                  var _n148 = _step237.value;
                  yl(this, t, e, _n148);
                }
              } catch (err) {
                _iterator237.e(err);
              } finally {
                _iterator237.f();
              }
            } else xl(this, t, e, n);
          }
        }, {
          key: "setAttributes",
          value: function setAttributes(t, e) {
            var _iterator238 = _createForOfIteratorHelper(Vi(t)),
                _step238;

            try {
              for (_iterator238.s(); !(_step238 = _iterator238.n()).done;) {
                var _step238$value = _slicedToArray(_step238.value, 2),
                    _n149 = _step238$value[0],
                    _i118 = _step238$value[1];

                this.setAttribute(_n149, _i118, e);
              }
            } catch (err) {
              _iterator238.e(err);
            } finally {
              _iterator238.f();
            }
          }
        }, {
          key: "removeAttribute",
          value: function removeAttribute(t, e) {
            if (this._assertWriterUsedCorrectly(), e instanceof Wa) {
              var _n150 = e.getMinimalFlatRanges();

              var _iterator239 = _createForOfIteratorHelper(_n150),
                  _step239;

              try {
                for (_iterator239.s(); !(_step239 = _iterator239.n()).done;) {
                  var _e164 = _step239.value;
                  yl(this, t, null, _e164);
                }
              } catch (err) {
                _iterator239.e(err);
              } finally {
                _iterator239.f();
              }
            } else xl(this, t, null, e);
          }
        }, {
          key: "clearAttributes",
          value: function clearAttributes(t) {
            var _this76 = this;

            this._assertWriterUsedCorrectly();

            var e = function e(t) {
              var _iterator240 = _createForOfIteratorHelper(t.getAttributeKeys()),
                  _step240;

              try {
                for (_iterator240.s(); !(_step240 = _iterator240.n()).done;) {
                  var _e165 = _step240.value;

                  _this76.removeAttribute(_e165, t);
                }
              } catch (err) {
                _iterator240.e(err);
              } finally {
                _iterator240.f();
              }
            };

            if (t instanceof Wa) {
              var _iterator241 = _createForOfIteratorHelper(t.getItems()),
                  _step241;

              try {
                for (_iterator241.s(); !(_step241 = _iterator241.n()).done;) {
                  var _n151 = _step241.value;
                  e(_n151);
                }
              } catch (err) {
                _iterator241.e(err);
              } finally {
                _iterator241.f();
              }
            } else e(t);
          }
        }, {
          key: "move",
          value: function move(t, e, n) {
            if (this._assertWriterUsedCorrectly(), !(t instanceof Wa)) throw new a("writer-move-invalid-range", this);
            if (!t.isFlat) throw new a("writer-move-range-not-flat", this);

            var i = Va._createAt(e, n);

            if (i.isEqual(t.start)) return;
            if (this._addOperationForAffectedMarkers("move", t), !Sl(t.root, i.root)) throw new a("writer-move-different-document", this);
            var o = t.root.document ? t.root.document.version : null,
                r = new pl(t.start, t.end.offset - t.start.offset, i, o);
            this.batch.addOperation(r), this.model.applyOperation(r);
          }
        }, {
          key: "remove",
          value: function remove(t) {
            this._assertWriterUsedCorrectly();

            var e = (t instanceof Wa ? t : Wa._createOn(t)).getMinimalFlatRanges().reverse();

            var _iterator242 = _createForOfIteratorHelper(e),
                _step242;

            try {
              for (_iterator242.s(); !(_step242 = _iterator242.n()).done;) {
                var _t169 = _step242.value;
                this._addOperationForAffectedMarkers("move", _t169), Dl(_t169.start, _t169.end.offset - _t169.start.offset, this.batch, this.model);
              }
            } catch (err) {
              _iterator242.e(err);
            } finally {
              _iterator242.f();
            }
          }
        }, {
          key: "merge",
          value: function merge(t) {
            this._assertWriterUsedCorrectly();

            var e = t.nodeBefore,
                n = t.nodeAfter;
            if (this._addOperationForAffectedMarkers("merge", t), !(e instanceof Oa)) throw new a("writer-merge-no-element-before", this);
            if (!(n instanceof Oa)) throw new a("writer-merge-no-element-after", this);
            t.root.document ? this._merge(t) : this._mergeDetached(t);
          }
        }, {
          key: "createPositionFromPath",
          value: function createPositionFromPath(t, e, n) {
            return this.model.createPositionFromPath(t, e, n);
          }
        }, {
          key: "createPositionAt",
          value: function createPositionAt(t, e) {
            return this.model.createPositionAt(t, e);
          }
        }, {
          key: "createPositionAfter",
          value: function createPositionAfter(t) {
            return this.model.createPositionAfter(t);
          }
        }, {
          key: "createPositionBefore",
          value: function createPositionBefore(t) {
            return this.model.createPositionBefore(t);
          }
        }, {
          key: "createRange",
          value: function createRange(t, e) {
            return this.model.createRange(t, e);
          }
        }, {
          key: "createRangeIn",
          value: function createRangeIn(t) {
            return this.model.createRangeIn(t);
          }
        }, {
          key: "createRangeOn",
          value: function createRangeOn(t) {
            return this.model.createRangeOn(t);
          }
        }, {
          key: "createSelection",
          value: function createSelection(t, e, n) {
            return this.model.createSelection(t, e, n);
          }
        }, {
          key: "_mergeDetached",
          value: function _mergeDetached(t) {
            var e = t.nodeBefore,
                n = t.nodeAfter;
            this.move(Wa._createIn(n), Va._createAt(e, "end")), this.remove(n);
          }
        }, {
          key: "_merge",
          value: function _merge(t) {
            var e = Va._createAt(t.nodeBefore, "end"),
                n = Va._createAt(t.nodeAfter, 0),
                i = t.root.document.graveyard,
                o = new Va(i, [0]),
                r = t.root.document.version,
                s = new Al(n, t.nodeAfter.maxOffset, e, o, r);

            this.batch.addOperation(s), this.model.applyOperation(s);
          }
        }, {
          key: "rename",
          value: function rename(t, e) {
            if (this._assertWriterUsedCorrectly(), !(t instanceof Oa)) throw new a("writer-rename-not-element-instance", this);
            var n = t.root.document ? t.root.document.version : null,
                i = new bl(Va._createBefore(t), t.name, e, n);
            this.batch.addOperation(i), this.model.applyOperation(i);
          }
        }, {
          key: "split",
          value: function split(t, e) {
            this._assertWriterUsedCorrectly();

            var n,
                i,
                o = t.parent;
            if (!o.parent) throw new a("writer-split-element-no-parent", this);
            if (e || (e = o.parent), !t.parent.getAncestors({
              includeSelf: !0
            }).includes(e)) throw new a("writer-split-invalid-limit-element", this);

            do {
              var _e166 = o.root.document ? o.root.document.version : null,
                  _r25 = o.maxOffset - t.offset,
                  _s17 = Cl.getInsertionPosition(t),
                  _a9 = new Cl(t, _r25, _s17, null, _e166);

              this.batch.addOperation(_a9), this.model.applyOperation(_a9), n || i || (n = o, i = t.parent.nextSibling), o = (t = this.createPositionAfter(t.parent)).parent;
            } while (o !== e);

            return {
              position: t,
              range: new Wa(Va._createAt(n, "end"), Va._createAt(i, 0))
            };
          }
        }, {
          key: "wrap",
          value: function wrap(t, e) {
            if (this._assertWriterUsedCorrectly(), !t.isFlat) throw new a("writer-wrap-range-not-flat", this);
            var n = e instanceof Oa ? e : new Oa(e);
            if (n.childCount > 0) throw new a("writer-wrap-element-not-empty", this);
            if (null !== n.parent) throw new a("writer-wrap-element-attached", this);
            this.insert(n, t.start);
            var i = new Wa(t.start.getShiftedBy(1), t.end.getShiftedBy(1));
            this.move(i, Va._createAt(n, 0));
          }
        }, {
          key: "unwrap",
          value: function unwrap(t) {
            if (this._assertWriterUsedCorrectly(), null === t.parent) throw new a("writer-unwrap-element-no-parent", this);
            this.move(Wa._createIn(t), this.createPositionAfter(t)), this.remove(t);
          }
        }, {
          key: "addMarker",
          value: function addMarker(t, e) {
            if (this._assertWriterUsedCorrectly(), !e || "boolean" != typeof e.usingOperation) throw new a("writer-addmarker-no-usingoperation", this);
            var n = e.usingOperation,
                i = e.range,
                o = void 0 !== e.affectsData && e.affectsData;
            if (this.model.markers.has(t)) throw new a("writer-addmarker-marker-exists", this);
            if (!i) throw new a("writer-addmarker-no-range", this);
            return n ? (El(this, t, null, i, o), this.model.markers.get(t)) : this.model.markers._set(t, i, n, o);
          }
        }, {
          key: "updateMarker",
          value: function updateMarker(t, e) {
            this._assertWriterUsedCorrectly();

            var n = "string" == typeof t ? t : t.name,
                i = this.model.markers.get(n);
            if (!i) throw new a("writer-updatemarker-marker-not-exists", this);
            if (!e) return void this.model.markers._refresh(i);
            var o = "boolean" == typeof e.usingOperation,
                r = "boolean" == typeof e.affectsData,
                s = r ? e.affectsData : i.affectsData;
            if (!o && !e.range && !r) throw new a("writer-updatemarker-wrong-options", this);
            var c = i.getRange(),
                l = e.range ? e.range : c;
            o && e.usingOperation !== i.managedUsingOperations ? e.usingOperation ? El(this, n, null, l, s) : (El(this, n, c, null, s), this.model.markers._set(n, l, void 0, s)) : i.managedUsingOperations ? El(this, n, c, l, s) : this.model.markers._set(n, l, void 0, s);
          }
        }, {
          key: "removeMarker",
          value: function removeMarker(t) {
            this._assertWriterUsedCorrectly();

            var e = "string" == typeof t ? t : t.name;
            if (!this.model.markers.has(e)) throw new a("writer-removemarker-no-marker", this);
            var n = this.model.markers.get(e);
            if (!n.managedUsingOperations) return void this.model.markers._remove(e);
            El(this, e, n.getRange(), null, n.affectsData);
          }
        }, {
          key: "setSelection",
          value: function setSelection(t, e, n) {
            this._assertWriterUsedCorrectly(), this.model.document.selection._setTo(t, e, n);
          }
        }, {
          key: "setSelectionFocus",
          value: function setSelectionFocus(t, e) {
            this._assertWriterUsedCorrectly(), this.model.document.selection._setFocus(t, e);
          }
        }, {
          key: "setSelectionAttribute",
          value: function setSelectionAttribute(t, e) {
            if (this._assertWriterUsedCorrectly(), "string" == typeof t) this._setSelectionAttribute(t, e);else {
              var _iterator243 = _createForOfIteratorHelper(Vi(t)),
                  _step243;

              try {
                for (_iterator243.s(); !(_step243 = _iterator243.n()).done;) {
                  var _step243$value = _slicedToArray(_step243.value, 2),
                      _e167 = _step243$value[0],
                      _n152 = _step243$value[1];

                  this._setSelectionAttribute(_e167, _n152);
                }
              } catch (err) {
                _iterator243.e(err);
              } finally {
                _iterator243.f();
              }
            }
          }
        }, {
          key: "removeSelectionAttribute",
          value: function removeSelectionAttribute(t) {
            if (this._assertWriterUsedCorrectly(), "string" == typeof t) this._removeSelectionAttribute(t);else {
              var _iterator244 = _createForOfIteratorHelper(t),
                  _step244;

              try {
                for (_iterator244.s(); !(_step244 = _iterator244.n()).done;) {
                  var _e168 = _step244.value;

                  this._removeSelectionAttribute(_e168);
                }
              } catch (err) {
                _iterator244.e(err);
              } finally {
                _iterator244.f();
              }
            }
          }
        }, {
          key: "overrideSelectionGravity",
          value: function overrideSelectionGravity() {
            return this.model.document.selection._overrideGravity();
          }
        }, {
          key: "restoreSelectionGravity",
          value: function restoreSelectionGravity(t) {
            this.model.document.selection._restoreGravity(t);
          }
        }, {
          key: "_setSelectionAttribute",
          value: function _setSelectionAttribute(t, e) {
            var n = this.model.document.selection;

            if (n.isCollapsed && n.anchor.parent.isEmpty) {
              var _i119 = cc._getStoreAttributeKey(t);

              this.setAttribute(_i119, e, n.anchor.parent);
            }

            n._setAttribute(t, e);
          }
        }, {
          key: "_removeSelectionAttribute",
          value: function _removeSelectionAttribute(t) {
            var e = this.model.document.selection;

            if (e.isCollapsed && e.anchor.parent.isEmpty) {
              var _n153 = cc._getStoreAttributeKey(t);

              this.removeAttribute(_n153, e.anchor.parent);
            }

            e._removeAttribute(t);
          }
        }, {
          key: "_assertWriterUsedCorrectly",
          value: function _assertWriterUsedCorrectly() {
            if (this.model._currentWriter !== this) throw new a("writer-incorrect-use", this);
          }
        }, {
          key: "_addOperationForAffectedMarkers",
          value: function _addOperationForAffectedMarkers(t, e) {
            var _iterator245 = _createForOfIteratorHelper(this.model.markers),
                _step245;

            try {
              for (_iterator245.s(); !(_step245 = _iterator245.n()).done;) {
                var _n154 = _step245.value;
                if (!_n154.managedUsingOperations) continue;

                var _i120 = _n154.getRange();

                var _o52 = !1;

                if ("move" === t) _o52 = e.containsPosition(_i120.start) || e.start.isEqual(_i120.start) || e.containsPosition(_i120.end) || e.end.isEqual(_i120.end);else {
                  var _t170 = e.nodeBefore,
                      _n155 = e.nodeAfter,
                      _r26 = _i120.start.parent == _t170 && _i120.start.isAtEnd,
                      _s18 = _i120.end.parent == _n155 && 0 == _i120.end.offset,
                      _a10 = _i120.end.nodeAfter == _n155,
                      _c4 = _i120.start.nodeAfter == _n155;

                  _o52 = _r26 || _s18 || _a10 || _c4;
                }
                _o52 && this.updateMarker(_n154.name, {
                  range: _i120
                });
              }
            } catch (err) {
              _iterator245.e(err);
            } finally {
              _iterator245.f();
            }
          }
        }]);

        return vl;
      }();

      function yl(t, e, n, i) {
        var o = t.model,
            r = o.document;
        var s,
            a,
            c,
            l = i.start;

        var _iterator246 = _createForOfIteratorHelper(i.getWalker({
          shallow: !0
        })),
            _step246;

        try {
          for (_iterator246.s(); !(_step246 = _iterator246.n()).done;) {
            var _t171 = _step246.value;
            c = _t171.item.getAttribute(e), s && a != c && (a != n && d(), l = s), s = _t171.nextPosition, a = c;
          }
        } catch (err) {
          _iterator246.e(err);
        } finally {
          _iterator246.f();
        }

        function d() {
          var i = new Wa(l, s),
              c = i.root.document ? r.version : null,
              d = new gl(i, e, a, n, c);
          t.batch.addOperation(d), o.applyOperation(d);
        }

        s instanceof Va && s != l && a != n && d();
      }

      function xl(t, e, n, i) {
        var o = t.model,
            r = o.document,
            s = i.getAttribute(e);
        var a, c;

        if (s != n) {
          if (i.root === i) {
            var _t172 = i.document ? r.version : null;

            c = new wl(i, e, s, n, _t172);
          } else {
            a = new Wa(Va._createBefore(i), t.createPositionAfter(i));

            var _o53 = a.root.document ? r.version : null;

            c = new gl(a, e, s, n, _o53);
          }

          t.batch.addOperation(c), o.applyOperation(c);
        }
      }

      function El(t, e, n, i, o) {
        var r = t.model,
            s = r.document,
            a = new kl(e, n, i, r.markers, o, s.version);
        t.batch.addOperation(a), r.applyOperation(a);
      }

      function Dl(t, e, n, i) {
        var o;

        if (t.root.document) {
          var _n156 = i.document,
              _r27 = new Va(_n156.graveyard, [0]);

          o = new pl(t, e, _r27, _n156.version);
        } else o = new ml(t, e);

        n.addOperation(o), i.applyOperation(o);
      }

      function Sl(t, e) {
        return t === e || t instanceof _l && e instanceof _l;
      }

      var Il = /*#__PURE__*/function () {
        function Il(t) {
          _classCallCheck(this, Il);

          this._markerCollection = t, this._changesInElement = new Map(), this._elementSnapshots = new Map(), this._changedMarkers = new Map(), this._changeCount = 0, this._cachedChanges = null, this._cachedChangesWithGraveyard = null;
        }

        _createClass(Il, [{
          key: "isEmpty",
          get: function get() {
            return 0 == this._changesInElement.size && 0 == this._changedMarkers.size;
          }
        }, {
          key: "refreshItem",
          value: function refreshItem(t) {
            if (this._isInInsertedElement(t.parent)) return;
            this._markRemove(t.parent, t.startOffset, t.offsetSize), this._markInsert(t.parent, t.startOffset, t.offsetSize);

            var e = Wa._createOn(t);

            var _iterator247 = _createForOfIteratorHelper(this._markerCollection.getMarkersIntersectingRange(e)),
                _step247;

            try {
              for (_iterator247.s(); !(_step247 = _iterator247.n()).done;) {
                var _t173 = _step247.value;

                var _e169 = _t173.getRange();

                this.bufferMarkerChange(_t173.name, _e169, _e169, _t173.affectsData);
              }
            } catch (err) {
              _iterator247.e(err);
            } finally {
              _iterator247.f();
            }

            this._cachedChanges = null;
          }
        }, {
          key: "bufferOperation",
          value: function bufferOperation(t) {
            switch (t.type) {
              case "insert":
                if (this._isInInsertedElement(t.position.parent)) return;

                this._markInsert(t.position.parent, t.position.offset, t.nodes.maxOffset);

                break;

              case "addAttribute":
              case "removeAttribute":
              case "changeAttribute":
                var _iterator248 = _createForOfIteratorHelper(t.range.getItems({
                  shallow: !0
                })),
                    _step248;

                try {
                  for (_iterator248.s(); !(_step248 = _iterator248.n()).done;) {
                    var _e170 = _step248.value;
                    this._isInInsertedElement(_e170.parent) || this._markAttribute(_e170);
                  }
                } catch (err) {
                  _iterator248.e(err);
                } finally {
                  _iterator248.f();
                }

                break;

              case "remove":
              case "move":
              case "reinsert":
                {
                  if (t.sourcePosition.isEqual(t.targetPosition) || t.sourcePosition.getShiftedBy(t.howMany).isEqual(t.targetPosition)) return;

                  var _e171 = this._isInInsertedElement(t.sourcePosition.parent),
                      _n157 = this._isInInsertedElement(t.targetPosition.parent);

                  _e171 || this._markRemove(t.sourcePosition.parent, t.sourcePosition.offset, t.howMany), _n157 || this._markInsert(t.targetPosition.parent, t.getMovedRangeStart().offset, t.howMany);
                  break;
                }

              case "rename":
                {
                  if (this._isInInsertedElement(t.position.parent)) return;
                  this._markRemove(t.position.parent, t.position.offset, 1), this._markInsert(t.position.parent, t.position.offset, 1);

                  var _e172 = Wa._createFromPositionAndShift(t.position, 1);

                  var _iterator249 = _createForOfIteratorHelper(this._markerCollection.getMarkersIntersectingRange(_e172)),
                      _step249;

                  try {
                    for (_iterator249.s(); !(_step249 = _iterator249.n()).done;) {
                      var _t174 = _step249.value;

                      var _e173 = _t174.getRange();

                      this.bufferMarkerChange(_t174.name, _e173, _e173, _t174.affectsData);
                    }
                  } catch (err) {
                    _iterator249.e(err);
                  } finally {
                    _iterator249.f();
                  }

                  break;
                }

              case "split":
                {
                  var _e174 = t.splitPosition.parent;
                  this._isInInsertedElement(_e174) || this._markRemove(_e174, t.splitPosition.offset, t.howMany), this._isInInsertedElement(t.insertionPosition.parent) || this._markInsert(t.insertionPosition.parent, t.insertionPosition.offset, 1), t.graveyardPosition && this._markRemove(t.graveyardPosition.parent, t.graveyardPosition.offset, 1);
                  break;
                }

              case "merge":
                {
                  var _e175 = t.sourcePosition.parent;
                  this._isInInsertedElement(_e175.parent) || this._markRemove(_e175.parent, _e175.startOffset, 1);
                  var _n158 = t.graveyardPosition.parent;

                  this._markInsert(_n158, t.graveyardPosition.offset, 1);

                  var _i121 = t.targetPosition.parent;
                  this._isInInsertedElement(_i121) || this._markInsert(_i121, t.targetPosition.offset, _e175.maxOffset);
                  break;
                }
            }

            this._cachedChanges = null;
          }
        }, {
          key: "bufferMarkerChange",
          value: function bufferMarkerChange(t, e, n, i) {
            var o = this._changedMarkers.get(t);

            o ? (o.newRange = n, o.affectsData = i, null == o.oldRange && null == o.newRange && this._changedMarkers.delete(t)) : this._changedMarkers.set(t, {
              oldRange: e,
              newRange: n,
              affectsData: i
            });
          }
        }, {
          key: "getMarkersToRemove",
          value: function getMarkersToRemove() {
            var t = [];

            var _iterator250 = _createForOfIteratorHelper(this._changedMarkers),
                _step250;

            try {
              for (_iterator250.s(); !(_step250 = _iterator250.n()).done;) {
                var _step250$value = _slicedToArray(_step250.value, 2),
                    _e176 = _step250$value[0],
                    _n159 = _step250$value[1];

                null != _n159.oldRange && t.push({
                  name: _e176,
                  range: _n159.oldRange
                });
              }
            } catch (err) {
              _iterator250.e(err);
            } finally {
              _iterator250.f();
            }

            return t;
          }
        }, {
          key: "getMarkersToAdd",
          value: function getMarkersToAdd() {
            var t = [];

            var _iterator251 = _createForOfIteratorHelper(this._changedMarkers),
                _step251;

            try {
              for (_iterator251.s(); !(_step251 = _iterator251.n()).done;) {
                var _step251$value = _slicedToArray(_step251.value, 2),
                    _e177 = _step251$value[0],
                    _n160 = _step251$value[1];

                null != _n160.newRange && t.push({
                  name: _e177,
                  range: _n160.newRange
                });
              }
            } catch (err) {
              _iterator251.e(err);
            } finally {
              _iterator251.f();
            }

            return t;
          }
        }, {
          key: "getChangedMarkers",
          value: function getChangedMarkers() {
            return Array.from(this._changedMarkers).map(function (t) {
              return {
                name: t[0],
                data: {
                  oldRange: t[1].oldRange,
                  newRange: t[1].newRange
                }
              };
            });
          }
        }, {
          key: "hasDataChanges",
          value: function hasDataChanges() {
            var _iterator252 = _createForOfIteratorHelper(this._changedMarkers),
                _step252;

            try {
              for (_iterator252.s(); !(_step252 = _iterator252.n()).done;) {
                var _step252$value = _slicedToArray(_step252.value, 2),
                    _t175 = _step252$value[1];

                if (_t175.affectsData) return !0;
              }
            } catch (err) {
              _iterator252.e(err);
            } finally {
              _iterator252.f();
            }

            return this._changesInElement.size > 0;
          }
        }, {
          key: "getChanges",
          value: function getChanges() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
              includeChangesInGraveyard: !1
            };
            if (this._cachedChanges) return t.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
            var e = [];

            var _iterator253 = _createForOfIteratorHelper(this._changesInElement.keys()),
                _step253;

            try {
              for (_iterator253.s(); !(_step253 = _iterator253.n()).done;) {
                var _t177 = _step253.value;

                var _n162 = this._changesInElement.get(_t177).sort(function (t, e) {
                  return t.offset === e.offset ? t.type != e.type ? "remove" == t.type ? -1 : 1 : 0 : t.offset < e.offset ? -1 : 1;
                }),
                    _i123 = this._elementSnapshots.get(_t177),
                    _o55 = Ml(_t177.getChildren()),
                    _r29 = Tl(_i123.length, _n162);

                var _s20 = 0,
                    _a12 = 0;

                var _iterator255 = _createForOfIteratorHelper(_r29),
                    _step255;

                try {
                  for (_iterator255.s(); !(_step255 = _iterator255.n()).done;) {
                    var _n163 = _step255.value;
                    if ("i" === _n163) e.push(this._getInsertDiff(_t177, _s20, _o55[_s20].name)), _s20++;else if ("r" === _n163) e.push(this._getRemoveDiff(_t177, _s20, _i123[_a12].name)), _a12++;else if ("a" === _n163) {
                      var _e179;

                      var _n164 = _o55[_s20].attributes,
                          _r30 = _i123[_a12].attributes;

                      var _c5 = void 0;

                      if ("$text" == _o55[_s20].name) _c5 = new Wa(Va._createAt(_t177, _s20), Va._createAt(_t177, _s20 + 1));else {
                        var _e178 = _t177.offsetToIndex(_s20);

                        _c5 = new Wa(Va._createAt(_t177, _s20), Va._createAt(_t177.getChild(_e178), 0));
                      }
                      (_e179 = e).push.apply(_e179, _toConsumableArray(this._getAttributesDiff(_c5, _r30, _n164))), _s20++, _a12++;
                    } else _s20++, _a12++;
                  }
                } catch (err) {
                  _iterator255.e(err);
                } finally {
                  _iterator255.f();
                }
              }
            } catch (err) {
              _iterator253.e(err);
            } finally {
              _iterator253.f();
            }

            e.sort(function (t, e) {
              return t.position.root != e.position.root ? t.position.root.rootName < e.position.root.rootName ? -1 : 1 : t.position.isEqual(e.position) ? t.changeCount - e.changeCount : t.position.isBefore(e.position) ? -1 : 1;
            });

            for (var _t176 = 1, _n161 = 0; _t176 < e.length; _t176++) {
              var _i122 = e[_n161],
                  _o54 = e[_t176],
                  _r28 = "remove" == _i122.type && "remove" == _o54.type && "$text" == _i122.name && "$text" == _o54.name && _i122.position.isEqual(_o54.position),
                  _s19 = "insert" == _i122.type && "insert" == _o54.type && "$text" == _i122.name && "$text" == _o54.name && _i122.position.parent == _o54.position.parent && _i122.position.offset + _i122.length == _o54.position.offset,
                  _a11 = "attribute" == _i122.type && "attribute" == _o54.type && _i122.position.parent == _o54.position.parent && _i122.range.isFlat && _o54.range.isFlat && _i122.position.offset + _i122.length == _o54.position.offset && _i122.attributeKey == _o54.attributeKey && _i122.attributeOldValue == _o54.attributeOldValue && _i122.attributeNewValue == _o54.attributeNewValue;

              _r28 || _s19 || _a11 ? (_i122.length++, _a11 && (_i122.range.end = _i122.range.end.getShiftedBy(1)), e[_t176] = null) : _n161 = _t176;
            }

            e = e.filter(function (t) {
              return t;
            });

            var _iterator254 = _createForOfIteratorHelper(e),
                _step254;

            try {
              for (_iterator254.s(); !(_step254 = _iterator254.n()).done;) {
                var _t178 = _step254.value;
                delete _t178.changeCount, "attribute" == _t178.type && (delete _t178.position, delete _t178.length);
              }
            } catch (err) {
              _iterator254.e(err);
            } finally {
              _iterator254.f();
            }

            return this._changeCount = 0, this._cachedChangesWithGraveyard = e.slice(), this._cachedChanges = e.filter(Nl), t.includeChangesInGraveyard ? this._cachedChangesWithGraveyard : this._cachedChanges;
          }
        }, {
          key: "reset",
          value: function reset() {
            this._changesInElement.clear(), this._elementSnapshots.clear(), this._changedMarkers.clear(), this._cachedChanges = null;
          }
        }, {
          key: "_markInsert",
          value: function _markInsert(t, e, n) {
            var i = {
              type: "insert",
              offset: e,
              howMany: n,
              count: this._changeCount++
            };

            this._markChange(t, i);
          }
        }, {
          key: "_markRemove",
          value: function _markRemove(t, e, n) {
            var i = {
              type: "remove",
              offset: e,
              howMany: n,
              count: this._changeCount++
            };
            this._markChange(t, i), this._removeAllNestedChanges(t, e, n);
          }
        }, {
          key: "_markAttribute",
          value: function _markAttribute(t) {
            var e = {
              type: "attribute",
              offset: t.startOffset,
              howMany: t.offsetSize,
              count: this._changeCount++
            };

            this._markChange(t.parent, e);
          }
        }, {
          key: "_markChange",
          value: function _markChange(t, e) {
            this._makeSnapshot(t);

            var n = this._getChangesForElement(t);

            this._handleChange(e, n), n.push(e);

            for (var _t179 = 0; _t179 < n.length; _t179++) {
              n[_t179].howMany < 1 && (n.splice(_t179, 1), _t179--);
            }
          }
        }, {
          key: "_getChangesForElement",
          value: function _getChangesForElement(t) {
            var e;
            return this._changesInElement.has(t) ? e = this._changesInElement.get(t) : (e = [], this._changesInElement.set(t, e)), e;
          }
        }, {
          key: "_makeSnapshot",
          value: function _makeSnapshot(t) {
            this._elementSnapshots.has(t) || this._elementSnapshots.set(t, Ml(t.getChildren()));
          }
        }, {
          key: "_handleChange",
          value: function _handleChange(t, e) {
            t.nodesToHandle = t.howMany;

            var _iterator256 = _createForOfIteratorHelper(e),
                _step256;

            try {
              for (_iterator256.s(); !(_step256 = _iterator256.n()).done;) {
                var _n165 = _step256.value;

                var _i124 = t.offset + t.howMany,
                    _o56 = _n165.offset + _n165.howMany;

                if ("insert" == t.type && ("insert" == _n165.type && (t.offset <= _n165.offset ? _n165.offset += t.howMany : t.offset < _o56 && (_n165.howMany += t.nodesToHandle, t.nodesToHandle = 0)), "remove" == _n165.type && t.offset < _n165.offset && (_n165.offset += t.howMany), "attribute" == _n165.type)) if (t.offset <= _n165.offset) _n165.offset += t.howMany;else if (t.offset < _o56) {
                  var _o57 = _n165.howMany;
                  _n165.howMany = t.offset - _n165.offset, e.unshift({
                    type: "attribute",
                    offset: _i124,
                    howMany: _o57 - _n165.howMany,
                    count: this._changeCount++
                  });
                }

                if ("remove" == t.type) {
                  if ("insert" == _n165.type) if (_i124 <= _n165.offset) _n165.offset -= t.howMany;else if (_i124 <= _o56) {
                    if (t.offset < _n165.offset) {
                      var _e180 = _i124 - _n165.offset;

                      _n165.offset = t.offset, _n165.howMany -= _e180, t.nodesToHandle -= _e180;
                    } else _n165.howMany -= t.nodesToHandle, t.nodesToHandle = 0;
                  } else if (t.offset <= _n165.offset) t.nodesToHandle -= _n165.howMany, _n165.howMany = 0;else if (t.offset < _o56) {
                    var _e181 = _o56 - t.offset;

                    _n165.howMany -= _e181, t.nodesToHandle -= _e181;
                  }
                  if ("remove" == _n165.type && (_i124 <= _n165.offset ? _n165.offset -= t.howMany : t.offset < _n165.offset && (t.nodesToHandle += _n165.howMany, _n165.howMany = 0)), "attribute" == _n165.type) if (_i124 <= _n165.offset) _n165.offset -= t.howMany;else if (t.offset < _n165.offset) {
                    var _e182 = _i124 - _n165.offset;

                    _n165.offset = t.offset, _n165.howMany -= _e182;
                  } else if (t.offset < _o56) if (_i124 <= _o56) {
                    var _i125 = _n165.howMany;
                    _n165.howMany = t.offset - _n165.offset;

                    var _o58 = _i125 - _n165.howMany - t.nodesToHandle;

                    e.unshift({
                      type: "attribute",
                      offset: t.offset,
                      howMany: _o58,
                      count: this._changeCount++
                    });
                  } else _n165.howMany -= _o56 - t.offset;
                }

                if ("attribute" == t.type) {
                  if ("insert" == _n165.type) if (t.offset < _n165.offset && _i124 > _n165.offset) {
                    if (_i124 > _o56) {
                      var _t180 = {
                        type: "attribute",
                        offset: _o56,
                        howMany: _i124 - _o56,
                        count: this._changeCount++
                      };
                      this._handleChange(_t180, e), e.push(_t180);
                    }

                    t.nodesToHandle = _n165.offset - t.offset, t.howMany = t.nodesToHandle;
                  } else t.offset >= _n165.offset && t.offset < _o56 && (_i124 > _o56 ? (t.nodesToHandle = _i124 - _o56, t.offset = _o56) : t.nodesToHandle = 0);

                  if ("remove" == _n165.type && t.offset < _n165.offset && _i124 > _n165.offset) {
                    var _o59 = {
                      type: "attribute",
                      offset: _n165.offset,
                      howMany: _i124 - _n165.offset,
                      count: this._changeCount++
                    };
                    this._handleChange(_o59, e), e.push(_o59), t.nodesToHandle = _n165.offset - t.offset, t.howMany = t.nodesToHandle;
                  }

                  "attribute" == _n165.type && (t.offset >= _n165.offset && _i124 <= _o56 ? (t.nodesToHandle = 0, t.howMany = 0, t.offset = 0) : t.offset <= _n165.offset && _i124 >= _o56 && (_n165.howMany = 0));
                }
              }
            } catch (err) {
              _iterator256.e(err);
            } finally {
              _iterator256.f();
            }

            t.howMany = t.nodesToHandle, delete t.nodesToHandle;
          }
        }, {
          key: "_getInsertDiff",
          value: function _getInsertDiff(t, e, n) {
            return {
              type: "insert",
              position: Va._createAt(t, e),
              name: n,
              length: 1,
              changeCount: this._changeCount++
            };
          }
        }, {
          key: "_getRemoveDiff",
          value: function _getRemoveDiff(t, e, n) {
            return {
              type: "remove",
              position: Va._createAt(t, e),
              name: n,
              length: 1,
              changeCount: this._changeCount++
            };
          }
        }, {
          key: "_getAttributesDiff",
          value: function _getAttributesDiff(t, e, n) {
            var i = [];
            n = new Map(n);

            var _iterator257 = _createForOfIteratorHelper(e),
                _step257;

            try {
              for (_iterator257.s(); !(_step257 = _iterator257.n()).done;) {
                var _step257$value = _slicedToArray(_step257.value, 2),
                    _o60 = _step257$value[0],
                    _r31 = _step257$value[1];

                var _e183 = n.has(_o60) ? n.get(_o60) : null;

                _e183 !== _r31 && i.push({
                  type: "attribute",
                  position: t.start,
                  range: t.clone(),
                  length: 1,
                  attributeKey: _o60,
                  attributeOldValue: _r31,
                  attributeNewValue: _e183,
                  changeCount: this._changeCount++
                }), n.delete(_o60);
              }
            } catch (err) {
              _iterator257.e(err);
            } finally {
              _iterator257.f();
            }

            var _iterator258 = _createForOfIteratorHelper(n),
                _step258;

            try {
              for (_iterator258.s(); !(_step258 = _iterator258.n()).done;) {
                var _step258$value = _slicedToArray(_step258.value, 2),
                    _e184 = _step258$value[0],
                    _o61 = _step258$value[1];

                i.push({
                  type: "attribute",
                  position: t.start,
                  range: t.clone(),
                  length: 1,
                  attributeKey: _e184,
                  attributeOldValue: null,
                  attributeNewValue: _o61,
                  changeCount: this._changeCount++
                });
              }
            } catch (err) {
              _iterator258.e(err);
            } finally {
              _iterator258.f();
            }

            return i;
          }
        }, {
          key: "_isInInsertedElement",
          value: function _isInInsertedElement(t) {
            var e = t.parent;
            if (!e) return !1;

            var n = this._changesInElement.get(e),
                i = t.startOffset;

            if (n) {
              var _iterator259 = _createForOfIteratorHelper(n),
                  _step259;

              try {
                for (_iterator259.s(); !(_step259 = _iterator259.n()).done;) {
                  var _t181 = _step259.value;
                  if ("insert" == _t181.type && i >= _t181.offset && i < _t181.offset + _t181.howMany) return !0;
                }
              } catch (err) {
                _iterator259.e(err);
              } finally {
                _iterator259.f();
              }
            }

            return this._isInInsertedElement(e);
          }
        }, {
          key: "_removeAllNestedChanges",
          value: function _removeAllNestedChanges(t, e, n) {
            var i = new Wa(Va._createAt(t, e), Va._createAt(t, e + n));

            var _iterator260 = _createForOfIteratorHelper(i.getItems({
              shallow: !0
            })),
                _step260;

            try {
              for (_iterator260.s(); !(_step260 = _iterator260.n()).done;) {
                var _t182 = _step260.value;
                _t182.is("element") && (this._elementSnapshots.delete(_t182), this._changesInElement.delete(_t182), this._removeAllNestedChanges(_t182, 0, _t182.maxOffset));
              }
            } catch (err) {
              _iterator260.e(err);
            } finally {
              _iterator260.f();
            }
          }
        }]);

        return Il;
      }();

      function Ml(t) {
        var e = [];

        var _iterator261 = _createForOfIteratorHelper(t),
            _step261;

        try {
          for (_iterator261.s(); !(_step261 = _iterator261.n()).done;) {
            var _n166 = _step261.value;
            if (_n166.is("$text")) for (var _t183 = 0; _t183 < _n166.data.length; _t183++) {
              e.push({
                name: "$text",
                attributes: new Map(_n166.getAttributes())
              });
            } else e.push({
              name: _n166.name,
              attributes: new Map(_n166.getAttributes())
            });
          }
        } catch (err) {
          _iterator261.e(err);
        } finally {
          _iterator261.f();
        }

        return e;
      }

      function Tl(t, e) {
        var n = [];
        var i = 0,
            o = 0;

        var _iterator262 = _createForOfIteratorHelper(e),
            _step262;

        try {
          for (_iterator262.s(); !(_step262 = _iterator262.n()).done;) {
            var _t184 = _step262.value;

            if (_t184.offset > i) {
              for (var _e186 = 0; _e186 < _t184.offset - i; _e186++) {
                n.push("e");
              }

              o += _t184.offset - i;
            }

            if ("insert" == _t184.type) {
              for (var _e187 = 0; _e187 < _t184.howMany; _e187++) {
                n.push("i");
              }

              i = _t184.offset + _t184.howMany;
            } else if ("remove" == _t184.type) {
              for (var _e188 = 0; _e188 < _t184.howMany; _e188++) {
                n.push("r");
              }

              i = _t184.offset, o += _t184.howMany;
            } else n.push.apply(n, _toConsumableArray("a".repeat(_t184.howMany).split(""))), i = _t184.offset + _t184.howMany, o += _t184.howMany;
          }
        } catch (err) {
          _iterator262.e(err);
        } finally {
          _iterator262.f();
        }

        if (o < t) for (var _e185 = 0; _e185 < t - o - i; _e185++) {
          n.push("e");
        }
        return n;
      }

      function Nl(t) {
        var e = t.position && "$graveyard" == t.position.root.rootName,
            n = t.range && "$graveyard" == t.range.root.rootName;
        return !e && !n;
      }

      var Bl = /*#__PURE__*/function () {
        function Bl() {
          _classCallCheck(this, Bl);

          this._operations = [], this._undoPairs = new Map(), this._undoneOperations = new Set();
        }

        _createClass(Bl, [{
          key: "addOperation",
          value: function addOperation(t) {
            this._operations.includes(t) || this._operations.push(t);
          }
        }, {
          key: "getOperations",
          value: function getOperations() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Number.NEGATIVE_INFINITY;
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.POSITIVE_INFINITY;
            var n = [];

            var _iterator263 = _createForOfIteratorHelper(this._operations),
                _step263;

            try {
              for (_iterator263.s(); !(_step263 = _iterator263.n()).done;) {
                var _i126 = _step263.value;
                _i126.baseVersion >= t && _i126.baseVersion < e && n.push(_i126);
              }
            } catch (err) {
              _iterator263.e(err);
            } finally {
              _iterator263.f();
            }

            return n;
          }
        }, {
          key: "getOperation",
          value: function getOperation(t) {
            var _iterator264 = _createForOfIteratorHelper(this._operations),
                _step264;

            try {
              for (_iterator264.s(); !(_step264 = _iterator264.n()).done;) {
                var _e189 = _step264.value;
                if (_e189.baseVersion == t) return _e189;
              }
            } catch (err) {
              _iterator264.e(err);
            } finally {
              _iterator264.f();
            }
          }
        }, {
          key: "setOperationAsUndone",
          value: function setOperationAsUndone(t, e) {
            this._undoPairs.set(e, t), this._undoneOperations.add(t);
          }
        }, {
          key: "isUndoingOperation",
          value: function isUndoingOperation(t) {
            return this._undoPairs.has(t);
          }
        }, {
          key: "isUndoneOperation",
          value: function isUndoneOperation(t) {
            return this._undoneOperations.has(t);
          }
        }, {
          key: "getUndoneOperation",
          value: function getUndoneOperation(t) {
            return this._undoPairs.get(t);
          }
        }]);

        return Bl;
      }();

      function zl(t, e) {
        return !!(n = t.charAt(e - 1)) && 1 == n.length && /[\ud800-\udbff]/.test(n) && function (t) {
          return !!t && 1 == t.length && /[\udc00-\udfff]/.test(t);
        }(t.charAt(e));
        var n;
      }

      function Pl(t, e) {
        return !!(n = t.charAt(e)) && 1 == n.length && /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(n);
        var n;
      }

      var Ll = "$graveyard";

      var Rl = /*#__PURE__*/function () {
        function Rl(t) {
          var _this77 = this;

          _classCallCheck(this, Rl);

          this.model = t, this.version = 0, this.history = new Bl(this), this.selection = new cc(this), this.roots = new Di({
            idProperty: "rootName"
          }), this.differ = new Il(t.markers), this._postFixers = new Set(), this._hasSelectionChangedFromTheLastChangeBlock = !1, this.createRoot("$root", Ll), this.listenTo(t, "applyOperation", function (t, e) {
            var n = e[0];
            if (n.isDocumentOperation && n.baseVersion !== _this77.version) throw new a("model-document-applyoperation-wrong-version", _this77, {
              operation: n
            });
          }, {
            priority: "highest"
          }), this.listenTo(t, "applyOperation", function (t, e) {
            var n = e[0];
            n.isDocumentOperation && _this77.differ.bufferOperation(n);
          }, {
            priority: "high"
          }), this.listenTo(t, "applyOperation", function (t, e) {
            var n = e[0];
            n.isDocumentOperation && (_this77.version++, _this77.history.addOperation(n));
          }, {
            priority: "low"
          }), this.listenTo(this.selection, "change", function () {
            _this77._hasSelectionChangedFromTheLastChangeBlock = !0;
          }), this.listenTo(t.markers, "update", function (t, e, n, i) {
            _this77.differ.bufferMarkerChange(e.name, n, i, e.affectsData), null === n && e.on("change", function (t, n) {
              _this77.differ.bufferMarkerChange(e.name, n, e.getRange(), e.affectsData);
            });
          });
        }

        _createClass(Rl, [{
          key: "graveyard",
          get: function get() {
            return this.getRoot(Ll);
          }
        }, {
          key: "createRoot",
          value: function createRoot() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "$root";
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
            if (this.roots.get(e)) throw new a("model-document-createroot-name-exists", this, {
              name: e
            });
            var n = new _l(this, t, e);
            return this.roots.add(n), n;
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.selection.destroy(), this.stopListening();
          }
        }, {
          key: "getRoot",
          value: function getRoot() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
            return this.roots.get(t);
          }
        }, {
          key: "getRootNames",
          value: function getRootNames() {
            return Array.from(this.roots, function (t) {
              return t.rootName;
            }).filter(function (t) {
              return t != Ll;
            });
          }
        }, {
          key: "registerPostFixer",
          value: function registerPostFixer(t) {
            this._postFixers.add(t);
          }
        }, {
          key: "toJSON",
          value: function toJSON() {
            var t = Ri(this);
            return t.selection = "[engine.model.DocumentSelection]", t.model = "[engine.model.Model]", t;
          }
        }, {
          key: "_handleChangeBlock",
          value: function _handleChangeBlock(t) {
            this._hasDocumentChangedFromTheLastChangeBlock() && (this._callPostFixers(t), this.selection.refresh(), this.differ.hasDataChanges() ? this.fire("change:data", t.batch) : this.fire("change", t.batch), this.selection.refresh(), this.differ.reset()), this._hasSelectionChangedFromTheLastChangeBlock = !1;
          }
        }, {
          key: "_hasDocumentChangedFromTheLastChangeBlock",
          value: function _hasDocumentChangedFromTheLastChangeBlock() {
            return !this.differ.isEmpty || this._hasSelectionChangedFromTheLastChangeBlock;
          }
        }, {
          key: "_getDefaultRoot",
          value: function _getDefaultRoot() {
            var _iterator265 = _createForOfIteratorHelper(this.roots),
                _step265;

            try {
              for (_iterator265.s(); !(_step265 = _iterator265.n()).done;) {
                var _t185 = _step265.value;
                if (_t185 !== this.graveyard) return _t185;
              }
            } catch (err) {
              _iterator265.e(err);
            } finally {
              _iterator265.f();
            }

            return this.graveyard;
          }
        }, {
          key: "_getDefaultRange",
          value: function _getDefaultRange() {
            var t = this._getDefaultRoot(),
                e = this.model,
                n = e.schema,
                i = e.createPositionFromPath(t, [0]);

            return n.getNearestSelectionRange(i) || e.createRange(i);
          }
        }, {
          key: "_validateSelectionRange",
          value: function _validateSelectionRange(t) {
            return Ol(t.start) && Ol(t.end);
          }
        }, {
          key: "_callPostFixers",
          value: function _callPostFixers(t) {
            var e = !1;

            do {
              var _iterator266 = _createForOfIteratorHelper(this._postFixers),
                  _step266;

              try {
                for (_iterator266.s(); !(_step266 = _iterator266.n()).done;) {
                  var _n167 = _step266.value;
                  if (this.selection.refresh(), e = _n167(t), e) break;
                }
              } catch (err) {
                _iterator266.e(err);
              } finally {
                _iterator266.f();
              }
            } while (e);
          }
        }]);

        return Rl;
      }();

      function Ol(t) {
        var e = t.textNode;

        if (e) {
          var _n168 = e.data,
              _i127 = t.offset - e.startOffset;

          return !zl(_n168, _i127) && !Pl(_n168, _i127);
        }

        return !0;
      }

      he(Rl, f);

      var jl = /*#__PURE__*/function (_Symbol$iterator12) {
        function jl() {
          _classCallCheck(this, jl);

          this._markers = new Map();
        }

        _createClass(jl, [{
          key: _Symbol$iterator12,
          value: function value() {
            return this._markers.values();
          }
        }, {
          key: "has",
          value: function has(t) {
            var e = t instanceof Fl ? t.name : t;
            return this._markers.has(e);
          }
        }, {
          key: "get",
          value: function get(t) {
            return this._markers.get(t) || null;
          }
        }, {
          key: "_set",
          value: function _set(t, e) {
            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
            var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
            var o = t instanceof Fl ? t.name : t;
            if (o.includes(",")) throw new a("markercollection-incorrect-marker-name", this);

            var r = this._markers.get(o);

            if (r) {
              var _t186 = r.getRange();

              var _s21 = !1;

              return _t186.isEqual(e) || (r._attachLiveRange(oc.fromRange(e)), _s21 = !0), n != r.managedUsingOperations && (r._managedUsingOperations = n, _s21 = !0), "boolean" == typeof i && i != r.affectsData && (r._affectsData = i, _s21 = !0), _s21 && this.fire("update:" + o, r, _t186, e), r;
            }

            var s = oc.fromRange(e),
                c = new Fl(o, s, n, i);
            return this._markers.set(o, c), this.fire("update:" + o, c, null, e), c;
          }
        }, {
          key: "_remove",
          value: function _remove(t) {
            var e = t instanceof Fl ? t.name : t,
                n = this._markers.get(e);

            return !!n && (this._markers.delete(e), this.fire("update:" + e, n, n.getRange(), null), this._destroyMarker(n), !0);
          }
        }, {
          key: "_refresh",
          value: function _refresh(t) {
            var e = t instanceof Fl ? t.name : t,
                n = this._markers.get(e);

            if (!n) throw new a("markercollection-refresh-marker-not-exists", this);
            var i = n.getRange();
            this.fire("update:" + e, n, i, i, n.managedUsingOperations, n.affectsData);
          }
        }, {
          key: "getMarkersAtPosition",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function getMarkersAtPosition(t) {
            var _iterator267, _step267, _e190;

            return _regeneratorRuntime.wrap(function getMarkersAtPosition$(_context31) {
              while (1) {
                switch (_context31.prev = _context31.next) {
                  case 0:
                    _iterator267 = _createForOfIteratorHelper(this);
                    _context31.prev = 1;

                    _iterator267.s();

                  case 3:
                    if ((_step267 = _iterator267.n()).done) {
                      _context31.next = 11;
                      break;
                    }

                    _e190 = _step267.value;
                    _context31.t0 = _e190.getRange().containsPosition(t);

                    if (!_context31.t0) {
                      _context31.next = 9;
                      break;
                    }

                    _context31.next = 9;
                    return _e190;

                  case 9:
                    _context31.next = 3;
                    break;

                  case 11:
                    _context31.next = 16;
                    break;

                  case 13:
                    _context31.prev = 13;
                    _context31.t1 = _context31["catch"](1);

                    _iterator267.e(_context31.t1);

                  case 16:
                    _context31.prev = 16;

                    _iterator267.f();

                    return _context31.finish(16);

                  case 19:
                  case "end":
                    return _context31.stop();
                }
              }
            }, getMarkersAtPosition, this, [[1, 13, 16, 19]]);
          })
        }, {
          key: "getMarkersIntersectingRange",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function getMarkersIntersectingRange(t) {
            var _iterator268, _step268, _e191;

            return _regeneratorRuntime.wrap(function getMarkersIntersectingRange$(_context32) {
              while (1) {
                switch (_context32.prev = _context32.next) {
                  case 0:
                    _iterator268 = _createForOfIteratorHelper(this);
                    _context32.prev = 1;

                    _iterator268.s();

                  case 3:
                    if ((_step268 = _iterator268.n()).done) {
                      _context32.next = 11;
                      break;
                    }

                    _e191 = _step268.value;
                    _context32.t0 = null !== _e191.getRange().getIntersection(t);

                    if (!_context32.t0) {
                      _context32.next = 9;
                      break;
                    }

                    _context32.next = 9;
                    return _e191;

                  case 9:
                    _context32.next = 3;
                    break;

                  case 11:
                    _context32.next = 16;
                    break;

                  case 13:
                    _context32.prev = 13;
                    _context32.t1 = _context32["catch"](1);

                    _iterator268.e(_context32.t1);

                  case 16:
                    _context32.prev = 16;

                    _iterator268.f();

                    return _context32.finish(16);

                  case 19:
                  case "end":
                    return _context32.stop();
                }
              }
            }, getMarkersIntersectingRange, this, [[1, 13, 16, 19]]);
          })
        }, {
          key: "destroy",
          value: function destroy() {
            var _iterator269 = _createForOfIteratorHelper(this._markers.values()),
                _step269;

            try {
              for (_iterator269.s(); !(_step269 = _iterator269.n()).done;) {
                var _t187 = _step269.value;

                this._destroyMarker(_t187);
              }
            } catch (err) {
              _iterator269.e(err);
            } finally {
              _iterator269.f();
            }

            this._markers = null, this.stopListening();
          }
        }, {
          key: "getMarkersGroup",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function getMarkersGroup(t) {
            var _iterator270, _step270, _e192;

            return _regeneratorRuntime.wrap(function getMarkersGroup$(_context33) {
              while (1) {
                switch (_context33.prev = _context33.next) {
                  case 0:
                    _iterator270 = _createForOfIteratorHelper(this._markers.values());
                    _context33.prev = 1;

                    _iterator270.s();

                  case 3:
                    if ((_step270 = _iterator270.n()).done) {
                      _context33.next = 11;
                      break;
                    }

                    _e192 = _step270.value;
                    _context33.t0 = _e192.name.startsWith(t + ":");

                    if (!_context33.t0) {
                      _context33.next = 9;
                      break;
                    }

                    _context33.next = 9;
                    return _e192;

                  case 9:
                    _context33.next = 3;
                    break;

                  case 11:
                    _context33.next = 16;
                    break;

                  case 13:
                    _context33.prev = 13;
                    _context33.t1 = _context33["catch"](1);

                    _iterator270.e(_context33.t1);

                  case 16:
                    _context33.prev = 16;

                    _iterator270.f();

                    return _context33.finish(16);

                  case 19:
                  case "end":
                    return _context33.stop();
                }
              }
            }, getMarkersGroup, this, [[1, 13, 16, 19]]);
          })
        }, {
          key: "_destroyMarker",
          value: function _destroyMarker(t) {
            t.stopListening(), t._detachLiveRange();
          }
        }]);

        return jl;
      }(Symbol.iterator);

      he(jl, f);

      var Fl = /*#__PURE__*/function () {
        function Fl(t, e, n, i) {
          _classCallCheck(this, Fl);

          this.name = t, this._liveRange = this._attachLiveRange(e), this._managedUsingOperations = n, this._affectsData = i;
        }

        _createClass(Fl, [{
          key: "managedUsingOperations",
          get: function get() {
            if (!this._liveRange) throw new a("marker-destroyed", this);
            return this._managedUsingOperations;
          }
        }, {
          key: "affectsData",
          get: function get() {
            if (!this._liveRange) throw new a("marker-destroyed", this);
            return this._affectsData;
          }
        }, {
          key: "getStart",
          value: function getStart() {
            if (!this._liveRange) throw new a("marker-destroyed", this);
            return this._liveRange.start.clone();
          }
        }, {
          key: "getEnd",
          value: function getEnd() {
            if (!this._liveRange) throw new a("marker-destroyed", this);
            return this._liveRange.end.clone();
          }
        }, {
          key: "getRange",
          value: function getRange() {
            if (!this._liveRange) throw new a("marker-destroyed", this);
            return this._liveRange.toRange();
          }
        }, {
          key: "is",
          value: function is(t) {
            return "marker" === t || "model:marker" === t;
          }
        }, {
          key: "_attachLiveRange",
          value: function _attachLiveRange(t) {
            return this._liveRange && this._detachLiveRange(), t.delegate("change:range").to(this), t.delegate("change:content").to(this), this._liveRange = t, t;
          }
        }, {
          key: "_detachLiveRange",
          value: function _detachLiveRange() {
            this._liveRange.stopDelegating("change:range", this), this._liveRange.stopDelegating("change:content", this), this._liveRange.detach(), this._liveRange = null;
          }
        }]);

        return Fl;
      }();

      he(Fl, f);

      var Vl = /*#__PURE__*/function (_il10) {
        _inherits(Vl, _il10);

        var _super38 = _createSuper(Vl);

        function Vl() {
          _classCallCheck(this, Vl);

          return _super38.apply(this, arguments);
        }

        _createClass(Vl, [{
          key: "type",
          get: function get() {
            return "noop";
          }
        }, {
          key: "clone",
          value: function clone() {
            return new Vl(this.baseVersion);
          }
        }, {
          key: "getReversed",
          value: function getReversed() {
            return new Vl(this.baseVersion + 1);
          }
        }, {
          key: "_execute",
          value: function _execute() {}
        }], [{
          key: "className",
          get: function get() {
            return "NoOperation";
          }
        }]);

        return Vl;
      }(il);

      var Ul = {};
      Ul[gl.className] = gl, Ul[fl.className] = fl, Ul[kl.className] = kl, Ul[pl.className] = pl, Ul[Vl.className] = Vl, Ul[il.className] = il, Ul[bl.className] = bl, Ul[wl.className] = wl, Ul[Cl.className] = Cl, Ul[Al.className] = Al;

      var Hl = /*#__PURE__*/function (_Va) {
        _inherits(Hl, _Va);

        var _super39 = _createSuper(Hl);

        function Hl(t, e) {
          var _this78;

          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";

          _classCallCheck(this, Hl);

          if (_this78 = _super39.call(this, t, e, n), !_this78.root.is("rootElement")) throw new a("model-liveposition-root-not-rootelement", t);
          ql.call(_assertThisInitialized(_this78));
          return _possibleConstructorReturn(_this78);
        }

        _createClass(Hl, [{
          key: "detach",
          value: function detach() {
            this.stopListening();
          }
        }, {
          key: "is",
          value: function is(t) {
            return "livePosition" === t || "model:livePosition" === t || "position" == t || "model:position" === t;
          }
        }, {
          key: "toPosition",
          value: function toPosition() {
            return new Va(this.root, this.path.slice(), this.stickiness);
          }
        }], [{
          key: "fromPosition",
          value: function fromPosition(t, e) {
            return new this(t.root, t.path.slice(), e || t.stickiness);
          }
        }]);

        return Hl;
      }(Va);

      function ql() {
        var _this79 = this;

        this.listenTo(this.root.document.model, "applyOperation", function (t, e) {
          var n = e[0];
          n.isDocumentOperation && Wl.call(_this79, n);
        }, {
          priority: "low"
        });
      }

      function Wl(t) {
        var e = this.getTransformedByOperation(t);

        if (!this.isEqual(e)) {
          var _t188 = this.toPosition();

          this.path = e.path, this.root = e.root, this.fire("change", _t188);
        }
      }

      he(Hl, f);

      var Gl = /*#__PURE__*/function () {
        function Gl(t, e, n) {
          _classCallCheck(this, Gl);

          this.model = t, this.writer = e, this.position = n, this.canMergeWith = new Set([this.position.parent]), this.schema = t.schema, this._documentFragment = e.createDocumentFragment(), this._documentFragmentPosition = e.createPositionAt(this._documentFragment, 0), this._firstNode = null, this._lastNode = null, this._lastAutoParagraph = null, this._filterAttributesOf = [], this._affectedStart = null, this._affectedEnd = null;
        }

        _createClass(Gl, [{
          key: "handleNodes",
          value: function handleNodes(t) {
            for (var _i128 = 0, _Array$from6 = Array.from(t); _i128 < _Array$from6.length; _i128++) {
              var _e193 = _Array$from6[_i128];

              this._handleNode(_e193);
            }

            this._insertPartialFragment(), this._lastAutoParagraph && this._updateLastNodeFromAutoParagraph(this._lastAutoParagraph), this._mergeOnRight(), this.schema.removeDisallowedAttributes(this._filterAttributesOf, this.writer), this._filterAttributesOf = [];
          }
        }, {
          key: "_updateLastNodeFromAutoParagraph",
          value: function _updateLastNodeFromAutoParagraph(t) {
            var e = this.writer.createPositionAfter(this._lastNode),
                n = this.writer.createPositionAfter(t);

            if (n.isAfter(e)) {
              if (this._lastNode = t, this.position.parent != t || !this.position.isAtEnd) throw new a("insertcontent-invalid-insertion-position", this);
              this.position = n, this._setAffectedBoundaries(this.position);
            }
          }
        }, {
          key: "getSelectionRange",
          value: function getSelectionRange() {
            return this.nodeToSelect ? Wa._createOn(this.nodeToSelect) : this.model.schema.getNearestSelectionRange(this.position);
          }
        }, {
          key: "getAffectedRange",
          value: function getAffectedRange() {
            return this._affectedStart ? new Wa(this._affectedStart, this._affectedEnd) : null;
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this._affectedStart && this._affectedStart.detach(), this._affectedEnd && this._affectedEnd.detach();
          }
        }, {
          key: "_handleNode",
          value: function _handleNode(t) {
            if (this.schema.isObject(t)) return void this._handleObject(t);

            var e = this._checkAndAutoParagraphToAllowedPosition(t);

            e || (e = this._checkAndSplitToAllowedPosition(t), e) ? (this._appendToFragment(t), this._firstNode || (this._firstNode = t), this._lastNode = t) : this._handleDisallowedNode(t);
          }
        }, {
          key: "_insertPartialFragment",
          value: function _insertPartialFragment() {
            if (this._documentFragment.isEmpty) return;
            var t = Hl.fromPosition(this.position, "toNext");
            this._setAffectedBoundaries(this.position), this._documentFragment.getChild(0) == this._firstNode && (this.writer.insert(this._firstNode, this.position), this._mergeOnLeft(), this.position = t.toPosition()), this._documentFragment.isEmpty || this.writer.insert(this._documentFragment, this.position), this._documentFragmentPosition = this.writer.createPositionAt(this._documentFragment, 0), this.position = t.toPosition(), t.detach();
          }
        }, {
          key: "_handleObject",
          value: function _handleObject(t) {
            this._checkAndSplitToAllowedPosition(t) ? this._appendToFragment(t) : this._tryAutoparagraphing(t);
          }
        }, {
          key: "_handleDisallowedNode",
          value: function _handleDisallowedNode(t) {
            t.is("element") ? this.handleNodes(t.getChildren()) : this._tryAutoparagraphing(t);
          }
        }, {
          key: "_appendToFragment",
          value: function _appendToFragment(t) {
            if (!this.schema.checkChild(this.position, t)) throw new a("insertcontent-wrong-position", this, {
              node: t,
              position: this.position
            });
            this.writer.insert(t, this._documentFragmentPosition), this._documentFragmentPosition = this._documentFragmentPosition.getShiftedBy(t.offsetSize), this.schema.isObject(t) && !this.schema.checkChild(this.position, "$text") ? this.nodeToSelect = t : this.nodeToSelect = null, this._filterAttributesOf.push(t);
          }
        }, {
          key: "_setAffectedBoundaries",
          value: function _setAffectedBoundaries(t) {
            this._affectedStart || (this._affectedStart = Hl.fromPosition(t, "toPrevious")), this._affectedEnd && !this._affectedEnd.isBefore(t) || (this._affectedEnd && this._affectedEnd.detach(), this._affectedEnd = Hl.fromPosition(t, "toNext"));
          }
        }, {
          key: "_mergeOnLeft",
          value: function _mergeOnLeft() {
            var t = this._firstNode;
            if (!(t instanceof Oa)) return;
            if (!this._canMergeLeft(t)) return;

            var e = Hl._createBefore(t);

            e.stickiness = "toNext";
            var n = Hl.fromPosition(this.position, "toNext");
            this._affectedStart.isEqual(e) && (this._affectedStart.detach(), this._affectedStart = Hl._createAt(e.nodeBefore, "end", "toPrevious")), this._firstNode === this._lastNode && (this._firstNode = e.nodeBefore, this._lastNode = e.nodeBefore), this.writer.merge(e), e.isEqual(this._affectedEnd) && this._firstNode === this._lastNode && (this._affectedEnd.detach(), this._affectedEnd = Hl._createAt(e.nodeBefore, "end", "toNext")), this.position = n.toPosition(), n.detach(), this._filterAttributesOf.push(this.position.parent), e.detach();
          }
        }, {
          key: "_mergeOnRight",
          value: function _mergeOnRight() {
            var t = this._lastNode;
            if (!(t instanceof Oa)) return;
            if (!this._canMergeRight(t)) return;

            var e = Hl._createAfter(t);

            if (e.stickiness = "toNext", !this.position.isEqual(e)) throw new a("insertcontent-invalid-insertion-position", this);
            this.position = Va._createAt(e.nodeBefore, "end");
            var n = Hl.fromPosition(this.position, "toPrevious");
            this._affectedEnd.isEqual(e) && (this._affectedEnd.detach(), this._affectedEnd = Hl._createAt(e.nodeBefore, "end", "toNext")), this._firstNode === this._lastNode && (this._firstNode = e.nodeBefore, this._lastNode = e.nodeBefore), this.writer.merge(e), e.getShiftedBy(-1).isEqual(this._affectedStart) && this._firstNode === this._lastNode && (this._affectedStart.detach(), this._affectedStart = Hl._createAt(e.nodeBefore, 0, "toPrevious")), this.position = n.toPosition(), n.detach(), this._filterAttributesOf.push(this.position.parent), e.detach();
          }
        }, {
          key: "_canMergeLeft",
          value: function _canMergeLeft(t) {
            var e = t.previousSibling;
            return e instanceof Oa && this.canMergeWith.has(e) && this.model.schema.checkMerge(e, t);
          }
        }, {
          key: "_canMergeRight",
          value: function _canMergeRight(t) {
            var e = t.nextSibling;
            return e instanceof Oa && this.canMergeWith.has(e) && this.model.schema.checkMerge(t, e);
          }
        }, {
          key: "_tryAutoparagraphing",
          value: function _tryAutoparagraphing(t) {
            var e = this.writer.createElement("paragraph");
            this._getAllowedIn(this.position.parent, e) && this.schema.checkChild(e, t) && (e._appendChild(t), this._handleNode(e));
          }
        }, {
          key: "_checkAndAutoParagraphToAllowedPosition",
          value: function _checkAndAutoParagraphToAllowedPosition(t) {
            if (this.schema.checkChild(this.position.parent, t)) return !0;
            if (!this.schema.checkChild(this.position.parent, "paragraph") || !this.schema.checkChild("paragraph", t)) return !1;

            this._insertPartialFragment();

            var e = this.writer.createElement("paragraph");
            return this.writer.insert(e, this.position), this._setAffectedBoundaries(this.position), this._lastAutoParagraph = e, this.position = this.writer.createPositionAt(e, 0), !0;
          }
        }, {
          key: "_checkAndSplitToAllowedPosition",
          value: function _checkAndSplitToAllowedPosition(t) {
            var e = this._getAllowedIn(this.position.parent, t);

            if (!e) return !1;

            for (e != this.position.parent && this._insertPartialFragment(); e != this.position.parent;) {
              if (this.position.isAtStart) {
                var _t189 = this.position.parent;
                this.position = this.writer.createPositionBefore(_t189), _t189.isEmpty && _t189.parent === e && this.writer.remove(_t189);
              } else if (this.position.isAtEnd) this.position = this.writer.createPositionAfter(this.position.parent);else {
                var _t190 = this.writer.createPositionAfter(this.position.parent);

                this._setAffectedBoundaries(this.position), this.writer.split(this.position), this.position = _t190, this.canMergeWith.add(this.position.nodeAfter);
              }
            }

            return !0;
          }
        }, {
          key: "_getAllowedIn",
          value: function _getAllowedIn(t, e) {
            return this.schema.checkChild(t, e) ? t : this.schema.isLimit(t) ? null : this._getAllowedIn(t.parent, e);
          }
        }]);

        return Gl;
      }();

      function $l(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (e.isCollapsed) return;
        var i = e.getFirstRange();
        if ("$graveyard" == i.root.rootName) return;
        var o = t.schema;
        t.change(function (t) {
          if (!n.doNotResetEntireContent && function (t, e) {
            var n = t.getLimitElement(e);
            if (!e.containsEntireContent(n)) return !1;
            var i = e.getFirstRange();
            if (i.start.parent == i.end.parent) return !1;
            return t.checkChild(n, "paragraph");
          }(o, e)) return void function (t, e) {
            var n = t.model.schema.getLimitElement(e);
            t.remove(t.createRangeIn(n)), Zl(t, t.createPositionAt(n, 0), e);
          }(t, e);

          var _ref26 = function (t) {
            var e = t.root.document.model,
                n = t.start;
            var i = t.end;

            if (e.hasContent(t, {
              ignoreMarkers: !0
            })) {
              var _n169 = function (t) {
                var e = t.parent,
                    n = e.root.document.model.schema,
                    i = e.getAncestors({
                  parentFirst: !0,
                  includeSelf: !0
                });

                var _iterator271 = _createForOfIteratorHelper(i),
                    _step271;

                try {
                  for (_iterator271.s(); !(_step271 = _iterator271.n()).done;) {
                    var _t191 = _step271.value;
                    if (n.isLimit(_t191)) return null;
                    if (n.isBlock(_t191)) return _t191;
                  }
                } catch (err) {
                  _iterator271.e(err);
                } finally {
                  _iterator271.f();
                }
              }(i);

              if (_n169 && i.isTouching(e.createPositionAt(_n169, 0))) {
                var _n170 = e.createSelection(t);

                e.modifySelection(_n170, {
                  direction: "backward"
                });

                var _o62 = _n170.getLastPosition(),
                    _r32 = e.createRange(_o62, i);

                e.hasContent(_r32, {
                  ignoreMarkers: !0
                }) || (i = _o62);
              }
            }

            return [Hl.fromPosition(n, "toPrevious"), Hl.fromPosition(i, "toNext")];
          }(i),
              _ref27 = _slicedToArray(_ref26, 2),
              r = _ref27[0],
              s = _ref27[1];

          r.isTouching(s) || t.remove(t.createRange(r, s)), n.leaveUnmerged || (!function (t, e, n) {
            var i = t.model;
            if (!Ql(t.model.schema, e, n)) return;

            var _ref28 = function (t, e) {
              var n = t.getAncestors(),
                  i = e.getAncestors();
              var o = 0;

              for (; n[o] && n[o] == i[o];) {
                o++;
              }

              return [n[o], i[o]];
            }(e, n),
                _ref29 = _slicedToArray(_ref28, 2),
                o = _ref29[0],
                r = _ref29[1];

            if (!o || !r) return;
            !i.hasContent(o, {
              ignoreMarkers: !0
            }) && i.hasContent(r, {
              ignoreMarkers: !0
            }) ? Kl(t, e, n, o.parent) : Yl(t, e, n, o.parent);
          }(t, r, s), o.removeDisallowedAttributes(r.parent.getChildren(), t)), Jl(t, e, r), !n.doNotAutoparagraph && function (t, e) {
            var n = t.checkChild(e, "$text"),
                i = t.checkChild(e, "paragraph");
            return !n && i;
          }(o, r) && Zl(t, r, e), r.detach(), s.detach();
        });
      }

      function Yl(t, e, n, i) {
        var o = e.parent,
            r = n.parent;

        if (o != i && r != i) {
          for (e = t.createPositionAfter(o), (n = t.createPositionBefore(r)).isEqual(e) || t.insert(r, e), t.merge(e); n.parent.isEmpty;) {
            var _e194 = n.parent;
            n = t.createPositionBefore(_e194), t.remove(_e194);
          }

          Ql(t.model.schema, e, n) && Yl(t, e, n, i);
        }
      }

      function Kl(t, e, n, i) {
        var o = e.parent,
            r = n.parent;

        if (o != i && r != i) {
          for (e = t.createPositionAfter(o), (n = t.createPositionBefore(r)).isEqual(e) || t.insert(o, n); e.parent.isEmpty;) {
            var _n171 = e.parent;
            e = t.createPositionBefore(_n171), t.remove(_n171);
          }

          n = t.createPositionBefore(r), function (t, e) {
            var n = e.nodeBefore,
                i = e.nodeAfter;
            n.name != i.name && t.rename(n, i.name);
            t.clearAttributes(n), t.setAttributes(Object.fromEntries(i.getAttributes()), n), t.merge(e);
          }(t, n), Ql(t.model.schema, e, n) && Kl(t, e, n, i);
        }
      }

      function Ql(t, e, n) {
        var i = e.parent,
            o = n.parent;
        return i != o && !t.isLimit(i) && !t.isLimit(o) && function (t, e, n) {
          var i = new Wa(t, e);

          var _iterator272 = _createForOfIteratorHelper(i.getWalker()),
              _step272;

          try {
            for (_iterator272.s(); !(_step272 = _iterator272.n()).done;) {
              var _t192 = _step272.value;
              if (n.isLimit(_t192.item)) return !1;
            }
          } catch (err) {
            _iterator272.e(err);
          } finally {
            _iterator272.f();
          }

          return !0;
        }(e, n, t);
      }

      function Zl(t, e, n) {
        var i = t.createElement("paragraph");
        t.insert(i, e), Jl(t, n, t.createPositionAt(i, 0));
      }

      function Jl(t, e, n) {
        e instanceof cc ? t.setSelection(n) : e.setTo(n);
      }

      var Xl = ' ,.?!:;"-()';

      function td(t, e) {
        var n = t.isForward,
            i = t.walker,
            o = t.unit,
            r = t.schema,
            s = e.type,
            a = e.item,
            c = e.nextPosition;
        if ("text" == s) return "word" === t.unit ? function (t, e) {
          var n = t.position.textNode;

          if (n) {
            var _i129 = t.position.offset - n.startOffset;

            for (; !nd(n.data, _i129, e) && !id(n, _i129, e);) {
              t.next();

              var _o63 = e ? t.position.nodeAfter : t.position.nodeBefore;

              if (_o63 && _o63.is("$text")) {
                var _i130 = _o63.data.charAt(e ? 0 : _o63.data.length - 1);

                Xl.includes(_i130) || (t.next(), n = t.position.textNode);
              }

              _i129 = t.position.offset - n.startOffset;
            }
          }

          return t.position;
        }(i, n) : function (t, e) {
          var n = t.position.textNode;

          if (n) {
            var _i131 = n.data;

            var _o64 = t.position.offset - n.startOffset;

            for (; zl(_i131, _o64) || "character" == e && Pl(_i131, _o64);) {
              t.next(), _o64 = t.position.offset - n.startOffset;
            }
          }

          return t.position;
        }(i, o);

        if (s == (n ? "elementStart" : "elementEnd")) {
          if (r.isSelectable(a)) return Va._createAt(a, n ? "after" : "before");
          if (r.checkChild(c, "$text")) return c;
        } else {
          if (r.isLimit(a)) return void i.skip(function () {
            return !0;
          });
          if (r.checkChild(c, "$text")) return c;
        }
      }

      function ed(t, e) {
        var n = t.root,
            i = Va._createAt(n, e ? "end" : 0);

        return e ? new Wa(t, i) : new Wa(i, t);
      }

      function nd(t, e, n) {
        var i = e + (n ? 0 : -1);
        return Xl.includes(t.charAt(i));
      }

      function id(t, e, n) {
        return e === (n ? t.endOffset : 0);
      }

      function od(t, e) {
        var n = [];
        Array.from(t.getItems({
          direction: "backward"
        })).map(function (t) {
          return e.createRangeOn(t);
        }).filter(function (e) {
          return (e.start.isAfter(t.start) || e.start.isEqual(t.start)) && (e.end.isBefore(t.end) || e.end.isEqual(t.end));
        }).forEach(function (t) {
          n.push(t.start.parent), e.remove(t);
        }), n.forEach(function (t) {
          var n = t;

          for (; n.parent && n.isEmpty;) {
            var _t193 = e.createRangeOn(n);

            n = n.parent, e.remove(_t193);
          }
        });
      }

      function rd(t) {
        t.document.registerPostFixer(function (e) {
          return function (t, e) {
            var n = e.document.selection,
                i = e.schema,
                o = [];
            var r = !1;

            var _iterator273 = _createForOfIteratorHelper(n.getRanges()),
                _step273;

            try {
              for (_iterator273.s(); !(_step273 = _iterator273.n()).done;) {
                var _t195 = _step273.value;

                var _e195 = sd(_t195, i);

                _e195 && !_e195.isEqual(_t195) ? (o.push(_e195), r = !0) : o.push(_t195);
              }
            } catch (err) {
              _iterator273.e(err);
            } finally {
              _iterator273.f();
            }

            r && t.setSelection(function (t) {
              var e = _toConsumableArray(t),
                  n = new Set();

              var i = 1;

              for (; i < e.length;) {
                var _t194 = e[i],
                    _o65 = e.slice(0, i);

                var _iterator274 = _createForOfIteratorHelper(_o65.entries()),
                    _step274;

                try {
                  for (_iterator274.s(); !(_step274 = _iterator274.n()).done;) {
                    var _step274$value = _slicedToArray(_step274.value, 2),
                        _r33 = _step274$value[0],
                        _s22 = _step274$value[1];

                    if (!n.has(_r33)) if (_t194.isEqual(_s22)) n.add(_r33);else if (_t194.isIntersecting(_s22)) {
                      n.add(_r33), n.add(i);

                      var _o66 = _t194.getJoined(_s22);

                      e.push(_o66);
                    }
                  }
                } catch (err) {
                  _iterator274.e(err);
                } finally {
                  _iterator274.f();
                }

                i++;
              }

              return e.filter(function (t, e) {
                return !n.has(e);
              });
            }(o), {
              backward: n.isBackward
            });
          }(e, t);
        });
      }

      function sd(t, e) {
        return t.isCollapsed ? function (t, e) {
          var n = t.start,
              i = e.getNearestSelectionRange(n);

          if (!i) {
            var _t196 = n.getAncestors().reverse().find(function (t) {
              return e.isObject(t);
            });

            return _t196 ? Wa._createOn(_t196) : null;
          }

          if (!i.isCollapsed) return i;
          var o = i.start;
          if (n.isEqual(o)) return null;
          return new Wa(o);
        }(t, e) : function (t, e) {
          var n = t.start,
              i = t.end,
              o = e.checkChild(n, "$text"),
              r = e.checkChild(i, "$text"),
              s = e.getLimitElement(n),
              a = e.getLimitElement(i);

          if (s === a) {
            if (o && r) return null;

            if (function (t, e, n) {
              var i = t.nodeAfter && !n.isLimit(t.nodeAfter) || n.checkChild(t, "$text"),
                  o = e.nodeBefore && !n.isLimit(e.nodeBefore) || n.checkChild(e, "$text");
              return i || o;
            }(n, i, e)) {
              var _t197 = n.nodeAfter && e.isSelectable(n.nodeAfter) ? null : e.getNearestSelectionRange(n, "forward"),
                  _o67 = i.nodeBefore && e.isSelectable(i.nodeBefore) ? null : e.getNearestSelectionRange(i, "backward"),
                  _r34 = _t197 ? _t197.start : n,
                  _s23 = _o67 ? _o67.end : i;

              return new Wa(_r34, _s23);
            }
          }

          var c = s && !s.is("rootElement"),
              l = a && !a.is("rootElement");

          if (c || l) {
            var _t198 = n.nodeAfter && i.nodeBefore && n.nodeAfter.parent === i.nodeBefore.parent,
                _o68 = c && (!_t198 || !cd(n.nodeAfter, e)),
                _r35 = l && (!_t198 || !cd(i.nodeBefore, e));

            var _d2 = n,
                _h2 = i;
            return _o68 && (_d2 = Va._createBefore(ad(s, e))), _r35 && (_h2 = Va._createAfter(ad(a, e))), new Wa(_d2, _h2);
          }

          return null;
        }(t, e);
      }

      function ad(t, e) {
        var n = t,
            i = n;

        for (; e.isLimit(i) && i.parent;) {
          n = i, i = i.parent;
        }

        return n;
      }

      function cd(t, e) {
        return t && e.isSelectable(t);
      }

      var ld = /*#__PURE__*/function () {
        function ld() {
          var _this80 = this;

          _classCallCheck(this, ld);

          this.markers = new jl(), this.document = new Rl(this), this.schema = new zc(), this._pendingChanges = [], this._currentWriter = null, ["insertContent", "deleteContent", "modifySelection", "getSelectedContent", "applyOperation"].forEach(function (t) {
            return _this80.decorate(t);
          }), this.on("applyOperation", function (t, e) {
            e[0]._validate();
          }, {
            priority: "highest"
          }), this.schema.register("$root", {
            isLimit: !0
          }), this.schema.register("$block", {
            allowIn: "$root",
            isBlock: !0
          }), this.schema.register("$text", {
            allowIn: "$block",
            isInline: !0,
            isContent: !0
          }), this.schema.register("$clipboardHolder", {
            allowContentOf: "$root",
            allowChildren: "$text",
            isLimit: !0
          }), this.schema.register("$documentFragment", {
            allowContentOf: "$root",
            allowChildren: "$text",
            isLimit: !0
          }), this.schema.register("$marker"), this.schema.addChildCheck(function (t, e) {
            if ("$marker" === e.name) return !0;
          }), rd(this), this.document.registerPostFixer(Ac);
        }

        _createClass(ld, [{
          key: "change",
          value: function change(t) {
            try {
              return 0 === this._pendingChanges.length ? (this._pendingChanges.push({
                batch: new nl(),
                callback: t
              }), this._runPendingChanges()[0]) : t(this._currentWriter);
            } catch (t) {
              a.rethrowUnexpectedError(t, this);
            }
          }
        }, {
          key: "enqueueChange",
          value: function enqueueChange(t, e) {
            try {
              t ? "function" == typeof t ? (e = t, t = new nl()) : t instanceof nl || (t = new nl(t)) : t = new nl(), this._pendingChanges.push({
                batch: t,
                callback: e
              }), 1 == this._pendingChanges.length && this._runPendingChanges();
            } catch (t) {
              a.rethrowUnexpectedError(t, this);
            }
          }
        }, {
          key: "applyOperation",
          value: function applyOperation(t) {
            t._execute();
          }
        }, {
          key: "insertContent",
          value: function insertContent(t, e, n) {
            return function (t, e, n, i) {
              return t.change(function (o) {
                var r;
                r = n ? n instanceof Xa || n instanceof cc ? n : o.createSelection(n, i) : t.document.selection, r.isCollapsed || t.deleteContent(r, {
                  doNotAutoparagraph: !0
                });
                var s = new Gl(t, o, r.anchor);
                var a;
                a = e.is("documentFragment") ? e.getChildren() : [e], s.handleNodes(a);
                var c = s.getSelectionRange();
                c && (r instanceof cc ? o.setSelection(c) : r.setTo(c));
                var l = s.getAffectedRange() || t.createRange(r.anchor);
                return s.destroy(), l;
              });
            }(this, t, e, n);
          }
        }, {
          key: "deleteContent",
          value: function deleteContent(t, e) {
            $l(this, t, e);
          }
        }, {
          key: "modifySelection",
          value: function modifySelection(t, e) {
            !function (t, e) {
              var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              var i = t.schema,
                  o = "backward" != n.direction,
                  r = n.unit ? n.unit : "character",
                  s = e.focus,
                  a = new ja({
                boundaries: ed(s, o),
                singleCharacters: !0,
                direction: o ? "forward" : "backward"
              }),
                  c = {
                walker: a,
                schema: i,
                isForward: o,
                unit: r
              };
              var l;

              var _loop3 = function _loop3() {
                if (l.done) return {
                  v: void 0
                };
                var n = td(c, l.value);
                if (n) return {
                  v: void (e instanceof cc ? t.change(function (t) {
                    t.setSelectionFocus(n);
                  }) : e.setFocus(n))
                };
              };

              for (; l = a.next();) {
                var _ret2 = _loop3();

                if (typeof _ret2 === "object") return _ret2.v;
              }
            }(this, t, e);
          }
        }, {
          key: "getSelectedContent",
          value: function getSelectedContent(t) {
            return function (t, e) {
              return t.change(function (t) {
                var n = t.createDocumentFragment(),
                    i = e.getFirstRange();
                if (!i || i.isCollapsed) return n;
                var o = i.start.root,
                    r = i.start.getCommonPath(i.end),
                    s = o.getNodeByPath(r);
                var a;
                a = i.start.parent == i.end.parent ? i : t.createRange(t.createPositionAt(s, i.start.path[r.length]), t.createPositionAt(s, i.end.path[r.length] + 1));
                var c = a.end.offset - a.start.offset;

                var _iterator275 = _createForOfIteratorHelper(a.getItems({
                  shallow: !0
                })),
                    _step275;

                try {
                  for (_iterator275.s(); !(_step275 = _iterator275.n()).done;) {
                    var _e197 = _step275.value;
                    _e197.is("$textProxy") ? t.appendText(_e197.data, _e197.getAttributes(), n) : t.append(t.cloneElement(_e197, !0), n);
                  }
                } catch (err) {
                  _iterator275.e(err);
                } finally {
                  _iterator275.f();
                }

                if (a != i) {
                  var _e196 = i._getTransformedByMove(a.start, t.createPositionAt(n, 0), c)[0],
                      _o69 = t.createRange(t.createPositionAt(n, 0), _e196.start);

                  od(t.createRange(_e196.end, t.createPositionAt(n, "end")), t), od(_o69, t);
                }

                return n;
              });
            }(this, t);
          }
        }, {
          key: "hasContent",
          value: function hasContent(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var n = t instanceof Oa ? Wa._createIn(t) : t;
            if (n.isCollapsed) return !1;
            var _e$ignoreWhitespaces = e.ignoreWhitespaces,
                i = _e$ignoreWhitespaces === void 0 ? !1 : _e$ignoreWhitespaces,
                _e$ignoreMarkers = e.ignoreMarkers,
                o = _e$ignoreMarkers === void 0 ? !1 : _e$ignoreMarkers;

            if (!o) {
              var _iterator276 = _createForOfIteratorHelper(this.markers.getMarkersIntersectingRange(n)),
                  _step276;

              try {
                for (_iterator276.s(); !(_step276 = _iterator276.n()).done;) {
                  var _t199 = _step276.value;
                  if (_t199.affectsData) return !0;
                }
              } catch (err) {
                _iterator276.e(err);
              } finally {
                _iterator276.f();
              }
            }

            var _iterator277 = _createForOfIteratorHelper(n.getItems()),
                _step277;

            try {
              for (_iterator277.s(); !(_step277 = _iterator277.n()).done;) {
                var _t200 = _step277.value;

                if (this.schema.isContent(_t200)) {
                  if (!_t200.is("$textProxy")) return !0;
                  if (!i) return !0;
                  if (-1 !== _t200.data.search(/\S/)) return !0;
                }
              }
            } catch (err) {
              _iterator277.e(err);
            } finally {
              _iterator277.f();
            }

            return !1;
          }
        }, {
          key: "createPositionFromPath",
          value: function createPositionFromPath(t, e, n) {
            return new Va(t, e, n);
          }
        }, {
          key: "createPositionAt",
          value: function createPositionAt(t, e) {
            return Va._createAt(t, e);
          }
        }, {
          key: "createPositionAfter",
          value: function createPositionAfter(t) {
            return Va._createAfter(t);
          }
        }, {
          key: "createPositionBefore",
          value: function createPositionBefore(t) {
            return Va._createBefore(t);
          }
        }, {
          key: "createRange",
          value: function createRange(t, e) {
            return new Wa(t, e);
          }
        }, {
          key: "createRangeIn",
          value: function createRangeIn(t) {
            return Wa._createIn(t);
          }
        }, {
          key: "createRangeOn",
          value: function createRangeOn(t) {
            return Wa._createOn(t);
          }
        }, {
          key: "createSelection",
          value: function createSelection(t, e, n) {
            return new Xa(t, e, n);
          }
        }, {
          key: "createBatch",
          value: function createBatch(t) {
            return new nl(t);
          }
        }, {
          key: "createOperationFromJSON",
          value: function createOperationFromJSON(t) {
            return /*#__PURE__*/function () {
              function _class() {
                _classCallCheck(this, _class);
              }

              _createClass(_class, null, [{
                key: "fromJSON",
                value: function fromJSON(t, e) {
                  return Ul[t.__className].fromJSON(t, e);
                }
              }]);

              return _class;
            }().fromJSON(t, this.document);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.document.destroy(), this.stopListening();
          }
        }, {
          key: "_runPendingChanges",
          value: function _runPendingChanges() {
            var t = [];

            for (this.fire("_beforeChanges"); this._pendingChanges.length;) {
              var _e198 = this._pendingChanges[0].batch;
              this._currentWriter = new vl(this, _e198);

              var _n172 = this._pendingChanges[0].callback(this._currentWriter);

              t.push(_n172), this.document._handleChangeBlock(this._currentWriter), this._pendingChanges.shift(), this._currentWriter = null;
            }

            return this.fire("_afterChanges"), t;
          }
        }]);

        return ld;
      }();

      he(ld, re);

      var dd = /*#__PURE__*/function (_Ca) {
        _inherits(dd, _Ca);

        var _super40 = _createSuper(dd);

        function dd(t) {
          var _this81;

          _classCallCheck(this, dd);

          _this81 = _super40.call(this), _this81.editor = t;
          return _this81;
        }

        _createClass(dd, [{
          key: "set",
          value: function set(t, e) {
            var _this82 = this;

            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            if ("string" == typeof e) {
              var _t201 = e;

              e = function e(_e199, n) {
                _this82.editor.execute(_t201), n();
              };
            }

            _get(_getPrototypeOf(dd.prototype), "set", this).call(this, t, e, n);
          }
        }]);

        return dd;
      }(Ca);

      var hd = /*#__PURE__*/function () {
        function hd() {
          var _this83 = this;

          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          _classCallCheck(this, hd);

          var e = t.language || this.constructor.defaultConfig && this.constructor.defaultConfig.language;
          this._context = t.context || new zi({
            language: e
          }), this._context._addEditor(this, !t.context);
          var n = Array.from(this.constructor.builtinPlugins || []);
          this.config = new vi(t, this.constructor.defaultConfig), this.config.define("plugins", n), this.config.define(this._context._getEditorConfig()), this.plugins = new Si(this, n, this._context.plugins), this.locale = this._context.locale, this.t = this.locale.t, this.commands = new Tc(), this.set("state", "initializing"), this.once("ready", function () {
            return _this83.state = "ready";
          }, {
            priority: "high"
          }), this.once("destroy", function () {
            return _this83.state = "destroyed";
          }, {
            priority: "high"
          }), this.set("isReadOnly", !1), this.model = new ld();
          var i = new Do();
          this.data = new Jc(this.model, i), this.editing = new Mc(this.model, i), this.editing.view.document.bind("isReadOnly").to(this), this.conversion = new Xc([this.editing.downcastDispatcher, this.data.downcastDispatcher], this.data.upcastDispatcher), this.conversion.addAlias("dataDowncast", this.data.downcastDispatcher), this.conversion.addAlias("editingDowncast", this.editing.downcastDispatcher), this.keystrokes = new dd(this), this.keystrokes.listenTo(this.editing.view.document);
        }

        _createClass(hd, [{
          key: "initPlugins",
          value: function initPlugins() {
            var t = this.config,
                e = t.get("plugins"),
                n = t.get("removePlugins") || [],
                i = t.get("extraPlugins") || [],
                o = t.get("substitutePlugins") || [];
            return this.plugins.init(e.concat(i), n, o);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            var _this84 = this;

            var t = Promise.resolve();
            return "initializing" == this.state && (t = new Promise(function (t) {
              return _this84.once("ready", t);
            })), t.then(function () {
              _this84.fire("destroy"), _this84.stopListening(), _this84.commands.destroy();
            }).then(function () {
              return _this84.plugins.destroy();
            }).then(function () {
              _this84.model.destroy(), _this84.data.destroy(), _this84.editing.destroy(), _this84.keystrokes.destroy();
            }).then(function () {
              return _this84._context._removeEditor(_this84);
            });
          }
        }, {
          key: "execute",
          value: function execute() {
            try {
              var _this$commands;

              return (_this$commands = this.commands).execute.apply(_this$commands, arguments);
            } catch (t) {
              a.rethrowUnexpectedError(t, this);
            }
          }
        }, {
          key: "focus",
          value: function focus() {
            this.editing.view.focus();
          }
        }]);

        return hd;
      }();

      he(hd, re);

      var ud = /*#__PURE__*/function () {
        function ud(t) {
          _classCallCheck(this, ud);

          this.editor = t, this._components = new Map();
        }

        _createClass(ud, [{
          key: "names",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function names() {
            var _iterator278, _step278, _t202;

            return _regeneratorRuntime.wrap(function names$(_context34) {
              while (1) {
                switch (_context34.prev = _context34.next) {
                  case 0:
                    _iterator278 = _createForOfIteratorHelper(this._components.values());
                    _context34.prev = 1;

                    _iterator278.s();

                  case 3:
                    if ((_step278 = _iterator278.n()).done) {
                      _context34.next = 9;
                      break;
                    }

                    _t202 = _step278.value;
                    _context34.next = 7;
                    return _t202.originalName;

                  case 7:
                    _context34.next = 3;
                    break;

                  case 9:
                    _context34.next = 14;
                    break;

                  case 11:
                    _context34.prev = 11;
                    _context34.t0 = _context34["catch"](1);

                    _iterator278.e(_context34.t0);

                  case 14:
                    _context34.prev = 14;

                    _iterator278.f();

                    return _context34.finish(14);

                  case 17:
                  case "end":
                    return _context34.stop();
                }
              }
            }, names, this, [[1, 11, 14, 17]]);
          })
        }, {
          key: "add",
          value: function add(t, e) {
            this._components.set(gd(t), {
              callback: e,
              originalName: t
            });
          }
        }, {
          key: "create",
          value: function create(t) {
            if (!this.has(t)) throw new a("componentfactory-item-missing", this, {
              name: t
            });
            return this._components.get(gd(t)).callback(this.editor.locale);
          }
        }, {
          key: "has",
          value: function has(t) {
            return this._components.has(gd(t));
          }
        }]);

        return ud;
      }();

      function gd(t) {
        return String(t).toLowerCase();
      }

      var md = /*#__PURE__*/function () {
        function md(t) {
          var _this85 = this;

          _classCallCheck(this, md);

          this.editor = t, this.componentFactory = new ud(t), this.focusTracker = new Aa(), this.set("viewportOffset", this._readViewportOffsetFromConfig()), this._editableElementsMap = new Map(), this.listenTo(t.editing.view.document, "layoutChanged", function () {
            return _this85.update();
          });
        }

        _createClass(md, [{
          key: "element",
          get: function get() {
            return null;
          }
        }, {
          key: "update",
          value: function update() {
            this.fire("update");
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.stopListening(), this.focusTracker.destroy();

            var _iterator279 = _createForOfIteratorHelper(this._editableElementsMap.values()),
                _step279;

            try {
              for (_iterator279.s(); !(_step279 = _iterator279.n()).done;) {
                var _t203 = _step279.value;
                _t203.ckeditorInstance = null;
              }
            } catch (err) {
              _iterator279.e(err);
            } finally {
              _iterator279.f();
            }

            this._editableElementsMap = new Map();
          }
        }, {
          key: "setEditableElement",
          value: function setEditableElement(t, e) {
            this._editableElementsMap.set(t, e), e.ckeditorInstance || (e.ckeditorInstance = this.editor);
          }
        }, {
          key: "getEditableElement",
          value: function getEditableElement() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
            return this._editableElementsMap.get(t);
          }
        }, {
          key: "getEditableElementsNames",
          value: function getEditableElementsNames() {
            return this._editableElementsMap.keys();
          }
        }, {
          key: "_editableElements",
          get: function get() {
            return console.warn("editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.", {
              editorUI: this
            }), this._editableElementsMap;
          }
        }, {
          key: "_readViewportOffsetFromConfig",
          value: function _readViewportOffsetFromConfig() {
            var t = this.editor,
                e = t.config.get("ui.viewportOffset");
            if (e) return e;
            var n = t.config.get("toolbar.viewportTopOffset");
            return n ? (console.warn("editor-ui-deprecated-viewport-offset-config: The `toolbar.vieportTopOffset` configuration option is deprecated. It will be removed from future CKEditor versions. Use `ui.viewportOffset.top` instead."), {
              top: n
            }) : {
              top: 0
            };
          }
        }]);

        return md;
      }();

      he(md, re);
      var pd = {
        setData: function setData(t) {
          this.data.set(t);
        },
        getData: function getData(t) {
          return this.data.get(t);
        }
      };
      var fd = pd;
      var kd = {
        updateSourceElement: function updateSourceElement() {
          if (!this.sourceElement) throw new a("editor-missing-sourceelement", this);
          var t, e;
          t = this.sourceElement, e = this.data.get(), t instanceof HTMLTextAreaElement && (t.value = e), t.innerHTML = e;
        }
      };

      var bd = /*#__PURE__*/function (_Pi, _Symbol$iterator13) {
        _inherits(bd, _Pi);

        var _super41 = _createSuper(bd);

        function bd() {
          _classCallCheck(this, bd);

          return _super41.apply(this, arguments);
        }

        _createClass(bd, [{
          key: "init",
          value: function init() {
            this.set("hasAny", !1), this._actions = new Di({
              idProperty: "_id"
            }), this._actions.delegate("add", "remove").to(this);
          }
        }, {
          key: "add",
          value: function add(t) {
            if ("string" != typeof t) throw new a("pendingactions-add-invalid-message", this);
            var e = Object.create(re);
            return e.set("message", t), this._actions.add(e), this.hasAny = !0, e;
          }
        }, {
          key: "remove",
          value: function remove(t) {
            this._actions.remove(t), this.hasAny = !!this._actions.length;
          }
        }, {
          key: "first",
          get: function get() {
            return this._actions.get(0);
          }
        }, {
          key: _Symbol$iterator13,
          value: function value() {
            return this._actions[Symbol.iterator]();
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "PendingActions";
          }
        }]);

        return bd;
      }(Pi, Symbol.iterator);

      var wd = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="4.5" r="1.5"/><circle cx="9.5" cy="10.5" r="1.5"/><circle cx="9.5" cy="16.5" r="1.5"/></svg>';
      var Ad = {
        cancel: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.591 10.177 4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>',
        caption: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 16h9a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2z"/><path d="M17 1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm0 1.5H3a.5.5 0 0 0-.492.41L2.5 3v9a.5.5 0 0 0 .41.492L3 12.5h14a.5.5 0 0 0 .492-.41L17.5 12V3a.5.5 0 0 0-.41-.492L17 2.5z" fill-opacity=".6"/></svg>',
        check: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>',
        cog: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.333 2 .19 2.263a5.899 5.899 0 0 1 1.458.604L14.714 3.4 16.6 5.286l-1.467 1.733c.263.452.468.942.605 1.46L18 8.666v2.666l-2.263.19a5.899 5.899 0 0 1-.604 1.458l1.467 1.733-1.886 1.886-1.733-1.467a5.899 5.899 0 0 1-1.46.605L11.334 18H8.667l-.19-2.263a5.899 5.899 0 0 1-1.458-.604L5.286 16.6 3.4 14.714l1.467-1.733a5.899 5.899 0 0 1-.604-1.458L2 11.333V8.667l2.262-.189a5.899 5.899 0 0 1 .605-1.459L3.4 5.286 5.286 3.4l1.733 1.467a5.899 5.899 0 0 1 1.46-.605L8.666 2h2.666zM10 6.267a3.733 3.733 0 1 0 0 7.466 3.733 3.733 0 0 0 0-7.466z"/></svg>',
        eraser: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m8.636 9.531-2.758 3.94a.5.5 0 0 0 .122.696l3.224 2.284h1.314l2.636-3.736L8.636 9.53zm.288 8.451L5.14 15.396a2 2 0 0 1-.491-2.786l6.673-9.53a2 2 0 0 1 2.785-.49l3.742 2.62a2 2 0 0 1 .491 2.785l-7.269 10.053-2.147-.066z"/><path d="M4 18h5.523v-1H4zm-2 0h1v-1H2z"/></svg>',
        lowVision: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22 2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>',
        image: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.91 10.54c.26-.23.64-.21.88.03l3.36 3.14 2.23-2.06a.64.64 0 0 1 .87 0l2.52 2.97V4.5H3.2v10.12l3.71-4.08zm10.27-7.51c.6 0 1.09.47 1.09 1.05v11.84c0 .59-.49 1.06-1.09 1.06H2.79c-.6 0-1.09-.47-1.09-1.06V4.08c0-.58.49-1.05 1.1-1.05h14.38zm-5.22 5.56a1.96 1.96 0 1 1 3.4-1.96 1.96 1.96 0 0 1-3.4 1.96z"/></svg>',
        alignBottom: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.239 13.938-2.88-1.663a.75.75 0 0 1 .75-1.3L9 12.067V4.75a.75.75 0 1 1 1.5 0v7.318l1.89-1.093a.75.75 0 0 1 .75 1.3l-2.879 1.663a.752.752 0 0 1-.511.187.752.752 0 0 1-.511-.187zM4.25 17a.75.75 0 1 1 0-1.5h10.5a.75.75 0 0 1 0 1.5H4.25z"/></svg>',
        alignMiddle: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 11.875a.752.752 0 0 1 .508.184l2.883 1.666a.75.75 0 0 1-.659 1.344l-.091-.044-1.892-1.093.001 4.318a.75.75 0 1 1-1.5 0v-4.317l-1.89 1.092a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .51-.187zM15.25 9a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM9.75.375a.75.75 0 0 1 .75.75v4.318l1.89-1.093.092-.045a.75.75 0 0 1 .659 1.344l-2.883 1.667a.752.752 0 0 1-.508.184.752.752 0 0 1-.511-.187L6.359 5.65a.75.75 0 0 1 .75-1.299L9 5.442V1.125a.75.75 0 0 1 .75-.75z"/></svg>',
        alignTop: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m10.261 7.062 2.88 1.663a.75.75 0 0 1-.75 1.3L10.5 8.933v7.317a.75.75 0 1 1-1.5 0V8.932l-1.89 1.093a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .511-.187.752.752 0 0 1 .511.187zM15.25 4a.75.75 0 1 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h10.5z"/></svg>',
        alignLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>',
        alignCenter: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm2.286 4c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75z"/></svg>',
        alignRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18 3.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 8a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 4a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75zm0-8a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75z"/></svg>',
        alignJustify: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>',
        objectLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zm0-3H18v1.5h-4.5zm0-3H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
        objectCenter: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M15.003 7v5.5a1 1 0 0 1-1 1H5.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H6.5V12h6.997V7.5z"/></svg>',
        objectRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2zm0-9h5v1.5H2zm0 3h5v1.5H2zm0 3h5v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>',
        objectFullWidth: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18 7v5.5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm-1.505.5H3.504V12h12.991V7.5z"/></svg>',
        objectInline: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
        objectBlockLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>',
        objectBlockRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>',
        objectSizeFull: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M18.095 2H1.905C.853 2 0 2.895 0 4v12c0 1.105.853 2 1.905 2h16.19C19.147 18 20 17.105 20 16V4c0-1.105-.853-2-1.905-2zm0 1.5c.263 0 .476.224.476.5v12c0 .276-.213.5-.476.5H1.905a.489.489 0 0 1-.476-.5V4c0-.276.213-.5.476-.5h16.19z"/></svg>',
        objectSizeLarge: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M13 6H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h11z"/></svg>',
        objectSizeSmall: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M7 10H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h5z"/></svg>',
        objectSizeMedium: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M10 8H2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h8z"/></svg>',
        pencil: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m7.3 17.37-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506 13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5 9.375 17H19v1.5H8z"/></svg>',
        pilcrow: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.999 2H15a1 1 0 0 1 0 2h-1.004v13a1 1 0 1 1-2 0V4H8.999v13a1 1 0 1 1-2 0v-7A4 4 0 0 1 3 6a4 4 0 0 1 3.999-4z"/></svg>',
        quote: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>',
        threeVerticalDots: wd
      };

      function Cd(_ref30) {
        var t = _ref30.emitter,
            e = _ref30.activator,
            n = _ref30.callback,
            i = _ref30.contextElements;
        t.listenTo(document, "mousedown", function (t, o) {
          if (!e()) return;
          var r = "function" == typeof o.composedPath ? o.composedPath() : [];

          var _iterator280 = _createForOfIteratorHelper(i),
              _step280;

          try {
            for (_iterator280.s(); !(_step280 = _iterator280.n()).done;) {
              var _t204 = _step280.value;
              if (_t204.contains(o.target) || r.includes(_t204)) return;
            }
          } catch (err) {
            _iterator280.e(err);
          } finally {
            _iterator280.f();
          }

          n();
        });
      }

      function _d(t) {
        t.set("_isCssTransitionsDisabled", !1), t.disableCssTransitions = function () {
          t._isCssTransitionsDisabled = !0;
        }, t.enableCssTransitions = function () {
          t._isCssTransitionsDisabled = !1;
        }, t.extendTemplate({
          attributes: {
            class: [t.bindTemplate.if("_isCssTransitionsDisabled", "ck-transitions-disabled")]
          }
        });
      }

      function vd(_ref31) {
        var t = _ref31.view;
        t.listenTo(t.element, "submit", function (e, n) {
          n.preventDefault(), t.fire("submit");
        }, {
          useCapture: !0
        });
      }

      var yd = /*#__PURE__*/function (_Di) {
        _inherits(yd, _Di);

        var _super42 = _createSuper(yd);

        function yd() {
          var _this86;

          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

          _classCallCheck(this, yd);

          _this86 = _super42.call(this, t, {
            idProperty: "viewUid"
          }), _this86.on("add", function (t, e, n) {
            _this86._renderViewIntoCollectionParent(e, n);
          }), _this86.on("remove", function (t, e) {
            e.element && _this86._parentElement && e.element.remove();
          }), _this86._parentElement = null;
          return _this86;
        }

        _createClass(yd, [{
          key: "destroy",
          value: function destroy() {
            this.map(function (t) {
              return t.destroy();
            });
          }
        }, {
          key: "setParent",
          value: function setParent(t) {
            this._parentElement = t;

            var _iterator281 = _createForOfIteratorHelper(this),
                _step281;

            try {
              for (_iterator281.s(); !(_step281 = _iterator281.n()).done;) {
                var _t205 = _step281.value;

                this._renderViewIntoCollectionParent(_t205);
              }
            } catch (err) {
              _iterator281.e(err);
            } finally {
              _iterator281.f();
            }
          }
        }, {
          key: "delegate",
          value: function delegate() {
            var _this87 = this;

            for (var _len19 = arguments.length, t = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
              t[_key19] = arguments[_key19];
            }

            if (!t.length || !t.every(function (t) {
              return "string" == typeof t;
            })) throw new a("ui-viewcollection-delegate-wrong-events", this);
            return {
              to: function to(e) {
                var _iterator282 = _createForOfIteratorHelper(_this87),
                    _step282;

                try {
                  for (_iterator282.s(); !(_step282 = _iterator282.n()).done;) {
                    var _n175 = _step282.value;

                    var _iterator285 = _createForOfIteratorHelper(t),
                        _step285;

                    try {
                      for (_iterator285.s(); !(_step285 = _iterator285.n()).done;) {
                        var _i132 = _step285.value;

                        _n175.delegate(_i132).to(e);
                      }
                    } catch (err) {
                      _iterator285.e(err);
                    } finally {
                      _iterator285.f();
                    }
                  }
                } catch (err) {
                  _iterator282.e(err);
                } finally {
                  _iterator282.f();
                }

                _this87.on("add", function (n, i) {
                  var _iterator283 = _createForOfIteratorHelper(t),
                      _step283;

                  try {
                    for (_iterator283.s(); !(_step283 = _iterator283.n()).done;) {
                      var _n173 = _step283.value;
                      i.delegate(_n173).to(e);
                    }
                  } catch (err) {
                    _iterator283.e(err);
                  } finally {
                    _iterator283.f();
                  }
                }), _this87.on("remove", function (n, i) {
                  var _iterator284 = _createForOfIteratorHelper(t),
                      _step284;

                  try {
                    for (_iterator284.s(); !(_step284 = _iterator284.n()).done;) {
                      var _n174 = _step284.value;
                      i.stopDelegating(_n174, e);
                    }
                  } catch (err) {
                    _iterator284.e(err);
                  } finally {
                    _iterator284.f();
                  }
                });
              }
            };
          }
        }, {
          key: "_renderViewIntoCollectionParent",
          value: function _renderViewIntoCollectionParent(t, e) {
            t.isRendered || t.render(), t.element && this._parentElement && this._parentElement.insertBefore(t.element, this._parentElement.children[e]);
          }
        }]);

        return yd;
      }(Di);

      var xd = n(4258),
          Ed = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(xd.Z, Ed), xd.Z.locals;

      var Dd = /*#__PURE__*/function () {
        function Dd(t) {
          _classCallCheck(this, Dd);

          this.element = null, this.isRendered = !1, this.locale = t, this.t = t && t.t, this._viewCollections = new Di(), this._unboundChildren = this.createCollection(), this._viewCollections.on("add", function (e, n) {
            n.locale = t;
          }), this.decorate("render");
        }

        _createClass(Dd, [{
          key: "bindTemplate",
          get: function get() {
            return this._bindTemplate ? this._bindTemplate : this._bindTemplate = Sd.bind(this, this);
          }
        }, {
          key: "createCollection",
          value: function createCollection(t) {
            var e = new yd(t);
            return this._viewCollections.add(e), e;
          }
        }, {
          key: "registerChild",
          value: function registerChild(t) {
            Ei(t) || (t = [t]);

            var _iterator286 = _createForOfIteratorHelper(t),
                _step286;

            try {
              for (_iterator286.s(); !(_step286 = _iterator286.n()).done;) {
                var _e200 = _step286.value;

                this._unboundChildren.add(_e200);
              }
            } catch (err) {
              _iterator286.e(err);
            } finally {
              _iterator286.f();
            }
          }
        }, {
          key: "deregisterChild",
          value: function deregisterChild(t) {
            Ei(t) || (t = [t]);

            var _iterator287 = _createForOfIteratorHelper(t),
                _step287;

            try {
              for (_iterator287.s(); !(_step287 = _iterator287.n()).done;) {
                var _e201 = _step287.value;

                this._unboundChildren.remove(_e201);
              }
            } catch (err) {
              _iterator287.e(err);
            } finally {
              _iterator287.f();
            }
          }
        }, {
          key: "setTemplate",
          value: function setTemplate(t) {
            this.template = new Sd(t);
          }
        }, {
          key: "extendTemplate",
          value: function extendTemplate(t) {
            Sd.extend(this.template, t);
          }
        }, {
          key: "render",
          value: function render() {
            if (this.isRendered) throw new a("ui-view-render-already-rendered", this);
            this.template && (this.element = this.template.render(), this.registerChild(this.template.getViews())), this.isRendered = !0;
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.stopListening(), this._viewCollections.map(function (t) {
              return t.destroy();
            }), this.template && this.template._revertData && this.template.revert(this.element);
          }
        }]);

        return Dd;
      }();

      he(Dd, ks), he(Dd, re);

      var Sd = /*#__PURE__*/function () {
        function Sd(t) {
          _classCallCheck(this, Sd);

          Object.assign(this, Od(Rd(t))), this._isRendered = !1, this._revertData = null;
        }

        _createClass(Sd, [{
          key: "render",
          value: function render() {
            var t = this._renderNode({
              intoFragment: !0
            });

            return this._isRendered = !0, t;
          }
        }, {
          key: "apply",
          value: function apply(t) {
            return this._revertData = {
              children: [],
              bindings: [],
              attributes: {}
            }, this._renderNode({
              node: t,
              isApplying: !0,
              revertData: this._revertData
            }), t;
          }
        }, {
          key: "revert",
          value: function revert(t) {
            if (!this._revertData) throw new a("ui-template-revert-not-applied", [this, t]);

            this._revertTemplateFromNode(t, this._revertData);
          }
        }, {
          key: "getViews",
          value: /*#__PURE__*/_regeneratorRuntime.mark(function getViews() {
            return _regeneratorRuntime.wrap(function getViews$(_context36) {
              while (1) {
                switch (_context36.prev = _context36.next) {
                  case 0:
                    return _context36.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function t(e) {
                      var _iterator288, _step288, _n176;

                      return _regeneratorRuntime.wrap(function t$(_context35) {
                        while (1) {
                          switch (_context35.prev = _context35.next) {
                            case 0:
                              if (!e.children) {
                                _context35.next = 24;
                                break;
                              }

                              _iterator288 = _createForOfIteratorHelper(e.children);
                              _context35.prev = 2;

                              _iterator288.s();

                            case 4:
                              if ((_step288 = _iterator288.n()).done) {
                                _context35.next = 16;
                                break;
                              }

                              _n176 = _step288.value;

                              if (!qd(_n176)) {
                                _context35.next = 11;
                                break;
                              }

                              _context35.next = 9;
                              return _n176;

                            case 9:
                              _context35.next = 14;
                              break;

                            case 11:
                              _context35.t0 = Wd(_n176);

                              if (!_context35.t0) {
                                _context35.next = 14;
                                break;
                              }

                              return _context35.delegateYield(t(_n176), "t1", 14);

                            case 14:
                              _context35.next = 4;
                              break;

                            case 16:
                              _context35.next = 21;
                              break;

                            case 18:
                              _context35.prev = 18;
                              _context35.t2 = _context35["catch"](2);

                              _iterator288.e(_context35.t2);

                            case 21:
                              _context35.prev = 21;

                              _iterator288.f();

                              return _context35.finish(21);

                            case 24:
                            case "end":
                              return _context35.stop();
                          }
                        }
                      }, t, null, [[2, 18, 21, 24]]);
                    })(this), "t0", 1);

                  case 1:
                  case "end":
                    return _context36.stop();
                }
              }
            }, getViews, this);
          })
        }, {
          key: "_renderNode",
          value: function _renderNode(t) {
            var e;
            if (e = t.node ? this.tag && this.text : this.tag ? this.text : !this.text, e) throw new a("ui-template-wrong-syntax", this);
            return this.text ? this._renderText(t) : this._renderElement(t);
          }
        }, {
          key: "_renderElement",
          value: function _renderElement(t) {
            var e = t.node;
            return e || (e = t.node = document.createElementNS(this.ns || "http://www.w3.org/1999/xhtml", this.tag)), this._renderAttributes(t), this._renderElementChildren(t), this._setUpListeners(t), e;
          }
        }, {
          key: "_renderText",
          value: function _renderText(t) {
            var e = t.node;
            return e ? t.revertData.text = e.textContent : e = t.node = document.createTextNode(""), Nd(this.text) ? this._bindToObservable({
              schema: this.text,
              updater: zd(e),
              data: t
            }) : e.textContent = this.text.join(""), e;
          }
        }, {
          key: "_renderAttributes",
          value: function _renderAttributes(t) {
            var e, n, i, o;
            if (!this.attributes) return;
            var r = t.node,
                s = t.revertData;

            for (e in this.attributes) {
              if (i = r.getAttribute(e), n = this.attributes[e], s && (s.attributes[e] = i), o = y(n[0]) && n[0].ns ? n[0].ns : null, Nd(n)) {
                var _a13 = o ? n[0].value : n;

                s && $d(e) && _a13.unshift(i), this._bindToObservable({
                  schema: _a13,
                  updater: Pd(r, e, o),
                  data: t
                });
              } else "style" == e && "string" != typeof n[0] ? this._renderStyleAttribute(n[0], t) : (s && i && $d(e) && n.unshift(i), n = n.map(function (t) {
                return t && t.value || t;
              }).reduce(function (t, e) {
                return t.concat(e);
              }, []).reduce(Fd, ""), Hd(n) || r.setAttributeNS(o, e, n));
            }
          }
        }, {
          key: "_renderStyleAttribute",
          value: function _renderStyleAttribute(t, e) {
            var n = e.node;

            for (var _i133 in t) {
              var _o70 = t[_i133];
              Nd(_o70) ? this._bindToObservable({
                schema: [_o70],
                updater: Ld(n, _i133),
                data: e
              }) : n.style[_i133] = _o70;
            }
          }
        }, {
          key: "_renderElementChildren",
          value: function _renderElementChildren(t) {
            var e = t.node,
                n = t.intoFragment ? document.createDocumentFragment() : e,
                i = t.isApplying;
            var o = 0;

            var _iterator289 = _createForOfIteratorHelper(this.children),
                _step289;

            try {
              for (_iterator289.s(); !(_step289 = _iterator289.n()).done;) {
                var _r36 = _step289.value;

                if (Gd(_r36)) {
                  if (!i) {
                    _r36.setParent(e);

                    var _iterator290 = _createForOfIteratorHelper(_r36),
                        _step290;

                    try {
                      for (_iterator290.s(); !(_step290 = _iterator290.n()).done;) {
                        var _t206 = _step290.value;
                        n.appendChild(_t206.element);
                      }
                    } catch (err) {
                      _iterator290.e(err);
                    } finally {
                      _iterator290.f();
                    }
                  }
                } else if (qd(_r36)) i || (_r36.isRendered || _r36.render(), n.appendChild(_r36.element));else if (Kr(_r36)) n.appendChild(_r36);else if (i) {
                  var _e202 = {
                    children: [],
                    bindings: [],
                    attributes: {}
                  };
                  t.revertData.children.push(_e202), _r36._renderNode({
                    node: n.childNodes[o++],
                    isApplying: !0,
                    revertData: _e202
                  });
                } else n.appendChild(_r36.render());
              }
            } catch (err) {
              _iterator289.e(err);
            } finally {
              _iterator289.f();
            }

            t.intoFragment && e.appendChild(n);
          }
        }, {
          key: "_setUpListeners",
          value: function _setUpListeners(t) {
            var _this88 = this;

            if (this.eventListeners) {
              var _loop4 = function _loop4(_e203) {
                var n = _this88.eventListeners[_e203].map(function (n) {
                  var _e203$split = _e203.split("@"),
                      _e203$split2 = _slicedToArray(_e203$split, 2),
                      i = _e203$split2[0],
                      o = _e203$split2[1];

                  return n.activateDomEventListener(i, o, t);
                });

                t.revertData && t.revertData.bindings.push(n);
              };

              for (var _e203 in this.eventListeners) {
                _loop4(_e203);
              }
            }
          }
        }, {
          key: "_bindToObservable",
          value: function _bindToObservable(_ref32) {
            var t = _ref32.schema,
                e = _ref32.updater,
                n = _ref32.data;
            var i = n.revertData;
            Bd(t, e, n);
            var o = t.filter(function (t) {
              return !Hd(t);
            }).filter(function (t) {
              return t.observable;
            }).map(function (i) {
              return i.activateAttributeListener(t, e, n);
            });
            i && i.bindings.push(o);
          }
        }, {
          key: "_revertTemplateFromNode",
          value: function _revertTemplateFromNode(t, e) {
            var _iterator291 = _createForOfIteratorHelper(e.bindings),
                _step291;

            try {
              for (_iterator291.s(); !(_step291 = _iterator291.n()).done;) {
                var _t207 = _step291.value;

                var _iterator292 = _createForOfIteratorHelper(_t207),
                    _step292;

                try {
                  for (_iterator292.s(); !(_step292 = _iterator292.n()).done;) {
                    var _e204 = _step292.value;

                    _e204();
                  }
                } catch (err) {
                  _iterator292.e(err);
                } finally {
                  _iterator292.f();
                }
              }
            } catch (err) {
              _iterator291.e(err);
            } finally {
              _iterator291.f();
            }

            if (e.text) t.textContent = e.text;else {
              for (var _n177 in e.attributes) {
                var _i134 = e.attributes[_n177];
                null === _i134 ? t.removeAttribute(_n177) : t.setAttribute(_n177, _i134);
              }

              for (var _n178 = 0; _n178 < e.children.length; ++_n178) {
                this._revertTemplateFromNode(t.childNodes[_n178], e.children[_n178]);
              }
            }
          }
        }], [{
          key: "bind",
          value: function bind(t, e) {
            return {
              to: function to(n, i) {
                return new Md({
                  eventNameOrFunction: n,
                  attribute: n,
                  observable: t,
                  emitter: e,
                  callback: i
                });
              },
              if: function _if(n, i, o) {
                return new Td({
                  observable: t,
                  emitter: e,
                  attribute: n,
                  valueIfTrue: i,
                  callback: o
                });
              }
            };
          }
        }, {
          key: "extend",
          value: function extend(t, e) {
            if (t._isRendered) throw new a("template-extend-render", [this, t]);
            Ud(t, Od(Rd(e)));
          }
        }]);

        return Sd;
      }();

      he(Sd, f);

      var Id = /*#__PURE__*/function () {
        function Id(t) {
          _classCallCheck(this, Id);

          Object.assign(this, t);
        }

        _createClass(Id, [{
          key: "getValue",
          value: function getValue(t) {
            var e = this.observable[this.attribute];
            return this.callback ? this.callback(e, t) : e;
          }
        }, {
          key: "activateAttributeListener",
          value: function activateAttributeListener(t, e, n) {
            var _this89 = this;

            var i = function i() {
              return Bd(t, e, n);
            };

            return this.emitter.listenTo(this.observable, "change:" + this.attribute, i), function () {
              _this89.emitter.stopListening(_this89.observable, "change:" + _this89.attribute, i);
            };
          }
        }]);

        return Id;
      }();

      var Md = /*#__PURE__*/function (_Id) {
        _inherits(Md, _Id);

        var _super43 = _createSuper(Md);

        function Md() {
          _classCallCheck(this, Md);

          return _super43.apply(this, arguments);
        }

        _createClass(Md, [{
          key: "activateDomEventListener",
          value: function activateDomEventListener(t, e, n) {
            var _this90 = this;

            var i = function i(t, n) {
              e && !n.target.matches(e) || ("function" == typeof _this90.eventNameOrFunction ? _this90.eventNameOrFunction(n) : _this90.observable.fire(_this90.eventNameOrFunction, n));
            };

            return this.emitter.listenTo(n.node, t, i), function () {
              _this90.emitter.stopListening(n.node, t, i);
            };
          }
        }]);

        return Md;
      }(Id);

      var Td = /*#__PURE__*/function (_Id2) {
        _inherits(Td, _Id2);

        var _super44 = _createSuper(Td);

        function Td() {
          _classCallCheck(this, Td);

          return _super44.apply(this, arguments);
        }

        _createClass(Td, [{
          key: "getValue",
          value: function getValue(t) {
            return !Hd(_get(_getPrototypeOf(Td.prototype), "getValue", this).call(this, t)) && (this.valueIfTrue || !0);
          }
        }]);

        return Td;
      }(Id);

      function Nd(t) {
        return !!t && (t.value && (t = t.value), Array.isArray(t) ? t.some(Nd) : t instanceof Id);
      }

      function Bd(t, e, _ref33) {
        var n = _ref33.node;

        var i = function (t, e) {
          return t.map(function (t) {
            return t instanceof Id ? t.getValue(e) : t;
          });
        }(t, n);

        i = 1 == t.length && t[0] instanceof Td ? i[0] : i.reduce(Fd, ""), Hd(i) ? e.remove() : e.set(i);
      }

      function zd(t) {
        return {
          set: function set(e) {
            t.textContent = e;
          },
          remove: function remove() {
            t.textContent = "";
          }
        };
      }

      function Pd(t, e, n) {
        return {
          set: function set(i) {
            t.setAttributeNS(n, e, i);
          },
          remove: function remove() {
            t.removeAttributeNS(n, e);
          }
        };
      }

      function Ld(t, e) {
        return {
          set: function set(n) {
            t.style[e] = n;
          },
          remove: function remove() {
            t.style[e] = null;
          }
        };
      }

      function Rd(t) {
        return Ci(t, function (t) {
          if (t && (t instanceof Id || Wd(t) || qd(t) || Gd(t))) return t;
        });
      }

      function Od(t) {
        if ("string" == typeof t ? t = function (t) {
          return {
            text: [t]
          };
        }(t) : t.text && function (t) {
          t.text = Ii(t.text);
        }(t), t.on && (t.eventListeners = function (t) {
          for (var _e205 in t) {
            jd(t, _e205);
          }

          return t;
        }(t.on), delete t.on), !t.text) {
          t.attributes && function (t) {
            for (var _e207 in t) {
              t[_e207].value && (t[_e207].value = Ii(t[_e207].value)), jd(t, _e207);
            }
          }(t.attributes);
          var _e206 = [];
          if (t.children) if (Gd(t.children)) _e206.push(t.children);else {
            var _iterator293 = _createForOfIteratorHelper(t.children),
                _step293;

            try {
              for (_iterator293.s(); !(_step293 = _iterator293.n()).done;) {
                var _n179 = _step293.value;
                Wd(_n179) || qd(_n179) || Kr(_n179) ? _e206.push(_n179) : _e206.push(new Sd(_n179));
              }
            } catch (err) {
              _iterator293.e(err);
            } finally {
              _iterator293.f();
            }
          }
          t.children = _e206;
        }

        return t;
      }

      function jd(t, e) {
        t[e] = Ii(t[e]);
      }

      function Fd(t, e) {
        return Hd(e) ? t : Hd(t) ? e : "".concat(t, " ").concat(e);
      }

      function Vd(t, e) {
        for (var _n180 in e) {
          var _t$_n;

          t[_n180] ? (_t$_n = t[_n180]).push.apply(_t$_n, _toConsumableArray(e[_n180])) : t[_n180] = e[_n180];
        }
      }

      function Ud(t, e) {
        var _t$text;

        if (e.attributes && (t.attributes || (t.attributes = {}), Vd(t.attributes, e.attributes)), e.eventListeners && (t.eventListeners || (t.eventListeners = {}), Vd(t.eventListeners, e.eventListeners)), e.text && (_t$text = t.text).push.apply(_t$text, _toConsumableArray(e.text)), e.children && e.children.length) {
          if (t.children.length != e.children.length) throw new a("ui-template-extend-children-mismatch", t);
          var _n181 = 0;

          var _iterator294 = _createForOfIteratorHelper(e.children),
              _step294;

          try {
            for (_iterator294.s(); !(_step294 = _iterator294.n()).done;) {
              var _i135 = _step294.value;
              Ud(t.children[_n181++], _i135);
            }
          } catch (err) {
            _iterator294.e(err);
          } finally {
            _iterator294.f();
          }
        }
      }

      function Hd(t) {
        return !t && 0 !== t;
      }

      function qd(t) {
        return t instanceof Dd;
      }

      function Wd(t) {
        return t instanceof Sd;
      }

      function Gd(t) {
        return t instanceof yd;
      }

      function $d(t) {
        return "class" == t || "style" == t;
      }

      var Yd = function Yd(t) {
        return "string" == typeof t || !It(t) && _t(t) && "[object String]" == R(t);
      };

      var Kd = /*#__PURE__*/function (_yd) {
        _inherits(Kd, _yd);

        var _super45 = _createSuper(Kd);

        function Kd(t) {
          var _this91;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

          _classCallCheck(this, Kd);

          _this91 = _super45.call(this, e), _this91.locale = t;
          return _this91;
        }

        _createClass(Kd, [{
          key: "attachToDom",
          value: function attachToDom() {
            this._bodyCollectionContainer = new Sd({
              tag: "div",
              attributes: {
                class: ["ck", "ck-reset_all", "ck-body", "ck-rounded-corners"],
                dir: this.locale.uiLanguageDirection
              },
              children: this
            }).render();
            var t = document.querySelector(".ck-body-wrapper");
            t || (t = function (t, e) {
              var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
              var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
              var o = n && n.xmlns,
                  r = o ? t.createElementNS(o, e) : t.createElement(e);

              for (var _t208 in n) {
                r.setAttribute(_t208, n[_t208]);
              }

              !Yd(i) && Ei(i) || (i = [i]);

              var _iterator295 = _createForOfIteratorHelper(i),
                  _step295;

              try {
                for (_iterator295.s(); !(_step295 = _iterator295.n()).done;) {
                  var _e208 = _step295.value;
                  Yd(_e208) && (_e208 = t.createTextNode(_e208)), r.appendChild(_e208);
                }
              } catch (err) {
                _iterator295.e(err);
              } finally {
                _iterator295.f();
              }

              return r;
            }(document, "div", {
              class: "ck-body-wrapper"
            }), document.body.appendChild(t)), t.appendChild(this._bodyCollectionContainer);
          }
        }, {
          key: "detachFromDom",
          value: function detachFromDom() {
            _get(_getPrototypeOf(Kd.prototype), "destroy", this).call(this), this._bodyCollectionContainer && this._bodyCollectionContainer.remove();
            var t = document.querySelector(".ck-body-wrapper");
            t && 0 == t.childElementCount && t.remove();
          }
        }]);

        return Kd;
      }(yd);

      var Qd = n(9474),
          Zd = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Qd.Z, Zd), Qd.Z.locals;

      var Jd = /*#__PURE__*/function (_Dd) {
        _inherits(Jd, _Dd);

        var _super46 = _createSuper(Jd);

        function Jd() {
          var _this92;

          _classCallCheck(this, Jd);

          _this92 = _super46.call(this);
          var t = _this92.bindTemplate;
          _this92.set("content", ""), _this92.set("viewBox", "0 0 20 20"), _this92.set("fillColor", ""), _this92.setTemplate({
            tag: "svg",
            ns: "http://www.w3.org/2000/svg",
            attributes: {
              class: ["ck", "ck-icon"],
              viewBox: t.to("viewBox")
            }
          });
          return _this92;
        }

        _createClass(Jd, [{
          key: "render",
          value: function render() {
            var _this93 = this;

            _get(_getPrototypeOf(Jd.prototype), "render", this).call(this), this._updateXMLContent(), this._colorFillPaths(), this.on("change:content", function () {
              _this93._updateXMLContent(), _this93._colorFillPaths();
            }), this.on("change:fillColor", function () {
              _this93._colorFillPaths();
            });
          }
        }, {
          key: "_updateXMLContent",
          value: function _updateXMLContent() {
            if (this.content) {
              var _t209 = new DOMParser().parseFromString(this.content.trim(), "image/svg+xml").querySelector("svg"),
                  _e209 = _t209.getAttribute("viewBox");

              for (_e209 && (this.viewBox = _e209), this.element.innerHTML = ""; _t209.childNodes.length > 0;) {
                this.element.appendChild(_t209.childNodes[0]);
              }
            }
          }
        }, {
          key: "_colorFillPaths",
          value: function _colorFillPaths() {
            var _this94 = this;

            this.fillColor && this.element.querySelectorAll(".ck-icon__fill").forEach(function (t) {
              t.style.fill = _this94.fillColor;
            });
          }
        }]);

        return Jd;
      }(Dd);

      var Xd = n(8552),
          th = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Xd.Z, th), Xd.Z.locals;

      var eh = /*#__PURE__*/function (_Dd2) {
        _inherits(eh, _Dd2);

        var _super47 = _createSuper(eh);

        function eh(t) {
          var _this95;

          _classCallCheck(this, eh);

          _this95 = _super47.call(this, t), _this95.set("text", ""), _this95.set("position", "s");
          var e = _this95.bindTemplate;

          _this95.setTemplate({
            tag: "span",
            attributes: {
              class: ["ck", "ck-tooltip", e.to("position", function (t) {
                return "ck-tooltip_" + t;
              }), e.if("text", "ck-hidden", function (t) {
                return !t.trim();
              })]
            },
            children: [{
              tag: "span",
              attributes: {
                class: ["ck", "ck-tooltip__text"]
              },
              children: [{
                text: e.to("text")
              }]
            }]
          });

          return _this95;
        }

        return _createClass(eh);
      }(Dd);

      var nh = n(2518),
          ih = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(nh.Z, ih), nh.Z.locals;

      var oh = /*#__PURE__*/function (_Dd3) {
        _inherits(oh, _Dd3);

        var _super48 = _createSuper(oh);

        function oh(t) {
          var _this96;

          _classCallCheck(this, oh);

          _this96 = _super48.call(this, t);
          var e = _this96.bindTemplate,
              n = r();
          _this96.set("class"), _this96.set("labelStyle"), _this96.set("icon"), _this96.set("isEnabled", !0), _this96.set("isOn", !1), _this96.set("isVisible", !0), _this96.set("isToggleable", !1), _this96.set("keystroke"), _this96.set("label"), _this96.set("tabindex", -1), _this96.set("tooltip"), _this96.set("tooltipPosition", "s"), _this96.set("type", "button"), _this96.set("withText", !1), _this96.set("withKeystroke", !1), _this96.children = _this96.createCollection(), _this96.tooltipView = _this96._createTooltipView(), _this96.labelView = _this96._createLabelView(n), _this96.iconView = new Jd(), _this96.iconView.extendTemplate({
            attributes: {
              class: "ck-button__icon"
            }
          }), _this96.keystrokeView = _this96._createKeystrokeView(), _this96.bind("_tooltipString").to(_assertThisInitialized(_this96), "tooltip", _assertThisInitialized(_this96), "label", _assertThisInitialized(_this96), "keystroke", _this96._getTooltipString.bind(_assertThisInitialized(_this96))), _this96.setTemplate({
            tag: "button",
            attributes: {
              class: ["ck", "ck-button", e.to("class"), e.if("isEnabled", "ck-disabled", function (t) {
                return !t;
              }), e.if("isVisible", "ck-hidden", function (t) {
                return !t;
              }), e.to("isOn", function (t) {
                return t ? "ck-on" : "ck-off";
              }), e.if("withText", "ck-button_with-text"), e.if("withKeystroke", "ck-button_with-keystroke")],
              type: e.to("type", function (t) {
                return t || "button";
              }),
              tabindex: e.to("tabindex"),
              "aria-labelledby": "ck-editor__aria-label_".concat(n),
              "aria-disabled": e.if("isEnabled", !0, function (t) {
                return !t;
              }),
              "aria-pressed": e.to("isOn", function (t) {
                return !!_this96.isToggleable && String(t);
              })
            },
            children: _this96.children,
            on: {
              mousedown: e.to(function (t) {
                t.preventDefault();
              }),
              click: e.to(function (t) {
                _this96.isEnabled ? _this96.fire("execute") : t.preventDefault();
              })
            }
          });
          return _this96;
        }

        _createClass(oh, [{
          key: "render",
          value: function render() {
            _get(_getPrototypeOf(oh.prototype), "render", this).call(this), this.icon && (this.iconView.bind("content").to(this, "icon"), this.children.add(this.iconView)), this.children.add(this.tooltipView), this.children.add(this.labelView), this.withKeystroke && this.keystroke && this.children.add(this.keystrokeView);
          }
        }, {
          key: "focus",
          value: function focus() {
            this.element.focus();
          }
        }, {
          key: "_createTooltipView",
          value: function _createTooltipView() {
            var t = new eh();
            return t.bind("text").to(this, "_tooltipString"), t.bind("position").to(this, "tooltipPosition"), t;
          }
        }, {
          key: "_createLabelView",
          value: function _createLabelView(t) {
            var e = new Dd(),
                n = this.bindTemplate;
            return e.setTemplate({
              tag: "span",
              attributes: {
                class: ["ck", "ck-button__label"],
                style: n.to("labelStyle"),
                id: "ck-editor__aria-label_".concat(t)
              },
              children: [{
                text: this.bindTemplate.to("label")
              }]
            }), e;
          }
        }, {
          key: "_createKeystrokeView",
          value: function _createKeystrokeView() {
            var t = new Dd();
            return t.setTemplate({
              tag: "span",
              attributes: {
                class: ["ck", "ck-button__keystroke"]
              },
              children: [{
                text: this.bindTemplate.to("keystroke", function (t) {
                  return mr(t);
                })
              }]
            }), t;
          }
        }, {
          key: "_getTooltipString",
          value: function _getTooltipString(t, e, n) {
            return t ? "string" == typeof t ? t : (n && (n = mr(n)), t instanceof Function ? t(e, n) : "".concat(e).concat(n ? " (".concat(n, ")") : "")) : "";
          }
        }]);

        return oh;
      }(Dd);

      var rh = n(9483),
          sh = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(rh.Z, sh), rh.Z.locals;

      var ah = /*#__PURE__*/function (_oh) {
        _inherits(ah, _oh);

        var _super49 = _createSuper(ah);

        function ah(t) {
          var _this97;

          _classCallCheck(this, ah);

          _this97 = _super49.call(this, t), _this97.isToggleable = !0, _this97.toggleSwitchView = _this97._createToggleView(), _this97.extendTemplate({
            attributes: {
              class: "ck-switchbutton"
            }
          });
          return _this97;
        }

        _createClass(ah, [{
          key: "render",
          value: function render() {
            _get(_getPrototypeOf(ah.prototype), "render", this).call(this), this.children.add(this.toggleSwitchView);
          }
        }, {
          key: "_createToggleView",
          value: function _createToggleView() {
            var t = new Dd();
            return t.setTemplate({
              tag: "span",
              attributes: {
                class: ["ck", "ck-button__toggle"]
              },
              children: [{
                tag: "span",
                attributes: {
                  class: ["ck", "ck-button__toggle__inner"]
                }
              }]
            }), t;
          }
        }]);

        return ah;
      }(oh);

      var ch = n(3362),
          lh = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(ch.Z, lh), ch.Z.locals;
      var dh = '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';

      var hh = /*#__PURE__*/function (_oh2) {
        _inherits(hh, _oh2);

        var _super50 = _createSuper(hh);

        function hh(t) {
          var _this98;

          _classCallCheck(this, hh);

          _this98 = _super50.call(this, t), _this98.arrowView = _this98._createArrowView(), _this98.extendTemplate({
            attributes: {
              "aria-haspopup": !0
            }
          }), _this98.delegate("execute").to(_assertThisInitialized(_this98), "open");
          return _this98;
        }

        _createClass(hh, [{
          key: "render",
          value: function render() {
            _get(_getPrototypeOf(hh.prototype), "render", this).call(this), this.children.add(this.arrowView);
          }
        }, {
          key: "_createArrowView",
          value: function _createArrowView() {
            var t = new Jd();
            return t.content = dh, t.extendTemplate({
              attributes: {
                class: "ck-dropdown__arrow"
              }
            }), t;
          }
        }]);

        return hh;
      }(oh);

      var uh = n(9199),
          gh = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(uh.Z, gh), uh.Z.locals;

      var mh = /*#__PURE__*/function (_Dd4) {
        _inherits(mh, _Dd4);

        var _super51 = _createSuper(mh);

        function mh(t) {
          var _this99;

          _classCallCheck(this, mh);

          _this99 = _super51.call(this, t);
          var e = _this99.bindTemplate;
          _this99.set("class"), _this99.set("icon"), _this99.set("isEnabled", !0), _this99.set("isOn", !1), _this99.set("isToggleable", !1), _this99.set("isVisible", !0), _this99.set("keystroke"), _this99.set("label"), _this99.set("tabindex", -1), _this99.set("tooltip"), _this99.set("tooltipPosition", "s"), _this99.set("type", "button"), _this99.set("withText", !1), _this99.children = _this99.createCollection(), _this99.actionView = _this99._createActionView(), _this99.arrowView = _this99._createArrowView(), _this99.keystrokes = new Ca(), _this99.focusTracker = new Aa(), _this99.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-splitbutton", e.to("class"), e.if("isVisible", "ck-hidden", function (t) {
                return !t;
              }), _this99.arrowView.bindTemplate.if("isOn", "ck-splitbutton_open")]
            },
            children: _this99.children
          });
          return _this99;
        }

        _createClass(mh, [{
          key: "render",
          value: function render() {
            var _this100 = this;

            _get(_getPrototypeOf(mh.prototype), "render", this).call(this), this.children.add(this.actionView), this.children.add(this.arrowView), this.focusTracker.add(this.actionView.element), this.focusTracker.add(this.arrowView.element), this.keystrokes.listenTo(this.element), this.keystrokes.set("arrowright", function (t, e) {
              _this100.focusTracker.focusedElement === _this100.actionView.element && (_this100.arrowView.focus(), e());
            }), this.keystrokes.set("arrowleft", function (t, e) {
              _this100.focusTracker.focusedElement === _this100.arrowView.element && (_this100.actionView.focus(), e());
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            _get(_getPrototypeOf(mh.prototype), "destroy", this).call(this), this.focusTracker.destroy(), this.keystrokes.destroy();
          }
        }, {
          key: "focus",
          value: function focus() {
            this.actionView.focus();
          }
        }, {
          key: "_createActionView",
          value: function _createActionView() {
            var t = new oh();
            return t.bind("icon", "isEnabled", "isOn", "isToggleable", "keystroke", "label", "tabindex", "tooltip", "tooltipPosition", "type", "withText").to(this), t.extendTemplate({
              attributes: {
                class: "ck-splitbutton__action"
              }
            }), t.delegate("execute").to(this), t;
          }
        }, {
          key: "_createArrowView",
          value: function _createArrowView() {
            var t = new oh(),
                e = t.bindTemplate;
            return t.icon = dh, t.extendTemplate({
              attributes: {
                class: "ck-splitbutton__arrow",
                "aria-haspopup": !0,
                "aria-expanded": e.to("isOn", function (t) {
                  return String(t);
                })
              }
            }), t.bind("isEnabled").to(this), t.delegate("execute").to(this, "open"), t;
          }
        }]);

        return mh;
      }(Dd);

      var ph = /*#__PURE__*/function (_Dd5) {
        _inherits(ph, _Dd5);

        var _super52 = _createSuper(ph);

        function ph(t) {
          var _this101;

          _classCallCheck(this, ph);

          _this101 = _super52.call(this, t);
          var e = _this101.bindTemplate;
          _this101.set("isVisible", !1), _this101.set("position", "se"), _this101.children = _this101.createCollection(), _this101.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-reset", "ck-dropdown__panel", e.to("position", function (t) {
                return "ck-dropdown__panel_".concat(t);
              }), e.if("isVisible", "ck-dropdown__panel-visible")]
            },
            children: _this101.children,
            on: {
              selectstart: e.to(function (t) {
                return t.preventDefault();
              })
            }
          });
          return _this101;
        }

        _createClass(ph, [{
          key: "focus",
          value: function focus() {
            this.children.length && this.children.first.focus();
          }
        }, {
          key: "focusLast",
          value: function focusLast() {
            if (this.children.length) {
              var _t210 = this.children.last;
              "function" == typeof _t210.focusLast ? _t210.focusLast() : _t210.focus();
            }
          }
        }]);

        return ph;
      }(Dd);

      var fh = n(4130),
          kh = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(fh.Z, kh), fh.Z.locals;

      function bh(_ref34) {
        var t = _ref34.element,
            e = _ref34.target,
            n = _ref34.positions,
            i = _ref34.limiter,
            o = _ref34.fitInViewport,
            r = _ref34.viewportOffsetConfig;
        O(e) && (e = e()), O(i) && (i = i());

        var s = function (t) {
          return t && t.parentNode ? t.offsetParent === os.document.body ? null : t.offsetParent : null;
        }(t),
            a = new ma(t);

        var c;
        var l = {
          targetRect: new ma(e),
          elementRect: a,
          positionedElementAncestor: s
        };

        if (i || o) {
          var _t211 = i && new ma(i).getVisible(),
              _e210 = o && function (t) {
            t = Object.assign({
              top: 0,
              bottom: 0,
              left: 0,
              right: 0
            }, t);
            var e = new ma(os.window);
            return e.top += t.top, e.height -= t.top, e.bottom -= t.bottom, e.height -= t.bottom, e;
          }(r);

          Object.assign(l, {
            limiterRect: _t211,
            viewportRect: _e210
          }), c = function (t, e) {
            var n = e.elementRect,
                i = n.getArea(),
                o = t.map(function (t) {
              return new Ah(t, e);
            }).filter(function (t) {
              return !!t.name;
            });
            var r = 0,
                s = null;

            var _iterator296 = _createForOfIteratorHelper(o),
                _step296;

            try {
              for (_iterator296.s(); !(_step296 = _iterator296.n()).done;) {
                var _t212 = _step296.value;
                var _e211 = _t212._limiterIntersectionArea,
                    _n182 = _t212._viewportIntersectionArea;
                if (_e211 === i) return _t212;

                var _o71 = Math.pow(_n182, 2) + Math.pow(_e211, 2);

                _o71 > r && (r = _o71, s = _t212);
              }
            } catch (err) {
              _iterator296.e(err);
            } finally {
              _iterator296.f();
            }

            return s;
          }(n, l) || new Ah(n[0], l);
        } else c = new Ah(n[0], l);

        return c;
      }

      function wh(t) {
        var _os$window2 = os.window,
            e = _os$window2.scrollX,
            n = _os$window2.scrollY;
        return t.clone().moveBy(e, n);
      }

      var Ah = /*#__PURE__*/function () {
        function Ah(t, e) {
          _classCallCheck(this, Ah);

          var n = t(e.targetRect, e.elementRect, e.viewportRect);
          if (!n) return;
          var i = n.left,
              o = n.top,
              r = n.name,
              s = n.config;
          Object.assign(this, {
            name: r,
            config: s
          }), this._positioningFunctionCorrdinates = {
            left: i,
            top: o
          }, this._options = e;
        }

        _createClass(Ah, [{
          key: "left",
          get: function get() {
            return this._absoluteRect.left;
          }
        }, {
          key: "top",
          get: function get() {
            return this._absoluteRect.top;
          }
        }, {
          key: "_limiterIntersectionArea",
          get: function get() {
            var t = this._options.limiterRect;

            if (t) {
              var _e212 = this._options.viewportRect;
              if (!_e212) return t.getIntersectionArea(this._rect);
              {
                var _n183 = t.getIntersection(_e212);

                if (_n183) return _n183.getIntersectionArea(this._rect);
              }
            }

            return 0;
          }
        }, {
          key: "_viewportIntersectionArea",
          get: function get() {
            var t = this._options.viewportRect;
            return t ? t.getIntersectionArea(this._rect) : 0;
          }
        }, {
          key: "_rect",
          get: function get() {
            return this._cachedRect || (this._cachedRect = this._options.elementRect.clone().moveTo(this._positioningFunctionCorrdinates.left, this._positioningFunctionCorrdinates.top)), this._cachedRect;
          }
        }, {
          key: "_absoluteRect",
          get: function get() {
            return this._cachedAbsoluteRect || (this._cachedAbsoluteRect = wh(this._rect), this._options.positionedElementAncestor && function (t, e) {
              var n = wh(new ma(e)),
                  i = ua(e);
              var o = 0,
                  r = 0;
              o -= n.left, r -= n.top, o += e.scrollLeft, r += e.scrollTop, o -= i.left, r -= i.top, t.moveBy(o, r);
            }(this._cachedAbsoluteRect, this._options.positionedElementAncestor)), this._cachedAbsoluteRect;
          }
        }]);

        return Ah;
      }();

      var Ch = /*#__PURE__*/function (_Dd6) {
        _inherits(Ch, _Dd6);

        var _super53 = _createSuper(Ch);

        function Ch(t, e, n) {
          var _this102;

          _classCallCheck(this, Ch);

          _this102 = _super53.call(this, t);
          var i = _this102.bindTemplate;
          _this102.buttonView = e, _this102.panelView = n, _this102.set("isOpen", !1), _this102.set("isEnabled", !0), _this102.set("class"), _this102.set("id"), _this102.set("panelPosition", "auto"), _this102.keystrokes = new Ca(), _this102.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-dropdown", i.to("class"), i.if("isEnabled", "ck-disabled", function (t) {
                return !t;
              })],
              id: i.to("id"),
              "aria-describedby": i.to("ariaDescribedById")
            },
            children: [e, n]
          }), e.extendTemplate({
            attributes: {
              class: ["ck-dropdown__button"]
            }
          });
          return _this102;
        }

        _createClass(Ch, [{
          key: "render",
          value: function render() {
            var _this103 = this;

            _get(_getPrototypeOf(Ch.prototype), "render", this).call(this), this.listenTo(this.buttonView, "open", function () {
              _this103.isOpen = !_this103.isOpen;
            }), this.panelView.bind("isVisible").to(this, "isOpen"), this.on("change:isOpen", function () {
              _this103.isOpen && ("auto" === _this103.panelPosition ? _this103.panelView.position = Ch._getOptimalPosition({
                element: _this103.panelView.element,
                target: _this103.buttonView.element,
                fitInViewport: !0,
                positions: _this103._panelPositions
              }).name : _this103.panelView.position = _this103.panelPosition);
            }), this.keystrokes.listenTo(this.element);

            var t = function t(_t213, e) {
              _this103.isOpen && (_this103.buttonView.focus(), _this103.isOpen = !1, e());
            };

            this.keystrokes.set("arrowdown", function (t, e) {
              _this103.buttonView.isEnabled && !_this103.isOpen && (_this103.isOpen = !0, e());
            }), this.keystrokes.set("arrowright", function (t, e) {
              _this103.isOpen && e();
            }), this.keystrokes.set("arrowleft", t), this.keystrokes.set("esc", t);
          }
        }, {
          key: "focus",
          value: function focus() {
            this.buttonView.focus();
          }
        }, {
          key: "_panelPositions",
          get: function get() {
            var _Ch$defaultPanelPosit = Ch.defaultPanelPositions,
                t = _Ch$defaultPanelPosit.south,
                e = _Ch$defaultPanelPosit.north,
                n = _Ch$defaultPanelPosit.southEast,
                i = _Ch$defaultPanelPosit.southWest,
                o = _Ch$defaultPanelPosit.northEast,
                r = _Ch$defaultPanelPosit.northWest,
                s = _Ch$defaultPanelPosit.southMiddleEast,
                a = _Ch$defaultPanelPosit.southMiddleWest,
                c = _Ch$defaultPanelPosit.northMiddleEast,
                l = _Ch$defaultPanelPosit.northMiddleWest;
            return "rtl" !== this.locale.uiLanguageDirection ? [n, i, s, a, t, o, r, c, l, e] : [i, n, a, s, t, r, o, l, c, e];
          }
        }]);

        return Ch;
      }(Dd);

      function _h(t) {
        return !!(t && t.getClientRects && t.getClientRects().length);
      }

      Ch.defaultPanelPositions = {
        south: function south(t, e) {
          return {
            top: t.bottom,
            left: t.left - (e.width - t.width) / 2,
            name: "s"
          };
        },
        southEast: function southEast(t) {
          return {
            top: t.bottom,
            left: t.left,
            name: "se"
          };
        },
        southWest: function southWest(t, e) {
          return {
            top: t.bottom,
            left: t.left - e.width + t.width,
            name: "sw"
          };
        },
        southMiddleEast: function southMiddleEast(t, e) {
          return {
            top: t.bottom,
            left: t.left - (e.width - t.width) / 4,
            name: "sme"
          };
        },
        southMiddleWest: function southMiddleWest(t, e) {
          return {
            top: t.bottom,
            left: t.left - 3 * (e.width - t.width) / 4,
            name: "smw"
          };
        },
        north: function north(t, e) {
          return {
            top: t.top - e.height,
            left: t.left - (e.width - t.width) / 2,
            name: "n"
          };
        },
        northEast: function northEast(t, e) {
          return {
            top: t.top - e.height,
            left: t.left,
            name: "ne"
          };
        },
        northWest: function northWest(t, e) {
          return {
            top: t.top - e.height,
            left: t.left - e.width + t.width,
            name: "nw"
          };
        },
        northMiddleEast: function northMiddleEast(t, e) {
          return {
            top: t.top - e.height,
            left: t.left - (e.width - t.width) / 4,
            name: "nme"
          };
        },
        northMiddleWest: function northMiddleWest(t, e) {
          return {
            top: t.top - e.height,
            left: t.left - 3 * (e.width - t.width) / 4,
            name: "nmw"
          };
        }
      }, Ch._getOptimalPosition = bh;

      var vh = /*#__PURE__*/function () {
        function vh(t) {
          var _this104 = this;

          _classCallCheck(this, vh);

          if (Object.assign(this, t), t.actions && t.keystrokeHandler) {
            var _loop5 = function _loop5(_e213) {
              var n = t.actions[_e213];
              "string" == typeof n && (n = [n]);

              var _iterator297 = _createForOfIteratorHelper(n),
                  _step297;

              try {
                for (_iterator297.s(); !(_step297 = _iterator297.n()).done;) {
                  var _i136 = _step297.value;
                  t.keystrokeHandler.set(_i136, function (t, n) {
                    _this104[_e213](), n();
                  });
                }
              } catch (err) {
                _iterator297.e(err);
              } finally {
                _iterator297.f();
              }
            };

            for (var _e213 in t.actions) {
              _loop5(_e213);
            }
          }
        }

        _createClass(vh, [{
          key: "first",
          get: function get() {
            return this.focusables.find(yh) || null;
          }
        }, {
          key: "last",
          get: function get() {
            return this.focusables.filter(yh).slice(-1)[0] || null;
          }
        }, {
          key: "next",
          get: function get() {
            return this._getFocusableItem(1);
          }
        }, {
          key: "previous",
          get: function get() {
            return this._getFocusableItem(-1);
          }
        }, {
          key: "current",
          get: function get() {
            var _this105 = this;

            var t = null;
            return null === this.focusTracker.focusedElement ? null : (this.focusables.find(function (e, n) {
              var i = e.element === _this105.focusTracker.focusedElement;
              return i && (t = n), i;
            }), t);
          }
        }, {
          key: "focusFirst",
          value: function focusFirst() {
            this._focus(this.first);
          }
        }, {
          key: "focusLast",
          value: function focusLast() {
            this._focus(this.last);
          }
        }, {
          key: "focusNext",
          value: function focusNext() {
            this._focus(this.next);
          }
        }, {
          key: "focusPrevious",
          value: function focusPrevious() {
            this._focus(this.previous);
          }
        }, {
          key: "_focus",
          value: function _focus(t) {
            t && t.focus();
          }
        }, {
          key: "_getFocusableItem",
          value: function _getFocusableItem(t) {
            var e = this.current,
                n = this.focusables.length;
            if (!n) return null;
            if (null === e) return this[1 === t ? "first" : "last"];
            var i = (e + n + t) % n;

            do {
              var _e214 = this.focusables.get(i);

              if (yh(_e214)) return _e214;
              i = (i + n + t) % n;
            } while (i !== e);

            return null;
          }
        }]);

        return vh;
      }();

      function yh(t) {
        return !(!t.focus || !_h(t.element));
      }

      var xh = /*#__PURE__*/function (_Dd7) {
        _inherits(xh, _Dd7);

        var _super54 = _createSuper(xh);

        function xh(t) {
          var _this106;

          _classCallCheck(this, xh);

          _this106 = _super54.call(this, t), _this106.setTemplate({
            tag: "span",
            attributes: {
              class: ["ck", "ck-toolbar__separator"]
            }
          });
          return _this106;
        }

        return _createClass(xh);
      }(Dd);

      var Eh = /*#__PURE__*/function (_Dd8) {
        _inherits(Eh, _Dd8);

        var _super55 = _createSuper(Eh);

        function Eh(t) {
          var _this107;

          _classCallCheck(this, Eh);

          _this107 = _super55.call(this, t), _this107.setTemplate({
            tag: "span",
            attributes: {
              class: ["ck", "ck-toolbar__line-break"]
            }
          });
          return _this107;
        }

        return _createClass(Eh);
      }(Dd);

      function Dh(t) {
        return Array.isArray(t) ? {
          items: t,
          removeItems: []
        } : t ? Object.assign({
          items: [],
          removeItems: []
        }, t) : {
          items: [],
          removeItems: []
        };
      }

      var Sh = n(1329),
          Ih = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Sh.Z, Ih), Sh.Z.locals;

      var Mh = /*#__PURE__*/function (_Dd9) {
        _inherits(Mh, _Dd9);

        var _super56 = _createSuper(Mh);

        function Mh(t, e) {
          var _this108;

          _classCallCheck(this, Mh);

          _this108 = _super56.call(this, t);
          var n = _this108.bindTemplate,
              i = _this108.t;
          _this108.options = e || {}, _this108.set("ariaLabel", i("Editor toolbar")), _this108.set("maxWidth", "auto"), _this108.items = _this108.createCollection(), _this108.focusTracker = new Aa(), _this108.keystrokes = new Ca(), _this108.set("class"), _this108.set("isCompact", !1), _this108.itemsView = new Th(t), _this108.children = _this108.createCollection(), _this108.children.add(_this108.itemsView), _this108.focusables = _this108.createCollection();
          var o = "rtl" === t.uiLanguageDirection;
          _this108._focusCycler = new vh({
            focusables: _this108.focusables,
            focusTracker: _this108.focusTracker,
            keystrokeHandler: _this108.keystrokes,
            actions: {
              focusPrevious: [o ? "arrowright" : "arrowleft", "arrowup"],
              focusNext: [o ? "arrowleft" : "arrowright", "arrowdown"]
            }
          });
          var r = ["ck", "ck-toolbar", n.to("class"), n.if("isCompact", "ck-toolbar_compact")];
          var s;
          _this108.options.shouldGroupWhenFull && _this108.options.isFloating && r.push("ck-toolbar_floating"), _this108.setTemplate({
            tag: "div",
            attributes: {
              class: r,
              role: "toolbar",
              "aria-label": n.to("ariaLabel"),
              style: {
                maxWidth: n.to("maxWidth")
              }
            },
            children: _this108.children,
            on: {
              mousedown: (s = _assertThisInitialized(_this108), s.bindTemplate.to(function (t) {
                t.target === s.element && t.preventDefault();
              }))
            }
          }), _this108._behavior = _this108.options.shouldGroupWhenFull ? new Bh(_assertThisInitialized(_this108)) : new Nh(_assertThisInitialized(_this108));
          return _this108;
        }

        _createClass(Mh, [{
          key: "render",
          value: function render() {
            var _this109 = this;

            _get(_getPrototypeOf(Mh.prototype), "render", this).call(this);

            var _iterator298 = _createForOfIteratorHelper(this.items),
                _step298;

            try {
              for (_iterator298.s(); !(_step298 = _iterator298.n()).done;) {
                var _t214 = _step298.value;
                this.focusTracker.add(_t214.element);
              }
            } catch (err) {
              _iterator298.e(err);
            } finally {
              _iterator298.f();
            }

            this.items.on("add", function (t, e) {
              _this109.focusTracker.add(e.element);
            }), this.items.on("remove", function (t, e) {
              _this109.focusTracker.remove(e.element);
            }), this.keystrokes.listenTo(this.element), this._behavior.render(this);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            return this._behavior.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy(), _get(_getPrototypeOf(Mh.prototype), "destroy", this).call(this);
          }
        }, {
          key: "focus",
          value: function focus() {
            this._focusCycler.focusFirst();
          }
        }, {
          key: "focusLast",
          value: function focusLast() {
            this._focusCycler.focusLast();
          }
        }, {
          key: "fillFromConfig",
          value: function fillFromConfig(t, e) {
            var _this110 = this;

            var n = Dh(t),
                i = n.items.filter(function (t, i, o) {
              return "|" === t || -1 === n.removeItems.indexOf(t) && ("-" === t ? !_this110.options.shouldGroupWhenFull || (c("toolbarview-line-break-ignored-when-grouping-items", o), !1) : !!e.has(t) || (c("toolbarview-item-unavailable", {
                name: t
              }), !1));
            }),
                o = this._cleanSeparators(i).map(function (t) {
              return "|" === t ? new xh() : "-" === t ? new Eh() : e.create(t);
            });

            this.items.addMany(o);
          }
        }, {
          key: "_cleanSeparators",
          value: function _cleanSeparators(t) {
            var e = function e(t) {
              return "-" !== t && "|" !== t;
            },
                n = t.length,
                i = t.findIndex(e),
                o = n - t.slice().reverse().findIndex(e);

            return t.slice(i, o).filter(function (t, n, i) {
              if (e(t)) return !0;
              return !(n > 0 && i[n - 1] === t);
            });
          }
        }]);

        return Mh;
      }(Dd);

      var Th = /*#__PURE__*/function (_Dd10) {
        _inherits(Th, _Dd10);

        var _super57 = _createSuper(Th);

        function Th(t) {
          var _this111;

          _classCallCheck(this, Th);

          _this111 = _super57.call(this, t), _this111.children = _this111.createCollection(), _this111.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-toolbar__items"]
            },
            children: _this111.children
          });
          return _this111;
        }

        return _createClass(Th);
      }(Dd);

      var Nh = /*#__PURE__*/function () {
        function Nh(t) {
          _classCallCheck(this, Nh);

          var e = t.bindTemplate;
          t.set("isVertical", !1), t.itemsView.children.bindTo(t.items).using(function (t) {
            return t;
          }), t.focusables.bindTo(t.items).using(function (t) {
            return t;
          }), t.extendTemplate({
            attributes: {
              class: [e.if("isVertical", "ck-toolbar_vertical")]
            }
          });
        }

        _createClass(Nh, [{
          key: "render",
          value: function render() {}
        }, {
          key: "destroy",
          value: function destroy() {}
        }]);

        return Nh;
      }();

      var Bh = /*#__PURE__*/function () {
        function Bh(t) {
          var _this112 = this;

          _classCallCheck(this, Bh);

          this.view = t, this.viewChildren = t.children, this.viewFocusables = t.focusables, this.viewItemsView = t.itemsView, this.viewFocusTracker = t.focusTracker, this.viewLocale = t.locale, this.ungroupedItems = t.createCollection(), this.groupedItems = t.createCollection(), this.groupedItemsDropdown = this._createGroupedItemsDropdown(), this.resizeObserver = null, this.cachedPadding = null, this.shouldUpdateGroupingOnNextResize = !1, t.itemsView.children.bindTo(this.ungroupedItems).using(function (t) {
            return t;
          }), this.ungroupedItems.on("add", this._updateFocusCycleableItems.bind(this)), this.ungroupedItems.on("remove", this._updateFocusCycleableItems.bind(this)), t.children.on("add", this._updateFocusCycleableItems.bind(this)), t.children.on("remove", this._updateFocusCycleableItems.bind(this)), t.items.on("change", function (t, e) {
            var n = e.index;

            var _iterator299 = _createForOfIteratorHelper(e.removed),
                _step299;

            try {
              for (_iterator299.s(); !(_step299 = _iterator299.n()).done;) {
                var _t216 = _step299.value;
                n >= _this112.ungroupedItems.length ? _this112.groupedItems.remove(_t216) : _this112.ungroupedItems.remove(_t216);
              }
            } catch (err) {
              _iterator299.e(err);
            } finally {
              _iterator299.f();
            }

            for (var _t215 = n; _t215 < n + e.added.length; _t215++) {
              var _i137 = e.added[_t215 - n];
              _t215 > _this112.ungroupedItems.length ? _this112.groupedItems.add(_i137, _t215 - _this112.ungroupedItems.length) : _this112.ungroupedItems.add(_i137, _t215);
            }

            _this112._updateGrouping();
          }), t.extendTemplate({
            attributes: {
              class: ["ck-toolbar_grouping"]
            }
          });
        }

        _createClass(Bh, [{
          key: "render",
          value: function render(t) {
            this.viewElement = t.element, this._enableGroupingOnResize(), this._enableGroupingOnMaxWidthChange(t);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.groupedItemsDropdown.destroy(), this.resizeObserver.destroy();
          }
        }, {
          key: "_updateGrouping",
          value: function _updateGrouping() {
            if (!this.viewElement.ownerDocument.body.contains(this.viewElement)) return;
            if (!_h(this.viewElement)) return void (this.shouldUpdateGroupingOnNextResize = !0);
            var t = this.groupedItems.length;
            var e;

            for (; this._areItemsOverflowing;) {
              this._groupLastItem(), e = !0;
            }

            if (!e && this.groupedItems.length) {
              for (; this.groupedItems.length && !this._areItemsOverflowing;) {
                this._ungroupFirstItem();
              }

              this._areItemsOverflowing && this._groupLastItem();
            }

            this.groupedItems.length !== t && this.view.fire("groupedItemsUpdate");
          }
        }, {
          key: "_areItemsOverflowing",
          get: function get() {
            if (!this.ungroupedItems.length) return !1;
            var t = this.viewElement,
                e = this.viewLocale.uiLanguageDirection,
                n = new ma(t.lastChild),
                i = new ma(t);

            if (!this.cachedPadding) {
              var _n184 = os.window.getComputedStyle(t),
                  _i138 = "ltr" === e ? "paddingRight" : "paddingLeft";

              this.cachedPadding = Number.parseInt(_n184[_i138]);
            }

            return "ltr" === e ? n.right > i.right - this.cachedPadding : n.left < i.left + this.cachedPadding;
          }
        }, {
          key: "_enableGroupingOnResize",
          value: function _enableGroupingOnResize() {
            var _this113 = this;

            var t;
            this.resizeObserver = new ka(this.viewElement, function (e) {
              t && t === e.contentRect.width && !_this113.shouldUpdateGroupingOnNextResize || (_this113.shouldUpdateGroupingOnNextResize = !1, _this113._updateGrouping(), t = e.contentRect.width);
            }), this._updateGrouping();
          }
        }, {
          key: "_enableGroupingOnMaxWidthChange",
          value: function _enableGroupingOnMaxWidthChange(t) {
            var _this114 = this;

            t.on("change:maxWidth", function () {
              _this114._updateGrouping();
            });
          }
        }, {
          key: "_groupLastItem",
          value: function _groupLastItem() {
            this.groupedItems.length || (this.viewChildren.add(new xh()), this.viewChildren.add(this.groupedItemsDropdown), this.viewFocusTracker.add(this.groupedItemsDropdown.element)), this.groupedItems.add(this.ungroupedItems.remove(this.ungroupedItems.last), 0);
          }
        }, {
          key: "_ungroupFirstItem",
          value: function _ungroupFirstItem() {
            this.ungroupedItems.add(this.groupedItems.remove(this.groupedItems.first)), this.groupedItems.length || (this.viewChildren.remove(this.groupedItemsDropdown), this.viewChildren.remove(this.viewChildren.last), this.viewFocusTracker.remove(this.groupedItemsDropdown.element));
          }
        }, {
          key: "_createGroupedItemsDropdown",
          value: function _createGroupedItemsDropdown() {
            var t = this.viewLocale,
                e = t.t,
                n = Hh(t);
            return n.class = "ck-toolbar__grouped-dropdown", n.panelPosition = "ltr" === t.uiLanguageDirection ? "sw" : "se", qh(n, []), n.buttonView.set({
              label: e("Show more items"),
              tooltip: !0,
              tooltipPosition: "rtl" === t.uiLanguageDirection ? "se" : "sw",
              icon: wd
            }), n.toolbarView.items.bindTo(this.groupedItems).using(function (t) {
              return t;
            }), n;
          }
        }, {
          key: "_updateFocusCycleableItems",
          value: function _updateFocusCycleableItems() {
            var _this115 = this;

            this.viewFocusables.clear(), this.ungroupedItems.map(function (t) {
              _this115.viewFocusables.add(t);
            }), this.groupedItems.length && this.viewFocusables.add(this.groupedItemsDropdown);
          }
        }]);

        return Bh;
      }();

      var zh = n(5319),
          Ph = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(zh.Z, Ph), zh.Z.locals;

      var Lh = /*#__PURE__*/function (_Dd11) {
        _inherits(Lh, _Dd11);

        var _super58 = _createSuper(Lh);

        function Lh() {
          var _this116;

          _classCallCheck(this, Lh);

          _this116 = _super58.call(this), _this116.items = _this116.createCollection(), _this116.focusTracker = new Aa(), _this116.keystrokes = new Ca(), _this116._focusCycler = new vh({
            focusables: _this116.items,
            focusTracker: _this116.focusTracker,
            keystrokeHandler: _this116.keystrokes,
            actions: {
              focusPrevious: "arrowup",
              focusNext: "arrowdown"
            }
          }), _this116.setTemplate({
            tag: "ul",
            attributes: {
              class: ["ck", "ck-reset", "ck-list"]
            },
            children: _this116.items
          });
          return _this116;
        }

        _createClass(Lh, [{
          key: "render",
          value: function render() {
            var _this117 = this;

            _get(_getPrototypeOf(Lh.prototype), "render", this).call(this);

            var _iterator300 = _createForOfIteratorHelper(this.items),
                _step300;

            try {
              for (_iterator300.s(); !(_step300 = _iterator300.n()).done;) {
                var _t217 = _step300.value;
                this.focusTracker.add(_t217.element);
              }
            } catch (err) {
              _iterator300.e(err);
            } finally {
              _iterator300.f();
            }

            this.items.on("add", function (t, e) {
              _this117.focusTracker.add(e.element);
            }), this.items.on("remove", function (t, e) {
              _this117.focusTracker.remove(e.element);
            }), this.keystrokes.listenTo(this.element);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            _get(_getPrototypeOf(Lh.prototype), "destroy", this).call(this), this.focusTracker.destroy(), this.keystrokes.destroy();
          }
        }, {
          key: "focus",
          value: function focus() {
            this._focusCycler.focusFirst();
          }
        }, {
          key: "focusLast",
          value: function focusLast() {
            this._focusCycler.focusLast();
          }
        }]);

        return Lh;
      }(Dd);

      var Rh = /*#__PURE__*/function (_Dd12) {
        _inherits(Rh, _Dd12);

        var _super59 = _createSuper(Rh);

        function Rh(t) {
          var _this118;

          _classCallCheck(this, Rh);

          _this118 = _super59.call(this, t), _this118.children = _this118.createCollection(), _this118.setTemplate({
            tag: "li",
            attributes: {
              class: ["ck", "ck-list__item"]
            },
            children: _this118.children
          });
          return _this118;
        }

        _createClass(Rh, [{
          key: "focus",
          value: function focus() {
            this.children.first.focus();
          }
        }]);

        return Rh;
      }(Dd);

      var Oh = /*#__PURE__*/function (_Dd13) {
        _inherits(Oh, _Dd13);

        var _super60 = _createSuper(Oh);

        function Oh(t) {
          var _this119;

          _classCallCheck(this, Oh);

          _this119 = _super60.call(this, t), _this119.setTemplate({
            tag: "li",
            attributes: {
              class: ["ck", "ck-list__separator"]
            }
          });
          return _this119;
        }

        return _createClass(Oh);
      }(Dd);

      var jh = n(2951),
          Fh = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      },
          Vh = (Zr()(jh.Z, Fh), jh.Z.locals, n(7995)),
          Uh = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Vh.Z, Uh), Vh.Z.locals;

      function Hh(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : hh;
        var n = new e(t),
            i = new ph(t),
            o = new Ch(t, n, i);
        return n.bind("isEnabled").to(o), n instanceof hh ? n.bind("isOn").to(o, "isOpen") : n.arrowView.bind("isOn").to(o, "isOpen"), function (t) {
          (function (t) {
            t.on("render", function () {
              Cd({
                emitter: t,
                activator: function activator() {
                  return t.isOpen;
                },
                callback: function callback() {
                  t.isOpen = !1;
                },
                contextElements: [t.element]
              });
            });
          })(t), function (t) {
            t.on("execute", function (e) {
              e.source instanceof ah || (t.isOpen = !1);
            });
          }(t), function (t) {
            t.keystrokes.set("arrowdown", function (e, n) {
              t.isOpen && (t.panelView.focus(), n());
            }), t.keystrokes.set("arrowup", function (e, n) {
              t.isOpen && (t.panelView.focusLast(), n());
            });
          }(t);
        }(o), o;
      }

      function qh(t, e) {
        var n = t.locale,
            i = n.t,
            o = t.toolbarView = new Mh(n);
        o.set("ariaLabel", i("Dropdown toolbar")), t.extendTemplate({
          attributes: {
            class: ["ck-toolbar-dropdown"]
          }
        }), e.map(function (t) {
          return o.items.add(t);
        }), t.panelView.children.add(o), o.items.delegate("execute").to(t);
      }

      function Wh(t, e) {
        var n = t.locale,
            i = t.listView = new Lh(n);
        i.items.bindTo(e).using(function (_ref35) {
          var t = _ref35.type,
              e = _ref35.model;
          if ("separator" === t) return new Oh(n);

          if ("button" === t || "switchbutton" === t) {
            var _o73;

            var _i139 = new Rh(n);

            var _o72;

            return _o72 = "button" === t ? new oh(n) : new ah(n), (_o73 = _o72).bind.apply(_o73, _toConsumableArray(Object.keys(e))).to(e), _o72.delegate("execute").to(_i139), _i139.children.add(_o72), _i139;
          }
        }), t.panelView.children.add(i), i.items.delegate("execute").to(t);
      }

      var Gh = n(4606),
          $h = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Gh.Z, $h), Gh.Z.locals;

      var Yh = /*#__PURE__*/function (_Dd14) {
        _inherits(Yh, _Dd14);

        var _super61 = _createSuper(Yh);

        function Yh(t) {
          var _this120;

          _classCallCheck(this, Yh);

          _this120 = _super61.call(this, t), _this120.body = new Kd(t);
          return _this120;
        }

        _createClass(Yh, [{
          key: "render",
          value: function render() {
            _get(_getPrototypeOf(Yh.prototype), "render", this).call(this), this.body.attachToDom();
          }
        }, {
          key: "destroy",
          value: function destroy() {
            return this.body.detachFromDom(), _get(_getPrototypeOf(Yh.prototype), "destroy", this).call(this);
          }
        }]);

        return Yh;
      }(Dd);

      var Kh = n(6526),
          Qh = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Kh.Z, Qh), Kh.Z.locals;

      var Zh = /*#__PURE__*/function (_Dd15) {
        _inherits(Zh, _Dd15);

        var _super62 = _createSuper(Zh);

        function Zh(t) {
          var _this121;

          _classCallCheck(this, Zh);

          _this121 = _super62.call(this, t), _this121.set("text"), _this121.set("for"), _this121.id = "ck-editor__label_".concat(r());
          var e = _this121.bindTemplate;

          _this121.setTemplate({
            tag: "label",
            attributes: {
              class: ["ck", "ck-label"],
              id: _this121.id,
              for: e.to("for")
            },
            children: [{
              text: e.to("text")
            }]
          });

          return _this121;
        }

        return _createClass(Zh);
      }(Dd);

      var Jh = /*#__PURE__*/function (_Yh) {
        _inherits(Jh, _Yh);

        var _super63 = _createSuper(Jh);

        function Jh(t) {
          var _this122;

          _classCallCheck(this, Jh);

          _this122 = _super63.call(this, t), _this122.top = _this122.createCollection(), _this122.main = _this122.createCollection(), _this122._voiceLabelView = _this122._createVoiceLabel(), _this122.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-reset", "ck-editor", "ck-rounded-corners"],
              role: "application",
              dir: t.uiLanguageDirection,
              lang: t.uiLanguage,
              "aria-labelledby": _this122._voiceLabelView.id
            },
            children: [_this122._voiceLabelView, {
              tag: "div",
              attributes: {
                class: ["ck", "ck-editor__top", "ck-reset_all"],
                role: "presentation"
              },
              children: _this122.top
            }, {
              tag: "div",
              attributes: {
                class: ["ck", "ck-editor__main"],
                role: "presentation"
              },
              children: _this122.main
            }]
          });
          return _this122;
        }

        _createClass(Jh, [{
          key: "_createVoiceLabel",
          value: function _createVoiceLabel() {
            var t = this.t,
                e = new Zh();
            return e.text = t("Rich Text Editor"), e.extendTemplate({
              attributes: {
                class: "ck-voice-label"
              }
            }), e;
          }
        }]);

        return Jh;
      }(Yh);

      var Xh = /*#__PURE__*/function (_Dd16) {
        _inherits(Xh, _Dd16);

        var _super64 = _createSuper(Xh);

        function Xh(t, e, n) {
          var _this123;

          _classCallCheck(this, Xh);

          _this123 = _super64.call(this, t), _this123.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-content", "ck-editor__editable", "ck-rounded-corners"],
              lang: t.contentLanguage,
              dir: t.contentLanguageDirection
            }
          }), _this123.name = null, _this123.set("isFocused", !1), _this123._editableElement = n, _this123._hasExternalElement = !!_this123._editableElement, _this123._editingView = e;
          return _this123;
        }

        _createClass(Xh, [{
          key: "render",
          value: function render() {
            var _this124 = this;

            _get(_getPrototypeOf(Xh.prototype), "render", this).call(this), this._hasExternalElement ? this.template.apply(this.element = this._editableElement) : this._editableElement = this.element, this.on("change:isFocused", function () {
              return _this124._updateIsFocusedClasses();
            }), this._updateIsFocusedClasses();
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this._hasExternalElement && this.template.revert(this._editableElement), _get(_getPrototypeOf(Xh.prototype), "destroy", this).call(this);
          }
        }, {
          key: "_updateIsFocusedClasses",
          value: function _updateIsFocusedClasses() {
            var t = this._editingView;

            function e(e) {
              t.change(function (n) {
                var i = t.document.getRoot(e.name);
                n.addClass(e.isFocused ? "ck-focused" : "ck-blurred", i), n.removeClass(e.isFocused ? "ck-blurred" : "ck-focused", i);
              });
            }

            t.isRenderingInProgress ? function n(i) {
              t.once("change:isRenderingInProgress", function (t, o, r) {
                r ? n(i) : e(i);
              });
            }(this) : e(this);
          }
        }]);

        return Xh;
      }(Dd);

      var tu = /*#__PURE__*/function (_Xh) {
        _inherits(tu, _Xh);

        var _super65 = _createSuper(tu);

        function tu(t, e, n) {
          var _this125;

          _classCallCheck(this, tu);

          _this125 = _super65.call(this, t, e, n), _this125.extendTemplate({
            attributes: {
              role: "textbox",
              class: "ck-editor__editable_inline"
            }
          });
          return _this125;
        }

        _createClass(tu, [{
          key: "render",
          value: function render() {
            var _this126 = this;

            _get(_getPrototypeOf(tu.prototype), "render", this).call(this);

            var t = this._editingView,
                e = this.t;
            t.change(function (n) {
              var i = t.document.getRoot(_this126.name);
              n.setAttribute("aria-label", e("Rich Text Editor, %0", _this126.name), i);
            });
          }
        }]);

        return tu;
      }(Xh);

      var eu = n(9458),
          nu = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(eu.Z, nu), eu.Z.locals;
      var iu = n(5735),
          ou = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(iu.Z, ou), iu.Z.locals;

      var ru = /*#__PURE__*/function (_Dd17) {
        _inherits(ru, _Dd17);

        var _super66 = _createSuper(ru);

        function ru(t) {
          var _this127;

          _classCallCheck(this, ru);

          _this127 = _super66.call(this, t), _this127.set("value"), _this127.set("id"), _this127.set("placeholder"), _this127.set("isReadOnly", !1), _this127.set("hasError", !1), _this127.set("ariaDescribedById"), _this127.focusTracker = new Aa(), _this127.bind("isFocused").to(_this127.focusTracker), _this127.set("isEmpty", !0), _this127.set("inputMode", "text");
          var e = _this127.bindTemplate;

          _this127.setTemplate({
            tag: "input",
            attributes: {
              class: ["ck", "ck-input", e.if("isFocused", "ck-input_focused"), e.if("isEmpty", "ck-input-text_empty"), e.if("hasError", "ck-error")],
              id: e.to("id"),
              placeholder: e.to("placeholder"),
              readonly: e.to("isReadOnly"),
              inputmode: e.to("inputMode"),
              "aria-invalid": e.if("hasError", !0),
              "aria-describedby": e.to("ariaDescribedById")
            },
            on: {
              input: e.to(function () {
                var _this128;

                for (var _len20 = arguments.length, t = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
                  t[_key20] = arguments[_key20];
                }

                (_this128 = _this127).fire.apply(_this128, ["input"].concat(t)), _this127._updateIsEmpty();
              }),
              change: e.to(_this127._updateIsEmpty.bind(_assertThisInitialized(_this127)))
            }
          });

          return _this127;
        }

        _createClass(ru, [{
          key: "render",
          value: function render() {
            var _this129 = this;

            _get(_getPrototypeOf(ru.prototype), "render", this).call(this), this.focusTracker.add(this.element), this._setDomElementValue(this.value), this._updateIsEmpty(), this.on("change:value", function (t, e, n) {
              _this129._setDomElementValue(n), _this129._updateIsEmpty();
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            _get(_getPrototypeOf(ru.prototype), "destroy", this).call(this), this.focusTracker.destroy();
          }
        }, {
          key: "select",
          value: function select() {
            this.element.select();
          }
        }, {
          key: "focus",
          value: function focus() {
            this.element.focus();
          }
        }, {
          key: "_updateIsEmpty",
          value: function _updateIsEmpty() {
            this.isEmpty = !this.element.value;
          }
        }, {
          key: "_setDomElementValue",
          value: function _setDomElementValue(t) {
            this.element.value = t || 0 === t ? t : "";
          }
        }]);

        return ru;
      }(Dd);

      var su = /*#__PURE__*/function (_ru) {
        _inherits(su, _ru);

        var _super67 = _createSuper(su);

        function su(t) {
          var _this130;

          _classCallCheck(this, su);

          _this130 = _super67.call(this, t), _this130.extendTemplate({
            attributes: {
              type: "text",
              class: ["ck-input-text"]
            }
          });
          return _this130;
        }

        return _createClass(su);
      }(ru);

      var au = n(6518),
          cu = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(au.Z, cu), au.Z.locals;

      var lu = /*#__PURE__*/function (_Dd18) {
        _inherits(lu, _Dd18);

        var _super68 = _createSuper(lu);

        function lu(t, e) {
          var _this131;

          _classCallCheck(this, lu);

          _this131 = _super68.call(this, t);
          var n = "ck-labeled-field-view-".concat(r()),
              i = "ck-labeled-field-view-status-".concat(r());
          _this131.fieldView = e(_assertThisInitialized(_this131), n, i), _this131.set("label"), _this131.set("isEnabled", !0), _this131.set("isEmpty", !0), _this131.set("isFocused", !1), _this131.set("errorText", null), _this131.set("infoText", null), _this131.set("class"), _this131.set("placeholder"), _this131.labelView = _this131._createLabelView(n), _this131.statusView = _this131._createStatusView(i), _this131.bind("_statusText").to(_assertThisInitialized(_this131), "errorText", _assertThisInitialized(_this131), "infoText", function (t, e) {
            return t || e;
          });
          var o = _this131.bindTemplate;

          _this131.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-labeled-field-view", o.to("class"), o.if("isEnabled", "ck-disabled", function (t) {
                return !t;
              }), o.if("isEmpty", "ck-labeled-field-view_empty"), o.if("isFocused", "ck-labeled-field-view_focused"), o.if("placeholder", "ck-labeled-field-view_placeholder"), o.if("errorText", "ck-error")]
            },
            children: [{
              tag: "div",
              attributes: {
                class: ["ck", "ck-labeled-field-view__input-wrapper"]
              },
              children: [_this131.fieldView, _this131.labelView]
            }, _this131.statusView]
          });

          return _this131;
        }

        _createClass(lu, [{
          key: "_createLabelView",
          value: function _createLabelView(t) {
            var e = new Zh(this.locale);
            return e.for = t, e.bind("text").to(this, "label"), e;
          }
        }, {
          key: "_createStatusView",
          value: function _createStatusView(t) {
            var e = new Dd(this.locale),
                n = this.bindTemplate;
            return e.setTemplate({
              tag: "div",
              attributes: {
                class: ["ck", "ck-labeled-field-view__status", n.if("errorText", "ck-labeled-field-view__status_error"), n.if("_statusText", "ck-hidden", function (t) {
                  return !t;
                })],
                id: t,
                role: n.if("errorText", "alert")
              },
              children: [{
                text: n.to("_statusText")
              }]
            }), e;
          }
        }, {
          key: "focus",
          value: function focus() {
            this.fieldView.focus();
          }
        }]);

        return lu;
      }(Dd);

      function du(t, e, n) {
        var i = new su(t.locale);
        return i.set({
          id: e,
          ariaDescribedById: n
        }), i.bind("isReadOnly").to(t, "isEnabled", function (t) {
          return !t;
        }), i.bind("hasError").to(t, "errorText", function (t) {
          return !!t;
        }), i.on("input", function () {
          t.errorText = null;
        }), t.bind("isEmpty", "isFocused", "placeholder").to(i), i;
      }

      var hu = /*#__PURE__*/function (_Pi2) {
        _inherits(hu, _Pi2);

        var _super69 = _createSuper(hu);

        function hu() {
          _classCallCheck(this, hu);

          return _super69.apply(this, arguments);
        }

        _createClass(hu, [{
          key: "init",
          value: function init() {
            this.on("show:warning", function (t, e) {
              window.alert(e.message);
            }, {
              priority: "lowest"
            });
          }
        }, {
          key: "showSuccess",
          value: function showSuccess(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            this._showNotification({
              message: t,
              type: "success",
              namespace: e.namespace,
              title: e.title
            });
          }
        }, {
          key: "showInfo",
          value: function showInfo(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            this._showNotification({
              message: t,
              type: "info",
              namespace: e.namespace,
              title: e.title
            });
          }
        }, {
          key: "showWarning",
          value: function showWarning(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            this._showNotification({
              message: t,
              type: "warning",
              namespace: e.namespace,
              title: e.title
            });
          }
        }, {
          key: "_showNotification",
          value: function _showNotification(t) {
            var e = "show:".concat(t.type) + (t.namespace ? ":".concat(t.namespace) : "");
            this.fire(e, {
              message: t.message,
              type: t.type,
              title: t.title || ""
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "Notification";
          }
        }]);

        return hu;
      }(Pi);

      var uu = /*#__PURE__*/_createClass(function uu(t, e) {
        _classCallCheck(this, uu);

        e && Jt(this, e), t && this.set(t);
      });

      function gu(t) {
        return function (e) {
          return e + t;
        };
      }

      he(uu, re);
      var mu = n(4451),
          pu = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(mu.Z, pu), mu.Z.locals;
      var fu = gu("px"),
          ku = os.document.body;

      var bu = /*#__PURE__*/function (_Dd19) {
        _inherits(bu, _Dd19);

        var _super70 = _createSuper(bu);

        function bu(t) {
          var _this132;

          _classCallCheck(this, bu);

          _this132 = _super70.call(this, t);
          var e = _this132.bindTemplate;
          _this132.set("top", 0), _this132.set("left", 0), _this132.set("position", "arrow_nw"), _this132.set("isVisible", !1), _this132.set("withArrow", !0), _this132.set("class"), _this132.content = _this132.createCollection(), _this132.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-balloon-panel", e.to("position", function (t) {
                return "ck-balloon-panel_".concat(t);
              }), e.if("isVisible", "ck-balloon-panel_visible"), e.if("withArrow", "ck-balloon-panel_with-arrow"), e.to("class")],
              style: {
                top: e.to("top", fu),
                left: e.to("left", fu)
              }
            },
            children: _this132.content
          });
          return _this132;
        }

        _createClass(bu, [{
          key: "show",
          value: function show() {
            this.isVisible = !0;
          }
        }, {
          key: "hide",
          value: function hide() {
            this.isVisible = !1;
          }
        }, {
          key: "attachTo",
          value: function attachTo(t) {
            this.show();

            var e = bu.defaultPositions,
                n = Object.assign({}, {
              element: this.element,
              positions: [e.southArrowNorth, e.southArrowNorthMiddleWest, e.southArrowNorthMiddleEast, e.southArrowNorthWest, e.southArrowNorthEast, e.northArrowSouth, e.northArrowSouthMiddleWest, e.northArrowSouthMiddleEast, e.northArrowSouthWest, e.northArrowSouthEast, e.viewportStickyNorth],
              limiter: ku,
              fitInViewport: !0
            }, t),
                i = bu._getOptimalPosition(n),
                o = parseInt(i.left),
                r = parseInt(i.top),
                s = i.name,
                _i$config = i.config,
                a = _i$config === void 0 ? {} : _i$config,
                _a$withArrow = a.withArrow,
                c = _a$withArrow === void 0 ? !0 : _a$withArrow;

            Object.assign(this, {
              top: r,
              left: o,
              position: s,
              withArrow: c
            });
          }
        }, {
          key: "pin",
          value: function pin(t) {
            var _this133 = this;

            this.unpin(), this._pinWhenIsVisibleCallback = function () {
              _this133.isVisible ? _this133._startPinning(t) : _this133._stopPinning();
            }, this._startPinning(t), this.listenTo(this, "change:isVisible", this._pinWhenIsVisibleCallback);
          }
        }, {
          key: "unpin",
          value: function unpin() {
            this._pinWhenIsVisibleCallback && (this._stopPinning(), this.stopListening(this, "change:isVisible", this._pinWhenIsVisibleCallback), this._pinWhenIsVisibleCallback = null, this.hide());
          }
        }, {
          key: "_startPinning",
          value: function _startPinning(t) {
            var _this134 = this;

            this.attachTo(t);
            var e = wu(t.target),
                n = t.limiter ? wu(t.limiter) : ku;
            this.listenTo(os.document, "scroll", function (i, o) {
              var r = o.target,
                  s = e && r.contains(e),
                  a = n && r.contains(n);
              !s && !a && e && n || _this134.attachTo(t);
            }, {
              useCapture: !0
            }), this.listenTo(os.window, "resize", function () {
              _this134.attachTo(t);
            });
          }
        }, {
          key: "_stopPinning",
          value: function _stopPinning() {
            this.stopListening(os.document, "scroll"), this.stopListening(os.window, "resize");
          }
        }]);

        return bu;
      }(Dd);

      function wu(t) {
        return _i(t) ? t : ha(t) ? t.commonAncestorContainer : "function" == typeof t ? wu(t()) : null;
      }

      bu.arrowHorizontalOffset = 25, bu.arrowVerticalOffset = 10, bu.stickyVerticalOffset = 20, bu._getOptimalPosition = bh, bu.defaultPositions = function () {
        var _ref36 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref36$horizontalOffs = _ref36.horizontalOffset,
            t = _ref36$horizontalOffs === void 0 ? bu.arrowHorizontalOffset : _ref36$horizontalOffs,
            _ref36$verticalOffset = _ref36.verticalOffset,
            e = _ref36$verticalOffset === void 0 ? bu.arrowVerticalOffset : _ref36$verticalOffset,
            _ref36$stickyVertical = _ref36.stickyVerticalOffset,
            n = _ref36$stickyVertical === void 0 ? bu.stickyVerticalOffset : _ref36$stickyVertical,
            i = _ref36.config;

        return {
          northWestArrowSouthWest: function northWestArrowSouthWest(e, n) {
            return _objectSpread({
              top: o(e, n),
              left: e.left - t,
              name: "arrow_sw"
            }, i && {
              config: i
            });
          },
          northWestArrowSouthMiddleWest: function northWestArrowSouthMiddleWest(e, n) {
            return _objectSpread({
              top: o(e, n),
              left: e.left - .25 * n.width - t,
              name: "arrow_smw"
            }, i && {
              config: i
            });
          },
          northWestArrowSouth: function northWestArrowSouth(t, e) {
            return _objectSpread({
              top: o(t, e),
              left: t.left - e.width / 2,
              name: "arrow_s"
            }, i && {
              config: i
            });
          },
          northWestArrowSouthMiddleEast: function northWestArrowSouthMiddleEast(e, n) {
            return _objectSpread({
              top: o(e, n),
              left: e.left - .75 * n.width + t,
              name: "arrow_sme"
            }, i && {
              config: i
            });
          },
          northWestArrowSouthEast: function northWestArrowSouthEast(e, n) {
            return _objectSpread({
              top: o(e, n),
              left: e.left - n.width + t,
              name: "arrow_se"
            }, i && {
              config: i
            });
          },
          northArrowSouthWest: function northArrowSouthWest(e, n) {
            return _objectSpread({
              top: o(e, n),
              left: e.left + e.width / 2 - t,
              name: "arrow_sw"
            }, i && {
              config: i
            });
          },
          northArrowSouthMiddleWest: function northArrowSouthMiddleWest(e, n) {
            return _objectSpread({
              top: o(e, n),
              left: e.left + e.width / 2 - .25 * n.width - t,
              name: "arrow_smw"
            }, i && {
              config: i
            });
          },
          northArrowSouth: function northArrowSouth(t, e) {
            return _objectSpread({
              top: o(t, e),
              left: t.left + t.width / 2 - e.width / 2,
              name: "arrow_s"
            }, i && {
              config: i
            });
          },
          northArrowSouthMiddleEast: function northArrowSouthMiddleEast(e, n) {
            return _objectSpread({
              top: o(e, n),
              left: e.left + e.width / 2 - .75 * n.width + t,
              name: "arrow_sme"
            }, i && {
              config: i
            });
          },
          northArrowSouthEast: function northArrowSouthEast(e, n) {
            return _objectSpread({
              top: o(e, n),
              left: e.left + e.width / 2 - n.width + t,
              name: "arrow_se"
            }, i && {
              config: i
            });
          },
          northEastArrowSouthWest: function northEastArrowSouthWest(e, n) {
            return _objectSpread({
              top: o(e, n),
              left: e.right - t,
              name: "arrow_sw"
            }, i && {
              config: i
            });
          },
          northEastArrowSouthMiddleWest: function northEastArrowSouthMiddleWest(e, n) {
            return _objectSpread({
              top: o(e, n),
              left: e.right - .25 * n.width - t,
              name: "arrow_smw"
            }, i && {
              config: i
            });
          },
          northEastArrowSouth: function northEastArrowSouth(t, e) {
            return _objectSpread({
              top: o(t, e),
              left: t.right - e.width / 2,
              name: "arrow_s"
            }, i && {
              config: i
            });
          },
          northEastArrowSouthMiddleEast: function northEastArrowSouthMiddleEast(e, n) {
            return _objectSpread({
              top: o(e, n),
              left: e.right - .75 * n.width + t,
              name: "arrow_sme"
            }, i && {
              config: i
            });
          },
          northEastArrowSouthEast: function northEastArrowSouthEast(e, n) {
            return _objectSpread({
              top: o(e, n),
              left: e.right - n.width + t,
              name: "arrow_se"
            }, i && {
              config: i
            });
          },
          southWestArrowNorthWest: function southWestArrowNorthWest(e, n) {
            return _objectSpread({
              top: r(e),
              left: e.left - t,
              name: "arrow_nw"
            }, i && {
              config: i
            });
          },
          southWestArrowNorthMiddleWest: function southWestArrowNorthMiddleWest(e, n) {
            return _objectSpread({
              top: r(e),
              left: e.left - .25 * n.width - t,
              name: "arrow_nmw"
            }, i && {
              config: i
            });
          },
          southWestArrowNorth: function southWestArrowNorth(t, e) {
            return _objectSpread({
              top: r(t),
              left: t.left - e.width / 2,
              name: "arrow_n"
            }, i && {
              config: i
            });
          },
          southWestArrowNorthMiddleEast: function southWestArrowNorthMiddleEast(e, n) {
            return _objectSpread({
              top: r(e),
              left: e.left - .75 * n.width + t,
              name: "arrow_nme"
            }, i && {
              config: i
            });
          },
          southWestArrowNorthEast: function southWestArrowNorthEast(e, n) {
            return _objectSpread({
              top: r(e),
              left: e.left - n.width + t,
              name: "arrow_ne"
            }, i && {
              config: i
            });
          },
          southArrowNorthWest: function southArrowNorthWest(e, n) {
            return _objectSpread({
              top: r(e),
              left: e.left + e.width / 2 - t,
              name: "arrow_nw"
            }, i && {
              config: i
            });
          },
          southArrowNorthMiddleWest: function southArrowNorthMiddleWest(e, n) {
            return _objectSpread({
              top: r(e),
              left: e.left + e.width / 2 - .25 * n.width - t,
              name: "arrow_nmw"
            }, i && {
              config: i
            });
          },
          southArrowNorth: function southArrowNorth(t, e) {
            return _objectSpread({
              top: r(t),
              left: t.left + t.width / 2 - e.width / 2,
              name: "arrow_n"
            }, i && {
              config: i
            });
          },
          southArrowNorthMiddleEast: function southArrowNorthMiddleEast(e, n) {
            return _objectSpread({
              top: r(e),
              left: e.left + e.width / 2 - .75 * n.width + t,
              name: "arrow_nme"
            }, i && {
              config: i
            });
          },
          southArrowNorthEast: function southArrowNorthEast(e, n) {
            return _objectSpread({
              top: r(e),
              left: e.left + e.width / 2 - n.width + t,
              name: "arrow_ne"
            }, i && {
              config: i
            });
          },
          southEastArrowNorthWest: function southEastArrowNorthWest(e, n) {
            return _objectSpread({
              top: r(e),
              left: e.right - t,
              name: "arrow_nw"
            }, i && {
              config: i
            });
          },
          southEastArrowNorthMiddleWest: function southEastArrowNorthMiddleWest(e, n) {
            return _objectSpread({
              top: r(e),
              left: e.right - .25 * n.width - t,
              name: "arrow_nmw"
            }, i && {
              config: i
            });
          },
          southEastArrowNorth: function southEastArrowNorth(t, e) {
            return _objectSpread({
              top: r(t),
              left: t.right - e.width / 2,
              name: "arrow_n"
            }, i && {
              config: i
            });
          },
          southEastArrowNorthMiddleEast: function southEastArrowNorthMiddleEast(e, n) {
            return _objectSpread({
              top: r(e),
              left: e.right - .75 * n.width + t,
              name: "arrow_nme"
            }, i && {
              config: i
            });
          },
          southEastArrowNorthEast: function southEastArrowNorthEast(e, n) {
            return _objectSpread({
              top: r(e),
              left: e.right - n.width + t,
              name: "arrow_ne"
            }, i && {
              config: i
            });
          },
          viewportStickyNorth: function viewportStickyNorth(t, e, o) {
            return t.getIntersection(o) ? {
              top: o.top + n,
              left: t.left + t.width / 2 - e.width / 2,
              name: "arrowless",
              config: _objectSpread({
                withArrow: !1
              }, i)
            } : null;
          }
        };

        function o(t, n) {
          return t.top - n.height - e;
        }

        function r(t) {
          return t.bottom + e;
        }
      }();

      var Au = n(9167),
          Cu = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      },
          _u = (Zr()(Au.Z, Cu), Au.Z.locals, n(9135)),
          vu = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };

      Zr()(_u.Z, vu), _u.Z.locals;
      var yu = gu("px");

      var xu = /*#__PURE__*/function (_ue) {
        _inherits(xu, _ue);

        var _super71 = _createSuper(xu);

        function xu(t) {
          var _this135;

          _classCallCheck(this, xu);

          _this135 = _super71.call(this, t), _this135.positionLimiter = function () {
            var t = _this135.editor.editing.view,
                e = t.document.selection.editableElement;
            return e ? t.domConverter.mapViewToDom(e.root) : null;
          }, _this135.set("visibleView", null), _this135.view = new bu(t.locale), t.ui.view.body.add(_this135.view), t.ui.focusTracker.add(_this135.view.element), _this135._viewToStack = new Map(), _this135._idToStack = new Map(), _this135.set("_numberOfStacks", 0), _this135.set("_singleViewMode", !1), _this135._rotatorView = _this135._createRotatorView(), _this135._fakePanelsView = _this135._createFakePanelsView();
          return _this135;
        }

        _createClass(xu, [{
          key: "destroy",
          value: function destroy() {
            _get(_getPrototypeOf(xu.prototype), "destroy", this).call(this), this.view.destroy(), this._rotatorView.destroy(), this._fakePanelsView.destroy();
          }
        }, {
          key: "hasView",
          value: function hasView(t) {
            return Array.from(this._viewToStack.keys()).includes(t);
          }
        }, {
          key: "add",
          value: function add(t) {
            if (this.hasView(t.view)) throw new a("contextualballoon-add-view-exist", [this, t]);
            var e = t.stackId || "main";
            if (!this._idToStack.has(e)) return this._idToStack.set(e, new Map([[t.view, t]])), this._viewToStack.set(t.view, this._idToStack.get(e)), this._numberOfStacks = this._idToStack.size, void (this._visibleStack && !t.singleViewMode || this.showStack(e));

            var n = this._idToStack.get(e);

            t.singleViewMode && this.showStack(e), n.set(t.view, t), this._viewToStack.set(t.view, n), n === this._visibleStack && this._showView(t);
          }
        }, {
          key: "remove",
          value: function remove(t) {
            if (!this.hasView(t)) throw new a("contextualballoon-remove-view-not-exist", [this, t]);

            var e = this._viewToStack.get(t);

            this._singleViewMode && this.visibleView === t && (this._singleViewMode = !1), this.visibleView === t && (1 === e.size ? this._idToStack.size > 1 ? this._showNextStack() : (this.view.hide(), this.visibleView = null, this._rotatorView.hideView()) : this._showView(Array.from(e.values())[e.size - 2])), 1 === e.size ? (this._idToStack.delete(this._getStackId(e)), this._numberOfStacks = this._idToStack.size) : e.delete(t), this._viewToStack.delete(t);
          }
        }, {
          key: "updatePosition",
          value: function updatePosition(t) {
            t && (this._visibleStack.get(this.visibleView).position = t), this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition();
          }
        }, {
          key: "showStack",
          value: function showStack(t) {
            this.visibleStack = t;

            var e = this._idToStack.get(t);

            if (!e) throw new a("contextualballoon-showstack-stack-not-exist", this);
            this._visibleStack !== e && this._showView(Array.from(e.values()).pop());
          }
        }, {
          key: "_visibleStack",
          get: function get() {
            return this._viewToStack.get(this.visibleView);
          }
        }, {
          key: "_getStackId",
          value: function _getStackId(t) {
            return Array.from(this._idToStack.entries()).find(function (e) {
              return e[1] === t;
            })[0];
          }
        }, {
          key: "_showNextStack",
          value: function _showNextStack() {
            var t = Array.from(this._idToStack.values());
            var e = t.indexOf(this._visibleStack) + 1;
            t[e] || (e = 0), this.showStack(this._getStackId(t[e]));
          }
        }, {
          key: "_showPrevStack",
          value: function _showPrevStack() {
            var t = Array.from(this._idToStack.values());
            var e = t.indexOf(this._visibleStack) - 1;
            t[e] || (e = t.length - 1), this.showStack(this._getStackId(t[e]));
          }
        }, {
          key: "_createRotatorView",
          value: function _createRotatorView() {
            var _this136 = this;

            var t = new Eu(this.editor.locale),
                e = this.editor.locale.t;
            return this.view.content.add(t), t.bind("isNavigationVisible").to(this, "_numberOfStacks", this, "_singleViewMode", function (t, e) {
              return !e && t > 1;
            }), t.on("change:isNavigationVisible", function () {
              return _this136.updatePosition();
            }, {
              priority: "low"
            }), t.bind("counter").to(this, "visibleView", this, "_numberOfStacks", function (t, n) {
              if (n < 2) return "";
              var i = Array.from(_this136._idToStack.values()).indexOf(_this136._visibleStack) + 1;
              return e("%0 of %1", [i, n]);
            }), t.buttonNextView.on("execute", function () {
              t.focusTracker.isFocused && _this136.editor.editing.view.focus(), _this136._showNextStack();
            }), t.buttonPrevView.on("execute", function () {
              t.focusTracker.isFocused && _this136.editor.editing.view.focus(), _this136._showPrevStack();
            }), t;
          }
        }, {
          key: "_createFakePanelsView",
          value: function _createFakePanelsView() {
            var t = new Du(this.editor.locale, this.view);
            return t.bind("numberOfPanels").to(this, "_numberOfStacks", this, "_singleViewMode", function (t, e) {
              return !e && t >= 2 ? Math.min(t - 1, 2) : 0;
            }), t.listenTo(this.view, "change:top", function () {
              return t.updatePosition();
            }), t.listenTo(this.view, "change:left", function () {
              return t.updatePosition();
            }), this.editor.ui.view.body.add(t), t;
          }
        }, {
          key: "_showView",
          value: function _showView(_ref37) {
            var t = _ref37.view,
                _ref37$balloonClassNa = _ref37.balloonClassName,
                e = _ref37$balloonClassNa === void 0 ? "" : _ref37$balloonClassNa,
                _ref37$withArrow = _ref37.withArrow,
                n = _ref37$withArrow === void 0 ? !0 : _ref37$withArrow,
                _ref37$singleViewMode = _ref37.singleViewMode,
                i = _ref37$singleViewMode === void 0 ? !1 : _ref37$singleViewMode;
            this.view.class = e, this.view.withArrow = n, this._rotatorView.showView(t), this.visibleView = t, this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition(), i && (this._singleViewMode = !0);
          }
        }, {
          key: "_getBalloonPosition",
          value: function _getBalloonPosition() {
            var t = Array.from(this._visibleStack.values()).pop().position;
            return t && (t.limiter || (t = Object.assign({}, t, {
              limiter: this.positionLimiter
            })), t = Object.assign({}, t, {
              viewportOffsetConfig: this.editor.ui.viewportOffset
            })), t;
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "ContextualBalloon";
          }
        }]);

        return xu;
      }(ue);

      var Eu = /*#__PURE__*/function (_Dd20) {
        _inherits(Eu, _Dd20);

        var _super72 = _createSuper(Eu);

        function Eu(t) {
          var _this137;

          _classCallCheck(this, Eu);

          _this137 = _super72.call(this, t);
          var e = t.t,
              n = _this137.bindTemplate;
          _this137.set("isNavigationVisible", !0), _this137.focusTracker = new Aa(), _this137.buttonPrevView = _this137._createButtonView(e("Previous"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z"/></svg>'), _this137.buttonNextView = _this137._createButtonView(e("Next"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>'), _this137.content = _this137.createCollection(), _this137.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-balloon-rotator"],
              "z-index": "-1"
            },
            children: [{
              tag: "div",
              attributes: {
                class: ["ck-balloon-rotator__navigation", n.to("isNavigationVisible", function (t) {
                  return t ? "" : "ck-hidden";
                })]
              },
              children: [_this137.buttonPrevView, {
                tag: "span",
                attributes: {
                  class: ["ck-balloon-rotator__counter"]
                },
                children: [{
                  text: n.to("counter")
                }]
              }, _this137.buttonNextView]
            }, {
              tag: "div",
              attributes: {
                class: "ck-balloon-rotator__content"
              },
              children: _this137.content
            }]
          });
          return _this137;
        }

        _createClass(Eu, [{
          key: "render",
          value: function render() {
            _get(_getPrototypeOf(Eu.prototype), "render", this).call(this), this.focusTracker.add(this.element);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            _get(_getPrototypeOf(Eu.prototype), "destroy", this).call(this), this.focusTracker.destroy();
          }
        }, {
          key: "showView",
          value: function showView(t) {
            this.hideView(), this.content.add(t);
          }
        }, {
          key: "hideView",
          value: function hideView() {
            this.content.clear();
          }
        }, {
          key: "_createButtonView",
          value: function _createButtonView(t, e) {
            var n = new oh(this.locale);
            return n.set({
              label: t,
              icon: e,
              tooltip: !0
            }), n;
          }
        }]);

        return Eu;
      }(Dd);

      var Du = /*#__PURE__*/function (_Dd21) {
        _inherits(Du, _Dd21);

        var _super73 = _createSuper(Du);

        function Du(t, e) {
          var _this138;

          _classCallCheck(this, Du);

          _this138 = _super73.call(this, t);
          var n = _this138.bindTemplate;
          _this138.set("top", 0), _this138.set("left", 0), _this138.set("height", 0), _this138.set("width", 0), _this138.set("numberOfPanels", 0), _this138.content = _this138.createCollection(), _this138._balloonPanelView = e, _this138.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck-fake-panel", n.to("numberOfPanels", function (t) {
                return t ? "" : "ck-hidden";
              })],
              style: {
                top: n.to("top", yu),
                left: n.to("left", yu),
                width: n.to("width", yu),
                height: n.to("height", yu)
              }
            },
            children: _this138.content
          }), _this138.on("change:numberOfPanels", function (t, e, n, i) {
            n > i ? _this138._addPanels(n - i) : _this138._removePanels(i - n), _this138.updatePosition();
          });
          return _this138;
        }

        _createClass(Du, [{
          key: "_addPanels",
          value: function _addPanels(t) {
            for (; t--;) {
              var _t218 = new Dd();

              _t218.setTemplate({
                tag: "div"
              }), this.content.add(_t218), this.registerChild(_t218);
            }
          }
        }, {
          key: "_removePanels",
          value: function _removePanels(t) {
            for (; t--;) {
              var _t219 = this.content.last;
              this.content.remove(_t219), this.deregisterChild(_t219), _t219.destroy();
            }
          }
        }, {
          key: "updatePosition",
          value: function updatePosition() {
            if (this.numberOfPanels) {
              var _this$_balloonPanelVi = this._balloonPanelView,
                  _t220 = _this$_balloonPanelVi.top,
                  _e215 = _this$_balloonPanelVi.left,
                  _ma = new ma(this._balloonPanelView.element),
                  _n185 = _ma.width,
                  _i140 = _ma.height;

              Object.assign(this, {
                top: _t220,
                left: _e215,
                width: _n185,
                height: _i140
              });
            }
          }
        }]);

        return Du;
      }(Dd);

      var Su = n(4285),
          Iu = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Su.Z, Iu), Su.Z.locals;
      var Mu = gu("px");

      var Tu = /*#__PURE__*/function (_Dd22) {
        _inherits(Tu, _Dd22);

        var _super74 = _createSuper(Tu);

        function Tu(t) {
          var _this139;

          _classCallCheck(this, Tu);

          _this139 = _super74.call(this, t);
          var e = _this139.bindTemplate;
          _this139.set("isActive", !1), _this139.set("isSticky", !1), _this139.set("limiterElement", null), _this139.set("limiterBottomOffset", 50), _this139.set("viewportTopOffset", 0), _this139.set("_marginLeft", null), _this139.set("_isStickyToTheLimiter", !1), _this139.set("_hasViewportTopOffset", !1), _this139.content = _this139.createCollection(), _this139._contentPanelPlaceholder = new Sd({
            tag: "div",
            attributes: {
              class: ["ck", "ck-sticky-panel__placeholder"],
              style: {
                display: e.to("isSticky", function (t) {
                  return t ? "block" : "none";
                }),
                height: e.to("isSticky", function (t) {
                  return t ? Mu(_this139._panelRect.height) : null;
                })
              }
            }
          }).render(), _this139._contentPanel = new Sd({
            tag: "div",
            attributes: {
              class: ["ck", "ck-sticky-panel__content", e.if("isSticky", "ck-sticky-panel__content_sticky"), e.if("_isStickyToTheLimiter", "ck-sticky-panel__content_sticky_bottom-limit")],
              style: {
                width: e.to("isSticky", function (t) {
                  return t ? Mu(_this139._contentPanelPlaceholder.getBoundingClientRect().width) : null;
                }),
                top: e.to("_hasViewportTopOffset", function (t) {
                  return t ? Mu(_this139.viewportTopOffset) : null;
                }),
                bottom: e.to("_isStickyToTheLimiter", function (t) {
                  return t ? Mu(_this139.limiterBottomOffset) : null;
                }),
                marginLeft: e.to("_marginLeft")
              }
            },
            children: _this139.content
          }).render(), _this139.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-sticky-panel"]
            },
            children: [_this139._contentPanelPlaceholder, _this139._contentPanel]
          });
          return _this139;
        }

        _createClass(Tu, [{
          key: "render",
          value: function render() {
            var _this140 = this;

            _get(_getPrototypeOf(Tu.prototype), "render", this).call(this), this._checkIfShouldBeSticky(), this.listenTo(os.window, "scroll", function () {
              _this140._checkIfShouldBeSticky();
            }), this.listenTo(this, "change:isActive", function () {
              _this140._checkIfShouldBeSticky();
            });
          }
        }, {
          key: "_checkIfShouldBeSticky",
          value: function _checkIfShouldBeSticky() {
            var t = this._panelRect = this._contentPanel.getBoundingClientRect();

            var e;
            this.limiterElement ? (e = this._limiterRect = this.limiterElement.getBoundingClientRect(), this.isSticky = this.isActive && e.top < this.viewportTopOffset && this._panelRect.height + this.limiterBottomOffset < e.height) : this.isSticky = !1, this.isSticky ? (this._isStickyToTheLimiter = e.bottom < t.height + this.limiterBottomOffset + this.viewportTopOffset, this._hasViewportTopOffset = !this._isStickyToTheLimiter && !!this.viewportTopOffset, this._marginLeft = this._isStickyToTheLimiter ? null : Mu(-os.window.scrollX)) : (this._isStickyToTheLimiter = !1, this._hasViewportTopOffset = !1, this._marginLeft = null);
          }
        }]);

        return Tu;
      }(Dd);

      gu("px");
      var Nu = n(2503),
          Bu = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Nu.Z, Bu), Nu.Z.locals;
      gu("px");
      gu("px");
      var zu = n(1314),
          Pu = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(zu.Z, Pu), zu.Z.locals;
      var Lu = new WeakMap();

      function Ru(t) {
        var e = t.view,
            n = t.element,
            i = t.text,
            _t$isDirectHost = t.isDirectHost,
            o = _t$isDirectHost === void 0 ? !0 : _t$isDirectHost,
            _t$keepOnFocus = t.keepOnFocus,
            r = _t$keepOnFocus === void 0 ? !1 : _t$keepOnFocus,
            s = e.document;
        Lu.has(s) || (Lu.set(s, new Map()), s.registerPostFixer(function (t) {
          return ju(s, t);
        })), Lu.get(s).set(n, {
          text: i,
          isDirectHost: o,
          keepOnFocus: r,
          hostElement: o ? n : null
        }), e.change(function (t) {
          return ju(s, t);
        });
      }

      function Ou(t, e) {
        return !!e.hasClass("ck-placeholder") && (t.removeClass("ck-placeholder", e), !0);
      }

      function ju(t, e) {
        var n = Lu.get(t),
            i = [];
        var o = !1;

        var _iterator301 = _createForOfIteratorHelper(n),
            _step301;

        try {
          for (_iterator301.s(); !(_step301 = _iterator301.n()).done;) {
            var _step301$value = _slicedToArray(_step301.value, 2),
                _t221 = _step301$value[0],
                _r37 = _step301$value[1];

            _r37.isDirectHost && (i.push(_t221), Fu(e, _t221, _r37) && (o = !0));
          }
        } catch (err) {
          _iterator301.e(err);
        } finally {
          _iterator301.f();
        }

        var _iterator302 = _createForOfIteratorHelper(n),
            _step302;

        try {
          for (_iterator302.s(); !(_step302 = _iterator302.n()).done;) {
            var _step302$value = _slicedToArray(_step302.value, 2),
                _t222 = _step302$value[0],
                _r38 = _step302$value[1];

            if (_r38.isDirectHost) continue;

            var _n186 = Vu(_t222);

            _n186 && (i.includes(_n186) || (_r38.hostElement = _n186, Fu(e, _t222, _r38) && (o = !0)));
          }
        } catch (err) {
          _iterator302.e(err);
        } finally {
          _iterator302.f();
        }

        return o;
      }

      function Fu(t, e, n) {
        var i = n.text,
            o = n.isDirectHost,
            r = n.hostElement;
        var s = !1;
        r.getAttribute("data-placeholder") !== i && (t.setAttribute("data-placeholder", i, r), s = !0);
        return (o || 1 == e.childCount) && function (t, e) {
          if (!t.isAttached()) return !1;
          var n = Array.from(t.getChildren()).some(function (t) {
            return !t.is("uiElement");
          });
          if (n) return !1;
          if (e) return !0;
          var i = t.document;
          if (!i.isFocused) return !0;
          var o = i.selection.anchor;
          return o && o.parent !== t;
        }(r, n.keepOnFocus) ? function (t, e) {
          return !e.hasClass("ck-placeholder") && (t.addClass("ck-placeholder", e), !0);
        }(t, r) && (s = !0) : Ou(t, r) && (s = !0), s;
      }

      function Vu(t) {
        if (t.childCount) {
          var _e216 = t.getChild(0);

          if (_e216.is("element") && !_e216.is("uiElement")) return _e216;
        }

        return null;
      }

      var Uu = new Map();

      function Hu(t, e, n) {
        var i = Uu.get(t);
        i || (i = new Map(), Uu.set(t, i)), i.set(e, n);
      }

      function qu(t) {
        return [t];
      }

      function Wu(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        var i = function (t, e) {
          var n = Uu.get(t);
          return n && n.has(e) ? n.get(e) : qu;
        }(t.constructor, e.constructor);

        try {
          return i(t = t.clone(), e, n);
        } catch (t) {
          throw t;
        }
      }

      function Gu(t, e, n) {
        t = t.slice(), e = e.slice();
        var i = new $u(n.document, n.useRelations, n.forceWeakRemove);
        i.setOriginalOperations(t), i.setOriginalOperations(e);
        var o = i.originalOperations;
        if (0 == t.length || 0 == e.length) return {
          operationsA: t,
          operationsB: e,
          originalOperations: o
        };
        var r = new WeakMap();

        var _iterator303 = _createForOfIteratorHelper(t),
            _step303;

        try {
          for (_iterator303.s(); !(_step303 = _iterator303.n()).done;) {
            var _e218 = _step303.value;
            r.set(_e218, 0);
          }
        } catch (err) {
          _iterator303.e(err);
        } finally {
          _iterator303.f();
        }

        var s = {
          nextBaseVersionA: t[t.length - 1].baseVersion + 1,
          nextBaseVersionB: e[e.length - 1].baseVersion + 1,
          originalOperationsACount: t.length,
          originalOperationsBCount: e.length
        };
        var a = 0;

        for (; a < t.length;) {
          var _t223, _e217;

          var _n187 = t[a],
              _o74 = r.get(_n187);

          if (_o74 == e.length) {
            a++;
            continue;
          }

          var _s24 = e[_o74],
              _c6 = Wu(_n187, _s24, i.getContext(_n187, _s24, !0)),
              _l2 = Wu(_s24, _n187, i.getContext(_s24, _n187, !1));

          i.updateRelation(_n187, _s24), i.setOriginalOperations(_c6, _n187), i.setOriginalOperations(_l2, _s24);

          var _iterator304 = _createForOfIteratorHelper(_c6),
              _step304;

          try {
            for (_iterator304.s(); !(_step304 = _iterator304.n()).done;) {
              var _t224 = _step304.value;
              r.set(_t224, _o74 + _l2.length);
            }
          } catch (err) {
            _iterator304.e(err);
          } finally {
            _iterator304.f();
          }

          (_t223 = t).splice.apply(_t223, [a, 1].concat(_toConsumableArray(_c6))), (_e217 = e).splice.apply(_e217, [_o74, 1].concat(_toConsumableArray(_l2)));
        }

        if (n.padWithNoOps) {
          var _n188 = t.length - s.originalOperationsACount,
              _i141 = e.length - s.originalOperationsBCount;

          Ku(t, _i141 - _n188), Ku(e, _n188 - _i141);
        }

        return Yu(t, s.nextBaseVersionB), Yu(e, s.nextBaseVersionA), {
          operationsA: t,
          operationsB: e,
          originalOperations: o
        };
      }

      var $u = /*#__PURE__*/function () {
        function $u(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;

          _classCallCheck(this, $u);

          this.originalOperations = new Map(), this._history = t.history, this._useRelations = e, this._forceWeakRemove = !!n, this._relations = new Map();
        }

        _createClass($u, [{
          key: "setOriginalOperations",
          value: function setOriginalOperations(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var n = e ? this.originalOperations.get(e) : null;

            var _iterator305 = _createForOfIteratorHelper(t),
                _step305;

            try {
              for (_iterator305.s(); !(_step305 = _iterator305.n()).done;) {
                var _e219 = _step305.value;
                this.originalOperations.set(_e219, n || _e219);
              }
            } catch (err) {
              _iterator305.e(err);
            } finally {
              _iterator305.f();
            }
          }
        }, {
          key: "updateRelation",
          value: function updateRelation(t, e) {
            switch (t.constructor) {
              case pl:
                switch (e.constructor) {
                  case Al:
                    t.targetPosition.isEqual(e.sourcePosition) || e.movedRange.containsPosition(t.targetPosition) ? this._setRelation(t, e, "insertAtSource") : t.targetPosition.isEqual(e.deletionPosition) ? this._setRelation(t, e, "insertBetween") : t.targetPosition.isAfter(e.sourcePosition) && this._setRelation(t, e, "moveTargetAfter");
                    break;

                  case pl:
                    t.targetPosition.isEqual(e.sourcePosition) || t.targetPosition.isBefore(e.sourcePosition) ? this._setRelation(t, e, "insertBefore") : this._setRelation(t, e, "insertAfter");
                }

                break;

              case Cl:
                switch (e.constructor) {
                  case Al:
                    t.splitPosition.isBefore(e.sourcePosition) && this._setRelation(t, e, "splitBefore");
                    break;

                  case pl:
                    if (t.splitPosition.isEqual(e.sourcePosition) || t.splitPosition.isBefore(e.sourcePosition)) this._setRelation(t, e, "splitBefore");else {
                      var _n189 = Wa._createFromPositionAndShift(e.sourcePosition, e.howMany);

                      if (t.splitPosition.hasSameParentAs(e.sourcePosition) && _n189.containsPosition(t.splitPosition)) {
                        var _i142 = _n189.end.offset - t.splitPosition.offset,
                            _o75 = t.splitPosition.offset - _n189.start.offset;

                        this._setRelation(t, e, {
                          howMany: _i142,
                          offset: _o75
                        });
                      }
                    }
                }

                break;

              case Al:
                switch (e.constructor) {
                  case Al:
                    t.targetPosition.isEqual(e.sourcePosition) || this._setRelation(t, e, "mergeTargetNotMoved"), t.sourcePosition.isEqual(e.targetPosition) && this._setRelation(t, e, "mergeSourceNotMoved"), t.sourcePosition.isEqual(e.sourcePosition) && this._setRelation(t, e, "mergeSameElement");
                    break;

                  case Cl:
                    t.sourcePosition.isEqual(e.splitPosition) && this._setRelation(t, e, "splitAtSource");
                }

                break;

              case kl:
                {
                  var _n190 = t.newRange;
                  if (!_n190) return;

                  switch (e.constructor) {
                    case pl:
                      {
                        var _i143 = Wa._createFromPositionAndShift(e.sourcePosition, e.howMany),
                            _o76 = _i143.containsPosition(_n190.start) || _i143.start.isEqual(_n190.start),
                            _r39 = _i143.containsPosition(_n190.end) || _i143.end.isEqual(_n190.end);

                        !_o76 && !_r39 || _i143.containsRange(_n190) || this._setRelation(t, e, {
                          side: _o76 ? "left" : "right",
                          path: _o76 ? _n190.start.path.slice() : _n190.end.path.slice()
                        });
                        break;
                      }

                    case Al:
                      {
                        var _i144 = _n190.start.isEqual(e.targetPosition),
                            _o77 = _n190.start.isEqual(e.deletionPosition),
                            _r40 = _n190.end.isEqual(e.deletionPosition),
                            _s25 = _n190.end.isEqual(e.sourcePosition);

                        (_i144 || _o77 || _r40 || _s25) && this._setRelation(t, e, {
                          wasInLeftElement: _i144,
                          wasStartBeforeMergedElement: _o77,
                          wasEndBeforeMergedElement: _r40,
                          wasInRightElement: _s25
                        });
                        break;
                      }
                  }

                  break;
                }
            }
          }
        }, {
          key: "getContext",
          value: function getContext(t, e, n) {
            return {
              aIsStrong: n,
              aWasUndone: this._wasUndone(t),
              bWasUndone: this._wasUndone(e),
              abRelation: this._useRelations ? this._getRelation(t, e) : null,
              baRelation: this._useRelations ? this._getRelation(e, t) : null,
              forceWeakRemove: this._forceWeakRemove
            };
          }
        }, {
          key: "_wasUndone",
          value: function _wasUndone(t) {
            var e = this.originalOperations.get(t);
            return e.wasUndone || this._history.isUndoneOperation(e);
          }
        }, {
          key: "_getRelation",
          value: function _getRelation(t, e) {
            var n = this.originalOperations.get(e),
                i = this._history.getUndoneOperation(n);

            if (!i) return null;

            var o = this.originalOperations.get(t),
                r = this._relations.get(o);

            return r && r.get(i) || null;
          }
        }, {
          key: "_setRelation",
          value: function _setRelation(t, e, n) {
            var i = this.originalOperations.get(t),
                o = this.originalOperations.get(e);

            var r = this._relations.get(i);

            r || (r = new Map(), this._relations.set(i, r)), r.set(o, n);
          }
        }]);

        return $u;
      }();

      function Yu(t, e) {
        var _iterator306 = _createForOfIteratorHelper(t),
            _step306;

        try {
          for (_iterator306.s(); !(_step306 = _iterator306.n()).done;) {
            var _n191 = _step306.value;
            _n191.baseVersion = e++;
          }
        } catch (err) {
          _iterator306.e(err);
        } finally {
          _iterator306.f();
        }
      }

      function Ku(t, e) {
        for (var _n192 = 0; _n192 < e; _n192++) {
          t.push(new Vl(0));
        }
      }

      function Qu(t, e, n) {
        var i = t.nodes.getNode(0).getAttribute(e);
        if (i == n) return null;
        var o = new Wa(t.position, t.position.getShiftedBy(t.howMany));
        return new gl(o, e, i, n, 0);
      }

      function Zu(t, e) {
        return null === t.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany);
      }

      function Ju(t, e) {
        var n = [];

        for (var _i145 = 0; _i145 < t.length; _i145++) {
          var _o78 = t[_i145],
              _r41 = new pl(_o78.start, _o78.end.offset - _o78.start.offset, e, 0);

          n.push(_r41);

          for (var _e220 = _i145 + 1; _e220 < t.length; _e220++) {
            t[_e220] = t[_e220]._getTransformedByMove(_r41.sourcePosition, _r41.targetPosition, _r41.howMany)[0];
          }

          e = e._getTransformedByMove(_r41.sourcePosition, _r41.targetPosition, _r41.howMany);
        }

        return n;
      }

      Hu(gl, gl, function (t, e, n) {
        if (t.key === e.key && t.range.start.hasSameParentAs(e.range.start)) {
          var _i146 = t.range.getDifference(e.range).map(function (e) {
            return new gl(e, t.key, t.oldValue, t.newValue, 0);
          }),
              _o79 = t.range.getIntersection(e.range);

          return _o79 && n.aIsStrong && _i146.push(new gl(_o79, e.key, e.newValue, t.newValue, 0)), 0 == _i146.length ? [new Vl(0)] : _i146;
        }

        return [t];
      }), Hu(gl, fl, function (t, e) {
        if (t.range.start.hasSameParentAs(e.position) && t.range.containsPosition(e.position)) {
          var _n193 = t.range._getTransformedByInsertion(e.position, e.howMany, !e.shouldReceiveAttributes).map(function (e) {
            return new gl(e, t.key, t.oldValue, t.newValue, t.baseVersion);
          });

          if (e.shouldReceiveAttributes) {
            var _i147 = Qu(e, t.key, t.oldValue);

            _i147 && _n193.unshift(_i147);
          }

          return _n193;
        }

        return t.range = t.range._getTransformedByInsertion(e.position, e.howMany, !1)[0], [t];
      }), Hu(gl, Al, function (t, e) {
        var n = [];
        t.range.start.hasSameParentAs(e.deletionPosition) && (t.range.containsPosition(e.deletionPosition) || t.range.start.isEqual(e.deletionPosition)) && n.push(Wa._createFromPositionAndShift(e.graveyardPosition, 1));

        var i = t.range._getTransformedByMergeOperation(e);

        return i.isCollapsed || n.push(i), n.map(function (e) {
          return new gl(e, t.key, t.oldValue, t.newValue, t.baseVersion);
        });
      }), Hu(gl, pl, function (t, e) {
        var n = function (t, e) {
          var n = Wa._createFromPositionAndShift(e.sourcePosition, e.howMany);

          var i = null,
              o = [];
          n.containsRange(t, !0) ? i = t : t.start.hasSameParentAs(n.start) ? (o = t.getDifference(n), i = t.getIntersection(n)) : o = [t];
          var r = [];

          var _iterator307 = _createForOfIteratorHelper(o),
              _step307;

          try {
            for (_iterator307.s(); !(_step307 = _iterator307.n()).done;) {
              var _t225 = _step307.value;
              _t225 = _t225._getTransformedByDeletion(e.sourcePosition, e.howMany);

              var _n194 = e.getMovedRangeStart(),
                  _i148 = _t225.start.hasSameParentAs(_n194);

              _t225 = _t225._getTransformedByInsertion(_n194, e.howMany, _i148), r.push.apply(r, _toConsumableArray(_t225));
            }
          } catch (err) {
            _iterator307.e(err);
          } finally {
            _iterator307.f();
          }

          i && r.push(i._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany, !1)[0]);
          return r;
        }(t.range, e);

        return n.map(function (e) {
          return new gl(e, t.key, t.oldValue, t.newValue, t.baseVersion);
        });
      }), Hu(gl, Cl, function (t, e) {
        if (t.range.end.isEqual(e.insertionPosition)) return e.graveyardPosition || t.range.end.offset++, [t];

        if (t.range.start.hasSameParentAs(e.splitPosition) && t.range.containsPosition(e.splitPosition)) {
          var _n195 = t.clone();

          return _n195.range = new Wa(e.moveTargetPosition.clone(), t.range.end._getCombined(e.splitPosition, e.moveTargetPosition)), t.range.end = e.splitPosition.clone(), t.range.end.stickiness = "toPrevious", [t, _n195];
        }

        return t.range = t.range._getTransformedBySplitOperation(e), [t];
      }), Hu(fl, gl, function (t, e) {
        var n = [t];

        if (t.shouldReceiveAttributes && t.position.hasSameParentAs(e.range.start) && e.range.containsPosition(t.position)) {
          var _i149 = Qu(t, e.key, e.newValue);

          _i149 && n.push(_i149);
        }

        return n;
      }), Hu(fl, fl, function (t, e, n) {
        return t.position.isEqual(e.position) && n.aIsStrong || (t.position = t.position._getTransformedByInsertOperation(e)), [t];
      }), Hu(fl, pl, function (t, e) {
        return t.position = t.position._getTransformedByMoveOperation(e), [t];
      }), Hu(fl, Cl, function (t, e) {
        return t.position = t.position._getTransformedBySplitOperation(e), [t];
      }), Hu(fl, Al, function (t, e) {
        return t.position = t.position._getTransformedByMergeOperation(e), [t];
      }), Hu(kl, fl, function (t, e) {
        return t.oldRange && (t.oldRange = t.oldRange._getTransformedByInsertOperation(e)[0]), t.newRange && (t.newRange = t.newRange._getTransformedByInsertOperation(e)[0]), [t];
      }), Hu(kl, kl, function (t, e, n) {
        if (t.name == e.name) {
          if (!n.aIsStrong) return [new Vl(0)];
          t.oldRange = e.newRange ? e.newRange.clone() : null;
        }

        return [t];
      }), Hu(kl, Al, function (t, e) {
        return t.oldRange && (t.oldRange = t.oldRange._getTransformedByMergeOperation(e)), t.newRange && (t.newRange = t.newRange._getTransformedByMergeOperation(e)), [t];
      }), Hu(kl, pl, function (t, e, n) {
        if (t.oldRange && (t.oldRange = Wa._createFromRanges(t.oldRange._getTransformedByMoveOperation(e))), t.newRange) {
          if (n.abRelation) {
            var _i150 = Wa._createFromRanges(t.newRange._getTransformedByMoveOperation(e));

            if ("left" == n.abRelation.side && e.targetPosition.isEqual(t.newRange.start)) return t.newRange.start.path = n.abRelation.path, t.newRange.end = _i150.end, [t];
            if ("right" == n.abRelation.side && e.targetPosition.isEqual(t.newRange.end)) return t.newRange.start = _i150.start, t.newRange.end.path = n.abRelation.path, [t];
          }

          t.newRange = Wa._createFromRanges(t.newRange._getTransformedByMoveOperation(e));
        }

        return [t];
      }), Hu(kl, Cl, function (t, e, n) {
        if (t.oldRange && (t.oldRange = t.oldRange._getTransformedBySplitOperation(e)), t.newRange) {
          if (n.abRelation) {
            var _i151 = t.newRange._getTransformedBySplitOperation(e);

            return t.newRange.start.isEqual(e.splitPosition) && n.abRelation.wasStartBeforeMergedElement ? t.newRange.start = Va._createAt(e.insertionPosition) : t.newRange.start.isEqual(e.splitPosition) && !n.abRelation.wasInLeftElement && (t.newRange.start = Va._createAt(e.moveTargetPosition)), t.newRange.end.isEqual(e.splitPosition) && n.abRelation.wasInRightElement ? t.newRange.end = Va._createAt(e.moveTargetPosition) : t.newRange.end.isEqual(e.splitPosition) && n.abRelation.wasEndBeforeMergedElement ? t.newRange.end = Va._createAt(e.insertionPosition) : t.newRange.end = _i151.end, [t];
          }

          t.newRange = t.newRange._getTransformedBySplitOperation(e);
        }

        return [t];
      }), Hu(Al, fl, function (t, e) {
        return t.sourcePosition.hasSameParentAs(e.position) && (t.howMany += e.howMany), t.sourcePosition = t.sourcePosition._getTransformedByInsertOperation(e), t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e), [t];
      }), Hu(Al, Al, function (t, e, n) {
        if (t.sourcePosition.isEqual(e.sourcePosition) && t.targetPosition.isEqual(e.targetPosition)) {
          if (n.bWasUndone) {
            var _n196 = e.graveyardPosition.path.slice();

            return _n196.push(0), t.sourcePosition = new Va(e.graveyardPosition.root, _n196), t.howMany = 0, [t];
          }

          return [new Vl(0)];
        }

        if (t.sourcePosition.isEqual(e.sourcePosition) && !t.targetPosition.isEqual(e.targetPosition) && !n.bWasUndone && "splitAtSource" != n.abRelation) {
          var _i152 = "$graveyard" == t.targetPosition.root.rootName,
              _o80 = "$graveyard" == e.targetPosition.root.rootName,
              _r42 = _i152 && !_o80;

          if (_o80 && !_i152 || !_r42 && n.aIsStrong) {
            var _n197 = e.targetPosition._getTransformedByMergeOperation(e),
                _i153 = t.targetPosition._getTransformedByMergeOperation(e);

            return [new pl(_n197, t.howMany, _i153, 0)];
          }

          return [new Vl(0)];
        }

        return t.sourcePosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.sourcePosition = t.sourcePosition._getTransformedByMergeOperation(e), t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), t.graveyardPosition.isEqual(e.graveyardPosition) && n.aIsStrong || (t.graveyardPosition = t.graveyardPosition._getTransformedByMergeOperation(e)), [t];
      }), Hu(Al, pl, function (t, e, n) {
        var i = Wa._createFromPositionAndShift(e.sourcePosition, e.howMany);

        return "remove" == e.type && !n.bWasUndone && !n.forceWeakRemove && t.deletionPosition.hasSameParentAs(e.sourcePosition) && i.containsPosition(t.sourcePosition) ? [new Vl(0)] : (t.sourcePosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.sourcePosition.hasSameParentAs(e.sourcePosition) && (t.howMany -= e.howMany), t.sourcePosition = t.sourcePosition._getTransformedByMoveOperation(e), t.targetPosition = t.targetPosition._getTransformedByMoveOperation(e), t.graveyardPosition.isEqual(e.targetPosition) || (t.graveyardPosition = t.graveyardPosition._getTransformedByMoveOperation(e)), [t]);
      }), Hu(Al, Cl, function (t, e, n) {
        if (e.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedByDeletion(e.graveyardPosition, 1), t.deletionPosition.isEqual(e.graveyardPosition) && (t.howMany = e.howMany)), t.targetPosition.isEqual(e.splitPosition)) {
          var _i154 = 0 != e.howMany,
              _o81 = e.graveyardPosition && t.deletionPosition.isEqual(e.graveyardPosition);

          if (_i154 || _o81 || "mergeTargetNotMoved" == n.abRelation) return t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e), [t];
        }

        if (t.sourcePosition.isEqual(e.splitPosition)) {
          if ("mergeSourceNotMoved" == n.abRelation) return t.howMany = 0, t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
          if ("mergeSameElement" == n.abRelation || t.sourcePosition.offset > 0) return t.sourcePosition = e.moveTargetPosition.clone(), t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
        }

        return t.sourcePosition.hasSameParentAs(e.splitPosition) && (t.howMany = e.splitPosition.offset), t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e), t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
      }), Hu(pl, fl, function (t, e) {
        var n = Wa._createFromPositionAndShift(t.sourcePosition, t.howMany)._getTransformedByInsertOperation(e, !1)[0];

        return t.sourcePosition = n.start, t.howMany = n.end.offset - n.start.offset, t.targetPosition.isEqual(e.position) || (t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e)), [t];
      }), Hu(pl, pl, function (t, e, n) {
        var i = Wa._createFromPositionAndShift(t.sourcePosition, t.howMany),
            o = Wa._createFromPositionAndShift(e.sourcePosition, e.howMany);

        var r,
            s = n.aIsStrong,
            a = !n.aIsStrong;
        if ("insertBefore" == n.abRelation || "insertAfter" == n.baRelation ? a = !0 : "insertAfter" != n.abRelation && "insertBefore" != n.baRelation || (a = !1), r = t.targetPosition.isEqual(e.targetPosition) && a ? t.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany) : t.targetPosition._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), Zu(t, e) && Zu(e, t)) return [e.getReversed()];
        if (i.containsPosition(e.targetPosition) && i.containsRange(o, !0)) return i.start = i.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), i.end = i.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), Ju([i], r);
        if (o.containsPosition(t.targetPosition) && o.containsRange(i, !0)) return i.start = i.start._getCombined(e.sourcePosition, e.getMovedRangeStart()), i.end = i.end._getCombined(e.sourcePosition, e.getMovedRangeStart()), Ju([i], r);
        var c = Li(t.sourcePosition.getParentPath(), e.sourcePosition.getParentPath());
        if ("prefix" == c || "extension" == c) return i.start = i.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), i.end = i.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), Ju([i], r);
        "remove" != t.type || "remove" == e.type || n.aWasUndone || n.forceWeakRemove ? "remove" == t.type || "remove" != e.type || n.bWasUndone || n.forceWeakRemove || (s = !1) : s = !0;
        var l = [],
            d = i.getDifference(o);

        var _iterator308 = _createForOfIteratorHelper(d),
            _step308;

        try {
          for (_iterator308.s(); !(_step308 = _iterator308.n()).done;) {
            var _t226 = _step308.value;
            _t226.start = _t226.start._getTransformedByDeletion(e.sourcePosition, e.howMany), _t226.end = _t226.end._getTransformedByDeletion(e.sourcePosition, e.howMany);

            var _n198 = "same" == Li(_t226.start.getParentPath(), e.getMovedRangeStart().getParentPath()),
                _i155 = _t226._getTransformedByInsertion(e.getMovedRangeStart(), e.howMany, _n198);

            l.push.apply(l, _toConsumableArray(_i155));
          }
        } catch (err) {
          _iterator308.e(err);
        } finally {
          _iterator308.f();
        }

        var h = i.getIntersection(o);
        return null !== h && s && (h.start = h.start._getCombined(e.sourcePosition, e.getMovedRangeStart()), h.end = h.end._getCombined(e.sourcePosition, e.getMovedRangeStart()), 0 === l.length ? l.push(h) : 1 == l.length ? o.start.isBefore(i.start) || o.start.isEqual(i.start) ? l.unshift(h) : l.push(h) : l.splice(1, 0, h)), 0 === l.length ? [new Vl(t.baseVersion)] : Ju(l, r);
      }), Hu(pl, Cl, function (t, e, n) {
        var i = t.targetPosition.clone();
        t.targetPosition.isEqual(e.insertionPosition) && e.graveyardPosition && "moveTargetAfter" != n.abRelation || (i = t.targetPosition._getTransformedBySplitOperation(e));

        var o = Wa._createFromPositionAndShift(t.sourcePosition, t.howMany);

        if (o.end.isEqual(e.insertionPosition)) return e.graveyardPosition || t.howMany++, t.targetPosition = i, [t];

        if (o.start.hasSameParentAs(e.splitPosition) && o.containsPosition(e.splitPosition)) {
          var _t227 = new Wa(e.splitPosition, o.end);

          _t227 = _t227._getTransformedBySplitOperation(e);
          return Ju([new Wa(o.start, e.splitPosition), _t227], i);
        }

        t.targetPosition.isEqual(e.splitPosition) && "insertAtSource" == n.abRelation && (i = e.moveTargetPosition), t.targetPosition.isEqual(e.insertionPosition) && "insertBetween" == n.abRelation && (i = t.targetPosition);
        var r = [o._getTransformedBySplitOperation(e)];

        if (e.graveyardPosition) {
          var _i156 = o.start.isEqual(e.graveyardPosition) || o.containsPosition(e.graveyardPosition);

          t.howMany > 1 && _i156 && !n.aWasUndone && r.push(Wa._createFromPositionAndShift(e.insertionPosition, 1));
        }

        return Ju(r, i);
      }), Hu(pl, Al, function (t, e, n) {
        var i = Wa._createFromPositionAndShift(t.sourcePosition, t.howMany);

        if (e.deletionPosition.hasSameParentAs(t.sourcePosition) && i.containsPosition(e.sourcePosition)) if ("remove" != t.type || n.forceWeakRemove) {
          if (1 == t.howMany) return n.bWasUndone ? (t.sourcePosition = e.graveyardPosition.clone(), t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), [t]) : [new Vl(0)];
        } else if (!n.aWasUndone) {
          var _n199 = [];

          var _i157 = e.graveyardPosition.clone(),
              _o82 = e.targetPosition._getTransformedByMergeOperation(e);

          t.howMany > 1 && (_n199.push(new pl(t.sourcePosition, t.howMany - 1, t.targetPosition, 0)), _i157 = _i157._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany - 1), _o82 = _o82._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany - 1));

          var _r43 = e.deletionPosition._getCombined(t.sourcePosition, t.targetPosition),
              _s26 = new pl(_i157, 1, _r43, 0),
              _a14 = _s26.getMovedRangeStart().path.slice();

          _a14.push(0);

          var _c7 = new Va(_s26.targetPosition.root, _a14);

          _o82 = _o82._getTransformedByMove(_i157, _r43, 1);

          var _l3 = new pl(_o82, e.howMany, _c7, 0);

          return _n199.push(_s26), _n199.push(_l3), _n199;
        }

        var o = Wa._createFromPositionAndShift(t.sourcePosition, t.howMany)._getTransformedByMergeOperation(e);

        return t.sourcePosition = o.start, t.howMany = o.end.offset - o.start.offset, t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), [t];
      }), Hu(bl, fl, function (t, e) {
        return t.position = t.position._getTransformedByInsertOperation(e), [t];
      }), Hu(bl, Al, function (t, e) {
        return t.position.isEqual(e.deletionPosition) ? (t.position = e.graveyardPosition.clone(), t.position.stickiness = "toNext", [t]) : (t.position = t.position._getTransformedByMergeOperation(e), [t]);
      }), Hu(bl, pl, function (t, e) {
        return t.position = t.position._getTransformedByMoveOperation(e), [t];
      }), Hu(bl, bl, function (t, e, n) {
        if (t.position.isEqual(e.position)) {
          if (!n.aIsStrong) return [new Vl(0)];
          t.oldName = e.newName;
        }

        return [t];
      }), Hu(bl, Cl, function (t, e) {
        if ("same" == Li(t.position.path, e.splitPosition.getParentPath()) && !e.graveyardPosition) {
          var _e221 = new bl(t.position.getShiftedBy(1), t.oldName, t.newName, 0);

          return [t, _e221];
        }

        return t.position = t.position._getTransformedBySplitOperation(e), [t];
      }), Hu(wl, wl, function (t, e, n) {
        if (t.root === e.root && t.key === e.key) {
          if (!n.aIsStrong || t.newValue === e.newValue) return [new Vl(0)];
          t.oldValue = e.newValue;
        }

        return [t];
      }), Hu(Cl, fl, function (t, e) {
        return t.splitPosition.hasSameParentAs(e.position) && t.splitPosition.offset < e.position.offset && (t.howMany += e.howMany), t.splitPosition = t.splitPosition._getTransformedByInsertOperation(e), t.insertionPosition = t.insertionPosition._getTransformedByInsertOperation(e), [t];
      }), Hu(Cl, Al, function (t, e, n) {
        if (!t.graveyardPosition && !n.bWasUndone && t.splitPosition.hasSameParentAs(e.sourcePosition)) {
          var _n200 = e.graveyardPosition.path.slice();

          _n200.push(0);

          var _i158 = new Va(e.graveyardPosition.root, _n200),
              _o83 = Cl.getInsertionPosition(new Va(e.graveyardPosition.root, _n200)),
              _r44 = new Cl(_i158, 0, _o83, null, 0);

          return t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e), t.insertionPosition = Cl.getInsertionPosition(t.splitPosition), t.graveyardPosition = _r44.insertionPosition.clone(), t.graveyardPosition.stickiness = "toNext", [_r44, t];
        }

        return t.splitPosition.hasSameParentAs(e.deletionPosition) && !t.splitPosition.isAfter(e.deletionPosition) && t.howMany--, t.splitPosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e), t.insertionPosition = Cl.getInsertionPosition(t.splitPosition), t.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedByMergeOperation(e)), [t];
      }), Hu(Cl, pl, function (t, e, n) {
        var i = Wa._createFromPositionAndShift(e.sourcePosition, e.howMany);

        if (t.graveyardPosition) {
          var _o84 = i.start.isEqual(t.graveyardPosition) || i.containsPosition(t.graveyardPosition);

          if (!n.bWasUndone && _o84) {
            var _n201 = t.splitPosition._getTransformedByMoveOperation(e),
                _i159 = t.graveyardPosition._getTransformedByMoveOperation(e),
                _o85 = _i159.path.slice();

            _o85.push(0);

            var _r45 = new Va(_i159.root, _o85);

            return [new pl(_n201, t.howMany, _r45, 0)];
          }

          t.graveyardPosition = t.graveyardPosition._getTransformedByMoveOperation(e);
        }

        var o = t.splitPosition.isEqual(e.targetPosition);
        if (o && ("insertAtSource" == n.baRelation || "splitBefore" == n.abRelation)) return t.howMany += e.howMany, t.splitPosition = t.splitPosition._getTransformedByDeletion(e.sourcePosition, e.howMany), t.insertionPosition = Cl.getInsertionPosition(t.splitPosition), [t];

        if (o && n.abRelation && n.abRelation.howMany) {
          var _n$abRelation = n.abRelation,
              _e222 = _n$abRelation.howMany,
              _i160 = _n$abRelation.offset;
          return t.howMany += _e222, t.splitPosition = t.splitPosition.getShiftedBy(_i160), [t];
        }

        if (t.splitPosition.hasSameParentAs(e.sourcePosition) && i.containsPosition(t.splitPosition)) {
          var _n202 = e.howMany - (t.splitPosition.offset - e.sourcePosition.offset);

          return t.howMany -= _n202, t.splitPosition.hasSameParentAs(e.targetPosition) && t.splitPosition.offset < e.targetPosition.offset && (t.howMany += e.howMany), t.splitPosition = e.sourcePosition.clone(), t.insertionPosition = Cl.getInsertionPosition(t.splitPosition), [t];
        }

        return e.sourcePosition.isEqual(e.targetPosition) || (t.splitPosition.hasSameParentAs(e.sourcePosition) && t.splitPosition.offset <= e.sourcePosition.offset && (t.howMany -= e.howMany), t.splitPosition.hasSameParentAs(e.targetPosition) && t.splitPosition.offset < e.targetPosition.offset && (t.howMany += e.howMany)), t.splitPosition.stickiness = "toNone", t.splitPosition = t.splitPosition._getTransformedByMoveOperation(e), t.splitPosition.stickiness = "toNext", t.graveyardPosition ? t.insertionPosition = t.insertionPosition._getTransformedByMoveOperation(e) : t.insertionPosition = Cl.getInsertionPosition(t.splitPosition), [t];
      }), Hu(Cl, Cl, function (t, e, n) {
        if (t.splitPosition.isEqual(e.splitPosition)) {
          if (!t.graveyardPosition && !e.graveyardPosition) return [new Vl(0)];
          if (t.graveyardPosition && e.graveyardPosition && t.graveyardPosition.isEqual(e.graveyardPosition)) return [new Vl(0)];
          if ("splitBefore" == n.abRelation) return t.howMany = 0, t.graveyardPosition = t.graveyardPosition._getTransformedBySplitOperation(e), [t];
        }

        if (t.graveyardPosition && e.graveyardPosition && t.graveyardPosition.isEqual(e.graveyardPosition)) {
          var _i161 = "$graveyard" == t.splitPosition.root.rootName,
              _o86 = "$graveyard" == e.splitPosition.root.rootName,
              _r46 = _i161 && !_o86;

          if (_o86 && !_i161 || !_r46 && n.aIsStrong) {
            var _n203 = [];
            return e.howMany && _n203.push(new pl(e.moveTargetPosition, e.howMany, e.splitPosition, 0)), t.howMany && _n203.push(new pl(t.splitPosition, t.howMany, t.moveTargetPosition, 0)), _n203;
          }

          return [new Vl(0)];
        }

        if (t.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedBySplitOperation(e)), t.splitPosition.isEqual(e.insertionPosition) && "splitBefore" == n.abRelation) return t.howMany++, [t];

        if (e.splitPosition.isEqual(t.insertionPosition) && "splitBefore" == n.baRelation) {
          var _n204 = e.insertionPosition.path.slice();

          _n204.push(0);

          var _i162 = new Va(e.insertionPosition.root, _n204);

          return [t, new pl(t.insertionPosition, 1, _i162, 0)];
        }

        return t.splitPosition.hasSameParentAs(e.splitPosition) && t.splitPosition.offset < e.splitPosition.offset && (t.howMany -= e.howMany), t.splitPosition = t.splitPosition._getTransformedBySplitOperation(e), t.insertionPosition = Cl.getInsertionPosition(t.splitPosition), [t];
      });

      var Xu = /*#__PURE__*/function (_qs5) {
        _inherits(Xu, _qs5);

        var _super75 = _createSuper(Xu);

        function Xu(t) {
          var _this141;

          _classCallCheck(this, Xu);

          _this141 = _super75.call(this, t), _this141.domEventType = "click";
          return _this141;
        }

        _createClass(Xu, [{
          key: "onDomEvent",
          value: function onDomEvent(t) {
            this.fire(t.type, t);
          }
        }]);

        return Xu;
      }(qs);

      var tg = /*#__PURE__*/function (_qs6) {
        _inherits(tg, _qs6);

        var _super76 = _createSuper(tg);

        function tg(t) {
          var _this142;

          _classCallCheck(this, tg);

          _this142 = _super76.call(this, t), _this142.domEventType = ["mousedown", "mouseup", "mouseover", "mouseout"];
          return _this142;
        }

        _createClass(tg, [{
          key: "onDomEvent",
          value: function onDomEvent(t) {
            this.fire(t.type, t);
          }
        }]);

        return tg;
      }(qs);

      var eg = /*#__PURE__*/function () {
        function eg(t) {
          _classCallCheck(this, eg);

          this.document = t;
        }

        _createClass(eg, [{
          key: "createDocumentFragment",
          value: function createDocumentFragment(t) {
            return new Cr(this.document, t);
          }
        }, {
          key: "createElement",
          value: function createElement(t, e, n) {
            return new Mo(this.document, t, e, n);
          }
        }, {
          key: "createText",
          value: function createText(t) {
            return new ji(this.document, t);
          }
        }, {
          key: "clone",
          value: function clone(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            return t._clone(e);
          }
        }, {
          key: "appendChild",
          value: function appendChild(t, e) {
            return e._appendChild(t);
          }
        }, {
          key: "insertChild",
          value: function insertChild(t, e, n) {
            return n._insertChild(t, e);
          }
        }, {
          key: "removeChildren",
          value: function removeChildren(t, e, n) {
            return n._removeChildren(t, e);
          }
        }, {
          key: "remove",
          value: function remove(t) {
            var e = t.parent;
            return e ? this.removeChildren(e.getChildIndex(t), 1, e) : [];
          }
        }, {
          key: "replace",
          value: function replace(t, e) {
            var n = t.parent;

            if (n) {
              var _i163 = n.getChildIndex(t);

              return this.removeChildren(_i163, 1, n), this.insertChild(_i163, e, n), !0;
            }

            return !1;
          }
        }, {
          key: "unwrapElement",
          value: function unwrapElement(t) {
            var e = t.parent;

            if (e) {
              var _n205 = e.getChildIndex(t);

              this.remove(t), this.insertChild(_n205, t.getChildren(), e);
            }
          }
        }, {
          key: "rename",
          value: function rename(t, e) {
            var n = new Mo(this.document, t, e.getAttributes(), e.getChildren());
            return this.replace(e, n) ? n : null;
          }
        }, {
          key: "setAttribute",
          value: function setAttribute(t, e, n) {
            n._setAttribute(t, e);
          }
        }, {
          key: "removeAttribute",
          value: function removeAttribute(t, e) {
            e._removeAttribute(t);
          }
        }, {
          key: "addClass",
          value: function addClass(t, e) {
            e._addClass(t);
          }
        }, {
          key: "removeClass",
          value: function removeClass(t, e) {
            e._removeClass(t);
          }
        }, {
          key: "setStyle",
          value: function setStyle(t, e, n) {
            ye(t) && void 0 === n && (n = e), n._setStyle(t, e);
          }
        }, {
          key: "removeStyle",
          value: function removeStyle(t, e) {
            e._removeStyle(t);
          }
        }, {
          key: "setCustomProperty",
          value: function setCustomProperty(t, e, n) {
            n._setCustomProperty(t, e);
          }
        }, {
          key: "removeCustomProperty",
          value: function removeCustomProperty(t, e) {
            return e._removeCustomProperty(t);
          }
        }, {
          key: "createPositionAt",
          value: function createPositionAt(t, e) {
            return Oo._createAt(t, e);
          }
        }, {
          key: "createPositionAfter",
          value: function createPositionAfter(t) {
            return Oo._createAfter(t);
          }
        }, {
          key: "createPositionBefore",
          value: function createPositionBefore(t) {
            return Oo._createBefore(t);
          }
        }, {
          key: "createRange",
          value: function createRange(t, e) {
            return new jo(t, e);
          }
        }, {
          key: "createRangeOn",
          value: function createRangeOn(t) {
            return jo._createOn(t);
          }
        }, {
          key: "createRangeIn",
          value: function createRangeIn(t) {
            return jo._createIn(t);
          }
        }, {
          key: "createSelection",
          value: function createSelection(t, e, n) {
            return new Uo(t, e, n);
          }
        }]);

        return eg;
      }();

      new Set(["black", "silver", "gray", "white", "maroon", "red", "purple", "fuchsia", "green", "lime", "olive", "yellow", "navy", "blue", "teal", "aqua", "orange", "aliceblue", "antiquewhite", "aquamarine", "azure", "beige", "bisque", "blanchedalmond", "blueviolet", "brown", "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue", "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod", "darkgray", "darkgreen", "darkgrey", "darkkhaki", "darkmagenta", "darkolivegreen", "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen", "darkslateblue", "darkslategray", "darkslategrey", "darkturquoise", "darkviolet", "deeppink", "deepskyblue", "dimgray", "dimgrey", "dodgerblue", "firebrick", "floralwhite", "forestgreen", "gainsboro", "ghostwhite", "gold", "goldenrod", "greenyellow", "grey", "honeydew", "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender", "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral", "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightgrey", "lightpink", "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightslategrey", "lightsteelblue", "lightyellow", "limegreen", "linen", "magenta", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple", "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise", "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin", "navajowhite", "oldlace", "olivedrab", "orangered", "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred", "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue", "rosybrown", "royalblue", "saddlebrown", "salmon", "sandybrown", "seagreen", "seashell", "sienna", "skyblue", "slateblue", "slategray", "slategrey", "snow", "springgreen", "steelblue", "tan", "thistle", "tomato", "turquoise", "violet", "wheat", "whitesmoke", "yellowgreen", "activeborder", "activecaption", "appworkspace", "background", "buttonface", "buttonhighlight", "buttonshadow", "buttontext", "captiontext", "graytext", "highlight", "highlighttext", "inactiveborder", "inactivecaption", "inactivecaptiontext", "infobackground", "infotext", "menu", "menutext", "scrollbar", "threeddarkshadow", "threedface", "threedhighlight", "threedlightshadow", "threedshadow", "window", "windowframe", "windowtext", "rebeccapurple", "currentcolor", "transparent"]);

      var ng = /*#__PURE__*/function (_md) {
        _inherits(ng, _md);

        var _super77 = _createSuper(ng);

        function ng(t, e) {
          var _this143;

          _classCallCheck(this, ng);

          _this143 = _super77.call(this, t), _this143.view = e, _this143._toolbarConfig = Dh(t.config.get("toolbar")), _this143._elementReplacer = new da();
          return _this143;
        }

        _createClass(ng, [{
          key: "element",
          get: function get() {
            return this.view.element;
          }
        }, {
          key: "init",
          value: function init(t) {
            var e = this.editor,
                n = this.view,
                i = e.editing.view,
                o = n.editable,
                r = i.document.getRoot();
            o.name = r.rootName, n.render();
            var s = o.element;
            this.setEditableElement(o.name, s), this.focusTracker.add(s), n.editable.bind("isFocused").to(this.focusTracker), i.attachDomRoot(s), t && this._elementReplacer.replace(t, this.element), this._initPlaceholder(), this._initToolbar(), this.fire("ready");
          }
        }, {
          key: "destroy",
          value: function destroy() {
            var t = this.view,
                e = this.editor.editing.view;
            this._elementReplacer.restore(), e.detachDomRoot(t.editable.name), t.destroy(), _get(_getPrototypeOf(ng.prototype), "destroy", this).call(this);
          }
        }, {
          key: "_initToolbar",
          value: function _initToolbar() {
            var t = this.editor,
                e = this.view,
                n = t.editing.view;
            e.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused"), e.stickyPanel.limiterElement = e.element, e.stickyPanel.bind("viewportTopOffset").to(this, "viewportOffset", function (_ref38) {
              var t = _ref38.top;
              return t;
            }), e.toolbar.fillFromConfig(this._toolbarConfig, this.componentFactory), function (_ref39) {
              var t = _ref39.origin,
                  e = _ref39.originKeystrokeHandler,
                  n = _ref39.originFocusTracker,
                  i = _ref39.toolbar,
                  o = _ref39.beforeFocus,
                  r = _ref39.afterBlur;
              n.add(i.element), e.set("Alt+F10", function (t, e) {
                n.isFocused && !i.focusTracker.isFocused && (o && o(), i.focus(), e());
              }), i.keystrokes.set("Esc", function (e, n) {
                i.focusTracker.isFocused && (t.focus(), r && r(), n());
              });
            }({
              origin: n,
              originFocusTracker: this.focusTracker,
              originKeystrokeHandler: t.keystrokes,
              toolbar: e.toolbar
            });
          }
        }, {
          key: "_initPlaceholder",
          value: function _initPlaceholder() {
            var t = this.editor,
                e = t.editing.view,
                n = e.document.getRoot(),
                i = t.sourceElement,
                o = t.config.get("placeholder") || i && "textarea" === i.tagName.toLowerCase() && i.getAttribute("placeholder");
            o && Ru({
              view: e,
              element: n,
              text: o,
              isDirectHost: !1,
              keepOnFocus: !0
            });
          }
        }]);

        return ng;
      }(md);

      var ig = n(2869),
          og = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(ig.Z, og), ig.Z.locals;

      var rg = /*#__PURE__*/function (_Jh) {
        _inherits(rg, _Jh);

        var _super78 = _createSuper(rg);

        function rg(t, e) {
          var _this144;

          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

          _classCallCheck(this, rg);

          _this144 = _super78.call(this, t), _this144.stickyPanel = new Tu(t), _this144.toolbar = new Mh(t, {
            shouldGroupWhenFull: n.shouldToolbarGroupWhenFull
          }), _this144.editable = new tu(t, e);
          return _this144;
        }

        _createClass(rg, [{
          key: "render",
          value: function render() {
            _get(_getPrototypeOf(rg.prototype), "render", this).call(this), this.stickyPanel.content.add(this.toolbar), this.top.add(this.stickyPanel), this.main.add(this.editable);
          }
        }]);

        return rg;
      }(Jh);

      var sg = /*#__PURE__*/function (_hd) {
        _inherits(sg, _hd);

        var _super79 = _createSuper(sg);

        function sg(t, e) {
          var _this145;

          _classCallCheck(this, sg);

          _this145 = _super79.call(this, e), _i(t) && (_this145.sourceElement = t), _this145.model.document.createRoot();
          var n = !_this145.config.get("toolbar.shouldNotGroupWhenFull"),
              i = new rg(_this145.locale, _this145.editing.view, {
            shouldToolbarGroupWhenFull: n
          });
          _this145.ui = new ng(_assertThisInitialized(_this145), i), function (t) {
            if (!O(t.updateSourceElement)) throw new a("attachtoform-missing-elementapi-interface", t);
            var e = t.sourceElement;

            if (e && "textarea" === e.tagName.toLowerCase() && e.form) {
              var _n206;

              var _i164 = e.form,
                  _o87 = function _o87() {
                return t.updateSourceElement();
              };

              O(_i164.submit) && (_n206 = _i164.submit, _i164.submit = function () {
                _o87(), _n206.apply(_i164);
              }), _i164.addEventListener("submit", _o87), t.on("destroy", function () {
                _i164.removeEventListener("submit", _o87), _n206 && (_i164.submit = _n206);
              });
            }
          }(_assertThisInitialized(_this145));
          return _this145;
        }

        _createClass(sg, [{
          key: "destroy",
          value: function destroy() {
            return this.sourceElement && this.updateSourceElement(), this.ui.destroy(), _get(_getPrototypeOf(sg.prototype), "destroy", this).call(this);
          }
        }], [{
          key: "create",
          value: function create(t) {
            var _this146 = this;

            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return new Promise(function (n) {
              var i = new _this146(t, e);
              n(i.initPlugins().then(function () {
                return i.ui.init(_i(t) ? t : null);
              }).then(function () {
                if (!_i(t) && e.initialData) throw new a("editor-create-initial-data", null);
                var n = void 0 !== e.initialData ? e.initialData : function (t) {
                  return _i(t) ? (e = t, e instanceof HTMLTextAreaElement ? e.value : e.innerHTML) : t;
                  var e;
                }(t);
                return i.data.init(n);
              }).then(function () {
                return i.fire("ready");
              }).then(function () {
                return i;
              }));
            });
          }
        }]);

        return sg;
      }(hd);

      he(sg, fd), he(sg, kd);

      var ag = /*#__PURE__*/function () {
        function ag(t) {
          var _this147 = this;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

          _classCallCheck(this, ag);

          this.model = t, this.size = 0, this.limit = e, this.isLocked = !1, this._changeCallback = function (t, e) {
            e.isLocal && e.isUndoable && e !== _this147._batch && _this147._reset(!0);
          }, this._selectionChangeCallback = function () {
            _this147._reset();
          }, this.model.document.on("change", this._changeCallback), this.model.document.selection.on("change:range", this._selectionChangeCallback), this.model.document.selection.on("change:attribute", this._selectionChangeCallback);
        }

        _createClass(ag, [{
          key: "batch",
          get: function get() {
            return this._batch || (this._batch = this.model.createBatch({
              isTyping: !0
            })), this._batch;
          }
        }, {
          key: "input",
          value: function input(t) {
            this.size += t, this.size >= this.limit && this._reset(!0);
          }
        }, {
          key: "lock",
          value: function lock() {
            this.isLocked = !0;
          }
        }, {
          key: "unlock",
          value: function unlock() {
            this.isLocked = !1;
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.model.document.off("change", this._changeCallback), this.model.document.selection.off("change:range", this._selectionChangeCallback), this.model.document.selection.off("change:attribute", this._selectionChangeCallback);
          }
        }, {
          key: "_reset",
          value: function _reset(t) {
            this.isLocked && !t || (this._batch = null, this.size = 0);
          }
        }]);

        return ag;
      }();

      var cg = /*#__PURE__*/function (_me2) {
        _inherits(cg, _me2);

        var _super80 = _createSuper(cg);

        function cg(t, e) {
          var _this148;

          _classCallCheck(this, cg);

          _this148 = _super80.call(this, t), _this148._buffer = new ag(t.model, e);
          return _this148;
        }

        _createClass(cg, [{
          key: "buffer",
          get: function get() {
            return this._buffer;
          }
        }, {
          key: "destroy",
          value: function destroy() {
            _get(_getPrototypeOf(cg.prototype), "destroy", this).call(this), this._buffer.destroy();
          }
        }, {
          key: "execute",
          value: function execute() {
            var _this149 = this;

            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var e = this.editor.model,
                n = e.document,
                i = t.text || "",
                o = i.length,
                r = t.range ? e.createSelection(t.range) : n.selection,
                s = t.resultRange;
            e.enqueueChange(this._buffer.batch, function (t) {
              _this149._buffer.lock(), e.deleteContent(r), i && e.insertContent(t.createText(i, n.selection.getAttributes()), r), s ? t.setSelection(s) : r.is("documentSelection") || t.setSelection(r), _this149._buffer.unlock(), _this149._buffer.input(o);
            });
          }
        }]);

        return cg;
      }(me);

      function lg(t) {
        if (t.newChildren.length - t.oldChildren.length != 1) return;

        var e = function (t, e) {
          var n = [];
          var i,
              o = 0;
          return t.forEach(function (t) {
            "equal" == t ? (r(), o++) : "insert" == t ? (s("insert") ? i.values.push(e[o]) : (r(), i = {
              type: "insert",
              index: o,
              values: [e[o]]
            }), o++) : s("delete") ? i.howMany++ : (r(), i = {
              type: "delete",
              index: o,
              howMany: 1
            });
          }), r(), n;

          function r() {
            i && (n.push(i), i = null);
          }

          function s(t) {
            return i && i.type == t;
          }
        }(Wr(t.oldChildren, t.newChildren, dg), t.newChildren);

        if (e.length > 1) return;
        var n = e[0];
        return n.values[0] && n.values[0].is("$text") ? n : void 0;
      }

      function dg(t, e) {
        return t && t.is("$text") && e && e.is("$text") ? t.data === e.data : t === e;
      }

      function hg(t, e) {
        var n = e.selection,
            i = t.shiftKey && t.keyCode === dr.delete,
            o = !n.isCollapsed;
        return i && o;
      }

      var ug = [ur("arrowUp"), ur("arrowRight"), ur("arrowDown"), ur("arrowLeft"), 9, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 45, 91, 93, 144, 145, 173, 174, 175, 176, 177, 178, 179, 255];

      for (var _t228 = 112; _t228 <= 135; _t228++) {
        ug.push(_t228);
      }

      function gg(t) {
        return !(!t.ctrlKey && !t.metaKey) || ug.includes(t.keyCode);
      }

      var mg = /*#__PURE__*/function () {
        function mg(t) {
          _classCallCheck(this, mg);

          this.editor = t, this.editing = this.editor.editing;
        }

        _createClass(mg, [{
          key: "handle",
          value: function handle(t, e) {
            if (function (t) {
              if (0 == t.length) return !1;

              var _iterator309 = _createForOfIteratorHelper(t),
                  _step309;

              try {
                for (_iterator309.s(); !(_step309 = _iterator309.n()).done;) {
                  var _e223 = _step309.value;
                  if ("children" === _e223.type && !lg(_e223)) return !0;
                }
              } catch (err) {
                _iterator309.e(err);
              } finally {
                _iterator309.f();
              }

              return !1;
            }(t)) this._handleContainerChildrenMutations(t, e);else {
              var _iterator310 = _createForOfIteratorHelper(t),
                  _step310;

              try {
                for (_iterator310.s(); !(_step310 = _iterator310.n()).done;) {
                  var _n207 = _step310.value;
                  this._handleTextMutation(_n207, e), this._handleTextNodeInsertion(_n207);
                }
              } catch (err) {
                _iterator310.e(err);
              } finally {
                _iterator310.f();
              }
            }
          }
        }, {
          key: "_handleContainerChildrenMutations",
          value: function _handleContainerChildrenMutations(t, e) {
            var n = function (t) {
              var e = t.map(function (t) {
                return t.node;
              }).reduce(function (t, e) {
                return t.getCommonAncestor(e, {
                  includeSelf: !0
                });
              });
              if (!e) return;
              return e.getAncestors({
                includeSelf: !0,
                parentFirst: !0
              }).find(function (t) {
                return t.is("containerElement") || t.is("rootElement");
              });
            }(t);

            if (!n) return;
            var i = this.editor.editing.view.domConverter.mapViewToDom(n),
                o = new us(this.editor.editing.view.document),
                r = this.editor.data.toModel(o.domToView(i)).getChild(0),
                s = this.editor.editing.mapper.toModelElement(n);
            if (!s) return;
            var a = Array.from(r.getChildren()),
                c = Array.from(s.getChildren()),
                l = a[a.length - 1],
                d = c[c.length - 1],
                h = l && l.is("element", "softBreak"),
                u = d && !d.is("element", "softBreak");
            h && u && a.pop();
            var g = this.editor.model.schema;
            if (!pg(a, g) || !pg(c, g)) return;
            var m = a.map(function (t) {
              return t.is("$text") ? t.data : "@";
            }).join("").replace(/\u00A0/g, " "),
                p = c.map(function (t) {
              return t.is("$text") ? t.data : "@";
            }).join("").replace(/\u00A0/g, " ");
            if (p === m) return;

            var f = Wr(p, m),
                _fg = fg(f),
                k = _fg.firstChangeAt,
                b = _fg.insertions,
                w = _fg.deletions;

            var A = null;
            e && (A = this.editing.mapper.toModelRange(e.getFirstRange()));

            var C = m.substr(k, b),
                _ = this.editor.model.createRange(this.editor.model.createPositionAt(s, k), this.editor.model.createPositionAt(s, k + w));

            this.editor.execute("input", {
              text: C,
              range: _,
              resultRange: A
            });
          }
        }, {
          key: "_handleTextMutation",
          value: function _handleTextMutation(t, e) {
            if ("text" != t.type) return;
            var n = t.newText.replace(/\u00A0/g, " "),
                i = t.oldText.replace(/\u00A0/g, " ");
            if (i === n) return;

            var o = Wr(i, n),
                _fg2 = fg(o),
                r = _fg2.firstChangeAt,
                s = _fg2.insertions,
                a = _fg2.deletions;

            var c = null;
            e && (c = this.editing.mapper.toModelRange(e.getFirstRange()));
            var l = this.editing.view.createPositionAt(t.node, r),
                d = this.editing.mapper.toModelPosition(l),
                h = this.editor.model.createRange(d, d.getShiftedBy(a)),
                u = n.substr(r, s);
            this.editor.execute("input", {
              text: u,
              range: h,
              resultRange: c
            });
          }
        }, {
          key: "_handleTextNodeInsertion",
          value: function _handleTextNodeInsertion(t) {
            if ("children" != t.type) return;
            var e = lg(t),
                n = this.editing.view.createPositionAt(t.node, e.index),
                i = this.editing.mapper.toModelPosition(n),
                o = e.values[0].data;
            this.editor.execute("input", {
              text: o.replace(/\u00A0/g, " "),
              range: this.editor.model.createRange(i)
            });
          }
        }]);

        return mg;
      }();

      function pg(t, e) {
        return t.every(function (t) {
          return e.isInline(t);
        });
      }

      function fg(t) {
        var e = null,
            n = null;

        for (var _i165 = 0; _i165 < t.length; _i165++) {
          "equal" != t[_i165] && (e = null === e ? _i165 : e, n = _i165);
        }

        var i = 0,
            o = 0;

        for (var _r47 = e; _r47 <= n; _r47++) {
          "insert" != t[_r47] && i++, "delete" != t[_r47] && o++;
        }

        return {
          insertions: o,
          deletions: i,
          firstChangeAt: e
        };
      }

      var kg = /*#__PURE__*/function (_ue2) {
        _inherits(kg, _ue2);

        var _super81 = _createSuper(kg);

        function kg() {
          _classCallCheck(this, kg);

          return _super81.apply(this, arguments);
        }

        _createClass(kg, [{
          key: "init",
          value: function init() {
            var t = this.editor,
                e = new cg(t, t.config.get("typing.undoStep") || 20);
            t.commands.add("input", e), function (t) {
              var e = null;
              var n = t.model,
                  i = t.editing.view,
                  o = t.commands.get("input");

              function r(t) {
                if (sr.isWindows && hg(t, i.document)) return;
                var r = n.document,
                    a = i.document.isComposing,
                    c = e && e.isEqual(r.selection);
                e = null, o.isEnabled && (gg(t) || r.selection.isCollapsed || a && 229 === t.keyCode || !a && 229 === t.keyCode && c || s());
              }

              function s() {
                var t = o.buffer;
                t.lock();
                var e = t.batch;
                n.enqueueChange(e, function () {
                  n.deleteContent(n.document.selection);
                }), t.unlock();
              }

              sr.isAndroid ? i.document.on("beforeinput", function (t, e) {
                return r(e);
              }, {
                priority: "lowest"
              }) : i.document.on("keydown", function (t, e) {
                return r(e);
              }, {
                priority: "lowest"
              }), i.document.on("compositionstart", function () {
                var t = n.document,
                    e = 1 !== t.selection.rangeCount || t.selection.getFirstRange().isFlat;
                t.selection.isCollapsed || e || s();
              }, {
                priority: "lowest"
              }), i.document.on("compositionend", function () {
                e = n.createSelection(n.document.selection);
              }, {
                priority: "lowest"
              });
            }(t), function (t) {
              t.editing.view.document.on("mutations", function (e, n, i) {
                new mg(t).handle(n, i);
              });
            }(t);
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "Input";
          }
        }]);

        return kg;
      }(ue);

      var bg = /*#__PURE__*/function (_me3) {
        _inherits(bg, _me3);

        var _super82 = _createSuper(bg);

        function bg(t, e) {
          var _this150;

          _classCallCheck(this, bg);

          _this150 = _super82.call(this, t), _this150.direction = e, _this150._buffer = new ag(t.model, t.config.get("typing.undoStep"));
          return _this150;
        }

        _createClass(bg, [{
          key: "buffer",
          get: function get() {
            return this._buffer;
          }
        }, {
          key: "execute",
          value: function execute() {
            var _this151 = this;

            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var e = this.editor.model,
                n = e.document;
            e.enqueueChange(this._buffer.batch, function (i) {
              _this151._buffer.lock();

              var o = i.createSelection(t.selection || n.selection),
                  r = t.sequence || 1,
                  s = o.isCollapsed;
              if (o.isCollapsed && e.modifySelection(o, {
                direction: _this151.direction,
                unit: t.unit
              }), _this151._shouldEntireContentBeReplacedWithParagraph(r)) return void _this151._replaceEntireContentWithParagraph(i);
              if (_this151._shouldReplaceFirstBlockWithParagraph(o, r)) return void _this151.editor.execute("paragraph", {
                selection: o
              });
              if (o.isCollapsed) return;
              var a = 0;
              o.getFirstRange().getMinimalFlatRanges().forEach(function (t) {
                a += Vo(t.getWalker({
                  singleCharacters: !0,
                  ignoreElementEnd: !0,
                  shallow: !0
                }));
              }), e.deleteContent(o, {
                doNotResetEntireContent: s,
                direction: _this151.direction
              }), _this151._buffer.input(a), i.setSelection(o), _this151._buffer.unlock();
            });
          }
        }, {
          key: "_shouldEntireContentBeReplacedWithParagraph",
          value: function _shouldEntireContentBeReplacedWithParagraph(t) {
            if (t > 1) return !1;
            var e = this.editor.model,
                n = e.document.selection,
                i = e.schema.getLimitElement(n);
            if (!(n.isCollapsed && n.containsEntireContent(i))) return !1;
            if (!e.schema.checkChild(i, "paragraph")) return !1;
            var o = i.getChild(0);
            return !o || "paragraph" !== o.name;
          }
        }, {
          key: "_replaceEntireContentWithParagraph",
          value: function _replaceEntireContentWithParagraph(t) {
            var e = this.editor.model,
                n = e.document.selection,
                i = e.schema.getLimitElement(n),
                o = t.createElement("paragraph");
            t.remove(t.createRangeIn(i)), t.insert(o, i), t.setSelection(o, 0);
          }
        }, {
          key: "_shouldReplaceFirstBlockWithParagraph",
          value: function _shouldReplaceFirstBlockWithParagraph(t, e) {
            var n = this.editor.model;
            if (e > 1 || "backward" != this.direction) return !1;
            if (!t.isCollapsed) return !1;
            var i = t.getFirstPosition(),
                o = n.schema.getLimitElement(i),
                r = o.getChild(0);
            return i.parent == r && !!t.containsEntireContent(r) && !!n.schema.checkChild(o, "paragraph") && "paragraph" != r.name;
          }
        }]);

        return bg;
      }(me);

      var wg = /*#__PURE__*/function (_As6) {
        _inherits(wg, _As6);

        var _super83 = _createSuper(wg);

        function wg(t) {
          var _this152;

          _classCallCheck(this, wg);

          _this152 = _super83.call(this, t);
          var e = t.document;
          var n = 0;

          function i(t, n, i) {
            var o = new qo(e, "delete", e.selection.getFirstRange());
            e.fire(o, new Hs(e, n, i)), o.stop.called && t.stop();
          }

          e.on("keyup", function (t, e) {
            e.keyCode != dr.delete && e.keyCode != dr.backspace || (n = 0);
          }), e.on("keydown", function (t, o) {
            if (sr.isWindows && hg(o, e)) return;
            var r = {};
            if (o.keyCode == dr.delete) r.direction = "forward", r.unit = "character";else {
              if (o.keyCode != dr.backspace) return;
              r.direction = "backward", r.unit = "codePoint";
            }
            var s = sr.isMac ? o.altKey : o.ctrlKey;
            r.unit = s ? "word" : r.unit, r.sequence = ++n, i(t, o.domEvent, r);
          }), sr.isAndroid && e.on("beforeinput", function (e, n) {
            if ("deleteContentBackward" != n.domEvent.inputType) return;
            var o = {
              unit: "codepoint",
              direction: "backward",
              sequence: 1
            },
                r = n.domTarget.ownerDocument.defaultView.getSelection();
            r.anchorNode == r.focusNode && r.anchorOffset + 1 != r.focusOffset && (o.selectionToRemove = t.domConverter.domSelectionToView(r)), i(e, n.domEvent, o);
          });
          return _this152;
        }

        _createClass(wg, [{
          key: "observe",
          value: function observe() {}
        }]);

        return wg;
      }(As);

      var Ag = /*#__PURE__*/function (_ue3) {
        _inherits(Ag, _ue3);

        var _super84 = _createSuper(Ag);

        function Ag() {
          _classCallCheck(this, Ag);

          return _super84.apply(this, arguments);
        }

        _createClass(Ag, [{
          key: "init",
          value: function init() {
            var _this153 = this;

            var t = this.editor,
                e = t.editing.view,
                n = e.document,
                i = t.model.document;
            e.addObserver(wg), this._undoOnBackspace = !1;
            var o = new bg(t, "forward");

            if (t.commands.add("deleteForward", o), t.commands.add("forwardDelete", o), t.commands.add("delete", new bg(t, "backward")), this.listenTo(n, "delete", function (n, i) {
              var o = {
                unit: i.unit,
                sequence: i.sequence
              };

              if (i.selectionToRemove) {
                var _e224 = t.model.createSelection(),
                    _n208 = [];

                var _iterator311 = _createForOfIteratorHelper(i.selectionToRemove.getRanges()),
                    _step311;

                try {
                  for (_iterator311.s(); !(_step311 = _iterator311.n()).done;) {
                    var _e225 = _step311.value;

                    _n208.push(t.editing.mapper.toModelRange(_e225));
                  }
                } catch (err) {
                  _iterator311.e(err);
                } finally {
                  _iterator311.f();
                }

                _e224.setTo(_n208), o.selection = _e224;
              }

              t.execute("forward" == i.direction ? "deleteForward" : "delete", o), i.preventDefault(), e.scrollToTheSelection();
            }, {
              priority: "low"
            }), sr.isAndroid) {
              var _t229 = null;
              this.listenTo(n, "delete", function (e, n) {
                var i = n.domTarget.ownerDocument.defaultView.getSelection();
                _t229 = {
                  anchorNode: i.anchorNode,
                  anchorOffset: i.anchorOffset,
                  focusNode: i.focusNode,
                  focusOffset: i.focusOffset
                };
              }, {
                priority: "lowest"
              }), this.listenTo(n, "keyup", function (e, n) {
                if (_t229) {
                  var _e226 = n.domTarget.ownerDocument.defaultView.getSelection();

                  _e226.collapse(_t229.anchorNode, _t229.anchorOffset), _e226.extend(_t229.focusNode, _t229.focusOffset), _t229 = null;
                }
              });
            }

            this.editor.plugins.has("UndoEditing") && (this.listenTo(n, "delete", function (e, n) {
              _this153._undoOnBackspace && "backward" == n.direction && 1 == n.sequence && "codePoint" == n.unit && (_this153._undoOnBackspace = !1, t.execute("undo"), n.preventDefault(), e.stop());
            }, {
              context: "$capture"
            }), this.listenTo(i, "change", function () {
              _this153._undoOnBackspace = !1;
            }));
          }
        }, {
          key: "requestUndoOnBackspace",
          value: function requestUndoOnBackspace() {
            this.editor.plugins.has("UndoEditing") && (this._undoOnBackspace = !0);
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "Delete";
          }
        }]);

        return Ag;
      }(ue);

      var Cg = /*#__PURE__*/function (_ue4) {
        _inherits(Cg, _ue4);

        var _super85 = _createSuper(Cg);

        function Cg() {
          _classCallCheck(this, Cg);

          return _super85.apply(this, arguments);
        }

        _createClass(Cg, null, [{
          key: "requires",
          get: function get() {
            return [kg, Ag];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "Typing";
          }
        }]);

        return Cg;
      }(ue);

      function _g(t, e) {
        var n = t.start;
        return {
          text: Array.from(t.getItems()).reduce(function (t, i) {
            return i.is("$text") || i.is("$textProxy") ? t + i.data : (n = e.createPositionAfter(i), "");
          }, ""),
          range: e.createRange(n, t.end)
        };
      }

      var vg = /*#__PURE__*/function () {
        function vg(t, e) {
          var _this154 = this;

          _classCallCheck(this, vg);

          this.model = t, this.testCallback = e, this.hasMatch = !1, this.set("isEnabled", !0), this.on("change:isEnabled", function () {
            _this154.isEnabled ? _this154._startListening() : (_this154.stopListening(t.document.selection), _this154.stopListening(t.document));
          }), this._startListening();
        }

        _createClass(vg, [{
          key: "_startListening",
          value: function _startListening() {
            var _this155 = this;

            var t = this.model.document;
            this.listenTo(t.selection, "change:range", function (e, _ref40) {
              var n = _ref40.directChange;
              n && (t.selection.isCollapsed ? _this155._evaluateTextBeforeSelection("selection") : _this155.hasMatch && (_this155.fire("unmatched"), _this155.hasMatch = !1));
            }), this.listenTo(t, "change:data", function (t, e) {
              !e.isUndo && e.isLocal && _this155._evaluateTextBeforeSelection("data", {
                batch: e
              });
            });
          }
        }, {
          key: "_evaluateTextBeforeSelection",
          value: function _evaluateTextBeforeSelection(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var n = this.model,
                i = n.document.selection,
                o = n.createRange(n.createPositionAt(i.focus.parent, 0), i.focus),
                _g2 = _g(o, n),
                r = _g2.text,
                s = _g2.range,
                a = this.testCallback(r);

            if (!a && this.hasMatch && this.fire("unmatched"), this.hasMatch = !!a, a) {
              var _n209 = Object.assign(e, {
                text: r,
                range: s
              });

              "object" == typeof a && Object.assign(_n209, a), this.fire("matched:".concat(t), _n209);
            }
          }
        }]);

        return vg;
      }();

      he(vg, re);

      var yg = /*#__PURE__*/function (_ue5) {
        _inherits(yg, _ue5);

        var _super86 = _createSuper(yg);

        function yg(t) {
          var _this156;

          _classCallCheck(this, yg);

          _this156 = _super86.call(this, t), _this156.attributes = new Set(), _this156._overrideUid = null;
          return _this156;
        }

        _createClass(yg, [{
          key: "init",
          value: function init() {
            var _this157 = this;

            var t = this.editor,
                e = t.model,
                n = t.editing.view,
                i = t.locale,
                o = e.document.selection;
            this.listenTo(n.document, "arrowKey", function (t, e) {
              if (!o.isCollapsed) return;
              if (e.shiftKey || e.altKey || e.ctrlKey) return;
              var n = e.keyCode == dr.arrowright,
                  r = e.keyCode == dr.arrowleft;
              if (!n && !r) return;
              var s = i.contentLanguageDirection;
              var a = !1;
              a = "ltr" === s && n || "rtl" === s && r ? _this157._handleForwardMovement(e) : _this157._handleBackwardMovement(e), !0 === a && t.stop();
            }, {
              context: "$text",
              priority: "highest"
            }), this._isNextGravityRestorationSkipped = !1, this.listenTo(o, "change:range", function (t, e) {
              _this157._isNextGravityRestorationSkipped ? _this157._isNextGravityRestorationSkipped = !1 : _this157._isGravityOverridden && (!e.directChange && Sg(o.getFirstPosition(), _this157.attributes) || _this157._restoreGravity());
            });
          }
        }, {
          key: "registerAttribute",
          value: function registerAttribute(t) {
            this.attributes.add(t);
          }
        }, {
          key: "_handleForwardMovement",
          value: function _handleForwardMovement(t) {
            var e = this.attributes,
                n = this.editor.model.document.selection,
                i = n.getFirstPosition();
            return !this._isGravityOverridden && (!i.isAtStart || !xg(n, e)) && (Sg(i, e) ? (Dg(t), this._overrideGravity(), !0) : void 0);
          }
        }, {
          key: "_handleBackwardMovement",
          value: function _handleBackwardMovement(t) {
            var e = this.attributes,
                n = this.editor.model,
                i = n.document.selection,
                o = i.getFirstPosition();
            return this._isGravityOverridden ? (Dg(t), this._restoreGravity(), Eg(n, e, o), !0) : o.isAtStart ? !!xg(i, e) && (Dg(t), Eg(n, e, o), !0) : function (t, e) {
              return Sg(t.getShiftedBy(-1), e);
            }(o, e) ? o.isAtEnd && !xg(i, e) && Sg(o, e) ? (Dg(t), Eg(n, e, o), !0) : (this._isNextGravityRestorationSkipped = !0, this._overrideGravity(), !1) : void 0;
          }
        }, {
          key: "_isGravityOverridden",
          get: function get() {
            return !!this._overrideUid;
          }
        }, {
          key: "_overrideGravity",
          value: function _overrideGravity() {
            this._overrideUid = this.editor.model.change(function (t) {
              return t.overrideSelectionGravity();
            });
          }
        }, {
          key: "_restoreGravity",
          value: function _restoreGravity() {
            var _this158 = this;

            this.editor.model.change(function (t) {
              t.restoreSelectionGravity(_this158._overrideUid), _this158._overrideUid = null;
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "TwoStepCaretMovement";
          }
        }]);

        return yg;
      }(ue);

      function xg(t, e) {
        var _iterator312 = _createForOfIteratorHelper(e),
            _step312;

        try {
          for (_iterator312.s(); !(_step312 = _iterator312.n()).done;) {
            var _n210 = _step312.value;
            if (t.hasAttribute(_n210)) return !0;
          }
        } catch (err) {
          _iterator312.e(err);
        } finally {
          _iterator312.f();
        }

        return !1;
      }

      function Eg(t, e, n) {
        var i = n.nodeBefore;
        t.change(function (t) {
          i ? t.setSelectionAttribute(i.getAttributes()) : t.removeSelectionAttribute(e);
        });
      }

      function Dg(t) {
        t.preventDefault();
      }

      function Sg(t, e) {
        var n = t.nodeBefore,
            i = t.nodeAfter;

        var _iterator313 = _createForOfIteratorHelper(e),
            _step313;

        try {
          for (_iterator313.s(); !(_step313 = _iterator313.n()).done;) {
            var _t230 = _step313.value;

            var _e227 = n ? n.getAttribute(_t230) : void 0;

            if ((i ? i.getAttribute(_t230) : void 0) !== _e227) return !0;
          }
        } catch (err) {
          _iterator313.e(err);
        } finally {
          _iterator313.f();
        }

        return !1;
      }

      var Ig = /[\\^$.*+?()[\]{}|]/g,
          Mg = RegExp(Ig.source);

      var Tg = function Tg(t) {
        return (t = ro(t)) && Mg.test(t) ? t.replace(Ig, "\\$&") : t;
      };

      var Ng = {
        copyright: {
          from: "(c)",
          to: "©"
        },
        registeredTrademark: {
          from: "(r)",
          to: "®"
        },
        trademark: {
          from: "(tm)",
          to: "™"
        },
        oneHalf: {
          from: /(^|[^/a-z0-9])(1\/2)([^/a-z0-9])$/i,
          to: [null, "½", null]
        },
        oneThird: {
          from: /(^|[^/a-z0-9])(1\/3)([^/a-z0-9])$/i,
          to: [null, "⅓", null]
        },
        twoThirds: {
          from: /(^|[^/a-z0-9])(2\/3)([^/a-z0-9])$/i,
          to: [null, "⅔", null]
        },
        oneForth: {
          from: /(^|[^/a-z0-9])(1\/4)([^/a-z0-9])$/i,
          to: [null, "¼", null]
        },
        threeQuarters: {
          from: /(^|[^/a-z0-9])(3\/4)([^/a-z0-9])$/i,
          to: [null, "¾", null]
        },
        lessThanOrEqual: {
          from: "<=",
          to: "≤"
        },
        greaterThanOrEqual: {
          from: ">=",
          to: "≥"
        },
        notEqual: {
          from: "!=",
          to: "≠"
        },
        arrowLeft: {
          from: "<-",
          to: "←"
        },
        arrowRight: {
          from: "->",
          to: "→"
        },
        horizontalEllipsis: {
          from: "...",
          to: "…"
        },
        enDash: {
          from: /(^| )(--)( )$/,
          to: [null, "–", null]
        },
        emDash: {
          from: /(^| )(---)( )$/,
          to: [null, "—", null]
        },
        quotesPrimary: {
          from: jg('"'),
          to: [null, "“", null, "”"]
        },
        quotesSecondary: {
          from: jg("'"),
          to: [null, "‘", null, "’"]
        },
        quotesPrimaryEnGb: {
          from: jg("'"),
          to: [null, "‘", null, "’"]
        },
        quotesSecondaryEnGb: {
          from: jg('"'),
          to: [null, "“", null, "”"]
        },
        quotesPrimaryPl: {
          from: jg('"'),
          to: [null, "„", null, "”"]
        },
        quotesSecondaryPl: {
          from: jg("'"),
          to: [null, "‚", null, "’"]
        }
      },
          Bg = {
        symbols: ["copyright", "registeredTrademark", "trademark"],
        mathematical: ["oneHalf", "oneThird", "twoThirds", "oneForth", "threeQuarters", "lessThanOrEqual", "greaterThanOrEqual", "notEqual", "arrowLeft", "arrowRight"],
        typography: ["horizontalEllipsis", "enDash", "emDash"],
        quotes: ["quotesPrimary", "quotesSecondary"]
      },
          zg = ["symbols", "mathematical", "typography", "quotes"];

      var Pg = /*#__PURE__*/function (_ue6) {
        _inherits(Pg, _ue6);

        var _super87 = _createSuper(Pg);

        function Pg(t) {
          var _this159;

          _classCallCheck(this, Pg);

          _this159 = _super87.call(this, t), t.config.define("typing", {
            transformations: {
              include: zg
            }
          });
          return _this159;
        }

        _createClass(Pg, [{
          key: "init",
          value: function init() {
            var _this160 = this;

            var t = this.editor.model.document.selection;
            t.on("change:range", function () {
              _this160.isEnabled = !t.anchor.parent.is("element", "codeBlock");
            }), this._enableTransformationWatchers();
          }
        }, {
          key: "_enableTransformationWatchers",
          value: function _enableTransformationWatchers() {
            var t = this.editor,
                e = t.model,
                n = t.plugins.get("Delete"),
                i = function (t) {
              var e = t.extra || [],
                  n = t.remove || [],
                  i = function i(t) {
                return !n.includes(t);
              };

              return function (t) {
                var e = new Set();

                var _iterator314 = _createForOfIteratorHelper(t),
                    _step314;

                try {
                  for (_iterator314.s(); !(_step314 = _iterator314.n()).done;) {
                    var _n211 = _step314.value;

                    if (Bg[_n211]) {
                      var _iterator315 = _createForOfIteratorHelper(Bg[_n211]),
                          _step315;

                      try {
                        for (_iterator315.s(); !(_step315 = _iterator315.n()).done;) {
                          var _t231 = _step315.value;
                          e.add(_t231);
                        }
                      } catch (err) {
                        _iterator315.e(err);
                      } finally {
                        _iterator315.f();
                      }
                    } else e.add(_n211);
                  }
                } catch (err) {
                  _iterator314.e(err);
                } finally {
                  _iterator314.f();
                }

                return Array.from(e);
              }(t.include.concat(e).filter(i)).filter(i).map(function (t) {
                return Ng[t] || t;
              }).filter(function (t) {
                return "object" == typeof t;
              }).map(function (t) {
                return {
                  from: Lg(t.from),
                  to: Rg(t.to)
                };
              });
            }(t.config.get("typing.transformations")),
                o = new vg(t.model, function (t) {
              var _iterator316 = _createForOfIteratorHelper(i),
                  _step316;

              try {
                for (_iterator316.s(); !(_step316 = _iterator316.n()).done;) {
                  var _e228 = _step316.value;
                  if (_e228.from.test(t)) return {
                    normalizedTransformation: _e228
                  };
                }
              } catch (err) {
                _iterator316.e(err);
              } finally {
                _iterator316.f();
              }
            });

            o.on("matched:data", function (t, i) {
              if (!i.batch.isTyping) return;
              var _i$normalizedTransfor = i.normalizedTransformation,
                  o = _i$normalizedTransfor.from,
                  r = _i$normalizedTransfor.to,
                  s = o.exec(i.text),
                  a = r(s.slice(1)),
                  c = i.range;
              var l = s.index;
              e.enqueueChange(function (t) {
                for (var _n212 = 1; _n212 < s.length; _n212++) {
                  var _i166 = s[_n212],
                      _o88 = a[_n212 - 1];

                  if (null == _o88) {
                    l += _i166.length;
                    continue;
                  }

                  var _r48 = c.start.getShiftedBy(l),
                      _d3 = e.createRange(_r48, _r48.getShiftedBy(_i166.length)),
                      _h3 = Og(_r48);

                  e.insertContent(t.createText(_o88, _h3), _d3), l += _o88.length;
                }

                e.enqueueChange(function () {
                  n.requestUndoOnBackspace();
                });
              });
            }), o.bind("isEnabled").to(this);
          }
        }], [{
          key: "requires",
          get: function get() {
            return ["Delete", "Input"];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "TextTransformation";
          }
        }]);

        return Pg;
      }(ue);

      function Lg(t) {
        return "string" == typeof t ? new RegExp("(".concat(Tg(t), ")$")) : t;
      }

      function Rg(t) {
        return "string" == typeof t ? function () {
          return [t];
        } : t instanceof Array ? function () {
          return t;
        } : t;
      }

      function Og(t) {
        return (t.textNode ? t.textNode : t.nodeAfter).getAttributes();
      }

      function jg(t) {
        return new RegExp("(^|\\s)(".concat(t, ")([^").concat(t, "]*)(").concat(t, ")$"));
      }

      function Fg(t, e, n, i) {
        return i.createRange(Vg(t, e, n, !0, i), Vg(t, e, n, !1, i));
      }

      function Vg(t, e, n, i, o) {
        var r = t.textNode || (i ? t.nodeBefore : t.nodeAfter),
            s = null;

        for (; r && r.getAttribute(e) == n;) {
          s = r, r = i ? r.previousSibling : r.nextSibling;
        }

        return s ? o.createPositionAt(s, i ? "before" : "after") : t;
      }

      function Ug(t, e, n, i) {
        var o,
            r = null;
        "function" == typeof i ? o = i : (r = t.commands.get(i), o = function o() {
          t.execute(i);
        }), t.model.document.on("change:data", function (s, a) {
          if (r && !r.isEnabled || !e.isEnabled) return;
          var c = wa(t.model.document.selection.getRanges());
          if (!c.isCollapsed) return;
          if (a.isUndo || !a.isLocal) return;
          var l = Array.from(t.model.document.differ.getChanges()),
              d = l[0];
          if (1 != l.length || "insert" !== d.type || "$text" != d.name || 1 != d.length) return;
          var h = d.position.parent;
          if (h.is("element", "codeBlock")) return;
          if (h.is("element", "listItem") && "function" != typeof i && !["numberedList", "bulletedList", "todoList"].includes(i)) return;
          if (r && !0 === r.value) return;
          var u = h.getChild(0),
              g = t.model.createRangeOn(u);
          if (!g.containsRange(c) && !c.end.isEqual(g.end)) return;
          var m = n.exec(u.data.substr(0, c.end.offset));
          m && t.model.enqueueChange(function (e) {
            var n = e.createPositionAt(h, 0),
                i = e.createPositionAt(h, m[0].length),
                r = new oc(n, i);

            if (!1 !== o({
              match: m
            })) {
              e.remove(r);

              var _n213 = t.model.document.selection.getFirstRange(),
                  _i167 = e.createRangeIn(h);

              !h.isEmpty || _i167.isEqual(_n213) || _i167.containsRange(_n213, !0) || e.remove(h);
            }

            r.detach(), t.model.enqueueChange(function () {
              t.plugins.get("Delete").requestUndoOnBackspace();
            });
          });
        });
      }

      function Hg(t, e, n, i) {
        var o, r;
        n instanceof RegExp ? o = n : r = n, r = r || function (t) {
          var e;
          var n = [],
              i = [];

          for (; null !== (e = o.exec(t)) && !(e && e.length < 4);) {
            var _e229 = e,
                _t232 = _e229.index,
                _o89 = _e229[1],
                _r49 = _e229[2],
                _s27 = _e229[3];

            var _a15 = _o89 + _r49 + _s27;

            _t232 += e[0].length - _a15.length;
            var _c8 = [_t232, _t232 + _o89.length],
                _l4 = [_t232 + _o89.length + _r49.length, _t232 + _o89.length + _r49.length + _s27.length];
            n.push(_c8), n.push(_l4), i.push([_t232 + _o89.length, _t232 + _o89.length + _r49.length]);
          }

          return {
            remove: n,
            format: i
          };
        }, t.model.document.on("change:data", function (n, o) {
          if (o.isUndo || !o.isLocal || !e.isEnabled) return;
          var s = t.model,
              a = s.document.selection;
          if (!a.isCollapsed) return;
          var c = Array.from(s.document.differ.getChanges()),
              l = c[0];
          if (1 != c.length || "insert" !== l.type || "$text" != l.name || 1 != l.length) return;

          var d = a.focus,
              h = d.parent,
              _ref41 = function (t, e) {
            var n = t.start;
            return {
              text: Array.from(t.getItems()).reduce(function (t, i) {
                return !i.is("$text") && !i.is("$textProxy") || i.getAttribute("code") ? (n = e.createPositionAfter(i), "") : t + i.data;
              }, ""),
              range: e.createRange(n, t.end)
            };
          }(s.createRange(s.createPositionAt(h, 0), d), s),
              u = _ref41.text,
              g = _ref41.range,
              m = r(u),
              p = qg(g.start, m.format, s),
              f = qg(g.start, m.remove, s);

          p.length && f.length && s.enqueueChange(function (e) {
            if (!1 !== i(e, p)) {
              var _iterator317 = _createForOfIteratorHelper(f.reverse()),
                  _step317;

              try {
                for (_iterator317.s(); !(_step317 = _iterator317.n()).done;) {
                  var _t233 = _step317.value;
                  e.remove(_t233);
                }
              } catch (err) {
                _iterator317.e(err);
              } finally {
                _iterator317.f();
              }

              s.enqueueChange(function () {
                t.plugins.get("Delete").requestUndoOnBackspace();
              });
            }
          });
        });
      }

      function qg(t, e, n) {
        return e.filter(function (t) {
          return void 0 !== t[0] && void 0 !== t[1];
        }).map(function (e) {
          return n.createRange(t.getShiftedBy(e[0]), t.getShiftedBy(e[1]));
        });
      }

      var Wg = /*#__PURE__*/function (_ue7) {
        _inherits(Wg, _ue7);

        var _super88 = _createSuper(Wg);

        function Wg() {
          _classCallCheck(this, Wg);

          return _super88.apply(this, arguments);
        }

        _createClass(Wg, [{
          key: "afterInit",
          value: function afterInit() {
            this._addListAutoformats(), this._addBasicStylesAutoformats(), this._addHeadingAutoformats(), this._addBlockQuoteAutoformats(), this._addCodeBlockAutoformats(), this._addHorizontalLineAutoformats();
          }
        }, {
          key: "_addListAutoformats",
          value: function _addListAutoformats() {
            var _this161 = this;

            var t = this.editor.commands;
            t.get("bulletedList") && Ug(this.editor, this, /^[*-]\s$/, "bulletedList"), t.get("numberedList") && Ug(this.editor, this, /^1[.|)]\s$/, "numberedList"), t.get("todoList") && Ug(this.editor, this, /^\[\s?\]\s$/, "todoList"), t.get("checkTodoList") && Ug(this.editor, this, /^\[\s?x\s?\]\s$/, function () {
              _this161.editor.execute("todoList"), _this161.editor.execute("checkTodoList");
            });
          }
        }, {
          key: "_addBasicStylesAutoformats",
          value: function _addBasicStylesAutoformats() {
            var t = this.editor.commands;

            if (t.get("bold")) {
              var _t234 = Gg(this.editor, "bold");

              Hg(this.editor, this, /(?:^|\s)(\*\*)([^*]+)(\*\*)$/g, _t234), Hg(this.editor, this, /(?:^|\s)(__)([^_]+)(__)$/g, _t234);
            }

            if (t.get("italic")) {
              var _t235 = Gg(this.editor, "italic");

              Hg(this.editor, this, /(?:^|\s)(\*)([^*_]+)(\*)$/g, _t235), Hg(this.editor, this, /(?:^|\s)(_)([^_]+)(_)$/g, _t235);
            }

            if (t.get("code")) {
              var _t236 = Gg(this.editor, "code");

              Hg(this.editor, this, /(`)([^`]+)(`)$/g, _t236);
            }

            if (t.get("strikethrough")) {
              var _t237 = Gg(this.editor, "strikethrough");

              Hg(this.editor, this, /(~~)([^~]+)(~~)$/g, _t237);
            }
          }
        }, {
          key: "_addHeadingAutoformats",
          value: function _addHeadingAutoformats() {
            var _this162 = this;

            var t = this.editor.commands.get("heading");
            t && t.modelElements.filter(function (t) {
              return t.match(/^heading[1-6]$/);
            }).forEach(function (e) {
              var n = e[7],
                  i = new RegExp("^(#{".concat(n, "})\\s$"));
              Ug(_this162.editor, _this162, i, function () {
                if (!t.isEnabled || t.value === e) return !1;

                _this162.editor.execute("heading", {
                  value: e
                });
              });
            });
          }
        }, {
          key: "_addBlockQuoteAutoformats",
          value: function _addBlockQuoteAutoformats() {
            this.editor.commands.get("blockQuote") && Ug(this.editor, this, /^>\s$/, "blockQuote");
          }
        }, {
          key: "_addCodeBlockAutoformats",
          value: function _addCodeBlockAutoformats() {
            var _this163 = this;

            var t = this.editor,
                e = t.model.document.selection;
            t.commands.get("codeBlock") && Ug(t, this, /^```$/, function () {
              if (e.getFirstPosition().parent.is("element", "listItem")) return !1;

              _this163.editor.execute("codeBlock", {
                usePreviousLanguageChoice: !0
              });
            });
          }
        }, {
          key: "_addHorizontalLineAutoformats",
          value: function _addHorizontalLineAutoformats() {
            this.editor.commands.get("horizontalLine") && Ug(this.editor, this, /^---$/, "horizontalLine");
          }
        }], [{
          key: "requires",
          get: function get() {
            return [Ag];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "Autoformat";
          }
        }]);

        return Wg;
      }(ue);

      function Gg(t, e) {
        return function (n, i) {
          if (!t.commands.get(e).isEnabled) return !1;
          var o = t.model.schema.getValidRanges(i, e);

          var _iterator318 = _createForOfIteratorHelper(o),
              _step318;

          try {
            for (_iterator318.s(); !(_step318 = _iterator318.n()).done;) {
              var _t238 = _step318.value;
              n.setAttribute(e, !0, _t238);
            }
          } catch (err) {
            _iterator318.e(err);
          } finally {
            _iterator318.f();
          }

          n.removeSelectionAttribute(e);
        };
      }

      var $g = function $g(t, e, n) {
        var i = t.length;
        return n = void 0 === n ? i : n, !e && n >= i ? t : ho(t, e, n);
      },
          Yg = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");

      var Kg = function Kg(t) {
        return Yg.test(t);
      };

      var Qg = function Qg(t) {
        return t.split("");
      },
          Zg = "[\\ud800-\\udfff]",
          Jg = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
          Xg = "\\ud83c[\\udffb-\\udfff]",
          tm = "[^\\ud800-\\udfff]",
          em = "(?:\\ud83c[\\udde6-\\uddff]){2}",
          nm = "[\\ud800-\\udbff][\\udc00-\\udfff]",
          im = "(?:" + Jg + "|" + Xg + ")" + "?",
          om = "[\\ufe0e\\ufe0f]?",
          rm = om + im + ("(?:\\u200d(?:" + [tm, em, nm].join("|") + ")" + om + im + ")*"),
          sm = "(?:" + [tm + Jg + "?", Jg, em, nm, Zg].join("|") + ")",
          am = RegExp(Xg + "(?=" + Xg + ")|" + sm + rm, "g");

      var cm = function cm(t) {
        return t.match(am) || [];
      };

      var lm = function lm(t) {
        return Kg(t) ? cm(t) : Qg(t);
      };

      var dm = function (t) {
        return function (e) {
          e = ro(e);
          var n = Kg(e) ? lm(e) : void 0,
              i = n ? n[0] : e.charAt(0),
              o = n ? $g(n, 1).join("") : e.slice(1);
          return i[t]() + o;
        };
      }("toUpperCase");

      var hm = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g,
          um = /^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i,
          gm = /^[\S]+@((?![-_])(?:[-\w\u00a1-\uffff]{0,63}[^-_]\.))+(?:[a-z\u00a1-\uffff]{2,})$/i,
          mm = /^((\w+:(\/{2,})?)|(\W))/i,
          pm = "Ctrl+K";

      function fm(t, _ref42) {
        var e = _ref42.writer;
        var n = e.createAttributeElement("a", {
          href: t
        }, {
          priority: 5
        });
        return e.setCustomProperty("link", !0, n), n;
      }

      function km(t) {
        return function (t) {
          return t.replace(hm, "").match(um);
        }(t = String(t)) ? t : "#";
      }

      function bm(t, e) {
        return !!t && e.checkAttribute(t.name, "linkHref");
      }

      function wm(t, e) {
        var n = (i = t, gm.test(i) ? "mailto:" : e);
        var i;
        var o = !!n && !mm.test(t);
        return t && o ? n + t : t;
      }

      function Am(t) {
        window.open(t, "_blank", "noopener");
      }

      var Cm = new RegExp("(^|\\s)(((?:(?:(?:https?|ftp):)?\\/\\/)(?:\\S+(?::\\S*)?@)?(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(((?!www\\.)|(www\\.))(?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.)+(?:[a-z\\u00a1-\\uffff]{2,63})))(?::\\d{2,5})?(?:[/?#]\\S*)?)|((www.|(\\S+@))((?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.))+(?:[a-z\\u00a1-\\uffff]{2,63})))$", "i");

      var _m = /*#__PURE__*/function (_ue8) {
        _inherits(_m, _ue8);

        var _super89 = _createSuper(_m);

        function _m() {
          _classCallCheck(this, _m);

          return _super89.apply(this, arguments);
        }

        _createClass(_m, [{
          key: "init",
          value: function init() {
            var _this164 = this;

            var t = this.editor.model.document.selection;
            t.on("change:range", function () {
              _this164.isEnabled = !t.anchor.parent.is("element", "codeBlock");
            }), this._enableTypingHandling();
          }
        }, {
          key: "afterInit",
          value: function afterInit() {
            this._enableEnterHandling(), this._enableShiftEnterHandling();
          }
        }, {
          key: "_enableTypingHandling",
          value: function _enableTypingHandling() {
            var _this165 = this;

            var t = this.editor,
                e = new vg(t.model, function (t) {
              if (!function (t) {
                return t.length > 4 && " " === t[t.length - 1] && " " !== t[t.length - 2];
              }(t)) return;
              var e = vm(t.substr(0, t.length - 1));
              return e ? {
                url: e
              } : void 0;
            });
            e.on("matched:data", function (e, n) {
              var i = n.batch,
                  o = n.range,
                  r = n.url;
              if (!i.isTyping) return;
              var s = o.end.getShiftedBy(-1),
                  a = s.getShiftedBy(-r.length),
                  c = t.model.createRange(a, s);

              _this165._applyAutoLink(r, c);
            }), e.bind("isEnabled").to(this);
          }
        }, {
          key: "_enableEnterHandling",
          value: function _enableEnterHandling() {
            var _this166 = this;

            var t = this.editor,
                e = t.model,
                n = t.commands.get("enter");
            n && n.on("execute", function () {
              var t = e.document.selection.getFirstPosition();
              if (!t.parent.previousSibling) return;
              var n = e.createRangeIn(t.parent.previousSibling);

              _this166._checkAndApplyAutoLinkOnRange(n);
            });
          }
        }, {
          key: "_enableShiftEnterHandling",
          value: function _enableShiftEnterHandling() {
            var _this167 = this;

            var t = this.editor,
                e = t.model,
                n = t.commands.get("shiftEnter");
            n && n.on("execute", function () {
              var t = e.document.selection.getFirstPosition(),
                  n = e.createRange(e.createPositionAt(t.parent, 0), t.getShiftedBy(-1));

              _this167._checkAndApplyAutoLinkOnRange(n);
            });
          }
        }, {
          key: "_checkAndApplyAutoLinkOnRange",
          value: function _checkAndApplyAutoLinkOnRange(t) {
            var e = this.editor.model,
                _g3 = _g(t, e),
                n = _g3.text,
                i = _g3.range,
                o = vm(n);

            if (o) {
              var _t239 = e.createRange(i.end.getShiftedBy(-o.length), i.end);

              this._applyAutoLink(o, _t239);
            }
          }
        }, {
          key: "_applyAutoLink",
          value: function _applyAutoLink(t, e) {
            var _this168 = this;

            var n = this.editor.model,
                i = this.editor.plugins.get("Delete");
            this.isEnabled && function (t, e) {
              return e.schema.checkAttributeInSelection(e.createSelection(t), "linkHref");
            }(e, n) && n.enqueueChange(function (o) {
              var r = _this168.editor.config.get("link.defaultProtocol"),
                  s = wm(t, r);

              o.setAttribute("linkHref", s, e), n.enqueueChange(function () {
                i.requestUndoOnBackspace();
              });
            });
          }
        }], [{
          key: "requires",
          get: function get() {
            return [Ag];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "AutoLink";
          }
        }]);

        return _m;
      }(ue);

      function vm(t) {
        var e = Cm.exec(t);
        return e ? e[2] : null;
      }

      function ym(t, e) {
        var _iterator319, _step319, _n214;

        return _regeneratorRuntime.wrap(function ym$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _iterator319 = _createForOfIteratorHelper(e);
                _context37.prev = 1;

                _iterator319.s();

              case 3:
                if ((_step319 = _iterator319.n()).done) {
                  _context37.next = 11;
                  break;
                }

                _n214 = _step319.value;
                _context37.t0 = _n214 && t.getAttributeProperties(_n214[0]).copyOnEnter;

                if (!_context37.t0) {
                  _context37.next = 9;
                  break;
                }

                _context37.next = 9;
                return _n214;

              case 9:
                _context37.next = 3;
                break;

              case 11:
                _context37.next = 16;
                break;

              case 13:
                _context37.prev = 13;
                _context37.t1 = _context37["catch"](1);

                _iterator319.e(_context37.t1);

              case 16:
                _context37.prev = 16;

                _iterator319.f();

                return _context37.finish(16);

              case 19:
              case "end":
                return _context37.stop();
            }
          }
        }, _marked3, null, [[1, 13, 16, 19]]);
      }

      var xm = /*#__PURE__*/function (_me4) {
        _inherits(xm, _me4);

        var _super90 = _createSuper(xm);

        function xm() {
          _classCallCheck(this, xm);

          return _super90.apply(this, arguments);
        }

        _createClass(xm, [{
          key: "execute",
          value: function execute() {
            var _this169 = this;

            var t = this.editor.model,
                e = t.document;
            t.change(function (n) {
              !function (t, e, n, i) {
                var o = n.isCollapsed,
                    r = n.getFirstRange(),
                    s = r.start.parent,
                    a = r.end.parent;
                if (i.isLimit(s) || i.isLimit(a)) return void (o || s != a || t.deleteContent(n));

                if (o) {
                  var _t240 = ym(e.model.schema, n.getAttributes());

                  Em(e, r.start), e.setSelectionAttribute(_t240);
                } else {
                  var _i168 = !(r.start.isAtStart && r.end.isAtEnd),
                      _o90 = s == a;

                  t.deleteContent(n, {
                    leaveUnmerged: _i168
                  }), _i168 && (_o90 ? Em(e, n.focus) : e.setSelection(a, 0));
                }
              }(_this169.editor.model, n, e.selection, t.schema), _this169.fire("afterExecute", {
                writer: n
              });
            });
          }
        }]);

        return xm;
      }(me);

      function Em(t, e) {
        t.split(e), t.setSelection(e.parent.nextSibling, 0);
      }

      var Dm = /*#__PURE__*/function (_As7) {
        _inherits(Dm, _As7);

        var _super91 = _createSuper(Dm);

        function Dm(t) {
          var _this170;

          _classCallCheck(this, Dm);

          _this170 = _super91.call(this, t);
          var e = _this170.document;
          e.on("keydown", function (t, n) {
            if (_this170.isEnabled && n.keyCode == dr.enter) {
              var _i169 = new qo(e, "enter", e.selection.getFirstRange());

              e.fire(_i169, new Hs(e, n.domEvent, {
                isSoft: n.shiftKey
              })), _i169.stop.called && t.stop();
            }
          });
          return _this170;
        }

        _createClass(Dm, [{
          key: "observe",
          value: function observe() {}
        }]);

        return Dm;
      }(As);

      var Sm = /*#__PURE__*/function (_ue9) {
        _inherits(Sm, _ue9);

        var _super92 = _createSuper(Sm);

        function Sm() {
          _classCallCheck(this, Sm);

          return _super92.apply(this, arguments);
        }

        _createClass(Sm, [{
          key: "init",
          value: function init() {
            var t = this.editor,
                e = t.editing.view,
                n = e.document;
            e.addObserver(Dm), t.commands.add("enter", new xm(t)), this.listenTo(n, "enter", function (n, i) {
              i.preventDefault(), i.isSoft || (t.execute("enter"), e.scrollToTheSelection());
            }, {
              priority: "low"
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "Enter";
          }
        }]);

        return Sm;
      }(ue);

      var Im = /*#__PURE__*/function (_me5) {
        _inherits(Im, _me5);

        var _super93 = _createSuper(Im);

        function Im() {
          _classCallCheck(this, Im);

          return _super93.apply(this, arguments);
        }

        _createClass(Im, [{
          key: "execute",
          value: function execute() {
            var _this171 = this;

            var t = this.editor.model,
                e = t.document;
            t.change(function (n) {
              !function (t, e, n) {
                var i = n.isCollapsed,
                    o = n.getFirstRange(),
                    r = o.start.parent,
                    s = o.end.parent,
                    a = r == s;

                if (i) {
                  var _i170 = ym(t.schema, n.getAttributes());

                  Mm(t, e, o.end), e.removeSelectionAttribute(n.getAttributeKeys()), e.setSelectionAttribute(_i170);
                } else {
                  var _i171 = !(o.start.isAtStart && o.end.isAtEnd);

                  t.deleteContent(n, {
                    leaveUnmerged: _i171
                  }), a ? Mm(t, e, n.focus) : _i171 && e.setSelection(s, 0);
                }
              }(t, n, e.selection), _this171.fire("afterExecute", {
                writer: n
              });
            });
          }
        }, {
          key: "refresh",
          value: function refresh() {
            var t = this.editor.model,
                e = t.document;

            this.isEnabled = function (t, e) {
              if (e.rangeCount > 1) return !1;
              var n = e.anchor;
              if (!n || !t.checkChild(n, "softBreak")) return !1;
              var i = e.getFirstRange(),
                  o = i.start.parent,
                  r = i.end.parent;
              if ((Tm(o, t) || Tm(r, t)) && o !== r) return !1;
              return !0;
            }(t.schema, e.selection);
          }
        }]);

        return Im;
      }(me);

      function Mm(t, e, n) {
        var i = e.createElement("softBreak");
        t.insertContent(i, n), e.setSelection(i, "after");
      }

      function Tm(t, e) {
        return !t.is("rootElement") && (e.isLimit(t) || Tm(t.parent, e));
      }

      var Nm = /*#__PURE__*/function (_ue10) {
        _inherits(Nm, _ue10);

        var _super94 = _createSuper(Nm);

        function Nm() {
          _classCallCheck(this, Nm);

          return _super94.apply(this, arguments);
        }

        _createClass(Nm, [{
          key: "init",
          value: function init() {
            var t = this.editor,
                e = t.model.schema,
                n = t.conversion,
                i = t.editing.view,
                o = i.document;
            e.register("softBreak", {
              allowWhere: "$text",
              isInline: !0
            }), n.for("upcast").elementToElement({
              model: "softBreak",
              view: "br"
            }), n.for("downcast").elementToElement({
              model: "softBreak",
              view: function view(t, _ref43) {
                var e = _ref43.writer;
                return e.createEmptyElement("br");
              }
            }), i.addObserver(Dm), t.commands.add("shiftEnter", new Im(t)), this.listenTo(o, "enter", function (e, n) {
              n.preventDefault(), n.isSoft && (t.execute("shiftEnter"), i.scrollToTheSelection());
            }, {
              priority: "low"
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "ShiftEnter";
          }
        }]);

        return Nm;
      }(ue);

      var Bm = /*#__PURE__*/function (_me6) {
        _inherits(Bm, _me6);

        var _super95 = _createSuper(Bm);

        function Bm() {
          _classCallCheck(this, Bm);

          return _super95.apply(this, arguments);
        }

        _createClass(Bm, [{
          key: "refresh",
          value: function refresh() {
            this.value = this._getValue(), this.isEnabled = this._checkEnabled();
          }
        }, {
          key: "execute",
          value: function execute() {
            var _this172 = this;

            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var e = this.editor.model,
                n = e.schema,
                i = e.document.selection,
                o = Array.from(i.getSelectedBlocks()),
                r = void 0 === t.forceValue ? !this.value : t.forceValue;
            e.change(function (t) {
              if (r) {
                var _e230 = o.filter(function (t) {
                  return zm(t) || Lm(n, t);
                });

                _this172._applyQuote(t, _e230);
              } else _this172._removeQuote(t, o.filter(zm));
            });
          }
        }, {
          key: "_getValue",
          value: function _getValue() {
            var t = wa(this.editor.model.document.selection.getSelectedBlocks());
            return !(!t || !zm(t));
          }
        }, {
          key: "_checkEnabled",
          value: function _checkEnabled() {
            if (this.value) return !0;
            var t = this.editor.model.document.selection,
                e = this.editor.model.schema,
                n = wa(t.getSelectedBlocks());
            return !!n && Lm(e, n);
          }
        }, {
          key: "_removeQuote",
          value: function _removeQuote(t, e) {
            Pm(t, e).reverse().forEach(function (e) {
              if (e.start.isAtStart && e.end.isAtEnd) return void t.unwrap(e.start.parent);

              if (e.start.isAtStart) {
                var _n215 = t.createPositionBefore(e.start.parent);

                return void t.move(e, _n215);
              }

              e.end.isAtEnd || t.split(e.end);
              var n = t.createPositionAfter(e.end.parent);
              t.move(e, n);
            });
          }
        }, {
          key: "_applyQuote",
          value: function _applyQuote(t, e) {
            var n = [];
            Pm(t, e).reverse().forEach(function (e) {
              var i = zm(e.start);
              i || (i = t.createElement("blockQuote"), t.wrap(e, i)), n.push(i);
            }), n.reverse().reduce(function (e, n) {
              return e.nextSibling == n ? (t.merge(t.createPositionAfter(e)), e) : n;
            });
          }
        }]);

        return Bm;
      }(me);

      function zm(t) {
        return "blockQuote" == t.parent.name ? t.parent : null;
      }

      function Pm(t, e) {
        var n,
            i = 0;
        var o = [];

        for (; i < e.length;) {
          var _r50 = e[i],
              _s28 = e[i + 1];
          n || (n = t.createPositionBefore(_r50)), _s28 && _r50.nextSibling == _s28 || (o.push(t.createRange(n, t.createPositionAfter(_r50))), n = null), i++;
        }

        return o;
      }

      function Lm(t, e) {
        var n = t.checkChild(e.parent, "blockQuote"),
            i = t.checkChild(["$root", "blockQuote"], e);
        return n && i;
      }

      var Rm = /*#__PURE__*/function (_ue11) {
        _inherits(Rm, _ue11);

        var _super96 = _createSuper(Rm);

        function Rm() {
          _classCallCheck(this, Rm);

          return _super96.apply(this, arguments);
        }

        _createClass(Rm, [{
          key: "init",
          value: function init() {
            var t = this.editor,
                e = t.model.schema;
            t.commands.add("blockQuote", new Bm(t)), e.register("blockQuote", {
              allowWhere: "$block",
              allowContentOf: "$root"
            }), t.conversion.elementToElement({
              model: "blockQuote",
              view: "blockquote"
            }), t.model.document.registerPostFixer(function (n) {
              var i = t.model.document.differ.getChanges();

              var _iterator320 = _createForOfIteratorHelper(i),
                  _step320;

              try {
                for (_iterator320.s(); !(_step320 = _iterator320.n()).done;) {
                  var _t241 = _step320.value;

                  if ("insert" == _t241.type) {
                    var _i172 = _t241.position.nodeAfter;
                    if (!_i172) continue;
                    if (_i172.is("element", "blockQuote") && _i172.isEmpty) return n.remove(_i172), !0;
                    if (_i172.is("element", "blockQuote") && !e.checkChild(_t241.position, _i172)) return n.unwrap(_i172), !0;

                    if (_i172.is("element")) {
                      var _t242 = n.createRangeIn(_i172);

                      var _iterator321 = _createForOfIteratorHelper(_t242.getItems()),
                          _step321;

                      try {
                        for (_iterator321.s(); !(_step321 = _iterator321.n()).done;) {
                          var _i173 = _step321.value;
                          if (_i173.is("element", "blockQuote") && !e.checkChild(n.createPositionBefore(_i173), _i173)) return n.unwrap(_i173), !0;
                        }
                      } catch (err) {
                        _iterator321.e(err);
                      } finally {
                        _iterator321.f();
                      }
                    }
                  } else if ("remove" == _t241.type) {
                    var _e231 = _t241.position.parent;
                    if (_e231.is("element", "blockQuote") && _e231.isEmpty) return n.remove(_e231), !0;
                  }
                }
              } catch (err) {
                _iterator320.e(err);
              } finally {
                _iterator320.f();
              }

              return !1;
            });
            var n = this.editor.editing.view.document,
                i = t.model.document.selection,
                o = t.commands.get("blockQuote");
            this.listenTo(n, "enter", function (e, n) {
              if (!i.isCollapsed || !o.value) return;
              i.getLastPosition().parent.isEmpty && (t.execute("blockQuote"), t.editing.view.scrollToTheSelection(), n.preventDefault(), e.stop());
            }, {
              context: "blockquote"
            }), this.listenTo(n, "delete", function (e, n) {
              if ("backward" != n.direction || !i.isCollapsed || !o.value) return;
              var r = i.getLastPosition().parent;
              r.isEmpty && !r.previousSibling && (t.execute("blockQuote"), t.editing.view.scrollToTheSelection(), n.preventDefault(), e.stop());
            }, {
              context: "blockquote"
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "BlockQuoteEditing";
          }
        }, {
          key: "requires",
          get: function get() {
            return [Sm, Ag];
          }
        }]);

        return Rm;
      }(ue);

      var Om = n(7614),
          jm = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Om.Z, jm), Om.Z.locals;

      var Fm = /*#__PURE__*/function (_ue12) {
        _inherits(Fm, _ue12);

        var _super97 = _createSuper(Fm);

        function Fm() {
          _classCallCheck(this, Fm);

          return _super97.apply(this, arguments);
        }

        _createClass(Fm, [{
          key: "init",
          value: function init() {
            var _this173 = this;

            var t = this.editor,
                e = t.t;
            t.ui.componentFactory.add("blockQuote", function (n) {
              var i = t.commands.get("blockQuote"),
                  o = new oh(n);
              return o.set({
                label: e("Block quote"),
                icon: Ad.quote,
                tooltip: !0,
                isToggleable: !0
              }), o.bind("isOn", "isEnabled").to(i, "value", "isEnabled"), _this173.listenTo(o, "execute", function () {
                t.execute("blockQuote"), t.editing.view.focus();
              }), o;
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "BlockQuoteUI";
          }
        }]);

        return Fm;
      }(ue);

      var Vm = /*#__PURE__*/function (_ue13) {
        _inherits(Vm, _ue13);

        var _super98 = _createSuper(Vm);

        function Vm() {
          _classCallCheck(this, Vm);

          return _super98.apply(this, arguments);
        }

        _createClass(Vm, null, [{
          key: "requires",
          get: function get() {
            return [Rm, Fm];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "BlockQuote";
          }
        }]);

        return Vm;
      }(ue);

      var Um = /*#__PURE__*/function (_me7) {
        _inherits(Um, _me7);

        var _super99 = _createSuper(Um);

        function Um(t, e) {
          var _this174;

          _classCallCheck(this, Um);

          _this174 = _super99.call(this, t), _this174.attributeKey = e;
          return _this174;
        }

        _createClass(Um, [{
          key: "refresh",
          value: function refresh() {
            var t = this.editor.model,
                e = t.document;
            this.value = this._getValueFromFirstAllowedNode(), this.isEnabled = t.schema.checkAttributeInSelection(e.selection, this.attributeKey);
          }
        }, {
          key: "execute",
          value: function execute() {
            var _this175 = this;

            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var e = this.editor.model,
                n = e.document.selection,
                i = void 0 === t.forceValue ? !this.value : t.forceValue;
            e.change(function (t) {
              if (n.isCollapsed) i ? t.setSelectionAttribute(_this175.attributeKey, !0) : t.removeSelectionAttribute(_this175.attributeKey);else {
                var _o91 = e.schema.getValidRanges(n.getRanges(), _this175.attributeKey);

                var _iterator322 = _createForOfIteratorHelper(_o91),
                    _step322;

                try {
                  for (_iterator322.s(); !(_step322 = _iterator322.n()).done;) {
                    var _e232 = _step322.value;
                    i ? t.setAttribute(_this175.attributeKey, i, _e232) : t.removeAttribute(_this175.attributeKey, _e232);
                  }
                } catch (err) {
                  _iterator322.e(err);
                } finally {
                  _iterator322.f();
                }
              }
            });
          }
        }, {
          key: "_getValueFromFirstAllowedNode",
          value: function _getValueFromFirstAllowedNode() {
            var t = this.editor.model,
                e = t.schema,
                n = t.document.selection;
            if (n.isCollapsed) return n.hasAttribute(this.attributeKey);

            var _iterator323 = _createForOfIteratorHelper(n.getRanges()),
                _step323;

            try {
              for (_iterator323.s(); !(_step323 = _iterator323.n()).done;) {
                var _t243 = _step323.value;

                var _iterator324 = _createForOfIteratorHelper(_t243.getItems()),
                    _step324;

                try {
                  for (_iterator324.s(); !(_step324 = _iterator324.n()).done;) {
                    var _n216 = _step324.value;
                    if (e.checkAttribute(_n216, this.attributeKey)) return _n216.hasAttribute(this.attributeKey);
                  }
                } catch (err) {
                  _iterator324.e(err);
                } finally {
                  _iterator324.f();
                }
              }
            } catch (err) {
              _iterator323.e(err);
            } finally {
              _iterator323.f();
            }

            return !1;
          }
        }]);

        return Um;
      }(me);

      var Hm = "bold";

      var qm = /*#__PURE__*/function (_ue14) {
        _inherits(qm, _ue14);

        var _super100 = _createSuper(qm);

        function qm() {
          _classCallCheck(this, qm);

          return _super100.apply(this, arguments);
        }

        _createClass(qm, [{
          key: "init",
          value: function init() {
            var t = this.editor;
            t.model.schema.extend("$text", {
              allowAttributes: Hm
            }), t.model.schema.setAttributeProperties(Hm, {
              isFormatting: !0,
              copyOnEnter: !0
            }), t.conversion.attributeToElement({
              model: Hm,
              view: "strong",
              upcastAlso: ["b", function (t) {
                var e = t.getStyle("font-weight");
                return e ? "bold" == e || Number(e) >= 600 ? {
                  name: !0,
                  styles: ["font-weight"]
                } : void 0 : null;
              }]
            }), t.commands.add(Hm, new Um(t, Hm)), t.keystrokes.set("CTRL+B", Hm);
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "BoldEditing";
          }
        }]);

        return qm;
      }(ue);

      var Wm = "bold";

      var Gm = /*#__PURE__*/function (_ue15) {
        _inherits(Gm, _ue15);

        var _super101 = _createSuper(Gm);

        function Gm() {
          _classCallCheck(this, Gm);

          return _super101.apply(this, arguments);
        }

        _createClass(Gm, [{
          key: "init",
          value: function init() {
            var _this176 = this;

            var t = this.editor,
                e = t.t;
            t.ui.componentFactory.add(Wm, function (n) {
              var i = t.commands.get(Wm),
                  o = new oh(n);
              return o.set({
                label: e("Bold"),
                icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>',
                keystroke: "CTRL+B",
                tooltip: !0,
                isToggleable: !0
              }), o.bind("isOn", "isEnabled").to(i, "value", "isEnabled"), _this176.listenTo(o, "execute", function () {
                t.execute(Wm), t.editing.view.focus();
              }), o;
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "BoldUI";
          }
        }]);

        return Gm;
      }(ue);

      var $m = /*#__PURE__*/function (_ue16) {
        _inherits($m, _ue16);

        var _super102 = _createSuper($m);

        function $m() {
          _classCallCheck(this, $m);

          return _super102.apply(this, arguments);
        }

        _createClass($m, null, [{
          key: "requires",
          get: function get() {
            return [qm, Gm];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "Bold";
          }
        }]);

        return $m;
      }(ue);

      var Ym = /*#__PURE__*/function () {
        function Ym() {
          var _this177 = this;

          _classCallCheck(this, Ym);

          var t = new window.FileReader();
          this._reader = t, this._data = void 0, this.set("loaded", 0), t.onprogress = function (t) {
            _this177.loaded = t.loaded;
          };
        }

        _createClass(Ym, [{
          key: "error",
          get: function get() {
            return this._reader.error;
          }
        }, {
          key: "data",
          get: function get() {
            return this._data;
          }
        }, {
          key: "read",
          value: function read(t) {
            var _this178 = this;

            var e = this._reader;
            return this.total = t.size, new Promise(function (n, i) {
              e.onload = function () {
                var t = e.result;
                _this178._data = t, n(t);
              }, e.onerror = function () {
                i("error");
              }, e.onabort = function () {
                i("aborted");
              }, _this178._reader.readAsDataURL(t);
            });
          }
        }, {
          key: "abort",
          value: function abort() {
            this._reader.abort();
          }
        }]);

        return Ym;
      }();

      he(Ym, re);

      var Km = /*#__PURE__*/function (_ue17) {
        _inherits(Km, _ue17);

        var _super103 = _createSuper(Km);

        function Km() {
          _classCallCheck(this, Km);

          return _super103.apply(this, arguments);
        }

        _createClass(Km, [{
          key: "init",
          value: function init() {
            var _this179 = this;

            this.loaders = new Di(), this.loaders.on("add", function () {
              return _this179._updatePendingAction();
            }), this.loaders.on("remove", function () {
              return _this179._updatePendingAction();
            }), this._loadersMap = new Map(), this._pendingAction = null, this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", function (t, e) {
              return e ? t / e * 100 : 0;
            });
          }
        }, {
          key: "getLoader",
          value: function getLoader(t) {
            return this._loadersMap.get(t) || null;
          }
        }, {
          key: "createLoader",
          value: function createLoader(t) {
            var _this180 = this;

            if (!this.createUploadAdapter) return c("filerepository-no-upload-adapter"), null;
            var e = new Qm(Promise.resolve(t), this.createUploadAdapter);
            return this.loaders.add(e), this._loadersMap.set(t, e), t instanceof Promise && e.file.then(function (t) {
              _this180._loadersMap.set(t, e);
            }).catch(function () {}), e.on("change:uploaded", function () {
              var t = 0;

              var _iterator325 = _createForOfIteratorHelper(_this180.loaders),
                  _step325;

              try {
                for (_iterator325.s(); !(_step325 = _iterator325.n()).done;) {
                  var _e233 = _step325.value;
                  t += _e233.uploaded;
                }
              } catch (err) {
                _iterator325.e(err);
              } finally {
                _iterator325.f();
              }

              _this180.uploaded = t;
            }), e.on("change:uploadTotal", function () {
              var t = 0;

              var _iterator326 = _createForOfIteratorHelper(_this180.loaders),
                  _step326;

              try {
                for (_iterator326.s(); !(_step326 = _iterator326.n()).done;) {
                  var _e234 = _step326.value;
                  _e234.uploadTotal && (t += _e234.uploadTotal);
                }
              } catch (err) {
                _iterator326.e(err);
              } finally {
                _iterator326.f();
              }

              _this180.uploadTotal = t;
            }), e;
          }
        }, {
          key: "destroyLoader",
          value: function destroyLoader(t) {
            var _this181 = this;

            var e = t instanceof Qm ? t : this.getLoader(t);
            e._destroy(), this.loaders.remove(e), this._loadersMap.forEach(function (t, n) {
              t === e && _this181._loadersMap.delete(n);
            });
          }
        }, {
          key: "_updatePendingAction",
          value: function _updatePendingAction() {
            var t = this.editor.plugins.get(bd);

            if (this.loaders.length) {
              if (!this._pendingAction) {
                var _e235 = this.editor.t,
                    _n217 = function _n217(t) {
                  return "".concat(_e235("Upload in progress"), " ").concat(parseInt(t), "%.");
                };

                this._pendingAction = t.add(_n217(this.uploadedPercent)), this._pendingAction.bind("message").to(this, "uploadedPercent", _n217);
              }
            } else t.remove(this._pendingAction), this._pendingAction = null;
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "FileRepository";
          }
        }, {
          key: "requires",
          get: function get() {
            return [bd];
          }
        }]);

        return Km;
      }(ue);

      he(Km, re);

      var Qm = /*#__PURE__*/function () {
        function Qm(t, e) {
          _classCallCheck(this, Qm);

          this.id = r(), this._filePromiseWrapper = this._createFilePromiseWrapper(t), this._adapter = e(this), this._reader = new Ym(), this.set("status", "idle"), this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", function (t, e) {
            return e ? t / e * 100 : 0;
          }), this.set("uploadResponse", null);
        }

        _createClass(Qm, [{
          key: "file",
          get: function get() {
            var _this182 = this;

            return this._filePromiseWrapper ? this._filePromiseWrapper.promise.then(function (t) {
              return _this182._filePromiseWrapper ? t : null;
            }) : Promise.resolve(null);
          }
        }, {
          key: "data",
          get: function get() {
            return this._reader.data;
          }
        }, {
          key: "read",
          value: function read() {
            var _this183 = this;

            if ("idle" != this.status) throw new a("filerepository-read-wrong-status", this);
            return this.status = "reading", this.file.then(function (t) {
              return _this183._reader.read(t);
            }).then(function (t) {
              if ("reading" !== _this183.status) throw _this183.status;
              return _this183.status = "idle", t;
            }).catch(function (t) {
              if ("aborted" === t) throw _this183.status = "aborted", "aborted";
              throw _this183.status = "error", _this183._reader.error ? _this183._reader.error : t;
            });
          }
        }, {
          key: "upload",
          value: function upload() {
            var _this184 = this;

            if ("idle" != this.status) throw new a("filerepository-upload-wrong-status", this);
            return this.status = "uploading", this.file.then(function () {
              return _this184._adapter.upload();
            }).then(function (t) {
              return _this184.uploadResponse = t, _this184.status = "idle", t;
            }).catch(function (t) {
              if ("aborted" === _this184.status) throw "aborted";
              throw _this184.status = "error", t;
            });
          }
        }, {
          key: "abort",
          value: function abort() {
            var t = this.status;
            this.status = "aborted", this._filePromiseWrapper.isFulfilled ? "reading" == t ? this._reader.abort() : "uploading" == t && this._adapter.abort && this._adapter.abort() : (this._filePromiseWrapper.promise.catch(function () {}), this._filePromiseWrapper.rejecter("aborted")), this._destroy();
          }
        }, {
          key: "_destroy",
          value: function _destroy() {
            this._filePromiseWrapper = void 0, this._reader = void 0, this._adapter = void 0, this.uploadResponse = void 0;
          }
        }, {
          key: "_createFilePromiseWrapper",
          value: function _createFilePromiseWrapper(t) {
            var e = {};
            return e.promise = new Promise(function (n, i) {
              e.rejecter = i, e.isFulfilled = !1, t.then(function (t) {
                e.isFulfilled = !0, n(t);
              }).catch(function (t) {
                e.isFulfilled = !0, i(t);
              });
            }), e;
          }
        }]);

        return Qm;
      }();

      he(Qm, re);

      var Zm = /*#__PURE__*/function (_Dd23) {
        _inherits(Zm, _Dd23);

        var _super104 = _createSuper(Zm);

        function Zm(t) {
          var _this185;

          _classCallCheck(this, Zm);

          _this185 = _super104.call(this, t), _this185.buttonView = new oh(t), _this185._fileInputView = new Jm(t), _this185._fileInputView.bind("acceptedType").to(_assertThisInitialized(_this185)), _this185._fileInputView.bind("allowMultipleFiles").to(_assertThisInitialized(_this185)), _this185._fileInputView.delegate("done").to(_assertThisInitialized(_this185)), _this185.setTemplate({
            tag: "span",
            attributes: {
              class: "ck-file-dialog-button"
            },
            children: [_this185.buttonView, _this185._fileInputView]
          }), _this185.buttonView.on("execute", function () {
            _this185._fileInputView.open();
          });
          return _this185;
        }

        _createClass(Zm, [{
          key: "focus",
          value: function focus() {
            this.buttonView.focus();
          }
        }]);

        return Zm;
      }(Dd);

      var Jm = /*#__PURE__*/function (_Dd24) {
        _inherits(Jm, _Dd24);

        var _super105 = _createSuper(Jm);

        function Jm(t) {
          var _this186;

          _classCallCheck(this, Jm);

          _this186 = _super105.call(this, t), _this186.set("acceptedType"), _this186.set("allowMultipleFiles", !1);
          var e = _this186.bindTemplate;

          _this186.setTemplate({
            tag: "input",
            attributes: {
              class: ["ck-hidden"],
              type: "file",
              tabindex: "-1",
              accept: e.to("acceptedType"),
              multiple: e.to("allowMultipleFiles")
            },
            on: {
              change: e.to(function () {
                _this186.element && _this186.element.files && _this186.element.files.length && _this186.fire("done", _this186.element.files), _this186.element.value = "";
              })
            }
          });

          return _this186;
        }

        _createClass(Jm, [{
          key: "open",
          value: function open() {
            this.element.click();
          }
        }]);

        return Jm;
      }(Dd);

      var Xm = "ckCsrfToken",
          tp = "abcdefghijklmnopqrstuvwxyz0123456789";

      function ep() {
        var t = function (t) {
          t = t.toLowerCase();
          var e = document.cookie.split(";");

          var _iterator327 = _createForOfIteratorHelper(e),
              _step327;

          try {
            for (_iterator327.s(); !(_step327 = _iterator327.n()).done;) {
              var _n218 = _step327.value;

              var _e236 = _n218.split("=");

              if (decodeURIComponent(_e236[0].trim().toLowerCase()) === t) return decodeURIComponent(_e236[1]);
            }
          } catch (err) {
            _iterator327.e(err);
          } finally {
            _iterator327.f();
          }

          return null;
        }(Xm);

        var e, n;
        return t && 40 == t.length || (t = function (t) {
          var e = "";
          var n = new Uint8Array(t);
          window.crypto.getRandomValues(n);

          for (var _t244 = 0; _t244 < n.length; _t244++) {
            var _i174 = tp.charAt(n[_t244] % tp.length);

            e += Math.random() > .5 ? _i174.toUpperCase() : _i174;
          }

          return e;
        }(40), e = Xm, n = t, document.cookie = encodeURIComponent(e) + "=" + encodeURIComponent(n) + ";path=/"), t;
      }

      var np = /*#__PURE__*/function (_ue18) {
        _inherits(np, _ue18);

        var _super106 = _createSuper(np);

        function np() {
          _classCallCheck(this, np);

          return _super106.apply(this, arguments);
        }

        _createClass(np, [{
          key: "init",
          value: function init() {
            var _this187 = this;

            var t = this.editor.config.get("ckfinder.uploadUrl");
            t && (this.editor.plugins.get(Km).createUploadAdapter = function (e) {
              return new ip(e, t, _this187.editor.t);
            });
          }
        }], [{
          key: "requires",
          get: function get() {
            return [Km];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "CKFinderUploadAdapter";
          }
        }]);

        return np;
      }(ue);

      var ip = /*#__PURE__*/function () {
        function ip(t, e, n) {
          _classCallCheck(this, ip);

          this.loader = t, this.url = e, this.t = n;
        }

        _createClass(ip, [{
          key: "upload",
          value: function upload() {
            var _this188 = this;

            return this.loader.file.then(function (t) {
              return new Promise(function (e, n) {
                _this188._initRequest(), _this188._initListeners(e, n, t), _this188._sendRequest(t);
              });
            });
          }
        }, {
          key: "abort",
          value: function abort() {
            this.xhr && this.xhr.abort();
          }
        }, {
          key: "_initRequest",
          value: function _initRequest() {
            var t = this.xhr = new XMLHttpRequest();
            t.open("POST", this.url, !0), t.responseType = "json";
          }
        }, {
          key: "_initListeners",
          value: function _initListeners(t, e, n) {
            var i = this.xhr,
                o = this.loader,
                r = (0, this.t)("Cannot upload file:") + " ".concat(n.name, ".");
            i.addEventListener("error", function () {
              return e(r);
            }), i.addEventListener("abort", function () {
              return e();
            }), i.addEventListener("load", function () {
              var n = i.response;
              if (!n || !n.uploaded) return e(n && n.error && n.error.message ? n.error.message : r);
              t({
                default: n.url
              });
            }), i.upload && i.upload.addEventListener("progress", function (t) {
              t.lengthComputable && (o.uploadTotal = t.total, o.uploaded = t.loaded);
            });
          }
        }, {
          key: "_sendRequest",
          value: function _sendRequest(t) {
            var e = new FormData();
            e.append("upload", t), e.append("ckCsrfToken", ep()), this.xhr.send(e);
          }
        }]);

        return ip;
      }();

      var op = {
        autoRefresh: !0
      },
          rp = 36e5;

      var sp = /*#__PURE__*/function () {
        function sp(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : op;

          _classCallCheck(this, sp);

          if (!t) throw new a("token-missing-token-url", this);
          e.initValue && this._validateTokenValue(e.initValue), this.set("value", e.initValue), this._refresh = "function" == typeof t ? t : function () {
            return e = t, new Promise(function (t, n) {
              var i = new XMLHttpRequest();
              i.open("GET", e), i.addEventListener("load", function () {
                var e = i.status,
                    o = i.response;
                return e < 200 || e > 299 ? n(new a("token-cannot-download-new-token", null)) : t(o);
              }), i.addEventListener("error", function () {
                return n(new Error("Network Error"));
              }), i.addEventListener("abort", function () {
                return n(new Error("Abort"));
              }), i.send();
            });
            var e;
          }, this._options = Object.assign({}, op, e);
        }

        _createClass(sp, [{
          key: "init",
          value: function init() {
            var _this189 = this;

            return new Promise(function (t, e) {
              _this189.value ? (_this189._options.autoRefresh && _this189._registerRefreshTokenTimeout(), t(_this189)) : _this189.refreshToken().then(t).catch(e);
            });
          }
        }, {
          key: "refreshToken",
          value: function refreshToken() {
            var _this190 = this;

            return this._refresh().then(function (t) {
              _this190._validateTokenValue(t), _this190.set("value", t), _this190._options.autoRefresh && _this190._registerRefreshTokenTimeout();
            }).then(function () {
              return _this190;
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            clearTimeout(this._tokenRefreshTimeout);
          }
        }, {
          key: "_validateTokenValue",
          value: function _validateTokenValue(t) {
            var e = "string" == typeof t,
                n = !/^".*"$/.test(t),
                i = e && 3 === t.split(".").length;
            if (!n || !i) throw new a("token-not-in-jwt-format", this);
          }
        }, {
          key: "_registerRefreshTokenTimeout",
          value: function _registerRefreshTokenTimeout() {
            var _this191 = this;

            var t = this._getTokenRefreshTimeoutTime();

            clearTimeout(this._tokenRefreshTimeout), this._tokenRefreshTimeout = setTimeout(function () {
              _this191.refreshToken();
            }, t);
          }
        }, {
          key: "_getTokenRefreshTimeoutTime",
          value: function _getTokenRefreshTimeoutTime() {
            try {
              var _this$value$split = this.value.split("."),
                  _this$value$split2 = _slicedToArray(_this$value$split, 2),
                  _t245 = _this$value$split2[1],
                  _JSON$parse = JSON.parse(atob(_t245)),
                  _e237 = _JSON$parse.exp;

              if (!_e237) return rp;
              return Math.floor((1e3 * _e237 - Date.now()) / 2);
            } catch (t) {
              return rp;
            }
          }
        }], [{
          key: "create",
          value: function create(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : op;
            return new sp(t, e).init();
          }
        }]);

        return sp;
      }();

      he(sp, re);
      var ap = sp;
      var cp = /^data:(\S*?);base64,/;

      var lp = /*#__PURE__*/function () {
        function lp(t, e, n) {
          _classCallCheck(this, lp);

          if (!t) throw new a("fileuploader-missing-file", null);
          if (!e) throw new a("fileuploader-missing-token", null);
          if (!n) throw new a("fileuploader-missing-api-address", null);
          this.file = function (t) {
            if ("string" != typeof t) return !1;
            var e = t.match(cp);
            return !(!e || !e.length);
          }(t) ? function (t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 512;

            try {
              var _n219 = t.match(cp)[1],
                  _i175 = atob(t.replace(cp, "")),
                  _o92 = [];

              for (var _t246 = 0; _t246 < _i175.length; _t246 += e) {
                var _n220 = _i175.slice(_t246, _t246 + e),
                    _r51 = new Array(_n220.length);

                for (var _t247 = 0; _t247 < _n220.length; _t247++) {
                  _r51[_t247] = _n220.charCodeAt(_t247);
                }

                _o92.push(new Uint8Array(_r51));
              }

              return new Blob(_o92, {
                type: _n219
              });
            } catch (t) {
              throw new a("fileuploader-decoding-image-data-error", null);
            }
          }(t) : t, this._token = e, this._apiAddress = n;
        }

        _createClass(lp, [{
          key: "onProgress",
          value: function onProgress(t) {
            return this.on("progress", function (e, n) {
              return t(n);
            }), this;
          }
        }, {
          key: "onError",
          value: function onError(t) {
            return this.once("error", function (e, n) {
              return t(n);
            }), this;
          }
        }, {
          key: "abort",
          value: function abort() {
            this.xhr.abort();
          }
        }, {
          key: "send",
          value: function send() {
            return this._prepareRequest(), this._attachXHRListeners(), this._sendRequest();
          }
        }, {
          key: "_prepareRequest",
          value: function _prepareRequest() {
            var t = new XMLHttpRequest();
            t.open("POST", this._apiAddress), t.setRequestHeader("Authorization", this._token.value), t.responseType = "json", this.xhr = t;
          }
        }, {
          key: "_attachXHRListeners",
          value: function _attachXHRListeners() {
            var _this192 = this;

            var t = this,
                e = this.xhr;

            function n(e) {
              return function () {
                return t.fire("error", e);
              };
            }

            e.addEventListener("error", n("Network Error")), e.addEventListener("abort", n("Abort")), e.upload && e.upload.addEventListener("progress", function (t) {
              t.lengthComputable && _this192.fire("progress", {
                total: t.total,
                uploaded: t.loaded
              });
            }), e.addEventListener("load", function () {
              var t = e.status,
                  n = e.response;
              if (t < 200 || t > 299) return _this192.fire("error", n.message || n.error);
            });
          }
        }, {
          key: "_sendRequest",
          value: function _sendRequest() {
            var _this193 = this;

            var t = new FormData(),
                e = this.xhr;
            return t.append("file", this.file), new Promise(function (n, i) {
              e.addEventListener("load", function () {
                var t = e.status,
                    o = e.response;
                return t < 200 || t > 299 ? o.message ? i(new a("fileuploader-uploading-data-failed", _this193, {
                  message: o.message
                })) : i(o.error) : n(o);
              }), e.addEventListener("error", function () {
                return i(new Error("Network Error"));
              }), e.addEventListener("abort", function () {
                return i(new Error("Abort"));
              }), e.send(t);
            });
          }
        }]);

        return lp;
      }();

      he(lp, f);

      var dp = /*#__PURE__*/function () {
        function dp(t, e) {
          _classCallCheck(this, dp);

          if (!t) throw new a("uploadgateway-missing-token", null);
          if (!e) throw new a("uploadgateway-missing-api-address", null);
          this._token = t, this._apiAddress = e;
        }

        _createClass(dp, [{
          key: "upload",
          value: function upload(t) {
            return new lp(t, this._token, this._apiAddress);
          }
        }]);

        return dp;
      }();

      var hp = /*#__PURE__*/function (_Pi3) {
        _inherits(hp, _Pi3);

        var _super107 = _createSuper(hp);

        function hp() {
          _classCallCheck(this, hp);

          return _super107.apply(this, arguments);
        }

        _createClass(hp, [{
          key: "createToken",
          value: function createToken(t, e) {
            return new ap(t, e);
          }
        }, {
          key: "createUploadGateway",
          value: function createUploadGateway(t, e) {
            return new dp(t, e);
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "CloudServicesCore";
          }
        }]);

        return hp;
      }(Pi);

      var up = /*#__PURE__*/function (_Pi4) {
        _inherits(up, _Pi4);

        var _super108 = _createSuper(up);

        function up() {
          _classCallCheck(this, up);

          return _super108.apply(this, arguments);
        }

        _createClass(up, [{
          key: "init",
          value: function init() {
            var t = this.context.config.get("cloudServices") || {};

            for (var _e238 in t) {
              this[_e238] = t[_e238];
            }

            if (this._tokens = new Map(), this.tokenUrl) return this.token = this.context.plugins.get("CloudServicesCore").createToken(this.tokenUrl), this._tokens.set(this.tokenUrl, this.token), this.token.init();
            this.token = null;
          }
        }, {
          key: "registerTokenUrl",
          value: function registerTokenUrl(t) {
            if (this._tokens.has(t)) return Promise.resolve(this.getTokenFor(t));
            var e = this.context.plugins.get("CloudServicesCore").createToken(t);
            return this._tokens.set(t, e), e.init();
          }
        }, {
          key: "getTokenFor",
          value: function getTokenFor(t) {
            var e = this._tokens.get(t);

            if (!e) throw new a("cloudservices-token-not-registered", this);
            return e;
          }
        }, {
          key: "destroy",
          value: function destroy() {
            _get(_getPrototypeOf(up.prototype), "destroy", this).call(this);

            var _iterator328 = _createForOfIteratorHelper(this._tokens.values()),
                _step328;

            try {
              for (_iterator328.s(); !(_step328 = _iterator328.n()).done;) {
                var _t248 = _step328.value;

                _t248.destroy();
              }
            } catch (err) {
              _iterator328.e(err);
            } finally {
              _iterator328.f();
            }
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "CloudServices";
          }
        }, {
          key: "requires",
          get: function get() {
            return [hp];
          }
        }]);

        return up;
      }(Pi);

      var gp = /*#__PURE__*/function () {
        function gp(t) {
          _classCallCheck(this, gp);

          this.files = function (t) {
            var e = Array.from(t.files || []),
                n = Array.from(t.items || []);
            if (e.length) return e;
            return n.filter(function (t) {
              return "file" === t.kind;
            }).map(function (t) {
              return t.getAsFile();
            });
          }(t), this._native = t;
        }

        _createClass(gp, [{
          key: "types",
          get: function get() {
            return this._native.types;
          }
        }, {
          key: "getData",
          value: function getData(t) {
            return this._native.getData(t);
          }
        }, {
          key: "setData",
          value: function setData(t, e) {
            this._native.setData(t, e);
          }
        }, {
          key: "effectAllowed",
          get: function get() {
            return this._native.effectAllowed;
          },
          set: function set(t) {
            this._native.effectAllowed = t;
          }
        }, {
          key: "dropEffect",
          get: function get() {
            return this._native.dropEffect;
          },
          set: function set(t) {
            this._native.dropEffect = t;
          }
        }, {
          key: "isCanceled",
          get: function get() {
            return "none" == this._native.dropEffect || !!this._native.mozUserCancelled;
          }
        }]);

        return gp;
      }();

      var mp = /*#__PURE__*/function (_qs7) {
        _inherits(mp, _qs7);

        var _super109 = _createSuper(mp);

        function mp(t) {
          var _this194;

          _classCallCheck(this, mp);

          _this194 = _super109.call(this, t);
          var n = _this194.document;

          function i(t) {
            return function (i, o) {
              o.preventDefault();
              var r = o.dropRange ? [o.dropRange] : null,
                  s = new e(n, t);
              n.fire(s, {
                dataTransfer: o.dataTransfer,
                method: i.name,
                targetRanges: r,
                target: o.target
              }), s.stop.called && o.stopPropagation();
            };
          }

          _this194.domEventType = ["paste", "copy", "cut", "drop", "dragover", "dragstart", "dragend", "dragenter", "dragleave"], _this194.listenTo(n, "paste", i("clipboardInput"), {
            priority: "low"
          }), _this194.listenTo(n, "drop", i("clipboardInput"), {
            priority: "low"
          }), _this194.listenTo(n, "dragover", i("dragging"), {
            priority: "low"
          });
          return _this194;
        }

        _createClass(mp, [{
          key: "onDomEvent",
          value: function onDomEvent(t) {
            var e = {
              dataTransfer: new gp(t.clipboardData ? t.clipboardData : t.dataTransfer)
            };
            "drop" != t.type && "dragover" != t.type || (e.dropRange = function (t, e) {
              var n = e.target.ownerDocument,
                  i = e.clientX,
                  o = e.clientY;
              var r;
              n.caretRangeFromPoint && n.caretRangeFromPoint(i, o) ? r = n.caretRangeFromPoint(i, o) : e.rangeParent && (r = n.createRange(), r.setStart(e.rangeParent, e.rangeOffset), r.collapse(!0));
              if (r) return t.domConverter.domRangeToView(r);
              return null;
            }(this.view, t)), this.fire(t.type, t, e);
          }
        }]);

        return mp;
      }(qs);

      var pp = ["figcaption", "li"];

      function fp(t) {
        var e = "";
        if (t.is("$text") || t.is("$textProxy")) e = t.data;else if (t.is("element", "img") && t.hasAttribute("alt")) e = t.getAttribute("alt");else if (t.is("element", "br")) e = "\n";else {
          var _n221 = null;

          var _iterator329 = _createForOfIteratorHelper(t.getChildren()),
              _step329;

          try {
            for (_iterator329.s(); !(_step329 = _iterator329.n()).done;) {
              var _i176 = _step329.value;

              var _t249 = fp(_i176);

              _n221 && (_n221.is("containerElement") || _i176.is("containerElement")) && (pp.includes(_n221.name) || pp.includes(_i176.name) ? e += "\n" : e += "\n\n"), e += _t249, _n221 = _i176;
            }
          } catch (err) {
            _iterator329.e(err);
          } finally {
            _iterator329.f();
          }
        }
        return e;
      }

      var kp = /*#__PURE__*/function (_ue19) {
        _inherits(kp, _ue19);

        var _super110 = _createSuper(kp);

        function kp() {
          _classCallCheck(this, kp);

          return _super110.apply(this, arguments);
        }

        _createClass(kp, [{
          key: "init",
          value: function init() {
            this.editor.editing.view.addObserver(mp), this._setupPasteDrop(), this._setupCopyCut();
          }
        }, {
          key: "_setupPasteDrop",
          value: function _setupPasteDrop() {
            var _this195 = this;

            var t = this.editor,
                n = t.model,
                i = t.editing.view,
                o = i.document;
            this.listenTo(o, "clipboardInput", function (e) {
              t.isReadOnly && e.stop();
            }, {
              priority: "highest"
            }), this.listenTo(o, "clipboardInput", function (t, n) {
              var o = n.dataTransfer;
              var r = n.content || "";
              var s;
              r || (o.getData("text/html") ? r = function (t) {
                return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, function (t, e) {
                  return 1 == e.length ? " " : e;
                }).replace(/<!--[\s\S]*?-->/g, "");
              }(o.getData("text/html")) : o.getData("text/plain") && (((s = (s = o.getData("text/plain")).replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r?\n\r?\n/g, "</p><p>").replace(/\r?\n/g, "<br>").replace(/^\s/, "&nbsp;").replace(/\s$/, "&nbsp;").replace(/\s\s/g, " &nbsp;")).includes("</p><p>") || s.includes("<br>")) && (s = "<p>".concat(s, "</p>")), r = s), r = _this195.editor.data.htmlProcessor.toView(r));
              var a = new e(_this195, "inputTransformation");
              _this195.fire(a, {
                content: r,
                dataTransfer: o,
                targetRanges: n.targetRanges,
                method: n.method
              }), a.stop.called && t.stop(), i.scrollToTheSelection();
            }, {
              priority: "low"
            }), this.listenTo(this, "inputTransformation", function (t, e) {
              if (e.content.isEmpty) return;

              var i = _this195.editor.data.toModel(e.content, "$clipboardHolder");

              0 != i.childCount && (t.stop(), n.change(function () {
                _this195.fire("contentInsertion", {
                  content: i,
                  method: e.method,
                  dataTransfer: e.dataTransfer,
                  targetRanges: e.targetRanges
                });
              }));
            }, {
              priority: "low"
            }), this.listenTo(this, "contentInsertion", function (t, e) {
              e.resultRange = n.insertContent(e.content);
            }, {
              priority: "low"
            });
          }
        }, {
          key: "_setupCopyCut",
          value: function _setupCopyCut() {
            var _this196 = this;

            var t = this.editor,
                e = t.model.document,
                n = t.editing.view.document;

            function i(i, o) {
              var r = o.dataTransfer;
              o.preventDefault();
              var s = t.data.toView(t.model.getSelectedContent(e.selection));
              n.fire("clipboardOutput", {
                dataTransfer: r,
                content: s,
                method: i.name
              });
            }

            this.listenTo(n, "copy", i, {
              priority: "low"
            }), this.listenTo(n, "cut", function (e, n) {
              t.isReadOnly ? n.preventDefault() : i(e, n);
            }, {
              priority: "low"
            }), this.listenTo(n, "clipboardOutput", function (n, i) {
              i.content.isEmpty || (i.dataTransfer.setData("text/html", _this196.editor.data.htmlProcessor.toData(i.content)), i.dataTransfer.setData("text/plain", fp(i.content))), "cut" == i.method && t.model.deleteContent(e.selection);
            }, {
              priority: "low"
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "ClipboardPipeline";
          }
        }]);

        return kp;
      }(ue);

      var bp = /*#__PURE__*/function () {
        function bp() {
          _classCallCheck(this, bp);

          this._stack = [];
        }

        _createClass(bp, [{
          key: "add",
          value: function add(t, e) {
            var n = this._stack,
                i = n[0];

            this._insertDescriptor(t);

            var o = n[0];
            i === o || wp(i, o) || this.fire("change:top", {
              oldDescriptor: i,
              newDescriptor: o,
              writer: e
            });
          }
        }, {
          key: "remove",
          value: function remove(t, e) {
            var n = this._stack,
                i = n[0];

            this._removeDescriptor(t);

            var o = n[0];
            i === o || wp(i, o) || this.fire("change:top", {
              oldDescriptor: i,
              newDescriptor: o,
              writer: e
            });
          }
        }, {
          key: "_insertDescriptor",
          value: function _insertDescriptor(t) {
            var e = this._stack,
                n = e.findIndex(function (e) {
              return e.id === t.id;
            });
            if (wp(t, e[n])) return;
            n > -1 && e.splice(n, 1);
            var i = 0;

            for (; e[i] && Ap(e[i], t);) {
              i++;
            }

            e.splice(i, 0, t);
          }
        }, {
          key: "_removeDescriptor",
          value: function _removeDescriptor(t) {
            var e = this._stack,
                n = e.findIndex(function (e) {
              return e.id === t;
            });
            n > -1 && e.splice(n, 1);
          }
        }]);

        return bp;
      }();

      function wp(t, e) {
        return t && e && t.priority == e.priority && Cp(t.classes) == Cp(e.classes);
      }

      function Ap(t, e) {
        return t.priority > e.priority || !(t.priority < e.priority) && Cp(t.classes) > Cp(e.classes);
      }

      function Cp(t) {
        return Array.isArray(t) ? t.sort().join(",") : t;
      }

      he(bp, f);
      var _p = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>';
      var vp = "ck-widget_selected";

      function yp(t) {
        return !!t.is("element") && !!t.getCustomProperty("widget");
      }

      function xp(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (!t.is("containerElement")) throw new a("widget-to-widget-wrong-element-type", null, {
          element: t
        });
        return e.setAttribute("contenteditable", "false", t), e.addClass("ck-widget", t), e.setCustomProperty("widget", !0, t), t.getFillerOffset = Np, n.label && function (t, e, n) {
          n.setCustomProperty("widgetLabel", e, t);
        }(t, n.label, e), n.hasSelectionHandle && function (t, e) {
          var n = e.createUIElement("div", {
            class: "ck ck-widget__selection-handle"
          }, function (t) {
            var e = this.toDomElement(t),
                n = new Jd();
            return n.set("content", _p), n.render(), e.appendChild(n.element), e;
          });
          e.insert(e.createPositionAt(t, 0), n), e.addClass(["ck-widget_with-selection-handle"], t);
        }(t, e), Sp(t, e), t;
      }

      function Ep(t, e, n) {
        if (e.classes && n.addClass(Ii(e.classes), t), e.attributes) for (var _i177 in e.attributes) {
          n.setAttribute(_i177, e.attributes[_i177], t);
        }
      }

      function Dp(t, e, n) {
        if (e.classes && n.removeClass(Ii(e.classes), t), e.attributes) for (var _i178 in e.attributes) {
          n.removeAttribute(_i178, t);
        }
      }

      function Sp(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Ep;
        var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Dp;
        var o = new bp();
        o.on("change:top", function (e, o) {
          o.oldDescriptor && i(t, o.oldDescriptor, o.writer), o.newDescriptor && n(t, o.newDescriptor, o.writer);
        }), e.setCustomProperty("addHighlight", function (t, e, n) {
          return o.add(e, n);
        }, t), e.setCustomProperty("removeHighlight", function (t, e, n) {
          return o.remove(e, n);
        }, t);
      }

      function Ip(t) {
        var e = t.getCustomProperty("widgetLabel");
        return e ? "function" == typeof e ? e() : e : "";
      }

      function Mp(t, e) {
        return e.addClass(["ck-editor__editable", "ck-editor__nested-editable"], t), e.setAttribute("contenteditable", t.isReadOnly ? "false" : "true", t), t.on("change:isReadOnly", function (n, i, o) {
          e.setAttribute("contenteditable", o ? "false" : "true", t);
        }), t.on("change:isFocused", function (n, i, o) {
          o ? e.addClass("ck-editor__nested-editable_focused", t) : e.removeClass("ck-editor__nested-editable_focused", t);
        }), Sp(t, e), t;
      }

      function Tp(t, e) {
        var n = t.getSelectedElement();

        if (n) {
          var _i179 = Pp(t);

          if (_i179) return e.createRange(e.createPositionAt(n, _i179));
          if (e.schema.isObject(n) && !e.schema.isInline(n)) return e.createRangeOn(n);
        }

        var i = t.getSelectedBlocks().next().value;

        if (i) {
          if (i.isEmpty) return e.createRange(e.createPositionAt(i, 0));

          var _n222 = e.createPositionAfter(i);

          return t.focus.isTouching(_n222) ? e.createRange(_n222) : e.createRange(e.createPositionBefore(i));
        }

        return e.createRange(t.focus);
      }

      function Np() {
        return null;
      }

      var Bp = "widget-type-around";

      function zp(t, e, n) {
        return t && yp(t) && !n.isInline(e);
      }

      function Pp(t) {
        return t.getAttribute(Bp);
      }

      var Lp = n(178),
          Rp = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Lp.Z, Rp), Lp.Z.locals;
      var Op = ["before", "after"],
          jp = new DOMParser().parseFromString('<svg viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg"><path d="M9.055.263v3.972h-6.77M1 4.216l2-2.038m-2 2 2 2.038"/></svg>', "image/svg+xml").firstChild,
          Fp = "ck-widget__type-around_disabled";

      var Vp = /*#__PURE__*/function (_ue20) {
        _inherits(Vp, _ue20);

        var _super111 = _createSuper(Vp);

        function Vp(t) {
          var _this197;

          _classCallCheck(this, Vp);

          _this197 = _super111.call(this, t), _this197._currentFakeCaretModelElement = null;
          return _this197;
        }

        _createClass(Vp, [{
          key: "init",
          value: function init() {
            var t = this.editor,
                e = t.editing.view;
            this.on("change:isEnabled", function (n, i, o) {
              e.change(function (t) {
                var _iterator330 = _createForOfIteratorHelper(e.document.roots),
                    _step330;

                try {
                  for (_iterator330.s(); !(_step330 = _iterator330.n()).done;) {
                    var _n223 = _step330.value;
                    o ? t.removeClass(Fp, _n223) : t.addClass(Fp, _n223);
                  }
                } catch (err) {
                  _iterator330.e(err);
                } finally {
                  _iterator330.f();
                }
              }), o || t.model.change(function (t) {
                t.removeSelectionAttribute(Bp);
              });
            }), this._enableTypeAroundUIInjection(), this._enableInsertingParagraphsOnButtonClick(), this._enableInsertingParagraphsOnEnterKeypress(), this._enableInsertingParagraphsOnTypingKeystroke(), this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows(), this._enableDeleteIntegration(), this._enableInsertContentIntegration(), this._enableDeleteContentIntegration();
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this._currentFakeCaretModelElement = null;
          }
        }, {
          key: "_insertParagraph",
          value: function _insertParagraph(t, e) {
            var n = this.editor,
                i = n.editing.view;
            n.execute("insertParagraph", {
              position: n.model.createPositionAt(t, e)
            }), i.focus(), i.scrollToTheSelection();
          }
        }, {
          key: "_listenToIfEnabled",
          value: function _listenToIfEnabled(t, e, n, i) {
            var _this198 = this;

            this.listenTo(t, e, function () {
              _this198.isEnabled && n.apply(void 0, arguments);
            }, i);
          }
        }, {
          key: "_insertParagraphAccordingToFakeCaretPosition",
          value: function _insertParagraphAccordingToFakeCaretPosition() {
            var t = this.editor.model.document.selection,
                e = Pp(t);
            if (!e) return !1;
            var n = t.getSelectedElement();
            return this._insertParagraph(n, e), !0;
          }
        }, {
          key: "_enableTypeAroundUIInjection",
          value: function _enableTypeAroundUIInjection() {
            var t = this.editor,
                e = t.model.schema,
                n = t.locale.t,
                i = {
              before: n("Insert paragraph before block"),
              after: n("Insert paragraph after block")
            };
            t.editing.downcastDispatcher.on("insert", function (t, n, o) {
              var r = o.mapper.toViewElement(n.item);
              zp(r, n.item, e) && function (t, e, n) {
                var i = t.createUIElement("div", {
                  class: "ck ck-reset_all ck-widget__type-around"
                }, function (t) {
                  var n = this.toDomElement(t);
                  return function (t, e) {
                    var _iterator331 = _createForOfIteratorHelper(Op),
                        _step331;

                    try {
                      for (_iterator331.s(); !(_step331 = _iterator331.n()).done;) {
                        var _n224 = _step331.value;

                        var _i180 = new Sd({
                          tag: "div",
                          attributes: {
                            class: ["ck", "ck-widget__type-around__button", "ck-widget__type-around__button_".concat(_n224)],
                            title: e[_n224]
                          },
                          children: [t.ownerDocument.importNode(jp, !0)]
                        });

                        t.appendChild(_i180.render());
                      }
                    } catch (err) {
                      _iterator331.e(err);
                    } finally {
                      _iterator331.f();
                    }
                  }(n, e), function (t) {
                    var e = new Sd({
                      tag: "div",
                      attributes: {
                        class: ["ck", "ck-widget__type-around__fake-caret"]
                      }
                    });
                    t.appendChild(e.render());
                  }(n), n;
                });
                t.insert(t.createPositionAt(n, "end"), i);
              }(o.writer, i, r);
            }, {
              priority: "low"
            });
          }
        }, {
          key: "_enableTypeAroundFakeCaretActivationUsingKeyboardArrows",
          value: function _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() {
            var _this199 = this;

            var t = this.editor,
                e = t.model,
                n = e.document.selection,
                i = e.schema,
                o = t.editing.view;

            function r(t) {
              return "ck-widget_type-around_show-fake-caret_".concat(t);
            }

            this._listenToIfEnabled(o.document, "arrowKey", function (t, e) {
              _this199._handleArrowKeyPress(t, e);
            }, {
              context: [yp, "$text"],
              priority: "high"
            }), this._listenToIfEnabled(n, "change:range", function (e, n) {
              n.directChange && t.model.change(function (t) {
                t.removeSelectionAttribute(Bp);
              });
            }), this._listenToIfEnabled(e.document, "change:data", function () {
              var e = n.getSelectedElement();

              if (e) {
                if (zp(t.editing.mapper.toViewElement(e), e, i)) return;
              }

              t.model.change(function (t) {
                t.removeSelectionAttribute(Bp);
              });
            }), this._listenToIfEnabled(t.editing.downcastDispatcher, "selection", function (t, e, n) {
              var o = n.writer;

              if (_this199._currentFakeCaretModelElement) {
                var _t250 = n.mapper.toViewElement(_this199._currentFakeCaretModelElement);

                _t250 && (o.removeClass(Op.map(r), _t250), _this199._currentFakeCaretModelElement = null);
              }

              var s = e.selection.getSelectedElement();
              if (!s) return;
              var a = n.mapper.toViewElement(s);
              if (!zp(a, s, i)) return;
              var c = Pp(e.selection);
              c && (o.addClass(r(c), a), _this199._currentFakeCaretModelElement = s);
            }), this._listenToIfEnabled(t.ui.focusTracker, "change:isFocused", function (e, n, i) {
              i || t.model.change(function (t) {
                t.removeSelectionAttribute(Bp);
              });
            });
          }
        }, {
          key: "_handleArrowKeyPress",
          value: function _handleArrowKeyPress(t, e) {
            var n = this.editor,
                i = n.model,
                o = i.document.selection,
                r = i.schema,
                s = n.editing.view,
                a = function (t, e) {
              var n = pr(t, e);
              return "down" === n || "right" === n;
            }(e.keyCode, n.locale.contentLanguageDirection),
                c = s.document.selection.getSelectedElement();

            var l;
            zp(c, n.editing.mapper.toModelElement(c), r) ? l = this._handleArrowKeyPressOnSelectedWidget(a) : o.isCollapsed ? l = this._handleArrowKeyPressWhenSelectionNextToAWidget(a) : e.shiftKey || (l = this._handleArrowKeyPressWhenNonCollapsedSelection(a)), l && (e.preventDefault(), t.stop());
          }
        }, {
          key: "_handleArrowKeyPressOnSelectedWidget",
          value: function _handleArrowKeyPressOnSelectedWidget(t) {
            var e = this.editor.model,
                n = Pp(e.document.selection);
            return e.change(function (e) {
              if (!n) return e.setSelectionAttribute(Bp, t ? "after" : "before"), !0;
              if (!(n === (t ? "after" : "before"))) return e.removeSelectionAttribute(Bp), !0;
              return !1;
            });
          }
        }, {
          key: "_handleArrowKeyPressWhenSelectionNextToAWidget",
          value: function _handleArrowKeyPressWhenSelectionNextToAWidget(t) {
            var e = this.editor,
                n = e.model,
                i = n.schema,
                o = e.plugins.get("Widget"),
                r = o._getObjectElementNextToSelection(t);

            return !!zp(e.editing.mapper.toViewElement(r), r, i) && (n.change(function (e) {
              o._setSelectionOverElement(r), e.setSelectionAttribute(Bp, t ? "before" : "after");
            }), !0);
          }
        }, {
          key: "_handleArrowKeyPressWhenNonCollapsedSelection",
          value: function _handleArrowKeyPressWhenNonCollapsedSelection(t) {
            var e = this.editor,
                n = e.model,
                i = n.schema,
                o = e.editing.mapper,
                r = n.document.selection,
                s = t ? r.getLastPosition().nodeBefore : r.getFirstPosition().nodeAfter;
            return !!zp(o.toViewElement(s), s, i) && (n.change(function (e) {
              e.setSelection(s, "on"), e.setSelectionAttribute(Bp, t ? "after" : "before");
            }), !0);
          }
        }, {
          key: "_enableInsertingParagraphsOnButtonClick",
          value: function _enableInsertingParagraphsOnButtonClick() {
            var _this200 = this;

            var t = this.editor,
                e = t.editing.view;

            this._listenToIfEnabled(e.document, "mousedown", function (n, i) {
              var o = i.domTarget.closest(".ck-widget__type-around__button");
              if (!o) return;

              var r = function (t) {
                return t.classList.contains("ck-widget__type-around__button_before") ? "before" : "after";
              }(o),
                  s = function (t, e) {
                var n = t.closest(".ck-widget");
                return e.mapDomToView(n);
              }(o, e.domConverter),
                  a = t.editing.mapper.toModelElement(s);

              _this200._insertParagraph(a, r), i.preventDefault(), n.stop();
            });
          }
        }, {
          key: "_enableInsertingParagraphsOnEnterKeypress",
          value: function _enableInsertingParagraphsOnEnterKeypress() {
            var _this201 = this;

            var t = this.editor,
                e = t.model.document.selection,
                n = t.editing.view;

            this._listenToIfEnabled(n.document, "enter", function (n, i) {
              if ("atTarget" != n.eventPhase) return;
              var o = e.getSelectedElement(),
                  r = t.editing.mapper.toViewElement(o),
                  s = t.model.schema;
              var a;
              _this201._insertParagraphAccordingToFakeCaretPosition() ? a = !0 : zp(r, o, s) && (_this201._insertParagraph(o, i.isSoft ? "before" : "after"), a = !0), a && (i.preventDefault(), n.stop());
            }, {
              context: yp
            });
          }
        }, {
          key: "_enableInsertingParagraphsOnTypingKeystroke",
          value: function _enableInsertingParagraphsOnTypingKeystroke() {
            var _this202 = this;

            var t = this.editor.editing.view,
                e = [dr.enter, dr.delete, dr.backspace];

            this._listenToIfEnabled(t.document, "keydown", function (t, n) {
              e.includes(n.keyCode) || gg(n) || _this202._insertParagraphAccordingToFakeCaretPosition();
            }, {
              priority: "high"
            });
          }
        }, {
          key: "_enableDeleteIntegration",
          value: function _enableDeleteIntegration() {
            var t = this.editor,
                e = t.editing.view,
                n = t.model,
                i = n.schema;

            this._listenToIfEnabled(e.document, "delete", function (e, o) {
              if ("atTarget" != e.eventPhase) return;
              var r = Pp(n.document.selection);
              if (!r) return;
              var s = o.direction,
                  a = n.document.selection.getSelectedElement(),
                  c = "forward" == s;
              if ("before" === r === c) t.execute("delete", {
                selection: n.createSelection(a, "on")
              });else {
                var _e239 = i.getNearestSelectionRange(n.createPositionAt(a, r), s);

                if (_e239) if (_e239.isCollapsed) {
                  var _o93 = n.createSelection(_e239.start);

                  if (n.modifySelection(_o93, {
                    direction: s
                  }), _o93.focus.isEqual(_e239.start)) {
                    var _t251 = function (t, e) {
                      var n = e;

                      var _iterator332 = _createForOfIteratorHelper(e.getAncestors({
                        parentFirst: !0
                      })),
                          _step332;

                      try {
                        for (_iterator332.s(); !(_step332 = _iterator332.n()).done;) {
                          var _i181 = _step332.value;
                          if (_i181.childCount > 1 || t.isLimit(_i181)) break;
                          n = _i181;
                        }
                      } catch (err) {
                        _iterator332.e(err);
                      } finally {
                        _iterator332.f();
                      }

                      return n;
                    }(i, _e239.start.parent);

                    n.deleteContent(n.createSelection(_t251, "on"), {
                      doNotAutoparagraph: !0
                    });
                  } else n.change(function (n) {
                    n.setSelection(_e239), t.execute(c ? "deleteForward" : "delete");
                  });
                } else n.change(function (n) {
                  n.setSelection(_e239), t.execute(c ? "deleteForward" : "delete");
                });
              }
              o.preventDefault(), e.stop();
            }, {
              context: yp
            });
          }
        }, {
          key: "_enableInsertContentIntegration",
          value: function _enableInsertContentIntegration() {
            var t = this.editor,
                e = this.editor.model,
                n = e.document.selection;

            this._listenToIfEnabled(t.model, "insertContent", function (t, _ref44) {
              var _ref45 = _slicedToArray(_ref44, 2),
                  i = _ref45[0],
                  o = _ref45[1];

              if (o && !o.is("documentSelection")) return;
              var r = Pp(n);
              return r ? (t.stop(), e.change(function (t) {
                var o = n.getSelectedElement(),
                    s = e.createPositionAt(o, r),
                    a = t.createSelection(s),
                    c = e.insertContent(i, a);
                return t.setSelection(a), c;
              })) : void 0;
            }, {
              priority: "high"
            });
          }
        }, {
          key: "_enableDeleteContentIntegration",
          value: function _enableDeleteContentIntegration() {
            var t = this.editor,
                e = this.editor.model.document.selection;

            this._listenToIfEnabled(t.model, "deleteContent", function (t, _ref46) {
              var _ref47 = _slicedToArray(_ref46, 1),
                  n = _ref47[0];

              if (n && !n.is("documentSelection")) return;
              Pp(e) && t.stop();
            }, {
              priority: "high"
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "WidgetTypeAround";
          }
        }, {
          key: "requires",
          get: function get() {
            return [Sm, Ag];
          }
        }]);

        return Vp;
      }(ue);

      function Up(t) {
        var e = t.model;
        return function (n, i) {
          var o = i.keyCode == dr.arrowup,
              r = i.keyCode == dr.arrowdown,
              s = i.shiftKey,
              a = e.document.selection;
          if (!o && !r) return;
          var c = r;
          if (s && function (t, e) {
            return !t.isCollapsed && t.isBackward == e;
          }(a, c)) return;

          var l = function (t, e, n) {
            var i = t.model;

            if (n) {
              var _t252 = e.isCollapsed ? e.focus : e.getLastPosition(),
                  _n225 = Hp(i, _t252, "forward");

              if (!_n225) return null;

              var _o94 = i.createRange(_t252, _n225),
                  _r52 = qp(i.schema, _o94, "backward");

              return _r52 ? i.createRange(_t252, _r52) : null;
            }

            {
              var _t253 = e.isCollapsed ? e.focus : e.getFirstPosition(),
                  _n226 = Hp(i, _t253, "backward");

              if (!_n226) return null;

              var _o95 = i.createRange(_n226, _t253),
                  _r53 = qp(i.schema, _o95, "forward");

              return _r53 ? i.createRange(_r53, _t253) : null;
            }
          }(t, a, c);

          if (l) {
            if (l.isCollapsed) {
              if (a.isCollapsed) return;
              if (s) return;
            }

            (l.isCollapsed || function (t, e, n) {
              var i = t.model,
                  o = t.view.domConverter;

              if (n) {
                var _t254 = i.createSelection(e.start);

                i.modifySelection(_t254), _t254.focus.isAtEnd || e.start.isEqual(_t254.focus) || (e = i.createRange(_t254.focus, e.end));
              }

              var r = t.mapper.toViewRange(e),
                  s = o.viewRangeToDom(r),
                  a = ma.getDomRangeRects(s);
              var c;

              var _iterator333 = _createForOfIteratorHelper(a),
                  _step333;

              try {
                for (_iterator333.s(); !(_step333 = _iterator333.n()).done;) {
                  var _t255 = _step333.value;

                  if (void 0 !== c) {
                    if (Math.round(_t255.top) >= c) return !1;
                    c = Math.max(c, Math.round(_t255.bottom));
                  } else c = Math.round(_t255.bottom);
                }
              } catch (err) {
                _iterator333.e(err);
              } finally {
                _iterator333.f();
              }

              return !0;
            }(t, l, c)) && (e.change(function (t) {
              var n = c ? l.end : l.start;

              if (s) {
                var _i182 = e.createSelection(a.anchor);

                _i182.setFocus(n), t.setSelection(_i182);
              } else t.setSelection(n);
            }), n.stop(), i.preventDefault(), i.stopPropagation());
          }
        };
      }

      function Hp(t, e, n) {
        var i = t.schema,
            o = t.createRangeIn(e.root),
            r = "forward" == n ? "elementStart" : "elementEnd";

        var _iterator334 = _createForOfIteratorHelper(o.getWalker({
          startPosition: e,
          direction: n
        })),
            _step334;

        try {
          for (_iterator334.s(); !(_step334 = _iterator334.n()).done;) {
            var _step334$value = _step334.value,
                _t256 = _step334$value.previousPosition,
                _s29 = _step334$value.item,
                _a16 = _step334$value.type;
            if (i.isLimit(_s29) && !i.isInline(_s29)) return _t256;
            if (_a16 == r && i.isBlock(_s29)) return null;
          }
        } catch (err) {
          _iterator334.e(err);
        } finally {
          _iterator334.f();
        }

        return null;
      }

      function qp(t, e, n) {
        var i = "backward" == n ? e.end : e.start;
        if (t.checkChild(i, "$text")) return i;

        var _iterator335 = _createForOfIteratorHelper(e.getWalker({
          direction: n
        })),
            _step335;

        try {
          for (_iterator335.s(); !(_step335 = _iterator335.n()).done;) {
            var _i183 = _step335.value.nextPosition;
            if (t.checkChild(_i183, "$text")) return _i183;
          }
        } catch (err) {
          _iterator335.e(err);
        } finally {
          _iterator335.f();
        }

        return null;
      }

      var Wp = n(7482),
          Gp = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Wp.Z, Gp), Wp.Z.locals;

      var $p = /*#__PURE__*/function (_ue21) {
        _inherits($p, _ue21);

        var _super112 = _createSuper($p);

        function $p() {
          _classCallCheck(this, $p);

          return _super112.apply(this, arguments);
        }

        _createClass($p, [{
          key: "init",
          value: function init() {
            var _this203 = this;

            var t = this.editor,
                e = t.editing.view,
                n = e.document;
            this._previouslySelected = new Set(), this.editor.editing.downcastDispatcher.on("selection", function (e, n, i) {
              var o = i.writer,
                  r = n.selection;
              if (r.isCollapsed) return;
              var s = r.getSelectedElement();
              if (!s) return;
              var a = t.editing.mapper.toViewElement(s);
              yp(a) && i.consumable.consume(r, "selection") && o.setSelection(o.createRangeOn(a), {
                fake: !0,
                label: Ip(a)
              });
            }), this.editor.editing.downcastDispatcher.on("selection", function (t, e, n) {
              _this203._clearPreviouslySelectedWidgets(n.writer);

              var i = n.writer,
                  o = i.document.selection;
              var r = null;

              var _iterator336 = _createForOfIteratorHelper(o.getRanges()),
                  _step336;

              try {
                for (_iterator336.s(); !(_step336 = _iterator336.n()).done;) {
                  var _t257 = _step336.value;

                  var _iterator337 = _createForOfIteratorHelper(_t257),
                      _step337;

                  try {
                    for (_iterator337.s(); !(_step337 = _iterator337.n()).done;) {
                      var _e240 = _step337.value;
                      var _t258 = _e240.item;
                      yp(_t258) && !Yp(_t258, r) && (i.addClass(vp, _t258), _this203._previouslySelected.add(_t258), r = _t258);
                    }
                  } catch (err) {
                    _iterator337.e(err);
                  } finally {
                    _iterator337.f();
                  }
                }
              } catch (err) {
                _iterator336.e(err);
              } finally {
                _iterator336.f();
              }
            }, {
              priority: "low"
            }), e.addObserver(tg), this.listenTo(n, "mousedown", function () {
              return _this203._onMousedown.apply(_this203, arguments);
            }), this.listenTo(n, "arrowKey", function () {
              _this203._handleSelectionChangeOnArrowKeyPress.apply(_this203, arguments);
            }, {
              context: [yp, "$text"]
            }), this.listenTo(n, "arrowKey", function () {
              _this203._preventDefaultOnArrowKeyPress.apply(_this203, arguments);
            }, {
              context: "$root"
            }), this.listenTo(n, "arrowKey", Up(this.editor.editing), {
              context: "$text"
            }), this.listenTo(n, "delete", function (t, e) {
              _this203._handleDelete("forward" == e.direction) && (e.preventDefault(), t.stop());
            }, {
              context: "$root"
            });
          }
        }, {
          key: "_onMousedown",
          value: function _onMousedown(t, e) {
            var n = this.editor,
                i = n.editing.view,
                o = i.document;
            var r = e.target;

            if (function (t) {
              for (; t;) {
                if (t.is("editableElement") && !t.is("rootElement")) return !0;
                if (yp(t)) return !1;
                t = t.parent;
              }

              return !1;
            }(r)) {
              if ((sr.isSafari || sr.isGecko) && e.domEvent.detail >= 3) {
                var _t259 = n.editing.mapper,
                    _i184 = r.is("attributeElement") ? r.findAncestor(function (t) {
                  return !t.is("attributeElement");
                }) : r,
                    _o96 = _t259.toModelElement(_i184);

                e.preventDefault(), this.editor.model.change(function (t) {
                  t.setSelection(_o96, "in");
                });
              }

              return;
            }

            if (!yp(r) && (r = r.findAncestor(yp), !r)) return;
            sr.isAndroid && e.preventDefault(), o.isFocused || i.focus();
            var s = n.editing.mapper.toModelElement(r);

            this._setSelectionOverElement(s);
          }
        }, {
          key: "_handleSelectionChangeOnArrowKeyPress",
          value: function _handleSelectionChangeOnArrowKeyPress(t, e) {
            var n = e.keyCode,
                i = this.editor.model,
                o = i.schema,
                r = i.document.selection,
                s = r.getSelectedElement(),
                a = pr(n, this.editor.locale.contentLanguageDirection),
                c = "down" == a || "right" == a,
                l = "up" == a || "down" == a;

            if (s && o.isObject(s)) {
              var _n227 = c ? r.getLastPosition() : r.getFirstPosition(),
                  _s30 = o.getNearestSelectionRange(_n227, c ? "forward" : "backward");

              return void (_s30 && (i.change(function (t) {
                t.setSelection(_s30);
              }), e.preventDefault(), t.stop()));
            }

            if (!r.isCollapsed && !e.shiftKey) {
              var _n228 = r.getFirstPosition(),
                  _s31 = r.getLastPosition(),
                  _a17 = _n228.nodeAfter,
                  _l5 = _s31.nodeBefore;

              return void ((_a17 && o.isObject(_a17) || _l5 && o.isObject(_l5)) && (i.change(function (t) {
                t.setSelection(c ? _s31 : _n228);
              }), e.preventDefault(), t.stop()));
            }

            if (!r.isCollapsed) return;

            var d = this._getObjectElementNextToSelection(c);

            if (d && o.isObject(d)) {
              if (o.isInline(d) && l) return;
              this._setSelectionOverElement(d), e.preventDefault(), t.stop();
            }
          }
        }, {
          key: "_preventDefaultOnArrowKeyPress",
          value: function _preventDefaultOnArrowKeyPress(t, e) {
            var n = this.editor.model,
                i = n.schema,
                o = n.document.selection.getSelectedElement();
            o && i.isObject(o) && (e.preventDefault(), t.stop());
          }
        }, {
          key: "_handleDelete",
          value: function _handleDelete(t) {
            var _this204 = this;

            if (this.editor.isReadOnly) return;
            var e = this.editor.model.document.selection;
            if (!e.isCollapsed) return;

            var n = this._getObjectElementNextToSelection(t);

            return n ? (this.editor.model.change(function (t) {
              var i = e.anchor.parent;

              for (; i.isEmpty;) {
                var _e241 = i;
                i = _e241.parent, t.remove(_e241);
              }

              _this204._setSelectionOverElement(n);
            }), !0) : void 0;
          }
        }, {
          key: "_setSelectionOverElement",
          value: function _setSelectionOverElement(t) {
            this.editor.model.change(function (e) {
              e.setSelection(e.createRangeOn(t));
            });
          }
        }, {
          key: "_getObjectElementNextToSelection",
          value: function _getObjectElementNextToSelection(t) {
            var e = this.editor.model,
                n = e.schema,
                i = e.document.selection,
                o = e.createSelection(i);
            if (e.modifySelection(o, {
              direction: t ? "forward" : "backward"
            }), o.isEqual(i)) return null;
            var r = t ? o.focus.nodeBefore : o.focus.nodeAfter;
            return r && n.isObject(r) ? r : null;
          }
        }, {
          key: "_clearPreviouslySelectedWidgets",
          value: function _clearPreviouslySelectedWidgets(t) {
            var _iterator338 = _createForOfIteratorHelper(this._previouslySelected),
                _step338;

            try {
              for (_iterator338.s(); !(_step338 = _iterator338.n()).done;) {
                var _e242 = _step338.value;
                t.removeClass(vp, _e242);
              }
            } catch (err) {
              _iterator338.e(err);
            } finally {
              _iterator338.f();
            }

            this._previouslySelected.clear();
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "Widget";
          }
        }, {
          key: "requires",
          get: function get() {
            return [Vp, Ag];
          }
        }]);

        return $p;
      }(ue);

      function Yp(t, e) {
        return !!e && Array.from(t.getAncestors()).includes(e);
      }

      var Kp = function Kp(t, e, n) {
        var i = !0,
            o = !0;
        if ("function" != typeof t) throw new TypeError("Expected a function");
        return y(n) && (i = "leading" in n ? !!n.leading : i, o = "trailing" in n ? !!n.trailing : o), oa(t, e, {
          leading: i,
          maxWait: e,
          trailing: o
        });
      },
          Qp = n(6147),
          Zp = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };

      Zr()(Qp.Z, Zp), Qp.Z.locals;

      var Jp = /*#__PURE__*/function (_ue22) {
        _inherits(Jp, _ue22);

        var _super113 = _createSuper(Jp);

        function Jp() {
          _classCallCheck(this, Jp);

          return _super113.apply(this, arguments);
        }

        _createClass(Jp, [{
          key: "init",
          value: function init() {
            var _this205 = this;

            var t = this.editor,
                e = t.editing.view;
            this._draggedRange = null, this._draggingUid = "", this._draggableElement = null, this._updateDropMarkerThrottled = Kp(function (t) {
              return _this205._updateDropMarker(t);
            }, 40), this._removeDropMarkerDelayed = ef(function () {
              return _this205._removeDropMarker();
            }, 40), this._clearDraggableAttributesDelayed = ef(function () {
              return _this205._clearDraggableAttributes();
            }, 40), e.addObserver(mp), e.addObserver(tg), this._setupDragging(), this._setupContentInsertionIntegration(), this._setupClipboardInputIntegration(), this._setupDropMarker(), this._setupDraggableAttributeHandling(), this.listenTo(t, "change:isReadOnly", function (t, e, n) {
              n ? _this205.forceDisabled("readOnlyMode") : _this205.clearForceDisabled("readOnlyMode");
            }), this.on("change:isEnabled", function (t, e, n) {
              n || _this205._finalizeDragging(!1);
            }), sr.isAndroid && this.forceDisabled("noAndroidSupport");
          }
        }, {
          key: "destroy",
          value: function destroy() {
            return this._draggedRange && (this._draggedRange.detach(), this._draggedRange = null), this._updateDropMarkerThrottled.cancel(), this._removeDropMarkerDelayed.cancel(), this._clearDraggableAttributesDelayed.cancel(), _get(_getPrototypeOf(Jp.prototype), "destroy", this).call(this);
          }
        }, {
          key: "_setupDragging",
          value: function _setupDragging() {
            var _this206 = this;

            var t = this.editor,
                e = t.model,
                n = e.document,
                i = t.editing.view,
                o = i.document;
            this.listenTo(o, "dragstart", function (i, s) {
              var a = n.selection;
              if (s.target && s.target.is("editableElement")) return void s.preventDefault();
              var c = s.target ? nf(s.target) : null;

              if (c) {
                var _n229 = t.editing.mapper.toModelElement(c);

                _this206._draggedRange = oc.fromRange(e.createRangeOn(_n229)), t.plugins.has("WidgetToolbarRepository") && t.plugins.get("WidgetToolbarRepository").forceDisabled("dragDrop");
              } else if (!o.selection.isCollapsed) {
                var _t260 = o.selection.getSelectedElement();

                _t260 && yp(_t260) || (_this206._draggedRange = oc.fromRange(a.getFirstRange()));
              }

              if (!_this206._draggedRange) return void s.preventDefault();
              _this206._draggingUid = r(), s.dataTransfer.effectAllowed = _this206.isEnabled ? "copyMove" : "copy", s.dataTransfer.setData("application/ckeditor5-dragging-uid", _this206._draggingUid);
              var l = e.createSelection(_this206._draggedRange.toRange()),
                  d = t.data.toView(e.getSelectedContent(l));
              o.fire("clipboardOutput", {
                dataTransfer: s.dataTransfer,
                content: d,
                method: i.name
              }), _this206.isEnabled || (_this206._draggedRange.detach(), _this206._draggedRange = null, _this206._draggingUid = "");
            }, {
              priority: "low"
            }), this.listenTo(o, "dragend", function (t, e) {
              _this206._finalizeDragging(!e.dataTransfer.isCanceled && "move" == e.dataTransfer.dropEffect);
            }, {
              priority: "low"
            }), this.listenTo(o, "dragenter", function () {
              _this206.isEnabled && i.focus();
            }), this.listenTo(o, "dragleave", function () {
              _this206._removeDropMarkerDelayed();
            }), this.listenTo(o, "dragging", function (e, n) {
              if (!_this206.isEnabled) return void (n.dataTransfer.dropEffect = "none");

              _this206._removeDropMarkerDelayed.cancel();

              var i = Xp(t, n.targetRanges, n.target);
              _this206._draggedRange || (n.dataTransfer.dropEffect = "copy"), sr.isGecko || ("copy" == n.dataTransfer.effectAllowed ? n.dataTransfer.dropEffect = "copy" : ["all", "copyMove"].includes(n.dataTransfer.effectAllowed) && (n.dataTransfer.dropEffect = "move")), i && _this206._updateDropMarkerThrottled(i);
            }, {
              priority: "low"
            });
          }
        }, {
          key: "_setupClipboardInputIntegration",
          value: function _setupClipboardInputIntegration() {
            var _this207 = this;

            var t = this.editor,
                e = t.editing.view.document;
            this.listenTo(e, "clipboardInput", function (e, n) {
              if ("drop" != n.method) return;
              var i = Xp(t, n.targetRanges, n.target);
              if (_this207._removeDropMarker(), !i) return _this207._finalizeDragging(!1), void e.stop();
              _this207._draggedRange && _this207._draggingUid != n.dataTransfer.getData("application/ckeditor5-dragging-uid") && (_this207._draggedRange.detach(), _this207._draggedRange = null, _this207._draggingUid = "");
              if ("move" == tf(n.dataTransfer) && _this207._draggedRange && _this207._draggedRange.containsRange(i, !0)) return _this207._finalizeDragging(!1), void e.stop();
              n.targetRanges = [t.editing.mapper.toViewRange(i)];
            }, {
              priority: "high"
            });
          }
        }, {
          key: "_setupContentInsertionIntegration",
          value: function _setupContentInsertionIntegration() {
            var _this208 = this;

            var t = this.editor.plugins.get(kp);
            t.on("contentInsertion", function (t, e) {
              if (!_this208.isEnabled || "drop" !== e.method) return;
              var n = e.targetRanges.map(function (t) {
                return _this208.editor.editing.mapper.toModelRange(t);
              });

              _this208.editor.model.change(function (t) {
                return t.setSelection(n);
              });
            }, {
              priority: "high"
            }), t.on("contentInsertion", function (t, e) {
              if (!_this208.isEnabled || "drop" !== e.method) return;
              var n = "move" == tf(e.dataTransfer),
                  i = !e.resultRange || !e.resultRange.isCollapsed;

              _this208._finalizeDragging(i && n);
            }, {
              priority: "lowest"
            });
          }
        }, {
          key: "_setupDraggableAttributeHandling",
          value: function _setupDraggableAttributeHandling() {
            var _this209 = this;

            var t = this.editor,
                e = t.editing.view,
                n = e.document;
            this.listenTo(n, "mousedown", function (i, o) {
              if (sr.isAndroid || !o) return;

              _this209._clearDraggableAttributesDelayed.cancel();

              var r = nf(o.target);

              if (sr.isBlink && !t.isReadOnly && !r && !n.selection.isCollapsed) {
                var _t261 = n.selection.getSelectedElement();

                _t261 && yp(_t261) || (r = n.selection.editableElement);
              }

              r && (e.change(function (t) {
                t.setAttribute("draggable", "true", r);
              }), _this209._draggableElement = t.editing.mapper.toModelElement(r));
            }), this.listenTo(n, "mouseup", function () {
              sr.isAndroid || _this209._clearDraggableAttributesDelayed();
            });
          }
        }, {
          key: "_clearDraggableAttributes",
          value: function _clearDraggableAttributes() {
            var _this210 = this;

            var t = this.editor.editing;
            t.view.change(function (e) {
              _this210._draggableElement && "$graveyard" != _this210._draggableElement.root.rootName && e.removeAttribute("draggable", t.mapper.toViewElement(_this210._draggableElement)), _this210._draggableElement = null;
            });
          }
        }, {
          key: "_setupDropMarker",
          value: function _setupDropMarker() {
            var t = this.editor;
            t.conversion.for("editingDowncast").markerToHighlight({
              model: "drop-target",
              view: {
                classes: ["ck-clipboard-drop-target-range"]
              }
            }), t.conversion.for("editingDowncast").markerToElement({
              model: "drop-target",
              view: function view(e, _ref48) {
                var n = _ref48.writer;
                if (t.model.schema.checkChild(e.markerRange.start, "$text")) return n.createUIElement("span", {
                  class: "ck ck-clipboard-drop-target-position"
                }, function (t) {
                  var e = this.toDomElement(t);
                  return e.innerHTML = "&NoBreak;<span></span>&NoBreak;", e;
                });
              }
            });
          }
        }, {
          key: "_updateDropMarker",
          value: function _updateDropMarker(t) {
            var e = this.editor,
                n = e.model.markers;
            e.model.change(function (e) {
              n.has("drop-target") ? n.get("drop-target").getRange().isEqual(t) || e.updateMarker("drop-target", {
                range: t
              }) : e.addMarker("drop-target", {
                range: t,
                usingOperation: !1,
                affectsData: !1
              });
            });
          }
        }, {
          key: "_removeDropMarker",
          value: function _removeDropMarker() {
            var t = this.editor.model;
            this._removeDropMarkerDelayed.cancel(), this._updateDropMarkerThrottled.cancel(), t.markers.has("drop-target") && t.change(function (t) {
              t.removeMarker("drop-target");
            });
          }
        }, {
          key: "_finalizeDragging",
          value: function _finalizeDragging(t) {
            var e = this.editor,
                n = e.model;
            this._removeDropMarker(), this._clearDraggableAttributes(), e.plugins.has("WidgetToolbarRepository") && e.plugins.get("WidgetToolbarRepository").clearForceDisabled("dragDrop"), this._draggingUid = "", this._draggedRange && (t && this.isEnabled && n.deleteContent(n.createSelection(this._draggedRange), {
              doNotAutoparagraph: !0
            }), this._draggedRange.detach(), this._draggedRange = null);
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "DragDrop";
          }
        }, {
          key: "requires",
          get: function get() {
            return [kp, $p];
          }
        }]);

        return Jp;
      }(ue);

      function Xp(t, e, n) {
        var i = t.model,
            o = t.editing.mapper;
        var r = null;
        var s = e ? e[0].start : null;
        if (n.is("uiElement") && (n = n.parent), r = function (t, e) {
          var n = t.model,
              i = t.editing.mapper;
          if (yp(e)) return n.createRangeOn(i.toModelElement(e));

          if (!e.is("editableElement")) {
            var _t262 = e.findAncestor(function (t) {
              return yp(t) || t.is("editableElement");
            });

            if (yp(_t262)) return n.createRangeOn(i.toModelElement(_t262));
          }

          return null;
        }(t, n), r) return r;

        var a = function (t, e) {
          var n = t.editing.mapper,
              i = t.editing.view,
              o = n.toModelElement(e);
          if (o) return o;
          var r = i.createPositionBefore(e),
              s = n.findMappedViewAncestor(r);
          return n.toModelElement(s);
        }(t, n),
            c = s ? o.toModelPosition(s) : null;

        return c ? (r = function (t, e, n) {
          var i = t.model;
          if (!i.schema.checkChild(n, "$block")) return null;
          var o = i.createPositionAt(n, 0),
              r = e.path.slice(0, o.path.length),
              s = i.createPositionFromPath(e.root, r).nodeAfter;
          if (s && i.schema.isObject(s)) return i.createRangeOn(s);
          return null;
        }(t, c, a), r || (r = i.schema.getNearestSelectionRange(c, sr.isGecko ? "forward" : "backward"), r || function (t, e) {
          var n = t.model;

          for (; e;) {
            if (n.schema.isObject(e)) return n.createRangeOn(e);
            e = e.parent;
          }
        }(t, c.parent))) : function (t, e) {
          var n = t.model,
              i = n.schema,
              o = n.createPositionAt(e, 0);
          return i.getNearestSelectionRange(o, "forward");
        }(t, a);
      }

      function tf(t) {
        return sr.isGecko ? t.dropEffect : ["all", "copyMove"].includes(t.effectAllowed) ? "move" : "copy";
      }

      function ef(t, e) {
        var n;

        function i() {
          for (var _len21 = arguments.length, o = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
            o[_key21] = arguments[_key21];
          }

          i.cancel(), n = setTimeout(function () {
            return t.apply(void 0, o);
          }, e);
        }

        return i.cancel = function () {
          clearTimeout(n);
        }, i;
      }

      function nf(t) {
        if (t.is("editableElement")) return null;
        if (t.hasClass("ck-widget__selection-handle")) return t.findAncestor(yp);
        if (yp(t)) return t;
        var e = t.findAncestor(function (t) {
          return yp(t) || t.is("editableElement");
        });
        return yp(e) ? e : null;
      }

      var of = /*#__PURE__*/function (_ue23) {
        _inherits(of, _ue23);

        var _super114 = _createSuper(of);

        function of() {
          _classCallCheck(this, of);

          return _super114.apply(this, arguments);
        }

        _createClass(of, [{
          key: "init",
          value: function init() {
            var t = this.editor,
                e = t.model,
                n = t.editing.view,
                i = n.document,
                o = e.document.selection;
            var r = !1;
            n.addObserver(mp), this.listenTo(i, "keydown", function (t, e) {
              r = e.shiftKey;
            }), t.plugins.get(kp).on("contentInsertion", function (t, n) {
              (r || function (t, e) {
                if (t.childCount > 1) return !1;
                var n = t.getChild(0);
                if (e.isObject(n)) return !1;
                return 0 == _toConsumableArray(n.getAttributeKeys()).length;
              }(n.content, e.schema)) && e.change(function (t) {
                var i = Array.from(o.getAttributes()).filter(function (_ref49) {
                  var _ref50 = _slicedToArray(_ref49, 1),
                      t = _ref50[0];

                  return e.schema.getAttributeProperties(t).isFormatting;
                });
                o.isCollapsed || e.deleteContent(o, {
                  doNotAutoparagraph: !0
                }), i.push.apply(i, _toConsumableArray(o.getAttributes()));
                var r = t.createRangeIn(n.content);

                var _iterator339 = _createForOfIteratorHelper(r.getItems()),
                    _step339;

                try {
                  for (_iterator339.s(); !(_step339 = _iterator339.n()).done;) {
                    var _e243 = _step339.value;
                    _e243.is("$textProxy") && t.setAttributes(i, _e243);
                  }
                } catch (err) {
                  _iterator339.e(err);
                } finally {
                  _iterator339.f();
                }
              });
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "PastePlainText";
          }
        }, {
          key: "requires",
          get: function get() {
            return [kp];
          }
        }]);

        return of;
      }(ue);

      var rf = /*#__PURE__*/function (_ue24) {
        _inherits(rf, _ue24);

        var _super115 = _createSuper(rf);

        function rf() {
          _classCallCheck(this, rf);

          return _super115.apply(this, arguments);
        }

        _createClass(rf, null, [{
          key: "pluginName",
          get: function get() {
            return "Clipboard";
          }
        }, {
          key: "requires",
          get: function get() {
            return [kp, Jp, of];
          }
        }]);

        return rf;
      }(ue);

      var sf = /*#__PURE__*/function (_me8) {
        _inherits(sf, _me8);

        var _super116 = _createSuper(sf);

        function sf(t) {
          var _this211;

          _classCallCheck(this, sf);

          _this211 = _super116.call(this, t), _this211.affectsData = !1;
          return _this211;
        }

        _createClass(sf, [{
          key: "execute",
          value: function execute() {
            var t = this.editor.model,
                e = t.document.selection;
            var n = t.schema.getLimitElement(e);
            if (e.containsEntireContent(n) || !af(t.schema, n)) do {
              if (n = n.parent, !n) return;
            } while (!af(t.schema, n));
            t.change(function (t) {
              t.setSelection(n, "in");
            });
          }
        }]);

        return sf;
      }(me);

      function af(t, e) {
        return t.isLimit(e) && (t.checkChild(e, "$text") || t.checkChild(e, "paragraph"));
      }

      var cf = gr("Ctrl+A");

      var lf = /*#__PURE__*/function (_ue25) {
        _inherits(lf, _ue25);

        var _super117 = _createSuper(lf);

        function lf() {
          _classCallCheck(this, lf);

          return _super117.apply(this, arguments);
        }

        _createClass(lf, [{
          key: "init",
          value: function init() {
            var t = this.editor,
                e = t.editing.view.document;
            t.commands.add("selectAll", new sf(t)), this.listenTo(e, "keydown", function (e, n) {
              ur(n) === cf && (t.execute("selectAll"), n.preventDefault());
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "SelectAllEditing";
          }
        }]);

        return lf;
      }(ue);

      var df = /*#__PURE__*/function (_ue26) {
        _inherits(df, _ue26);

        var _super118 = _createSuper(df);

        function df() {
          _classCallCheck(this, df);

          return _super118.apply(this, arguments);
        }

        _createClass(df, [{
          key: "init",
          value: function init() {
            var _this212 = this;

            var t = this.editor;
            t.ui.componentFactory.add("selectAll", function (e) {
              var n = t.commands.get("selectAll"),
                  i = new oh(e),
                  o = e.t;
              return i.set({
                label: o("Select all"),
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M.75 15.5a.75.75 0 0 1 .75.75V18l.008.09A.5.5 0 0 0 2 18.5h1.75a.75.75 0 1 1 0 1.5H1.5l-.144-.007a1.5 1.5 0 0 1-1.35-1.349L0 18.5v-2.25a.75.75 0 0 1 .75-.75zm18.5 0a.75.75 0 0 1 .75.75v2.25l-.007.144a1.5 1.5 0 0 1-1.349 1.35L18.5 20h-2.25a.75.75 0 1 1 0-1.5H18a.5.5 0 0 0 .492-.41L18.5 18v-1.75a.75.75 0 0 1 .75-.75zm-10.45 3c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm.45-5.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5zM1.3 11c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM1.3 7c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5zm-5 0a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5zm-6.5-5a.75.75 0 0 1 0 1.5H2a.5.5 0 0 0-.492.41L1.5 2v1.75a.75.75 0 0 1-1.5 0V1.5l.007-.144A1.5 1.5 0 0 1 1.356.006L1.5 0h2.25zM18.5 0l.144.007a1.5 1.5 0 0 1 1.35 1.349L20 1.5v2.25a.75.75 0 1 1-1.5 0V2l-.008-.09A.5.5 0 0 0 18 1.5h-1.75a.75.75 0 1 1 0-1.5h2.25zM8.8 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6z"/></svg>',
                keystroke: "Ctrl+A",
                tooltip: !0
              }), i.bind("isOn", "isEnabled").to(n, "value", "isEnabled"), _this212.listenTo(i, "execute", function () {
                t.execute("selectAll"), t.editing.view.focus();
              }), i;
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "SelectAllUI";
          }
        }]);

        return df;
      }(ue);

      var hf = /*#__PURE__*/function (_ue27) {
        _inherits(hf, _ue27);

        var _super119 = _createSuper(hf);

        function hf() {
          _classCallCheck(this, hf);

          return _super119.apply(this, arguments);
        }

        _createClass(hf, null, [{
          key: "requires",
          get: function get() {
            return [lf, df];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "SelectAll";
          }
        }]);

        return hf;
      }(ue);

      var uf = /*#__PURE__*/function (_me9) {
        _inherits(uf, _me9);

        var _super120 = _createSuper(uf);

        function uf(t) {
          var _this213;

          _classCallCheck(this, uf);

          _this213 = _super120.call(this, t), _this213._stack = [], _this213._createdBatches = new WeakSet(), _this213.refresh(), _this213.listenTo(t.data, "set", function (t, e) {
            e[1] = _objectSpread({}, e[1]);
            var n = e[1];
            n.batchType || (n.batchType = {
              isUndoable: !1
            });
          }, {
            priority: "high"
          }), _this213.listenTo(t.data, "set", function (t, e) {
            e[1].batchType.isUndoable || _this213.clearStack();
          });
          return _this213;
        }

        _createClass(uf, [{
          key: "refresh",
          value: function refresh() {
            this.isEnabled = this._stack.length > 0;
          }
        }, {
          key: "addBatch",
          value: function addBatch(t) {
            var e = this.editor.model.document.selection,
                n = {
              ranges: e.hasOwnRange ? Array.from(e.getRanges()) : [],
              isBackward: e.isBackward
            };
            this._stack.push({
              batch: t,
              selection: n
            }), this.refresh();
          }
        }, {
          key: "clearStack",
          value: function clearStack() {
            this._stack = [], this.refresh();
          }
        }, {
          key: "_restoreSelection",
          value: function _restoreSelection(t, e, n) {
            var i = this.editor.model,
                o = i.document,
                r = [],
                s = t.map(function (t) {
              return t.getTransformedByOperations(n);
            }),
                a = s.flat();

            var _iterator340 = _createForOfIteratorHelper(s),
                _step340;

            try {
              for (_iterator340.s(); !(_step340 = _iterator340.n()).done;) {
                var _t263 = _step340.value;

                var _e244 = _t263.filter(function (t) {
                  return t.root != o.graveyard;
                }).filter(function (t) {
                  return !mf(t, a);
                });

                _e244.length && (gf(_e244), r.push(_e244[0]));
              }
            } catch (err) {
              _iterator340.e(err);
            } finally {
              _iterator340.f();
            }

            r.length && i.change(function (t) {
              t.setSelection(r, {
                backward: e
              });
            });
          }
        }, {
          key: "_undo",
          value: function _undo(t, e) {
            var n = this.editor.model,
                i = n.document;

            this._createdBatches.add(e);

            var o = t.operations.slice().filter(function (t) {
              return t.isDocumentOperation;
            });
            o.reverse();

            var _iterator341 = _createForOfIteratorHelper(o),
                _step341;

            try {
              for (_iterator341.s(); !(_step341 = _iterator341.n()).done;) {
                var _t264 = _step341.value;

                var _o97 = _t264.baseVersion + 1,
                    _r54 = Array.from(i.history.getOperations(_o97)),
                    _s32 = Gu([_t264.getReversed()], _r54, {
                  useRelations: !0,
                  document: this.editor.model.document,
                  padWithNoOps: !1,
                  forceWeakRemove: !0
                }).operationsA;

                var _iterator342 = _createForOfIteratorHelper(_s32),
                    _step342;

                try {
                  for (_iterator342.s(); !(_step342 = _iterator342.n()).done;) {
                    var _o98 = _step342.value;
                    e.addOperation(_o98), n.applyOperation(_o98), i.history.setOperationAsUndone(_t264, _o98);
                  }
                } catch (err) {
                  _iterator342.e(err);
                } finally {
                  _iterator342.f();
                }
              }
            } catch (err) {
              _iterator341.e(err);
            } finally {
              _iterator341.f();
            }
          }
        }]);

        return uf;
      }(me);

      function gf(t) {
        t.sort(function (t, e) {
          return t.start.isBefore(e.start) ? -1 : 1;
        });

        for (var _e245 = 1; _e245 < t.length; _e245++) {
          var _n230 = t[_e245 - 1].getJoined(t[_e245], !0);

          _n230 && (_e245--, t.splice(_e245, 2, _n230));
        }
      }

      function mf(t, e) {
        return e.some(function (e) {
          return e !== t && e.containsRange(t, !0);
        });
      }

      var pf = /*#__PURE__*/function (_uf) {
        _inherits(pf, _uf);

        var _super121 = _createSuper(pf);

        function pf() {
          _classCallCheck(this, pf);

          return _super121.apply(this, arguments);
        }

        _createClass(pf, [{
          key: "execute",
          value: function execute() {
            var _this214 = this;

            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var e = t ? this._stack.findIndex(function (e) {
              return e.batch == t;
            }) : this._stack.length - 1,
                n = this._stack.splice(e, 1)[0],
                i = this.editor.model.createBatch({
              isUndo: !0
            });

            this.editor.model.enqueueChange(i, function () {
              _this214._undo(n.batch, i);

              var t = _this214.editor.model.document.history.getOperations(n.batch.baseVersion);

              _this214._restoreSelection(n.selection.ranges, n.selection.isBackward, t), _this214.fire("revert", n.batch, i);
            }), this.refresh();
          }
        }]);

        return pf;
      }(uf);

      var ff = /*#__PURE__*/function (_uf2) {
        _inherits(ff, _uf2);

        var _super122 = _createSuper(ff);

        function ff() {
          _classCallCheck(this, ff);

          return _super122.apply(this, arguments);
        }

        _createClass(ff, [{
          key: "execute",
          value: function execute() {
            var _this215 = this;

            var t = this._stack.pop(),
                e = this.editor.model.createBatch({
              isUndo: !0
            });

            this.editor.model.enqueueChange(e, function () {
              var n = t.batch.operations[t.batch.operations.length - 1].baseVersion + 1,
                  i = _this215.editor.model.document.history.getOperations(n);

              _this215._restoreSelection(t.selection.ranges, t.selection.isBackward, i), _this215._undo(t.batch, e);
            }), this.refresh();
          }
        }]);

        return ff;
      }(uf);

      var kf = /*#__PURE__*/function (_ue28) {
        _inherits(kf, _ue28);

        var _super123 = _createSuper(kf);

        function kf(t) {
          var _this216;

          _classCallCheck(this, kf);

          _this216 = _super123.call(this, t), _this216._batchRegistry = new WeakSet();
          return _this216;
        }

        _createClass(kf, [{
          key: "init",
          value: function init() {
            var _this217 = this;

            var t = this.editor;
            this._undoCommand = new pf(t), this._redoCommand = new ff(t), t.commands.add("undo", this._undoCommand), t.commands.add("redo", this._redoCommand), this.listenTo(t.model, "applyOperation", function (t, e) {
              var n = e[0];
              if (!n.isDocumentOperation) return;

              var i = n.batch,
                  o = _this217._redoCommand._createdBatches.has(i),
                  r = _this217._undoCommand._createdBatches.has(i);

              _this217._batchRegistry.has(i) || (_this217._batchRegistry.add(i), i.isUndoable && (o ? _this217._undoCommand.addBatch(i) : r || (_this217._undoCommand.addBatch(i), _this217._redoCommand.clearStack())));
            }, {
              priority: "highest"
            }), this.listenTo(this._undoCommand, "revert", function (t, e, n) {
              _this217._redoCommand.addBatch(n);
            }), t.keystrokes.set("CTRL+Z", "undo"), t.keystrokes.set("CTRL+Y", "redo"), t.keystrokes.set("CTRL+SHIFT+Z", "redo");
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "UndoEditing";
          }
        }]);

        return kf;
      }(ue);

      var bf = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m5.042 9.367 2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>',
          wf = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m14.958 9.367-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>';

      var Af = /*#__PURE__*/function (_ue29) {
        _inherits(Af, _ue29);

        var _super124 = _createSuper(Af);

        function Af() {
          _classCallCheck(this, Af);

          return _super124.apply(this, arguments);
        }

        _createClass(Af, [{
          key: "init",
          value: function init() {
            var t = this.editor,
                e = t.locale,
                n = t.t,
                i = "ltr" == e.uiLanguageDirection ? bf : wf,
                o = "ltr" == e.uiLanguageDirection ? wf : bf;
            this._addButton("undo", n("Undo"), "CTRL+Z", i), this._addButton("redo", n("Redo"), "CTRL+Y", o);
          }
        }, {
          key: "_addButton",
          value: function _addButton(t, e, n, i) {
            var _this218 = this;

            var o = this.editor;
            o.ui.componentFactory.add(t, function (r) {
              var s = o.commands.get(t),
                  a = new oh(r);
              return a.set({
                label: e,
                icon: i,
                keystroke: n,
                tooltip: !0
              }), a.bind("isEnabled").to(s, "isEnabled"), _this218.listenTo(a, "execute", function () {
                o.execute(t), o.editing.view.focus();
              }), a;
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "UndoUI";
          }
        }]);

        return Af;
      }(ue);

      var Cf = /*#__PURE__*/function (_ue30) {
        _inherits(Cf, _ue30);

        var _super125 = _createSuper(Cf);

        function Cf() {
          _classCallCheck(this, Cf);

          return _super125.apply(this, arguments);
        }

        _createClass(Cf, null, [{
          key: "requires",
          get: function get() {
            return [kf, Af];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "Undo";
          }
        }]);

        return Cf;
      }(ue);

      var _f = /*#__PURE__*/function (_ue31) {
        _inherits(_f, _ue31);

        var _super126 = _createSuper(_f);

        function _f() {
          _classCallCheck(this, _f);

          return _super126.apply(this, arguments);
        }

        _createClass(_f, null, [{
          key: "requires",
          get: function get() {
            return [rf, Sm, hf, Nm, Cg, Cf];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "Essentials";
          }
        }]);

        return _f;
      }(ue);

      var vf = /*#__PURE__*/function (_me10) {
        _inherits(vf, _me10);

        var _super127 = _createSuper(vf);

        function vf() {
          _classCallCheck(this, vf);

          return _super127.apply(this, arguments);
        }

        _createClass(vf, [{
          key: "refresh",
          value: function refresh() {
            var t = this.editor.model,
                e = wa(t.document.selection.getSelectedBlocks());
            this.value = !!e && e.is("element", "paragraph"), this.isEnabled = !!e && yf(e, t.schema);
          }
        }, {
          key: "execute",
          value: function execute() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var e = this.editor.model,
                n = e.document;
            e.change(function (i) {
              var o = (t.selection || n.selection).getSelectedBlocks();

              var _iterator343 = _createForOfIteratorHelper(o),
                  _step343;

              try {
                for (_iterator343.s(); !(_step343 = _iterator343.n()).done;) {
                  var _t265 = _step343.value;
                  !_t265.is("element", "paragraph") && yf(_t265, e.schema) && i.rename(_t265, "paragraph");
                }
              } catch (err) {
                _iterator343.e(err);
              } finally {
                _iterator343.f();
              }
            });
          }
        }]);

        return vf;
      }(me);

      function yf(t, e) {
        return e.checkChild(t.parent, "paragraph") && !e.isObject(t);
      }

      var xf = /*#__PURE__*/function (_me11) {
        _inherits(xf, _me11);

        var _super128 = _createSuper(xf);

        function xf() {
          _classCallCheck(this, xf);

          return _super128.apply(this, arguments);
        }

        _createClass(xf, [{
          key: "execute",
          value: function execute(t) {
            var e = this.editor.model;
            var n = t.position;
            e.change(function (t) {
              var i = t.createElement("paragraph");

              if (!e.schema.checkChild(n.parent, i)) {
                var _o99 = e.schema.findAllowedParent(n, i);

                if (!_o99) return;
                n = t.split(n, _o99).position;
              }

              e.insertContent(i, n), t.setSelection(i, "in");
            });
          }
        }]);

        return xf;
      }(me);

      var Ef = /*#__PURE__*/function (_ue32) {
        _inherits(Ef, _ue32);

        var _super129 = _createSuper(Ef);

        function Ef() {
          _classCallCheck(this, Ef);

          return _super129.apply(this, arguments);
        }

        _createClass(Ef, [{
          key: "init",
          value: function init() {
            var t = this.editor,
                e = t.model;
            t.commands.add("paragraph", new vf(t)), t.commands.add("insertParagraph", new xf(t)), e.schema.register("paragraph", {
              inheritAllFrom: "$block"
            }), t.conversion.elementToElement({
              model: "paragraph",
              view: "p"
            }), t.conversion.for("upcast").elementToElement({
              model: function model(t, _ref51) {
                var e = _ref51.writer;
                return Ef.paragraphLikeElements.has(t.name) ? t.isEmpty ? null : e.createElement("paragraph") : null;
              },
              view: /.+/,
              converterPriority: "low"
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "Paragraph";
          }
        }]);

        return Ef;
      }(ue);

      Ef.paragraphLikeElements = new Set(["blockquote", "dd", "div", "dt", "h1", "h2", "h3", "h4", "h5", "h6", "li", "p", "td", "th"]);

      var Df = /*#__PURE__*/function (_me12) {
        _inherits(Df, _me12);

        var _super130 = _createSuper(Df);

        function Df(t, e) {
          var _this219;

          _classCallCheck(this, Df);

          _this219 = _super130.call(this, t), _this219.modelElements = e;
          return _this219;
        }

        _createClass(Df, [{
          key: "refresh",
          value: function refresh() {
            var _this220 = this;

            var t = wa(this.editor.model.document.selection.getSelectedBlocks());
            this.value = !!t && this.modelElements.includes(t.name) && t.name, this.isEnabled = !!t && this.modelElements.some(function (e) {
              return Sf(t, e, _this220.editor.model.schema);
            });
          }
        }, {
          key: "execute",
          value: function execute(t) {
            var e = this.editor.model,
                n = e.document,
                i = t.value;
            e.change(function (t) {
              var o = Array.from(n.selection.getSelectedBlocks()).filter(function (t) {
                return Sf(t, i, e.schema);
              });

              var _iterator344 = _createForOfIteratorHelper(o),
                  _step344;

              try {
                for (_iterator344.s(); !(_step344 = _iterator344.n()).done;) {
                  var _e246 = _step344.value;
                  _e246.is("element", i) || t.rename(_e246, i);
                }
              } catch (err) {
                _iterator344.e(err);
              } finally {
                _iterator344.f();
              }
            });
          }
        }]);

        return Df;
      }(me);

      function Sf(t, e, n) {
        return n.checkChild(t.parent, e) && !n.isObject(t);
      }

      var If = "paragraph";

      var Mf = /*#__PURE__*/function (_ue33) {
        _inherits(Mf, _ue33);

        var _super131 = _createSuper(Mf);

        function Mf(t) {
          var _this221;

          _classCallCheck(this, Mf);

          _this221 = _super131.call(this, t), t.config.define("heading", {
            options: [{
              model: "paragraph",
              title: "Paragraph",
              class: "ck-heading_paragraph"
            }, {
              model: "heading1",
              view: "h2",
              title: "Heading 1",
              class: "ck-heading_heading1"
            }, {
              model: "heading2",
              view: "h3",
              title: "Heading 2",
              class: "ck-heading_heading2"
            }, {
              model: "heading3",
              view: "h4",
              title: "Heading 3",
              class: "ck-heading_heading3"
            }]
          });
          return _this221;
        }

        _createClass(Mf, [{
          key: "init",
          value: function init() {
            var t = this.editor,
                e = t.config.get("heading.options"),
                n = [];

            var _iterator345 = _createForOfIteratorHelper(e),
                _step345;

            try {
              for (_iterator345.s(); !(_step345 = _iterator345.n()).done;) {
                var _i185 = _step345.value;
                _i185.model !== If && (t.model.schema.register(_i185.model, {
                  inheritAllFrom: "$block"
                }), t.conversion.elementToElement(_i185), n.push(_i185.model));
              }
            } catch (err) {
              _iterator345.e(err);
            } finally {
              _iterator345.f();
            }

            this._addDefaultH1Conversion(t), t.commands.add("heading", new Df(t, n));
          }
        }, {
          key: "afterInit",
          value: function afterInit() {
            var t = this.editor,
                e = t.commands.get("enter"),
                n = t.config.get("heading.options");
            e && this.listenTo(e, "afterExecute", function (e, i) {
              var o = t.model.document.selection.getFirstPosition().parent;
              n.some(function (t) {
                return o.is("element", t.model);
              }) && !o.is("element", If) && 0 === o.childCount && i.writer.rename(o, If);
            });
          }
        }, {
          key: "_addDefaultH1Conversion",
          value: function _addDefaultH1Conversion(t) {
            t.conversion.for("upcast").elementToElement({
              model: "heading1",
              view: "h1",
              converterPriority: s.get("low") + 1
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "HeadingEditing";
          }
        }, {
          key: "requires",
          get: function get() {
            return [Ef];
          }
        }]);

        return Mf;
      }(ue);

      var Tf = n(2233),
          Nf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Tf.Z, Nf), Tf.Z.locals;

      var Bf = /*#__PURE__*/function (_ue34) {
        _inherits(Bf, _ue34);

        var _super132 = _createSuper(Bf);

        function Bf() {
          _classCallCheck(this, Bf);

          return _super132.apply(this, arguments);
        }

        _createClass(Bf, [{
          key: "init",
          value: function init() {
            var _this222 = this;

            var t = this.editor,
                e = t.t,
                n = function (t) {
              var e = t.t,
                  n = {
                Paragraph: e("Paragraph"),
                "Heading 1": e("Heading 1"),
                "Heading 2": e("Heading 2"),
                "Heading 3": e("Heading 3"),
                "Heading 4": e("Heading 4"),
                "Heading 5": e("Heading 5"),
                "Heading 6": e("Heading 6")
              };
              return t.config.get("heading.options").map(function (t) {
                var e = n[t.title];
                return e && e != t.title && (t.title = e), t;
              });
            }(t),
                i = e("Choose heading"),
                o = e("Heading");

            t.ui.componentFactory.add("heading", function (e) {
              var r = {},
                  s = new Di(),
                  a = t.commands.get("heading"),
                  c = t.commands.get("paragraph"),
                  l = [a];

              var _iterator346 = _createForOfIteratorHelper(n),
                  _step346;

              try {
                var _loop6 = function _loop6() {
                  var t = _step346.value;
                  var e = {
                    type: "button",
                    model: new uu({
                      label: t.title,
                      class: t.class,
                      withText: !0
                    })
                  };
                  "paragraph" === t.model ? (e.model.bind("isOn").to(c, "value"), e.model.set("commandName", "paragraph"), l.push(c)) : (e.model.bind("isOn").to(a, "value", function (e) {
                    return e === t.model;
                  }), e.model.set({
                    commandName: "heading",
                    commandValue: t.model
                  })), s.add(e), r[t.model] = t.title;
                };

                for (_iterator346.s(); !(_step346 = _iterator346.n()).done;) {
                  _loop6();
                }
              } catch (err) {
                _iterator346.e(err);
              } finally {
                _iterator346.f();
              }

              var d = Hh(e);
              return Wh(d, s), d.buttonView.set({
                isOn: !1,
                withText: !0,
                tooltip: o
              }), d.extendTemplate({
                attributes: {
                  class: ["ck-heading-dropdown"]
                }
              }), d.bind("isEnabled").toMany(l, "isEnabled", function () {
                for (var _len22 = arguments.length, t = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
                  t[_key22] = arguments[_key22];
                }

                return t.some(function (t) {
                  return t;
                });
              }), d.buttonView.bind("label").to(a, "value", c, "value", function (t, e) {
                var n = t || e && "paragraph";
                return r[n] ? r[n] : i;
              }), _this222.listenTo(d, "execute", function (e) {
                t.execute(e.source.commandName, e.source.commandValue ? {
                  value: e.source.commandValue
                } : void 0), t.editing.view.focus();
              }), d;
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "HeadingUI";
          }
        }]);

        return Bf;
      }(ue);

      var zf = /*#__PURE__*/function (_ue35) {
        _inherits(zf, _ue35);

        var _super133 = _createSuper(zf);

        function zf() {
          _classCallCheck(this, zf);

          return _super133.apply(this, arguments);
        }

        _createClass(zf, null, [{
          key: "requires",
          get: function get() {
            return [Mf, Bf];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "Heading";
          }
        }]);

        return zf;
      }(ue);

      var Pf = /*#__PURE__*/function (_ue36) {
        _inherits(Pf, _ue36);

        var _super134 = _createSuper(Pf);

        function Pf() {
          _classCallCheck(this, Pf);

          return _super134.apply(this, arguments);
        }

        _createClass(Pf, [{
          key: "init",
          value: function init() {
            var _this223 = this;

            var t = this.editor;

            if (t.plugins.has("BalloonToolbar")) {
              var _e247 = t.plugins.get("BalloonToolbar");

              this.listenTo(_e247, "show", function (e) {
                (function (t) {
                  var e = t.getSelectedElement();
                  return !(!e || !yp(e));
                })(t.editing.view.document.selection) && e.stop();
              }, {
                priority: "high"
              });
            }

            this._toolbarDefinitions = new Map(), this._balloon = this.editor.plugins.get("ContextualBalloon"), this.on("change:isEnabled", function () {
              _this223._updateToolbarsVisibility();
            }), this.listenTo(t.ui, "update", function () {
              _this223._updateToolbarsVisibility();
            }), this.listenTo(t.ui.focusTracker, "change:isFocused", function () {
              _this223._updateToolbarsVisibility();
            }, {
              priority: "low"
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            _get(_getPrototypeOf(Pf.prototype), "destroy", this).call(this);

            var _iterator347 = _createForOfIteratorHelper(this._toolbarDefinitions.values()),
                _step347;

            try {
              for (_iterator347.s(); !(_step347 = _iterator347.n()).done;) {
                var _t266 = _step347.value;

                _t266.view.destroy();
              }
            } catch (err) {
              _iterator347.e(err);
            } finally {
              _iterator347.f();
            }
          }
        }, {
          key: "register",
          value: function register(t, _ref52) {
            var e = _ref52.ariaLabel,
                n = _ref52.items,
                i = _ref52.getRelatedElement,
                _ref52$balloonClassNa = _ref52.balloonClassName,
                o = _ref52$balloonClassNa === void 0 ? "ck-toolbar-container" : _ref52$balloonClassNa;
            if (!n.length) return void c("widget-toolbar-no-items", {
              toolbarId: t
            });
            var r = this.editor,
                s = r.t,
                l = new Mh(r.locale);
            if (l.ariaLabel = e || s("Widget toolbar"), this._toolbarDefinitions.has(t)) throw new a("widget-toolbar-duplicated", this, {
              toolbarId: t
            });
            l.fillFromConfig(n, r.ui.componentFactory), this._toolbarDefinitions.set(t, {
              view: l,
              getRelatedElement: i,
              balloonClassName: o
            });
          }
        }, {
          key: "_updateToolbarsVisibility",
          value: function _updateToolbarsVisibility() {
            var t = 0,
                e = null,
                n = null;

            var _iterator348 = _createForOfIteratorHelper(this._toolbarDefinitions.values()),
                _step348;

            try {
              for (_iterator348.s(); !(_step348 = _iterator348.n()).done;) {
                var _i186 = _step348.value;

                var _o100 = _i186.getRelatedElement(this.editor.editing.view.document.selection);

                if (this.isEnabled && _o100) {
                  if (this.editor.ui.focusTracker.isFocused) {
                    var _r55 = _o100.getAncestors().length;

                    _r55 > t && (t = _r55, e = _o100, n = _i186);
                  } else this._isToolbarVisible(_i186) && this._hideToolbar(_i186);
                } else this._isToolbarInBalloon(_i186) && this._hideToolbar(_i186);
              }
            } catch (err) {
              _iterator348.e(err);
            } finally {
              _iterator348.f();
            }

            n && this._showToolbar(n, e);
          }
        }, {
          key: "_hideToolbar",
          value: function _hideToolbar(t) {
            this._balloon.remove(t.view), this.stopListening(this._balloon, "change:visibleView");
          }
        }, {
          key: "_showToolbar",
          value: function _showToolbar(t, e) {
            var _this224 = this;

            this._isToolbarVisible(t) ? Lf(this.editor, e) : this._isToolbarInBalloon(t) || (this._balloon.add({
              view: t.view,
              position: Rf(this.editor, e),
              balloonClassName: t.balloonClassName
            }), this.listenTo(this._balloon, "change:visibleView", function () {
              var _iterator349 = _createForOfIteratorHelper(_this224._toolbarDefinitions.values()),
                  _step349;

              try {
                for (_iterator349.s(); !(_step349 = _iterator349.n()).done;) {
                  var _t267 = _step349.value;

                  if (_this224._isToolbarVisible(_t267)) {
                    var _e248 = _t267.getRelatedElement(_this224.editor.editing.view.document.selection);

                    Lf(_this224.editor, _e248);
                  }
                }
              } catch (err) {
                _iterator349.e(err);
              } finally {
                _iterator349.f();
              }
            }));
          }
        }, {
          key: "_isToolbarVisible",
          value: function _isToolbarVisible(t) {
            return this._balloon.visibleView === t.view;
          }
        }, {
          key: "_isToolbarInBalloon",
          value: function _isToolbarInBalloon(t) {
            return this._balloon.hasView(t.view);
          }
        }], [{
          key: "requires",
          get: function get() {
            return [xu];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "WidgetToolbarRepository";
          }
        }]);

        return Pf;
      }(ue);

      function Lf(t, e) {
        var n = t.plugins.get("ContextualBalloon"),
            i = Rf(t, e);
        n.updatePosition(i);
      }

      function Rf(t, e) {
        var n = t.editing.view,
            i = bu.defaultPositions;
        return {
          target: n.domConverter.mapViewToDom(e),
          positions: [i.northArrowSouth, i.northArrowSouthWest, i.northArrowSouthEast, i.southArrowNorth, i.southArrowNorthWest, i.southArrowNorthEast, i.viewportStickyNorth]
        };
      }

      var Of = /*#__PURE__*/function () {
        function Of(t) {
          _classCallCheck(this, Of);

          this.set("activeHandlePosition", null), this.set("proposedWidthPercents", null), this.set("proposedWidth", null), this.set("proposedHeight", null), this.set("proposedHandleHostWidth", null), this.set("proposedHandleHostHeight", null), this._options = t, this._referenceCoordinates = null;
        }

        _createClass(Of, [{
          key: "begin",
          value: function begin(t, e, n) {
            var i = new ma(e);
            this.activeHandlePosition = function (t) {
              var e = ["top-left", "top-right", "bottom-right", "bottom-left"];

              for (var _i187 = 0, _e249 = e; _i187 < _e249.length; _i187++) {
                var _n231 = _e249[_i187];
                if (t.classList.contains(jf(_n231))) return _n231;
              }
            }(t), this._referenceCoordinates = function (t, e) {
              var n = new ma(t),
                  i = e.split("-"),
                  o = {
                x: "right" == i[1] ? n.right : n.left,
                y: "bottom" == i[0] ? n.bottom : n.top
              };
              return o.x += t.ownerDocument.defaultView.scrollX, o.y += t.ownerDocument.defaultView.scrollY, o;
            }(e, function (t) {
              var e = t.split("-"),
                  n = {
                top: "bottom",
                bottom: "top",
                left: "right",
                right: "left"
              };
              return "".concat(n[e[0]], "-").concat(n[e[1]]);
            }(this.activeHandlePosition)), this.originalWidth = i.width, this.originalHeight = i.height, this.aspectRatio = i.width / i.height;
            var o = n.style.width;
            o && o.match(/^\d+(\.\d*)?%$/) ? this.originalWidthPercents = parseFloat(o) : this.originalWidthPercents = function (t, e) {
              var n = t.parentElement,
                  i = parseFloat(n.ownerDocument.defaultView.getComputedStyle(n).width);
              return e.width / i * 100;
            }(n, i);
          }
        }, {
          key: "update",
          value: function update(t) {
            this.proposedWidth = t.width, this.proposedHeight = t.height, this.proposedWidthPercents = t.widthPercents, this.proposedHandleHostWidth = t.handleHostWidth, this.proposedHandleHostHeight = t.handleHostHeight;
          }
        }]);

        return Of;
      }();

      function jf(t) {
        return "ck-widget__resizer__handle-".concat(t);
      }

      he(Of, re);

      var Ff = /*#__PURE__*/function (_Dd25) {
        _inherits(Ff, _Dd25);

        var _super135 = _createSuper(Ff);

        function Ff() {
          var _this225;

          _classCallCheck(this, Ff);

          _this225 = _super135.call(this);
          var t = _this225.bindTemplate;

          _this225.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-size-view", t.to("_viewPosition", function (t) {
                return t ? "ck-orientation-".concat(t) : "";
              })],
              style: {
                display: t.if("_isVisible", "none", function (t) {
                  return !t;
                })
              }
            },
            children: [{
              text: t.to("_label")
            }]
          });

          return _this225;
        }

        _createClass(Ff, [{
          key: "_bindToState",
          value: function _bindToState(t, e) {
            this.bind("_isVisible").to(e, "proposedWidth", e, "proposedHeight", function (t, e) {
              return null !== t && null !== e;
            }), this.bind("_label").to(e, "proposedHandleHostWidth", e, "proposedHandleHostHeight", e, "proposedWidthPercents", function (e, n, i) {
              return "px" === t.unit ? "".concat(e, "\xD7").concat(n) : "".concat(i, "%");
            }), this.bind("_viewPosition").to(e, "activeHandlePosition", e, "proposedHandleHostWidth", e, "proposedHandleHostHeight", function (t, e, n) {
              return e < 50 || n < 50 ? "above-center" : t;
            });
          }
        }, {
          key: "_dismiss",
          value: function _dismiss() {
            this.unbind(), this._isVisible = !1;
          }
        }]);

        return Ff;
      }(Dd);

      var Vf = /*#__PURE__*/function () {
        function Vf(t) {
          var _this226 = this;

          _classCallCheck(this, Vf);

          this._options = t, this._viewResizerWrapper = null, this.set("isEnabled", !0), this.decorate("begin"), this.decorate("cancel"), this.decorate("commit"), this.decorate("updateSize"), this.on("commit", function (t) {
            _this226.state.proposedWidth || _this226.state.proposedWidthPercents || (_this226._cleanup(), t.stop());
          }, {
            priority: "high"
          }), this.on("change:isEnabled", function () {
            _this226.isEnabled && _this226.redraw();
          });
        }

        _createClass(Vf, [{
          key: "attach",
          value: function attach() {
            var _this227 = this;

            var t = this,
                e = this._options.viewElement;

            this._options.editor.editing.view.change(function (n) {
              var i = n.createUIElement("div", {
                class: "ck ck-reset_all ck-widget__resizer"
              }, function (e) {
                var n = this.toDomElement(e);
                return t._appendHandles(n), t._appendSizeUI(n), t.on("change:isEnabled", function (t, e, i) {
                  n.style.display = i ? "" : "none";
                }), n.style.display = t.isEnabled ? "" : "none", n;
              });
              n.insert(n.createPositionAt(e, "end"), i), n.addClass("ck-widget_with-resizer", e), _this227._viewResizerWrapper = i;
            });
          }
        }, {
          key: "begin",
          value: function begin(t) {
            this.state = new Of(this._options), this._sizeView._bindToState(this._options, this.state), this._initialViewWidth = this._options.viewElement.getStyle("width"), this.state.begin(t, this._getHandleHost(), this._getResizeHost());
          }
        }, {
          key: "updateSize",
          value: function updateSize(t) {
            var _this228 = this;

            var e = this._proposeNewSize(t);

            this._options.editor.editing.view.change(function (t) {
              var n = _this228._options.unit || "%",
                  i = ("%" === n ? e.widthPercents : e.width) + n;
              t.setStyle("width", i, _this228._options.viewElement);
            });

            var n = this._getHandleHost(),
                i = new ma(n);

            e.handleHostWidth = Math.round(i.width), e.handleHostHeight = Math.round(i.height);
            var o = new ma(n);
            e.width = Math.round(o.width), e.height = Math.round(o.height), this.redraw(i), this.state.update(e);
          }
        }, {
          key: "commit",
          value: function commit() {
            var _this229 = this;

            var t = this._options.unit || "%",
                e = ("%" === t ? this.state.proposedWidthPercents : this.state.proposedWidth) + t;

            this._options.editor.editing.view.change(function () {
              _this229._cleanup(), _this229._options.onCommit(e);
            });
          }
        }, {
          key: "cancel",
          value: function cancel() {
            this._cleanup();
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.cancel();
          }
        }, {
          key: "redraw",
          value: function redraw(t) {
            var e = this._domResizerWrapper;
            if (!((n = e) && n.ownerDocument && n.ownerDocument.contains(n))) return;
            var n;

            var i = e.parentElement,
                o = this._getHandleHost(),
                r = this._viewResizerWrapper,
                s = [r.getStyle("width"), r.getStyle("height"), r.getStyle("left"), r.getStyle("top")];

            var a;

            if (i.isSameNode(o)) {
              var _e250 = t || new ma(o);

              a = [_e250.width + "px", _e250.height + "px", void 0, void 0];
            } else a = [o.offsetWidth + "px", o.offsetHeight + "px", o.offsetLeft + "px", o.offsetTop + "px"];

            "same" !== Li(s, a) && this._options.editor.editing.view.change(function (t) {
              t.setStyle({
                width: a[0],
                height: a[1],
                left: a[2],
                top: a[3]
              }, r);
            });
          }
        }, {
          key: "containsHandle",
          value: function containsHandle(t) {
            return this._domResizerWrapper.contains(t);
          }
        }, {
          key: "_cleanup",
          value: function _cleanup() {
            var _this230 = this;

            this._sizeView._dismiss();

            this._options.editor.editing.view.change(function (t) {
              t.setStyle("width", _this230._initialViewWidth, _this230._options.viewElement);
            });
          }
        }, {
          key: "_proposeNewSize",
          value: function _proposeNewSize(t) {
            var e = this.state,
                n = {
              x: (i = t).pageX,
              y: i.pageY
            };
            var i;

            var o = !this._options.isCentered || this._options.isCentered(this),
                r = {
              x: e._referenceCoordinates.x - (n.x + e.originalWidth),
              y: n.y - e.originalHeight - e._referenceCoordinates.y
            };

            o && e.activeHandlePosition.endsWith("-right") && (r.x = n.x - (e._referenceCoordinates.x + e.originalWidth)), o && (r.x *= 2);
            var s = {
              width: Math.abs(e.originalWidth + r.x),
              height: Math.abs(e.originalHeight + r.y)
            };
            s.dominant = s.width / e.aspectRatio > s.height ? "width" : "height", s.max = s[s.dominant];
            var a = {
              width: s.width,
              height: s.height
            };
            return "width" == s.dominant ? a.height = a.width / e.aspectRatio : a.width = a.height * e.aspectRatio, {
              width: Math.round(a.width),
              height: Math.round(a.height),
              widthPercents: Math.min(Math.round(e.originalWidthPercents / e.originalWidth * a.width * 100) / 100, 100)
            };
          }
        }, {
          key: "_getResizeHost",
          value: function _getResizeHost() {
            var t = this._domResizerWrapper.parentElement;
            return this._options.getResizeHost(t);
          }
        }, {
          key: "_getHandleHost",
          value: function _getHandleHost() {
            var t = this._domResizerWrapper.parentElement;
            return this._options.getHandleHost(t);
          }
        }, {
          key: "_domResizerWrapper",
          get: function get() {
            return this._options.editor.editing.view.domConverter.mapViewToDom(this._viewResizerWrapper);
          }
        }, {
          key: "_appendHandles",
          value: function _appendHandles(t) {
            var e = ["top-left", "top-right", "bottom-right", "bottom-left"];

            for (var _i188 = 0, _e251 = e; _i188 < _e251.length; _i188++) {
              var _i189 = _e251[_i188];
              t.appendChild(new Sd({
                tag: "div",
                attributes: {
                  class: "ck-widget__resizer__handle " + (n = _i189, "ck-widget__resizer__handle-".concat(n))
                }
              }).render());
            }

            var n;
          }
        }, {
          key: "_appendSizeUI",
          value: function _appendSizeUI(t) {
            this._sizeView = new Ff(), this._sizeView.render(), t.appendChild(this._sizeView.element);
          }
        }], [{
          key: "isResizeHandle",
          value: function isResizeHandle(t) {
            return t.classList.contains("ck-widget__resizer__handle");
          }
        }]);

        return Vf;
      }();

      he(Vf, re);
      var Uf = n(2497),
          Hf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Uf.Z, Hf), Uf.Z.locals;
      he( /*#__PURE__*/function (_ue37) {
        _inherits(_class2, _ue37);

        var _super136 = _createSuper(_class2);

        function _class2() {
          _classCallCheck(this, _class2);

          return _super136.apply(this, arguments);
        }

        _createClass(_class2, [{
          key: "init",
          value: function init() {
            var _this231 = this;

            var t = this.editor.editing,
                e = os.window.document;
            this.set("visibleResizer", null), this.set("_activeResizer", null), this._resizers = new Map(), t.view.addObserver(tg), this._observer = Object.create(ks), this.listenTo(t.view.document, "mousedown", this._mouseDownListener.bind(this), {
              priority: "high"
            }), this._observer.listenTo(e, "mousemove", this._mouseMoveListener.bind(this)), this._observer.listenTo(e, "mouseup", this._mouseUpListener.bind(this));

            var n = function n() {
              _this231.visibleResizer && _this231.visibleResizer.redraw();
            };

            this._redrawFocusedResizerThrottled = Kp(n, 200), this.on("change:visibleResizer", n), this.editor.ui.on("update", this._redrawFocusedResizerThrottled), this.editor.model.document.on("change", function () {
              var _iterator350 = _createForOfIteratorHelper(_this231._resizers),
                  _step350;

              try {
                for (_iterator350.s(); !(_step350 = _iterator350.n()).done;) {
                  var _step350$value = _slicedToArray(_step350.value, 2),
                      _t268 = _step350$value[0],
                      _e252 = _step350$value[1];

                  _t268.isAttached() || (_this231._resizers.delete(_t268), _e252.destroy());
                }
              } catch (err) {
                _iterator350.e(err);
              } finally {
                _iterator350.f();
              }
            }, {
              priority: "lowest"
            }), this._observer.listenTo(os.window, "resize", this._redrawFocusedResizerThrottled);
            var i = this.editor.editing.view.document.selection;
            i.on("change", function () {
              var t = i.getSelectedElement();
              _this231.visibleResizer = _this231.getResizerByViewElement(t) || null;
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this._observer.stopListening();

            var _iterator351 = _createForOfIteratorHelper(this._resizers.values()),
                _step351;

            try {
              for (_iterator351.s(); !(_step351 = _iterator351.n()).done;) {
                var _t269 = _step351.value;

                _t269.destroy();
              }
            } catch (err) {
              _iterator351.e(err);
            } finally {
              _iterator351.f();
            }

            this._redrawFocusedResizerThrottled.cancel();
          }
        }, {
          key: "attachTo",
          value: function attachTo(t) {
            var e = new Vf(t),
                n = this.editor.plugins;

            if (e.attach(), n.has("WidgetToolbarRepository")) {
              var _t270 = n.get("WidgetToolbarRepository");

              e.on("begin", function () {
                _t270.forceDisabled("resize");
              }, {
                priority: "lowest"
              }), e.on("cancel", function () {
                _t270.clearForceDisabled("resize");
              }, {
                priority: "highest"
              }), e.on("commit", function () {
                _t270.clearForceDisabled("resize");
              }, {
                priority: "highest"
              });
            }

            this._resizers.set(t.viewElement, e);

            var i = this.editor.editing.view.document.selection.getSelectedElement();
            return this.getResizerByViewElement(i) == e && (this.visibleResizer = e), e;
          }
        }, {
          key: "getResizerByViewElement",
          value: function getResizerByViewElement(t) {
            return this._resizers.get(t);
          }
        }, {
          key: "_getResizerByHandle",
          value: function _getResizerByHandle(t) {
            var _iterator352 = _createForOfIteratorHelper(this._resizers.values()),
                _step352;

            try {
              for (_iterator352.s(); !(_step352 = _iterator352.n()).done;) {
                var _e253 = _step352.value;
                if (_e253.containsHandle(t)) return _e253;
              }
            } catch (err) {
              _iterator352.e(err);
            } finally {
              _iterator352.f();
            }
          }
        }, {
          key: "_mouseDownListener",
          value: function _mouseDownListener(t, e) {
            var n = e.domTarget;
            Vf.isResizeHandle(n) && (this._activeResizer = this._getResizerByHandle(n), this._activeResizer && (this._activeResizer.begin(n), t.stop(), e.preventDefault()));
          }
        }, {
          key: "_mouseMoveListener",
          value: function _mouseMoveListener(t, e) {
            this._activeResizer && this._activeResizer.updateSize(e);
          }
        }, {
          key: "_mouseUpListener",
          value: function _mouseUpListener() {
            this._activeResizer && (this._activeResizer.commit(), this._activeResizer = null);
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "WidgetResize";
          }
        }]);

        return _class2;
      }(ue), re);

      var qf = /*#__PURE__*/function (_me13) {
        _inherits(qf, _me13);

        var _super137 = _createSuper(qf);

        function qf() {
          _classCallCheck(this, qf);

          return _super137.apply(this, arguments);
        }

        _createClass(qf, [{
          key: "refresh",
          value: function refresh() {
            var t = this.editor.plugins.get("ImageUtils").getClosestSelectedImageElement(this.editor.model.document.selection);
            this.isEnabled = !!t, this.isEnabled && t.hasAttribute("alt") ? this.value = t.getAttribute("alt") : this.value = !1;
          }
        }, {
          key: "execute",
          value: function execute(t) {
            var e = this.editor,
                n = e.plugins.get("ImageUtils"),
                i = e.model,
                o = n.getClosestSelectedImageElement(i.document.selection);
            i.change(function (e) {
              e.setAttribute("alt", t.newValue, o);
            });
          }
        }]);

        return qf;
      }(me);

      function Wf(t, e) {
        var n = t.createEmptyElement("img"),
            i = "imageBlock" === e ? t.createContainerElement("figure", {
          class: "image"
        }) : t.createContainerElement("span", {
          class: "image-inline"
        }, {
          isAllowedInsideAttributeElement: !0
        });
        return t.insert(t.createPositionAt(i, 0), n), i;
      }

      function Gf(t, e) {
        if (t.plugins.has("ImageInlineEditing") !== t.plugins.has("ImageBlockEditing")) return {
          name: "img"
        };
        var n = t.plugins.get("ImageUtils");
        return function (t) {
          if (!n.isInlineImageView(t)) return null;
          return (t.findAncestor(n.isBlockImageView) ? "imageBlock" : "imageInline") !== e ? null : {
            name: !0
          };
        };
      }

      function $f(t, e) {
        var n = wa(e.getSelectedBlocks());
        return !n || t.isObject(n) || n.isEmpty && "listItem" != n.name ? "imageBlock" : "imageInline";
      }

      var Yf = /*#__PURE__*/function (_ue38) {
        _inherits(Yf, _ue38);

        var _super138 = _createSuper(Yf);

        function Yf() {
          _classCallCheck(this, Yf);

          return _super138.apply(this, arguments);
        }

        _createClass(Yf, [{
          key: "isImage",
          value: function isImage(t) {
            return this.isInlineImage(t) || this.isBlockImage(t);
          }
        }, {
          key: "isInlineImageView",
          value: function isInlineImageView(t) {
            return !!t && t.is("element", "img");
          }
        }, {
          key: "isBlockImageView",
          value: function isBlockImageView(t) {
            return !!t && t.is("element", "figure") && t.hasClass("image");
          }
        }, {
          key: "insertImage",
          value: function insertImage() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var i = this.editor,
                o = i.model,
                r = o.document.selection;
            n = Kf(i, e || r, n), t = _objectSpread(_objectSpread({}, Object.fromEntries(r.getAttributes())), t);

            for (var _e254 in t) {
              o.schema.checkAttribute(n, _e254) || delete t[_e254];
            }

            return o.change(function (i) {
              var s = i.createElement(n, t);
              return e || "imageInline" == n || (e = Tp(r, o)), o.insertContent(s, e), s.parent ? (i.setSelection(s, "on"), s) : null;
            });
          }
        }, {
          key: "getClosestSelectedImageWidget",
          value: function getClosestSelectedImageWidget(t) {
            var e = t.getSelectedElement();
            if (e && this.isImageWidget(e)) return e;
            var n = t.getFirstPosition().parent;

            for (; n;) {
              if (n.is("element") && this.isImageWidget(n)) return n;
              n = n.parent;
            }

            return null;
          }
        }, {
          key: "getClosestSelectedImageElement",
          value: function getClosestSelectedImageElement(t) {
            var e = t.getSelectedElement();
            return this.isImage(e) ? e : t.getFirstPosition().findAncestor("imageBlock");
          }
        }, {
          key: "isImageAllowed",
          value: function isImageAllowed() {
            var t = this.editor.model.document.selection;
            return function (t, e) {
              if ("imageBlock" == Kf(t, e)) {
                var _n232 = function (t, e) {
                  var n = Tp(t, e).start.parent;
                  if (n.isEmpty && !n.is("element", "$root")) return n.parent;
                  return n;
                }(e, t.model);

                if (t.model.schema.checkChild(_n232, "imageBlock")) return !0;
              } else if (t.model.schema.checkChild(e.focus, "imageInline")) return !0;

              return !1;
            }(this.editor, t) && function (t) {
              return _toConsumableArray(t.focus.getAncestors()).every(function (t) {
                return !t.is("element", "imageBlock");
              });
            }(t);
          }
        }, {
          key: "toImageWidget",
          value: function toImageWidget(t, e, n) {
            var _this232 = this;

            e.setCustomProperty("image", !0, t);
            return xp(t, e, {
              label: function label() {
                var e = _this232.findViewImgElement(t).getAttribute("alt");

                return e ? "".concat(e, " ").concat(n) : n;
              }
            });
          }
        }, {
          key: "isImageWidget",
          value: function isImageWidget(t) {
            return !!t.getCustomProperty("image") && yp(t);
          }
        }, {
          key: "isBlockImage",
          value: function isBlockImage(t) {
            return !!t && t.is("element", "imageBlock");
          }
        }, {
          key: "isInlineImage",
          value: function isInlineImage(t) {
            return !!t && t.is("element", "imageInline");
          }
        }, {
          key: "findViewImgElement",
          value: function findViewImgElement(t) {
            if (this.isInlineImageView(t)) return t;
            var e = this.editor.editing.view;

            var _iterator353 = _createForOfIteratorHelper(e.createRangeIn(t)),
                _step353;

            try {
              for (_iterator353.s(); !(_step353 = _iterator353.n()).done;) {
                var _n233 = _step353.value.item;
                if (this.isInlineImageView(_n233)) return _n233;
              }
            } catch (err) {
              _iterator353.e(err);
            } finally {
              _iterator353.f();
            }
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "ImageUtils";
          }
        }]);

        return Yf;
      }(ue);

      function Kf(t, e, n) {
        var i = t.model.schema,
            o = t.config.get("image.insert.type");
        return t.plugins.has("ImageBlockEditing") ? t.plugins.has("ImageInlineEditing") ? n || ("inline" === o ? "imageInline" : "block" === o ? "imageBlock" : e.is("selection") ? $f(i, e) : i.checkChild(e, "imageInline") ? "imageInline" : "imageBlock") : "imageBlock" : "imageInline";
      }

      var Qf = /*#__PURE__*/function (_ue39) {
        _inherits(Qf, _ue39);

        var _super139 = _createSuper(Qf);

        function Qf() {
          _classCallCheck(this, Qf);

          return _super139.apply(this, arguments);
        }

        _createClass(Qf, [{
          key: "init",
          value: function init() {
            this.editor.commands.add("imageTextAlternative", new qf(this.editor));
          }
        }], [{
          key: "requires",
          get: function get() {
            return [Yf];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "ImageTextAlternativeEditing";
          }
        }]);

        return Qf;
      }(ue);

      var Zf = n(6003),
          Jf = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      },
          Xf = (Zr()(Zf.Z, Jf), Zf.Z.locals, n(8312)),
          tk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Xf.Z, tk), Xf.Z.locals;

      var ek = /*#__PURE__*/function (_Dd26) {
        _inherits(ek, _Dd26);

        var _super140 = _createSuper(ek);

        function ek(t) {
          var _this233;

          _classCallCheck(this, ek);

          _this233 = _super140.call(this, t);
          var e = _this233.locale.t;
          _this233.focusTracker = new Aa(), _this233.keystrokes = new Ca(), _this233.labeledInput = _this233._createLabeledInputView(), _this233.saveButtonView = _this233._createButton(e("Save"), Ad.check, "ck-button-save"), _this233.saveButtonView.type = "submit", _this233.cancelButtonView = _this233._createButton(e("Cancel"), Ad.cancel, "ck-button-cancel", "cancel"), _this233._focusables = new yd(), _this233._focusCycler = new vh({
            focusables: _this233._focusables,
            focusTracker: _this233.focusTracker,
            keystrokeHandler: _this233.keystrokes,
            actions: {
              focusPrevious: "shift + tab",
              focusNext: "tab"
            }
          }), _this233.setTemplate({
            tag: "form",
            attributes: {
              class: ["ck", "ck-text-alternative-form", "ck-responsive-form"],
              tabindex: "-1"
            },
            children: [_this233.labeledInput, _this233.saveButtonView, _this233.cancelButtonView]
          }), _d(_assertThisInitialized(_this233));
          return _this233;
        }

        _createClass(ek, [{
          key: "render",
          value: function render() {
            var _this234 = this;

            _get(_getPrototypeOf(ek.prototype), "render", this).call(this), this.keystrokes.listenTo(this.element), vd({
              view: this
            }), [this.labeledInput, this.saveButtonView, this.cancelButtonView].forEach(function (t) {
              _this234._focusables.add(t), _this234.focusTracker.add(t.element);
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            _get(_getPrototypeOf(ek.prototype), "destroy", this).call(this), this.focusTracker.destroy(), this.keystrokes.destroy();
          }
        }, {
          key: "_createButton",
          value: function _createButton(t, e, n, i) {
            var o = new oh(this.locale);
            return o.set({
              label: t,
              icon: e,
              tooltip: !0
            }), o.extendTemplate({
              attributes: {
                class: n
              }
            }), i && o.delegate("execute").to(this, i), o;
          }
        }, {
          key: "_createLabeledInputView",
          value: function _createLabeledInputView() {
            var t = this.locale.t,
                e = new lu(this.locale, du);
            return e.label = t("Text alternative"), e;
          }
        }]);

        return ek;
      }(Dd);

      function nk(t) {
        var e = t.editing.view,
            n = bu.defaultPositions,
            i = t.plugins.get("ImageUtils");
        return {
          target: e.domConverter.viewToDom(i.getClosestSelectedImageWidget(e.document.selection)),
          positions: [n.northArrowSouth, n.northArrowSouthWest, n.northArrowSouthEast, n.southArrowNorth, n.southArrowNorthWest, n.southArrowNorthEast, n.viewportStickyNorth]
        };
      }

      var ik = /*#__PURE__*/function (_ue40) {
        _inherits(ik, _ue40);

        var _super141 = _createSuper(ik);

        function ik() {
          _classCallCheck(this, ik);

          return _super141.apply(this, arguments);
        }

        _createClass(ik, [{
          key: "init",
          value: function init() {
            this._createButton(), this._createForm();
          }
        }, {
          key: "destroy",
          value: function destroy() {
            _get(_getPrototypeOf(ik.prototype), "destroy", this).call(this), this._form.destroy();
          }
        }, {
          key: "_createButton",
          value: function _createButton() {
            var _this235 = this;

            var t = this.editor,
                e = t.t;
            t.ui.componentFactory.add("imageTextAlternative", function (n) {
              var i = t.commands.get("imageTextAlternative"),
                  o = new oh(n);
              return o.set({
                label: e("Change image text alternative"),
                icon: Ad.lowVision,
                tooltip: !0
              }), o.bind("isEnabled").to(i, "isEnabled"), _this235.listenTo(o, "execute", function () {
                _this235._showForm();
              }), o;
            });
          }
        }, {
          key: "_createForm",
          value: function _createForm() {
            var _this236 = this;

            var t = this.editor,
                e = t.editing.view.document,
                n = t.plugins.get("ImageUtils");
            this._balloon = this.editor.plugins.get("ContextualBalloon"), this._form = new ek(t.locale), this._form.render(), this.listenTo(this._form, "submit", function () {
              t.execute("imageTextAlternative", {
                newValue: _this236._form.labeledInput.fieldView.element.value
              }), _this236._hideForm(!0);
            }), this.listenTo(this._form, "cancel", function () {
              _this236._hideForm(!0);
            }), this._form.keystrokes.set("Esc", function (t, e) {
              _this236._hideForm(!0), e();
            }), this.listenTo(t.ui, "update", function () {
              n.getClosestSelectedImageWidget(e.selection) ? _this236._isVisible && function (t) {
                var e = t.plugins.get("ContextualBalloon");

                if (t.plugins.get("ImageUtils").getClosestSelectedImageWidget(t.editing.view.document.selection)) {
                  var _n234 = nk(t);

                  e.updatePosition(_n234);
                }
              }(t) : _this236._hideForm(!0);
            }), Cd({
              emitter: this._form,
              activator: function activator() {
                return _this236._isVisible;
              },
              contextElements: [this._balloon.view.element],
              callback: function callback() {
                return _this236._hideForm();
              }
            });
          }
        }, {
          key: "_showForm",
          value: function _showForm() {
            if (this._isVisible) return;
            var t = this.editor,
                e = t.commands.get("imageTextAlternative"),
                n = this._form.labeledInput;
            this._form.disableCssTransitions(), this._isInBalloon || this._balloon.add({
              view: this._form,
              position: nk(t)
            }), n.fieldView.value = n.fieldView.element.value = e.value || "", this._form.labeledInput.fieldView.select(), this._form.enableCssTransitions();
          }
        }, {
          key: "_hideForm",
          value: function _hideForm(t) {
            this._isInBalloon && (this._form.focusTracker.isFocused && this._form.saveButtonView.focus(), this._balloon.remove(this._form), t && this.editor.editing.view.focus());
          }
        }, {
          key: "_isVisible",
          get: function get() {
            return this._balloon.visibleView === this._form;
          }
        }, {
          key: "_isInBalloon",
          get: function get() {
            return this._balloon.hasView(this._form);
          }
        }], [{
          key: "requires",
          get: function get() {
            return [xu];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "ImageTextAlternativeUI";
          }
        }]);

        return ik;
      }(ue);

      var ok = /*#__PURE__*/function (_ue41) {
        _inherits(ok, _ue41);

        var _super142 = _createSuper(ok);

        function ok() {
          _classCallCheck(this, ok);

          return _super142.apply(this, arguments);
        }

        _createClass(ok, null, [{
          key: "requires",
          get: function get() {
            return [Qf, ik];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "ImageTextAlternative";
          }
        }]);

        return ok;
      }(ue);

      function rk(t, e) {
        return function (t) {
          t.on("attribute:srcset:".concat(e), n);
        };

        function n(e, n, i) {
          if (!i.consumable.consume(n.item, e.name)) return;
          var o = i.writer,
              r = i.mapper.toViewElement(n.item),
              s = t.findViewImgElement(r);

          if (null === n.attributeNewValue) {
            var _t271 = n.attributeOldValue;
            _t271.data && (o.removeAttribute("srcset", s), o.removeAttribute("sizes", s), _t271.width && o.removeAttribute("width", s));
          } else {
            var _t272 = n.attributeNewValue;
            _t272.data && (o.setAttribute("srcset", _t272.data, s), o.setAttribute("sizes", "100vw", s), _t272.width && o.setAttribute("width", _t272.width, s));
          }
        }
      }

      function sk(t, e, n) {
        return function (t) {
          t.on("attribute:".concat(n, ":").concat(e), i);
        };

        function i(e, n, i) {
          if (!i.consumable.consume(n.item, e.name)) return;
          var o = i.writer,
              r = i.mapper.toViewElement(n.item),
              s = t.findViewImgElement(r);
          o.setAttribute(n.attributeKey, n.attributeNewValue || "", s);
        }
      }

      var ak = /*#__PURE__*/function (_As8) {
        _inherits(ak, _As8);

        var _super143 = _createSuper(ak);

        function ak() {
          _classCallCheck(this, ak);

          return _super143.apply(this, arguments);
        }

        _createClass(ak, [{
          key: "observe",
          value: function observe(t) {
            var _this237 = this;

            this.listenTo(t, "load", function (t, e) {
              var n = e.target;
              _this237.checkShouldIgnoreEventFromTarget(n) || "IMG" == n.tagName && _this237._fireEvents(e);
            }, {
              useCapture: !0
            });
          }
        }, {
          key: "_fireEvents",
          value: function _fireEvents(t) {
            this.isEnabled && (this.document.fire("layoutChanged"), this.document.fire("imageLoaded", t));
          }
        }]);

        return ak;
      }(As);

      var ck = /*#__PURE__*/function (_me14) {
        _inherits(ck, _me14);

        var _super144 = _createSuper(ck);

        function ck(t) {
          var _this238;

          _classCallCheck(this, ck);

          _this238 = _super144.call(this, t);
          var e = t.config.get("image.insert.type");
          t.plugins.has("ImageBlockEditing") || "block" === e && c("image-block-plugin-required"), t.plugins.has("ImageInlineEditing") || "inline" === e && c("image-inline-plugin-required");
          return _this238;
        }

        _createClass(ck, [{
          key: "refresh",
          value: function refresh() {
            this.isEnabled = this.editor.plugins.get("ImageUtils").isImageAllowed();
          }
        }, {
          key: "execute",
          value: function execute(t) {
            var _this239 = this;

            var e = Ii(t.source),
                n = this.editor.model.document.selection,
                i = this.editor.plugins.get("ImageUtils"),
                o = Object.fromEntries(n.getAttributes());
            e.forEach(function (t, e) {
              var r = n.getSelectedElement();

              if ("string" == typeof t && (t = {
                src: t
              }), e && r && i.isImage(r)) {
                var _e255 = _this239.editor.model.createPositionAfter(r);

                i.insertImage(_objectSpread(_objectSpread({}, t), o), _e255);
              } else i.insertImage(_objectSpread(_objectSpread({}, t), o));
            });
          }
        }]);

        return ck;
      }(me);

      var lk = /*#__PURE__*/function (_ue42) {
        _inherits(lk, _ue42);

        var _super145 = _createSuper(lk);

        function lk() {
          _classCallCheck(this, lk);

          return _super145.apply(this, arguments);
        }

        _createClass(lk, [{
          key: "init",
          value: function init() {
            var t = this.editor,
                e = t.conversion;
            t.editing.view.addObserver(ak), e.for("upcast").attributeToAttribute({
              view: {
                name: "img",
                key: "alt"
              },
              model: "alt"
            }).attributeToAttribute({
              view: {
                name: "img",
                key: "srcset"
              },
              model: {
                key: "srcset",
                value: function value(t) {
                  var e = {
                    data: t.getAttribute("srcset")
                  };
                  return t.hasAttribute("width") && (e.width = t.getAttribute("width")), e;
                }
              }
            });
            var n = new ck(t);
            t.commands.add("insertImage", n), t.commands.add("imageInsert", n);
          }
        }], [{
          key: "requires",
          get: function get() {
            return [Yf];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "ImageEditing";
          }
        }]);

        return lk;
      }(ue);

      var dk = /*#__PURE__*/function (_me15) {
        _inherits(dk, _me15);

        var _super146 = _createSuper(dk);

        function dk(t, e) {
          var _this240;

          _classCallCheck(this, dk);

          _this240 = _super146.call(this, t), _this240._modelElementName = e;
          return _this240;
        }

        _createClass(dk, [{
          key: "refresh",
          value: function refresh() {
            var t = this.editor.plugins.get("ImageUtils"),
                e = t.getClosestSelectedImageElement(this.editor.model.document.selection);
            "imageBlock" === this._modelElementName ? this.isEnabled = t.isInlineImage(e) : this.isEnabled = t.isBlockImage(e);
          }
        }, {
          key: "execute",
          value: function execute() {
            var _this241 = this;

            var t = this.editor,
                e = this.editor.model,
                n = t.plugins.get("ImageUtils"),
                i = n.getClosestSelectedImageElement(e.document.selection),
                o = Object.fromEntries(i.getAttributes());
            return o.src || o.uploadId ? e.change(function (t) {
              var r = Array.from(e.markers).filter(function (t) {
                return t.getRange().containsItem(i);
              }),
                  s = n.insertImage(o, e.createSelection(i, "on"), _this241._modelElementName);
              if (!s) return null;
              var a = t.createRangeOn(s);

              var _iterator354 = _createForOfIteratorHelper(r),
                  _step354;

              try {
                for (_iterator354.s(); !(_step354 = _iterator354.n()).done;) {
                  var _e256 = _step354.value;

                  var _n235 = _e256.getRange(),
                      _i190 = "$graveyard" != _n235.root.rootName ? _n235.getJoined(a, !0) : a;

                  t.updateMarker(_e256, {
                    range: _i190
                  });
                }
              } catch (err) {
                _iterator354.e(err);
              } finally {
                _iterator354.f();
              }

              return {
                oldElement: i,
                newElement: s
              };
            }) : null;
          }
        }]);

        return dk;
      }(me);

      var hk = /*#__PURE__*/function (_ue43) {
        _inherits(hk, _ue43);

        var _super147 = _createSuper(hk);

        function hk() {
          _classCallCheck(this, hk);

          return _super147.apply(this, arguments);
        }

        _createClass(hk, [{
          key: "init",
          value: function init() {
            var t = this.editor;
            t.model.schema.register("imageBlock", {
              isObject: !0,
              isBlock: !0,
              allowWhere: "$block",
              allowAttributes: ["alt", "src", "srcset"]
            }), this._setupConversion(), t.plugins.has("ImageInlineEditing") && (t.commands.add("imageTypeBlock", new dk(this.editor, "imageBlock")), this._setupClipboardIntegration());
          }
        }, {
          key: "_setupConversion",
          value: function _setupConversion() {
            var t = this.editor,
                e = t.t,
                n = t.conversion,
                i = t.plugins.get("ImageUtils");
            n.for("dataDowncast").elementToElement({
              model: "imageBlock",
              view: function view(t, _ref53) {
                var e = _ref53.writer;
                return Wf(e, "imageBlock");
              }
            }), n.for("editingDowncast").elementToElement({
              model: "imageBlock",
              view: function view(t, _ref54) {
                var n = _ref54.writer;
                return i.toImageWidget(Wf(n, "imageBlock"), n, e("image widget"));
              }
            }), n.for("downcast").add(sk(i, "imageBlock", "src")).add(sk(i, "imageBlock", "alt")).add(rk(i, "imageBlock")), n.for("upcast").elementToElement({
              view: Gf(t, "imageBlock"),
              model: function model(t, _ref55) {
                var e = _ref55.writer;
                return e.createElement("imageBlock", t.hasAttribute("src") ? {
                  src: t.getAttribute("src")
                } : null);
              }
            }).add(function (t) {
              return function (t) {
                t.on("element:figure", e);
              };

              function e(e, n, i) {
                if (!i.consumable.test(n.viewItem, {
                  name: !0,
                  classes: "image"
                })) return;
                var o = t.findViewImgElement(n.viewItem);
                if (!o || !i.consumable.test(o, {
                  name: !0
                })) return;
                i.consumable.consume(n.viewItem, {
                  name: !0,
                  classes: "image"
                });
                var r = wa(i.convertItem(o, n.modelCursor).modelRange.getItems());
                r ? (i.convertChildren(n.viewItem, r), i.updateConversionResult(r, n)) : i.consumable.revert(n.viewItem, {
                  name: !0,
                  classes: "image"
                });
              }
            }(i));
          }
        }, {
          key: "_setupClipboardIntegration",
          value: function _setupClipboardIntegration() {
            var t = this.editor,
                e = t.model,
                n = t.editing.view,
                i = t.plugins.get("ImageUtils");
            this.listenTo(t.plugins.get("ClipboardPipeline"), "inputTransformation", function (o, r) {
              var s = Array.from(r.content.getChildren());
              var a;
              if (!s.every(i.isInlineImageView)) return;
              a = r.targetRanges ? t.editing.mapper.toModelRange(r.targetRanges[0]) : e.document.selection.getFirstRange();
              var c = e.createSelection(a);

              if ("imageBlock" === $f(e.schema, c)) {
                var _t273 = new eg(n.document),
                    _e257 = s.map(function (e) {
                  return _t273.createElement("figure", {
                    class: "image"
                  }, e);
                });

                r.content = _t273.createDocumentFragment(_e257);
              }
            });
          }
        }], [{
          key: "requires",
          get: function get() {
            return [lk, Yf, kp];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "ImageBlockEditing";
          }
        }]);

        return hk;
      }(ue);

      var uk = n(6359),
          gk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(uk.Z, gk), uk.Z.locals;

      var mk = /*#__PURE__*/function (_ue44) {
        _inherits(mk, _ue44);

        var _super148 = _createSuper(mk);

        function mk() {
          _classCallCheck(this, mk);

          return _super148.apply(this, arguments);
        }

        _createClass(mk, null, [{
          key: "requires",
          get: function get() {
            return [hk, $p, ok];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "ImageBlock";
          }
        }]);

        return mk;
      }(ue);

      var pk = /*#__PURE__*/function (_ue45) {
        _inherits(pk, _ue45);

        var _super149 = _createSuper(pk);

        function pk() {
          _classCallCheck(this, pk);

          return _super149.apply(this, arguments);
        }

        _createClass(pk, [{
          key: "init",
          value: function init() {
            var t = this.editor,
                e = t.model.schema;
            e.register("imageInline", {
              isObject: !0,
              isInline: !0,
              allowWhere: "$text",
              allowAttributesOf: "$text",
              allowAttributes: ["alt", "src", "srcset"]
            }), e.addChildCheck(function (t, e) {
              if (t.endsWith("caption") && "imageInline" === e.name) return !1;
            }), this._setupConversion(), t.plugins.has("ImageBlockEditing") && (t.commands.add("imageTypeInline", new dk(this.editor, "imageInline")), this._setupClipboardIntegration());
          }
        }, {
          key: "_setupConversion",
          value: function _setupConversion() {
            var t = this.editor,
                e = t.t,
                n = t.conversion,
                i = t.plugins.get("ImageUtils");
            n.for("dataDowncast").elementToElement({
              model: "imageInline",
              view: function view(t, _ref56) {
                var e = _ref56.writer;
                return e.createEmptyElement("img");
              }
            }), n.for("editingDowncast").elementToElement({
              model: "imageInline",
              view: function view(t, _ref57) {
                var n = _ref57.writer;
                return i.toImageWidget(Wf(n, "imageInline"), n, e("image widget"));
              }
            }), n.for("downcast").add(sk(i, "imageInline", "src")).add(sk(i, "imageInline", "alt")).add(rk(i, "imageInline")), n.for("upcast").elementToElement({
              view: Gf(t, "imageInline"),
              model: function model(t, _ref58) {
                var e = _ref58.writer;
                return e.createElement("imageInline", t.hasAttribute("src") ? {
                  src: t.getAttribute("src")
                } : null);
              }
            });
          }
        }, {
          key: "_setupClipboardIntegration",
          value: function _setupClipboardIntegration() {
            var t = this.editor,
                e = t.model,
                n = t.editing.view,
                i = t.plugins.get("ImageUtils");
            this.listenTo(t.plugins.get("ClipboardPipeline"), "inputTransformation", function (o, r) {
              var s = Array.from(r.content.getChildren());
              var a;
              if (!s.every(i.isBlockImageView)) return;
              a = r.targetRanges ? t.editing.mapper.toModelRange(r.targetRanges[0]) : e.document.selection.getFirstRange();
              var c = e.createSelection(a);

              if ("imageInline" === $f(e.schema, c)) {
                var _t274 = new eg(n.document),
                    _e258 = s.map(function (e) {
                  return 1 === e.childCount ? (Array.from(e.getAttributes()).forEach(function (n) {
                    return _t274.setAttribute.apply(_t274, _toConsumableArray(n).concat([i.findViewImgElement(e)]));
                  }), e.getChild(0)) : e;
                });

                r.content = _t274.createDocumentFragment(_e258);
              }
            });
          }
        }], [{
          key: "requires",
          get: function get() {
            return [lk, Yf, kp];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "ImageInlineEditing";
          }
        }]);

        return pk;
      }(ue);

      var fk = /*#__PURE__*/function (_ue46) {
        _inherits(fk, _ue46);

        var _super150 = _createSuper(fk);

        function fk() {
          _classCallCheck(this, fk);

          return _super150.apply(this, arguments);
        }

        _createClass(fk, null, [{
          key: "requires",
          get: function get() {
            return [pk, $p, ok];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "ImageInline";
          }
        }]);

        return fk;
      }(ue);

      var kk = /*#__PURE__*/function (_ue47) {
        _inherits(kk, _ue47);

        var _super151 = _createSuper(kk);

        function kk() {
          _classCallCheck(this, kk);

          return _super151.apply(this, arguments);
        }

        _createClass(kk, null, [{
          key: "requires",
          get: function get() {
            return [mk, fk];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "Image";
          }
        }]);

        return kk;
      }(ue);

      function bk(t) {
        var _iterator355 = _createForOfIteratorHelper(t.getChildren()),
            _step355;

        try {
          for (_iterator355.s(); !(_step355 = _iterator355.n()).done;) {
            var _e259 = _step355.value;
            if (_e259 && _e259.is("element", "caption")) return _e259;
          }
        } catch (err) {
          _iterator355.e(err);
        } finally {
          _iterator355.f();
        }

        return null;
      }

      function wk(t, e) {
        var n = e.getFirstPosition().findAncestor("caption");
        return n && t.isBlockImage(n.parent) ? n : null;
      }

      var Ak = /*#__PURE__*/function (_me16) {
        _inherits(Ak, _me16);

        var _super152 = _createSuper(Ak);

        function Ak() {
          _classCallCheck(this, Ak);

          return _super152.apply(this, arguments);
        }

        _createClass(Ak, [{
          key: "refresh",
          value: function refresh() {
            var t = this.editor,
                e = t.plugins.get("ImageUtils");
            if (!t.plugins.has(hk)) return this.isEnabled = !1, void (this.value = !1);
            var n = t.model.document.selection,
                i = n.getSelectedElement();

            if (!i) {
              var _t275 = wk(e, n);

              return this.isEnabled = !!_t275, void (this.value = !!_t275);
            }

            this.isEnabled = this.editor.plugins.get("ImageUtils").isImage(i), this.isEnabled ? this.value = !!bk(i) : this.value = !1;
          }
        }, {
          key: "execute",
          value: function execute() {
            var _this242 = this;

            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var e = t.focusCaptionOnShow;
            this.editor.model.change(function (t) {
              _this242.value ? _this242._hideImageCaption(t) : _this242._showImageCaption(t, e);
            });
          }
        }, {
          key: "_showImageCaption",
          value: function _showImageCaption(t, e) {
            var n = this.editor.model.document.selection,
                i = this.editor.plugins.get("ImageCaptionEditing");
            var o = n.getSelectedElement();

            var r = i._getSavedCaption(o);

            this.editor.plugins.get("ImageUtils").isInlineImage(o) && (this.editor.execute("imageTypeBlock"), o = n.getSelectedElement());
            var s = r || t.createElement("caption");
            t.append(s, o), e && t.setSelection(s, "in");
          }
        }, {
          key: "_hideImageCaption",
          value: function _hideImageCaption(t) {
            var e = this.editor,
                n = e.model.document.selection,
                i = e.plugins.get("ImageCaptionEditing"),
                o = e.plugins.get("ImageUtils");
            var r,
                s = n.getSelectedElement();
            s ? r = bk(s) : (r = wk(o, n), s = r.parent), i._saveCaption(s, r), t.setSelection(s, "on"), t.remove(r);
          }
        }]);

        return Ak;
      }(me);

      var Ck = /*#__PURE__*/function (_ue48) {
        _inherits(Ck, _ue48);

        var _super153 = _createSuper(Ck);

        function Ck(t) {
          var _this243;

          _classCallCheck(this, Ck);

          _this243 = _super153.call(this, t), _this243._savedCaptionsMap = new WeakMap();
          return _this243;
        }

        _createClass(Ck, [{
          key: "init",
          value: function init() {
            var t = this.editor,
                e = t.model.schema;
            e.isRegistered("caption") ? e.extend("caption", {
              allowIn: "imageBlock"
            }) : e.register("caption", {
              allowIn: "imageBlock",
              allowContentOf: "$block",
              isLimit: !0
            }), t.commands.add("toggleImageCaption", new Ak(this.editor)), this._setupConversion(), this._setupImageTypeCommandsIntegration();
          }
        }, {
          key: "_setupConversion",
          value: function _setupConversion() {
            var t = this.editor,
                e = t.editing.view,
                n = t.plugins.get("ImageUtils"),
                i = t.t;
            t.conversion.for("upcast").elementToElement({
              view: function view(t) {
                return function (t, e) {
                  return "figcaption" == e.name && t.isBlockImageView(e.parent) ? {
                    name: !0
                  } : null;
                }(n, t);
              },
              model: "caption"
            }), t.conversion.for("dataDowncast").elementToElement({
              model: "caption",
              view: function view(t, _ref59) {
                var e = _ref59.writer;
                return n.isBlockImage(t.parent) ? e.createContainerElement("figcaption") : null;
              }
            }), t.conversion.for("editingDowncast").elementToElement({
              model: "caption",
              view: function view(t, _ref60) {
                var o = _ref60.writer;
                if (!n.isBlockImage(t.parent)) return null;
                var r = o.createEditableElement("figcaption");
                return o.setCustomProperty("imageCaption", !0, r), Ru({
                  view: e,
                  element: r,
                  text: i("Enter image caption"),
                  keepOnFocus: !0
                }), Mp(r, o);
              }
            }), t.editing.mapper.on("modelToViewPosition", _k(e)), t.data.mapper.on("modelToViewPosition", _k(e));
          }
        }, {
          key: "_setupImageTypeCommandsIntegration",
          value: function _setupImageTypeCommandsIntegration() {
            var _this244 = this;

            var t = this.editor,
                e = t.plugins.get("ImageUtils"),
                n = t.commands.get("imageTypeInline"),
                i = t.commands.get("imageTypeBlock"),
                o = function o(t) {
              if (!t.return) return;
              var _t$return = t.return,
                  n = _t$return.oldElement,
                  i = _t$return.newElement;
              if (!n) return;

              if (e.isBlockImage(n)) {
                var _t276 = bk(n);

                if (_t276) return void _this244._saveCaption(i, _t276);
              }

              var o = _this244._getSavedCaption(n);

              o && _this244._saveCaption(i, o);
            };

            n && this.listenTo(n, "execute", o, {
              priority: "low"
            }), i && this.listenTo(i, "execute", o, {
              priority: "low"
            });
          }
        }, {
          key: "_getSavedCaption",
          value: function _getSavedCaption(t) {
            var e = this._savedCaptionsMap.get(t);

            return e ? Oa.fromJSON(e) : null;
          }
        }, {
          key: "_saveCaption",
          value: function _saveCaption(t, e) {
            this._savedCaptionsMap.set(t, e.toJSON());
          }
        }], [{
          key: "requires",
          get: function get() {
            return [Yf];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "ImageCaptionEditing";
          }
        }]);

        return Ck;
      }(ue);

      function _k(t) {
        return function (e, n) {
          var i = n.modelPosition,
              o = i.parent;
          if (!o.is("element", "imageBlock")) return;
          var r = n.mapper.toViewElement(o);
          n.viewPosition = t.createPositionAt(r, i.offset + 1);
        };
      }

      var vk = /*#__PURE__*/function (_ue49) {
        _inherits(vk, _ue49);

        var _super154 = _createSuper(vk);

        function vk() {
          _classCallCheck(this, vk);

          return _super154.apply(this, arguments);
        }

        _createClass(vk, [{
          key: "init",
          value: function init() {
            var _this245 = this;

            var t = this.editor,
                e = t.editing.view,
                n = t.plugins.get("ImageUtils"),
                i = t.t;
            t.ui.componentFactory.add("toggleImageCaption", function (o) {
              var r = t.commands.get("toggleImageCaption"),
                  s = new oh(o);
              return s.set({
                icon: Ad.caption,
                tooltip: !0,
                isToggleable: !0
              }), s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), s.bind("label").to(r, "value", function (t) {
                return i(t ? "Toggle caption off" : "Toggle caption on");
              }), _this245.listenTo(s, "execute", function () {
                t.execute("toggleImageCaption", {
                  focusCaptionOnShow: !0
                });
                var i = wk(n, t.model.document.selection);

                if (i) {
                  var _n236 = t.editing.mapper.toViewElement(i);

                  e.scrollToTheSelection(), e.change(function (t) {
                    t.addClass("image__caption_highlighted", _n236);
                  });
                }
              }), s;
            });
          }
        }], [{
          key: "requires",
          get: function get() {
            return [Yf];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "ImageCaptionUI";
          }
        }]);

        return vk;
      }(ue);

      var yk = n(7347),
          xk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(yk.Z, xk), yk.Z.locals;

      var Ek = /*#__PURE__*/function (_ue50) {
        _inherits(Ek, _ue50);

        var _super155 = _createSuper(Ek);

        function Ek() {
          _classCallCheck(this, Ek);

          return _super155.apply(this, arguments);
        }

        _createClass(Ek, null, [{
          key: "requires",
          get: function get() {
            return [Ck, vk];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "ImageCaption";
          }
        }]);

        return Ek;
      }(ue);

      var Dk = /*#__PURE__*/function (_me17) {
        _inherits(Dk, _me17);

        var _super156 = _createSuper(Dk);

        function Dk(t, e) {
          var _this246;

          _classCallCheck(this, Dk);

          _this246 = _super156.call(this, t), _this246._defaultStyles = {
            imageBlock: !1,
            imageInline: !1
          }, _this246._styles = new Map(e.map(function (t) {
            if (t.isDefault) {
              var _iterator356 = _createForOfIteratorHelper(t.modelElements),
                  _step356;

              try {
                for (_iterator356.s(); !(_step356 = _iterator356.n()).done;) {
                  var _e260 = _step356.value;
                  _this246._defaultStyles[_e260] = t.name;
                }
              } catch (err) {
                _iterator356.e(err);
              } finally {
                _iterator356.f();
              }
            }

            return [t.name, t];
          }));
          return _this246;
        }

        _createClass(Dk, [{
          key: "refresh",
          value: function refresh() {
            var t = this.editor.plugins.get("ImageUtils").getClosestSelectedImageElement(this.editor.model.document.selection);
            this.isEnabled = !!t, this.isEnabled ? t.hasAttribute("imageStyle") ? this.value = t.getAttribute("imageStyle") : this.value = this._defaultStyles[t.name] : this.value = !1;
          }
        }, {
          key: "execute",
          value: function execute() {
            var _this247 = this;

            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var e = this.editor,
                n = e.model,
                i = e.plugins.get("ImageUtils");
            n.change(function (e) {
              var o = t.value;
              var r = i.getClosestSelectedImageElement(n.document.selection);
              o && _this247.shouldConvertImageType(o, r) && (_this247.editor.execute(i.isBlockImage(r) ? "imageTypeInline" : "imageTypeBlock"), r = i.getClosestSelectedImageElement(n.document.selection)), !o || _this247._styles.get(o).isDefault ? e.removeAttribute("imageStyle", r) : e.setAttribute("imageStyle", o, r);
            });
          }
        }, {
          key: "shouldConvertImageType",
          value: function shouldConvertImageType(t, e) {
            return !this._styles.get(t).modelElements.includes(e.name);
          }
        }]);

        return Dk;
      }(me);

      var Sk = Ad.objectFullWidth,
          Ik = Ad.objectInline,
          Mk = Ad.objectLeft,
          Tk = Ad.objectRight,
          Nk = Ad.objectCenter,
          Bk = Ad.objectBlockLeft,
          zk = Ad.objectBlockRight,
          Pk = {
        inline: {
          name: "inline",
          title: "In line",
          icon: Ik,
          modelElements: ["imageInline"],
          isDefault: !0
        },
        alignLeft: {
          name: "alignLeft",
          title: "Left aligned image",
          icon: Mk,
          modelElements: ["imageBlock", "imageInline"],
          className: "image-style-align-left"
        },
        alignBlockLeft: {
          name: "alignBlockLeft",
          title: "Left aligned image",
          icon: Bk,
          modelElements: ["imageBlock"],
          className: "image-style-block-align-left"
        },
        alignCenter: {
          name: "alignCenter",
          title: "Centered image",
          icon: Nk,
          modelElements: ["imageBlock"],
          className: "image-style-align-center"
        },
        alignRight: {
          name: "alignRight",
          title: "Right aligned image",
          icon: Tk,
          modelElements: ["imageBlock", "imageInline"],
          className: "image-style-align-right"
        },
        alignBlockRight: {
          name: "alignBlockRight",
          title: "Right aligned image",
          icon: zk,
          modelElements: ["imageBlock"],
          className: "image-style-block-align-right"
        },
        block: {
          name: "block",
          title: "Centered image",
          icon: Nk,
          modelElements: ["imageBlock"],
          isDefault: !0
        },
        side: {
          name: "side",
          title: "Side image",
          icon: Tk,
          modelElements: ["imageBlock"],
          className: "image-style-side"
        }
      },
          Lk = {
        full: Sk,
        left: Bk,
        right: zk,
        center: Nk,
        inlineLeft: Mk,
        inlineRight: Tk,
        inline: Ik
      },
          Rk = [{
        name: "imageStyle:wrapText",
        title: "Wrap text",
        defaultItem: "imageStyle:alignLeft",
        items: ["imageStyle:alignLeft", "imageStyle:alignRight"]
      }, {
        name: "imageStyle:breakText",
        title: "Break text",
        defaultItem: "imageStyle:block",
        items: ["imageStyle:alignBlockLeft", "imageStyle:block", "imageStyle:alignBlockRight"]
      }];

      function Ok(t) {
        c("image-style-configuration-definition-invalid", t);
      }

      var jk = {
        normalizeStyles: function normalizeStyles(t) {
          return (t.configuredStyles.options || []).map(function (t) {
            return function (t) {
              t = "string" == typeof t ? Pk[t] ? _objectSpread({}, Pk[t]) : {
                name: t
              } : function (t, e) {
                var n = _objectSpread({}, e);

                for (var _i191 in t) {
                  Object.prototype.hasOwnProperty.call(e, _i191) || (n[_i191] = t[_i191]);
                }

                return n;
              }(Pk[t.name], t);
              "string" == typeof t.icon && (t.icon = Lk[t.icon] || t.icon);
              return t;
            }(t);
          }).filter(function (e) {
            return function (t, _ref61) {
              var e = _ref61.isBlockPluginLoaded,
                  n = _ref61.isInlinePluginLoaded;
              var i = t.modelElements,
                  o = t.name;
              if (!(i && i.length && o)) return Ok({
                style: t
              }), !1;
              {
                var _o101 = [e ? "imageBlock" : null, n ? "imageInline" : null];
                if (!i.some(function (t) {
                  return _o101.includes(t);
                })) return c("image-style-missing-dependency", {
                  style: t,
                  missingPlugins: i.map(function (t) {
                    return "imageBlock" === t ? "ImageBlockEditing" : "ImageInlineEditing";
                  })
                }), !1;
              }
              return !0;
            }(e, t);
          });
        },
        getDefaultStylesConfiguration: function getDefaultStylesConfiguration(t, e) {
          return t && e ? {
            options: ["inline", "alignLeft", "alignRight", "alignCenter", "alignBlockLeft", "alignBlockRight", "block", "side"]
          } : t ? {
            options: ["block", "side"]
          } : e ? {
            options: ["inline", "alignLeft", "alignRight"]
          } : {};
        },
        getDefaultDropdownDefinitions: function getDefaultDropdownDefinitions(t) {
          return t.has("ImageBlockEditing") && t.has("ImageInlineEditing") ? [].concat(Rk) : [];
        },
        warnInvalidStyle: Ok,
        DEFAULT_OPTIONS: Pk,
        DEFAULT_ICONS: Lk,
        DEFAULT_DROPDOWN_DEFINITIONS: Rk
      };

      function Fk(t, e) {
        var _iterator357 = _createForOfIteratorHelper(e),
            _step357;

        try {
          for (_iterator357.s(); !(_step357 = _iterator357.n()).done;) {
            var _n237 = _step357.value;
            if (_n237.name === t) return _n237;
          }
        } catch (err) {
          _iterator357.e(err);
        } finally {
          _iterator357.f();
        }
      }

      var Vk = /*#__PURE__*/function (_ue51) {
        _inherits(Vk, _ue51);

        var _super157 = _createSuper(Vk);

        function Vk() {
          _classCallCheck(this, Vk);

          return _super157.apply(this, arguments);
        }

        _createClass(Vk, [{
          key: "init",
          value: function init() {
            var t = jk.normalizeStyles,
                e = jk.getDefaultStylesConfiguration,
                n = this.editor,
                i = n.plugins.has("ImageBlockEditing"),
                o = n.plugins.has("ImageInlineEditing");
            n.config.define("image.styles", e(i, o)), this.normalizedStyles = t({
              configuredStyles: n.config.get("image.styles"),
              isBlockPluginLoaded: i,
              isInlinePluginLoaded: o
            }), this._setupConversion(i, o), this._setupPostFixer(), n.commands.add("imageStyle", new Dk(n, this.normalizedStyles));
          }
        }, {
          key: "_setupConversion",
          value: function _setupConversion(t, e) {
            var n = this.editor,
                i = n.model.schema,
                o = (r = this.normalizedStyles, function (t, e, n) {
              if (!n.consumable.consume(e.item, t.name)) return;
              var i = Fk(e.attributeNewValue, r),
                  o = Fk(e.attributeOldValue, r),
                  s = n.mapper.toViewElement(e.item),
                  a = n.writer;
              o && a.removeClass(o.className, s), i && a.addClass(i.className, s);
            });
            var r;

            var s = function (t) {
              var e = {
                imageInline: t.filter(function (t) {
                  return !t.isDefault && t.modelElements.includes("imageInline");
                }),
                imageBlock: t.filter(function (t) {
                  return !t.isDefault && t.modelElements.includes("imageBlock");
                })
              };
              return function (t, n, i) {
                if (!n.modelRange) return;
                var o = n.viewItem,
                    r = wa(n.modelRange.getItems());

                if (r && i.schema.checkAttribute(r, "imageStyle")) {
                  var _iterator358 = _createForOfIteratorHelper(e[r.name]),
                      _step358;

                  try {
                    for (_iterator358.s(); !(_step358 = _iterator358.n()).done;) {
                      var _t277 = _step358.value;
                      i.consumable.consume(o, {
                        classes: _t277.className
                      }) && i.writer.setAttribute("imageStyle", _t277.name, r);
                    }
                  } catch (err) {
                    _iterator358.e(err);
                  } finally {
                    _iterator358.f();
                  }
                }
              };
            }(this.normalizedStyles);

            n.editing.downcastDispatcher.on("attribute:imageStyle", o), n.data.downcastDispatcher.on("attribute:imageStyle", o), t && (i.extend("imageBlock", {
              allowAttributes: "imageStyle"
            }), n.data.upcastDispatcher.on("element:figure", s, {
              priority: "low"
            })), e && (i.extend("imageInline", {
              allowAttributes: "imageStyle"
            }), n.data.upcastDispatcher.on("element:img", s, {
              priority: "low"
            }));
          }
        }, {
          key: "_setupPostFixer",
          value: function _setupPostFixer() {
            var t = this.editor,
                e = t.model.document,
                n = t.plugins.get(Yf),
                i = new Map(this.normalizedStyles.map(function (t) {
              return [t.name, t];
            }));
            e.registerPostFixer(function (t) {
              var o = !1;

              var _iterator359 = _createForOfIteratorHelper(e.differ.getChanges()),
                  _step359;

              try {
                for (_iterator359.s(); !(_step359 = _iterator359.n()).done;) {
                  var _r56 = _step359.value;

                  if ("insert" == _r56.type || "attribute" == _r56.type && "imageStyle" == _r56.attributeKey) {
                    var _e261 = "insert" == _r56.type ? _r56.position.nodeAfter : _r56.range.start.nodeAfter;

                    if (_e261 && _e261.is("element", "paragraph") && _e261.childCount > 0 && (_e261 = _e261.getChild(0)), !n.isImage(_e261)) continue;

                    var _s33 = _e261.getAttribute("imageStyle");

                    if (!_s33) continue;

                    var _a18 = i.get(_s33);

                    _a18 && _a18.modelElements.includes(_e261.name) || (t.removeAttribute("imageStyle", _e261), o = !0);
                  }
                }
              } catch (err) {
                _iterator359.e(err);
              } finally {
                _iterator359.f();
              }

              return o;
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "ImageStyleEditing";
          }
        }, {
          key: "requires",
          get: function get() {
            return [Yf];
          }
        }]);

        return Vk;
      }(ue);

      var Uk = n(1443),
          Hk = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Uk.Z, Hk), Uk.Z.locals;

      var qk = /*#__PURE__*/function (_ue52) {
        _inherits(qk, _ue52);

        var _super158 = _createSuper(qk);

        function qk() {
          _classCallCheck(this, qk);

          return _super158.apply(this, arguments);
        }

        _createClass(qk, [{
          key: "localizedDefaultStylesTitles",
          get: function get() {
            var t = this.editor.t;
            return {
              "Wrap text": t("Wrap text"),
              "Break text": t("Break text"),
              "In line": t("In line"),
              "Full size image": t("Full size image"),
              "Side image": t("Side image"),
              "Left aligned image": t("Left aligned image"),
              "Centered image": t("Centered image"),
              "Right aligned image": t("Right aligned image")
            };
          }
        }, {
          key: "init",
          value: function init() {
            var t = this.editor.plugins,
                e = this.editor.config.get("image.toolbar") || [],
                n = Wk(t.get("ImageStyleEditing").normalizedStyles, this.localizedDefaultStylesTitles);

            var _iterator360 = _createForOfIteratorHelper(n),
                _step360;

            try {
              for (_iterator360.s(); !(_step360 = _iterator360.n()).done;) {
                var _t278 = _step360.value;

                this._createButton(_t278);
              }
            } catch (err) {
              _iterator360.e(err);
            } finally {
              _iterator360.f();
            }

            var i = Wk([].concat(_toConsumableArray(e.filter(y)), _toConsumableArray(jk.getDefaultDropdownDefinitions(t))), this.localizedDefaultStylesTitles);

            var _iterator361 = _createForOfIteratorHelper(i),
                _step361;

            try {
              for (_iterator361.s(); !(_step361 = _iterator361.n()).done;) {
                var _t279 = _step361.value;

                this._createDropdown(_t279, n);
              }
            } catch (err) {
              _iterator361.e(err);
            } finally {
              _iterator361.f();
            }
          }
        }, {
          key: "_createDropdown",
          value: function _createDropdown(t, e) {
            var n = this.editor.ui.componentFactory;
            n.add(t.name, function (i) {
              var o;
              var r = t.defaultItem,
                  s = t.items,
                  a = t.title,
                  c = s.filter(function (t) {
                return e.find(function (_ref62) {
                  var e = _ref62.name;
                  return Gk(e) === t;
                });
              }).map(function (t) {
                var e = n.create(t);
                return t === r && (o = e), e;
              });
              s.length !== c.length && jk.warnInvalidStyle({
                dropdown: t
              });
              var l = Hh(i, mh),
                  d = l.buttonView;
              return qh(l, c), d.set({
                label: $k(a, o.label),
                class: null,
                tooltip: !0
              }), d.bind("icon").toMany(c, "isOn", function () {
                for (var _len23 = arguments.length, t = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
                  t[_key23] = arguments[_key23];
                }

                var e = t.findIndex(rt);
                return e < 0 ? o.icon : c[e].icon;
              }), d.bind("label").toMany(c, "isOn", function () {
                for (var _len24 = arguments.length, t = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
                  t[_key24] = arguments[_key24];
                }

                var e = t.findIndex(rt);
                return $k(a, e < 0 ? o.label : c[e].label);
              }), d.bind("isOn").toMany(c, "isOn", function () {
                for (var _len25 = arguments.length, t = new Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
                  t[_key25] = arguments[_key25];
                }

                return t.some(rt);
              }), d.bind("class").toMany(c, "isOn", function () {
                for (var _len26 = arguments.length, t = new Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
                  t[_key26] = arguments[_key26];
                }

                return t.some(rt) ? "ck-splitbutton_flatten" : null;
              }), d.on("execute", function () {
                c.some(function (_ref63) {
                  var t = _ref63.isOn;
                  return t;
                }) ? l.isOpen = !l.isOpen : o.fire("execute");
              }), l.bind("isEnabled").toMany(c, "isEnabled", function () {
                for (var _len27 = arguments.length, t = new Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
                  t[_key27] = arguments[_key27];
                }

                return t.some(rt);
              }), l;
            });
          }
        }, {
          key: "_createButton",
          value: function _createButton(t) {
            var _this248 = this;

            var e = t.name;
            this.editor.ui.componentFactory.add(Gk(e), function (n) {
              var i = _this248.editor.commands.get("imageStyle"),
                  o = new oh(n);

              return o.set({
                label: t.title,
                icon: t.icon,
                tooltip: !0,
                isToggleable: !0
              }), o.bind("isEnabled").to(i, "isEnabled"), o.bind("isOn").to(i, "value", function (t) {
                return t === e;
              }), o.on("execute", _this248._executeCommand.bind(_this248, e)), o;
            });
          }
        }, {
          key: "_executeCommand",
          value: function _executeCommand(t) {
            this.editor.execute("imageStyle", {
              value: t
            }), this.editor.editing.view.focus();
          }
        }], [{
          key: "requires",
          get: function get() {
            return [Vk];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "ImageStyleUI";
          }
        }]);

        return qk;
      }(ue);

      function Wk(t, e) {
        var _iterator362 = _createForOfIteratorHelper(t),
            _step362;

        try {
          for (_iterator362.s(); !(_step362 = _iterator362.n()).done;) {
            var _n238 = _step362.value;
            e[_n238.title] && (_n238.title = e[_n238.title]);
          }
        } catch (err) {
          _iterator362.e(err);
        } finally {
          _iterator362.f();
        }

        return t;
      }

      function Gk(t) {
        return "imageStyle:".concat(t);
      }

      function $k(t, e) {
        return (t ? t + ": " : "") + e;
      }

      var Yk = /*#__PURE__*/function (_ue53) {
        _inherits(Yk, _ue53);

        var _super159 = _createSuper(Yk);

        function Yk() {
          _classCallCheck(this, Yk);

          return _super159.apply(this, arguments);
        }

        _createClass(Yk, null, [{
          key: "requires",
          get: function get() {
            return [Vk, qk];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "ImageStyle";
          }
        }]);

        return Yk;
      }(ue);

      var Kk = /*#__PURE__*/function (_ue54) {
        _inherits(Kk, _ue54);

        var _super160 = _createSuper(Kk);

        function Kk() {
          _classCallCheck(this, Kk);

          return _super160.apply(this, arguments);
        }

        _createClass(Kk, [{
          key: "afterInit",
          value: function afterInit() {
            var t = this.editor,
                e = t.t,
                n = t.plugins.get(Pf),
                i = t.plugins.get("ImageUtils");
            var o;
            n.register("image", {
              ariaLabel: e("Image toolbar"),
              items: (o = t.config.get("image.toolbar") || [], o.map(function (t) {
                return y(t) ? t.name : t;
              })),
              getRelatedElement: function getRelatedElement(t) {
                return i.getClosestSelectedImageWidget(t);
              }
            });
          }
        }], [{
          key: "requires",
          get: function get() {
            return [Pf, Yf];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "ImageToolbar";
          }
        }]);

        return Kk;
      }(ue);

      function Qk(t) {
        var e = t.map(function (t) {
          return t.replace("+", "\\+");
        });
        return new RegExp("^image\\/(".concat(e.join("|"), ")$"));
      }

      function Zk(t) {
        return new Promise(function (e, n) {
          var i = t.getAttribute("src");
          fetch(i).then(function (t) {
            return t.blob();
          }).then(function (t) {
            var n = Jk(t, i),
                o = n.replace("image/", ""),
                r = new File([t], "image.".concat(o), {
              type: n
            });
            e(r);
          }).catch(function (t) {
            return t && "TypeError" === t.name ? function (t) {
              return function (t) {
                return new Promise(function (e, n) {
                  var i = os.document.createElement("img");
                  i.addEventListener("load", function () {
                    var t = os.document.createElement("canvas");
                    t.width = i.width, t.height = i.height;
                    t.getContext("2d").drawImage(i, 0, 0), t.toBlob(function (t) {
                      return t ? e(t) : n();
                    });
                  }), i.addEventListener("error", function () {
                    return n();
                  }), i.src = t;
                });
              }(t).then(function (e) {
                var n = Jk(e, t),
                    i = n.replace("image/", "");
                return new File([e], "image.".concat(i), {
                  type: n
                });
              });
            }(i).then(e).catch(n) : n(t);
          });
        });
      }

      function Jk(t, e) {
        return t.type ? t.type : e.match(/data:(image\/\w+);base64/) ? e.match(/data:(image\/\w+);base64/)[1].toLowerCase() : "image/jpeg";
      }

      var Xk = /*#__PURE__*/function (_ue55) {
        _inherits(Xk, _ue55);

        var _super161 = _createSuper(Xk);

        function Xk() {
          _classCallCheck(this, Xk);

          return _super161.apply(this, arguments);
        }

        _createClass(Xk, [{
          key: "init",
          value: function init() {
            var t = this.editor,
                e = t.t,
                n = function n(_n239) {
              var i = new Zm(_n239),
                  o = t.commands.get("uploadImage"),
                  r = t.config.get("image.upload.types"),
                  s = Qk(r);
              return i.set({
                acceptedType: r.map(function (t) {
                  return "image/".concat(t);
                }).join(","),
                allowMultipleFiles: !0
              }), i.buttonView.set({
                label: e("Insert image"),
                icon: Ad.image,
                tooltip: !0
              }), i.buttonView.bind("isEnabled").to(o), i.on("done", function (e, n) {
                var i = Array.from(n).filter(function (t) {
                  return s.test(t.type);
                });
                i.length && t.execute("uploadImage", {
                  file: i
                });
              }), i;
            };

            t.ui.componentFactory.add("uploadImage", n), t.ui.componentFactory.add("imageUpload", n);
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "ImageUploadUI";
          }
        }]);

        return Xk;
      }(ue);

      var tb = n(4636),
          eb = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      },
          nb = (Zr()(tb.Z, eb), tb.Z.locals, n(5333)),
          ib = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      },
          ob = (Zr()(nb.Z, ib), nb.Z.locals, n(5074)),
          rb = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(ob.Z, rb), ob.Z.locals;

      var sb = /*#__PURE__*/function (_ue56) {
        _inherits(sb, _ue56);

        var _super162 = _createSuper(sb);

        function sb(t) {
          var _this249;

          _classCallCheck(this, sb);

          _this249 = _super162.call(this, t), _this249.placeholder = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
          return _this249;
        }

        _createClass(sb, [{
          key: "init",
          value: function init() {
            var _this250 = this;

            var t = this.editor;
            t.plugins.has("ImageBlockEditing") && t.editing.downcastDispatcher.on("attribute:uploadStatus:imageBlock", function () {
              return _this250.uploadStatusChange.apply(_this250, arguments);
            }), t.plugins.has("ImageInlineEditing") && t.editing.downcastDispatcher.on("attribute:uploadStatus:imageInline", function () {
              return _this250.uploadStatusChange.apply(_this250, arguments);
            });
          }
        }, {
          key: "uploadStatusChange",
          value: function uploadStatusChange(t, e, n) {
            var i = this.editor,
                o = e.item,
                r = o.getAttribute("uploadId");
            if (!n.consumable.consume(e.item, t.name)) return;
            var s = i.plugins.get("ImageUtils"),
                a = i.plugins.get(Km),
                c = r ? e.attributeNewValue : null,
                l = this.placeholder,
                d = i.editing.mapper.toViewElement(o),
                h = n.writer;
            if ("reading" == c) return ab(d, h), void cb(s, l, d, h);

            if ("uploading" == c) {
              var _t280 = a.loaders.get(r);

              return ab(d, h), void (_t280 ? (lb(d, h), function (t, e, n, i) {
                var o = function (t) {
                  var e = t.createUIElement("div", {
                    class: "ck-progress-bar"
                  });
                  return t.setCustomProperty("progressBar", !0, e), e;
                }(e);

                e.insert(e.createPositionAt(t, "end"), o), n.on("change:uploadedPercent", function (t, e, n) {
                  i.change(function (t) {
                    t.setStyle("width", n + "%", o);
                  });
                });
              }(d, h, _t280, i.editing.view), function (t, e, n, i) {
                if (i.data) {
                  var _o102 = t.findViewImgElement(e);

                  n.setAttribute("src", i.data, _o102);
                }
              }(s, d, h, _t280)) : cb(s, l, d, h));
            }

            "complete" == c && a.loaders.get(r) && function (t, e, n) {
              var i = e.createUIElement("div", {
                class: "ck-image-upload-complete-icon"
              });
              e.insert(e.createPositionAt(t, "end"), i), setTimeout(function () {
                n.change(function (t) {
                  return t.remove(t.createRangeOn(i));
                });
              }, 3e3);
            }(d, h, i.editing.view), function (t, e) {
              hb(t, e, "progressBar");
            }(d, h), lb(d, h), function (t, e) {
              e.removeClass("ck-appear", t);
            }(d, h);
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "ImageUploadProgress";
          }
        }]);

        return sb;
      }(ue);

      function ab(t, e) {
        t.hasClass("ck-appear") || e.addClass("ck-appear", t);
      }

      function cb(t, e, n, i) {
        n.hasClass("ck-image-upload-placeholder") || i.addClass("ck-image-upload-placeholder", n);
        var o = t.findViewImgElement(n);
        o.getAttribute("src") !== e && i.setAttribute("src", e, o), db(n, "placeholder") || i.insert(i.createPositionAfter(o), function (t) {
          var e = t.createUIElement("div", {
            class: "ck-upload-placeholder-loader"
          });
          return t.setCustomProperty("placeholder", !0, e), e;
        }(i));
      }

      function lb(t, e) {
        t.hasClass("ck-image-upload-placeholder") && e.removeClass("ck-image-upload-placeholder", t), hb(t, e, "placeholder");
      }

      function db(t, e) {
        var _iterator363 = _createForOfIteratorHelper(t.getChildren()),
            _step363;

        try {
          for (_iterator363.s(); !(_step363 = _iterator363.n()).done;) {
            var _n240 = _step363.value;
            if (_n240.getCustomProperty(e)) return _n240;
          }
        } catch (err) {
          _iterator363.e(err);
        } finally {
          _iterator363.f();
        }
      }

      function hb(t, e, n) {
        var i = db(t, n);
        i && e.remove(e.createRangeOn(i));
      }

      var ub = /*#__PURE__*/function (_me18) {
        _inherits(ub, _me18);

        var _super163 = _createSuper(ub);

        function ub() {
          _classCallCheck(this, ub);

          return _super163.apply(this, arguments);
        }

        _createClass(ub, [{
          key: "refresh",
          value: function refresh() {
            var t = this.editor,
                e = t.plugins.get("ImageUtils"),
                n = t.model.document.selection.getSelectedElement();
            this.isEnabled = e.isImageAllowed() || e.isImage(n);
          }
        }, {
          key: "execute",
          value: function execute(t) {
            var _this251 = this;

            var e = Ii(t.file),
                n = this.editor.model.document.selection,
                i = this.editor.plugins.get("ImageUtils"),
                o = Object.fromEntries(n.getAttributes());
            e.forEach(function (t, e) {
              var r = n.getSelectedElement();

              if (e && r && i.isImage(r)) {
                var _e262 = _this251.editor.model.createPositionAfter(r);

                _this251._uploadImage(t, o, _e262);
              } else _this251._uploadImage(t, o);
            });
          }
        }, {
          key: "_uploadImage",
          value: function _uploadImage(t, e, n) {
            var i = this.editor,
                o = i.plugins.get(Km).createLoader(t),
                r = i.plugins.get("ImageUtils");
            o && r.insertImage(_objectSpread(_objectSpread({}, e), {}, {
              uploadId: o.id
            }), n);
          }
        }]);

        return ub;
      }(me);

      var gb = /*#__PURE__*/function (_ue57) {
        _inherits(gb, _ue57);

        var _super164 = _createSuper(gb);

        function gb(t) {
          var _this252;

          _classCallCheck(this, gb);

          _this252 = _super164.call(this, t), t.config.define("image", {
            upload: {
              types: ["jpeg", "png", "gif", "bmp", "webp", "tiff"]
            }
          }), _this252._uploadImageElements = new Map();
          return _this252;
        }

        _createClass(gb, [{
          key: "init",
          value: function init() {
            var _this253 = this;

            var t = this.editor,
                e = t.model.document,
                n = t.conversion,
                i = t.plugins.get(Km),
                o = t.plugins.get("ImageUtils"),
                r = Qk(t.config.get("image.upload.types")),
                s = new ub(t);
            t.commands.add("uploadImage", s), t.commands.add("imageUpload", s), n.for("upcast").attributeToAttribute({
              view: {
                name: "img",
                key: "uploadId"
              },
              model: "uploadId"
            }), this.listenTo(t.editing.view.document, "clipboardInput", function (e, n) {
              if (i = n.dataTransfer, Array.from(i.types).includes("text/html") && "" !== i.getData("text/html")) return;
              var i;
              var o = Array.from(n.dataTransfer.files).filter(function (t) {
                return !!t && r.test(t.type);
              });
              o.length && (e.stop(), t.model.change(function (e) {
                n.targetRanges && e.setSelection(n.targetRanges.map(function (e) {
                  return t.editing.mapper.toModelRange(e);
                })), t.model.enqueueChange(function () {
                  t.execute("uploadImage", {
                    file: o
                  });
                });
              }));
            }), this.listenTo(t.plugins.get("ClipboardPipeline"), "inputTransformation", function (e, n) {
              var r = Array.from(t.editing.view.createRangeIn(n.content)).filter(function (t) {
                return function (t, e) {
                  return !(!t.isInlineImageView(e) || !e.getAttribute("src")) && (e.getAttribute("src").match(/^data:image\/\w+;base64,/g) || e.getAttribute("src").match(/^blob:/g));
                }(o, t.item) && !t.item.getAttribute("uploadProcessed");
              }).map(function (t) {
                return {
                  promise: Zk(t.item),
                  imageElement: t.item
                };
              });
              if (!r.length) return;
              var s = new eg(t.editing.view.document);

              var _iterator364 = _createForOfIteratorHelper(r),
                  _step364;

              try {
                for (_iterator364.s(); !(_step364 = _iterator364.n()).done;) {
                  var _t281 = _step364.value;
                  s.setAttribute("uploadProcessed", !0, _t281.imageElement);

                  var _e263 = i.createLoader(_t281.promise);

                  _e263 && (s.setAttribute("src", "", _t281.imageElement), s.setAttribute("uploadId", _e263.id, _t281.imageElement));
                }
              } catch (err) {
                _iterator364.e(err);
              } finally {
                _iterator364.f();
              }
            }), t.editing.view.document.on("dragover", function (t, e) {
              e.preventDefault();
            }), e.on("change", function () {
              var n = e.differ.getChanges({
                includeChangesInGraveyard: !0
              }).reverse(),
                  o = new Set();

              var _iterator365 = _createForOfIteratorHelper(n),
                  _step365;

              try {
                for (_iterator365.s(); !(_step365 = _iterator365.n()).done;) {
                  var _e264 = _step365.value;

                  if ("insert" == _e264.type && "$text" != _e264.name) {
                    var _n241 = _e264.position.nodeAfter,
                        _r57 = "$graveyard" == _e264.position.root.rootName;

                    var _iterator366 = _createForOfIteratorHelper(mb(t, _n241)),
                        _step366;

                    try {
                      for (_iterator366.s(); !(_step366 = _iterator366.n()).done;) {
                        var _e265 = _step366.value;

                        var _t282 = _e265.getAttribute("uploadId");

                        if (!_t282) continue;

                        var _n242 = i.loaders.get(_t282);

                        _n242 && (_r57 ? o.has(_t282) || _n242.abort() : (o.add(_t282), _this253._uploadImageElements.set(_t282, _e265), "idle" == _n242.status && _this253._readAndUpload(_n242)));
                      }
                    } catch (err) {
                      _iterator366.e(err);
                    } finally {
                      _iterator366.f();
                    }
                  }
                }
              } catch (err) {
                _iterator365.e(err);
              } finally {
                _iterator365.f();
              }
            }), this.on("uploadComplete", function (t, _ref64) {
              var e = _ref64.imageElement,
                  n = _ref64.data;
              var i = n.urls ? n.urls : n;

              _this253.editor.model.change(function (t) {
                t.setAttribute("src", i.default, e), _this253._parseAndSetSrcsetAttributeOnImage(i, e, t);
              });
            }, {
              priority: "low"
            });
          }
        }, {
          key: "afterInit",
          value: function afterInit() {
            var t = this.editor.model.schema;
            this.editor.plugins.has("ImageBlockEditing") && t.extend("imageBlock", {
              allowAttributes: ["uploadId", "uploadStatus"]
            }), this.editor.plugins.has("ImageInlineEditing") && t.extend("imageInline", {
              allowAttributes: ["uploadId", "uploadStatus"]
            });
          }
        }, {
          key: "_readAndUpload",
          value: function _readAndUpload(t) {
            var _this254 = this;

            var e = this.editor,
                n = e.model,
                i = e.locale.t,
                o = e.plugins.get(Km),
                r = e.plugins.get(hu),
                s = e.plugins.get("ImageUtils"),
                a = this._uploadImageElements;
            return n.enqueueChange({
              isUndoable: !1
            }, function (e) {
              e.setAttribute("uploadStatus", "reading", a.get(t.id));
            }), t.read().then(function () {
              var i = t.upload(),
                  o = a.get(t.id);

              if (sr.isSafari) {
                var _t283 = e.editing.mapper.toViewElement(o),
                    _n243 = s.findViewImgElement(_t283);

                e.editing.view.once("render", function () {
                  if (!_n243.parent) return;
                  var t = e.editing.view.domConverter.mapViewToDom(_n243.parent);
                  if (!t) return;
                  var i = t.style.display;
                  t.style.display = "none", t._ckHack = t.offsetHeight, t.style.display = i;
                });
              }

              return n.enqueueChange({
                isUndoable: !1
              }, function (t) {
                t.setAttribute("uploadStatus", "uploading", o);
              }), i;
            }).then(function (e) {
              n.enqueueChange({
                isUndoable: !1
              }, function (n) {
                var i = a.get(t.id);
                n.setAttribute("uploadStatus", "complete", i), _this254.fire("uploadComplete", {
                  data: e,
                  imageElement: i
                });
              }), c();
            }).catch(function (e) {
              if ("error" !== t.status && "aborted" !== t.status) throw e;
              "error" == t.status && e && r.showWarning(e, {
                title: i("Upload failed"),
                namespace: "upload"
              }), n.enqueueChange({
                isUndoable: !1
              }, function (e) {
                e.remove(a.get(t.id));
              }), c();
            });

            function c() {
              n.enqueueChange({
                isUndoable: !1
              }, function (e) {
                var n = a.get(t.id);
                e.removeAttribute("uploadId", n), e.removeAttribute("uploadStatus", n), a.delete(t.id);
              }), o.destroyLoader(t);
            }
          }
        }, {
          key: "_parseAndSetSrcsetAttributeOnImage",
          value: function _parseAndSetSrcsetAttributeOnImage(t, e, n) {
            var i = 0;
            var o = Object.keys(t).filter(function (t) {
              var e = parseInt(t, 10);
              if (!isNaN(e)) return i = Math.max(i, e), !0;
            }).map(function (e) {
              return "".concat(t[e], " ").concat(e, "w");
            }).join(", ");
            "" != o && n.setAttribute("srcset", {
              data: o,
              width: i
            }, e);
          }
        }], [{
          key: "requires",
          get: function get() {
            return [Km, hu, kp, Yf];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "ImageUploadEditing";
          }
        }]);

        return gb;
      }(ue);

      function mb(t, e) {
        var n = t.plugins.get("ImageUtils");
        return Array.from(t.model.createRangeOn(e)).filter(function (t) {
          return n.isImage(t.item);
        }).map(function (t) {
          return t.item;
        });
      }

      var pb = /*#__PURE__*/function (_ue58) {
        _inherits(pb, _ue58);

        var _super165 = _createSuper(pb);

        function pb() {
          _classCallCheck(this, pb);

          return _super165.apply(this, arguments);
        }

        _createClass(pb, null, [{
          key: "pluginName",
          get: function get() {
            return "ImageUpload";
          }
        }, {
          key: "requires",
          get: function get() {
            return [gb, Xk, sb];
          }
        }]);

        return pb;
      }(ue);

      var fb = /*#__PURE__*/function (_ue59) {
        _inherits(fb, _ue59);

        var _super166 = _createSuper(fb);

        function fb() {
          _classCallCheck(this, fb);

          return _super166.apply(this, arguments);
        }

        _createClass(fb, [{
          key: "init",
          value: function init() {
            var t = this.editor;
            t.commands.add("indent", new fe(t)), t.commands.add("outdent", new fe(t));
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "IndentEditing";
          }
        }]);

        return fb;
      }(ue);

      var kb = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zM1.632 6.95 5.02 9.358a.4.4 0 0 1-.013.661l-3.39 2.207A.4.4 0 0 1 1 11.892V7.275a.4.4 0 0 1 .632-.326z"/></svg>',
          bb = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zm1.618-9.55L.98 9.358a.4.4 0 0 0 .013.661l3.39 2.207A.4.4 0 0 0 5 11.892V7.275a.4.4 0 0 0-.632-.326z"/></svg>';

      var wb = /*#__PURE__*/function (_ue60) {
        _inherits(wb, _ue60);

        var _super167 = _createSuper(wb);

        function wb() {
          _classCallCheck(this, wb);

          return _super167.apply(this, arguments);
        }

        _createClass(wb, [{
          key: "init",
          value: function init() {
            var t = this.editor,
                e = t.locale,
                n = t.t,
                i = "ltr" == e.uiLanguageDirection ? kb : bb,
                o = "ltr" == e.uiLanguageDirection ? bb : kb;
            this._defineButton("indent", n("Increase indent"), i), this._defineButton("outdent", n("Decrease indent"), o);
          }
        }, {
          key: "_defineButton",
          value: function _defineButton(t, e, n) {
            var _this255 = this;

            var i = this.editor;
            i.ui.componentFactory.add(t, function (o) {
              var r = i.commands.get(t),
                  s = new oh(o);
              return s.set({
                label: e,
                icon: n,
                tooltip: !0
              }), s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), _this255.listenTo(s, "execute", function () {
                i.execute(t), i.editing.view.focus();
              }), s;
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "IndentUI";
          }
        }]);

        return wb;
      }(ue);

      var Ab = /*#__PURE__*/function (_ue61) {
        _inherits(Ab, _ue61);

        var _super168 = _createSuper(Ab);

        function Ab() {
          _classCallCheck(this, Ab);

          return _super168.apply(this, arguments);
        }

        _createClass(Ab, null, [{
          key: "pluginName",
          get: function get() {
            return "Indent";
          }
        }, {
          key: "requires",
          get: function get() {
            return [fb, wb];
          }
        }]);

        return Ab;
      }(ue);

      var Cb = "italic";

      var _b = /*#__PURE__*/function (_ue62) {
        _inherits(_b, _ue62);

        var _super169 = _createSuper(_b);

        function _b() {
          _classCallCheck(this, _b);

          return _super169.apply(this, arguments);
        }

        _createClass(_b, [{
          key: "init",
          value: function init() {
            var t = this.editor;
            t.model.schema.extend("$text", {
              allowAttributes: Cb
            }), t.model.schema.setAttributeProperties(Cb, {
              isFormatting: !0,
              copyOnEnter: !0
            }), t.conversion.attributeToElement({
              model: Cb,
              view: "i",
              upcastAlso: ["em", {
                styles: {
                  "font-style": "italic"
                }
              }]
            }), t.commands.add(Cb, new Um(t, Cb)), t.keystrokes.set("CTRL+I", Cb);
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "ItalicEditing";
          }
        }]);

        return _b;
      }(ue);

      var vb = "italic";

      var yb = /*#__PURE__*/function (_ue63) {
        _inherits(yb, _ue63);

        var _super170 = _createSuper(yb);

        function yb() {
          _classCallCheck(this, yb);

          return _super170.apply(this, arguments);
        }

        _createClass(yb, [{
          key: "init",
          value: function init() {
            var _this256 = this;

            var t = this.editor,
                e = t.t;
            t.ui.componentFactory.add(vb, function (n) {
              var i = t.commands.get(vb),
                  o = new oh(n);
              return o.set({
                label: e("Italic"),
                icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.586 14.633.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>',
                keystroke: "CTRL+I",
                tooltip: !0,
                isToggleable: !0
              }), o.bind("isOn", "isEnabled").to(i, "value", "isEnabled"), _this256.listenTo(o, "execute", function () {
                t.execute(vb), t.editing.view.focus();
              }), o;
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "ItalicUI";
          }
        }]);

        return yb;
      }(ue);

      var xb = /*#__PURE__*/function (_ue64) {
        _inherits(xb, _ue64);

        var _super171 = _createSuper(xb);

        function xb() {
          _classCallCheck(this, xb);

          return _super171.apply(this, arguments);
        }

        _createClass(xb, null, [{
          key: "requires",
          get: function get() {
            return [_b, yb];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "Italic";
          }
        }]);

        return xb;
      }(ue);

      var Eb = /*#__PURE__*/function () {
        function Eb() {
          _classCallCheck(this, Eb);

          this._definitions = new Set();
        }

        _createClass(Eb, [{
          key: "length",
          get: function get() {
            return this._definitions.size;
          }
        }, {
          key: "add",
          value: function add(t) {
            var _this257 = this;

            Array.isArray(t) ? t.forEach(function (t) {
              return _this257._definitions.add(t);
            }) : this._definitions.add(t);
          }
        }, {
          key: "getDispatcher",
          value: function getDispatcher() {
            var _this258 = this;

            return function (t) {
              t.on("attribute:linkHref", function (t, e, n) {
                if (!n.consumable.test(e.item, "attribute:linkHref")) return;
                var i = n.writer,
                    o = i.document.selection;

                var _iterator367 = _createForOfIteratorHelper(_this258._definitions),
                    _step367;

                try {
                  for (_iterator367.s(); !(_step367 = _iterator367.n()).done;) {
                    var _t284 = _step367.value;

                    var _r58 = i.createAttributeElement("a", _t284.attributes, {
                      priority: 5
                    });

                    _t284.classes && i.addClass(_t284.classes, _r58);

                    for (var _e266 in _t284.styles) {
                      i.setStyle(_e266, _t284.styles[_e266], _r58);
                    }

                    i.setCustomProperty("link", !0, _r58), _t284.callback(e.attributeNewValue) ? e.item.is("selection") ? i.wrap(o.getFirstRange(), _r58) : i.wrap(n.mapper.toViewRange(e.range), _r58) : i.unwrap(n.mapper.toViewRange(e.range), _r58);
                  }
                } catch (err) {
                  _iterator367.e(err);
                } finally {
                  _iterator367.f();
                }
              }, {
                priority: "high"
              });
            };
          }
        }, {
          key: "getDispatcherForLinkedImage",
          value: function getDispatcherForLinkedImage() {
            var _this259 = this;

            return function (t) {
              t.on("attribute:linkHref:imageBlock", function (t, e, _ref65) {
                var n = _ref65.writer,
                    i = _ref65.mapper;
                var o = i.toViewElement(e.item),
                    r = Array.from(o.getChildren()).find(function (t) {
                  return "a" === t.name;
                });

                var _iterator368 = _createForOfIteratorHelper(_this259._definitions),
                    _step368;

                try {
                  for (_iterator368.s(); !(_step368 = _iterator368.n()).done;) {
                    var _t285 = _step368.value;

                    var _i192 = Vi(_t285.attributes);

                    if (_t285.callback(e.attributeNewValue)) {
                      var _iterator369 = _createForOfIteratorHelper(_i192),
                          _step369;

                      try {
                        for (_iterator369.s(); !(_step369 = _iterator369.n()).done;) {
                          var _step369$value = _slicedToArray(_step369.value, 2),
                              _t286 = _step369$value[0],
                              _e268 = _step369$value[1];

                          "class" === _t286 ? n.addClass(_e268, r) : n.setAttribute(_t286, _e268, r);
                        }
                      } catch (err) {
                        _iterator369.e(err);
                      } finally {
                        _iterator369.f();
                      }

                      _t285.classes && n.addClass(_t285.classes, r);

                      for (var _e267 in _t285.styles) {
                        n.setStyle(_e267, _t285.styles[_e267], r);
                      }
                    } else {
                      var _iterator370 = _createForOfIteratorHelper(_i192),
                          _step370;

                      try {
                        for (_iterator370.s(); !(_step370 = _iterator370.n()).done;) {
                          var _step370$value = _slicedToArray(_step370.value, 2),
                              _t287 = _step370$value[0],
                              _e270 = _step370$value[1];

                          "class" === _t287 ? n.removeClass(_e270, r) : n.removeAttribute(_t287, r);
                        }
                      } catch (err) {
                        _iterator370.e(err);
                      } finally {
                        _iterator370.f();
                      }

                      _t285.classes && n.removeClass(_t285.classes, r);

                      for (var _e269 in _t285.styles) {
                        n.removeStyle(_e269, r);
                      }
                    }
                  }
                } catch (err) {
                  _iterator368.e(err);
                } finally {
                  _iterator368.f();
                }
              });
            };
          }
        }]);

        return Eb;
      }();

      var Db = /*#__PURE__*/function (_me19) {
        _inherits(Db, _me19);

        var _super172 = _createSuper(Db);

        function Db(t) {
          var _this260;

          _classCallCheck(this, Db);

          _this260 = _super172.call(this, t), _this260.manualDecorators = new Di(), _this260.automaticDecorators = new Eb();
          return _this260;
        }

        _createClass(Db, [{
          key: "restoreManualDecoratorStates",
          value: function restoreManualDecoratorStates() {
            var _iterator371 = _createForOfIteratorHelper(this.manualDecorators),
                _step371;

            try {
              for (_iterator371.s(); !(_step371 = _iterator371.n()).done;) {
                var _t288 = _step371.value;
                _t288.value = this._getDecoratorStateFromModel(_t288.id);
              }
            } catch (err) {
              _iterator371.e(err);
            } finally {
              _iterator371.f();
            }
          }
        }, {
          key: "refresh",
          value: function refresh() {
            var t = this.editor.model,
                e = t.document.selection,
                n = e.getSelectedElement() || wa(e.getSelectedBlocks());
            bm(n, t.schema) ? (this.value = n.getAttribute("linkHref"), this.isEnabled = t.schema.checkAttribute(n, "linkHref")) : (this.value = e.getAttribute("linkHref"), this.isEnabled = t.schema.checkAttributeInSelection(e, "linkHref"));

            var _iterator372 = _createForOfIteratorHelper(this.manualDecorators),
                _step372;

            try {
              for (_iterator372.s(); !(_step372 = _iterator372.n()).done;) {
                var _t289 = _step372.value;
                _t289.value = this._getDecoratorStateFromModel(_t289.id);
              }
            } catch (err) {
              _iterator372.e(err);
            } finally {
              _iterator372.f();
            }
          }
        }, {
          key: "execute",
          value: function execute(t) {
            var _this261 = this;

            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var n = this.editor.model,
                i = n.document.selection,
                o = [],
                r = [];

            for (var _t290 in e) {
              e[_t290] ? o.push(_t290) : r.push(_t290);
            }

            n.change(function (e) {
              if (i.isCollapsed) {
                var _s34 = i.getFirstPosition();

                if (i.hasAttribute("linkHref")) {
                  var _a19 = Fg(_s34, "linkHref", i.getAttribute("linkHref"), n);

                  e.setAttribute("linkHref", t, _a19), o.forEach(function (t) {
                    e.setAttribute(t, !0, _a19);
                  }), r.forEach(function (t) {
                    e.removeAttribute(t, _a19);
                  }), e.setSelection(e.createPositionAfter(_a19.end.nodeBefore));
                } else if ("" !== t) {
                  var _r59 = Vi(i.getAttributes());

                  _r59.set("linkHref", t), o.forEach(function (t) {
                    _r59.set(t, !0);
                  });

                  var _n$insertContent = n.insertContent(e.createText(t, _r59), _s34),
                      _a20 = _n$insertContent.end;

                  e.setSelection(_a20);
                }

                ["linkHref"].concat(o, r).forEach(function (t) {
                  e.removeSelectionAttribute(t);
                });
              } else {
                var _s35 = n.schema.getValidRanges(i.getRanges(), "linkHref"),
                    _a21 = [];

                var _iterator373 = _createForOfIteratorHelper(i.getSelectedBlocks()),
                    _step373;

                try {
                  for (_iterator373.s(); !(_step373 = _iterator373.n()).done;) {
                    var _t291 = _step373.value;
                    n.schema.checkAttribute(_t291, "linkHref") && _a21.push(e.createRangeOn(_t291));
                  }
                } catch (err) {
                  _iterator373.e(err);
                } finally {
                  _iterator373.f();
                }

                var _c9 = _a21.slice();

                var _iterator374 = _createForOfIteratorHelper(_s35),
                    _step374;

                try {
                  for (_iterator374.s(); !(_step374 = _iterator374.n()).done;) {
                    var _t292 = _step374.value;
                    _this261._isRangeToUpdate(_t292, _a21) && _c9.push(_t292);
                  }
                } catch (err) {
                  _iterator374.e(err);
                } finally {
                  _iterator374.f();
                }

                var _iterator375 = _createForOfIteratorHelper(_c9),
                    _step375;

                try {
                  var _loop7 = function _loop7() {
                    var n = _step375.value;
                    e.setAttribute("linkHref", t, n), o.forEach(function (t) {
                      e.setAttribute(t, !0, n);
                    }), r.forEach(function (t) {
                      e.removeAttribute(t, n);
                    });
                  };

                  for (_iterator375.s(); !(_step375 = _iterator375.n()).done;) {
                    _loop7();
                  }
                } catch (err) {
                  _iterator375.e(err);
                } finally {
                  _iterator375.f();
                }
              }
            });
          }
        }, {
          key: "_getDecoratorStateFromModel",
          value: function _getDecoratorStateFromModel(t) {
            var e = this.editor.model,
                n = e.document.selection,
                i = n.getSelectedElement();
            return bm(i, e.schema) ? i.getAttribute(t) : n.getAttribute(t);
          }
        }, {
          key: "_isRangeToUpdate",
          value: function _isRangeToUpdate(t, e) {
            var _iterator376 = _createForOfIteratorHelper(e),
                _step376;

            try {
              for (_iterator376.s(); !(_step376 = _iterator376.n()).done;) {
                var _n244 = _step376.value;
                if (_n244.containsRange(t)) return !1;
              }
            } catch (err) {
              _iterator376.e(err);
            } finally {
              _iterator376.f();
            }

            return !0;
          }
        }]);

        return Db;
      }(me);

      var Sb = /*#__PURE__*/function (_me20) {
        _inherits(Sb, _me20);

        var _super173 = _createSuper(Sb);

        function Sb() {
          _classCallCheck(this, Sb);

          return _super173.apply(this, arguments);
        }

        _createClass(Sb, [{
          key: "refresh",
          value: function refresh() {
            var t = this.editor.model,
                e = t.document.selection,
                n = e.getSelectedElement();
            bm(n, t.schema) ? this.isEnabled = t.schema.checkAttribute(n, "linkHref") : this.isEnabled = t.schema.checkAttributeInSelection(e, "linkHref");
          }
        }, {
          key: "execute",
          value: function execute() {
            var t = this.editor,
                e = this.editor.model,
                n = e.document.selection,
                i = t.commands.get("link");
            e.change(function (t) {
              var o = n.isCollapsed ? [Fg(n.getFirstPosition(), "linkHref", n.getAttribute("linkHref"), e)] : e.schema.getValidRanges(n.getRanges(), "linkHref");

              var _iterator377 = _createForOfIteratorHelper(o),
                  _step377;

              try {
                for (_iterator377.s(); !(_step377 = _iterator377.n()).done;) {
                  var _e271 = _step377.value;

                  if (t.removeAttribute("linkHref", _e271), i) {
                    var _iterator378 = _createForOfIteratorHelper(i.manualDecorators),
                        _step378;

                    try {
                      for (_iterator378.s(); !(_step378 = _iterator378.n()).done;) {
                        var _n245 = _step378.value;
                        t.removeAttribute(_n245.id, _e271);
                      }
                    } catch (err) {
                      _iterator378.e(err);
                    } finally {
                      _iterator378.f();
                    }
                  }
                }
              } catch (err) {
                _iterator377.e(err);
              } finally {
                _iterator377.f();
              }
            });
          }
        }]);

        return Sb;
      }(me);

      var Ib = /*#__PURE__*/function () {
        function Ib(_ref66) {
          var t = _ref66.id,
              e = _ref66.label,
              n = _ref66.attributes,
              i = _ref66.classes,
              o = _ref66.styles,
              r = _ref66.defaultValue;

          _classCallCheck(this, Ib);

          this.id = t, this.set("value"), this.defaultValue = r, this.label = e, this.attributes = n, this.classes = i, this.styles = o;
        }

        _createClass(Ib, [{
          key: "_createPattern",
          value: function _createPattern() {
            return {
              attributes: this.attributes,
              classes: this.classes,
              styles: this.styles
            };
          }
        }]);

        return Ib;
      }();

      he(Ib, re);
      var Mb = n(9352),
          Tb = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Mb.Z, Tb), Mb.Z.locals;
      var Nb = "automatic",
          Bb = /^(https?:)?\/\//;

      var zb = /*#__PURE__*/function (_ue65) {
        _inherits(zb, _ue65);

        var _super174 = _createSuper(zb);

        function zb(t) {
          var _this262;

          _classCallCheck(this, zb);

          _this262 = _super174.call(this, t), t.config.define("link", {
            addTargetToExternalLinks: !1
          });
          return _this262;
        }

        _createClass(zb, [{
          key: "init",
          value: function init() {
            var t = this.editor;
            t.model.schema.extend("$text", {
              allowAttributes: "linkHref"
            }), t.conversion.for("dataDowncast").attributeToElement({
              model: "linkHref",
              view: fm
            }), t.conversion.for("editingDowncast").attributeToElement({
              model: "linkHref",
              view: function view(t, e) {
                return fm(km(t), e);
              }
            }), t.conversion.for("upcast").elementToAttribute({
              view: {
                name: "a",
                attributes: {
                  href: !0
                }
              },
              model: {
                key: "linkHref",
                value: function value(t) {
                  return t.getAttribute("href");
                }
              }
            }), t.commands.add("link", new Db(t)), t.commands.add("unlink", new Sb(t));

            var e = function (t, e) {
              var n = {
                "Open in a new tab": t("Open in a new tab"),
                Downloadable: t("Downloadable")
              };
              return e.forEach(function (t) {
                return t.label && n[t.label] && (t.label = n[t.label]), t;
              }), e;
            }(t.t, function (t) {
              var e = [];
              if (t) for (var _i193 = 0, _Object$entries2 = Object.entries(t); _i193 < _Object$entries2.length; _i193++) {
                var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i193], 2),
                    _n246 = _Object$entries2$_i[0],
                    _i194 = _Object$entries2$_i[1];

                var _t293 = Object.assign({}, _i194, {
                  id: "link".concat(dm(_n246))
                });

                e.push(_t293);
              }
              return e;
            }(t.config.get("link.decorators")));

            this._enableAutomaticDecorators(e.filter(function (t) {
              return t.mode === Nb;
            })), this._enableManualDecorators(e.filter(function (t) {
              return "manual" === t.mode;
            }));
            t.plugins.get(yg).registerAttribute("linkHref"), function (t, e, n, i) {
              var o = t.editing.view,
                  r = new Set();
              o.document.registerPostFixer(function (o) {
                var s = t.model.document.selection;
                var a = !1;

                if (s.hasAttribute(e)) {
                  var _c10 = Fg(s.getFirstPosition(), e, s.getAttribute(e), t.model),
                      _l6 = t.editing.mapper.toViewRange(_c10);

                  var _iterator379 = _createForOfIteratorHelper(_l6.getItems()),
                      _step379;

                  try {
                    for (_iterator379.s(); !(_step379 = _iterator379.n()).done;) {
                      var _t294 = _step379.value;
                      _t294.is("element", n) && !_t294.hasClass(i) && (o.addClass(i, _t294), r.add(_t294), a = !0);
                    }
                  } catch (err) {
                    _iterator379.e(err);
                  } finally {
                    _iterator379.f();
                  }
                }

                return a;
              }), t.conversion.for("editingDowncast").add(function (t) {
                function e() {
                  o.change(function (t) {
                    var _iterator380 = _createForOfIteratorHelper(r.values()),
                        _step380;

                    try {
                      for (_iterator380.s(); !(_step380 = _iterator380.n()).done;) {
                        var _e272 = _step380.value;
                        t.removeClass(i, _e272), r.delete(_e272);
                      }
                    } catch (err) {
                      _iterator380.e(err);
                    } finally {
                      _iterator380.f();
                    }
                  });
                }

                t.on("insert", e, {
                  priority: "highest"
                }), t.on("remove", e, {
                  priority: "highest"
                }), t.on("attribute", e, {
                  priority: "highest"
                }), t.on("selection", e, {
                  priority: "highest"
                });
              });
            }(t, "linkHref", "a", "ck-link_selected"), this._enableLinkOpen(), this._enableInsertContentSelectionAttributesFixer(), this._enableClickingAfterLink(), this._enableTypingOverLink(), this._handleDeleteContentAfterLink();
          }
        }, {
          key: "_enableAutomaticDecorators",
          value: function _enableAutomaticDecorators(t) {
            var e = this.editor,
                n = e.commands.get("link").automaticDecorators;
            e.config.get("link.addTargetToExternalLinks") && n.add({
              id: "linkIsExternal",
              mode: Nb,
              callback: function callback(t) {
                return Bb.test(t);
              },
              attributes: {
                target: "_blank",
                rel: "noopener noreferrer"
              }
            }), n.add(t), n.length && e.conversion.for("downcast").add(n.getDispatcher());
          }
        }, {
          key: "_enableManualDecorators",
          value: function _enableManualDecorators(t) {
            if (!t.length) return;
            var e = this.editor,
                n = e.commands.get("link").manualDecorators;
            t.forEach(function (t) {
              e.model.schema.extend("$text", {
                allowAttributes: t.id
              }), t = new Ib(t), n.add(t), e.conversion.for("downcast").attributeToElement({
                model: t.id,
                view: function view(e, _ref67) {
                  var n = _ref67.writer;

                  if (e) {
                    var _e273 = n.createAttributeElement("a", t.attributes, {
                      priority: 5
                    });

                    t.classes && n.addClass(t.classes, _e273);

                    for (var _i195 in t.styles) {
                      n.setStyle(_i195, t.styles[_i195], _e273);
                    }

                    return n.setCustomProperty("link", !0, _e273), _e273;
                  }
                }
              }), e.conversion.for("upcast").elementToAttribute({
                view: _objectSpread({
                  name: "a"
                }, t._createPattern()),
                model: {
                  key: t.id
                }
              });
            });
          }
        }, {
          key: "_enableLinkOpen",
          value: function _enableLinkOpen() {
            var t = this.editor,
                e = t.editing.view.document,
                n = t.model.document;
            this.listenTo(e, "click", function (t, e) {
              if (!(sr.isMac ? e.domEvent.metaKey : e.domEvent.ctrlKey)) return;
              var n = e.domTarget;
              if ("a" != n.tagName.toLowerCase() && (n = n.closest("a")), !n) return;
              var i = n.getAttribute("href");
              i && (t.stop(), e.preventDefault(), Am(i));
            }, {
              context: "$capture"
            }), this.listenTo(e, "enter", function (t, e) {
              var i = n.selection,
                  o = i.getSelectedElement(),
                  r = o ? o.getAttribute("linkHref") : i.getAttribute("linkHref");
              r && e.domEvent.altKey && (t.stop(), Am(r));
            }, {
              context: "a"
            });
          }
        }, {
          key: "_enableInsertContentSelectionAttributesFixer",
          value: function _enableInsertContentSelectionAttributesFixer() {
            var t = this.editor.model,
                e = t.document.selection;
            this.listenTo(t, "insertContent", function () {
              var n = e.anchor.nodeBefore,
                  i = e.anchor.nodeAfter;
              e.hasAttribute("linkHref") && n && n.hasAttribute("linkHref") && (i && i.hasAttribute("linkHref") || t.change(function (e) {
                Pb(e, Rb(t.schema));
              }));
            }, {
              priority: "low"
            });
          }
        }, {
          key: "_enableClickingAfterLink",
          value: function _enableClickingAfterLink() {
            var t = this.editor,
                e = t.model;
            t.editing.view.addObserver(tg);
            var n = !1;
            this.listenTo(t.editing.view.document, "mousedown", function () {
              n = !0;
            }), this.listenTo(t.editing.view.document, "selectionChange", function () {
              if (!n) return;
              n = !1;
              var t = e.document.selection;
              if (!t.isCollapsed) return;
              if (!t.hasAttribute("linkHref")) return;
              var i = t.getFirstPosition(),
                  o = Fg(i, "linkHref", t.getAttribute("linkHref"), e);
              (i.isTouching(o.start) || i.isTouching(o.end)) && e.change(function (t) {
                Pb(t, Rb(e.schema));
              });
            });
          }
        }, {
          key: "_enableTypingOverLink",
          value: function _enableTypingOverLink() {
            var t = this.editor,
                e = t.editing.view;
            var n, i;
            this.listenTo(e.document, "delete", function () {
              i = !0;
            }, {
              priority: "high"
            }), this.listenTo(t.model, "deleteContent", function () {
              var e = t.model.document.selection;
              e.isCollapsed || (i ? i = !1 : Lb(t) && function (t) {
                var e = t.document.selection,
                    n = e.getFirstPosition(),
                    i = e.getLastPosition(),
                    o = n.nodeAfter;
                if (!o) return !1;
                if (!o.is("$text")) return !1;
                if (!o.hasAttribute("linkHref")) return !1;
                var r = i.textNode || i.nodeBefore;
                if (o === r) return !0;
                return Fg(n, "linkHref", o.getAttribute("linkHref"), t).containsRange(t.createRange(n, i), !0);
              }(t.model) && (n = e.getAttributes()));
            }, {
              priority: "high"
            }), this.listenTo(t.model, "insertContent", function (e, _ref68) {
              var _ref69 = _slicedToArray(_ref68, 1),
                  o = _ref69[0];

              i = !1, Lb(t) && n && (t.model.change(function (t) {
                var _iterator381 = _createForOfIteratorHelper(n),
                    _step381;

                try {
                  for (_iterator381.s(); !(_step381 = _iterator381.n()).done;) {
                    var _step381$value = _slicedToArray(_step381.value, 2),
                        _e274 = _step381$value[0],
                        _i196 = _step381$value[1];

                    t.setAttribute(_e274, _i196, o);
                  }
                } catch (err) {
                  _iterator381.e(err);
                } finally {
                  _iterator381.f();
                }
              }), n = null);
            }, {
              priority: "high"
            });
          }
        }, {
          key: "_handleDeleteContentAfterLink",
          value: function _handleDeleteContentAfterLink() {
            var t = this.editor,
                e = t.model,
                n = e.document.selection,
                i = t.editing.view;
            var o = !1,
                r = !1;
            this.listenTo(i.document, "delete", function (t, e) {
              r = e.domEvent.keyCode === dr.backspace;
            }, {
              priority: "high"
            }), this.listenTo(e, "deleteContent", function () {
              o = !1;
              var t = n.getFirstPosition(),
                  i = n.getAttribute("linkHref");
              if (!i) return;
              var r = Fg(t, "linkHref", i, e);
              o = r.containsPosition(t) || r.end.isEqual(t);
            }, {
              priority: "high"
            }), this.listenTo(e, "deleteContent", function () {
              r && (r = !1, o || t.model.enqueueChange(function (t) {
                Pb(t, Rb(e.schema));
              }));
            }, {
              priority: "low"
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "LinkEditing";
          }
        }, {
          key: "requires",
          get: function get() {
            return [yg, kg, kp];
          }
        }]);

        return zb;
      }(ue);

      function Pb(t, e) {
        t.removeSelectionAttribute("linkHref");

        var _iterator382 = _createForOfIteratorHelper(e),
            _step382;

        try {
          for (_iterator382.s(); !(_step382 = _iterator382.n()).done;) {
            var _n247 = _step382.value;
            t.removeSelectionAttribute(_n247);
          }
        } catch (err) {
          _iterator382.e(err);
        } finally {
          _iterator382.f();
        }
      }

      function Lb(t) {
        return t.model.change(function (t) {
          return t.batch;
        }).isTyping;
      }

      function Rb(t) {
        return t.getDefinition("$text").allowAttributes.filter(function (t) {
          return t.startsWith("link");
        });
      }

      var Ob = n(3953),
          jb = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Ob.Z, jb), Ob.Z.locals;

      var Fb = /*#__PURE__*/function (_Dd27) {
        _inherits(Fb, _Dd27);

        var _super175 = _createSuper(Fb);

        function Fb(t, e) {
          var _this263;

          _classCallCheck(this, Fb);

          _this263 = _super175.call(this, t);
          var n = t.t;
          _this263.focusTracker = new Aa(), _this263.keystrokes = new Ca(), _this263.urlInputView = _this263._createUrlInput(), _this263.saveButtonView = _this263._createButton(n("Save"), Ad.check, "ck-button-save"), _this263.saveButtonView.type = "submit", _this263.cancelButtonView = _this263._createButton(n("Cancel"), Ad.cancel, "ck-button-cancel", "cancel"), _this263._manualDecoratorSwitches = _this263._createManualDecoratorSwitches(e), _this263.children = _this263._createFormChildren(e.manualDecorators), _this263._focusables = new yd(), _this263._focusCycler = new vh({
            focusables: _this263._focusables,
            focusTracker: _this263.focusTracker,
            keystrokeHandler: _this263.keystrokes,
            actions: {
              focusPrevious: "shift + tab",
              focusNext: "tab"
            }
          });
          var i = ["ck", "ck-link-form", "ck-responsive-form"];
          e.manualDecorators.length && i.push("ck-link-form_layout-vertical", "ck-vertical-form"), _this263.setTemplate({
            tag: "form",
            attributes: {
              class: i,
              tabindex: "-1"
            },
            children: _this263.children
          }), _d(_assertThisInitialized(_this263));
          return _this263;
        }

        _createClass(Fb, [{
          key: "getDecoratorSwitchesState",
          value: function getDecoratorSwitchesState() {
            return Array.from(this._manualDecoratorSwitches).reduce(function (t, e) {
              return t[e.name] = e.isOn, t;
            }, {});
          }
        }, {
          key: "render",
          value: function render() {
            var _this264 = this;

            _get(_getPrototypeOf(Fb.prototype), "render", this).call(this), vd({
              view: this
            });
            [this.urlInputView].concat(_toConsumableArray(this._manualDecoratorSwitches), [this.saveButtonView, this.cancelButtonView]).forEach(function (t) {
              _this264._focusables.add(t), _this264.focusTracker.add(t.element);
            }), this.keystrokes.listenTo(this.element);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            _get(_getPrototypeOf(Fb.prototype), "destroy", this).call(this), this.focusTracker.destroy(), this.keystrokes.destroy();
          }
        }, {
          key: "focus",
          value: function focus() {
            this._focusCycler.focusFirst();
          }
        }, {
          key: "_createUrlInput",
          value: function _createUrlInput() {
            var t = this.locale.t,
                e = new lu(this.locale, du);
            return e.label = t("Link URL"), e;
          }
        }, {
          key: "_createButton",
          value: function _createButton(t, e, n, i) {
            var o = new oh(this.locale);
            return o.set({
              label: t,
              icon: e,
              tooltip: !0
            }), o.extendTemplate({
              attributes: {
                class: n
              }
            }), i && o.delegate("execute").to(this, i), o;
          }
        }, {
          key: "_createManualDecoratorSwitches",
          value: function _createManualDecoratorSwitches(t) {
            var _this265 = this;

            var e = this.createCollection();

            var _iterator383 = _createForOfIteratorHelper(t.manualDecorators),
                _step383;

            try {
              var _loop8 = function _loop8() {
                var n = _step383.value;
                var i = new ah(_this265.locale);
                i.set({
                  name: n.id,
                  label: n.label,
                  withText: !0
                }), i.bind("isOn").toMany([n, t], "value", function (t, e) {
                  return void 0 === e && void 0 === t ? n.defaultValue : t;
                }), i.on("execute", function () {
                  n.set("value", !i.isOn);
                }), e.add(i);
              };

              for (_iterator383.s(); !(_step383 = _iterator383.n()).done;) {
                _loop8();
              }
            } catch (err) {
              _iterator383.e(err);
            } finally {
              _iterator383.f();
            }

            return e;
          }
        }, {
          key: "_createFormChildren",
          value: function _createFormChildren(t) {
            var e = this.createCollection();

            if (e.add(this.urlInputView), t.length) {
              var _t295 = new Dd();

              _t295.setTemplate({
                tag: "ul",
                children: this._manualDecoratorSwitches.map(function (t) {
                  return {
                    tag: "li",
                    children: [t],
                    attributes: {
                      class: ["ck", "ck-list__item"]
                    }
                  };
                }),
                attributes: {
                  class: ["ck", "ck-reset", "ck-list"]
                }
              }), e.add(_t295);
            }

            return e.add(this.saveButtonView), e.add(this.cancelButtonView), e;
          }
        }]);

        return Fb;
      }(Dd);

      var Vb = n(6022),
          Ub = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Vb.Z, Ub), Vb.Z.locals;

      var Hb = /*#__PURE__*/function (_Dd28) {
        _inherits(Hb, _Dd28);

        var _super176 = _createSuper(Hb);

        function Hb(t) {
          var _this266;

          _classCallCheck(this, Hb);

          _this266 = _super176.call(this, t);
          var e = t.t;
          _this266.focusTracker = new Aa(), _this266.keystrokes = new Ca(), _this266.previewButtonView = _this266._createPreviewButton(), _this266.unlinkButtonView = _this266._createButton(e("Unlink"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>', "unlink"), _this266.editButtonView = _this266._createButton(e("Edit link"), Ad.pencil, "edit"), _this266.set("href"), _this266._focusables = new yd(), _this266._focusCycler = new vh({
            focusables: _this266._focusables,
            focusTracker: _this266.focusTracker,
            keystrokeHandler: _this266.keystrokes,
            actions: {
              focusPrevious: "shift + tab",
              focusNext: "tab"
            }
          }), _this266.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-link-actions", "ck-responsive-form"],
              tabindex: "-1"
            },
            children: [_this266.previewButtonView, _this266.editButtonView, _this266.unlinkButtonView]
          });
          return _this266;
        }

        _createClass(Hb, [{
          key: "render",
          value: function render() {
            var _this267 = this;

            _get(_getPrototypeOf(Hb.prototype), "render", this).call(this);

            [this.previewButtonView, this.editButtonView, this.unlinkButtonView].forEach(function (t) {
              _this267._focusables.add(t), _this267.focusTracker.add(t.element);
            }), this.keystrokes.listenTo(this.element);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            _get(_getPrototypeOf(Hb.prototype), "destroy", this).call(this), this.focusTracker.destroy(), this.keystrokes.destroy();
          }
        }, {
          key: "focus",
          value: function focus() {
            this._focusCycler.focusFirst();
          }
        }, {
          key: "_createButton",
          value: function _createButton(t, e, n) {
            var i = new oh(this.locale);
            return i.set({
              label: t,
              icon: e,
              tooltip: !0
            }), i.delegate("execute").to(this, n), i;
          }
        }, {
          key: "_createPreviewButton",
          value: function _createPreviewButton() {
            var t = new oh(this.locale),
                e = this.bindTemplate,
                n = this.t;
            return t.set({
              withText: !0,
              tooltip: n("Open link in new tab")
            }), t.extendTemplate({
              attributes: {
                class: ["ck", "ck-link-actions__preview"],
                href: e.to("href", function (t) {
                  return t && km(t);
                }),
                target: "_blank",
                rel: "noopener noreferrer"
              }
            }), t.bind("label").to(this, "href", function (t) {
              return t || n("This link has no URL");
            }), t.bind("isEnabled").to(this, "href", function (t) {
              return !!t;
            }), t.template.tag = "a", t.template.eventListeners = {}, t;
          }
        }]);

        return Hb;
      }(Dd);

      var qb = "link-ui";

      var Wb = /*#__PURE__*/function (_ue66) {
        _inherits(Wb, _ue66);

        var _super177 = _createSuper(Wb);

        function Wb() {
          _classCallCheck(this, Wb);

          return _super177.apply(this, arguments);
        }

        _createClass(Wb, [{
          key: "init",
          value: function init() {
            var t = this.editor;
            t.editing.view.addObserver(Xu), this.actionsView = this._createActionsView(), this.formView = this._createFormView(), this._balloon = t.plugins.get(xu), this._createToolbarLinkButton(), this._enableUserBalloonInteractions(), t.conversion.for("editingDowncast").markerToHighlight({
              model: qb,
              view: {
                classes: ["ck-fake-link-selection"]
              }
            }), t.conversion.for("editingDowncast").markerToElement({
              model: qb,
              view: {
                name: "span",
                classes: ["ck-fake-link-selection", "ck-fake-link-selection_collapsed"]
              }
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            _get(_getPrototypeOf(Wb.prototype), "destroy", this).call(this), this.formView.destroy();
          }
        }, {
          key: "_createActionsView",
          value: function _createActionsView() {
            var _this268 = this;

            var t = this.editor,
                e = new Hb(t.locale),
                n = t.commands.get("link"),
                i = t.commands.get("unlink");
            return e.bind("href").to(n, "value"), e.editButtonView.bind("isEnabled").to(n), e.unlinkButtonView.bind("isEnabled").to(i), this.listenTo(e, "edit", function () {
              _this268._addFormView();
            }), this.listenTo(e, "unlink", function () {
              t.execute("unlink"), _this268._hideUI();
            }), e.keystrokes.set("Esc", function (t, e) {
              _this268._hideUI(), e();
            }), e.keystrokes.set(pm, function (t, e) {
              _this268._addFormView(), e();
            }), e;
          }
        }, {
          key: "_createFormView",
          value: function _createFormView() {
            var _this269 = this;

            var t = this.editor,
                e = t.commands.get("link"),
                n = t.config.get("link.defaultProtocol"),
                i = new Fb(t.locale, e);
            return i.urlInputView.fieldView.bind("value").to(e, "value"), i.urlInputView.bind("isReadOnly").to(e, "isEnabled", function (t) {
              return !t;
            }), i.saveButtonView.bind("isEnabled").to(e), this.listenTo(i, "submit", function () {
              var e = i.urlInputView.fieldView.element.value,
                  o = wm(e, n);
              t.execute("link", o, i.getDecoratorSwitchesState()), _this269._closeFormView();
            }), this.listenTo(i, "cancel", function () {
              _this269._closeFormView();
            }), i.keystrokes.set("Esc", function (t, e) {
              _this269._closeFormView(), e();
            }), i;
          }
        }, {
          key: "_createToolbarLinkButton",
          value: function _createToolbarLinkButton() {
            var _this270 = this;

            var t = this.editor,
                e = t.commands.get("link"),
                n = t.t;
            t.keystrokes.set(pm, function (t, n) {
              n(), e.isEnabled && _this270._showUI(!0);
            }), t.ui.componentFactory.add("link", function (t) {
              var i = new oh(t);
              return i.isEnabled = !0, i.label = n("Link"), i.icon = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>', i.keystroke = pm, i.tooltip = !0, i.isToggleable = !0, i.bind("isEnabled").to(e, "isEnabled"), i.bind("isOn").to(e, "value", function (t) {
                return !!t;
              }), _this270.listenTo(i, "execute", function () {
                return _this270._showUI(!0);
              }), i;
            });
          }
        }, {
          key: "_enableUserBalloonInteractions",
          value: function _enableUserBalloonInteractions() {
            var _this271 = this;

            var t = this.editor.editing.view.document;
            this.listenTo(t, "click", function () {
              _this271._getSelectedLinkElement() && _this271._showUI();
            }), this.editor.keystrokes.set("Tab", function (t, e) {
              _this271._areActionsVisible && !_this271.actionsView.focusTracker.isFocused && (_this271.actionsView.focus(), e());
            }, {
              priority: "high"
            }), this.editor.keystrokes.set("Esc", function (t, e) {
              _this271._isUIVisible && (_this271._hideUI(), e());
            }), Cd({
              emitter: this.formView,
              activator: function activator() {
                return _this271._isUIInPanel;
              },
              contextElements: [this._balloon.view.element],
              callback: function callback() {
                return _this271._hideUI();
              }
            });
          }
        }, {
          key: "_addActionsView",
          value: function _addActionsView() {
            this._areActionsInPanel || this._balloon.add({
              view: this.actionsView,
              position: this._getBalloonPositionData()
            });
          }
        }, {
          key: "_addFormView",
          value: function _addFormView() {
            if (this._isFormInPanel) return;
            var t = this.editor.commands.get("link");
            this.formView.disableCssTransitions(), this._balloon.add({
              view: this.formView,
              position: this._getBalloonPositionData()
            }), this._balloon.visibleView === this.formView && this.formView.urlInputView.fieldView.select(), this.formView.enableCssTransitions(), this.formView.urlInputView.fieldView.element.value = t.value || "";
          }
        }, {
          key: "_closeFormView",
          value: function _closeFormView() {
            var t = this.editor.commands.get("link");
            t.restoreManualDecoratorStates(), void 0 !== t.value ? this._removeFormView() : this._hideUI();
          }
        }, {
          key: "_removeFormView",
          value: function _removeFormView() {
            this._isFormInPanel && (this.formView.saveButtonView.focus(), this._balloon.remove(this.formView), this.editor.editing.view.focus(), this._hideFakeVisualSelection());
          }
        }, {
          key: "_showUI",
          value: function _showUI() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
            this._getSelectedLinkElement() ? (this._areActionsVisible ? this._addFormView() : this._addActionsView(), t && this._balloon.showStack("main")) : (this._showFakeVisualSelection(), this._addActionsView(), t && this._balloon.showStack("main"), this._addFormView()), this._startUpdatingUI();
          }
        }, {
          key: "_hideUI",
          value: function _hideUI() {
            if (!this._isUIInPanel) return;
            var t = this.editor;
            this.stopListening(t.ui, "update"), this.stopListening(this._balloon, "change:visibleView"), t.editing.view.focus(), this._removeFormView(), this._balloon.remove(this.actionsView), this._hideFakeVisualSelection();
          }
        }, {
          key: "_startUpdatingUI",
          value: function _startUpdatingUI() {
            var _this272 = this;

            var t = this.editor,
                e = t.editing.view.document;

            var n = this._getSelectedLinkElement(),
                i = r();

            var o = function o() {
              var t = _this272._getSelectedLinkElement(),
                  e = r();

              n && !t || !n && e !== i ? _this272._hideUI() : _this272._isUIVisible && _this272._balloon.updatePosition(_this272._getBalloonPositionData()), n = t, i = e;
            };

            function r() {
              return e.selection.focus.getAncestors().reverse().find(function (t) {
                return t.is("element");
              });
            }

            this.listenTo(t.ui, "update", o), this.listenTo(this._balloon, "change:visibleView", o);
          }
        }, {
          key: "_isFormInPanel",
          get: function get() {
            return this._balloon.hasView(this.formView);
          }
        }, {
          key: "_areActionsInPanel",
          get: function get() {
            return this._balloon.hasView(this.actionsView);
          }
        }, {
          key: "_areActionsVisible",
          get: function get() {
            return this._balloon.visibleView === this.actionsView;
          }
        }, {
          key: "_isUIInPanel",
          get: function get() {
            return this._isFormInPanel || this._areActionsInPanel;
          }
        }, {
          key: "_isUIVisible",
          get: function get() {
            return this._balloon.visibleView == this.formView || this._areActionsVisible;
          }
        }, {
          key: "_getBalloonPositionData",
          value: function _getBalloonPositionData() {
            var _this273 = this;

            var t = this.editor.editing.view,
                e = this.editor.model,
                n = t.document;
            var i = null;

            if (e.markers.has(qb)) {
              var _e275 = Array.from(this.editor.editing.mapper.markerNameToElements(qb)),
                  _n248 = t.createRange(t.createPositionBefore(_e275[0]), t.createPositionAfter(_e275[_e275.length - 1]));

              i = t.domConverter.viewRangeToDom(_n248);
            } else i = function i() {
              var e = _this273._getSelectedLinkElement();

              return e ? t.domConverter.mapViewToDom(e) : t.domConverter.viewRangeToDom(n.selection.getFirstRange());
            };

            return {
              target: i
            };
          }
        }, {
          key: "_getSelectedLinkElement",
          value: function _getSelectedLinkElement() {
            var t = this.editor.editing.view,
                e = t.document.selection,
                n = e.getSelectedElement();
            if (e.isCollapsed || n && yp(n)) return Gb(e.getFirstPosition());
            {
              var _n249 = e.getFirstRange().getTrimmed(),
                  _i197 = Gb(_n249.start),
                  _o103 = Gb(_n249.end);

              return _i197 && _i197 == _o103 && t.createRangeIn(_i197).getTrimmed().isEqual(_n249) ? _i197 : null;
            }
          }
        }, {
          key: "_showFakeVisualSelection",
          value: function _showFakeVisualSelection() {
            var t = this.editor.model;
            t.change(function (e) {
              var n = t.document.selection.getFirstRange();
              if (t.markers.has(qb)) e.updateMarker(qb, {
                range: n
              });else if (n.start.isAtEnd) {
                var _i198 = n.start.getLastMatchingPosition(function (_ref70) {
                  var e = _ref70.item;
                  return !t.schema.isContent(e);
                }, {
                  boundaries: n
                });

                e.addMarker(qb, {
                  usingOperation: !1,
                  affectsData: !1,
                  range: e.createRange(_i198, n.end)
                });
              } else e.addMarker(qb, {
                usingOperation: !1,
                affectsData: !1,
                range: n
              });
            });
          }
        }, {
          key: "_hideFakeVisualSelection",
          value: function _hideFakeVisualSelection() {
            var t = this.editor.model;
            t.markers.has(qb) && t.change(function (t) {
              t.removeMarker(qb);
            });
          }
        }], [{
          key: "requires",
          get: function get() {
            return [xu];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "LinkUI";
          }
        }]);

        return Wb;
      }(ue);

      function Gb(t) {
        return t.getAncestors().find(function (t) {
          return (e = t).is("attributeElement") && !!e.getCustomProperty("link");
          var e;
        });
      }

      var $b = /*#__PURE__*/function (_ue67) {
        _inherits($b, _ue67);

        var _super178 = _createSuper($b);

        function $b() {
          _classCallCheck(this, $b);

          return _super178.apply(this, arguments);
        }

        _createClass($b, null, [{
          key: "requires",
          get: function get() {
            return [zb, Wb, _m];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "Link";
          }
        }]);

        return $b;
      }(ue);

      var Yb = /*#__PURE__*/function (_me21) {
        _inherits(Yb, _me21);

        var _super179 = _createSuper(Yb);

        function Yb(t, e) {
          var _this274;

          _classCallCheck(this, Yb);

          _this274 = _super179.call(this, t), _this274.type = e;
          return _this274;
        }

        _createClass(Yb, [{
          key: "refresh",
          value: function refresh() {
            this.value = this._getValue(), this.isEnabled = this._checkEnabled();
          }
        }, {
          key: "execute",
          value: function execute() {
            var _this275 = this;

            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var e = this.editor.model,
                n = e.document,
                i = Array.from(n.selection.getSelectedBlocks()).filter(function (t) {
              return Qb(t, e.schema);
            }),
                o = void 0 !== t.forceValue ? !t.forceValue : this.value;
            e.change(function (t) {
              if (o) {
                var _e276 = i[i.length - 1].nextSibling,
                    _n250 = Number.POSITIVE_INFINITY,
                    _o104 = [];

                for (; _e276 && "listItem" == _e276.name && 0 !== _e276.getAttribute("listIndent");) {
                  var _t296 = _e276.getAttribute("listIndent");

                  _t296 < _n250 && (_n250 = _t296);

                  var _i199 = _t296 - _n250;

                  _o104.push({
                    element: _e276,
                    listIndent: _i199
                  }), _e276 = _e276.nextSibling;
                }

                _o104 = _o104.reverse();

                var _iterator384 = _createForOfIteratorHelper(_o104),
                    _step384;

                try {
                  for (_iterator384.s(); !(_step384 = _iterator384.n()).done;) {
                    var _e277 = _step384.value;
                    t.setAttribute("listIndent", _e277.listIndent, _e277.element);
                  }
                } catch (err) {
                  _iterator384.e(err);
                } finally {
                  _iterator384.f();
                }
              }

              if (!o) {
                var _t297 = Number.POSITIVE_INFINITY;

                var _iterator385 = _createForOfIteratorHelper(i),
                    _step385;

                try {
                  for (_iterator385.s(); !(_step385 = _iterator385.n()).done;) {
                    var _e278 = _step385.value;
                    _e278.is("element", "listItem") && _e278.getAttribute("listIndent") < _t297 && (_t297 = _e278.getAttribute("listIndent"));
                  }
                } catch (err) {
                  _iterator385.e(err);
                } finally {
                  _iterator385.f();
                }

                _t297 = 0 === _t297 ? 1 : _t297, Kb(i, !0, _t297), Kb(i, !1, _t297);
              }

              var _iterator386 = _createForOfIteratorHelper(i.reverse()),
                  _step386;

              try {
                for (_iterator386.s(); !(_step386 = _iterator386.n()).done;) {
                  var _e279 = _step386.value;
                  o && "listItem" == _e279.name ? t.rename(_e279, "paragraph") : o || "listItem" == _e279.name ? o || "listItem" != _e279.name || _e279.getAttribute("listType") == _this275.type || t.setAttribute("listType", _this275.type, _e279) : (t.setAttributes({
                    listType: _this275.type,
                    listIndent: 0
                  }, _e279), t.rename(_e279, "listItem"));
                }
              } catch (err) {
                _iterator386.e(err);
              } finally {
                _iterator386.f();
              }

              _this275.fire("_executeCleanup", i);
            });
          }
        }, {
          key: "_getValue",
          value: function _getValue() {
            var t = wa(this.editor.model.document.selection.getSelectedBlocks());
            return !!t && t.is("element", "listItem") && t.getAttribute("listType") == this.type;
          }
        }, {
          key: "_checkEnabled",
          value: function _checkEnabled() {
            if (this.value) return !0;
            var t = this.editor.model.document.selection,
                e = this.editor.model.schema,
                n = wa(t.getSelectedBlocks());
            return !!n && Qb(n, e);
          }
        }]);

        return Yb;
      }(me);

      function Kb(t, e, n) {
        var i = e ? t[0] : t[t.length - 1];

        if (i.is("element", "listItem")) {
          var _o105 = i[e ? "previousSibling" : "nextSibling"],
              _r60 = i.getAttribute("listIndent");

          for (; _o105 && _o105.is("element", "listItem") && _o105.getAttribute("listIndent") >= n;) {
            _r60 > _o105.getAttribute("listIndent") && (_r60 = _o105.getAttribute("listIndent")), _o105.getAttribute("listIndent") == _r60 && t[e ? "unshift" : "push"](_o105), _o105 = _o105[e ? "previousSibling" : "nextSibling"];
          }
        }
      }

      function Qb(t, e) {
        return e.checkChild(t.parent, "listItem") && !e.isObject(t);
      }

      var Zb = /*#__PURE__*/function (_me22) {
        _inherits(Zb, _me22);

        var _super180 = _createSuper(Zb);

        function Zb(t, e) {
          var _this276;

          _classCallCheck(this, Zb);

          _this276 = _super180.call(this, t), _this276._indentBy = "forward" == e ? 1 : -1;
          return _this276;
        }

        _createClass(Zb, [{
          key: "refresh",
          value: function refresh() {
            this.isEnabled = this._checkEnabled();
          }
        }, {
          key: "execute",
          value: function execute() {
            var _this277 = this;

            var t = this.editor.model,
                e = t.document;
            var n = Array.from(e.selection.getSelectedBlocks());
            t.change(function (t) {
              var e = n[n.length - 1];
              var i = e.nextSibling;

              for (; i && "listItem" == i.name && i.getAttribute("listIndent") > e.getAttribute("listIndent");) {
                n.push(i), i = i.nextSibling;
              }

              _this277._indentBy < 0 && (n = n.reverse());

              var _iterator387 = _createForOfIteratorHelper(n),
                  _step387;

              try {
                for (_iterator387.s(); !(_step387 = _iterator387.n()).done;) {
                  var _e280 = _step387.value;

                  var _n251 = _e280.getAttribute("listIndent") + _this277._indentBy;

                  _n251 < 0 ? t.rename(_e280, "paragraph") : t.setAttribute("listIndent", _n251, _e280);
                }
              } catch (err) {
                _iterator387.e(err);
              } finally {
                _iterator387.f();
              }

              _this277.fire("_executeCleanup", n);
            });
          }
        }, {
          key: "_checkEnabled",
          value: function _checkEnabled() {
            var t = wa(this.editor.model.document.selection.getSelectedBlocks());
            if (!t || !t.is("element", "listItem")) return !1;

            if (this._indentBy > 0) {
              var _e281 = t.getAttribute("listIndent"),
                  _n252 = t.getAttribute("listType");

              var _i200 = t.previousSibling;

              for (; _i200 && _i200.is("element", "listItem") && _i200.getAttribute("listIndent") >= _e281;) {
                if (_i200.getAttribute("listIndent") == _e281) return _i200.getAttribute("listType") == _n252;
                _i200 = _i200.previousSibling;
              }

              return !1;
            }

            return !0;
          }
        }]);

        return Zb;
      }(me);

      function Jb(t, e) {
        var n = e.mapper,
            i = e.writer,
            o = "numbered" == t.getAttribute("listType") ? "ol" : "ul",
            r = function (t) {
          var e = t.createContainerElement("li");
          return e.getFillerOffset = ow, e;
        }(i),
            s = i.createContainerElement(o, null);

        return i.insert(i.createPositionAt(s, 0), r), n.bindElements(t, r), r;
      }

      function Xb(t, e, n, i) {
        var o = e.parent,
            r = n.mapper,
            s = n.writer;
        var a = r.toViewPosition(i.createPositionBefore(t));
        var c = nw(t.previousSibling, {
          sameIndent: !0,
          smallerIndent: !0,
          listIndent: t.getAttribute("listIndent")
        }),
            l = t.previousSibling;

        if (c && c.getAttribute("listIndent") == t.getAttribute("listIndent")) {
          var _t298 = r.toViewElement(c);

          a = s.breakContainer(s.createPositionAfter(_t298));
        } else if (l && "listItem" == l.name) {
          a = r.toViewPosition(i.createPositionAt(l, "end"));

          var _t299 = r.findMappedViewAncestor(a),
              _e282 = function (t) {
            var _iterator388 = _createForOfIteratorHelper(t.getChildren()),
                _step388;

            try {
              for (_iterator388.s(); !(_step388 = _iterator388.n()).done;) {
                var _e283 = _step388.value;
                if ("ul" == _e283.name || "ol" == _e283.name) return _e283;
              }
            } catch (err) {
              _iterator388.e(err);
            } finally {
              _iterator388.f();
            }

            return null;
          }(_t299);

          a = _e282 ? s.createPositionBefore(_e282) : s.createPositionAt(_t299, "end");
        } else a = r.toViewPosition(i.createPositionBefore(t));

        if (a = ew(a), s.insert(a, o), l && "listItem" == l.name) {
          var _t300 = r.toViewElement(l),
              _n253 = s.createRange(s.createPositionAt(_t300, 0), a).getWalker({
            ignoreElementEnd: !0
          });

          var _iterator389 = _createForOfIteratorHelper(_n253),
              _step389;

          try {
            for (_iterator389.s(); !(_step389 = _iterator389.n()).done;) {
              var _t301 = _step389.value;

              if (_t301.item.is("element", "li")) {
                var _i201 = s.breakContainer(s.createPositionBefore(_t301.item)),
                    _o106 = _t301.item.parent,
                    _r61 = s.createPositionAt(e, "end");

                tw(s, _r61.nodeBefore, _r61.nodeAfter), s.move(s.createRangeOn(_o106), _r61), _n253.position = _i201;
              }
            }
          } catch (err) {
            _iterator389.e(err);
          } finally {
            _iterator389.f();
          }
        } else {
          var _n254 = o.nextSibling;

          if (_n254 && (_n254.is("element", "ul") || _n254.is("element", "ol"))) {
            var _i202 = null;

            var _iterator390 = _createForOfIteratorHelper(_n254.getChildren()),
                _step390;

            try {
              for (_iterator390.s(); !(_step390 = _iterator390.n()).done;) {
                var _e284 = _step390.value;

                var _n255 = r.toModelElement(_e284);

                if (!(_n255 && _n255.getAttribute("listIndent") > t.getAttribute("listIndent"))) break;
                _i202 = _e284;
              }
            } catch (err) {
              _iterator390.e(err);
            } finally {
              _iterator390.f();
            }

            _i202 && (s.breakContainer(s.createPositionAfter(_i202)), s.move(s.createRangeOn(_i202.parent), s.createPositionAt(e, "end")));
          }
        }

        tw(s, o, o.nextSibling), tw(s, o.previousSibling, o);
      }

      function tw(t, e, n) {
        return !e || !n || "ul" != e.name && "ol" != e.name || e.name != n.name || e.getAttribute("class") !== n.getAttribute("class") ? null : t.mergeContainers(t.createPositionAfter(e));
      }

      function ew(t) {
        return t.getLastMatchingPosition(function (t) {
          return t.item.is("uiElement");
        });
      }

      function nw(t, e) {
        var n = !!e.sameIndent,
            i = !!e.smallerIndent,
            o = e.listIndent;
        var r = t;

        for (; r && "listItem" == r.name;) {
          var _t302 = r.getAttribute("listIndent");

          if (n && o == _t302 || i && o > _t302) return r;
          r = "forward" === e.direction ? r.nextSibling : r.previousSibling;
        }

        return null;
      }

      function iw(t, e, n, i) {
        t.ui.componentFactory.add(e, function (o) {
          var r = t.commands.get(e),
              s = new oh(o);
          return s.set({
            label: n,
            icon: i,
            tooltip: !0,
            isToggleable: !0
          }), s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), s.on("execute", function () {
            t.execute(e), t.editing.view.focus();
          }), s;
        });
      }

      function ow() {
        var t = !this.isEmpty && ("ul" == this.getChild(0).name || "ol" == this.getChild(0).name);
        return this.isEmpty || t ? 0 : Bo.call(this);
      }

      function rw(t) {
        return function (e, n, i) {
          var o = i.consumable;
          if (!o.test(n.item, "insert") || !o.test(n.item, "attribute:listType") || !o.test(n.item, "attribute:listIndent")) return;
          o.consume(n.item, "insert"), o.consume(n.item, "attribute:listType"), o.consume(n.item, "attribute:listIndent");
          var r = n.item;
          Xb(r, Jb(r, i), i, t);
        };
      }

      function sw(t, e, n) {
        if (!n.consumable.consume(e.item, "attribute:listType")) return;
        var i = n.mapper.toViewElement(e.item),
            o = n.writer;
        o.breakContainer(o.createPositionBefore(i)), o.breakContainer(o.createPositionAfter(i));
        var r = i.parent,
            s = "numbered" == e.attributeNewValue ? "ol" : "ul";
        o.rename(s, r);
      }

      function aw(t, e, n) {
        var i = n.mapper.toViewElement(e.item).parent,
            o = n.writer;
        tw(o, i, i.nextSibling), tw(o, i.previousSibling, i);

        var _iterator391 = _createForOfIteratorHelper(e.item.getChildren()),
            _step391;

        try {
          for (_iterator391.s(); !(_step391 = _iterator391.n()).done;) {
            var _t303 = _step391.value;
            n.consumable.consume(_t303, "insert");
          }
        } catch (err) {
          _iterator391.e(err);
        } finally {
          _iterator391.f();
        }
      }

      function cw(t, e, n) {
        if ("listItem" != e.item.name) {
          var _t304 = n.mapper.toViewPosition(e.range.start);

          var _i203 = n.writer,
              _o107 = [];

          for (; ("ul" == _t304.parent.name || "ol" == _t304.parent.name) && (_t304 = _i203.breakContainer(_t304), "li" == _t304.parent.name);) {
            var _e285 = _t304,
                _n256 = _i203.createPositionAt(_t304.parent, "end");

            if (!_e285.isEqual(_n256)) {
              var _t305 = _i203.remove(_i203.createRange(_e285, _n256));

              _o107.push(_t305);
            }

            _t304 = _i203.createPositionAfter(_t304.parent);
          }

          if (_o107.length > 0) {
            for (var _e286 = 0; _e286 < _o107.length; _e286++) {
              var _n257 = _t304.nodeBefore;

              if (_t304 = _i203.insert(_t304, _o107[_e286]).end, _e286 > 0) {
                var _e287 = tw(_i203, _n257, _n257.nextSibling);

                _e287 && _e287.parent == _n257 && _t304.offset--;
              }
            }

            tw(_i203, _t304.nodeBefore, _t304.nodeAfter);
          }
        }
      }

      function lw(t, e, n) {
        var i = n.mapper.toViewPosition(e.position),
            o = i.nodeBefore,
            r = i.nodeAfter;
        tw(n.writer, o, r);
      }

      function dw(t, e, n) {
        if (n.consumable.consume(e.viewItem, {
          name: !0
        })) {
          var _t306 = n.writer,
              _i204 = _t306.createElement("listItem"),
              _o108 = function (t) {
            var e = 0,
                n = t.parent;

            for (; n;) {
              if (n.is("element", "li")) e++;else {
                var _t307 = n.previousSibling;
                _t307 && _t307.is("element", "li") && e++;
              }
              n = n.parent;
            }

            return e;
          }(e.viewItem);

          _t306.setAttribute("listIndent", _o108, _i204);

          var _r62 = e.viewItem.parent && "ol" == e.viewItem.parent.name ? "numbered" : "bulleted";

          if (_t306.setAttribute("listType", _r62, _i204), !n.safeInsert(_i204, e.modelCursor)) return;

          var _s36 = function (t, e, n) {
            var i = n.writer,
                o = n.schema;
            var r = i.createPositionAfter(t);

            var _iterator392 = _createForOfIteratorHelper(e),
                _step392;

            try {
              for (_iterator392.s(); !(_step392 = _iterator392.n()).done;) {
                var _s37 = _step392.value;
                if ("ul" == _s37.name || "ol" == _s37.name) r = n.convertItem(_s37, r).modelCursor;else {
                  var _e288 = n.convertItem(_s37, i.createPositionAt(t, "end")),
                      _a22 = _e288.modelRange.start.nodeAfter;

                  _a22 && _a22.is("element") && !o.checkChild(t, _a22.name) && (t = _e288.modelCursor.parent.is("element", "listItem") ? _e288.modelCursor.parent : pw(_e288.modelCursor), r = i.createPositionAfter(t));
                }
              }
            } catch (err) {
              _iterator392.e(err);
            } finally {
              _iterator392.f();
            }

            return r;
          }(_i204, e.viewItem.getChildren(), n);

          e.modelRange = _t306.createRange(e.modelCursor, _s36), n.updateConversionResult(_i204, e);
        }
      }

      function hw(t, e, n) {
        if (n.consumable.test(e.viewItem, {
          name: !0
        })) {
          var _t308 = Array.from(e.viewItem.getChildren());

          for (var _i205 = 0, _t309 = _t308; _i205 < _t309.length; _i205++) {
            var _e289 = _t309[_i205];
            !(_e289.is("element", "li") || kw(_e289)) && _e289._remove();
          }
        }
      }

      function uw(t, e, n) {
        if (n.consumable.test(e.viewItem, {
          name: !0
        })) {
          if (0 === e.viewItem.childCount) return;

          var _t310 = _toConsumableArray(e.viewItem.getChildren());

          var _n258 = !1;

          var _iterator393 = _createForOfIteratorHelper(_t310),
              _step393;

          try {
            for (_iterator393.s(); !(_step393 = _iterator393.n()).done;) {
              var _e290 = _step393.value;
              _n258 && !kw(_e290) && _e290._remove(), kw(_e290) && (_n258 = !0);
            }
          } catch (err) {
            _iterator393.e(err);
          } finally {
            _iterator393.f();
          }
        }
      }

      function gw(t) {
        return function (e, n) {
          if (n.isPhantom) return;
          var i = n.modelPosition.nodeBefore;

          if (i && i.is("element", "listItem")) {
            var _e291 = n.mapper.toViewElement(i),
                _o109 = _e291.getAncestors().find(kw),
                _r63 = t.createPositionAt(_e291, 0).getWalker();

            var _iterator394 = _createForOfIteratorHelper(_r63),
                _step394;

            try {
              for (_iterator394.s(); !(_step394 = _iterator394.n()).done;) {
                var _t311 = _step394.value;

                if ("elementStart" == _t311.type && _t311.item.is("element", "li")) {
                  n.viewPosition = _t311.previousPosition;
                  break;
                }

                if ("elementEnd" == _t311.type && _t311.item == _o109) {
                  n.viewPosition = _t311.nextPosition;
                  break;
                }
              }
            } catch (err) {
              _iterator394.e(err);
            } finally {
              _iterator394.f();
            }
          }
        };
      }

      function mw(t, _ref71) {
        var _ref72 = _slicedToArray(_ref71, 2),
            e = _ref72[0],
            n = _ref72[1];

        var i,
            o = e.is("documentFragment") ? e.getChild(0) : e;

        if (i = n ? this.createSelection(n) : this.document.selection, o && o.is("element", "listItem")) {
          var _t312 = i.getFirstPosition();

          var _e292 = null;

          if (_t312.parent.is("element", "listItem") ? _e292 = _t312.parent : _t312.nodeBefore && _t312.nodeBefore.is("element", "listItem") && (_e292 = _t312.nodeBefore), _e292) {
            var _t313 = _e292.getAttribute("listIndent");

            if (_t313 > 0) for (; o && o.is("element", "listItem");) {
              o._setAttribute("listIndent", o.getAttribute("listIndent") + _t313), o = o.nextSibling;
            }
          }
        }
      }

      function pw(t) {
        var e = new ja({
          startPosition: t
        });
        var n;

        do {
          n = e.next();
        } while (!n.value.item.is("element", "listItem"));

        return n.value.item;
      }

      function fw(t, e, n, i, o, r) {
        var s = nw(e.nodeBefore, {
          sameIndent: !0,
          smallerIndent: !0,
          listIndent: t,
          foo: "b"
        }),
            a = o.mapper,
            c = o.writer,
            l = s ? s.getAttribute("listIndent") : null;
        var d;
        if (s) {
          if (l == t) {
            var _t314 = a.toViewElement(s).parent;
            d = c.createPositionAfter(_t314);
          } else {
            var _t315 = r.createPositionAt(s, "end");

            d = a.toViewPosition(_t315);
          }
        } else d = n;
        d = ew(d);

        for (var _i206 = 0, _arr = _toConsumableArray(i.getChildren()); _i206 < _arr.length; _i206++) {
          var _t316 = _arr[_i206];
          kw(_t316) && (d = c.move(c.createRangeOn(_t316), d).end, tw(c, _t316, _t316.nextSibling), tw(c, _t316.previousSibling, _t316));
        }
      }

      function kw(t) {
        return t.is("element", "ol") || t.is("element", "ul");
      }

      var bw = /*#__PURE__*/function (_ue68) {
        _inherits(bw, _ue68);

        var _super181 = _createSuper(bw);

        function bw() {
          _classCallCheck(this, bw);

          return _super181.apply(this, arguments);
        }

        _createClass(bw, [{
          key: "init",
          value: function init() {
            var _this278 = this;

            var t = this.editor;
            t.model.schema.register("listItem", {
              inheritAllFrom: "$block",
              allowAttributes: ["listType", "listIndent"]
            });
            var e = t.data,
                n = t.editing;
            var i;
            t.model.document.registerPostFixer(function (e) {
              return function (t, e) {
                var n = t.document.differ.getChanges(),
                    i = new Map();
                var o = !1;

                var _iterator395 = _createForOfIteratorHelper(n),
                    _step395;

                try {
                  for (_iterator395.s(); !(_step395 = _iterator395.n()).done;) {
                    var _i208 = _step395.value;
                    if ("insert" == _i208.type && "listItem" == _i208.name) r(_i208.position);else if ("insert" == _i208.type && "listItem" != _i208.name) {
                      if ("$text" != _i208.name) {
                        var _n259 = _i208.position.nodeAfter;
                        _n259.hasAttribute("listIndent") && (e.removeAttribute("listIndent", _n259), o = !0), _n259.hasAttribute("listType") && (e.removeAttribute("listType", _n259), o = !0), _n259.hasAttribute("listStyle") && (e.removeAttribute("listStyle", _n259), o = !0), _n259.hasAttribute("listReversed") && (e.removeAttribute("listReversed", _n259), o = !0), _n259.hasAttribute("listStart") && (e.removeAttribute("listStart", _n259), o = !0);

                        var _iterator397 = _createForOfIteratorHelper(Array.from(t.createRangeIn(_n259)).filter(function (t) {
                          return t.item.is("element", "listItem");
                        })),
                            _step397;

                        try {
                          for (_iterator397.s(); !(_step397 = _iterator397.n()).done;) {
                            var _e295 = _step397.value;
                            r(_e295.previousPosition);
                          }
                        } catch (err) {
                          _iterator397.e(err);
                        } finally {
                          _iterator397.f();
                        }
                      }

                      r(_i208.position.getShiftedBy(_i208.length));
                    } else "remove" == _i208.type && "listItem" == _i208.name ? r(_i208.position) : ("attribute" == _i208.type && "listIndent" == _i208.attributeKey || "attribute" == _i208.type && "listType" == _i208.attributeKey) && r(_i208.range.start);
                  }
                } catch (err) {
                  _iterator395.e(err);
                } finally {
                  _iterator395.f();
                }

                var _iterator396 = _createForOfIteratorHelper(i.values()),
                    _step396;

                try {
                  for (_iterator396.s(); !(_step396 = _iterator396.n()).done;) {
                    var _t318 = _step396.value;
                    s(_t318), a(_t318);
                  }
                } catch (err) {
                  _iterator396.e(err);
                } finally {
                  _iterator396.f();
                }

                return o;

                function r(t) {
                  var e = t.nodeBefore;

                  if (e && e.is("element", "listItem")) {
                    var _t317 = e;
                    if (i.has(_t317)) return;

                    for (var _e293 = _t317.previousSibling; _e293 && _e293.is("element", "listItem"); _e293 = _t317.previousSibling) {
                      if (_t317 = _e293, i.has(_t317)) return;
                    }

                    i.set(e, _t317);
                  } else {
                    var _e294 = t.nodeAfter;
                    _e294 && _e294.is("element", "listItem") && i.set(_e294, _e294);
                  }
                }

                function s(t) {
                  var n = 0,
                      i = null;

                  for (; t && t.is("element", "listItem");) {
                    var _r64 = t.getAttribute("listIndent");

                    if (_r64 > n) {
                      var _s38 = void 0;

                      null === i ? (i = _r64 - n, _s38 = n) : (i > _r64 && (i = _r64), _s38 = _r64 - i), e.setAttribute("listIndent", _s38, t), o = !0;
                    } else i = null, n = t.getAttribute("listIndent") + 1;

                    t = t.nextSibling;
                  }
                }

                function a(t) {
                  var n = [],
                      i = null;

                  for (; t && t.is("element", "listItem");) {
                    var _r65 = t.getAttribute("listIndent");

                    if (i && i.getAttribute("listIndent") > _r65 && (n = n.slice(0, _r65 + 1)), 0 != _r65) if (n[_r65]) {
                      var _i207 = n[_r65];
                      t.getAttribute("listType") != _i207 && (e.setAttribute("listType", _i207, t), o = !0);
                    } else n[_r65] = t.getAttribute("listType");
                    i = t, t = t.nextSibling;
                  }
                }
              }(t.model, e);
            }), n.mapper.registerViewToModelLength("li", ww), e.mapper.registerViewToModelLength("li", ww), n.mapper.on("modelToViewPosition", gw(n.view)), n.mapper.on("viewToModelPosition", (i = t.model, function (t, e) {
              var n = e.viewPosition,
                  o = n.parent,
                  r = e.mapper;

              if ("ul" == o.name || "ol" == o.name) {
                if (n.isAtEnd) {
                  var _t319 = r.toModelElement(n.nodeBefore),
                      _o110 = r.getModelLength(n.nodeBefore);

                  e.modelPosition = i.createPositionBefore(_t319).getShiftedBy(_o110);
                } else {
                  var _t320 = r.toModelElement(n.nodeAfter);

                  e.modelPosition = i.createPositionBefore(_t320);
                }

                t.stop();
              } else if ("li" == o.name && n.nodeBefore && ("ul" == n.nodeBefore.name || "ol" == n.nodeBefore.name)) {
                var _s39 = r.toModelElement(o);

                var _a23 = 1,
                    _c11 = n.nodeBefore;

                for (; _c11 && kw(_c11);) {
                  _a23 += r.getModelLength(_c11), _c11 = _c11.previousSibling;
                }

                e.modelPosition = i.createPositionBefore(_s39).getShiftedBy(_a23), t.stop();
              }
            })), e.mapper.on("modelToViewPosition", gw(n.view)), t.conversion.for("editingDowncast").add(function (e) {
              e.on("insert", cw, {
                priority: "high"
              }), e.on("insert:listItem", rw(t.model)), e.on("attribute:listType:listItem", sw, {
                priority: "high"
              }), e.on("attribute:listType:listItem", aw, {
                priority: "low"
              }), e.on("attribute:listIndent:listItem", function (t) {
                return function (e, n, i) {
                  if (!i.consumable.consume(n.item, "attribute:listIndent")) return;
                  var o = i.mapper.toViewElement(n.item),
                      r = i.writer;
                  r.breakContainer(r.createPositionBefore(o)), r.breakContainer(r.createPositionAfter(o));
                  var s = o.parent,
                      a = s.previousSibling,
                      c = r.createRangeOn(s);
                  r.remove(c), a && a.nextSibling && tw(r, a, a.nextSibling), fw(n.attributeOldValue + 1, n.range.start, c.start, o, i, t), Xb(n.item, o, i, t);

                  var _iterator398 = _createForOfIteratorHelper(n.item.getChildren()),
                      _step398;

                  try {
                    for (_iterator398.s(); !(_step398 = _iterator398.n()).done;) {
                      var _t321 = _step398.value;
                      i.consumable.consume(_t321, "insert");
                    }
                  } catch (err) {
                    _iterator398.e(err);
                  } finally {
                    _iterator398.f();
                  }
                };
              }(t.model)), e.on("remove:listItem", function (t) {
                return function (e, n, i) {
                  var o = i.mapper.toViewPosition(n.position).getLastMatchingPosition(function (t) {
                    return !t.item.is("element", "li");
                  }).nodeAfter,
                      r = i.writer;
                  r.breakContainer(r.createPositionBefore(o)), r.breakContainer(r.createPositionAfter(o));
                  var s = o.parent,
                      a = s.previousSibling,
                      c = r.createRangeOn(s),
                      l = r.remove(c);
                  a && a.nextSibling && tw(r, a, a.nextSibling), fw(i.mapper.toModelElement(o).getAttribute("listIndent") + 1, n.position, c.start, o, i, t);

                  var _iterator399 = _createForOfIteratorHelper(r.createRangeIn(l).getItems()),
                      _step399;

                  try {
                    for (_iterator399.s(); !(_step399 = _iterator399.n()).done;) {
                      var _t322 = _step399.value;
                      i.mapper.unbindViewElement(_t322);
                    }
                  } catch (err) {
                    _iterator399.e(err);
                  } finally {
                    _iterator399.f();
                  }

                  e.stop();
                };
              }(t.model)), e.on("remove", lw, {
                priority: "low"
              });
            }), t.conversion.for("dataDowncast").add(function (e) {
              e.on("insert", cw, {
                priority: "high"
              }), e.on("insert:listItem", rw(t.model));
            }), t.conversion.for("upcast").add(function (t) {
              t.on("element:ul", hw, {
                priority: "high"
              }), t.on("element:ol", hw, {
                priority: "high"
              }), t.on("element:li", uw, {
                priority: "high"
              }), t.on("element:li", dw);
            }), t.model.on("insertContent", mw, {
              priority: "high"
            }), t.commands.add("numberedList", new Yb(t, "numbered")), t.commands.add("bulletedList", new Yb(t, "bulleted")), t.commands.add("indentList", new Zb(t, "forward")), t.commands.add("outdentList", new Zb(t, "backward"));
            var o = n.view.document;
            this.listenTo(o, "enter", function (t, e) {
              var n = _this278.editor.model.document,
                  i = n.selection.getLastPosition().parent;
              n.selection.isCollapsed && "listItem" == i.name && i.isEmpty && (_this278.editor.execute("outdentList"), e.preventDefault(), t.stop());
            }, {
              context: "li"
            }), this.listenTo(o, "delete", function (t, e) {
              if ("backward" !== e.direction) return;
              var n = _this278.editor.model.document.selection;
              if (!n.isCollapsed) return;
              var i = n.getFirstPosition();
              if (!i.isAtStart) return;
              var o = i.parent;
              if ("listItem" !== o.name) return;
              o.previousSibling && "listItem" === o.previousSibling.name || (_this278.editor.execute("outdentList"), e.preventDefault(), t.stop());
            }, {
              context: "li"
            });

            var r = function r(t) {
              return function (e, n) {
                _this278.editor.commands.get(t).isEnabled && (_this278.editor.execute(t), n());
              };
            };

            t.keystrokes.set("Tab", r("indentList")), t.keystrokes.set("Shift+Tab", r("outdentList"));
          }
        }, {
          key: "afterInit",
          value: function afterInit() {
            var t = this.editor.commands,
                e = t.get("indent"),
                n = t.get("outdent");
            e && e.registerChildCommand(t.get("indentList")), n && n.registerChildCommand(t.get("outdentList"));
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "ListEditing";
          }
        }, {
          key: "requires",
          get: function get() {
            return [Sm, Ag];
          }
        }]);

        return bw;
      }(ue);

      function ww(t) {
        var e = 1;

        var _iterator400 = _createForOfIteratorHelper(t.getChildren()),
            _step400;

        try {
          for (_iterator400.s(); !(_step400 = _iterator400.n()).done;) {
            var _n260 = _step400.value;

            if ("ul" == _n260.name || "ol" == _n260.name) {
              var _iterator401 = _createForOfIteratorHelper(_n260.getChildren()),
                  _step401;

              try {
                for (_iterator401.s(); !(_step401 = _iterator401.n()).done;) {
                  var _t323 = _step401.value;
                  e += ww(_t323);
                }
              } catch (err) {
                _iterator401.e(err);
              } finally {
                _iterator401.f();
              }
            }
          }
        } catch (err) {
          _iterator400.e(err);
        } finally {
          _iterator400.f();
        }

        return e;
      }

      var Aw = /*#__PURE__*/function (_ue69) {
        _inherits(Aw, _ue69);

        var _super182 = _createSuper(Aw);

        function Aw() {
          _classCallCheck(this, Aw);

          return _super182.apply(this, arguments);
        }

        _createClass(Aw, [{
          key: "init",
          value: function init() {
            var t = this.editor.t;
            iw(this.editor, "numberedList", t("Numbered List"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>'), iw(this.editor, "bulletedList", t("Bulleted List"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>');
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "ListUI";
          }
        }]);

        return Aw;
      }(ue);

      var Cw = /*#__PURE__*/function (_ue70) {
        _inherits(Cw, _ue70);

        var _super183 = _createSuper(Cw);

        function Cw() {
          _classCallCheck(this, Cw);

          return _super183.apply(this, arguments);
        }

        _createClass(Cw, null, [{
          key: "requires",
          get: function get() {
            return [bw, Aw];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "List";
          }
        }]);

        return Cw;
      }(ue);

      function _w(t, e) {
        return function (t) {
          t.on("attribute:url:media", n);
        };

        function n(n, i, o) {
          if (!o.consumable.consume(i.item, n.name)) return;

          var r = i.attributeNewValue,
              s = o.writer,
              a = o.mapper.toViewElement(i.item),
              c = _toConsumableArray(a.getChildren()).find(function (t) {
            return t.getCustomProperty("media-content");
          });

          s.remove(c);
          var l = t.getMediaViewElement(s, r, e);
          s.insert(s.createPositionAt(a, 0), l);
        }
      }

      function vw(t, e, n, i) {
        var o = t.createContainerElement("figure", {
          class: "media"
        });
        return t.insert(t.createPositionAt(o, 0), e.getMediaViewElement(t, n, i)), o;
      }

      function yw(t) {
        var e = t.getSelectedElement();
        return e && e.is("element", "media") ? e : null;
      }

      function xw(t, e, n) {
        t.change(function (i) {
          var o = i.createElement("media", {
            url: e
          });
          t.insertContent(o, n), i.setSelection(o, "on");
        });
      }

      var Ew = /*#__PURE__*/function (_me23) {
        _inherits(Ew, _me23);

        var _super184 = _createSuper(Ew);

        function Ew() {
          _classCallCheck(this, Ew);

          return _super184.apply(this, arguments);
        }

        _createClass(Ew, [{
          key: "refresh",
          value: function refresh() {
            var t = this.editor.model,
                e = t.document.selection,
                n = yw(e);
            this.value = n ? n.getAttribute("url") : null, this.isEnabled = function (t) {
              var e = t.getSelectedElement();
              return !!e && "media" === e.name;
            }(e) || function (t, e) {
              var n = Tp(t, e).start.parent;
              n.isEmpty && !e.schema.isLimit(n) && (n = n.parent);
              return e.schema.checkChild(n, "media");
            }(e, t);
          }
        }, {
          key: "execute",
          value: function execute(t) {
            var e = this.editor.model,
                n = e.document.selection,
                i = yw(n);
            i ? e.change(function (e) {
              e.setAttribute("url", t, i);
            }) : xw(e, t, Tp(n, e));
          }
        }]);

        return Ew;
      }(me);

      var Dw = /*#__PURE__*/function () {
        function Dw(t, e) {
          _classCallCheck(this, Dw);

          var n = e.providers,
              i = e.extraProviders || [],
              o = new Set(e.removeProviders),
              r = n.concat(i).filter(function (t) {
            var e = t.name;
            return e ? !o.has(e) : (c("media-embed-no-provider-name", {
              provider: t
            }), !1);
          });
          this.locale = t, this.providerDefinitions = r;
        }

        _createClass(Dw, [{
          key: "hasMedia",
          value: function hasMedia(t) {
            return !!this._getMedia(t);
          }
        }, {
          key: "getMediaViewElement",
          value: function getMediaViewElement(t, e, n) {
            return this._getMedia(e).getViewElement(t, n);
          }
        }, {
          key: "_getMedia",
          value: function _getMedia(t) {
            if (!t) return new Sw(this.locale);
            t = t.trim();

            var _iterator402 = _createForOfIteratorHelper(this.providerDefinitions),
                _step402;

            try {
              for (_iterator402.s(); !(_step402 = _iterator402.n()).done;) {
                var _e296 = _step402.value;

                var _n261 = _e296.html,
                    _i209 = Ii(_e296.url);

                var _iterator403 = _createForOfIteratorHelper(_i209),
                    _step403;

                try {
                  for (_iterator403.s(); !(_step403 = _iterator403.n()).done;) {
                    var _e297 = _step403.value;

                    var _i210 = this._getUrlMatches(t, _e297);

                    if (_i210) return new Sw(this.locale, t, _i210, _n261);
                  }
                } catch (err) {
                  _iterator403.e(err);
                } finally {
                  _iterator403.f();
                }
              }
            } catch (err) {
              _iterator402.e(err);
            } finally {
              _iterator402.f();
            }

            return null;
          }
        }, {
          key: "_getUrlMatches",
          value: function _getUrlMatches(t, e) {
            var n = t.match(e);
            if (n) return n;
            var i = t.replace(/^https?:\/\//, "");
            return n = i.match(e), n || (i = i.replace(/^www\./, ""), n = i.match(e), n || null);
          }
        }]);

        return Dw;
      }();

      var Sw = /*#__PURE__*/function () {
        function Sw(t, e, n, i) {
          _classCallCheck(this, Sw);

          this.url = this._getValidUrl(e), this._t = t.t, this._match = n, this._previewRenderer = i;
        }

        _createClass(Sw, [{
          key: "getViewElement",
          value: function getViewElement(t, e) {
            var n = {};
            var i;

            if (e.renderForEditingView || e.renderMediaPreview && this.url && this._previewRenderer) {
              this.url && (n["data-oembed-url"] = this.url), e.renderForEditingView && (n.class = "ck-media__wrapper");

              var _o111 = this._getPreviewHtml(e);

              i = t.createRawElement("div", n, function (t, e) {
                e.setContentOf(t, _o111);
              });
            } else this.url && (n.url = this.url), i = t.createEmptyElement(e.elementName, n);

            return t.setCustomProperty("media-content", !0, i), i;
          }
        }, {
          key: "_getPreviewHtml",
          value: function _getPreviewHtml(t) {
            return this._previewRenderer ? this._previewRenderer(this._match) : this.url && t.renderForEditingView ? this._getPlaceholderHtml() : "";
          }
        }, {
          key: "_getPlaceholderHtml",
          value: function _getPlaceholderHtml() {
            var t = new eh(),
                e = new Jd();
            t.text = this._t("Open media in new tab"), e.content = '<svg viewBox="0 0 64 42" xmlns="http://www.w3.org/2000/svg"><path d="M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098-2.506.668-4.538-.083-4.538-1.678 0-1.594 2.032-3.43 4.538-4.098.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556A1.014 1.014 0 0 0 49 17h-1.574zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.994 1.994 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805V17zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17zm29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155h18.692zM20.6 21.375v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616V37.53H20.6zm24.233-16.155v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615V37.53h-1.615zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35v-9.956z"/></svg>', e.viewBox = "0 0 64 42";
            return new Sd({
              tag: "div",
              attributes: {
                class: "ck ck-reset_all ck-media__placeholder"
              },
              children: [{
                tag: "div",
                attributes: {
                  class: "ck-media__placeholder__icon"
                },
                children: [e]
              }, {
                tag: "a",
                attributes: {
                  class: "ck-media__placeholder__url",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  href: this.url
                },
                children: [{
                  tag: "span",
                  attributes: {
                    class: "ck-media__placeholder__url__text"
                  },
                  children: [this.url]
                }, t]
              }]
            }).render().outerHTML;
          }
        }, {
          key: "_getValidUrl",
          value: function _getValidUrl(t) {
            return t ? t.match(/^https?/) ? t : "https://" + t : null;
          }
        }]);

        return Sw;
      }();

      var Iw = n(6385),
          Mw = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Iw.Z, Mw), Iw.Z.locals;

      var Tw = /*#__PURE__*/function (_ue71) {
        _inherits(Tw, _ue71);

        var _super185 = _createSuper(Tw);

        function Tw(t) {
          var _this279;

          _classCallCheck(this, Tw);

          _this279 = _super185.call(this, t), t.config.define("mediaEmbed", {
            elementName: "oembed",
            providers: [{
              name: "dailymotion",
              url: /^dailymotion\.com\/video\/(\w+)/,
              html: function html(t) {
                return "<div style=\"position: relative; padding-bottom: 100%; height: 0; \"><iframe src=\"https://www.dailymotion.com/embed/video/".concat(t[1], "\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" width=\"480\" height=\"270\" allowfullscreen allow=\"autoplay\"></iframe></div>");
              }
            }, {
              name: "spotify",
              url: [/^open\.spotify\.com\/(artist\/\w+)/, /^open\.spotify\.com\/(album\/\w+)/, /^open\.spotify\.com\/(track\/\w+)/],
              html: function html(t) {
                return "<div style=\"position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;\"><iframe src=\"https://open.spotify.com/embed/".concat(t[1], "\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" allowtransparency=\"true\" allow=\"encrypted-media\"></iframe></div>");
              }
            }, {
              name: "youtube",
              url: [/^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)/, /^(?:m\.)?youtube\.com\/v\/([\w-]+)/, /^youtube\.com\/embed\/([\w-]+)/, /^youtu\.be\/([\w-]+)/],
              html: function html(t) {
                return "<div style=\"position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;\"><iframe src=\"https://www.youtube.com/embed/".concat(t[1], "\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe></div>");
              }
            }, {
              name: "vimeo",
              url: [/^vimeo\.com\/(\d+)/, /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/channels\/[^/]+\/(\d+)/, /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/, /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/, /^player\.vimeo\.com\/video\/(\d+)/],
              html: function html(t) {
                return "<div style=\"position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;\"><iframe src=\"https://player.vimeo.com/video/".concat(t[1], "\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>");
              }
            }, {
              name: "instagram",
              url: /^instagram\.com\/p\/(\w+)/
            }, {
              name: "twitter",
              url: /^twitter\.com/
            }, {
              name: "googleMaps",
              url: [/^google\.com\/maps/, /^goo\.gl\/maps/, /^maps\.google\.com/, /^maps\.app\.goo\.gl/]
            }, {
              name: "flickr",
              url: /^flickr\.com/
            }, {
              name: "facebook",
              url: /^facebook\.com/
            }]
          }), _this279.registry = new Dw(t.locale, t.config.get("mediaEmbed"));
          return _this279;
        }

        _createClass(Tw, [{
          key: "init",
          value: function init() {
            var t = this.editor,
                e = t.model.schema,
                n = t.t,
                i = t.conversion,
                o = t.config.get("mediaEmbed.previewsInData"),
                r = t.config.get("mediaEmbed.elementName"),
                s = this.registry;
            t.commands.add("mediaEmbed", new Ew(t)), e.register("media", {
              isObject: !0,
              isBlock: !0,
              allowWhere: "$block",
              allowAttributes: ["url"]
            }), i.for("dataDowncast").elementToElement({
              model: "media",
              view: function view(t, _ref73) {
                var e = _ref73.writer;
                var n = t.getAttribute("url");
                return vw(e, s, n, {
                  elementName: r,
                  renderMediaPreview: n && o
                });
              }
            }), i.for("dataDowncast").add(_w(s, {
              elementName: r,
              renderMediaPreview: o
            })), i.for("editingDowncast").elementToElement({
              model: "media",
              view: function view(t, _ref74) {
                var e = _ref74.writer;
                var i = t.getAttribute("url");
                return function (t, e, n) {
                  return e.setCustomProperty("media", !0, t), xp(t, e, {
                    label: n
                  });
                }(vw(e, s, i, {
                  elementName: r,
                  renderForEditingView: !0
                }), e, n("media widget"));
              }
            }), i.for("editingDowncast").add(_w(s, {
              elementName: r,
              renderForEditingView: !0
            })), i.for("upcast").elementToElement({
              view: function view(t) {
                return ["oembed", r].includes(t.name) && t.getAttribute("url") ? {
                  name: !0
                } : null;
              },
              model: function model(t, _ref75) {
                var e = _ref75.writer;
                var n = t.getAttribute("url");
                if (s.hasMedia(n)) return e.createElement("media", {
                  url: n
                });
              }
            }).elementToElement({
              view: {
                name: "div",
                attributes: {
                  "data-oembed-url": !0
                }
              },
              model: function model(t, _ref76) {
                var e = _ref76.writer;
                var n = t.getAttribute("data-oembed-url");
                if (s.hasMedia(n)) return e.createElement("media", {
                  url: n
                });
              }
            }).add(function (t) {
              t.on("element:figure", function (t, e, n) {
                if (!n.consumable.consume(e.viewItem, {
                  name: !0,
                  classes: "media"
                })) return;

                var _n$convertChildren3 = n.convertChildren(e.viewItem, e.modelCursor),
                    i = _n$convertChildren3.modelRange,
                    o = _n$convertChildren3.modelCursor;

                e.modelRange = i, e.modelCursor = o;
                wa(i.getItems()) || n.consumable.revert(e.viewItem, {
                  name: !0,
                  classes: "media"
                });
              });
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "MediaEmbedEditing";
          }
        }]);

        return Tw;
      }(ue);

      var Nw = /^(?:http(s)?:\/\/)?[\w-]+\.[\w-.~:/?#[\]@!$&'()*+,;=%]+$/;

      var Bw = /*#__PURE__*/function (_ue72) {
        _inherits(Bw, _ue72);

        var _super186 = _createSuper(Bw);

        function Bw(t) {
          var _this280;

          _classCallCheck(this, Bw);

          _this280 = _super186.call(this, t), _this280._timeoutId = null, _this280._positionToInsert = null;
          return _this280;
        }

        _createClass(Bw, [{
          key: "init",
          value: function init() {
            var _this281 = this;

            var t = this.editor,
                e = t.model.document;
            this.listenTo(t.plugins.get("ClipboardPipeline"), "inputTransformation", function () {
              var t = e.selection.getFirstRange(),
                  n = Hl.fromPosition(t.start);
              n.stickiness = "toPrevious";
              var i = Hl.fromPosition(t.end);
              i.stickiness = "toNext", e.once("change:data", function () {
                _this281._embedMediaBetweenPositions(n, i), n.detach(), i.detach();
              }, {
                priority: "high"
              });
            }), t.commands.get("undo").on("execute", function () {
              _this281._timeoutId && (os.window.clearTimeout(_this281._timeoutId), _this281._positionToInsert.detach(), _this281._timeoutId = null, _this281._positionToInsert = null);
            }, {
              priority: "high"
            });
          }
        }, {
          key: "_embedMediaBetweenPositions",
          value: function _embedMediaBetweenPositions(t, e) {
            var _this282 = this;

            var n = this.editor,
                i = n.plugins.get(Tw).registry,
                o = new oc(t, e),
                r = o.getWalker({
              ignoreElementEnd: !0
            });
            var s = "";

            var _iterator404 = _createForOfIteratorHelper(r),
                _step404;

            try {
              for (_iterator404.s(); !(_step404 = _iterator404.n()).done;) {
                var _t324 = _step404.value;
                _t324.item.is("$textProxy") && (s += _t324.item.data);
              }
            } catch (err) {
              _iterator404.e(err);
            } finally {
              _iterator404.f();
            }

            if (s = s.trim(), !s.match(Nw)) return void o.detach();
            if (!i.hasMedia(s)) return void o.detach();
            n.commands.get("mediaEmbed").isEnabled ? (this._positionToInsert = Hl.fromPosition(t), this._timeoutId = os.window.setTimeout(function () {
              n.model.change(function (t) {
                var e;
                _this282._timeoutId = null, t.remove(o), o.detach(), "$graveyard" !== _this282._positionToInsert.root.rootName && (e = _this282._positionToInsert), xw(n.model, s, e), _this282._positionToInsert.detach(), _this282._positionToInsert = null;
              }), n.plugins.get("Delete").requestUndoOnBackspace();
            }, 100)) : o.detach();
          }
        }], [{
          key: "requires",
          get: function get() {
            return [rf, Ag, Cf];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "AutoMediaEmbed";
          }
        }]);

        return Bw;
      }(ue);

      var zw = n(1523),
          Pw = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(zw.Z, Pw), zw.Z.locals;

      var Lw = /*#__PURE__*/function (_Dd29) {
        _inherits(Lw, _Dd29);

        var _super187 = _createSuper(Lw);

        function Lw(t, e) {
          var _this283;

          _classCallCheck(this, Lw);

          _this283 = _super187.call(this, e);
          var n = e.t;
          _this283.focusTracker = new Aa(), _this283.keystrokes = new Ca(), _this283.set("mediaURLInputValue", ""), _this283.urlInputView = _this283._createUrlInput(), _this283.saveButtonView = _this283._createButton(n("Save"), Ad.check, "ck-button-save"), _this283.saveButtonView.type = "submit", _this283.saveButtonView.bind("isEnabled").to(_assertThisInitialized(_this283), "mediaURLInputValue", function (t) {
            return !!t;
          }), _this283.cancelButtonView = _this283._createButton(n("Cancel"), Ad.cancel, "ck-button-cancel", "cancel"), _this283._focusables = new yd(), _this283._focusCycler = new vh({
            focusables: _this283._focusables,
            focusTracker: _this283.focusTracker,
            keystrokeHandler: _this283.keystrokes,
            actions: {
              focusPrevious: "shift + tab",
              focusNext: "tab"
            }
          }), _this283._validators = t, _this283.setTemplate({
            tag: "form",
            attributes: {
              class: ["ck", "ck-media-form", "ck-responsive-form"],
              tabindex: "-1"
            },
            children: [_this283.urlInputView, _this283.saveButtonView, _this283.cancelButtonView]
          }), _d(_assertThisInitialized(_this283));
          return _this283;
        }

        _createClass(Lw, [{
          key: "render",
          value: function render() {
            var _this284 = this;

            _get(_getPrototypeOf(Lw.prototype), "render", this).call(this), vd({
              view: this
            });
            [this.urlInputView, this.saveButtonView, this.cancelButtonView].forEach(function (t) {
              _this284._focusables.add(t), _this284.focusTracker.add(t.element);
            }), this.keystrokes.listenTo(this.element);

            var t = function t(_t325) {
              return _t325.stopPropagation();
            };

            this.keystrokes.set("arrowright", t), this.keystrokes.set("arrowleft", t), this.keystrokes.set("arrowup", t), this.keystrokes.set("arrowdown", t), this.listenTo(this.urlInputView.element, "selectstart", function (t, e) {
              e.stopPropagation();
            }, {
              priority: "high"
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            _get(_getPrototypeOf(Lw.prototype), "destroy", this).call(this), this.focusTracker.destroy(), this.keystrokes.destroy();
          }
        }, {
          key: "focus",
          value: function focus() {
            this._focusCycler.focusFirst();
          }
        }, {
          key: "url",
          get: function get() {
            return this.urlInputView.fieldView.element.value.trim();
          },
          set: function set(t) {
            this.urlInputView.fieldView.element.value = t.trim();
          }
        }, {
          key: "isValid",
          value: function isValid() {
            this.resetFormStatus();

            var _iterator405 = _createForOfIteratorHelper(this._validators),
                _step405;

            try {
              for (_iterator405.s(); !(_step405 = _iterator405.n()).done;) {
                var _t326 = _step405.value;

                var _e298 = _t326(this);

                if (_e298) return this.urlInputView.errorText = _e298, !1;
              }
            } catch (err) {
              _iterator405.e(err);
            } finally {
              _iterator405.f();
            }

            return !0;
          }
        }, {
          key: "resetFormStatus",
          value: function resetFormStatus() {
            this.urlInputView.errorText = null, this.urlInputView.infoText = this._urlInputViewInfoDefault;
          }
        }, {
          key: "_createUrlInput",
          value: function _createUrlInput() {
            var _this285 = this;

            var t = this.locale.t,
                e = new lu(this.locale, du),
                n = e.fieldView;
            return this._urlInputViewInfoDefault = t("Paste the media URL in the input."), this._urlInputViewInfoTip = t("Tip: Paste the URL into the content to embed faster."), e.label = t("Media URL"), e.infoText = this._urlInputViewInfoDefault, n.on("input", function () {
              e.infoText = n.element.value ? _this285._urlInputViewInfoTip : _this285._urlInputViewInfoDefault, _this285.mediaURLInputValue = n.element.value.trim();
            }), e;
          }
        }, {
          key: "_createButton",
          value: function _createButton(t, e, n, i) {
            var o = new oh(this.locale);
            return o.set({
              label: t,
              icon: e,
              tooltip: !0
            }), o.extendTemplate({
              attributes: {
                class: n
              }
            }), i && o.delegate("execute").to(this, i), o;
          }
        }]);

        return Lw;
      }(Dd);

      var Rw = /*#__PURE__*/function (_ue73) {
        _inherits(Rw, _ue73);

        var _super188 = _createSuper(Rw);

        function Rw() {
          _classCallCheck(this, Rw);

          return _super188.apply(this, arguments);
        }

        _createClass(Rw, [{
          key: "init",
          value: function init() {
            var _this286 = this;

            var t = this.editor,
                e = t.commands.get("mediaEmbed"),
                n = t.plugins.get(Tw).registry;
            t.ui.componentFactory.add("mediaEmbed", function (i) {
              var o = Hh(i),
                  r = new Lw(function (t, e) {
                return [function (e) {
                  if (!e.url.length) return t("The URL must not be empty.");
                }, function (n) {
                  if (!e.hasMedia(n.url)) return t("This media URL is not supported.");
                }];
              }(t.t, n), t.locale);
              return _this286._setUpDropdown(o, r, e, t), _this286._setUpForm(o, r, e), o;
            });
          }
        }, {
          key: "_setUpDropdown",
          value: function _setUpDropdown(t, e, n) {
            var i = this.editor,
                o = i.t,
                r = t.buttonView;

            function s() {
              i.editing.view.focus(), t.isOpen = !1;
            }

            t.bind("isEnabled").to(n), t.panelView.children.add(e), r.set({
              label: o("Insert media"),
              icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M18.68 3.03c.6 0 .59-.03.59.55v12.84c0 .59.01.56-.59.56H1.29c-.6 0-.59.03-.59-.56V3.58c0-.58-.01-.55.6-.55h17.38zM15.77 15V5H4.2v10h11.57zM2 4v1h1V4H2zm0 2v1h1V6H2zm0 2v1h1V8H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zM17 4v1h1V4h-1zm0 2v1h1V6h-1zm0 2v1h1V8h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zM7.5 7.177a.4.4 0 0 1 .593-.351l5.133 2.824a.4.4 0 0 1 0 .7l-5.133 2.824a.4.4 0 0 1-.593-.35V7.176v.001z"/></svg>',
              tooltip: !0
            }), r.on("open", function () {
              e.disableCssTransitions(), e.url = n.value || "", e.urlInputView.fieldView.select(), e.focus(), e.enableCssTransitions();
            }, {
              priority: "low"
            }), t.on("submit", function () {
              e.isValid() && (i.execute("mediaEmbed", e.url), s());
            }), t.on("change:isOpen", function () {
              return e.resetFormStatus();
            }), t.on("cancel", function () {
              return s();
            });
          }
        }, {
          key: "_setUpForm",
          value: function _setUpForm(t, e, n) {
            e.delegate("submit", "cancel").to(t), e.urlInputView.bind("value").to(n, "value"), e.urlInputView.bind("isReadOnly").to(n, "isEnabled", function (t) {
              return !t;
            });
          }
        }], [{
          key: "requires",
          get: function get() {
            return [Tw];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "MediaEmbedUI";
          }
        }]);

        return Rw;
      }(ue);

      var Ow = n(8030),
          jw = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Ow.Z, jw), Ow.Z.locals;

      var Fw = /*#__PURE__*/function (_ue74) {
        _inherits(Fw, _ue74);

        var _super189 = _createSuper(Fw);

        function Fw() {
          _classCallCheck(this, Fw);

          return _super189.apply(this, arguments);
        }

        _createClass(Fw, null, [{
          key: "requires",
          get: function get() {
            return [Tw, Rw, Bw, $p];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "MediaEmbed";
          }
        }]);

        return Fw;
      }(ue);

      var Vw = /*#__PURE__*/function (_me24) {
        _inherits(Vw, _me24);

        var _super190 = _createSuper(Vw);

        function Vw() {
          _classCallCheck(this, Vw);

          return _super190.apply(this, arguments);
        }

        _createClass(Vw, [{
          key: "refresh",
          value: function refresh() {
            var t = this.editor.model,
                e = t.document;
            this.isEnabled = t.schema.checkAttributeInSelection(e.selection, "mention");
          }
        }, {
          key: "execute",
          value: function execute(t) {
            var e = this.editor.model,
                n = e.document.selection,
                i = "string" == typeof t.mention ? {
              id: t.mention
            } : t.mention,
                o = i.id,
                r = t.range || n.getFirstRange(),
                s = t.text || o,
                c = Hw({
              _text: s,
              id: o
            }, i);
            if (1 != t.marker.length) throw new a("mentioncommand-incorrect-marker", this);
            if (o.charAt(0) != t.marker) throw new a("mentioncommand-incorrect-id", this);
            e.change(function (t) {
              var i = Vi(n.getAttributes()),
                  o = new Map(i.entries());
              o.set("mention", c), e.insertContent(t.createText(s, o), r), e.insertContent(t.createText(" ", i), r.start.getShiftedBy(s.length));
            });
          }
        }]);

        return Vw;
      }(me);

      var Uw = /*#__PURE__*/function (_ue75) {
        _inherits(Uw, _ue75);

        var _super191 = _createSuper(Uw);

        function Uw() {
          _classCallCheck(this, Uw);

          return _super191.apply(this, arguments);
        }

        _createClass(Uw, [{
          key: "init",
          value: function init() {
            var t = this.editor,
                e = t.model,
                n = e.document;
            e.schema.extend("$text", {
              allowAttributes: "mention"
            }), t.conversion.for("upcast").elementToAttribute({
              view: {
                name: "span",
                key: "data-mention",
                classes: "mention"
              },
              model: {
                key: "mention",
                value: function value(t) {
                  return qw(t);
                }
              }
            }), t.conversion.for("downcast").attributeToElement({
              model: "mention",
              view: Gw
            }), t.conversion.for("downcast").add(Ww), n.registerPostFixer(function (t) {
              return function (t, e, n) {
                var i = e.differ.getChanges();
                var o = !1;

                var _iterator406 = _createForOfIteratorHelper(i),
                    _step406;

                try {
                  for (_iterator406.s(); !(_step406 = _iterator406.n()).done;) {
                    var _e299 = _step406.value;
                    var _i211 = _e299.position;

                    if ("$text" == _e299.name) {
                      var _e300 = _i211.textNode && _i211.textNode.nextSibling;

                      o = Yw(_i211.textNode, t) || o, o = Yw(_e300, t) || o, o = Yw(_i211.nodeBefore, t) || o, o = Yw(_i211.nodeAfter, t) || o;
                    }

                    if ("$text" != _e299.name && "insert" == _e299.type) {
                      var _e301 = _i211.nodeAfter;

                      var _iterator407 = _createForOfIteratorHelper(t.createRangeIn(_e301).getItems()),
                          _step407;

                      try {
                        for (_iterator407.s(); !(_step407 = _iterator407.n()).done;) {
                          var _n262 = _step407.value;
                          o = Yw(_n262, t) || o;
                        }
                      } catch (err) {
                        _iterator407.e(err);
                      } finally {
                        _iterator407.f();
                      }
                    }

                    if ("insert" == _e299.type && n.isInline(_e299.name)) {
                      var _e302 = _i211.nodeAfter && _i211.nodeAfter.nextSibling;

                      o = Yw(_i211.nodeBefore, t) || o, o = Yw(_e302, t) || o;
                    }
                  }
                } catch (err) {
                  _iterator406.e(err);
                } finally {
                  _iterator406.f();
                }

                return o;
              }(t, n, e.schema);
            }), n.registerPostFixer(function (t) {
              return function (t, e) {
                var n = e.differ.getChanges();
                var i = !1;

                var _iterator408 = _createForOfIteratorHelper(n),
                    _step408;

                try {
                  for (_iterator408.s(); !(_step408 = _iterator408.n()).done;) {
                    var _e303 = _step408.value;

                    if ("attribute" === _e303.type && "mention" != _e303.attributeKey) {
                      var _n263 = _e303.range.start.nodeBefore,
                          _o112 = _e303.range.end.nodeAfter;

                      for (var _i212 = 0, _arr2 = [_n263, _o112]; _i212 < _arr2.length; _i212++) {
                        var _r66 = _arr2[_i212];
                        $w(_r66) && _r66.getAttribute(_e303.attributeKey) != _e303.attributeNewValue && (t.setAttribute(_e303.attributeKey, _e303.attributeNewValue, _r66), i = !0);
                      }
                    }
                  }
                } catch (err) {
                  _iterator408.e(err);
                } finally {
                  _iterator408.f();
                }

                return i;
              }(t, n);
            }), n.registerPostFixer(function (t) {
              return function (t, e) {
                var n = e.selection,
                    i = n.focus;
                if (n.isCollapsed && n.hasAttribute("mention") && function (t) {
                  var e = t.isAtStart;
                  return t.nodeBefore && t.nodeBefore.is("$text") || e;
                }(i)) return t.removeSelectionAttribute("mention"), !0;
              }(t, n);
            }), t.commands.add("mention", new Vw(t));
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "MentionEditing";
          }
        }]);

        return Uw;
      }(ue);

      function Hw(t, e) {
        return Object.assign({
          uid: r()
        }, t, e || {});
      }

      function qw(t, e) {
        var n = t.getAttribute("data-mention"),
            i = t.getChild(0);
        if (!i) return;
        return Hw({
          id: n,
          _text: i.data
        }, e);
      }

      function Ww(t) {
        t.on("attribute:mention", function (t, e, n) {
          var i = e.attributeNewValue;
          if (!e.item.is("$textProxy") || !i) return;
          var o = e.range.start;
          (o.textNode || o.nodeAfter).data != i._text && n.consumable.consume(e.item, t.name);
        }, {
          priority: "highest"
        });
      }

      function Gw(t, _ref77) {
        var e = _ref77.writer;
        if (!t) return;
        var n = {
          class: "mention",
          "data-mention": t.id
        },
            i = {
          id: t.uid,
          priority: 20
        };
        return e.createAttributeElement("span", n, i);
      }

      function $w(t) {
        if (!t || !t.is("$text") && !t.is("$textProxy") || !t.hasAttribute("mention")) return !1;
        return t.data != t.getAttribute("mention")._text;
      }

      function Yw(t, e) {
        return !!$w(t) && (e.removeAttribute("mention", t), !0);
      }

      var Kw = n(6614),
          Qw = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(Kw.Z, Qw), Kw.Z.locals;

      var Zw = /*#__PURE__*/function (_Lh) {
        _inherits(Zw, _Lh);

        var _super192 = _createSuper(Zw);

        function Zw(t) {
          var _this287;

          _classCallCheck(this, Zw);

          _this287 = _super192.call(this, t), _this287.extendTemplate({
            attributes: {
              class: ["ck-mentions"],
              tabindex: "-1"
            }
          });
          return _this287;
        }

        _createClass(Zw, [{
          key: "selectFirst",
          value: function selectFirst() {
            this.select(0);
          }
        }, {
          key: "selectNext",
          value: function selectNext() {
            var t = this.selected,
                e = this.items.getIndex(t);
            this.select(e + 1);
          }
        }, {
          key: "selectPrevious",
          value: function selectPrevious() {
            var t = this.selected,
                e = this.items.getIndex(t);
            this.select(e - 1);
          }
        }, {
          key: "select",
          value: function select(t) {
            var e = 0;
            t > 0 && t < this.items.length ? e = t : t < 0 && (e = this.items.length - 1);
            var n = this.items.get(e);
            this.selected !== n && (this.selected && this.selected.removeHighlight(), n.highlight(), this.selected = n, this._isItemVisibleInScrolledArea(n) || (this.element.scrollTop = n.element.offsetTop));
          }
        }, {
          key: "executeSelected",
          value: function executeSelected() {
            this.selected.fire("execute");
          }
        }, {
          key: "_isItemVisibleInScrolledArea",
          value: function _isItemVisibleInScrolledArea(t) {
            return new ma(this.element).contains(new ma(t.element));
          }
        }]);

        return Zw;
      }(Lh);

      var Jw = /*#__PURE__*/function (_Dd30) {
        _inherits(Jw, _Dd30);

        var _super193 = _createSuper(Jw);

        function Jw(t, e) {
          var _this288;

          _classCallCheck(this, Jw);

          _this288 = _super193.call(this, t), _this288.template = !1, _this288.domElement = e, _this288.domElement.classList.add("ck-button"), _this288.set("isOn", !1), _this288.on("change:isOn", function (t, e, n) {
            n ? (_this288.domElement.classList.add("ck-on"), _this288.domElement.classList.remove("ck-off")) : (_this288.domElement.classList.add("ck-off"), _this288.domElement.classList.remove("ck-on"));
          }), _this288.listenTo(_this288.domElement, "click", function () {
            _this288.fire("execute");
          });
          return _this288;
        }

        _createClass(Jw, [{
          key: "render",
          value: function render() {
            _get(_getPrototypeOf(Jw.prototype), "render", this).call(this), this.element = this.domElement;
          }
        }]);

        return Jw;
      }(Dd);

      var Xw = /*#__PURE__*/function (_Rh) {
        _inherits(Xw, _Rh);

        var _super194 = _createSuper(Xw);

        function Xw() {
          _classCallCheck(this, Xw);

          return _super194.apply(this, arguments);
        }

        _createClass(Xw, [{
          key: "highlight",
          value: function highlight() {
            this.children.first.isOn = !0;
          }
        }, {
          key: "removeHighlight",
          value: function removeHighlight() {
            this.children.first.isOn = !1;
          }
        }]);

        return Xw;
      }(Rh);

      var tA = [dr.arrowup, dr.arrowdown, dr.esc],
          eA = [dr.enter, dr.tab];

      var nA = /*#__PURE__*/function (_ue76) {
        _inherits(nA, _ue76);

        var _super195 = _createSuper(nA);

        function nA(t) {
          var _this289;

          _classCallCheck(this, nA);

          _this289 = _super195.call(this, t), _this289._mentionsView = _this289._createMentionView(), _this289._mentionsConfigurations = new Map(), _this289._requestFeedDebounced = oa(_this289._requestFeed, 100), t.config.define("mention", {
            feeds: []
          });
          return _this289;
        }

        _createClass(nA, [{
          key: "init",
          value: function init() {
            var _this290 = this;

            var t = this.editor,
                e = t.config.get("mention.commitKeys") || eA,
                n = tA.concat(e);
            this._balloon = t.plugins.get(xu), t.editing.view.document.on("keydown", function (t, i) {
              var o;
              o = i.keyCode, n.includes(o) && _this290._isUIVisible && (i.preventDefault(), t.stop(), i.keyCode == dr.arrowdown && _this290._mentionsView.selectNext(), i.keyCode == dr.arrowup && _this290._mentionsView.selectPrevious(), e.includes(i.keyCode) && _this290._mentionsView.executeSelected(), i.keyCode == dr.esc && _this290._hideUIAndRemoveMarker());
            }, {
              priority: "highest"
            }), Cd({
              emitter: this._mentionsView,
              activator: function activator() {
                return _this290._isUIVisible;
              },
              contextElements: [this._balloon.view.element],
              callback: function callback() {
                return _this290._hideUIAndRemoveMarker();
              }
            });
            var i = t.config.get("mention.feeds");

            var _iterator409 = _createForOfIteratorHelper(i),
                _step409;

            try {
              for (_iterator409.s(); !(_step409 = _iterator409.n()).done;) {
                var _t327 = _step409.value;
                var _e304 = _t327.feed,
                    _n264 = _t327.marker;
                if (!aA(_n264)) throw new a("mentionconfig-incorrect-marker", null, {
                  marker: _n264
                });
                var _i213 = {
                  marker: _n264,
                  feedCallback: "function" == typeof _e304 ? _e304.bind(this.editor) : sA(_e304),
                  itemRenderer: _t327.itemRenderer
                };

                this._mentionsConfigurations.set(_n264, _i213);
              }
            } catch (err) {
              _iterator409.e(err);
            } finally {
              _iterator409.f();
            }

            this._setupTextWatcher(i), this.listenTo(t, "change:isReadOnly", function () {
              _this290._hideUIAndRemoveMarker();
            }), this.on("requestFeed:response", function (t, e) {
              return _this290._handleFeedResponse(e);
            }), this.on("requestFeed:error", function () {
              return _this290._hideUIAndRemoveMarker();
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            _get(_getPrototypeOf(nA.prototype), "destroy", this).call(this), this._mentionsView.destroy();
          }
        }, {
          key: "_isUIVisible",
          get: function get() {
            return this._balloon.visibleView === this._mentionsView;
          }
        }, {
          key: "_createMentionView",
          value: function _createMentionView() {
            var _this291 = this;

            var t = this.editor.locale,
                e = new Zw(t);
            return this._items = new Di(), e.items.bindTo(this._items).using(function (n) {
              var i = n.item,
                  o = n.marker,
                  r = _this291.editor.config.get("mention.dropdownLimit") || 10;
              if (e.items.length >= r) return;

              var s = new Xw(t),
                  a = _this291._renderItem(i, o);

              return a.delegate("execute").to(s), s.children.add(a), s.item = i, s.marker = o, s.on("execute", function () {
                e.fire("execute", {
                  item: i,
                  marker: o
                });
              }), s;
            }), e.on("execute", function (t, e) {
              var n = _this291.editor,
                  i = n.model,
                  o = e.item,
                  r = e.marker,
                  s = n.model.markers.get("mention"),
                  a = i.createPositionAt(i.document.selection.focus),
                  c = i.createPositionAt(s.getStart()),
                  l = i.createRange(c, a);
              _this291._hideUIAndRemoveMarker(), n.execute("mention", {
                mention: o,
                text: o.text,
                marker: r,
                range: l
              }), n.editing.view.focus();
            }), e;
          }
        }, {
          key: "_getItemRenderer",
          value: function _getItemRenderer(t) {
            var _this$_mentionsConfig = this._mentionsConfigurations.get(t),
                e = _this$_mentionsConfig.itemRenderer;

            return e;
          }
        }, {
          key: "_requestFeed",
          value: function _requestFeed(t, e) {
            var _this292 = this;

            this._lastRequested = e;

            var _this$_mentionsConfig2 = this._mentionsConfigurations.get(t),
                n = _this$_mentionsConfig2.feedCallback,
                i = n(e);

            i instanceof Promise ? i.then(function (n) {
              _this292._lastRequested == e ? _this292.fire("requestFeed:response", {
                feed: n,
                marker: t,
                feedText: e
              }) : _this292.fire("requestFeed:discarded", {
                feed: n,
                marker: t,
                feedText: e
              });
            }).catch(function (e) {
              _this292.fire("requestFeed:error", {
                error: e
              }), c("mention-feed-callback-error", {
                marker: t
              });
            }) : this.fire("requestFeed:response", {
              feed: i,
              marker: t,
              feedText: e
            });
          }
        }, {
          key: "_setupTextWatcher",
          value: function _setupTextWatcher(t) {
            var _this293 = this;

            var e = this.editor,
                n = t.map(function (t) {
              return _objectSpread(_objectSpread({}, t), {}, {
                pattern: rA(t.marker, t.minimumCharacters || 0)
              });
            }),
                i = new vg(e.model, function (t) {
              return function (e) {
                var n = oA(t, e);
                if (!n) return !1;
                var i = 0;
                0 !== n.position && (i = n.position - 1);
                var o = e.substring(i);
                return n.pattern.test(o);
              };
            }(n));
            i.on("matched", function (t, i) {
              var o = oA(n, i.text),
                  r = e.model.document.selection.focus;
              if (function (t) {
                var e = t.textNode && t.textNode.hasAttribute("mention"),
                    n = t.nodeBefore;
                return e || n && n.is("$text") && n.hasAttribute("mention");
              }(r)) return void _this293._hideUIAndRemoveMarker();

              var s = function (t, e) {
                var n = 0;
                0 !== t.position && (n = t.position - 1);
                var i = rA(t.marker, 0),
                    o = e.substring(n);
                return o.match(i)[2];
              }(o, i.text),
                  a = o.marker.length + s.length,
                  c = r.getShiftedBy(-a),
                  l = r.getShiftedBy(-s.length),
                  d = e.model.createRange(c, l);

              if (cA(e)) {
                var _t328 = e.model.markers.get("mention");

                e.model.change(function (e) {
                  e.updateMarker(_t328, {
                    range: d
                  });
                });
              } else e.model.change(function (t) {
                t.addMarker("mention", {
                  range: d,
                  usingOperation: !1,
                  affectsData: !1
                });
              });

              _this293._requestFeedDebounced(o.marker, s);
            }), i.on("unmatched", function () {
              _this293._hideUIAndRemoveMarker();
            });
            var o = e.commands.get("mention");
            return i.bind("isEnabled").to(o), i;
          }
        }, {
          key: "_handleFeedResponse",
          value: function _handleFeedResponse(t) {
            var e = t.feed,
                n = t.marker;
            if (!cA(this.editor)) return;

            this._items.clear();

            var _iterator410 = _createForOfIteratorHelper(e),
                _step410;

            try {
              for (_iterator410.s(); !(_step410 = _iterator410.n()).done;) {
                var _t329 = _step410.value;

                var _e305 = "object" != typeof _t329 ? {
                  id: _t329,
                  text: _t329
                } : _t329;

                this._items.add({
                  item: _e305,
                  marker: n
                });
              }
            } catch (err) {
              _iterator410.e(err);
            } finally {
              _iterator410.f();
            }

            var i = this.editor.model.markers.get("mention");
            this._items.length ? this._showOrUpdateUI(i) : this._hideUIAndRemoveMarker();
          }
        }, {
          key: "_showOrUpdateUI",
          value: function _showOrUpdateUI(t) {
            this._isUIVisible ? this._balloon.updatePosition(this._getBalloonPanelPositionData(t, this._mentionsView.position)) : this._balloon.add({
              view: this._mentionsView,
              position: this._getBalloonPanelPositionData(t, this._mentionsView.position),
              singleViewMode: !0
            }), this._mentionsView.position = this._balloon.view.position, this._mentionsView.selectFirst();
          }
        }, {
          key: "_hideUIAndRemoveMarker",
          value: function _hideUIAndRemoveMarker() {
            this._balloon.hasView(this._mentionsView) && this._balloon.remove(this._mentionsView), cA(this.editor) && this.editor.model.change(function (t) {
              return t.removeMarker("mention");
            }), this._mentionsView.position = void 0;
          }
        }, {
          key: "_renderItem",
          value: function _renderItem(t, e) {
            var n = this.editor;
            var i,
                o = t.id;

            var r = this._getItemRenderer(e);

            if (r) {
              var _e306 = r(t);

              "string" != typeof _e306 ? i = new Jw(n.locale, _e306) : o = _e306;
            }

            if (!i) {
              var _t330 = new oh(n.locale);

              _t330.label = o, _t330.withText = !0, i = _t330;
            }

            return i;
          }
        }, {
          key: "_getBalloonPanelPositionData",
          value: function _getBalloonPanelPositionData(t, e) {
            var _this294 = this;

            var n = this.editor,
                i = n.editing,
                o = i.view.domConverter,
                r = i.mapper;
            return {
              target: function target() {
                var e = t.getRange();
                "$graveyard" == e.start.root.rootName && (e = n.model.document.selection.getFirstRange());
                var i = r.toViewRange(e);
                return ma.getDomRangeRects(o.viewRangeToDom(i)).pop();
              },
              limiter: function limiter() {
                var t = _this294.editor.editing.view,
                    e = t.document.selection.editableElement;
                return e ? t.domConverter.mapViewToDom(e.root) : null;
              },
              positions: iA(e)
            };
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "MentionUI";
          }
        }, {
          key: "requires",
          get: function get() {
            return [xu];
          }
        }]);

        return nA;
      }(ue);

      function iA(t) {
        var e = {
          caret_se: function caret_se(t) {
            return {
              top: t.bottom + 3,
              left: t.right,
              name: "caret_se",
              config: {
                withArrow: !1
              }
            };
          },
          caret_ne: function caret_ne(t, e) {
            return {
              top: t.top - e.height - 3,
              left: t.right,
              name: "caret_ne",
              config: {
                withArrow: !1
              }
            };
          },
          caret_sw: function caret_sw(t, e) {
            return {
              top: t.bottom + 3,
              left: t.right - e.width,
              name: "caret_sw",
              config: {
                withArrow: !1
              }
            };
          },
          caret_nw: function caret_nw(t, e) {
            return {
              top: t.top - e.height - 3,
              left: t.right - e.width,
              name: "caret_nw",
              config: {
                withArrow: !1
              }
            };
          }
        };
        return Object.prototype.hasOwnProperty.call(e, t) ? [e[t]] : [e.caret_se, e.caret_sw, e.caret_ne, e.caret_nw];
      }

      function oA(t, e) {
        var n;

        var _iterator411 = _createForOfIteratorHelper(t),
            _step411;

        try {
          for (_iterator411.s(); !(_step411 = _iterator411.n()).done;) {
            var _i214 = _step411.value;

            var _t331 = e.lastIndexOf(_i214.marker);

            _t331 > 0 && !e.substring(_t331 - 1).match(_i214.pattern) || (!n || _t331 >= n.position) && (n = {
              marker: _i214.marker,
              position: _t331,
              minimumCharacters: _i214.minimumCharacters,
              pattern: _i214.pattern
            });
          }
        } catch (err) {
          _iterator411.e(err);
        } finally {
          _iterator411.f();
        }

        return n;
      }

      function rA(t, e) {
        var n = 0 == e ? "*" : "{".concat(e, ",}"),
            i = sr.features.isRegExpUnicodePropertySupported ? "\\p{Ps}\\p{Pi}\"'" : "\\(\\[{\"'";
        return new RegExp("(?:^|[ ".concat(i, "])([").concat(t, "])(.").concat(n, ")$"), "u");
      }

      function sA(t) {
        return function (e) {
          return t.filter(function (t) {
            return ("string" == typeof t ? t : String(t.id)).toLowerCase().includes(e.toLowerCase());
          });
        };
      }

      function aA(t) {
        return t && 1 == t.length;
      }

      function cA(t) {
        return t.model.markers.has("mention");
      }

      var lA = n(3010),
          dA = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(lA.Z, dA), lA.Z.locals;

      var hA = /*#__PURE__*/function (_ue77) {
        _inherits(hA, _ue77);

        var _super196 = _createSuper(hA);

        function hA() {
          _classCallCheck(this, hA);

          return _super196.apply(this, arguments);
        }

        _createClass(hA, [{
          key: "toMentionAttribute",
          value: function toMentionAttribute(t, e) {
            return qw(t, e);
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "Mention";
          }
        }, {
          key: "requires",
          get: function get() {
            return [Uw, nA];
          }
        }]);

        return hA;
      }(ue);

      function uA(t, e) {
        if (!t.childCount) return;

        var n = new eg(t.document),
            i = function (t, e) {
          var n = e.createRangeIn(t),
              i = new Ui({
            name: /^p|h\d+$/,
            styles: {
              "mso-list": /.*/
            }
          }),
              o = [];

          var _iterator412 = _createForOfIteratorHelper(n),
              _step412;

          try {
            for (_iterator412.s(); !(_step412 = _iterator412.n()).done;) {
              var _t332 = _step412.value;

              if ("elementStart" === _t332.type && i.match(_t332.item)) {
                var _e307 = pA(_t332.item);

                o.push({
                  element: _t332.item,
                  id: _e307.id,
                  order: _e307.order,
                  indent: _e307.indent
                });
              }
            }
          } catch (err) {
            _iterator412.e(err);
          } finally {
            _iterator412.f();
          }

          return o;
        }(t, n);

        if (!i.length) return;
        var o = null,
            r = 1;
        i.forEach(function (t, s) {
          var a = function (t, e) {
            if (!t) return !0;
            if (t.id !== e.id) return e.indent - t.indent != 1;
            var n = e.element.previousSibling;
            if (!n) return !0;
            return i = n, !(i.is("element", "ol") || i.is("element", "ul"));
            var i;
          }(i[s - 1], t),
              c = a ? null : i[s - 1],
              l = (h = t, (d = c) ? h.indent - d.indent : h.indent - 1);

          var d, h;

          if (a && (o = null, r = 1), !o || 0 !== l) {
            var _i215 = function (t, e) {
              var n = new RegExp("@list l".concat(t.id, ":level").concat(t.indent, "\\s*({[^}]*)"), "gi"),
                  i = /mso-level-number-format:([^;]{0,100});/gi,
                  o = /mso-level-start-at:\s{0,100}([0-9]{0,10})\s{0,100};/gi,
                  r = n.exec(e);
              var s = "decimal",
                  a = "ol",
                  c = null;

              if (r && r[1]) {
                var _e308 = i.exec(r[1]);

                if (_e308 && _e308[1] && (s = _e308[1].trim(), a = "bullet" !== s && "image" !== s ? "ol" : "ul"), "bullet" === s) {
                  var _e309 = function (t) {
                    var e = function (t) {
                      if (t.getChild(0).is("$text")) return null;

                      var _iterator413 = _createForOfIteratorHelper(t.getChildren()),
                          _step413;

                      try {
                        for (_iterator413.s(); !(_step413 = _iterator413.n()).done;) {
                          var _e310 = _step413.value;
                          if (!_e310.is("element", "span")) continue;

                          var _t333 = _e310.getChild(0);

                          return _t333.is("$text") ? _t333 : _t333.getChild(0);
                        }
                      } catch (err) {
                        _iterator413.e(err);
                      } finally {
                        _iterator413.f();
                      }
                    }(t);

                    if (!e) return null;
                    var n = e._data;
                    if ("o" === n) return "circle";
                    if ("·" === n) return "disc";
                    if ("§" === n) return "square";
                    return null;
                  }(t.element);

                  _e309 && (s = _e309);
                } else {
                  var _t334 = o.exec(r[1]);

                  _t334 && _t334[1] && (c = parseInt(_t334[1]));
                }
              }

              return {
                type: a,
                startIndex: c,
                style: gA(s)
              };
            }(t, e);

            if (o) {
              if (t.indent > r) {
                var _t335 = o.getChild(o.childCount - 1),
                    _e311 = _t335.getChild(_t335.childCount - 1);

                o = mA(_i215, _e311, n), r += 1;
              } else if (t.indent < r) {
                var _e312 = r - t.indent;

                o = function (t, e) {
                  var n = t.getAncestors({
                    parentFirst: !0
                  });
                  var i = null,
                      o = 0;

                  var _iterator414 = _createForOfIteratorHelper(n),
                      _step414;

                  try {
                    for (_iterator414.s(); !(_step414 = _iterator414.n()).done;) {
                      var _t336 = _step414.value;

                      if ("ul" !== _t336.name && "ol" !== _t336.name || o++, o === e) {
                        i = _t336;
                        break;
                      }
                    }
                  } catch (err) {
                    _iterator414.e(err);
                  } finally {
                    _iterator414.f();
                  }

                  return i;
                }(o, _e312), r = parseInt(t.indent);
              }
            } else o = mA(_i215, t.element, n);

            t.indent <= r && (o.is("element", _i215.type) || (o = n.rename(_i215.type, o)));
          }

          var u = function (t, e) {
            return function (t, e) {
              var n = new Ui({
                name: "span",
                styles: {
                  "mso-list": "Ignore"
                }
              }),
                  i = e.createRangeIn(t);

              var _iterator415 = _createForOfIteratorHelper(i),
                  _step415;

              try {
                for (_iterator415.s(); !(_step415 = _iterator415.n()).done;) {
                  var _t337 = _step415.value;
                  "elementStart" === _t337.type && n.match(_t337.item) && e.remove(_t337.item);
                }
              } catch (err) {
                _iterator415.e(err);
              } finally {
                _iterator415.f();
              }
            }(t, e), e.rename("li", t);
          }(t.element, n);

          n.appendChild(u, o);
        });
      }

      function gA(t) {
        if (t.startsWith("arabic-leading-zero")) return "decimal-leading-zero";

        switch (t) {
          case "alpha-upper":
            return "upper-alpha";

          case "alpha-lower":
            return "lower-alpha";

          case "roman-upper":
            return "upper-roman";

          case "roman-lower":
            return "lower-roman";

          case "circle":
          case "disc":
          case "square":
            return t;

          default:
            return null;
        }
      }

      function mA(t, e, n) {
        var i = e.parent,
            o = n.createElement(t.type),
            r = i.getChildIndex(e) + 1;
        return n.insertChild(r, o, i), t.style && n.setStyle("list-style-type", t.style, o), t.startIndex && t.startIndex > 1 && n.setAttribute("start", t.startIndex, o), o;
      }

      function pA(t) {
        var e = {},
            n = t.getStyle("mso-list");

        if (n) {
          var _t338 = n.match(/(^|\s{1,100})l(\d+)/i),
              _i216 = n.match(/\s{0,100}lfo(\d+)/i),
              _o113 = n.match(/\s{0,100}level(\d+)/i);

          _t338 && _i216 && _o113 && (e.id = _t338[2], e.order = _i216[1], e.indent = _o113[1]);
        }

        return e;
      }

      var fA = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;

      var kA = /*#__PURE__*/function () {
        function kA(t) {
          _classCallCheck(this, kA);

          this.document = t;
        }

        _createClass(kA, [{
          key: "isActive",
          value: function isActive(t) {
            return fA.test(t);
          }
        }, {
          key: "execute",
          value: function execute(t) {
            var e = new eg(this.document),
                n = t._parsedData.body;
            !function (t, e) {
              var _iterator416 = _createForOfIteratorHelper(t.getChildren()),
                  _step416;

              try {
                for (_iterator416.s(); !(_step416 = _iterator416.n()).done;) {
                  var _n265 = _step416.value;

                  if (_n265.is("element", "b") && "normal" === _n265.getStyle("font-weight")) {
                    var _i217 = t.getChildIndex(_n265);

                    e.remove(_n265), e.insertChild(_i217, _n265.getChildren(), t);
                  }
                }
              } catch (err) {
                _iterator416.e(err);
              } finally {
                _iterator416.f();
              }
            }(n, e), function (t, e) {
              var _iterator417 = _createForOfIteratorHelper(e.createRangeIn(t)),
                  _step417;

              try {
                for (_iterator417.s(); !(_step417 = _iterator417.n()).done;) {
                  var _n266 = _step417.value;
                  var _t339 = _n266.item;

                  if (_t339.is("element", "li")) {
                    var _n267 = _t339.getChild(0);

                    _n267 && _n267.is("element", "p") && e.unwrapElement(_n267);
                  }
                }
              } catch (err) {
                _iterator417.e(err);
              } finally {
                _iterator417.f();
              }
            }(n, e), t.content = n;
          }
        }]);

        return kA;
      }();

      function bA(t, e) {
        if (!t.childCount) return;

        var n = new eg(),
            i = function (t, e) {
          var n = e.createRangeIn(t),
              i = new Ui({
            name: /v:(.+)/
          }),
              o = [];

          var _iterator418 = _createForOfIteratorHelper(n),
              _step418;

          try {
            for (_iterator418.s(); !(_step418 = _iterator418.n()).done;) {
              var _t340 = _step418.value;
              if ("elementStart" != _t340.type) continue;

              var _e313 = _t340.item,
                  _n268 = _e313.previousSibling && _e313.previousSibling.name || null;

              i.match(_e313) && _e313.getAttribute("o:gfxdata") && "v:shapetype" !== _n268 && o.push(_t340.item.getAttribute("id"));
            }
          } catch (err) {
            _iterator418.e(err);
          } finally {
            _iterator418.f();
          }

          return o;
        }(t, n);

        !function (t, e, n) {
          var i = n.createRangeIn(e),
              o = new Ui({
            name: "img"
          }),
              r = [];

          var _iterator419 = _createForOfIteratorHelper(i),
              _step419;

          try {
            for (_iterator419.s(); !(_step419 = _iterator419.n()).done;) {
              var _e314 = _step419.value;

              if (o.match(_e314.item)) {
                var _n269 = _e314.item,
                    _i219 = _n269.getAttribute("v:shapes") ? _n269.getAttribute("v:shapes").split(" ") : [];

                _i219.length && _i219.every(function (e) {
                  return t.indexOf(e) > -1;
                }) ? r.push(_n269) : _n269.getAttribute("src") || r.push(_n269);
              }
            }
          } catch (err) {
            _iterator419.e(err);
          } finally {
            _iterator419.f();
          }

          for (var _i218 = 0, _r67 = r; _i218 < _r67.length; _i218++) {
            var _t341 = _r67[_i218];
            n.remove(_t341);
          }
        }(i, t, n), function (t, e) {
          var n = e.createRangeIn(t),
              i = new Ui({
            name: /v:(.+)/
          }),
              o = [];

          var _iterator420 = _createForOfIteratorHelper(n),
              _step420;

          try {
            for (_iterator420.s(); !(_step420 = _iterator420.n()).done;) {
              var _t343 = _step420.value;
              "elementStart" == _t343.type && i.match(_t343.item) && o.push(_t343.item);
            }
          } catch (err) {
            _iterator420.e(err);
          } finally {
            _iterator420.f();
          }

          for (var _i220 = 0, _o114 = o; _i220 < _o114.length; _i220++) {
            var _t342 = _o114[_i220];
            e.remove(_t342);
          }
        }(t, n);

        var o = function (t, e) {
          var n = e.createRangeIn(t),
              i = new Ui({
            name: "img"
          }),
              o = [];

          var _iterator421 = _createForOfIteratorHelper(n),
              _step421;

          try {
            for (_iterator421.s(); !(_step421 = _iterator421.n()).done;) {
              var _t344 = _step421.value;
              i.match(_t344.item) && _t344.item.getAttribute("src").startsWith("file://") && o.push(_t344.item);
            }
          } catch (err) {
            _iterator421.e(err);
          } finally {
            _iterator421.f();
          }

          return o;
        }(t, n);

        o.length && function (t, e, n) {
          if (t.length === e.length) for (var _i221 = 0; _i221 < t.length; _i221++) {
            var _o115 = "data:".concat(e[_i221].type, ";base64,").concat(wA(e[_i221].hex));

            n.setAttribute("src", _o115, t[_i221]);
          }
        }(o, function (t) {
          if (!t) return [];
          var e = /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/,
              n = new RegExp("(?:(" + e.source + "))([\\da-fA-F\\s]+)\\}", "g"),
              i = t.match(n),
              o = [];

          if (i) {
            var _iterator422 = _createForOfIteratorHelper(i),
                _step422;

            try {
              for (_iterator422.s(); !(_step422 = _iterator422.n()).done;) {
                var _t345 = _step422.value;

                var _n270 = !1;

                _t345.includes("\\pngblip") ? _n270 = "image/png" : _t345.includes("\\jpegblip") && (_n270 = "image/jpeg"), _n270 && o.push({
                  hex: _t345.replace(e, "").replace(/[^\da-fA-F]/g, ""),
                  type: _n270
                });
              }
            } catch (err) {
              _iterator422.e(err);
            } finally {
              _iterator422.f();
            }
          }

          return o;
        }(e), n);
      }

      function wA(t) {
        return btoa(t.match(/\w{2}/g).map(function (t) {
          return String.fromCharCode(parseInt(t, 16));
        }).join(""));
      }

      var AA = /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i,
          CA = /xmlns:o="urn:schemas-microsoft-com/i;

      var _A = /*#__PURE__*/function () {
        function _A(t) {
          _classCallCheck(this, _A);

          this.document = t;
        }

        _createClass(_A, [{
          key: "isActive",
          value: function isActive(t) {
            return AA.test(t) || CA.test(t);
          }
        }, {
          key: "execute",
          value: function execute(t) {
            var _t$_parsedData = t._parsedData,
                e = _t$_parsedData.body,
                n = _t$_parsedData.stylesString;
            uA(e, n), bA(e, t.dataTransfer.getData("text/rtf")), t.content = e;
          }
        }]);

        return _A;
      }();

      function vA(t) {
        return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, function (t, e) {
          return 1 === e.length ? " " : Array(e.length + 1).join("  ").substr(0, e.length);
        });
      }

      function yA(t, e) {
        var n = new DOMParser(),
            i = function (t) {
          return vA(vA(t)).replace(/(<span\s+style=['"]mso-spacerun:yes['"]>[^\S\r\n]*?)[\r\n]+([^\S\r\n]*<\/span>)/g, "$1$2").replace(/<span\s+style=['"]mso-spacerun:yes['"]><\/span>/g, "").replace(/ <\//g, " </").replace(/ <o:p><\/o:p>/g, " <o:p></o:p>").replace(/<o:p>(&nbsp;|\u00A0)<\/o:p>/g, "").replace(/>([^\S\r\n]*[\r\n]\s*)</g, "><");
        }(function (t) {
          var e = "</body>",
              n = "</html>",
              i = t.indexOf(e);
          if (i < 0) return t;
          var o = t.indexOf(n, i + e.length);
          return t.substring(0, i + e.length) + (o >= 0 ? t.substring(o) : "");
        }(t = t.replace(/<!--\[if gte vml 1]>/g, ""))),
            o = n.parseFromString(i, "text/html");

        !function (t) {
          t.querySelectorAll("span[style*=spacerun]").forEach(function (t) {
            var e = t.innerText.length || 0;
            t.innerHTML = Array(e + 1).join("  ").substr(0, e);
          });
        }(o);

        var r = o.body.innerHTML,
            s = function (t, e) {
          var n = new Jo(e),
              i = new us(n, {
            renderingMode: "data"
          }),
              o = t.createDocumentFragment(),
              r = t.body.childNodes;

          for (; r.length > 0;) {
            o.appendChild(r[0]);
          }

          return i.domToView(o, {
            skipComments: !0
          });
        }(o, e),
            a = function (t) {
          var e = [],
              n = [],
              i = Array.from(t.getElementsByTagName("style"));

          for (var _i223 = 0, _i222 = i; _i223 < _i222.length; _i223++) {
            var _t346 = _i222[_i223];
            _t346.sheet && _t346.sheet.cssRules && _t346.sheet.cssRules.length && (e.push(_t346.sheet), n.push(_t346.innerHTML));
          }

          return {
            styles: e,
            stylesString: n.join(" ")
          };
        }(o);

        return {
          body: s,
          bodyString: r,
          styles: a.styles,
          stylesString: a.stylesString
        };
      }

      var xA = /*#__PURE__*/function (_ue78) {
        _inherits(xA, _ue78);

        var _super197 = _createSuper(xA);

        function xA() {
          _classCallCheck(this, xA);

          return _super197.apply(this, arguments);
        }

        _createClass(xA, [{
          key: "init",
          value: function init() {
            var t = this.editor,
                e = t.editing.view.document,
                n = [];
            n.push(new _A(e)), n.push(new kA(e)), t.plugins.get("ClipboardPipeline").on("inputTransformation", function (t, i) {
              if (i._isTransformedWithPasteFromOffice) return;
              var o = i.dataTransfer.getData("text/html"),
                  r = n.find(function (t) {
                return t.isActive(o);
              });
              r && (i._parsedData = yA(o, e.stylesProcessor), r.execute(i), i._isTransformedWithPasteFromOffice = !0);
            }, {
              priority: "high"
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "PasteFromOffice";
          }
        }, {
          key: "requires",
          get: function get() {
            return [kp];
          }
        }]);

        return xA;
      }(ue);

      function EA(t, e, n, i) {
        var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
        e > o ? i.setAttribute(t, e, n) : i.removeAttribute(t, n);
      }

      function DA(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var i = t.createElement("tableCell", n);
        return t.insertElement("paragraph", i), t.insert(i, e), i;
      }

      function SA(t, e) {
        var n = e.parent.parent,
            i = parseInt(n.getAttribute("headingColumns") || 0),
            _t$getCellLocation = t.getCellLocation(e),
            o = _t$getCellLocation.column;

        return !!i && o < i;
      }

      function IA() {
        return function (t) {
          t.on("element:table", function (t, e, n) {
            var i = e.viewItem;
            if (!n.consumable.test(i, {
              name: !0
            })) return;

            var _ref78 = function (t) {
              var e = {
                headingRows: 0,
                headingColumns: 0
              },
                  n = [],
                  i = [];
              var o;

              for (var _i224 = 0, _Array$from7 = Array.from(t.getChildren()); _i224 < _Array$from7.length; _i224++) {
                var _r68 = _Array$from7[_i224];

                if ("tbody" === _r68.name || "thead" === _r68.name || "tfoot" === _r68.name) {
                  "thead" !== _r68.name || o || (o = _r68);

                  var _t347 = Array.from(_r68.getChildren()).filter(function (t) {
                    return t.is("element", "tr");
                  });

                  var _iterator423 = _createForOfIteratorHelper(_t347),
                      _step423;

                  try {
                    for (_iterator423.s(); !(_step423 = _iterator423.n()).done;) {
                      var _r69 = _step423.value;
                      if ("thead" === _r69.parent.name && _r69.parent === o) e.headingRows++, n.push(_r69);else {
                        i.push(_r69);

                        var _t348 = TA(_r69);

                        _t348 > e.headingColumns && (e.headingColumns = _t348);
                      }
                    }
                  } catch (err) {
                    _iterator423.e(err);
                  } finally {
                    _iterator423.f();
                  }
                }
              }

              return e.rows = [].concat(n, i), e;
            }(i),
                o = _ref78.rows,
                r = _ref78.headingRows,
                s = _ref78.headingColumns,
                a = {};

            s && (a.headingColumns = s), r && (a.headingRows = r);
            var c = n.writer.createElement("table", a);

            if (n.safeInsert(c, e.modelCursor)) {
              if (n.consumable.consume(i, {
                name: !0
              }), o.forEach(function (t) {
                return n.convertItem(t, n.writer.createPositionAt(c, "end"));
              }), n.convertChildren(i, n.writer.createPositionAt(c, "end")), c.isEmpty) {
                var _t349 = n.writer.createElement("tableRow");

                n.writer.insert(_t349, n.writer.createPositionAt(c, "end")), DA(n.writer, n.writer.createPositionAt(_t349, "end"));
              }

              n.updateConversionResult(c, e);
            }
          });
        };
      }

      function MA(t) {
        return function (e) {
          e.on("element:".concat(t), function (t, e, n) {
            if (e.modelRange && e.viewItem.isEmpty) {
              var _t350 = e.modelRange.start.nodeAfter,
                  _i225 = n.writer.createPositionAt(_t350, 0);

              n.writer.insertElement("paragraph", _i225);
            }
          }, {
            priority: "low"
          });
        };
      }

      function TA(t) {
        var e = 0,
            n = 0;
        var i = Array.from(t.getChildren()).filter(function (t) {
          return "th" === t.name || "td" === t.name;
        });

        for (; n < i.length && "th" === i[n].name;) {
          var _t351 = i[n];
          e += parseInt(_t351.getAttribute("colspan") || 1), n++;
        }

        return e;
      }

      var NA = /*#__PURE__*/function (_Symbol$iterator14) {
        function NA(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          _classCallCheck(this, NA);

          this._table = t, this._startRow = void 0 !== e.row ? e.row : e.startRow || 0, this._endRow = void 0 !== e.row ? e.row : e.endRow, this._startColumn = void 0 !== e.column ? e.column : e.startColumn || 0, this._endColumn = void 0 !== e.column ? e.column : e.endColumn, this._includeAllSlots = !!e.includeAllSlots, this._skipRows = new Set(), this._row = 0, this._rowIndex = 0, this._column = 0, this._cellIndex = 0, this._spannedCells = new Map(), this._nextCellAtColumn = -1;
        }

        _createClass(NA, [{
          key: _Symbol$iterator14,
          value: function value() {
            return this;
          }
        }, {
          key: "next",
          value: function next() {
            var t = this._table.getChild(this._rowIndex);

            if (!t || this._isOverEndRow()) return {
              done: !0
            };
            if (!t.is("element", "tableRow")) return this._rowIndex++, this.next();
            if (this._isOverEndColumn()) return this._advanceToNextRow();
            var e = null;

            var n = this._getSpanned();

            if (n) this._includeAllSlots && !this._shouldSkipSlot() && (e = this._formatOutValue(n.cell, n.row, n.column));else {
              var _n271 = t.getChild(this._cellIndex);

              if (!_n271) return this._advanceToNextRow();

              var _i226 = parseInt(_n271.getAttribute("colspan") || 1),
                  _o116 = parseInt(_n271.getAttribute("rowspan") || 1);

              (_i226 > 1 || _o116 > 1) && this._recordSpans(_n271, _o116, _i226), this._shouldSkipSlot() || (e = this._formatOutValue(_n271)), this._nextCellAtColumn = this._column + _i226;
            }
            return this._column++, this._column == this._nextCellAtColumn && this._cellIndex++, e || this.next();
          }
        }, {
          key: "skipRow",
          value: function skipRow(t) {
            this._skipRows.add(t);
          }
        }, {
          key: "_advanceToNextRow",
          value: function _advanceToNextRow() {
            return this._row++, this._rowIndex++, this._column = 0, this._cellIndex = 0, this._nextCellAtColumn = -1, this.next();
          }
        }, {
          key: "_isOverEndRow",
          value: function _isOverEndRow() {
            return void 0 !== this._endRow && this._row > this._endRow;
          }
        }, {
          key: "_isOverEndColumn",
          value: function _isOverEndColumn() {
            return void 0 !== this._endColumn && this._column > this._endColumn;
          }
        }, {
          key: "_formatOutValue",
          value: function _formatOutValue(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._row;
            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this._column;
            return {
              done: !1,
              value: new BA(this, t, e, n)
            };
          }
        }, {
          key: "_shouldSkipSlot",
          value: function _shouldSkipSlot() {
            var t = this._skipRows.has(this._row),
                e = this._row < this._startRow,
                n = this._column < this._startColumn,
                i = void 0 !== this._endColumn && this._column > this._endColumn;

            return t || e || n || i;
          }
        }, {
          key: "_getSpanned",
          value: function _getSpanned() {
            var t = this._spannedCells.get(this._row);

            return t && t.get(this._column) || null;
          }
        }, {
          key: "_recordSpans",
          value: function _recordSpans(t, e, n) {
            var i = {
              cell: t,
              row: this._row,
              column: this._column
            };

            for (var _t352 = this._row; _t352 < this._row + e; _t352++) {
              for (var _e315 = this._column; _e315 < this._column + n; _e315++) {
                _t352 == this._row && _e315 == this._column || this._markSpannedCell(_t352, _e315, i);
              }
            }
          }
        }, {
          key: "_markSpannedCell",
          value: function _markSpannedCell(t, e, n) {
            this._spannedCells.has(t) || this._spannedCells.set(t, new Map());

            this._spannedCells.get(t).set(e, n);
          }
        }]);

        return NA;
      }(Symbol.iterator);

      var BA = /*#__PURE__*/function () {
        function BA(t, e, n, i) {
          _classCallCheck(this, BA);

          this.cell = e, this.row = t._row, this.column = t._column, this.cellAnchorRow = n, this.cellAnchorColumn = i, this._cellIndex = t._cellIndex, this._rowIndex = t._rowIndex, this._table = t._table;
        }

        _createClass(BA, [{
          key: "isAnchor",
          get: function get() {
            return this.row === this.cellAnchorRow && this.column === this.cellAnchorColumn;
          }
        }, {
          key: "cellWidth",
          get: function get() {
            return parseInt(this.cell.getAttribute("colspan") || 1);
          }
        }, {
          key: "cellHeight",
          get: function get() {
            return parseInt(this.cell.getAttribute("rowspan") || 1);
          }
        }, {
          key: "rowIndex",
          get: function get() {
            return this._rowIndex;
          }
        }, {
          key: "getPositionBefore",
          value: function getPositionBefore() {
            return this._table.root.document.model.createPositionAt(this._table.getChild(this.row), this._cellIndex);
          }
        }]);

        return BA;
      }();

      function zA() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return function (e) {
          return e.on("insert:table", function (e, n, i) {
            var o = n.item;
            if (!i.consumable.consume(o, "insert")) return;
            i.consumable.consume(o, "attribute:headingRows:table"), i.consumable.consume(o, "attribute:headingColumns:table");
            var r = t && t.asWidget,
                s = i.writer.createContainerElement("figure", {
              class: "table"
            }),
                a = i.writer.createContainerElement("table");
            var c;
            var l, d;
            i.writer.insert(i.writer.createPositionAt(s, 0), a), r && (l = s, (d = i.writer).setCustomProperty("table", !0, l), c = xp(l, d, {
              hasSelectionHandle: !0
            }));
            var h = new NA(o),
                u = {
              headingRows: o.getAttribute("headingRows") || 0,
              headingColumns: o.getAttribute("headingColumns") || 0
            },
                g = new Map();

            var _iterator424 = _createForOfIteratorHelper(h),
                _step424;

            try {
              for (_iterator424.s(); !(_step424 = _iterator424.n()).done;) {
                var _e316 = _step424.value;

                var _n272 = _e316.row,
                    _r70 = _e316.cell,
                    _s40 = o.getChild(_n272),
                    _c12 = g.get(_n272) || jA(a, _s40, _n272, u, i);

                g.set(_n272, _c12), i.consumable.consume(_r70, "insert");
                OA(_e316, u, i.writer.createPositionAt(_c12, "end"), i, t);
              }
            } catch (err) {
              _iterator424.e(err);
            } finally {
              _iterator424.f();
            }

            var _iterator425 = _createForOfIteratorHelper(o.getChildren()),
                _step425;

            try {
              for (_iterator425.s(); !(_step425 = _iterator425.n()).done;) {
                var _t353 = _step425.value;
                var _e317 = _t353.index;
                _t353.is("element", "tableRow") && !g.has(_e317) && g.set(_e317, jA(a, _t353, _e317, u, i));
              }
            } catch (err) {
              _iterator425.e(err);
            } finally {
              _iterator425.f();
            }

            var m = i.mapper.toViewPosition(n.range.start);
            i.mapper.bindElements(o, r ? c : s), i.writer.insert(m, r ? c : s);
          });
        };
      }

      function PA(t, e) {
        var n = e.writer;
        if (t.parent.is("element", "tableCell")) return LA(t) ? n.createContainerElement("span", {
          class: "ck-table-bogus-paragraph"
        }) : n.createContainerElement("p");
      }

      function LA(t) {
        return 1 === t.parent.childCount && !HA(t);
      }

      function RA(t, e, n) {
        var i = t.cell,
            o = FA(t, e),
            r = n.mapper.toViewElement(i);
        r && r.name !== o && function (t, e, n) {
          var i = n.writer,
              o = n.mapper.toViewElement(t),
              r = Mp(i.createEditableElement(e, o.getAttributes()), i);
          i.insert(i.createPositionAfter(o), r), i.move(i.createRangeIn(o), i.createPositionAt(r, 0)), i.remove(i.createRangeOn(o)), n.mapper.unbindViewElement(o), n.mapper.bindElements(t, r);
        }(i, o, n);
      }

      function OA(t, e, n, i, o) {
        var r = o && o.asWidget,
            s = FA(t, e),
            a = r ? Mp(i.writer.createEditableElement(s), i.writer) : i.writer.createContainerElement(s),
            c = t.cell,
            l = c.getChild(0),
            d = 1 === c.childCount && "paragraph" === l.name;

        if (i.writer.insert(n, a), i.mapper.bindElements(c, a), !r && d && !HA(l)) {
          var _t354 = c.getChild(0);

          i.consumable.consume(_t354, "insert"), i.mapper.bindElements(_t354, a);
        }
      }

      function jA(t, e, n, i, o) {
        o.consumable.consume(e, "insert");
        var r = e.isEmpty ? o.writer.createEmptyElement("tr") : o.writer.createContainerElement("tr");
        o.mapper.bindElements(e, r);

        var s = i.headingRows,
            a = function (t, e, n) {
          var i = VA(t, e);
          return i || function (t, e, n) {
            var i = n.writer.createContainerElement(t),
                o = n.writer.createPositionAt(e, "tbody" == t ? "end" : 0);
            return n.writer.insert(o, i), i;
          }(t, e, n);
        }(function (t, e) {
          return t < e.headingRows ? "thead" : "tbody";
        }(n, i), t, o),
            c = s > 0 && n >= s ? n - s : n,
            l = o.writer.createPositionAt(a, c);

        return o.writer.insert(l, r), r;
      }

      function FA(t, e) {
        var n = t.row,
            i = t.column,
            o = e.headingColumns,
            r = e.headingRows;
        if (r && r > n) return "th";
        return o && o > i ? "th" : "td";
      }

      function VA(t, e) {
        var _iterator426 = _createForOfIteratorHelper(e.getChildren()),
            _step426;

        try {
          for (_iterator426.s(); !(_step426 = _iterator426.n()).done;) {
            var _n273 = _step426.value;
            if (_n273.name == t) return _n273;
          }
        } catch (err) {
          _iterator426.e(err);
        } finally {
          _iterator426.f();
        }
      }

      function UA(t, e, n) {
        var i = VA(t, e);
        i && 0 === i.childCount && n.writer.remove(n.writer.createRangeOn(i));
      }

      function HA(t) {
        return !!_toConsumableArray(t.getAttributeKeys()).length;
      }

      var qA = /*#__PURE__*/function (_me25) {
        _inherits(qA, _me25);

        var _super198 = _createSuper(qA);

        function qA() {
          _classCallCheck(this, qA);

          return _super198.apply(this, arguments);
        }

        _createClass(qA, [{
          key: "refresh",
          value: function refresh() {
            var t = this.editor.model,
                e = t.document.selection,
                n = t.schema;

            this.isEnabled = function (t, e) {
              var n = t.getFirstPosition().parent,
                  i = n === n.root ? n : n.parent;
              return e.checkChild(i, "table");
            }(e, n);
          }
        }, {
          key: "execute",
          value: function execute() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var e = this.editor.model,
                n = e.document.selection,
                i = this.editor.plugins.get("TableUtils"),
                o = this.editor.config.get("table"),
                r = Tp(n, e),
                s = o.defaultHeadings.rows,
                a = o.defaultHeadings.columns;
            void 0 === t.headingRows && s && (t.headingRows = s), void 0 === t.headingColumns && a && (t.headingColumns = a), e.change(function (n) {
              var o = i.createTable(n, t);
              e.insertContent(o, r), n.setSelection(n.createPositionAt(o.getNodeByPath([0, 0, 0]), 0));
            });
          }
        }]);

        return qA;
      }(me);

      function WA(t) {
        var e = [];

        var _iterator427 = _createForOfIteratorHelper(ZA(t.getRanges())),
            _step427;

        try {
          for (_iterator427.s(); !(_step427 = _iterator427.n()).done;) {
            var _n274 = _step427.value;

            var _t355 = _n274.getContainedElement();

            _t355 && _t355.is("element", "tableCell") && e.push(_t355);
          }
        } catch (err) {
          _iterator427.e(err);
        } finally {
          _iterator427.f();
        }

        return e;
      }

      function GA(t) {
        var e = [];

        var _iterator428 = _createForOfIteratorHelper(t.getRanges()),
            _step428;

        try {
          for (_iterator428.s(); !(_step428 = _iterator428.n()).done;) {
            var _n275 = _step428.value;

            var _t356 = _n275.start.findAncestor("tableCell");

            _t356 && e.push(_t356);
          }
        } catch (err) {
          _iterator428.e(err);
        } finally {
          _iterator428.f();
        }

        return e;
      }

      function $A(t) {
        var e = WA(t);
        return e.length ? e : GA(t);
      }

      function YA(t) {
        var e = t.map(function (t) {
          return t.parent.index;
        });
        return JA(e);
      }

      function KA(t) {
        var e = t[0].findAncestor("table");
        return JA(_toConsumableArray(new NA(e)).filter(function (e) {
          return t.includes(e.cell);
        }).map(function (t) {
          return t.column;
        }));
      }

      function QA(t, e) {
        if (t.length < 2 || !function (t) {
          var e = t[0].findAncestor("table"),
              n = YA(t),
              i = parseInt(e.getAttribute("headingRows") || 0);
          if (!tC(n, i)) return !1;
          var o = parseInt(e.getAttribute("headingColumns") || 0);
          return tC(KA(t), o);
        }(t)) return !1;
        var n = new Set(),
            i = new Set();
        var o = 0;

        var _iterator429 = _createForOfIteratorHelper(t),
            _step429;

        try {
          for (_iterator429.s(); !(_step429 = _iterator429.n()).done;) {
            var _r71 = _step429.value;

            var _e$getCellLocation = e.getCellLocation(_r71),
                _t357 = _e$getCellLocation.row,
                _s41 = _e$getCellLocation.column,
                _a24 = parseInt(_r71.getAttribute("rowspan") || 1),
                _c13 = parseInt(_r71.getAttribute("colspan") || 1);

            n.add(_t357), i.add(_s41), _a24 > 1 && n.add(_t357 + _a24 - 1), _c13 > 1 && i.add(_s41 + _c13 - 1), o += _a24 * _c13;
          }
        } catch (err) {
          _iterator429.e(err);
        } finally {
          _iterator429.f();
        }

        var r = function (t, e) {
          var n = Array.from(t.values()),
              i = Array.from(e.values()),
              o = Math.max.apply(Math, _toConsumableArray(n)),
              r = Math.min.apply(Math, _toConsumableArray(n)),
              s = Math.max.apply(Math, _toConsumableArray(i)),
              a = Math.min.apply(Math, _toConsumableArray(i));
          return (o - r + 1) * (s - a + 1);
        }(n, i);

        return r == o;
      }

      function ZA(t) {
        return Array.from(t).sort(XA);
      }

      function JA(t) {
        var e = t.sort(function (t, e) {
          return t - e;
        });
        return {
          first: e[0],
          last: e[e.length - 1]
        };
      }

      function XA(t, e) {
        var n = t.start,
            i = e.start;
        return n.isBefore(i) ? -1 : 1;
      }

      function tC(_ref79, n) {
        var t = _ref79.first,
            e = _ref79.last;
        return t < n === e < n;
      }

      var eC = /*#__PURE__*/function (_me26) {
        _inherits(eC, _me26);

        var _super199 = _createSuper(eC);

        function eC(t) {
          var _this295;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          _classCallCheck(this, eC);

          _this295 = _super199.call(this, t), _this295.order = e.order || "below";
          return _this295;
        }

        _createClass(eC, [{
          key: "refresh",
          value: function refresh() {
            var t = !!$A(this.editor.model.document.selection).length;
            this.isEnabled = t;
          }
        }, {
          key: "execute",
          value: function execute() {
            var t = this.editor,
                e = t.model.document.selection,
                n = t.plugins.get("TableUtils"),
                i = "above" === this.order,
                o = $A(e),
                r = YA(o),
                s = i ? r.first : r.last,
                a = o[0].findAncestor("table");
            n.insertRows(a, {
              at: i ? s : s + 1,
              copyStructureFromAbove: !i
            });
          }
        }]);

        return eC;
      }(me);

      var nC = /*#__PURE__*/function (_me27) {
        _inherits(nC, _me27);

        var _super200 = _createSuper(nC);

        function nC(t) {
          var _this296;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          _classCallCheck(this, nC);

          _this296 = _super200.call(this, t), _this296.order = e.order || "right";
          return _this296;
        }

        _createClass(nC, [{
          key: "refresh",
          value: function refresh() {
            var t = !!$A(this.editor.model.document.selection).length;
            this.isEnabled = t;
          }
        }, {
          key: "execute",
          value: function execute() {
            var t = this.editor,
                e = t.model.document.selection,
                n = t.plugins.get("TableUtils"),
                i = "left" === this.order,
                o = $A(e),
                r = KA(o),
                s = i ? r.first : r.last,
                a = o[0].findAncestor("table");
            n.insertColumns(a, {
              columns: 1,
              at: i ? s : s + 1
            });
          }
        }]);

        return nC;
      }(me);

      var iC = /*#__PURE__*/function (_me28) {
        _inherits(iC, _me28);

        var _super201 = _createSuper(iC);

        function iC(t) {
          var _this297;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          _classCallCheck(this, iC);

          _this297 = _super201.call(this, t), _this297.direction = e.direction || "horizontally";
          return _this297;
        }

        _createClass(iC, [{
          key: "refresh",
          value: function refresh() {
            var t = $A(this.editor.model.document.selection);
            this.isEnabled = 1 === t.length;
          }
        }, {
          key: "execute",
          value: function execute() {
            var t = $A(this.editor.model.document.selection)[0],
                e = "horizontally" === this.direction,
                n = this.editor.plugins.get("TableUtils");
            e ? n.splitCellHorizontally(t, 2) : n.splitCellVertically(t, 2);
          }
        }]);

        return iC;
      }(me);

      function oC(t, e, n) {
        var i = e.startRow,
            o = e.startColumn,
            r = e.endRow,
            s = e.endColumn,
            a = n.createElement("table"),
            c = r - i + 1;

        for (var _t358 = 0; _t358 < c; _t358++) {
          n.insertElement("tableRow", a, "end");
        }

        var l = _toConsumableArray(new NA(t, {
          startRow: i,
          endRow: r,
          startColumn: o,
          endColumn: s,
          includeAllSlots: !0
        }));

        var _iterator430 = _createForOfIteratorHelper(l),
            _step430;

        try {
          for (_iterator430.s(); !(_step430 = _iterator430.n()).done;) {
            var _step430$value = _step430.value,
                _t359 = _step430$value.row,
                _e318 = _step430$value.column,
                _c14 = _step430$value.cell,
                _d4 = _step430$value.isAnchor,
                _h4 = _step430$value.cellAnchorRow,
                _u2 = _step430$value.cellAnchorColumn;

            var _l7 = _t359 - i,
                _g4 = a.getChild(_l7);

            if (_d4) {
              var _i227 = n.cloneElement(_c14);

              n.append(_i227, _g4), lC(_i227, _t359, _e318, r, s, n);
            } else (_h4 < i || _u2 < o) && DA(n, n.createPositionAt(_g4, "end"));
          }
        } catch (err) {
          _iterator430.e(err);
        } finally {
          _iterator430.f();
        }

        return function (t, e, n, i, o) {
          var r = parseInt(e.getAttribute("headingRows") || 0);

          if (r > 0) {
            EA("headingRows", r - n, t, o, 0);
          }

          var s = parseInt(e.getAttribute("headingColumns") || 0);

          if (s > 0) {
            EA("headingColumns", s - i, t, o, 0);
          }
        }(a, t, i, o, n), a;
      }

      function rC(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var i = [],
            o = new NA(t, {
          startRow: n,
          endRow: e - 1
        });

        var _iterator431 = _createForOfIteratorHelper(o),
            _step431;

        try {
          for (_iterator431.s(); !(_step431 = _iterator431.n()).done;) {
            var _t360 = _step431.value;

            var _n276 = _t360.row,
                _o117 = _t360.cellHeight,
                _r72 = _n276 + _o117 - 1;

            _n276 < e && e <= _r72 && i.push(_t360);
          }
        } catch (err) {
          _iterator431.e(err);
        } finally {
          _iterator431.f();
        }

        return i;
      }

      function sC(t, e, n) {
        var i = t.parent,
            o = i.parent,
            r = i.index,
            s = e - r,
            a = {},
            c = parseInt(t.getAttribute("rowspan")) - s;
        c > 1 && (a.rowspan = c);
        var l = parseInt(t.getAttribute("colspan") || 1);
        l > 1 && (a.colspan = l);

        var d = r + s,
            h = _toConsumableArray(new NA(o, {
          startRow: r,
          endRow: d,
          includeAllSlots: !0
        }));

        var u,
            g = null;

        var _iterator432 = _createForOfIteratorHelper(h),
            _step432;

        try {
          for (_iterator432.s(); !(_step432 = _iterator432.n()).done;) {
            var _e319 = _step432.value;
            var _i228 = _e319.row,
                _o118 = _e319.column,
                _r73 = _e319.cell;
            _r73 === t && void 0 === u && (u = _o118), void 0 !== u && u === _o118 && _i228 === d && (g = DA(n, _e319.getPositionBefore(), a));
          }
        } catch (err) {
          _iterator432.e(err);
        } finally {
          _iterator432.f();
        }

        return EA("rowspan", s, t, n), g;
      }

      function aC(t, e) {
        var n = [],
            i = new NA(t);

        var _iterator433 = _createForOfIteratorHelper(i),
            _step433;

        try {
          for (_iterator433.s(); !(_step433 = _iterator433.n()).done;) {
            var _t361 = _step433.value;

            var _i229 = _t361.column,
                _o119 = _t361.cellWidth,
                _r74 = _i229 + _o119 - 1;

            _i229 < e && e <= _r74 && n.push(_t361);
          }
        } catch (err) {
          _iterator433.e(err);
        } finally {
          _iterator433.f();
        }

        return n;
      }

      function cC(t, e, n, i) {
        var o = n - e,
            r = {},
            s = parseInt(t.getAttribute("colspan")) - o;
        s > 1 && (r.colspan = s);
        var a = parseInt(t.getAttribute("rowspan") || 1);
        a > 1 && (r.rowspan = a);
        var c = DA(i, i.createPositionAfter(t), r);
        return EA("colspan", o, t, i), c;
      }

      function lC(t, e, n, i, o, r) {
        var s = parseInt(t.getAttribute("colspan") || 1),
            a = parseInt(t.getAttribute("rowspan") || 1);

        if (n + s - 1 > o) {
          EA("colspan", o - n + 1, t, r, 1);
        }

        if (e + a - 1 > i) {
          EA("rowspan", i - e + 1, t, r, 1);
        }
      }

      function dC(t, e) {
        var n = e.getColumns(t),
            i = new Array(n).fill(0);

        var _iterator434 = _createForOfIteratorHelper(new NA(t)),
            _step434;

        try {
          for (_iterator434.s(); !(_step434 = _iterator434.n()).done;) {
            var _e320 = _step434.value.column;
            i[_e320]++;
          }
        } catch (err) {
          _iterator434.e(err);
        } finally {
          _iterator434.f();
        }

        var o = i.reduce(function (t, e, n) {
          return e ? t : [].concat(_toConsumableArray(t), [n]);
        }, []);

        if (o.length > 0) {
          var _n277 = o[o.length - 1];
          return e.removeColumns(t, {
            at: _n277
          }), !0;
        }

        return !1;
      }

      function hC(t, e) {
        var n = [],
            i = e.getRows(t);

        for (var _e321 = 0; _e321 < i; _e321++) {
          t.getChild(_e321).isEmpty && n.push(_e321);
        }

        if (n.length > 0) {
          var _i230 = n[n.length - 1];
          return e.removeRows(t, {
            at: _i230
          }), !0;
        }

        return !1;
      }

      function uC(t, e) {
        dC(t, e) || hC(t, e);
      }

      function gC(t, e) {
        var n = Array.from(new NA(t, {
          startColumn: e.firstColumn,
          endColumn: e.lastColumn,
          row: e.lastRow
        }));
        if (n.every(function (_ref80) {
          var t = _ref80.cellHeight;
          return 1 === t;
        })) return e.lastRow;
        var i = n[0].cellHeight - 1;
        return e.lastRow + i;
      }

      function mC(t, e) {
        var n = Array.from(new NA(t, {
          startRow: e.firstRow,
          endRow: e.lastRow,
          column: e.lastColumn
        }));
        if (n.every(function (_ref81) {
          var t = _ref81.cellWidth;
          return 1 === t;
        })) return e.lastColumn;
        var i = n[0].cellWidth - 1;
        return e.lastColumn + i;
      }

      var pC = /*#__PURE__*/function (_me29) {
        _inherits(pC, _me29);

        var _super202 = _createSuper(pC);

        function pC(t, e) {
          var _this298;

          _classCallCheck(this, pC);

          _this298 = _super202.call(this, t), _this298.direction = e.direction, _this298.isHorizontal = "right" == _this298.direction || "left" == _this298.direction;
          return _this298;
        }

        _createClass(pC, [{
          key: "refresh",
          value: function refresh() {
            var t = this._getMergeableCell();

            this.value = t, this.isEnabled = !!t;
          }
        }, {
          key: "execute",
          value: function execute() {
            var _this299 = this;

            var t = this.editor.model,
                e = GA(t.document.selection)[0],
                n = this.value,
                i = this.direction;
            t.change(function (t) {
              var o = "right" == i || "down" == i,
                  r = o ? e : n,
                  s = o ? n : e,
                  a = s.parent;
              !function (t, e, n) {
                fC(t) || (fC(e) && n.remove(n.createRangeIn(e)), n.move(n.createRangeIn(t), n.createPositionAt(e, "end")));
                n.remove(t);
              }(s, r, t);
              var c = _this299.isHorizontal ? "colspan" : "rowspan",
                  l = parseInt(e.getAttribute(c) || 1),
                  d = parseInt(n.getAttribute(c) || 1);
              t.setAttribute(c, l + d, r), t.setSelection(t.createRangeIn(r));

              var h = _this299.editor.plugins.get("TableUtils");

              uC(a.findAncestor("table"), h);
            });
          }
        }, {
          key: "_getMergeableCell",
          value: function _getMergeableCell() {
            var t = GA(this.editor.model.document.selection)[0];
            if (!t) return;
            var e = this.editor.plugins.get("TableUtils"),
                n = this.isHorizontal ? function (t, e, n) {
              var i = t.parent.parent,
                  o = "right" == e ? t.nextSibling : t.previousSibling,
                  r = (i.getAttribute("headingColumns") || 0) > 0;
              if (!o) return;

              var s = "right" == e ? t : o,
                  a = "right" == e ? o : t,
                  _n$getCellLocation = n.getCellLocation(s),
                  c = _n$getCellLocation.column,
                  _n$getCellLocation2 = n.getCellLocation(a),
                  l = _n$getCellLocation2.column,
                  d = parseInt(s.getAttribute("colspan") || 1),
                  h = SA(n, s),
                  u = SA(n, a);

              if (r && h != u) return;
              return c + d === l ? o : void 0;
            }(t, this.direction, e) : function (t, e, n) {
              var i = t.parent,
                  o = i.parent,
                  r = o.getChildIndex(i);
              if ("down" == e && r === n.getRows(o) - 1 || "up" == e && 0 === r) return;
              var s = parseInt(t.getAttribute("rowspan") || 1),
                  a = o.getAttribute("headingRows") || 0,
                  c = "down" == e && r + s === a,
                  l = "up" == e && r === a;
              if (a && (c || l)) return;

              var d = parseInt(t.getAttribute("rowspan") || 1),
                  h = "down" == e ? r + d : r,
                  u = _toConsumableArray(new NA(o, {
                endRow: h
              })),
                  g = u.find(function (e) {
                return e.cell === t;
              }).column,
                  m = u.find(function (_ref82) {
                var t = _ref82.row,
                    n = _ref82.cellHeight,
                    i = _ref82.column;
                return i === g && ("down" == e ? t === h : h === t + n);
              });

              return m && m.cell;
            }(t, this.direction, e);
            if (!n) return;
            var i = this.isHorizontal ? "rowspan" : "colspan",
                o = parseInt(t.getAttribute(i) || 1);
            return parseInt(n.getAttribute(i) || 1) === o ? n : void 0;
          }
        }]);

        return pC;
      }(me);

      function fC(t) {
        return 1 == t.childCount && t.getChild(0).is("element", "paragraph") && t.getChild(0).isEmpty;
      }

      var kC = /*#__PURE__*/function (_me30) {
        _inherits(kC, _me30);

        var _super203 = _createSuper(kC);

        function kC() {
          _classCallCheck(this, kC);

          return _super203.apply(this, arguments);
        }

        _createClass(kC, [{
          key: "refresh",
          value: function refresh() {
            var t = $A(this.editor.model.document.selection),
                e = t[0];

            if (e) {
              var _n278 = e.findAncestor("table"),
                  _i231 = this.editor.plugins.get("TableUtils").getRows(_n278) - 1,
                  _o120 = YA(t),
                  _r75 = 0 === _o120.first && _o120.last === _i231;

              this.isEnabled = !_r75;
            } else this.isEnabled = !1;
          }
        }, {
          key: "execute",
          value: function execute() {
            var t = this.editor.model,
                e = this.editor.plugins.get("TableUtils"),
                n = $A(t.document.selection),
                i = YA(n),
                o = n[0],
                r = o.findAncestor("table"),
                s = e.getCellLocation(o).column;
            t.change(function (t) {
              var n = i.last - i.first + 1;
              e.removeRows(r, {
                at: i.first,
                rows: n
              });

              var o = function (t, e, n, i) {
                var o = t.getChild(Math.min(e, i - 1));
                var r = o.getChild(0),
                    s = 0;

                var _iterator435 = _createForOfIteratorHelper(o.getChildren()),
                    _step435;

                try {
                  for (_iterator435.s(); !(_step435 = _iterator435.n()).done;) {
                    var _t362 = _step435.value;
                    if (s > n) return r;
                    r = _t362, s += parseInt(_t362.getAttribute("colspan") || 1);
                  }
                } catch (err) {
                  _iterator435.e(err);
                } finally {
                  _iterator435.f();
                }

                return r;
              }(r, i.first, s, e.getRows(r));

              t.setSelection(t.createPositionAt(o, 0));
            });
          }
        }]);

        return kC;
      }(me);

      var bC = /*#__PURE__*/function (_me31) {
        _inherits(bC, _me31);

        var _super204 = _createSuper(bC);

        function bC() {
          _classCallCheck(this, bC);

          return _super204.apply(this, arguments);
        }

        _createClass(bC, [{
          key: "refresh",
          value: function refresh() {
            var t = $A(this.editor.model.document.selection),
                e = t[0];

            if (e) {
              var _n279 = e.findAncestor("table"),
                  _i232 = this.editor.plugins.get("TableUtils").getColumns(_n279),
                  _KA = KA(t),
                  _o121 = _KA.first,
                  _r76 = _KA.last;

              this.isEnabled = _r76 - _o121 < _i232 - 1;
            } else this.isEnabled = !1;
          }
        }, {
          key: "execute",
          value: function execute() {
            var _this300 = this;

            var _ref83 = function (t) {
              var e = $A(t),
                  n = e[0],
                  i = e.pop(),
                  o = [n, i];
              return n.isBefore(i) ? o : o.reverse();
            }(this.editor.model.document.selection),
                _ref84 = _slicedToArray(_ref83, 2),
                t = _ref84[0],
                e = _ref84[1],
                n = t.parent.parent,
                i = _toConsumableArray(new NA(n)),
                o = {
              first: i.find(function (e) {
                return e.cell === t;
              }).column,
              last: i.find(function (t) {
                return t.cell === e;
              }).column
            },
                r = function (t, e, n, i) {
              return parseInt(n.getAttribute("colspan") || 1) > 1 ? n : e.previousSibling || n.nextSibling ? n.nextSibling || e.previousSibling : i.first ? t.reverse().find(function (_ref85) {
                var t = _ref85.column;
                return t < i.first;
              }).cell : t.reverse().find(function (_ref86) {
                var t = _ref86.column;
                return t > i.last;
              }).cell;
            }(i, t, e, o);

            this.editor.model.change(function (t) {
              var e = o.last - o.first + 1;
              _this300.editor.plugins.get("TableUtils").removeColumns(n, {
                at: o.first,
                columns: e
              }), t.setSelection(t.createPositionAt(r, 0));
            });
          }
        }]);

        return bC;
      }(me);

      var wC = /*#__PURE__*/function (_me32) {
        _inherits(wC, _me32);

        var _super205 = _createSuper(wC);

        function wC() {
          _classCallCheck(this, wC);

          return _super205.apply(this, arguments);
        }

        _createClass(wC, [{
          key: "refresh",
          value: function refresh() {
            var _this301 = this;

            var t = $A(this.editor.model.document.selection),
                e = t.length > 0;
            this.isEnabled = e, this.value = e && t.every(function (t) {
              return _this301._isInHeading(t, t.parent.parent);
            });
          }
        }, {
          key: "execute",
          value: function execute() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (t.forceValue === this.value) return;

            var e = this.editor.model,
                n = $A(e.document.selection),
                i = n[0].findAncestor("table"),
                _YA = YA(n),
                o = _YA.first,
                r = _YA.last,
                s = this.value ? o : r + 1,
                a = i.getAttribute("headingRows") || 0;

            e.change(function (t) {
              if (s) {
                var _e322 = rC(i, s, s > a ? a : 0);

                var _iterator436 = _createForOfIteratorHelper(_e322),
                    _step436;

                try {
                  for (_iterator436.s(); !(_step436 = _iterator436.n()).done;) {
                    var _n280 = _step436.value.cell;
                    sC(_n280, s, t);
                  }
                } catch (err) {
                  _iterator436.e(err);
                } finally {
                  _iterator436.f();
                }
              }

              EA("headingRows", s, i, t, 0);
            });
          }
        }, {
          key: "_isInHeading",
          value: function _isInHeading(t, e) {
            var n = parseInt(e.getAttribute("headingRows") || 0);
            return !!n && t.parent.index < n;
          }
        }]);

        return wC;
      }(me);

      var AC = /*#__PURE__*/function (_me33) {
        _inherits(AC, _me33);

        var _super206 = _createSuper(AC);

        function AC() {
          _classCallCheck(this, AC);

          return _super206.apply(this, arguments);
        }

        _createClass(AC, [{
          key: "refresh",
          value: function refresh() {
            var t = $A(this.editor.model.document.selection),
                e = this.editor.plugins.get("TableUtils"),
                n = t.length > 0;
            this.isEnabled = n, this.value = n && t.every(function (t) {
              return SA(e, t);
            });
          }
        }, {
          key: "execute",
          value: function execute() {
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (t.forceValue === this.value) return;

            var e = this.editor.model,
                n = $A(e.document.selection),
                i = n[0].findAncestor("table"),
                _KA2 = KA(n),
                o = _KA2.first,
                r = _KA2.last,
                s = this.value ? o : r + 1;

            e.change(function (t) {
              if (s) {
                var _e323 = aC(i, s);

                var _iterator437 = _createForOfIteratorHelper(_e323),
                    _step437;

                try {
                  for (_iterator437.s(); !(_step437 = _iterator437.n()).done;) {
                    var _step437$value = _step437.value,
                        _n281 = _step437$value.cell,
                        _i233 = _step437$value.column;
                    cC(_n281, _i233, s, t);
                  }
                } catch (err) {
                  _iterator437.e(err);
                } finally {
                  _iterator437.f();
                }
              }

              EA("headingColumns", s, i, t, 0);
            });
          }
        }]);

        return AC;
      }(me);

      var CC = /*#__PURE__*/function (_ue79) {
        _inherits(CC, _ue79);

        var _super207 = _createSuper(CC);

        function CC() {
          _classCallCheck(this, CC);

          return _super207.apply(this, arguments);
        }

        _createClass(CC, [{
          key: "init",
          value: function init() {
            this.decorate("insertColumns"), this.decorate("insertRows");
          }
        }, {
          key: "getCellLocation",
          value: function getCellLocation(t) {
            var e = t.parent,
                n = e.parent,
                i = n.getChildIndex(e),
                o = new NA(n, {
              row: i
            });

            var _iterator438 = _createForOfIteratorHelper(o),
                _step438;

            try {
              for (_iterator438.s(); !(_step438 = _iterator438.n()).done;) {
                var _step438$value = _step438.value,
                    _e324 = _step438$value.cell,
                    _n282 = _step438$value.row,
                    _i234 = _step438$value.column;
                if (_e324 === t) return {
                  row: _n282,
                  column: _i234
                };
              }
            } catch (err) {
              _iterator438.e(err);
            } finally {
              _iterator438.f();
            }
          }
        }, {
          key: "createTable",
          value: function createTable(t, e) {
            var n = t.createElement("table"),
                i = parseInt(e.rows) || 2,
                o = parseInt(e.columns) || 2;
            return _C(t, n, 0, i, o), e.headingRows && EA("headingRows", Math.min(e.headingRows, i), n, t, 0), e.headingColumns && EA("headingColumns", Math.min(e.headingColumns, o), n, t, 0), n;
          }
        }, {
          key: "insertRows",
          value: function insertRows(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var n = this.editor.model,
                i = e.at || 0,
                o = e.rows || 1,
                r = void 0 !== e.copyStructureFromAbove,
                s = e.copyStructureFromAbove ? i - 1 : i,
                c = this.getRows(t),
                l = this.getColumns(t);
            if (i > c) throw new a("tableutils-insertrows-insert-out-of-range", this, {
              options: e
            });
            n.change(function (e) {
              var n = t.getAttribute("headingRows") || 0;
              if (n > i && EA("headingRows", n + o, t, e, 0), !r && (0 === i || i === c)) return void _C(e, t, i, o, l);
              var a = r ? Math.max(i, s) : i,
                  d = new NA(t, {
                endRow: a
              }),
                  h = new Array(l).fill(1);

              var _iterator439 = _createForOfIteratorHelper(d),
                  _step439;

              try {
                for (_iterator439.s(); !(_step439 = _iterator439.n()).done;) {
                  var _step439$value = _step439.value,
                      _t364 = _step439$value.row,
                      _n285 = _step439$value.column,
                      _a25 = _step439$value.cellHeight,
                      _c15 = _step439$value.cellWidth,
                      _l8 = _step439$value.cell;

                  var _d5 = _t364 + _a25 - 1,
                      _u3 = _t364 <= s && s <= _d5;

                  _t364 < i && i <= _d5 ? (e.setAttribute("rowspan", _a25 + o, _l8), h[_n285] = -_c15) : r && _u3 && (h[_n285] = _c15);
                }
              } catch (err) {
                _iterator439.e(err);
              } finally {
                _iterator439.f();
              }

              for (var _n283 = 0; _n283 < o; _n283++) {
                var _n284 = e.createElement("tableRow");

                e.insert(_n284, t, i);

                for (var _t363 = 0; _t363 < h.length; _t363++) {
                  var _i235 = h[_t363],
                      _o122 = e.createPositionAt(_n284, "end");

                  _i235 > 0 && DA(e, _o122, _i235 > 1 ? {
                    colspan: _i235
                  } : null), _t363 += Math.abs(_i235) - 1;
                }
              }
            });
          }
        }, {
          key: "insertColumns",
          value: function insertColumns(t) {
            var _this302 = this;

            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var n = this.editor.model,
                i = e.at || 0,
                o = e.columns || 1;
            n.change(function (e) {
              var n = t.getAttribute("headingColumns");
              i < n && e.setAttribute("headingColumns", n + o, t);

              var r = _this302.getColumns(t);

              if (0 === i || r === i) {
                var _iterator440 = _createForOfIteratorHelper(t.getChildren()),
                    _step440;

                try {
                  for (_iterator440.s(); !(_step440 = _iterator440.n()).done;) {
                    var _n286 = _step440.value;
                    _n286.is("element", "tableRow") && vC(o, e, e.createPositionAt(_n286, i ? "end" : 0));
                  }
                } catch (err) {
                  _iterator440.e(err);
                } finally {
                  _iterator440.f();
                }

                return;
              }

              var s = new NA(t, {
                column: i,
                includeAllSlots: !0
              });

              var _iterator441 = _createForOfIteratorHelper(s),
                  _step441;

              try {
                for (_iterator441.s(); !(_step441 = _iterator441.n()).done;) {
                  var _t365 = _step441.value;
                  var _n287 = _t365.row,
                      _r77 = _t365.cell,
                      _a26 = _t365.cellAnchorColumn,
                      _c16 = _t365.cellAnchorRow,
                      _l9 = _t365.cellWidth,
                      _d6 = _t365.cellHeight;

                  if (_a26 < i) {
                    e.setAttribute("colspan", _l9 + o, _r77);

                    var _t366 = _c16 + _d6 - 1;

                    for (var _e325 = _n287; _e325 <= _t366; _e325++) {
                      s.skipRow(_e325);
                    }
                  } else vC(o, e, _t365.getPositionBefore());
                }
              } catch (err) {
                _iterator441.e(err);
              } finally {
                _iterator441.f();
              }
            });
          }
        }, {
          key: "removeRows",
          value: function removeRows(t, e) {
            var _this303 = this;

            var n = this.editor.model,
                i = e.rows || 1,
                o = this.getRows(t),
                r = e.at,
                s = r + i - 1;
            if (s > o - 1) throw new a("tableutils-removerows-row-index-out-of-range", this, {
              table: t,
              options: e
            });
            n.change(function (e) {
              var _ref87 = function (t, e, n) {
                var i = new Map(),
                    o = [];

                var _iterator442 = _createForOfIteratorHelper(new NA(t, {
                  endRow: n
                })),
                    _step442;

                try {
                  for (_iterator442.s(); !(_step442 = _iterator442.n()).done;) {
                    var _step442$value = _step442.value,
                        _r78 = _step442$value.row,
                        _s42 = _step442$value.column,
                        _a27 = _step442$value.cellHeight,
                        _c17 = _step442$value.cell;

                    var _t367 = _r78 + _a27 - 1;

                    if (_r78 >= e && _r78 <= n && _t367 > n) {
                      var _t368 = _a27 - (n - _r78 + 1);

                      i.set(_s42, {
                        cell: _c17,
                        rowspan: _t368
                      });
                    }

                    if (_r78 < e && _t367 >= e) {
                      var _i236 = void 0;

                      _i236 = _t367 >= n ? n - e + 1 : _t367 - e + 1, o.push({
                        cell: _c17,
                        rowspan: _a27 - _i236
                      });
                    }
                  }
                } catch (err) {
                  _iterator442.e(err);
                } finally {
                  _iterator442.f();
                }

                return {
                  cellsToMove: i,
                  cellsToTrim: o
                };
              }(t, r, s),
                  n = _ref87.cellsToMove,
                  i = _ref87.cellsToTrim;

              if (n.size) {
                !function (t, e, n, i) {
                  var o = _toConsumableArray(new NA(t, {
                    includeAllSlots: !0,
                    row: e
                  })),
                      r = t.getChild(e);

                  var s;

                  var _iterator443 = _createForOfIteratorHelper(o),
                      _step443;

                  try {
                    for (_iterator443.s(); !(_step443 = _iterator443.n()).done;) {
                      var _step443$value = _step443.value,
                          _t369 = _step443$value.column,
                          _e326 = _step443$value.cell,
                          _a28 = _step443$value.isAnchor;

                      if (n.has(_t369)) {
                        var _n$get = n.get(_t369),
                            _e327 = _n$get.cell,
                            _o123 = _n$get.rowspan,
                            _a29 = s ? i.createPositionAfter(s) : i.createPositionAt(r, 0);

                        i.move(i.createRangeOn(_e327), _a29), EA("rowspan", _o123, _e327, i), s = _e327;
                      } else _a28 && (s = _e326);
                    }
                  } catch (err) {
                    _iterator443.e(err);
                  } finally {
                    _iterator443.f();
                  }
                }(t, s + 1, n, e);
              }

              for (var _n288 = s; _n288 >= r; _n288--) {
                e.remove(t.getChild(_n288));
              }

              var _iterator444 = _createForOfIteratorHelper(i),
                  _step444;

              try {
                for (_iterator444.s(); !(_step444 = _iterator444.n()).done;) {
                  var _step444$value = _step444.value,
                      _t370 = _step444$value.rowspan,
                      _n289 = _step444$value.cell;
                  EA("rowspan", _t370, _n289, e);
                }
              } catch (err) {
                _iterator444.e(err);
              } finally {
                _iterator444.f();
              }

              !function (t, e, n, i) {
                var o = t.getAttribute("headingRows") || 0;

                if (e < o) {
                  EA("headingRows", n < o ? o - (n - e + 1) : e, t, i, 0);
                }
              }(t, r, s, e), dC(t, _this303) || hC(t, _this303);
            });
          }
        }, {
          key: "removeColumns",
          value: function removeColumns(t, e) {
            var _this304 = this;

            var n = this.editor.model,
                i = e.at,
                o = e.columns || 1,
                r = e.at + o - 1;
            n.change(function (e) {
              !function (t, e, n) {
                var i = t.getAttribute("headingColumns") || 0;

                if (i && e.first < i) {
                  var _o124 = Math.min(i - 1, e.last) - e.first + 1;

                  n.setAttribute("headingColumns", i - _o124, t);
                }
              }(t, {
                first: i,
                last: r
              }, e);

              for (var _n290 = r; _n290 >= i; _n290--) {
                for (var _i237 = 0, _arr3 = _toConsumableArray(new NA(t)); _i237 < _arr3.length; _i237++) {
                  var _arr3$_i = _arr3[_i237],
                      _i238 = _arr3$_i.cell,
                      _o125 = _arr3$_i.column,
                      _r79 = _arr3$_i.cellWidth;
                  _o125 <= _n290 && _r79 > 1 && _o125 + _r79 > _n290 ? EA("colspan", _r79 - 1, _i238, e) : _o125 === _n290 && e.remove(_i238);
                }
              }

              hC(t, _this304) || dC(t, _this304);
            });
          }
        }, {
          key: "splitCellVertically",
          value: function splitCellVertically(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
            var n = this.editor.model,
                i = t.parent.parent,
                o = parseInt(t.getAttribute("rowspan") || 1),
                r = parseInt(t.getAttribute("colspan") || 1);
            n.change(function (n) {
              if (r > 1) {
                var _yC = yC(r, e),
                    _i239 = _yC.newCellsSpan,
                    _s43 = _yC.updatedSpan;

                EA("colspan", _s43, t, n);
                var _a30 = {};
                _i239 > 1 && (_a30.colspan = _i239), o > 1 && (_a30.rowspan = o);
                vC(r > e ? e - 1 : r - 1, n, n.createPositionAfter(t), _a30);
              }

              if (r < e) {
                var _s44 = e - r,
                    _a31 = _toConsumableArray(new NA(i)),
                    _a31$find = _a31.find(function (_ref88) {
                  var e = _ref88.cell;
                  return e === t;
                }),
                    _c18 = _a31$find.column,
                    _l10 = _a31.filter(function (_ref89) {
                  var e = _ref89.cell,
                      n = _ref89.cellWidth,
                      i = _ref89.column;
                  return e !== t && i === _c18 || i < _c18 && i + n > _c18;
                });

                var _iterator445 = _createForOfIteratorHelper(_l10),
                    _step445;

                try {
                  for (_iterator445.s(); !(_step445 = _iterator445.n()).done;) {
                    var _step445$value = _step445.value,
                        _t371 = _step445$value.cell,
                        _e328 = _step445$value.cellWidth;
                    n.setAttribute("colspan", _e328 + _s44, _t371);
                  }
                } catch (err) {
                  _iterator445.e(err);
                } finally {
                  _iterator445.f();
                }

                var _d7 = {};
                o > 1 && (_d7.rowspan = o), vC(_s44, n, n.createPositionAfter(t), _d7);

                var _h5 = i.getAttribute("headingColumns") || 0;

                _h5 > _c18 && EA("headingColumns", _h5 + _s44, i, n);
              }
            });
          }
        }, {
          key: "splitCellHorizontally",
          value: function splitCellHorizontally(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
            var n = this.editor.model,
                i = t.parent,
                o = i.parent,
                r = o.getChildIndex(i),
                s = parseInt(t.getAttribute("rowspan") || 1),
                a = parseInt(t.getAttribute("colspan") || 1);
            n.change(function (n) {
              if (s > 1) {
                var _i240 = _toConsumableArray(new NA(o, {
                  startRow: r,
                  endRow: r + s - 1,
                  includeAllSlots: !0
                })),
                    _yC2 = yC(s, e),
                    _c19 = _yC2.newCellsSpan,
                    _l11 = _yC2.updatedSpan;

                EA("rowspan", _l11, t, n);

                var _i240$find = _i240.find(function (_ref90) {
                  var e = _ref90.cell;
                  return e === t;
                }),
                    _d8 = _i240$find.column,
                    _h6 = {};

                _c19 > 1 && (_h6.rowspan = _c19), a > 1 && (_h6.colspan = a);

                for (var _i242 = 0, _i241 = _i240; _i242 < _i241.length; _i242++) {
                  var _t372 = _i241[_i242];

                  var _e329 = _t372.column,
                      _i243 = _t372.row,
                      _o126 = _e329 === _d8,
                      _s45 = (_i243 + r + _l11) % _c19 == 0;

                  _i243 >= r + _l11 && _o126 && _s45 && vC(1, n, _t372.getPositionBefore(), _h6);
                }
              }

              if (s < e) {
                var _i244 = e - s,
                    _c20 = _toConsumableArray(new NA(o, {
                  startRow: 0,
                  endRow: r
                }));

                var _iterator446 = _createForOfIteratorHelper(_c20),
                    _step446;

                try {
                  for (_iterator446.s(); !(_step446 = _iterator446.n()).done;) {
                    var _step446$value = _step446.value,
                        _e330 = _step446$value.cell,
                        _o127 = _step446$value.cellHeight,
                        _s46 = _step446$value.row;

                    if (_e330 !== t && _s46 + _o127 > r) {
                      var _t373 = _o127 + _i244;

                      n.setAttribute("rowspan", _t373, _e330);
                    }
                  }
                } catch (err) {
                  _iterator446.e(err);
                } finally {
                  _iterator446.f();
                }

                var _l12 = {};
                a > 1 && (_l12.colspan = a), _C(n, o, r + 1, _i244, 1, _l12);

                var _d9 = o.getAttribute("headingRows") || 0;

                _d9 > r && EA("headingRows", _d9 + _i244, o, n);
              }
            });
          }
        }, {
          key: "getColumns",
          value: function getColumns(t) {
            return _toConsumableArray(t.getChild(0).getChildren()).reduce(function (t, e) {
              return t + parseInt(e.getAttribute("colspan") || 1);
            }, 0);
          }
        }, {
          key: "getRows",
          value: function getRows(t) {
            return Array.from(t.getChildren()).reduce(function (t, e) {
              return e.is("element", "tableRow") ? t + 1 : t;
            }, 0);
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "TableUtils";
          }
        }]);

        return CC;
      }(ue);

      function _C(t, e, n, i, o) {
        var r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

        for (var _s47 = 0; _s47 < i; _s47++) {
          var _i245 = t.createElement("tableRow");

          t.insert(_i245, e, n), vC(o, t, t.createPositionAt(_i245, "end"), r);
        }
      }

      function vC(t, e, n) {
        var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

        for (var _o128 = 0; _o128 < t; _o128++) {
          DA(e, n, i);
        }
      }

      function yC(t, e) {
        if (t < e) return {
          newCellsSpan: 1,
          updatedSpan: 1
        };
        var n = Math.floor(t / e);
        return {
          newCellsSpan: n,
          updatedSpan: t - n * e + n
        };
      }

      var xC = /*#__PURE__*/function (_me34) {
        _inherits(xC, _me34);

        var _super208 = _createSuper(xC);

        function xC() {
          _classCallCheck(this, xC);

          return _super208.apply(this, arguments);
        }

        _createClass(xC, [{
          key: "refresh",
          value: function refresh() {
            var t = WA(this.editor.model.document.selection);
            this.isEnabled = QA(t, this.editor.plugins.get(CC));
          }
        }, {
          key: "execute",
          value: function execute() {
            var t = this.editor.model,
                e = this.editor.plugins.get(CC);
            t.change(function (n) {
              var i = WA(t.document.selection),
                  o = i.shift(),
                  _ref91 = function (t, e, n) {
                var i = 0,
                    o = 0;

                var _iterator447 = _createForOfIteratorHelper(e),
                    _step447;

                try {
                  for (_iterator447.s(); !(_step447 = _iterator447.n()).done;) {
                    var _t374 = _step447.value;

                    var _n$getCellLocation4 = n.getCellLocation(_t374),
                        _e331 = _n$getCellLocation4.row,
                        _r80 = _n$getCellLocation4.column;

                    i = SC(_t374, _r80, i, "colspan"), o = SC(_t374, _e331, o, "rowspan");
                  }
                } catch (err) {
                  _iterator447.e(err);
                } finally {
                  _iterator447.f();
                }

                var _n$getCellLocation3 = n.getCellLocation(t),
                    r = _n$getCellLocation3.row,
                    s = _n$getCellLocation3.column;

                return {
                  mergeWidth: i - s,
                  mergeHeight: o - r
                };
              }(o, i, e),
                  r = _ref91.mergeWidth,
                  s = _ref91.mergeHeight;

              EA("colspan", r, o, n), EA("rowspan", s, o, n);

              var _iterator448 = _createForOfIteratorHelper(i),
                  _step448;

              try {
                for (_iterator448.s(); !(_step448 = _iterator448.n()).done;) {
                  var _t375 = _step448.value;
                  EC(_t375, o, n);
                }
              } catch (err) {
                _iterator448.e(err);
              } finally {
                _iterator448.f();
              }

              uC(o.findAncestor("table"), e), n.setSelection(o, "in");
            });
          }
        }]);

        return xC;
      }(me);

      function EC(t, e, n) {
        DC(t) || (DC(e) && n.remove(n.createRangeIn(e)), n.move(n.createRangeIn(t), n.createPositionAt(e, "end"))), n.remove(t);
      }

      function DC(t) {
        return 1 == t.childCount && t.getChild(0).is("element", "paragraph") && t.getChild(0).isEmpty;
      }

      function SC(t, e, n, i) {
        var o = parseInt(t.getAttribute(i) || 1);
        return Math.max(n, e + o);
      }

      var IC = /*#__PURE__*/function (_me35) {
        _inherits(IC, _me35);

        var _super209 = _createSuper(IC);

        function IC(t) {
          var _this305;

          _classCallCheck(this, IC);

          _this305 = _super209.call(this, t), _this305.affectsData = !1;
          return _this305;
        }

        _createClass(IC, [{
          key: "refresh",
          value: function refresh() {
            var t = $A(this.editor.model.document.selection);
            this.isEnabled = t.length > 0;
          }
        }, {
          key: "execute",
          value: function execute() {
            var t = this.editor.model,
                e = $A(t.document.selection),
                n = YA(e),
                i = e[0].findAncestor("table"),
                o = [];

            for (var _e332 = n.first; _e332 <= n.last; _e332++) {
              var _iterator449 = _createForOfIteratorHelper(i.getChild(_e332).getChildren()),
                  _step449;

              try {
                for (_iterator449.s(); !(_step449 = _iterator449.n()).done;) {
                  var _n291 = _step449.value;
                  o.push(t.createRangeOn(_n291));
                }
              } catch (err) {
                _iterator449.e(err);
              } finally {
                _iterator449.f();
              }
            }

            t.change(function (t) {
              t.setSelection(o);
            });
          }
        }]);

        return IC;
      }(me);

      var MC = /*#__PURE__*/function (_me36) {
        _inherits(MC, _me36);

        var _super210 = _createSuper(MC);

        function MC(t) {
          var _this306;

          _classCallCheck(this, MC);

          _this306 = _super210.call(this, t), _this306.affectsData = !1;
          return _this306;
        }

        _createClass(MC, [{
          key: "refresh",
          value: function refresh() {
            var t = $A(this.editor.model.document.selection);
            this.isEnabled = t.length > 0;
          }
        }, {
          key: "execute",
          value: function execute() {
            var t = this.editor.model,
                e = $A(t.document.selection),
                n = e[0],
                i = e.pop(),
                o = n.findAncestor("table"),
                r = this.editor.plugins.get("TableUtils"),
                s = r.getCellLocation(n),
                a = r.getCellLocation(i),
                c = Math.min(s.column, a.column),
                l = Math.max(s.column, a.column),
                d = [];

            var _iterator450 = _createForOfIteratorHelper(new NA(o, {
              startColumn: c,
              endColumn: l
            })),
                _step450;

            try {
              for (_iterator450.s(); !(_step450 = _iterator450.n()).done;) {
                var _e333 = _step450.value;
                d.push(t.createRangeOn(_e333.cell));
              }
            } catch (err) {
              _iterator450.e(err);
            } finally {
              _iterator450.f();
            }

            t.change(function (t) {
              t.setSelection(d);
            });
          }
        }]);

        return MC;
      }(me);

      function TC(t) {
        t.document.registerPostFixer(function (e) {
          return function (t, e) {
            var n = e.document.differ.getChanges();
            var i = !1;
            var o = new Set();

            var _iterator451 = _createForOfIteratorHelper(n),
                _step451;

            try {
              for (_iterator451.s(); !(_step451 = _iterator451.n()).done;) {
                var _e334 = _step451.value;

                var _n292 = void 0;

                "table" == _e334.name && "insert" == _e334.type && (_n292 = _e334.position.nodeAfter), "tableRow" != _e334.name && "tableCell" != _e334.name || (_n292 = _e334.position.findAncestor("table")), zC(_e334) && (_n292 = _e334.range.start.findAncestor("table")), _n292 && !o.has(_n292) && (i = NC(_n292, t) || i, i = BC(_n292, t) || i, o.add(_n292));
              }
            } catch (err) {
              _iterator451.e(err);
            } finally {
              _iterator451.f();
            }

            return i;
          }(e, t);
        });
      }

      function NC(t, e) {
        var n = !1;

        var i = function (t) {
          var e = parseInt(t.getAttribute("headingRows") || 0),
              n = Array.from(t.getChildren()).reduce(function (t, e) {
            return e.is("element", "tableRow") ? t + 1 : t;
          }, 0),
              i = [];

          var _iterator452 = _createForOfIteratorHelper(new NA(t)),
              _step452;

          try {
            for (_iterator452.s(); !(_step452 = _iterator452.n()).done;) {
              var _step452$value = _step452.value,
                  _o129 = _step452$value.row,
                  _r81 = _step452$value.cell,
                  _s48 = _step452$value.cellHeight;
              if (_s48 < 2) continue;

              var _t376 = _o129 < e ? e : n;

              if (_o129 + _s48 > _t376) {
                var _e335 = _t376 - _o129;

                i.push({
                  cell: _r81,
                  rowspan: _e335
                });
              }
            }
          } catch (err) {
            _iterator452.e(err);
          } finally {
            _iterator452.f();
          }

          return i;
        }(t);

        if (i.length) {
          n = !0;

          var _iterator453 = _createForOfIteratorHelper(i),
              _step453;

          try {
            for (_iterator453.s(); !(_step453 = _iterator453.n()).done;) {
              var _t377 = _step453.value;
              EA("rowspan", _t377.rowspan, _t377.cell, e, 1);
            }
          } catch (err) {
            _iterator453.e(err);
          } finally {
            _iterator453.f();
          }
        }

        return n;
      }

      function BC(t, e) {
        var n = !1;

        var i = function (t) {
          var e = new Array(t.childCount).fill(0);

          var _iterator454 = _createForOfIteratorHelper(new NA(t, {
            includeAllSlots: !0
          })),
              _step454;

          try {
            for (_iterator454.s(); !(_step454 = _iterator454.n()).done;) {
              var _n293 = _step454.value.rowIndex;
              e[_n293]++;
            }
          } catch (err) {
            _iterator454.e(err);
          } finally {
            _iterator454.f();
          }

          return e;
        }(t),
            o = [];

        var _iterator455 = _createForOfIteratorHelper(i.entries()),
            _step455;

        try {
          for (_iterator455.s(); !(_step455 = _iterator455.n()).done;) {
            var _step455$value = _slicedToArray(_step455.value, 2),
                _e336 = _step455$value[0],
                _n296 = _step455$value[1];

            !_n296 && t.getChild(_e336).is("element", "tableRow") && o.push(_e336);
          }
        } catch (err) {
          _iterator455.e(err);
        } finally {
          _iterator455.f();
        }

        if (o.length) {
          n = !0;

          var _iterator456 = _createForOfIteratorHelper(o.reverse()),
              _step456;

          try {
            for (_iterator456.s(); !(_step456 = _iterator456.n()).done;) {
              var _n294 = _step456.value;
              e.remove(t.getChild(_n294)), i.splice(_n294, 1);
            }
          } catch (err) {
            _iterator456.e(err);
          } finally {
            _iterator456.f();
          }
        }

        var r = i.filter(function (e, n) {
          return t.getChild(n).is("element", "tableRow");
        }),
            s = r[0];

        if (!r.every(function (t) {
          return t === s;
        })) {
          var _i246 = r.reduce(function (t, e) {
            return e > t ? e : t;
          }, 0);

          var _iterator457 = _createForOfIteratorHelper(r.entries()),
              _step457;

          try {
            for (_iterator457.s(); !(_step457 = _iterator457.n()).done;) {
              var _step457$value = _slicedToArray(_step457.value, 2),
                  _o130 = _step457$value[0],
                  _s49 = _step457$value[1];

              var _r82 = _i246 - _s49;

              if (_r82) {
                for (var _n295 = 0; _n295 < _r82; _n295++) {
                  DA(e, e.createPositionAt(t.getChild(_o130), "end"));
                }

                n = !0;
              }
            }
          } catch (err) {
            _iterator457.e(err);
          } finally {
            _iterator457.f();
          }
        }

        return n;
      }

      function zC(t) {
        var e = "attribute" === t.type,
            n = t.attributeKey;
        return e && ("headingRows" === n || "colspan" === n || "rowspan" === n);
      }

      function PC(t) {
        t.document.registerPostFixer(function (e) {
          return function (t, e) {
            var n = e.document.differ.getChanges();
            var i = !1;

            var _iterator458 = _createForOfIteratorHelper(n),
                _step458;

            try {
              for (_iterator458.s(); !(_step458 = _iterator458.n()).done;) {
                var _e337 = _step458.value;
                "insert" == _e337.type && "table" == _e337.name && (i = LC(_e337.position.nodeAfter, t) || i), "insert" == _e337.type && "tableRow" == _e337.name && (i = RC(_e337.position.nodeAfter, t) || i), "insert" == _e337.type && "tableCell" == _e337.name && (i = OC(_e337.position.nodeAfter, t) || i), jC(_e337) && (i = OC(_e337.position.parent, t) || i);
              }
            } catch (err) {
              _iterator458.e(err);
            } finally {
              _iterator458.f();
            }

            return i;
          }(e, t);
        });
      }

      function LC(t, e) {
        var n = !1;

        var _iterator459 = _createForOfIteratorHelper(t.getChildren()),
            _step459;

        try {
          for (_iterator459.s(); !(_step459 = _iterator459.n()).done;) {
            var _i247 = _step459.value;
            _i247.is("element", "tableRow") && (n = RC(_i247, e) || n);
          }
        } catch (err) {
          _iterator459.e(err);
        } finally {
          _iterator459.f();
        }

        return n;
      }

      function RC(t, e) {
        var n = !1;

        var _iterator460 = _createForOfIteratorHelper(t.getChildren()),
            _step460;

        try {
          for (_iterator460.s(); !(_step460 = _iterator460.n()).done;) {
            var _i248 = _step460.value;
            n = OC(_i248, e) || n;
          }
        } catch (err) {
          _iterator460.e(err);
        } finally {
          _iterator460.f();
        }

        return n;
      }

      function OC(t, e) {
        if (0 == t.childCount) return e.insertElement("paragraph", t), !0;
        var n = Array.from(t.getChildren()).filter(function (t) {
          return t.is("$text");
        });

        var _iterator461 = _createForOfIteratorHelper(n),
            _step461;

        try {
          for (_iterator461.s(); !(_step461 = _iterator461.n()).done;) {
            var _t378 = _step461.value;
            e.wrap(e.createRangeOn(_t378), "paragraph");
          }
        } catch (err) {
          _iterator461.e(err);
        } finally {
          _iterator461.f();
        }

        return !!n.length;
      }

      function jC(t) {
        return !(!t.position || !t.position.parent.is("element", "tableCell")) && ("insert" == t.type && "$text" == t.name || "remove" == t.type);
      }

      function FC(t, e) {
        t.document.registerPostFixer(function () {
          return function (t, e) {
            var n = new Set();

            var _iterator462 = _createForOfIteratorHelper(t.getChanges()),
                _step462;

            try {
              for (_iterator462.s(); !(_step462 = _iterator462.n()).done;) {
                var _e338 = _step462.value;

                var _t379 = "attribute" == _e338.type ? _e338.range.start.parent : _e338.position.parent;

                _t379.is("element", "tableCell") && n.add(_t379);
              }
            } catch (err) {
              _iterator462.e(err);
            } finally {
              _iterator462.f();
            }

            var _iterator463 = _createForOfIteratorHelper(n.values()),
                _step463;

            try {
              for (_iterator463.s(); !(_step463 = _iterator463.n()).done;) {
                var _i249 = _step463.value;

                var _iterator464 = _createForOfIteratorHelper(_toConsumableArray(_i249.getChildren()).filter(function (t) {
                  return VC(t, e);
                })),
                    _step464;

                try {
                  for (_iterator464.s(); !(_step464 = _iterator464.n()).done;) {
                    var _n297 = _step464.value;
                    t.refreshItem(_n297);
                  }
                } catch (err) {
                  _iterator464.e(err);
                } finally {
                  _iterator464.f();
                }
              }
            } catch (err) {
              _iterator463.e(err);
            } finally {
              _iterator463.f();
            }

            return !1;
          }(t.document.differ, e);
        });
      }

      function VC(t, e) {
        if (!t.is("element", "paragraph")) return !1;
        var n = e.toViewElement(t);
        return !!n && LA(t) !== n.is("element", "span");
      }

      function UC(t) {
        t.document.registerPostFixer(function () {
          return function (t) {
            var e = t.document.differ,
                n = new Set();

            var _iterator465 = _createForOfIteratorHelper(e.getChanges()),
                _step465;

            try {
              for (_iterator465.s(); !(_step465 = _iterator465.n()).done;) {
                var _t381 = _step465.value;

                if ("attribute" === _t381.type) {
                  var _e339 = _t381.range.start.nodeAfter;
                  _e339 && _e339.is("element", "table") && "headingRows" === _t381.attributeKey && n.add(_e339);
                } else if ("insert" === _t381.type || "remove" === _t381.type) if ("tableRow" === _t381.name) {
                  var _e340 = _t381.position.findAncestor("table"),
                      _i250 = _e340.getAttribute("headingRows") || 0;

                  _t381.position.offset < _i250 && n.add(_e340);
                } else if ("tableCell" === _t381.name) {
                  var _e341 = _t381.position.findAncestor("table"),
                      _i251 = _e341.getAttribute("headingColumns") || 0;

                  _t381.position.offset < _i251 && n.add(_e341);
                }
              }
            } catch (err) {
              _iterator465.e(err);
            } finally {
              _iterator465.f();
            }

            if (n.size) {
              var _iterator466 = _createForOfIteratorHelper(n.values()),
                  _step466;

              try {
                for (_iterator466.s(); !(_step466 = _iterator466.n()).done;) {
                  var _t380 = _step466.value;
                  e.refreshItem(_t380);
                }
              } catch (err) {
                _iterator466.e(err);
              } finally {
                _iterator466.f();
              }

              return !0;
            }

            return !1;
          }(t);
        });
      }

      var HC = n(2511),
          qC = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(HC.Z, qC), HC.Z.locals;

      var WC = /*#__PURE__*/function (_ue80) {
        _inherits(WC, _ue80);

        var _super211 = _createSuper(WC);

        function WC() {
          _classCallCheck(this, WC);

          return _super211.apply(this, arguments);
        }

        _createClass(WC, [{
          key: "init",
          value: function init() {
            var t = this.editor,
                e = t.model,
                n = e.schema,
                i = t.conversion;
            n.register("table", {
              allowWhere: "$block",
              allowAttributes: ["headingRows", "headingColumns"],
              isObject: !0,
              isBlock: !0
            }), n.register("tableRow", {
              allowIn: "table",
              isLimit: !0
            }), n.register("tableCell", {
              allowIn: "tableRow",
              allowChildren: "$block",
              allowAttributes: ["colspan", "rowspan"],
              isLimit: !0,
              isSelectable: !0
            }), i.for("upcast").add(function (t) {
              t.on("element:figure", function (t, e, n) {
                if (!n.consumable.test(e.viewItem, {
                  name: !0,
                  classes: "table"
                })) return;

                var i = function (t) {
                  var _iterator467 = _createForOfIteratorHelper(t.getChildren()),
                      _step467;

                  try {
                    for (_iterator467.s(); !(_step467 = _iterator467.n()).done;) {
                      var _e342 = _step467.value;
                      if (_e342.is("element", "table")) return _e342;
                    }
                  } catch (err) {
                    _iterator467.e(err);
                  } finally {
                    _iterator467.f();
                  }
                }(e.viewItem);

                if (!i || !n.consumable.test(i, {
                  name: !0
                })) return;
                n.consumable.consume(e.viewItem, {
                  name: !0,
                  classes: "table"
                });
                var o = wa(n.convertItem(i, e.modelCursor).modelRange.getItems());
                o ? (n.convertChildren(e.viewItem, n.writer.createPositionAt(o, "end")), n.updateConversionResult(o, e)) : n.consumable.revert(e.viewItem, {
                  name: !0,
                  classes: "table"
                });
              });
            }), i.for("upcast").add(IA()), i.for("editingDowncast").add(zA({
              asWidget: !0
            })), i.for("dataDowncast").add(zA()), i.for("upcast").elementToElement({
              model: "tableRow",
              view: "tr"
            }), i.for("upcast").add(function (t) {
              t.on("element:tr", function (t, e) {
                e.viewItem.isEmpty && 0 == e.modelCursor.index && t.stop();
              }, {
                priority: "high"
              });
            }), i.for("editingDowncast").add(function (t) {
              return t.on("insert:tableRow", function (t, e, n) {
                var i = e.item;
                if (!n.consumable.consume(i, "insert")) return;

                var o = i.parent,
                    r = function (t) {
                  var _iterator468 = _createForOfIteratorHelper(t.getChildren()),
                      _step468;

                  try {
                    for (_iterator468.s(); !(_step468 = _iterator468.n()).done;) {
                      var _e343 = _step468.value;
                      if ("table" === _e343.name) return _e343;
                    }
                  } catch (err) {
                    _iterator468.e(err);
                  } finally {
                    _iterator468.f();
                  }
                }(n.mapper.toViewElement(o)),
                    s = o.getChildIndex(i),
                    a = new NA(o, {
                  row: s
                }),
                    c = {
                  headingRows: o.getAttribute("headingRows") || 0,
                  headingColumns: o.getAttribute("headingColumns") || 0
                },
                    l = new Map();

                var _iterator469 = _createForOfIteratorHelper(a),
                    _step469;

                try {
                  for (_iterator469.s(); !(_step469 = _iterator469.n()).done;) {
                    var _t382 = _step469.value;

                    var _e344 = l.get(s) || jA(r, i, s, c, n);

                    l.set(s, _e344), n.consumable.consume(_t382.cell, "insert"), OA(_t382, c, n.writer.createPositionAt(_e344, "end"), n, {
                      asWidget: !0
                    });
                  }
                } catch (err) {
                  _iterator469.e(err);
                } finally {
                  _iterator469.f();
                }
              });
            }), i.for("editingDowncast").add(function (t) {
              return t.on("remove:tableRow", function (t, e, n) {
                t.stop();
                var i = n.writer,
                    o = n.mapper,
                    r = o.toViewPosition(e.position).getLastMatchingPosition(function (t) {
                  return !t.item.is("element", "tr");
                }).nodeAfter,
                    s = r.parent.parent,
                    a = i.createRangeOn(r),
                    c = i.remove(a);

                var _iterator470 = _createForOfIteratorHelper(i.createRangeIn(c).getItems()),
                    _step470;

                try {
                  for (_iterator470.s(); !(_step470 = _iterator470.n()).done;) {
                    var _t383 = _step470.value;
                    o.unbindViewElement(_t383);
                  }
                } catch (err) {
                  _iterator470.e(err);
                } finally {
                  _iterator470.f();
                }

                UA("thead", s, n), UA("tbody", s, n);
              }, {
                priority: "higher"
              });
            }), i.for("upcast").elementToElement({
              model: "tableCell",
              view: "td"
            }), i.for("upcast").elementToElement({
              model: "tableCell",
              view: "th"
            }), i.for("upcast").add(MA("td")), i.for("upcast").add(MA("th")), i.for("editingDowncast").add(function (t) {
              return t.on("insert:tableCell", function (t, e, n) {
                var i = e.item;
                if (!n.consumable.consume(i, "insert")) return;
                var o = i.parent,
                    r = o.parent,
                    s = r.getChildIndex(o),
                    a = new NA(r, {
                  row: s
                }),
                    c = {
                  headingRows: r.getAttribute("headingRows") || 0,
                  headingColumns: r.getAttribute("headingColumns") || 0
                };

                var _iterator471 = _createForOfIteratorHelper(a),
                    _step471;

                try {
                  for (_iterator471.s(); !(_step471 = _iterator471.n()).done;) {
                    var _t384 = _step471.value;

                    if (_t384.cell === i) {
                      var _e345 = n.mapper.toViewElement(o);

                      return void OA(_t384, c, n.writer.createPositionAt(_e345, o.getChildIndex(i)), n, {
                        asWidget: !0
                      });
                    }
                  }
                } catch (err) {
                  _iterator471.e(err);
                } finally {
                  _iterator471.f();
                }
              });
            }), i.for("editingDowncast").elementToElement({
              model: "paragraph",
              view: PA,
              converterPriority: "high"
            }), i.for("downcast").attributeToAttribute({
              model: "colspan",
              view: "colspan"
            }), i.for("upcast").attributeToAttribute({
              model: {
                key: "colspan",
                value: GC("colspan")
              },
              view: "colspan"
            }), i.for("downcast").attributeToAttribute({
              model: "rowspan",
              view: "rowspan"
            }), i.for("upcast").attributeToAttribute({
              model: {
                key: "rowspan",
                value: GC("rowspan")
              },
              view: "rowspan"
            }), i.for("editingDowncast").add(function (t) {
              return t.on("attribute:headingColumns:table", function (t, e, n) {
                var i = e.item;
                if (!n.consumable.consume(e.item, t.name)) return;
                var o = {
                  headingRows: i.getAttribute("headingRows") || 0,
                  headingColumns: i.getAttribute("headingColumns") || 0
                },
                    r = e.attributeOldValue,
                    s = e.attributeNewValue,
                    a = (r > s ? r : s) - 1;

                var _iterator472 = _createForOfIteratorHelper(new NA(i, {
                  endColumn: a
                })),
                    _step472;

                try {
                  for (_iterator472.s(); !(_step472 = _iterator472.n()).done;) {
                    var _t385 = _step472.value;
                    RA(_t385, o, n);
                  }
                } catch (err) {
                  _iterator472.e(err);
                } finally {
                  _iterator472.f();
                }
              });
            }), t.data.mapper.on("modelToViewPosition", function (t, e) {
              var n = e.modelPosition.parent,
                  i = e.modelPosition.nodeBefore;
              if (!n.is("element", "tableCell")) return;
              if (!i || !i.is("element", "paragraph")) return;
              var o = e.mapper.toViewElement(i),
                  r = e.mapper.toViewElement(n);
              o === r && (e.viewPosition = e.mapper.findPositionIn(r, i.maxOffset));
            }), t.config.define("table.defaultHeadings.rows", 0), t.config.define("table.defaultHeadings.columns", 0), t.commands.add("insertTable", new qA(t)), t.commands.add("insertTableRowAbove", new eC(t, {
              order: "above"
            })), t.commands.add("insertTableRowBelow", new eC(t, {
              order: "below"
            })), t.commands.add("insertTableColumnLeft", new nC(t, {
              order: "left"
            })), t.commands.add("insertTableColumnRight", new nC(t, {
              order: "right"
            })), t.commands.add("removeTableRow", new kC(t)), t.commands.add("removeTableColumn", new bC(t)), t.commands.add("splitTableCellVertically", new iC(t, {
              direction: "vertically"
            })), t.commands.add("splitTableCellHorizontally", new iC(t, {
              direction: "horizontally"
            })), t.commands.add("mergeTableCells", new xC(t)), t.commands.add("mergeTableCellRight", new pC(t, {
              direction: "right"
            })), t.commands.add("mergeTableCellLeft", new pC(t, {
              direction: "left"
            })), t.commands.add("mergeTableCellDown", new pC(t, {
              direction: "down"
            })), t.commands.add("mergeTableCellUp", new pC(t, {
              direction: "up"
            })), t.commands.add("setTableColumnHeader", new AC(t)), t.commands.add("setTableRowHeader", new wC(t)), t.commands.add("selectTableRow", new IC(t)), t.commands.add("selectTableColumn", new MC(t)), UC(e), TC(e), FC(e, t.editing.mapper), PC(e);
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "TableEditing";
          }
        }, {
          key: "requires",
          get: function get() {
            return [CC];
          }
        }]);

        return WC;
      }(ue);

      function GC(t) {
        return function (e) {
          var n = parseInt(e.getAttribute(t));
          return Number.isNaN(n) || n <= 0 ? null : n;
        };
      }

      var $C = n(2798),
          YC = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()($C.Z, YC), $C.Z.locals;

      var KC = /*#__PURE__*/function (_Dd31) {
        _inherits(KC, _Dd31);

        var _super212 = _createSuper(KC);

        function KC(t) {
          var _this307;

          _classCallCheck(this, KC);

          _this307 = _super212.call(this, t);
          var e = _this307.bindTemplate;
          _this307.items = _this307._createGridCollection(), _this307.set("rows", 0), _this307.set("columns", 0), _this307.bind("label").to(_assertThisInitialized(_this307), "columns", _assertThisInitialized(_this307), "rows", function (t, e) {
            return "".concat(e, " \xD7 ").concat(t);
          }), _this307.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck"]
            },
            children: [{
              tag: "div",
              attributes: {
                class: ["ck-insert-table-dropdown__grid"]
              },
              on: {
                "mouseover@.ck-insert-table-dropdown-grid-box": e.to("boxover")
              },
              children: _this307.items
            }, {
              tag: "div",
              attributes: {
                class: ["ck-insert-table-dropdown__label"]
              },
              children: [{
                text: e.to("label")
              }]
            }],
            on: {
              mousedown: e.to(function (t) {
                t.preventDefault();
              }),
              click: e.to(function () {
                _this307.fire("execute");
              })
            }
          }), _this307.on("boxover", function (t, e) {
            var _e$target$dataset = e.target.dataset,
                n = _e$target$dataset.row,
                i = _e$target$dataset.column;

            _this307.set({
              rows: parseInt(n),
              columns: parseInt(i)
            });
          }), _this307.on("change:columns", function () {
            _this307._highlightGridBoxes();
          }), _this307.on("change:rows", function () {
            _this307._highlightGridBoxes();
          });
          return _this307;
        }

        _createClass(KC, [{
          key: "focus",
          value: function focus() {}
        }, {
          key: "focusLast",
          value: function focusLast() {}
        }, {
          key: "_highlightGridBoxes",
          value: function _highlightGridBoxes() {
            var t = this.rows,
                e = this.columns;
            this.items.map(function (n, i) {
              var o = Math.floor(i / 10) < t && i % 10 < e;
              n.set("isOn", o);
            });
          }
        }, {
          key: "_createGridCollection",
          value: function _createGridCollection() {
            var t = [];

            for (var _e346 = 0; _e346 < 100; _e346++) {
              var _n298 = Math.floor(_e346 / 10),
                  _i252 = _e346 % 10;

              t.push(new QC(this.locale, _n298 + 1, _i252 + 1));
            }

            return this.createCollection(t);
          }
        }]);

        return KC;
      }(Dd);

      var QC = /*#__PURE__*/function (_Dd32) {
        _inherits(QC, _Dd32);

        var _super213 = _createSuper(QC);

        function QC(t, e, n) {
          var _this308;

          _classCallCheck(this, QC);

          _this308 = _super213.call(this, t);
          var i = _this308.bindTemplate;
          _this308.set("isOn", !1), _this308.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck-insert-table-dropdown-grid-box", i.if("isOn", "ck-on")],
              "data-row": e,
              "data-column": n
            }
          });
          return _this308;
        }

        return _createClass(QC);
      }(Dd);

      var ZC = /*#__PURE__*/function (_ue81) {
        _inherits(ZC, _ue81);

        var _super214 = _createSuper(ZC);

        function ZC() {
          _classCallCheck(this, ZC);

          return _super214.apply(this, arguments);
        }

        _createClass(ZC, [{
          key: "init",
          value: function init() {
            var _this309 = this;

            var t = this.editor,
                e = this.editor.t,
                n = "ltr" === t.locale.contentLanguageDirection;
            t.ui.componentFactory.add("insertTable", function (n) {
              var i = t.commands.get("insertTable"),
                  o = Hh(n);
              var r;
              return o.bind("isEnabled").to(i), o.buttonView.set({
                icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 6v3h4V6H3zm0 4v3h4v-3H3zm0 4v3h4v-3H3zm5 3h4v-3H8v3zm5 0h4v-3h-4v3zm4-4v-3h-4v3h4zm0-4V6h-4v3h4zm1.5 8a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 17V4c.222-.863 1.068-1.5 2-1.5h13c.932 0 1.778.637 2 1.5v13zM12 13v-3H8v3h4zm0-4V6H8v3h4z"/></svg>',
                label: e("Insert table"),
                tooltip: !0
              }), o.on("change:isOpen", function () {
                r || (r = new KC(n), o.panelView.children.add(r), r.delegate("execute").to(o), o.buttonView.on("open", function () {
                  r.rows = 0, r.columns = 0;
                }), o.on("execute", function () {
                  t.execute("insertTable", {
                    rows: r.rows,
                    columns: r.columns
                  }), t.editing.view.focus();
                }));
              }), o;
            }), t.ui.componentFactory.add("tableColumn", function (t) {
              var i = [{
                type: "switchbutton",
                model: {
                  commandName: "setTableColumnHeader",
                  label: e("Header column"),
                  bindIsOn: !0
                }
              }, {
                type: "separator"
              }, {
                type: "button",
                model: {
                  commandName: n ? "insertTableColumnLeft" : "insertTableColumnRight",
                  label: e("Insert column left")
                }
              }, {
                type: "button",
                model: {
                  commandName: n ? "insertTableColumnRight" : "insertTableColumnLeft",
                  label: e("Insert column right")
                }
              }, {
                type: "button",
                model: {
                  commandName: "removeTableColumn",
                  label: e("Delete column")
                }
              }, {
                type: "button",
                model: {
                  commandName: "selectTableColumn",
                  label: e("Select column")
                }
              }];
              return _this309._prepareDropdown(e("Column"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M18 7v1H2V7h16zm0 5v1H2v-1h16z" opacity=".6"/><path d="M14 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm-2 1H8v4h4V2zm0 6H8v4h4V8zm0 6H8v4h4v-4z"/></svg>', i, t);
            }), t.ui.componentFactory.add("tableRow", function (t) {
              var n = [{
                type: "switchbutton",
                model: {
                  commandName: "setTableRowHeader",
                  label: e("Header row"),
                  bindIsOn: !0
                }
              }, {
                type: "separator"
              }, {
                type: "button",
                model: {
                  commandName: "insertTableRowAbove",
                  label: e("Insert row above")
                }
              }, {
                type: "button",
                model: {
                  commandName: "insertTableRowBelow",
                  label: e("Insert row below")
                }
              }, {
                type: "button",
                model: {
                  commandName: "removeTableRow",
                  label: e("Delete row")
                }
              }, {
                type: "button",
                model: {
                  commandName: "selectTableRow",
                  label: e("Select row")
                }
              }];
              return _this309._prepareDropdown(e("Row"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v16h-1V2z" opacity=".6"/><path d="M1 6h18a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm1 2v4h4V8H2zm6 0v4h4V8H8zm6 0v4h4V8h-4z"/></svg>', n, t);
            }), t.ui.componentFactory.add("mergeTableCells", function (t) {
              var i = [{
                type: "button",
                model: {
                  commandName: "mergeTableCellUp",
                  label: e("Merge cell up")
                }
              }, {
                type: "button",
                model: {
                  commandName: n ? "mergeTableCellRight" : "mergeTableCellLeft",
                  label: e("Merge cell right")
                }
              }, {
                type: "button",
                model: {
                  commandName: "mergeTableCellDown",
                  label: e("Merge cell down")
                }
              }, {
                type: "button",
                model: {
                  commandName: n ? "mergeTableCellLeft" : "mergeTableCellRight",
                  label: e("Merge cell left")
                }
              }, {
                type: "separator"
              }, {
                type: "button",
                model: {
                  commandName: "splitTableCellVertically",
                  label: e("Split cell vertically")
                }
              }, {
                type: "button",
                model: {
                  commandName: "splitTableCellHorizontally",
                  label: e("Split cell horizontally")
                }
              }];
              return _this309._prepareMergeSplitButtonDropdown(e("Merge cells"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v7h-1V2zm6 5v1H2V7h16zM8 12v1H2v-1h6z" opacity=".6"/><path d="M7 7h12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm1 2v9h10V9H8z"/></svg>', i, t);
            });
          }
        }, {
          key: "_prepareDropdown",
          value: function _prepareDropdown(t, e, n, i) {
            var o = this.editor,
                r = Hh(i),
                s = this._fillDropdownWithListOptions(r, n);

            return r.buttonView.set({
              label: t,
              icon: e,
              tooltip: !0
            }), r.bind("isEnabled").toMany(s, "isEnabled", function () {
              for (var _len28 = arguments.length, t = new Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
                t[_key28] = arguments[_key28];
              }

              return t.some(function (t) {
                return t;
              });
            }), this.listenTo(r, "execute", function (t) {
              o.execute(t.source.commandName), o.editing.view.focus();
            }), r;
          }
        }, {
          key: "_prepareMergeSplitButtonDropdown",
          value: function _prepareMergeSplitButtonDropdown(t, e, n, i) {
            var o = this.editor,
                r = Hh(i, mh),
                s = "mergeTableCells",
                a = o.commands.get(s),
                c = this._fillDropdownWithListOptions(r, n);

            return r.buttonView.set({
              label: t,
              icon: e,
              tooltip: !0,
              isEnabled: !0
            }), r.bind("isEnabled").toMany([a].concat(_toConsumableArray(c)), "isEnabled", function () {
              for (var _len29 = arguments.length, t = new Array(_len29), _key29 = 0; _key29 < _len29; _key29++) {
                t[_key29] = arguments[_key29];
              }

              return t.some(function (t) {
                return t;
              });
            }), this.listenTo(r.buttonView, "execute", function () {
              o.execute(s), o.editing.view.focus();
            }), this.listenTo(r, "execute", function (t) {
              o.execute(t.source.commandName), o.editing.view.focus();
            }), r;
          }
        }, {
          key: "_fillDropdownWithListOptions",
          value: function _fillDropdownWithListOptions(t, e) {
            var n = this.editor,
                i = [],
                o = new Di();

            var _iterator473 = _createForOfIteratorHelper(e),
                _step473;

            try {
              for (_iterator473.s(); !(_step473 = _iterator473.n()).done;) {
                var _t386 = _step473.value;
                JC(_t386, n, i, o);
              }
            } catch (err) {
              _iterator473.e(err);
            } finally {
              _iterator473.f();
            }

            return Wh(t, o, n.ui.componentFactory), i;
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "TableUI";
          }
        }]);

        return ZC;
      }(ue);

      function JC(t, e, n, i) {
        var o = t.model = new uu(t.model),
            _t$model2 = t.model,
            r = _t$model2.commandName,
            s = _t$model2.bindIsOn;

        if ("button" === t.type || "switchbutton" === t.type) {
          var _t387 = e.commands.get(r);

          n.push(_t387), o.set({
            commandName: r
          }), o.bind("isEnabled").to(_t387), s && o.bind("isOn").to(_t387, "value");
        }

        o.set({
          withText: !0
        }), i.add(t);
      }

      var XC = n(2382),
          t_ = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(XC.Z, t_), XC.Z.locals;

      var e_ = /*#__PURE__*/function (_ue82) {
        _inherits(e_, _ue82);

        var _super215 = _createSuper(e_);

        function e_() {
          _classCallCheck(this, e_);

          return _super215.apply(this, arguments);
        }

        _createClass(e_, [{
          key: "init",
          value: function init() {
            var _this310 = this;

            var t = this.editor.model;
            this.listenTo(t, "deleteContent", function (t, e) {
              return _this310._handleDeleteContent(t, e);
            }, {
              priority: "high"
            }), this._defineSelectionConverter(), this._enablePluginDisabling();
          }
        }, {
          key: "getSelectedTableCells",
          value: function getSelectedTableCells() {
            var t = WA(this.editor.model.document.selection);
            return 0 == t.length ? null : t;
          }
        }, {
          key: "getSelectionAsFragment",
          value: function getSelectionAsFragment() {
            var _this311 = this;

            var t = this.getSelectedTableCells();
            return t ? this.editor.model.change(function (e) {
              var n = e.createDocumentFragment(),
                  i = _this311.editor.plugins.get("TableUtils"),
                  _KA3 = KA(t),
                  o = _KA3.first,
                  r = _KA3.last,
                  _YA2 = YA(t),
                  s = _YA2.first,
                  a = _YA2.last,
                  c = t[0].findAncestor("table");

              var l = a,
                  d = r;

              if (QA(t, i)) {
                var _t388 = {
                  firstColumn: o,
                  lastColumn: r,
                  firstRow: s,
                  lastRow: a
                };
                l = gC(c, _t388), d = mC(c, _t388);
              }

              var h = oC(c, {
                startRow: s,
                startColumn: o,
                endRow: l,
                endColumn: d
              }, e);
              return e.insert(h, n, 0), n;
            }) : null;
          }
        }, {
          key: "setCellSelection",
          value: function setCellSelection(t, e) {
            var n = this._getCellsToSelect(t, e);

            this.editor.model.change(function (t) {
              t.setSelection(n.cells.map(function (e) {
                return t.createRangeOn(e);
              }), {
                backward: n.backward
              });
            });
          }
        }, {
          key: "getFocusCell",
          value: function getFocusCell() {
            var t = _toConsumableArray(this.editor.model.document.selection.getRanges()).pop().getContainedElement();

            return t && t.is("element", "tableCell") ? t : null;
          }
        }, {
          key: "getAnchorCell",
          value: function getAnchorCell() {
            var t = wa(this.editor.model.document.selection.getRanges()).getContainedElement();
            return t && t.is("element", "tableCell") ? t : null;
          }
        }, {
          key: "_defineSelectionConverter",
          value: function _defineSelectionConverter() {
            var _this312 = this;

            var t = this.editor,
                e = new Set();
            t.conversion.for("editingDowncast").add(function (t) {
              return t.on("selection", function (t, n, i) {
                var o = i.writer;
                !function (t) {
                  var _iterator474 = _createForOfIteratorHelper(e),
                      _step474;

                  try {
                    for (_iterator474.s(); !(_step474 = _iterator474.n()).done;) {
                      var _n299 = _step474.value;
                      t.removeClass("ck-editor__editable_selected", _n299);
                    }
                  } catch (err) {
                    _iterator474.e(err);
                  } finally {
                    _iterator474.f();
                  }

                  e.clear();
                }(o);

                var r = _this312.getSelectedTableCells();

                if (!r) return;

                var _iterator475 = _createForOfIteratorHelper(r),
                    _step475;

                try {
                  for (_iterator475.s(); !(_step475 = _iterator475.n()).done;) {
                    var _t389 = _step475.value;

                    var _n300 = i.mapper.toViewElement(_t389);

                    o.addClass("ck-editor__editable_selected", _n300), e.add(_n300);
                  }
                } catch (err) {
                  _iterator475.e(err);
                } finally {
                  _iterator475.f();
                }

                var s = i.mapper.toViewElement(r[r.length - 1]);
                o.setSelection(s, 0);
              }, {
                priority: "lowest"
              });
            });
          }
        }, {
          key: "_enablePluginDisabling",
          value: function _enablePluginDisabling() {
            var _this313 = this;

            var t = this.editor;
            this.on("change:isEnabled", function () {
              if (!_this313.isEnabled) {
                var _e347 = _this313.getSelectedTableCells();

                if (!_e347) return;
                t.model.change(function (n) {
                  var i = n.createPositionAt(_e347[0], 0),
                      o = t.model.schema.getNearestSelectionRange(i);
                  n.setSelection(o);
                });
              }
            });
          }
        }, {
          key: "_handleDeleteContent",
          value: function _handleDeleteContent(t, e) {
            var _e348 = _slicedToArray(e, 2),
                n = _e348[0],
                i = _e348[1],
                o = this.editor.model,
                r = !i || "backward" == i.direction,
                s = WA(n);

            s.length && (t.stop(), o.change(function (t) {
              var e = s[r ? s.length - 1 : 0];
              o.change(function (t) {
                var _iterator476 = _createForOfIteratorHelper(s),
                    _step476;

                try {
                  for (_iterator476.s(); !(_step476 = _iterator476.n()).done;) {
                    var _e349 = _step476.value;
                    o.deleteContent(t.createSelection(_e349, "in"));
                  }
                } catch (err) {
                  _iterator476.e(err);
                } finally {
                  _iterator476.f();
                }
              });
              var i = o.schema.getNearestSelectionRange(t.createPositionAt(e, 0));
              n.is("documentSelection") ? t.setSelection(i) : n.setTo(i);
            }));
          }
        }, {
          key: "_getCellsToSelect",
          value: function _getCellsToSelect(t, e) {
            var n = this.editor.plugins.get("TableUtils"),
                i = n.getCellLocation(t),
                o = n.getCellLocation(e),
                r = Math.min(i.row, o.row),
                s = Math.max(i.row, o.row),
                a = Math.min(i.column, o.column),
                c = Math.max(i.column, o.column),
                l = new Array(s - r + 1).fill(null).map(function () {
              return [];
            }),
                d = {
              startRow: r,
              endRow: s,
              startColumn: a,
              endColumn: c
            };

            var _iterator477 = _createForOfIteratorHelper(new NA(t.findAncestor("table"), d)),
                _step477;

            try {
              for (_iterator477.s(); !(_step477 = _iterator477.n()).done;) {
                var _step477$value = _step477.value,
                    _e350 = _step477$value.row,
                    _n301 = _step477$value.cell;

                l[_e350 - r].push(_n301);
              }
            } catch (err) {
              _iterator477.e(err);
            } finally {
              _iterator477.f();
            }

            var h = o.row < i.row,
                u = o.column < i.column;
            return h && l.reverse(), u && l.forEach(function (t) {
              return t.reverse();
            }), {
              cells: l.flat(),
              backward: h || u
            };
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "TableSelection";
          }
        }, {
          key: "requires",
          get: function get() {
            return [CC];
          }
        }]);

        return e_;
      }(ue);

      var n_ = /*#__PURE__*/function (_ue83) {
        _inherits(n_, _ue83);

        var _super216 = _createSuper(n_);

        function n_() {
          _classCallCheck(this, n_);

          return _super216.apply(this, arguments);
        }

        _createClass(n_, [{
          key: "init",
          value: function init() {
            var _this314 = this;

            var t = this.editor,
                e = t.editing.view.document;
            this.listenTo(e, "copy", function (t, e) {
              return _this314._onCopyCut(t, e);
            }), this.listenTo(e, "cut", function (t, e) {
              return _this314._onCopyCut(t, e);
            }), this.listenTo(t.model, "insertContent", function (t, e) {
              return _this314._onInsertContent.apply(_this314, [t].concat(_toConsumableArray(e)));
            }, {
              priority: "high"
            }), this.decorate("_replaceTableSlotCell");
          }
        }, {
          key: "_onCopyCut",
          value: function _onCopyCut(t, e) {
            var n = this.editor.plugins.get(e_);
            if (!n.getSelectedTableCells()) return;
            if ("cut" == t.name && this.editor.isReadOnly) return;
            e.preventDefault(), t.stop();
            var i = this.editor.data,
                o = this.editor.editing.view.document,
                r = i.toView(n.getSelectionAsFragment());
            o.fire("clipboardOutput", {
              dataTransfer: e.dataTransfer,
              content: r,
              method: t.name
            });
          }
        }, {
          key: "_onInsertContent",
          value: function _onInsertContent(t, e, n) {
            var _this315 = this;

            if (n && !n.is("documentSelection")) return;
            var i = this.editor.model,
                o = this.editor.plugins.get(CC);

            var r = function (t, e) {
              if (!t.is("documentFragment") && !t.is("element")) return null;
              if (t.is("element", "table")) return t;
              if (1 == t.childCount && t.getChild(0).is("element", "table")) return t.getChild(0);
              var n = e.createRangeIn(t);

              var _iterator478 = _createForOfIteratorHelper(n.getItems()),
                  _step478;

              try {
                for (_iterator478.s(); !(_step478 = _iterator478.n()).done;) {
                  var _t390 = _step478.value;

                  if (_t390.is("element", "table")) {
                    var _i253 = e.createRange(n.start, e.createPositionBefore(_t390));

                    if (e.hasContent(_i253, {
                      ignoreWhitespaces: !0
                    })) return null;

                    var _o131 = e.createRange(e.createPositionAfter(_t390), n.end);

                    return e.hasContent(_o131, {
                      ignoreWhitespaces: !0
                    }) ? null : _t390;
                  }
                }
              } catch (err) {
                _iterator478.e(err);
              } finally {
                _iterator478.f();
              }

              return null;
            }(e, i);

            if (!r) return;
            var s = $A(i.document.selection);
            s.length ? (t.stop(), i.change(function (t) {
              var e = {
                width: o.getColumns(r),
                height: o.getRows(r)
              },
                  n = function (t, e, n, i) {
                var o = t[0].findAncestor("table"),
                    r = KA(t),
                    s = YA(t),
                    a = {
                  firstColumn: r.first,
                  lastColumn: r.last,
                  firstRow: s.first,
                  lastRow: s.last
                },
                    c = 1 === t.length;
                c && (a.lastRow += e.height - 1, a.lastColumn += e.width - 1, function (t, e, n, i) {
                  var o = i.getColumns(t),
                      r = i.getRows(t);
                  n > o && i.insertColumns(t, {
                    at: o,
                    columns: n - o
                  });
                  e > r && i.insertRows(t, {
                    at: r,
                    rows: e - r
                  });
                }(o, a.lastRow + 1, a.lastColumn + 1, i));
                c || !QA(t, i) ? function (t, e, n) {
                  var i = e.firstRow,
                      o = e.lastRow,
                      r = e.firstColumn,
                      s = e.lastColumn,
                      a = {
                    first: i,
                    last: o
                  },
                      c = {
                    first: r,
                    last: s
                  };
                  o_(t, r, a, n), o_(t, s + 1, a, n), i_(t, i, c, n), i_(t, o + 1, c, n, i);
                }(o, a, n) : (a.lastRow = gC(o, a), a.lastColumn = mC(o, a));
                return a;
              }(s, e, t, o),
                  i = n.lastRow - n.firstRow + 1,
                  a = n.lastColumn - n.firstColumn + 1,
                  c = {
                startRow: 0,
                startColumn: 0,
                endRow: Math.min(i, e.height) - 1,
                endColumn: Math.min(a, e.width) - 1
              };

              r = oC(r, c, t);

              var l = s[0].findAncestor("table"),
                  d = _this315._replaceSelectedCellsWithPasted(r, e, l, n, t);

              if (_this315.editor.plugins.get("TableSelection").isEnabled) {
                var _e351 = ZA(d.map(function (e) {
                  return t.createRangeOn(e);
                }));

                t.setSelection(_e351);
              } else t.setSelection(d[0], 0);
            })) : uC(r, o);
          }
        }, {
          key: "_replaceSelectedCellsWithPasted",
          value: function _replaceSelectedCellsWithPasted(t, e, n, i, o) {
            var r = e.width,
                s = e.height,
                a = function (t, e, n) {
              var i = new Array(n).fill(null).map(function () {
                return new Array(e).fill(null);
              });

              var _iterator479 = _createForOfIteratorHelper(new NA(t)),
                  _step479;

              try {
                for (_iterator479.s(); !(_step479 = _iterator479.n()).done;) {
                  var _step479$value = _step479.value,
                      _e352 = _step479$value.column,
                      _n302 = _step479$value.row,
                      _o132 = _step479$value.cell;
                  i[_n302][_e352] = _o132;
                }
              } catch (err) {
                _iterator479.e(err);
              } finally {
                _iterator479.f();
              }

              return i;
            }(t, r, s),
                c = _toConsumableArray(new NA(n, {
              startRow: i.firstRow,
              endRow: i.lastRow,
              startColumn: i.firstColumn,
              endColumn: i.lastColumn,
              includeAllSlots: !0
            })),
                l = [];

            var d;

            for (var _i254 = 0, _c21 = c; _i254 < _c21.length; _i254++) {
              var _t391 = _c21[_i254];
              var _e353 = _t391.row,
                  _n303 = _t391.column;
              _n303 === i.firstColumn && (d = _t391.getPositionBefore());

              var _c22 = _e353 - i.firstRow,
                  _h7 = _n303 - i.firstColumn,
                  _u4 = a[_c22 % s][_h7 % r],
                  _g5 = _u4 ? o.cloneElement(_u4) : null,
                  _m2 = this._replaceTableSlotCell(_t391, _g5, d, o);

              _m2 && (lC(_m2, _e353, _n303, i.lastRow, i.lastColumn, o), l.push(_m2), d = o.createPositionAfter(_m2));
            }

            var h = parseInt(n.getAttribute("headingRows") || 0),
                u = parseInt(n.getAttribute("headingColumns") || 0),
                g = i.firstRow < h && h <= i.lastRow,
                m = i.firstColumn < u && u <= i.lastColumn;

            if (g) {
              var _t392 = i_(n, h, {
                first: i.firstColumn,
                last: i.lastColumn
              }, o, i.firstRow);

              l.push.apply(l, _toConsumableArray(_t392));
            }

            if (m) {
              var _t393 = o_(n, u, {
                first: i.firstRow,
                last: i.lastRow
              }, o);

              l.push.apply(l, _toConsumableArray(_t393));
            }

            return l;
          }
        }, {
          key: "_replaceTableSlotCell",
          value: function _replaceTableSlotCell(t, e, n, i) {
            var o = t.cell,
                r = t.isAnchor;
            return r && i.remove(o), e ? (i.insert(e, n), e) : null;
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "TableClipboard";
          }
        }, {
          key: "requires",
          get: function get() {
            return [e_, CC];
          }
        }]);

        return n_;
      }(ue);

      function i_(t, e, n, i) {
        var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
        if (e < 1) return;
        return rC(t, e, o).filter(function (_ref92) {
          var t = _ref92.column,
              e = _ref92.cellWidth;
          return r_(t, e, n);
        }).map(function (_ref93) {
          var t = _ref93.cell;
          return sC(t, e, i);
        });
      }

      function o_(t, e, n, i) {
        if (e < 1) return;
        return aC(t, e).filter(function (_ref94) {
          var t = _ref94.row,
              e = _ref94.cellHeight;
          return r_(t, e, n);
        }).map(function (_ref95) {
          var t = _ref95.cell,
              n = _ref95.column;
          return cC(t, n, e, i);
        });
      }

      function r_(t, e, n) {
        var i = t + e - 1,
            o = n.first,
            r = n.last;
        return t >= o && t <= r || t < o && i >= o;
      }

      var s_ = /*#__PURE__*/function (_ue84) {
        _inherits(s_, _ue84);

        var _super217 = _createSuper(s_);

        function s_() {
          _classCallCheck(this, s_);

          return _super217.apply(this, arguments);
        }

        _createClass(s_, [{
          key: "init",
          value: function init() {
            var _this316 = this;

            var t = this.editor.editing.view.document;
            this.editor.keystrokes.set("Tab", function () {
              return _this316._handleTabOnSelectedTable.apply(_this316, arguments);
            }, {
              priority: "low"
            }), this.editor.keystrokes.set("Tab", this._getTabHandler(!0), {
              priority: "low"
            }), this.editor.keystrokes.set("Shift+Tab", this._getTabHandler(!1), {
              priority: "low"
            }), this.listenTo(t, "arrowKey", function () {
              return _this316._onArrowKey.apply(_this316, arguments);
            }, {
              context: "table"
            });
          }
        }, {
          key: "_handleTabOnSelectedTable",
          value: function _handleTabOnSelectedTable(t, e) {
            var n = this.editor,
                i = n.model.document.selection.getSelectedElement();
            i && i.is("element", "table") && (e(), n.model.change(function (t) {
              t.setSelection(t.createRangeIn(i.getChild(0).getChild(0)));
            }));
          }
        }, {
          key: "_getTabHandler",
          value: function _getTabHandler(t) {
            var _this317 = this;

            var e = this.editor;
            return function (n, i) {
              var o = GA(e.model.document.selection)[0];
              if (o || (o = _this317.editor.plugins.get("TableSelection").getFocusCell()), !o) return;
              i();
              var r = o.parent,
                  s = r.parent,
                  a = s.getChildIndex(r),
                  c = r.getChildIndex(o),
                  l = 0 === c;
              if (!t && l && 0 === a) return void e.model.change(function (t) {
                t.setSelection(t.createRangeOn(s));
              });

              var d = _this317.editor.plugins.get("TableUtils"),
                  h = c === r.childCount - 1,
                  u = a === d.getRows(s) - 1;

              if (t && u && h && (e.execute("insertTableRowBelow"), a === d.getRows(s) - 1)) return void e.model.change(function (t) {
                t.setSelection(t.createRangeOn(s));
              });
              var g;

              if (t && h) {
                var _t394 = s.getChild(a + 1);

                g = _t394.getChild(0);
              } else if (!t && l) {
                var _t395 = s.getChild(a - 1);

                g = _t395.getChild(_t395.childCount - 1);
              } else g = r.getChild(c + (t ? 1 : -1));

              e.model.change(function (t) {
                t.setSelection(t.createRangeIn(g));
              });
            };
          }
        }, {
          key: "_onArrowKey",
          value: function _onArrowKey(t, e) {
            var n = this.editor,
                i = pr(e.keyCode, n.locale.contentLanguageDirection);
            this._handleArrowKeys(i, e.shiftKey) && (e.preventDefault(), e.stopPropagation(), t.stop());
          }
        }, {
          key: "_handleArrowKeys",
          value: function _handleArrowKeys(t, e) {
            var n = this.editor.model,
                i = n.document.selection,
                o = ["right", "down"].includes(t),
                r = WA(i);

            if (r.length) {
              var _n304;

              return _n304 = e ? this.editor.plugins.get("TableSelection").getFocusCell() : o ? r[r.length - 1] : r[0], this._navigateFromCellInDirection(_n304, t, e), !0;
            }

            var s = i.focus.findAncestor("tableCell");
            if (!s) return !1;
            if (!i.isCollapsed) if (e) {
              if (i.isBackward == o && !i.containsEntireContent(s)) return !1;
            } else {
              var _t396 = i.getSelectedElement();

              if (!_t396 || !n.schema.isObject(_t396)) return !1;
            }
            return !!this._isSelectionAtCellEdge(i, s, o) && (this._navigateFromCellInDirection(s, t, e), !0);
          }
        }, {
          key: "_isSelectionAtCellEdge",
          value: function _isSelectionAtCellEdge(t, e, n) {
            var i = this.editor.model,
                o = this.editor.model.schema,
                r = n ? t.getLastPosition() : t.getFirstPosition();

            if (!o.getLimitElement(r).is("element", "tableCell")) {
              return i.createPositionAt(e, n ? "end" : 0).isTouching(r);
            }

            var s = i.createSelection(r);
            return i.modifySelection(s, {
              direction: n ? "forward" : "backward"
            }), r.isEqual(s.focus);
          }
        }, {
          key: "_navigateFromCellInDirection",
          value: function _navigateFromCellInDirection(t, e) {
            var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;

            var i = this.editor.model,
                o = t.findAncestor("table"),
                r = _toConsumableArray(new NA(o, {
              includeAllSlots: !0
            })),
                _r83 = r[r.length - 1],
                s = _r83.row,
                a = _r83.column,
                c = r.find(function (_ref96) {
              var e = _ref96.cell;
              return e == t;
            });

            var l = c.row,
                d = c.column;

            switch (e) {
              case "left":
                d--;
                break;

              case "up":
                l--;
                break;

              case "right":
                d += c.cellWidth;
                break;

              case "down":
                l += c.cellHeight;
            }

            if (l < 0 || l > s || d < 0 && l <= 0 || d > a && l >= s) return void i.change(function (t) {
              t.setSelection(t.createRangeOn(o));
            });
            d < 0 ? (d = n ? 0 : a, l--) : d > a && (d = n ? a : 0, l++);
            var h = r.find(function (t) {
              return t.row == l && t.column == d;
            }).cell,
                u = ["right", "down"].includes(e),
                g = this.editor.plugins.get("TableSelection");

            if (n && g.isEnabled) {
              var _e354 = g.getAnchorCell() || t;

              g.setCellSelection(_e354, h);
            } else {
              var _t397 = i.createPositionAt(h, u ? 0 : "end");

              i.change(function (e) {
                e.setSelection(_t397);
              });
            }
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "TableKeyboard";
          }
        }, {
          key: "requires",
          get: function get() {
            return [e_];
          }
        }]);

        return s_;
      }(ue);

      var a_ = /*#__PURE__*/function (_qs8) {
        _inherits(a_, _qs8);

        var _super218 = _createSuper(a_);

        function a_(t) {
          var _this318;

          _classCallCheck(this, a_);

          _this318 = _super218.call(this, t), _this318.domEventType = ["mousemove", "mouseleave"];
          return _this318;
        }

        _createClass(a_, [{
          key: "onDomEvent",
          value: function onDomEvent(t) {
            this.fire(t.type, t);
          }
        }]);

        return a_;
      }(qs);

      var c_ = /*#__PURE__*/function (_ue85) {
        _inherits(c_, _ue85);

        var _super219 = _createSuper(c_);

        function c_() {
          _classCallCheck(this, c_);

          return _super219.apply(this, arguments);
        }

        _createClass(c_, [{
          key: "init",
          value: function init() {
            this.editor.editing.view.addObserver(a_), this._enableShiftClickSelection(), this._enableMouseDragSelection();
          }
        }, {
          key: "_enableShiftClickSelection",
          value: function _enableShiftClickSelection() {
            var _this319 = this;

            var t = this.editor;
            var e = !1;
            var n = t.plugins.get(e_);
            this.listenTo(t.editing.view.document, "mousedown", function (i, o) {
              if (!_this319.isEnabled || !n.isEnabled) return;
              if (!o.domEvent.shiftKey) return;
              var r = n.getAnchorCell() || GA(t.model.document.selection)[0];
              if (!r) return;

              var s = _this319._getModelTableCellFromDomEvent(o);

              s && l_(r, s) && (e = !0, n.setCellSelection(r, s), o.preventDefault());
            }), this.listenTo(t.editing.view.document, "mouseup", function () {
              e = !1;
            }), this.listenTo(t.editing.view.document, "selectionChange", function (t) {
              e && t.stop();
            }, {
              priority: "highest"
            });
          }
        }, {
          key: "_enableMouseDragSelection",
          value: function _enableMouseDragSelection() {
            var _this320 = this;

            var t = this.editor;
            var e,
                n,
                i = !1,
                o = !1;
            var r = t.plugins.get(e_);
            this.listenTo(t.editing.view.document, "mousedown", function (t, n) {
              _this320.isEnabled && r.isEnabled && (n.domEvent.shiftKey || n.domEvent.ctrlKey || n.domEvent.altKey || (e = _this320._getModelTableCellFromDomEvent(n)));
            }), this.listenTo(t.editing.view.document, "mousemove", function (t, s) {
              if (!s.domEvent.buttons) return;
              if (!e) return;

              var a = _this320._getModelTableCellFromDomEvent(s);

              a && l_(e, a) && (n = a, i || n == e || (i = !0)), i && (o = !0, r.setCellSelection(e, n), s.preventDefault());
            }), this.listenTo(t.editing.view.document, "mouseup", function () {
              i = !1, o = !1, e = null, n = null;
            }), this.listenTo(t.editing.view.document, "selectionChange", function (t) {
              o && t.stop();
            }, {
              priority: "highest"
            });
          }
        }, {
          key: "_getModelTableCellFromDomEvent",
          value: function _getModelTableCellFromDomEvent(t) {
            var e = t.target,
                n = this.editor.editing.view.createPositionAt(e, 0);
            return this.editor.editing.mapper.toModelPosition(n).parent.findAncestor("tableCell", {
              includeSelf: !0
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "TableMouse";
          }
        }, {
          key: "requires",
          get: function get() {
            return [e_];
          }
        }]);

        return c_;
      }(ue);

      function l_(t, e) {
        return t.parent.parent == e.parent.parent;
      }

      var d_ = n(9311),
          h_ = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(d_.Z, h_), d_.Z.locals;

      var u_ = /*#__PURE__*/function (_ue86) {
        _inherits(u_, _ue86);

        var _super220 = _createSuper(u_);

        function u_() {
          _classCallCheck(this, u_);

          return _super220.apply(this, arguments);
        }

        _createClass(u_, null, [{
          key: "requires",
          get: function get() {
            return [WC, ZC, e_, c_, s_, n_, $p];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "Table";
          }
        }]);

        return u_;
      }(ue);

      function g_(t) {
        var e = t.getSelectedElement();
        return e && p_(e) ? e : null;
      }

      function m_(t) {
        var e = t.getFirstPosition().parent;

        for (; e;) {
          if (e.is("element") && p_(e)) return e;
          e = e.parent;
        }

        return null;
      }

      function p_(t) {
        return !!t.getCustomProperty("table") && yp(t);
      }

      var f_ = /*#__PURE__*/function (_ue87) {
        _inherits(f_, _ue87);

        var _super221 = _createSuper(f_);

        function f_() {
          _classCallCheck(this, f_);

          return _super221.apply(this, arguments);
        }

        _createClass(f_, [{
          key: "afterInit",
          value: function afterInit() {
            var t = this.editor,
                e = t.t,
                n = t.plugins.get(Pf),
                i = t.config.get("table.contentToolbar"),
                o = t.config.get("table.tableToolbar");
            i && n.register("tableContent", {
              ariaLabel: e("Table toolbar"),
              items: i,
              getRelatedElement: m_
            }), o && n.register("table", {
              ariaLabel: e("Table toolbar"),
              items: o,
              getRelatedElement: g_
            });
          }
        }], [{
          key: "requires",
          get: function get() {
            return [Pf];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "TableToolbar";
          }
        }]);

        return f_;
      }(ue);

      var k_ = n(3917);

      function b_(t, e) {
        return Array(e + 1).join(t);
      }

      n.n(k_)().use({
        tokenizer: {
          autolink: function autolink() {
            return null;
          },
          url: function url() {
            return null;
          }
        },
        renderer: {
          checkbox: function checkbox() {
            var _Object$getPrototypeO;

            for (var _len30 = arguments.length, t = new Array(_len30), _key30 = 0; _key30 < _len30; _key30++) {
              t[_key30] = arguments[_key30];
            }

            return (_Object$getPrototypeO = Object.getPrototypeOf(this).checkbox).call.apply(_Object$getPrototypeO, [this].concat(t)).trimRight();
          }
        }
      });
      var w_ = ["address", "article", "aside", "audio", "blockquote", "body", "canvas", "center", "dd", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "isindex", "li", "main", "menu", "nav", "noframes", "noscript", "ol", "output", "p", "pre", "section", "table", "tbody", "td", "tfoot", "th", "thead", "tr", "ul"];

      function A_(t) {
        return -1 !== w_.indexOf(t.nodeName.toLowerCase());
      }

      var C_ = ["area", "base", "br", "col", "command", "embed", "hr", "img", "input", "keygen", "link", "meta", "param", "source", "track", "wbr"];

      function __(t) {
        return -1 !== C_.indexOf(t.nodeName.toLowerCase());
      }

      var v_ = C_.join();
      var y_ = {};

      function x_(t) {
        for (var e in this.options = t, this._keep = [], this._remove = [], this.blankRule = {
          replacement: t.blankReplacement
        }, this.keepReplacement = t.keepReplacement, this.defaultRule = {
          replacement: t.defaultReplacement
        }, this.array = [], t.rules) {
          this.array.push(t.rules[e]);
        }
      }

      function E_(t, e, n) {
        for (var i = 0; i < t.length; i++) {
          var o = t[i];
          if (D_(o, e, n)) return o;
        }
      }

      function D_(t, e, n) {
        var i = t.filter;

        if ("string" == typeof i) {
          if (i === e.nodeName.toLowerCase()) return !0;
        } else if (Array.isArray(i)) {
          if (i.indexOf(e.nodeName.toLowerCase()) > -1) return !0;
        } else {
          if ("function" != typeof i) throw new TypeError("`filter` needs to be a string, array, or function");
          if (i.call(t, e, n)) return !0;
        }
      }

      function S_(t) {
        var e = t.nextSibling || t.parentNode;
        return t.parentNode.removeChild(t), e;
      }

      function I_(t, e, n) {
        return t && t.parentNode === e || n(e) ? e.nextSibling || e.parentNode : e.firstChild || e.nextSibling || e.parentNode;
      }

      y_.paragraph = {
        filter: "p",
        replacement: function replacement(t) {
          return "\n\n" + t + "\n\n";
        }
      }, y_.lineBreak = {
        filter: "br",
        replacement: function replacement(t, e, n) {
          return n.br + "\n";
        }
      }, y_.heading = {
        filter: ["h1", "h2", "h3", "h4", "h5", "h6"],
        replacement: function replacement(t, e, n) {
          var i = Number(e.nodeName.charAt(1));
          return "setext" === n.headingStyle && i < 3 ? "\n\n" + t + "\n" + b_(1 === i ? "=" : "-", t.length) + "\n\n" : "\n\n" + b_("#", i) + " " + t + "\n\n";
        }
      }, y_.blockquote = {
        filter: "blockquote",
        replacement: function replacement(t) {
          return "\n\n" + (t = (t = t.replace(/^\n+|\n+$/g, "")).replace(/^/gm, "> ")) + "\n\n";
        }
      }, y_.list = {
        filter: ["ul", "ol"],
        replacement: function replacement(t, e) {
          var n = e.parentNode;
          return "LI" === n.nodeName && n.lastElementChild === e ? "\n" + t : "\n\n" + t + "\n\n";
        }
      }, y_.listItem = {
        filter: "li",
        replacement: function replacement(t, e, n) {
          t = t.replace(/^\n+/, "").replace(/\n+$/, "\n").replace(/\n/gm, "\n    ");
          var i = n.bulletListMarker + "   ",
              o = e.parentNode;

          if ("OL" === o.nodeName) {
            var r = o.getAttribute("start"),
                s = Array.prototype.indexOf.call(o.children, e);
            i = (r ? Number(r) + s : s + 1) + ".  ";
          }

          return i + t + (e.nextSibling && !/\n$/.test(t) ? "\n" : "");
        }
      }, y_.indentedCodeBlock = {
        filter: function filter(t, e) {
          return "indented" === e.codeBlockStyle && "PRE" === t.nodeName && t.firstChild && "CODE" === t.firstChild.nodeName;
        },
        replacement: function replacement(t, e, n) {
          return "\n\n    " + e.firstChild.textContent.replace(/\n/g, "\n    ") + "\n\n";
        }
      }, y_.fencedCodeBlock = {
        filter: function filter(t, e) {
          return "fenced" === e.codeBlockStyle && "PRE" === t.nodeName && t.firstChild && "CODE" === t.firstChild.nodeName;
        },
        replacement: function replacement(t, e, n) {
          for (var i, o = ((e.firstChild.className || "").match(/language-(\S+)/) || [null, ""])[1], r = e.firstChild.textContent, s = n.fence.charAt(0), a = 3, c = new RegExp("^" + s + "{3,}", "gm"); i = c.exec(r);) {
            i[0].length >= a && (a = i[0].length + 1);
          }

          var l = b_(s, a);
          return "\n\n" + l + o + "\n" + r.replace(/\n$/, "") + "\n" + l + "\n\n";
        }
      }, y_.horizontalRule = {
        filter: "hr",
        replacement: function replacement(t, e, n) {
          return "\n\n" + n.hr + "\n\n";
        }
      }, y_.inlineLink = {
        filter: function filter(t, e) {
          return "inlined" === e.linkStyle && "A" === t.nodeName && t.getAttribute("href");
        },
        replacement: function replacement(t, e) {
          return "[" + t + "](" + e.getAttribute("href") + (e.title ? ' "' + e.title + '"' : "") + ")";
        }
      }, y_.referenceLink = {
        filter: function filter(t, e) {
          return "referenced" === e.linkStyle && "A" === t.nodeName && t.getAttribute("href");
        },
        replacement: function replacement(t, e, n) {
          var i,
              o,
              r = e.getAttribute("href"),
              s = e.title ? ' "' + e.title + '"' : "";

          switch (n.linkReferenceStyle) {
            case "collapsed":
              i = "[" + t + "][]", o = "[" + t + "]: " + r + s;
              break;

            case "shortcut":
              i = "[" + t + "]", o = "[" + t + "]: " + r + s;
              break;

            default:
              var a = this.references.length + 1;
              i = "[" + t + "][" + a + "]", o = "[" + a + "]: " + r + s;
          }

          return this.references.push(o), i;
        },
        references: [],
        append: function append(t) {
          var e = "";
          return this.references.length && (e = "\n\n" + this.references.join("\n") + "\n\n", this.references = []), e;
        }
      }, y_.emphasis = {
        filter: ["em", "i"],
        replacement: function replacement(t, e, n) {
          return t.trim() ? n.emDelimiter + t + n.emDelimiter : "";
        }
      }, y_.strong = {
        filter: ["strong", "b"],
        replacement: function replacement(t, e, n) {
          return t.trim() ? n.strongDelimiter + t + n.strongDelimiter : "";
        }
      }, y_.code = {
        filter: function filter(t) {
          var e = t.previousSibling || t.nextSibling,
              n = "PRE" === t.parentNode.nodeName && !e;
          return "CODE" === t.nodeName && !n;
        },
        replacement: function replacement(t) {
          if (!t.trim()) return "";
          var e = "`",
              n = "",
              i = "",
              o = t.match(/`+/gm);
          if (o) for (/^`/.test(t) && (n = " "), /`$/.test(t) && (i = " "); -1 !== o.indexOf(e);) {
            e += "`";
          }
          return e + n + t + i + e;
        }
      }, y_.image = {
        filter: "img",
        replacement: function replacement(t, e) {
          var n = e.alt || "",
              i = e.getAttribute("src") || "",
              o = e.title || "";
          return i ? "![" + n + "](" + i + (o ? ' "' + o + '"' : "") + ")" : "";
        }
      }, x_.prototype = {
        add: function add(t, e) {
          this.array.unshift(e);
        },
        keep: function keep(t) {
          this._keep.unshift({
            filter: t,
            replacement: this.keepReplacement
          });
        },
        remove: function remove(t) {
          this._remove.unshift({
            filter: t,
            replacement: function replacement() {
              return "";
            }
          });
        },
        forNode: function forNode(t) {
          return t.isBlank ? this.blankRule : (e = E_(this.array, t, this.options)) || (e = E_(this._keep, t, this.options)) || (e = E_(this._remove, t, this.options)) ? e : this.defaultRule;
          var e;
        },
        forEach: function forEach(t) {
          for (var e = 0; e < this.array.length; e++) {
            t(this.array[e], e);
          }
        }
      };
      var M_ = "undefined" != typeof window ? window : {};
      var T_,
          N_,
          B_,
          z_ = function () {
        var t = M_.DOMParser,
            e = !1;

        try {
          new t().parseFromString("", "text/html") && (e = !0);
        } catch (t) {}

        return e;
      }() ? M_.DOMParser : (T_ = function T_() {}, N_ = n(5915).JSDOM, T_.prototype.parseFromString = function (t) {
        return new N_(t).window.document;
      }, T_);

      function P_(t) {
        var e;
        "string" == typeof t ? e = (B_ = B_ || new z_()).parseFromString('<x-turndown id="turndown-root">' + t + "</x-turndown>", "text/html").getElementById("turndown-root") : e = t.cloneNode(!0);
        return function (t) {
          var e = t.element,
              n = t.isBlock,
              i = t.isVoid,
              o = t.isPre || function (t) {
            return "PRE" === t.nodeName;
          };

          if (e.firstChild && !o(e)) {
            for (var r = null, s = !1, a = null, c = I_(a, e, o); c !== e;) {
              if (3 === c.nodeType || 4 === c.nodeType) {
                var l = c.data.replace(/[ \r\n\t]+/g, " ");

                if (r && !/ $/.test(r.data) || s || " " !== l[0] || (l = l.substr(1)), !l) {
                  c = S_(c);
                  continue;
                }

                c.data = l, r = c;
              } else {
                if (1 !== c.nodeType) {
                  c = S_(c);
                  continue;
                }

                n(c) || "BR" === c.nodeName ? (r && (r.data = r.data.replace(/ $/, "")), r = null, s = !1) : i(c) && (r = null, s = !0);
              }

              var d = I_(a, c, o);
              a = c, c = d;
            }

            r && (r.data = r.data.replace(/ $/, ""), r.data || S_(r));
          }
        }({
          element: e,
          isBlock: A_,
          isVoid: __
        }), e;
      }

      function L_(t) {
        return t.isBlock = A_(t), t.isCode = "code" === t.nodeName.toLowerCase() || t.parentNode.isCode, t.isBlank = function (t) {
          return -1 === ["A", "TH", "TD", "IFRAME", "SCRIPT", "AUDIO", "VIDEO"].indexOf(t.nodeName) && /^\s*$/i.test(t.textContent) && !__(t) && !function (t) {
            return t.querySelector && t.querySelector(v_);
          }(t);
        }(t), t.flankingWhitespace = function (t) {
          var e = "",
              n = "";

          if (!t.isBlock) {
            var i = /^\s/.test(t.textContent),
                o = /\s$/.test(t.textContent),
                r = t.isBlank && i && o;
            i && !R_("left", t) && (e = " "), r || !o || R_("right", t) || (n = " ");
          }

          return {
            leading: e,
            trailing: n
          };
        }(t), t;
      }

      function R_(t, e) {
        var n, i, o;
        return "left" === t ? (n = e.previousSibling, i = / $/) : (n = e.nextSibling, i = /^ /), n && (3 === n.nodeType ? o = i.test(n.nodeValue) : 1 !== n.nodeType || A_(n) || (o = i.test(n.textContent))), o;
      }

      var O_ = Array.prototype.reduce,
          j_ = /^\n*/,
          F_ = /\n*$/,
          V_ = [[/\\/g, "\\\\"], [/\*/g, "\\*"], [/^-/g, "\\-"], [/^\+ /g, "\\+ "], [/^(=+)/g, "\\$1"], [/^(#{1,6}) /g, "\\$1 "], [/`/g, "\\`"], [/^~~~/g, "\\~~~"], [/\[/g, "\\["], [/\]/g, "\\]"], [/^>/g, "\\>"], [/_/g, "\\_"], [/^(\d+)\. /g, "$1\\. "]];

      function U_(t) {
        if (!(this instanceof U_)) return new U_(t);
        var e = {
          rules: y_,
          headingStyle: "setext",
          hr: "* * *",
          bulletListMarker: "*",
          codeBlockStyle: "indented",
          fence: "```",
          emDelimiter: "_",
          strongDelimiter: "**",
          linkStyle: "inlined",
          linkReferenceStyle: "full",
          br: "  ",
          blankReplacement: function blankReplacement(t, e) {
            return e.isBlock ? "\n\n" : "";
          },
          keepReplacement: function keepReplacement(t, e) {
            return e.isBlock ? "\n\n" + e.outerHTML + "\n\n" : e.outerHTML;
          },
          defaultReplacement: function defaultReplacement(t, e) {
            return e.isBlock ? "\n\n" + t + "\n\n" : t;
          }
        };
        this.options = function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var n = arguments[e];

            for (var i in n) {
              n.hasOwnProperty(i) && (t[i] = n[i]);
            }
          }

          return t;
        }({}, e, t), this.rules = new x_(this.options);
      }

      function H_(t) {
        var e = this;
        return O_.call(t.childNodes, function (t, n) {
          var i = "";
          return 3 === (n = new L_(n)).nodeType ? i = n.isCode ? n.nodeValue : e.escape(n.nodeValue) : 1 === n.nodeType && (i = W_.call(e, n)), G_(t, i);
        }, "");
      }

      function q_(t) {
        var e = this;
        return this.rules.forEach(function (n) {
          "function" == typeof n.append && (t = G_(t, n.append(e.options)));
        }), t.replace(/^[\t\r\n]+/, "").replace(/[\t\r\n\s]+$/, "");
      }

      function W_(t) {
        var e = this.rules.forNode(t),
            n = H_.call(this, t),
            i = t.flankingWhitespace;
        return (i.leading || i.trailing) && (n = n.trim()), i.leading + e.replacement(n, t, this.options) + i.trailing;
      }

      function G_(t, e) {
        var n,
            i,
            o,
            r = (n = e, i = [t.match(F_)[0], n.match(j_)[0]].sort(), (o = i[i.length - 1]).length < 2 ? o : "\n\n");
        return (t = t.replace(F_, "")) + r + (e = e.replace(j_, ""));
      }

      U_.prototype = {
        turndown: function turndown(t) {
          if (!function (t) {
            return null != t && ("string" == typeof t || t.nodeType && (1 === t.nodeType || 9 === t.nodeType || 11 === t.nodeType));
          }(t)) throw new TypeError(t + " is not a string, or an element/document/fragment node.");
          if ("" === t) return "";
          var e = H_.call(this, new P_(t));
          return q_.call(this, e);
        },
        use: function use(t) {
          if (Array.isArray(t)) for (var e = 0; e < t.length; e++) {
            this.use(t[e]);
          } else {
            if ("function" != typeof t) throw new TypeError("plugin must be a Function or an Array of Functions");
            t(this);
          }
          return this;
        },
        addRule: function addRule(t, e) {
          return this.rules.add(t, e), this;
        },
        keep: function keep(t) {
          return this.rules.keep(t), this;
        },
        remove: function remove(t) {
          return this.rules.remove(t), this;
        },
        escape: function escape(t) {
          return V_.reduce(function (t, e) {
            return t.replace(e[0], e[1]);
          }, t);
        }
      };
      var $_ = U_,
          Y_ = /highlight-(?:text|source)-([a-z0-9]+)/;

      function K_(t) {
        t.addRule("highlightedCodeBlock", {
          filter: function filter(t) {
            var e = t.firstChild;
            return "DIV" === t.nodeName && Y_.test(t.className) && e && "PRE" === e.nodeName;
          },
          replacement: function replacement(t, e, n) {
            var i = ((e.className || "").match(Y_) || [null, ""])[1];
            return "\n\n" + n.fence + i + "\n" + e.firstChild.textContent + "\n" + n.fence + "\n\n";
          }
        });
      }

      function Q_(t) {
        t.addRule("strikethrough", {
          filter: ["del", "s", "strike"],
          replacement: function replacement(t) {
            return "~" + t + "~";
          }
        });
      }

      var Z_ = Array.prototype.indexOf,
          J_ = Array.prototype.every,
          X_ = {};

      function tv(t) {
        var e,
            n,
            i = t.parentNode;
        return "THEAD" === i.nodeName || i.firstChild === t && ("TABLE" === i.nodeName || (n = (e = i).previousSibling, "TBODY" === e.nodeName && (!n || "THEAD" === n.nodeName && /^\s*$/i.test(n.textContent)))) && J_.call(t.childNodes, function (t) {
          return "TH" === t.nodeName;
        });
      }

      function ev(t, e) {
        var n = " ";
        return 0 === Z_.call(e.parentNode.childNodes, e) && (n = "| "), n + t + " |";
      }

      function nv(t) {
        for (var e in t.keep(function (t) {
          return "TABLE" === t.nodeName && !tv(t.rows[0]);
        }), X_) {
          t.addRule(e, X_[e]);
        }
      }

      function iv(t) {
        t.addRule("taskListItems", {
          filter: function filter(t) {
            return "checkbox" === t.type && "LI" === t.parentNode.nodeName;
          },
          replacement: function replacement(t, e) {
            return (e.checked ? "[x]" : "[ ]") + " ";
          }
        });
      }

      X_.tableCell = {
        filter: ["th", "td"],
        replacement: function replacement(t, e) {
          return ev(t, e);
        }
      }, X_.tableRow = {
        filter: "tr",
        replacement: function replacement(t, e) {
          var n = "",
              i = {
            left: ":--",
            right: "--:",
            center: ":-:"
          };
          if (tv(e)) for (var o = 0; o < e.childNodes.length; o++) {
            var r = "---",
                s = (e.childNodes[o].getAttribute("align") || "").toLowerCase();
            s && (r = i[s] || r), n += ev(r, e.childNodes[o]);
          }
          return "\n" + t + (n ? "\n" + n : "");
        }
      }, X_.table = {
        filter: function filter(t) {
          return "TABLE" === t.nodeName && tv(t.rows[0]);
        },
        replacement: function replacement(t) {
          return "\n\n" + (t = t.replace("\n\n", "\n")) + "\n\n";
        }
      }, X_.tableSection = {
        filter: ["thead", "tbody", "tfoot"],
        replacement: function replacement(t) {
          return t;
        }
      };
      var ov = $_.prototype.escape;

      function rv(t) {
        return t = (t = ov(t)).replace(/</g, "\\<");
      }

      $_.prototype.escape = function (t) {
        var e = "",
            n = 0;

        var _iterator480 = _createForOfIteratorHelper( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t) {
          var _iterator481, _step481, _e355, _t398, _n305;

          return _regeneratorRuntime.wrap(function _callee3$(_context38) {
            while (1) {
              switch (_context38.prev = _context38.next) {
                case 0:
                  _iterator481 = _createForOfIteratorHelper(t.matchAll(av));
                  _context38.prev = 1;

                  _iterator481.s();

                case 3:
                  if ((_step481 = _iterator481.n()).done) {
                    _context38.next = 10;
                    break;
                  }

                  _e355 = _step481.value;
                  _t398 = _e355[0], _n305 = cv(_t398);
                  _context38.next = 8;
                  return Object.assign([_t398.substring(0, _n305)], {
                    index: _e355.index
                  });

                case 8:
                  _context38.next = 3;
                  break;

                case 10:
                  _context38.next = 15;
                  break;

                case 12:
                  _context38.prev = 12;
                  _context38.t0 = _context38["catch"](1);

                  _iterator481.e(_context38.t0);

                case 15:
                  _context38.prev = 15;

                  _iterator481.f();

                  return _context38.finish(15);

                case 18:
                case "end":
                  return _context38.stop();
              }
            }
          }, _callee3, null, [[1, 12, 15, 18]]);
        })(t)),
            _step480;

        try {
          for (_iterator480.s(); !(_step480 = _iterator480.n()).done;) {
            var _i255 = _step480.value;
            var _o133 = _i255.index;
            _o133 > n && (e += rv(t.substring(n, _o133)));
            var _r84 = _i255[0];
            e += _r84, n = _o133 + _r84.length;
          }
        } catch (err) {
          _iterator480.e(err);
        } finally {
          _iterator480.f();
        }

        return n < t.length && (e += rv(t.substring(n, t.length))), e;
      };

      var sv = new $_({
        codeBlockStyle: "fenced",
        hr: "---",
        headingStyle: "atx"
      });
      sv.use([function (t) {
        t.use([K_, Q_, nv, iv]);
      }, function (t) {
        t.addRule("taskListItems", {
          filter: function filter(t) {
            return "checkbox" === t.type && ("LI" === t.parentNode.nodeName || "LI" === t.parentNode.parentNode.nodeName);
          },
          replacement: function replacement(t, e) {
            return (e.checked ? "[x]" : "[ ]") + " ";
          }
        });
      }]);
      var av = new RegExp(/\b(?:(?:https?|ftp):\/\/|www\.)/.source + /(?![-_])(?:[-_a-z0-9\u00a1-\uffff]{1,63}\.)+(?:[a-z\u00a1-\uffff]{2,63})/.source + /(?:[^\s<>]*)/.source, "gi");

      function cv(t) {
        var e = t.length;

        for (; e > 0;) {
          var _n306 = t[e - 1];
          if ("?!.,:*_~'\"".includes(_n306)) e--;else {
            if (")" != _n306) break;
            {
              var _n307 = 0;

              for (var _i256 = 0; _i256 < e; _i256++) {
                "(" == t[_i256] ? _n307++ : ")" == t[_i256] && _n307--;
              }

              if (!(_n307 < 0)) break;
              e--;
            }
          }
        }

        return e;
      }

      var lv = "subscript";

      var dv = /*#__PURE__*/function (_ue88) {
        _inherits(dv, _ue88);

        var _super222 = _createSuper(dv);

        function dv() {
          _classCallCheck(this, dv);

          return _super222.apply(this, arguments);
        }

        _createClass(dv, [{
          key: "init",
          value: function init() {
            var t = this.editor;
            t.model.schema.extend("$text", {
              allowAttributes: lv
            }), t.model.schema.setAttributeProperties(lv, {
              isFormatting: !0,
              copyOnEnter: !0
            }), t.conversion.attributeToElement({
              model: lv,
              view: "sub",
              upcastAlso: [{
                styles: {
                  "vertical-align": "sub"
                }
              }]
            }), t.commands.add(lv, new Um(t, lv));
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "SubscriptEditing";
          }
        }]);

        return dv;
      }(ue);

      var hv = "subscript";

      var uv = /*#__PURE__*/function (_ue89) {
        _inherits(uv, _ue89);

        var _super223 = _createSuper(uv);

        function uv() {
          _classCallCheck(this, uv);

          return _super223.apply(this, arguments);
        }

        _createClass(uv, [{
          key: "init",
          value: function init() {
            var _this321 = this;

            var t = this.editor,
                e = t.t;
            t.ui.componentFactory.add(hv, function (n) {
              var i = t.commands.get(hv),
                  o = new oh(n);
              return o.set({
                label: e("Subscript"),
                icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m7.03 10.349 3.818-3.819a.8.8 0 1 1 1.132 1.132L8.16 11.48l3.819 3.818a.8.8 0 1 1-1.132 1.132L7.03 12.61l-3.818 3.82a.8.8 0 1 1-1.132-1.132L5.9 11.48 2.08 7.662A.8.8 0 1 1 3.212 6.53l3.818 3.82zm8.147 7.829h2.549c.254 0 .447.05.58.152a.49.49 0 0 1 .201.413.54.54 0 0 1-.159.393c-.105.108-.266.162-.48.162h-3.594c-.245 0-.435-.066-.572-.197a.621.621 0 0 1-.205-.463c0-.114.044-.265.132-.453a1.62 1.62 0 0 1 .288-.444c.433-.436.824-.81 1.172-1.122.348-.312.597-.517.747-.615.267-.183.49-.368.667-.553.177-.185.312-.375.405-.57.093-.194.139-.384.139-.57a1.008 1.008 0 0 0-.554-.917 1.197 1.197 0 0 0-.56-.133c-.426 0-.761.182-1.005.546a2.332 2.332 0 0 0-.164.39 1.609 1.609 0 0 1-.258.488c-.096.114-.237.17-.423.17a.558.558 0 0 1-.405-.156.568.568 0 0 1-.161-.427c0-.218.05-.446.151-.683.101-.238.252-.453.452-.646s.454-.349.762-.467a2.998 2.998 0 0 1 1.081-.178c.498 0 .923.076 1.274.228a1.916 1.916 0 0 1 1.004 1.032 1.984 1.984 0 0 1-.156 1.794c-.2.32-.405.572-.613.754-.208.182-.558.468-1.048.857-.49.39-.826.691-1.008.906a2.703 2.703 0 0 0-.24.309z"/></svg>',
                tooltip: !0,
                isToggleable: !0
              }), o.bind("isOn", "isEnabled").to(i, "value", "isEnabled"), _this321.listenTo(o, "execute", function () {
                t.execute(hv), t.editing.view.focus();
              }), o;
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "SubscriptUI";
          }
        }]);

        return uv;
      }(ue);

      var gv = /*#__PURE__*/function (_ue90) {
        _inherits(gv, _ue90);

        var _super224 = _createSuper(gv);

        function gv() {
          _classCallCheck(this, gv);

          return _super224.apply(this, arguments);
        }

        _createClass(gv, null, [{
          key: "requires",
          get: function get() {
            return [dv, uv];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "Subscript";
          }
        }]);

        return gv;
      }(ue);

      var mv = "superscript";

      var pv = /*#__PURE__*/function (_ue91) {
        _inherits(pv, _ue91);

        var _super225 = _createSuper(pv);

        function pv() {
          _classCallCheck(this, pv);

          return _super225.apply(this, arguments);
        }

        _createClass(pv, [{
          key: "init",
          value: function init() {
            var t = this.editor;
            t.model.schema.extend("$text", {
              allowAttributes: mv
            }), t.model.schema.setAttributeProperties(mv, {
              isFormatting: !0,
              copyOnEnter: !0
            }), t.conversion.attributeToElement({
              model: mv,
              view: "sup",
              upcastAlso: [{
                styles: {
                  "vertical-align": "super"
                }
              }]
            }), t.commands.add(mv, new Um(t, mv));
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "SuperscriptEditing";
          }
        }]);

        return pv;
      }(ue);

      var fv = "superscript";

      var kv = /*#__PURE__*/function (_ue92) {
        _inherits(kv, _ue92);

        var _super226 = _createSuper(kv);

        function kv() {
          _classCallCheck(this, kv);

          return _super226.apply(this, arguments);
        }

        _createClass(kv, [{
          key: "init",
          value: function init() {
            var _this322 = this;

            var t = this.editor,
                e = t.t;
            t.ui.componentFactory.add(fv, function (n) {
              var i = t.commands.get(fv),
                  o = new oh(n);
              return o.set({
                label: e("Superscript"),
                icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M15.677 8.678h2.549c.254 0 .447.05.58.152a.49.49 0 0 1 .201.413.54.54 0 0 1-.159.393c-.105.108-.266.162-.48.162h-3.594c-.245 0-.435-.066-.572-.197a.621.621 0 0 1-.205-.463c0-.114.044-.265.132-.453a1.62 1.62 0 0 1 .288-.444c.433-.436.824-.81 1.172-1.122.348-.312.597-.517.747-.615.267-.183.49-.368.667-.553.177-.185.312-.375.405-.57.093-.194.139-.384.139-.57a1.008 1.008 0 0 0-.554-.917 1.197 1.197 0 0 0-.56-.133c-.426 0-.761.182-1.005.546a2.332 2.332 0 0 0-.164.39 1.609 1.609 0 0 1-.258.488c-.096.114-.237.17-.423.17a.558.558 0 0 1-.405-.156.568.568 0 0 1-.161-.427c0-.218.05-.446.151-.683.101-.238.252-.453.452-.646s.454-.349.762-.467a2.998 2.998 0 0 1 1.081-.178c.498 0 .923.076 1.274.228a1.916 1.916 0 0 1 1.004 1.032 1.984 1.984 0 0 1-.156 1.794c-.2.32-.405.572-.613.754-.208.182-.558.468-1.048.857-.49.39-.826.691-1.008.906a2.703 2.703 0 0 0-.24.309zM7.03 10.349l3.818-3.819a.8.8 0 1 1 1.132 1.132L8.16 11.48l3.819 3.818a.8.8 0 1 1-1.132 1.132L7.03 12.61l-3.818 3.82a.8.8 0 1 1-1.132-1.132L5.9 11.48 2.08 7.662A.8.8 0 1 1 3.212 6.53l3.818 3.82z"/></svg>',
                tooltip: !0,
                isToggleable: !0
              }), o.bind("isOn", "isEnabled").to(i, "value", "isEnabled"), _this322.listenTo(o, "execute", function () {
                t.execute(fv), t.editing.view.focus();
              }), o;
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "SuperscriptUI";
          }
        }]);

        return kv;
      }(ue);

      var bv = /*#__PURE__*/function (_ue93) {
        _inherits(bv, _ue93);

        var _super227 = _createSuper(bv);

        function bv() {
          _classCallCheck(this, bv);

          return _super227.apply(this, arguments);
        }

        _createClass(bv, null, [{
          key: "requires",
          get: function get() {
            return [pv, kv];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "Superscript";
          }
        }]);

        return bv;
      }(ue);

      function wv(t) {
        var e = t.t,
            n = t.config.get("codeBlock.languages");

        var _iterator482 = _createForOfIteratorHelper(n),
            _step482;

        try {
          for (_iterator482.s(); !(_step482 = _iterator482.n()).done;) {
            var _t399 = _step482.value;
            "Plain text" === _t399.label && (_t399.label = e("Plain text")), void 0 === _t399.class && (_t399.class = "language-".concat(_t399.language));
          }
        } catch (err) {
          _iterator482.e(err);
        } finally {
          _iterator482.f();
        }

        return n;
      }

      function Av(t, e, n) {
        var i = {};

        var _iterator483 = _createForOfIteratorHelper(t),
            _step483;

        try {
          for (_iterator483.s(); !(_step483 = _iterator483.n()).done;) {
            var _o134 = _step483.value;
            "class" === e ? i[_o134[e].split(" ").shift()] = _o134[n] : i[_o134[e]] = _o134[n];
          }
        } catch (err) {
          _iterator483.e(err);
        } finally {
          _iterator483.f();
        }

        return i;
      }

      function Cv(t) {
        return t.data.match(/^(\s*)/)[0];
      }

      function _v(t) {
        var e = t.document.selection,
            n = [];
        if (e.isCollapsed) n.push(e.anchor);else {
          var _i257 = e.getFirstRange().getWalker({
            ignoreElementEnd: !0,
            direction: "backward"
          });

          var _iterator484 = _createForOfIteratorHelper(_i257),
              _step484;

          try {
            for (_iterator484.s(); !(_step484 = _iterator484.n()).done;) {
              var _e356 = _step484.value.item;

              if (_e356.is("$textProxy") && _e356.parent.is("element", "codeBlock")) {
                var _i258 = Cv(_e356.textNode),
                    _e356$textNode = _e356.textNode,
                    _o135 = _e356$textNode.parent,
                    _r85 = _e356$textNode.startOffset,
                    _s50 = t.createPositionAt(_o135, _r85 + _i258.length);

                n.push(_s50);
              }
            }
          } catch (err) {
            _iterator484.e(err);
          } finally {
            _iterator484.f();
          }
        }
        return n;
      }

      function vv(t) {
        var e = wa(t.getSelectedBlocks());
        return e && e.is("element", "codeBlock");
      }

      var yv = /*#__PURE__*/function (_me37) {
        _inherits(yv, _me37);

        var _super228 = _createSuper(yv);

        function yv(t) {
          var _this323;

          _classCallCheck(this, yv);

          _this323 = _super228.call(this, t), _this323._lastLanguage = null;
          return _this323;
        }

        _createClass(yv, [{
          key: "refresh",
          value: function refresh() {
            this.value = this._getValue(), this.isEnabled = this._checkEnabled();
          }
        }, {
          key: "execute",
          value: function execute() {
            var _this324 = this;

            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var e = this.editor,
                n = e.model,
                i = n.document.selection,
                o = wv(e)[0],
                r = Array.from(i.getSelectedBlocks()),
                s = void 0 === t.forceValue ? !this.value : t.forceValue,
                a = function (t, e, n) {
              if (t.language) return t.language;
              if (t.usePreviousLanguageChoice && e) return e;
              return n;
            }(t, this._lastLanguage, o.language);

            n.change(function (t) {
              s ? _this324._applyCodeBlock(t, r, a) : _this324._removeCodeBlock(t, r);
            });
          }
        }, {
          key: "_getValue",
          value: function _getValue() {
            var t = wa(this.editor.model.document.selection.getSelectedBlocks());
            return !!!(!t || !t.is("element", "codeBlock")) && t.getAttribute("language");
          }
        }, {
          key: "_checkEnabled",
          value: function _checkEnabled() {
            if (this.value) return !0;
            var t = this.editor.model.document.selection,
                e = this.editor.model.schema,
                n = wa(t.getSelectedBlocks());
            return !!n && xv(e, n);
          }
        }, {
          key: "_applyCodeBlock",
          value: function _applyCodeBlock(t, e, n) {
            this._lastLanguage = n;
            var i = this.editor.model.schema,
                o = e.filter(function (t) {
              return xv(i, t);
            });

            var _iterator485 = _createForOfIteratorHelper(o),
                _step485;

            try {
              var _loop9 = function _loop9() {
                var e = _step485.value;
                t.rename(e, "codeBlock"), t.setAttribute("language", n, e), i.removeDisallowedAttributes([e], t), Array.from(e.getChildren()).filter(function (t) {
                  return !i.checkChild(e, t);
                }).forEach(function (e) {
                  return t.remove(e);
                });
              };

              for (_iterator485.s(); !(_step485 = _iterator485.n()).done;) {
                _loop9();
              }
            } catch (err) {
              _iterator485.e(err);
            } finally {
              _iterator485.f();
            }

            o.reverse().forEach(function (e, n) {
              var i = o[n + 1];
              e.previousSibling === i && (t.appendElement("softBreak", i), t.merge(t.createPositionBefore(e)));
            });
          }
        }, {
          key: "_removeCodeBlock",
          value: function _removeCodeBlock(t, e) {
            var n = e.filter(function (t) {
              return t.is("element", "codeBlock");
            });

            var _iterator486 = _createForOfIteratorHelper(n),
                _step486;

            try {
              for (_iterator486.s(); !(_step486 = _iterator486.n()).done;) {
                var _e357 = _step486.value;

                var _n308 = t.createRangeOn(_e357);

                var _iterator487 = _createForOfIteratorHelper(Array.from(_n308.getItems()).reverse()),
                    _step487;

                try {
                  for (_iterator487.s(); !(_step487 = _iterator487.n()).done;) {
                    var _e358 = _step487.value;

                    if (_e358.is("element", "softBreak") && _e358.parent.is("element", "codeBlock")) {
                      var _t$split = t.split(t.createPositionBefore(_e358)),
                          _n309 = _t$split.position;

                      t.rename(_n309.nodeAfter, "paragraph"), t.removeAttribute("language", _n309.nodeAfter), t.remove(_e358);
                    }
                  }
                } catch (err) {
                  _iterator487.e(err);
                } finally {
                  _iterator487.f();
                }

                t.rename(_e357, "paragraph"), t.removeAttribute("language", _e357);
              }
            } catch (err) {
              _iterator486.e(err);
            } finally {
              _iterator486.f();
            }
          }
        }]);

        return yv;
      }(me);

      function xv(t, e) {
        return !e.is("rootElement") && !t.isLimit(e) && t.checkChild(e.parent, "codeBlock");
      }

      var Ev = /*#__PURE__*/function (_me38) {
        _inherits(Ev, _me38);

        var _super229 = _createSuper(Ev);

        function Ev(t) {
          var _this325;

          _classCallCheck(this, Ev);

          _this325 = _super229.call(this, t), _this325._indentSequence = t.config.get("codeBlock.indentSequence");
          return _this325;
        }

        _createClass(Ev, [{
          key: "refresh",
          value: function refresh() {
            this.isEnabled = this._checkEnabled();
          }
        }, {
          key: "execute",
          value: function execute() {
            var _this326 = this;

            var t = this.editor.model;
            t.change(function (e) {
              var n = _v(t);

              var _iterator488 = _createForOfIteratorHelper(n),
                  _step488;

              try {
                for (_iterator488.s(); !(_step488 = _iterator488.n()).done;) {
                  var _t400 = _step488.value;
                  e.insertText(_this326._indentSequence, _t400);
                }
              } catch (err) {
                _iterator488.e(err);
              } finally {
                _iterator488.f();
              }
            });
          }
        }, {
          key: "_checkEnabled",
          value: function _checkEnabled() {
            return !!this._indentSequence && vv(this.editor.model.document.selection);
          }
        }]);

        return Ev;
      }(me);

      var Dv = /*#__PURE__*/function (_me39) {
        _inherits(Dv, _me39);

        var _super230 = _createSuper(Dv);

        function Dv(t) {
          var _this327;

          _classCallCheck(this, Dv);

          _this327 = _super230.call(this, t), _this327._indentSequence = t.config.get("codeBlock.indentSequence");
          return _this327;
        }

        _createClass(Dv, [{
          key: "refresh",
          value: function refresh() {
            this.isEnabled = this._checkEnabled();
          }
        }, {
          key: "execute",
          value: function execute() {
            var _this328 = this;

            var t = this.editor.model;
            t.change(function (e) {
              var n = _v(t);

              var _iterator489 = _createForOfIteratorHelper(n),
                  _step489;

              try {
                for (_iterator489.s(); !(_step489 = _iterator489.n()).done;) {
                  var _t401 = _step489.value;

                  var _n310 = Sv(_this328.editor.model, _t401, _this328._indentSequence);

                  _n310 && e.remove(_n310);
                }
              } catch (err) {
                _iterator489.e(err);
              } finally {
                _iterator489.f();
              }
            });
          }
        }, {
          key: "_checkEnabled",
          value: function _checkEnabled() {
            var _this329 = this;

            if (!this._indentSequence) return !1;
            var t = this.editor.model;
            return !!vv(t.document.selection) && _v(t).some(function (e) {
              return Sv(t, e, _this329._indentSequence);
            });
          }
        }]);

        return Dv;
      }(me);

      function Sv(t, e, n) {
        var i = function (t) {
          var e = t.parent.getChild(t.index);
          e && !e.is("element", "softBreak") || (e = t.nodeBefore);
          if (!e || e.is("element", "softBreak")) return null;
          return e;
        }(e);

        if (!i) return null;
        var o = Cv(i),
            r = o.lastIndexOf(n);
        if (r + n.length !== o.length) return null;
        if (-1 === r) return null;
        var s = i.parent,
            a = i.startOffset;
        return t.createRange(t.createPositionAt(s, a + r), t.createPositionAt(s, a + r + n.length));
      }

      function Iv(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        var i = Av(e, "language", "class"),
            o = Av(e, "language", "label");
        return function (e, r, s) {
          var a = s.writer,
              c = s.mapper,
              l = s.consumable;
          if (!l.consume(r.item, "insert")) return;
          var d = r.item.getAttribute("language"),
              h = c.toViewPosition(t.createPositionBefore(r.item)),
              u = {};
          n && (u["data-language"] = o[d], u.spellcheck = "false");
          var g = a.createContainerElement("pre", u),
              m = a.createContainerElement("code", {
            class: i[d] || null
          });
          a.insert(a.createPositionAt(g, 0), m), a.insert(h, g), c.bindElements(r.item, m);
        };
      }

      var Mv = "paragraph";

      var Tv = /*#__PURE__*/function (_ue94) {
        _inherits(Tv, _ue94);

        var _super231 = _createSuper(Tv);

        function Tv(t) {
          var _this330;

          _classCallCheck(this, Tv);

          _this330 = _super231.call(this, t), t.config.define("codeBlock", {
            languages: [{
              language: "plaintext",
              label: "Plain text"
            }, {
              language: "c",
              label: "C"
            }, {
              language: "cs",
              label: "C#"
            }, {
              language: "cpp",
              label: "C++"
            }, {
              language: "css",
              label: "CSS"
            }, {
              language: "diff",
              label: "Diff"
            }, {
              language: "html",
              label: "HTML"
            }, {
              language: "java",
              label: "Java"
            }, {
              language: "javascript",
              label: "JavaScript"
            }, {
              language: "php",
              label: "PHP"
            }, {
              language: "python",
              label: "Python"
            }, {
              language: "ruby",
              label: "Ruby"
            }, {
              language: "typescript",
              label: "TypeScript"
            }, {
              language: "xml",
              label: "XML"
            }],
            indentSequence: "\t"
          });
          return _this330;
        }

        _createClass(Tv, [{
          key: "init",
          value: function init() {
            var _this331 = this;

            var t = this.editor,
                e = t.model.schema,
                n = t.model,
                i = (t.editing.view, wv(t));
            t.commands.add("codeBlock", new yv(t)), t.commands.add("indentCodeBlock", new Ev(t)), t.commands.add("outdentCodeBlock", new Dv(t));

            var o = function o(t) {
              return function (e, n) {
                _this331.editor.commands.get(t).isEnabled && (_this331.editor.execute(t), n());
              };
            };

            t.keystrokes.set("Tab", o("indentCodeBlock")), t.keystrokes.set("Shift+Tab", o("outdentCodeBlock")), e.register("codeBlock", {
              allowWhere: "$block",
              allowChildren: "$text",
              isBlock: !0,
              allowAttributes: ["language"]
            }), e.addAttributeCheck(function (t) {
              if (t.endsWith("codeBlock $text")) return !1;
            }), t.model.schema.addChildCheck(function (t, e) {
              if (t.endsWith("codeBlock") && e.isObject) return !1;
            }), t.editing.downcastDispatcher.on("insert:codeBlock", Iv(n, i, !0)), t.data.downcastDispatcher.on("insert:codeBlock", Iv(n, i)), t.data.downcastDispatcher.on("insert:softBreak", function (t) {
              return function (e, n, i) {
                if ("codeBlock" !== n.item.parent.name) return;
                var o = i.writer,
                    r = i.mapper,
                    s = i.consumable;
                if (!s.consume(n.item, "insert")) return;
                var a = r.toViewPosition(t.createPositionBefore(n.item));
                o.insert(a, o.createText("\n"));
              };
            }(n), {
              priority: "high"
            }), t.data.upcastDispatcher.on("element:code", function (t, e) {
              var n = Av(e, "class", "language"),
                  i = e[0].language;
              return function (t, e, o) {
                var r = e.viewItem,
                    s = r.parent;
                if (!s || !s.is("element", "pre")) return;
                if (e.modelCursor.findAncestor("codeBlock")) return;
                var a = o.consumable,
                    c = o.writer;
                if (!a.test(r, {
                  name: !0
                })) return;

                var l = c.createElement("codeBlock"),
                    d = _toConsumableArray(r.getClassNames());

                d.length || d.push("");

                var _iterator490 = _createForOfIteratorHelper(d),
                    _step490;

                try {
                  for (_iterator490.s(); !(_step490 = _iterator490.n()).done;) {
                    var _t402 = _step490.value;
                    var _e359 = n[_t402];

                    if (_e359) {
                      c.setAttribute("language", _e359, l);
                      break;
                    }
                  }
                } catch (err) {
                  _iterator490.e(err);
                } finally {
                  _iterator490.f();
                }

                l.hasAttribute("language") || c.setAttribute("language", i, l), o.convertChildren(r, l), o.safeInsert(l, e.modelCursor) && (a.consume(r, {
                  name: !0
                }), o.updateConversionResult(l, e));
              };
            }(0, i)), t.data.upcastDispatcher.on("text", function (t, e, _ref97) {
              var n = _ref97.consumable,
                  i = _ref97.writer;
              var o = e.modelCursor;
              if (!n.test(e.viewItem)) return;
              if (!o.findAncestor("codeBlock")) return;
              n.consume(e.viewItem);
              var r = e.viewItem.data.split("\n").map(function (t) {
                return i.createText(t);
              }),
                  s = r[r.length - 1];

              var _iterator491 = _createForOfIteratorHelper(r),
                  _step491;

              try {
                for (_iterator491.s(); !(_step491 = _iterator491.n()).done;) {
                  var _t403 = _step491.value;

                  if (i.insert(_t403, o), o = o.getShiftedBy(_t403.offsetSize), _t403 !== s) {
                    var _t404 = i.createElement("softBreak");

                    i.insert(_t404, o), o = i.createPositionAfter(_t404);
                  }
                }
              } catch (err) {
                _iterator491.e(err);
              } finally {
                _iterator491.f();
              }

              e.modelRange = i.createRange(e.modelCursor, o), e.modelCursor = o;
            }), this.listenTo(t.editing.view.document, "clipboardInput", function (e, i) {
              var o = n.createRange(n.document.selection.anchor);
              if (i.targetRanges && (o = t.editing.mapper.toModelRange(i.targetRanges[0])), !o.start.parent.is("element", "codeBlock")) return;
              var r = i.dataTransfer.getData("text/plain"),
                  s = new eg(t.editing.view.document);

              i.content = function (t, e) {
                var n = t.createDocumentFragment(),
                    i = e.split("\n"),
                    o = i.reduce(function (e, n, o) {
                  return e.push(n), o < i.length - 1 && e.push(t.createElement("br")), e;
                }, []);
                return t.appendChild(o, n), n;
              }(s, r);
            }), this.listenTo(n, "getSelectedContent", function (t, _ref98) {
              var _ref99 = _slicedToArray(_ref98, 1),
                  i = _ref99[0];

              var o = i.anchor;
              !i.isCollapsed && o.parent.is("element", "codeBlock") && o.hasSameParentAs(i.focus) && n.change(function (n) {
                var r = t.return;

                if (r.childCount > 1 || i.containsEntireContent(o.parent)) {
                  var _e360 = n.createElement("codeBlock", o.parent.getAttributes());

                  n.append(r, _e360);

                  var _i259 = n.createDocumentFragment();

                  n.append(_e360, _i259), t.return = _i259;
                } else {
                  var _t405 = r.getChild(0);

                  e.checkAttribute(_t405, "code") && n.setAttribute("code", !0, _t405);
                }
              });
            });
          }
        }, {
          key: "afterInit",
          value: function afterInit() {
            var t = this.editor,
                e = t.commands,
                n = e.get("indent"),
                i = e.get("outdent");
            n && n.registerChildCommand(e.get("indentCodeBlock")), i && i.registerChildCommand(e.get("outdentCodeBlock")), this.listenTo(t.editing.view.document, "enter", function (e, n) {
              t.model.document.selection.getLastPosition().parent.is("element", "codeBlock") && (function (t, e) {
                var n = t.model.document,
                    i = t.editing.view,
                    o = n.selection.getLastPosition(),
                    r = o.nodeAfter;
                if (e || !n.selection.isCollapsed || !o.isAtStart) return !1;
                if (!Bv(r)) return !1;
                return t.model.change(function (e) {
                  t.execute("enter");
                  var i = n.selection.anchor.parent.previousSibling;
                  e.rename(i, Mv), e.setSelection(i, "in"), t.model.schema.removeDisallowedAttributes([i], e), e.remove(r);
                }), i.scrollToTheSelection(), !0;
              }(t, n.isSoft) || function (t, e) {
                var n = t.model,
                    i = n.document,
                    o = t.editing.view,
                    r = i.selection.getLastPosition(),
                    s = r.nodeBefore;
                var a;
                if (e || !i.selection.isCollapsed || !r.isAtEnd || !s || !s.previousSibling) return !1;
                if (Bv(s) && Bv(s.previousSibling)) a = n.createRange(n.createPositionBefore(s.previousSibling), n.createPositionAfter(s));else if (Nv(s) && Bv(s.previousSibling) && Bv(s.previousSibling.previousSibling)) a = n.createRange(n.createPositionBefore(s.previousSibling.previousSibling), n.createPositionAfter(s));else {
                  if (!(Nv(s) && Bv(s.previousSibling) && Nv(s.previousSibling.previousSibling) && Bv(s.previousSibling.previousSibling.previousSibling))) return !1;
                  a = n.createRange(n.createPositionBefore(s.previousSibling.previousSibling.previousSibling), n.createPositionAfter(s));
                }
                return t.model.change(function (e) {
                  e.remove(a), t.execute("enter");
                  var n = i.selection.anchor.parent;
                  e.rename(n, Mv), t.model.schema.removeDisallowedAttributes([n], e);
                }), o.scrollToTheSelection(), !0;
              }(t, n.isSoft) || function (t) {
                var e = t.model.document,
                    n = e.selection.getLastPosition(),
                    i = n.nodeBefore || n.textNode;
                var o;
                i && i.is("$text") && (o = Cv(i));
                t.model.change(function (n) {
                  t.execute("shiftEnter"), o && n.insertText(o, e.selection.anchor);
                });
              }(t), n.preventDefault(), e.stop());
            }, {
              context: "pre"
            });
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "CodeBlockEditing";
          }
        }, {
          key: "requires",
          get: function get() {
            return [Nm];
          }
        }]);

        return Tv;
      }(ue);

      function Nv(t) {
        return t && t.is("$text") && !t.data.match(/\S/);
      }

      function Bv(t) {
        return t && t.is("element", "softBreak");
      }

      var zv = n(3807),
          Pv = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
      Zr()(zv.Z, Pv), zv.Z.locals;

      var Lv = /*#__PURE__*/function (_ue95) {
        _inherits(Lv, _ue95);

        var _super232 = _createSuper(Lv);

        function Lv() {
          _classCallCheck(this, Lv);

          return _super232.apply(this, arguments);
        }

        _createClass(Lv, [{
          key: "init",
          value: function init() {
            var _this332 = this;

            var t = this.editor,
                e = t.t,
                n = t.ui.componentFactory,
                i = wv(t);
            n.add("codeBlock", function (n) {
              var o = t.commands.get("codeBlock"),
                  r = Hh(n, mh),
                  s = r.buttonView;
              return s.set({
                label: e("Insert code block"),
                tooltip: !0,
                icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12.87 12.61a.75.75 0 0 1-.089.976l-.085.07-3.154 2.254 3.412 2.414a.75.75 0 0 1 .237.95l-.057.095a.75.75 0 0 1-.95.237l-.096-.058-4.272-3.022-.003-1.223 4.01-2.867a.75.75 0 0 1 1.047.174zm2.795-.231.095.057 4.011 2.867-.003 1.223-4.272 3.022-.095.058a.75.75 0 0 1-.88-.151l-.07-.086-.058-.095a.75.75 0 0 1 .15-.88l.087-.07 3.412-2.414-3.154-2.253-.085-.071a.75.75 0 0 1 .862-1.207zM16 0a2 2 0 0 1 2 2v9.354l-.663-.492-.837-.001V2a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h3.118L7.156 19H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h14zM5.009 15l.003 1H3v-1h2.009zm2.188-2-1.471 1H5v-1h2.197zM10 11v.095L8.668 12H7v-1h3zm4-2v1H7V9h7zm0-2v1H7V7h7zm-4-2v1H5V5h5zM6 3v1H3V3h3z"/></svg>',
                isToggleable: !0
              }), s.bind("isOn").to(o, "value", function (t) {
                return !!t;
              }), s.on("execute", function () {
                t.execute("codeBlock", {
                  usePreviousLanguageChoice: !0
                }), t.editing.view.focus();
              }), r.on("execute", function (e) {
                t.execute("codeBlock", {
                  language: e.source._codeBlockLanguage,
                  forceValue: !0
                }), t.editing.view.focus();
              }), r.class = "ck-code-block-dropdown", r.bind("isEnabled").to(o), Wh(r, _this332._getLanguageListItemDefinitions(i)), r;
            });
          }
        }, {
          key: "_getLanguageListItemDefinitions",
          value: function _getLanguageListItemDefinitions(t) {
            var e = this.editor.commands.get("codeBlock"),
                n = new Di();

            var _iterator492 = _createForOfIteratorHelper(t),
                _step492;

            try {
              var _loop10 = function _loop10() {
                var i = _step492.value;
                var t = {
                  type: "button",
                  model: new uu({
                    _codeBlockLanguage: i.language,
                    label: i.label,
                    withText: !0
                  })
                };
                t.model.bind("isOn").to(e, "value", function (e) {
                  return e === t.model._codeBlockLanguage;
                }), n.add(t);
              };

              for (_iterator492.s(); !(_step492 = _iterator492.n()).done;) {
                _loop10();
              }
            } catch (err) {
              _iterator492.e(err);
            } finally {
              _iterator492.f();
            }

            return n;
          }
        }], [{
          key: "pluginName",
          get: function get() {
            return "CodeBlockUI";
          }
        }]);

        return Lv;
      }(ue);

      var Rv = /*#__PURE__*/function (_ue96) {
        _inherits(Rv, _ue96);

        var _super233 = _createSuper(Rv);

        function Rv() {
          _classCallCheck(this, Rv);

          return _super233.apply(this, arguments);
        }

        _createClass(Rv, null, [{
          key: "requires",
          get: function get() {
            return [Tv, Lv];
          }
        }, {
          key: "pluginName",
          get: function get() {
            return "CodeBlock";
          }
        }]);

        return Rv;
      }(ue);

      function Ov(t) {
        t.conversion.for("upcast").elementToAttribute({
          view: {
            name: "strong",
            key: "data-mention",
            classes: "badge badge-primary font-weight-bold",
            attributes: {
              "data-user-id": !0
            }
          },
          model: {
            key: "mention",
            value: function value(e) {
              return t.plugins.get("Mention").toMentionAttribute(e, {
                userId: e.getAttribute("data-user-id")
              });
            }
          },
          converterPriority: "high"
        }), t.conversion.for("downcast").attributeToElement({
          model: "mention",
          view: function view(t, _ref100) {
            var e = _ref100.writer;
            if (!t) return;
            return e.createAttributeElement("strong", {
              class: "badge badge-primary font-weight-bold",
              "data-mention": t.id,
              "data-user-id": t.userId
            }, {
              priority: 40,
              id: t.uid
            });
          },
          converterPriority: "high"
        });
      }

      var jv = /*#__PURE__*/function () {
        function jv(t) {
          _classCallCheck(this, jv);

          this.loader = t;
        }

        _createClass(jv, [{
          key: "upload",
          value: function upload() {
            var _this333 = this;

            return this.loader.file.then(function (t) {
              return new Promise(function (e, n) {
                _this333._initRequest(), _this333._initListeners(e, n, t), _this333._sendRequest(t);
              });
            });
          }
        }, {
          key: "abort",
          value: function abort() {
            this.xhr && this.xhr.abort();
          }
        }, {
          key: "_initRequest",
          value: function _initRequest() {
            var t = this.xhr = new XMLHttpRequest();
            t.open("POST", process.env.REACT_APP_API_URL + "/api/tasks_updates_image_upload", !0), t.responseType = "json";
          }
        }, {
          key: "_initListeners",
          value: function _initListeners(t, e, n) {
            var i = this.xhr,
                o = this.loader,
                r = "Couldn't upload file: ".concat(n.name, ".");
            i.addEventListener("error", function () {
              return e(r);
            }), i.addEventListener("abort", function () {
              return e();
            }), i.addEventListener("load", function () {
              var n = i.response;
              if (!n || n.error) return e(n && n.error ? n.error.message : r);
              t({
                default: process.env.REACT_APP_API_URL + "/" + n.url
              });
            }), i.upload && i.upload.addEventListener("progress", function (t) {
              t.lengthComputable && (o.uploadTotal = t.total, o.uploaded = t.loaded);
            });
          }
        }, {
          key: "_sendRequest",
          value: function _sendRequest(t) {
            var e = new FormData();
            e.append("upload", t), this.xhr.send(e);
          }
        }]);

        return jv;
      }();

      var Fv = /*#__PURE__*/function (_sg) {
        _inherits(Fv, _sg);

        var _super234 = _createSuper(Fv);

        function Fv() {
          _classCallCheck(this, Fv);

          return _super234.apply(this, arguments);
        }

        return _createClass(Fv);
      }(sg);

      Fv.builtinPlugins = [Wg, _m, Vm, $m, np, up, _f, zf, function (t) {
        t.plugins.get("FileRepository").createUploadAdapter = function (t) {
          return new jv(t);
        };
      }, kk, Ek, Yk, Kk, pb, Ab, xb, $b, Cw, Fw, Ov, hA, Ef, xA, u_, f_, Pg, Rv, bv, gv], Fv.defaultConfig = {
        toolbar: {
          items: ["heading", "|", "bold", "italic", "link", "bulletedList", "numberedList", "subscript", "superscript", "|", "imageUpload", "insertTable", "mediaEmbed", "|", "outdent", "indent", "blockQuote", "undo", "redo"]
        },
        language: "de",
        image: {
          toolbar: ["imageTextAlternative", "imageStyle:inline", "imageStyle:block", "imageStyle:side"]
        },
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"]
        }
      };

      var Vv = /*#__PURE__*/function (_sg2) {
        _inherits(Vv, _sg2);

        var _super235 = _createSuper(Vv);

        function Vv() {
          _classCallCheck(this, Vv);

          return _super235.apply(this, arguments);
        }

        return _createClass(Vv);
      }(sg);

      Vv.builtinPlugins = [Wg, _m, Vm, $m, np, up, _f, zf, kk, Ek, Yk, Kk, pb, Ab, xb, $b, Cw, Fw, Ov, hA, Ef, xA, u_, f_, Pg, Rv, bv, gv], Vv.defaultConfig = {
        toolbar: {
          items: ["heading", "|", "bold", "italic", "link", "bulletedList", "numberedList", "subscript", "superscript", "|", "insertTable", "mediaEmbed", "|", "outdent", "indent", "blockQuote", "undo", "redo"]
        },
        language: "de",
        image: {
          toolbar: ["imageTextAlternative", "imageStyle:inline", "imageStyle:block", "imageStyle:side"]
        },
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"]
        }
      };
      var Uv = {
        TaskUpdateEditor: Fv,
        TaskInfoEditor: Vv
      };
    }(), i = i.default;
  }();
});